var Bm = Object.defineProperty;
var Zm = (e, t, r) => t in e ? Bm(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var K = (e, t, r) => (Zm(e, typeof t != "symbol" ? t + "" : t, r), r);
const qm = "5.2.4", Um = [], Hm = {
  version: qm,
  objects: Um
}, Gm = "rect", Wm = "5.2.4", Vm = "left", Xm = "top", Ym = 0, Km = 0, Qm = 400, Jm = 400, ef = "#ebb970", tf = null, rf = 0, nf = null, of = "butt", sf = 0, af = "miter", lf = !1, cf = 4, uf = 1, hf = 1, mf = 0, ff = !1, df = !1, pf = 1, gf = null, kf = !0, vf = "", yf = "nonzero", bf = "fill", xf = "source-over", wf = 0, Lf = 0, zf = 0, Cf = 0, Sf = !1, $f = !1, Af = {
  ml: !1,
  mt: !1,
  mr: !1,
  mb: !1,
  mtr: !1
}, Mf = "background", jf = {
  type: Gm,
  version: Wm,
  originX: Vm,
  originY: Xm,
  left: Ym,
  top: Km,
  width: Qm,
  height: Jm,
  fill: ef,
  stroke: tf,
  strokeWidth: rf,
  strokeDashArray: nf,
  strokeLineCap: of,
  strokeDashOffset: sf,
  strokeLineJoin: af,
  strokeUniform: lf,
  strokeMiterLimit: cf,
  scaleX: uf,
  scaleY: hf,
  angle: mf,
  flipX: ff,
  flipY: df,
  opacity: pf,
  shadow: gf,
  visible: kf,
  backgroundColor: vf,
  fillRule: yf,
  paintFirst: bf,
  globalCompositeOperation: xf,
  skewX: wf,
  skewY: Lf,
  rx: zf,
  ry: Cf,
  selectable: Sf,
  hasBorders: $f,
  _controlsVisibility: Af,
  pk_type: Mf
}, Ef = "group", Tf = "5.2.4", Pf = "left", Nf = "top", Df = 100, Of = 100, Rf = 200, If = 200, _f = "rgb(0,0,0)", Ff = null, Bf = 0, Zf = null, qf = "butt", Uf = 0, Hf = "miter", Gf = !1, Wf = 4, Vf = 1, Xf = 1, Yf = 0, Kf = !1, Qf = !1, Jf = 1, ed = null, td = !0, rd = "", nd = "nonzero", od = "fill", sd = "source-over", id = 0, ad = 0, ld = !1, cd = !1, ud = 1, hd = !0, md = {
  ml: !1,
  mt: !1,
  mr: !1,
  mb: !1,
  mtr: !1
}, fd = null, dd = null, pd = [
  {
    type: "rect",
    version: "5.2.4",
    originX: "left",
    originY: "top",
    left: -100,
    top: -100,
    width: 200,
    height: 200,
    fill: !1,
    stroke: null,
    strokeWidth: 0,
    strokeDashArray: null,
    strokeLineCap: "butt",
    strokeDashOffset: 0,
    strokeLineJoin: "miter",
    strokeUniform: !1,
    strokeMiterLimit: 4,
    scaleX: 1,
    scaleY: 1,
    angle: 0,
    flipX: !1,
    flipY: !1,
    opacity: 1,
    shadow: null,
    visible: !0,
    backgroundColor: "",
    fillRule: "nonzero",
    paintFirst: "fill",
    globalCompositeOperation: "source-over",
    skewX: 0,
    skewY: 0,
    rx: 0,
    ry: 0,
    selectable: !0,
    hasBorders: !0
  },
  {
    type: "group",
    version: "5.2.4",
    originX: "left",
    originY: "top",
    left: -100,
    top: -100,
    width: 200,
    height: 200,
    fill: "rgb(0,0,0)",
    stroke: null,
    strokeWidth: 0,
    strokeDashArray: null,
    strokeLineCap: "butt",
    strokeDashOffset: 0,
    strokeLineJoin: "miter",
    strokeUniform: !1,
    strokeMiterLimit: 4,
    scaleX: 1,
    scaleY: 1,
    angle: 0,
    flipX: !1,
    flipY: !1,
    opacity: 1,
    shadow: null,
    visible: !0,
    backgroundColor: "",
    fillRule: "nonzero",
    paintFirst: "fill",
    globalCompositeOperation: "source-over",
    skewX: 0,
    skewY: 0,
    selectable: !0,
    hasBorders: !0,
    objects: [
      {
        type: "path",
        version: "5.2.4",
        originX: "left",
        originY: "top",
        left: -100,
        top: -100,
        width: 200,
        height: 200,
        fill: "transparent",
        stroke: null,
        strokeWidth: 0,
        strokeDashArray: null,
        strokeLineCap: "butt",
        strokeDashOffset: 0,
        strokeLineJoin: "miter",
        strokeUniform: !1,
        strokeMiterLimit: 4,
        scaleX: 1,
        scaleY: 1,
        angle: 0,
        flipX: !1,
        flipY: !1,
        opacity: 1,
        shadow: null,
        visible: !0,
        backgroundColor: "",
        fillRule: "nonzero",
        paintFirst: "fill",
        globalCompositeOperation: "source-over",
        skewX: 0,
        skewY: 0,
        selectable: !0,
        hasBorders: !0,
        path: [
          [
            "M",
            0,
            0
          ],
          [
            "L",
            200,
            0
          ],
          [
            "L",
            200,
            200
          ],
          [
            "L",
            0,
            200
          ],
          [
            "Z"
          ]
        ]
      },
      {
        type: "path",
        version: "5.2.4",
        originX: "left",
        originY: "top",
        left: -100,
        top: -100,
        width: 200,
        height: 200,
        fill: "black",
        stroke: null,
        strokeWidth: 0,
        strokeDashArray: null,
        strokeLineCap: "butt",
        strokeDashOffset: 0,
        strokeLineJoin: "miter",
        strokeUniform: !1,
        strokeMiterLimit: 4,
        scaleX: 1,
        scaleY: 1,
        angle: 0,
        flipX: !1,
        flipY: !1,
        opacity: 1,
        shadow: null,
        visible: !0,
        backgroundColor: "",
        fillRule: "nonzero",
        paintFirst: "fill",
        globalCompositeOperation: "source-over",
        skewX: 0,
        skewY: 0,
        selectable: !0,
        hasBorders: !0,
        path: []
      }
    ]
  }
], gd = {
  type: Ef,
  version: Tf,
  originX: Pf,
  originY: Nf,
  left: Df,
  top: Of,
  width: Rf,
  height: If,
  fill: _f,
  stroke: Ff,
  strokeWidth: Bf,
  strokeDashArray: Zf,
  strokeLineCap: qf,
  strokeDashOffset: Uf,
  strokeLineJoin: Hf,
  strokeUniform: Gf,
  strokeMiterLimit: Wf,
  scaleX: Vf,
  scaleY: Xf,
  angle: Yf,
  flipX: Kf,
  flipY: Qf,
  opacity: Jf,
  shadow: ed,
  visible: td,
  backgroundColor: rd,
  fillRule: nd,
  paintFirst: od,
  globalCompositeOperation: sd,
  skewX: id,
  skewY: ad,
  selectable: ld,
  hasBorders: cd,
  minScaleLimit: ud,
  lockScalingFlip: hd,
  _controlsVisibility: md,
  pk_fill: fd,
  pk_shape: dd,
  objects: pd
}, kd = "linear", vd = {
  x1: 50,
  y1: 0,
  x2: 50,
  y2: 100
}, yd = [
  {
    offset: 0.01,
    color: "#cb4f57"
  },
  {
    offset: 1,
    color: "#7a1745"
  }
], bd = 0, xd = 0, wd = "pixels", Ld = null, zd = {
  type: kd,
  coords: vd,
  colorStops: yd,
  offsetX: bd,
  offsetY: xd,
  gradientUnits: wd,
  gradientTransform: Ld
}, Cd = "path", Sd = "5.2.4", $d = "left", Ad = "top", Md = -100, jd = -100, Ed = 200, Td = 200, Pd = {
  type: "pattern",
  source: "",
  repeat: "no-repeat",
  crossOrigin: "",
  offsetX: 0,
  offsetY: 0,
  patternTransform: [
    0.5,
    0,
    0,
    0.5,
    0,
    0
  ]
}, Nd = null, Dd = 0, Od = null, Rd = "butt", Id = 0, _d = "miter", Fd = !1, Bd = 4, Zd = 1, qd = 1, Ud = 0, Hd = !1, Gd = !1, Wd = 1, Vd = null, Xd = !0, Yd = "", Kd = "nonzero", Qd = "fill", Jd = "source-over", ep = 0, tp = 0, rp = !0, np = !0, op = "image", sp = [], B5 = {
  type: Cd,
  version: Sd,
  originX: $d,
  originY: Ad,
  left: Md,
  top: jd,
  width: Ed,
  height: Td,
  fill: Pd,
  stroke: Nd,
  strokeWidth: Dd,
  strokeDashArray: Od,
  strokeLineCap: Rd,
  strokeDashOffset: Id,
  strokeLineJoin: _d,
  strokeUniform: Fd,
  strokeMiterLimit: Bd,
  scaleX: Zd,
  scaleY: qd,
  angle: Ud,
  flipX: Hd,
  flipY: Gd,
  opacity: Wd,
  shadow: Vd,
  visible: Xd,
  backgroundColor: Yd,
  fillRule: Kd,
  paintFirst: Qd,
  globalCompositeOperation: Jd,
  skewX: ep,
  skewY: tp,
  selectable: rp,
  hasBorders: np,
  pk_type: op,
  path: sp
}, ip = "pattern", ap = "", lp = "repeat", cp = "", up = 0, hp = 0, mp = [
  1,
  0,
  0,
  1,
  0,
  0
], fp = {
  type: ip,
  source: ap,
  repeat: lp,
  crossOrigin: cp,
  offsetX: up,
  offsetY: hp,
  patternTransform: mp
}, dp = "", pp = 0, gp = 0, kp = 0, vp = !1, yp = !0, bp = {
  color: dp,
  blur: pp,
  offsetX: gp,
  offsetY: kp,
  affectStroke: vp,
  nonScaling: yp
}, Le = {
  blank: () => JSON.parse(JSON.stringify(Hm)),
  background: () => JSON.parse(JSON.stringify(jf)),
  shape: () => JSON.parse(JSON.stringify(gd)),
  gradient: () => JSON.parse(JSON.stringify(zd)),
  image: () => JSON.parse(JSON.stringify(B5)),
  texture: () => JSON.parse(JSON.stringify(fp)),
  text: () => JSON.parse(JSON.stringify(B5)),
  shadow: () => JSON.parse(JSON.stringify(bp))
}, A8 = (e) => Math.floor(Math.random() * e.length), le = (e) => e[A8(e)], Jn = (e) => e.splice(A8(e), 1)[0], ja = (e, t) => {
  const r = [];
  for (let s = 0; s < t.length; s += 1)
    r[s] = t[s] + (r[s - 1] || 0);
  const o = r[r.length - 1] * Math.random();
  for (let s = 0; s < e.length; s += 1)
    if (r[s] >= o)
      return e[s];
}, Fr = (e, t) => {
  let r = new Array(e), n = t.length, o = new Array(n);
  for (; e--; ) {
    let s = Math.floor(Math.random() * n);
    r[e] = t[s in o ? o[s] : s], o[s] = --n in o ? o[n] : n;
  }
  return r;
}, Ea = (e, t) => (e = Math.ceil(e), t = Math.floor(t), Math.floor(Math.random() * (t - e + 1)) + e), xp = () => !!Math.floor(Math.random() * 2), wp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getRandomArrayIndex: A8,
  getRandomElement: le,
  removeRandomElement: Jn,
  getWeightedRandomElement: ja,
  getRandomArray: Fr,
  getRandomInt: Ea,
  getRandomBool: xp
}, Symbol.toStringTag, { value: "Module" })), Lp = "blocks", zp = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/c9cb1002-0661-46c8-a9cb-75f7964be10f.jpeg", Cp = [
  1,
  1,
  1,
  2
], Sp = [
  "block36",
  "block37",
  "block38",
  "block39"
], $p = [], Ap = [
  "circle",
  "circle-one-side",
  "circle-opposite-sides",
  "circle-three-sides"
], Mp = {
  type: Lp,
  thumbnailUrl: zp,
  blockWeights: Cp,
  blocks: Sp,
  shapes: $p,
  imageShapes: Ap
}, jp = "blocks", Ep = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/b6b74d63-0cf5-4c07-865a-b9701f058cce.jpeg", Tp = [
  1,
  1,
  1,
  1
], Pp = [
  "block85",
  "block86",
  "block87",
  "block106"
], Np = [], Dp = [
  "circle",
  "circle-one-side",
  "circle-opposite-sides",
  "circle-three-sides"
], Op = {
  type: jp,
  thumbnailUrl: Ep,
  blockWeights: Tp,
  blocks: Pp,
  shapes: Np,
  imageShapes: Dp
}, Rp = "blocks", Ip = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/7635868e-edfb-4488-b76d-35b708cba0e7.jpeg", _p = [
  1,
  1,
  1,
  1,
  1
], Fp = [
  "block3",
  "block47",
  "block53",
  "block54",
  "block58"
], Bp = [
  "square",
  "wedge-bl"
], Zp = !0, qp = {
  type: Rp,
  thumbnailUrl: Ip,
  blockWeights: _p,
  blocks: Fp,
  imageShapes: Bp,
  free: Zp
}, Up = "blocks", Hp = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/ef4f828a-b054-4eca-9e5c-d0f6d2a5d798.jpeg", Gp = [
  1,
  1,
  1
], Wp = [
  "block25",
  "block26",
  "block27",
  "block28"
], Vp = [], Xp = [
  "circle",
  "circle-one-side",
  "circle-opposite-sides",
  "circle-three-sides"
], Yp = {
  type: Up,
  thumbnailUrl: Hp,
  blockWeights: Gp,
  blocks: Wp,
  shapes: Vp,
  imageShapes: Xp
}, Kp = "blocks", Qp = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/2ca6a802-31e4-4584-8939-6889ebeaa5fa.jpeg", Jp = [
  1
], eg = [
  "block53"
], tg = [], rg = [
  "square",
  "wedge-bl"
], ng = !0, og = {
  type: Kp,
  thumbnailUrl: Qp,
  blockWeights: Jp,
  blocks: eg,
  shapes: tg,
  imageShapes: rg,
  free: ng
}, sg = "blocks", ig = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/e76604b0-5cd6-4498-a304-ba1118f0df6f.jpeg", ag = [
  1,
  2,
  1,
  2
], lg = [
  "block12",
  "block16",
  "block46",
  "block76"
], cg = [], ug = [
  "circle",
  "circle-one-side",
  "circle-opposite-sides",
  "circle-three-sides"
], hg = !0, mg = {
  type: sg,
  thumbnailUrl: ig,
  blockWeights: ag,
  blocks: lg,
  shapes: cg,
  imageShapes: ug,
  free: hg
}, fg = "blocks", dg = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/69490a91-d2b6-4fe8-90d9-f03c58be7d13.jpeg", pg = [
  1
], gg = [
  "block68"
], kg = [], vg = [
  "circle",
  "circle-opposite-sides"
], yg = !0, bg = {
  type: fg,
  thumbnailUrl: dg,
  blockWeights: pg,
  blocks: gg,
  shapes: kg,
  imageShapes: vg,
  free: yg
}, xg = "blocks", wg = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/5d130d17-8e58-43a5-b226-53938550514f.jpeg", Lg = [
  2,
  1,
  1
], zg = [
  "block79",
  "block80",
  "block81"
], Cg = [], Sg = [
  "circle",
  "square",
  "circle-one-side",
  "circle-opposite-sides",
  "circle-three-sides"
], $g = {
  type: xg,
  thumbnailUrl: wg,
  blockWeights: Lg,
  blocks: zg,
  shapes: Cg,
  imageShapes: Sg
}, Ag = "blocks", Mg = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/4988120e-ad02-46fd-ab6f-eac1663590bb.jpeg", jg = [
  1,
  1
], Eg = [
  "block113",
  "block114"
], Tg = [], Pg = [
  "square",
  "wedge-bl"
], Ng = {
  type: Ag,
  thumbnailUrl: Mg,
  blockWeights: jg,
  blocks: Eg,
  shapes: Tg,
  imageShapes: Pg
}, Dg = "blocks", Og = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/273945f6-65dc-4197-8f74-e79ed7779f15.jpeg", Rg = [
  1
], Ig = [
  "block115"
], _g = [], Fg = [
  "square",
  "wedge-bl"
], Bg = {
  type: Dg,
  thumbnailUrl: Og,
  blockWeights: Rg,
  blocks: Ig,
  shapes: _g,
  imageShapes: Fg
}, Zg = "blocks", qg = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/c9835caf-055e-4edf-9e68-f3dcb97cc62d.jpeg", Ug = [
  1
], Hg = [
  "block3"
], Gg = [], Wg = [
  "square",
  "wedge-bl"
], Vg = !0, Xg = {
  type: Zg,
  thumbnailUrl: qg,
  blockWeights: Ug,
  blocks: Hg,
  shapes: Gg,
  imageShapes: Wg,
  free: Vg
}, Yg = "blocks", Kg = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/9501e33d-f786-429e-8d51-05ee3570e98c.jpeg", Qg = [
  1,
  1,
  1,
  1
], Jg = [
  "block32",
  "block33",
  "block34",
  "block35"
], ek = [], tk = [
  "square"
], rk = !0, nk = {
  type: Yg,
  thumbnailUrl: Kg,
  blockWeights: Qg,
  blocks: Jg,
  shapes: ek,
  imageShapes: tk,
  free: rk
}, ok = "blocks", sk = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/15a8c1c2-b3db-4f88-91e9-4bd70e03b0d3.jpeg", ik = [
  2,
  2,
  2,
  2,
  1
], ak = [
  "block95",
  "block96",
  "block16",
  "block97",
  "block98"
], lk = [], ck = [
  "square"
], uk = {
  type: ok,
  thumbnailUrl: sk,
  blockWeights: ik,
  blocks: ak,
  shapes: lk,
  imageShapes: ck
}, hk = "blocks", mk = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/feb6b43f-9ef6-4f83-84fe-9c7f67e68735.jpeg", fk = [
  1
], dk = [
  "block67"
], pk = [], gk = [
  "square",
  "wedge-bl"
], kk = {
  type: hk,
  thumbnailUrl: mk,
  blockWeights: fk,
  blocks: dk,
  shapes: pk,
  imageShapes: gk
}, vk = "blocks", yk = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/0e10901d-6b6c-4f7a-ae08-67d68cdd636a.jpeg", bk = [
  1,
  1
], xk = [
  "block30",
  "block31"
], wk = [], Lk = [
  "square",
  "wedge-bl"
], zk = !0, Ck = {
  type: vk,
  thumbnailUrl: yk,
  blockWeights: bk,
  blocks: xk,
  shapes: wk,
  imageShapes: Lk,
  free: zk
}, Sk = "blocks", $k = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/5dc24802-3743-4ef6-af8a-c51433137007.jpeg", Ak = [
  1,
  1,
  1,
  1,
  1,
  1,
  1
], Mk = [
  "block4",
  "block11",
  "block12",
  "block16",
  "block45",
  "block51",
  "block57"
], jk = [], Ek = [
  "circle",
  "circle-one-side",
  "circle-opposite-sides",
  "circle-three-sides"
], Tk = {
  type: Sk,
  thumbnailUrl: $k,
  blockWeights: Ak,
  blocks: Mk,
  shapes: jk,
  imageShapes: Ek
}, Pk = "blocks", Nk = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/c706e66c-6dca-42e6-b46e-ab2989d40116.jpeg", Dk = [
  1,
  1,
  1,
  1,
  1,
  1,
  1
], Ok = [
  "block110",
  "block88",
  "block45",
  "block15",
  "block59",
  "block103",
  "block63"
], Rk = [], Ik = [
  "circle"
], _k = {
  type: Pk,
  thumbnailUrl: Nk,
  blockWeights: Dk,
  blocks: Ok,
  shapes: Rk,
  imageShapes: Ik
}, Fk = "blocks", Bk = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/db6db322-e5e8-4651-86de-0e8412089341.jpeg", Zk = [
  1,
  1,
  1,
  1
], qk = [
  "block104",
  "block105",
  "block25",
  "block97"
], Uk = [], Hk = [
  "circle",
  "semi-circle-rectangle-t",
  "circle-one-side",
  "circle-opposite-sides",
  "circle-three-sides"
], Gk = !0, Wk = {
  type: Fk,
  thumbnailUrl: Bk,
  blockWeights: Zk,
  blocks: qk,
  shapes: Uk,
  imageShapes: Hk,
  free: Gk
}, Vk = "blocks", Xk = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/7299cea6-7996-47d5-9236-380e024fcf1a.jpeg", Yk = [
  1
], Kk = [
  "block12"
], Qk = [
  "circle",
  "circle-one-side",
  "circle-opposite-sides",
  "circle-three-sides"
], Jk = !0, ev = {
  type: Vk,
  thumbnailUrl: Xk,
  blockWeights: Yk,
  blocks: Kk,
  imageShapes: Qk,
  free: Jk
}, tv = "blocks", rv = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/305e7c7d-6a1d-4392-9294-b63c7d3c9ea4.jpeg", nv = [
  1,
  1,
  1
], ov = [
  "block82",
  "block83",
  "block84"
], sv = [], iv = [
  "square"
], av = {
  type: tv,
  thumbnailUrl: rv,
  blockWeights: nv,
  blocks: ov,
  shapes: sv,
  imageShapes: iv
}, lv = "blocks", cv = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/d61c5164-1cf0-4cfb-b755-65b996c93784.jpeg", uv = [
  1
], hv = [
  "block47"
], mv = [], fv = [
  "square",
  "wedge-bl"
], dv = {
  type: lv,
  thumbnailUrl: cv,
  blockWeights: uv,
  blocks: hv,
  shapes: mv,
  imageShapes: fv
}, pv = "blocks", gv = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/c351750c-9521-4e61-ad44-2877444dc67a.jpeg", kv = [
  1,
  1
], vv = [
  "block65",
  "block66"
], yv = [], bv = [
  "square",
  "circle",
  "circle-one-side",
  "circle-opposite-sides",
  "circle-three-sides"
], xv = {
  type: pv,
  thumbnailUrl: gv,
  blockWeights: kv,
  blocks: vv,
  shapes: yv,
  imageShapes: bv
}, wv = "blocks", Lv = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/5af0eac0-2703-4a87-8606-accd82b7712c.jpeg", zv = [
  1
], Cv = [
  "block1"
], Sv = [], $v = [
  "square",
  "wedge-bl"
], Av = !0, Mv = {
  type: wv,
  thumbnailUrl: Lv,
  blockWeights: zv,
  blocks: Cv,
  shapes: Sv,
  imageShapes: $v,
  free: Av
}, jv = "blocks", Ev = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/85221af7-a2c3-430f-97a5-a1f0fd676778.jpeg", Tv = [
  1,
  1,
  2,
  1,
  1
], Pv = [
  "block99",
  "block100",
  "block63",
  "block88",
  "block89"
], Nv = [], Dv = [
  "square",
  "wedge-bl"
], Ov = !0, Rv = {
  type: jv,
  thumbnailUrl: Ev,
  blockWeights: Tv,
  blocks: Pv,
  shapes: Nv,
  imageShapes: Dv,
  free: Ov
}, Iv = "blocks", _v = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/855c605b-085f-4227-a612-da209e5a59c9.jpeg", Fv = [
  1,
  1,
  1
], Bv = [
  "block40",
  "block41",
  "block42"
], Zv = [], qv = [
  "circle",
  "semi-circle-rectangle-t",
  "circle-one-side",
  "circle-opposite-sides",
  "circle-three-sides"
], Uv = {
  type: Iv,
  thumbnailUrl: _v,
  blockWeights: Fv,
  blocks: Bv,
  shapes: Zv,
  imageShapes: qv
}, Hv = "blocks", Gv = "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/thumbnails/41684383-1778-4e98-8855-4bf2b25bd36e.jpeg", Wv = [
  1,
  1,
  1,
  1,
  1
], Vv = [
  "block16",
  "block109",
  "block110",
  "block111",
  "block112"
], Xv = [], Yv = [
  "square",
  "wedge-bl"
], Kv = !0, Qv = {
  type: Hv,
  thumbnailUrl: Gv,
  blockWeights: Wv,
  blocks: Vv,
  shapes: Xv,
  imageShapes: Yv,
  free: Kv
}, t2 = {
  spaceCadet: Rv,
  chemicalKev: qp,
  sawtooth: Mv,
  cornerstone: og,
  pidge: Wk,
  teddy: Qv,
  poggins: ev,
  eyeHoles: bg,
  dynasty: mg,
  menos: nk,
  mrBusiness: Ck,
  houses: Xg,
  glorio: Bg,
  binLid: Mp,
  century: Op,
  furio: Ng,
  clockwork: Yp,
  flowers: $g,
  mockup: uk,
  movingBoxes: kk,
  mrsMischief: Tk,
  okocha: _k,
  pyramids: av,
  rooftop: dv,
  roundabout: xv,
  sunshine: Uv
}, a9 = Object.keys(t2), Ta = () => a9.filter((e) => t2[e].free), Jv = () => Ta().reduce((t, r) => (t[r] = !0, t), {}), ey = () => t2[le(a9)], L50 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  list: t2,
  templateNames: a9,
  getFreeTemplates: Ta,
  getFreeTemplatesObject: Jv,
  getRandomTemplate: ey,
  default: t2
}, Symbol.toStringTag, { value: "Module" })), ty = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "sawtooth-l",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "sawtooth-l",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 180
  }
], ry = [
  2,
  2
], ny = 3, oy = !1, sy = {
  shapes: ty,
  dimensions: ry,
  colourCount: ny,
  rotate: oy
}, iy = [
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  }
], ay = [
  2,
  2
], ly = 2, cy = !0, uy = {
  shapes: iy,
  dimensions: ay,
  colourCount: ly,
  rotate: cy
}, hy = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "house",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "center-point-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 180
  }
], my = [
  2,
  2
], fy = 3, dy = !0, py = {
  shapes: hy,
  dimensions: my,
  colourCount: fy,
  rotate: dy
}, gy = [
  {
    name: "center-point-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "semi-circle-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  }
], ky = [
  2,
  2
], vy = 2, yy = !0, by = {
  shapes: gy,
  dimensions: ky,
  colourCount: vy,
  rotate: yy
}, xy = [
  {
    name: "circles-diagonal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "circles-diagonal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  }
], wy = [
  2,
  2
], Ly = 2, zy = !0, Cy = {
  shapes: xy,
  dimensions: wy,
  colourCount: Ly,
  rotate: zy
}, Sy = [
  {
    name: "petal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "petal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 90
  }
], $y = [
  2,
  2
], Ay = 2, My = !1, jy = {
  shapes: Sy,
  dimensions: $y,
  colourCount: Ay,
  rotate: My
}, Ey = [
  {
    name: "petal",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "petal",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "petal",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 0,
    rotation: 90
  },
  {
    name: "petal",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 0,
    rotation: 90
  }
], Ty = [
  2,
  2
], Py = 2, Ny = !1, Dy = {
  shapes: Ey,
  dimensions: Ty,
  colourCount: Py,
  rotate: Ny
}, Oy = [
  {
    name: "circle",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "petal",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "petal",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "petal",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 2,
    rotation: 0
  },
  {
    name: "petal",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 2,
    rotation: 0
  }
], Ry = [
  2,
  2
], Iy = 3, _y = !1, Fy = {
  shapes: Oy,
  dimensions: Ry,
  colourCount: Iy,
  rotate: _y
}, By = [
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "diamond",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  }
], Zy = [
  2,
  2
], qy = 2, Uy = !0, Hy = {
  shapes: By,
  dimensions: Zy,
  colourCount: qy,
  rotate: Uy
}, Gy = [
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "petal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  }
], Wy = [
  2,
  2
], Vy = 2, Xy = !0, Yy = {
  shapes: Gy,
  dimensions: Wy,
  colourCount: Vy,
  rotate: Xy
}, Ky = [
  {
    name: "quarter-circle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "center-point-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  }
], Qy = [
  2,
  2
], Jy = 2, eb = !0, tb = {
  shapes: Ky,
  dimensions: Qy,
  colourCount: Jy,
  rotate: eb
}, rb = [
  {
    name: "quarter-circle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "semi-circle-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  }
], nb = [
  2,
  2
], ob = 2, sb = !0, ib = {
  shapes: rb,
  dimensions: nb,
  colourCount: ob,
  rotate: sb
}, ab = [
  {
    name: "diamond",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "rectangle-diagonal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  }
], lb = [
  2,
  2
], cb = 2, ub = !0, hb = {
  shapes: ab,
  dimensions: lb,
  colourCount: cb,
  rotate: ub
}, mb = [
  {
    name: "diamond",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  }
], fb = [
  2,
  2
], db = 2, pb = !1, gb = {
  shapes: mb,
  dimensions: fb,
  colourCount: db,
  rotate: pb
}, kb = [
  {
    name: "circle-three-sides",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "circle-three-sides",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "circle-three-sides",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 1,
    rotation: 270
  },
  {
    name: "circle-three-sides",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 0,
    rotation: 180
  }
], vb = [
  2,
  2
], yb = 2, bb = !1, xb = {
  shapes: kb,
  dimensions: vb,
  colourCount: yb,
  rotate: bb
}, wb = [
  {
    name: "quarter-circle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "quarter-circle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], Lb = [
  2,
  2
], zb = 2, Cb = !0, Sb = {
  shapes: wb,
  dimensions: Lb,
  colourCount: zb,
  rotate: Cb
}, $b = [
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 180
  },
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 0
  }
], Ab = [
  2,
  2
], Mb = 4, jb = !0, Eb = {
  shapes: $b,
  dimensions: Ab,
  colourCount: Mb,
  rotate: jb
}, Tb = [
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  },
  {
    name: "center-point-d",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  }
], Pb = [
  2,
  2
], Nb = 2, Db = !0, Ob = {
  shapes: Tb,
  dimensions: Pb,
  colourCount: Nb,
  rotate: Db
}, Rb = [
  {
    name: "rectangle-l",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 90
  },
  {
    name: "rectangle-l",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 1,
    rotation: 180
  },
  {
    name: "rectangle-l",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 0,
    rotation: 270
  },
  {
    name: "rectangle-l",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 1,
    rotation: 0
  }
], Ib = [
  2,
  2
], _b = 2, Fb = !1, Bb = {
  shapes: Rb,
  dimensions: Ib,
  colourCount: _b,
  rotate: Fb
}, Zb = [
  {
    name: "rectangle-l",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 270
  },
  {
    name: "rectangle-l",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "rectangle-l",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 0,
    rotation: 90
  },
  {
    name: "rectangle-l",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 1,
    rotation: 180
  }
], qb = [
  2,
  2
], Ub = 2, Hb = !1, Gb = {
  shapes: Zb,
  dimensions: qb,
  colourCount: Ub,
  rotate: Hb
}, Wb = [
  {
    name: "center-point-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "center-point-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  }
], Vb = [
  2,
  2
], Xb = 2, Yb = !0, Kb = {
  shapes: Wb,
  dimensions: Vb,
  colourCount: Xb,
  rotate: Yb
}, Qb = [
  {
    name: "circle",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "center-point-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 0
  },
  {
    name: "center-point-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  }
], Jb = [
  2,
  2
], ex = 3, tx = !0, rx = {
  shapes: Qb,
  dimensions: Jb,
  colourCount: ex,
  rotate: tx
}, nx = [
  {
    name: "circle-opposite-sides",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "circle-opposite-sides",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "circle-opposite-sides",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 1,
    rotation: 270
  },
  {
    name: "circle-opposite-sides",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 0,
    rotation: 180
  }
], ox = [
  2,
  2
], sx = 2, ix = !1, ax = {
  shapes: nx,
  dimensions: ox,
  colourCount: sx,
  rotate: ix
}, lx = [
  {
    name: "circle-three-sides",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 180
  },
  {
    name: "circle-three-sides",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 1,
    rotation: 270
  },
  {
    name: "circle-three-sides",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "circle-three-sides",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 0,
    rotation: 0
  }
], cx = [
  2,
  2
], ux = 2, hx = !1, mx = {
  shapes: lx,
  dimensions: cx,
  colourCount: ux,
  rotate: hx
}, fx = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "circle",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], dx = [
  2,
  2
], px = 2, gx = !1, kx = {
  shapes: fx,
  dimensions: dx,
  colourCount: px,
  rotate: gx
}, vx = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "semi-circle-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "semi-circle-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 180
  }
], yx = [
  2,
  2
], bx = 3, xx = !0, wx = {
  shapes: vx,
  dimensions: yx,
  colourCount: bx,
  rotate: xx
}, Lx = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "circle",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "circle-quarter-cut",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 0
  }
], zx = [
  2,
  2
], Cx = 3, Sx = !0, $x = {
  shapes: Lx,
  dimensions: zx,
  colourCount: Cx,
  rotate: Sx
}, Ax = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "semi-circle-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "semi-circle-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 180
  },
  {
    name: "semi-circle-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 3,
    rotation: 90
  }
], Mx = [
  2,
  2
], jx = 4, Ex = !0, Tx = {
  shapes: Ax,
  dimensions: Mx,
  colourCount: jx,
  rotate: Ex
}, Px = [
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  },
  {
    name: "semi-circle-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 90
  },
  {
    name: "semi-circle-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 270
  }
], Nx = [
  2,
  2
], Dx = 2, Ox = !0, Rx = {
  shapes: Px,
  dimensions: Nx,
  colourCount: Dx,
  rotate: Ox
}, Ix = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "wedge-opposite-l",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "wedge-opposite-l",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 0,
    flip: !0
  }
], _x = [
  2,
  2
], Fx = 3, Bx = !1, Zx = {
  shapes: Ix,
  dimensions: _x,
  colourCount: Fx,
  rotate: Bx
}, qx = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "wedge-opposite-l",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  },
  {
    name: "wedge-opposite-l",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 180,
    flip: !0
  }
], Ux = [
  2,
  2
], Hx = 3, Gx = !1, Wx = {
  shapes: qx,
  dimensions: Ux,
  colourCount: Hx,
  rotate: Gx
}, Vx = [
  {
    name: "pyramid-t",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  },
  {
    name: "square",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 2,
    rotation: 0
  },
  {
    name: "pyramid-t",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 3,
    rotation: 180
  },
  {
    name: "square",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 2,
    rotation: 0
  },
  {
    name: "pyramid-t",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 3,
    rotation: 0
  },
  {
    name: "pyramid-t",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 1,
    rotation: 0
  }
], Xx = 4, Yx = !1, Kx = {
  shapes: Vx,
  colourCount: Xx,
  rotate: Yx
}, Qx = [
  {
    name: "square",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "pyramid-t",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "pyramid-t",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 3,
    rotation: 270
  },
  {
    name: "pyramid-t",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 3,
    rotation: 90
  },
  {
    name: "square",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "pyramid-t",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 1,
    rotation: 270
  }
], Jx = 4, ew = !1, tw = {
  shapes: Qx,
  colourCount: Jx,
  rotate: ew
}, rw = [
  {
    name: "square",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "pyramid-t",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "pyramid-t",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 3,
    rotation: 0
  },
  {
    name: "pyramid-t",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 3,
    rotation: 0
  },
  {
    name: "square",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "pyramid-t",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 1,
    rotation: 0
  }
], nw = 4, ow = !1, sw = {
  shapes: rw,
  colourCount: nw,
  rotate: ow
}, iw = [
  {
    name: "pyramid-t",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  },
  {
    name: "square",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 2,
    rotation: 0
  },
  {
    name: "pyramid-t",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 3,
    rotation: 180
  },
  {
    name: "square",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 2,
    rotation: 0
  },
  {
    name: "pyramid-t",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 3,
    rotation: 180
  },
  {
    name: "pyramid-t",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 1,
    rotation: 180
  }
], aw = 4, lw = !1, cw = {
  shapes: iw,
  colourCount: aw,
  rotate: lw
}, uw = [
  {
    name: "rectangle-diagonal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "rectangle-diagonal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "circle",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 0
  }
], hw = 3, mw = !1, fw = {
  shapes: uw,
  colourCount: hw,
  rotate: mw
}, dw = [
  {
    name: "rectangle-diagonal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "rectangle-diagonal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "semi-circle-rectangle-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 0
  }
], pw = 3, gw = !0, kw = {
  shapes: dw,
  colourCount: pw,
  rotate: gw
}, vw = [
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 180
  },
  {
    name: "circle-three-sides",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 3,
    rotation: 90
  }
], yw = 4, bw = !0, xw = {
  shapes: vw,
  colourCount: yw,
  rotate: bw
}, ww = [
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  },
  {
    name: "semi-circle-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "semi-circle-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  }
], Lw = 3, zw = !0, Cw = {
  shapes: ww,
  colourCount: Lw,
  rotate: zw
}, Sw = [
  {
    name: "circle-quarter-cut",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  }
], $w = [
  2,
  2
], Aw = 1, Mw = !0, jw = {
  shapes: Sw,
  dimensions: $w,
  colourCount: Aw,
  rotate: Mw
}, Ew = [
  {
    name: "semi-circle-d",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "semi-circle-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], Tw = [
  2,
  2
], Pw = 2, Nw = !0, Dw = {
  shapes: Ew,
  dimensions: Tw,
  colourCount: Pw,
  rotate: Nw
}, Ow = [
  {
    name: "circle",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "circle-quarter-cut",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], Rw = [
  2,
  2
], Iw = 2, _w = !0, Fw = {
  shapes: Ow,
  dimensions: Rw,
  colourCount: Iw,
  rotate: _w
}, Bw = [
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  },
  {
    name: "circle-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "circle-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 180
  }
], Zw = [
  2,
  2
], qw = 2, Uw = !0, Hw = {
  shapes: Bw,
  dimensions: Zw,
  colourCount: qw,
  rotate: Uw
}, Gw = [
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  },
  {
    name: "quarter-circle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 180
  },
  {
    name: "quarter-circle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 270
  }
], Ww = [
  2,
  2
], Vw = 2, Xw = !0, Yw = {
  shapes: Gw,
  dimensions: Ww,
  colourCount: Vw,
  rotate: Xw
}, Kw = [
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "quarter-circle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 180
  }
], Qw = [
  2,
  2
], Jw = 1, eL = !0, tL = {
  shapes: Kw,
  dimensions: Qw,
  colourCount: Jw,
  rotate: eL
}, rL = [
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "semi-circle-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  }
], nL = [
  2,
  2
], oL = 2, sL = !0, iL = {
  shapes: rL,
  dimensions: nL,
  colourCount: oL,
  rotate: sL
}, aL = [
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  },
  {
    name: "center-point-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 0
  }
], lL = [
  2,
  2
], cL = 3, uL = !0, hL = {
  shapes: aL,
  dimensions: lL,
  colourCount: cL,
  rotate: uL
}, mL = [
  {
    name: "semi-circle-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "semi-circle-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 180
  },
  {
    name: "center-point-v",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], fL = [
  2,
  2
], dL = 2, pL = !0, gL = {
  shapes: mL,
  dimensions: fL,
  colourCount: dL,
  rotate: pL
}, kL = [
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  },
  {
    name: "center-point-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "center-point-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 270
  }
], vL = [
  2,
  2
], yL = 2, bL = !0, xL = {
  shapes: kL,
  dimensions: vL,
  colourCount: yL,
  rotate: bL
}, wL = [
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  },
  {
    name: "circle-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "circle-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 180
  }
], LL = [
  2,
  2
], zL = 2, CL = !0, SL = {
  shapes: wL,
  dimensions: LL,
  colourCount: zL,
  rotate: CL
}, $L = [
  {
    name: "center-point-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "quarter-circle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 180
  }
], AL = [
  2,
  2
], ML = 1, jL = !0, EL = {
  shapes: $L,
  dimensions: AL,
  colourCount: ML,
  rotate: jL
}, TL = [
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  },
  {
    name: "center-point-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "center-point-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 270
  }
], PL = [
  2,
  2
], NL = 3, DL = !0, OL = {
  shapes: TL,
  dimensions: PL,
  colourCount: NL,
  rotate: DL
}, RL = [
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  },
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 90
  }
], IL = [
  2,
  2
], _L = 3, FL = !0, BL = {
  shapes: RL,
  dimensions: IL,
  colourCount: _L,
  rotate: FL
}, ZL = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "wedge-bl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 90
  },
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], qL = [
  2,
  2
], UL = 3, HL = !0, GL = {
  shapes: ZL,
  dimensions: qL,
  colourCount: UL,
  rotate: HL
}, WL = [
  {
    name: "quarter-circle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], VL = [
  2,
  2
], XL = 2, YL = !0, KL = {
  shapes: WL,
  dimensions: VL,
  colourCount: XL,
  rotate: YL
}, QL = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "quarter-circle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 90
  }
], JL = [
  2,
  2
], ez = 3, tz = !0, rz = {
  shapes: QL,
  dimensions: JL,
  colourCount: ez,
  rotate: tz
}, nz = [
  {
    name: "semi-circle-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  }
], oz = [
  2,
  2
], sz = 2, iz = !0, az = {
  shapes: nz,
  dimensions: oz,
  colourCount: sz,
  rotate: iz
}, lz = [
  {
    name: "rectangle-diagonal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 270
  }
], cz = [
  2,
  2
], uz = 3, hz = !0, mz = {
  shapes: lz,
  dimensions: cz,
  colourCount: uz,
  rotate: hz
}, fz = [
  {
    name: "pyramid-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "center-point-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  }
], dz = [
  2,
  2
], pz = 2, gz = !0, kz = {
  shapes: fz,
  dimensions: dz,
  colourCount: pz,
  rotate: gz
}, vz = [
  {
    name: "quarter-circle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "quarter-circle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 90
  },
  {
    name: "center-point-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], yz = [
  2,
  2
], bz = 2, xz = !0, wz = {
  shapes: vz,
  dimensions: yz,
  colourCount: bz,
  rotate: xz
}, Lz = [
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 180
  },
  {
    name: "quarter-circle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "quarter-circle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 90
  }
], zz = [
  2,
  2
], Cz = 3, Sz = !0, $z = {
  shapes: Lz,
  dimensions: zz,
  colourCount: Cz,
  rotate: Sz
}, Az = [
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "quarter-circle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "quarter-circle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  }
], Mz = [
  2,
  2
], jz = 2, Ez = !0, Tz = {
  shapes: Az,
  dimensions: Mz,
  colourCount: jz,
  rotate: Ez
}, Pz = [
  {
    name: "circle",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "pyramid-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], Nz = [
  2,
  2
], Dz = 2, Oz = !0, Rz = {
  shapes: Pz,
  dimensions: Nz,
  colourCount: Dz,
  rotate: Oz
}, Iz = [
  {
    name: "rectangle-diagonal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "diamond",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], _z = [
  2,
  2
], Fz = 2, Bz = !0, Zz = {
  shapes: Iz,
  dimensions: _z,
  colourCount: Fz,
  rotate: Bz
}, qz = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "quarter-circle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "quarter-circle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 180
  }
], Uz = [
  2,
  2
], Hz = 3, Gz = !0, Wz = {
  shapes: qz,
  dimensions: Uz,
  colourCount: Hz,
  rotate: Gz
}, Vz = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "quarter-circle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "quarter-circle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  }
], Xz = [
  2,
  2
], Yz = 2, Kz = !0, Qz = {
  shapes: Vz,
  dimensions: Xz,
  colourCount: Yz,
  rotate: Kz
}, Jz = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "wedge-opposite-l",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 270,
    flip: !0
  },
  {
    name: "triangle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 270
  },
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  }
], eC = [
  2,
  2
], tC = 3, rC = {
  shapes: Jz,
  dimensions: eC,
  colourCount: tC
}, nC = [
  {
    name: "petal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 90
  },
  {
    name: "petal-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], oC = [
  2,
  2
], sC = 2, iC = !0, aC = {
  shapes: nC,
  dimensions: oC,
  colourCount: sC,
  rotate: iC
}, lC = [
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 90
  }
], cC = [
  2,
  2
], uC = 2, hC = !0, mC = {
  shapes: lC,
  dimensions: cC,
  colourCount: uC,
  rotate: hC
}, fC = [
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 180
  }
], dC = [
  2,
  2
], pC = 2, gC = !0, kC = {
  shapes: fC,
  dimensions: dC,
  colourCount: pC,
  rotate: gC
}, vC = [
  {
    name: "semi-circle-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "center-point-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], yC = [
  2,
  2
], bC = 2, xC = !0, wC = {
  shapes: vC,
  dimensions: yC,
  colourCount: bC,
  rotate: xC
}, LC = [
  {
    name: "diamond-diagonal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "diamond-diagonal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 90
  }
], zC = [
  2,
  2
], CC = 1, SC = {
  shapes: LC,
  dimensions: zC,
  colourCount: CC
}, $C = [
  {
    name: "diamond-diagonal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "diamond-diagonal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  }
], AC = [
  2,
  2
], MC = 2, jC = !0, EC = {
  shapes: $C,
  dimensions: AC,
  colourCount: MC,
  rotate: jC
}, TC = [
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 180
  },
  {
    name: "diamond-diagonal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "diamond-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "diamond-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 270
  }
], PC = [
  2,
  2
], NC = 3, DC = !0, OC = {
  shapes: TC,
  dimensions: PC,
  colourCount: NC,
  rotate: DC
}, RC = [
  {
    name: "triangle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "center-point-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "triangle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 90
  }
], IC = [
  2,
  2
], _C = 3, FC = !0, BC = {
  shapes: RC,
  dimensions: IC,
  colourCount: _C,
  rotate: FC
}, ZC = [
  {
    name: "quarter-circle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "semi-circle-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], qC = [
  2,
  2
], UC = 2, HC = !0, GC = {
  shapes: ZC,
  dimensions: qC,
  colourCount: UC,
  rotate: HC
}, WC = [
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "triangle-br-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  }
], VC = [
  2,
  2
], XC = 2, YC = !0, KC = {
  shapes: WC,
  dimensions: VC,
  colourCount: XC,
  rotate: YC
}, QC = [
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "triangle-br-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 180
  }
], JC = [
  2,
  2
], eS = 1, tS = !0, rS = {
  shapes: QC,
  dimensions: JC,
  colourCount: eS,
  rotate: tS
}, nS = [
  {
    name: "quarter-circle-tl",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 270
  },
  {
    name: "quarter-circle-tl",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "quarter-circle-tl",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "quarter-circle-tl",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 0,
    rotation: 180
  }
], oS = [
  2,
  2
], sS = 2, iS = {
  shapes: nS,
  dimensions: oS,
  colourCount: sS
}, aS = [
  {
    name: "petal",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 90
  },
  {
    name: "petal",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "square",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 2,
    rotation: 0
  },
  {
    name: "petal",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "square",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 3,
    rotation: 0
  },
  {
    name: "petal",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 0,
    rotation: 90
  }
], lS = [
  2,
  2
], cS = 4, uS = {
  shapes: aS,
  dimensions: lS,
  colourCount: cS
}, hS = [
  {
    name: "petal",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 90
  },
  {
    name: "petal",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "petal",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "petal",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 0,
    rotation: 90
  }
], mS = [
  2,
  2
], fS = 2, dS = {
  shapes: hS,
  dimensions: mS,
  colourCount: fS
}, pS = [
  {
    name: "pyramid-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "pyramid-b-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0,
    flip: !0
  }
], gS = [
  2,
  2
], kS = 2, vS = {
  shapes: pS,
  dimensions: gS,
  colourCount: kS
}, yS = [
  {
    name: "pyramid-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "pyramid-b-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "pyramid-b-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 0,
    flip: !0
  },
  {
    name: "pyramid-b-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 3,
    rotation: 180
  }
], bS = [
  2,
  2
], xS = 4, wS = {
  shapes: yS,
  dimensions: bS,
  colourCount: xS
}, LS = [
  {
    name: "pyramid-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 180
  },
  {
    name: "pyramid-b-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180,
    flip: !0
  },
  {
    name: "pyramid-b-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 0,
    flip: !0
  }
], zS = [
  2,
  2
], CS = 3, SS = {
  shapes: LS,
  dimensions: zS,
  colourCount: CS
}, $S = [
  {
    name: "quarter-circle-tl",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  },
  {
    name: "square",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "quarter-circle-tl",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 2,
    rotation: 270
  },
  {
    name: "square",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 2,
    rotation: 0
  },
  {
    name: "quarter-circle-tl",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 0,
    rotation: 180
  },
  {
    name: "quarter-circle-tl",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 3,
    rotation: 0
  }
], AS = [
  2,
  2
], MS = 4, jS = {
  shapes: $S,
  dimensions: AS,
  colourCount: MS
}, ES = [
  {
    name: "square",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "quarter-circle-tl",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  },
  {
    name: "quarter-circle-tl",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 3,
    rotation: 270
  },
  {
    name: "quarter-circle-tl",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 2,
    rotation: 90
  },
  {
    name: "square",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 2,
    rotation: 0
  },
  {
    name: "quarter-circle-tl",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 0,
    rotation: 90
  }
], TS = [
  2,
  2
], PS = 4, NS = {
  shapes: ES,
  dimensions: TS,
  colourCount: PS
}, DS = [
  {
    name: "quarter-circle-tl",
    size: 1,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "square",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 2,
    rotation: 0
  },
  {
    name: "quarter-circle-tl",
    size: 1,
    position: [
      1,
      0
    ],
    colour: 3,
    rotation: 270
  },
  {
    name: "square",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "quarter-circle-tl",
    size: 1,
    position: [
      0,
      1
    ],
    colour: 2,
    rotation: 90
  },
  {
    name: "quarter-circle-tl",
    size: 1,
    position: [
      1,
      1
    ],
    colour: 0,
    rotation: 0
  }
], OS = [
  2,
  2
], RS = 4, IS = {
  shapes: DS,
  dimensions: OS,
  colourCount: RS
}, _S = [
  {
    name: "sawtooth-big",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0,
    flip: !1
  }
], FS = [
  2,
  2
], BS = 1, ZS = !0, qS = {
  shapes: _S,
  dimensions: FS,
  colourCount: BS,
  rotate: ZS
}, US = [
  {
    name: "sawtooth-big-r",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0,
    flip: !0
  },
  {
    name: "sawtooth-big-l",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0,
    flip: !1
  }
], HS = [
  2,
  2
], GS = 1, WS = !0, VS = {
  shapes: US,
  dimensions: HS,
  colourCount: GS,
  rotate: WS
}, XS = [
  {
    name: "lines-2",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "lines-2",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  }
], YS = [
  2,
  2
], KS = 2, QS = !1, JS = {
  shapes: XS,
  dimensions: YS,
  colourCount: KS,
  rotate: QS
}, e$ = [
  {
    name: "rectangle-flip",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  }
], t$ = [
  2,
  2
], r$ = 1, n$ = !0, o$ = {
  shapes: e$,
  dimensions: t$,
  colourCount: r$,
  rotate: n$
}, s$ = [
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 270
  },
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 90
  },
  {
    name: "rectangle-flip",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], i$ = [
  2,
  2
], a$ = 3, l$ = !0, c$ = {
  shapes: s$,
  dimensions: i$,
  colourCount: a$,
  rotate: l$
}, u$ = [
  {
    name: "triangle-flip",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  }
], h$ = [
  2,
  2
], m$ = 1, f$ = !0, d$ = {
  shapes: u$,
  dimensions: h$,
  colourCount: m$,
  rotate: f$
}, p$ = [
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 270
  },
  {
    name: "triangle-flip",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  }
], g$ = [
  2,
  2
], k$ = 3, v$ = !0, y$ = {
  shapes: p$,
  dimensions: g$,
  colourCount: k$,
  rotate: v$
}, b$ = [
  {
    name: "circle",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "circle-small-center",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], x$ = [
  2,
  2
], w$ = 2, L$ = !1, z$ = {
  shapes: b$,
  dimensions: x$,
  colourCount: w$,
  rotate: L$
}, C$ = [
  {
    name: "petal-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "petal-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  }
], S$ = [
  2,
  2
], $$ = 2, A$ = !0, M$ = {
  shapes: C$,
  dimensions: S$,
  colourCount: $$,
  rotate: A$
}, j$ = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], E$ = [
  2,
  2
], T$ = 2, P$ = !0, N$ = {
  shapes: j$,
  dimensions: E$,
  colourCount: T$,
  rotate: P$
}, D$ = [
  {
    name: "petal-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  }
], O$ = [
  2,
  2
], R$ = 2, I$ = !0, _$ = {
  shapes: D$,
  dimensions: O$,
  colourCount: R$,
  rotate: I$
}, F$ = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "semi-circle-d",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "semi-circle-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  }
], B$ = [
  2,
  2
], Z$ = 2, q$ = !0, U$ = {
  shapes: F$,
  dimensions: B$,
  colourCount: Z$,
  rotate: q$
}, H$ = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "semi-circle-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "semi-circle-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 180
  }
], G$ = [
  2,
  2
], W$ = 2, V$ = !0, X$ = {
  shapes: H$,
  dimensions: G$,
  colourCount: W$,
  rotate: V$
}, Y$ = [
  {
    name: "circle",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "circle-small-center",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 0
  }
], K$ = [
  2,
  2
], Q$ = 3, J$ = !0, eA = {
  shapes: Y$,
  dimensions: K$,
  colourCount: Q$,
  rotate: J$
}, tA = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "sawtooth-big-l",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "sawtooth-big-l",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 180
  }
], rA = [
  2,
  2
], nA = 3, oA = !0, sA = {
  shapes: tA,
  dimensions: rA,
  colourCount: nA,
  rotate: oA
}, iA = [
  {
    name: "circle",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "center-point-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "circle-small-center",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 0
  }
], aA = [
  2,
  2
], lA = 3, cA = !0, uA = {
  shapes: iA,
  dimensions: aA,
  colourCount: lA,
  rotate: cA
}, hA = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "quarter-circle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], mA = [
  2,
  2
], fA = 2, dA = !0, pA = {
  shapes: hA,
  dimensions: mA,
  colourCount: fA,
  rotate: dA
}, gA = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "rectangle-half",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], kA = [
  2,
  2
], vA = 2, yA = !0, bA = {
  shapes: gA,
  dimensions: kA,
  colourCount: vA,
  rotate: yA
}, xA = [
  {
    name: "circle",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  },
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 180
  }
], wA = [
  2,
  2
], LA = 3, zA = !0, CA = {
  shapes: xA,
  dimensions: wA,
  colourCount: LA,
  rotate: zA
}, SA = [
  {
    name: "sawtooth-l",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "sawtooth-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], $A = [
  2,
  2
], AA = 2, MA = !0, jA = {
  shapes: SA,
  dimensions: $A,
  colourCount: AA,
  rotate: MA
}, EA = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "circle-opposite-sides",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 0
  }
], TA = [
  2,
  2
], PA = 2, NA = !0, DA = {
  shapes: EA,
  dimensions: TA,
  colourCount: PA,
  rotate: NA
}, OA = [
  {
    name: "quarter-circle-arch-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  }
], RA = [
  2,
  2
], IA = 1, _A = !0, FA = {
  shapes: OA,
  dimensions: RA,
  colourCount: IA,
  rotate: _A
}, BA = [
  {
    name: "triangle-tl",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "triangle-tl-small",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  }
], ZA = [
  2,
  2
], qA = 2, UA = !0, HA = {
  shapes: BA,
  dimensions: ZA,
  colourCount: qA,
  rotate: UA
}, GA = [
  {
    name: "triangle-tl-cutout",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  }
], WA = [
  2,
  2
], VA = 1, XA = !0, YA = {
  shapes: GA,
  dimensions: WA,
  colourCount: VA,
  rotate: XA
}, KA = [
  {
    name: "square",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  }
], QA = [
  2,
  2
], JA = 1, eM = !1, tM = {
  shapes: KA,
  dimensions: QA,
  colourCount: JA,
  rotate: eM
}, rM = [
  {
    name: "center-point-v",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "center-point-v",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "wedge-diagonal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 0
  }
], nM = [
  2,
  2
], oM = 3, sM = !0, iM = {
  shapes: rM,
  dimensions: nM,
  colourCount: oM,
  rotate: sM
}, aM = [
  {
    name: "center-point-v",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "center-point-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  },
  {
    name: "center-point-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 2,
    rotation: 270
  },
  {
    name: "wedge-diagonal",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 3,
    rotation: 0
  }
], lM = [
  2,
  2
], cM = 4, uM = !0, hM = {
  shapes: aM,
  dimensions: lM,
  colourCount: cM,
  rotate: uM
}, mM = [
  {
    name: "triangle-tl-cutout",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "triangle-tl-cutout",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  }
], fM = [
  2,
  2
], dM = 2, pM = !0, gM = {
  shapes: mM,
  dimensions: fM,
  colourCount: dM,
  rotate: pM
}, kM = [
  {
    name: "semi-circle-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "center-point-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  }
], vM = [
  2,
  2
], yM = 2, bM = !0, xM = {
  shapes: kM,
  dimensions: vM,
  colourCount: yM,
  rotate: bM
}, wM = [
  {
    name: "semi-circle-b",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 90
  }
], LM = [
  2,
  2
], zM = 2, CM = !0, SM = {
  shapes: wM,
  dimensions: LM,
  colourCount: zM,
  rotate: CM
}, $M = [
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "rectangle-quarter",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  }
], AM = [
  2,
  2
], MM = 2, jM = !0, EM = {
  shapes: $M,
  dimensions: AM,
  colourCount: MM,
  rotate: jM
}, TM = [
  {
    name: "center-point-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 0,
    rotation: 0
  },
  {
    name: "center-point-t",
    size: 2,
    position: [
      0,
      0
    ],
    colour: 1,
    rotation: 180
  }
], PM = [
  2,
  2
], NM = 2, DM = !0, OM = {
  shapes: TM,
  dimensions: PM,
  colourCount: NM,
  rotate: DM
}, eo = {
  block1: sy,
  block2: uy,
  block3: py,
  block4: by,
  block5: Cy,
  block6: jy,
  block7: Dy,
  block8: Fy,
  block9: Hy,
  block10: Yy,
  block11: tb,
  block12: ib,
  block13: hb,
  block14: gb,
  block15: xb,
  block16: Sb,
  block17: Eb,
  block18: Ob,
  block19: Bb,
  block20: Gb,
  block21: Kb,
  block22: rx,
  block23: ax,
  block24: mx,
  block25: kx,
  block26: wx,
  block27: $x,
  block28: Tx,
  block29: Rx,
  block30: Zx,
  block31: Wx,
  block32: Kx,
  block33: tw,
  block34: sw,
  block35: cw,
  block36: fw,
  block37: kw,
  block38: xw,
  block39: Cw,
  block40: jw,
  block41: Dw,
  block42: Fw,
  block43: Hw,
  block44: Yw,
  block45: tL,
  block46: iL,
  block47: hL,
  block48: gL,
  block49: xL,
  block50: SL,
  block51: EL,
  block52: OL,
  block53: BL,
  block54: GL,
  block55: KL,
  block56: rz,
  block57: az,
  block58: mz,
  block59: kz,
  block60: wz,
  block61: $z,
  block62: Tz,
  block63: Rz,
  block64: Zz,
  block65: Wz,
  block66: Qz,
  block67: rC,
  block68: aC,
  block69: mC,
  block70: kC,
  block71: wC,
  block72: SC,
  block73: EC,
  block74: OC,
  block75: BC,
  block76: GC,
  block77: KC,
  block78: rS,
  block79: iS,
  block80: uS,
  block81: dS,
  block82: vS,
  block83: wS,
  block84: SS,
  block85: jS,
  block86: NS,
  block87: IS,
  block88: qS,
  block89: VS,
  block90: JS,
  block91: o$,
  block92: c$,
  block93: d$,
  block94: y$,
  block95: z$,
  block96: M$,
  block97: N$,
  block98: _$,
  block99: U$,
  block100: X$,
  block101: eA,
  block102: sA,
  block103: uA,
  block104: pA,
  block105: bA,
  block106: CA,
  block107: jA,
  block108: DA,
  block109: FA,
  block110: HA,
  block111: YA,
  block112: tM,
  block113: iM,
  block114: hM,
  block115: gM,
  block116: xM,
  block117: SM,
  block118: EM,
  block119: OM
}, RM = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 0 100 L 100 0 L 0 0 M 100 0 L 100 100 L 200 0 L 100 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 0 100 L 100 0 L 0 0 M 100 0 L 100 100 L 200 0 L 100 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, IM = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, _M = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 0 L 200 100 L 200 200 L 0 200 L 0 100 L 100 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 100 100 L 200 0 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, FM = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 100 100 L 200 0 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 C 0 55.228474983079344 44.771525016920656 100 100 100 C 155.22847498307934 100 200 55.228474983079344 200 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, BM = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 50 0 C 22.385762508460328 0 0 22.385762508460328 0 50 C 0 77.61423749153967 22.385762508460328 100 50 100 C 77.61423749153967 100 100 77.61423749153967 100 50 C 100 22.385762508460328 77.61423749153967 0 50 0 z M 150 100 C 122.38576250846033 100 100 122.38576250846033 100 150 C 100 177.61423749153968 122.38576250846033 200 150 200 C 177.61423749153968 200 200 177.61423749153968 200 150 C 200 122.38576250846033 177.61423749153968 100 150 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 50 0 C 22.385762508460328 0 0 22.385762508460328 0 50 C 0 77.61423749153967 22.385762508460328 100 50 100 C 77.61423749153967 100 100 77.61423749153967 100 50 C 100 22.385762508460328 77.61423749153967 0 50 0 z M 150 100 C 122.38576250846033 100 100 122.38576250846033 100 150 C 100 177.61423749153968 122.38576250846033 200 150 200 C 177.61423749153968 200 200 177.61423749153968 200 150 C 200 122.38576250846033 177.61423749153968 100 150 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, ZM = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, qM = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, UM = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 100 C 0 44.771525016920656 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.771525016920634 200 99.99999999999997 C 200 155.22847498307934 155.22847498307934 200 100 200 C 44.77152501692066 200 0 155.22847498307934 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, HM = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 0 L 200 100 L 100 200 L 0 100 L 100 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, GM = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, WM = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 100 100 L 200 0 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, VM = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 C 0 55.228474983079344 44.771525016920656 100 100 100 C 155.22847498307934 100 200 55.228474983079344 200 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, XM = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 0 L 200 100 L 100 200 L 0 100 L 100 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 M 100 100 L 200 100 L 200 200 L 100 200 L 100 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, YM = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 0 L 200 100 L 100 200 L 0 100 L 100 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, KM = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 200 C 44.771525016920656 200 0 155.22847498307934 0 100 C 0 44.77152501692066 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.77152501692063 200 99.99999999999997 L 200 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 200 C 44.771525016920656 200 0 155.22847498307934 0 100 C 0 44.77152501692066 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.77152501692063 200 99.99999999999997 L 200 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 200 C 44.771525016920656 200 0 155.22847498307934 0 100 C 0 44.77152501692066 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.77152501692063 200 99.99999999999997 L 200 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 200 C 44.771525016920656 200 0 155.22847498307934 0 100 C 0 44.77152501692066 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.77152501692063 200 99.99999999999997 L 200 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, QM = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 100 0 C 100 55.228474983079344 55.228474983079344 100 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, JM = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, ej = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 100 100 L 200 0 L 0 0 M 0 100 L 100 200 L 200 100 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, tj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 0 200 L 200 200 L 200 100 L 100 100 L 100 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 0 200 L 200 200 L 200 100 L 100 100 L 100 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 0 200 L 200 200 L 200 100 L 100 100 L 100 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 0 200 L 200 200 L 200 100 L 100 100 L 100 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, rj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 0 200 L 200 200 L 200 100 L 100 100 L 100 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 0 200 L 200 200 L 200 100 L 100 100 L 100 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 0 200 L 200 200 L 200 100 L 100 100 L 100 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 0 200 L 200 200 L 200 100 L 100 100 L 100 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, nj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 L 200 100 L 100 200 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 L 200 100 L 100 200 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, oj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 100 C 0 44.771525016920656 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.771525016920634 200 99.99999999999997 C 200 155.22847498307934 155.22847498307934 200 100 200 C 44.77152501692066 200 0 155.22847498307934 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 L 200 100 L 100 200 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 L 200 100 L 100 200 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, sj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 200 C 44.771525016920656 200 0 155.22847498307934 0 100 L 0 0 L 100 0 C 155.22847498307934 0 200 44.77152501692063 200 99.99999999999997 L 200 200 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 200 C 44.771525016920656 200 0 155.22847498307934 0 100 L 0 0 L 100 0 C 155.22847498307934 0 200 44.77152501692063 200 99.99999999999997 L 200 200 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 200 C 44.771525016920656 200 0 155.22847498307934 0 100 L 0 0 L 100 0 C 155.22847498307934 0 200 44.77152501692063 200 99.99999999999997 L 200 200 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 200 C 44.771525016920656 200 0 155.22847498307934 0 100 L 0 0 L 100 0 C 155.22847498307934 0 200 44.77152501692063 200 99.99999999999997 L 200 200 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, ij = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 200 C 44.771525016920656 200 0 155.22847498307934 0 100 C 0 44.77152501692066 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.77152501692063 200 99.99999999999997 L 200 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 200 C 44.771525016920656 200 0 155.22847498307934 0 100 C 0 44.77152501692066 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.77152501692063 200 99.99999999999997 L 200 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 200 C 44.771525016920656 200 0 155.22847498307934 0 100 C 0 44.77152501692066 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.77152501692063 200 99.99999999999997 L 200 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 200 C 44.771525016920656 200 0 155.22847498307934 0 100 C 0 44.77152501692066 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.77152501692063 200 99.99999999999997 L 200 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, aj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 100 C 0 44.771525016920656 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.771525016920634 200 99.99999999999997 C 200 155.22847498307934 155.22847498307934 200 100 200 C 44.77152501692066 200 0 155.22847498307934 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, lj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 C 0 155.22847498307934 44.771525016920656 200 100 200 C 155.22847498307934 200 200 155.22847498307934 200 100 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 C 0 155.22847498307934 44.771525016920656 200 100 200 C 155.22847498307934 200 200 155.22847498307934 200 100 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, cj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 100 C 0 44.771525016920656 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.771525016920634 200 99.99999999999997 C 200 155.22847498307934 155.22847498307934 200 100 200 C 44.77152501692066 200 0 155.22847498307934 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 200 C 44.771525016920656 200 0 155.22847498307934 0 100 C 0 44.77152501692066 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.77152501692063 200 99.99999999999997 L 100 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, uj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 C 0 155.22847498307934 44.771525016920656 200 100 200 C 155.22847498307934 200 200 155.22847498307934 200 100 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 C 0 155.22847498307934 44.771525016920656 200 100 200 C 155.22847498307934 200 200 155.22847498307934 200 100 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 C 0 155.22847498307934 44.771525016920656 200 100 200 C 155.22847498307934 200 200 155.22847498307934 200 100 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, hj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 C 0 55.228474983079344 44.771525016920656 100 100 100 C 155.22847498307934 100 200 55.228474983079344 200 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 C 0 55.228474983079344 44.771525016920656 100 100 100 C 155.22847498307934 100 200 55.228474983079344 200 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, mj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 0 100 L 100 200 L 100 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 0 100 L 100 200 L 100 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, fj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 0 100 L 100 200 L 100 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 0 100 L 100 200 L 100 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, dj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, pj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, gj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, kj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, vj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 M 100 100 L 200 100 L 200 200 L 100 200 L 100 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 M 100 100 L 200 100 L 200 200 L 100 200 L 100 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 100 C 0 44.771525016920656 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.771525016920634 200 99.99999999999997 C 200 155.22847498307934 155.22847498307934 200 100 200 C 44.77152501692066 200 0 155.22847498307934 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, yj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 M 100 100 L 200 100 L 200 200 L 100 200 L 100 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 M 100 100 L 200 100 L 200 200 L 100 200 L 100 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 0 100 C 0 44.771525016920656 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.771525016920634 200 99.99999999999997 L 200 200 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, bj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 200 C 44.771525016920656 200 0 155.22847498307934 0 100 C 0 44.77152501692066 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.77152501692063 200 99.99999999999997 L 200 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, xj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 C 0 55.228474983079344 44.771525016920656 100 100 100 C 155.22847498307934 100 200 55.228474983079344 200 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 C 0 55.228474983079344 44.771525016920656 100 100 100 C 155.22847498307934 100 200 55.228474983079344 200 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, wj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 200 C 44.771525016920656 200 0 155.22847498307934 0 100 C 0 44.77152501692066 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.77152501692063 200 99.99999999999997 L 100 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Lj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 C 0 55.228474983079344 44.771525016920656 100 100 100 C 155.22847498307934 100 200 55.228474983079344 200 0 L 0 0 M 0 100 C 0 155.22847498307934 44.771525016920656 200 100 200 C 155.22847498307934 200 200 155.22847498307934 200 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 C 0 55.228474983079344 44.771525016920656 100 100 100 C 155.22847498307934 100 200 55.228474983079344 200 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, zj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 100 C 0 44.771525016920656 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.771525016920634 200 99.99999999999997 C 200 155.22847498307934 155.22847498307934 200 100 200 C 44.77152501692066 200 0 155.22847498307934 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 200 C 44.771525016920656 200 0 155.22847498307934 0 100 C 0 44.77152501692066 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.77152501692063 200 99.99999999999997 L 100 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Cj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 50 C 0 22.385762508460328 22.385762508460328 0 50 0 C 77.61423749153967 0 100 22.385762508460317 100 49.999999999999986 C 100 77.61423749153967 77.61423749153967 100 50 100 C 22.38576250846033 100 0 77.61423749153967 0 50 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 50 C 0 22.385762508460328 22.385762508460328 0 50 0 C 77.61423749153967 0 100 22.385762508460317 100 49.999999999999986 C 100 77.61423749153967 77.61423749153967 100 50 100 C 22.38576250846033 100 0 77.61423749153967 0 50 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Sj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 100 0 C 100 55.228474983079344 55.228474983079344 100 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 100 0 C 100 55.228474983079344 55.228474983079344 100 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, $j = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 100 0 C 100 55.228474983079344 55.228474983079344 100 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Aj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 C 0 55.228474983079344 44.771525016920656 100 100 100 C 155.22847498307934 100 200 55.228474983079344 200 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Mj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 100 100 L 200 0 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, jj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 C 0 55.228474983079344 44.771525016920656 100 100 100 C 155.22847498307934 100 200 55.228474983079344 200 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 C 0 55.228474983079344 44.771525016920656 100 100 100 C 155.22847498307934 100 200 55.228474983079344 200 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 100 100 L 200 200 L 0 200 L 100 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Ej = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 L 200 100 L 100 200 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 L 200 100 L 100 200 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Tj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 50 C 0 22.385762508460328 22.385762508460328 0 50 0 C 77.61423749153967 0 100 22.385762508460317 100 49.999999999999986 C 100 77.61423749153967 77.61423749153967 100 50 100 C 22.38576250846033 100 0 77.61423749153967 0 50 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 50 C 0 22.385762508460328 22.385762508460328 0 50 0 C 77.61423749153967 0 100 22.385762508460317 100 49.999999999999986 C 100 77.61423749153967 77.61423749153967 100 50 100 C 22.38576250846033 100 0 77.61423749153967 0 50 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Pj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 100 100 L 200 0 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 100 0 C 100 55.228474983079344 55.228474983079344 100 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Nj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 L 200 100 L 100 200 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 L 200 100 L 100 200 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Dj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Oj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 100 0 L 200 100 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Rj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Ij = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 100 0 C 100 55.228474983079344 55.228474983079344 100 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, _j = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 C 0 55.228474983079344 44.771525016920656 100 100 100 C 155.22847498307934 100 200 55.228474983079344 200 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Fj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 M 100 100 L 200 100 L 200 200 L 100 200 L 100 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Bj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 100 100 L 200 0 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Zj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 100 0 C 100 55.228474983079344 55.228474983079344 100 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 100 0 C 100 55.228474983079344 55.228474983079344 100 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 L 200 100 L 100 200 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, qj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 100 0 C 100 55.228474983079344 55.228474983079344 100 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 100 0 C 100 55.228474983079344 55.228474983079344 100 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Uj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 100 0 C 100 55.228474983079344 55.228474983079344 100 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 100 0 C 100 55.228474983079344 55.228474983079344 100 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Hj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 100 C 0 44.771525016920656 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.771525016920634 200 99.99999999999997 C 200 155.22847498307934 155.22847498307934 200 100 200 C 44.77152501692066 200 0 155.22847498307934 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Gj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 M 100 100 L 200 100 L 200 200 L 100 200 L 100 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 0 L 200 100 L 100 200 L 0 100 L 100 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Wj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 100 0 C 100 55.228474983079344 55.228474983079344 100 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 100 0 C 100 55.228474983079344 55.228474983079344 100 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Vj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 100 0 C 100 55.228474983079344 55.228474983079344 100 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 100 0 C 100 55.228474983079344 55.228474983079344 100 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Xj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 0 100 L 100 200 L 100 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Yj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Kj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Qj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Jj = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 C 0 155.22847498307934 44.771525016920656 200 100 200 C 155.22847498307934 200 200 155.22847498307934 200 100 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 100 100 L 200 0 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, eE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 50 0 L 100 50 L 50 100 L 0 50 L 50 0 M 150 100 L 200 150 L 150 200 L 100 150 L 150 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 50 0 L 100 50 L 50 100 L 0 50 L 50 0 M 150 100 L 200 150 L 150 200 L 100 150 L 150 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, tE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 50 0 L 100 50 L 50 100 L 0 50 L 50 0 M 150 100 L 200 150 L 150 200 L 100 150 L 150 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 50 0 L 100 50 L 50 100 L 0 50 L 50 0 M 150 100 L 200 150 L 150 200 L 100 150 L 150 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, rE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 50 0 L 100 50 L 50 100 L 0 50 L 50 0 M 150 100 L 200 150 L 150 200 L 100 150 L 150 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 50 0 L 100 50 L 50 100 L 0 50 L 50 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 50 0 L 100 50 L 50 100 L 0 50 L 50 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, nE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 100 100 L 200 0 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, oE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 C 0 55.228474983079344 44.771525016920656 100 100 100 C 155.22847498307934 100 200 55.228474983079344 200 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, sE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 100 0 L 0 100 L 100 100 L 100 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, iE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 100 0 L 0 100 L 100 100 L 100 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, aE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, lE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, cE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 C 0 89.54305003384131 89.54305003384131 0 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, uE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 50 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, hE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 50 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 50 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 50 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, mE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 100 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 50 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 50 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, fE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, dE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, pE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(1 0 0 1 100 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 100)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 100 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(1 0 0 1 300 300)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, gE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 100 L 0 0 M 0 100 L 200 100 L 0 200 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, kE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 L 200 100 L 0 200 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 200 0 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, vE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 40 L 200 40 L 200 80 L 0 80 L 0 40 M 0 120 L 200 120 L 200 160 L 0 160 L 0 120 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 40 L 200 40 L 200 80 L 0 80 L 0 40 M 0 120 L 200 120 L 200 160 L 0 160 L 0 120 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, yE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -25)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -75)" d="M 50 100 L 0 100 L 0 0 L 200 0 L 200 100 L 150 100 L 150 50 L 50 50 L 50 100 L 150 100 L 150 150 L 50 150 L 50 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, bE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -25)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -75)" d="M 50 100 L 0 100 L 0 0 L 200 0 L 200 100 L 150 100 L 150 50 L 50 50 L 50 100 L 150 100 L 150 150 L 50 150 L 50 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, xE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 50 50 L 0 0 L 0 200 L 200 200 L 150 150 L 50 150 L 50 50 L 150 50 L 150 150 L 50 50 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, wE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 50 50 L 0 0 L 0 200 L 200 200 L 150 150 L 50 150 L 50 50 L 150 50 L 150 150 L 50 50 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, LE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 100 C 0 44.771525016920656 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.771525016920634 200 99.99999999999997 C 200 155.22847498307934 155.22847498307934 200 100 200 C 44.77152501692066 200 0 155.22847498307934 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 50 100 C 50 72.38576250846033 72.38576250846033 50 100 50 C 127.61423749153967 50 150 72.38576250846032 150 99.99999999999999 C 150 127.61423749153967 127.61423749153967 150 100 150 C 72.38576250846033 150 50 127.61423749153967 50 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, zE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, CE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, SE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 200 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, $E = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 C 0 55.228474983079344 44.771525016920656 100 100 100 C 155.22847498307934 100 200 55.228474983079344 200 0 L 0 0 M 0 100 C 0 155.22847498307934 44.771525016920656 200 100 200 C 155.22847498307934 200 200 155.22847498307934 200 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 C 0 55.228474983079344 44.771525016920656 100 100 100 C 155.22847498307934 100 200 55.228474983079344 200 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, AE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 C 0 55.228474983079344 44.771525016920656 100 100 100 C 155.22847498307934 100 200 55.228474983079344 200 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 C 0 55.228474983079344 44.771525016920656 100 100 100 C 155.22847498307934 100 200 55.228474983079344 200 0 L 0 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, ME = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 100 C 0 44.771525016920656 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.771525016920634 200 99.99999999999997 C 200 155.22847498307934 155.22847498307934 200 100 200 C 44.77152501692066 200 0 155.22847498307934 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 50 100 C 50 72.38576250846033 72.38576250846033 50 100 50 C 127.61423749153967 50 150 72.38576250846032 150 99.99999999999999 C 150 127.61423749153967 127.61423749153967 150 100 150 C 72.38576250846033 150 50 127.61423749153967 50 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, jE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 200 0 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 200 0 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, EE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 100 C 0 44.771525016920656 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.771525016920634 200 99.99999999999997 C 200 155.22847498307934 155.22847498307934 200 100 200 C 44.77152501692066 200 0 155.22847498307934 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 100 100 L 200 0 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 50 100 C 50 72.38576250846033 72.38576250846033 50 100 50 C 127.61423749153967 50 150 72.38576250846032 150 99.99999999999999 C 150 127.61423749153967 127.61423749153967 150 100 150 C 72.38576250846033 150 50 127.61423749153967 50 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, TE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, PE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -100)" d="M 0 0 L 100 0 L 100 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, NE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 100 C 0 44.771525016920656 44.771525016920656 0 100 0 C 155.22847498307934 0 200 44.771525016920634 200 99.99999999999997 C 200 155.22847498307934 155.22847498307934 200 100 200 C 44.77152501692066 200 0 155.22847498307934 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, DE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 0 100 L 100 0 L 0 0 M 100 0 L 100 100 L 200 0 L 100 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 L 0 200 L 100 100 L 0 100 M 100 100 L 100 200 L 200 100 L 100 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, OE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 200 C 44.771525016920656 200 0 155.22847498307934 0 100 L 0 0 L 100 0 C 155.22847498307934 0 200 44.77152501692063 200 99.99999999999997 L 200 200 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, RE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 C 200 110.45694996615869 110.45694996615869 200 0 200 L 0 100 C 55.228474983079344 100 100 55.228474983079344 100 0 Z Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, IE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, _E = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 0 L 200 0 L 0 200 L 0 100 L 100 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, FE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, BE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 100 100 L 200 200 L 0 200 L 100 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 100 100 L 200 200 L 0 200 L 100 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 50 50 L 200 0 L 150 150 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, ZE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 100 100 L 200 200 L 0 200 L 100 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 100 100 L 200 0 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 100 100 L 200 0 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(87,115,153); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 200 L 50 50 L 200 0 L 150 150 L 0 200 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, qE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 0 L 200 0 L 0 200 L 0 100 L 100 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 100 0 L 200 0 L 0 200 L 0 100 L 100 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, UE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 C 0 155.22847498307934 44.771525016920656 200 100 200 C 155.22847498307934 200 200 155.22847498307934 200 100 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 L 200 100 L 100 200 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, HE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(248,228,245); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -150)" d="M 0 100 C 0 155.22847498307934 44.771525016920656 200 100 200 C 155.22847498307934 200 200 155.22847498307934 200 100 L 0 100 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, GE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(1 0 0 1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(-1 0 0 -1 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 -50 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(181,45,158); fill-rule: nonzero; opacity: 1;"  transform=" translate(-50, -50)" d="M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, WE = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="400" height="400" viewBox="0 0 400 400" xml:space="preserve">
<desc>Created with Fabric.js 2.6.0</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 200 200)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-200" y="-200" rx="0" ry="0" width="400" height="400" />
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 1 -1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(165,230,186); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 100 100 L 200 0 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
<g transform="matrix(2 0 0 2 200 200)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<rect style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"  x="-100" y="-100" rx="0" ry="0" width="200" height="200" />
</g>
	<g transform="matrix(0 -1 1 0 0 0)" style=""  >
	<g transform="matrix(1 0 0 1 0 0)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-opacity: 0; fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -100)" d="M 0 0 L 200 0 L 200 200 L 0 200 Z" stroke-linecap="round" />
</g>
	<g transform="matrix(1 0 0 1 0 -50)"  >
<path style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(154,198,197); fill-rule: nonzero; opacity: 1;"  transform=" translate(-100, -50)" d="M 0 0 L 100 100 L 200 0 L 0 0 Z" stroke-linecap="round" />
</g>
</g>
</g>
</svg>`, Pa = {
  block1: RM,
  block2: IM,
  block3: _M,
  block4: FM,
  block5: BM,
  block6: ZM,
  block7: qM,
  block8: UM,
  block9: HM,
  block10: GM,
  block11: WM,
  block12: VM,
  block13: XM,
  block14: YM,
  block15: KM,
  block16: QM,
  block17: JM,
  block18: ej,
  block19: tj,
  block20: rj,
  block21: nj,
  block22: oj,
  block23: sj,
  block24: ij,
  block25: aj,
  block26: lj,
  block27: cj,
  block28: uj,
  block29: hj,
  block30: mj,
  block31: fj,
  block32: dj,
  block33: pj,
  block34: gj,
  block35: kj,
  block36: vj,
  block37: yj,
  block38: bj,
  block39: xj,
  block40: wj,
  block41: Lj,
  block42: zj,
  block43: Cj,
  block44: Sj,
  block45: $j,
  block46: Aj,
  block47: Mj,
  block48: jj,
  block49: Ej,
  block50: Tj,
  block51: Pj,
  block52: Nj,
  block53: Dj,
  block54: Oj,
  block55: Rj,
  block56: Ij,
  block57: _j,
  block58: Fj,
  block59: Bj,
  block60: Zj,
  block61: qj,
  block62: Uj,
  block63: Hj,
  block64: Gj,
  block65: Wj,
  block66: Vj,
  block67: Xj,
  block68: Yj,
  block69: Kj,
  block70: Qj,
  block71: Jj,
  block72: eE,
  block73: tE,
  block74: rE,
  block75: nE,
  block76: oE,
  block77: sE,
  block78: iE,
  block79: aE,
  block80: lE,
  block81: cE,
  block82: uE,
  block83: hE,
  block84: mE,
  block85: fE,
  block86: dE,
  block87: pE,
  block88: gE,
  block89: kE,
  block90: vE,
  block91: yE,
  block92: bE,
  block93: xE,
  block94: wE,
  block95: LE,
  block96: zE,
  block97: CE,
  block98: SE,
  block99: $E,
  block100: AE,
  block101: ME,
  block102: jE,
  block103: EE,
  block104: TE,
  block105: PE,
  block106: NE,
  block107: DE,
  block108: OE,
  block109: RE,
  block110: IE,
  block111: _E,
  block112: FE,
  block113: BE,
  block114: ZE,
  block115: qE,
  block116: UE,
  block117: HE,
  block118: GE,
  block119: WE
}, Na = () => {
  const e = [
    112,
    2,
    3,
    4,
    5,
    7,
    11,
    110,
    12,
    13,
    14,
    15,
    16,
    24,
    25,
    26,
    27,
    28,
    29,
    40,
    41,
    42,
    109,
    105,
    104,
    96,
    97,
    88,
    72,
    73,
    74,
    75,
    76,
    64,
    58,
    55,
    45,
    46,
    47,
    48,
    51,
    90,
    91,
    92,
    25,
    19,
    20,
    111
  ], t = Object.keys(Pa).length, r = [];
  for (let n = 0; n < e.length; n++)
    r.push({ name: `block${e[n]}`, free: !0 });
  for (let n = 1; n <= t; n++)
    e.includes(n) || r.push({ name: `block${n}` });
  return r;
}, kr = {
  type: "blocks",
  thumbnailUrl: "",
  blockWeights: [],
  blocks: [],
  shapes: [],
  imageShapes: [
    "circle",
    "square",
    "wedge-bl",
    "circle-one-side",
    "circle-opposite-sides",
    "circle-three-sides"
  ]
}, to = (e = Na()) => (kr.blocks = e, kr.blockWeights = new Array(kr.blocks.length).fill(1), kr), VE = (e) => Pa[e], Da = (e) => eo[e], XE = Object.keys(eo).map((e, t) => ({ ...eo[e], name: `block${t + 1}` })).filter((e) => e.rotate).map((e) => e.name), z50 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getList: Na,
  blocksTemplate: to,
  getBlockSvgByName: VE,
  getBlockByName: Da,
  blockTileList: XE
}, Symbol.toStringTag, { value: "Module" })), YE = [
  {
    type: "shape",
    category: "circles",
    name: "circle",
    outerSvg: "M0,100 A100,100 0 0 1 200,100 A100,100 0 0 1 0,100",
    path: [
      ["M", 0, 100],
      ["C", 0, 44.771525016920656, 44.771525016920656, 0, 100, 0],
      [
        "C",
        155.22847498307934,
        0,
        200,
        44.771525016920634,
        200,
        99.99999999999997
      ],
      ["C", 200, 155.22847498307934, 155.22847498307934, 200, 100, 200],
      ["C", 44.77152501692066, 200, 0, 155.22847498307934, 0, 100],
      ["Z"]
    ],
    symmetry: 1,
    image: !0,
    full: !0
  },
  {
    type: "shape",
    category: "circles",
    name: "circle-small",
    outerSvg: "M0,50 A50,50 0 0 1 100,50 A50,50 0 0 1 0,50",
    path: [
      ["M", 0, 50],
      ["C", 0, 22.385762508460328, 22.385762508460328, 0, 50, 0],
      [
        "C",
        77.61423749153967,
        0,
        100,
        22.385762508460317,
        100,
        49.999999999999986
      ],
      ["C", 100, 77.61423749153967, 77.61423749153967, 100, 50, 100],
      ["C", 22.38576250846033, 100, 0, 77.61423749153967, 0, 50],
      ["Z"]
    ],
    symmetry: 4
  },
  {
    type: "shape",
    category: "circles",
    name: "circle-small-center",
    outerSvg: "M50,100 A50,50 0 0 1 150,100 A50,50 0 0 1 50,100",
    path: [
      ["M", 50, 100],
      ["C", 50, 72.38576250846033, 72.38576250846033, 50, 100, 50],
      [
        "C",
        127.61423749153967,
        50,
        150,
        72.38576250846032,
        150,
        99.99999999999999
      ],
      ["C", 150, 127.61423749153967, 127.61423749153967, 150, 100, 150],
      ["C", 72.38576250846033, 150, 50, 127.61423749153967, 50, 100],
      ["Z"]
    ],
    height: 150,
    width: 150,
    symmetry: 1
  },
  {
    type: "shape",
    category: "circles",
    name: "circles-diagonal",
    outerSvg: "m50 0a50 50 0 0 0-50 50 50 50 0 0 0 50 50 50 50 0 0 0 50-50 50 50 0 0 0-50-50zm100 100a50 50 0 0 0-50 50 50 50 0 0 0 50 50 50 50 0 0 0 50-50 50 50 0 0 0-50-50",
    path: [
      ["M", 50, 0],
      ["C", 22.385762508460328, 0, 0, 22.385762508460328, 0, 50],
      ["C", 0, 77.61423749153967, 22.385762508460328, 100, 50, 100],
      ["C", 77.61423749153967, 100, 100, 77.61423749153967, 100, 50],
      ["C", 100, 22.385762508460328, 77.61423749153967, 0, 50, 0],
      ["z"],
      ["M", 150, 100],
      ["C", 122.38576250846033, 100, 100, 122.38576250846033, 100, 150],
      ["C", 100, 177.61423749153968, 122.38576250846033, 200, 150, 200],
      ["C", 177.61423749153968, 200, 200, 177.61423749153968, 200, 150],
      ["C", 200, 122.38576250846033, 177.61423749153968, 100, 150, 100],
      ["Z"]
    ],
    symmetry: 2,
    full: !0
  },
  {
    type: "shape",
    category: "circles",
    name: "quarter-circle-tl",
    outerSvg: "M200,0 A200,200 0 0 1 0,200 L0,0",
    path: [
      ["M", 200, 0],
      ["C", 200, 110.45694996615869, 110.45694996615869, 200, 0, 200],
      ["L", 0, 0],
      ["Z"]
    ],
    symmetry: 4
  },
  {
    type: "shape",
    category: "circles",
    name: "quarter-circle-tl-small",
    outerSvg: "M100,0 A100,100 0 0 1 0,100 L0,0",
    path: [
      ["M", 100, 0],
      ["C", 100, 55.228474983079344, 55.228474983079344, 100, 0, 100],
      ["L", 0, 0],
      ["Z"]
    ],
    symmetry: 4
  },
  {
    type: "shape",
    category: "circles",
    name: "quarter-circle-arch-tl",
    outerSvg: "M0,0 L 200,0 A200,200 0 0 1 0,200 L0,100 A100,100 0 0 0 100,0 Z",
    path: [
      ["M", 0, 0],
      ["L", 200, 0],
      ["C", 200, 110.45694996615869, 110.45694996615869, 200, 0, 200],
      ["L", 0, 100],
      ["C", 55.228474983079344, 100, 100, 55.228474983079344, 100, 0],
      ["Z"],
      ["Z"]
    ],
    symmetry: 4
  },
  {
    type: "shape",
    category: "circles",
    name: "quarter-circle-arch-tl-small",
    outerSvg: "M60,0 L 140,0 A140,140 0 0 1 0,140 L0,60 A60,60 0 0 0 60,0",
    path: [
      ["M", 60, 0],
      ["L", 140, 0],
      ["C", 140, 77.31986497631108, 77.31986497631108, 140, 0, 140],
      ["L", 0, 60],
      ["C", 33.13708498984761, 60, 60, 33.13708498984761, 60, 0],
      ["Z"]
    ],
    symmetry: 4
  },
  {
    type: "shape",
    category: "circles",
    name: "petal",
    outerSvg: "M200,0 A200,200 0 0 1 0,200 A200,200 0 0 1 200,0",
    path: [
      ["M", 200, 0],
      ["C", 200, 110.45694996615869, 110.45694996615869, 200, 0, 200],
      ["C", 0, 89.54305003384131, 89.54305003384131, 0, 200, 0],
      ["Z"]
    ],
    symmetry: 2,
    full: !0
  },
  {
    type: "shape",
    category: "circles",
    name: "petal-small",
    outerSvg: "M100,0 A100,100 0 0 1 0,100 A100,100 0 0 1 100,0",
    path: [
      ["M", 0, 0],
      ["C", 0, 55.225, 55.225, 100, 100, 100],
      ["C", 100, 44.27, 44.27, 0, 0, 0],
      ["Z"]
    ],
    symmetry: 2,
    full: !0
  },
  {
    type: "shape",
    category: "circles",
    name: "petal-half",
    outerSvg: "M200,0 A200,200 0 0 1 0,200 L200,0 Z",
    path: [
      ["M", 200, 0],
      ["C", 200, 110.45694996615869, 110.45694996615869, 200, 0, 200],
      ["L", 200, 0],
      ["Z"]
    ],
    symmetry: 4
  },
  {
    type: "shape",
    category: "circles",
    name: "hump",
    outerSvg: "M100,0 A100,100 0 0 1 0,100 A100,100 0 0 1 100,0",
    path: [["M", 0, 0], ["C", 100, 55.225, 55.225, 100, 0, 100], ["Z"]],
    symmetry: 2,
    full: !0
  },
  {
    type: "shape",
    category: "circles",
    name: "semi-circle-d",
    outerSvg: "M0,0 a1,1 0 0 0 200,0 L 0,0 M0,100 a1,1 0 0 0 200,0",
    path: [
      ["M", 0, 0],
      ["C", 0, 55.228474983079344, 44.771525016920656, 100, 100, 100],
      ["C", 155.22847498307934, 100, 200, 55.228474983079344, 200, 0],
      ["L", 0, 0],
      ["M", 0, 100],
      ["C", 0, 155.22847498307934, 44.771525016920656, 200, 100, 200],
      ["C", 155.22847498307934, 200, 200, 155.22847498307934, 200, 100],
      ["Z"]
    ],
    symmetry: 4,
    full: !0
  },
  {
    type: "shape",
    category: "circles",
    name: "semi-circle-t",
    outerSvg: "M0,0 A100,100 0 0 0 200,0 L 0,0 Z",
    path: [
      ["M", 0, 0],
      ["C", 0, 55.228474983079344, 44.771525016920656, 100, 100, 100],
      ["C", 155.22847498307934, 100, 200, 55.228474983079344, 200, 0],
      ["L", 0, 0],
      ["Z"],
      ["Z"]
    ],
    symmetry: 4
  },
  {
    type: "shape",
    category: "circles",
    name: "semi-circle-b",
    outerSvg: "M0,100 A100,100 0 0 0 200,100 L 0,100",
    path: [
      ["M", 0, 100],
      ["C", 0, 155.22847498307934, 44.771525016920656, 200, 100, 200],
      ["C", 155.22847498307934, 200, 200, 155.22847498307934, 200, 100],
      ["L", 0, 100],
      ["Z"]
    ],
    symmetry: 4,
    height: 100
  },
  {
    type: "shape",
    category: "circles",
    name: "semi-circle-rectangle-t",
    outerSvg: "M0,200 L 0,100 a1,1 0 0 1 200,0 L 200,200 Z",
    path: [
      ["M", 0, 200],
      ["L", 0, 100],
      ["C", 0, 44.771525016920656, 44.771525016920656, 0, 100, 0],
      [
        "C",
        155.22847498307934,
        0,
        200,
        44.771525016920634,
        200,
        99.99999999999997
      ],
      ["L", 200, 200],
      ["Z"],
      ["Z"]
    ],
    symmetry: 4,
    image: !0,
    full: !0
  },
  {
    type: "shape",
    category: "circles",
    name: "circle-one-side",
    outerSvg: "M100,200 A100,100 0 0 1 0,100 L0,0 L200,0 L200,200 L100,200 Z",
    path: [
      ["M", 100, 200],
      ["C", 44.771525016920656, 200, 0, 155.22847498307934, 0, 100],
      ["L", 0, 0],
      ["L", 200, 0],
      ["L", 200, 200],
      ["L", 100, 200],
      ["Z"],
      ["Z"]
    ],
    symmetry: 4,
    image: !0,
    full: !0
  },
  {
    type: "shape",
    category: "circles",
    name: "circle-three-sides",
    outerSvg: "M100,200 A100,100 0 0 1 100,0 A100,100 0 0 1 200,100 L200,200 Z",
    path: [
      ["M", 100, 200],
      ["C", 44.771525016920656, 200, 0, 155.22847498307934, 0, 100],
      ["C", 0, 44.77152501692066, 44.771525016920656, 0, 100, 0],
      [
        "C",
        155.22847498307934,
        0,
        200,
        44.77152501692063,
        200,
        99.99999999999997
      ],
      ["L", 200, 200],
      ["Z"]
    ],
    symmetry: 4,
    image: !0,
    full: !0
  },
  {
    type: "shape",
    category: "circles",
    name: "circle-opposite-sides",
    outerSvg: "M100,200 A100,100 0 0 1 0,100 L0,0 L100,0 A100,100 0 0 1 200,100 L200,200 Z",
    path: [
      ["M", 100, 200],
      ["C", 44.771525016920656, 200, 0, 155.22847498307934, 0, 100],
      ["L", 0, 0],
      ["L", 100, 0],
      [
        "C",
        155.22847498307934,
        0,
        200,
        44.77152501692063,
        200,
        99.99999999999997
      ],
      ["L", 200, 200],
      ["Z"],
      ["Z"]
    ],
    symmetry: 2,
    image: !0,
    full: !0
  },
  {
    type: "shape",
    category: "circles",
    name: "circle-quarter-cut",
    outerSvg: "M100,200 A100,100 0 0 1 100,0 A100,100 0 0 1 200,100 L100,100",
    path: [
      ["M", 100, 200],
      ["C", 44.771525016920656, 200, 0, 155.22847498307934, 0, 100],
      ["C", 0, 44.77152501692066, 44.771525016920656, 0, 100, 0],
      [
        "C",
        155.22847498307934,
        0,
        200,
        44.77152501692063,
        200,
        99.99999999999997
      ],
      ["L", 100, 100],
      ["Z"]
    ],
    symmetry: 4
  }
], KE = [
  {
    type: "shape",
    category: "rectangles",
    name: "square",
    outerSvg: "M0,0 L200,0 200,200 0,200 0,0",
    path: [
      ["M", 0, 0],
      ["L", 200, 0],
      ["L", 200, 200],
      ["L", 0, 200],
      ["L", 0, 0],
      ["Z"]
    ],
    symmetry: 1,
    image: !0,
    full: !0
  },
  {
    type: "shape",
    category: "rectangles",
    name: "rectangle-half",
    outerSvg: "M0,0 L 100,0 100,200 0,200 0,0",
    path: [
      ["M", 0, 0],
      ["L", 100, 0],
      ["L", 100, 200],
      ["L", 0, 200],
      ["L", 0, 0],
      ["Z"]
    ],
    symmetry: 4
  },
  {
    type: "shape",
    category: "rectangles",
    name: "rectangle-diagonal",
    outerSvg: "M0,0 L 100,0 100,100 0,100 0,0 M100,100 L200,100 200,200 100,200 100,100 Z",
    path: [
      ["M", 0, 0],
      ["L", 100, 0],
      ["L", 100, 100],
      ["L", 0, 100],
      ["L", 0, 0],
      ["M", 100, 100],
      ["L", 200, 100],
      ["L", 200, 200],
      ["L", 100, 200],
      ["L", 100, 100],
      ["Z"]
    ],
    symmetry: 2,
    full: !0
  },
  {
    type: "shape",
    category: "rectangles",
    name: "rectangle-quarter",
    outerSvg: "M0,0 L 100,0 100,100 0,100 0,0",
    path: [
      ["M", 0, 0],
      ["L", 100, 0],
      ["L", 100, 100],
      ["L", 0, 100],
      ["L", 0, 0],
      ["Z"]
    ],
    symmetry: 4
  },
  {
    type: "shape",
    category: "rectangles",
    name: "rectangle-l",
    outerSvg: "M0,0 L 0,200 200,200 200,100 100,100 100,0 0,0 Z",
    path: [
      ["M", 0, 0],
      ["L", 0, 200],
      ["L", 200, 200],
      ["L", 200, 100],
      ["L", 100, 100],
      ["L", 100, 0],
      ["L", 0, 0],
      ["Z"],
      ["Z"]
    ],
    symmetry: 4,
    full: !0
  },
  {
    type: "shape",
    category: "rectangles",
    name: "diamond",
    outerSvg: "M100,0 L 200,100 100,200 0,100 100,0 Z",
    path: [
      ["M", 100, 0],
      ["L", 200, 100],
      ["L", 100, 200],
      ["L", 0, 100],
      ["L", 100, 0],
      ["Z"]
    ],
    symmetry: 1,
    full: !0
  },
  {
    type: "shape",
    category: "rectangles",
    name: "diamond-diagonal",
    outerSvg: "M50,0 L 100,50 50,100 0,50 50,0 M150,100 L200,150 150,200 100,150 150,100 Z",
    path: [
      ["M", 50, 0],
      ["L", 100, 50],
      ["L", 50, 100],
      ["L", 0, 50],
      ["L", 50, 0],
      ["M", 150, 100],
      ["L", 200, 150],
      ["L", 150, 200],
      ["L", 100, 150],
      ["L", 150, 100],
      ["Z"]
    ],
    symmetry: 1,
    full: !1
  },
  {
    type: "shape",
    category: "rectangles",
    name: "diamond-quarter",
    outerSvg: "M50,0 L 100,50 50,100 0,50 50,0 M150,100 Z",
    path: [
      ["M", 50, 0],
      ["L", 100, 50],
      ["L", 50, 100],
      ["L", 0, 50],
      ["L", 50, 0],
      ["Z"]
    ],
    symmetry: 1,
    full: !1
  },
  {
    type: "shape",
    category: "rectangles",
    name: "rectangle-flip",
    outerSvg: "M50,100 L 0,100 0,0 200,0 200,100 150,100 150,50 50,50 50,100 150,100 150,150 50,150 50,100Z",
    path: [
      ["M", 50, 100],
      ["L", 0, 100],
      ["L", 0, 0],
      ["L", 200, 0],
      ["L", 200, 100],
      ["L", 150, 100],
      ["L", 150, 50],
      ["L", 50, 50],
      ["L", 50, 100],
      ["L", 150, 100],
      ["L", 150, 150],
      ["L", 50, 150],
      ["L", 50, 100],
      ["Z"]
    ],
    symmetry: 1,
    full: !1
  }
], QE = [
  {
    type: "shape",
    category: "triangles",
    name: "triangle-tl",
    outerSvg: "M0,0 L 200,0 0,200 0,0 Z",
    path: [["M", 0, 0], ["L", 200, 0], ["L", 0, 200], ["L", 0, 0], ["Z"]],
    symmetry: 4,
    full: !0
  },
  {
    type: "shape",
    category: "triangles",
    name: "triangle-tl-small",
    outerSvg: "M0,0 L 100,0 0,100 0,0 Z",
    path: [["M", 0, 0], ["L", 100, 0], ["L", 0, 100], ["L", 0, 0], ["Z"]],
    symmetry: 4,
    full: !0
  },
  {
    type: "shape",
    category: "triangles",
    name: "triangle-br-small",
    outerSvg: "M100,0 L 0,100 100,100 100,0 Z",
    path: [["M", 100, 0], ["L", 0, 100], ["L", 100, 100], ["L", 100, 0], ["Z"]],
    symmetry: 4,
    full: !0,
    hidden: !0
  },
  {
    type: "shape",
    category: "triangles",
    name: "triangle-tl-cutout",
    outerSvg: "M100,0 L 200,0 0,200 0,100 100,0Z",
    path: [
      ["M", 100, 0],
      ["L", 200, 0],
      ["L", 0, 200],
      ["L", 0, 100],
      ["L", 100, 0],
      ["Z"]
    ],
    symmetry: 4,
    full: !0
  },
  {
    type: "shape",
    category: "triangles",
    name: "pyramid-t",
    outerSvg: "M0,200 L 100,0 200,200 0,200 Z",
    path: [["M", 0, 200], ["L", 100, 0], ["L", 200, 200], ["L", 0, 200], ["Z"]],
    symmetry: 4
  },
  {
    type: "shape",
    category: "triangles",
    name: "pyramid-t-small",
    outerSvg: "M0,100 L 50,0 100,100 0,100 Z",
    path: [["M", 0, 100], ["L", 50, 0], ["L", 100, 100], ["L", 0, 100], ["Z"]],
    symmetry: 4,
    hidden: !0
  },
  {
    type: "shape",
    category: "triangles",
    name: "pyramid-b-small",
    outerSvg: "M0,0 L 100,0 50,100 0,0 Z",
    path: [["M", 0, 0], ["L", 100, 0], ["L", 50, 100], ["L", 0, 0], ["Z"]],
    symmetry: 4,
    hidden: !0
  },
  {
    type: "shape",
    category: "triangles",
    name: "center-point-d",
    outerSvg: "M0,0 L 100,100 200,0 0,0 M0,100 L 100,200 200,100 0,100 Z",
    path: [
      ["M", 0, 0],
      ["L", 100, 100],
      ["L", 200, 0],
      ["L", 0, 0],
      ["M", 0, 100],
      ["L", 100, 200],
      ["L", 200, 100],
      ["L", 0, 100],
      ["Z"]
    ],
    symmetry: 4,
    full: !0
  },
  {
    type: "shape",
    category: "triangles",
    name: "center-point-t",
    outerSvg: "M0,0 L 100,100 200,0 0,0 Z",
    path: [["M", 0, 0], ["L", 100, 100], ["L", 200, 0], ["L", 0, 0], ["Z"]],
    symmetry: 4
  },
  {
    type: "shape",
    category: "triangles",
    name: "center-point-b",
    outerSvg: "M0,100 L 200,100 100,200 0,100 Z",
    path: [
      ["M", 0, 100],
      ["L", 200, 100],
      ["L", 100, 200],
      ["L", 0, 100],
      ["Z"]
    ],
    symmetry: 4,
    height: 100
  },
  {
    type: "shape",
    category: "triangles",
    name: "center-point-v",
    outerSvg: "M0,0 L 200,0 100,100 200,200 0,200 100,100 0,0 Z",
    path: [
      ["M", 0, 0],
      ["L", 200, 0],
      ["L", 100, 100],
      ["L", 200, 200],
      ["L", 0, 200],
      ["L", 100, 100],
      ["L", 0, 0],
      ["Z"]
    ],
    symmetry: 2,
    full: !0
  },
  {
    type: "shape",
    category: "triangles",
    name: "chevron-t",
    outerSvg: "M0,0 L 100,100 200,0 200,200 0,200 0,0 Z",
    path: [
      ["M", 0, 0],
      ["L", 100, 100],
      ["L", 200, 0],
      ["L", 200, 200],
      ["L", 0, 200],
      ["L", 0, 0],
      ["Z"],
      ["Z"]
    ],
    symmetry: 4,
    full: !0
  },
  {
    type: "shape",
    category: "triangles",
    name: "house",
    outerSvg: "M100,0 L 200,100 200,200 0,200 0,100 100,0 Z",
    path: [
      ["M", 100, 0],
      ["L", 200, 100],
      ["L", 200, 200],
      ["L", 0, 200],
      ["L", 0, 100],
      ["L", 100, 0],
      ["Z"]
    ],
    symmetry: 4,
    full: !0
  },
  {
    type: "shape",
    category: "triangles",
    name: "wedge-bl",
    outerSvg: "M0,0 L 100,0 200,100 200,200 0,200 0,0 Z",
    path: [
      ["M", 0, 0],
      ["L", 100, 0],
      ["L", 200, 100],
      ["L", 200, 200],
      ["L", 0, 200],
      ["L", 0, 0],
      ["Z"]
    ],
    symmetry: 4,
    full: !0
  },
  {
    type: "shape",
    category: "triangles",
    name: "wedge-opposite-l",
    outerSvg: "M0,0 L 0,100 100,200 100,100 0,0 Z",
    path: [
      ["M", 0, 0],
      ["L", 0, 100],
      ["L", 100, 200],
      ["L", 100, 100],
      ["L", 0, 0],
      ["Z"]
    ],
    symmetry: 4
  },
  {
    type: "shape",
    category: "triangles",
    name: "wedge-diagonal",
    outerSvg: "M0,200 L 50,50 200,0 150,150 0,200 Z",
    path: [
      ["M", 0, 200],
      ["L", 50, 50],
      ["L", 200, 0],
      ["L", 150, 150],
      ["L", 0, 200],
      ["Z"]
    ],
    symmetry: 2
  },
  {
    type: "shape",
    category: "triangles",
    name: "sawtooth-l",
    outerSvg: "M0,0 L0,100 100,0 0,0 M100,0 L100,100 200,0 100,0 Z",
    path: [
      ["M", 0, 0],
      ["L", 0, 100],
      ["L", 100, 0],
      ["L", 0, 0],
      ["M", 100, 0],
      ["L", 100, 100],
      ["L", 200, 0],
      ["L", 100, 0],
      ["Z"]
    ],
    symmetry: 4
  },
  {
    type: "shape",
    category: "triangles",
    name: "sawtooth-b",
    outerSvg: "M0,100 L0,200 100,100 0,100 M100,100 L100,200 200,100 100,100 Z",
    path: [
      ["M", 0, 100],
      ["L", 0, 200],
      ["L", 100, 100],
      ["L", 0, 100],
      ["M", 100, 100],
      ["L", 100, 200],
      ["L", 200, 100],
      ["L", 100, 100],
      ["Z"]
    ],
    symmetry: 4,
    height: 100
  },
  {
    type: "shape",
    category: "triangles",
    name: "sawtooth-big",
    outerSvg: "M0,0 L0,200 100,0 0,0 M100,0 L100,200 200,0 100,0 Z",
    path: [
      ["M", 0, 0],
      ["L", 200, 0],
      ["L", 0, 100],
      ["L", 0, 0],
      ["M", 0, 100],
      ["L", 200, 100],
      ["L", 0, 200],
      ["L", 0, 100],
      ["Z"]
    ],
    symmetry: 4
  },
  {
    type: "shape",
    category: "triangles",
    name: "sawtooth-big-l",
    outerSvg: "M0,0 L0,200 100,0 0,0 Z",
    path: [["M", 0, 0], ["L", 200, 0], ["L", 0, 100], ["L", 0, 0], ["Z"]],
    symmetry: 4
  },
  {
    type: "shape",
    category: "triangles",
    name: "sawtooth-big-r",
    outerSvg: "M100,0 L100,200 200,0 100,0 Z",
    path: [["M", 0, 100], ["L", 200, 100], ["L", 0, 200], ["L", 0, 100], ["Z"]],
    symmetry: 4,
    height: 100
  },
  {
    type: "shape",
    category: "triangles",
    name: "triangle-flip",
    outerSvg: "M50,50 L0,0 0,200 200,200 150,150 50,150 50,50 150,50 150,150 50,50 Z",
    path: [
      ["M", 50, 50],
      ["L", 0, 0],
      ["L", 0, 200],
      ["L", 200, 200],
      ["L", 150, 150],
      ["L", 50, 150],
      ["L", 50, 50],
      ["L", 150, 50],
      ["L", 150, 150],
      ["L", 50, 50],
      ["Z"]
    ],
    symmetry: 4
  }
], JE = [
  {
    type: "shape",
    category: "miscellanious",
    name: "x-shape",
    outerSvg: "M40,0 L 100,60 160,0 200,40 140,100 200,160 160,200 100,140 40,200 0,160 60,100 0,40 40,0 Z",
    path: [
      ["M", 40, 0],
      ["L", 100, 60],
      ["L", 160, 0],
      ["L", 200, 40],
      ["L", 140, 100],
      ["L", 200, 160],
      ["L", 160, 200],
      ["L", 100, 140],
      ["L", 40, 200],
      ["L", 0, 160],
      ["L", 60, 100],
      ["L", 0, 40],
      ["L", 40, 0],
      ["Z"]
    ],
    symmetry: 1,
    full: !0
  },
  {
    type: "shape",
    category: "miscellanious",
    name: "lines-2",
    outerSvg: "M0,40 L200,40 200,80 0,80 0,40 M0,120 200,120 200,160 0,160 0,120 Z",
    path: [
      ["M", 0, 40],
      ["L", 200, 40],
      ["L", 200, 80],
      ["L", 0, 80],
      ["L", 0, 40],
      ["M", 0, 120],
      ["L", 200, 120],
      ["L", 200, 160],
      ["L", 0, 160],
      ["L", 0, 120],
      ["Z"]
    ],
    symmetry: 2,
    height: 160
  }
], Oa = [].concat(YE).concat(KE).concat(QE).concat(JE), eT = {
  shapes: [
    {
      name: "shape-name",
      size: 2,
      position: [0, 0],
      colour: 0,
      rotation: 0
    }
  ],
  dimensions: [2, 2],
  colourCount: 1,
  rotate: !0
}, tT = [...Oa].reduce((e, t, r) => {
  const n = JSON.parse(JSON.stringify(eT));
  return n.shapes[0].name = t.name, e[`shape${r}`] = n, e;
}, {}), rT = {
  resolution: 200
}, nT = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (https://www.inkscape.org/) -->
<!-- ClipArt by Arvin61r58 (https://openclipart.org/user-detail/Arvin61r58) -->
<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="{{pk_dimension}}"
   height="{{pk_dimension}}"
   viewBox="0 0 135 135"
   version="1.1"
   id="svg8">
  <title
     id="title5721">Abstract Pattern 16</title>
  <defs
     id="defs2">
     {{pk_gradient}}
   </defs>
  <metadata
     id="metadata5">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title>Abstract Pattern 16</dc:title>
        <cc:license
           rdf:resource="http://creativecommons.org/publicdomain/zero/1.0/" />
        <dc:creator>
          <cc:Agent>
            <dc:title>Arvin61r58</dc:title>
          </cc:Agent>
        </dc:creator>
        <dc:publisher>
          <cc:Agent>
            <dc:title>Openclipart.org</dc:title>
          </cc:Agent>
        </dc:publisher>
        <dc:identifier>https://openclipart.org/</dc:identifier>
        <dc:source>https://openclipart.org/user-detail/Arvin61r58</dc:source>
        <dc:subject>
          <rdf:Bag>
            <rdf:li>pattern</rdf:li>
            <rdf:li>abstract</rdf:li>
            <rdf:li>tile</rdf:li>
            <rdf:li>tileable</rdf:li>
            <rdf:li>seamless. geometric</rdf:li>
            <rdf:li>texture</rdf:li>
          </rdf:Bag>
        </dc:subject>
        <dc:description>Seamless/tileable abstract pattern</dc:description>
      </cc:Work>
      <cc:License
         rdf:about="http://creativecommons.org/publicdomain/zero/1.0/">
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#Reproduction" />
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#Distribution" />
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#DerivativeWorks" />
      </cc:License>
    </rdf:RDF>
  </metadata>
  <g
     transform="translate(-37.266671,-80.766647)"
     id="layer1">
    <g
       transform="translate(22.556594,21.739808)"
       id="g5717">
      <title
         id="title5719">Abstract Pattern 16  --  by Arvin61r58</title>
      <g
         id="g5575"
         transform="translate(1.4790969,-0.43939123)">
        <g
           transform="translate(-6.0598808,-1.4790837)"
           id="g5505">
          <path
             style="fill:{{pk_fill}};stroke-width:0.99999905"
             d="m 23.673515,60.945314 v 4.133588 4.133075 h 2.125453 2.124935 v 8.533311 8.533312 h 1.992125 1.992127 V 73.612216 60.945314 h -4.24987 z m -4.24987,63.733446 v 1.99988 1.99987 h 4.24987 3.98477 v -1.99987 -1.99988 h -4.117578 z"
             id="path4651" />
          <path
             style="fill:{{pk_fill}};stroke-width:0.99999905"
             d="m 44.923382,60.945314 v 0.133324 4.13359 h -4.24987 -4.249869 v 10.66651 10.666514 h -2.124935 -2.124935 v 4.133587 4.133075 h 4.117059 4.117063 V 82.012202 69.211977 h 2.257742 2.257745 v 8.533311 8.533312 h 1.992125 1.992127 V 73.612216 60.945314 Z m 8.234122,0 v 1.999873 2.000392 h 4.117062 4.117578 v -4.000265 z m -8.234122,63.733446 v 3.99975 h 3.984252 4.24987 8.23464 v -3.99975 h -8.23464 z"
             id="path4649" />
          <path
             style="fill:{{pk_fill}};stroke-width:1"
             d="m 78.657261,60.945452 v 2.133715 2.133199 h -8.499739 -8.49974 v 2.133199 2.133198 h -2.124935 -2.12545 v 4.13359 4.133072 h 4.117578 4.117062 v -4.266398 -4.266913 h 2.257742 2.257743 v 2.133199 2.133714 h 4.24987 4.249869 v 2.133199 2.133199 h 1.992128 1.992127 v -8.399987 -8.399986 z"
             id="path4645" />
          <path
             style="fill:{{pk_fill}};stroke-width:1"
             d="m 19.423668,69.478763 v 6.400113 6.400112 h -0.132807 v 3.999749 h 1.992124 2.124938 v -8.399985 -8.399989 h -1.992127 z"
             id="path4643" />
          <path
             style="fill:{{pk_fill}};stroke-width:1"
             d="m 53.157527,78.012074 v 4.133591 4.133072 h 1.992125 1.992127 v -4.133072 -4.133591 h -1.992127 z"
             id="path4641" />
          <g
             id="g4763"
             transform="matrix(1,0,0,0.99999802,-11.680398,-0.59137689)">
            <path
               id="path4639"
               d="m 81.83792,78.603607 v 2.000396 1.999877 h 4.117062 4.117062 v -1.999877 -2.000396 h -4.117062 z"
               style="fill:{{pk_fill}};stroke-width:1" />
            <path
               id="path4637"
               d="m 73.33818,82.870529 v 4.133083 4.133599 h 12.616802 12.616802 v -2.133204 -2.133721 h 0.132807 v -3.999757 h -4.117062 -4.24987 v 2.133203 2.133204 h -4.382677 -4.382677 v -2.133204 -2.133203 h -4.117063 z"
               style="fill:{{pk_fill}};stroke-width:1" />
          </g>
          <path
             style="fill:{{pk_fill}};stroke-width:1"
             d="m 19.423668,90.812302 v 1.999873 1.999876 h 2.124935 2.124935 v 4.133588 4.133081 h 2.125451 2.124935 v 8.5333 8.53331 h 1.992127 1.992127 V 107.47895 94.812051 H 29.783243 27.658309 V 92.812175 90.812302 H 23.54073 Z"
             id="path4635" />
          <path
             style="fill:{{pk_fill}};stroke-width:1"
             d="m 44.923403,90.812302 v 4.133072 4.133591 h -4.24987 -4.24987 v 10.666505 10.66651 h -2.124935 -2.124935 v 4.1336 4.13307 h 8.234125 v -12.79971 -12.80022 h 2.257742 2.257743 v 8.5333 8.53331 h 1.992127 1.992127 V 107.47895 94.812051 h 2.124935 2.124935 v 1.999873 2.000391 h 4.117062 4.117578 v -4.000264 -3.999749 h -8.23464 z"
             id="path4633" />
          <path
             style="fill:{{pk_fill}};stroke-width:1"
             d="m 78.657261,94.812051 v 2.133715 2.133199 h -8.499739 -8.49974 v 2.133195 2.13321 h -2.124935 -2.12545 v 4.13358 4.13307 h 4.117578 4.117062 v -4.26639 -4.26691 h 2.257742 2.257743 v 2.13319 2.13372 h 4.24987 4.249869 v 2.1332 2.13319 h 1.992128 1.992127 v -8.39998 -8.399989 h -1.992127 z"
             id="path4631" />
          <path
             style="fill:{{pk_fill}};stroke-width:1"
             d="m 19.423668,103.34537 v 6.4001 6.40012 h -0.132807 v 3.99974 h 1.992124 2.124938 v -8.39998 -8.39998 h -1.992127 z"
             id="path4629" />
          <path
             style="fill:{{pk_fill}};stroke-width:1"
             d="m 53.157527,111.87867 v 4.13359 4.13307 h 1.992125 1.992127 v -4.13307 -4.13359 h -1.992127 z"
             id="path4627" />
          <g
             id="g4772"
             transform="matrix(1,0,0,0.99999802,-11.680398,-0.59137689)">
            <path
               id="path4625"
               d="m 81.83792,112.47027 v 2.0004 1.99988 h 4.117062 4.117062 v -1.99988 -2.0004 h -4.117062 z"
               style="fill:{{pk_fill}};stroke-width:1" />
            <path
               id="path4623"
               d="m 73.33818,116.7372 v 4.13308 4.1336 h 12.616802 12.616802 v -2.13372 -2.13321 h 0.132807 v -3.99975 h -4.117062 -4.24987 v 2.1332 2.1332 h -4.382677 -4.382677 v -2.1332 -2.1332 h -4.117063 z"
               style="fill:{{pk_fill}};stroke-width:1" />
          </g>
        </g>
        <g
           transform="translate(61.673451,-1.4790837)"
           id="g5539">
          <path
             id="path5507"
             d="m 23.673515,60.945314 v 4.133588 4.133075 h 2.125453 2.124935 v 8.533311 8.533312 h 1.992125 1.992127 V 73.612216 60.945314 h -4.24987 z m -4.24987,63.733446 v 1.99988 1.99987 h 4.24987 3.98477 v -1.99987 -1.99988 h -4.117578 z"
             style="fill:{{pk_fill}};stroke-width:0.99999905" />
          <path
             id="path5509"
             d="m 44.923382,60.945314 v 0.133324 4.13359 h -4.24987 -4.249869 v 10.66651 10.666514 h -2.124935 -2.124935 v 4.133587 4.133075 h 4.117059 4.117063 V 82.012202 69.211977 h 2.257742 2.257745 v 8.533311 8.533312 h 1.992125 1.992127 V 73.612216 60.945314 Z m 8.234122,0 v 1.999873 2.000392 h 4.117062 4.117578 v -4.000265 z m -8.234122,63.733446 v 3.99975 h 3.984252 4.24987 8.23464 v -3.99975 h -8.23464 z"
             style="fill:{{pk_fill}};stroke-width:0.99999905" />
          <path
             id="path5511"
             d="m 78.657261,60.945452 v 2.133715 2.133199 h -8.499739 -8.49974 v 2.133199 2.133198 h -2.124935 -2.12545 v 4.13359 4.133072 h 4.117578 4.117062 v -4.266398 -4.266913 h 2.257742 2.257743 v 2.133199 2.133714 h 4.24987 4.249869 v 2.133199 2.133199 h 1.992128 1.992127 v -8.399987 -8.399986 z"
             style="fill:{{pk_fill}};stroke-width:1" />
          <path
             id="path5513"
             d="m 19.423668,69.478763 v 6.400113 6.400112 h -0.132807 v 3.999749 h 1.992124 2.124938 v -8.399985 -8.399989 h -1.992127 z"
             style="fill:{{pk_fill}};stroke-width:1" />
          <path
             id="path5515"
             d="m 53.157527,78.012074 v 4.133591 4.133072 h 1.992125 1.992127 v -4.133072 -4.133591 h -1.992127 z"
             style="fill:{{pk_fill}};stroke-width:1" />
          <g
             transform="matrix(1,0,0,0.99999802,-11.680398,-0.59137689)"
             id="g5521">
            <path
               style="fill:{{pk_fill}};stroke-width:1"
               d="m 81.83792,78.603607 v 2.000396 1.999877 h 4.117062 4.117062 v -1.999877 -2.000396 h -4.117062 z"
               id="path5517" />
            <path
               style="fill:{{pk_fill}};stroke-width:1"
               d="m 73.33818,82.870529 v 4.133083 4.133599 h 12.616802 12.616802 v -2.133204 -2.133721 h 0.132807 v -3.999757 h -4.117062 -4.24987 v 2.133203 2.133204 h -4.382677 -4.382677 v -2.133204 -2.133203 h -4.117063 z"
               id="path5519" />
          </g>
          <path
             id="path5523"
             d="m 19.423668,90.812302 v 1.999873 1.999876 h 2.124935 2.124935 v 4.133588 4.133081 h 2.125451 2.124935 v 8.5333 8.53331 h 1.992127 1.992127 V 107.47895 94.812051 H 29.783243 27.658309 V 92.812175 90.812302 H 23.54073 Z"
             style="fill:{{pk_fill}};stroke-width:1" />
          <path
             id="path5525"
             d="m 44.923403,90.812302 v 4.133072 4.133591 h -4.24987 -4.24987 v 10.666505 10.66651 h -2.124935 -2.124935 v 4.1336 4.13307 h 8.234125 v -12.79971 -12.80022 h 2.257742 2.257743 v 8.5333 8.53331 h 1.992127 1.992127 V 107.47895 94.812051 h 2.124935 2.124935 v 1.999873 2.000391 h 4.117062 4.117578 v -4.000264 -3.999749 h -8.23464 z"
             style="fill:{{pk_fill}};stroke-width:1" />
          <path
             id="path5527"
             d="m 78.657261,94.812051 v 2.133715 2.133199 h -8.499739 -8.49974 v 2.133195 2.13321 h -2.124935 -2.12545 v 4.13358 4.13307 h 4.117578 4.117062 v -4.26639 -4.26691 h 2.257742 2.257743 v 2.13319 2.13372 h 4.24987 4.249869 v 2.1332 2.13319 h 1.992128 1.992127 v -8.39998 -8.399989 h -1.992127 z"
             style="fill:{{pk_fill}};stroke-width:1" />
          <path
             id="path5529"
             d="m 19.423668,103.34537 v 6.4001 6.40012 h -0.132807 v 3.99974 h 1.992124 2.124938 v -8.39998 -8.39998 h -1.992127 z"
             style="fill:{{pk_fill}};stroke-width:1" />
          <path
             id="path5531"
             d="m 53.157527,111.87867 v 4.13359 4.13307 h 1.992125 1.992127 v -4.13307 -4.13359 h -1.992127 z"
             style="fill:{{pk_fill}};stroke-width:1" />
          <g
             transform="matrix(1,0,0,0.99999802,-11.680398,-0.59137689)"
             id="g5537">
            <path
               style="fill:{{pk_fill}};stroke-width:1"
               d="m 81.83792,112.47027 v 2.0004 1.99988 h 4.117062 4.117062 v -1.99988 -2.0004 h -4.117062 z"
               id="path5533" />
            <path
               style="fill:{{pk_fill}};stroke-width:1"
               d="m 73.33818,116.7372 v 4.13308 4.1336 h 12.616802 12.616802 v -2.13372 -2.13321 h 0.132807 v -3.99975 h -4.117062 -4.24987 v 2.1332 2.1332 h -4.382677 -4.382677 v -2.1332 -2.1332 h -4.117063 z"
               id="path5535" />
          </g>
        </g>
      </g>
      <g
         id="g5645"
         transform="translate(1.4790969,67.293971)">
        <g
           id="g5609"
           transform="translate(-6.0598808,-1.4790837)">
          <path
             id="path5577"
             d="m 23.673515,60.945314 v 4.133588 4.133075 h 2.125453 2.124935 v 8.533311 8.533312 h 1.992125 1.992127 V 73.612216 60.945314 h -4.24987 z m -4.24987,63.733446 v 1.99988 1.99987 h 4.24987 3.98477 v -1.99987 -1.99988 h -4.117578 z"
             style="fill:{{pk_fill}};stroke-width:0.99999905" />
          <path
             id="path5579"
             d="m 44.923382,60.945314 v 0.133324 4.13359 h -4.24987 -4.249869 v 10.66651 10.666514 h -2.124935 -2.124935 v 4.133587 4.133075 h 4.117059 4.117063 V 82.012202 69.211977 h 2.257742 2.257745 v 8.533311 8.533312 h 1.992125 1.992127 V 73.612216 60.945314 Z m 8.234122,0 v 1.999873 2.000392 h 4.117062 4.117578 v -4.000265 z m -8.234122,63.733446 v 3.99975 h 3.984252 4.24987 8.23464 v -3.99975 h -8.23464 z"
             style="fill:{{pk_fill}};stroke-width:0.99999905" />
          <path
             id="path5581"
             d="m 78.657261,60.945452 v 2.133715 2.133199 h -8.499739 -8.49974 v 2.133199 2.133198 h -2.124935 -2.12545 v 4.13359 4.133072 h 4.117578 4.117062 v -4.266398 -4.266913 h 2.257742 2.257743 v 2.133199 2.133714 h 4.24987 4.249869 v 2.133199 2.133199 h 1.992128 1.992127 v -8.399987 -8.399986 z"
             style="fill:{{pk_fill}};stroke-width:1" />
          <path
             id="path5583"
             d="m 19.423668,69.478763 v 6.400113 6.400112 h -0.132807 v 3.999749 h 1.992124 2.124938 v -8.399985 -8.399989 h -1.992127 z"
             style="fill:{{pk_fill}};stroke-width:1" />
          <path
             id="path5585"
             d="m 53.157527,78.012074 v 4.133591 4.133072 h 1.992125 1.992127 v -4.133072 -4.133591 h -1.992127 z"
             style="fill:{{pk_fill}};stroke-width:1" />
          <g
             transform="matrix(1,0,0,0.99999802,-11.680398,-0.59137689)"
             id="g5591">
            <path
               style="fill:{{pk_fill}};stroke-width:1"
               d="m 81.83792,78.603607 v 2.000396 1.999877 h 4.117062 4.117062 v -1.999877 -2.000396 h -4.117062 z"
               id="path5587" />
            <path
               style="fill:{{pk_fill}};stroke-width:1"
               d="m 73.33818,82.870529 v 4.133083 4.133599 h 12.616802 12.616802 v -2.133204 -2.133721 h 0.132807 v -3.999757 h -4.117062 -4.24987 v 2.133203 2.133204 h -4.382677 -4.382677 v -2.133204 -2.133203 h -4.117063 z"
               id="path5589" />
          </g>
          <path
             id="path5593"
             d="m 19.423668,90.812302 v 1.999873 1.999876 h 2.124935 2.124935 v 4.133588 4.133081 h 2.125451 2.124935 v 8.5333 8.53331 h 1.992127 1.992127 V 107.47895 94.812051 H 29.783243 27.658309 V 92.812175 90.812302 H 23.54073 Z"
             style="fill:{{pk_fill}};stroke-width:1" />
          <path
             id="path5595"
             d="m 44.923403,90.812302 v 4.133072 4.133591 h -4.24987 -4.24987 v 10.666505 10.66651 h -2.124935 -2.124935 v 4.1336 4.13307 h 8.234125 v -12.79971 -12.80022 h 2.257742 2.257743 v 8.5333 8.53331 h 1.992127 1.992127 V 107.47895 94.812051 h 2.124935 2.124935 v 1.999873 2.000391 h 4.117062 4.117578 v -4.000264 -3.999749 h -8.23464 z"
             style="fill:{{pk_fill}};stroke-width:1" />
          <path
             id="path5597"
             d="m 78.657261,94.812051 v 2.133715 2.133199 h -8.499739 -8.49974 v 2.133195 2.13321 h -2.124935 -2.12545 v 4.13358 4.13307 h 4.117578 4.117062 v -4.26639 -4.26691 h 2.257742 2.257743 v 2.13319 2.13372 h 4.24987 4.249869 v 2.1332 2.13319 h 1.992128 1.992127 v -8.39998 -8.399989 h -1.992127 z"
             style="fill:{{pk_fill}};stroke-width:1" />
          <path
             id="path5599"
             d="m 19.423668,103.34537 v 6.4001 6.40012 h -0.132807 v 3.99974 h 1.992124 2.124938 v -8.39998 -8.39998 h -1.992127 z"
             style="fill:{{pk_fill}};stroke-width:1" />
          <path
             id="path5601"
             d="m 53.157527,111.87867 v 4.13359 4.13307 h 1.992125 1.992127 v -4.13307 -4.13359 h -1.992127 z"
             style="fill:{{pk_fill}};stroke-width:1" />
          <g
             transform="matrix(1,0,0,0.99999802,-11.680398,-0.59137689)"
             id="g5607">
            <path
               style="fill:{{pk_fill}};stroke-width:1"
               d="m 81.83792,112.47027 v 2.0004 1.99988 h 4.117062 4.117062 v -1.99988 -2.0004 h -4.117062 z"
               id="path5603" />
            <path
               style="fill:{{pk_fill}};stroke-width:1"
               d="m 73.33818,116.7372 v 4.13308 4.1336 h 12.616802 12.616802 v -2.13372 -2.13321 h 0.132807 v -3.99975 h -4.117062 -4.24987 v 2.1332 2.1332 h -4.382677 -4.382677 v -2.1332 -2.1332 h -4.117063 z"
               id="path5605" />
          </g>
        </g>
        <g
           id="g5643"
           transform="translate(61.673451,-1.4790837)">
          <path
             style="fill:{{pk_fill}};stroke-width:0.99999905"
             d="m 23.673515,60.945314 v 4.133588 4.133075 h 2.125453 2.124935 v 8.533311 8.533312 h 1.992125 1.992127 V 73.612216 60.945314 h -4.24987 z m -4.24987,63.733446 v 1.99988 1.99987 h 4.24987 3.98477 v -1.99987 -1.99988 h -4.117578 z"
             id="path5611" />
          <path
             style="fill:{{pk_fill}};stroke-width:0.99999905"
             d="m 44.923382,60.945314 v 0.133324 4.13359 h -4.24987 -4.249869 v 10.66651 10.666514 h -2.124935 -2.124935 v 4.133587 4.133075 h 4.117059 4.117063 V 82.012202 69.211977 h 2.257742 2.257745 v 8.533311 8.533312 h 1.992125 1.992127 V 73.612216 60.945314 Z m 8.234122,0 v 1.999873 2.000392 h 4.117062 4.117578 v -4.000265 z m -8.234122,63.733446 v 3.99975 h 3.984252 4.24987 8.23464 v -3.99975 h -8.23464 z"
             id="path5613" />
          <path
             style="fill:{{pk_fill}};stroke-width:1"
             d="m 78.657261,60.945452 v 2.133715 2.133199 h -8.499739 -8.49974 v 2.133199 2.133198 h -2.124935 -2.12545 v 4.13359 4.133072 h 4.117578 4.117062 v -4.266398 -4.266913 h 2.257742 2.257743 v 2.133199 2.133714 h 4.24987 4.249869 v 2.133199 2.133199 h 1.992128 1.992127 v -8.399987 -8.399986 z"
             id="path5615" />
          <path
             style="fill:{{pk_fill}};stroke-width:1"
             d="m 19.423668,69.478763 v 6.400113 6.400112 h -0.132807 v 3.999749 h 1.992124 2.124938 v -8.399985 -8.399989 h -1.992127 z"
             id="path5617" />
          <path
             style="fill:{{pk_fill}};stroke-width:1"
             d="m 53.157527,78.012074 v 4.133591 4.133072 h 1.992125 1.992127 v -4.133072 -4.133591 h -1.992127 z"
             id="path5619" />
          <g
             id="g5625"
             transform="matrix(1,0,0,0.99999802,-11.680398,-0.59137689)">
            <path
               id="path5621"
               d="m 81.83792,78.603607 v 2.000396 1.999877 h 4.117062 4.117062 v -1.999877 -2.000396 h -4.117062 z"
               style="fill:{{pk_fill}};stroke-width:1" />
            <path
               id="path5623"
               d="m 73.33818,82.870529 v 4.133083 4.133599 h 12.616802 12.616802 v -2.133204 -2.133721 h 0.132807 v -3.999757 h -4.117062 -4.24987 v 2.133203 2.133204 h -4.382677 -4.382677 v -2.133204 -2.133203 h -4.117063 z"
               style="fill:{{pk_fill}};stroke-width:1" />
          </g>
          <path
             style="fill:{{pk_fill}};stroke-width:1"
             d="m 19.423668,90.812302 v 1.999873 1.999876 h 2.124935 2.124935 v 4.133588 4.133081 h 2.125451 2.124935 v 8.5333 8.53331 h 1.992127 1.992127 V 107.47895 94.812051 H 29.783243 27.658309 V 92.812175 90.812302 H 23.54073 Z"
             id="path5627" />
          <path
             style="fill:{{pk_fill}};stroke-width:1"
             d="m 44.923403,90.812302 v 4.133072 4.133591 h -4.24987 -4.24987 v 10.666505 10.66651 h -2.124935 -2.124935 v 4.1336 4.13307 h 8.234125 v -12.79971 -12.80022 h 2.257742 2.257743 v 8.5333 8.53331 h 1.992127 1.992127 V 107.47895 94.812051 h 2.124935 2.124935 v 1.999873 2.000391 h 4.117062 4.117578 v -4.000264 -3.999749 h -8.23464 z"
             id="path5629" />
          <path
             style="fill:{{pk_fill}};stroke-width:1"
             d="m 78.657261,94.812051 v 2.133715 2.133199 h -8.499739 -8.49974 v 2.133195 2.13321 h -2.124935 -2.12545 v 4.13358 4.13307 h 4.117578 4.117062 v -4.26639 -4.26691 h 2.257742 2.257743 v 2.13319 2.13372 h 4.24987 4.249869 v 2.1332 2.13319 h 1.992128 1.992127 v -8.39998 -8.399989 h -1.992127 z"
             id="path5631" />
          <path
             style="fill:{{pk_fill}};stroke-width:1"
             d="m 19.423668,103.34537 v 6.4001 6.40012 h -0.132807 v 3.99974 h 1.992124 2.124938 v -8.39998 -8.39998 h -1.992127 z"
             id="path5633" />
          <path
             style="fill:{{pk_fill}};stroke-width:1"
             d="m 53.157527,111.87867 v 4.13359 4.13307 h 1.992125 1.992127 v -4.13307 -4.13359 h -1.992127 z"
             id="path5635" />
          <g
             id="g5641"
             transform="matrix(1,0,0,0.99999802,-11.680398,-0.59137689)">
            <path
               id="path5637"
               d="m 81.83792,112.47027 v 2.0004 1.99988 h 4.117062 4.117062 v -1.99988 -2.0004 h -4.117062 z"
               style="fill:{{pk_fill}};stroke-width:1" />
            <path
               id="path5639"
               d="m 73.33818,116.7372 v 4.13308 4.1336 h 12.616802 12.616802 v -2.13372 -2.13321 h 0.132807 v -3.99975 h -4.117062 -4.24987 v 2.1332 2.1332 h -4.382677 -4.382677 v -2.1332 -2.1332 h -4.117063 z"
               style="fill:{{pk_fill}};stroke-width:1" />
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
`, oT = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="{{pk_dimension}}" height="{{pk_dimension}}" viewBox="0 0 1023 1023"
 preserveAspectRatio="xMidYMid meet">
<metadata>
Created by potrace 1.12, written by Peter Selinger 2001-2015
</metadata>
<defs>     
{{pk_gradient}}
</defs>
<g transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
fill="{{pk_fill}}" stroke="none">
<path d="M0 9790 c0 -247 1 -450 3 -450 1 0 27 14 57 30 30 17 78 41 105 55
28 14 73 38 100 54 28 16 88 48 135 72 47 24 98 54 113 66 16 13 37 23 46 23
10 0 29 9 43 19 13 11 67 40 119 65 52 25 139 71 194 101 55 30 145 77 200
105 166 85 268 140 284 154 9 7 31 18 50 25 19 6 42 17 50 25 9 7 32 19 52 25
20 7 44 20 54 31 9 10 30 22 46 25 96 21 -21 25 -805 25 l-846 0 0 -450z"/>
<path d="M2705 10215 c-33 -12 -77 -29 -97 -38 -21 -9 -43 -17 -50 -17 -7 0
-37 -11 -66 -25 -30 -14 -62 -25 -71 -25 -9 0 -34 -9 -56 -20 -21 -11 -63 -27
-94 -36 -31 -9 -61 -20 -67 -25 -6 -5 -36 -16 -65 -25 -30 -9 -71 -25 -91 -35
-21 -10 -45 -19 -55 -19 -10 0 -39 -11 -65 -25 -26 -14 -55 -25 -64 -25 -10 0
-36 -9 -58 -19 -38 -18 -80 -34 -201 -76 -27 -10 -73 -28 -101 -41 -28 -13
-57 -24 -64 -24 -8 0 -32 -9 -54 -19 -23 -11 -67 -29 -99 -40 -151 -55 -173
-64 -187 -76 -8 -7 -33 -18 -55 -24 -22 -6 -62 -22 -89 -36 -27 -14 -54 -25
-60 -25 -6 0 -33 -11 -60 -25 -27 -14 -59 -25 -70 -25 -12 0 -45 -11 -74 -25
-30 -14 -64 -25 -75 -25 -12 0 -35 -7 -52 -16 -16 -9 -57 -24 -90 -34 -81 -25
-183 -63 -222 -83 -18 -9 -40 -17 -50 -17 -10 0 -37 -9 -58 -20 -22 -12 -64
-28 -93 -36 l-52 -15 0 -280 0 -279 23 -1 c12 0 54 -9 92 -20 39 -10 106 -25
150 -33 44 -8 93 -19 109 -25 15 -6 70 -18 121 -26 51 -9 112 -22 135 -30 24
-8 71 -20 105 -25 34 -5 82 -19 106 -29 24 -11 71 -25 103 -31 39 -8 73 -23
98 -43 l38 -30 0 -111 c1 -269 25 -385 143 -681 96 -242 94 -235 67 -230 -45
9 -67 18 -119 54 -29 20 -60 41 -70 46 -27 18 -132 89 -165 113 -17 12 -47 33
-66 47 -64 45 -250 186 -344 260 -35 28 -82 64 -105 80 -23 17 -70 53 -105 80
-35 28 -82 64 -105 80 -23 17 -68 50 -99 75 -31 25 -69 54 -85 63 l-27 17 0
-1171 0 -1171 293 5 c160 3 323 10 360 17 50 9 81 9 111 1 51 -13 142 -65 221
-126 11 -8 45 -31 75 -50 30 -18 66 -42 80 -52 26 -19 96 -65 151 -98 18 -11
43 -27 55 -35 31 -22 73 -50 119 -78 22 -14 59 -38 83 -53 23 -16 45 -29 48
-29 4 0 19 -10 34 -22 15 -13 51 -36 80 -53 28 -16 67 -42 87 -57 20 -16 40
-28 45 -28 6 0 23 -10 38 -22 15 -13 43 -32 61 -43 62 -37 98 -60 144 -93 25
-17 60 -39 78 -48 18 -9 34 -20 37 -24 3 -4 21 -15 40 -25 19 -9 43 -24 53
-33 9 -8 25 -20 35 -26 10 -6 33 -20 51 -31 18 -11 60 -38 93 -60 33 -22 79
-51 103 -65 24 -14 70 -43 102 -64 51 -34 187 -122 234 -151 9 -6 29 -19 45
-29 29 -19 55 -36 149 -94 28 -17 64 -41 80 -52 17 -11 53 -35 80 -52 28 -17
81 -51 118 -76 37 -25 81 -52 96 -61 16 -9 58 -35 92 -59 35 -23 67 -42 72
-42 5 0 22 -10 37 -23 15 -12 43 -31 61 -42 18 -11 49 -30 69 -42 19 -12 52
-31 72 -42 20 -11 39 -25 43 -30 3 -6 39 -28 80 -51 101 -56 99 -70 -7 -69
-82 0 -268 12 -463 29 -55 5 -194 12 -310 15 -115 4 -234 10 -264 16 -30 5
-88 9 -130 9 -41 0 -88 5 -105 10 -17 6 -179 17 -361 25 -347 16 -527 28 -585
39 -19 4 -179 11 -355 16 -336 9 -470 24 -527 57 -30 17 -33 24 -35 74 -5 107
-10 117 -54 129 -22 6 -100 15 -172 20 -164 12 -588 13 -605 2 -7 -5 -17 -24
-22 -43 -6 -22 -10 -782 -10 -2111 l0 -2078 838 0 837 0 150 76 c83 42 161 81
175 88 14 7 43 22 65 32 22 11 67 34 100 52 33 17 76 39 95 47 19 8 58 28 85
44 51 30 58 34 110 58 17 7 42 20 58 28 67 36 84 45 107 56 14 6 36 17 50 24
14 8 66 34 115 60 50 25 101 53 115 61 14 8 36 19 50 25 14 6 52 25 85 44 33
18 78 43 100 54 22 12 63 34 90 51 28 16 73 41 100 55 70 36 121 68 147 92 13
11 28 22 34 24 25 8 95 81 91 94 -7 18 -107 62 -192 85 -120 33 -244 43 -359
30 -101 -12 -337 -67 -405 -96 -118 -49 -370 -96 -581 -109 -190 -10 -264 -15
-337 -21 -40 -4 -73 -4 -73 -1 0 30 173 226 431 489 74 75 142 145 151 155 18
19 853 877 1078 1108 75 77 156 163 180 190 23 28 101 111 174 185 73 74 145
151 160 170 43 53 340 350 351 350 9 0 5 -58 -5 -85 -5 -14 -16 -77 -24 -139
-8 -62 -19 -123 -25 -134 -6 -11 -18 -74 -26 -139 -9 -65 -22 -140 -30 -168
-8 -27 -19 -92 -26 -143 -6 -52 -17 -108 -24 -126 -8 -19 -17 -64 -21 -102 -3
-38 -17 -114 -30 -169 -12 -55 -28 -139 -34 -187 -6 -48 -17 -102 -24 -120 -8
-18 -17 -64 -21 -103 -4 -38 -17 -113 -30 -165 -13 -52 -26 -129 -30 -170 -4
-41 -15 -95 -25 -120 -9 -25 -20 -79 -24 -120 -4 -41 -19 -111 -32 -155 -19
-58 -26 -109 -29 -185 -2 -58 -8 -118 -14 -133 -15 -38 -14 -112 2 -124 6 -6
23 -14 37 -18 14 -4 727 -11 1585 -15 858 -5 1578 -12 1600 -17 l40 -8 -100
-28 c-105 -29 -191 -46 -365 -72 -122 -19 -200 -41 -200 -59 0 -13 69 -82 110
-109 14 -10 45 -33 70 -52 25 -19 59 -41 75 -48 17 -8 36 -21 44 -30 7 -10 19
-17 26 -17 7 0 29 -13 50 -30 21 -16 43 -30 50 -30 6 0 20 -9 30 -20 10 -11
27 -22 39 -26 11 -3 29 -14 39 -22 25 -22 83 -57 132 -80 22 -11 46 -27 54
-36 7 -9 18 -16 23 -16 5 0 24 -11 41 -24 81 -59 24 -56 934 -56 458 0 833 2
833 4 0 2 -11 28 -25 58 -14 29 -25 63 -25 74 0 12 -8 32 -18 45 -11 13 -24
46 -31 72 -6 27 -20 65 -31 85 -11 20 -20 46 -20 57 0 11 -11 41 -25 67 -14
26 -25 55 -25 65 0 11 -9 36 -20 58 -11 21 -27 63 -36 94 -9 31 -22 63 -29 71
-7 8 -17 29 -20 45 -4 17 -17 48 -30 70 -12 22 -25 53 -29 69 -4 17 -16 42
-26 57 -11 14 -24 39 -30 54 -6 15 -29 57 -52 91 -48 75 -40 73 -213 59 -44
-3 -102 -12 -130 -20 -27 -8 -79 -21 -115 -29 l-65 -15 -60 30 c-62 31 -233
143 -270 177 -26 23 -102 80 -125 92 -12 6 -29 18 -38 26 -45 40 -155 124
-162 124 -4 0 -37 24 -73 52 -65 52 -103 81 -182 138 -22 16 -48 36 -58 45 -9
8 -47 35 -82 60 -36 24 -70 49 -77 54 -32 27 -100 78 -133 101 -20 14 -66 48
-103 77 -105 82 -115 89 -149 106 -17 9 -33 20 -35 24 -3 8 -63 54 -133 103
-38 26 -109 81 -135 103 -8 7 -42 31 -75 52 -33 22 -85 60 -117 85 -31 25 -91
70 -133 100 -42 30 -86 63 -98 72 -12 10 -47 35 -77 57 -30 22 -64 47 -75 55
-34 27 -159 120 -181 136 -21 14 -146 108 -229 171 -22 16 -76 57 -120 89 -91
67 -104 77 -162 122 -23 18 -58 44 -78 58 -20 14 -51 37 -68 51 -46 37 -172
132 -193 145 -10 6 -14 15 -10 22 11 18 65 15 130 -8 31 -10 84 -22 119 -26
34 -4 98 -17 141 -30 44 -13 92 -24 107 -24 15 0 56 -9 91 -20 34 -11 96 -25
135 -31 40 -5 97 -18 126 -28 29 -10 78 -22 108 -26 30 -4 92 -18 138 -31 46
-13 96 -24 111 -24 16 0 57 -9 92 -20 34 -11 92 -25 128 -30 36 -6 90 -19 120
-29 30 -10 82 -22 115 -26 32 -4 80 -15 105 -25 25 -10 73 -21 105 -25 33 -5
85 -16 115 -27 30 -10 87 -23 125 -29 39 -5 97 -18 130 -28 33 -11 84 -23 114
-27 30 -3 79 -15 108 -25 29 -10 87 -23 128 -28 41 -6 91 -17 110 -25 19 -8
68 -19 107 -25 40 -6 98 -19 129 -29 30 -11 84 -23 120 -27 35 -4 84 -15 109
-25 25 -10 73 -21 105 -25 33 -4 92 -18 132 -31 39 -13 88 -24 108 -24 20 0
69 -11 108 -24 40 -13 97 -27 129 -31 31 -3 80 -15 108 -26 29 -11 84 -24 124
-29 39 -5 91 -18 116 -28 25 -11 76 -23 114 -27 38 -4 86 -16 107 -26 21 -12
68 -23 111 -26 40 -3 101 -17 136 -30 36 -13 84 -23 115 -23 29 0 78 -9 110
-20 62 -22 166 -27 199 -9 25 13 23 25 -39 249 -74 268 -85 323 -88 470 -3
111 -1 148 16 210 28 106 91 240 160 342 22 31 44 70 116 198 53 95 98 202
152 362 50 149 81 195 249 371 85 89 161 171 168 183 20 29 44 127 44 174 0
41 -42 151 -70 185 -9 11 -32 42 -50 68 -18 27 -67 86 -109 130 -98 105 -132
150 -165 215 -29 58 -35 60 -128 41 -72 -14 -204 -56 -253 -80 -22 -10 -56
-22 -75 -25 -19 -4 -45 -13 -58 -21 -13 -8 -53 -25 -90 -37 -37 -13 -98 -36
-137 -51 -38 -15 -90 -34 -115 -42 -25 -8 -68 -26 -95 -39 -28 -13 -58 -24
-68 -24 -10 0 -40 -11 -67 -25 -27 -14 -57 -25 -67 -25 -10 0 -38 -11 -63 -24
-25 -13 -61 -27 -80 -31 -19 -4 -40 -12 -47 -17 -11 -9 -67 -31 -217 -84 -38
-14 -75 -29 -80 -34 -6 -4 -34 -14 -61 -21 -28 -6 -55 -16 -62 -21 -11 -9 -72
-33 -203 -80 -30 -10 -73 -28 -96 -39 -22 -10 -46 -19 -54 -19 -8 0 -32 -9
-54 -19 -40 -19 -114 -47 -206 -77 -25 -9 -63 -24 -85 -35 -22 -10 -60 -26
-85 -35 -25 -9 -81 -29 -125 -46 -44 -16 -100 -36 -125 -45 -25 -8 -57 -21
-72 -29 -15 -8 -51 -22 -80 -31 -29 -8 -70 -24 -90 -34 -21 -10 -45 -19 -55
-19 -10 0 -31 -7 -48 -16 -32 -17 -129 -56 -205 -81 -25 -8 -63 -23 -85 -33
-22 -10 -62 -26 -90 -35 -110 -37 -181 -64 -210 -79 -16 -9 -37 -16 -45 -16
-8 0 -31 -8 -50 -19 -19 -10 -60 -25 -90 -34 -30 -9 -73 -25 -95 -37 -21 -11
-48 -20 -58 -20 -11 0 -36 -9 -56 -19 -20 -11 -56 -26 -81 -34 -25 -9 -83 -30
-130 -47 -47 -17 -105 -38 -130 -46 -25 -9 -58 -22 -75 -30 -16 -7 -55 -22
-85 -33 -134 -47 -158 -56 -211 -78 -31 -12 -62 -23 -69 -23 -7 0 -37 -11 -66
-25 -30 -14 -68 -28 -86 -32 -18 -3 -45 -14 -60 -24 -35 -25 -121 -27 -116 -2
2 9 21 22 42 30 22 7 47 20 56 28 14 13 93 56 235 128 22 11 47 26 55 32 8 7
26 16 40 20 14 4 33 14 42 22 15 13 84 51 253 138 28 15 71 38 97 53 26 15 87
47 135 72 49 24 101 55 116 67 16 13 37 23 46 23 10 0 29 8 42 19 13 10 83 49
154 86 72 37 141 76 154 86 13 11 31 19 41 19 10 0 28 8 41 19 31 24 159 91
174 91 6 0 17 6 23 13 15 14 188 109 337 183 17 8 37 19 45 25 8 5 38 21 65
35 28 13 73 38 100 54 28 16 64 35 80 43 17 8 37 17 45 21 8 4 38 20 65 36 28
16 66 36 85 45 19 8 44 21 55 27 103 60 154 86 175 93 14 4 32 13 40 20 8 7
57 35 108 62 191 99 288 150 337 178 93 51 100 55 111 55 6 0 19 9 28 19 10
11 31 23 47 26 15 4 38 14 51 24 13 10 40 23 60 30 20 7 42 18 48 26 6 7 48
32 93 55 45 23 127 66 182 96 55 29 127 67 160 84 126 64 140 72 155 85 8 7
25 16 38 20 13 4 59 29 103 56 44 27 86 49 92 49 7 0 32 14 57 30 25 16 49 30
53 30 5 0 21 9 36 19 15 11 40 23 57 27 16 4 45 18 64 31 19 12 42 23 50 23 9
0 26 7 38 16 35 25 140 48 156 35 7 -6 16 -42 19 -79 13 -138 122 -486 155
-496 52 -16 179 -26 350 -26 l192 0 0 1160 0 1159 -26 18 c-14 10 -51 38 -82
63 -31 25 -68 54 -82 63 -36 25 -80 58 -235 177 -75 58 -146 111 -158 119 -12
8 -34 26 -49 39 -15 14 -37 30 -49 36 -33 16 -34 34 -5 47 21 10 42 8 114 -10
48 -13 114 -27 147 -32 33 -5 90 -18 126 -29 36 -11 98 -24 138 -30 39 -5 88
-17 108 -25 19 -8 39 -15 44 -15 5 0 9 121 9 268 l0 268 -69 -22 c-38 -12 -77
-27 -87 -33 -11 -6 -44 -19 -74 -30 -133 -46 -158 -55 -205 -78 -28 -12 -63
-23 -78 -23 -15 0 -41 -9 -56 -21 -29 -21 -72 -23 -78 -2 -2 6 11 16 30 22 19
6 44 23 55 36 12 14 30 25 41 25 10 0 31 10 46 22 27 21 127 75 301 162 50 25
97 52 103 60 7 8 26 18 42 21 l29 7 0 454 0 454 -324 0 -323 0 -7 -31 c-3 -17
-6 -51 -6 -74 0 -23 -7 -61 -14 -83 -8 -23 -20 -88 -26 -144 -15 -135 -28
-241 -40 -303 -5 -27 -9 -76 -9 -108 -1 -61 -20 -118 -50 -152 -13 -14 -21
-44 -25 -101 -4 -45 -16 -110 -27 -145 -10 -35 -19 -81 -19 -101 0 -79 -25
-87 -35 -10 -3 26 -12 63 -20 82 -8 19 -16 69 -18 110 -5 92 -25 134 -71 150
-18 6 -42 20 -52 31 -32 35 -88 58 -152 61 -75 3 -73 17 3 15 38 -2 56 2 60
11 8 22 6 69 -6 99 -6 15 -15 52 -21 82 -5 30 -18 70 -29 90 -10 20 -19 42
-19 49 0 16 -54 161 -81 217 -10 22 -24 60 -30 84 -6 24 -17 54 -24 65 -7 12
-18 40 -25 64 l-11 42 -855 0 c-576 0 -853 -3 -849 -10 4 -6 24 -19 46 -30 21
-11 39 -24 39 -29 0 -5 21 -18 48 -30 26 -11 67 -34 92 -51 25 -16 56 -35 70
-42 14 -7 38 -23 53 -35 16 -13 35 -23 42 -23 7 0 26 -10 42 -22 32 -26 50
-38 113 -73 25 -14 65 -39 90 -55 25 -16 64 -40 86 -52 23 -13 67 -40 98 -60
31 -21 60 -38 65 -38 4 0 25 -14 46 -30 21 -16 43 -30 50 -30 6 0 20 -9 30
-20 10 -11 26 -22 37 -25 10 -4 46 -24 81 -46 34 -22 78 -46 97 -54 19 -9 42
-20 50 -25 8 -6 29 -17 45 -24 36 -17 79 -72 71 -92 -5 -12 -71 -14 -428 -15
-233 0 -432 -2 -443 -4 -11 -1 -41 -6 -68 -9 -26 -3 -107 -23 -180 -45 -205
-61 -279 -74 -396 -72 -150 2 -223 23 -351 97 -30 18 -80 37 -110 43 -82 16
-271 31 -395 30 -600 0 -1002 -5 -1012 -12 -23 -15 -53 -140 -62 -257 -5 -63
-16 -142 -25 -175 -9 -33 -21 -118 -26 -188 -6 -71 -17 -145 -26 -165 -8 -20
-19 -91 -24 -157 -5 -66 -16 -137 -24 -157 -9 -19 -20 -89 -26 -154 -5 -66
-17 -144 -25 -174 -9 -30 -20 -102 -26 -160 -5 -58 -19 -141 -29 -185 -10 -44
-24 -130 -30 -192 -6 -61 -17 -127 -24 -145 -8 -18 -17 -76 -21 -128 -4 -52
-15 -130 -26 -173 -11 -43 -23 -120 -28 -170 -4 -51 -17 -139 -29 -197 -11
-58 -26 -152 -32 -210 -6 -57 -16 -112 -21 -122 -5 -9 -16 -80 -24 -156 -8
-77 -19 -151 -24 -165 -5 -14 -15 -72 -21 -128 -7 -57 -21 -147 -31 -200 -11
-52 -24 -142 -29 -200 -6 -57 -16 -126 -24 -154 -8 -27 -20 -103 -26 -168 -6
-65 -18 -136 -25 -158 -8 -21 -17 -78 -21 -126 -3 -48 -17 -139 -30 -200 -13
-62 -24 -130 -24 -152 0 -21 -9 -83 -21 -138 -11 -54 -27 -152 -35 -218 -8
-66 -18 -133 -24 -150 -5 -16 -12 -51 -16 -77 -6 -47 -25 -75 -42 -64 -5 3
-15 27 -22 53 -6 26 -16 53 -21 59 -8 10 -33 76 -74 199 -9 28 -25 68 -35 90
-10 22 -25 60 -34 85 -36 110 -57 167 -70 190 -7 14 -17 41 -21 60 -4 19 -14
46 -22 59 -8 13 -23 52 -33 87 -10 35 -26 73 -34 86 -9 12 -16 32 -16 43 0 11
-11 42 -23 70 -23 49 -34 77 -83 219 -13 38 -29 74 -34 81 -5 6 -14 34 -20 63
-6 28 -18 56 -25 62 -8 7 -17 28 -21 49 -3 20 -16 59 -29 86 -12 28 -30 73
-39 100 -10 28 -29 79 -43 115 -13 36 -31 85 -40 110 -8 25 -25 69 -39 98 -13
29 -24 59 -24 68 0 8 -11 36 -25 62 -14 26 -25 56 -25 68 0 12 -11 41 -24 66
-13 25 -27 60 -31 78 -4 18 -18 56 -31 84 -13 28 -24 61 -24 72 0 12 -9 33
-20 46 -10 14 -24 46 -30 71 -5 26 -19 61 -30 79 -11 18 -20 42 -20 53 0 11
-11 43 -25 70 -13 28 -25 57 -25 66 0 9 -11 36 -24 61 -13 25 -27 60 -31 79
-4 19 -18 54 -31 79 -13 25 -24 54 -24 65 0 11 -12 43 -25 70 -14 28 -25 57
-25 65 0 8 -9 33 -21 55 -12 21 -27 62 -35 89 -7 28 -22 69 -33 91 -12 21 -21
46 -21 55 0 8 -9 29 -19 47 -11 17 -23 49 -27 70 -4 21 -17 58 -30 83 -13 25
-24 54 -24 65 0 11 -11 38 -25 60 -13 22 -25 49 -25 60 0 12 -9 39 -20 60 -11
22 -27 60 -34 85 -8 25 -23 63 -35 85 -11 22 -21 49 -21 60 0 11 -9 34 -19 52
-11 17 -25 51 -31 75 -7 24 -20 57 -30 73 -10 17 -21 46 -25 65 -4 19 -18 56
-31 82 -13 26 -24 53 -24 60 0 7 -11 35 -23 63 -23 49 -44 104 -73 195 -8 25
-23 61 -33 80 -10 19 -22 55 -26 80 -4 25 -14 58 -22 73 -8 16 -13 45 -11 65
3 33 6 37 28 34 14 -2 85 -6 158 -9 212 -8 334 20 657 149 56 23 228 79 390
127 39 11 169 39 290 61 218 39 353 73 450 112 342 136 465 207 581 333 46 50
97 111 115 138 54 81 136 137 203 137 12 0 16 9 16 35 l0 35 -1177 -1 -1178
-2 -60 -22z m-1282 -812 c132 -34 63 -57 -148 -50 -124 5 -207 19 -193 32 2 3
33 11 68 18 99 20 196 20 273 0z m7860 -754 c-12 -137 -27 -252 -38 -289 -8
-25 -19 -90 -25 -145 -6 -55 -20 -133 -30 -172 -11 -40 -23 -105 -26 -145 -4
-40 -15 -93 -24 -118 -10 -25 -23 -79 -29 -120 -15 -100 -91 -251 -91 -182 0
10 -4 22 -9 27 -13 14 -59 207 -71 295 -19 149 -9 292 31 449 34 133 86 216
231 369 60 65 85 74 81 31z m-4745 -4781 c-5 -15 -58 -24 -58 -9 0 9 20 17 48
20 8 0 12 -5 10 -11z m-379 -147 c28 -18 4 -38 -54 -44 -31 -3 -63 -11 -70
-17 -17 -14 -159 -66 -231 -84 -28 -8 -62 -20 -75 -29 -13 -8 -49 -20 -79 -26
-30 -7 -64 -18 -76 -26 -12 -7 -39 -17 -60 -20 -21 -4 -53 -15 -70 -25 -17
-10 -55 -23 -83 -29 -28 -6 -68 -19 -89 -29 -20 -11 -59 -24 -85 -31 -27 -6
-59 -18 -70 -25 -12 -7 -44 -19 -72 -25 -27 -7 -60 -19 -72 -27 -12 -8 -46
-19 -75 -25 -29 -6 -69 -19 -88 -29 -19 -10 -50 -21 -69 -25 -18 -4 -48 -15
-65 -25 -17 -10 -48 -21 -69 -24 -21 -4 -59 -18 -84 -32 -25 -13 -56 -24 -67
-24 -12 0 -37 -9 -57 -19 -20 -11 -56 -25 -80 -31 -24 -7 -60 -20 -79 -30 -19
-9 -52 -20 -74 -24 -21 -4 -61 -18 -90 -30 -28 -13 -71 -30 -96 -39 -89 -30
-116 -40 -166 -63 -29 -12 -69 -26 -90 -30 -21 -4 -59 -18 -83 -31 -24 -12
-53 -23 -65 -23 -12 0 -41 -9 -65 -20 -24 -11 -62 -23 -85 -26 -22 -4 -57 -15
-76 -24 -19 -10 -62 -21 -95 -25 -33 -4 -74 -10 -91 -15 -17 -4 -35 -5 -40 -1
-5 3 -24 53 -43 111 -18 58 -51 152 -72 209 -22 57 -39 110 -39 117 0 22 128
74 231 94 52 10 120 25 150 33 30 9 88 19 129 22 41 3 95 13 120 20 25 8 104
22 175 30 72 9 150 22 175 30 25 7 79 17 120 20 41 4 111 16 155 26 44 11 121
24 170 29 50 5 109 16 133 24 23 8 90 20 149 27 59 6 125 18 147 25 22 8 81
19 131 24 49 5 124 18 165 29 41 11 116 24 166 30 50 6 110 17 135 25 24 8 85
20 134 25 50 6 124 19 165 30 41 10 102 22 135 26 33 4 94 15 135 25 120 30
149 34 169 21z"/>
<path d="M5537 10193 c24 -70 120 -163 198 -192 127 -48 304 -63 490 -40 170
21 301 78 365 159 26 33 60 98 60 115 0 3 -254 5 -564 5 l-565 0 16 -47z"/>
<path d="M3892 8789 c-185 -32 -375 -165 -447 -313 -19 -39 -42 -102 -50 -141
-17 -81 -20 -281 -5 -373 54 -328 297 -662 484 -662 77 0 165 76 229 198 76
145 122 316 156 582 47 366 34 510 -56 628 -52 69 -186 104 -311 81z"/>
<path d="M10220 4121 c-6 -22 -15 -88 -21 -147 -5 -59 -15 -114 -21 -121 -15
-19 -38 -149 -38 -220 0 -41 -8 -84 -24 -126 -17 -45 -26 -95 -31 -177 -5 -88
-12 -123 -27 -150 -17 -29 -21 -59 -26 -165 -4 -109 -8 -134 -25 -157 -17 -23
-21 -47 -24 -155 -3 -103 -8 -137 -25 -172 -16 -34 -22 -70 -25 -160 -4 -84
-12 -138 -29 -194 -18 -59 -24 -101 -24 -172 0 -70 -5 -107 -20 -145 -13 -34
-22 -86 -26 -162 -3 -68 -13 -136 -25 -170 -10 -31 -21 -101 -24 -155 -6 -98
-19 -186 -36 -233 -5 -14 -13 -79 -19 -145 -5 -66 -16 -142 -25 -170 -8 -27
-18 -93 -21 -145 -4 -52 -15 -131 -25 -175 -11 -44 -24 -127 -29 -185 -5 -58
-19 -136 -30 -175 -11 -38 -20 -87 -20 -107 l0 -38 330 0 330 0 0 2080 c0
1144 -2 2080 -5 2080 -2 0 -9 -18 -15 -39z"/>
<path d="M8716 2180 c-146 -18 -245 -54 -310 -110 -51 -45 -66 -79 -66 -148 0
-126 131 -307 274 -377 258 -128 494 -10 562 282 39 167 -25 295 -168 338 -64
19 -204 26 -292 15z"/>
<path d="M4300 560 c-14 -4 -41 -9 -60 -9 -19 -1 -53 -9 -75 -17 -22 -9 -67
-22 -100 -29 -33 -8 -78 -23 -100 -35 -21 -11 -48 -20 -58 -20 -11 0 -34 -9
-51 -19 -17 -11 -49 -23 -71 -27 -22 -4 -60 -18 -84 -31 -24 -12 -53 -23 -65
-23 -12 0 -42 -11 -68 -25 -26 -14 -57 -25 -70 -25 -13 0 -37 -9 -55 -19 -17
-11 -51 -25 -75 -31 -24 -7 -56 -20 -73 -30 -16 -10 -48 -21 -70 -25 -21 -3
-59 -18 -84 -31 -25 -13 -54 -24 -64 -24 -10 0 -39 -11 -65 -25 -26 -14 -56
-25 -67 -25 -11 0 -34 -9 -51 -19 -17 -10 -55 -26 -85 -35 -30 -9 -61 -20 -69
-26 -10 -6 386 -10 1183 -10 l1197 0 0 25 c0 20 -7 26 -42 36 -24 6 -57 15
-74 20 -20 6 -97 75 -225 203 -189 188 -197 195 -291 240 -97 46 -135 53 -188
36z"/>
</g>
</svg>`, sT = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev/svgjs" viewBox="0 0 160 160" width="{{pk_dimension}}" height="{{pk_dimension}}">
<defs>     
{{pk_gradient}}
</defs>
<g fill="{{pk_fill}}">
    <circle  cx="10" cy="10" r="5" />
    <circle  cx="30" cy="10" r="5" />
    <circle  cx="50" cy="10" r="5" />
    <circle  cx="70" cy="10" r="5" />
    <circle  cx="90" cy="10" r="5" />
    <circle  cx="110" cy="10" r="5" />
    <circle  cx="130" cy="10" r="5" />
    <circle  cx="150" cy="10" r="5" />

    <circle  cx="10" cy="30" r="5" />
    <circle  cx="30" cy="30" r="5" />
    <circle  cx="50" cy="30" r="5" />
    <circle  cx="70" cy="30" r="5" />
    <circle  cx="90" cy="30" r="5" />
    <circle  cx="110" cy="30" r="5" />
    <circle  cx="130" cy="30" r="5" />
    <circle  cx="150" cy="30" r="5" />

    <circle  cx="10" cy="50" r="5" />
    <circle  cx="30" cy="50" r="5" />
    <circle  cx="50" cy="50" r="5" />
    <circle  cx="70" cy="50" r="5" />
    <circle  cx="90" cy="50" r="5" />
    <circle  cx="110" cy="50" r="5" />
    <circle  cx="130" cy="50" r="5" />
    <circle  cx="150" cy="50" r="5" />

    <circle  cx="10" cy="70" r="5" />
    <circle  cx="30" cy="70" r="5" />
    <circle  cx="50" cy="70" r="5" />
    <circle  cx="70" cy="70" r="5" />
    <circle  cx="90" cy="70" r="5" />
    <circle  cx="110" cy="70" r="5" />
    <circle  cx="130" cy="70" r="5" />
    <circle  cx="150" cy="70" r="5" />

    <circle  cx="10" cy="90" r="5" />
    <circle  cx="30" cy="90" r="5" />
    <circle  cx="50" cy="90" r="5" />
    <circle  cx="70" cy="90" r="5" />
    <circle  cx="90" cy="90" r="5" />
    <circle  cx="110" cy="90" r="5" />
    <circle  cx="130" cy="90" r="5" />
    <circle  cx="150" cy="90" r="5" />

    <circle  cx="10" cy="110" r="5" />
    <circle  cx="30" cy="110" r="5" />
    <circle  cx="50" cy="110" r="5" />
    <circle  cx="70" cy="110" r="5" />
    <circle  cx="90" cy="110" r="5" />
    <circle  cx="110" cy="110" r="5" />
    <circle  cx="130" cy="110" r="5" />
    <circle  cx="150" cy="110" r="5" />

    <circle  cx="10" cy="130" r="5" />
    <circle  cx="30" cy="130" r="5" />
    <circle  cx="50" cy="130" r="5" />
    <circle  cx="70" cy="130" r="5" />
    <circle  cx="90" cy="130" r="5" />
    <circle  cx="110" cy="130" r="5" />
    <circle  cx="130" cy="130" r="5" />
    <circle  cx="150" cy="130" r="5" />

    <circle  cx="10" cy="150" r="5" />
    <circle  cx="30" cy="150" r="5" />
    <circle  cx="50" cy="150" r="5" />
    <circle  cx="70" cy="150" r="5" />
    <circle  cx="90" cy="150" r="5" />
    <circle  cx="110" cy="150" r="5" />
    <circle  cx="130" cy="150" r="5" />
    <circle  cx="150" cy="150" r="5" />
</g></svg>`, iT = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev/svgjs" viewBox="0 0 160 160" width="{{pk_dimension}}" height="{{pk_dimension}}">
<defs>     
{{pk_gradient}}
</defs>
<g fill="{{pk_fill}}">
    <circle  cx="20" cy="20" r="10" />
    <circle  cx="60" cy="20" r="10" />
    <circle  cx="100" cy="20" r="10" />
    <circle  cx="140" cy="20" r="10" />

    <circle  cx="20" cy="60" r="10" />
    <circle  cx="60" cy="60" r="10" />
    <circle  cx="100" cy="60" r="10" />
    <circle  cx="140" cy="60" r="10" />

    <circle  cx="20" cy="100" r="10" />
    <circle  cx="60" cy="100" r="10" />
    <circle  cx="100" cy="100" r="10" />
    <circle  cx="140" cy="100" r="10" />

    <circle  cx="20" cy="140" r="10" />
    <circle  cx="60" cy="140" r="10" />
    <circle  cx="100" cy="140" r="10" />
    <circle  cx="140" cy="140" r="10" />
</g></svg>`, aT = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev/svgjs" viewBox="0 0 800 800" width="{{pk_dimension}}" height="{{pk_dimension}}">
<defs>     
{{pk_gradient}}
</defs>
<g stroke-width="80" stroke="{{pk_fill}}" fill="none">
<line x1="0" y1="0" x2="800" y2="800" stroke-linecap="square" ></line>
<line x1="200" y1="0" x2="800" y2="600" stroke-linecap="square" ></line>
<line x1="400" y1="0" x2="800" y2="400" stroke-linecap="square" ></line>
<line x1="600" y1="0" x2="800" y2="200" stroke-linecap="square" ></line>
<line x1="798" y1="-2" x2="802" y2="2" stroke-linecap="square" ></line>
<line x1="0" y1="200" x2="600" y2="800" stroke-linecap="square" ></line>
<line x1="0" y1="400" x2="400" y2="800" stroke-linecap="square" ></line>
<line x1="0" y1="600" x2="200" y2="800" stroke-linecap="square" ></line>
<line x1="-2" y1="798" x2="2" y2="802" stroke-linecap="square" ></line>
</g></svg>`, lT = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev/svgjs" viewBox="0 0 800 800" width="{{pk_dimension}}" height="{{pk_dimension}}">
<defs>     
{{pk_gradient}}
</defs>
<g stroke-width="80" stroke="{{pk_fill}}" fill="none" transform="rotate(90 400 400)">
<line x1="0" y1="0" x2="800" y2="800" stroke-linecap="square" ></line>
<line x1="200" y1="0" x2="800" y2="600" stroke-linecap="square" ></line>
<line x1="400" y1="0" x2="800" y2="400" stroke-linecap="square" ></line>
<line x1="600" y1="0" x2="800" y2="200" stroke-linecap="square" ></line>
<line x1="798" y1="-2" x2="802" y2="2" stroke-linecap="square" ></line>
<line x1="0" y1="200" x2="600" y2="800" stroke-linecap="square" ></line>
<line x1="0" y1="400" x2="400" y2="800" stroke-linecap="square" ></line>
<line x1="0" y1="600" x2="200" y2="800" stroke-linecap="square" ></line>
<line x1="-2" y1="798" x2="2" y2="802" stroke-linecap="square" ></line>
</g></svg>`, cT = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (http://www.inkscape.org/) -->
<!-- ClipArt by Arvin61r58 (http://openclipart.org/user-detail/Arvin61r58) -->
<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   id="svg4510"
   version="1.1"
   viewBox="0 0 96.308331 96.308336"
   height="{{pk_dimension}}"
   width="{{pk_dimension}}">
  <title
     id="title4554">Abstract Tile Pattern 5</title>
  <defs
     id="defs4504">
   {{pk_gradient}}
   </defs>
  <metadata
     id="metadata4507">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title>Abstract Tile Pattern 5</dc:title>
        <cc:license
           rdf:resource="http://creativecommons.org/publicdomain/zero/1.0/" />
        <dc:creator>
          <cc:Agent>
            <dc:title>Arvin61r58</dc:title>
          </cc:Agent>
        </dc:creator>
        <dc:publisher>
          <cc:Agent>
            <dc:title>Openclipart.org</dc:title>
          </cc:Agent>
        </dc:publisher>
        <dc:identifier>https://openclipart.org/</dc:identifier>
        <dc:source>https://openclipart.org/user-detail/Arvin61r58</dc:source>
        <dc:description>tileable pattern</dc:description>
        <dc:subject>
          <rdf:Bag>
            <rdf:li>tile</rdf:li>
            <rdf:li>tileable</rdf:li>
            <rdf:li>pattern</rdf:li>
            <rdf:li>seamless</rdf:li>
            <rdf:li>texture</rdf:li>
          </rdf:Bag>
        </dc:subject>
      </cc:Work>
      <cc:License
         rdf:about="http://creativecommons.org/publicdomain/zero/1.0/">
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#Reproduction" />
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#Distribution" />
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#DerivativeWorks" />
      </cc:License>
    </rdf:RDF>
  </metadata>
  <g
     transform="translate(-56.845837,-100.34583)"
     id="layer1">
    <path
       id="path4523"
       d="m 62.227938,100.34583 v 0.56896 h -0.377756 -0.377754 v 0.37878 0.37931 h -0.377756 -0.377754 v 0.3793 0.37931 h -0.377237 -0.377757 v 0.37879 0.3793 h -0.377753 -0.377756 v 0.37931 0.3793 h -0.377754 -0.377753 v 0.37879 0.3793 h -0.377241 -0.378269 v 0.37931 0.37931 h -0.849561 v 1.70584 h 0.849561 v 0.3793 0.37931 h 0.378269 0.377241 v 0.37878 0.37931 h 0.377753 0.377754 v 0.3793 0.37931 h 0.377756 0.377753 v 0.37879 0.3793 h 0.377757 0.377237 v 0.3793 0.37931 h 0.377754 0.377756 v 0.37879 0.3793 h 0.377754 0.377756 v 0.66353 0.66353 h -0.377756 -0.377754 v 0.3793 0.37879 h -0.377756 -0.377754 v 0.3793 0.37931 h -0.377237 -0.377757 v 0.3793 0.37879 h -0.377753 -0.377756 v 0.37931 0.3793 h -0.377754 -0.377753 v 0.37931 0.37879 h -0.377241 -0.378269 v 0.3793 0.3793 h -0.849561 v 1.70584 h 0.849561 v 0.37931 0.3793 h 0.378269 0.377241 v 0.37931 0.37879 h 0.377753 0.377754 v 0.3793 0.37931 h 0.377756 0.377753 v 0.3793 0.37879 h 0.377757 0.377237 v 0.37931 0.3793 h 0.377754 0.377756 v 0.3793 0.3788 h 0.377754 0.377756 v 0.56895 0.56896 h -0.377756 -0.377754 v 0.37879 0.3793 h -0.377756 -0.377754 v 0.37931 0.3793 h -0.377237 -0.377757 v 0.37879 0.3793 h -0.377753 -0.377756 v 0.37931 0.37931 h -0.377754 -0.377753 v 0.37878 0.37931 h -0.377241 -0.378269 v 0.3793 0.37931 h -0.849561 v 1.70584 h 0.849561 v 0.3793 0.37931 h 0.378269 0.377241 v 0.37879 0.3793 h 0.377753 0.377754 v 0.3793 0.37931 h 0.377756 0.377753 v 0.37879 0.3793 h 0.377757 0.377237 v 0.37931 0.3793 h 0.377754 0.377756 v 0.37879 0.37931 h 0.377754 0.377756 v 0.66352 0.66353 h -0.377756 -0.377754 v 0.3793 0.37879 h -0.377756 -0.377754 v 0.37931 0.3793 h -0.377237 -0.377757 v 0.37931 0.37878 h -0.377753 -0.377756 v 0.37931 0.3793 h -0.377754 -0.377753 v 0.37931 0.37879 h -0.377241 -0.378269 v 0.3793 0.37931 h -0.849561 v 1.70584 h 0.849561 v 0.3793 0.37931 h 0.378269 0.377241 v 0.3793 0.37879 h 0.377753 0.377754 v 0.3793 0.37931 h 0.377756 0.377753 v 0.3793 0.37879 h 0.377757 0.377237 v 0.37931 0.3793 h 0.377754 0.377756 v 0.37931 0.37879 h 0.377754 0.377756 v 0.56896 0.56895 h -0.377756 -0.377754 v 0.37879 0.3793 h -0.377756 -0.377754 v 0.37931 0.37931 h -0.377237 -0.377757 v 0.37878 0.37931 h -0.377753 -0.377756 v 0.3793 0.37931 h -0.377754 -0.377753 v 0.37879 0.3793 h -0.377241 -0.378269 v 0.37931 0.3793 h -0.849561 v 1.70584 h 0.849561 v 0.37931 0.3793 h 0.378269 0.377241 v 0.37879 0.3793 h 0.377753 0.377754 v 0.37931 0.3793 h 0.377756 0.377753 v 0.37879 0.37931 h 0.377757 0.377237 v 0.3793 0.37931 h 0.377754 0.377756 v 0.37879 0.3793 h 0.377754 0.377756 v 0.66353 0.66352 h -0.377756 -0.377754 v 0.37931 0.37878 h -0.377756 -0.377754 v 0.37931 0.3793 h -0.377237 -0.377757 v 0.37931 0.37879 h -0.377753 -0.377756 v 0.3793 0.37931 h -0.377754 -0.377753 v 0.3793 0.37879 h -0.377241 -0.378269 v 0.37931 0.3793 h -0.849561 v 1.70584 h 0.849561 v 0.3793 0.37931 h 0.378269 0.377241 v 0.3793 0.37879 h 0.377753 0.377754 v 0.37931 0.3793 h 0.377756 0.377753 v 0.37931 0.37879 h 0.377757 0.377237 v 0.3793 0.37931 h 0.377754 0.377756 v 0.3793 0.37879 h 0.377754 0.377756 v 0.56896 0.56896 h -0.377756 -0.377754 v 0.37878 0.37931 h -0.377756 -0.377754 v 0.3793 0.37931 h -0.377237 -0.377757 v 0.37879 0.3793 h -0.377753 -0.377756 v 0.37931 0.3793 h -0.377754 -0.377753 v 0.37879 0.3793 h -0.377241 -0.378269 v 0.37931 0.3793 h -0.849561 v 1.70584 h 0.849561 v 0.37931 0.3793 h 0.378269 0.377241 v 0.37879 0.37931 h 0.377753 0.377754 v 0.3793 0.37931 h 0.377756 0.377753 v 0.37879 0.3793 h 0.377757 0.377237 v 0.3793 0.37931 h 0.377754 0.377756 v 0.3793 0.37879 h 0.377754 0.377756 v 0.66353 0.66352 h -0.377756 -0.377754 v 0.37931 0.37879 h -0.377756 -0.377754 v 0.3793 0.37931 h -0.377237 -0.377757 v 0.3793 0.37879 h -0.377753 -0.377756 v 0.37931 0.3793 h -0.377754 -0.377753 v 0.37931 0.37878 h -0.377241 -0.378269 v 0.37931 0.3793 h -0.849561 v 1.70584 h 0.849561 v 0.37931 0.3793 h 0.378269 0.377241 v 0.37931 0.37879 h 0.377753 0.377754 v 0.3793 0.37931 h 0.377756 0.377753 v 0.3793 0.37879 h 0.377757 0.377237 v 0.37931 0.3793 h 0.377754 0.377756 v 0.3793 0.37879 h 0.377754 0.377756 v 0.56896 h 13.407448 v -0.56896 h 0.377756 0.377754 v -0.37879 -0.3793 h 0.377756 0.377753 v -0.3793 -0.37931 h 0.377238 0.378272 v -0.37879 -0.3793 h 0.377238 0.377756 v -0.37931 -0.3793 h 0.377754 0.377753 v -0.37879 -0.37931 h 0.37724 0.37827 v -0.3793 -0.37931 h 0.754994 0.755509 v 0.37931 0.3793 h 0.377754 0.377756 v 0.37931 0.37879 h 0.377238 0.377753 v 0.3793 0.37931 h 0.377757 0.377753 v 0.3793 0.37879 h 0.377756 0.377754 v 0.37931 0.3793 h 0.377753 0.377241 v 0.3793 0.37879 h 0.377753 0.377754 v 0.56896 h 13.407451 v -0.56896 h 0.378272 0.377236 v -0.37879 -0.3793 h 0.37776 0.37775 v -0.3793 -0.37931 h 0.37775 0.37724 v -0.37879 -0.3793 h 0.37827 0.37724 v -0.37931 -0.3793 h 0.37776 0.37775 v -0.37879 -0.37931 h 0.37776 0.37775 v -0.3793 -0.37931 H 105 h 0.84956 v 0.37931 0.3793 h 0.37827 0.37724 v 0.37931 0.37879 h 0.37776 0.37775 v 0.3793 0.37931 h 0.37776 0.37775 v 0.3793 0.37879 h 0.37776 0.37723 v 0.37931 0.3793 h 0.37776 0.37775 v 0.3793 0.37879 h 0.37776 0.37775 v 0.56896 h 13.40745 v -0.56896 h 0.37776 0.37775 v -0.37879 -0.3793 h 0.37776 0.37775 v -0.3793 -0.37931 h 0.37724 0.37827 v -0.37879 -0.3793 h 0.37724 0.37776 v -0.37931 -0.3793 h 0.37775 0.37775 v -0.37879 -0.37931 h 0.37724 0.37827 v -0.3793 -0.37931 h 0.755 0.75551 v 0.37931 0.3793 h 0.37775 0.37776 v 0.37931 0.37879 h 0.37723 0.37776 v 0.3793 0.37931 h 0.37775 0.37776 v 0.3793 0.37879 h 0.37775 0.37776 v 0.37931 0.3793 h 0.37775 0.37724 v 0.3793 0.37879 h 0.37775 0.37776 v 0.56896 h 13.40745 v -0.56896 h 0.37827 0.37724 v -0.37879 -0.3793 h 0.37775 0.37776 v -0.3793 -0.37931 h 0.37775 0.37724 v -0.37879 -0.3793 h 0.37827 0.37724 v -0.37931 -0.3793 h 0.37775 0.37776 v -0.37879 -0.37931 h 0.37775 0.37776 v -0.3793 -0.37931 h 0.84956 v -1.70584 h -0.84956 v -0.3793 -0.37931 h -0.37776 -0.37775 v -0.37878 -0.37931 h -0.37776 -0.37775 v -0.3793 -0.37931 h -0.37724 -0.37827 v -0.37879 -0.3793 h -0.37724 -0.37775 v -0.37931 -0.3793 h -0.37776 -0.37775 v -0.37879 -0.37931 h -0.37724 -0.37827 v -0.66352 -0.66353 h 0.37827 0.37724 v -0.37879 -0.3793 h 0.37775 0.37776 v -0.37931 -0.3793 h 0.37775 0.37724 v -0.3793 -0.37879 h 0.37827 0.37724 v -0.37931 -0.3793 h 0.37775 0.37776 v -0.37931 -0.37879 h 0.37775 0.37776 v -0.3793 -0.37931 h 0.84956 v -1.70584 h -0.84956 v -0.3793 -0.37931 h -0.37776 -0.37775 v -0.3793 -0.37879 h -0.37776 -0.37775 v -0.3793 -0.37931 h -0.37724 -0.37827 v -0.3793 -0.37879 h -0.37724 -0.37775 v -0.37931 -0.3793 h -0.37776 -0.37775 v -0.37931 -0.37878 h -0.37724 -0.37827 v -0.56896 -0.56896 h 0.37827 0.37724 v -0.37879 -0.3793 h 0.37775 0.37776 v -0.37931 -0.3793 h 0.37775 0.37724 v -0.37879 -0.37931 h 0.37827 0.37724 v -0.3793 -0.37931 h 0.37775 0.37776 v -0.37879 -0.3793 h 0.37775 0.37776 v -0.37931 -0.3793 h 0.84956 v -1.70584 h -0.84956 v -0.3793 -0.37931 h -0.37776 -0.37775 v -0.37879 -0.3793 h -0.37776 -0.37775 v -0.37931 -0.3793 h -0.37724 -0.37827 v -0.37879 -0.37931 h -0.37724 -0.37775 v -0.3793 -0.37931 h -0.37776 -0.37775 v -0.37878 -0.37931 h -0.37724 -0.37827 v -0.66352 -0.66353 h 0.37827 0.37724 v -0.3793 -0.37879 h 0.37775 0.37776 v -0.37931 -0.3793 h 0.37775 0.37724 v -0.37931 -0.37879 h 0.37827 0.37724 v -0.3793 -0.37931 h 0.37775 0.37776 v -0.3793 -0.37879 h 0.37775 0.37776 v -0.3793 -0.37931 h 0.84956 v -1.70584 h -0.84956 v -0.3793 -0.37931 h -0.37776 -0.37775 v -0.3793 -0.37879 h -0.37776 -0.37775 v -0.37931 -0.3793 h -0.37724 -0.37827 v -0.37931 -0.37878 h -0.37724 -0.37775 v -0.37931 -0.37931 h -0.37776 -0.37775 v -0.3793 -0.37879 h -0.37724 -0.37827 V 148.5 147.93104 h 0.37827 0.37724 v -0.37879 -0.37931 h 0.37775 0.37776 v -0.3793 -0.37931 h 0.37775 0.37724 v -0.37879 -0.3793 h 0.37827 0.37724 v -0.37931 -0.3793 h 0.37775 0.37776 v -0.37879 -0.3793 h 0.37775 0.37776 v -0.37931 -0.3793 h 0.84956 v -1.70584 h -0.84956 v -0.37931 -0.3793 h -0.37776 -0.37775 v -0.37879 -0.37931 h -0.37776 -0.37775 v -0.3793 -0.37931 h -0.37724 -0.37827 v -0.37878 -0.37931 h -0.37724 -0.37775 v -0.3793 -0.37931 h -0.37776 -0.37775 v -0.37879 -0.3793 h -0.37724 -0.37827 v -0.66353 -0.66352 h 0.37827 0.37724 v -0.37931 -0.37879 h 0.37775 0.37776 v -0.3793 -0.37931 h 0.37775 0.37724 v -0.3793 -0.37879 h 0.37827 0.37724 v -0.37931 -0.3793 h 0.37775 0.37776 v -0.3793 -0.37879 h 0.37775 0.37776 v -0.37931 -0.3793 h 0.84956 v -1.70584 h -0.84956 v -0.37931 -0.3793 h -0.37776 -0.37775 v -0.37931 -0.37878 h -0.37776 -0.37775 v -0.37931 -0.37931 h -0.37724 -0.37827 v -0.3793 -0.37879 h -0.37724 -0.37775 v -0.3793 -0.37931 h -0.37776 -0.37775 v -0.3793 -0.37879 h -0.37724 -0.37827 v -0.56896 -0.56895 h 0.37827 0.37724 v -0.3788 -0.3793 h 0.37775 0.37776 v -0.3793 -0.37931 h 0.37775 0.37724 v -0.37879 -0.3793 h 0.37827 0.37724 v -0.37931 -0.3793 h 0.37775 0.37776 v -0.37879 -0.37931 h 0.37775 0.37776 v -0.3793 -0.37931 h 0.84956 V 117.598 h -0.84956 v -0.3793 -0.3793 h -0.37776 -0.37775 v -0.37879 -0.37931 h -0.37776 -0.37775 v -0.3793 -0.37931 h -0.37724 -0.37827 v -0.37879 -0.3793 h -0.37724 -0.37775 v -0.37931 -0.3793 h -0.37776 -0.37775 v -0.37879 -0.3793 h -0.37724 -0.37827 v -0.66353 -0.66353 h 0.37827 0.37724 v -0.3793 -0.37879 h 0.37775 0.37776 v -0.37931 -0.3793 h 0.37775 0.37724 v -0.3793 -0.37879 h 0.37827 0.37724 v -0.37931 -0.3793 h 0.37775 0.37776 v -0.37931 -0.37878 h 0.37775 0.37776 v -0.37931 -0.3793 h 0.84956 v -1.70584 h -0.84956 v -0.37931 -0.37931 h -0.37776 -0.37775 v -0.3793 -0.37879 h -0.37776 -0.37775 v -0.3793 -0.37931 h -0.37724 -0.37827 v -0.3793 -0.37879 h -0.37724 -0.37775 v -0.37931 -0.3793 h -0.37776 -0.37775 v -0.37931 -0.37878 h -0.37724 -0.37827 v -0.56896 h -13.40745 v 0.56896 h -0.37776 -0.37775 v 0.37878 0.37931 h -0.37724 -0.37775 v 0.3793 0.37931 h -0.37776 -0.37775 v 0.37879 0.3793 h -0.37776 -0.37775 v 0.37931 0.3793 h -0.37776 -0.37723 v 0.37879 0.3793 h -0.37776 -0.37775 v 0.37931 0.37931 h -0.75551 -0.755 v -0.37931 -0.37931 h -0.37827 -0.37724 v -0.3793 -0.37879 h -0.37775 -0.37775 v -0.3793 -0.37931 h -0.37776 -0.37724 v -0.3793 -0.37879 h -0.37827 -0.37724 v -0.37931 -0.3793 h -0.37775 -0.37776 v -0.37931 -0.37878 h -0.37775 -0.37776 v -0.56896 H 110.3821 v 0.56896 h -0.37775 -0.37776 v 0.37878 0.37931 h -0.37775 -0.37776 v 0.3793 0.37931 h -0.37723 -0.37776 v 0.37879 0.3793 h -0.37775 -0.37776 v 0.37931 0.3793 h -0.37775 -0.37776 v 0.37879 0.3793 h -0.37724 -0.37827 v 0.37931 0.37931 H 105 104.15044 v -0.37931 -0.37931 h -0.37775 -0.37776 v -0.3793 -0.37879 h -0.37775 -0.37776 v -0.3793 -0.37931 h -0.37724 -0.37827 v -0.3793 -0.37879 h -0.37724 -0.37775 v -0.37931 -0.3793 h -0.37775 -0.37776 v -0.37931 -0.37878 h -0.377236 -0.378272 v -0.56896 H 86.210451 v 0.56896 h -0.377754 -0.377753 v 0.37878 0.37931 H 85.077703 84.69995 v 0.3793 0.37931 H 84.322196 83.94444 v 0.37879 0.3793 H 83.566687 83.18893 v 0.37931 0.3793 h -0.377753 -0.377238 v 0.37879 0.3793 h -0.377756 -0.377754 v 0.37931 0.37931 H 80.92292 80.167926 v -0.37931 -0.37931 h -0.37827 -0.37724 v -0.3793 -0.37879 h -0.377753 -0.377754 v -0.3793 -0.37931 h -0.377756 -0.377238 v -0.3793 -0.37879 h -0.378272 -0.377238 v -0.37931 -0.3793 h -0.377753 -0.377756 v -0.37931 -0.37878 h -0.377754 -0.377756 v -0.56896 z m 5.853906,0.75809 h 0.850077 0.849559 v 0.37931 0.3793 h 0.377756 0.377753 v 0.37931 0.37878 h 0.377757 0.377237 v 0.37931 0.3793 h 0.377754 0.377756 v 0.37879 0.37931 h 0.377754 0.377756 v 0.3793 0.37931 h 0.377753 0.377238 v 0.37879 0.3793 h 0.378272 0.377238 v 0.66353 0.66352 h -0.377238 -0.378272 v 0.37931 0.3793 h -0.377238 -0.377753 v 0.37931 0.37878 h -0.377756 -0.377754 v 0.37931 0.37931 h -0.377756 -0.377754 v 0.37878 0.37931 h -0.377237 -0.377757 v 0.3793 0.37931 H 70.159236 69.78148 v 0.37879 0.3793 h -0.849559 -0.850077 v -0.3793 -0.37879 h -0.377756 -0.377754 v -0.37931 -0.3793 H 66.949097 66.57134 v -0.37931 -0.37878 h -0.377753 -0.377756 v -0.37931 -0.37931 H 65.438077 65.060321 V 108.119 107.73969 H 64.682567 64.30533 v -0.3793 -0.37931 H 63.927574 63.54982 v -0.66352 -0.66353 h 0.377754 0.377756 v -0.3793 -0.37879 h 0.377237 0.377754 v -0.37931 -0.3793 h 0.377756 0.377754 v -0.37931 -0.37879 h 0.377756 0.377753 v -0.3793 -0.37931 h 0.377757 0.377237 v -0.37878 -0.37931 h 0.377754 0.377756 v -0.3793 z m 23.983032,0 h 0.849561 0.849558 v 0.37931 0.3793 h 0.377757 0.377753 v 0.37931 0.37878 h 0.377756 0.377754 v 0.37931 0.3793 h 0.377237 0.378273 v 0.37879 0.37931 h 0.377237 0.377754 v 0.3793 0.37931 h 0.377756 0.377754 v 0.37879 0.3793 h 0.377237 0.378272 v 0.66353 0.66352 h -0.378272 -0.377237 v 0.37931 0.3793 h -0.377754 -0.377756 v 0.37931 0.37878 h -0.377754 -0.377237 v 0.37931 0.37931 h -0.378273 -0.377237 v 0.37878 0.37931 h -0.377754 -0.377756 v 0.3793 0.37931 h -0.377753 -0.377757 v 0.37879 0.3793 h -0.849558 -0.849561 v -0.3793 -0.37879 h -0.378273 -0.377237 v -0.37931 -0.3793 H 90.93161 90.553856 v -0.37931 -0.37878 h -0.377753 -0.377757 v -0.37931 -0.37931 h -0.377753 -0.377238 v -0.37878 -0.37931 h -0.377756 -0.377754 v -0.3793 -0.37931 h -0.377756 -0.377753 v -0.66352 -0.66353 h 0.377753 0.377756 v -0.3793 -0.37879 h 0.377754 0.377756 v -0.37931 -0.3793 h 0.377238 0.377753 v -0.37931 -0.37879 h 0.377757 0.377753 v -0.3793 -0.37931 h 0.377754 0.377756 v -0.37878 -0.37931 h 0.377237 0.378273 v -0.3793 z m 24.171134,0 h 0.85008 0.84956 v 0.37931 0.3793 h 0.37775 0.37776 v 0.37931 0.37878 h 0.37775 0.37724 v 0.37931 0.3793 h 0.37775 0.37776 v 0.37879 0.37931 h 0.37775 0.37776 v 0.3793 0.37931 h 0.37775 0.37724 v 0.37879 0.3793 h 0.37827 0.37724 v 0.66353 0.66352 h -0.37724 -0.37827 v 0.37931 0.3793 h -0.37724 -0.37775 v 0.37931 0.37878 h -0.37776 -0.37775 v 0.37931 0.37931 h -0.37776 -0.37775 v 0.37878 0.37931 h -0.37724 -0.37775 v 0.3793 0.37931 h -0.37776 -0.37775 v 0.37879 0.3793 h -0.84956 -0.85008 v -0.3793 -0.37879 h -0.37776 -0.37775 v -0.37931 -0.3793 h -0.37724 -0.37775 v -0.37931 -0.37878 H 114.34775 113.97 v -0.37931 -0.37931 h -0.37776 -0.37775 v -0.37878 -0.37931 h -0.37776 -0.37723 v -0.3793 -0.37931 h -0.37776 -0.37775 v -0.66352 -0.66353 h 0.37775 0.37776 v -0.3793 -0.37879 h 0.37723 0.37776 v -0.37931 -0.3793 h 0.37775 0.37776 v -0.37931 -0.37879 h 0.37775 0.37776 v -0.3793 -0.37931 h 0.37775 0.37724 v -0.37878 -0.37931 h 0.37775 0.37776 v -0.3793 z m 23.98303,0 h 0.84956 0.84956 v 0.37931 0.3793 h 0.37776 0.37775 v 0.37931 0.37878 h 0.37776 0.37775 v 0.37931 0.3793 h 0.37724 0.37827 v 0.37879 0.37931 h 0.37724 0.37775 v 0.3793 0.37931 h 0.37776 0.37775 v 0.37879 0.3793 h 0.37724 0.37827 v 0.66353 0.66352 h -0.37827 -0.37724 v 0.37931 0.3793 h -0.37775 -0.37776 v 0.37931 0.37878 h -0.37775 -0.37724 v 0.37931 0.37931 h -0.37827 -0.37724 v 0.37878 0.37931 h -0.37775 -0.37776 v 0.3793 0.37931 h -0.37775 -0.37776 v 0.37879 0.3793 h -0.84956 -0.84956 v -0.3793 -0.37879 h -0.37827 -0.37724 v -0.37931 -0.3793 h -0.37775 -0.37776 v -0.37931 -0.37878 h -0.37775 -0.37776 v -0.37931 -0.37931 h -0.37775 -0.37724 v -0.37878 -0.37931 h -0.37776 -0.37775 v -0.3793 -0.37931 h -0.37775 -0.37776 v -0.66352 -0.66353 h 0.37776 0.37775 v -0.3793 -0.37879 h 0.37775 0.37776 v -0.37931 -0.3793 h 0.37724 0.37775 v -0.37931 -0.37879 h 0.37776 0.37775 v -0.3793 -0.37931 h 0.37776 0.37775 v -0.37878 -0.37931 h 0.37724 0.37827 v -0.3793 z m -60.051114,6.06682 h 0.754994 0.755509 v 0.3793 0.37931 h 0.377754 0.377756 v 0.37878 0.37931 h 0.377238 0.377753 v 0.3793 0.37931 h 0.377757 0.377753 v 0.37879 0.3793 h 0.377756 0.377754 v 0.3793 0.37931 h 0.377753 0.377241 v 0.37879 0.3793 h 0.377753 0.377754 v 0.66353 0.66353 h -0.377754 -0.377753 v 0.3793 0.37879 H 85.077703 84.69995 v 0.3793 0.37931 H 84.322196 83.94444 v 0.3793 0.37879 H 83.566687 83.18893 v 0.37931 0.3793 h -0.377753 -0.377238 v 0.37931 0.37879 h -0.377756 -0.377754 v 0.3793 0.3793 H 80.92292 80.167926 v -0.3793 -0.3793 h -0.37827 -0.37724 v -0.37879 -0.37931 h -0.377753 -0.377754 v -0.3793 -0.37931 h -0.377756 -0.377238 v -0.37879 -0.3793 h -0.378272 -0.377238 v -0.37931 -0.3793 h -0.377753 -0.377756 v -0.37879 -0.3793 h -0.377754 -0.377756 v -0.66353 -0.66353 h 0.377756 0.377754 v -0.3793 -0.37879 h 0.377756 0.377753 v -0.37931 -0.3793 h 0.377238 0.378272 v -0.3793 -0.37879 h 0.377238 0.377756 v -0.37931 -0.3793 h 0.377754 0.377753 v -0.37931 -0.37878 h 0.37724 0.37827 v -0.37931 z m 23.982514,0 H 105 h 0.84956 v 0.3793 0.37931 h 0.37827 0.37724 v 0.37878 0.37931 h 0.37776 0.37775 v 0.3793 0.37931 h 0.37776 0.37775 v 0.37879 0.3793 h 0.37776 0.37723 v 0.3793 0.37931 h 0.37776 0.37775 v 0.37879 0.3793 h 0.37776 0.37775 v 0.66353 0.66353 h -0.37775 -0.37776 v 0.3793 0.37879 h -0.37775 -0.37776 v 0.3793 0.37931 h -0.37723 -0.37776 v 0.3793 0.37879 h -0.37775 -0.37776 v 0.37931 0.3793 h -0.37775 -0.37776 v 0.37931 0.37879 h -0.37724 -0.37827 v 0.3793 0.3793 H 105 104.15044 v -0.3793 -0.3793 h -0.37775 -0.37776 v -0.37879 -0.37931 h -0.37775 -0.37776 v -0.3793 -0.37931 h -0.37724 -0.37827 v -0.37879 -0.3793 h -0.37724 -0.37775 v -0.37931 -0.3793 h -0.37775 -0.37776 v -0.37879 -0.3793 h -0.377236 -0.378272 v -0.66353 -0.66353 h 0.378272 0.377236 v -0.3793 -0.37879 h 0.37776 0.37775 v -0.37931 -0.3793 h 0.37775 0.37724 v -0.3793 -0.37879 h 0.37827 0.37724 v -0.37931 -0.3793 h 0.37776 0.37775 v -0.37931 -0.37878 h 0.37776 0.37775 v -0.37931 z m 24.17165,0 h 0.755 0.75551 v 0.3793 0.37931 h 0.37775 0.37776 v 0.37878 0.37931 h 0.37723 0.37776 v 0.3793 0.37931 h 0.37775 0.37776 v 0.37879 0.3793 h 0.37775 0.37776 v 0.3793 0.37931 h 0.37775 0.37724 v 0.37879 0.3793 h 0.37775 0.37776 v 0.66353 0.66353 h -0.37776 -0.37775 v 0.3793 0.37879 h -0.37724 -0.37775 v 0.3793 0.37931 h -0.37776 -0.37775 v 0.3793 0.37879 h -0.37776 -0.37775 v 0.37931 0.3793 h -0.37776 -0.37723 v 0.37931 0.37879 h -0.37776 -0.37775 v 0.3793 0.3793 h -0.75551 -0.755 v -0.3793 -0.3793 h -0.37827 -0.37724 v -0.37879 -0.37931 h -0.37775 -0.37775 v -0.3793 -0.37931 h -0.37776 -0.37724 v -0.37879 -0.3793 h -0.37827 -0.37724 v -0.37931 -0.3793 h -0.37775 -0.37776 v -0.37879 -0.3793 h -0.37775 -0.37776 v -0.66353 -0.66353 h 0.37776 0.37775 v -0.3793 -0.37879 h 0.37776 0.37775 v -0.37931 -0.3793 h 0.37724 0.37827 v -0.3793 -0.37879 h 0.37724 0.37776 v -0.37931 -0.3793 h 0.37775 0.37775 v -0.37931 -0.37878 h 0.37724 0.37827 v -0.37931 z m -60.240246,6.06681 h 0.850077 0.849559 v 0.3793 0.37931 h 0.377756 0.377753 v 0.37879 0.3793 h 0.377757 0.377237 v 0.37931 0.37878 h 0.377754 0.377756 v 0.37931 0.3793 h 0.377754 0.377756 v 0.37879 0.37931 h 0.377753 0.377238 v 0.3793 0.37931 h 0.378272 0.377238 v 0.66352 0.66353 h -0.377238 -0.378272 v 0.3793 0.37879 h -0.377238 -0.377753 v 0.37931 0.3793 h -0.377756 -0.377754 v 0.37931 0.37878 h -0.377756 -0.377754 v 0.37931 0.3793 h -0.377237 -0.377757 v 0.37879 0.37931 H 70.159236 69.78148 v 0.3793 0.37931 h -0.849559 -0.850077 v -0.37931 -0.3793 h -0.377756 -0.377754 v -0.37931 -0.37879 H 66.949097 66.57134 v -0.3793 -0.37931 h -0.377753 -0.377756 v -0.37878 -0.37931 h -0.377754 -0.377756 v -0.3793 -0.37931 H 64.682567 64.30533 v -0.37879 -0.3793 H 63.927574 63.54982 v -0.66353 -0.66352 h 0.377754 0.377756 v -0.37931 -0.3793 h 0.377237 0.377754 v -0.37931 -0.37879 h 0.377756 0.377754 v -0.3793 -0.37931 h 0.377756 0.377753 v -0.37878 -0.37931 h 0.377757 0.377237 v -0.3793 -0.37879 h 0.377754 0.377756 v -0.37931 z m 23.983032,0 h 0.849561 0.849558 v 0.3793 0.37931 h 0.377757 0.377753 v 0.37879 0.3793 h 0.377756 0.377754 v 0.37931 0.37878 h 0.377237 0.378273 v 0.37931 0.3793 h 0.377237 0.377754 v 0.37879 0.37931 h 0.377756 0.377754 v 0.3793 0.37931 h 0.377237 0.378272 v 0.66352 0.66353 h -0.378272 -0.377237 v 0.3793 0.37879 h -0.377754 -0.377756 v 0.37931 0.3793 h -0.377754 -0.377237 v 0.37931 0.37878 h -0.378273 -0.377237 v 0.37931 0.3793 h -0.377754 -0.377756 v 0.37879 0.37931 h -0.377753 -0.377757 v 0.3793 0.37931 h -0.849558 -0.849561 v -0.37931 -0.3793 h -0.378273 -0.377237 v -0.37931 -0.37879 H 90.93161 90.553856 v -0.3793 -0.37931 h -0.377753 -0.377757 v -0.37878 -0.37931 h -0.377753 -0.377238 v -0.3793 -0.37931 h -0.377756 -0.377754 v -0.37879 -0.3793 h -0.377756 -0.377753 v -0.66353 -0.66352 h 0.377753 0.377756 v -0.37931 -0.3793 h 0.377754 0.377756 v -0.37931 -0.37879 h 0.377238 0.377753 v -0.3793 -0.37931 h 0.377757 0.377753 v -0.37878 -0.37931 h 0.377754 0.377756 v -0.3793 -0.37879 h 0.377237 0.378273 v -0.37931 z m 24.171134,0 h 0.85008 0.84956 v 0.3793 0.37931 h 0.37775 0.37776 v 0.37879 0.3793 h 0.37775 0.37724 v 0.37931 0.37878 h 0.37775 0.37776 v 0.37931 0.3793 h 0.37775 0.37776 v 0.37879 0.37931 h 0.37775 0.37724 v 0.3793 0.37931 h 0.37827 0.37724 v 0.66352 0.66353 h -0.37724 -0.37827 v 0.3793 0.37879 h -0.37724 -0.37775 v 0.37931 0.3793 h -0.37776 -0.37775 v 0.37931 0.37878 h -0.37776 -0.37775 v 0.37931 0.3793 h -0.37724 -0.37775 v 0.37879 0.37931 h -0.37776 -0.37775 v 0.3793 0.37931 h -0.84956 -0.85008 v -0.37931 -0.3793 h -0.37776 -0.37775 v -0.37931 -0.37879 h -0.37724 -0.37775 v -0.3793 -0.37931 H 114.34775 113.97 v -0.37878 -0.37931 h -0.37776 -0.37775 v -0.3793 -0.37931 h -0.37776 -0.37723 v -0.37879 -0.3793 h -0.37776 -0.37775 v -0.66353 -0.66352 h 0.37775 0.37776 v -0.37931 -0.3793 h 0.37723 0.37776 v -0.37931 -0.37879 h 0.37775 0.37776 v -0.3793 -0.37931 h 0.37775 0.37776 v -0.37878 -0.37931 h 0.37775 0.37724 v -0.3793 -0.37879 h 0.37775 0.37776 v -0.37931 z m 23.98303,0 h 0.84956 0.84956 v 0.3793 0.37931 h 0.37776 0.37775 v 0.37879 0.3793 h 0.37776 0.37775 v 0.37931 0.37878 h 0.37724 0.37827 v 0.37931 0.3793 h 0.37724 0.37775 v 0.37879 0.37931 h 0.37776 0.37775 v 0.3793 0.37931 h 0.37724 0.37827 v 0.66352 0.66353 h -0.37827 -0.37724 v 0.3793 0.37879 h -0.37775 -0.37776 v 0.37931 0.3793 h -0.37775 -0.37724 v 0.37931 0.37878 h -0.37827 -0.37724 v 0.37931 0.3793 h -0.37775 -0.37776 v 0.37879 0.37931 h -0.37775 -0.37776 v 0.3793 0.37931 h -0.84956 -0.84956 v -0.37931 -0.3793 h -0.37827 -0.37724 v -0.37931 -0.37879 h -0.37775 -0.37776 v -0.3793 -0.37931 h -0.37775 -0.37776 v -0.37878 -0.37931 h -0.37775 -0.37724 v -0.3793 -0.37931 h -0.37776 -0.37775 v -0.37879 -0.3793 h -0.37775 -0.37776 v -0.66353 -0.66352 h 0.37776 0.37775 v -0.37931 -0.3793 h 0.37775 0.37776 v -0.37931 -0.37879 h 0.37724 0.37775 v -0.3793 -0.37931 h 0.37776 0.37775 v -0.37878 -0.37931 h 0.37776 0.37775 v -0.3793 -0.37879 h 0.37724 0.37827 v -0.37931 z m -60.051114,6.06629 h 0.754994 0.755509 v 0.37931 0.3793 h 0.377754 0.377756 v 0.37931 0.37879 h 0.377238 0.377753 v 0.3793 0.37931 h 0.377757 0.377753 v 0.3793 0.37879 h 0.377756 0.377754 v 0.37931 0.3793 h 0.377753 0.377241 v 0.3793 0.3788 h 0.377753 0.377754 v 0.56895 0.56896 h -0.377754 -0.377753 v 0.37879 0.3793 H 85.077703 84.69995 v 0.37931 0.3793 H 84.322196 83.94444 v 0.37879 0.3793 H 83.566687 83.18893 v 0.37931 0.37931 h -0.377753 -0.377238 v 0.37878 0.37931 h -0.377756 -0.377754 v 0.3793 0.37931 H 80.92292 80.167926 v -0.37931 -0.3793 h -0.37827 -0.37724 v -0.37931 -0.37878 h -0.377753 -0.377754 v -0.37931 -0.37931 h -0.377756 -0.377238 v -0.3793 -0.37879 h -0.378272 -0.377238 v -0.3793 -0.37931 h -0.377753 -0.377756 v -0.3793 -0.37879 h -0.377754 -0.377756 v -0.56896 -0.56895 h 0.377756 0.377754 v -0.3788 -0.3793 h 0.377756 0.377753 v -0.3793 -0.37931 h 0.377238 0.378272 v -0.37879 -0.3793 h 0.377238 0.377756 v -0.37931 -0.3793 h 0.377754 0.377753 v -0.37879 -0.37931 h 0.37724 0.37827 v -0.3793 z m 23.982514,0 H 105 h 0.84956 v 0.37931 0.3793 h 0.37827 0.37724 v 0.37931 0.37879 h 0.37776 0.37775 v 0.3793 0.37931 h 0.37776 0.37775 v 0.3793 0.37879 h 0.37776 0.37723 v 0.37931 0.3793 h 0.37776 0.37775 v 0.3793 0.3788 h 0.37776 0.37775 v 0.56895 0.56896 h -0.37775 -0.37776 v 0.37879 0.3793 h -0.37775 -0.37776 v 0.37931 0.3793 h -0.37723 -0.37776 v 0.37879 0.3793 h -0.37775 -0.37776 v 0.37931 0.37931 h -0.37775 -0.37776 v 0.37878 0.37931 h -0.37724 -0.37827 v 0.3793 0.37931 H 105 104.15044 v -0.37931 -0.3793 h -0.37775 -0.37776 v -0.37931 -0.37878 h -0.37775 -0.37776 v -0.37931 -0.37931 h -0.37724 -0.37827 v -0.3793 -0.37879 h -0.37724 -0.37775 v -0.3793 -0.37931 h -0.37775 -0.37776 v -0.3793 -0.37879 h -0.377236 -0.378272 v -0.56896 -0.56895 h 0.378272 0.377236 v -0.3788 -0.3793 h 0.37776 0.37775 v -0.3793 -0.37931 h 0.37775 0.37724 v -0.37879 -0.3793 h 0.37827 0.37724 v -0.37931 -0.3793 h 0.37776 0.37775 v -0.37879 -0.37931 h 0.37776 0.37775 v -0.3793 z m 24.17165,0 h 0.755 0.75551 v 0.37931 0.3793 h 0.37775 0.37776 v 0.37931 0.37879 h 0.37723 0.37776 v 0.3793 0.37931 h 0.37775 0.37776 v 0.3793 0.37879 h 0.37775 0.37776 v 0.37931 0.3793 h 0.37775 0.37724 v 0.3793 0.3788 h 0.37775 0.37776 v 0.56895 0.56896 h -0.37776 -0.37775 v 0.37879 0.3793 h -0.37724 -0.37775 v 0.37931 0.3793 h -0.37776 -0.37775 v 0.37879 0.3793 h -0.37776 -0.37775 v 0.37931 0.37931 h -0.37776 -0.37723 v 0.37878 0.37931 h -0.37776 -0.37775 v 0.3793 0.37931 h -0.75551 -0.755 v -0.37931 -0.3793 h -0.37827 -0.37724 v -0.37931 -0.37878 h -0.37775 -0.37775 v -0.37931 -0.37931 h -0.37776 -0.37724 v -0.3793 -0.37879 h -0.37827 -0.37724 v -0.3793 -0.37931 h -0.37775 -0.37776 v -0.3793 -0.37879 h -0.37775 -0.37776 v -0.56896 -0.56895 h 0.37776 0.37775 v -0.3788 -0.3793 h 0.37776 0.37775 v -0.3793 -0.37931 h 0.37724 0.37827 v -0.37879 -0.3793 h 0.37724 0.37776 v -0.37931 -0.3793 h 0.37775 0.37775 v -0.37879 -0.37931 h 0.37724 0.37827 v -0.3793 z M 68.081844,125.181 h 0.850077 0.849559 v 0.37931 0.37931 h 0.377756 0.377753 v 0.3793 0.37879 h 0.377757 0.377237 v 0.3793 0.37931 h 0.377754 0.377756 v 0.37879 0.3793 h 0.377754 0.377756 v 0.37931 0.3793 h 0.377753 0.377238 v 0.37879 0.37931 h 0.378272 0.377238 v 0.66352 0.66352 h -0.377238 -0.378272 v 0.37931 0.37931 h -0.377238 -0.377753 v 0.3793 0.37879 h -0.377756 -0.377754 v 0.3793 0.37931 h -0.377756 -0.377754 v 0.37879 0.3793 h -0.377237 -0.377757 v 0.37931 0.3793 H 70.159236 69.78148 v 0.37879 0.37931 h -0.849559 -0.850077 v -0.37931 -0.37879 h -0.377756 -0.377754 v -0.3793 -0.37931 H 66.949097 66.57134 v -0.3793 -0.37879 h -0.377753 -0.377756 v -0.37931 -0.3793 h -0.377754 -0.377756 v -0.37879 -0.3793 H 64.682567 64.30533 v -0.37931 -0.37931 H 63.927574 63.54982 v -0.66352 -0.66352 h 0.377754 0.377756 v -0.37931 -0.37879 h 0.377237 0.377754 v -0.3793 -0.37931 h 0.377756 0.377754 v -0.3793 -0.37879 h 0.377756 0.377753 v -0.37931 -0.3793 h 0.377757 0.377237 v -0.37879 -0.3793 h 0.377754 0.377756 v -0.37931 z m 23.983032,0 h 0.849561 0.849558 v 0.37931 0.37931 h 0.377757 0.377753 v 0.3793 0.37879 h 0.377756 0.377754 v 0.3793 0.37931 h 0.377237 0.378273 v 0.37879 0.3793 h 0.377237 0.377754 v 0.37931 0.3793 h 0.377756 0.377754 v 0.37879 0.37931 h 0.377237 0.378272 v 0.66352 0.66352 h -0.378272 -0.377237 v 0.37931 0.37931 h -0.377754 -0.377756 v 0.3793 0.37879 h -0.377754 -0.377237 v 0.3793 0.37931 h -0.378273 -0.377237 v 0.37879 0.3793 h -0.377754 -0.377756 v 0.37931 0.3793 h -0.377753 -0.377757 v 0.37879 0.37931 h -0.849558 -0.849561 v -0.37931 -0.37879 h -0.378273 -0.377237 v -0.3793 -0.37931 H 90.93161 90.553856 v -0.3793 -0.37879 h -0.377753 -0.377757 v -0.37931 -0.3793 h -0.377753 -0.377238 v -0.37879 -0.3793 h -0.377756 -0.377754 v -0.37931 -0.37931 h -0.377756 -0.377753 v -0.66352 -0.66352 h 0.377753 0.377756 v -0.37931 -0.37879 h 0.377754 0.377756 v -0.3793 -0.37931 h 0.377238 0.377753 v -0.3793 -0.37879 h 0.377757 0.377753 v -0.37931 -0.3793 h 0.377754 0.377756 v -0.37879 -0.3793 h 0.377237 0.378273 v -0.37931 z m 24.171134,0 h 0.85008 0.84956 v 0.37931 0.37931 h 0.37775 0.37776 v 0.3793 0.37879 h 0.37775 0.37724 v 0.3793 0.37931 h 0.37775 0.37776 v 0.37879 0.3793 h 0.37775 0.37776 v 0.37931 0.3793 h 0.37775 0.37724 v 0.37879 0.37931 h 0.37827 0.37724 v 0.66352 0.66352 h -0.37724 -0.37827 v 0.37931 0.37931 h -0.37724 -0.37775 v 0.3793 0.37879 h -0.37776 -0.37775 v 0.3793 0.37931 h -0.37776 -0.37775 v 0.37879 0.3793 h -0.37724 -0.37775 v 0.37931 0.3793 h -0.37776 -0.37775 v 0.37879 0.37931 h -0.84956 -0.85008 v -0.37931 -0.37879 h -0.37776 -0.37775 v -0.3793 -0.37931 h -0.37724 -0.37775 v -0.3793 -0.37879 H 114.34775 113.97 v -0.37931 -0.3793 h -0.37776 -0.37775 v -0.37879 -0.3793 h -0.37776 -0.37723 v -0.37931 -0.37931 h -0.37776 -0.37775 v -0.66352 -0.66352 h 0.37775 0.37776 v -0.37931 -0.37879 h 0.37723 0.37776 v -0.3793 -0.37931 h 0.37775 0.37776 v -0.3793 -0.37879 h 0.37775 0.37776 v -0.37931 -0.3793 h 0.37775 0.37724 v -0.37879 -0.3793 h 0.37775 0.37776 v -0.37931 z m 23.98303,0 h 0.84956 0.84956 v 0.37931 0.37931 h 0.37776 0.37775 v 0.3793 0.37879 h 0.37776 0.37775 v 0.3793 0.37931 h 0.37724 0.37827 v 0.37879 0.3793 h 0.37724 0.37775 v 0.37931 0.3793 h 0.37776 0.37775 v 0.37879 0.37931 h 0.37724 0.37827 v 0.66352 0.66352 h -0.37827 -0.37724 v 0.37931 0.37931 h -0.37775 -0.37776 v 0.3793 0.37879 h -0.37775 -0.37724 v 0.3793 0.37931 h -0.37827 -0.37724 v 0.37879 0.3793 h -0.37775 -0.37776 v 0.37931 0.3793 h -0.37775 -0.37776 v 0.37879 0.37931 h -0.84956 -0.84956 v -0.37931 -0.37879 h -0.37827 -0.37724 v -0.3793 -0.37931 h -0.37775 -0.37776 v -0.3793 -0.37879 h -0.37775 -0.37776 v -0.37931 -0.3793 h -0.37775 -0.37724 v -0.37879 -0.3793 h -0.37776 -0.37775 v -0.37931 -0.37931 h -0.37775 -0.37776 v -0.66352 -0.66352 h 0.37776 0.37775 v -0.37931 -0.37879 h 0.37775 0.37776 v -0.3793 -0.37931 h 0.37724 0.37775 v -0.3793 -0.37879 h 0.37776 0.37775 v -0.37931 -0.3793 h 0.37776 0.37775 v -0.37879 -0.3793 h 0.37724 0.37827 v -0.37931 z m -60.051114,6.06682 h 0.754994 0.755509 v 0.3793 0.37931 h 0.377754 0.377756 v 0.37879 0.3793 h 0.377238 0.377753 v 0.3793 0.37931 h 0.377757 0.377753 v 0.37879 0.3793 h 0.377756 0.377754 v 0.37931 0.3793 h 0.377753 0.377241 v 0.37879 0.37931 h 0.377753 0.377754 v 0.66352 0.66353 h -0.377754 -0.377753 v 0.3793 0.37879 H 85.077703 84.69995 v 0.37931 0.3793 H 84.322196 83.94444 v 0.37931 0.37878 H 83.566687 83.18893 v 0.37931 0.3793 h -0.377753 -0.377238 v 0.37931 0.37879 h -0.377756 -0.377754 v 0.3793 0.37931 H 80.92292 80.167926 v -0.37931 -0.3793 h -0.37827 -0.37724 v -0.37879 -0.37931 h -0.377753 -0.377754 v -0.3793 -0.37931 h -0.377756 -0.377238 v -0.37878 -0.37931 h -0.378272 -0.377238 v -0.3793 -0.37931 h -0.377753 -0.377756 v -0.37879 -0.3793 h -0.377754 -0.377756 v -0.66353 -0.66352 h 0.377756 0.377754 v -0.37931 -0.37879 h 0.377756 0.377753 v -0.3793 -0.37931 h 0.377238 0.378272 v -0.3793 -0.37879 h 0.377238 0.377756 v -0.37931 -0.3793 h 0.377754 0.377753 v -0.3793 -0.37879 h 0.37724 0.37827 v -0.37931 z m 23.982514,0 H 105 h 0.84956 v 0.3793 0.37931 h 0.37827 0.37724 v 0.37879 0.3793 h 0.37776 0.37775 v 0.3793 0.37931 h 0.37776 0.37775 v 0.37879 0.3793 h 0.37776 0.37723 v 0.37931 0.3793 h 0.37776 0.37775 v 0.37879 0.37931 h 0.37776 0.37775 v 0.66352 0.66353 h -0.37775 -0.37776 v 0.3793 0.37879 h -0.37775 -0.37776 v 0.37931 0.3793 h -0.37723 -0.37776 v 0.37931 0.37878 h -0.37775 -0.37776 v 0.37931 0.3793 h -0.37775 -0.37776 v 0.37931 0.37879 h -0.37724 -0.37827 v 0.3793 0.37931 H 105 104.15044 v -0.37931 -0.3793 h -0.37775 -0.37776 v -0.37879 -0.37931 h -0.37775 -0.37776 v -0.3793 -0.37931 h -0.37724 -0.37827 v -0.37878 -0.37931 h -0.37724 -0.37775 v -0.3793 -0.37931 h -0.37775 -0.37776 v -0.37879 -0.3793 h -0.377236 -0.378272 v -0.66353 -0.66352 h 0.378272 0.377236 v -0.37931 -0.37879 h 0.37776 0.37775 v -0.3793 -0.37931 h 0.37775 0.37724 v -0.3793 -0.37879 h 0.37827 0.37724 v -0.37931 -0.3793 h 0.37776 0.37775 v -0.3793 -0.37879 h 0.37776 0.37775 v -0.37931 z m 24.17165,0 h 0.755 0.75551 v 0.3793 0.37931 h 0.37775 0.37776 v 0.37879 0.3793 h 0.37723 0.37776 v 0.3793 0.37931 h 0.37775 0.37776 v 0.37879 0.3793 h 0.37775 0.37776 v 0.37931 0.3793 h 0.37775 0.37724 v 0.37879 0.37931 h 0.37775 0.37776 v 0.66352 0.66353 h -0.37776 -0.37775 v 0.3793 0.37879 h -0.37724 -0.37775 v 0.37931 0.3793 h -0.37776 -0.37775 v 0.37931 0.37878 h -0.37776 -0.37775 v 0.37931 0.3793 h -0.37776 -0.37723 v 0.37931 0.37879 h -0.37776 -0.37775 v 0.3793 0.37931 h -0.75551 -0.755 v -0.37931 -0.3793 h -0.37827 -0.37724 v -0.37879 -0.37931 h -0.37775 -0.37775 v -0.3793 -0.37931 h -0.37776 -0.37724 v -0.37878 -0.37931 h -0.37827 -0.37724 v -0.3793 -0.37931 h -0.37775 -0.37776 v -0.37879 -0.3793 h -0.37775 -0.37776 v -0.66353 -0.66352 h 0.37776 0.37775 v -0.37931 -0.37879 h 0.37776 0.37775 v -0.3793 -0.37931 h 0.37724 0.37827 v -0.3793 -0.37879 h 0.37724 0.37776 v -0.37931 -0.3793 h 0.37775 0.37775 v -0.3793 -0.37879 h 0.37724 0.37827 v -0.37931 z m -60.240246,6.06681 h 0.850077 0.849559 v 0.37931 0.3793 h 0.377756 0.377753 v 0.37879 0.3793 h 0.377757 0.377237 v 0.37931 0.37879 h 0.377754 0.377756 v 0.3793 0.37931 h 0.377754 0.377756 v 0.37879 0.3793 h 0.377753 0.377238 v 0.37931 0.3793 h 0.378272 0.377238 v 0.66352 0.66353 h -0.377238 -0.378272 v 0.37931 0.37878 h -0.377238 -0.377753 v 0.37931 0.37931 h -0.377756 -0.377754 v 0.3793 0.37879 h -0.377756 -0.377754 v 0.3793 0.37931 h -0.377237 -0.377757 v 0.37879 0.3793 H 70.159236 69.78148 v 0.37931 0.3793 h -0.849559 -0.850077 v -0.3793 -0.37931 h -0.377756 -0.377754 v -0.3793 -0.37879 H 66.949097 66.57134 v -0.37931 -0.3793 h -0.377753 -0.377756 v -0.37879 -0.3793 h -0.377754 -0.377756 v -0.37931 -0.37931 H 64.682567 64.30533 v -0.37878 -0.37931 H 63.927574 63.54982 v -0.66353 -0.66352 h 0.377754 0.377756 v -0.3793 -0.37931 h 0.377237 0.377754 v -0.3793 -0.37879 h 0.377756 0.377754 v -0.37931 -0.3793 h 0.377756 0.377753 v -0.37879 -0.37931 h 0.377757 0.377237 v -0.3793 -0.37879 h 0.377754 0.377756 v -0.3793 z m 23.983032,0 h 0.849561 0.849558 v 0.37931 0.3793 h 0.377757 0.377753 v 0.37879 0.3793 h 0.377756 0.377754 v 0.37931 0.37879 h 0.377237 0.378273 v 0.3793 0.37931 h 0.377237 0.377754 v 0.37879 0.3793 h 0.377756 0.377754 v 0.37931 0.3793 h 0.377237 0.378272 v 0.66352 0.66353 h -0.378272 -0.377237 v 0.37931 0.37878 h -0.377754 -0.377756 v 0.37931 0.37931 h -0.377754 -0.377237 v 0.3793 0.37879 h -0.378273 -0.377237 v 0.3793 0.37931 h -0.377754 -0.377756 v 0.37879 0.3793 h -0.377753 -0.377757 v 0.37931 0.3793 h -0.849558 -0.849561 v -0.3793 -0.37931 h -0.378273 -0.377237 v -0.3793 -0.37879 H 90.93161 90.553856 v -0.37931 -0.3793 h -0.377753 -0.377757 v -0.37879 -0.3793 h -0.377753 -0.377238 v -0.37931 -0.37931 h -0.377756 -0.377754 v -0.37878 -0.37931 h -0.377756 -0.377753 v -0.66353 -0.66352 h 0.377753 0.377756 v -0.3793 -0.37931 h 0.377754 0.377756 v -0.3793 -0.37879 h 0.377238 0.377753 v -0.37931 -0.3793 h 0.377757 0.377753 v -0.37879 -0.37931 h 0.377754 0.377756 v -0.3793 -0.37879 h 0.377237 0.378273 v -0.3793 z m 24.171134,0 h 0.85008 0.84956 v 0.37931 0.3793 h 0.37775 0.37776 v 0.37879 0.3793 h 0.37775 0.37724 v 0.37931 0.37879 h 0.37775 0.37776 v 0.3793 0.37931 h 0.37775 0.37776 v 0.37879 0.3793 h 0.37775 0.37724 v 0.37931 0.3793 h 0.37827 0.37724 v 0.66352 0.66353 h -0.37724 -0.37827 v 0.37931 0.37878 h -0.37724 -0.37775 v 0.37931 0.37931 h -0.37776 -0.37775 v 0.3793 0.37879 h -0.37776 -0.37775 v 0.3793 0.37931 h -0.37724 -0.37775 v 0.37879 0.3793 h -0.37776 -0.37775 v 0.37931 0.3793 h -0.84956 -0.85008 v -0.3793 -0.37931 h -0.37776 -0.37775 v -0.3793 -0.37879 h -0.37724 -0.37775 v -0.37931 -0.3793 H 114.34775 113.97 v -0.37879 -0.3793 h -0.37776 -0.37775 v -0.37931 -0.37931 h -0.37776 -0.37723 v -0.37878 -0.37931 h -0.37776 -0.37775 v -0.66353 -0.66352 h 0.37775 0.37776 v -0.3793 -0.37931 h 0.37723 0.37776 v -0.3793 -0.37879 h 0.37775 0.37776 v -0.37931 -0.3793 h 0.37775 0.37776 v -0.37879 -0.37931 h 0.37775 0.37724 v -0.3793 -0.37879 h 0.37775 0.37776 v -0.3793 z m 23.98303,0 h 0.84956 0.84956 v 0.37931 0.3793 h 0.37776 0.37775 v 0.37879 0.3793 h 0.37776 0.37775 v 0.37931 0.37879 h 0.37724 0.37827 v 0.3793 0.37931 h 0.37724 0.37775 v 0.37879 0.3793 h 0.37776 0.37775 v 0.37931 0.3793 h 0.37724 0.37827 v 0.66352 0.66353 h -0.37827 -0.37724 v 0.37931 0.37878 h -0.37775 -0.37776 v 0.37931 0.37931 h -0.37775 -0.37724 v 0.3793 0.37879 h -0.37827 -0.37724 v 0.3793 0.37931 h -0.37775 -0.37776 v 0.37879 0.3793 h -0.37775 -0.37776 v 0.37931 0.3793 h -0.84956 -0.84956 v -0.3793 -0.37931 h -0.37827 -0.37724 v -0.3793 -0.37879 h -0.37775 -0.37776 v -0.37931 -0.3793 h -0.37775 -0.37776 v -0.37879 -0.3793 h -0.37775 -0.37724 v -0.37931 -0.37931 h -0.37776 -0.37775 v -0.37878 -0.37931 h -0.37775 -0.37776 v -0.66353 -0.66352 h 0.37776 0.37775 v -0.3793 -0.37931 h 0.37775 0.37776 v -0.3793 -0.37879 h 0.37724 0.37775 v -0.37931 -0.3793 h 0.37776 0.37775 v -0.37879 -0.37931 h 0.37776 0.37775 v -0.3793 -0.37879 h 0.37724 0.37827 v -0.3793 z m -60.051114,6.0663 h 0.754994 0.755509 v 0.3793 0.37931 h 0.377754 0.377756 v 0.3793 0.37879 h 0.377238 0.377753 v 0.3793 0.37931 h 0.377757 0.377753 v 0.3793 0.37879 h 0.377756 0.377754 v 0.37931 0.3793 h 0.377753 0.377241 v 0.37931 0.37879 h 0.377753 0.377754 v 0.56896 0.56895 h -0.377754 -0.377753 v 0.37879 0.3793 H 85.077703 84.69995 v 0.37931 0.37931 H 84.322196 83.94444 v 0.37878 0.37931 H 83.566687 83.18893 v 0.3793 0.37931 h -0.377753 -0.377238 v 0.37879 0.3793 h -0.377756 -0.377754 v 0.37931 0.3793 H 80.92292 80.167926 v -0.3793 -0.37931 h -0.37827 -0.37724 v -0.3793 -0.37879 h -0.377753 -0.377754 v -0.37931 -0.3793 h -0.377756 -0.377238 v -0.37931 -0.37878 h -0.378272 -0.377238 v -0.37931 -0.37931 h -0.377753 -0.377756 v -0.3793 -0.37879 H 76.013142 75.635386 V 148.5 147.93104 h 0.377756 0.377754 v -0.37879 -0.37931 h 0.377756 0.377753 v -0.3793 -0.37931 h 0.377238 0.378272 v -0.37879 -0.3793 h 0.377238 0.377756 v -0.37931 -0.3793 h 0.377754 0.377753 v -0.37879 -0.3793 h 0.37724 0.37827 v -0.37931 z m 23.982514,0 H 105 h 0.84956 v 0.3793 0.37931 h 0.37827 0.37724 v 0.3793 0.37879 h 0.37776 0.37775 v 0.3793 0.37931 h 0.37776 0.37775 v 0.3793 0.37879 h 0.37776 0.37723 v 0.37931 0.3793 h 0.37776 0.37775 v 0.37931 0.37879 h 0.37776 0.37775 v 0.56896 0.56895 h -0.37775 -0.37776 v 0.37879 0.3793 h -0.37775 -0.37776 v 0.37931 0.37931 h -0.37723 -0.37776 v 0.37878 0.37931 h -0.37775 -0.37776 v 0.3793 0.37931 h -0.37775 -0.37776 v 0.37879 0.3793 h -0.37724 -0.37827 v 0.37931 0.3793 H 105 104.15044 v -0.3793 -0.37931 h -0.37775 -0.37776 v -0.3793 -0.37879 h -0.37775 -0.37776 v -0.37931 -0.3793 h -0.37724 -0.37827 v -0.37931 -0.37878 h -0.37724 -0.37775 v -0.37931 -0.37931 h -0.37775 -0.37776 v -0.3793 -0.37879 H 99.996174 99.617902 V 148.5 147.93104 h 0.378272 0.377236 v -0.37879 -0.37931 h 0.37776 0.37775 v -0.3793 -0.37931 h 0.37775 0.37724 v -0.37879 -0.3793 h 0.37827 0.37724 v -0.37931 -0.3793 h 0.37776 0.37775 v -0.37879 -0.3793 h 0.37776 0.37775 v -0.37931 z m 24.17165,0 h 0.755 0.75551 v 0.3793 0.37931 h 0.37775 0.37776 v 0.3793 0.37879 h 0.37723 0.37776 v 0.3793 0.37931 h 0.37775 0.37776 v 0.3793 0.37879 h 0.37775 0.37776 v 0.37931 0.3793 h 0.37775 0.37724 v 0.37931 0.37879 h 0.37775 0.37776 v 0.56896 0.56895 h -0.37776 -0.37775 v 0.37879 0.3793 h -0.37724 -0.37775 v 0.37931 0.37931 h -0.37776 -0.37775 v 0.37878 0.37931 h -0.37776 -0.37775 v 0.3793 0.37931 h -0.37776 -0.37723 v 0.37879 0.3793 h -0.37776 -0.37775 v 0.37931 0.3793 h -0.75551 -0.755 v -0.3793 -0.37931 h -0.37827 -0.37724 v -0.3793 -0.37879 h -0.37775 -0.37775 v -0.37931 -0.3793 h -0.37776 -0.37724 v -0.37931 -0.37878 h -0.37827 -0.37724 v -0.37931 -0.37931 h -0.37775 -0.37776 v -0.3793 -0.37879 h -0.37775 -0.37776 V 148.5 147.93104 h 0.37776 0.37775 v -0.37879 -0.37931 h 0.37776 0.37775 v -0.3793 -0.37931 h 0.37724 0.37827 v -0.37879 -0.3793 h 0.37724 0.37776 v -0.37931 -0.3793 h 0.37775 0.37775 v -0.37879 -0.3793 h 0.37724 0.37827 v -0.37931 z m -60.240246,5.87716 h 0.850077 0.849559 v 0.3793 0.37931 h 0.377756 0.377753 v 0.3793 0.37879 h 0.377757 0.377237 v 0.37931 0.3793 h 0.377754 0.377756 v 0.37879 0.3793 h 0.377754 0.377756 v 0.37931 0.3793 h 0.377753 0.377238 v 0.37879 0.37931 h 0.378272 0.377238 v 0.66352 0.66353 h -0.377238 -0.378272 v 0.3793 0.37931 h -0.377238 -0.377753 v 0.3793 0.37879 h -0.377756 -0.377754 v 0.37931 0.3793 h -0.377756 -0.377754 v 0.37879 0.3793 h -0.377237 -0.377757 v 0.37931 0.3793 H 70.159236 69.78148 v 0.37879 0.37931 h -0.849559 -0.850077 v -0.37931 -0.37879 h -0.377756 -0.377754 v -0.3793 -0.37931 H 66.949097 66.57134 v -0.3793 -0.37879 h -0.377753 -0.377756 v -0.3793 -0.37931 h -0.377754 -0.377756 v -0.37879 -0.3793 H 64.682567 64.30533 v -0.37931 -0.3793 H 63.927574 63.54982 v -0.66353 -0.66352 h 0.377754 0.377756 v -0.37931 -0.37879 h 0.377237 0.377754 v -0.3793 -0.37931 h 0.377756 0.377754 v -0.3793 -0.37879 h 0.377756 0.377753 v -0.3793 -0.37931 h 0.377757 0.377237 v -0.37879 -0.3793 h 0.377754 0.377756 v -0.37931 z m 23.983032,0 h 0.849561 0.849558 v 0.3793 0.37931 h 0.377757 0.377753 v 0.3793 0.37879 h 0.377756 0.377754 v 0.37931 0.3793 h 0.377237 0.378273 v 0.37879 0.3793 h 0.377237 0.377754 v 0.37931 0.3793 h 0.377756 0.377754 v 0.37879 0.37931 h 0.377237 0.378272 v 0.66352 0.66353 h -0.378272 -0.377237 v 0.3793 0.37931 h -0.377754 -0.377756 v 0.3793 0.37879 h -0.377754 -0.377237 v 0.37931 0.3793 h -0.378273 -0.377237 v 0.37879 0.3793 h -0.377754 -0.377756 v 0.37931 0.3793 h -0.377753 -0.377757 v 0.37879 0.37931 h -0.849558 -0.849561 v -0.37931 -0.37879 h -0.378273 -0.377237 v -0.3793 -0.37931 H 90.93161 90.553856 v -0.3793 -0.37879 h -0.377753 -0.377757 v -0.3793 -0.37931 h -0.377753 -0.377238 v -0.37879 -0.3793 h -0.377756 -0.377754 v -0.37931 -0.3793 h -0.377756 -0.377753 v -0.66353 -0.66352 h 0.377753 0.377756 v -0.37931 -0.37879 h 0.377754 0.377756 v -0.3793 -0.37931 h 0.377238 0.377753 v -0.3793 -0.37879 h 0.377757 0.377753 v -0.3793 -0.37931 h 0.377754 0.377756 v -0.37879 -0.3793 h 0.377237 0.378273 v -0.37931 z m 24.171134,0 h 0.85008 0.84956 v 0.3793 0.37931 h 0.37775 0.37776 v 0.3793 0.37879 h 0.37775 0.37724 v 0.37931 0.3793 h 0.37775 0.37776 v 0.37879 0.3793 h 0.37775 0.37776 v 0.37931 0.3793 h 0.37775 0.37724 v 0.37879 0.37931 h 0.37827 0.37724 v 0.66352 0.66353 h -0.37724 -0.37827 v 0.3793 0.37931 h -0.37724 -0.37775 v 0.3793 0.37879 h -0.37776 -0.37775 v 0.37931 0.3793 h -0.37776 -0.37775 v 0.37879 0.3793 h -0.37724 -0.37775 v 0.37931 0.3793 h -0.37776 -0.37775 v 0.37879 0.37931 h -0.84956 -0.85008 v -0.37931 -0.37879 h -0.37776 -0.37775 v -0.3793 -0.37931 h -0.37724 -0.37775 v -0.3793 -0.37879 H 114.34775 113.97 v -0.3793 -0.37931 h -0.37776 -0.37775 v -0.37879 -0.3793 h -0.37776 -0.37723 v -0.37931 -0.3793 h -0.37776 -0.37775 v -0.66353 -0.66352 h 0.37775 0.37776 v -0.37931 -0.37879 h 0.37723 0.37776 v -0.3793 -0.37931 h 0.37775 0.37776 v -0.3793 -0.37879 h 0.37775 0.37776 v -0.3793 -0.37931 h 0.37775 0.37724 v -0.37879 -0.3793 h 0.37775 0.37776 v -0.37931 z m 23.98303,0 h 0.84956 0.84956 v 0.3793 0.37931 h 0.37776 0.37775 v 0.3793 0.37879 h 0.37776 0.37775 v 0.37931 0.3793 h 0.37724 0.37827 v 0.37879 0.3793 h 0.37724 0.37775 v 0.37931 0.3793 h 0.37776 0.37775 v 0.37879 0.37931 h 0.37724 0.37827 v 0.66352 0.66353 h -0.37827 -0.37724 v 0.3793 0.37931 h -0.37775 -0.37776 v 0.3793 0.37879 h -0.37775 -0.37724 v 0.37931 0.3793 h -0.37827 -0.37724 v 0.37879 0.3793 h -0.37775 -0.37776 v 0.37931 0.3793 h -0.37775 -0.37776 v 0.37879 0.37931 h -0.84956 -0.84956 v -0.37931 -0.37879 h -0.37827 -0.37724 v -0.3793 -0.37931 h -0.37775 -0.37776 v -0.3793 -0.37879 h -0.37775 -0.37776 v -0.3793 -0.37931 h -0.37775 -0.37724 v -0.37879 -0.3793 h -0.37776 -0.37775 v -0.37931 -0.3793 h -0.37775 -0.37776 v -0.66353 -0.66352 h 0.37776 0.37775 v -0.37931 -0.37879 h 0.37775 0.37776 v -0.3793 -0.37931 h 0.37724 0.37775 v -0.3793 -0.37879 h 0.37776 0.37775 v -0.3793 -0.37931 h 0.37776 0.37775 v -0.37879 -0.3793 h 0.37724 0.37827 v -0.37931 z m -60.051114,6.06681 h 0.754994 0.755509 v 0.37931 0.3793 h 0.377754 0.377756 v 0.37879 0.3793 h 0.377238 0.377753 v 0.37931 0.3793 h 0.377757 0.377753 v 0.37879 0.37931 h 0.377756 0.377754 v 0.3793 0.37931 h 0.377753 0.377241 v 0.37879 0.3793 h 0.377753 0.377754 v 0.66353 0.66352 h -0.377754 -0.377753 v 0.37931 0.37878 H 85.077703 84.69995 v 0.37931 0.3793 H 84.322196 83.94444 v 0.37931 0.37879 H 83.566687 83.18893 v 0.3793 0.37931 h -0.377753 -0.377238 v 0.3793 0.37879 h -0.377756 -0.377754 v 0.37931 0.3793 H 80.92292 80.167926 v -0.3793 -0.37931 h -0.37827 -0.37724 v -0.37879 -0.3793 h -0.377753 -0.377754 v -0.37931 -0.3793 h -0.377756 -0.377238 v -0.37879 -0.37931 h -0.378272 -0.377238 v -0.3793 -0.37931 h -0.377753 -0.377756 v -0.37878 -0.37931 h -0.377754 -0.377756 v -0.66352 -0.66353 h 0.377756 0.377754 v -0.3793 -0.37879 h 0.377756 0.377753 v -0.37931 -0.3793 h 0.377238 0.378272 v -0.37931 -0.37879 h 0.377238 0.377756 v -0.3793 -0.37931 h 0.377754 0.377753 v -0.3793 -0.37879 h 0.37724 0.37827 v -0.3793 z m 23.982514,0 H 105 h 0.84956 v 0.37931 0.3793 h 0.37827 0.37724 v 0.37879 0.3793 h 0.37776 0.37775 v 0.37931 0.3793 h 0.37776 0.37775 v 0.37879 0.37931 h 0.37776 0.37723 v 0.3793 0.37931 h 0.37776 0.37775 v 0.37879 0.3793 h 0.37776 0.37775 v 0.66353 0.66352 h -0.37775 -0.37776 v 0.37931 0.37878 h -0.37775 -0.37776 v 0.37931 0.3793 h -0.37723 -0.37776 v 0.37931 0.37879 h -0.37775 -0.37776 v 0.3793 0.37931 h -0.37775 -0.37776 v 0.3793 0.37879 h -0.37724 -0.37827 v 0.37931 0.3793 H 105 104.15044 v -0.3793 -0.37931 h -0.37775 -0.37776 v -0.37879 -0.3793 h -0.37775 -0.37776 v -0.37931 -0.3793 h -0.37724 -0.37827 v -0.37879 -0.37931 h -0.37724 -0.37775 v -0.3793 -0.37931 h -0.37775 -0.37776 v -0.37878 -0.37931 h -0.377236 -0.378272 v -0.66352 -0.66353 h 0.378272 0.377236 v -0.3793 -0.37879 h 0.37776 0.37775 v -0.37931 -0.3793 h 0.37775 0.37724 v -0.37931 -0.37879 h 0.37827 0.37724 v -0.3793 -0.37931 h 0.37776 0.37775 v -0.3793 -0.37879 h 0.37776 0.37775 v -0.3793 z m 24.17165,0 h 0.755 0.75551 v 0.37931 0.3793 h 0.37775 0.37776 v 0.37879 0.3793 h 0.37723 0.37776 v 0.37931 0.3793 h 0.37775 0.37776 v 0.37879 0.37931 h 0.37775 0.37776 v 0.3793 0.37931 h 0.37775 0.37724 v 0.37879 0.3793 h 0.37775 0.37776 v 0.66353 0.66352 h -0.37776 -0.37775 v 0.37931 0.37878 h -0.37724 -0.37775 v 0.37931 0.3793 h -0.37776 -0.37775 v 0.37931 0.37879 h -0.37776 -0.37775 v 0.3793 0.37931 h -0.37776 -0.37723 v 0.3793 0.37879 h -0.37776 -0.37775 v 0.37931 0.3793 h -0.75551 -0.755 v -0.3793 -0.37931 h -0.37827 -0.37724 v -0.37879 -0.3793 h -0.37775 -0.37775 v -0.37931 -0.3793 h -0.37776 -0.37724 v -0.37879 -0.37931 h -0.37827 -0.37724 v -0.3793 -0.37931 h -0.37775 -0.37776 v -0.37878 -0.37931 h -0.37775 -0.37776 v -0.66352 -0.66353 h 0.37776 0.37775 v -0.3793 -0.37879 h 0.37776 0.37775 v -0.37931 -0.3793 h 0.37724 0.37827 v -0.37931 -0.37879 h 0.37724 0.37776 v -0.3793 -0.37931 h 0.37775 0.37775 v -0.3793 -0.37879 h 0.37724 0.37827 v -0.3793 z m -60.240246,6.06681 h 0.850077 0.849559 v 0.37931 0.3793 h 0.377756 0.377753 v 0.37879 0.37931 h 0.377757 0.377237 v 0.3793 0.37879 h 0.377754 0.377756 v 0.3793 0.37931 h 0.377754 0.377756 v 0.37879 0.3793 h 0.377753 0.377238 v 0.37931 0.3793 h 0.378272 0.377238 v 0.66353 0.66353 h -0.377238 -0.378272 v 0.3793 0.3793 h -0.377238 -0.377753 v 0.37879 0.37931 h -0.377756 -0.377754 v 0.3793 0.37879 h -0.377756 -0.377754 v 0.37931 0.3793 h -0.377237 -0.377757 v 0.37879 0.3793 H 70.159236 69.78148 v 0.37931 0.3793 h -0.849559 -0.850077 v -0.3793 -0.37931 h -0.377756 -0.377754 v -0.3793 -0.37879 H 66.949097 66.57134 v -0.3793 -0.37931 h -0.377753 -0.377756 v -0.37879 -0.3793 h -0.377754 -0.377756 v -0.37931 -0.37879 H 64.682567 64.30533 v -0.3793 -0.3793 H 63.927574 63.54982 v -0.66353 -0.66353 h 0.377754 0.377756 v -0.3793 -0.37931 h 0.377237 0.377754 v -0.3793 -0.37879 h 0.377756 0.377754 v -0.37931 -0.3793 h 0.377756 0.377753 v -0.37879 -0.3793 h 0.377757 0.377237 v -0.37931 -0.37879 h 0.377754 0.377756 v -0.3793 z m 23.983032,0 h 0.849561 0.849558 v 0.37931 0.3793 h 0.377757 0.377753 v 0.37879 0.37931 h 0.377756 0.377754 v 0.3793 0.37879 h 0.377237 0.378273 v 0.3793 0.37931 h 0.377237 0.377754 v 0.37879 0.3793 h 0.377756 0.377754 v 0.37931 0.3793 h 0.377237 0.378272 v 0.66353 0.66353 h -0.378272 -0.377237 v 0.3793 0.3793 h -0.377754 -0.377756 v 0.37879 0.37931 h -0.377754 -0.377237 v 0.3793 0.37879 h -0.378273 -0.377237 v 0.37931 0.3793 h -0.377754 -0.377756 v 0.37879 0.3793 h -0.377753 -0.377757 v 0.37931 0.3793 h -0.849558 -0.849561 v -0.3793 -0.37931 h -0.378273 -0.377237 v -0.3793 -0.37879 H 90.93161 90.553856 v -0.3793 -0.37931 h -0.377753 -0.377757 v -0.37879 -0.3793 h -0.377753 -0.377238 v -0.37931 -0.37879 h -0.377756 -0.377754 v -0.3793 -0.3793 h -0.377756 -0.377753 v -0.66353 -0.66353 h 0.377753 0.377756 v -0.3793 -0.37931 h 0.377754 0.377756 v -0.3793 -0.37879 h 0.377238 0.377753 v -0.37931 -0.3793 h 0.377757 0.377753 v -0.37879 -0.3793 h 0.377754 0.377756 v -0.37931 -0.37879 h 0.377237 0.378273 v -0.3793 z m 24.171134,0 h 0.85008 0.84956 v 0.37931 0.3793 h 0.37775 0.37776 v 0.37879 0.37931 h 0.37775 0.37724 v 0.3793 0.37879 h 0.37775 0.37776 v 0.3793 0.37931 h 0.37775 0.37776 v 0.37879 0.3793 h 0.37775 0.37724 v 0.37931 0.3793 h 0.37827 0.37724 v 0.66353 0.66353 h -0.37724 -0.37827 v 0.3793 0.3793 h -0.37724 -0.37775 v 0.37879 0.37931 h -0.37776 -0.37775 v 0.3793 0.37879 h -0.37776 -0.37775 v 0.37931 0.3793 h -0.37724 -0.37775 v 0.37879 0.3793 h -0.37776 -0.37775 v 0.37931 0.3793 h -0.84956 -0.85008 v -0.3793 -0.37931 h -0.37776 -0.37775 v -0.3793 -0.37879 h -0.37724 -0.37775 v -0.3793 -0.37931 H 114.34775 113.97 v -0.37879 -0.3793 h -0.37776 -0.37775 v -0.37931 -0.37879 h -0.37776 -0.37723 v -0.3793 -0.3793 h -0.37776 -0.37775 v -0.66353 -0.66353 h 0.37775 0.37776 v -0.3793 -0.37931 h 0.37723 0.37776 v -0.3793 -0.37879 h 0.37775 0.37776 v -0.37931 -0.3793 h 0.37775 0.37776 v -0.37879 -0.3793 h 0.37775 0.37724 v -0.37931 -0.37879 h 0.37775 0.37776 v -0.3793 z m 23.98303,0 h 0.84956 0.84956 v 0.37931 0.3793 h 0.37776 0.37775 v 0.37879 0.37931 h 0.37776 0.37775 v 0.3793 0.37879 h 0.37724 0.37827 v 0.3793 0.37931 h 0.37724 0.37775 v 0.37879 0.3793 h 0.37776 0.37775 v 0.37931 0.3793 h 0.37724 0.37827 v 0.66353 0.66353 h -0.37827 -0.37724 v 0.3793 0.3793 h -0.37775 -0.37776 v 0.37879 0.37931 h -0.37775 -0.37724 v 0.3793 0.37879 h -0.37827 -0.37724 v 0.37931 0.3793 h -0.37775 -0.37776 v 0.37879 0.3793 h -0.37775 -0.37776 v 0.37931 0.3793 h -0.84956 -0.84956 v -0.3793 -0.37931 h -0.37827 -0.37724 v -0.3793 -0.37879 h -0.37775 -0.37776 v -0.3793 -0.37931 h -0.37775 -0.37776 v -0.37879 -0.3793 h -0.37775 -0.37724 v -0.37931 -0.37879 h -0.37776 -0.37775 v -0.3793 -0.3793 h -0.37775 -0.37776 v -0.66353 -0.66353 h 0.37776 0.37775 v -0.3793 -0.37931 h 0.37775 0.37776 v -0.3793 -0.37879 h 0.37724 0.37775 v -0.37931 -0.3793 h 0.37776 0.37775 v -0.37879 -0.3793 h 0.37776 0.37775 v -0.37931 -0.37879 h 0.37724 0.37827 v -0.3793 z m -60.051114,6.0663 h 0.754994 0.755509 v 0.3793 0.37931 h 0.377754 0.377756 v 0.3793 0.37879 h 0.377238 0.377753 v 0.37931 0.3793 h 0.377757 0.377753 v 0.37931 0.37879 h 0.377756 0.377754 v 0.3793 0.37931 h 0.377753 0.377241 v 0.3793 0.37879 h 0.377753 0.377754 v 0.56896 0.56896 h -0.377754 -0.377753 v 0.37878 0.37931 H 85.077703 84.69995 v 0.3793 0.37931 H 84.322196 83.94444 v 0.37879 0.3793 H 83.566687 83.18893 v 0.37931 0.3793 h -0.377753 -0.377238 v 0.37879 0.3793 h -0.377756 -0.377754 v 0.37931 0.3793 H 80.92292 80.167926 v -0.3793 -0.37931 h -0.37827 -0.37724 v -0.3793 -0.37879 h -0.377753 -0.377754 v -0.3793 -0.37931 h -0.377756 -0.377238 v -0.3793 -0.37879 h -0.378272 -0.377238 v -0.37931 -0.3793 h -0.377753 -0.377756 v -0.37931 -0.37878 h -0.377754 -0.377756 v -0.56896 -0.56896 h 0.377756 0.377754 v -0.37879 -0.3793 h 0.377756 0.377753 v -0.37931 -0.3793 h 0.377238 0.378272 v -0.37879 -0.37931 h 0.377238 0.377756 v -0.3793 -0.37931 h 0.377754 0.377753 v -0.37879 -0.3793 h 0.37724 0.37827 v -0.37931 z m 23.982514,0 H 105 h 0.84956 v 0.3793 0.37931 h 0.37827 0.37724 v 0.3793 0.37879 h 0.37776 0.37775 v 0.37931 0.3793 h 0.37776 0.37775 v 0.37931 0.37879 h 0.37776 0.37723 v 0.3793 0.37931 h 0.37776 0.37775 v 0.3793 0.37879 h 0.37776 0.37775 v 0.56896 0.56896 h -0.37775 -0.37776 v 0.37878 0.37931 h -0.37775 -0.37776 v 0.3793 0.37931 h -0.37723 -0.37776 v 0.37879 0.3793 h -0.37775 -0.37776 v 0.37931 0.3793 h -0.37775 -0.37776 v 0.37879 0.3793 h -0.37724 -0.37827 v 0.37931 0.3793 H 105 104.15044 v -0.3793 -0.37931 h -0.37775 -0.37776 v -0.3793 -0.37879 h -0.37775 -0.37776 v -0.3793 -0.37931 h -0.37724 -0.37827 v -0.3793 -0.37879 h -0.37724 -0.37775 v -0.37931 -0.3793 h -0.37775 -0.37776 v -0.37931 -0.37878 h -0.377236 -0.378272 v -0.56896 -0.56896 h 0.378272 0.377236 v -0.37879 -0.3793 h 0.37776 0.37775 v -0.37931 -0.3793 h 0.37775 0.37724 v -0.37879 -0.37931 h 0.37827 0.37724 v -0.3793 -0.37931 h 0.37776 0.37775 v -0.37879 -0.3793 h 0.37776 0.37775 v -0.37931 z m 24.17165,0 h 0.755 0.75551 v 0.3793 0.37931 h 0.37775 0.37776 v 0.3793 0.37879 h 0.37723 0.37776 v 0.37931 0.3793 h 0.37775 0.37776 v 0.37931 0.37879 h 0.37775 0.37776 v 0.3793 0.37931 h 0.37775 0.37724 v 0.3793 0.37879 h 0.37775 0.37776 v 0.56896 0.56896 h -0.37776 -0.37775 v 0.37878 0.37931 h -0.37724 -0.37775 v 0.3793 0.37931 h -0.37776 -0.37775 v 0.37879 0.3793 h -0.37776 -0.37775 v 0.37931 0.3793 h -0.37776 -0.37723 v 0.37879 0.3793 h -0.37776 -0.37775 v 0.37931 0.3793 h -0.75551 -0.755 v -0.3793 -0.37931 h -0.37827 -0.37724 v -0.3793 -0.37879 h -0.37775 -0.37775 v -0.3793 -0.37931 h -0.37776 -0.37724 v -0.3793 -0.37879 h -0.37827 -0.37724 v -0.37931 -0.3793 h -0.37775 -0.37776 v -0.37931 -0.37878 h -0.37775 -0.37776 v -0.56896 -0.56896 h 0.37776 0.37775 v -0.37879 -0.3793 h 0.37776 0.37775 v -0.37931 -0.3793 h 0.37724 0.37827 v -0.37879 -0.37931 h 0.37724 0.37776 v -0.3793 -0.37931 h 0.37775 0.37775 v -0.37879 -0.3793 h 0.37724 0.37827 v -0.37931 z m -60.240246,5.87716 h 0.850077 0.849559 v 0.3793 0.37931 h 0.377756 0.377753 v 0.37931 0.37878 h 0.377757 0.377237 v 0.37931 0.3793 h 0.377754 0.377756 v 0.37879 0.37931 h 0.377754 0.377756 v 0.3793 0.37931 h 0.377753 0.377238 v 0.37878 0.37931 h 0.378272 0.377238 v 0.66353 0.66352 h -0.377238 -0.378272 v 0.3793 0.37931 h -0.377238 -0.377753 v 0.37931 0.37878 h -0.377756 -0.377754 v 0.37931 0.3793 h -0.377756 -0.377754 v 0.37879 0.37931 h -0.377237 -0.377757 v 0.3793 0.37931 H 70.159236 69.78148 v 0.37879 0.3793 h -0.849559 -0.850077 v -0.3793 -0.37879 h -0.377756 -0.377754 v -0.37931 -0.3793 H 66.949097 66.57134 v -0.37931 -0.37879 h -0.377753 -0.377756 v -0.3793 -0.37931 h -0.377754 -0.377756 v -0.37878 -0.37931 H 64.682567 64.30533 v -0.37931 -0.3793 H 63.927574 63.54982 v -0.66352 -0.66353 h 0.377754 0.377756 v -0.37931 -0.37878 h 0.377237 0.377754 v -0.37931 -0.3793 h 0.377756 0.377754 v -0.37931 -0.37879 h 0.377756 0.377753 v -0.3793 -0.37931 h 0.377757 0.377237 v -0.37878 -0.37931 h 0.377754 0.377756 v -0.37931 z m 23.983032,0 h 0.849561 0.849558 v 0.3793 0.37931 h 0.377757 0.377753 v 0.37931 0.37878 h 0.377756 0.377754 v 0.37931 0.3793 h 0.377237 0.378273 v 0.37879 0.37931 h 0.377237 0.377754 v 0.3793 0.37931 h 0.377756 0.377754 v 0.37878 0.37931 h 0.377237 0.378272 v 0.66353 0.66352 h -0.378272 -0.377237 v 0.3793 0.37931 h -0.377754 -0.377756 v 0.37931 0.37878 h -0.377754 -0.377237 v 0.37931 0.3793 h -0.378273 -0.377237 v 0.37879 0.37931 h -0.377754 -0.377756 v 0.3793 0.37931 h -0.377753 -0.377757 v 0.37879 0.3793 h -0.849558 -0.849561 v -0.3793 -0.37879 h -0.378273 -0.377237 v -0.37931 -0.3793 H 90.93161 90.553856 v -0.37931 -0.37879 h -0.377753 -0.377757 v -0.3793 -0.37931 h -0.377753 -0.377238 v -0.37878 -0.37931 h -0.377756 -0.377754 v -0.37931 -0.3793 h -0.377756 -0.377753 v -0.66352 -0.66353 h 0.377753 0.377756 v -0.37931 -0.37878 h 0.377754 0.377756 v -0.37931 -0.3793 h 0.377238 0.377753 v -0.37931 -0.37879 h 0.377757 0.377753 v -0.3793 -0.37931 h 0.377754 0.377756 v -0.37878 -0.37931 h 0.377237 0.378273 v -0.37931 z m 24.171134,0 h 0.85008 0.84956 v 0.3793 0.37931 h 0.37775 0.37776 v 0.37931 0.37878 h 0.37775 0.37724 v 0.37931 0.3793 h 0.37775 0.37776 v 0.37879 0.37931 h 0.37775 0.37776 v 0.3793 0.37931 h 0.37775 0.37724 v 0.37878 0.37931 h 0.37827 0.37724 v 0.66353 0.66352 h -0.37724 -0.37827 v 0.3793 0.37931 h -0.37724 -0.37775 v 0.37931 0.37878 h -0.37776 -0.37775 v 0.37931 0.3793 h -0.37776 -0.37775 v 0.37879 0.37931 h -0.37724 -0.37775 v 0.3793 0.37931 h -0.37776 -0.37775 v 0.37879 0.3793 h -0.84956 -0.85008 v -0.3793 -0.37879 h -0.37776 -0.37775 v -0.37931 -0.3793 h -0.37724 -0.37775 v -0.37931 -0.37879 H 114.34775 113.97 v -0.3793 -0.37931 h -0.37776 -0.37775 v -0.37878 -0.37931 h -0.37776 -0.37723 v -0.37931 -0.3793 h -0.37776 -0.37775 v -0.66352 -0.66353 h 0.37775 0.37776 v -0.37931 -0.37878 h 0.37723 0.37776 v -0.37931 -0.3793 h 0.37775 0.37776 v -0.37931 -0.37879 h 0.37775 0.37776 v -0.3793 -0.37931 h 0.37775 0.37724 v -0.37878 -0.37931 h 0.37775 0.37776 v -0.37931 z m 23.98303,0 h 0.84956 0.84956 v 0.3793 0.37931 h 0.37776 0.37775 v 0.37931 0.37878 h 0.37776 0.37775 v 0.37931 0.3793 h 0.37724 0.37827 v 0.37879 0.37931 h 0.37724 0.37775 v 0.3793 0.37931 h 0.37776 0.37775 v 0.37878 0.37931 h 0.37724 0.37827 v 0.66353 0.66352 h -0.37827 -0.37724 v 0.3793 0.37931 h -0.37775 -0.37776 v 0.37931 0.37878 h -0.37775 -0.37724 v 0.37931 0.3793 h -0.37827 -0.37724 v 0.37879 0.37931 h -0.37775 -0.37776 v 0.3793 0.37931 h -0.37775 -0.37776 v 0.37879 0.3793 h -0.84956 -0.84956 v -0.3793 -0.37879 h -0.37827 -0.37724 v -0.37931 -0.3793 h -0.37775 -0.37776 v -0.37931 -0.37879 h -0.37775 -0.37776 v -0.3793 -0.37931 h -0.37775 -0.37724 v -0.37878 -0.37931 h -0.37776 -0.37775 v -0.37931 -0.3793 h -0.37775 -0.37776 v -0.66352 -0.66353 h 0.37776 0.37775 v -0.37931 -0.37878 h 0.37775 0.37776 v -0.37931 -0.3793 h 0.37724 0.37775 v -0.37931 -0.37879 h 0.37776 0.37775 v -0.3793 -0.37931 h 0.37776 0.37775 v -0.37878 -0.37931 h 0.37724 0.37827 v -0.37931 z m -60.051114,6.06681 h 0.754994 0.755509 v 0.37931 0.3793 h 0.377754 0.377756 v 0.37879 0.37931 h 0.377238 0.377753 v 0.3793 0.37931 h 0.377757 0.377753 v 0.37879 0.3793 h 0.377756 0.377754 v 0.3793 0.37931 h 0.377753 0.377241 v 0.3793 0.37879 h 0.377753 0.377754 v 0.66353 0.66352 h -0.377754 -0.377753 v 0.37931 0.37879 H 85.077703 84.69995 v 0.3793 0.37931 H 84.322196 83.94444 v 0.3793 0.37879 H 83.566687 83.18893 v 0.37931 0.3793 h -0.377753 -0.377238 v 0.37931 0.37878 h -0.377756 -0.377754 v 0.37931 0.3793 H 80.92292 80.167926 v -0.3793 -0.37931 h -0.37827 -0.37724 v -0.37878 -0.37931 h -0.377753 -0.377754 v -0.3793 -0.37931 h -0.377756 -0.377238 v -0.37879 -0.3793 h -0.378272 -0.377238 v -0.37931 -0.3793 h -0.377753 -0.377756 v -0.37879 -0.37931 h -0.377754 -0.377756 v -0.66352 -0.66353 h 0.377756 0.377754 v -0.37879 -0.3793 h 0.377756 0.377753 v -0.37931 -0.3793 h 0.377238 0.378272 v -0.3793 -0.37879 h 0.377238 0.377756 v -0.37931 -0.3793 h 0.377754 0.377753 v -0.37931 -0.37879 h 0.37724 0.37827 v -0.3793 z m 23.982514,0 H 105 h 0.84956 v 0.37931 0.3793 h 0.37827 0.37724 v 0.37879 0.37931 h 0.37776 0.37775 v 0.3793 0.37931 h 0.37776 0.37775 v 0.37879 0.3793 h 0.37776 0.37723 v 0.3793 0.37931 h 0.37776 0.37775 v 0.3793 0.37879 h 0.37776 0.37775 v 0.66353 0.66352 h -0.37775 -0.37776 v 0.37931 0.37879 h -0.37775 -0.37776 v 0.3793 0.37931 h -0.37723 -0.37776 v 0.3793 0.37879 h -0.37775 -0.37776 v 0.37931 0.3793 h -0.37775 -0.37776 v 0.37931 0.37878 h -0.37724 -0.37827 v 0.37931 0.3793 H 105 104.15044 v -0.3793 -0.37931 h -0.37775 -0.37776 v -0.37878 -0.37931 h -0.37775 -0.37776 v -0.3793 -0.37931 h -0.37724 -0.37827 v -0.37879 -0.3793 h -0.37724 -0.37775 v -0.37931 -0.3793 h -0.37775 -0.37776 v -0.37879 -0.37931 h -0.377236 -0.378272 v -0.66352 -0.66353 h 0.378272 0.377236 v -0.37879 -0.3793 h 0.37776 0.37775 v -0.37931 -0.3793 h 0.37775 0.37724 v -0.3793 -0.37879 h 0.37827 0.37724 v -0.37931 -0.3793 h 0.37776 0.37775 v -0.37931 -0.37879 h 0.37776 0.37775 v -0.3793 z m 24.17165,0 h 0.755 0.75551 v 0.37931 0.3793 h 0.37775 0.37776 v 0.37879 0.37931 h 0.37723 0.37776 v 0.3793 0.37931 h 0.37775 0.37776 v 0.37879 0.3793 h 0.37775 0.37776 v 0.3793 0.37931 h 0.37775 0.37724 v 0.3793 0.37879 h 0.37775 0.37776 v 0.66353 0.66352 h -0.37776 -0.37775 v 0.37931 0.37879 h -0.37724 -0.37775 v 0.3793 0.37931 h -0.37776 -0.37775 v 0.3793 0.37879 h -0.37776 -0.37775 v 0.37931 0.3793 h -0.37776 -0.37723 v 0.37931 0.37878 h -0.37776 -0.37775 v 0.37931 0.3793 h -0.75551 -0.755 v -0.3793 -0.37931 h -0.37827 -0.37724 v -0.37878 -0.37931 h -0.37775 -0.37775 v -0.3793 -0.37931 h -0.37776 -0.37724 v -0.37879 -0.3793 h -0.37827 -0.37724 v -0.37931 -0.3793 h -0.37775 -0.37776 v -0.37879 -0.37931 h -0.37775 -0.37776 v -0.66352 -0.66353 h 0.37776 0.37775 v -0.37879 -0.3793 h 0.37776 0.37775 v -0.37931 -0.3793 h 0.37724 0.37827 v -0.3793 -0.37879 h 0.37724 0.37776 v -0.37931 -0.3793 h 0.37775 0.37775 v -0.37931 -0.37879 h 0.37724 0.37827 v -0.3793 z m -60.240246,6.06682 h 0.850077 0.849559 v 0.3793 0.37931 h 0.377756 0.377753 v 0.37878 0.37931 h 0.377757 0.377237 v 0.3793 0.37879 h 0.377754 0.377756 v 0.37931 0.3793 h 0.377754 0.377756 v 0.37879 0.37931 h 0.377753 0.377238 v 0.3793 0.37931 h 0.378272 0.377238 v 0.66352 0.66353 h -0.377238 -0.378272 v 0.3793 0.37879 h -0.377238 -0.377753 v 0.3793 0.37931 h -0.377756 -0.377754 v 0.37931 0.37878 h -0.377756 -0.377754 v 0.37931 0.3793 h -0.377237 -0.377757 v 0.37879 0.37931 H 70.159236 69.78148 v 0.3793 0.37931 h -0.849559 -0.850077 v -0.37931 -0.3793 h -0.377756 -0.377754 v -0.37931 -0.37879 H 66.949097 66.57134 v -0.3793 -0.37931 h -0.377753 -0.377756 v -0.37878 -0.37931 h -0.377754 -0.377756 v -0.37931 -0.3793 H 64.682567 64.30533 v -0.37879 -0.3793 H 63.927574 63.54982 v -0.66353 -0.66352 h 0.377754 0.377756 v -0.37931 -0.3793 h 0.377237 0.377754 v -0.37931 -0.37879 h 0.377756 0.377754 v -0.3793 -0.37931 h 0.377756 0.377753 v -0.37879 -0.3793 h 0.377757 0.377237 v -0.37931 -0.37878 h 0.377754 0.377756 v -0.37931 z m 23.983032,0 h 0.849561 0.849558 v 0.3793 0.37931 h 0.377757 0.377753 v 0.37878 0.37931 h 0.377756 0.377754 v 0.3793 0.37879 h 0.377237 0.378273 v 0.37931 0.3793 h 0.377237 0.377754 v 0.37879 0.37931 h 0.377756 0.377754 v 0.3793 0.37931 h 0.377237 0.378272 v 0.66352 0.66353 h -0.378272 -0.377237 v 0.3793 0.37879 h -0.377754 -0.377756 v 0.3793 0.37931 h -0.377754 -0.377237 v 0.37931 0.37878 h -0.378273 -0.377237 v 0.37931 0.3793 h -0.377754 -0.377756 v 0.37879 0.37931 h -0.377753 -0.377757 v 0.3793 0.37931 h -0.849558 -0.849561 v -0.37931 -0.3793 h -0.378273 -0.377237 v -0.37931 -0.37879 H 90.93161 90.553856 v -0.3793 -0.37931 h -0.377753 -0.377757 v -0.37878 -0.37931 h -0.377753 -0.377238 v -0.37931 -0.3793 h -0.377756 -0.377754 v -0.37879 -0.3793 h -0.377756 -0.377753 v -0.66353 -0.66352 h 0.377753 0.377756 v -0.37931 -0.3793 h 0.377754 0.377756 v -0.37931 -0.37879 h 0.377238 0.377753 v -0.3793 -0.37931 h 0.377757 0.377753 v -0.37879 -0.3793 h 0.377754 0.377756 v -0.37931 -0.37878 h 0.377237 0.378273 v -0.37931 z m 24.171134,0 h 0.85008 0.84956 v 0.3793 0.37931 h 0.37775 0.37776 v 0.37878 0.37931 h 0.37775 0.37724 v 0.3793 0.37879 h 0.37775 0.37776 v 0.37931 0.3793 h 0.37775 0.37776 v 0.37879 0.37931 h 0.37775 0.37724 v 0.3793 0.37931 h 0.37827 0.37724 v 0.66352 0.66353 h -0.37724 -0.37827 v 0.3793 0.37879 h -0.37724 -0.37775 v 0.3793 0.37931 h -0.37776 -0.37775 v 0.37931 0.37878 h -0.37776 -0.37775 v 0.37931 0.3793 h -0.37724 -0.37775 v 0.37879 0.37931 h -0.37776 -0.37775 v 0.3793 0.37931 h -0.84956 -0.85008 v -0.37931 -0.3793 h -0.37776 -0.37775 v -0.37931 -0.37879 h -0.37724 -0.37775 v -0.3793 -0.37931 H 114.34775 113.97 v -0.37878 -0.37931 h -0.37776 -0.37775 v -0.37931 -0.3793 h -0.37776 -0.37723 v -0.37879 -0.3793 h -0.37776 -0.37775 v -0.66353 -0.66352 h 0.37775 0.37776 v -0.37931 -0.3793 h 0.37723 0.37776 v -0.37931 -0.37879 h 0.37775 0.37776 v -0.3793 -0.37931 h 0.37775 0.37776 v -0.37879 -0.3793 h 0.37775 0.37724 v -0.37931 -0.37878 h 0.37775 0.37776 v -0.37931 z m 23.98303,0 h 0.84956 0.84956 v 0.3793 0.37931 h 0.37776 0.37775 v 0.37878 0.37931 h 0.37776 0.37775 v 0.3793 0.37879 h 0.37724 0.37827 v 0.37931 0.3793 h 0.37724 0.37775 v 0.37879 0.37931 h 0.37776 0.37775 v 0.3793 0.37931 h 0.37724 0.37827 v 0.66352 0.66353 h -0.37827 -0.37724 v 0.3793 0.37879 h -0.37775 -0.37776 v 0.3793 0.37931 h -0.37775 -0.37724 v 0.37931 0.37878 h -0.37827 -0.37724 v 0.37931 0.3793 h -0.37775 -0.37776 v 0.37879 0.37931 h -0.37775 -0.37776 v 0.3793 0.37931 h -0.84956 -0.84956 v -0.37931 -0.3793 h -0.37827 -0.37724 v -0.37931 -0.37879 h -0.37775 -0.37776 v -0.3793 -0.37931 h -0.37775 -0.37776 v -0.37878 -0.37931 h -0.37775 -0.37724 v -0.37931 -0.3793 h -0.37776 -0.37775 v -0.37879 -0.3793 h -0.37775 -0.37776 v -0.66353 -0.66352 h 0.37776 0.37775 v -0.37931 -0.3793 h 0.37775 0.37776 v -0.37931 -0.37879 h 0.37724 0.37775 v -0.3793 -0.37931 h 0.37776 0.37775 v -0.37879 -0.3793 h 0.37776 0.37775 v -0.37931 -0.37878 h 0.37724 0.37827 v -0.37931 z"
       style="fill:{{pk_fill}};stroke-width:0.99999994">
      <title
         id="title4575">Abstract Tile Pattern 5  --  by Arvin61r58</title>
    </path>
  </g>
</svg>
`, uT = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev/svgjs" viewBox="0 0 800 800" width="{{pk_dimension}}" height="{{pk_dimension}}">
<defs>     
{{pk_gradient}}
</defs>
<g stroke-width="60" stroke="{{pk_fill}}" fill="none" transform="rotate(90 400 400)">
<line x1="0" y1="0" x2="0" y2="800" stroke-linecap="square" ></line>
<line x1="100" y1="0" x2="100" y2="800" stroke-linecap="square" ></line>
<line x1="200" y1="0" x2="200" y2="800" stroke-linecap="square" ></line>
<line x1="300" y1="0" x2="300" y2="800" stroke-linecap="square" ></line>
<line x1="400" y1="0" x2="400" y2="800" stroke-linecap="square" ></line>
<line x1="500" y1="0" x2="500" y2="800" stroke-linecap="square" ></line>
<line x1="600" y1="0" x2="600" y2="800" stroke-linecap="square" ></line>
<line x1="700" y1="0" x2="700" y2="800" stroke-linecap="square" ></line>
<line x1="800" y1="0" x2="800" y2="800" stroke-linecap="square" ></line>
</g></svg>`, hT = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (https://www.inkscape.org/) -->
<!-- ClipArt by Arvin61r58 (https://openclipart.org/user-detail/Arvin61r58) -->
<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="{{pk_dimension}}"
   height="{{pk_dimension}}"
   viewBox="0 0 135.46666 135.46667"
   version="1.1"
   id="svg4543">
  <title
     id="title4484">Abstract Tile Pattern 40</title>
  <defs
     id="defs4537">
   {{pk_gradient}}
   </defs>
  <metadata
     id="metadata4540">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title>Abstract Tile Pattern 40</dc:title>
        <cc:license
           rdf:resource="http://creativecommons.org/publicdomain/zero/1.0/" />
        <dc:subject>
          <rdf:Bag>
            <rdf:li>abstract</rdf:li>
            <rdf:li>geometric</rdf:li>
            <rdf:li>pattern</rdf:li>
            <rdf:li>seamless</rdf:li>
            <rdf:li>texture</rdf:li>
            <rdf:li>tile</rdf:li>
            <rdf:li>tileable</rdf:li>
          </rdf:Bag>
        </dc:subject>
        <dc:description>Tileable/seamless abstract pattern</dc:description>
        <dc:creator>
          <cc:Agent>
            <dc:title>Arvin61r58</dc:title>
          </cc:Agent>
        </dc:creator>
        <dc:publisher>
          <cc:Agent>
            <dc:title>Openclipart.org</dc:title>
          </cc:Agent>
        </dc:publisher>
        <dc:identifier>https://openclipart.org/</dc:identifier>
        <dc:source>https://openclipart.org/user-detail/Arvin61r58</dc:source>
      </cc:Work>
      <cc:License
         rdf:about="http://creativecommons.org/publicdomain/zero/1.0/">
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#Reproduction" />
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#Distribution" />
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#DerivativeWorks" />
      </cc:License>
    </rdf:RDF>
  </metadata>
  <g
     transform="translate(-37.266459,-107.68593)"
     id="layer1">
    <title
       id="title4486">Abstract Tile Pattern 40  --  by Arvin61r58</title>
    <path
       style="fill:{{pk_fill}};stroke-width:0.99806774"
       d="m 140.84961,407.00195 v 4.96094 h 0.50195 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98633 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 3.51367 3.51367 V 505.23438 503.25 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 1.50586 1.50586 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00976 2.00782 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00781 2.00782 v -1.98633 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 4.51758 4.51758 v 1.98438 1.98437 H 307 h 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 2.48047 2.48047 h 2.00781 1.50586 0.50195 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98633 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 3.51367 3.51367 V 633.23438 631.25 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 1.50586 1.50586 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00976 2.00782 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00781 2.00782 v -1.98633 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 4.51758 4.51758 v 1.98438 1.98437 H 563 h 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 4.01563 v 2.48047 2.48047 h 2.00781 1.50586 v -4.96094 -4.96093 h -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00976 v -1.98437 -1.98438 h -2.00781 -2.00782 v -3.96875 -3.96875 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00976 2.00782 v -1.98437 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00781 2.00782 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 4.51758 4.51758 v 1.98438 1.98437 H 563 h 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 2.48047 2.48047 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 1.50586 v -8.92969 h -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -3.51367 -3.51367 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00782 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98633 h -2.00977 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -1.50586 -1.50586 v 4.96093 4.96094 h 1.50586 1.50586 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98632 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 3.47266 3.47266 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98633 h -2.00977 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -1.50586 -1.50586 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98633 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -4.51758 -4.51758 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00977 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -2.48047 -2.48046 h -2.00781 -1.50586 -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00976 v -1.98437 -1.98438 h -2.00781 -2.00782 v -3.96875 h -10.03906 v 4.96094 h 1.50586 1.50586 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98632 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 3.47266 3.47266 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98633 h -2.00977 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -1.50586 -1.50586 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98633 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -4.51758 -4.51758 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00977 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 z m 28.61328,0 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98633 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 3.51367 3.51367 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98633 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98437 -1.98438 h 1.50586 1.50586 V 439.25 434.78516 h -1.50586 -1.50586 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -3.96875 h -11.04297 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 3.47266 3.47266 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98633 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -4.51758 -4.51758 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 z m 32.125,0 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 3.51367 3.51367 V 439.25 434.78516 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 z m 95.37305,0 v 4.96094 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 H 307 h 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 1.50586 0.50195 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98633 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 3.51367 3.51367 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98633 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98437 -1.98438 h 1.50586 1.50586 V 567.25 562.78516 h -1.50586 -1.50586 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -3.96875 -3.96875 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98438 -1.98437 h 1.50586 1.50586 V 505.23438 503.25 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00976 2.00782 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00781 2.00782 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 4.51758 4.51758 v 1.98437 1.98438 H 563 h 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 2.48047 2.48047 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 1.50586 v -8.92968 h -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -3.51367 -3.51367 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98633 h -2.00977 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00782 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -1.50586 -1.50586 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98633 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -4.51758 -4.51758 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00977 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -1.50586 -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 -7.02734 v 2.48047 2.48047 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 1.50586 0.50195 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00977 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 3.47266 3.47266 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98633 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -4.51758 -4.51758 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00977 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -1.50586 -0.50195 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 z m 32.125,0 v 2.48047 2.48047 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 1.50586 0.50195 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 3.51367 3.51367 V 567.25 562.78516 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00977 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -1.50586 -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 z m 64.25,0 v 2.48047 2.48047 h 2.00781 1.50586 0.50195 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98633 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 3.51367 3.51367 V 505.23438 503.25 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 1.50586 1.50586 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00976 2.00782 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00781 2.00782 v -1.98633 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 4.51758 4.51758 v 1.98438 1.98437 H 563 h 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 2.48047 2.48047 h 2.00781 1.50586 v -9.92187 h -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00976 v -1.98437 -1.98438 h -2.00781 -2.00782 v -3.96875 h -10.03906 v 4.96094 h 1.50586 1.50586 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98632 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 3.47266 3.47266 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98633 h -2.00977 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -1.50586 -1.50586 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98633 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -4.51758 -4.51758 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00977 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 -3.51367 z m 32.12695,0 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98633 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 3.51367 3.51367 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98633 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98437 -1.98438 h 1.50586 1.50586 V 439.25 434.78516 h -1.50586 -1.50586 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -3.96875 h -11.04297 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 3.47266 3.47266 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98633 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -4.51758 -4.51758 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 z m 32.125,0 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 3.51367 3.51367 V 439.25 434.78516 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 z m 95.37305,0 v 4.96094 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 H 563 h 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 1.50586 v -8.92969 h -0.50195 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 z m 32.125,0 v 2.48047 2.48047 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 1.50586 v -8.92969 h -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 z m 32.125,0 v 2.48047 2.48047 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 1.50586 v -8.92968 h -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 z m 32.125,0 v 2.48047 2.48047 h 2.00781 1.50586 v -4.96094 z m -508.48633,27.78321 v 8.92968 h 0.50195 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00977 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 3.47266 3.47266 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98633 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -4.51758 -4.51758 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00977 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -1.50586 v 8.92969 h 0.50195 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98633 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 3.51367 3.51367 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98633 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98437 -1.98438 h 1.50586 1.50586 V 567.25 562.78516 h -1.50586 -1.50586 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -3.96875 -3.96875 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98438 -1.98437 h 1.50586 1.50586 V 505.23438 503.25 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00976 2.00782 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00781 2.00782 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 4.51758 4.51758 v 1.98437 1.98438 H 307 h 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 2.48047 2.48047 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 1.50586 0.50195 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00977 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 4.01562 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 3.47266 3.47266 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98633 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -4.51758 -4.51758 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00977 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -1.50586 -0.50195 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -2.48047 -2.48046 h -3.51367 -3.51367 v 4.96093 4.96094 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 H 307 h 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 1.50586 0.50195 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 4.01562 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98633 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 3.51367 3.51367 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98633 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98437 -1.98438 h 1.50586 1.50586 V 695.25 690.78516 h -1.50586 -1.50586 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -3.96875 -3.96875 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98438 -1.98437 h 1.50586 1.50586 V 633.23438 631.25 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00976 2.00782 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00781 2.00782 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 4.51758 4.51758 v 1.98437 1.98438 H 563 h 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 4.01563 v 2.48047 2.48047 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 1.50586 v -8.92968 h -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -3.51367 -3.51367 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98633 h -2.00977 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00782 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -1.50586 -1.50586 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98633 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -4.51758 -4.51758 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00977 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -1.50586 -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -3.51367 -3.51367 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98633 h -2.00977 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00782 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -1.50586 -1.50586 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98633 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -4.51758 -4.51758 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00977 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 z m 0,31.75195 v 8.92969 h 0.50195 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 3.51367 3.51367 V 567.25 562.78516 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00977 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 z m 156.11133,31.75195 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00782 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98633 h -2.00977 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -1.50586 -1.50586 v 4.96093 4.96094 h 1.50586 1.50586 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98632 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 3.47266 3.47266 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98633 h -2.00977 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -1.50586 -1.50586 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98633 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -4.51758 -4.51758 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00977 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -2.48047 -2.48046 h -2.00781 -1.50586 v 9.92187 h 0.50195 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98633 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 3.51367 3.51367 V 633.23438 631.25 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 1.50586 1.50586 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00976 2.00782 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00781 2.00782 v -1.98633 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 4.51758 4.51758 v 1.98438 1.98437 H 307 h 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 4.01563 v 2.48047 2.48047 h 2.00781 1.50586 0.50195 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98633 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 3.51367 3.51367 V 761.23438 759.25 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 1.50586 1.50586 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00976 2.00782 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00781 2.00782 v -1.98633 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 4.51758 4.51758 v 1.98438 1.98437 H 563 h 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 2.48047 2.48047 h 2.00781 1.50586 v -9.92187 h -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00976 v -1.98437 -1.98438 h -2.00781 -2.00782 v -3.96875 -3.96875 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00976 2.00782 v -1.98437 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00781 2.00782 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 4.51758 4.51758 v 1.98438 1.98437 H 563 h 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 4.01563 v 2.48047 2.48047 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 1.50586 v -8.92969 h -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -3.51367 -3.51367 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00782 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00977 -2.00781 v 1.98633 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -1.50586 -1.50586 v 4.96093 4.96094 h 1.50586 1.50586 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98632 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 3.47266 3.47266 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98633 h -2.00977 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -1.50586 -1.50586 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98633 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -4.51758 -4.51758 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00977 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 v -2.48047 -2.48046 h -2.00781 -1.50586 -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00976 v -1.98437 -1.98438 h -2.00781 -2.00782 v -3.96875 -3.96875 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00976 2.00782 v -1.98437 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00781 2.00782 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 4.51758 4.51758 v 1.98438 1.98437 H 307 h 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 2.48047 2.48047 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 1.50586 0.50195 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 4.01562 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 3.51367 3.51367 V 695.25 690.78516 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00977 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -1.50586 -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -3.51367 z m 256,31.75196 v 4.96093 4.96094 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 H 563 h 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 1.50586 v -8.92969 h -0.50195 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -2.48047 -2.48046 h -3.51367 z m -412.11133,32.74414 v 8.92968 h 0.50195 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00977 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 4.01562 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 3.47266 3.47266 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98633 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -4.51758 -4.51758 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00977 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -1.50586 v 8.92969 h 0.50195 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 4.01562 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98633 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 3.51367 3.51367 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98633 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98437 -1.98438 h 1.50586 1.50586 V 695.25 690.78516 h -1.50586 -1.50586 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -3.96875 -3.96875 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98438 -1.98437 h 1.50586 1.50586 V 633.23438 631.25 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00976 2.00782 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00781 2.00782 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 4.51758 4.51758 v 1.98437 1.98438 H 307 h 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 4.01563 v 2.48047 2.48047 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 1.50586 0.50195 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00977 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 3.47266 3.47266 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98633 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -4.51758 -4.51758 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00977 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -1.50586 -0.50195 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 v -2.48047 -2.48046 h -3.51367 -3.51367 v 4.96093 4.96094 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 H 307 h 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 1.50586 0.50195 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98633 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 3.51367 3.51367 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98633 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98437 -1.98438 h 1.50586 1.50586 V 823.25 818.78516 h -1.50586 -1.50586 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -3.96875 -3.96875 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98438 -1.98437 h 1.50586 1.50586 V 761.23438 759.25 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00976 2.00782 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00781 2.00782 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 4.51758 4.51758 v 1.98437 1.98438 H 563 h 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 2.48047 2.48047 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 1.50586 v -8.92968 h -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -3.51367 -3.51367 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98633 h -2.00977 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00782 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -1.50586 -1.50586 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98633 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -4.51758 -4.51758 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00977 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -1.50586 -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -3.51367 -3.51367 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98633 h -2.00977 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00782 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -1.50586 -1.50586 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98633 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -4.51758 -4.51758 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00977 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 z m 0,31.75195 v 8.92969 h 0.50195 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 4.01562 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 3.51367 3.51367 V 695.25 690.78516 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00977 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 z m 156.11133,31.75195 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00782 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00977 -2.00781 v 1.98633 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -1.50586 -1.50586 v 4.96093 4.96094 h 1.50586 1.50586 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98632 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 3.47266 3.47266 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98633 h -2.00977 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -1.50586 -1.50586 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98633 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -4.51758 -4.51758 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00977 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 v -2.48047 -2.48046 h -2.00781 -1.50586 v 4.96093 4.96094 h 0.50195 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98633 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 3.51367 3.51367 V 761.23438 759.25 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 1.50586 1.50586 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00976 2.00782 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00781 2.00782 v -1.98633 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 4.51758 4.51758 v 1.98438 1.98437 H 307 h 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 2.48047 2.48047 h 2.00781 1.50586 0.50195 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98633 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 3.51367 3.51367 V 889.23438 887.25 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 1.50586 1.50586 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00976 2.00782 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00781 2.00782 v -1.98633 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 4.51758 4.51758 v 1.98438 1.98437 H 563 h 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 4.01563 3.51367 v -4.96093 h -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00976 v -1.98437 -1.98438 h -2.00781 -2.00782 v -3.96875 -3.96875 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00976 2.00782 v -1.98437 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00781 2.00782 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 4.51758 4.51758 v 1.98438 1.98437 H 563 h 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 2.48047 2.48047 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 1.50586 v -8.92969 h -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -3.51367 -3.51367 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00782 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98633 h -2.00977 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -1.50586 -1.50586 v 4.96093 4.96094 h 1.50586 1.50586 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98632 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 3.47266 3.47266 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98633 h -2.00977 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -1.50586 -1.50586 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98633 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -4.51758 -4.51758 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00977 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -2.48047 -2.48046 h -2.00781 -1.50586 -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00976 v -1.98437 -1.98438 h -2.00781 -2.00782 v -3.96875 -3.96875 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00976 2.00782 v -1.98437 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00781 2.00782 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 4.51758 4.51758 v 1.98438 1.98437 H 307 h 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 4.01563 v 2.48047 2.48047 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 1.50586 0.50195 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 3.51367 3.51367 V 823.25 818.78516 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00977 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -1.50586 -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -3.51367 z m 256,31.75196 v 4.96093 4.96094 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 H 563 h 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 1.50586 v -8.92969 h -0.50195 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -4.01563 v -2.48047 -2.48046 h -3.51367 z m -412.11133,32.74414 v 8.92968 h 0.50195 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00977 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 3.47266 3.47266 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98633 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -4.51758 -4.51758 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00977 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -1.50586 v 8.92969 h 0.50195 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98633 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 3.51367 3.51367 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98633 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98437 -1.98438 h 1.50586 1.50586 V 823.25 818.78516 h -1.50586 -1.50586 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -3.96875 -3.96875 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98438 -1.98437 h 1.50586 1.50586 V 761.23438 759.25 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00976 2.00782 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00781 2.00782 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 4.51758 4.51758 v 1.98437 1.98438 H 307 h 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 2.48047 2.48047 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 1.50586 0.50195 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00977 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 4.01562 11.04297 v -3.96875 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98438 -1.98437 h 1.50586 1.50586 V 889.23438 887.25 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00976 2.00782 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00781 2.00782 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 4.51758 4.51758 v 1.98437 1.98438 H 563 h 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 4.01563 7.02734 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -3.51367 -3.51367 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98633 h -2.00977 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00782 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -1.50586 -1.50586 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98633 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -4.51758 -4.51758 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00977 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -1.50586 -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -3.51367 -3.51367 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98633 h -2.00977 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00782 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -1.50586 -1.50586 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98633 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -4.51758 -4.51758 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00977 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 z m 0,31.75195 v 8.92969 h 0.50195 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 2.48047 2.48047 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98632 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 3.51367 3.51367 V 823.25 818.78516 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00977 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 z m 156.11133,31.75195 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00782 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98633 h -2.00977 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -1.50586 -1.50586 v 4.96093 4.96094 h 1.50586 1.50586 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98632 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 3.47266 3.47266 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98633 h -2.00977 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -1.50586 -1.50586 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98633 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -4.51758 -4.51758 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00977 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -2.48047 -2.48046 h -2.00781 -1.50586 v 9.92187 h 0.50195 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98633 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 3.51367 3.51367 V 889.23438 887.25 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 1.50586 1.50586 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98438 -1.98437 h 2.00976 2.00782 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00781 2.00782 v -1.98633 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 4.51758 4.51758 v 1.98438 1.98437 H 307 h 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 4.01563 3.51367 3.51367 v -2.48047 -2.48046 h -2.00781 -1.50586 -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00976 v -1.98437 -1.98438 h -2.00781 -2.00782 v -3.96875 -3.96875 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00976 2.00782 v -1.98437 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00781 2.00782 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 4.51758 4.51758 v 1.98438 1.98437 H 307 h 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 2.48047 2.48047 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 1.50586 0.50195 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 4.01562 7.02734 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00977 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -1.50586 -0.50195 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -3.51367 z m 0,31.75196 v 4.96093 4.96094 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 H 307 h 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 1.50586 0.50195 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 4.01562 7.02734 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00977 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -1.50586 -0.50195 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -2.48047 -2.48046 h -3.51367 z m 256,0 v 4.96093 4.96094 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 H 563 h 2.00781 v 1.98438 1.98632 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 1.50586 v -8.92969 h -0.50195 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98633 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -2.48047 -2.48046 h -3.51367 z m -412.11133,32.74414 v 8.92968 h 0.50195 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98633 h 2.00781 2.00977 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 4.01562 11.04297 v -3.96875 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00782 2.00781 v -1.98438 -1.98437 h 1.50586 1.50586 V 889.23438 887.25 h 2.00781 2.00781 v -1.98438 -1.98437 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00976 2.00782 v -1.98438 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00781 2.00782 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98438 -1.98437 h 4.51758 4.51758 v 1.98437 1.98438 H 307 h 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 4.01563 7.02734 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -3.51367 -3.51367 v 1.98437 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98633 h -2.00977 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00782 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -1.50586 -1.50586 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98633 1.98438 h -2.00782 -2.00781 v 1.98437 1.98438 h -4.51758 -4.51758 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00977 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 z m 0,31.75195 v 8.92969 h 0.50195 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98438 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98437 1.98633 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 4.01562 7.02734 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00782 v -1.98633 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00977 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 z m 0,31.75195 v 8.92969 h 0.50195 v 1.98437 1.98438 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98437 1.98633 h 2.00781 2.00977 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00781 2.00782 v 1.98438 1.98437 h 4.01562 7.02734 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00782 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00781 -2.00782 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00977 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 z m 156.11133,0 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00782 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00977 -2.00781 v 1.98633 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -1.50586 -1.50586 v 4.96093 h 10.03906 v -3.96875 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00976 2.00782 v -1.98437 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00781 2.00782 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 4.51758 4.51758 v 1.98438 1.98437 H 307 h 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 4.01563 7.02734 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -3.51367 z m 256,0 v 1.98438 1.98437 h -2.00782 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00781 -2.00782 v 1.98438 1.98437 h -2.00781 -2.00781 v 1.98438 1.98437 h -2.00977 -2.00781 v 1.98633 1.98438 h -2.00781 -2.00782 v 1.98437 1.98438 h -2.00781 -2.00781 v 1.98437 1.98438 h -1.50586 -1.50586 v 4.96093 h 10.03906 v -3.96875 h 2.00782 2.00781 v -1.98437 -1.98438 h 2.00976 2.00782 v -1.98437 -1.98438 h 2.00781 2.00781 v -1.98437 -1.98438 h 2.00781 2.00782 v -1.98633 -1.98437 h 2.00781 2.00781 v -1.98437 -1.98438 h 4.51758 4.51758 v 1.98438 1.98437 H 563 h 2.00781 v 1.98437 1.98633 h 2.00781 2.00782 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 2.00782 2.00781 v 1.98438 1.98437 h 2.00781 2.00781 v 1.98438 1.98437 h 4.01563 7.02734 v -2.48047 -2.48046 h -2.00781 -2.00781 v -1.98438 -1.98437 h -2.00782 -2.00781 v -1.98438 -1.98437 h -2.00781 -2.00781 v -1.98438 -1.98633 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -2.00781 -2.00781 v -1.98437 -1.98438 h -2.00782 -2.00781 v -1.98437 -1.98438 h -3.51367 z m -412.11133,31.75196 v 4.96093 h 3.51367 v -2.48047 -2.48046 h -2.00781 z m 156.11133,0 v 4.96093 h 7.02734 v -2.48047 -2.48046 h -3.51367 z m 256,0 v 4.96093 h 7.02734 v -2.48047 -2.48046 h -3.51367 z"
       transform="scale(0.26458333)"
       id="path4556" />
  </g>
</svg>
`, mT = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (http://www.inkscape.org/) -->
<!-- ClipArt by Arvin61r58 (http://openclipart.org/user-detail/Arvin61r58) -->

<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   version="1.1"
   id="svg4268"
   viewBox="0 0 300 300"
   height="{{pk_dimension}}"
   width="{{pk_dimension}}">
  <title
     id="title4834">Tileable Wave Pattern</title>
  <defs
     id="defs4270">
     {{pk_gradient}}
  </defs>
  <metadata
     id="metadata4273">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title>Tileable Wave Pattern</dc:title>
        <dc:description>tileable/seamless wave pattern</dc:description>
        <dc:creator>
          <cc:Agent>
            <dc:title>Arvin61r58</dc:title>
          </cc:Agent>
        </dc:creator>
        <dc:publisher>
          <cc:Agent>
            <dc:title>Openclipart.org</dc:title>
          </cc:Agent>
        </dc:publisher>
        <dc:identifier>https://openclipart.org/</dc:identifier>
        <dc:source>https://openclipart.org/user-detail/Arvin61r58</dc:source>
        <dc:subject>
          <rdf:Bag>
            <rdf:li>pattern</rdf:li>
            <rdf:li>tile</rdf:li>
            <rdf:li>wave</rdf:li>
            <rdf:li>sine waave</rdf:li>
            <rdf:li></rdf:li>
          </rdf:Bag>
        </dc:subject>
        <cc:license
           rdf:resource="http://creativecommons.org/publicdomain/zero/1.0/" />
      </cc:Work>
      <cc:License
         rdf:about="http://creativecommons.org/publicdomain/zero/1.0/">
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#Reproduction" />
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#Distribution" />
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#DerivativeWorks" />
      </cc:License>
    </rdf:RDF>
  </metadata>
  <g
     transform="translate(-222.04724,-376.18102)"
     id="layer1">
    <path
       id="path4147"
       d="m 222.04727,376.18102 0,20.5254 c 7.52005,-1.82885 14.24978,0.35479 23.2588,6.55958 15.60852,10.75001 21.27297,10.92027 35.99413,1.08984 16.47339,-11.00056 25.16548,-11.16026 39.50683,-0.73534 13.92694,10.12476 22.32587,10.12578 37.21289,0.012 14.69808,-9.98571 23.19735,-10.06957 37.28613,-0.3662 15.60852,10.75001 21.27299,10.9232 35.99414,1.09276 16.47341,-11.00057 25.16549,-11.16317 39.50683,-0.73828 13.92695,10.12476 22.32587,10.12869 37.21289,0.015 5.2986,-3.5998 9.78773,-5.89433 14.02733,-6.92578 l 0,-20.52833 -299.99997,0 z m 79.96875,49.20412 c -5.55213,-0.0194 -11.1646,2.50638 -18.52149,7.57325 -15.07223,10.38063 -23.60368,10.35555 -38.80958,-0.11715 -9.17244,-6.31733 -15.582,-8.60315 -22.63768,-6.86133 l 0,45.43068 c 1.26405,-0.14295 2.59906,-0.22558 4.12792,-0.22558 7.27827,0 11.33239,1.51959 20.01564,7.5 14.3872,9.90882 21.36837,9.91449 35.88281,0.0234 15.18926,-10.35242 25.0032,-10.34823 39.21093,0.012 14.018,10.22163 22.60049,10.21239 35.97363,-0.0351 8.01457,-6.14137 11.44282,-7.5 18.917,-7.5 7.2782,0 11.33238,1.5196 20.01561,7.5 14.38722,9.90882 21.36837,9.91451 35.88282,0.0234 15.18925,-10.35242 25.00318,-10.35115 39.21093,0.009 14.01797,10.22163 22.6005,10.21238 35.97363,-0.0351 6.37526,-4.8852 9.8734,-6.72126 14.78905,-7.27734 l 0,-45.42482 c -4.09234,1.01025 -8.40008,3.36524 -13.59668,7.09863 -14.31228,10.28263 -23.96279,10.28575 -38.26755,0.009 -14.24605,-10.23472 -21.97476,-10.26265 -36.68849,-0.12885 -15.07223,10.38062 -23.60367,10.35556 -38.80957,-0.11715 -14.49254,-9.9814 -22.07825,-9.92994 -36.23437,0.24022 -14.31228,10.28262 -23.96278,10.28283 -38.26756,0.006 -7.12302,-5.11737 -12.61487,-7.68278 -18.167,-7.70214 z m 150.11132,74.77153 c -5.39339,0.0756 -11.07189,2.74399 -18.84961,8.02734 -15.61594,10.60957 -22.28946,10.60882 -38.23242,-0.003 -15.3284,-10.2027 -21.27855,-10.30098 -35.29687,-0.58008 -8.78267,6.09028 -12.49382,7.43476 -20.70117,7.50001 -8.546,0.0679 -11.42555,-1.01139 -19.79004,-7.4209 -13.26213,-10.16247 -20.42403,-10.05987 -35.97949,0.50682 -15.61594,10.60811 -22.28947,10.60591 -38.23243,-0.006 -10.05926,-6.69549 -16.08513,-9.01091 -22.99804,-7.08398 l 0,45.61233 c 7.52005,-1.82885 14.24978,0.35481 23.2588,6.55958 15.60852,10.75001 21.27297,10.9232 35.99413,1.09277 16.47339,-11.00056 25.16548,-11.16319 39.50683,-0.73829 13.92694,10.12479 22.32587,10.1258 37.21288,0.012 14.69808,-9.98567 23.19736,-10.06953 37.28614,-0.36621 15.60851,10.75004 21.27299,10.92321 35.99414,1.09279 16.47341,-11.00056 25.16549,-11.16315 39.50683,-0.73829 13.92695,10.12177 22.32587,10.12579 37.21289,0.012 5.2986,-3.59979 9.78773,-5.89434 14.02733,-6.92578 l 0,-45.61233 c -3.62104,1.00951 -7.48001,3.15941 -12.29882,6.50098 -8.78267,6.09029 -12.4938,7.43768 -20.70117,7.50293 -8.546,0.0679 -11.42262,-1.01136 -19.7871,-7.42089 -6.63106,-5.08125 -11.73943,-7.59911 -17.13281,-7.52345 z m -150.11132,75.22854 c -5.55213,-0.0194 -11.1646,2.50929 -18.52149,7.57618 -15.07223,10.38062 -23.60368,10.35262 -38.80958,-0.12016 -9.17244,-6.31731 -15.582,-8.60313 -22.63768,-6.86131 l 0,45.43069 c 1.26405,-0.14295 2.59906,-0.22266 4.12792,-0.22266 7.27827,0 11.33239,1.51958 20.01564,7.49997 14.3872,9.90899 21.36837,9.9116 35.88281,0.0205 15.18926,-10.35244 25.0032,-10.34822 39.21093,0.012 14.018,10.22147 22.60049,10.21238 35.97363,-0.0351 8.01457,-6.14139 11.44282,-7.5 18.917,-7.5 7.2782,0 11.33238,1.51959 20.01561,7.5 14.38722,9.90896 21.36837,9.91449 35.88282,0.0234 15.18925,-10.35242 25.00318,-10.35115 39.21093,0.009 14.01797,10.22146 22.6005,10.21529 35.97363,-0.0322 6.37518,-4.88515 9.87351,-6.72124 14.78905,-7.27735 l 0,-45.42774 c -4.09234,1.01026 -8.40008,3.36816 -13.59668,7.10155 -14.31228,10.28266 -23.96279,10.28285 -38.26755,0.006 -14.24605,-10.23473 -21.97476,-10.25971 -36.68849,-0.12599 -15.07223,10.38061 -23.60367,10.35262 -38.80957,-0.12016 -14.49254,-9.9814 -22.07825,-9.92996 -36.23437,0.24023 -14.31228,10.28264 -23.96278,10.28283 -38.26756,0.006 -7.12302,-5.1174 -12.61487,-7.6828 -18.167,-7.70216 z m 0.1113,74.77444 c -5.3934,0.0756 -11.07187,2.74399 -18.84961,8.02736 -15.61594,10.60807 -22.28947,10.60585 -38.23243,-0.006 -10.05926,-6.69552 -16.08513,-9.01094 -22.99804,-7.08399 l 0,25.084 300,0 0,-25.084 c -3.62107,1.00952 -7.48005,3.16235 -12.29885,6.50391 -8.78267,6.0903 -12.4938,7.43475 -20.70117,7.49999 -8.546,0.0679 -11.42261,-1.01136 -19.7871,-7.42088 -13.26215,-10.16248 -20.42697,-10.06283 -35.98242,0.5039 -15.61594,10.60955 -22.28945,10.60879 -38.23241,-0.003 -15.32841,-10.20274 -21.27855,-10.30102 -35.29688,-0.58008 -8.78266,6.09027 -12.49381,7.43475 -20.70117,7.5 -8.546,0.0679 -11.42555,-1.01139 -19.79004,-7.42089 -6.63106,-5.08125 -11.73648,-7.59618 -17.12988,-7.52053 z"
       style="fill:{{pk_fill}};fill-opacity:1" />
  </g>
</svg>`, fT = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   id="svg2"
   version="1.1"
   inkscape:version="0.91 r13725"
   width="{{pk_dimension}}"
   height="{{pk_dimension}}"
   viewBox="0 0 600 600"
   sodipodi:docname="seamless pattern 02.svg">
  <metadata
     id="metadata8">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title></dc:title>
      </cc:Work>
    </rdf:RDF>
  </metadata>
  <defs
     id="defs6">
     {{pk_gradient}}
   </defs>
  <g
     id="g83700">
    <g
       style="fill:{{pk_fill}};fill-opacity:1"
       id="g83686">
      <path
         inkscape:connector-curvature="0"
         id="path83688"
         d="M 0,599.43364 C 0,598.61197 11.636288,587 12.45968,587 c 0.735382,0 11.788989,10.63778 12.59896,12.125 0.364139,0.66861 0.286355,0.875 -0.329773,0.875 -0.443475,0 -3.376391,-2.51137 -6.517592,-5.58082 L 12.5,588.83835 6.788725,594.41918 C 1.3668788,599.71718 0,600.72682 0,599.43364 Z M 36.667539,587.89763 C 29.975393,581.24132 24.5,575.4442 24.5,575.01512 24.5,574.01573 36.516708,562 37.516183,562 38.245021,562 75.5,598.91823 75.5,599.64048 c 0,1.62682 -4.078015,-2.02063 -19.8524,-17.75631 l -18.160387,-18.11583 -5.610435,5.61044 -5.610434,5.61043 12.116828,12.15383 C 45.047427,593.82764 50.5,599.45506 50.5,599.64843 c 0,1.52894 -3.297827,-1.27259 -13.832461,-11.7508 z M 100,599.69671 c 0,-0.47395 6.93188,-7.52224 10.13918,-10.30946 l 2.88918,-2.51077 5.77687,5.68677 c 6.19479,6.09816 7.26167,7.43675 5.9272,7.43675 -0.44152,0 -3.2254,-2.3625 -6.1864,-5.25 -2.961,-2.8875 -5.56921,-5.25 -5.79603,-5.25 -0.22682,0 -2.83503,2.3625 -5.79604,5.25 -4.6154,4.50084 -6.95396,6.16438 -6.95396,4.94671 z m 36.91838,-11.54865 C 130.36327,581.6295 125,575.97731 125,575.58766 125,574.72188 136.88214,562 137.69077,562 c 0.61337,0 37.80923,37.02985 37.80923,37.64048 0,1.62582 -4.06323,-2.00588 -19.73385,-17.63805 l -18.04183,-17.99757 -4.25222,4.37257 c -2.33873,2.40492 -4.79616,4.9969 -5.46097,5.75997 l -1.20875,1.38741 11.84881,11.8865 c 6.51684,6.53757 11.84881,12.04449 11.84881,12.23759 0,1.52314 -3.26436,-1.24109 -13.58162,-11.50083 z M 199.94136,599.125 C 200.59515,597.92455 211.73511,587 212.30544,587 c 0.25244,0 3.3775,2.925 6.94456,6.5 7.96607,7.98379 7.26686,8.96553 -0.89027,1.25 -3.05277,-2.8875 -5.76911,-5.25 -6.03631,-5.25 -0.26719,0 -2.90845,2.3625 -5.86946,5.25 -2.961,2.8875 -5.74488,5.25 -6.18639,5.25 -0.61274,0 -0.68995,-0.20712 -0.32621,-0.875 z m 36.87083,-11 c -6.6342,-6.53125 -12.25715,-12.18311 -12.49543,-12.55967 -0.31418,-0.49652 1.33275,-2.45461 5.99278,-7.125 3.53432,-3.54219 6.67209,-6.44033 6.97283,-6.44033 0.65449,0 37.02444,35.70477 37.74898,37.05859 0.40299,0.75298 0.33098,0.94141 -0.35977,0.94141 -0.47497,0 -9.02771,-8.14409 -19.00608,-18.09797 l -18.14248,-18.09797 -1.38651,1.20814 c -4.21931,3.67652 -9.63651,9.32718 -9.63651,10.0518 0,0.45984 5.19432,5.85946 11.54294,11.99915 C 249.84093,598.47287 251.21755,600 249.70478,600 c -0.45671,0 -6.25838,-5.34375 -12.89259,-11.875 z M 81.061415,581.77471 C 77.45264,578.21329 74.5,575.04314 74.5,574.72994 74.5,574.41673 85.4125,563.06326 98.75,549.5 112.0875,535.93674 123,524.58087 123,524.26472 123,523.57444 112.85406,513.5 112.15889,513.5 c -0.26735,0 -11.34552,11.025 -24.61817,24.5 -13.27265,13.475 -24.365475,24.5 -24.65072,24.5 -0.28525,0 -5.50034,-4.78125 -11.5891,-10.625 -6.088757,-5.84375 -11.691493,-11.17674 -12.450524,-11.8511 L 37.47032,538.79781 19.094473,557.1489 C 8.987758,567.24201 0.5569362,575.5 0.35931367,575.5 c -1.62915387,0 2.05245053,-4.11031 18.00033733,-20.09639 10.097809,-10.12199 18.704059,-18.3956 19.125,-18.3858 0.420942,0.01 6.270764,5.28096 12.999604,11.7137 7.276,6.95582 12.46864,11.55862 12.81258,11.35719 0.31808,-0.18628 11.19501,-11.1387 24.17096,-24.3387 12.975945,-13.2 23.972785,-24.06283 24.437415,-24.13964 0.52394,-0.0866 3.30695,2.33082 7.32769,6.36509 l 6.4829,6.50473 -10.73078,10.88491 c -5.90192,5.9867 -17.02521,17.24386 -24.718405,25.01589 l -13.987625,14.13099 5.485505,5.50523 c 3.01703,3.02787 5.744585,5.44393 6.06124,5.36901 C 88.14239,585.31129 99.13114,574.3375 112.24518,561 c 13.11403,-13.3375 24.18581,-24.32749 24.60395,-24.4222 0.45669,-0.10343 5.70857,4.76165 13.15291,12.18422 6.81596,6.79603 12.63617,12.27351 12.93379,12.17219 0.29762,-0.10132 11.27796,-11.09671 24.40076,-24.43421 13.12279,-13.3375 24.17983,-24.44496 24.57119,-24.68324 0.52531,-0.31984 2.39741,1.24885 7.15189,5.99278 3.54218,3.53432 6.44033,6.65684 6.44033,6.93895 0,0.28211 -10.9266,11.60408 -24.28133,25.15993 -13.35472,13.55586 -24.21097,24.92678 -24.125,25.26873 0.086,0.34194 2.59209,2.96187 5.56913,5.82208 l 5.4128,5.20036 7.82865,-7.9748 C 220.6505,553.01657 236.77587,537 237.40908,537 c 0.39672,0 4.19408,3.31875 8.43859,7.375 4.24452,4.05625 9.85417,9.37585 12.46589,11.82133 l 4.74859,4.44632 18.28065,-18.19632 c 10.12488,-10.07819 18.38215,-17.92075 18.50816,-17.57862 0.12513,0.33974 -0.2277,1.257 -0.78408,2.03836 -1.44841,2.0341 -35.51888,35.59393 -36.13553,35.59393 -0.2826,0 -6.03226,-5.29928 -12.77701,-11.77618 -6.74476,-6.4769 -12.57143,-11.70815 -12.94816,-11.625 -0.37672,0.0831 -11.42227,11.06368 -24.54564,24.40118 -13.12338,13.3375 -24.20941,24.31283 -24.63562,24.38963 -0.44146,0.0796 -3.56919,-2.66403 -7.26838,-6.37567 l -6.49346,-6.51532 7.74904,-7.87432 c 4.26197,-4.33087 15.34028,-15.53829 24.61846,-24.90537 9.27818,-9.36709 16.86942,-17.26349 16.86942,-17.54759 0,-0.89437 -10.47444,-10.75055 -11.24578,-10.58199 -0.40431,0.0883 -11.36362,10.96063 -24.35403,24.16063 -12.99041,13.2 -24.04432,24.31124 -24.56425,24.69166 -0.87156,0.63769 -1.93712,-0.29869 -13.65542,-12 L 136.97043,538.25 l -24.67379,25 -24.673805,25 -6.56142,-6.47529 z M 280.55681,581.5604 c -3.33124,-3.54178 -6.05681,-6.6415 -6.05681,-6.88828 0,-0.73939 24.9529,-25.38588 25.32488,-25.01391 0.7746,0.7746 -1.51739,3.35782 -11.68124,13.16553 -5.87147,5.66573 -10.91105,10.74167 -11.19909,11.27986 -0.45591,0.85189 0.19039,1.70057 4.99387,6.5576 l 5.51757,5.57907 5.94334,-5.87013 c 3.26883,-3.22858 6.09124,-5.87014 6.272,-5.87014 0.18077,0 0.32867,0.3564 0.32867,0.79201 C 300,576.37833 288.54517,588 287.47445,588 c -0.47345,0 -3.58639,-2.89782 -6.91764,-6.4396 z M 0,549.66838 c 0,-0.45738 5.337923,-6.19946 11.862051,-12.76016 l 11.862051,-11.92856 -5.600066,-5.60007 -5.600067,-5.60006 -5.9333195,5.86023 C 3.3273239,522.86289 0.509431,525.5 0.32866515,525.5 0.14789932,525.5 0,525.14359 0,524.70798 0,523.65922 11.436158,512 12.464859,512 13.480703,512 25.5,524.0058 25.5,525.02051 25.5,525.74825 1.0702973,550.5 0.35202479,550.5 0.15841115,550.5 0,550.12577 0,549.66838 Z M 37.441231,513.74097 C 24.071407,500.40844 12.817186,489.5 12.43185,489.5 c -0.385336,0 -2.9463905,2.26517 -5.691231,5.03373 C 1.28728,500.03417 0,501.02698 0,499.73243 c 0,-0.84326 10.067225,-11.4632 11.692725,-12.33468 0.815166,-0.43704 2.74332,1.27784 14.25,12.67378 7.319002,7.24856 18.537521,18.3512 24.930045,24.67253 l 11.62277,11.49333 5.50223,-5.48517 c 3.026225,-3.01684 5.501225,-5.714 5.5,-5.9937 -0.001,-0.27969 -10.96998,-11.30154 -24.375001,-24.49301 -13.405023,-13.19147 -24.567728,-24.29958 -24.80601,-24.68468 -0.317474,-0.51309 1.283877,-2.42112 5.992785,-7.1405 C 33.843859,464.89814 37.03002,462 37.389901,462 c 0.359881,0 11.789581,11.06747 25.399334,24.59438 L 87.53424,511.18876 99.66555,499.09438 C 106.33777,492.44247 112.0219,487 112.29695,487 c 0.27506,0 1.38951,0.91954 2.47657,2.04343 1.08706,1.12389 12.28285,12.18872 24.87951,24.58852 l 22.90304,22.5451 5.47196,-5.455 c 3.00958,-3.00025 5.47096,-5.68383 5.46974,-5.96353 -0.001,-0.27969 -10.96998,-11.30154 -24.375,-24.49301 -13.40503,-13.19147 -24.56773,-24.29958 -24.80601,-24.68468 -0.31747,-0.51309 1.28387,-2.42112 5.99279,-7.14051 3.53431,-3.54218 6.72047,-6.44032 7.08035,-6.44032 0.35988,0 11.79177,11.06965 25.40419,24.59921 l 24.74986,24.59921 12.10678,-12.09921 C 206.30946,492.44465 211.9914,487 212.27727,487 c 0.28588,0 1.40919,0.91954 2.49625,2.04343 1.08707,1.12389 12.28284,12.18872 24.87952,24.58852 l 22.90303,22.5451 5.47197,-5.455 c 3.00958,-3.00025 5.47096,-5.68383 5.46973,-5.96353 -10e-4,-0.27969 -10.96998,-11.30154 -24.375,-24.49301 -13.40502,-13.19147 -24.56773,-24.29958 -24.80601,-24.68468 -0.31747,-0.51309 1.28388,-2.42112 5.99279,-7.14051 3.53431,-3.54218 6.71379,-6.44032 7.06551,-6.44032 0.35172,0 11.67873,10.9125 25.17112,24.25 13.4924,13.3375 24.79959,24.25 25.12711,24.25 0.32751,0 2.84125,-2.26518 5.58609,-5.03373 5.4618,-5.50897 6.74062,-6.49397 6.74062,-5.19185 0,1.03033 -11.49136,12.80898 -12.31033,12.61808 -0.33624,-0.0784 -11.76574,-11.13282 -25.39889,-24.56542 l -24.78753,-24.42292 -2.37663,2.00973 c -4.30039,3.63651 -8.72967,8.43503 -8.55031,9.26307 0.0955,0.441 11.08619,11.53797 24.42369,24.65995 13.3375,13.12197 24.32273,24.15167 24.41163,24.51042 C 275.61625,525.17316 263.52794,538 262.54503,538 262.14384,538 250.705,526.93503 237.1254,513.4112 L 212.43522,488.82239 200.33886,500.9112 C 193.68586,507.56003 187.94138,513 187.57335,513 c -0.36803,0 -11.77492,-11.05447 -25.34864,-24.56548 l -24.6795,-24.56549 -2.39761,2.0273 c -4.31851,3.65151 -8.75102,8.45086 -8.57129,9.28063 0.0955,0.441 11.08619,11.53797 24.42369,24.65995 13.3375,13.12197 24.32273,24.15167 24.41163,24.51042 C 175.61673,525.1751 163.52676,538 162.54132,538 162.13808,538 150.85569,527.0875 137.46933,513.75 124.08298,500.4125 112.8181,489.5 112.43626,489.5 112.05443,489.5 106.45811,494.7875 100,501.25 93.54189,507.7125 87.940355,513 87.552145,513 87.163935,513 75.84728,502.03125 62.40402,488.625 48.960763,475.21875 37.773981,464.18455 37.544505,464.10455 c -0.229476,-0.08 -2.819509,2.14814 -5.755629,4.95142 -3.584582,3.4224 -5.289197,5.39699 -5.188637,6.01042 0.08237,0.50245 11.062261,11.64944 24.399761,24.7711 13.3375,13.12166 24.32273,24.15109 24.411625,24.50984 0.20997,0.84738 -11.899445,13.65549 -12.89938,13.64364 -0.419235,-0.005 -11.70119,-10.91745 -25.071014,-24.25 z m 43.315309,-32.22701 -6.493465,-6.51532 7.74904,-7.87432 c 4.26197,-4.33087 15.34028,-15.5383 24.618465,-24.90537 C 115.90876,432.85186 123.5,424.95546 123.5,424.67136 123.5,423.90857 113.17786,414 112.38323,414 c -0.37364,0 -3.81561,3.20625 -7.64881,7.125 C 84.42199,441.89073 63.29723,463 62.828695,463 c -0.29301,0 -6.128765,-5.56875 -12.968344,-12.375 l -12.4356,-12.375 -18.43073,18.625 C 8.8571195,467.11875 0.43655048,475.5 0.28164547,475.5 c -1.43069947,0 2.24040823,-4.1096 17.99672153,-20.14633 10.053101,-10.23202 18.635036,-18.68257 19.070963,-18.779 0.497198,-0.10998 5.416807,4.44611 13.19998,12.22461 l 12.407385,12.39994 5.204575,-5.22461 C 71.023785,453.10108 81.888175,442.0875 92.304355,431.5 c 10.416175,-10.5875 19.248215,-19.44496 19.626755,-19.68324 0.50032,-0.31494 2.44677,1.32138 7.12857,5.99279 3.54218,3.53431 6.44032,6.65683 6.44032,6.93894 0,0.28211 -10.9266,11.60408 -24.28132,25.15993 -13.35473,13.55586 -24.21098,24.92678 -24.125005,25.26873 0.08598,0.34194 2.592085,2.96187 5.56913,5.82208 l 5.4128,5.20036 7.828645,-7.9748 c 25.44487,-25.91988 40.88039,-41.22258 41.56464,-41.20698 0.42961,0.01 6.28652,5.28096 13.01536,11.7137 7.276,6.95582 12.46864,11.55862 12.81258,11.35719 0.31808,-0.18628 11.19501,-11.1387 24.17096,-24.3387 12.97595,-13.2 23.97279,-24.06284 24.43742,-24.13964 0.52394,-0.0866 3.30695,2.33081 7.32769,6.36509 l 6.4829,6.50473 -10.73078,10.88491 c -5.90193,5.9867 -17.02521,17.24385 -24.71841,25.01589 l -13.98762,14.13099 5.4855,5.50523 c 3.01703,3.02787 5.74459,5.44393 6.06124,5.36901 0.31666,-0.0749 11.30609,-11.04871 24.42096,-24.38621 14.61673,-14.86486 24.26282,-24.30433 24.92426,-24.39037 0.82612,-0.10747 3.8909,2.676 13.07514,11.875 6.59786,6.60845 12.22406,12.01537 12.50268,12.01537 0.27862,0 8.38038,-7.88897 18.00391,-17.53106 9.62353,-9.64208 17.89107,-17.74999 18.37232,-18.01759 0.68333,-0.37996 0.875,-0.29744 0.875,0.37668 0,0.84812 -34.8615,36.25636 -36.67991,37.25516 -0.80206,0.44054 -2.62554,-1.17991 -13.26296,-11.78621 -6.78318,-6.76334 -12.55222,-12.30059 -12.82009,-12.305 -0.26787,-0.005 -11.54065,11.18934 -25.05063,24.875 L 187.62283,488.25 181.06141,481.77471 C 177.45264,478.21329 174.5,475.04314 174.5,474.72993 174.5,474.41673 185.4125,463.06326 198.75,449.5 212.0875,435.93674 223,424.58087 223,424.26472 223,423.57444 212.85406,413.5 212.15889,413.5 c -0.26735,0 -11.34553,11.025 -24.61817,24.5 -13.27265,13.475 -24.35508,24.5 -24.62764,24.5 -0.27255,0 -6.01398,-5.29928 -12.75874,-11.77618 -6.74475,-6.4769 -12.57142,-11.70815 -12.94815,-11.625 -0.37673,0.0831 -11.42227,11.06368 -24.54565,24.40118 -13.12338,13.3375 -24.209405,24.31283 -24.635615,24.38963 -0.44146,0.0796 -3.56919,-2.66403 -7.268385,-6.37567 z m 200.35303,0.43967 c -3.49776,-3.3255 -6.43846,-6.39487 -6.53487,-6.82084 -0.16818,-0.743 22.60342,-24.10046 24.5503,-25.18192 0.68066,-0.3781 0.875,-0.29745 0.875,0.36316 0,0.46706 -5.34375,6.23098 -11.875,12.8087 l -11.875,11.9595 5.5,5.19269 c 3.025,2.85597 5.72922,5.19997 6.00938,5.20888 0.28016,0.009 2.75516,-2.24898 5.5,-5.01753 C 298.72118,474.9573 300,473.9723 300,475.27442 300,476.10133 288.68833,488 287.90221,488 c -0.23818,0 -3.29487,-2.72087 -6.79264,-6.04637 z M 0,449.66838 C 0,449.211 5.3198425,443.4871 11.821872,436.94862 l 11.821871,-11.88815 -2.03418,-2.40524 c -1.118799,-1.32288 -3.628971,-3.97701 -5.57816,-5.89806 l -3.543979,-3.49283 -6.033359,6.11783 C 3.1357182,422.74698 0.32604795,425.5 0.21035352,425.5 0.09465908,425.5 0,425.14222 0,424.70494 0,423.78167 11.873758,411.5 12.766357,411.5 13.579082,411.5 25.5,424.21966 25.5,425.08684 25.5,425.77044 1.0284949,450.5 0.35202479,450.5 0.15841115,450.5 0,450.12577 0,449.66838 Z M 37.104374,413.41168 12.45875,388.84394 6.55804,394.67197 C 3.3126496,397.87738 0.509431,400.5 0.32866515,400.5 0.14789932,400.5 0,400.14359 0,399.70798 0,398.80691 11.363635,387 12.230883,387 c 0.311393,0 1.455583,0.91954 2.542643,2.04343 1.087061,1.12389 12.28284,12.18872 24.87951,24.58852 l 22.903034,22.5451 5.471965,-5.455 c 3.00958,-3.00024 5.47096,-5.68384 5.469735,-5.96353 -0.001,-0.27969 -10.96998,-11.30154 -24.375001,-24.49301 -13.405023,-13.19147 -24.567728,-24.29958 -24.80601,-24.68468 -0.317474,-0.51309 1.283877,-2.42112 5.992785,-7.14051 C 33.843859,364.89814 37.029592,362 37.388951,362 c 0.359359,0 11.633997,10.9125 25.054749,24.25 13.420755,13.3375 24.6069,24.25 24.8581,24.25 0.251195,0 5.404805,-4.96502 11.45246,-11.03337 6.04766,-6.06836 11.6414,-11.37555 12.43054,-11.79377 l 1.4348,-0.76039 13.5652,13.41454 c 7.46086,7.378 18.68294,18.4761 24.93797,24.66246 l 11.37277,11.24792 5.50223,-5.48517 c 3.02623,-3.01684 5.50122,-5.714 5.5,-5.99369 -0.001,-0.2797 -10.96998,-11.30155 -24.375,-24.49302 -13.40503,-13.19147 -24.56773,-24.29958 -24.80601,-24.68468 -0.31747,-0.51309 1.28387,-2.42112 5.99279,-7.1405 3.53431,-3.54219 6.72047,-6.44033 7.08035,-6.44033 0.35988,0 11.79177,11.06964 25.40419,24.59921 l 24.74986,24.59921 12.10678,-12.09921 C 206.30946,392.44464 211.9914,387 212.27727,387 c 0.28588,0 1.40919,0.91954 2.49625,2.04343 1.08707,1.12389 12.28284,12.18872 24.87952,24.58852 l 22.90303,22.5451 5.47197,-5.455 c 3.00958,-3.00024 5.47096,-5.68384 5.46973,-5.96353 -10e-4,-0.27969 -10.96998,-11.30154 -24.375,-24.49301 -13.40502,-13.19147 -24.56773,-24.29958 -24.80601,-24.68468 -0.31747,-0.51309 1.28388,-2.42112 5.99279,-7.14051 3.53431,-3.54218 6.72047,-6.44032 7.08035,-6.44032 0.35988,0 11.78665,11.06457 25.39283,24.58791 l 24.7385,24.58792 6.06016,-5.96292 c 3.42696,-3.37196 6.15509,-5.69451 6.27862,-5.3452 0.12015,0.33974 -0.22886,1.23974 -0.77559,2 C 297.53163,404.02695 288.21199,413 287.52215,413 c -0.33987,0 -11.72371,-11.05447 -25.29744,-24.56548 l -24.6795,-24.56549 -2.3976,2.02729 c -4.31851,3.65152 -8.75103,8.45087 -8.57129,9.28064 0.0955,0.441 11.08618,11.53798 24.42368,24.65995 13.3375,13.12197 24.32273,24.15166 24.41163,24.51042 C 275.61673,425.17509 263.52676,438 262.54132,438 c -0.40324,0 -11.68563,-10.9125 -25.07199,-24.25 -13.38636,-13.3375 -24.65124,-24.25 -25.03307,-24.25 -0.38183,0 -5.97815,5.2875 -12.43626,11.75 -6.45811,6.4625 -12.04662,11.75 -12.41891,11.75 -0.37228,0 -11.78266,-11.05447 -25.35638,-24.56548 l -24.6795,-24.56549 -2.3976,2.02729 c -4.31851,3.65152 -8.75103,8.45087 -8.57129,9.28064 0.0955,0.441 11.08618,11.53798 24.42368,24.65995 13.3375,13.12197 24.32273,24.15166 24.41163,24.51042 C 175.62077,425.19142 163.51681,438 162.51001,438 c -0.42046,0 -10.21347,-9.46457 -21.76224,-21.03239 -11.54878,-11.56781 -22.7382,-22.61365 -24.86539,-24.54632 l -3.86762,-3.51392 -12.01394,11.67131 c -6.607665,6.41922 -12.35577,11.74547 -12.773565,11.8361 -0.45758,0.0993 -10.48524,-9.52012 -25.218905,-24.1921 l -24.459277,-24.35688 -2.399537,2.02891 c -4.335139,3.66554 -8.753046,8.45188 -8.573221,9.28817 0.09553,0.44426 11.086185,11.54073 24.423685,24.65884 13.3375,13.11811 24.32273,24.14514 24.411625,24.5045 0.20999,0.84891 -11.89954,13.65698 -12.89938,13.64349 -0.419235,-0.006 -11.852775,-11.06577 -25.407871,-24.57803 z M 81.061415,381.7747 C 77.45264,378.21329 74.5,375.04314 74.5,374.72993 74.5,374.41672 85.4125,363.06326 98.75,349.5 112.0875,335.93675 123,324.58087 123,324.26472 123,323.57444 112.85406,313.5 112.15889,313.5 c -0.26735,0 -11.34552,11.025 -24.61817,24.5 -13.27265,13.475 -24.365475,24.5 -24.65072,24.5 -0.28525,0 -5.50034,-4.78125 -11.5891,-10.625 -6.088757,-5.84375 -11.691493,-11.17674 -12.450524,-11.8511 L 37.47032,338.7978 18.925905,357.2739 C 8.619314,367.54252 0.27932739,375.4756 0.15150811,375.13229 c -0.12649028,-0.33974 0.22170569,-1.23975 0.77376879,-2 1.8991713,-2.6154 35.8585631,-36.13227 36.5912851,-36.11448 0.403391,0.01 6.238853,5.28096 12.967693,11.7137 7.276,6.95583 12.46864,11.55862 12.81258,11.35719 0.31808,-0.18628 11.19501,-11.1387 24.17096,-24.3387 12.975945,-13.2 23.972785,-24.06284 24.437415,-24.13964 0.52394,-0.0866 3.30695,2.33082 7.32769,6.3651 l 6.4829,6.50473 -10.73078,10.8849 c -5.90192,5.9867 -17.02521,17.24385 -24.718405,25.01589 l -13.987625,14.13099 5.485505,5.50523 c 3.01703,3.02787 5.744585,5.44393 6.06124,5.36901 C 88.14239,385.31129 99.13538,374.3375 112.2546,361 c 13.7591,-13.98803 24.22984,-24.25 24.74333,-24.25 0.48961,0 6.55664,5.49492 13.4823,12.21093 l 12.59209,12.21093 5.13757,-5.21093 c 2.82566,-2.86601 13.66404,-13.87343 24.08527,-24.46093 10.42123,-10.5875 19.25741,-19.44496 19.63594,-19.68324 0.50033,-0.31495 2.44678,1.32138 7.12857,5.99278 3.54218,3.53432 6.44033,6.65685 6.44033,6.93895 0,0.28211 -10.9266,11.60408 -24.28133,25.15993 -13.35472,13.55586 -24.21097,24.92678 -24.125,25.26873 0.086,0.34194 2.59209,2.96187 5.56913,5.82208 l 5.4128,5.20036 7.82865,-7.9748 C 221.16344,352.49405 236.78381,337 237.46514,337 c 0.42754,0 6.23411,5.45335 12.90348,12.11854 l 12.12612,12.11855 18.39331,-18.36855 C 291.00438,332.76585 299.44306,324.5 299.64069,324.5 c 1.62915,0 -2.05246,4.11031 -18.00034,20.09638 C 271.54254,354.71837 262.93453,363 262.51144,363 c -0.42309,0 -6.16749,-5.40433 -12.76535,-12.00963 -6.59785,-6.60529 -12.27257,-11.94904 -12.61048,-11.875 -0.33791,0.074 -11.3517,11.04713 -24.47507,24.38463 -13.12338,13.3375 -24.20941,24.31283 -24.63562,24.38963 -0.44146,0.0795 -3.56919,-2.66403 -7.26838,-6.37567 l -6.49346,-6.51532 7.74904,-7.87432 c 4.26197,-4.33087 15.34028,-15.5383 24.61846,-24.90537 C 215.90876,332.85187 223.5,324.95545 223.5,324.67136 223.5,323.90857 213.17786,314 212.38323,314 c -0.37364,0 -3.81561,3.20625 -7.64881,7.125 C 184.55743,341.75227 163.29883,363 162.83801,363 162.55012,363 156.77302,357.4875 150,350.75 c -6.77302,-6.7375 -12.52506,-12.25361 -12.78229,-12.25802 -0.25724,-0.004 -11.52132,11.18933 -25.0313,24.875 L 87.622835,388.25 l -6.56142,-6.4753 z m 199.959385,-0.0233 c -3.58644,-3.54862 -6.5208,-6.67741 -6.5208,-6.95285 0,-0.58884 23.33988,-24.14354 24.625,-24.85165 0.67896,-0.37412 0.875,-0.29207 0.875,0.36619 0,0.46658 -5.175,6.05357 -11.5,12.41552 -6.325,6.36195 -11.5,11.80715 -11.5,12.10045 0,0.56805 9.6983,10.29652 10.56874,10.60161 0.28359,0.0994 3.11631,-2.3756 6.29494,-5.5 3.72332,-3.6598 5.86484,-5.4368 6.01971,-4.99506 0.14133,0.40313 -2.35187,3.27791 -6.0507,6.97675 l -6.29109,6.29108 -6.5208,-6.45204 z M 0,349.66838 c 0,-0.45738 5.337923,-6.19946 11.862051,-12.76017 l 11.862051,-11.92855 -5.600066,-5.60007 -5.600067,-5.60007 -5.9333195,5.86024 C 3.3273239,322.86289 0.509431,325.5 0.32866515,325.5 0.14789932,325.5 0,325.14359 0,324.70798 0,323.65922 11.436158,312 12.464859,312 13.480703,312 25.5,324.0058 25.5,325.02051 25.5,325.74825 1.0702973,350.5 0.35202479,350.5 0.15841115,350.5 0,350.12577 0,349.66838 Z M 43.116037,319.35952 C 32.877217,309.10725 24.5,300.55725 24.5,300.35952 c 0,-1.62681 4.078016,2.02063 19.852398,17.75631 l 18.160387,18.11583 5.610435,-5.61044 5.610435,-5.61043 L 61.61683,312.85696 C 54.952575,306.17236 49.5,300.54494 49.5,300.35157 49.5,300.15821 49.874608,300 50.33246,300 51.389355,300 75.5,323.93565 75.5,324.98488 75.5,325.98427 63.48329,338 62.483815,338 c -0.413455,0 -9.12896,-8.38822 -19.367778,-18.64048 z m 99.999993,0 c -10.23882,-10.25227 -18.61603,-18.80227 -18.61603,-19 0,-1.62681 4.07801,2.02063 19.8524,17.75631 l 18.16038,18.11583 5.61044,-5.61044 5.61043,-5.61043 -12.24182,-12.31751 c -6.82943,-6.87165 -11.96873,-12.41793 -11.62412,-12.54463 0.33974,-0.12492 1.23974,0.22356 2,0.77439 2.41627,1.75067 23.63229,23.34871 23.63229,24.05781 0,0.95712 -12.02886,13.01915 -12.98335,13.01915 -0.43152,0 -9.1618,-8.38822 -19.40062,-18.64048 z m 100,0 c -10.23882,-10.25227 -18.61603,-18.80227 -18.61603,-19 0,-1.62679 4.07766,2.02027 19.84952,17.75344 l 18.15752,18.11297 5.49648,-5.47944 c 3.02306,-3.01369 5.49648,-5.74626 5.49648,-6.07238 0,-0.32612 -5.27634,-5.70736 -11.7252,-11.9583 -6.44886,-6.25095 -11.8418,-11.66922 -11.98431,-12.04059 -0.14817,-0.38612 0.0693,-0.67522 0.50789,-0.67522 0.83334,0 24.84832,23.28506 25.11325,24.34994 C 275.62196,325.19542 263.51315,338 262.50328,338 c -0.42417,0 -9.14843,-8.38822 -19.38725,-18.64048 z M 81.13218,307.375 C 74.99362,301.33234 73.93478,300 75.271135,300 c 0.44347,0 3.37639,2.51137 6.51759,5.58082 l 5.711275,5.58082 5.711275,-5.58082 c 3.1412,-3.06945 6.07412,-5.58082 6.51759,-5.58082 0.616125,0 0.693915,0.20639 0.329775,0.875 C 99.27474,302.31435 88.206925,313 87.5,313 c -0.35945,0 -3.22497,-2.53125 -6.36782,-5.625 z m 99.4672,-0.54459 c -3.35466,-3.39327 -6.09938,-6.31827 -6.09938,-6.5 0,-1.26647 2.35722,0.43155 7.28872,5.25041 l 5.71128,5.58082 5.71127,-5.58082 c 4.9315,-4.81886 7.28873,-6.51688 7.28873,-5.25041 0,0.7274 -12.25364,12.66959 -13,12.66959 -0.44068,0 -3.54596,-2.77631 -6.90062,-6.16959 z m 100,0 c -3.35465,-3.39327 -6.09938,-6.31827 -6.09938,-6.5 0,-1.26647 2.35723,0.43155 7.28872,5.25041 l 5.71128,5.58082 5.71127,-5.58082 C 298.60459,300.3107 300,299.27498 300,300.54201 300,301.42931 288.4061,313 287.51702,313 c -0.45004,0 -3.56298,-2.77631 -6.91764,-6.16959 z"
         style="fill:{{pk_fill}};fill-opacity:1" />
    </g>
    <g
       transform="translate(300,0)"
       id="g83692"
       style="fill:{{pk_fill}};fill-opacity:1">
      <path
         style="fill:{{pk_fill}};fill-opacity:1"
         d="M 0,599.43364 C 0,598.61197 11.636288,587 12.45968,587 c 0.735382,0 11.788989,10.63778 12.59896,12.125 0.364139,0.66861 0.286355,0.875 -0.329773,0.875 -0.443475,0 -3.376391,-2.51137 -6.517592,-5.58082 L 12.5,588.83835 6.788725,594.41918 C 1.3668788,599.71718 0,600.72682 0,599.43364 Z M 36.667539,587.89763 C 29.975393,581.24132 24.5,575.4442 24.5,575.01512 24.5,574.01573 36.516708,562 37.516183,562 38.245021,562 75.5,598.91823 75.5,599.64048 c 0,1.62682 -4.078015,-2.02063 -19.8524,-17.75631 l -18.160387,-18.11583 -5.610435,5.61044 -5.610434,5.61043 12.116828,12.15383 C 45.047427,593.82764 50.5,599.45506 50.5,599.64843 c 0,1.52894 -3.297827,-1.27259 -13.832461,-11.7508 z M 100,599.69671 c 0,-0.47395 6.93188,-7.52224 10.13918,-10.30946 l 2.88918,-2.51077 5.77687,5.68677 c 6.19479,6.09816 7.26167,7.43675 5.9272,7.43675 -0.44152,0 -3.2254,-2.3625 -6.1864,-5.25 -2.961,-2.8875 -5.56921,-5.25 -5.79603,-5.25 -0.22682,0 -2.83503,2.3625 -5.79604,5.25 -4.6154,4.50084 -6.95396,6.16438 -6.95396,4.94671 z m 36.91838,-11.54865 C 130.36327,581.6295 125,575.97731 125,575.58766 125,574.72188 136.88214,562 137.69077,562 c 0.61337,0 37.80923,37.02985 37.80923,37.64048 0,1.62582 -4.06323,-2.00588 -19.73385,-17.63805 l -18.04183,-17.99757 -4.25222,4.37257 c -2.33873,2.40492 -4.79616,4.9969 -5.46097,5.75997 l -1.20875,1.38741 11.84881,11.8865 c 6.51684,6.53757 11.84881,12.04449 11.84881,12.23759 0,1.52314 -3.26436,-1.24109 -13.58162,-11.50083 z M 199.94136,599.125 C 200.59515,597.92455 211.73511,587 212.30544,587 c 0.25244,0 3.3775,2.925 6.94456,6.5 7.96607,7.98379 7.26686,8.96553 -0.89027,1.25 -3.05277,-2.8875 -5.76911,-5.25 -6.03631,-5.25 -0.26719,0 -2.90845,2.3625 -5.86946,5.25 -2.961,2.8875 -5.74488,5.25 -6.18639,5.25 -0.61274,0 -0.68995,-0.20712 -0.32621,-0.875 z m 36.87083,-11 c -6.6342,-6.53125 -12.25715,-12.18311 -12.49543,-12.55967 -0.31418,-0.49652 1.33275,-2.45461 5.99278,-7.125 3.53432,-3.54219 6.67209,-6.44033 6.97283,-6.44033 0.65449,0 37.02444,35.70477 37.74898,37.05859 0.40299,0.75298 0.33098,0.94141 -0.35977,0.94141 -0.47497,0 -9.02771,-8.14409 -19.00608,-18.09797 l -18.14248,-18.09797 -1.38651,1.20814 c -4.21931,3.67652 -9.63651,9.32718 -9.63651,10.0518 0,0.45984 5.19432,5.85946 11.54294,11.99915 C 249.84093,598.47287 251.21755,600 249.70478,600 c -0.45671,0 -6.25838,-5.34375 -12.89259,-11.875 z M 81.061415,581.77471 C 77.45264,578.21329 74.5,575.04314 74.5,574.72994 74.5,574.41673 85.4125,563.06326 98.75,549.5 112.0875,535.93674 123,524.58087 123,524.26472 123,523.57444 112.85406,513.5 112.15889,513.5 c -0.26735,0 -11.34552,11.025 -24.61817,24.5 -13.27265,13.475 -24.365475,24.5 -24.65072,24.5 -0.28525,0 -5.50034,-4.78125 -11.5891,-10.625 -6.088757,-5.84375 -11.691493,-11.17674 -12.450524,-11.8511 L 37.47032,538.79781 19.094473,557.1489 C 8.987758,567.24201 0.5569362,575.5 0.35931367,575.5 c -1.62915387,0 2.05245053,-4.11031 18.00033733,-20.09639 10.097809,-10.12199 18.704059,-18.3956 19.125,-18.3858 0.420942,0.01 6.270764,5.28096 12.999604,11.7137 7.276,6.95582 12.46864,11.55862 12.81258,11.35719 0.31808,-0.18628 11.19501,-11.1387 24.17096,-24.3387 12.975945,-13.2 23.972785,-24.06283 24.437415,-24.13964 0.52394,-0.0866 3.30695,2.33082 7.32769,6.36509 l 6.4829,6.50473 -10.73078,10.88491 c -5.90192,5.9867 -17.02521,17.24386 -24.718405,25.01589 l -13.987625,14.13099 5.485505,5.50523 c 3.01703,3.02787 5.744585,5.44393 6.06124,5.36901 C 88.14239,585.31129 99.13114,574.3375 112.24518,561 c 13.11403,-13.3375 24.18581,-24.32749 24.60395,-24.4222 0.45669,-0.10343 5.70857,4.76165 13.15291,12.18422 6.81596,6.79603 12.63617,12.27351 12.93379,12.17219 0.29762,-0.10132 11.27796,-11.09671 24.40076,-24.43421 13.12279,-13.3375 24.17983,-24.44496 24.57119,-24.68324 0.52531,-0.31984 2.39741,1.24885 7.15189,5.99278 3.54218,3.53432 6.44033,6.65684 6.44033,6.93895 0,0.28211 -10.9266,11.60408 -24.28133,25.15993 -13.35472,13.55586 -24.21097,24.92678 -24.125,25.26873 0.086,0.34194 2.59209,2.96187 5.56913,5.82208 l 5.4128,5.20036 7.82865,-7.9748 C 220.6505,553.01657 236.77587,537 237.40908,537 c 0.39672,0 4.19408,3.31875 8.43859,7.375 4.24452,4.05625 9.85417,9.37585 12.46589,11.82133 l 4.74859,4.44632 18.28065,-18.19632 c 10.12488,-10.07819 18.38215,-17.92075 18.50816,-17.57862 0.12513,0.33974 -0.2277,1.257 -0.78408,2.03836 -1.44841,2.0341 -35.51888,35.59393 -36.13553,35.59393 -0.2826,0 -6.03226,-5.29928 -12.77701,-11.77618 -6.74476,-6.4769 -12.57143,-11.70815 -12.94816,-11.625 -0.37672,0.0831 -11.42227,11.06368 -24.54564,24.40118 -13.12338,13.3375 -24.20941,24.31283 -24.63562,24.38963 -0.44146,0.0796 -3.56919,-2.66403 -7.26838,-6.37567 l -6.49346,-6.51532 7.74904,-7.87432 c 4.26197,-4.33087 15.34028,-15.53829 24.61846,-24.90537 9.27818,-9.36709 16.86942,-17.26349 16.86942,-17.54759 0,-0.89437 -10.47444,-10.75055 -11.24578,-10.58199 -0.40431,0.0883 -11.36362,10.96063 -24.35403,24.16063 -12.99041,13.2 -24.04432,24.31124 -24.56425,24.69166 -0.87156,0.63769 -1.93712,-0.29869 -13.65542,-12 L 136.97043,538.25 l -24.67379,25 -24.673805,25 -6.56142,-6.47529 z M 280.55681,581.5604 c -3.33124,-3.54178 -6.05681,-6.6415 -6.05681,-6.88828 0,-0.73939 24.9529,-25.38588 25.32488,-25.01391 0.7746,0.7746 -1.51739,3.35782 -11.68124,13.16553 -5.87147,5.66573 -10.91105,10.74167 -11.19909,11.27986 -0.45591,0.85189 0.19039,1.70057 4.99387,6.5576 l 5.51757,5.57907 5.94334,-5.87013 c 3.26883,-3.22858 6.09124,-5.87014 6.272,-5.87014 0.18077,0 0.32867,0.3564 0.32867,0.79201 C 300,576.37833 288.54517,588 287.47445,588 c -0.47345,0 -3.58639,-2.89782 -6.91764,-6.4396 z M 0,549.66838 c 0,-0.45738 5.337923,-6.19946 11.862051,-12.76016 l 11.862051,-11.92856 -5.600066,-5.60007 -5.600067,-5.60006 -5.9333195,5.86023 C 3.3273239,522.86289 0.509431,525.5 0.32866515,525.5 0.14789932,525.5 0,525.14359 0,524.70798 0,523.65922 11.436158,512 12.464859,512 13.480703,512 25.5,524.0058 25.5,525.02051 25.5,525.74825 1.0702973,550.5 0.35202479,550.5 0.15841115,550.5 0,550.12577 0,549.66838 Z M 37.441231,513.74097 C 24.071407,500.40844 12.817186,489.5 12.43185,489.5 c -0.385336,0 -2.9463905,2.26517 -5.691231,5.03373 C 1.28728,500.03417 0,501.02698 0,499.73243 c 0,-0.84326 10.067225,-11.4632 11.692725,-12.33468 0.815166,-0.43704 2.74332,1.27784 14.25,12.67378 7.319002,7.24856 18.537521,18.3512 24.930045,24.67253 l 11.62277,11.49333 5.50223,-5.48517 c 3.026225,-3.01684 5.501225,-5.714 5.5,-5.9937 -0.001,-0.27969 -10.96998,-11.30154 -24.375001,-24.49301 -13.405023,-13.19147 -24.567728,-24.29958 -24.80601,-24.68468 -0.317474,-0.51309 1.283877,-2.42112 5.992785,-7.1405 C 33.843859,464.89814 37.03002,462 37.389901,462 c 0.359881,0 11.789581,11.06747 25.399334,24.59438 L 87.53424,511.18876 99.66555,499.09438 C 106.33777,492.44247 112.0219,487 112.29695,487 c 0.27506,0 1.38951,0.91954 2.47657,2.04343 1.08706,1.12389 12.28285,12.18872 24.87951,24.58852 l 22.90304,22.5451 5.47196,-5.455 c 3.00958,-3.00025 5.47096,-5.68383 5.46974,-5.96353 -0.001,-0.27969 -10.96998,-11.30154 -24.375,-24.49301 -13.40503,-13.19147 -24.56773,-24.29958 -24.80601,-24.68468 -0.31747,-0.51309 1.28387,-2.42112 5.99279,-7.14051 3.53431,-3.54218 6.72047,-6.44032 7.08035,-6.44032 0.35988,0 11.79177,11.06965 25.40419,24.59921 l 24.74986,24.59921 12.10678,-12.09921 C 206.30946,492.44465 211.9914,487 212.27727,487 c 0.28588,0 1.40919,0.91954 2.49625,2.04343 1.08707,1.12389 12.28284,12.18872 24.87952,24.58852 l 22.90303,22.5451 5.47197,-5.455 c 3.00958,-3.00025 5.47096,-5.68383 5.46973,-5.96353 -10e-4,-0.27969 -10.96998,-11.30154 -24.375,-24.49301 -13.40502,-13.19147 -24.56773,-24.29958 -24.80601,-24.68468 -0.31747,-0.51309 1.28388,-2.42112 5.99279,-7.14051 3.53431,-3.54218 6.71379,-6.44032 7.06551,-6.44032 0.35172,0 11.67873,10.9125 25.17112,24.25 13.4924,13.3375 24.79959,24.25 25.12711,24.25 0.32751,0 2.84125,-2.26518 5.58609,-5.03373 5.4618,-5.50897 6.74062,-6.49397 6.74062,-5.19185 0,1.03033 -11.49136,12.80898 -12.31033,12.61808 -0.33624,-0.0784 -11.76574,-11.13282 -25.39889,-24.56542 l -24.78753,-24.42292 -2.37663,2.00973 c -4.30039,3.63651 -8.72967,8.43503 -8.55031,9.26307 0.0955,0.441 11.08619,11.53797 24.42369,24.65995 13.3375,13.12197 24.32273,24.15167 24.41163,24.51042 C 275.61625,525.17316 263.52794,538 262.54503,538 262.14384,538 250.705,526.93503 237.1254,513.4112 L 212.43522,488.82239 200.33886,500.9112 C 193.68586,507.56003 187.94138,513 187.57335,513 c -0.36803,0 -11.77492,-11.05447 -25.34864,-24.56548 l -24.6795,-24.56549 -2.39761,2.0273 c -4.31851,3.65151 -8.75102,8.45086 -8.57129,9.28063 0.0955,0.441 11.08619,11.53797 24.42369,24.65995 13.3375,13.12197 24.32273,24.15167 24.41163,24.51042 C 175.61673,525.1751 163.52676,538 162.54132,538 162.13808,538 150.85569,527.0875 137.46933,513.75 124.08298,500.4125 112.8181,489.5 112.43626,489.5 112.05443,489.5 106.45811,494.7875 100,501.25 93.54189,507.7125 87.940355,513 87.552145,513 87.163935,513 75.84728,502.03125 62.40402,488.625 48.960763,475.21875 37.773981,464.18455 37.544505,464.10455 c -0.229476,-0.08 -2.819509,2.14814 -5.755629,4.95142 -3.584582,3.4224 -5.289197,5.39699 -5.188637,6.01042 0.08237,0.50245 11.062261,11.64944 24.399761,24.7711 13.3375,13.12166 24.32273,24.15109 24.411625,24.50984 0.20997,0.84738 -11.899445,13.65549 -12.89938,13.64364 -0.419235,-0.005 -11.70119,-10.91745 -25.071014,-24.25 z m 43.315309,-32.22701 -6.493465,-6.51532 7.74904,-7.87432 c 4.26197,-4.33087 15.34028,-15.5383 24.618465,-24.90537 C 115.90876,432.85186 123.5,424.95546 123.5,424.67136 123.5,423.90857 113.17786,414 112.38323,414 c -0.37364,0 -3.81561,3.20625 -7.64881,7.125 C 84.42199,441.89073 63.29723,463 62.828695,463 c -0.29301,0 -6.128765,-5.56875 -12.968344,-12.375 l -12.4356,-12.375 -18.43073,18.625 C 8.8571195,467.11875 0.43655048,475.5 0.28164547,475.5 c -1.43069947,0 2.24040823,-4.1096 17.99672153,-20.14633 10.053101,-10.23202 18.635036,-18.68257 19.070963,-18.779 0.497198,-0.10998 5.416807,4.44611 13.19998,12.22461 l 12.407385,12.39994 5.204575,-5.22461 C 71.023785,453.10108 81.888175,442.0875 92.304355,431.5 c 10.416175,-10.5875 19.248215,-19.44496 19.626755,-19.68324 0.50032,-0.31494 2.44677,1.32138 7.12857,5.99279 3.54218,3.53431 6.44032,6.65683 6.44032,6.93894 0,0.28211 -10.9266,11.60408 -24.28132,25.15993 -13.35473,13.55586 -24.21098,24.92678 -24.125005,25.26873 0.08598,0.34194 2.592085,2.96187 5.56913,5.82208 l 5.4128,5.20036 7.828645,-7.9748 c 25.44487,-25.91988 40.88039,-41.22258 41.56464,-41.20698 0.42961,0.01 6.28652,5.28096 13.01536,11.7137 7.276,6.95582 12.46864,11.55862 12.81258,11.35719 0.31808,-0.18628 11.19501,-11.1387 24.17096,-24.3387 12.97595,-13.2 23.97279,-24.06284 24.43742,-24.13964 0.52394,-0.0866 3.30695,2.33081 7.32769,6.36509 l 6.4829,6.50473 -10.73078,10.88491 c -5.90193,5.9867 -17.02521,17.24385 -24.71841,25.01589 l -13.98762,14.13099 5.4855,5.50523 c 3.01703,3.02787 5.74459,5.44393 6.06124,5.36901 0.31666,-0.0749 11.30609,-11.04871 24.42096,-24.38621 14.61673,-14.86486 24.26282,-24.30433 24.92426,-24.39037 0.82612,-0.10747 3.8909,2.676 13.07514,11.875 6.59786,6.60845 12.22406,12.01537 12.50268,12.01537 0.27862,0 8.38038,-7.88897 18.00391,-17.53106 9.62353,-9.64208 17.89107,-17.74999 18.37232,-18.01759 0.68333,-0.37996 0.875,-0.29744 0.875,0.37668 0,0.84812 -34.8615,36.25636 -36.67991,37.25516 -0.80206,0.44054 -2.62554,-1.17991 -13.26296,-11.78621 -6.78318,-6.76334 -12.55222,-12.30059 -12.82009,-12.305 -0.26787,-0.005 -11.54065,11.18934 -25.05063,24.875 L 187.62283,488.25 181.06141,481.77471 C 177.45264,478.21329 174.5,475.04314 174.5,474.72993 174.5,474.41673 185.4125,463.06326 198.75,449.5 212.0875,435.93674 223,424.58087 223,424.26472 223,423.57444 212.85406,413.5 212.15889,413.5 c -0.26735,0 -11.34553,11.025 -24.61817,24.5 -13.27265,13.475 -24.35508,24.5 -24.62764,24.5 -0.27255,0 -6.01398,-5.29928 -12.75874,-11.77618 -6.74475,-6.4769 -12.57142,-11.70815 -12.94815,-11.625 -0.37673,0.0831 -11.42227,11.06368 -24.54565,24.40118 -13.12338,13.3375 -24.209405,24.31283 -24.635615,24.38963 -0.44146,0.0796 -3.56919,-2.66403 -7.268385,-6.37567 z m 200.35303,0.43967 c -3.49776,-3.3255 -6.43846,-6.39487 -6.53487,-6.82084 -0.16818,-0.743 22.60342,-24.10046 24.5503,-25.18192 0.68066,-0.3781 0.875,-0.29745 0.875,0.36316 0,0.46706 -5.34375,6.23098 -11.875,12.8087 l -11.875,11.9595 5.5,5.19269 c 3.025,2.85597 5.72922,5.19997 6.00938,5.20888 0.28016,0.009 2.75516,-2.24898 5.5,-5.01753 C 298.72118,474.9573 300,473.9723 300,475.27442 300,476.10133 288.68833,488 287.90221,488 c -0.23818,0 -3.29487,-2.72087 -6.79264,-6.04637 z M 0,449.66838 C 0,449.211 5.3198425,443.4871 11.821872,436.94862 l 11.821871,-11.88815 -2.03418,-2.40524 c -1.118799,-1.32288 -3.628971,-3.97701 -5.57816,-5.89806 l -3.543979,-3.49283 -6.033359,6.11783 C 3.1357182,422.74698 0.32604795,425.5 0.21035352,425.5 0.09465908,425.5 0,425.14222 0,424.70494 0,423.78167 11.873758,411.5 12.766357,411.5 13.579082,411.5 25.5,424.21966 25.5,425.08684 25.5,425.77044 1.0284949,450.5 0.35202479,450.5 0.15841115,450.5 0,450.12577 0,449.66838 Z M 37.104374,413.41168 12.45875,388.84394 6.55804,394.67197 C 3.3126496,397.87738 0.509431,400.5 0.32866515,400.5 0.14789932,400.5 0,400.14359 0,399.70798 0,398.80691 11.363635,387 12.230883,387 c 0.311393,0 1.455583,0.91954 2.542643,2.04343 1.087061,1.12389 12.28284,12.18872 24.87951,24.58852 l 22.903034,22.5451 5.471965,-5.455 c 3.00958,-3.00024 5.47096,-5.68384 5.469735,-5.96353 -0.001,-0.27969 -10.96998,-11.30154 -24.375001,-24.49301 -13.405023,-13.19147 -24.567728,-24.29958 -24.80601,-24.68468 -0.317474,-0.51309 1.283877,-2.42112 5.992785,-7.14051 C 33.843859,364.89814 37.029592,362 37.388951,362 c 0.359359,0 11.633997,10.9125 25.054749,24.25 13.420755,13.3375 24.6069,24.25 24.8581,24.25 0.251195,0 5.404805,-4.96502 11.45246,-11.03337 6.04766,-6.06836 11.6414,-11.37555 12.43054,-11.79377 l 1.4348,-0.76039 13.5652,13.41454 c 7.46086,7.378 18.68294,18.4761 24.93797,24.66246 l 11.37277,11.24792 5.50223,-5.48517 c 3.02623,-3.01684 5.50122,-5.714 5.5,-5.99369 -0.001,-0.2797 -10.96998,-11.30155 -24.375,-24.49302 -13.40503,-13.19147 -24.56773,-24.29958 -24.80601,-24.68468 -0.31747,-0.51309 1.28387,-2.42112 5.99279,-7.1405 3.53431,-3.54219 6.72047,-6.44033 7.08035,-6.44033 0.35988,0 11.79177,11.06964 25.40419,24.59921 l 24.74986,24.59921 12.10678,-12.09921 C 206.30946,392.44464 211.9914,387 212.27727,387 c 0.28588,0 1.40919,0.91954 2.49625,2.04343 1.08707,1.12389 12.28284,12.18872 24.87952,24.58852 l 22.90303,22.5451 5.47197,-5.455 c 3.00958,-3.00024 5.47096,-5.68384 5.46973,-5.96353 -10e-4,-0.27969 -10.96998,-11.30154 -24.375,-24.49301 -13.40502,-13.19147 -24.56773,-24.29958 -24.80601,-24.68468 -0.31747,-0.51309 1.28388,-2.42112 5.99279,-7.14051 3.53431,-3.54218 6.72047,-6.44032 7.08035,-6.44032 0.35988,0 11.78665,11.06457 25.39283,24.58791 l 24.7385,24.58792 6.06016,-5.96292 c 3.42696,-3.37196 6.15509,-5.69451 6.27862,-5.3452 0.12015,0.33974 -0.22886,1.23974 -0.77559,2 C 297.53163,404.02695 288.21199,413 287.52215,413 c -0.33987,0 -11.72371,-11.05447 -25.29744,-24.56548 l -24.6795,-24.56549 -2.3976,2.02729 c -4.31851,3.65152 -8.75103,8.45087 -8.57129,9.28064 0.0955,0.441 11.08618,11.53798 24.42368,24.65995 13.3375,13.12197 24.32273,24.15166 24.41163,24.51042 C 275.61673,425.17509 263.52676,438 262.54132,438 c -0.40324,0 -11.68563,-10.9125 -25.07199,-24.25 -13.38636,-13.3375 -24.65124,-24.25 -25.03307,-24.25 -0.38183,0 -5.97815,5.2875 -12.43626,11.75 -6.45811,6.4625 -12.04662,11.75 -12.41891,11.75 -0.37228,0 -11.78266,-11.05447 -25.35638,-24.56548 l -24.6795,-24.56549 -2.3976,2.02729 c -4.31851,3.65152 -8.75103,8.45087 -8.57129,9.28064 0.0955,0.441 11.08618,11.53798 24.42368,24.65995 13.3375,13.12197 24.32273,24.15166 24.41163,24.51042 C 175.62077,425.19142 163.51681,438 162.51001,438 c -0.42046,0 -10.21347,-9.46457 -21.76224,-21.03239 -11.54878,-11.56781 -22.7382,-22.61365 -24.86539,-24.54632 l -3.86762,-3.51392 -12.01394,11.67131 c -6.607665,6.41922 -12.35577,11.74547 -12.773565,11.8361 -0.45758,0.0993 -10.48524,-9.52012 -25.218905,-24.1921 l -24.459277,-24.35688 -2.399537,2.02891 c -4.335139,3.66554 -8.753046,8.45188 -8.573221,9.28817 0.09553,0.44426 11.086185,11.54073 24.423685,24.65884 13.3375,13.11811 24.32273,24.14514 24.411625,24.5045 0.20999,0.84891 -11.89954,13.65698 -12.89938,13.64349 -0.419235,-0.006 -11.852775,-11.06577 -25.407871,-24.57803 z M 81.061415,381.7747 C 77.45264,378.21329 74.5,375.04314 74.5,374.72993 74.5,374.41672 85.4125,363.06326 98.75,349.5 112.0875,335.93675 123,324.58087 123,324.26472 123,323.57444 112.85406,313.5 112.15889,313.5 c -0.26735,0 -11.34552,11.025 -24.61817,24.5 -13.27265,13.475 -24.365475,24.5 -24.65072,24.5 -0.28525,0 -5.50034,-4.78125 -11.5891,-10.625 -6.088757,-5.84375 -11.691493,-11.17674 -12.450524,-11.8511 L 37.47032,338.7978 18.925905,357.2739 C 8.619314,367.54252 0.27932739,375.4756 0.15150811,375.13229 c -0.12649028,-0.33974 0.22170569,-1.23975 0.77376879,-2 1.8991713,-2.6154 35.8585631,-36.13227 36.5912851,-36.11448 0.403391,0.01 6.238853,5.28096 12.967693,11.7137 7.276,6.95583 12.46864,11.55862 12.81258,11.35719 0.31808,-0.18628 11.19501,-11.1387 24.17096,-24.3387 12.975945,-13.2 23.972785,-24.06284 24.437415,-24.13964 0.52394,-0.0866 3.30695,2.33082 7.32769,6.3651 l 6.4829,6.50473 -10.73078,10.8849 c -5.90192,5.9867 -17.02521,17.24385 -24.718405,25.01589 l -13.987625,14.13099 5.485505,5.50523 c 3.01703,3.02787 5.744585,5.44393 6.06124,5.36901 C 88.14239,385.31129 99.13538,374.3375 112.2546,361 c 13.7591,-13.98803 24.22984,-24.25 24.74333,-24.25 0.48961,0 6.55664,5.49492 13.4823,12.21093 l 12.59209,12.21093 5.13757,-5.21093 c 2.82566,-2.86601 13.66404,-13.87343 24.08527,-24.46093 10.42123,-10.5875 19.25741,-19.44496 19.63594,-19.68324 0.50033,-0.31495 2.44678,1.32138 7.12857,5.99278 3.54218,3.53432 6.44033,6.65685 6.44033,6.93895 0,0.28211 -10.9266,11.60408 -24.28133,25.15993 -13.35472,13.55586 -24.21097,24.92678 -24.125,25.26873 0.086,0.34194 2.59209,2.96187 5.56913,5.82208 l 5.4128,5.20036 7.82865,-7.9748 C 221.16344,352.49405 236.78381,337 237.46514,337 c 0.42754,0 6.23411,5.45335 12.90348,12.11854 l 12.12612,12.11855 18.39331,-18.36855 C 291.00438,332.76585 299.44306,324.5 299.64069,324.5 c 1.62915,0 -2.05246,4.11031 -18.00034,20.09638 C 271.54254,354.71837 262.93453,363 262.51144,363 c -0.42309,0 -6.16749,-5.40433 -12.76535,-12.00963 -6.59785,-6.60529 -12.27257,-11.94904 -12.61048,-11.875 -0.33791,0.074 -11.3517,11.04713 -24.47507,24.38463 -13.12338,13.3375 -24.20941,24.31283 -24.63562,24.38963 -0.44146,0.0795 -3.56919,-2.66403 -7.26838,-6.37567 l -6.49346,-6.51532 7.74904,-7.87432 c 4.26197,-4.33087 15.34028,-15.5383 24.61846,-24.90537 C 215.90876,332.85187 223.5,324.95545 223.5,324.67136 223.5,323.90857 213.17786,314 212.38323,314 c -0.37364,0 -3.81561,3.20625 -7.64881,7.125 C 184.55743,341.75227 163.29883,363 162.83801,363 162.55012,363 156.77302,357.4875 150,350.75 c -6.77302,-6.7375 -12.52506,-12.25361 -12.78229,-12.25802 -0.25724,-0.004 -11.52132,11.18933 -25.0313,24.875 L 87.622835,388.25 81.061415,381.7747 Z M 281.0208,381.7514 c -3.58644,-3.54862 -6.5208,-6.67741 -6.5208,-6.95285 0,-0.58884 23.33988,-24.14354 24.625,-24.85165 0.67896,-0.37412 0.875,-0.29207 0.875,0.36619 0,0.46658 -5.175,6.05357 -11.5,12.41552 -6.325,6.36195 -11.5,11.80715 -11.5,12.10045 0,0.56805 9.6983,10.29652 10.56874,10.60161 0.28359,0.0994 3.11631,-2.3756 6.29494,-5.5 3.72332,-3.6598 5.86484,-5.4368 6.01971,-4.99506 0.14133,0.40313 -2.35187,3.27791 -6.0507,6.97675 l -6.29109,6.29108 -6.5208,-6.45204 z M 0,349.66838 c 0,-0.45738 5.337923,-6.19946 11.862051,-12.76017 l 11.862051,-11.92855 -5.600066,-5.60007 -5.600067,-5.60007 -5.9333195,5.86024 C 3.3273239,322.86289 0.509431,325.5 0.32866515,325.5 0.14789932,325.5 0,325.14359 0,324.70798 0,323.65922 11.436158,312 12.464859,312 13.480703,312 25.5,324.0058 25.5,325.02051 25.5,325.74825 1.0702973,350.5 0.35202479,350.5 0.15841115,350.5 0,350.12577 0,349.66838 Z M 43.116037,319.35952 C 32.877217,309.10725 24.5,300.55725 24.5,300.35952 c 0,-1.62681 4.078016,2.02063 19.852398,17.75631 l 18.160387,18.11583 5.610435,-5.61044 5.610435,-5.61043 L 61.61683,312.85696 C 54.952575,306.17236 49.5,300.54494 49.5,300.35157 49.5,300.15821 49.874608,300 50.33246,300 51.389355,300 75.5,323.93565 75.5,324.98488 75.5,325.98427 63.48329,338 62.483815,338 c -0.413455,0 -9.12896,-8.38822 -19.367778,-18.64048 z m 99.999993,0 c -10.23882,-10.25227 -18.61603,-18.80227 -18.61603,-19 0,-1.62681 4.07801,2.02063 19.8524,17.75631 l 18.16038,18.11583 5.61044,-5.61044 5.61043,-5.61043 -12.24182,-12.31751 c -6.82943,-6.87165 -11.96873,-12.41793 -11.62412,-12.54463 0.33974,-0.12492 1.23974,0.22356 2,0.77439 2.41627,1.75067 23.63229,23.34871 23.63229,24.05781 0,0.95712 -12.02886,13.01915 -12.98335,13.01915 -0.43152,0 -9.1618,-8.38822 -19.40062,-18.64048 z m 100,0 c -10.23882,-10.25227 -18.61603,-18.80227 -18.61603,-19 0,-1.62679 4.07766,2.02027 19.84952,17.75344 l 18.15752,18.11297 5.49648,-5.47944 c 3.02306,-3.01369 5.49648,-5.74626 5.49648,-6.07238 0,-0.32612 -5.27634,-5.70736 -11.7252,-11.9583 -6.44886,-6.25095 -11.8418,-11.66922 -11.98431,-12.04059 -0.14817,-0.38612 0.0693,-0.67522 0.50789,-0.67522 0.83334,0 24.84832,23.28506 25.11325,24.34994 C 275.62196,325.19542 263.51315,338 262.50328,338 c -0.42417,0 -9.14843,-8.38822 -19.38725,-18.64048 z M 81.13218,307.375 C 74.99362,301.33234 73.93478,300 75.271135,300 c 0.44347,0 3.37639,2.51137 6.51759,5.58082 l 5.711275,5.58082 5.711275,-5.58082 c 3.1412,-3.06945 6.07412,-5.58082 6.51759,-5.58082 0.616125,0 0.693915,0.20639 0.329775,0.875 C 99.27474,302.31435 88.206925,313 87.5,313 c -0.35945,0 -3.22497,-2.53125 -6.36782,-5.625 z m 99.4672,-0.54459 c -3.35466,-3.39327 -6.09938,-6.31827 -6.09938,-6.5 0,-1.26647 2.35722,0.43155 7.28872,5.25041 l 5.71128,5.58082 5.71127,-5.58082 c 4.9315,-4.81886 7.28873,-6.51688 7.28873,-5.25041 0,0.7274 -12.25364,12.66959 -13,12.66959 -0.44068,0 -3.54596,-2.77631 -6.90062,-6.16959 z m 100,0 c -3.35465,-3.39327 -6.09938,-6.31827 -6.09938,-6.5 0,-1.26647 2.35723,0.43155 7.28872,5.25041 l 5.71128,5.58082 5.71127,-5.58082 C 298.60459,300.3107 300,299.27498 300,300.54201 300,301.42931 288.4061,313 287.51702,313 c -0.45004,0 -3.56298,-2.77631 -6.91764,-6.16959 z"
         id="path83694"
         inkscape:connector-curvature="0" />
    </g>
  </g>
  <g
     id="g83706"
     transform="translate(0,-299.92613)">
    <g
       id="g83708"
       style="fill:{{pk_fill}};fill-opacity:1">
      <path
         style="fill:{{pk_fill}};fill-opacity:1"
         d="M 0,599.43364 C 0,598.61197 11.636288,587 12.45968,587 c 0.735382,0 11.788989,10.63778 12.59896,12.125 0.364139,0.66861 0.286355,0.875 -0.329773,0.875 -0.443475,0 -3.376391,-2.51137 -6.517592,-5.58082 L 12.5,588.83835 6.788725,594.41918 C 1.3668788,599.71718 0,600.72682 0,599.43364 Z M 36.667539,587.89763 C 29.975393,581.24132 24.5,575.4442 24.5,575.01512 24.5,574.01573 36.516708,562 37.516183,562 38.245021,562 75.5,598.91823 75.5,599.64048 c 0,1.62682 -4.078015,-2.02063 -19.8524,-17.75631 l -18.160387,-18.11583 -5.610435,5.61044 -5.610434,5.61043 12.116828,12.15383 C 45.047427,593.82764 50.5,599.45506 50.5,599.64843 c 0,1.52894 -3.297827,-1.27259 -13.832461,-11.7508 z M 100,599.69671 c 0,-0.47395 6.93188,-7.52224 10.13918,-10.30946 l 2.88918,-2.51077 5.77687,5.68677 c 6.19479,6.09816 7.26167,7.43675 5.9272,7.43675 -0.44152,0 -3.2254,-2.3625 -6.1864,-5.25 -2.961,-2.8875 -5.56921,-5.25 -5.79603,-5.25 -0.22682,0 -2.83503,2.3625 -5.79604,5.25 -4.6154,4.50084 -6.95396,6.16438 -6.95396,4.94671 z m 36.91838,-11.54865 C 130.36327,581.6295 125,575.97731 125,575.58766 125,574.72188 136.88214,562 137.69077,562 c 0.61337,0 37.80923,37.02985 37.80923,37.64048 0,1.62582 -4.06323,-2.00588 -19.73385,-17.63805 l -18.04183,-17.99757 -4.25222,4.37257 c -2.33873,2.40492 -4.79616,4.9969 -5.46097,5.75997 l -1.20875,1.38741 11.84881,11.8865 c 6.51684,6.53757 11.84881,12.04449 11.84881,12.23759 0,1.52314 -3.26436,-1.24109 -13.58162,-11.50083 z M 199.94136,599.125 C 200.59515,597.92455 211.73511,587 212.30544,587 c 0.25244,0 3.3775,2.925 6.94456,6.5 7.96607,7.98379 7.26686,8.96553 -0.89027,1.25 -3.05277,-2.8875 -5.76911,-5.25 -6.03631,-5.25 -0.26719,0 -2.90845,2.3625 -5.86946,5.25 -2.961,2.8875 -5.74488,5.25 -6.18639,5.25 -0.61274,0 -0.68995,-0.20712 -0.32621,-0.875 z m 36.87083,-11 c -6.6342,-6.53125 -12.25715,-12.18311 -12.49543,-12.55967 -0.31418,-0.49652 1.33275,-2.45461 5.99278,-7.125 3.53432,-3.54219 6.67209,-6.44033 6.97283,-6.44033 0.65449,0 37.02444,35.70477 37.74898,37.05859 0.40299,0.75298 0.33098,0.94141 -0.35977,0.94141 -0.47497,0 -9.02771,-8.14409 -19.00608,-18.09797 l -18.14248,-18.09797 -1.38651,1.20814 c -4.21931,3.67652 -9.63651,9.32718 -9.63651,10.0518 0,0.45984 5.19432,5.85946 11.54294,11.99915 C 249.84093,598.47287 251.21755,600 249.70478,600 c -0.45671,0 -6.25838,-5.34375 -12.89259,-11.875 z M 81.061415,581.77471 C 77.45264,578.21329 74.5,575.04314 74.5,574.72994 74.5,574.41673 85.4125,563.06326 98.75,549.5 112.0875,535.93674 123,524.58087 123,524.26472 123,523.57444 112.85406,513.5 112.15889,513.5 c -0.26735,0 -11.34552,11.025 -24.61817,24.5 -13.27265,13.475 -24.365475,24.5 -24.65072,24.5 -0.28525,0 -5.50034,-4.78125 -11.5891,-10.625 -6.088757,-5.84375 -11.691493,-11.17674 -12.450524,-11.8511 L 37.47032,538.79781 19.094473,557.1489 C 8.987758,567.24201 0.5569362,575.5 0.35931367,575.5 c -1.62915387,0 2.05245053,-4.11031 18.00033733,-20.09639 10.097809,-10.12199 18.704059,-18.3956 19.125,-18.3858 0.420942,0.01 6.270764,5.28096 12.999604,11.7137 7.276,6.95582 12.46864,11.55862 12.81258,11.35719 0.31808,-0.18628 11.19501,-11.1387 24.17096,-24.3387 12.975945,-13.2 23.972785,-24.06283 24.437415,-24.13964 0.52394,-0.0866 3.30695,2.33082 7.32769,6.36509 l 6.4829,6.50473 -10.73078,10.88491 c -5.90192,5.9867 -17.02521,17.24386 -24.718405,25.01589 l -13.987625,14.13099 5.485505,5.50523 c 3.01703,3.02787 5.744585,5.44393 6.06124,5.36901 C 88.14239,585.31129 99.13114,574.3375 112.24518,561 c 13.11403,-13.3375 24.18581,-24.32749 24.60395,-24.4222 0.45669,-0.10343 5.70857,4.76165 13.15291,12.18422 6.81596,6.79603 12.63617,12.27351 12.93379,12.17219 0.29762,-0.10132 11.27796,-11.09671 24.40076,-24.43421 13.12279,-13.3375 24.17983,-24.44496 24.57119,-24.68324 0.52531,-0.31984 2.39741,1.24885 7.15189,5.99278 3.54218,3.53432 6.44033,6.65684 6.44033,6.93895 0,0.28211 -10.9266,11.60408 -24.28133,25.15993 -13.35472,13.55586 -24.21097,24.92678 -24.125,25.26873 0.086,0.34194 2.59209,2.96187 5.56913,5.82208 l 5.4128,5.20036 7.82865,-7.9748 C 220.6505,553.01657 236.77587,537 237.40908,537 c 0.39672,0 4.19408,3.31875 8.43859,7.375 4.24452,4.05625 9.85417,9.37585 12.46589,11.82133 l 4.74859,4.44632 18.28065,-18.19632 c 10.12488,-10.07819 18.38215,-17.92075 18.50816,-17.57862 0.12513,0.33974 -0.2277,1.257 -0.78408,2.03836 -1.44841,2.0341 -35.51888,35.59393 -36.13553,35.59393 -0.2826,0 -6.03226,-5.29928 -12.77701,-11.77618 -6.74476,-6.4769 -12.57143,-11.70815 -12.94816,-11.625 -0.37672,0.0831 -11.42227,11.06368 -24.54564,24.40118 -13.12338,13.3375 -24.20941,24.31283 -24.63562,24.38963 -0.44146,0.0796 -3.56919,-2.66403 -7.26838,-6.37567 l -6.49346,-6.51532 7.74904,-7.87432 c 4.26197,-4.33087 15.34028,-15.53829 24.61846,-24.90537 9.27818,-9.36709 16.86942,-17.26349 16.86942,-17.54759 0,-0.89437 -10.47444,-10.75055 -11.24578,-10.58199 -0.40431,0.0883 -11.36362,10.96063 -24.35403,24.16063 -12.99041,13.2 -24.04432,24.31124 -24.56425,24.69166 -0.87156,0.63769 -1.93712,-0.29869 -13.65542,-12 L 136.97043,538.25 l -24.67379,25 -24.673805,25 -6.56142,-6.47529 z M 280.55681,581.5604 c -3.33124,-3.54178 -6.05681,-6.6415 -6.05681,-6.88828 0,-0.73939 24.9529,-25.38588 25.32488,-25.01391 0.7746,0.7746 -1.51739,3.35782 -11.68124,13.16553 -5.87147,5.66573 -10.91105,10.74167 -11.19909,11.27986 -0.45591,0.85189 0.19039,1.70057 4.99387,6.5576 l 5.51757,5.57907 5.94334,-5.87013 c 3.26883,-3.22858 6.09124,-5.87014 6.272,-5.87014 0.18077,0 0.32867,0.3564 0.32867,0.79201 C 300,576.37833 288.54517,588 287.47445,588 c -0.47345,0 -3.58639,-2.89782 -6.91764,-6.4396 z M 0,549.66838 c 0,-0.45738 5.337923,-6.19946 11.862051,-12.76016 l 11.862051,-11.92856 -5.600066,-5.60007 -5.600067,-5.60006 -5.9333195,5.86023 C 3.3273239,522.86289 0.509431,525.5 0.32866515,525.5 0.14789932,525.5 0,525.14359 0,524.70798 0,523.65922 11.436158,512 12.464859,512 13.480703,512 25.5,524.0058 25.5,525.02051 25.5,525.74825 1.0702973,550.5 0.35202479,550.5 0.15841115,550.5 0,550.12577 0,549.66838 Z M 37.441231,513.74097 C 24.071407,500.40844 12.817186,489.5 12.43185,489.5 c -0.385336,0 -2.9463905,2.26517 -5.691231,5.03373 C 1.28728,500.03417 0,501.02698 0,499.73243 c 0,-0.84326 10.067225,-11.4632 11.692725,-12.33468 0.815166,-0.43704 2.74332,1.27784 14.25,12.67378 7.319002,7.24856 18.537521,18.3512 24.930045,24.67253 l 11.62277,11.49333 5.50223,-5.48517 c 3.026225,-3.01684 5.501225,-5.714 5.5,-5.9937 -0.001,-0.27969 -10.96998,-11.30154 -24.375001,-24.49301 -13.405023,-13.19147 -24.567728,-24.29958 -24.80601,-24.68468 -0.317474,-0.51309 1.283877,-2.42112 5.992785,-7.1405 C 33.843859,464.89814 37.03002,462 37.389901,462 c 0.359881,0 11.789581,11.06747 25.399334,24.59438 L 87.53424,511.18876 99.66555,499.09438 C 106.33777,492.44247 112.0219,487 112.29695,487 c 0.27506,0 1.38951,0.91954 2.47657,2.04343 1.08706,1.12389 12.28285,12.18872 24.87951,24.58852 l 22.90304,22.5451 5.47196,-5.455 c 3.00958,-3.00025 5.47096,-5.68383 5.46974,-5.96353 -0.001,-0.27969 -10.96998,-11.30154 -24.375,-24.49301 -13.40503,-13.19147 -24.56773,-24.29958 -24.80601,-24.68468 -0.31747,-0.51309 1.28387,-2.42112 5.99279,-7.14051 3.53431,-3.54218 6.72047,-6.44032 7.08035,-6.44032 0.35988,0 11.79177,11.06965 25.40419,24.59921 l 24.74986,24.59921 12.10678,-12.09921 C 206.30946,492.44465 211.9914,487 212.27727,487 c 0.28588,0 1.40919,0.91954 2.49625,2.04343 1.08707,1.12389 12.28284,12.18872 24.87952,24.58852 l 22.90303,22.5451 5.47197,-5.455 c 3.00958,-3.00025 5.47096,-5.68383 5.46973,-5.96353 -10e-4,-0.27969 -10.96998,-11.30154 -24.375,-24.49301 -13.40502,-13.19147 -24.56773,-24.29958 -24.80601,-24.68468 -0.31747,-0.51309 1.28388,-2.42112 5.99279,-7.14051 3.53431,-3.54218 6.71379,-6.44032 7.06551,-6.44032 0.35172,0 11.67873,10.9125 25.17112,24.25 13.4924,13.3375 24.79959,24.25 25.12711,24.25 0.32751,0 2.84125,-2.26518 5.58609,-5.03373 5.4618,-5.50897 6.74062,-6.49397 6.74062,-5.19185 0,1.03033 -11.49136,12.80898 -12.31033,12.61808 -0.33624,-0.0784 -11.76574,-11.13282 -25.39889,-24.56542 l -24.78753,-24.42292 -2.37663,2.00973 c -4.30039,3.63651 -8.72967,8.43503 -8.55031,9.26307 0.0955,0.441 11.08619,11.53797 24.42369,24.65995 13.3375,13.12197 24.32273,24.15167 24.41163,24.51042 C 275.61625,525.17316 263.52794,538 262.54503,538 262.14384,538 250.705,526.93503 237.1254,513.4112 L 212.43522,488.82239 200.33886,500.9112 C 193.68586,507.56003 187.94138,513 187.57335,513 c -0.36803,0 -11.77492,-11.05447 -25.34864,-24.56548 l -24.6795,-24.56549 -2.39761,2.0273 c -4.31851,3.65151 -8.75102,8.45086 -8.57129,9.28063 0.0955,0.441 11.08619,11.53797 24.42369,24.65995 13.3375,13.12197 24.32273,24.15167 24.41163,24.51042 C 175.61673,525.1751 163.52676,538 162.54132,538 162.13808,538 150.85569,527.0875 137.46933,513.75 124.08298,500.4125 112.8181,489.5 112.43626,489.5 112.05443,489.5 106.45811,494.7875 100,501.25 93.54189,507.7125 87.940355,513 87.552145,513 87.163935,513 75.84728,502.03125 62.40402,488.625 48.960763,475.21875 37.773981,464.18455 37.544505,464.10455 c -0.229476,-0.08 -2.819509,2.14814 -5.755629,4.95142 -3.584582,3.4224 -5.289197,5.39699 -5.188637,6.01042 0.08237,0.50245 11.062261,11.64944 24.399761,24.7711 13.3375,13.12166 24.32273,24.15109 24.411625,24.50984 0.20997,0.84738 -11.899445,13.65549 -12.89938,13.64364 -0.419235,-0.005 -11.70119,-10.91745 -25.071014,-24.25 z m 43.315309,-32.22701 -6.493465,-6.51532 7.74904,-7.87432 c 4.26197,-4.33087 15.34028,-15.5383 24.618465,-24.90537 C 115.90876,432.85186 123.5,424.95546 123.5,424.67136 123.5,423.90857 113.17786,414 112.38323,414 c -0.37364,0 -3.81561,3.20625 -7.64881,7.125 C 84.42199,441.89073 63.29723,463 62.828695,463 c -0.29301,0 -6.128765,-5.56875 -12.968344,-12.375 l -12.4356,-12.375 -18.43073,18.625 C 8.8571195,467.11875 0.43655048,475.5 0.28164547,475.5 c -1.43069947,0 2.24040823,-4.1096 17.99672153,-20.14633 10.053101,-10.23202 18.635036,-18.68257 19.070963,-18.779 0.497198,-0.10998 5.416807,4.44611 13.19998,12.22461 l 12.407385,12.39994 5.204575,-5.22461 C 71.023785,453.10108 81.888175,442.0875 92.304355,431.5 c 10.416175,-10.5875 19.248215,-19.44496 19.626755,-19.68324 0.50032,-0.31494 2.44677,1.32138 7.12857,5.99279 3.54218,3.53431 6.44032,6.65683 6.44032,6.93894 0,0.28211 -10.9266,11.60408 -24.28132,25.15993 -13.35473,13.55586 -24.21098,24.92678 -24.125005,25.26873 0.08598,0.34194 2.592085,2.96187 5.56913,5.82208 l 5.4128,5.20036 7.828645,-7.9748 c 25.44487,-25.91988 40.88039,-41.22258 41.56464,-41.20698 0.42961,0.01 6.28652,5.28096 13.01536,11.7137 7.276,6.95582 12.46864,11.55862 12.81258,11.35719 0.31808,-0.18628 11.19501,-11.1387 24.17096,-24.3387 12.97595,-13.2 23.97279,-24.06284 24.43742,-24.13964 0.52394,-0.0866 3.30695,2.33081 7.32769,6.36509 l 6.4829,6.50473 -10.73078,10.88491 c -5.90193,5.9867 -17.02521,17.24385 -24.71841,25.01589 l -13.98762,14.13099 5.4855,5.50523 c 3.01703,3.02787 5.74459,5.44393 6.06124,5.36901 0.31666,-0.0749 11.30609,-11.04871 24.42096,-24.38621 14.61673,-14.86486 24.26282,-24.30433 24.92426,-24.39037 0.82612,-0.10747 3.8909,2.676 13.07514,11.875 6.59786,6.60845 12.22406,12.01537 12.50268,12.01537 0.27862,0 8.38038,-7.88897 18.00391,-17.53106 9.62353,-9.64208 17.89107,-17.74999 18.37232,-18.01759 0.68333,-0.37996 0.875,-0.29744 0.875,0.37668 0,0.84812 -34.8615,36.25636 -36.67991,37.25516 -0.80206,0.44054 -2.62554,-1.17991 -13.26296,-11.78621 -6.78318,-6.76334 -12.55222,-12.30059 -12.82009,-12.305 -0.26787,-0.005 -11.54065,11.18934 -25.05063,24.875 L 187.62283,488.25 181.06141,481.77471 C 177.45264,478.21329 174.5,475.04314 174.5,474.72993 174.5,474.41673 185.4125,463.06326 198.75,449.5 212.0875,435.93674 223,424.58087 223,424.26472 223,423.57444 212.85406,413.5 212.15889,413.5 c -0.26735,0 -11.34553,11.025 -24.61817,24.5 -13.27265,13.475 -24.35508,24.5 -24.62764,24.5 -0.27255,0 -6.01398,-5.29928 -12.75874,-11.77618 -6.74475,-6.4769 -12.57142,-11.70815 -12.94815,-11.625 -0.37673,0.0831 -11.42227,11.06368 -24.54565,24.40118 -13.12338,13.3375 -24.209405,24.31283 -24.635615,24.38963 -0.44146,0.0796 -3.56919,-2.66403 -7.268385,-6.37567 z m 200.35303,0.43967 c -3.49776,-3.3255 -6.43846,-6.39487 -6.53487,-6.82084 -0.16818,-0.743 22.60342,-24.10046 24.5503,-25.18192 0.68066,-0.3781 0.875,-0.29745 0.875,0.36316 0,0.46706 -5.34375,6.23098 -11.875,12.8087 l -11.875,11.9595 5.5,5.19269 c 3.025,2.85597 5.72922,5.19997 6.00938,5.20888 0.28016,0.009 2.75516,-2.24898 5.5,-5.01753 C 298.72118,474.9573 300,473.9723 300,475.27442 300,476.10133 288.68833,488 287.90221,488 c -0.23818,0 -3.29487,-2.72087 -6.79264,-6.04637 z M 0,449.66838 C 0,449.211 5.3198425,443.4871 11.821872,436.94862 l 11.821871,-11.88815 -2.03418,-2.40524 c -1.118799,-1.32288 -3.628971,-3.97701 -5.57816,-5.89806 l -3.543979,-3.49283 -6.033359,6.11783 C 3.1357182,422.74698 0.32604795,425.5 0.21035352,425.5 0.09465908,425.5 0,425.14222 0,424.70494 0,423.78167 11.873758,411.5 12.766357,411.5 13.579082,411.5 25.5,424.21966 25.5,425.08684 25.5,425.77044 1.0284949,450.5 0.35202479,450.5 0.15841115,450.5 0,450.12577 0,449.66838 Z M 37.104374,413.41168 12.45875,388.84394 6.55804,394.67197 C 3.3126496,397.87738 0.509431,400.5 0.32866515,400.5 0.14789932,400.5 0,400.14359 0,399.70798 0,398.80691 11.363635,387 12.230883,387 c 0.311393,0 1.455583,0.91954 2.542643,2.04343 1.087061,1.12389 12.28284,12.18872 24.87951,24.58852 l 22.903034,22.5451 5.471965,-5.455 c 3.00958,-3.00024 5.47096,-5.68384 5.469735,-5.96353 -0.001,-0.27969 -10.96998,-11.30154 -24.375001,-24.49301 -13.405023,-13.19147 -24.567728,-24.29958 -24.80601,-24.68468 -0.317474,-0.51309 1.283877,-2.42112 5.992785,-7.14051 C 33.843859,364.89814 37.029592,362 37.388951,362 c 0.359359,0 11.633997,10.9125 25.054749,24.25 13.420755,13.3375 24.6069,24.25 24.8581,24.25 0.251195,0 5.404805,-4.96502 11.45246,-11.03337 6.04766,-6.06836 11.6414,-11.37555 12.43054,-11.79377 l 1.4348,-0.76039 13.5652,13.41454 c 7.46086,7.378 18.68294,18.4761 24.93797,24.66246 l 11.37277,11.24792 5.50223,-5.48517 c 3.02623,-3.01684 5.50122,-5.714 5.5,-5.99369 -0.001,-0.2797 -10.96998,-11.30155 -24.375,-24.49302 -13.40503,-13.19147 -24.56773,-24.29958 -24.80601,-24.68468 -0.31747,-0.51309 1.28387,-2.42112 5.99279,-7.1405 3.53431,-3.54219 6.72047,-6.44033 7.08035,-6.44033 0.35988,0 11.79177,11.06964 25.40419,24.59921 l 24.74986,24.59921 12.10678,-12.09921 C 206.30946,392.44464 211.9914,387 212.27727,387 c 0.28588,0 1.40919,0.91954 2.49625,2.04343 1.08707,1.12389 12.28284,12.18872 24.87952,24.58852 l 22.90303,22.5451 5.47197,-5.455 c 3.00958,-3.00024 5.47096,-5.68384 5.46973,-5.96353 -10e-4,-0.27969 -10.96998,-11.30154 -24.375,-24.49301 -13.40502,-13.19147 -24.56773,-24.29958 -24.80601,-24.68468 -0.31747,-0.51309 1.28388,-2.42112 5.99279,-7.14051 3.53431,-3.54218 6.72047,-6.44032 7.08035,-6.44032 0.35988,0 11.78665,11.06457 25.39283,24.58791 l 24.7385,24.58792 6.06016,-5.96292 c 3.42696,-3.37196 6.15509,-5.69451 6.27862,-5.3452 0.12015,0.33974 -0.22886,1.23974 -0.77559,2 C 297.53163,404.02695 288.21199,413 287.52215,413 c -0.33987,0 -11.72371,-11.05447 -25.29744,-24.56548 l -24.6795,-24.56549 -2.3976,2.02729 c -4.31851,3.65152 -8.75103,8.45087 -8.57129,9.28064 0.0955,0.441 11.08618,11.53798 24.42368,24.65995 13.3375,13.12197 24.32273,24.15166 24.41163,24.51042 C 275.61673,425.17509 263.52676,438 262.54132,438 c -0.40324,0 -11.68563,-10.9125 -25.07199,-24.25 -13.38636,-13.3375 -24.65124,-24.25 -25.03307,-24.25 -0.38183,0 -5.97815,5.2875 -12.43626,11.75 -6.45811,6.4625 -12.04662,11.75 -12.41891,11.75 -0.37228,0 -11.78266,-11.05447 -25.35638,-24.56548 l -24.6795,-24.56549 -2.3976,2.02729 c -4.31851,3.65152 -8.75103,8.45087 -8.57129,9.28064 0.0955,0.441 11.08618,11.53798 24.42368,24.65995 13.3375,13.12197 24.32273,24.15166 24.41163,24.51042 C 175.62077,425.19142 163.51681,438 162.51001,438 c -0.42046,0 -10.21347,-9.46457 -21.76224,-21.03239 -11.54878,-11.56781 -22.7382,-22.61365 -24.86539,-24.54632 l -3.86762,-3.51392 -12.01394,11.67131 c -6.607665,6.41922 -12.35577,11.74547 -12.773565,11.8361 -0.45758,0.0993 -10.48524,-9.52012 -25.218905,-24.1921 l -24.459277,-24.35688 -2.399537,2.02891 c -4.335139,3.66554 -8.753046,8.45188 -8.573221,9.28817 0.09553,0.44426 11.086185,11.54073 24.423685,24.65884 13.3375,13.11811 24.32273,24.14514 24.411625,24.5045 0.20999,0.84891 -11.89954,13.65698 -12.89938,13.64349 -0.419235,-0.006 -11.852775,-11.06577 -25.407871,-24.57803 z M 81.061415,381.7747 C 77.45264,378.21329 74.5,375.04314 74.5,374.72993 74.5,374.41672 85.4125,363.06326 98.75,349.5 112.0875,335.93675 123,324.58087 123,324.26472 123,323.57444 112.85406,313.5 112.15889,313.5 c -0.26735,0 -11.34552,11.025 -24.61817,24.5 -13.27265,13.475 -24.365475,24.5 -24.65072,24.5 -0.28525,0 -5.50034,-4.78125 -11.5891,-10.625 -6.088757,-5.84375 -11.691493,-11.17674 -12.450524,-11.8511 L 37.47032,338.7978 18.925905,357.2739 C 8.619314,367.54252 0.27932739,375.4756 0.15150811,375.13229 c -0.12649028,-0.33974 0.22170569,-1.23975 0.77376879,-2 1.8991713,-2.6154 35.8585631,-36.13227 36.5912851,-36.11448 0.403391,0.01 6.238853,5.28096 12.967693,11.7137 7.276,6.95583 12.46864,11.55862 12.81258,11.35719 0.31808,-0.18628 11.19501,-11.1387 24.17096,-24.3387 12.975945,-13.2 23.972785,-24.06284 24.437415,-24.13964 0.52394,-0.0866 3.30695,2.33082 7.32769,6.3651 l 6.4829,6.50473 -10.73078,10.8849 c -5.90192,5.9867 -17.02521,17.24385 -24.718405,25.01589 l -13.987625,14.13099 5.485505,5.50523 c 3.01703,3.02787 5.744585,5.44393 6.06124,5.36901 C 88.14239,385.31129 99.13538,374.3375 112.2546,361 c 13.7591,-13.98803 24.22984,-24.25 24.74333,-24.25 0.48961,0 6.55664,5.49492 13.4823,12.21093 l 12.59209,12.21093 5.13757,-5.21093 c 2.82566,-2.86601 13.66404,-13.87343 24.08527,-24.46093 10.42123,-10.5875 19.25741,-19.44496 19.63594,-19.68324 0.50033,-0.31495 2.44678,1.32138 7.12857,5.99278 3.54218,3.53432 6.44033,6.65685 6.44033,6.93895 0,0.28211 -10.9266,11.60408 -24.28133,25.15993 -13.35472,13.55586 -24.21097,24.92678 -24.125,25.26873 0.086,0.34194 2.59209,2.96187 5.56913,5.82208 l 5.4128,5.20036 7.82865,-7.9748 C 221.16344,352.49405 236.78381,337 237.46514,337 c 0.42754,0 6.23411,5.45335 12.90348,12.11854 l 12.12612,12.11855 18.39331,-18.36855 C 291.00438,332.76585 299.44306,324.5 299.64069,324.5 c 1.62915,0 -2.05246,4.11031 -18.00034,20.09638 C 271.54254,354.71837 262.93453,363 262.51144,363 c -0.42309,0 -6.16749,-5.40433 -12.76535,-12.00963 -6.59785,-6.60529 -12.27257,-11.94904 -12.61048,-11.875 -0.33791,0.074 -11.3517,11.04713 -24.47507,24.38463 -13.12338,13.3375 -24.20941,24.31283 -24.63562,24.38963 -0.44146,0.0795 -3.56919,-2.66403 -7.26838,-6.37567 l -6.49346,-6.51532 7.74904,-7.87432 c 4.26197,-4.33087 15.34028,-15.5383 24.61846,-24.90537 C 215.90876,332.85187 223.5,324.95545 223.5,324.67136 223.5,323.90857 213.17786,314 212.38323,314 c -0.37364,0 -3.81561,3.20625 -7.64881,7.125 C 184.55743,341.75227 163.29883,363 162.83801,363 162.55012,363 156.77302,357.4875 150,350.75 c -6.77302,-6.7375 -12.52506,-12.25361 -12.78229,-12.25802 -0.25724,-0.004 -11.52132,11.18933 -25.0313,24.875 L 87.622835,388.25 81.061415,381.7747 Z M 281.0208,381.7514 c -3.58644,-3.54862 -6.5208,-6.67741 -6.5208,-6.95285 0,-0.58884 23.33988,-24.14354 24.625,-24.85165 0.67896,-0.37412 0.875,-0.29207 0.875,0.36619 0,0.46658 -5.175,6.05357 -11.5,12.41552 -6.325,6.36195 -11.5,11.80715 -11.5,12.10045 0,0.56805 9.6983,10.29652 10.56874,10.60161 0.28359,0.0994 3.11631,-2.3756 6.29494,-5.5 3.72332,-3.6598 5.86484,-5.4368 6.01971,-4.99506 0.14133,0.40313 -2.35187,3.27791 -6.0507,6.97675 l -6.29109,6.29108 -6.5208,-6.45204 z M 0,349.66838 c 0,-0.45738 5.337923,-6.19946 11.862051,-12.76017 l 11.862051,-11.92855 -5.600066,-5.60007 -5.600067,-5.60007 -5.9333195,5.86024 C 3.3273239,322.86289 0.509431,325.5 0.32866515,325.5 0.14789932,325.5 0,325.14359 0,324.70798 0,323.65922 11.436158,312 12.464859,312 13.480703,312 25.5,324.0058 25.5,325.02051 25.5,325.74825 1.0702973,350.5 0.35202479,350.5 0.15841115,350.5 0,350.12577 0,349.66838 Z M 43.116037,319.35952 C 32.877217,309.10725 24.5,300.55725 24.5,300.35952 c 0,-1.62681 4.078016,2.02063 19.852398,17.75631 l 18.160387,18.11583 5.610435,-5.61044 5.610435,-5.61043 L 61.61683,312.85696 C 54.952575,306.17236 49.5,300.54494 49.5,300.35157 49.5,300.15821 49.874608,300 50.33246,300 51.389355,300 75.5,323.93565 75.5,324.98488 75.5,325.98427 63.48329,338 62.483815,338 c -0.413455,0 -9.12896,-8.38822 -19.367778,-18.64048 z m 99.999993,0 c -10.23882,-10.25227 -18.61603,-18.80227 -18.61603,-19 0,-1.62681 4.07801,2.02063 19.8524,17.75631 l 18.16038,18.11583 5.61044,-5.61044 5.61043,-5.61043 -12.24182,-12.31751 c -6.82943,-6.87165 -11.96873,-12.41793 -11.62412,-12.54463 0.33974,-0.12492 1.23974,0.22356 2,0.77439 2.41627,1.75067 23.63229,23.34871 23.63229,24.05781 0,0.95712 -12.02886,13.01915 -12.98335,13.01915 -0.43152,0 -9.1618,-8.38822 -19.40062,-18.64048 z m 100,0 c -10.23882,-10.25227 -18.61603,-18.80227 -18.61603,-19 0,-1.62679 4.07766,2.02027 19.84952,17.75344 l 18.15752,18.11297 5.49648,-5.47944 c 3.02306,-3.01369 5.49648,-5.74626 5.49648,-6.07238 0,-0.32612 -5.27634,-5.70736 -11.7252,-11.9583 -6.44886,-6.25095 -11.8418,-11.66922 -11.98431,-12.04059 -0.14817,-0.38612 0.0693,-0.67522 0.50789,-0.67522 0.83334,0 24.84832,23.28506 25.11325,24.34994 C 275.62196,325.19542 263.51315,338 262.50328,338 c -0.42417,0 -9.14843,-8.38822 -19.38725,-18.64048 z M 81.13218,307.375 C 74.99362,301.33234 73.93478,300 75.271135,300 c 0.44347,0 3.37639,2.51137 6.51759,5.58082 l 5.711275,5.58082 5.711275,-5.58082 c 3.1412,-3.06945 6.07412,-5.58082 6.51759,-5.58082 0.616125,0 0.693915,0.20639 0.329775,0.875 C 99.27474,302.31435 88.206925,313 87.5,313 c -0.35945,0 -3.22497,-2.53125 -6.36782,-5.625 z m 99.4672,-0.54459 c -3.35466,-3.39327 -6.09938,-6.31827 -6.09938,-6.5 0,-1.26647 2.35722,0.43155 7.28872,5.25041 l 5.71128,5.58082 5.71127,-5.58082 c 4.9315,-4.81886 7.28873,-6.51688 7.28873,-5.25041 0,0.7274 -12.25364,12.66959 -13,12.66959 -0.44068,0 -3.54596,-2.77631 -6.90062,-6.16959 z m 100,0 c -3.35465,-3.39327 -6.09938,-6.31827 -6.09938,-6.5 0,-1.26647 2.35723,0.43155 7.28872,5.25041 l 5.71128,5.58082 5.71127,-5.58082 C 298.60459,300.3107 300,299.27498 300,300.54201 300,301.42931 288.4061,313 287.51702,313 c -0.45004,0 -3.56298,-2.77631 -6.91764,-6.16959 z"
         id="path83710"
         inkscape:connector-curvature="0" />
    </g>
    <g
       style="fill:{{pk_fill}};fill-opacity:1"
       id="g83712"
       transform="translate(300,0)">
      <path
         inkscape:connector-curvature="0"
         id="path83714"
         d="M 0,599.43364 C 0,598.61197 11.636288,587 12.45968,587 c 0.735382,0 11.788989,10.63778 12.59896,12.125 0.364139,0.66861 0.286355,0.875 -0.329773,0.875 -0.443475,0 -3.376391,-2.51137 -6.517592,-5.58082 L 12.5,588.83835 6.788725,594.41918 C 1.3668788,599.71718 0,600.72682 0,599.43364 Z M 36.667539,587.89763 C 29.975393,581.24132 24.5,575.4442 24.5,575.01512 24.5,574.01573 36.516708,562 37.516183,562 38.245021,562 75.5,598.91823 75.5,599.64048 c 0,1.62682 -4.078015,-2.02063 -19.8524,-17.75631 l -18.160387,-18.11583 -5.610435,5.61044 -5.610434,5.61043 12.116828,12.15383 C 45.047427,593.82764 50.5,599.45506 50.5,599.64843 c 0,1.52894 -3.297827,-1.27259 -13.832461,-11.7508 z M 100,599.69671 c 0,-0.47395 6.93188,-7.52224 10.13918,-10.30946 l 2.88918,-2.51077 5.77687,5.68677 c 6.19479,6.09816 7.26167,7.43675 5.9272,7.43675 -0.44152,0 -3.2254,-2.3625 -6.1864,-5.25 -2.961,-2.8875 -5.56921,-5.25 -5.79603,-5.25 -0.22682,0 -2.83503,2.3625 -5.79604,5.25 -4.6154,4.50084 -6.95396,6.16438 -6.95396,4.94671 z m 36.91838,-11.54865 C 130.36327,581.6295 125,575.97731 125,575.58766 125,574.72188 136.88214,562 137.69077,562 c 0.61337,0 37.80923,37.02985 37.80923,37.64048 0,1.62582 -4.06323,-2.00588 -19.73385,-17.63805 l -18.04183,-17.99757 -4.25222,4.37257 c -2.33873,2.40492 -4.79616,4.9969 -5.46097,5.75997 l -1.20875,1.38741 11.84881,11.8865 c 6.51684,6.53757 11.84881,12.04449 11.84881,12.23759 0,1.52314 -3.26436,-1.24109 -13.58162,-11.50083 z M 199.94136,599.125 C 200.59515,597.92455 211.73511,587 212.30544,587 c 0.25244,0 3.3775,2.925 6.94456,6.5 7.96607,7.98379 7.26686,8.96553 -0.89027,1.25 -3.05277,-2.8875 -5.76911,-5.25 -6.03631,-5.25 -0.26719,0 -2.90845,2.3625 -5.86946,5.25 -2.961,2.8875 -5.74488,5.25 -6.18639,5.25 -0.61274,0 -0.68995,-0.20712 -0.32621,-0.875 z m 36.87083,-11 c -6.6342,-6.53125 -12.25715,-12.18311 -12.49543,-12.55967 -0.31418,-0.49652 1.33275,-2.45461 5.99278,-7.125 3.53432,-3.54219 6.67209,-6.44033 6.97283,-6.44033 0.65449,0 37.02444,35.70477 37.74898,37.05859 0.40299,0.75298 0.33098,0.94141 -0.35977,0.94141 -0.47497,0 -9.02771,-8.14409 -19.00608,-18.09797 l -18.14248,-18.09797 -1.38651,1.20814 c -4.21931,3.67652 -9.63651,9.32718 -9.63651,10.0518 0,0.45984 5.19432,5.85946 11.54294,11.99915 C 249.84093,598.47287 251.21755,600 249.70478,600 c -0.45671,0 -6.25838,-5.34375 -12.89259,-11.875 z M 81.061415,581.77471 C 77.45264,578.21329 74.5,575.04314 74.5,574.72994 74.5,574.41673 85.4125,563.06326 98.75,549.5 112.0875,535.93674 123,524.58087 123,524.26472 123,523.57444 112.85406,513.5 112.15889,513.5 c -0.26735,0 -11.34552,11.025 -24.61817,24.5 -13.27265,13.475 -24.365475,24.5 -24.65072,24.5 -0.28525,0 -5.50034,-4.78125 -11.5891,-10.625 -6.088757,-5.84375 -11.691493,-11.17674 -12.450524,-11.8511 L 37.47032,538.79781 19.094473,557.1489 C 8.987758,567.24201 0.5569362,575.5 0.35931367,575.5 c -1.62915387,0 2.05245053,-4.11031 18.00033733,-20.09639 10.097809,-10.12199 18.704059,-18.3956 19.125,-18.3858 0.420942,0.01 6.270764,5.28096 12.999604,11.7137 7.276,6.95582 12.46864,11.55862 12.81258,11.35719 0.31808,-0.18628 11.19501,-11.1387 24.17096,-24.3387 12.975945,-13.2 23.972785,-24.06283 24.437415,-24.13964 0.52394,-0.0866 3.30695,2.33082 7.32769,6.36509 l 6.4829,6.50473 -10.73078,10.88491 c -5.90192,5.9867 -17.02521,17.24386 -24.718405,25.01589 l -13.987625,14.13099 5.485505,5.50523 c 3.01703,3.02787 5.744585,5.44393 6.06124,5.36901 C 88.14239,585.31129 99.13114,574.3375 112.24518,561 c 13.11403,-13.3375 24.18581,-24.32749 24.60395,-24.4222 0.45669,-0.10343 5.70857,4.76165 13.15291,12.18422 6.81596,6.79603 12.63617,12.27351 12.93379,12.17219 0.29762,-0.10132 11.27796,-11.09671 24.40076,-24.43421 13.12279,-13.3375 24.17983,-24.44496 24.57119,-24.68324 0.52531,-0.31984 2.39741,1.24885 7.15189,5.99278 3.54218,3.53432 6.44033,6.65684 6.44033,6.93895 0,0.28211 -10.9266,11.60408 -24.28133,25.15993 -13.35472,13.55586 -24.21097,24.92678 -24.125,25.26873 0.086,0.34194 2.59209,2.96187 5.56913,5.82208 l 5.4128,5.20036 7.82865,-7.9748 C 220.6505,553.01657 236.77587,537 237.40908,537 c 0.39672,0 4.19408,3.31875 8.43859,7.375 4.24452,4.05625 9.85417,9.37585 12.46589,11.82133 l 4.74859,4.44632 18.28065,-18.19632 c 10.12488,-10.07819 18.38215,-17.92075 18.50816,-17.57862 0.12513,0.33974 -0.2277,1.257 -0.78408,2.03836 -1.44841,2.0341 -35.51888,35.59393 -36.13553,35.59393 -0.2826,0 -6.03226,-5.29928 -12.77701,-11.77618 -6.74476,-6.4769 -12.57143,-11.70815 -12.94816,-11.625 -0.37672,0.0831 -11.42227,11.06368 -24.54564,24.40118 -13.12338,13.3375 -24.20941,24.31283 -24.63562,24.38963 -0.44146,0.0796 -3.56919,-2.66403 -7.26838,-6.37567 l -6.49346,-6.51532 7.74904,-7.87432 c 4.26197,-4.33087 15.34028,-15.53829 24.61846,-24.90537 9.27818,-9.36709 16.86942,-17.26349 16.86942,-17.54759 0,-0.89437 -10.47444,-10.75055 -11.24578,-10.58199 -0.40431,0.0883 -11.36362,10.96063 -24.35403,24.16063 -12.99041,13.2 -24.04432,24.31124 -24.56425,24.69166 -0.87156,0.63769 -1.93712,-0.29869 -13.65542,-12 L 136.97043,538.25 l -24.67379,25 -24.673805,25 -6.56142,-6.47529 z M 280.55681,581.5604 c -3.33124,-3.54178 -6.05681,-6.6415 -6.05681,-6.88828 0,-0.73939 24.9529,-25.38588 25.32488,-25.01391 0.7746,0.7746 -1.51739,3.35782 -11.68124,13.16553 -5.87147,5.66573 -10.91105,10.74167 -11.19909,11.27986 -0.45591,0.85189 0.19039,1.70057 4.99387,6.5576 l 5.51757,5.57907 5.94334,-5.87013 c 3.26883,-3.22858 6.09124,-5.87014 6.272,-5.87014 0.18077,0 0.32867,0.3564 0.32867,0.79201 C 300,576.37833 288.54517,588 287.47445,588 c -0.47345,0 -3.58639,-2.89782 -6.91764,-6.4396 z M 0,549.66838 c 0,-0.45738 5.337923,-6.19946 11.862051,-12.76016 l 11.862051,-11.92856 -5.600066,-5.60007 -5.600067,-5.60006 -5.9333195,5.86023 C 3.3273239,522.86289 0.509431,525.5 0.32866515,525.5 0.14789932,525.5 0,525.14359 0,524.70798 0,523.65922 11.436158,512 12.464859,512 13.480703,512 25.5,524.0058 25.5,525.02051 25.5,525.74825 1.0702973,550.5 0.35202479,550.5 0.15841115,550.5 0,550.12577 0,549.66838 Z M 37.441231,513.74097 C 24.071407,500.40844 12.817186,489.5 12.43185,489.5 c -0.385336,0 -2.9463905,2.26517 -5.691231,5.03373 C 1.28728,500.03417 0,501.02698 0,499.73243 c 0,-0.84326 10.067225,-11.4632 11.692725,-12.33468 0.815166,-0.43704 2.74332,1.27784 14.25,12.67378 7.319002,7.24856 18.537521,18.3512 24.930045,24.67253 l 11.62277,11.49333 5.50223,-5.48517 c 3.026225,-3.01684 5.501225,-5.714 5.5,-5.9937 -0.001,-0.27969 -10.96998,-11.30154 -24.375001,-24.49301 -13.405023,-13.19147 -24.567728,-24.29958 -24.80601,-24.68468 -0.317474,-0.51309 1.283877,-2.42112 5.992785,-7.1405 C 33.843859,464.89814 37.03002,462 37.389901,462 c 0.359881,0 11.789581,11.06747 25.399334,24.59438 L 87.53424,511.18876 99.66555,499.09438 C 106.33777,492.44247 112.0219,487 112.29695,487 c 0.27506,0 1.38951,0.91954 2.47657,2.04343 1.08706,1.12389 12.28285,12.18872 24.87951,24.58852 l 22.90304,22.5451 5.47196,-5.455 c 3.00958,-3.00025 5.47096,-5.68383 5.46974,-5.96353 -0.001,-0.27969 -10.96998,-11.30154 -24.375,-24.49301 -13.40503,-13.19147 -24.56773,-24.29958 -24.80601,-24.68468 -0.31747,-0.51309 1.28387,-2.42112 5.99279,-7.14051 3.53431,-3.54218 6.72047,-6.44032 7.08035,-6.44032 0.35988,0 11.79177,11.06965 25.40419,24.59921 l 24.74986,24.59921 12.10678,-12.09921 C 206.30946,492.44465 211.9914,487 212.27727,487 c 0.28588,0 1.40919,0.91954 2.49625,2.04343 1.08707,1.12389 12.28284,12.18872 24.87952,24.58852 l 22.90303,22.5451 5.47197,-5.455 c 3.00958,-3.00025 5.47096,-5.68383 5.46973,-5.96353 -10e-4,-0.27969 -10.96998,-11.30154 -24.375,-24.49301 -13.40502,-13.19147 -24.56773,-24.29958 -24.80601,-24.68468 -0.31747,-0.51309 1.28388,-2.42112 5.99279,-7.14051 3.53431,-3.54218 6.71379,-6.44032 7.06551,-6.44032 0.35172,0 11.67873,10.9125 25.17112,24.25 13.4924,13.3375 24.79959,24.25 25.12711,24.25 0.32751,0 2.84125,-2.26518 5.58609,-5.03373 5.4618,-5.50897 6.74062,-6.49397 6.74062,-5.19185 0,1.03033 -11.49136,12.80898 -12.31033,12.61808 -0.33624,-0.0784 -11.76574,-11.13282 -25.39889,-24.56542 l -24.78753,-24.42292 -2.37663,2.00973 c -4.30039,3.63651 -8.72967,8.43503 -8.55031,9.26307 0.0955,0.441 11.08619,11.53797 24.42369,24.65995 13.3375,13.12197 24.32273,24.15167 24.41163,24.51042 C 275.61625,525.17316 263.52794,538 262.54503,538 262.14384,538 250.705,526.93503 237.1254,513.4112 L 212.43522,488.82239 200.33886,500.9112 C 193.68586,507.56003 187.94138,513 187.57335,513 c -0.36803,0 -11.77492,-11.05447 -25.34864,-24.56548 l -24.6795,-24.56549 -2.39761,2.0273 c -4.31851,3.65151 -8.75102,8.45086 -8.57129,9.28063 0.0955,0.441 11.08619,11.53797 24.42369,24.65995 13.3375,13.12197 24.32273,24.15167 24.41163,24.51042 C 175.61673,525.1751 163.52676,538 162.54132,538 162.13808,538 150.85569,527.0875 137.46933,513.75 124.08298,500.4125 112.8181,489.5 112.43626,489.5 112.05443,489.5 106.45811,494.7875 100,501.25 93.54189,507.7125 87.940355,513 87.552145,513 87.163935,513 75.84728,502.03125 62.40402,488.625 48.960763,475.21875 37.773981,464.18455 37.544505,464.10455 c -0.229476,-0.08 -2.819509,2.14814 -5.755629,4.95142 -3.584582,3.4224 -5.289197,5.39699 -5.188637,6.01042 0.08237,0.50245 11.062261,11.64944 24.399761,24.7711 13.3375,13.12166 24.32273,24.15109 24.411625,24.50984 0.20997,0.84738 -11.899445,13.65549 -12.89938,13.64364 -0.419235,-0.005 -11.70119,-10.91745 -25.071014,-24.25 z m 43.315309,-32.22701 -6.493465,-6.51532 7.74904,-7.87432 c 4.26197,-4.33087 15.34028,-15.5383 24.618465,-24.90537 C 115.90876,432.85186 123.5,424.95546 123.5,424.67136 123.5,423.90857 113.17786,414 112.38323,414 c -0.37364,0 -3.81561,3.20625 -7.64881,7.125 C 84.42199,441.89073 63.29723,463 62.828695,463 c -0.29301,0 -6.128765,-5.56875 -12.968344,-12.375 l -12.4356,-12.375 -18.43073,18.625 C 8.8571195,467.11875 0.43655048,475.5 0.28164547,475.5 c -1.43069947,0 2.24040823,-4.1096 17.99672153,-20.14633 10.053101,-10.23202 18.635036,-18.68257 19.070963,-18.779 0.497198,-0.10998 5.416807,4.44611 13.19998,12.22461 l 12.407385,12.39994 5.204575,-5.22461 C 71.023785,453.10108 81.888175,442.0875 92.304355,431.5 c 10.416175,-10.5875 19.248215,-19.44496 19.626755,-19.68324 0.50032,-0.31494 2.44677,1.32138 7.12857,5.99279 3.54218,3.53431 6.44032,6.65683 6.44032,6.93894 0,0.28211 -10.9266,11.60408 -24.28132,25.15993 -13.35473,13.55586 -24.21098,24.92678 -24.125005,25.26873 0.08598,0.34194 2.592085,2.96187 5.56913,5.82208 l 5.4128,5.20036 7.828645,-7.9748 c 25.44487,-25.91988 40.88039,-41.22258 41.56464,-41.20698 0.42961,0.01 6.28652,5.28096 13.01536,11.7137 7.276,6.95582 12.46864,11.55862 12.81258,11.35719 0.31808,-0.18628 11.19501,-11.1387 24.17096,-24.3387 12.97595,-13.2 23.97279,-24.06284 24.43742,-24.13964 0.52394,-0.0866 3.30695,2.33081 7.32769,6.36509 l 6.4829,6.50473 -10.73078,10.88491 c -5.90193,5.9867 -17.02521,17.24385 -24.71841,25.01589 l -13.98762,14.13099 5.4855,5.50523 c 3.01703,3.02787 5.74459,5.44393 6.06124,5.36901 0.31666,-0.0749 11.30609,-11.04871 24.42096,-24.38621 14.61673,-14.86486 24.26282,-24.30433 24.92426,-24.39037 0.82612,-0.10747 3.8909,2.676 13.07514,11.875 6.59786,6.60845 12.22406,12.01537 12.50268,12.01537 0.27862,0 8.38038,-7.88897 18.00391,-17.53106 9.62353,-9.64208 17.89107,-17.74999 18.37232,-18.01759 0.68333,-0.37996 0.875,-0.29744 0.875,0.37668 0,0.84812 -34.8615,36.25636 -36.67991,37.25516 -0.80206,0.44054 -2.62554,-1.17991 -13.26296,-11.78621 -6.78318,-6.76334 -12.55222,-12.30059 -12.82009,-12.305 -0.26787,-0.005 -11.54065,11.18934 -25.05063,24.875 L 187.62283,488.25 181.06141,481.77471 C 177.45264,478.21329 174.5,475.04314 174.5,474.72993 174.5,474.41673 185.4125,463.06326 198.75,449.5 212.0875,435.93674 223,424.58087 223,424.26472 223,423.57444 212.85406,413.5 212.15889,413.5 c -0.26735,0 -11.34553,11.025 -24.61817,24.5 -13.27265,13.475 -24.35508,24.5 -24.62764,24.5 -0.27255,0 -6.01398,-5.29928 -12.75874,-11.77618 -6.74475,-6.4769 -12.57142,-11.70815 -12.94815,-11.625 -0.37673,0.0831 -11.42227,11.06368 -24.54565,24.40118 -13.12338,13.3375 -24.209405,24.31283 -24.635615,24.38963 -0.44146,0.0796 -3.56919,-2.66403 -7.268385,-6.37567 z m 200.35303,0.43967 c -3.49776,-3.3255 -6.43846,-6.39487 -6.53487,-6.82084 -0.16818,-0.743 22.60342,-24.10046 24.5503,-25.18192 0.68066,-0.3781 0.875,-0.29745 0.875,0.36316 0,0.46706 -5.34375,6.23098 -11.875,12.8087 l -11.875,11.9595 5.5,5.19269 c 3.025,2.85597 5.72922,5.19997 6.00938,5.20888 0.28016,0.009 2.75516,-2.24898 5.5,-5.01753 C 298.72118,474.9573 300,473.9723 300,475.27442 300,476.10133 288.68833,488 287.90221,488 c -0.23818,0 -3.29487,-2.72087 -6.79264,-6.04637 z M 0,449.66838 C 0,449.211 5.3198425,443.4871 11.821872,436.94862 l 11.821871,-11.88815 -2.03418,-2.40524 c -1.118799,-1.32288 -3.628971,-3.97701 -5.57816,-5.89806 l -3.543979,-3.49283 -6.033359,6.11783 C 3.1357182,422.74698 0.32604795,425.5 0.21035352,425.5 0.09465908,425.5 0,425.14222 0,424.70494 0,423.78167 11.873758,411.5 12.766357,411.5 13.579082,411.5 25.5,424.21966 25.5,425.08684 25.5,425.77044 1.0284949,450.5 0.35202479,450.5 0.15841115,450.5 0,450.12577 0,449.66838 Z M 37.104374,413.41168 12.45875,388.84394 6.55804,394.67197 C 3.3126496,397.87738 0.509431,400.5 0.32866515,400.5 0.14789932,400.5 0,400.14359 0,399.70798 0,398.80691 11.363635,387 12.230883,387 c 0.311393,0 1.455583,0.91954 2.542643,2.04343 1.087061,1.12389 12.28284,12.18872 24.87951,24.58852 l 22.903034,22.5451 5.471965,-5.455 c 3.00958,-3.00024 5.47096,-5.68384 5.469735,-5.96353 -0.001,-0.27969 -10.96998,-11.30154 -24.375001,-24.49301 -13.405023,-13.19147 -24.567728,-24.29958 -24.80601,-24.68468 -0.317474,-0.51309 1.283877,-2.42112 5.992785,-7.14051 C 33.843859,364.89814 37.029592,362 37.388951,362 c 0.359359,0 11.633997,10.9125 25.054749,24.25 13.420755,13.3375 24.6069,24.25 24.8581,24.25 0.251195,0 5.404805,-4.96502 11.45246,-11.03337 6.04766,-6.06836 11.6414,-11.37555 12.43054,-11.79377 l 1.4348,-0.76039 13.5652,13.41454 c 7.46086,7.378 18.68294,18.4761 24.93797,24.66246 l 11.37277,11.24792 5.50223,-5.48517 c 3.02623,-3.01684 5.50122,-5.714 5.5,-5.99369 -0.001,-0.2797 -10.96998,-11.30155 -24.375,-24.49302 -13.40503,-13.19147 -24.56773,-24.29958 -24.80601,-24.68468 -0.31747,-0.51309 1.28387,-2.42112 5.99279,-7.1405 3.53431,-3.54219 6.72047,-6.44033 7.08035,-6.44033 0.35988,0 11.79177,11.06964 25.40419,24.59921 l 24.74986,24.59921 12.10678,-12.09921 C 206.30946,392.44464 211.9914,387 212.27727,387 c 0.28588,0 1.40919,0.91954 2.49625,2.04343 1.08707,1.12389 12.28284,12.18872 24.87952,24.58852 l 22.90303,22.5451 5.47197,-5.455 c 3.00958,-3.00024 5.47096,-5.68384 5.46973,-5.96353 -10e-4,-0.27969 -10.96998,-11.30154 -24.375,-24.49301 -13.40502,-13.19147 -24.56773,-24.29958 -24.80601,-24.68468 -0.31747,-0.51309 1.28388,-2.42112 5.99279,-7.14051 3.53431,-3.54218 6.72047,-6.44032 7.08035,-6.44032 0.35988,0 11.78665,11.06457 25.39283,24.58791 l 24.7385,24.58792 6.06016,-5.96292 c 3.42696,-3.37196 6.15509,-5.69451 6.27862,-5.3452 0.12015,0.33974 -0.22886,1.23974 -0.77559,2 C 297.53163,404.02695 288.21199,413 287.52215,413 c -0.33987,0 -11.72371,-11.05447 -25.29744,-24.56548 l -24.6795,-24.56549 -2.3976,2.02729 c -4.31851,3.65152 -8.75103,8.45087 -8.57129,9.28064 0.0955,0.441 11.08618,11.53798 24.42368,24.65995 13.3375,13.12197 24.32273,24.15166 24.41163,24.51042 C 275.61673,425.17509 263.52676,438 262.54132,438 c -0.40324,0 -11.68563,-10.9125 -25.07199,-24.25 -13.38636,-13.3375 -24.65124,-24.25 -25.03307,-24.25 -0.38183,0 -5.97815,5.2875 -12.43626,11.75 -6.45811,6.4625 -12.04662,11.75 -12.41891,11.75 -0.37228,0 -11.78266,-11.05447 -25.35638,-24.56548 l -24.6795,-24.56549 -2.3976,2.02729 c -4.31851,3.65152 -8.75103,8.45087 -8.57129,9.28064 0.0955,0.441 11.08618,11.53798 24.42368,24.65995 13.3375,13.12197 24.32273,24.15166 24.41163,24.51042 C 175.62077,425.19142 163.51681,438 162.51001,438 c -0.42046,0 -10.21347,-9.46457 -21.76224,-21.03239 -11.54878,-11.56781 -22.7382,-22.61365 -24.86539,-24.54632 l -3.86762,-3.51392 -12.01394,11.67131 c -6.607665,6.41922 -12.35577,11.74547 -12.773565,11.8361 -0.45758,0.0993 -10.48524,-9.52012 -25.218905,-24.1921 l -24.459277,-24.35688 -2.399537,2.02891 c -4.335139,3.66554 -8.753046,8.45188 -8.573221,9.28817 0.09553,0.44426 11.086185,11.54073 24.423685,24.65884 13.3375,13.11811 24.32273,24.14514 24.411625,24.5045 0.20999,0.84891 -11.89954,13.65698 -12.89938,13.64349 -0.419235,-0.006 -11.852775,-11.06577 -25.407871,-24.57803 z M 81.061415,381.7747 C 77.45264,378.21329 74.5,375.04314 74.5,374.72993 74.5,374.41672 85.4125,363.06326 98.75,349.5 112.0875,335.93675 123,324.58087 123,324.26472 123,323.57444 112.85406,313.5 112.15889,313.5 c -0.26735,0 -11.34552,11.025 -24.61817,24.5 -13.27265,13.475 -24.365475,24.5 -24.65072,24.5 -0.28525,0 -5.50034,-4.78125 -11.5891,-10.625 -6.088757,-5.84375 -11.691493,-11.17674 -12.450524,-11.8511 L 37.47032,338.7978 18.925905,357.2739 C 8.619314,367.54252 0.27932739,375.4756 0.15150811,375.13229 c -0.12649028,-0.33974 0.22170569,-1.23975 0.77376879,-2 1.8991713,-2.6154 35.8585631,-36.13227 36.5912851,-36.11448 0.403391,0.01 6.238853,5.28096 12.967693,11.7137 7.276,6.95583 12.46864,11.55862 12.81258,11.35719 0.31808,-0.18628 11.19501,-11.1387 24.17096,-24.3387 12.975945,-13.2 23.972785,-24.06284 24.437415,-24.13964 0.52394,-0.0866 3.30695,2.33082 7.32769,6.3651 l 6.4829,6.50473 -10.73078,10.8849 c -5.90192,5.9867 -17.02521,17.24385 -24.718405,25.01589 l -13.987625,14.13099 5.485505,5.50523 c 3.01703,3.02787 5.744585,5.44393 6.06124,5.36901 C 88.14239,385.31129 99.13538,374.3375 112.2546,361 c 13.7591,-13.98803 24.22984,-24.25 24.74333,-24.25 0.48961,0 6.55664,5.49492 13.4823,12.21093 l 12.59209,12.21093 5.13757,-5.21093 c 2.82566,-2.86601 13.66404,-13.87343 24.08527,-24.46093 10.42123,-10.5875 19.25741,-19.44496 19.63594,-19.68324 0.50033,-0.31495 2.44678,1.32138 7.12857,5.99278 3.54218,3.53432 6.44033,6.65685 6.44033,6.93895 0,0.28211 -10.9266,11.60408 -24.28133,25.15993 -13.35472,13.55586 -24.21097,24.92678 -24.125,25.26873 0.086,0.34194 2.59209,2.96187 5.56913,5.82208 l 5.4128,5.20036 7.82865,-7.9748 C 221.16344,352.49405 236.78381,337 237.46514,337 c 0.42754,0 6.23411,5.45335 12.90348,12.11854 l 12.12612,12.11855 18.39331,-18.36855 C 291.00438,332.76585 299.44306,324.5 299.64069,324.5 c 1.62915,0 -2.05246,4.11031 -18.00034,20.09638 C 271.54254,354.71837 262.93453,363 262.51144,363 c -0.42309,0 -6.16749,-5.40433 -12.76535,-12.00963 -6.59785,-6.60529 -12.27257,-11.94904 -12.61048,-11.875 -0.33791,0.074 -11.3517,11.04713 -24.47507,24.38463 -13.12338,13.3375 -24.20941,24.31283 -24.63562,24.38963 -0.44146,0.0795 -3.56919,-2.66403 -7.26838,-6.37567 l -6.49346,-6.51532 7.74904,-7.87432 c 4.26197,-4.33087 15.34028,-15.5383 24.61846,-24.90537 C 215.90876,332.85187 223.5,324.95545 223.5,324.67136 223.5,323.90857 213.17786,314 212.38323,314 c -0.37364,0 -3.81561,3.20625 -7.64881,7.125 C 184.55743,341.75227 163.29883,363 162.83801,363 162.55012,363 156.77302,357.4875 150,350.75 c -6.77302,-6.7375 -12.52506,-12.25361 -12.78229,-12.25802 -0.25724,-0.004 -11.52132,11.18933 -25.0313,24.875 L 87.622835,388.25 81.061415,381.7747 Z M 281.0208,381.7514 c -3.58644,-3.54862 -6.5208,-6.67741 -6.5208,-6.95285 0,-0.58884 23.33988,-24.14354 24.625,-24.85165 0.67896,-0.37412 0.875,-0.29207 0.875,0.36619 0,0.46658 -5.175,6.05357 -11.5,12.41552 -6.325,6.36195 -11.5,11.80715 -11.5,12.10045 0,0.56805 9.6983,10.29652 10.56874,10.60161 0.28359,0.0994 3.11631,-2.3756 6.29494,-5.5 3.72332,-3.6598 5.86484,-5.4368 6.01971,-4.99506 0.14133,0.40313 -2.35187,3.27791 -6.0507,6.97675 l -6.29109,6.29108 -6.5208,-6.45204 z M 0,349.66838 c 0,-0.45738 5.337923,-6.19946 11.862051,-12.76017 l 11.862051,-11.92855 -5.600066,-5.60007 -5.600067,-5.60007 -5.9333195,5.86024 C 3.3273239,322.86289 0.509431,325.5 0.32866515,325.5 0.14789932,325.5 0,325.14359 0,324.70798 0,323.65922 11.436158,312 12.464859,312 13.480703,312 25.5,324.0058 25.5,325.02051 25.5,325.74825 1.0702973,350.5 0.35202479,350.5 0.15841115,350.5 0,350.12577 0,349.66838 Z M 43.116037,319.35952 C 32.877217,309.10725 24.5,300.55725 24.5,300.35952 c 0,-1.62681 4.078016,2.02063 19.852398,17.75631 l 18.160387,18.11583 5.610435,-5.61044 5.610435,-5.61043 L 61.61683,312.85696 C 54.952575,306.17236 49.5,300.54494 49.5,300.35157 49.5,300.15821 49.874608,300 50.33246,300 51.389355,300 75.5,323.93565 75.5,324.98488 75.5,325.98427 63.48329,338 62.483815,338 c -0.413455,0 -9.12896,-8.38822 -19.367778,-18.64048 z m 99.999993,0 c -10.23882,-10.25227 -18.61603,-18.80227 -18.61603,-19 0,-1.62681 4.07801,2.02063 19.8524,17.75631 l 18.16038,18.11583 5.61044,-5.61044 5.61043,-5.61043 -12.24182,-12.31751 c -6.82943,-6.87165 -11.96873,-12.41793 -11.62412,-12.54463 0.33974,-0.12492 1.23974,0.22356 2,0.77439 2.41627,1.75067 23.63229,23.34871 23.63229,24.05781 0,0.95712 -12.02886,13.01915 -12.98335,13.01915 -0.43152,0 -9.1618,-8.38822 -19.40062,-18.64048 z m 100,0 c -10.23882,-10.25227 -18.61603,-18.80227 -18.61603,-19 0,-1.62679 4.07766,2.02027 19.84952,17.75344 l 18.15752,18.11297 5.49648,-5.47944 c 3.02306,-3.01369 5.49648,-5.74626 5.49648,-6.07238 0,-0.32612 -5.27634,-5.70736 -11.7252,-11.9583 -6.44886,-6.25095 -11.8418,-11.66922 -11.98431,-12.04059 -0.14817,-0.38612 0.0693,-0.67522 0.50789,-0.67522 0.83334,0 24.84832,23.28506 25.11325,24.34994 C 275.62196,325.19542 263.51315,338 262.50328,338 c -0.42417,0 -9.14843,-8.38822 -19.38725,-18.64048 z M 81.13218,307.375 C 74.99362,301.33234 73.93478,300 75.271135,300 c 0.44347,0 3.37639,2.51137 6.51759,5.58082 l 5.711275,5.58082 5.711275,-5.58082 c 3.1412,-3.06945 6.07412,-5.58082 6.51759,-5.58082 0.616125,0 0.693915,0.20639 0.329775,0.875 C 99.27474,302.31435 88.206925,313 87.5,313 c -0.35945,0 -3.22497,-2.53125 -6.36782,-5.625 z m 99.4672,-0.54459 c -3.35466,-3.39327 -6.09938,-6.31827 -6.09938,-6.5 0,-1.26647 2.35722,0.43155 7.28872,5.25041 l 5.71128,5.58082 5.71127,-5.58082 c 4.9315,-4.81886 7.28873,-6.51688 7.28873,-5.25041 0,0.7274 -12.25364,12.66959 -13,12.66959 -0.44068,0 -3.54596,-2.77631 -6.90062,-6.16959 z m 100,0 c -3.35465,-3.39327 -6.09938,-6.31827 -6.09938,-6.5 0,-1.26647 2.35723,0.43155 7.28872,5.25041 l 5.71128,5.58082 5.71127,-5.58082 C 298.60459,300.3107 300,299.27498 300,300.54201 300,301.42931 288.4061,313 287.51702,313 c -0.45004,0 -3.56298,-2.77631 -6.91764,-6.16959 z"
         style="fill:{{pk_fill}};fill-opacity:1" />
    </g>
  </g>
</svg>
`, dT = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (https://www.inkscape.org/) -->
<!-- ClipArt by Arvin61r58 (https://openclipart.org/user-detail/Arvin61r58) -->
<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   id="svg887"
   version="1.1"
   viewBox="0 0 135.46807 135.47087"
   height="{{pk_dimension}}"
   width="{{pk_dimension}}">
  <title
     id="title1438">Security Pattern</title>
  <defs
     id="defs881">
   {{pk_gradient}}
   </defs>
  <metadata
     id="metadata884">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title>Security Pattern</dc:title>
        <dc:creator>
          <cc:Agent>
            <dc:title>Arvin61r58</dc:title>
          </cc:Agent>
        </dc:creator>
        <dc:publisher>
          <cc:Agent>
            <dc:title>Openclipart.org</dc:title>
          </cc:Agent>
        </dc:publisher>
        <dc:identifier>https://openclipart.org/</dc:identifier>
        <dc:source>https://openclipart.org/user-detail/Arvin61r58</dc:source>
        <dc:description>Pattern generated from a security envelope scan</dc:description>
        <cc:license
           rdf:resource="http://creativecommons.org/publicdomain/zero/1.0/" />
        <dc:subject>
          <rdf:Bag>
            <rdf:li>pattern</rdf:li>
            <rdf:li>texture</rdf:li>
            <rdf:li>security</rdf:li>
          </rdf:Bag>
        </dc:subject>
      </cc:Work>
      <cc:License
         rdf:about="http://creativecommons.org/publicdomain/zero/1.0/">
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#Reproduction" />
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#Distribution" />
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#DerivativeWorks" />
      </cc:License>
    </rdf:RDF>
  </metadata>
  <g
     transform="translate(-37.265968,-80.764561)"
     id="layer1">
    <path
       id="path861"
       d="m 45.509458,80.764561 -3.02049,5.29e-4 -0.0832,0.249079 -0.1018,0.305924 0.87488,0.08372 0.874885,0.08423 0.513147,-0.02119 0.51263,-0.02066 0.274402,-0.434599 z m 24.612452,0 -4.427638,5.29e-4 0.903822,0.349332 1.768883,0.684197 0.365352,1.166336 0.365353,1.166855 0.29559,0.571024 0.295589,0.571542 1.651061,1.742011 1.65158,1.742012 h 0.270266 0.27027 l 0.296105,-0.650089 0.296106,-0.65009 0.427363,0.228928 0.427882,0.228926 0.790133,-0.146762 0.790133,-0.146759 0.746723,-0.621668 0.747241,-0.621667 h 0.243914 0.243912 v -0.396875 -0.396359 l -0.197919,-0.02016 -0.198437,-0.02066 -0.39636,-0.07752 -0.396359,-0.077 -0.594796,0.220657 -0.594278,0.221692 v 0.405662 0.404625 H 75.898818 75.63475 v -0.380855 -0.381373 l -0.594794,0.113689 -0.59428,0.113173 -0.280086,0.381889 -0.280085,0.38137 -1.753383,-1.31413 -1.753381,-1.3131 -0.465605,-1.055233 -0.465088,-1.054714 -0.342098,0.131773 -0.342614,0.130742 v -0.0801 -0.07958 l 1.057299,-1.145667 z m 43.1214,0 -3.02049,5.29e-4 -0.0832,0.249079 -0.1018,0.305924 0.87489,0.08372 0.87488,0.08423 0.51314,-0.02119 0.51263,-0.02066 0.27441,-0.434599 z m 24.61246,0 -4.42765,5.29e-4 0.90383,0.349332 1.76888,0.684197 0.36535,1.166336 0.36536,1.166855 0.29558,0.571024 0.2956,0.571542 1.65106,1.742011 1.65158,1.742012 h 0.27027 0.27026 l 0.29611,-0.650089 0.2961,-0.65009 0.42737,0.228928 0.42788,0.228926 0.79013,-0.146762 0.79014,-0.146759 0.74672,-0.621668 0.74724,-0.621667 h 0.24391 0.24392 v -0.396875 -0.396359 l -0.19792,-0.02016 -0.19844,-0.02066 -0.39636,-0.07752 -0.39636,-0.077 -0.59479,0.220657 -0.59428,0.221692 v 0.405662 0.404624 h -0.26459 -0.26406 v -0.380855 -0.381373 l -0.5948,0.113689 -0.59428,0.113173 -0.28008,0.381889 -0.28009,0.38137 -1.75338,-1.31413 -1.75338,-1.3131 -0.46561,-1.055233 -0.46509,-1.054714 -0.3421,0.131773 -0.34261,0.130742 v -0.0801 -0.07958 l 1.0573,-1.145667 z M 37.266038,80.76509 v 2.441194 h 0.0176 l 0.16329,0.264584 0.1633,0.264583 h -0.13177 -0.13229 l -0.0801,-0.129707 v 1.816942 l 0.49402,0.778248 0.64182,1.01079 -0.0816,0.241845 -0.0816,0.241329 -0.66043,-0.34313 -0.31212,-0.162264 v 2.001428 l 1.71979,-0.144693 0.15503,-0.209807 0.15503,-0.210325 0.59118,-0.33021 0.59117,-0.33073 h 0.40825 0.40824 l 0.11937,-0.330213 0.11938,-0.330729 -0.34727,-1.652095 -0.34726,-1.652612 h 0.20463 0.20464 l 0.46819,0.793232 0.46819,0.793234 h 0.18965 0.18965 l 0.1695,0.534334 0.1695,0.534334 -1.20509,1.340487 -1.2051,1.341004 0.26665,0.49816 0.26665,0.498159 0.5886,0.30231 0.58859,0.30179 0.52814,0.47749 0.528646,0.47697 1.494999,1.35651 1.494483,1.35702 0.172599,-0.27905 0.172599,-0.27957 -0.163297,-0.26407 -0.163298,-0.26458 h 0.238745 0.239262 l 0.429948,0.47594 0.430465,0.47543 -0.719853,1.01337 -0.719336,1.01337 -0.134359,-0.75964 -0.134358,-0.76016 -0.79065,-0.16898 -0.790649,-0.16898 -1.884636,-0.0315 -1.88464,-0.0315 -0.69195,-0.90744 -0.69246,-0.90796 v -0.14934 -0.14986 h 0.28112 0.28111 l 1.68982,0.81545 1.69034,0.81545 0.262,-0.16174 0.261483,-0.16175 -1.081593,-1.44694 -1.08158,-1.44694 -0.29249,-0.0331 -0.29197,-0.0331 -0.79324,-0.0331 -0.79271,-0.0331 0.0894,-0.63407 0.0894,-0.634069 -1.24954,0.171048 -0.95911,0.132291 v 1.69447 l 0.0718,0.0212 -0.0718,0.0682 v 1.19528 l 0.57619,-0.35657 v 0.13384 0.13281 l -0.51573,1.1529 -0.0605,0.13539 v 3.31091 l 0.11472,-0.57567 h 0.2005 0.20051 l 0.12815,0.48989 0.12765,0.48886 1.51722,0.89917 1.5167,0.89865 0.69866,0.46509 0.69815,0.466118 0.50902,0.1726 0.509009,0.17208 -0.579289,0.21446 -0.5793,0.21394 -0.98702,-0.54622 -0.9865,-0.54725 -0.25115,-0.239778 -0.25114,-0.23875 h -0.47543 -0.47594 v 0.24495 0.245978 l 0.36484,0.34933 0.36483,0.34882 1.56167,1.49603 1.56217,1.49603 0.507983,0.0899 0.508496,0.0904 0.21084,-1.42317 0.21084,-1.42368 -0.257349,-0.31006 -0.257348,-0.31006 0.782898,-0.4625 0.782897,-0.462508 v 0.34985 0.349848 l 1.615922,0.64234 1.615406,0.64182 0.614433,0.48369 0.614433,0.48318 -0.403076,0.98495 -0.403593,0.98495 -0.357084,0.37104 -0.356568,0.37052 -0.922425,-0.76688 -0.922424,-0.76739 -0.01912,-0.46768 -0.01912,-0.46818 0.645955,0.16226 0.645439,0.16227 0.292489,-0.18087 0.291972,-0.18035 -0.33228,-0.4005 -0.332279,-0.40049 -0.626319,-0.23823 -0.626835,-0.23822 -0.35605,0.19946 -0.356568,0.19948 -0.830957,1.14773 -0.830957,1.14773 0.121956,0.31833 0.121957,0.31833 1.753898,0.3483 1.753899,0.34881 0.278535,0.52142 0.279053,0.52141 -0.08733,0.0703 -0.08785,0.0703 -0.837159,0.28267 -0.837158,0.28216 -0.458886,-0.50747 -0.458887,-0.50746 h -0.333833 -0.333313 l -0.109037,0.32814 -0.109554,0.32814 -0.375171,-0.39429 -0.375171,-0.39429 -0.38654,-0.74828 -0.386027,-0.74827 -1.40146,0.0873 -1.40095,0.0873 -0.13746,-0.4346 -0.13746,-0.43511 -0.98185,-0.18449 -0.98237,-0.18397 -0.70952,-0.42374 v 1.56993 l 0.0491,0.0548 v 0.36793 0.36794 l -0.0491,-0.005 v 0.78858 l 0.70952,0.10701 0.79272,0.11937 1.03714,0.14315 1.03715,0.14314 0.35037,0.29094 0.35036,0.29042 v 0.56999 0.56948 l 0.38396,0.5488 0.38447,0.54829 -0.71468,-0.12816 -0.71417,-0.12867 -0.26459,-0.20413 -0.26406,-0.20412 -0.81442,-0.12712 -0.81391,-0.12661 -0.32711,0.524 -0.32763,0.52451 0.67903,0.97979 0.67903,0.9803 v 0.31626 0.31575 l 0.19792,-0.0439 0.19844,-0.0444 0.98133,0.20463 0.98186,0.20413 0.30385,0.36587 0.30334,0.36638 0.27544,-0.17053 0.27492,-0.17002 -0.19586,0.31678 -0.19533,0.31678 0.32246,0.38912 0.322976,0.38912 -0.300236,1.49397 -0.29973,1.49448 v 0.22015 0.22014 h 0.41135 0.410826 l 0.526066,-1.1896 0.526066,-1.18959 h 0.507979 0.507979 l -0.168464,0.43977 -0.168982,0.43977 0.37517,-0.22635 0.375171,-0.22634 -0.347782,0.42995 -0.348299,0.42943 0.720886,0.47232 0.720886,0.47232 0.287838,-0.50487 0.287838,-0.5054 0.638204,-0.66559 0.637687,-0.6656 0.155029,0.43202 0.15503,0.43202 1.189074,0.88883 1.189075,0.88884 0.660941,0.30282 -0.0031,5.3e-4 0.660943,0.30282 0.03411,0.0181 0.03411,0.0176 1.508953,-0.90899 1.509469,-0.90899 1.036111,-1.59577 1.03663,-1.59524 -0.260967,-1.13069 -0.260448,-1.13068 -0.0062,-1.75596 -0.0062,-1.75648 -0.330211,-0.11627 -0.330213,-0.11576 -0.659392,0.16536 -0.659392,0.16537 -0.08992,0.47077 -0.09043,0.47077 0.420129,0.46457 0.420129,0.46458 -0.175181,0.17518 -0.175183,0.17518 0.499711,0.55242 0.49971,0.55242 -0.737422,-0.33641 -0.737939,-0.3359 -0.534853,-1.20612 -0.535366,-1.20613 -0.505912,-0.99943 -0.505913,-0.99942 v -0.78548 -0.78496 h 0.513147 0.51263 l 0.163298,-0.26407 0.163296,-0.26458 h 0.653708 0.65319 l 0.164846,-0.42892 0.164849,-0.42943 -0.417028,-0.23358 -0.416513,-0.23306 -0.54932,-0.88883 -0.548804,-0.88884 v -0.82786 -0.828368 h 0.773597 0.773597 l 0.516763,0.65732 0.516765,0.657328 0.179832,1.43918 0.179835,1.43919 0.324011,0.26924 0.324012,0.26871 0.650089,-0.37207 0.650608,-0.37207 0.594278,-0.31729 0.594796,-0.31729 v -0.22169 -0.22221 h 0.264584 0.264064 l -0.0083,0.33073 -0.0083,0.33021 -1.207677,0.7338 -1.207677,0.73381 0.299722,0.36122 0.299723,0.36122 0.535884,0.14056 0.536403,0.14004 0.144177,-0.37621 0.144177,-0.37568 h 0.72037 0.720887 l 0.162263,-0.16279 0.162264,-0.16226 -0.412896,-0.63097 -0.412895,-0.63045 h 0.209291 0.20929 l 0.720368,0.85938 0.719855,0.85886 0.20412,-0.19999 0.203605,-0.19999 -0.599445,-1.20096 -0.599344,-1.20096 -0.647557,-0.64806 -0.648023,-0.64751 h -1.422654 -1.422651 l -0.414962,-0.41548 -0.415478,-0.415478 v -0.36535 -0.36484 l 1.599901,-0.93792 1.599904,-0.93793 h 0.186552 0.187068 l 0.762228,-0.70745 0.762743,-0.70745 -0.718301,-0.61805 -0.718304,-0.61857 -0.245462,0.15193 -0.244946,0.15141 v 0.49403 0.49351 l -2.18023,0.83768 -2.180228,0.83715 -0.436149,0.38861 -0.43615,0.38861 -0.687295,-0.90124 -0.686782,-0.90124 v -0.17311 -0.17364 h 1.717726 1.717725 v -0.53485 -0.53537 l -0.726054,-0.27646 -0.726053,-0.27596 -0.702284,0.41497 -0.701765,0.41496 h -0.307475 -0.307475 l 0.160713,-0.50747 0.161232,-0.50746 -0.473358,-0.13384 -0.473871,-0.13384 -0.792718,-0.15658 -0.792716,-0.15607 -0.52865,-0.10283 -0.52865,-0.10335 -0.697632,-0.17829 -0.698148,-0.17828 -0.156063,0.2527 -0.15658,0.25321 2.068091,1.202 2.068092,1.20199 -0.224793,1.54047 -0.224277,1.54099 0.157613,2.313038 0.158131,2.31356 -0.222208,-0.004 -0.22221,-0.004 -0.381371,-0.24133 -0.380856,-0.24082 -0.302307,0.4129 -0.30179,0.41341 0.119372,0.62529 0.119373,0.62528 0.431497,0.0305 0.432017,0.0305 -0.482142,0.12557 -0.481625,0.12454 0.141077,0.36794 0.141077,0.36742 -0.337447,0.80305 -0.337964,0.80357 -0.114205,-0.0925 -0.114722,-0.0925 -0.456303,0.47852 -0.456303,0.47853 0.456303,0.23564 0.456303,0.23565 1.345654,0.31574 1.345655,0.31523 1.410766,1.27072 1.410766,1.27021 -0.01963,1.22834 -0.01963,1.22887 -0.430467,0.65732 -0.430463,0.65681 H 54.79064 54.572565 l -0.58446,-0.50694 -0.584977,-0.50747 -0.08372,-0.61598 -0.08423,-0.6165 -0.202055,-1.14618 -0.201538,-1.14619 -0.397394,-0.15296 -0.397391,-0.15244 -0.355534,0.48627 -0.355533,0.48679 -0.181901,-0.18241 -0.182418,-0.18294 0.566373,-0.76481 0.565856,-0.76585 -0.353983,-0.29352 -0.353466,-0.29404 -1.869653,-0.0615 -1.869653,-0.061 0.14211,-0.66094 0.142627,-0.66094 1.099674,-0.99064 1.100192,-0.99063 0.19792,-5.3e-4 0.198438,-0.001 v -0.39586 -0.39688 h -0.249082 -0.248563 l -0.163298,0.26458 -0.163297,0.26407 -0.578777,-0.0134 -0.579292,-0.0145 0.594795,-0.41496 0.59428,-0.41496 v -0.33228 -0.33176 l 0.418062,-0.34727 0.418062,-0.34675 0.49351,-0.94103 0.492993,-0.94102 0.329179,-0.61392 0.329178,-0.61392 -0.356049,-0.22014 -0.356051,-0.22014 -1.412834,-0.17622 -1.412834,-0.17673 v -0.192748 -0.19224 l 0.297657,-0.29817 0.297656,-0.29766 -0.172082,-0.68626 -0.172083,-0.68575 -0.529167,0.28319 -0.529683,0.2837 0.181901,0.31678 0.181901,0.31729 -0.221175,-0.2005 -0.220659,-0.20051 -0.590662,0.55501 -0.590661,0.555 -0.464055,-0.0894 -0.464571,-0.0899 -0.08733,-0.26458 -0.08733,-0.26458 0.629936,-0.39636 0.630452,-0.39636 1.332736,-1.05782 1.332735,-1.0573 0.148828,-0.34726 0.148828,-0.34727 -0.825273,-0.75396 -0.825272,-0.75396 0.170015,-0.67747 0.170016,-0.678 -0.994772,-0.62839 -0.994254,-0.62786 -0.264584,-0.0579 -0.264066,-0.0568 -0.396359,-0.33745 -0.396358,-0.33745 -0.430465,-0.15193 -0.430464,-0.15141 -0.273368,0.27337 -0.273369,0.27337 -0.317293,-0.19585 -0.31781,-0.19637 0.140043,-1.043868 0.140043,-1.043863 0.387573,-0.442352 0.387573,-0.441833 0.187069,-0.613399 0.187069,-0.6134 -0.522449,-0.136943 -0.522449,-0.136424 -0.421682,-0.968418 -0.42168,-0.968414 -0.27595,-0.762228 -0.27543,-0.761711 -1.15291,0.15813 -1.1529,0.158129 -0.86971,-1.022676 -0.74311,-0.872815 z m 1.82262,0 0.66198,0.327113 h 0.36742 0.3669 V 80.76509 Z m 7.615559,0 0.06356,0.569474 0.0708,0.639754 0.270784,0.326594 0.271302,0.326596 0.318843,-0.06666 0.318328,-0.06614 0.660941,-0.276987 0.660425,-0.276985 1.189591,-0.46664 1.189074,-0.466638 0.313677,-0.242361 h -4.686536 l 0.0124,0.06201 -0.309542,-0.06201 z m 7.959206,0 1.126027,1.037146 h 5.29e-4 l 1.213879,1.118793 0.315225,0.01035 0.314711,0.01085 0.135393,-0.219625 0.135908,-0.219623 -0.857313,-1.300697 -0.288354,-0.437181 z m 2.936769,0 -0.01034,0.03152 0.440801,0.929142 0.440799,0.92914 0.305924,0.189654 0.306443,0.189137 2.556949,0.198437 2.556949,0.197919 1.024226,0.54932 1.024745,0.549323 0.160713,0.458369 0.160197,0.457854 -0.121957,0.467154 -0.121954,0.466637 h -0.224282 -0.223758 l -0.280604,-0.523996 -0.280604,-0.524518 -1.380276,-0.636135 -1.380794,-0.636138 -1.778187,-0.168466 -1.778186,-0.167947 0.146246,0.380855 0.146243,0.38137 1.00924,0.699702 1.009243,0.699698 1.313098,0.346231 1.313097,0.34675 0.498676,0.289904 0.499195,0.289904 -0.264583,0.01188 -0.264065,0.01241 0.347266,0.220141 0.346747,0.220141 1.701189,-0.471805 1.70067,-0.471805 v 0.247529 0.24753 h 0.52865 0.528651 v -0.364318 -0.36432 l -0.406178,-0.972032 -0.406177,-0.97255 -0.525032,0.166912 -0.524515,0.166399 -0.509013,-1.150318 -0.508498,-1.150832 -0.608748,-0.548288 -0.608229,-0.548288 -0.429948,-0.150894 -0.430466,-0.150895 -0.273368,0.273886 -0.273367,0.273368 -0.317813,-0.196371 -0.31729,-0.196371 0.07028,-0.521931 z m 13.277744,0 v 0.526066 l 0.330211,0.272333 0.330213,0.27182 1.189074,0.173632 1.189593,0.174149 0.396357,0.06201 0.396359,0.06201 0.528651,0.288872 0.528648,0.289388 0.937929,-0.0863 0.938443,-0.0863 0.314709,0.503844 0.314711,0.503846 -0.7028,-0.267168 -0.702283,-0.267166 -0.194302,0.314709 -0.194305,0.314708 -1.383379,-0.16433 -1.383377,-0.163814 -0.439251,-0.397391 -0.439766,-0.397909 -0.977718,-0.155546 -0.977717,-0.155546 v 0.482658 0.48214 l 1.433505,1.120346 1.433504,1.119828 h 0.39274 0.392742 l 1.54564,-0.481108 1.545127,-0.481108 0.916739,0.374137 0.916223,0.374139 0.799433,0.701765 0.79892,0.702284 -0.07855,1.634524 -0.07803,1.63453 0.238228,0.87695 0.238228,0.87694 0.322461,-0.0734 0.321945,-0.0724 -0.147278,0.23875 -0.147796,0.23823 0.891419,0.94516 0.890902,0.94568 0.690398,0.17312 0.68988,0.17311 v -0.24959 -0.2496 l -0.963766,-1.23816 -0.964282,-1.23766 0.159679,-0.15968 0.159681,-0.15968 1.398882,1.33274 1.399397,1.33273 0.707966,0.55501 0.708486,0.55449 0.156578,-0.25322 0.15658,-0.25321 -1.195276,-1.34669 -1.195277,-1.34617 v -0.11524 -0.11472 l 0.330214,0.14418 0.330729,0.14366 1.348756,1.61282 1.349271,1.61282 -0.802536,1.13895 -0.802535,1.13895 -0.10542,-0.10542 -0.105418,-0.10542 0.280085,-0.52349 0.280085,-0.524 -0.325043,-0.25734 -0.324527,-0.25787 -1.057302,-0.21756 -1.056783,-0.21807 -0.859379,0.0718 -0.858862,0.0718 v -0.28474 -0.28525 h -0.249597 -0.249597 l -1.197859,-1.25574 -1.197343,-1.25574 -0.0062,-0.99528 -0.0062,-0.99478 -0.248563,-0.459399 -0.248563,-0.458888 -0.451136,-1.264523 -0.451651,-1.265039 -0.290939,0.09922 -0.290938,0.09922 -0.02894,0.636653 -0.02842,0.637173 -0.03772,0.462502 -0.03721,0.462505 h -0.496078 -0.496094 l -0.316259,0.381375 -0.316261,0.380855 -0.901753,-0.506429 -0.901237,-0.506428 -0.334346,0.131773 -0.334346,0.131776 -0.564309,1.683614 -0.564306,1.68362 0.54777,0.54777 0.547772,0.54829 0.941543,-0.56896 0.941544,-0.56844 -0.462502,0.53278 -0.462505,0.53227 v 0.31885 0.31936 l -0.461987,0.70538 -0.461988,0.70538 -0.134874,-0.77876 -0.134877,-0.77877 -0.790649,-0.16898 -0.790649,-0.16949 -1.884641,-0.031 -1.88464,-0.0315 -0.691946,-0.90744 -0.691946,-0.90796 v -0.14986 -0.14986 h 0.280601 0.28112 l 1.718241,0.8294 1.718241,0.8289 0.258384,-0.2589 0.258382,-0.25839 -0.407729,-0.33848 -0.407209,-0.33848 -0.0093,-0.29765 -0.0088,-0.29818 -0.496091,-0.59479 -0.496094,-0.59531 H 69.32507 69.046017 L 68.772649,89.568687 68.498763,89.057092 V 88.94082 88.824031 l 0.793234,-0.158647 0.792716,-0.158647 v -0.413411 -0.413928 l -1.18494,0.07648 -1.184941,0.077 -0.522449,1.214911 -0.522965,1.214913 -0.406694,0.33745 -0.406693,0.33744 v 0.36433 0.36431 h 0.250631 0.25063 l -0.0067,1.53273 -0.0067,1.53272 -1.10226,-0.0367 -1.101741,-0.0372 -0.264583,-0.062 -0.264067,-0.0615 0.92501,-0.33434 0.925007,-0.33384 v -0.63355 -0.63355 l -0.497126,-0.0961 -0.496612,-0.0956 -0.216525,0.35036 -0.216524,0.34985 -0.872297,-0.99735 -0.872299,-0.99787 -0.793232,-0.0532 -0.792718,-0.0537 0.102836,0.39636 0.10232,0.39687 -0.03462,0.79272 -0.03462,0.79323 0.196371,0.27854 0.196371,0.27802 1.585434,1.08417 1.585949,1.08365 0.618051,0.18345 0.618048,0.18294 1.580266,0.96635 1.580782,0.96635 0.708483,0.4656 0.708485,0.46561 0.509014,0.17208 0.50901,0.17208 -0.578776,0.21446 -0.578776,0.213938 -1.251603,-0.686258 -1.251601,-0.68627 -0.251148,-0.23202 -0.251148,-0.23151 H 65.85814 64.643226 l -1.021641,-1.04645 -1.021127,-1.04697 -0.224274,0.13901 -0.224277,0.1385 0.06149,0.80666 0.0615,0.80616 0.271301,0.0801 0.27182,0.0791 0.727085,0.15968 0.726572,0.15916 v 0.78807 0.788058 h 0.232027 0.232026 l 0.399976,-0.594798 0.39946,-0.59479 0.199988,0.19275 0.199469,0.19276 -0.711584,1.076418 -0.712102,1.0759 -1.314129,-0.9648 -1.314133,-0.964798 -0.391189,0.15038 -0.391192,0.14986 v 0.275438 0.27543 l 0.54932,0.45992 0.54932,0.45992 0.391708,0.74466 0.391192,0.74466 0.75189,-0.16537 0.751893,-0.16536 0.173117,0.28009 0.172598,0.28008 h 0.507979 0.507981 l 0.160197,-0.72709 0.160195,-0.72708 0.196887,-0.66094 0.196887,-0.66095 0.771014,-0.14727 0.771528,-0.147278 1.189075,0.997868 1.189074,0.99787 1.038699,0.91984 1.038177,0.92036 0.213942,-0.13178 0.21394,-0.13229 -0.12609,0.34417 -0.12609,0.34416 1.15135,1.22577 1.150835,1.22576 0.695563,-0.13281 0.696081,-0.13332 v -0.20309 -0.2036 l -0.386537,-0.74518 -0.386541,-0.74517 0.127125,-0.12713 0.127124,-0.12712 1.063501,1.0387 1.0635,1.03921 0.149344,0.59635 0.149863,0.59634 h 1.275374 1.275373 l 0.668695,0.25425 0.668692,0.25425 0.163814,-0.26614 0.16433,-0.26561 -0.321942,-0.38809 -0.321945,-0.38861 0.709001,-0.65732 0.709518,-0.65784 h 0.134358 0.133842 l -0.144693,0.23409 -0.144695,0.23461 0.581361,0.15193 0.580842,0.15193 -0.571542,0.60926 -0.572058,0.60927 0.22221,0.36018 0.222723,0.36019 0.300242,-0.18552 0.300241,-0.18603 -0.07235,0.35036 -0.07286,0.34985 0.350366,-0.0729 0.349848,-0.0729 -0.134358,0.21756 -0.134358,0.21755 0.180867,0.26976 0.180866,0.27026 2.155426,1.59215 -0.0011,-0.002 2.155426,1.59215 1.808673,-0.47128 1.808676,-0.47181 1.107426,-0.0155 1.106909,-0.0155 1.221115,-1.0573 1.221631,-1.05782 h 0.24804 0.24857 v -0.32041 -0.31987 l -1.1126,-1.13379 -1.112081,-1.13378 h -0.341064 -0.341579 v 0.14315 0.14262 l 0.528648,1.03612 0.52865,1.03663 v 0.14211 0.14365 h -0.202054 -0.202054 l -0.627354,-1.32239 -0.627351,-1.32189 h -0.228409 -0.227894 v -0.47904 -0.47904 l -0.781865,-0.57877 -0.782381,-0.57775 h -0.176733 -0.17725 l 0.132292,1.17357 0.132291,1.17409 -0.381373,-0.38034 -0.380854,-0.38137 h -0.501777 -0.501264 l 0.170016,0.44184 0.1695,0.44286 -0.416512,-0.15968 -0.416513,-0.15968 -0.155546,0.15503 -0.155545,0.15607 0.294039,0.35449 0.294555,0.35502 0.56224,0.002 0.562239,0.002 0.76481,0.50436 0.764294,0.50437 0.358635,-0.13798 0.358635,-0.13746 v 0.13023 0.13022 l -0.356566,0.6873 -0.356052,0.68678 -0.16433,-0.16382 -0.163815,-0.16433 -1.312582,0.56483 -1.312582,0.56482 h -0.787548 -0.788064 l -0.484209,-0.65629 -0.484724,-0.65578 -0.660943,-0.1173 -0.660423,-0.11782 -0.156065,-0.0196 -0.156062,-0.0196 -0.329697,-1.12345 -0.329695,-1.12396 -0.436665,-0.92501 -0.436666,-0.92552 -0.24443,-0.17467 -0.243911,-0.17467 -0.947746,0.14573 -0.947748,0.14625 -0.72657,0.36586 -0.726569,0.36587 v 0.52194 0.52193 h -0.360185 -0.360186 l -1.027327,-0.81494 -1.027326,-0.81545 -0.219626,-0.38861 -0.219109,-0.38861 0.376722,-0.58084 0.376721,-0.58033 0.147278,-0.78341 0.146762,-0.7829 -1.030947,-1.00097 -1.031462,-1.001488 v -0.30541 -0.30592 l 0.462505,0.37155 0.462505,0.37155 0.591177,0.330728 0.590661,0.33022 h 0.363802 0.363802 l 0.997874,0.79323 0.997354,0.79323 h -0.250113 -0.250113 l -0.513149,-0.38809 -0.51263,-0.38861 -0.170016,-0.008 -0.170013,-0.008 -0.159682,0.416 -0.159162,0.41548 0.314192,0.57567 0.314709,0.57568 -0.07648,0.79323 -0.07648,0.79323 -0.245465,0.29973 -0.24598,0.29972 0.422198,0.16175 0.422196,0.16226 0.575675,-0.29869 0.575675,-0.29817 0.320395,-0.25373 0.320394,-0.25373 -0.409278,-0.62477 -0.409276,-0.62529 0.170531,-0.27595 0.170532,-0.27595 h 0.761712 0.761193 l 0.163298,0.26458 0.163814,0.26407 h 0.264065 0.233061 v 0.23978 0.27027 l 0.532267,0.28525 0.532787,0.28525 0.09767,-0.34209 0.09818,-0.34158 0.306959,-1.12914 0.306441,-1.12913 -0.160198,-0.25941 -0.160713,-0.25993 -0.495062,0.2651 -0.495059,0.2651 h -0.48731 -0.487307 l -2.01073,-2.005568 -2.011248,-2.00556 -0.151411,0.24495 -0.150894,0.24443 0.517797,0.96686 0.517798,0.96687 v 0.13281 0.133318 h -0.2589 -0.258898 l -0.519866,-1.020088 -0.52038,-1.02009 -1.279509,0.12299 -1.278991,0.12299 -0.352436,-0.42478 -0.352432,-0.42478 -0.56224,0.004 -0.56224,0.004 -0.594794,0.15968 -0.594796,0.15916 v 0.36587 0.36587 l -0.197922,-0.004 -0.198437,-0.004 -0.792716,-0.72244 -0.792718,-0.72295 -0.858861,-1.233 -0.858861,-1.233 v -0.18707 -0.18758 l 0.407209,0.33848 0.407728,0.33796 1.243852,0.63459 1.244367,0.63407 1.717725,0.21911 1.718241,0.21859 0.239779,-0.22221 0.239779,-0.22273 -0.270786,-0.34158 -0.270266,-0.3421 -0.130741,-0.72708 -0.13126,-0.72658 h 0.236162 0.235646 l 0.156061,0.40618 0.156065,0.40618 0.785998,0.40669 0.786513,0.40721 -0.167947,0.57464 -0.168465,0.57465 -0.106453,0.46302 -0.106455,0.4625 h 0.381373 0.380855 v -0.2465 -0.24649 l 0.52865,-0.16795 0.528651,-0.16795 v -0.4784 -0.47853 l -0.396359,-0.32917 -0.396359,-0.32918 v -0.27285 -0.27337 l -0.66094,-0.86662 -0.660426,-0.86661 v -0.14986 -0.14935 h 0.644922 0.644922 l 0.163298,-0.26458 0.163298,-0.26458 h 0.238744 0.238228 l 0.27027,1.00304 0.26975,1.00252 0.55862,0.59996 0.558623,0.59945 0.664043,0.2527 0.664041,0.2527 -0.278019,0.33486 -0.278535,0.33538 0.223242,0.9896 0.223243,0.99012 0.351917,0.45527 0.352433,0.45475 0.728636,0.727088 0.728638,0.72709 h 0.26665 0.26665 v -0.24495 -0.24546 l -0.660424,-0.519868 -0.660942,-0.51986 v -0.34313 -0.34262 l 0.330729,0.38344 0.330213,0.38396 0.714685,0.626828 0.714168,0.62684 1.796272,-1.654158 1.796275,-1.65365 0.968933,-0.61753 0.968934,-0.61754 -0.137462,-0.5271 -0.137974,-0.52658 -0.650089,-0.42633 -0.650608,-0.42633 0.146246,-0.70952 0.146243,-0.71003 -1.853634,-1.12345 -1.854149,-1.12344 H 85.521983 85.11684 l 0.163298,0.26406 0.163298,0.26459 h -0.247531 -0.247528 l -0.306443,-0.36949 -0.306956,-0.37 0.117821,-0.650093 0.117822,-0.65009 0.555522,-1.149799 0.555006,-1.149284 -0.635104,-0.540536 -0.634587,-0.540536 -0.470257,-1.281575 -0.470255,-1.281576 -0.377237,-0.145211 -0.377754,-0.144693 -0.233579,0.36897 -0.233577,0.368969 -0.0036,0.213939 -0.0036,0.213943 0.330211,-0.198438 0.330213,-0.198437 -0.323495,0.399975 -0.323493,0.400492 1.050581,1.025777 1.050065,1.026295 v 0.228409 0.22841 l -0.714219,0.936376 -0.714168,0.936895 -0.49816,-0.615985 -0.498676,-0.615981 0.287837,-0.09612 0.287319,-0.0956 v -0.314323 -0.314193 l -0.810802,-0.984437 -0.811321,-0.983917 0.187071,-0.596347 0.18655,-0.596347 0.48886,-0.6258 0.488341,-0.625804 -0.144177,-0.23306 -0.144176,-0.233577 h -0.31781 -0.317294 l -0.330213,-0.529167 -0.330729,-0.529683 0.08837,-0.06149 h -0.821655 l 0.03359,0.855244 h 0.203089 0.203089 l 0.172083,0.541568 0.171563,0.541055 -0.318325,0.383955 -0.318844,0.383955 H 79.840666 79.61794 L 79.372994,83.00792 79.127532,82.545415 78.994206,81.53876 78.89137,80.765163 h -0.879533 l 0.0021,0.031 -0.301274,0.186036 h -5.29e-4 l -0.301275,0.186553 -2.472717,0.03359 -2.4722,0.03411 0.149344,-0.470773 z m 11.661304,0 0.04031,0.104902 0.334346,-0.104902 z m 2.19573,0 -0.649055,0.121955 -0.144695,0.234095 -0.144693,0.234611 0.163298,0.264584 0.163296,0.264067 h 0.87695 0.876949 l 0.338481,-0.407728 0.338479,-0.407728 -0.271817,-0.271301 -0.03256,-0.03256 z m 2.300636,0 -5.29e-4,0.0031 0.01188,-0.0031 z m 1.410251,0 -0.390158,0.09767 -0.28267,0.528648 -0.283189,0.52865 0.42168,0.643372 0.421164,0.642855 h 0.174667 0.174665 l 1.074354,-0.492993 1.074869,-0.492992 1.26814,-0.458888 1.268656,-0.459404 -0.102835,-0.30334 -0.07855,-0.233577 z m 6.95203,0 -0.334865,0.403074 0.512115,0.291973 0.511595,0.291973 1.072285,0.984952 v -0.0011 l 1.07229,0.984951 0.18241,0.0072 0.18242,0.0067 0.1602,-0.258899 0.15968,-0.258381 -0.60668,-0.865063 -0.60668,-0.865063 -0.18501,-0.139529 -0.18448,-0.139525 -0.20412,-0.443383 z m 3.07991,0 -0.2129,0.57309 0.44545,0.492993 0.44596,0.492477 v 0.436666 0.437184 l 0.60617,0.151926 0.606683,0.152448 0.71055,-0.129191 0.71055,-0.128674 0.13488,0.218074 0.13539,0.218591 -0.41651,0.159679 -0.41651,0.160197 h -0.65784 -0.657333 l 0.0847,0.565857 0.0842,0.566375 0.58705,0.21549 0.58704,0.216008 0.38499,-0.385506 0.38499,-0.38499 h 0.14469 0.14418 l -0.14986,0.858862 -0.14935,0.859379 -0.39945,1.272792 -0.39895,1.273307 0.1478,0.147278 0.14728,0.147793 0.41392,-0.158646 0.41393,-0.158647 0.1664,-0.468704 0.1664,-0.468707 0.33796,-0.397391 0.33797,-0.396875 0.38757,-0.748273 0.38809,-0.747761 -0.35967,-0.693496 -0.35967,-0.693497 0.12041,-0.120407 0.12092,-0.120922 0.56431,0.505394 0.56431,0.50488 0.22479,0.353984 v -1.811261 l -0.16175,-0.261998 -0.1633,-0.264584 h 0.1323 0.13229 l 0.0605,0.09818 v -2.539378 h -2.62413 l 0.34313,0.322461 0.63924,0.60048 0.34365,-0.131776 0.34416,-0.131775 0.0357,0.592214 0.0362,0.591693 -0.89813,0.275952 -0.89814,0.275953 -0.27027,-0.505397 -0.27027,-0.504878 h -0.34623 -0.34623 l -0.46044,-0.509013 -0.46095,-0.509529 0.0599,-0.366385 h -1.113642 l 0.3731,0.292489 0.46251,0.363284 v 0.09974 0.09974 h -0.0997 -0.0997 l -0.36278,-0.462505 -0.30748,-0.39274 z m 6.522093,0 v 2.441194 h 0.0176 l 0.16329,0.264584 0.1633,0.264583 h -0.13177 -0.1323 l -0.0801,-0.129707 v 1.816942 l 0.49403,0.778248 0.64182,1.01079 -0.0816,0.241845 -0.0817,0.241329 -0.66042,-0.34313 -0.31213,-0.162264 v 2.001428 l 1.71979,-0.144693 0.15503,-0.209807 0.15503,-0.210325 0.59118,-0.33021 0.59118,-0.33073 h 0.40824 0.40825 l 0.11937,-0.330213 0.11937,-0.330729 -0.34726,-1.652095 -0.34727,-1.652612 h 0.20464 0.20464 l 0.46819,0.793232 0.46819,0.793234 h 0.18965 0.18965 l 0.1695,0.534334 0.1695,0.534334 -1.2051,1.340487 -1.20509,1.341004 0.26665,0.49816 0.26665,0.498159 0.5886,0.30231 0.58859,0.30179 0.52813,0.47749 0.52865,0.47697 1.495,1.35651 1.49449,1.35702 0.17259,-0.27905 0.1726,-0.27957 -0.16329,-0.26407 -0.1633,-0.26458 h 0.23874 0.23927 l 0.42994,0.47594 0.43047,0.47543 -0.71985,1.01337 -0.71934,1.01337 -0.13436,-0.75964 -0.13436,-0.76016 -0.79065,-0.16898 -0.79065,-0.16898 -1.88464,-0.0315 -1.88464,-0.0315 -0.69194,-0.90744 -0.69247,-0.90796 v -0.14934 -0.14986 h 0.28112 0.28112 l 1.68982,0.81545 1.69034,0.81545 0.262,-0.16174 0.26148,-0.16175 -1.08159,-1.44694 -1.08159,-1.44694 -0.29249,-0.0331 -0.29197,-0.0331 -0.79323,-0.0331 -0.79272,-0.0331 0.0894,-0.63407 0.0894,-0.634069 -1.24953,0.171048 -0.95912,0.132291 v 1.69447 l 0.0718,0.0212 -0.0718,0.0682 v 1.19528 l 0.5762,-0.35657 v 0.13384 0.13281 l -0.51573,1.1529 -0.0605,0.13539 v 3.31091 l 0.11472,-0.57567 h 0.2005 0.20051 l 0.12816,0.48989 0.12764,0.48886 1.51721,0.89917 1.51671,0.89865 0.69866,0.46509 0.69815,0.466118 0.50902,0.1726 0.50901,0.17208 -0.5793,0.21446 -0.57929,0.21394 -0.98702,-0.54622 -0.9865,-0.54725 -0.25115,-0.239778 -0.25115,-0.23875 h -0.47542 -0.47594 v 0.24495 0.245978 l 0.36484,0.34933 0.36483,0.34882 1.56166,1.49603 1.56218,1.49603 0.50798,0.0899 0.5085,0.0904 0.21084,-1.42317 0.21084,-1.42368 -0.25735,-0.31006 -0.25735,-0.31006 0.7829,-0.4625 0.7829,-0.462508 v 0.34985 0.349848 l 1.61592,0.64234 1.6154,0.64182 0.61444,0.48369 0.61443,0.48318 -0.40308,0.98495 -0.40359,0.98495 -0.35708,0.37104 -0.35657,0.37052 -0.92243,-0.76688 -0.92242,-0.76739 -0.0191,-0.46768 -0.0191,-0.46818 0.64595,0.16226 0.64544,0.16227 0.29249,-0.18087 0.29197,-0.18035 -0.33228,-0.4005 -0.33227,-0.40049 -0.62632,-0.23823 -0.62684,-0.23822 -0.35605,0.19946 -0.35657,0.19948 -0.83095,1.14773 -0.83096,1.14773 0.12196,0.31833 0.12195,0.31833 1.7539,0.3483 1.7539,0.34881 0.27853,0.52142 0.27906,0.52141 -0.0873,0.0703 -0.0879,0.0703 -0.83716,0.28267 -0.83716,0.28216 -0.45889,-0.50747 -0.45888,-0.50746 h -0.33383 -0.33332 l -0.10903,0.32815 -0.10956,0.32814 -0.37517,-0.39429 -0.37517,-0.39429 -0.38654,-0.74828 -0.38602,-0.74827 -1.40147,0.0873 -1.40095,0.0873 -0.13745,-0.4346 -0.13746,-0.43512 -0.98186,-0.18448 -0.98237,-0.18397 -0.70951,-0.42374 v 1.56992 l 0.0491,0.0548 v 0.36794 0.36794 l -0.0491,-0.005 v 0.78858 l 0.70951,0.10697 0.79272,0.11937 1.03715,0.14315 1.03714,0.14314 0.35037,0.29094 0.35037,0.29042 v 0.56999 0.56947 l 0.38395,0.54881 0.38447,0.54829 -0.71468,-0.12816 -0.71417,-0.12867 -0.26458,-0.20413 -0.26407,-0.20412 -0.81442,-0.12712 -0.8139,-0.12661 -0.32712,0.524 -0.32762,0.52451 0.67903,0.97979 0.67902,0.9803 v 0.31626 0.31574 l 0.19792,-0.0439 0.19844,-0.0444 0.98134,0.20464 0.98185,0.20413 0.30386,0.36587 0.30334,0.36638 0.27543,-0.17053 0.27492,-0.17002 -0.19585,0.31678 -0.19534,0.31678 0.32246,0.38912 0.32298,0.38912 -0.30024,1.49397 -0.29972,1.49448 v 0.22014 0.22015 h 0.41134 0.41083 l 0.52606,-1.1896 0.52607,-1.18959 h 0.50798 0.50798 l -0.16847,0.43977 -0.16898,0.43977 0.37517,-0.22635 0.37517,-0.22634 -0.34778,0.42995 -0.3483,0.42943 0.72089,0.47232 0.72089,0.47232 0.28783,-0.50487 0.28784,-0.5054 0.63821,-0.66559 0.63768,-0.6656 0.15503,0.43202 0.15503,0.43202 1.18908,0.88883 1.18907,0.88883 0.66094,0.30283 -0.003,5.3e-4 0.66094,0.30282 0.0341,0.0181 0.0341,0.0176 1.50895,-0.90899 1.50947,-0.90899 1.03612,-1.59577 1.03662,-1.59525 -0.26096,-1.13068 -0.26045,-1.13068 -0.006,-1.75596 -0.006,-1.75648 -0.33022,-0.11628 -0.33021,-0.11575 -0.65939,0.16536 -0.65939,0.16537 -0.0904,0.47077 -0.0904,0.47077 0.42013,0.46457 0.42013,0.46457 -0.17518,0.17519 -0.17519,0.17518 0.49971,0.55242 0.49972,0.55242 -0.73743,-0.33641 -0.73794,-0.3359 -0.53485,-1.20613 -0.53536,-1.20612 -0.50592,-0.99943 -0.50591,-0.99942 v -0.78548 -0.78497 h 0.51315 0.51263 l 0.16329,-0.26406 0.1633,-0.26458 h 0.65371 0.65319 l 0.16485,-0.42892 0.16484,-0.42943 -0.41702,-0.23358 -0.41652,-0.23306 -0.54932,-0.88883 -0.5488,-0.88884 v -0.82786 -0.828368 h 0.7736 0.77359 l 0.51677,0.65732 0.51676,0.657328 0.17983,1.43919 0.17984,1.43918 0.32401,0.26924 0.32401,0.26872 0.65009,-0.37207 0.65061,-0.37207 0.59428,-0.3173 0.59479,-0.31729 v -0.22169 -0.22221 h 0.26459 0.26406 l -0.008,0.33073 -0.008,0.33021 -1.20768,0.73381 -1.20768,0.7338 0.29973,0.36122 0.29972,0.36122 0.53589,0.14056 0.5364,0.14004 0.14417,-0.3762 0.14418,-0.37569 h 0.72037 0.72089 l 0.16226,-0.16278 0.16226,-0.16227 -0.41289,-0.63097 -0.41289,-0.63045 h 0.20928 0.20929 l 0.72037,0.85938 0.71986,0.85886 0.20412,-0.19998 0.2036,-0.19999 -0.59944,-1.20096 -0.59945,-1.20096 -0.64751,-0.64802 -0.64802,-0.64751 h -1.42265 -1.42265 l -0.41497,-0.41548 -0.41547,-0.415478 v -0.36535 -0.36484 l 1.5999,-0.93792 1.5999,-0.93793 h 0.18654 0.18707 l 0.76223,-0.70745 0.76274,-0.70745 -0.7183,-0.61805 -0.7183,-0.61857 -0.24547,0.15193 -0.24494,0.15141 v 0.49403 0.49351 l -2.18023,0.83768 -2.18023,0.83715 -0.43615,0.38861 -0.43615,0.38861 -0.6873,-0.90124 -0.68677,-0.90124 v -0.17311 -0.17364 h 1.71772 1.71772 v -0.53485 -0.53537 l -0.72605,-0.27646 -0.72605,-0.27596 -0.70229,0.41497 -0.70176,0.41496 h -0.30748 -0.30747 l 0.16071,-0.50747 0.16123,-0.50746 -0.47335,-0.13384 -0.47388,-0.13384 -0.79271,-0.15658 -0.79272,-0.15607 -0.52865,-0.10283 -0.52865,-0.10335 -0.69763,-0.17829 -0.69815,-0.17828 -0.15606,0.2527 -0.15658,0.25321 2.06809,1.202 2.06809,1.20199 -0.22479,1.54047 -0.22428,1.54099 0.15761,2.313038 0.15813,2.31356 -0.2222,-0.004 -0.22221,-0.004 -0.38138,-0.24133 -0.38085,-0.24082 -0.30231,0.4129 -0.30179,0.41341 0.11938,0.62529 0.11937,0.62528 0.4315,0.0305 0.43201,0.0305 -0.48214,0.12557 -0.48163,0.12454 0.14108,0.36794 0.14108,0.36742 -0.33745,0.80305 -0.33796,0.80357 -0.11421,-0.0925 -0.11472,-0.0925 -0.4563,0.47852 -0.45631,0.47853 0.45631,0.23564 0.4563,0.23565 1.34566,0.31574 1.34565,0.31523 1.41077,1.27072 1.41076,1.27021 -0.0196,1.22834 -0.0196,1.22887 -0.43046,0.65732 -0.43047,0.65681 h -0.21755 -0.21808 l -0.58446,-0.50694 -0.58498,-0.50747 -0.0837,-0.61598 -0.0842,-0.6165 -0.20205,-1.14618 -0.20154,-1.14619 -0.39739,-0.15296 -0.39739,-0.15244 -0.35554,0.48627 -0.35553,0.48679 -0.1819,-0.18241 -0.18242,-0.18294 0.56638,-0.76481 0.56585,-0.76585 -0.35398,-0.29352 -0.35347,-0.29404 -1.86965,-0.0615 -1.86965,-0.061 0.14211,-0.66094 0.14262,-0.66094 1.09968,-0.99064 1.10019,-0.99063 0.19792,-5.3e-4 0.19844,-10e-4 v -0.39584 -0.39688 h -0.24908 -0.24857 l -0.1633,0.26458 -0.16329,0.26407 -0.57878,-0.0134 -0.57929,-0.0145 0.59479,-0.41496 0.59428,-0.41496 v -0.33228 -0.33176 l 0.41807,-0.34727 0.41806,-0.34675 0.49351,-0.94103 0.49299,-0.94102 0.32918,-0.61392 0.32918,-0.61392 -0.35605,-0.22014 -0.35605,-0.22014 -1.41284,-0.17622 -1.41283,-0.17673 v -0.192748 -0.19224 l 0.29766,-0.29817 0.29765,-0.29766 -0.17208,-0.68626 -0.17208,-0.68575 -0.52917,0.28319 -0.52968,0.28371 0.1819,0.31677 0.1819,0.31729 -0.22118,-0.2005 -0.22065,-0.2005 -0.59067,0.555 -0.59066,0.55501 -0.46405,-0.0894 -0.46457,-0.0899 -0.0873,-0.26459 -0.0873,-0.26458 0.62993,-0.39636 0.63046,-0.39636 1.33273,-1.05781 1.33274,-1.0573 0.14882,-0.34727 0.14883,-0.34726 -0.82527,-0.75396 -0.82527,-0.75396 0.17001,-0.67748 0.17002,-0.678 -0.99469,-0.62838 -0.99425,-0.62787 -0.26458,-0.0579 -0.26407,-0.0568 -0.39636,-0.33744 -0.39636,-0.33745 -0.43046,-0.15193 -0.43047,-0.15141 -0.27336,0.27337 -0.27337,0.27336 -0.3173,-0.19585 -0.31781,-0.19637 0.14005,-1.043863 0.14004,-1.043863 0.38757,-0.442352 0.38757,-0.441833 0.18708,-0.613399 0.18706,-0.6134 -0.52244,-0.136943 -0.52245,-0.136424 -0.42168,-0.968418 -0.42168,-0.968414 -0.27596,-0.762228 -0.27543,-0.761711 -1.1529,0.15813 -1.1529,0.158129 -0.86972,-1.022676 -0.7431,-0.872815 z m 1.82262,0 0.66198,0.327113 h 0.36742 0.3669 V 80.76509 Z m 7.61556,0 0.0636,0.569474 0.0708,0.639754 0.27079,0.326594 0.2713,0.326596 0.31884,-0.06666 0.31833,-0.06615 0.66094,-0.276987 0.66042,-0.276984 1.1896,-0.46664 1.18907,-0.466638 0.31367,-0.242361 h -4.68653 l 0.0124,0.06201 -0.30955,-0.06201 z m 7.9592,0 1.12603,1.037146 h 5.3e-4 l 1.21388,1.118793 0.31523,0.01035 0.31471,0.01085 0.13539,-0.219625 0.13591,-0.219623 -0.85731,-1.300697 -0.28836,-0.437181 z m 2.93678,0 -0.0103,0.03152 0.44079,0.929142 0.44081,0.92914 0.30592,0.189654 0.30644,0.189137 2.55695,0.198437 2.55695,0.197919 1.02423,0.54932 1.02474,0.549323 0.16072,0.458369 0.16019,0.457854 -0.12195,0.467154 -0.12196,0.466637 h -0.22427 -0.22376 l -0.28061,-0.523996 -0.2806,-0.524518 -1.38027,-0.636135 -1.3808,-0.636138 -1.77818,-0.168466 -1.77819,-0.167947 0.14624,0.380855 0.14625,0.38137 1.00924,0.699702 1.00924,0.699698 1.3131,0.346231 1.3131,0.34675 0.49867,0.289904 0.4992,0.289904 -0.26458,0.01188 -0.26407,0.01241 0.34726,0.220141 0.34675,0.220141 1.70119,-0.471805 1.70067,-0.471805 v 0.247529 0.24753 h 0.52865 0.52865 v -0.364318 -0.36432 l -0.40618,-0.972032 -0.40617,-0.97255 -0.52504,0.166912 -0.52451,0.166399 -0.50901,-1.150318 -0.5085,-1.150832 -0.60875,-0.548288 -0.60823,-0.548288 -0.42995,-0.150894 -0.43046,-0.150895 -0.27337,0.273886 -0.27337,0.273368 -0.31781,-0.196371 -0.31729,-0.196371 0.0703,-0.521931 z m 13.27774,0 v 0.526066 l 0.33021,0.272333 0.33022,0.27182 1.18907,0.173632 1.18959,0.174149 0.39636,0.06201 0.39636,0.06201 0.52865,0.288872 0.52865,0.289388 0.93793,-0.0863 0.93844,-0.0863 0.31471,0.503844 0.31471,0.503846 -0.7028,-0.267169 -0.70228,-0.267165 -0.19431,0.314708 -0.1943,0.314709 -1.38338,-0.16433 -1.38338,-0.163814 -0.43924,-0.397391 -0.43977,-0.39791 -0.97772,-0.155546 -0.97772,-0.155545 v 0.482658 0.482139 l 1.43351,1.120347 1.4335,1.119828 h 0.39274 0.39274 l 1.54565,-0.481108 1.54512,-0.481108 0.91674,0.374137 0.91622,0.374139 0.79944,0.701765 0.79891,0.702284 -0.0785,1.634524 -0.078,1.63453 0.23823,0.87695 0.23823,0.87694 0.32246,-0.0734 0.32195,-0.0724 -0.14728,0.23875 -0.14779,0.23823 0.89141,0.94516 0.8909,0.94568 0.6904,0.17312 0.68988,0.17311 v -0.24959 -0.2496 l -0.96376,-1.23816 -0.96429,-1.23766 0.15968,-0.15968 0.15968,-0.15968 1.39888,1.33274 1.3994,1.33273 0.70797,0.55501 0.70848,0.55449 0.15658,-0.25322 0.15658,-0.25321 -1.19527,-1.34669 -1.19528,-1.34617 v -0.11524 -0.11472 l 0.33021,0.14418 0.33073,0.14366 1.34876,1.61282 1.34927,1.61282 -0.80253,1.13895 -0.80254,1.13895 -0.10542,-0.10542 -0.10542,-0.10542 0.28009,-0.52349 0.28008,-0.524 -0.32504,-0.25734 -0.32453,-0.25787 -1.0573,-0.21756 -1.05678,-0.21807 -0.85938,0.0718 -0.85887,0.0718 v -0.28474 -0.28525 h -0.24959 -0.2496 l -1.19786,-1.25574 -1.19734,-1.25574 -0.006,-0.99528 -0.006,-0.99478 -0.24908,-0.459399 -0.24805,-0.458888 -0.45165,-1.264523 -0.45114,-1.26504 -0.29145,0.09922 -0.29042,0.09922 -0.0289,0.636654 -0.0284,0.637172 -0.0377,0.462503 -0.0372,0.462504 h -0.49609 -0.49609 l -0.31626,0.381374 -0.31626,0.380854 -0.90175,-0.506428 -0.90124,-0.506429 -0.33435,0.131773 -0.33435,0.131776 -0.5643,1.683617 -0.56431,1.68362 0.54777,0.54777 0.54777,0.54829 0.94155,-0.56896 0.94154,-0.56844 -0.4625,0.53278 -0.46251,0.53227 v 0.31884 0.31936 l -0.46199,0.70539 -0.46198,0.70538 -0.13488,-0.77876 -0.13487,-0.77877 -0.79065,-0.16898 -0.79065,-0.1695 -1.88464,-0.031 -1.88464,-0.0315 -0.69195,-0.90744 -0.69195,-0.90795 v -0.14986 -0.14986 h 0.2806 0.28112 l 1.71825,0.8294 1.71824,0.82889 0.25838,-0.2589 0.25839,-0.25838 -0.40773,-0.33848 -0.40721,-0.33848 -0.009,-0.29766 -0.009,-0.29817 -0.4961,-0.5948 -0.49609,-0.59531 h -0.27867 -0.27905 l -0.27337,-0.511075 -0.27389,-0.511595 V 88.94072 88.823931 l 0.79324,-0.158647 0.79272,-0.158647 v -0.413411 -0.413928 l -1.18495,0.07648 -1.18494,0.077 -0.52245,1.214911 -0.52296,1.214913 -0.4067,0.33745 -0.40669,0.33744 v 0.36433 0.36431 h 0.25063 0.25063 l -0.007,1.53273 -0.007,1.53272 -1.10225,-0.0367 -1.10175,-0.0372 -0.26458,-0.062 -0.26407,-0.0615 0.92501,-0.33434 0.92501,-0.33384 v -0.63355 -0.63355 l -0.49713,-0.0961 -0.49661,-0.0956 -0.21652,0.35036 -0.21653,0.34985 -0.8723,-0.99735 -0.87229,-0.99787 -0.79324,-0.0532 -0.79271,-0.0537 0.10283,0.39636 0.10232,0.39687 -0.0346,0.79272 -0.0346,0.79323 0.19638,0.27854 0.19636,0.27802 1.58544,1.08417 1.58595,1.08365 0.61805,0.18345 0.61805,0.18294 1.58026,0.96635 1.58078,0.96635 0.70849,0.4656 0.70849,0.46561 0.50901,0.17208 0.50902,0.17208 -0.57878,0.21446 -0.57878,0.213938 -1.25161,-0.686258 -1.2516,-0.68627 -0.25115,-0.23202 -0.25115,-0.23151 h -1.21498 -1.21492 l -1.02164,-1.04645 -1.02113,-1.04697 -0.22427,0.13901 -0.22428,0.1385 0.0615,0.80666 0.0615,0.80616 0.2713,0.0801 0.27182,0.0791 0.72709,0.15968 0.72657,0.15916 v 0.78807 0.788058 h 0.23202 0.23203 l 0.39998,-0.594798 0.39946,-0.59479 0.19998,0.19275 0.19948,0.19276 -0.71159,1.076418 -0.7121,1.0759 -1.31413,-0.9648 -1.31414,-0.964798 -0.39118,0.15038 -0.3912,0.14986 v 0.275438 0.27543 l 0.54932,0.45992 0.54933,0.45992 0.3917,0.74466 0.39119,0.74466 0.7519,-0.16537 0.75189,-0.16536 0.17311,0.28009 0.1726,0.28008 h 0.50798 0.50798 l 0.1602,-0.72709 0.1602,-0.72708 0.19688,-0.66094 0.19689,-0.66095 0.77101,-0.14727 0.77153,-0.147278 1.18908,0.997868 1.18908,0.99787 1.03869,0.91984 1.03818,0.92036 0.21394,-0.13178 0.21394,-0.13229 -0.12609,0.34417 -0.12609,0.34416 1.15135,1.22577 1.15084,1.22576 0.69556,-0.13281 0.69608,-0.13332 v -0.20309 -0.2036 l -0.38654,-0.74518 -0.38654,-0.74517 0.12713,-0.12713 0.12712,-0.12712 1.0635,1.0387 1.0635,1.03921 0.14935,0.59635 0.14986,0.59634 h 1.27537 1.27538 l 0.66869,0.25425 0.66869,0.25425 0.16382,-0.26614 0.16433,-0.26561 -0.32194,-0.38809 -0.32195,-0.38861 0.709,-0.65732 0.70952,-0.65784 h 0.13436 0.13384 l -0.14469,0.23409 -0.1447,0.23461 0.58136,0.15193 0.58084,0.15193 -0.57154,0.60926 -0.57205,0.60927 0.2222,0.36018 0.22273,0.36019 0.30024,-0.18552 0.30024,-0.18603 -0.0724,0.35036 -0.0729,0.34985 0.35037,-0.0729 0.34985,-0.0729 -0.13436,0.21756 -0.13436,0.21755 0.18086,0.26976 0.18087,0.27026 2.15543,1.59215 -0.001,-0.002 2.15542,1.59215 1.80868,-0.47128 1.80867,-0.47181 1.10743,-0.0155 1.10691,-0.0155 1.22111,-1.0573 1.22163,-1.05782 h 0.24805 0.24856 v -0.32039 -0.31988 l -1.11259,-1.13378 -1.11208,-1.13378 h -0.34107 -0.34157 v 0.14315 0.14262 l 0.52865,1.03611 0.52864,1.03663 v 0.14211 0.14366 h -0.20205 -0.20205 l -0.62736,-1.3224 -0.62735,-1.32188 h -0.22789 -0.22789 v -0.47904 -0.47904 l -0.78187,-0.57878 -0.78238,-0.57774 h -0.17673 -0.17725 l 0.13229,1.17357 0.13229,1.17409 -0.38137,-0.38034 -0.38086,-0.38137 h -0.50178 -0.50126 l 0.17002,0.44184 0.1695,0.44286 -0.41652,-0.15968 -0.41651,-0.15968 -0.15554,0.15503 -0.15555,0.15606 0.29404,0.3545 0.29455,0.35502 0.56224,0.002 0.56224,0.002 0.76482,0.50436 0.76429,0.50437 0.35863,-0.13798 0.35864,-0.13746 v 0.13023 0.13022 l -0.35657,0.6873 -0.35605,0.68678 -0.16433,-0.16382 -0.16381,-0.16433 -1.31259,0.56482 -1.31258,0.56483 h -0.78755 -0.78806 l -0.48421,-0.65629 -0.48473,-0.65578 -0.66094,-0.1173 -0.66042,-0.11782 -0.15606,-0.0196 -0.15607,-0.0196 -0.32969,-1.12345 -0.3297,-1.12396 -0.43666,-0.92501 -0.43667,-0.92553 -0.24443,-0.17466 -0.24391,-0.17467 -0.94775,0.14573 -0.94774,0.14625 -0.72657,0.36586 -0.72658,0.36587 v 0.52194 0.52193 h -0.36018 -0.36018 l -1.02733,-0.81494 -1.02733,-0.81545 -0.21963,-0.38861 -0.2191,-0.38861 0.37672,-0.58084 0.37672,-0.58033 0.14728,-0.78341 0.14676,-0.7829 -1.03095,-1.00097 -1.03146,-1.001488 v -0.30541 -0.30592 l 0.46251,0.37155 0.4625,0.37155 0.59118,0.330728 0.59066,0.33022 h 0.3638 0.3638 l 0.99788,0.79323 0.99735,0.79323 h -0.25011 -0.25012 l -0.51314,-0.38809 -0.51263,-0.38861 -0.17002,-0.008 -0.17001,-0.008 -0.15968,0.416 -0.15917,0.41547 0.31419,0.57568 0.31472,0.57568 -0.0765,0.79323 -0.0765,0.79323 -0.24546,0.29973 -0.24598,0.29972 0.42219,0.16175 0.4222,0.16226 0.57568,-0.29869 0.57567,-0.29817 0.3204,-0.25373 0.32039,-0.25373 -0.40928,-0.62477 -0.40927,-0.62529 0.17053,-0.27595 0.17053,-0.27595 h 0.76171 0.7612 l 0.16329,0.26458 0.16382,0.26407 h 0.26406 0.23306 v 0.23978 0.27026 l 0.53227,0.28526 0.53279,0.28525 0.0977,-0.3421 0.0982,-0.34158 0.30696,-1.12913 0.30644,-1.12913 -0.1602,-0.25941 -0.16071,-0.25993 -0.49506,0.26509 -0.49506,0.26511 h -0.48731 -0.48731 l -2.01073,-2.005568 -2.01125,-2.00556 -0.15141,0.24495 -0.15089,0.24443 0.51779,0.96686 0.5178,0.96687 v 0.13281 0.133318 h -0.2589 -0.2589 l -0.51986,-1.020088 -0.52038,-1.02009 -1.27951,0.12299 -1.27899,0.12299 -0.35244,-0.42478 -0.35243,-0.42479 -0.56224,0.004 -0.56224,0.004 -0.59479,0.15969 -0.5948,0.15916 v 0.36587 0.36587 l -0.19792,-0.004 -0.19844,-0.004 -0.79272,-0.72244 -0.79271,-0.72295 -0.85886,-1.233 -0.85887,-1.233 v -0.18707 -0.18759 l 0.40721,0.33849 0.40773,0.33796 1.24385,0.63459 1.24437,0.63407 1.71773,0.2191 1.71824,0.2186 0.23978,-0.22222 0.23978,-0.22272 -0.27079,-0.34158 -0.27027,-0.3421 -0.13074,-0.72708 -0.13126,-0.72658 h 0.23616 0.23565 l 0.15606,0.40618 0.15606,0.40618 0.786,0.40669 0.78652,0.40721 -0.16795,0.57464 -0.16846,0.57465 -0.10646,0.46302 -0.10645,0.4625 h 0.38137 0.38086 v -0.2465 -0.24649 l 0.52865,-0.16795 0.52864,-0.16795 v -0.47842 -0.47852 l -0.39635,-0.32918 -0.39636,-0.32918 v -0.27285 -0.27337 l -0.66094,-0.86661 -0.66043,-0.86662 v -0.14986 -0.14934 h 0.64492 0.64493 l 0.1633,-0.26459 0.16329,-0.26458 h 0.23875 0.23823 l 0.27026,1.00304 0.26975,1.00252 0.55863,0.59997 0.55862,0.59944 0.66404,0.2527 0.66404,0.2527 -0.27802,0.33486 -0.27853,0.33538 0.22324,0.9896 0.22324,0.99012 0.35192,0.45527 0.35243,0.45476 0.72864,0.727078 0.72864,0.72709 h 0.26665 0.26665 v -0.24494 -0.24547 l -0.66043,-0.519858 -0.66094,-0.51987 v -0.34313 -0.34261 l 0.33073,0.38344 0.33021,0.38395 0.71469,0.626838 0.71417,0.62683 1.79627,-1.654158 1.79627,-1.65365 0.96893,-0.61753 0.96894,-0.61753 -0.13746,-0.5271 -0.13798,-0.52659 -0.65009,-0.42633 -0.6506,-0.42633 0.14624,-0.70951 0.14625,-0.71004 -1.85364,-1.12344 -1.85415,-1.12345 h -0.40463 -0.40514 l 0.1633,0.26407 0.1633,0.26458 h -0.24753 -0.24753 l -0.30644,-0.36949 -0.30696,-0.37 0.11782,-0.65009 0.11782,-0.65009 0.55552,-1.149799 0.55501,-1.149284 -0.63511,-0.540536 -0.63458,-0.540536 -0.47026,-1.281575 -0.47025,-1.281576 -0.37724,-0.145211 -0.37776,-0.144693 -0.23357,0.36897 -0.23358,0.368969 -0.004,0.213939 -0.004,0.213943 0.33021,-0.198438 0.33021,-0.198437 -0.32349,0.399975 -0.3235,0.400492 1.05058,1.025777 1.05007,1.026295 v 0.228409 0.22841 l -0.71417,0.936376 -0.71416,0.936895 -0.49817,-0.615985 -0.49867,-0.615981 0.28783,-0.09612 0.28733,-0.0956 v -0.314226 -0.314193 l -0.81081,-0.984437 -0.81132,-0.983917 0.18707,-0.596347 0.18655,-0.596347 0.48886,-0.6258 0.48834,-0.625804 -0.14418,-0.23306 -0.14417,-0.233577 h -0.3173 -0.31729 l -0.33021,-0.529167 -0.33073,-0.529683 0.0884,-0.06149 h -0.82166 l 0.0336,0.855244 h 0.20309 0.20309 l 0.17208,0.541568 0.17157,0.541055 -0.31833,0.383955 -0.31884,0.383955 h -0.22221 -0.22273 l -0.24472,-0.46302 -0.24547,-0.462505 -0.13332,-1.006655 -0.10284,-0.773597 h -0.87953 l 0.002,0.031 -0.30128,0.186036 h -5.3e-4 l -0.30127,0.186553 -2.47272,0.03359 -2.4722,0.03411 0.14935,-0.470773 z m 11.66131,0 0.0403,0.104902 0.33435,-0.104902 z m 2.19573,0 -0.64906,0.121955 -0.14469,0.234095 -0.1447,0.234611 0.1633,0.264584 0.1633,0.264067 h 0.87695 0.87694 l 0.33849,-0.407728 0.33848,-0.407728 -0.27182,-0.271301 -0.0331,-0.03256 z m 2.30063,0 -0.001,0.0031 0.0119,-0.0031 z m 1.41025,0 -0.39016,0.09767 -0.28267,0.528648 -0.28318,0.52865 0.42168,0.643372 0.42116,0.642855 h 0.17467 0.17466 l 1.07435,-0.492993 1.07487,-0.492992 1.26814,-0.458888 1.26866,-0.459404 -0.10284,-0.30334 -0.0791,-0.233577 z m 6.95203,0 -0.33486,0.403074 0.51211,0.291973 0.5116,0.291973 1.07228,0.984952 v -0.0011 l 1.07229,0.984951 0.18242,0.0072 0.18242,0.0067 0.16019,-0.2589 0.15968,-0.258382 -0.60668,-0.865063 -0.60668,-0.865063 -0.185,-0.139528 -0.18449,-0.139526 -0.20412,-0.443383 z m 3.07992,0 -0.21291,0.57309 0.44545,0.492993 0.44597,0.492477 v 0.436666 0.437184 l 0.60616,0.151926 0.60668,0.152448 0.71056,-0.129191 0.71055,-0.128674 0.13487,0.218074 0.13539,0.218591 -0.41651,0.159679 -0.41651,0.160197 h -0.65784 -0.65732 l 0.0847,0.565857 0.0842,0.566375 0.58704,0.21549 0.58705,0.216008 0.38499,-0.385506 0.38499,-0.38499 h 0.14469 0.14417 l -0.14986,0.858862 -0.14934,0.859379 -0.39946,1.272792 -0.39894,1.273307 0.14779,0.147278 0.14728,0.147793 0.41393,-0.158646 0.41393,-0.158647 0.16639,-0.468704 0.1664,-0.468707 0.33797,-0.397391 0.33796,-0.396875 0.38757,-0.748273 0.38809,-0.747761 -0.35966,-0.693496 -0.35967,-0.693497 0.12041,-0.120407 0.12092,-0.120922 0.5643,0.505394 0.56431,0.50488 0.22479,0.353984 v -1.811261 l -0.16175,-0.261998 -0.16329,-0.264584 h 0.13229 0.13229 l 0.0605,0.09818 v -2.539378 h -2.62413 l 0.34314,0.322461 0.63923,0.60048 0.34365,-0.131776 0.34417,-0.131775 0.0362,0.592214 0.0362,0.591693 -0.89813,0.275952 -0.89814,0.275953 -0.27027,-0.505397 -0.27026,-0.504878 h -0.34624 -0.34623 l -0.46044,-0.509013 -0.46095,-0.509529 0.0594,-0.366385 h -1.11363 l 0.3731,0.292489 0.46251,0.363284 v 0.09974 0.09974 h -0.0992 -0.0997 l -0.36281,-0.462505 -0.30748,-0.39274 z M 52.378807,80.928904 v 0.160198 0.160713 l -0.89607,0.324011 -0.896069,0.324012 -0.149862,1.116726 -0.150378,1.117246 -0.1726,1.850533 -0.172082,1.850533 -0.397392,0.859377 -0.397391,0.85938 h -0.362252 -0.362769 l -1.192692,-0.31936 -1.193209,-0.31936 v -0.221176 -0.221176 l 0.330212,0.04341 0.330729,0.04289 0.461988,-0.03152 0.462504,-0.03152 V 88.27936 88.064902 l -0.765845,-0.566891 -0.766361,-0.566891 -0.683679,-0.171564 -0.683163,-0.171566 -0.279053,0.734838 -0.279053,0.734322 0.160197,0.730189 0.160197,0.72967 0.709518,0.168982 0.709517,0.168984 1.189592,0.596867 1.189075,0.59634 0.474906,-0.23513 0.47439,-0.23564 1.166337,-1.584402 1.16582,-1.584399 -0.156579,-2.460315 -0.15658,-2.459797 0.254248,-0.157097 0.254247,-0.157612 0.904338,0.623216 0.904338,0.622702 1.123445,0.68988 1.122929,0.689879 v 0.393259 0.393258 H 55.477842 55.14143 l -1.404049,-0.925526 -1.404567,-0.925007 h -0.241329 -0.241329 v 0.641821 0.642337 l 0.351401,0.351401 0.351917,0.351917 -0.109556,0.328144 -0.109037,0.328147 h 1.917197 1.917195 l 0.476456,-0.431499 0.476456,-0.431498 0.674894,0.442349 0.674897,0.442352 0.226859,-0.140044 0.227375,-0.14056 -0.03669,0.42478 -0.03617,0.424265 -0.725538,0.789099 -0.726053,0.789614 0.173632,0.303342 0.173633,0.303856 -0.216524,-0.196369 -0.216006,-0.195855 -0.354499,0.294555 -0.355018,0.294556 v 0.232029 0.232026 h 0.441833 0.441317 l 1.43195,-1.515152 1.431954,-1.515152 -1.278475,-1.057818 -1.278993,-1.058333 -1.896007,-1.813843 -1.895493,-1.814359 -0.813385,-0.05633 z m 67.733853,0 v 0.160198 0.160713 l -0.89607,0.324011 -0.89607,0.324012 -0.14986,1.116726 -0.15038,1.117246 -0.1726,1.850533 -0.17208,1.850533 -0.39739,0.859377 -0.39739,0.85938 h -0.36226 -0.36277 l -1.19269,-0.31936 -1.19321,-0.31936 v -0.221176 -0.221176 l 0.33022,0.04341 0.33072,0.04289 0.46199,-0.03152 0.46251,-0.03152 V 88.27936 88.064902 l -0.76585,-0.566891 -0.76636,-0.566891 -0.68368,-0.171564 -0.68316,-0.171566 -0.27905,0.734838 -0.27906,0.734322 0.1602,0.730189 0.1602,0.72967 0.70952,0.168982 0.70951,0.168984 1.18959,0.596867 1.18908,0.59634 0.4749,-0.23513 0.47439,-0.23564 1.16634,-1.584402 1.16582,-1.584399 -0.15658,-2.460315 -0.15658,-2.459797 0.25425,-0.157097 0.25425,-0.157612 0.90433,0.623216 0.90434,0.622702 1.12345,0.68988 1.12293,0.689879 v 0.393259 0.393258 h -0.33642 -0.33641 l -1.40405,-0.925526 -1.40456,-0.925007 h -0.24133 -0.24133 v 0.641821 0.642337 l 0.3514,0.351401 0.35192,0.351917 -0.10956,0.328144 -0.10904,0.328147 h 1.9172 1.91719 l 0.47646,-0.431499 0.47646,-0.431498 0.67489,0.442349 0.6749,0.442352 0.22686,-0.140044 0.22737,-0.14056 -0.0367,0.42478 -0.0367,0.424265 -0.72502,0.789099 -0.72657,0.789614 0.17363,0.303342 0.17416,0.303856 -0.21705,-0.196369 -0.216,-0.195855 -0.3545,0.294555 -0.35502,0.294556 v 0.232029 0.232026 h 0.44183 0.44184 l 1.43143,-1.515152 1.43247,-1.515152 -1.27899,-1.057818 -1.27899,-1.058333 -1.89601,-1.813843 -1.89549,-1.814359 -0.81338,-0.05633 z m -58.48429,0.426847 h 0.396359 0.396359 v 0.528651 0.528648 H 62.024729 61.62837 v -0.528648 z m 67.73385,0 h 0.39636 0.39636 v 0.528651 0.528648 h -0.39636 -0.39636 v -0.528648 z m -34.876423,0.02273 -0.968418,0.297656 -0.968414,0.297138 v 0.235646 0.235643 l -0.24288,-0.150379 -0.243395,-0.14986 -0.376206,0.376204 -0.376203,0.376205 -0.07131,1.543058 -0.07132,1.542542 -0.07855,1.057815 -0.07803,1.057301 -0.02379,0.433565 -0.02429,0.433049 -0.481108,0.594797 -0.481623,0.594281 -1.368393,-0.350886 -1.36891,-0.350885 v -0.214457 -0.213942 h 0.680062 0.680579 l -0.08578,-0.437182 -0.08526,-0.437182 -0.952915,-0.494543 -0.953429,-0.494543 -0.398425,0.152961 -0.398426,0.152963 -0.280603,0.615982 -0.280086,0.615466 0.391708,0.559657 0.392224,0.560171 1.107942,0.48163 1.107943,0.48162 0.660424,0.293 0.660942,0.29353 0.131776,0.0119 0.132292,0.0119 0.548285,-0.45682 0.548804,-0.45682 0.987536,-1.523939 0.988055,-1.523939 -0.154514,-0.486275 -0.154511,-0.486791 -0.209807,-1.744596 -0.210323,-1.745113 0.546219,-0.07906 0.545704,-0.07751 0.481623,0.595313 0.481627,0.594797 h 0.221691 0.221176 l 1.081069,0.707966 1.080556,0.707967 v 0.173116 0.173632 l -0.165883,0.165881 -0.165881,0.16588 -1.221113,-0.674893 -1.221631,-0.674894 -0.251148,-0.240295 -0.251148,-0.239779 h -0.497644 -0.497644 l 0.136943,0.330211 0.136943,0.330729 0.322977,0.991156 0.323495,0.991669 h 1.853115 1.853631 l 0.42117,-0.381371 0.42116,-0.381373 0.85473,0.414446 0.85524,0.414444 v 0.313676 0.314193 l -0.81545,0.776698 -0.81597,0.776179 -0.25373,0.468188 -0.25374,0.468187 0.16175,0.262 0.16175,0.262 1.56838,-1.364773 1.568383,-1.364258 v -0.342614 -0.342099 l -1.235583,-1.138433 -1.23507,-1.137915 -0.42582,-0.396875 -0.42529,-0.396356 -1.599387,-1.376662 z m 67.733853,0 -0.96841,0.297656 -0.96842,0.297138 v 0.235646 0.235643 l -0.24288,-0.150379 -0.2434,-0.14986 -0.3762,0.376204 -0.3762,0.376205 -0.0713,1.543058 -0.0713,1.542542 -0.0785,1.057815 -0.078,1.057301 -0.0238,0.433565 -0.0243,0.433049 -0.48111,0.594797 -0.48162,0.594281 -1.36839,-0.350886 -1.36891,-0.350885 v -0.214457 -0.213942 h 0.68006 0.68058 l -0.0863,-0.437182 -0.0853,-0.437182 -0.95291,-0.494543 -0.95343,-0.494543 -0.39843,0.152961 -0.39842,0.152963 -0.2806,0.615982 -0.28009,0.615466 0.39171,0.559657 0.39222,0.560171 1.10794,0.48163 1.10795,0.48162 0.66042,0.293 0.66094,0.29353 0.13178,0.0119 0.13229,0.0119 0.54829,-0.45682 0.5488,-0.45682 0.98754,-1.523939 0.98805,-1.523939 -0.15451,-0.486275 -0.15451,-0.486791 -0.20981,-1.744596 -0.21032,-1.745113 0.54622,-0.07906 0.5457,-0.07751 0.48162,0.595313 0.48163,0.594797 h 0.22169 0.22118 l 1.08106,0.707966 1.08056,0.707967 v 0.173117 0.173633 l -0.16588,0.16588 -0.16588,0.165881 -1.22112,-0.674894 -1.22163,-0.674894 -0.25115,-0.240295 -0.25114,-0.239778 h -0.49765 -0.49764 l 0.13694,0.33021 0.13694,0.33073 0.32298,0.991155 0.3235,0.991669 h 1.85311 1.85364 l 0.42116,-0.38137 0.42116,-0.381373 0.85473,0.414446 0.85525,0.414443 v 0.313675 0.314193 l -0.81546,0.776698 -0.81597,0.776179 -0.25373,0.468188 -0.25373,0.468187 0.16175,0.262 0.16174,0.262 1.56838,-1.364773 1.56838,-1.364258 v -0.342614 -0.342099 l -1.23558,-1.138433 -1.23507,-1.137915 -0.42581,-0.396875 -0.4253,-0.396356 -1.59938,-1.376662 z m -117.108617,0.590661 -1.255221,0.116271 -1.255224,0.11679 v 0.240295 0.240294 l 0.56431,0.459923 0.564824,0.45992 1.417484,1.440738 1.417485,1.440738 v 0.192236 0.192238 l 0.462504,0.105418 0.462504,0.104905 0.185002,-0.09354 0.185001,-0.09302 -1.047998,-2.168342 -1.048515,-2.168345 -0.326078,-0.293521 z m 67.733847,0 -1.25522,0.116271 -1.25522,0.11679 v 0.240295 0.240294 l 0.56431,0.459923 0.56482,0.45992 1.41749,1.440738 1.41748,1.440738 v 0.192236 0.192238 l 0.46251,0.105418 0.4625,0.104905 0.185,-0.09354 0.185,-0.09302 -1.04799,-2.168342 -1.04852,-2.168345 -0.32608,-0.293521 z m -28.596186,0.479557 -0.198953,0.122989 -0.198953,0.122473 0.154511,0.403593 0.15503,0.403077 0.375687,-0.144177 0.376206,-0.144177 -0.143145,0.230992 -0.142626,0.231511 0.351917,0.291973 0.351398,0.29197 0.188103,-0.187584 0.187584,-0.188103 -0.191719,0.500745 -0.192236,0.500229 0.439251,-0.168465 0.439248,-0.168466 -0.06304,0.320911 -0.06305,0.32091 0.350366,-0.07338 0.349851,-0.07235 -0.157615,0.254765 -0.157612,0.25528 0.825788,0.941028 0.826307,0.941546 h 0.368969 0.36897 v -0.08837 -0.08837 l -1.144633,-2.319239 -1.145148,-2.319753 -1.155486,-0.0863 z m 67.733856,0 -0.19895,0.122989 -0.19896,0.122473 0.15452,0.403593 0.15502,0.403077 0.37569,-0.144177 0.37621,-0.144177 -0.14315,0.230992 -0.14262,0.231511 0.35191,0.291973 0.3514,0.29197 0.1881,-0.187584 0.18759,-0.188103 -0.19172,0.500745 -0.19223,0.500229 0.43924,-0.168465 0.43925,-0.168466 -0.0636,0.320911 -0.063,0.32091 0.35036,-0.07338 0.34985,-0.07235 -0.15761,0.254765 -0.15761,0.25528 0.82578,0.941028 0.82631,0.941546 h 0.36897 0.36897 v -0.08837 -0.08837 l -1.14463,-2.319239 -1.14515,-2.319753 -1.15549,-0.0863 z m -102.501758,0.168466 -0.994771,0.18655 -0.995288,0.186552 -0.163815,0.265102 -0.163814,0.265615 0.501778,1.362708 0.502295,1.362707 0.303858,0.600998 0.30334,0.600996 0.282671,-0.09405 0.28267,-0.09353 0.07028,-2.321822 z m 67.733858,0 -0.99478,0.18655 -0.99529,0.186552 -0.16381,0.265102 -0.16381,0.265615 0.50178,1.362708 0.50229,1.362707 0.30386,0.600998 0.30334,0.600996 0.28267,-0.09405 0.28267,-0.09353 0.0703,-2.321822 z m -79.045312,0.06046 h 0.35967 0.35915 l 0.37104,0.594796 0.37052,0.594797 -0.1292,0.991669 -0.12919,0.991156 h -0.19688 -0.19689 l -0.72347,-0.670762 -0.72399,-0.670761 0.18655,-0.452683 0.18656,-0.452686 0.13332,-0.463021 z m 67.733852,0 h 0.35967 0.35915 l 0.37103,0.594796 0.37053,0.594797 -0.1292,0.991669 -0.12919,0.991156 h -0.19688 -0.19689 l -0.72347,-0.670762 -0.72399,-0.670761 0.18656,-0.452683 0.18655,-0.452686 0.13332,-0.463021 z m -33.175237,0.264583 h 0.132292 0.132291 V 83.0745 83.206276 H 72.860245 72.727953 V 83.0745 Z m 67.733857,0 h 0.13229 0.13229 v 0.132292 0.131776 h -0.13229 -0.13229 V 83.0745 Z m -86.232986,0.176218 0.176215,0.176215 0.176218,0.176218 -0.176218,0.176215 -0.176215,0.176218 v -0.352433 z m 67.733856,0 0.17621,0.176215 0.17622,0.176218 -0.17622,0.176215 -0.17621,0.176218 v -0.352433 z m -31.937076,0.101801 -0.786516,0.210325 -0.786514,0.210323 -0.08785,0.456303 -0.08785,0.456303 0.3483,0.419611 0.3483,0.419613 0.01188,0.295074 0.01241,0.294555 0.450101,1.014407 h 5.29e-4 l 0.450101,1.014926 0.334346,-0.112138 0.33383,-0.112138 -0.09043,-2.092378 -0.09147,-2.092378 -0.179316,-0.191204 z m 67.733856,0 -0.78651,0.210325 -0.78652,0.210323 -0.0884,0.456303 -0.0873,0.456303 0.3483,0.419611 0.3483,0.419613 0.0119,0.295074 0.0124,0.294555 0.4501,1.014407 h 5.3e-4 l 0.4501,1.014926 0.33435,-0.112138 0.33382,-0.112138 -0.0904,-2.092378 -0.0915,-2.092378 -0.17931,-0.191204 z m -56.75364,1.837097 h 0.13229 0.13177 v 0.131776 0.132292 h -0.13177 -0.13229 V 85.1891 Z m 67.73385,0 h 0.13229 0.13178 v 0.131776 0.132292 h -0.13178 -0.13229 V 85.1891 Z M 52.511098,86.9554 l -0.241329,0.230476 -0.241329,0.230479 0.637688,0.28112 0.637686,0.281119 0.89762,0.654225 0.898136,0.654222 h 0.336931 0.337447 l 0.812871,-0.684713 0.813385,-0.684196 V 87.581717 87.245302 L 54.955393,87.10061 Z m 67.733852,0 -0.24133,0.230476 -0.24133,0.230479 0.63769,0.28112 0.63769,0.281119 0.89762,0.654225 0.89813,0.654222 h 0.33693 0.33745 l 0.81287,-0.684713 0.81339,-0.684196 v -0.336415 -0.336415 l -2.44482,-0.144692 z m -15.67088,0.05323 -0.26458,0.0083 -0.26407,0.0078 -0.59479,0.706417 -0.59428,0.70745 v 0.462505 0.463021 l 1.89291,-0.159165 0.25011,-0.02119 v -1.954403 z m 67.73386,0 -0.26459,0.0083 -0.26406,0.0078 -0.5948,0.706417 -0.59428,0.70745 v 0.462505 0.463021 l 1.89291,-0.159165 0.25011,-0.02119 v -1.954403 z m -110.97153,0.04496 -0.253214,0.389642 -0.252699,0.389641 0.152445,0.644922 0.151929,0.644922 0.775663,0.793235 0.775148,0.79323 v 0.18345 0.18345 l 0.513146,0.13436 0.513146,0.13436 0.136427,-0.13642 0.135908,-0.13591 -0.518831,-1.017 -0.518314,-1.016988 0.363802,0.139525 0.364318,0.140044 0.603581,1.174089 0.604099,1.1746 h 0.222724 0.222726 v -0.24443 -0.24391 l 0.618567,-0.74724 0.61805,-0.74724 0.284221,-0.834575 0.284218,-0.834057 -0.468704,-0.122473 -0.468704,-0.122989 -0.433567,0.242877 -0.434081,0.243398 v 0.345197 0.345718 l -1.300697,-0.293008 -1.300694,-0.293005 -0.69505,-0.653706 z m 67.73385,0 -0.25321,0.389642 -0.2527,0.389641 0.15244,0.644922 0.15193,0.644922 0.77567,0.793235 0.77514,0.79323 v 0.18345 0.18345 l 0.51315,0.13436 0.51315,0.13436 0.13642,-0.13642 0.13591,-0.13591 -0.51883,-1.017 -0.51831,-1.016988 0.3638,0.139525 0.36432,0.140044 0.60358,1.174089 0.6041,1.1746 h 0.22272 0.22273 v -0.24443 -0.24391 l 0.61856,-0.74724 0.61805,-0.74724 0.28422,-0.834575 0.28422,-0.834057 -0.4687,-0.122473 -0.46871,-0.122989 -0.43356,0.242877 -0.43408,0.243398 v 0.345197 0.345718 l -1.3007,-0.293008 -1.3007,-0.293005 -0.69504,-0.653706 z m -35.682577,0.358635 -0.171048,0.276987 -0.171051,0.276984 0.610817,0.2589 0.610299,0.259416 1.057299,0.623219 1.056783,0.623734 0.436149,-0.114205 0.435636,-0.113689 0.72915,-0.761712 0.72967,-0.761193 -0.37259,-0.119372 -0.37207,-0.118856 -2.289779,-0.164848 z m 67.733857,0 -0.17105,0.276987 -0.17105,0.276984 0.61082,0.2589 0.6103,0.259416 1.05729,0.623219 1.05679,0.623734 0.43615,-0.114205 0.43563,-0.113689 0.72915,-0.761712 0.72968,-0.761193 -0.37259,-0.119372 -0.37207,-0.118856 -2.28978,-0.164848 z m -109.495132,0.719336 -0.417029,0.345715 -0.416512,0.345716 v 0.619601 0.619089 l 0.492476,0.26355 0.491959,0.26354 0.763262,0.14056 0.76326,0.14108 0.792718,0.2434 v -5.3e-4 l 0.792715,0.24339 0.759127,0.0227 0.759127,0.0222 -0.305406,-0.36794 -0.305409,-0.36845 -0.850077,-0.34365 -0.850077,-0.34313 -1.057301,-0.673863 -1.056783,-0.673862 -0.178285,-0.250113 z m 67.733852,0 -0.41703,0.345715 -0.41651,0.345716 v 0.619601 0.619089 l 0.49248,0.26355 0.49195,0.26354 0.76327,0.14056 0.76326,0.14108 0.79271,0.2434 v -5.3e-4 l 0.79272,0.24339 0.75913,0.0227 0.75912,0.0222 -0.3054,-0.36794 -0.30541,-0.36845 -0.85008,-0.34365 -0.85008,-0.34313 -1.0573,-0.673863 -1.05678,-0.673862 -0.17828,-0.250113 z m -37.910866,0.01035 0.176215,0.176215 0.176218,0.176218 h -0.352433 -0.352435 l 0.176217,-0.176218 z m 67.733856,0 0.17621,0.176215 0.17622,0.176218 h -0.35243 -0.35243 l 0.17621,-0.176218 z m -74.076622,0.352412 v 0.132292 0.132292 h 0.132292 0.131775 V 88.626615 88.494323 H 75.23891 Z m 67.733852,0 v 0.132292 0.132292 h 0.13229 0.13178 v -0.132292 -0.132292 h -0.13178 z m -50.364369,0.173633 -0.360185,0.492477 -0.359669,0.492474 v 0.163299 0.163296 l 0.330729,0.45269 0.330729,0.4532 0.660426,0.12816 0.659908,0.12816 1.321366,0.37103 1.321367,0.37104 0.627355,0.0238 0.62683,0.0238 -0.30799,-0.37104 -0.30748,-0.37104 -1.376654,-0.70434 -1.376143,-0.704354 -0.895038,-0.556556 z m 67.733859,0 -0.36019,0.492477 -0.35967,0.492474 v 0.163299 0.163296 l 0.33073,0.45269 0.33073,0.4532 0.66043,0.12816 0.6599,0.12816 1.32137,0.37103 1.32137,0.37104 0.62735,0.0238 0.62684,0.0238 -0.308,-0.37104 -0.30747,-0.37104 -1.37666,-0.70434 -1.37614,-0.704354 -0.89504,-0.556556 z m -81.931959,0.09095 h 0.131776 0.132292 v 0.132292 0.132292 h -0.132292 -0.131776 v -0.132292 z m 67.733859,0 h 0.13177 0.13229 v 0.132292 0.132292 h -0.13229 -0.13177 v -0.132292 z m -75.930259,0.230476 -0.173114,0.451652 -0.173117,0.451648 0.465603,0.34107 0.465606,0.34055 0.644406,-0.29404 0.644922,-0.29404 -0.07855,-0.415479 -0.07855,-0.41548 -0.858345,-0.08268 z m 67.733859,0 -0.17312,0.451652 -0.17311,0.451648 0.4656,0.34107 0.4656,0.34055 0.64441,-0.29404 0.64492,-0.29404 -0.0791,-0.415479 -0.078,-0.41548 -0.85835,-0.08268 z m -78.976065,0.293524 -0.853178,0.729156 -0.853179,0.72967 0.160714,0.58084 0.160713,0.58033 0.435115,0.093 0.435634,0.093 0.516763,-0.93793 0.517282,-0.93793 0.01138,-0.374652 0.01138,-0.374655 -0.271301,-0.09043 z m 67.733855,0 -0.85318,0.729156 -0.85318,0.72967 0.16071,0.58084 0.16072,0.58033 0.43511,0.093 0.43564,0.093 0.51676,-0.93793 0.51728,-0.93793 0.0114,-0.374652 0.0114,-0.374655 -0.2713,-0.09043 z m -21.57388,0.483174 -0.3669,0.05064 h -0.73743 -0.7369 l -0.34933,0.330212 -0.34882,0.33073 -0.39688,-0.007 -0.39635,-0.007 -0.30645,-0.19224 -0.30644,-0.19223 -0.42013,0.16123 -0.42012,0.16123 v -0.2925 -0.292485 h -0.301803 -0.30179 l -0.75034,0.784965 -0.74982,0.78548 0.15089,0.3943 0.15141,0.39429 0.53744,0.17053 0.53692,0.17053 0.22737,-0.35863 0.22738,-0.35864 0.004,-0.447 0.004,-0.447 0.264063,-0.16381 0.26459,-0.1633 -0.0196,0.47852 -0.0191,0.47801 -0.448553,0.76429 -0.44855,0.7643 -2.57039,0.0351 -2.569869,0.0351 0.136943,-0.4315 0.136943,-0.4315 -0.336415,-0.27802 -0.336413,-0.27802 -0.968417,-0.18138 -0.968415,-0.18087 -0.947748,0.34262 -0.947227,0.34261 v 0.35192 0.35191 l 0.375687,0.14418 0.375688,0.14418 0.535368,-0.28681 0.535369,-0.28628 0.639236,0.63924 0.639238,0.63923 1.554943,0.20826 1.554943,0.20825 0.132292,0.0362 0.131776,0.0367 0.396878,0.14935 0.39636,0.14986 1.23403,0.31884 1.23455,0.31833 0.274923,-0.17002 0.27491,-0.17001 0.16485,-0.98185 0.16433,-0.98237 0.27596,-0.89866 0.27543,-0.89865 0.26148,0.46767 0.26149,0.46716 -0.0139,1.02423 -0.0145,1.02371 0.41392,0.41392 0.41393,0.41393 0.69298,-0.78496 0.69247,-0.78548 0.72657,-0.4501 0.22737,-0.14057 z m 67.73385,0 -0.3669,0.05064 h -0.73742 -0.73691 l -0.34933,0.330212 -0.34882,0.33073 -0.39687,-0.007 -0.39636,-0.007 -0.30644,-0.19224 -0.30644,-0.19223 -0.42013,0.16123 -0.42013,0.16123 v -0.29249 -0.292494 h -0.30179 -0.30179 l -0.75034,0.784964 -0.74983,0.78548 0.1509,0.3943 0.15141,0.39429 0.53743,0.17053 0.53692,0.17053 0.22738,-0.35863 0.22737,-0.35864 0.004,-0.447 0.004,-0.447 0.26407,-0.16381 0.26458,-0.1633 -0.0196,0.47852 -0.0191,0.47801 -0.44856,0.76429 -0.44855,0.7643 -2.57038,0.0351 -2.56987,0.0351 0.13694,-0.4315 0.13694,-0.4315 -0.33641,-0.27802 -0.33641,-0.27802 -0.96842,-0.18138 -0.96842,-0.18087 -0.94774,0.34262 -0.94723,0.34261 v 0.35192 0.35191 l 0.37569,0.14418 0.37569,0.14418 0.53536,-0.2868 0.53537,-0.28629 0.63924,0.63924 0.63923,0.63923 1.55495,0.20826 1.55494,0.20825 0.13229,0.0362 0.13178,0.0367 0.39688,0.14935 0.39635,0.14986 1.23404,0.31885 1.23455,0.31832 0.27491,-0.17002 0.27492,-0.17001 0.16485,-0.98185 0.16433,-0.98237 0.27596,-0.89865 0.27543,-0.89866 0.26148,0.46768 0.26148,0.46715 -0.0139,1.02423 -0.0145,1.02371 0.41392,0.41392 0.41394,0.41393 0.69298,-0.78496 0.69246,-0.78548 0.72657,-0.4501 0.22738,-0.14057 z m -113.071654,0.447002 -0.438732,1.18959 -0.439251,1.18959 -2.937806,0.0749 -2.93832,0.0744 v -0.22014 -0.22014 l 0.308507,-0.30851 0.307991,-0.30851 -0.419611,-0.16123 -0.420129,-0.16123 -0.350885,-0.0532 -0.350882,-0.0532 -0.335897,-0.20929 -0.33538,-0.2098 -0.985986,0.31523 -0.985469,0.3147 -0.240296,0.2217 -0.239779,0.22117 0.325562,0.39171 0.325045,0.39222 0.443384,-0.16278 0.442867,-0.16226 0.232544,-0.38861 0.232543,-0.38809 0.334347,0.79478 0.333828,0.79479 1.944069,0.2899 1.944068,0.29042 1.057299,0.36794 1.056783,0.36845 0.898136,-0.0274 0.89762,-0.0269 0.500745,-1.71875 0.501261,-1.71824 0.05478,-0.39688 0.05478,-0.39636 h -0.389123 z m 67.733854,0 -0.43873,1.18959 -0.43926,1.18959 -2.9378,0.0749 -2.93832,0.0744 v -0.22014 -0.22014 l 0.30851,-0.30851 0.30799,-0.30851 -0.41961,-0.16123 -0.42013,-0.16123 -0.35089,-0.0532 -0.35088,-0.0532 -0.3359,-0.20929 -0.33538,-0.2098 -0.98598,0.31523 -0.98547,0.3147 -0.2403,0.2217 -0.23978,0.22117 0.32557,0.39171 0.32504,0.39222 0.44338,-0.16278 0.44287,-0.16226 0.23254,-0.38861 0.23255,-0.38809 0.33435,0.79478 0.33383,0.79479 1.94406,0.2899 1.94407,0.29042 1.0573,0.36794 1.05678,0.36845 0.89814,-0.0274 0.89762,-0.0269 0.50074,-1.71875 0.50126,-1.71824 0.0548,-0.39688 0.0548,-0.39636 h -0.38913 z m -53.081517,0.39636 h 0.874363 0.874366 l 0.486791,0.35656 v -5.3e-4 l 0.487309,0.35657 -0.267684,0.16537 -0.267166,0.16536 -0.145211,-0.14521 -0.144695,-0.14469 -0.486791,-0.092 -0.486275,-0.092 -0.462505,-0.0207 -0.462502,-0.0207 v -0.26395 z m 67.733857,0 h 0.87436 0.87437 l 0.48679,0.35656 v -5.3e-4 l 0.48731,0.35657 -0.26768,0.16537 -0.26717,0.16536 -0.14521,-0.14521 -0.1447,-0.14469 -0.48679,-0.092 -0.48628,-0.092 -0.4625,-0.0207 -0.4625,-0.0207 v -0.26395 z m -39.24361,0.22789 1.09451,0.32815 1.09399,0.32762 -0.34158,0.32298 -0.3421,0.32298 -0.59221,0.17777 -0.59273,0.17776 -0.30902,-0.67902 -0.30954,-0.67955 0.14934,-0.14934 z m 67.73386,0 1.09451,0.32815 1.09398,0.32762 -0.34157,0.32298 -0.3421,0.32298 -0.59221,0.17777 -0.59273,0.17776 -0.30903,-0.67902 -0.30954,-0.67955 0.14934,-0.14934 z m -91.995941,0.0367 h 0.132291 0.132292 v 0.13229 0.13178 H 78.67436 78.542069 v -0.13178 z m 67.733851,0 h 0.1323 0.13229 v 0.13229 0.13178 h -0.13229 -0.1323 v -0.13178 z m -102.188597,0.26407 h 0.14056 0.140043 l 0.756543,0.6506 0.756543,0.65009 -0.140043,0.14005 -0.140044,0.14004 -0.756543,-0.79013 z m 37.626126,0 h 0.132292 0.132291 v 0.13229 0.13229 h -0.132291 -0.132292 v -0.13229 z m 30.107721,0 h 0.14056 0.14005 l 0.75654,0.6506 0.75654,0.65009 -0.14004,0.14005 -0.14004,0.14004 -0.75654,-0.79013 z m 37.62614,0 h 0.13229 0.13229 v 0.13229 0.13229 h -0.13229 -0.13229 v -0.13229 z m -58.975221,2.45721 -0.342099,0.21136 -0.341582,0.21135 0.124542,0.10181 0.124539,0.1018 1.321367,0.74207 1.321366,0.74156 0.72967,0.38137 0.729674,0.38086 -0.184486,0.29817 -0.183968,0.29817 -0.115239,1.46555 -0.115237,1.46606 -0.02066,0.792708 -0.02119,0.79324 0.159681,0.84336 0.159679,0.84284 0.181385,0.29352 0.181385,0.29352 0.338998,-0.28163 0.338997,-0.28164 0.201539,0.86351 0.201019,0.86352 -0.01654,0.14159 -0.01654,0.1416 0.443903,0.031 0.443383,0.031 1.057302,0.17673 1.0573,0.17725 -0.52865,-0.49454 -0.52865,-0.49455 -0.328666,-0.51624 -0.329179,-0.51574 -0.791681,-1.32188 -0.791683,-1.32188 -0.0021,-0.60307 -0.0021,-0.603058 0.437701,-0.16795 0.4377,-0.16846 0.664559,0.37465 0.664039,0.374648 0.42065,1.84795 0.42064,1.84744 0.48059,0.0925 0.48008,0.0925 1.498623,-1.01028 1.49861,-1.01027 0.52607,-0.27544 0.52658,-0.27595 0.077,-0.40049 0.077,-0.40101 -2.07171,0.0884 -2.072223,0.0879 -0.51315,-0.57361 -0.51366,-0.573608 0.49661,-0.29662 0.49661,-0.29714 1.749763,-1.14773 1.74977,-1.14774 0.59479,-0.55035 0.59438,-0.55087 v 0.31057 0.31058 h -0.29873 -0.29869 l 0.14831,0.91622 0.14883,0.91622 -0.5023,-0.31419 -0.50281,-0.31367 -0.54415,0.58445 -0.54416,0.58447 -0.80976,0.41909 -0.809773,0.41858 0.16588,0.16588 0.16588,0.16588 1.090893,0.0563 1.09089,0.0558 0.61546,-0.234084 0.61547,-0.23409 0.34107,0.13125 0.34106,0.13074 -0.0289,0.663524 -0.0294,0.66404 -0.90434,0.77308 -0.90434,0.7736 -0.29765,0.0108 -0.29817,0.0109 -0.30903,0.37207 -0.30851,0.37207 -0.92811,0.4408 -0.928623,0.4408 0.1049,0.31057 0.10439,0.31058 0.751373,-0.0909 0.75138,-0.0915 0.67902,-0.42013 0.67903,-0.42013 0.59532,-0.52658 0.59531,-0.52659 0.7922,0.88729 0.7922,0.8878 v 0.36742 0.36793 l -0.72657,-0.0749 -0.72709,-0.0749 -0.29662,-0.2129 -0.29714,-0.21291 -0.42995,0.16485 -0.42943,0.16536 v 0.23616 0.23617 h -0.49661 -0.4961 l -0.33434,0.40255 -0.33435,0.40308 0.10387,0.0868 0.10387,0.0873 2.11408,-0.21807 2.11409,-0.21756 0.16174,0.0243 v -3.10988 l -0.41341,-0.2465 -1.04593,-0.62373 0.39894,-0.15296 0.39895,-0.15348 0.66145,0.30075 v -2.681994 l -0.28577,-0.37776 -0.004,-0.42995 -0.004,-0.42943 0.16485,-0.8263 0.12868,-0.64286 v -3.08973 l -0.016,0.0357 -0.51574,1.15238 -0.1452,-0.0661 -0.1447,-0.0662 -0.13229,0.0331 -0.13229,0.0331 -0.19792,0.0336 -0.19844,0.0336 -2.24638,1.09503 -2.246373,1.0945 -1.05678,0.34675 -1.0573,0.34727 -0.337966,0.40359 -0.337965,0.40359 -0.643372,-0.78806 -0.643887,-0.78807 -0.0098,-0.19844 -0.01035,-0.19791 0.726569,-0.0259 0.727089,-0.0253 1.012342,0.047 1.01234,0.0481 -0.0873,-0.59583 -0.0873,-0.59583 -0.73691,-0.24443 -0.736902,-0.24443 -0.888834,0.42168 -0.888836,0.42219 -0.356565,-0.0212 -0.356053,-0.0212 0.330213,-0.13332 0.330214,-0.13333 v -0.50694 -0.50643 h -0.396359 -0.396359 l -0.06615,-0.016 -0.06615,-0.0155 -1.76475,-0.47387 z m 67.733851,0 -0.34209,0.21136 -0.34158,0.21135 0.12454,0.10181 0.12453,0.1018 1.32137,0.74207 1.32137,0.74156 0.72967,0.38137 0.72967,0.38086 -0.18449,0.29817 -0.18396,0.29817 -0.11524,1.46555 -0.11524,1.46606 -0.0207,0.792708 -0.0217,0.79324 0.15968,0.84336 0.15968,0.84284 0.18139,0.29352 0.18138,0.29352 0.339,-0.28163 0.339,-0.28164 0.20154,0.86351 0.20101,0.86352 -0.016,0.14159 -0.0165,0.1416 0.44391,0.031 0.44338,0.031 1.0573,0.17673 1.0573,0.17725 -0.52865,-0.49454 -0.52865,-0.49455 -0.32866,-0.51624 -0.32918,-0.51574 -0.79168,-1.32188 -0.79169,-1.32188 -0.002,-0.60307 -0.002,-0.603058 0.4377,-0.16795 0.4377,-0.16846 0.66456,0.37465 0.66404,0.374648 0.42064,1.84795 0.42065,1.84744 0.48059,0.0925 0.48007,0.0925 1.49862,-1.01028 1.49862,-1.01027 0.52606,-0.27544 0.52659,-0.27595 0.077,-0.40049 0.077,-0.40101 -2.0717,0.0884 -2.07223,0.0879 -0.51315,-0.57361 -0.51366,-0.573608 0.49661,-0.29662 0.49661,-0.29714 1.74976,-1.14773 1.74977,-1.14774 0.59479,-0.55035 0.59428,-0.55087 v 0.31057 0.31058 h -0.29869 -0.29869 l 0.14831,0.91622 0.14883,0.91622 -0.50229,-0.31419 -0.50281,-0.31367 -0.54416,0.58445 -0.54415,0.58447 -0.80977,0.41909 -0.80977,0.41858 0.16588,0.16588 0.16588,0.16588 1.09089,0.0563 1.09089,0.0558 0.61547,-0.234084 0.61547,-0.23409 0.34106,0.13125 0.34107,0.13074 -0.0289,0.663524 -0.0295,0.66404 -0.90434,0.77308 -0.90433,0.7736 -0.29766,0.0108 -0.29817,0.0109 -0.30903,0.37207 -0.30851,0.37207 -0.9281,0.4408 -0.92863,0.4408 0.1049,0.31057 0.10439,0.31058 0.75137,-0.0909 0.75138,-0.0915 0.67903,-0.42013 0.67903,-0.42013 0.59531,-0.52658 0.59531,-0.52659 0.7922,0.88729 0.7922,0.8878 v 0.36742 0.36793 l -0.72657,-0.0749 -0.72709,-0.0749 -0.29662,-0.2129 -0.29714,-0.21291 -0.42995,0.16485 -0.42943,0.16536 v 0.23616 0.23617 h -0.49661 -0.49609 l -0.33435,0.40255 -0.33435,0.40308 0.10387,0.0868 0.10387,0.0873 2.11408,-0.21807 2.11409,-0.21756 0.16175,0.0243 v -3.10988 l -0.41333,-0.2465 -1.04593,-0.62373 0.39894,-0.15296 0.39894,-0.15348 0.66146,0.30075 v -2.681994 l -0.28577,-0.37776 -0.004,-0.42995 -0.004,-0.42943 0.16484,-0.8263 0.12868,-0.64286 v -3.08973 l -0.016,0.0357 -0.51573,1.15238 -0.14521,-0.0661 -0.1447,-0.0662 -0.13229,0.0331 -0.13229,0.0331 -0.19792,0.0336 -0.19844,0.0336 -2.24637,1.09503 -2.24638,1.0945 -1.05678,0.34675 -1.0573,0.34727 -0.33797,0.40359 -0.33796,0.40359 -0.64337,-0.78806 -0.64389,-0.78807 -0.01,-0.19844 -0.0103,-0.19791 0.72657,-0.0259 0.72709,-0.0253 1.01234,0.047 1.01234,0.0481 -0.0873,-0.59583 -0.0873,-0.59583 -0.7369,-0.24443 -0.73691,-0.24443 -0.88883,0.42168 -0.88884,0.42219 -0.35657,-0.0212 -0.35604,-0.0212 0.33021,-0.13332 0.33021,-0.13333 v -0.50694 -0.50643 h -0.39636 -0.39636 l -0.0661,-0.016 -0.0662,-0.0155 -1.76475,-0.47387 z m -91.292103,0.89194 0.176216,0.17621 0.176217,0.17622 h -0.352433 -0.352435 l 0.176218,-0.17622 z m 67.733853,0 0.17621,0.17621 0.17622,0.17622 h -0.35243 -0.35243 l 0.17621,-0.17622 z m -93.368462,0.79891 0.4625,0.39223 0.46251,0.39222 1.522383,0.72709 1.521871,0.72709 -0.174666,0.31006 -0.175183,0.30954 -0.397392,0.4625 -0.396875,0.46251 h -0.164848 -0.164331 l -0.389124,-0.47439 -0.389125,-0.47439 -0.85886,-1.22112 -0.85886,-1.22111 v -0.19585 z m 67.733852,0 0.4625,0.39223 0.4625,0.39222 1.52239,0.72709 1.52187,0.72709 -0.17466,0.31006 -0.17518,0.30954 -0.3974,0.4625 -0.39687,0.46251 h -0.16485 -0.16433 l -0.38912,-0.47439 -0.38913,-0.47439 -0.85886,-1.22112 -0.85886,-1.22111 v -0.19585 z m -41.799004,0.0749 1.10536,0.80306 1.105358,0.80253 0.660424,0.51005 0.660942,0.50953 -0.605647,-0.0439 -0.605131,-0.0444 -0.434599,-0.48007 -0.434081,-0.48008 -0.877983,-0.54312 -0.877983,-0.5426 0.151411,-0.24546 z m 67.733854,0 1.10536,0.80306 1.10536,0.80253 0.66043,0.51005 0.66094,0.50953 -0.60565,-0.0439 -0.60513,-0.0444 -0.43461,-0.48007 -0.43408,-0.48008 -0.87798,-0.54312 -0.87798,-0.5426 0.15141,-0.24546 z m -96.752242,0.13953 0.11008,0.33021 0.11007,0.33073 h -0.44029 -0.44028 l 0.0879,-0.26458 0.0884,-0.26458 0.24184,-0.0662 z m 67.733852,0 0.11008,0.33021 0.11007,0.33073 h -0.44029 -0.44028 l 0.0879,-0.26458 0.0884,-0.26458 0.24185,-0.0662 z m -55.688071,0.37931 -0.252698,0.15658 -0.252697,0.15606 0.12454,1.71566 0.12454,1.71617 0.15503,0.25115 0.155545,0.251658 h 0.62942 0.62942 l 0.160194,-0.258898 0.159682,-0.2589 -0.298172,-0.55758 -0.298174,-0.55759 -0.125574,-0.70384 -0.126091,-0.70383 -0.392741,-0.60306 z m 67.733851,0 -0.2527,0.15658 -0.25269,0.15606 0.12454,1.71566 0.12454,1.71617 0.15502,0.25115 0.15555,0.251658 h 0.62942 0.62942 l 0.1602,-0.258898 0.15968,-0.2589 -0.29818,-0.55758 -0.29817,-0.55759 -0.12557,-0.70384 -0.12609,-0.70383 -0.39274,-0.60306 z m -34.903296,0.008 0.707966,0.49919 0.708483,0.49971 1.153419,0.52503 1.152901,0.52504 -0.756542,0.83612 -0.75706,0.83613 -1.267105,-1.59732 -1.267624,-1.59732 0.162779,-0.26355 z m 67.733856,0 0.70797,0.49919 0.70848,0.49971 1.15342,0.52503 1.1529,0.52504 -0.75654,0.83612 -0.75706,0.83613 -1.26711,-1.59732 -1.26762,-1.59732 0.16278,-0.26355 z m -59.915213,0.48575 0.155546,1.76786 0.155546,1.76836 0.309542,0.373098 0.309544,0.37363 -0.626838,-0.0181 -0.626835,-0.0186 -0.509529,-0.19999 -0.509014,-0.19947 0.442868,-0.17002 0.443383,-0.170008 v -0.67748 -0.678 l -0.412377,-0.15813 -0.411861,-0.15813 -0.764812,0.73278 -0.764294,0.73277 0.05323,0.29249 0.05374,0.293518 -0.264583,-0.0424 -0.264068,-0.0408 -0.404108,-0.0904 -0.404628,-0.091 -0.124023,0.26458 -0.12454,0.26459 1.982309,0.97358 1.98179,0.97358 0.197922,0.0837 0.197919,0.0837 -0.567407,1.14722 -0.567407,1.1467 -0.318844,0.12247 -0.31936,0.12248 -0.962732,-0.56845 -0.963247,-0.56844 0.0041,-0.17208 0.0036,-0.17208 0.226859,-0.35812 0.226343,-0.3576 0.546222,0.29249 0.546219,0.29249 0.190169,-0.30799 0.19017,-0.30799 -0.599964,-0.48576 -0.599964,-0.48628 h -0.45625 -0.456819 l -0.853178,0.93793 -0.85266,0.93741 -0.09819,0.51056 -0.0987,0.51108 1.10691,0.30076 1.106909,0.30075 0.396359,0.0811 0.396875,0.0806 0.197921,0.0207 0.198438,0.0202 v 0.50695 0.50695 l 0.33021,0.1328 v 5.3e-4 l 0.330729,0.13281 0.958599,-1.03404 0.958599,-1.03353 0.957045,-1.60766 0.957567,-1.60765 v -0.37776 -0.37775 l -0.462505,-0.0155 -0.462505,-0.0155 0.433049,-0.29508 0.432533,-0.29455 -0.345718,-1.07745 -0.345196,-1.07797 -0.224793,-0.79065 -0.224793,-0.79014 -0.493511,-0.0951 z m 67.733853,0 0.15555,1.76786 0.15554,1.76836 0.30955,0.373098 0.30954,0.37363 -0.62684,-0.0181 -0.62683,-0.0186 -0.50953,-0.19999 -0.50901,-0.19947 0.44286,-0.17002 0.44339,-0.170008 v -0.67748 -0.678 l -0.41238,-0.15813 -0.41186,-0.15813 -0.76481,0.73278 -0.7643,0.73277 0.0532,0.29249 0.0532,0.293518 -0.26459,-0.0424 -0.26406,-0.0408 -0.40411,-0.0904 -0.40463,-0.091 -0.12402,0.26458 -0.12454,0.26459 1.98231,0.97358 1.98179,0.97358 0.19792,0.0837 0.19792,0.0837 -0.56741,1.14722 -0.56741,1.1467 -0.31884,0.12247 -0.31936,0.12248 -0.96273,-0.56845 -0.96325,-0.56844 0.004,-0.17208 0.004,-0.17208 0.22686,-0.35812 0.22635,-0.3576 0.54622,0.29249 0.54621,0.29249 0.19017,-0.30799 0.19017,-0.30799 -0.59996,-0.48576 -0.59996,-0.48628 h -0.45631 -0.45682 l -0.85317,0.93793 -0.85266,0.93741 -0.0982,0.51056 -0.0987,0.51108 1.10691,0.30076 1.10691,0.30075 0.39635,0.0811 0.39688,0.0806 0.19792,0.0207 0.19844,0.0202 v 0.50695 0.50695 l 0.33021,0.1328 v 5.3e-4 l 0.33073,0.13281 0.9586,-1.03404 0.9586,-1.03353 0.95704,-1.60766 0.95757,-1.60765 v -0.37776 -0.37775 l -0.46251,-0.0155 -0.4625,-0.0155 0.43305,-0.29508 0.43253,-0.29455 -0.34572,-1.07745 -0.3452,-1.07797 -0.22479,-0.79065 -0.22479,-0.79014 -0.49351,-0.0951 z m -119.159652,0.0455 1.10536,0.80306 1.10536,0.80305 0.66042,0.50952 0.66094,0.51005 -0.60513,-0.0444 -0.60565,-0.0439 -0.43408,-0.48059 -0.4346,-0.48012 -0.87798,-0.5426 -0.87798,-0.54312 0.15141,-0.24547 z m 67.733852,0 1.10536,0.80306 1.10536,0.80305 0.66042,0.50952 0.66094,0.51005 -0.60513,-0.0444 -0.60565,-0.0439 -0.43408,-0.48059 -0.4346,-0.48007 -0.87798,-0.54261 -0.87798,-0.54311 0.15141,-0.24547 z m -46.812651,2.12235 -0.832506,0.29042 -0.83199,0.28991 v 0.39894 0.39946 l 0.462502,-0.19069 0.461989,-0.19068 0.462502,-0.13281 0.462505,-0.13281 v -0.36587 -0.36587 h -0.0925 z m 67.733851,0 -0.83251,0.29042 -0.83199,0.28991 v 0.39894 0.39946 l 0.46251,-0.19069 0.46199,-0.19068 0.4625,-0.13281 0.4625,-0.13281 v -0.36587 -0.36587 h -0.0925 z m -56.7955,0.71055 0.900203,0.19379 0.900205,0.19327 0.264065,0.0718 0.264067,0.0708 0.744141,0.304888 0.74414,0.30541 h 0.262517 0.262515 l -0.191202,0.30902 -0.190685,0.30955 0.423746,-0.16278 0.424262,-0.16278 0.08165,0.84491 0.08165,0.84491 -0.925008,0.32607 -0.924491,0.3266 -0.660942,-0.0269 -0.660424,-0.0264 -0.462505,-0.12093 -0.462505,-0.12092 v -0.25528 -0.25477 l 0.594281,0.0512 0.594794,0.0512 0.462505,-0.0408 0.462505,-0.0408 v -0.4145 -0.41444 l -0.498163,0.15813 -0.497644,0.15813 -0.170014,-0.67851 -0.170534,-0.67852 -0.627351,-0.23874 -0.62787,-0.238748 -0.198953,-0.32194 z m 67.73386,0 0.9002,0.19379 0.9002,0.19327 0.26407,0.0718 0.26407,0.0708 0.74414,0.304888 0.74414,0.30541 h 0.26251 0.26252 l -0.1912,0.30902 -0.19069,0.30955 0.42375,-0.16278 0.42426,-0.16278 0.0811,0.84491 0.0816,0.84491 -0.92501,0.32607 -0.92449,0.3266 -0.66094,-0.0269 -0.66042,-0.0264 -0.46251,-0.12093 -0.4625,-0.12092 v -0.25528 -0.25477 l 0.59428,0.0512 0.59479,0.0512 0.46251,-0.0408 0.4625,-0.0408 v -0.4145 -0.41444 l -0.49816,0.15813 -0.49765,0.15813 -0.17001,-0.67851 -0.17053,-0.67852 -0.62735,-0.23874 -0.62787,-0.238748 -0.19896,-0.32194 z m -101.792242,0.22526 v 2.750218 l 0.72347,0.32866 1.30741,0.59429 0.5948,0.0589 0.59427,0.0589 v -0.15038 -0.1509 l -1.12292,-1.10071 -1.12345,-1.10122 -0.59066,-0.781348 z m 67.733852,0 v 2.750218 l 0.72347,0.32866 1.30741,0.59429 0.5948,0.0589 0.59427,0.0589 v -0.15038 -0.1509 l -1.12292,-1.10071 -1.12345,-1.10122 -0.59066,-0.781348 z m -17.208258,0.38551 v 0.13229 0.132288 h 0.132292 0.132291 v -0.132288 -0.13229 h -0.132291 z m 67.733858,0 v 0.13229 0.132288 h 0.13229 0.13229 v -0.132288 -0.13229 h -0.13229 z m -86.927519,1.551328 -1.106392,0.44286 -1.106392,0.44287 v 0.31833 0.31832 l 0.982884,0.37983 0.982369,0.37982 1.330153,0.70745 1.330151,0.70745 0.330213,0.0191 0.33021,0.0196 -0.0078,-0.33022 -0.0083,-0.33072 -1.52859,-1.53738 z m 67.733849,0 -1.10639,0.44286 -1.10639,0.44287 v 0.31833 0.31832 l 0.98289,0.37983 0.98236,0.37982 1.33016,0.70745 1.33015,0.70745 0.33021,0.0191 0.33022,0.0196 -0.008,-0.33022 -0.008,-0.33072 -1.52859,-1.53738 z m -52.740964,0.3054 -0.161232,0.26149 -0.161748,0.26148 H 83.019313 82.77075 v -0.10387 -0.10387 l 0.409792,-0.15761 z m 67.733854,0 -0.16123,0.26149 -0.16175,0.26148 h -0.24856 -0.24856 v -0.10387 -0.10387 l 0.40979,-0.15761 z m -67.365919,0.70125 -0.195853,0.21653 -0.195855,0.21652 0.328147,0.40514 0.328144,0.40567 -0.330729,-0.19844 -0.311608,-0.18707 -0.139528,-0.22634 -0.151929,-0.24598 0.334864,-0.19276 z m 67.733859,0 -0.19586,0.21653 -0.19585,0.21652 0.32814,0.40514 0.32815,0.40567 -0.33073,-0.19844 -0.31161,-0.18707 -0.13952,-0.22634 -0.15193,-0.24598 0.33486,-0.19276 z m -97.992477,0.35037 h 0.132292 0.131775 v 0.13229 0.13178 h -0.131775 -0.132292 v -0.13178 z m 67.733847,0 h 0.1323 0.13177 v 0.13229 0.13178 h -0.13177 -0.1323 v -0.13178 z m -57.771665,0.25735 -0.134874,0.13487 -0.134877,0.13488 0.290938,0.63872 0.290939,0.63924 0.544671,0.17311 0.544668,0.1726 v 0.18087 0.18035 l -1.78387,0.006 -1.783871,0.006 -0.749308,0.1788 -0.749824,0.17828 -0.375172,0.31161 -0.374655,0.31109 -1.254186,0.0408 -1.25367,0.0408 -0.345199,-0.47077 -0.345199,-0.47129 h -0.381889 -0.38137 v 0.39636 0.39688 l -0.330214,0.0207 -0.330213,0.0212 0.315227,0.12867 0.315743,0.12816 -0.135392,0.35346 -0.135393,0.35295 1.537375,0.0191 1.537891,0.0207 0.396359,0.0987 0.396356,0.0987 0.396359,0.14986 0.396875,0.15038 0.739489,0.16227 0.73949,0.16278 0.978236,0.91002 v 5.3e-4 l 0.978233,0.91002 0.133842,0.007 0.133842,0.007 0.328663,-1.05316 0.328663,-1.05369 v -0.2682 -0.26872 l -0.198438,0.031 -0.197921,0.0315 -0.330729,-0.0315 -0.330214,-0.031 v -0.26458 -0.26407 h 0.419098 0.419613 l 1.959052,-0.56947 1.959054,-0.56948 v -0.37362 -0.37362 l -0.528132,0.16744 -0.528651,0.16794 v -0.39481 -0.39532 l -1.493967,-0.68419 z m 67.733855,0 -0.13488,0.13487 -0.13487,0.13488 0.29093,0.63872 0.29094,0.63924 0.54467,0.17311 0.54467,0.1726 v 0.18087 0.18035 l -1.78387,0.006 -1.78387,0.006 -0.74931,0.1788 -0.74982,0.17828 -0.37517,0.31161 -0.37466,0.31109 -1.25418,0.0408 -1.25367,0.0408 -0.3452,-0.47077 -0.3452,-0.47129 h -0.38189 -0.38137 v 0.39636 0.39688 l -0.33022,0.0207 -0.33021,0.0212 0.31523,0.12867 0.31574,0.12816 -0.13539,0.35346 -0.13539,0.35295 1.53737,0.0191 1.53789,0.0207 0.39636,0.0987 0.39636,0.0987 0.39636,0.14986 0.39687,0.15038 0.73949,0.16227 0.73949,0.16278 0.97824,0.91002 v 5.3e-4 l 0.97823,0.91002 0.13384,0.007 0.13385,0.007 0.32866,-1.05316 0.32866,-1.05369 v -0.2682 -0.26872 l -0.19844,0.031 -0.19792,0.0315 -0.33073,-0.0315 -0.33021,-0.031 v -0.26458 -0.26407 h 0.4191 0.41961 l 1.95905,-0.56947 1.95905,-0.56948 v -0.37362 -0.37362 l -0.52813,0.16744 -0.52865,0.16794 v -0.39481 -0.39532 l -1.49396,-0.68419 z m -75.317372,0.007 v 0.13229 0.13229 h 0.131776 0.132291 v -0.13227 -0.13229 h -0.132291 z m 67.733852,0 v 0.13229 0.13229 h 0.13178 0.13229 v -0.13229 -0.13229 h -0.13229 z m -46.887578,0.26458 h 0.132292 0.132292 l 0.163295,0.26459 0.163299,0.26406 h -0.132292 -0.131773 l -0.163817,-0.26406 z m 67.733858,0 h 0.13229 0.13229 l 0.1633,0.26459 0.1633,0.26406 h -0.13229 -0.13178 l -0.16381,-0.26406 z m -98.886996,0.70487 0.176217,0.17622 0.1757,0.17621 h -0.351917 -0.352433 l 0.176217,-0.17621 z m 67.733856,0 0.17621,0.17622 0.1757,0.17621 h -0.35191 -0.35244 l 0.17622,-0.17621 z m -47.913359,0.79323 0.176215,0.17622 0.176218,0.17621 h -0.352433 -0.352435 l 0.176217,-0.1762 z m 67.733849,0 0.17622,0.17622 0.17622,0.17621 h -0.35244 -0.35243 l 0.17622,-0.17621 z m -61.126502,0.82786 -1.651579,0.18862 -1.651577,0.18862 -0.425297,0.22324 -0.425299,0.22324 -0.439766,0.67179 -0.439767,0.6718 h -0.408241 -0.408245 l 0.167947,-0.52917 0.167434,-0.52865 h -0.396875 -0.396875 l -0.653709,0.24857 -0.65319,0.24856 -0.176215,0.80305 -0.176218,0.80305 0.170532,0.53847 0.171051,0.53847 0.242361,-0.14934 0.241845,-0.14987 -0.174665,0.45631 -0.175183,0.45578 0.43925,-0.16846 0.439248,-0.16847 -0.06305,0.32091 -0.06304,0.32091 0.350367,-0.0729 0.349848,-0.0724 -0.155027,0.25064 -0.15503,0.25062 0.843875,0.601 0.843875,0.601 -0.230992,-0.38241 -0.230478,-0.3824 0.438216,0.35553 0.438216,0.35553 0.293008,-0.0977 0.292486,-0.0977 -0.680061,-0.7338 -0.680577,-0.73432 v -0.43202 -0.43201 l -0.574128,-0.61185 -0.57464,-0.61185 0.376203,0.009 0.376206,0.009 0.61495,0.51211 0.614949,0.51263 -0.167949,0.27182 -0.167947,0.27182 h 0.298688 0.298691 l 0.417028,0.41703 0.417028,0.41703 0.489376,-0.12764 0.489376,-0.12816 -0.124023,0.20102 -0.124539,0.20154 0.639236,0.60048 0.639238,0.60048 0.343649,-0.13178 0.343646,-0.13177 0.03669,0.60565 0.03669,0.60513 -1.886706,0.22582 -1.886707,0.22635 -0.238228,-0.46871 -0.238744,-0.4687 -1.214914,-0.008 -1.214914,-0.008 -2.103231,-1.94924 -2.103231,-1.94923 -0.966864,-0.28991 -0.966351,-0.28939 h -0.271301 -0.271817 l -0.166399,0.4346 -0.166915,0.43512 0.443902,0.49041 0.443383,0.49041 h 0.199988 0.199469 l 1.080556,0.70796 1.081072,0.70797 v 0.17312 0.17363 l -0.165881,0.16597 -0.165881,0.16588 -1.221631,-0.6749 -1.221629,-0.67489 -0.251148,-0.2403 -0.251148,-0.23978 h -0.497644 -0.497644 l 0.136943,0.33022 0.136943,0.33073 0.323493,0.99115 0.322976,0.99167 h 1.853634 1.853118 l 0.421164,-0.38137 0.421161,-0.38137 0.855247,0.41444 0.854728,0.41445 v 0.31367 0.3142 l -0.815456,0.77669 -0.815454,0.77618 -0.25373,0.46819 -0.253733,0.46819 0.168985,0.27388 0.168981,0.27389 1.412832,-1.33687 1.413352,-1.33687 h 0.657323 0.657325 l 0.54777,0.6966 0.547253,0.6966 v 0.35191 0.3514 l 0.583428,0.31213 0.583427,0.31213 0.275434,-0.48525 0.275952,-0.48575 0.637689,-0.6656 0.637685,-0.66611 0.15503,0.41393 0.15503,0.41341 1.66243,1.37873 1.66243,1.37873 0.318328,-0.10646 0.318844,-0.10593 0.0011,-0.50747 0.0011,-0.50694 -0.367419,-0.28784 -0.367419,-0.28784 0.241845,-0.43201 0.241845,-0.43202 0.654741,0.33952 0.65474,0.34003 1.361673,-0.016 1.36116,-0.0165 -0.0987,0.1602 -0.0987,0.15968 0.639239,0.60048 0.639236,0.60048 0.343648,-0.13178 0.343649,-0.13177 0.03617,0.59737 0.03669,0.5979 -0.829408,0.24598 -0.828889,0.2465 -0.528649,-0.48938 -0.52865,-0.48886 -1.004591,-0.82423 -1.004589,-0.82425 -0.257866,0.25735 -0.257349,0.25787 0.92501,1.16944 0.925007,1.16943 0.535368,0.0336 0.535369,0.0331 0.198437,0.0434 0.197919,0.0439 -0.721402,0.39171 -0.721402,0.39171 -0.929662,-0.38861 -0.930174,-0.3886 -1.689304,-1.20613 -1.689817,-1.20613 -0.623218,0.1018 -0.623218,0.10129 -0.296624,-0.23564 -0.297138,-0.23565 -0.402561,0.15451 -0.402558,0.15452 -0.127641,0.57722 -0.127124,0.57723 -0.610298,1.64279 -0.609783,1.64331 0.445969,0.49248 0.445965,0.49299 v 0.43667 0.43666 l 0.606166,0.15245 0.606166,0.15244 0.711067,-0.12919 0.71055,-0.12867 0.134876,0.21807 0.134874,0.21859 -0.416512,0.15969 -0.41651,0.16019 h -0.65741 -0.657323 l 0.08423,0.56586 0.08423,0.56586 0.587044,0.216 0.587563,0.21549 0.38499,-0.38499 0.384987,-0.3855 h 0.134361 0.134358 l -0.156062,0.99167 -0.155549,0.99115 -0.35605,1.02475 -0.356049,1.02474 v 0.25063 0.24856 l 0.455784,-0.0879 0.455787,-0.0878 0.271301,-0.53175 0.270786,-0.53226 0.557072,-0.78755 0.556553,-0.78755 0.123508,-0.38964 0.123507,-0.38964 -0.340031,-0.65578 -0.340032,-0.65577 0.127124,-0.12712 0.127124,-0.12713 1.058852,1.03456 1.059365,1.03457 0.432533,-0.27286 0.432531,-0.27285 0.06976,-0.47697 0.07028,-0.47698 0.547769,-0.58342 0.54777,-0.58343 v -0.2713 -0.2713 l -1.123445,-1.18649 -1.122929,-1.18701 -0.925007,-0.1788 -0.92501,-0.1788 -1.39733,-0.56172 -1.396813,-0.56172 -0.160197,0.16071 -0.160197,0.1602 0.349332,0.42116 0.349851,0.42168 0.481107,-0.12609 0.481105,-0.12609 -0.12402,0.20154 -0.124542,0.20102 0.639238,0.60099 0.639236,0.60048 0.343649,-0.13177 0.343649,-0.13229 0.03617,0.59221 0.03565,0.59221 -0.898136,0.27595 -0.898136,0.27544 -0.270267,-0.50488 -0.270269,-0.50488 h -0.346215 -0.345715 l -0.460955,-0.50953 -0.460436,-0.50901 0.230476,-1.40767 0.230476,-1.40766 0.915707,0.0754 0.916223,0.0744 0.08785,0.25528 0.08837,0.25528 h 0.227375 0.227893 l 2.424142,1.16996 2.423626,1.16943 0.365868,-0.14056 0.365353,-0.14004 v -0.23616 -0.23565 h 0.257865 0.257347 l -0.14986,0.85938 -0.149346,0.85835 -0.399458,1.27331 -0.398941,1.2733 0.147793,0.14728 0.147278,0.14831 0.413928,-0.15968 0.41393,-0.15864 0.166396,-0.46871 0.166399,-0.46871 0.337963,-0.39739 0.337966,-0.39687 0.387572,-0.74828 0.388091,-0.74724 -0.35967,-0.69401 -0.359666,-0.6935 0.120406,-0.12041 0.120923,-0.12092 0.564306,0.5054 0.564306,0.50487 0.641821,1.0108 0.642339,1.0113 -0.08165,0.24133 -0.08165,0.24185 -0.792715,-0.41186 -0.793235,-0.41135 -0.02739,-0.0481 -0.02739,-0.0475 -0.699183,0.83096 -0.699182,0.83147 v 0.39223 0.39222 l 1.651579,0.001 1.651579,10e-4 1.255221,0.185 1.25522,0.18552 v -0.28629 -0.28629 l 0.553972,-0.55397 0.553971,-0.55397 -0.656291,-0.70176 -0.656291,-0.70177 -0.172598,-0.57206 -0.172601,-0.57257 0.171566,-0.68368 0.171566,-0.68316 0.169498,0.006 0.1695,0.006 0.74414,1.05213 0.743623,1.05162 h 0.278021 0.278019 l -0.187587,-0.5948 -0.187584,-0.5948 -0.139526,-0.79323 -0.140044,-0.79323 -0.426331,-0.48628 -0.426847,-0.48627 -0.95963,0.15347 -0.959633,0.15348 -0.875398,-1.02887 -0.875398,-1.02888 -1.059368,-0.1695 -1.059368,-0.1695 -1.29346,-0.65009 -1.292945,-0.64957 h -1.797303 -1.796788 l -0.691949,-0.90805 -0.691946,-0.90744 v -0.14986 -0.14986 h 0.28112 0.280604 l 1.690335,0.81545 1.690336,0.81545 0.261482,-0.16174 0.261483,-0.16175 -1.081588,-1.44694 -1.081587,-1.44694 -0.291971,-0.0331 -0.292489,-0.0331 -0.759645,-0.0331 -0.759642,-0.0331 -0.06615,-0.83199 -0.06666,-0.83199 -0.495062,-0.69557 -0.495578,-0.69556 -0.925007,0.11834 -0.925007,0.11782 -0.792718,0.17105 -0.792716,0.17105 0.528651,-0.42685 0.528132,-0.42633 1.387512,-0.70332 1.387512,-0.70383 v -0.36742 z m 67.733852,0 -1.65157,0.18862 -1.65159,0.18862 -0.42529,0.22324 -0.4253,0.22324 -0.43977,0.67179 -0.43976,0.6718 h -0.40825 -0.40824 l 0.16795,-0.52917 0.16743,-0.52865 h -0.39688 -0.39687 l -0.65371,0.24857 -0.65319,0.24856 -0.17621,0.80305 -0.17622,0.80305 0.17053,0.53847 0.17105,0.53847 0.24236,-0.14934 0.24185,-0.14987 -0.17467,0.45631 -0.17518,0.45578 0.43925,-0.16846 0.43925,-0.16847 -0.0631,0.32091 -0.0631,0.32091 0.35036,-0.0729 0.34985,-0.0724 -0.15503,0.25064 -0.15503,0.25062 0.84388,0.601 0.84388,0.601 -0.231,-0.38241 -0.23047,-0.3824 0.43821,0.35553 0.43822,0.35553 0.293,-0.0977 0.29249,-0.0977 -0.68006,-0.7338 -0.68058,-0.73432 v -0.43202 -0.43201 l -0.57412,-0.61185 -0.57465,-0.61185 0.37621,0.009 0.3762,0.009 0.61495,0.51211 0.61495,0.51263 -0.16795,0.27182 -0.16794,0.27182 h 0.29869 0.29869 l 0.41702,0.41703 0.41703,0.41703 0.48938,-0.12764 0.48938,-0.12816 -0.12403,0.20102 -0.12454,0.20154 0.63924,0.60048 0.63924,0.60048 0.34365,-0.13178 0.34365,-0.13177 0.0367,0.60565 0.0367,0.60513 -1.88671,0.22582 -1.88671,0.22635 -0.23823,-0.46871 -0.23874,-0.4687 -1.21492,-0.008 -1.21491,-0.008 -2.10323,-1.94924 -2.10323,-1.94923 -0.96687,-0.28991 -0.96634,-0.28939 h -0.27131 -0.27182 l -0.16639,0.4346 -0.16692,0.43512 0.4439,0.49041 0.44339,0.49041 h 0.19998 0.19948 l 1.08055,0.70796 1.08107,0.70797 v 0.17312 0.17363 l -0.16589,0.16597 -0.16588,0.16588 -1.22163,-0.6749 -1.22163,-0.67489 -0.25115,-0.2403 -0.25115,-0.23978 h -0.49764 -0.49765 l 0.13695,0.33022 0.13694,0.33073 0.32349,0.99115 0.32298,0.99167 h 1.85363 1.85312 l 0.42116,-0.38137 0.42117,-0.38137 0.85524,0.41444 0.85473,0.41445 v 0.31367 0.3142 l -0.81545,0.77669 -0.81546,0.77618 -0.25373,0.46819 -0.25373,0.46819 0.16898,0.27388 0.16898,0.27389 1.41284,-1.33687 1.41335,-1.33687 h 0.65732 0.65732 l 0.54777,0.6966 0.54726,0.6966 v 0.35191 0.3514 l 0.58343,0.31213 0.58342,0.31213 0.27544,-0.48525 0.27595,-0.48575 0.63769,-0.6656 0.63769,-0.66611 0.15503,0.41393 0.15503,0.41341 1.66243,1.37873 1.66243,1.37873 0.31832,-0.10646 0.31885,-0.10593 5.3e-4,-0.50747 0.001,-0.50694 -0.36742,-0.28784 -0.36742,-0.28784 0.24184,-0.43201 0.24185,-0.43202 0.65474,0.33952 0.65474,0.34003 1.36167,-0.016 1.36116,-0.0165 -0.0987,0.1602 -0.0987,0.15968 0.63923,0.60048 0.63924,0.60048 0.34365,-0.13178 0.34365,-0.13177 0.0362,0.59737 0.0372,0.5979 -0.82941,0.24598 -0.82889,0.2465 -0.52865,-0.48938 -0.52865,-0.48886 -1.00459,-0.82423 -1.00459,-0.82425 -0.25838,0.25735 -0.25683,0.25787 0.92449,1.16944 0.92552,1.16943 0.53537,0.0336 0.53537,0.0331 0.19844,0.0434 0.19792,0.0439 -0.72141,0.39171 -0.7214,0.39171 -0.92966,-0.38861 -0.93069,-0.3886 -1.68878,-1.20613 -1.68982,-1.20613 -0.62322,0.1018 -0.62322,0.10129 -0.29662,-0.23564 -0.29714,-0.23565 -0.40256,0.15451 -0.40256,0.15452 -0.12764,0.57722 -0.12713,0.57723 -0.6103,1.64279 -0.60978,1.64331 0.44597,0.49248 0.44597,0.49299 v 0.43667 0.43666 l 0.60616,0.15245 0.60617,0.15244 0.71107,-0.12919 0.71055,-0.12867 0.13487,0.21807 0.13488,0.21859 -0.41651,0.15969 -0.41652,0.16019 h -0.65732 -0.65732 l 0.0842,0.56586 0.0842,0.56586 0.58705,0.216 0.58756,0.21549 0.38499,-0.38499 0.38499,-0.3855 h 0.13435 0.13436 l -0.15606,0.99167 -0.15555,0.99115 -0.35605,1.02475 -0.35605,1.02474 v 0.25063 0.24856 l 0.45579,-0.0879 0.45578,-0.0878 0.2713,-0.53175 0.27079,-0.53226 0.55707,-0.78755 0.55656,-0.78755 0.1235,-0.38964 0.12351,-0.38964 -0.34003,-0.65578 -0.34003,-0.65577 0.12712,-0.12712 0.12713,-0.12713 1.05885,1.03456 1.05936,1.03457 0.43254,-0.27286 0.43253,-0.27285 0.0698,-0.47697 0.0703,-0.47698 0.54777,-0.58342 0.54777,-0.58343 v -0.2713 -0.2713 l -1.12345,-1.18649 -1.12292,-1.18701 -0.92501,-0.1788 -0.92501,-0.1788 -1.39733,-0.56172 -1.39681,-0.56172 -0.1602,0.16071 -0.1602,0.1602 0.34933,0.42116 0.34985,0.42168 0.48111,-0.12609 0.48111,-0.12609 -0.12402,0.20154 -0.12455,0.20102 0.63924,0.60099 0.63924,0.60048 0.34365,-0.13177 0.34365,-0.13229 0.0362,0.59221 0.0357,0.59221 -0.89814,0.27595 -0.89814,0.27544 -0.27026,-0.50488 -0.27027,-0.50488 h -0.34623 -0.34572 l -0.46095,-0.50953 -0.46044,-0.50901 0.23048,-1.40767 0.23047,-1.40766 0.91571,0.0754 0.91622,0.0744 0.0884,0.25528 0.0884,0.25528 h 0.22737 0.2279 l 2.42414,1.16996 2.42362,1.16943 0.36587,-0.14056 0.36535,-0.14004 v -0.23616 -0.23565 h 0.25787 0.25735 l -0.14986,0.85938 -0.14935,0.85835 -0.39946,1.27331 -0.39894,1.2733 0.1478,0.14728 0.14727,0.14831 0.41393,-0.15968 0.41393,-0.15864 0.1664,-0.46871 0.1664,-0.46871 0.33796,-0.39739 0.33796,-0.39687 0.38758,-0.74828 0.38809,-0.74724 -0.35967,-0.69401 -0.35967,-0.6935 0.12041,-0.12041 0.12092,-0.12092 0.56431,0.5054 0.5643,0.50487 0.64182,1.0108 0.64234,1.0113 -0.0816,0.24133 -0.0816,0.24185 -0.79272,-0.41186 -0.79323,-0.41135 -0.0274,-0.0481 -0.0274,-0.0475 -0.69918,0.83096 -0.69919,0.83147 v 0.39223 0.39222 l 1.65158,0.001 1.65158,10e-4 1.25522,0.185 1.25522,0.18552 v -0.28629 -0.28629 l 0.55397,-0.55397 0.55397,-0.55397 -0.65628,-0.70176 -0.6563,-0.70177 -0.1726,-0.57206 -0.17259,-0.57257 0.17156,-0.68368 0.17157,-0.68316 0.1695,0.006 0.16949,0.006 0.74414,1.05213 0.74363,1.05162 h 0.27802 0.27802 l -0.18759,-0.5948 -0.18759,-0.5948 -0.13952,-0.79323 -0.14004,-0.79323 -0.42633,-0.48628 -0.42685,-0.48627 -0.95963,0.15347 -0.95963,0.15348 -0.8754,-1.02887 -0.8754,-1.02888 -1.05937,-0.1695 -1.05937,-0.1695 -1.29346,-0.65009 -1.29294,-0.64957 h -1.79731 -1.79679 l -0.69194,-0.90796 -0.69195,-0.90744 v -0.14986 -0.14986 h 0.28112 0.2806 l 1.69034,0.81546 1.69033,0.81545 0.26149,-0.16175 0.26148,-0.16175 -1.08159,-1.44693 -1.08159,-1.44695 -0.29197,-0.0331 -0.29249,-0.0331 -0.75964,-0.0331 -0.75965,-0.0331 -0.0667,-0.83199 -0.0667,-0.83199 -0.49506,-0.69556 -0.49558,-0.69557 -0.92501,0.11834 -0.925,0.11783 -0.79272,0.17104 -0.79272,0.17105 0.52865,-0.42684 0.52813,-0.42633 1.38752,-0.70332 1.38751,-0.70383 v -0.36742 z m -56.370204,0.58239 v 0.27957 0.28009 l 0.264067,-0.1633 0.264584,-0.1633 v -0.11679 -0.11627 h -0.264584 z m 67.733854,0 v 0.27957 0.28009 l 0.26407,-0.1633 0.26458,-0.1633 v -0.11679 -0.11627 h -0.26458 z m -53.462893,0.22221 v 0.28474 0.28422 l 0.95395,1.05626 0.95343,1.05627 0.21756,-0.13436 0.217043,-0.13436 0.18758,0.30386 0.18759,0.30386 1.87534,-0.1571 1.87533,-0.15761 0.0915,-0.2744 0.0915,-0.2744 h 0.50695 0.007 v -0.99013 l -0.39119,-0.3917 -2.08825,0.18241 -2.08876,0.18242 -0.439253,-0.38757 -0.43977,-0.38706 -0.85886,-0.18293 z m 67.733853,0 v 0.28474 0.28422 l 0.95395,1.05626 0.95343,1.05627 0.21756,-0.13436 0.21704,-0.13436 0.18759,0.30386 0.18758,0.30386 1.87534,-0.1571 1.87534,-0.15761 0.0915,-0.2744 0.0915,-0.2744 h 0.50695 0.007 v -0.99013 l -0.39119,-0.3917 -2.08824,0.18241 -2.08876,0.18242 -0.43925,-0.38757 -0.43977,-0.38706 -0.85886,-0.18293 z m -79.437012,0.0108 -0.213423,0.21394 -0.213424,0.21342 0.415994,0.85938 0.415997,0.85938 0.23151,0.0331 0.230995,0.0331 0.198437,0.0496 0.197919,0.0496 1.515155,0.33176 1.515152,0.33177 0.152445,0.24649 0.151929,0.2465 h 0.348816 0.348298 l 0.281638,-0.33951 0.281636,-0.33952 -0.183452,-0.28215 -0.182935,-0.28164 -0.577226,-0.30437 -0.577225,-0.30386 h -0.798918 -0.798401 l -1.370457,-0.80822 z m 67.733852,0 -0.21342,0.21394 -0.21342,0.21342 0.41599,0.85938 0.416,0.85938 0.23151,0.0331 0.23099,0.0331 0.19844,0.0496 0.19792,0.0496 1.51515,0.33176 1.51516,0.33177 0.15244,0.24649 0.15193,0.2465 h 0.34882 0.3483 l 0.28163,-0.33951 0.28164,-0.33952 -0.18345,-0.28215 -0.18294,-0.28164 -0.57722,-0.30437 -0.57723,-0.30386 h -0.79892 -0.7984 l -1.37046,-0.80822 z m -77.996274,0.5023 -0.08113,0.0951 -0.08113,0.0946 -0.299207,0.57671 -0.299722,0.57619 0.386537,0.34881 0.387057,0.34882 0.405143,0.34107 0.405662,0.34106 v -0.11576 -0.11524 l 1.519803,0.45424 1.519288,0.45475 0.330729,0.003 0.330211,0.003 v -0.22059 -0.22014 h 0.537953 0.537951 l 0.651124,-0.42685 0.651639,-0.42736 v -0.36587 -0.36639 l -2.18023,-0.0202 -2.180743,-0.0202 -0.452686,-0.0868 -0.453202,-0.0873 -0.817523,-0.5824 z m 67.733854,0 -0.0811,0.0951 -0.0811,0.0946 -0.29921,0.57671 -0.29972,0.57619 0.38654,0.34881 0.38705,0.34882 0.40515,0.34107 0.40566,0.34106 v -0.11576 -0.11524 l 1.5198,0.45424 1.51929,0.45475 0.33073,0.003 0.33021,0.003 v -0.22059 -0.22014 h 0.53795 0.53795 l 0.65113,-0.42685 0.65164,-0.42736 v -0.36587 -0.36639 l -2.18023,-0.0202 -2.18075,-0.0202 -0.45268,-0.0868 -0.45321,-0.0873 -0.81752,-0.5824 z m -71.407015,0.0238 -0.173116,0.45165 -0.173117,0.45165 0.465605,0.34055 0.465604,0.34106 0.644921,-0.29404 0.644406,-0.29404 -0.07855,-0.41547 -0.07855,-0.41548 -0.858345,-0.0827 z m 67.733855,0 -0.17312,0.45165 -0.17311,0.45165 0.4656,0.34055 0.46561,0.34106 0.64492,-0.29404 0.6444,-0.29404 -0.0785,-0.41547 -0.0786,-0.41548 -0.85835,-0.0827 z m -56.102007,0.21032 0.176216,0.17622 0.176217,0.17621 h -0.352433 -0.351917 l 0.1757,-0.17621 z m 67.733857,0 0.17622,0.17622 0.17621,0.17621 h -0.35243 -0.35192 l 0.1757,-0.17621 z m -106.120662,0.32453 0.860413,1.08623 0.859896,1.08676 0.02997,1.10846 0.03049,1.10846 -0.219625,1.12396 -0.219625,1.12345 h 0.397392 0.396875 l 0.692464,-1.2392 0.692464,-1.23972 -0.155029,-0.40463 -0.155546,-0.40514 0.190686,0.19069 0.190686,0.1912 0.500744,-0.4532 0.500228,-0.45321 -0.187068,1.41284 -0.187586,1.41232 0.49506,-0.27699 0.495061,-0.27699 0.283186,0.83716 0.283187,0.83716 0.307992,-0.063 0.307992,-0.0631 -0.130225,0.34003 -0.130741,0.34003 0.668692,0.62838 0.668694,0.62787 v 0.61495 0.61495 h -0.242879 -0.242364 l -1.313097,-1.4981 -1.313615,-1.4981 -0.957565,0.0362 -0.957047,0.0367 -0.472323,0.2527 -0.472323,0.25272 -0.912605,-0.43253 -0.912606,-0.43305 -1.252637,-0.86971 -1.252638,-0.8692 h -0.26717 -0.26665 v -0.28577 -0.28525 l 0.72657,0.14779 0.727092,0.1478 0.660425,0.12609 0.660941,0.1266 0.591179,0.17364 0.591178,0.17311 0.168982,-0.43976 0.168982,-0.44029 -0.628386,-0.67282 -0.627868,-0.67335 -1.850016,0.17725 -1.850019,0.17725 0.26459,-0.26303 0.26406,-0.26303 0.92088,-0.23461 0.92087,-0.23513 0.290938,-1.04128 0.290939,-1.0418 0.538985,-0.0801 z m 67.733852,0 0.86041,1.08623 0.8599,1.08676 0.03,1.10846 0.0305,1.10846 -0.21963,1.12396 -0.21962,1.12345 h 0.39739 0.39687 l 0.69247,-1.2392 0.69246,-1.23972 -0.15503,-0.40463 -0.15554,-0.40514 0.19068,0.19069 0.19069,0.1912 0.50074,-0.4532 0.50023,-0.45321 -0.18707,1.41284 -0.18758,1.41232 0.49506,-0.27699 0.49506,-0.27699 0.28319,0.83716 0.28318,0.83716 0.30799,-0.063 0.308,-0.0631 -0.13023,0.34003 -0.13074,0.34003 0.66869,0.62838 0.6687,0.62787 v 0.61495 0.61495 h -0.24288 -0.24237 l -1.3131,-1.4981 -1.31361,-1.4981 -0.95756,0.0362 -0.95705,0.0367 -0.47232,0.2527 -0.47233,0.2527 -0.9126,-0.43253 -0.91261,-0.43305 -1.25263,-0.86972 -1.25264,-0.86919 h -0.26717 -0.26665 v -0.28577 -0.28526 l 0.72657,0.1478 0.72709,0.14779 0.66042,0.12609 0.66095,0.12661 0.59117,0.17363 0.59118,0.17312 0.16899,-0.43977 0.16898,-0.44028 -0.62839,-0.67283 -0.62787,-0.67334 -1.85002,0.17725 -1.85001,0.17725 0.26458,-0.26304 0.26407,-0.26303 0.92087,-0.23461 0.92088,-0.23513 0.29094,-1.04128 0.29093,-1.04179 0.53899,-0.0801 z m -75.908542,0.0166 v 1.06867 h 0.0708 0.50643 v -0.24547 -0.24546 l -0.44493,-0.44545 z m 67.733852,0 v 1.06867 h 0.0708 0.50642 v -0.24547 -0.24546 l -0.44493,-0.44545 z m -0.41807,2.08721 -1.55649,0.18086 -1.55649,0.18087 -1.486223,0.66043 -1.48673,0.65991 -1.07435,0.49971 -1.074354,0.49971 -0.511599,0.006 -0.511079,0.006 -0.730705,1.03353 -0.730705,1.03404 0.31316,0.19379 0.313677,0.19378 -0.618567,0.22893 -0.618569,0.22893 0.257866,0.25786 0.257865,0.25787 1.187524,-0.22169 1.187527,-0.22221 0.515728,0.20205 0.515211,0.20154 0.74259,0.0186 0.74208,0.0186 -0.17984,-0.29145 -0.17983,-0.29146 -0.95912,-0.41703 -0.958591,-0.41703 -0.528651,0.0734 -0.52865,0.0734 -0.330211,0.27079 -0.330213,0.27078 v -0.26665 -0.26665 l 0.898652,-0.42633 0.898655,-0.42685 h 0.390157 0.390672 l 0.31781,-0.38344 0.31781,-0.38344 1.10174,-0.51624 1.102263,-0.51677 1.03404,-0.35553 1.03405,-0.35605 0.11111,0.33021 0.1111,0.33073 h 0.23771 0.23771 l 2.15181,1.05213 v -1.19476 l -0.42582,-0.32039 0.004,-0.84491 z m 67.73386,0 -1.5565,0.18086 -1.55649,0.18087 -1.48622,0.66043 -1.48673,0.65991 -1.07435,0.49971 -1.07435,0.49971 -0.5116,0.006 -0.51108,0.006 -0.7307,1.03353 -0.73071,1.03404 0.31316,0.19379 0.31368,0.19378 -0.61857,0.22893 -0.61857,0.22893 0.25787,0.25786 0.25787,0.25787 1.18752,-0.22169 1.18752,-0.22221 0.51573,0.20205 0.51522,0.20154 0.74259,0.0186 0.74207,0.0186 -0.17983,-0.29145 -0.17984,-0.29146 -0.95911,-0.41703 -0.9586,-0.41703 -0.52865,0.0734 -0.52865,0.0734 -0.33021,0.27079 -0.33021,0.27078 v -0.26665 -0.26665 l 0.89865,-0.42633 0.89865,-0.42685 h 0.39016 0.39067 l 0.31781,-0.38344 0.31781,-0.38344 1.10175,-0.51624 1.10225,-0.51677 1.03405,-0.35553 1.03404,-0.35605 0.11111,0.33021 0.1111,0.33073 h 0.23771 0.23772 l 2.1518,1.05213 v -1.19476 l -0.42581,-0.32039 0.004,-0.84491 z m -103.287245,0.0326 1.122929,0.15761 1.122928,0.1571 0.33073,0.1018 0.330213,0.10232 v 0.27234 0.27285 l -0.462505,-0.0274 -0.462502,-0.0274 -0.991156,-0.26304 -0.990637,-0.26355 v -0.24133 z m 67.733855,0 1.12293,0.15761 1.12293,0.1571 0.33073,0.1018 0.33021,0.10232 v 0.27234 0.27285 l -0.4625,-0.0274 -0.46251,-0.0274 -0.99115,-0.26304 -0.99064,-0.26355 v -0.24133 z m -61.265515,0.0227 -0.591695,0.15503 -0.591178,0.15451 v 0.23048 0.22996 l 1.056783,0.66766 1.057299,0.66766 v 0.22479 0.22479 l 0.645438,-0.0708 0.645956,-0.0713 0.279054,-0.1726 0.279569,-0.1726 v -0.48059 -0.48111 l -0.330213,-0.25063 -0.330729,-0.25011 -1.059884,-0.30231 z m 67.733855,0 -0.5917,0.15503 -0.59117,0.15451 v 0.23048 0.22996 l 1.05678,0.66766 1.0573,0.66766 v 0.22479 0.22479 l 0.64544,-0.0708 0.64595,-0.0713 0.27906,-0.1726 0.27957,-0.1726 v -0.48059 -0.48111 l -0.33022,-0.25063 -0.33073,-0.25011 -1.05988,-0.30231 z m -48.502988,0.24804 h 0.09974 0.09973 v 0.23616 0.23617 l -0.433565,0.16639 -0.433565,0.1664 0.333828,-0.40256 z m 67.733858,0 h 0.0997 0.0992 v 0.23616 0.23617 l -0.43356,0.16639 -0.43357,0.1664 0.33383,-0.40256 z m -77.656765,0.23927 -0.254765,0.25424 -0.254248,0.25425 0.992703,1.6092 0.992706,1.60869 h 0.722953 0.722953 l 0.316259,-0.38085 0.316259,-0.38138 -0.613916,-0.52193 -0.614431,-0.52193 -1.163238,-0.96015 z m 67.733855,0 -0.25476,0.25424 -0.25425,0.25425 0.9927,1.6092 0.99271,1.60869 h 0.72295 0.72295 l 0.31626,-0.38085 0.31626,-0.38138 -0.61392,-0.52193 -0.61443,-0.52193 -1.16323,-0.96015 z m -70.040691,0.062 -0.621152,0.11265 -0.621667,0.11265 -1.025777,0.42323 -1.026295,0.42272 -0.594794,0.54984 -0.594796,0.54932 v 0.33434 0.33383 l 0.760677,0.83303 0.760677,0.83302 2.212269,1.1498 2.212784,1.1498 0.462502,0.0165 0.462505,0.016 v -0.39635 -0.39636 h -0.250113 -0.250113 l -1.581301,-0.92708 -1.581298,-0.92759 -0.811319,-0.81132 -0.811321,-0.81184 v -0.29559 -0.2961 l 0.907439,0.88005 0.907436,0.88005 0.443902,-0.17053 0.4439,-0.17054 -0.424262,-0.59169 -0.424265,-0.5917 -0.275434,-0.4625 -0.275952,-0.46251 h 0.237709 0.237197 l 0.697113,0.69712 0.6966,0.6966 v 0.3607 0.3607 h 0.51108 0.51108 l 0.0832,0.69815 0.08372,0.69866 0.587044,0.2155 0.587045,0.21549 0.396356,-0.39636 0.395843,-0.39636 -0.827341,-1.57923 -0.827855,-1.57975 -0.428916,0.13643 -0.428914,0.13642 -0.457853,-0.77463 z m 67.733851,0 -0.62115,0.11265 -0.62167,0.11265 -1.02577,0.42323 -1.02629,0.42272 -0.5948,0.54984 -0.5948,0.54932 v 0.33434 0.33383 l 0.76068,0.83303 0.76068,0.83302 2.21227,1.1498 2.21278,1.1498 0.46251,0.0165 0.4625,0.016 v -0.39636 -0.39636 h -0.25012 -0.25011 l -1.5813,-0.92707 -1.5813,-0.92759 -0.81132,-0.81132 -0.81132,-0.81184 v -0.29559 -0.29611 l 0.90744,0.88005 0.90744,0.88006 0.4439,-0.17054 0.4439,-0.17053 -0.42426,-0.59169 -0.42427,-0.5917 -0.27543,-0.4625 -0.27595,-0.46251 h 0.23771 0.23719 l 0.69712,0.69712 0.6966,0.69659 v 0.36071 0.3607 h 0.51108 0.51108 l 0.0832,0.69815 0.0837,0.69866 0.58704,0.21549 0.58705,0.21549 0.39636,-0.39635 0.39584,-0.39636 -0.82734,-1.57924 -0.82786,-1.57974 -0.42891,0.13642 -0.42892,0.13643 -0.45785,-0.77463 z M 46.036041,111.4645 v 0.13229 0.13229 l -0.264067,0.1633 -0.264583,0.1633 v -0.13229 -0.13178 l 0.264583,-0.16381 z m 67.733849,0 v 0.13229 0.13229 l -0.26406,0.1633 -0.26459,0.1633 v -0.13229 -0.13178 l 0.26459,-0.16381 z m -76.503852,0.0935 v 1.21543 l 0.17725,0.0868 2.25102,1.10071 v 0.21445 0.21446 l -0.62735,-0.23823 -0.62684,-0.23875 -0.30799,0.67593 -0.30747,0.67593 -0.14366,-0.14366 -0.14366,-0.14366 0.26716,-0.49971 0.26717,-0.49972 -0.17983,-0.27801 -0.17984,-0.27802 -0.44596,-0.0822 v 6.87968 h 0.42116 0.65371 l 0.15813,-0.25683 0.15864,-0.25632 -0.40721,-0.78806 -0.40721,-0.78755 v -0.80615 -0.80667 h 0.22738 0.22737 l 0.96222,-0.65267 0.9617,-0.65319 v 0.2346 0.2341 l -0.28526,0.0951 -0.28525,0.0951 -0.27595,2.24017 -0.27595,2.24018 -0.16589,0.17828 -0.16536,0.17777 -1.41387,-0.26097 -0.0884,-0.016 v 1.942 l 0.0486,0.0186 v 0.17002 l -5.3e-4,0.17002 -0.0481,-5.3e-4 v 2.10788 l 2.01797,1.57613 2.23345,1.7446 0.16072,0.25993 0.16071,0.26045 h -0.10025 -0.10025 l -1.69913,-1.3193 -1.69963,-1.31982 -0.1695,-0.002 -0.17002,-0.002 -0.15968,0.416 -0.15916,0.41548 0.24598,0.46044 0.2465,0.45992 1.64176,0.86144 1.64176,0.86093 0.25011,-0.34933 0.25011,-0.34882 -0.14417,0.4501 -0.14366,0.44959 0.77618,0.38757 0.77618,0.38758 0.730184,-0.19689 0.730188,-0.19689 0.792717,0.48214 0.793233,0.48214 0.429948,10e-4 0.429948,0.001 0.334347,0.40308 0.334346,0.40256 0.130742,-0.13074 0.130741,-0.13074 0.771529,0.54984 0.771529,0.54932 -0.379822,0.43408 -0.380338,0.43408 -0.173633,0.57102 -0.173633,0.57103 -0.382405,0.31729 -0.382406,0.31781 -0.909505,-0.75654 -0.910022,-0.75603 -0.01912,-0.47284 -0.0186,-0.47284 0.698665,0.0765 0.699182,0.076 0.10697,-0.30437 0.107487,-0.30437 -0.800468,-0.39946 -0.799951,-0.39946 -0.66921,0.52658 -0.66921,0.52659 0.143144,0.23151 0.143144,0.23202 -0.681612,0.44649 -0.681096,0.44648 0.07855,0.40256 0.07803,0.40256 1.850017,0.42788 1.849499,0.42788 -0.07855,0.99219 -0.07855,0.99064 0.541053,-0.33848 0.541569,-0.33797 v -0.24598 -0.24598 l 0.438733,-0.48524 0.439249,-0.48576 0.287322,-0.49764 0.287837,-0.49765 0.991154,-1.62935 0.991155,-1.62988 v -0.25011 -0.25012 H 51.18967 50.793312 v -0.24237 -0.24236 l 0.330212,-0.1111 0.330213,-0.11111 -0.309542,-0.6382 -0.310059,-0.63769 -0.456303,-1.26504 -0.456303,-1.26452 -0.290938,0.0977 -0.290938,0.0977 0.07028,2.03244 0.0708,2.03243 -0.731221,-0.1757 -0.731222,-0.1757 -0.130224,-0.11472 -0.129708,-0.11472 0.460437,-0.25787 0.45992,-0.25735 v -0.524 -0.524 l -0.395845,-0.15204 -0.396359,-0.15245 -0.766878,0.82166 -0.766878,0.82114 H 45.79775 45.243262 v -0.26459 -0.26406 l 0.198438,-0.005 0.197921,-0.004 1.585949,-1.44281 1.585434,-1.4428 0.462504,-0.15658 0.462504,-0.1571 v -0.34727 -0.34726 l -0.937927,-0.71572 -0.937928,-0.71572 0.343132,-0.41393 0.343648,-0.41393 -0.08527,-0.15761 -0.08475,-0.15761 -0.389124,-0.42995 -0.389123,-0.43046 0.222208,-1.2883 0.222726,-1.28829 0.901753,0.0749 0.902271,0.0744 0.14211,0.19689 0.142627,0.1974 1.100191,0.48473 1.100191,0.48524 0.275953,-0.17053 0.275952,-0.17054 1.79524,0.32091 1.795238,0.32143 0.720371,0.59015 0.720367,0.59066 0.336931,-0.0568 0.336415,-0.0563 0.594794,-0.38138 0.594797,-0.38137 v -0.3328 -0.33279 l -0.330729,-0.0196 -0.330214,-0.0196 -0.651639,-0.11989 -0.652156,-0.11937 -0.627869,-0.41186 -0.627351,-0.41135 -1.23145,0.002 -1.230932,0.002 -1.551326,-0.3607 -1.551845,-0.36018 -0.584977,-0.54984 -0.584977,-0.54932 -0.638204,0.10387 -0.638204,0.10387 -0.297139,-0.23565 -0.296623,-0.23564 -0.363802,0.14314 -0.363803,0.14263 -0.564306,1.64641 -0.564824,1.6459 -0.189652,0.46095 -0.190169,0.46095 0.0062,0.003 -0.191196,0.11844 -0.240296,0.14831 -0.684712,-0.8139 -0.684713,-0.81442 v -0.5023 -0.50229 l 0.660942,-0.43305 0.660424,-0.43305 v -0.35037 -0.35088 l -0.246496,-0.15245 -0.247014,-0.15244 -1.033528,0.35605 -1.033526,0.35657 -0.53692,-0.19896 -0.53692,-0.19843 -0.56121,-0.78859 -0.5612,-0.78858 v -0.15761 -0.1571 h 0.66869 0.66921 l 0.15813,-0.41238 0.15813,-0.41237 -0.71417,-0.7457 -0.71365,-0.74517 0.0847,-0.47232 0.0853,-0.47181 -1.30483,-0.33796 -1.30432,-0.33848 -0.67747,-0.51057 z m 67.733852,0 v 1.21543 l 0.17725,0.0868 2.25102,1.10071 v 0.21445 0.21446 l -0.62735,-0.23823 -0.62684,-0.23874 -0.30799,0.67593 -0.30747,0.67592 -0.14366,-0.14366 -0.14366,-0.14366 0.26717,-0.49971 0.26716,-0.49971 -0.17983,-0.27802 -0.17984,-0.27802 -0.44596,-0.0822 v 0.0145 l -0.63407,-0.11679 -1.00149,-0.18397 -1.18753,-0.50901 -1.18752,-0.50953 -1.048523,0.41962 -1.04851,0.41961 -0.004,0.43408 -0.004,0.43408 -0.16071,0.59893 -0.1602,0.59842 0.36225,-0.0925 0.36225,-0.093 -0.19843,0.1111 -0.19792,0.11059 v 0.50177 0.50178 l 0.60616,0.15245 0.606163,0.15193 0.71107,-0.12868 0.71055,-0.12919 0.13488,0.21859 0.13488,0.21808 -0.41652,0.1602 -0.41651,0.15967 h -0.63924 -0.638723 v 0.23203 0.23203 l 0.422203,0.35088 0.4222,0.35037 0.50281,0.0765 0.50281,0.077 v -0.263 -0.26252 h 0.25735 0.25786 l -0.16278,0.85938 -0.16278,0.85886 -0.21962,0.28267 -0.21963,0.28216 -0.0734,0.8971 -0.0739,0.8971 0.46354,0.0961 0.46354,0.0956 0.17776,-0.48214 0.17777,-0.48214 0.66301,-0.8816 0.66249,-0.88212 -0.27595,-1.03507 -0.27647,-1.03457 h 0.19534 0.19533 l 0.3173,0.38241 0.31729,0.38292 0.12402,0.87282 0.12351,0.87333 0.11162,0.33021 0.1111,0.33073 h 0.31058 0.42116 0.65371 l 0.15813,-0.25683 0.15865,-0.25632 -0.40721,-0.78806 -0.40721,-0.78755 v -0.80616 -0.80667 h 0.22737 0.22738 l 0.96221,-0.65267 0.9617,-0.65319 v 0.23461 0.23409 l -0.28525,0.0951 -0.28525,0.0951 -0.27596,2.24018 -0.27595,2.24017 -0.16588,0.17828 -0.16536,0.17777 -1.41387,-0.26096 -0.0884,-0.016 v 1.942 l 0.0486,0.0186 v 0.17001 l -5.3e-4,0.17002 -0.0481,-5.3e-4 v 2.10788 l 2.01797,1.57613 2.23345,1.7446 0.16071,0.25993 0.16072,0.26045 h -0.10026 -0.10025 l -1.69912,-1.3193 -1.69964,-1.31981 -0.1695,-0.002 -0.17001,-0.002 -0.15968,0.41599 -0.15916,0.41548 0.24598,0.46044 0.24649,0.45992 1.64176,0.86145 1.64176,0.86092 0.25012,-0.34933 0.25011,-0.34881 -0.14418,0.4501 -0.14366,0.44958 0.77618,0.38758 0.77618,0.38757 0.73019,-0.19689 0.73019,-0.19688 0.79272,0.48214 0.79323,0.48214 0.42995,10e-4 0.42995,0.001 0.33434,0.40307 0.33435,0.40256 0.13074,-0.13074 0.13074,-0.13074 0.77153,0.54984 0.77153,0.54932 -0.37982,0.43408 -0.38034,0.43408 -0.17363,0.57103 -0.17364,0.57102 -0.3824,0.31729 -0.38241,0.31782 -0.9095,-0.75655 -0.91003,-0.75602 -0.0191,-0.47284 -0.0186,-0.47284 0.69867,0.0765 0.69918,0.076 0.10697,-0.30438 0.10749,-0.30437 -0.80047,-0.39946 -0.79995,-0.39946 -0.66921,0.52658 -0.66921,0.52659 0.14314,0.23151 0.14315,0.23202 -0.68161,0.44649 -0.6811,0.44648 0.0786,0.40256 0.078,0.40256 1.85002,0.42788 1.8495,0.42788 -0.0785,0.99219 -0.0786,0.99064 0.54105,-0.33848 0.54157,-0.33797 v -0.24609 -0.24598 l 0.43873,-0.48524 0.43925,-0.48576 0.28732,-0.49764 0.28784,-0.49765 0.99116,-1.62936 0.99115,-1.62987 v -0.25011 -0.25012 h -0.39636 -0.39636 v -0.24236 -0.24236 l 0.33021,-0.11111 0.33022,-0.1111 -0.30954,-0.63821 -0.31006,-0.63768 -0.45631,-1.26504 -0.4563,-1.26452 -0.29094,0.0977 -0.29094,0.0977 0.0703,2.03243 0.0708,2.03243 -0.73122,-0.1757 -0.73122,-0.1757 -0.13023,-0.11472 -0.1297,-0.11472 0.46043,-0.25787 0.45992,-0.25734 v -0.524 -0.524 l -0.39584,-0.15193 -0.39636,-0.15245 -0.76687,0.82166 -0.76688,0.82114 h -0.55501 -0.55449 v -0.26459 -0.26406 l 0.19844,-0.005 0.19792,-0.004 1.58595,-1.44281 1.58544,-1.4428 0.4625,-0.15658 0.4625,-0.1571 v -0.34725 -0.34727 l -0.93792,-0.71572 -0.93793,-0.71572 0.34313,-0.41393 0.34365,-0.41392 -0.0853,-0.15762 -0.0847,-0.15761 -0.38912,-0.42995 -0.38913,-0.43046 0.22221,-1.2883 0.22273,-1.28829 0.90175,0.0749 0.90227,0.0744 0.14211,0.19689 0.14263,0.1974 1.10019,0.48473 1.10019,0.48524 0.27595,-0.17053 0.27595,-0.17053 1.79524,0.32091 1.79524,0.32142 0.72037,0.59015 0.72037,0.59066 0.33693,-0.0568 0.33642,-0.0563 0.59479,-0.38137 0.5948,-0.38137 v -0.3328 -0.3328 l -0.33073,-0.0196 -0.33021,-0.0196 -0.65164,-0.11989 -0.65216,-0.11937 -0.62787,-0.41186 -0.62735,-0.41135 -1.23145,0.002 -1.23093,0.002 -1.55133,-0.3607 -1.55184,-0.36018 -0.58498,-0.54984 -0.58498,-0.54932 -0.6382,0.10387 -0.63821,0.10387 -0.29714,-0.23564 -0.29662,-0.23565 -0.3638,0.14315 -0.3638,0.14262 -0.56431,1.64641 -0.56482,1.6459 -0.18966,0.46095 -0.19016,0.46096 0.006,0.003 -0.1912,0.11834 -0.2403,0.14831 -0.68471,-0.81391 -0.68472,-0.81442 v -0.50229 -0.5023 l 0.66095,-0.43305 0.66042,-0.43305 v -0.35036 -0.35088 l -0.2465,-0.15245 -0.24701,-0.15244 -1.03353,0.35605 -1.03353,0.35656 -0.53691,-0.19895 -0.53692,-0.19844 -0.56121,-0.78858 -0.5612,-0.78858 v -0.15761 -0.1571 h 0.66869 0.66921 l 0.15813,-0.41238 0.15813,-0.41238 -0.71417,-0.74569 -0.71365,-0.74517 0.0847,-0.47233 0.0853,-0.4718 -1.30483,-0.33797 -1.30431,-0.33848 -0.67748,-0.51056 z m -11.315077,0.46664 -0.807186,0.28163 -0.806669,0.28112 -0.61495,1.37098 -0.614434,1.37097 -0.194818,0.46251 -0.194821,0.46302 h 0.353984 0.353983 l 1.487247,-1.85467 1.487249,-1.85415 v -0.26097 -0.26045 h -0.224792 z m 67.733857,0 -0.80719,0.28163 -0.80667,0.28112 -0.61495,1.37098 -0.61443,1.37097 -0.19482,0.46251 -0.19482,0.46302 h 0.35398 0.35399 l 1.48725,-1.85467 1.48724,-1.85415 v -0.26097 -0.26045 h -0.22479 z m 7.30446,0.0103 -1.04851,0.41961 -1.04852,0.41961 -0.004,0.43408 -0.004,0.43409 -0.16071,0.59893 -0.1602,0.59841 0.36225,-0.0925 0.36225,-0.093 -0.19843,0.1111 -0.19792,0.11059 v 0.50178 0.50178 l 0.60616,0.15244 0.60616,0.15193 0.71107,-0.12867 0.71055,-0.12919 0.13488,0.21859 0.13488,0.21807 -0.41652,0.1602 -0.41651,0.15968 h -0.63924 -0.63872 v 0.23203 0.23202 l 0.4222,0.35089 0.4222,0.35036 0.50281,0.0765 0.50281,0.077 v -0.263 -0.26252 h 0.25735 0.25786 l -0.16278,0.85938 -0.16278,0.85886 -0.21962,0.28267 -0.21963,0.28216 -0.0734,0.8971 -0.0739,0.8971 0.46354,0.0961 0.46354,0.0956 0.17777,-0.48214 0.17776,-0.48214 0.66301,-0.8816 0.66249,-0.88212 -0.27595,-1.03508 -0.27647,-1.03456 h 0.19534 0.19533 l 0.3173,0.38241 0.31729,0.38292 0.12403,0.87281 0.1235,0.87333 0.11162,0.33022 0.11111,0.33073 h 0.31057 v -6.86522 l -0.63407,-0.11679 -1.00149,-0.18397 -1.18752,-0.50901 z m -78.213317,0.58756 -0.434083,0.24288 -0.434081,0.24288 v 0.37517 0.37517 l -0.372589,-0.14314 -0.372586,-0.14263 -0.750343,0.39015 -0.750858,0.39068 -0.660424,0.57722 -0.660942,0.57723 -0.367419,0.20619 -0.367419,0.20619 0.185002,0.2992 0.185002,0.29921 h 0.327628 0.328144 l 0.251148,-0.22531 0.251148,-0.22531 1.247468,-0.3359 1.247987,-0.33538 0.161747,-0.51056 0.161748,-0.51004 0.385506,0.31987 0.385506,0.31988 0.21704,-0.23978 0.21704,-0.24029 0.278019,-0.83406 0.277503,-0.83458 -0.468188,-0.12247 z m 67.733857,0 -0.43409,0.24288 -0.43408,0.24288 v 0.37517 0.37517 l -0.37258,-0.14314 -0.37259,-0.14263 -0.75034,0.39015 -0.75086,0.39068 -0.66043,0.57722 -0.66094,0.57723 -0.36742,0.20619 -0.36742,0.20619 0.18501,0.2992 0.185,0.29921 h 0.32763 0.32814 l 0.25115,-0.22531 0.25115,-0.22531 1.24747,-0.3359 1.24798,-0.33538 0.16175,-0.51056 0.16175,-0.51004 0.3855,0.31987 0.38551,0.31988 0.21704,-0.23978 0.21704,-0.24029 0.27802,-0.83406 0.2775,-0.83458 -0.46819,-0.12247 z m -104.077375,0.1695 -0.166915,0.16795 -0.166915,0.16794 0.621667,0.50436 0.622184,0.50437 0.237196,-0.14625 0.236678,-0.14624 v -0.35244 -0.35243 l -0.691949,-0.17363 z m 67.733855,0 -0.16692,0.16795 -0.16691,0.16794 0.62166,0.50436 0.62219,0.50437 0.23719,-0.14625 0.23668,-0.14624 v -0.35244 -0.35243 l -0.69194,-0.17363 z m -19.87424,0.1359 -0.10542,0.17105 -0.10542,0.17054 0.63872,0.60048 0.63924,0.60048 0.34364,-0.13178 0.34417,-0.13177 0.0357,0.59221 0.0362,0.59221 -0.89865,0.27544 -0.89814,0.27595 -0.27027,-0.50488 -0.26975,-0.50539 h -0.34106 -0.34107 l -0.56275,-0.59894 -0.562243,-0.59893 0.18603,-0.29197 0.186043,-0.29249 0.97255,-0.1111 z m 67.73385,0 -0.10542,0.17105 -0.10542,0.17054 0.63872,0.60048 0.63924,0.60048 0.34365,-0.13178 0.34416,-0.13177 0.0357,0.59221 0.0362,0.59221 -0.89865,0.27544 -0.89814,0.27595 -0.27026,-0.50488 -0.26975,-0.50539 h -0.34107 -0.34106 l -0.56276,-0.59894 -0.56224,-0.59893 0.18603,-0.29197 0.18604,-0.29249 0.97255,-0.1111 z m -118.469259,0.41858 h 0.132292 0.131776 l 0.163295,0.26407 0.163299,0.26458 h -0.131776 -0.132292 l -0.163296,-0.26458 z m 67.733849,0 h 0.13229 0.13178 l 0.1633,0.26407 0.16329,0.26458 h -0.13177 -0.13229 l -0.1633,-0.26458 z m -60.785435,0.2403 -0.171051,0.27698 -0.171048,0.27699 0.610299,0.25941 0.610814,0.2589 1.056783,0.62373 1.057302,0.62322 0.436147,-0.1142 0.435634,-0.11369 0.729154,-0.76119 0.729155,-0.76171 -0.37207,-0.11886 -0.372589,-0.11937 -2.289265,-0.16485 z m 67.733855,0 -0.17105,0.27698 -0.17105,0.27699 0.6103,0.25941 0.61081,0.2589 1.05679,0.62373 1.0573,0.62322 0.43615,-0.1142 0.43563,-0.11369 0.72915,-0.76119 0.72916,-0.76171 -0.37207,-0.11886 -0.37259,-0.11937 -2.28927,-0.16485 z m -86.014912,0.28835 h 0.13178 0.13229 v 0.13229 0.13178 h -0.13229 -0.13178 v -0.13178 z m 67.733852,0 h 0.13178 0.13229 v 0.13229 0.13178 h -0.13229 -0.13178 v -0.13178 z m -50.364369,0.96635 -0.360183,0.49299 -0.360185,0.49248 v 0.1633 0.16329 l 0.331245,0.45269 0.330729,0.45269 0.659908,0.12815 0.660426,0.12868 1.321367,0.37103 1.321366,0.37104 0.626835,0.0238 0.627351,0.0238 -0.307991,-0.37103 -0.307991,-0.37104 -1.376146,-0.70435 -1.376143,-0.70435 -0.895551,-0.55656 z m 67.733849,0 -0.36018,0.49299 -0.36019,0.49248 v 0.1633 0.16329 l 0.33125,0.45269 0.33073,0.45269 0.65991,0.12815 0.66042,0.12868 1.32137,0.37103 1.32137,0.37104 0.62683,0.0238 0.62735,0.0238 -0.30799,-0.37103 -0.30799,-0.37104 -1.37614,-0.70435 -1.37615,-0.70435 -0.89555,-0.55656 z m -83.253832,0.32401 v 0.13229 0.13229 l -0.26407,0.1633 -0.26406,0.1633 v -0.13178 -0.13229 l 0.26406,-0.16329 z m 67.733852,0 v 0.13229 0.13229 l -0.26406,0.1633 -0.26407,0.1633 v -0.13178 -0.13229 l 0.26407,-0.16329 z m -44.877365,0.56017 -0.848527,0.92553 -0.849045,0.925 0.130225,0.33952 0.130225,0.33951 0.638204,0.0527 0.637688,0.0527 0.165365,-0.52193 0.165881,-0.52193 -0.168982,-0.27337 -0.168465,-0.27337 0.217556,0.0486 0.218075,0.0486 0.462505,-0.20205 0.462505,-0.20257 v -0.36846 -0.36845 h -0.596863 z m 67.733855,0 -0.84853,0.92553 -0.84904,0.925 0.13022,0.33952 0.13022,0.33951 0.63821,0.0527 0.63769,0.0527 0.16536,-0.52193 0.16588,-0.52193 -0.16898,-0.27337 -0.16846,-0.27337 0.21755,0.0486 0.21808,0.0486 0.4625,-0.20205 0.46251,-0.20257 v -0.36846 -0.36845 h -0.59687 z m -43.266615,0.21446 -1.131713,0.37775 -1.132231,0.37724 v 0.34882 0.3483 l 0.991153,0.51469 0.990637,0.51418 -0.183452,0.29714 -0.183451,0.29663 -0.05013,1.233 -0.04961,1.23248 -0.329179,1.02216 -0.329694,1.02268 -0.218075,0.2775 -0.218591,0.2775 -0.18242,1.14153 -0.182417,1.14205 0.699699,-0.45837 0.699183,-0.45837 v 0.18759 0.1881 l -0.546219,0.76791 -0.546738,0.76791 h -0.261993 -0.262001 l 0.139009,-0.22479 0.138494,-0.22427 -0.626319,-0.33538 -0.62632,-0.33538 -0.289903,0.1788 -0.289388,0.1788 v 0.37209 0.37156 l 0.462504,0.23771 0.462503,0.23823 0.330213,-0.11886 0.330729,-0.11834 -0.0021,0.22014 -0.0021,0.22066 -0.460955,0.69867 -0.460438,0.69866 -0.212389,0.0946 -0.212389,0.094 -0.712618,-1.31464 -0.712619,-1.31517 -1.057301,-0.59738 -1.056783,-0.59738 -0.66094,0.0822 -0.660426,0.0827 -0.06873,0.64027 -0.06822,0.64027 0.200506,0.27854 0.200504,0.27853 1.940968,1.53686 1.940965,1.53737 0.648022,-0.29559 0.648542,-0.29559 h 0.13539 0.134876 l -0.161747,0.26252 -0.162264,0.26252 1.99626,0.94774 1.996779,0.94827 v 0.22169 0.22169 l -0.506947,1.18236 -0.506429,1.18287 -0.243395,0.15038 -0.24288,0.15038 -1.012859,-1.03767 -1.012857,-1.03766 0.375171,-0.13281 0.375172,-0.13281 0.500226,0.0574 0.500229,0.0579 0.110586,-0.31367 0.111106,-0.31368 -0.703834,-0.46095 -0.703834,-0.46147 -0.435631,0.28784 -0.43615,0.28732 0.07286,0.30902 0.07235,0.30851 -0.244946,-0.15141 -0.244945,-0.15193 -0.529167,0.83664 -0.529685,0.83613 0.13436,0.35036 0.134358,0.34985 1.096058,0.28319 1.096058,0.28319 0.462502,0.13435 0.462505,0.13385 v 0.77566 l 5.29e-4,0.77515 h 0.219625 0.219626 l 1.594733,-2.44585 1.594218,-2.44533 0.294555,-0.56689 0.294558,-0.56741 -0.393776,-0.32711 -0.39429,-0.32711 0.29714,-0.35812 0.297138,-0.35812 -0.207738,-0.46612 -0.20774,-0.46612 -0.419614,-1.30069 -0.41961,-1.3007 -0.327112,-0.10955 -0.327113,-0.10904 v 1.82004 1.81953 l 0.312642,0.31316 0.312643,0.31264 -0.144177,0.14418 -0.143661,0.14366 -0.719336,-0.27337 -0.719852,-0.27388 -0.241845,0.14986 -0.242363,0.14986 v -0.25218 -0.25167 l 0.396359,-0.15192 0.396356,-0.15245 v -0.65319 -0.65371 l -0.253214,-0.15709 -0.25373,-0.15658 -1.045414,0.94516 -1.045932,0.94464 -0.162264,-0.26251 -0.162264,-0.26252 1.561661,-1.50533 1.561664,-1.50585 -0.5178,-1.16996 -0.517279,-1.16995 0.144692,-0.37724 0.144696,-0.37724 h 0.433046 0.432533 l 0.521933,0.66353 0.521414,0.66352 0.219109,-0.13539 0.218591,-0.13539 1.339453,1.05936 1.339453,1.05937 2.037086,-0.0806 2.036568,-0.0806 0.11575,-0.34778 0.11576,-0.34726 -0.75861,-0.60875 -0.759128,-0.60875 -0.74104,0.14624 -0.740524,0.14625 -0.750858,-0.71934 -0.75034,-0.71934 -1.547709,0.13798 -1.54771,0.13746 0.60978,-0.13539 0.609783,-0.13591 -0.08113,-0.23926 -0.08165,-0.23978 -1.175639,-0.59945 -1.176155,-0.59893 -0.110072,-0.35605 -0.109553,-0.35657 0.541568,0.29042 0.54157,0.28991 h 0.822171 0.821656 l 0.697114,0.64699 0.697116,0.64647 0.21704,-0.13384 0.217041,-0.13436 -0.2651,-0.49506 -0.265099,-0.49558 v -0.18293 -0.18293 l 0.991153,1.0418 0.991156,1.04179 0.792715,0.35967 0.792716,0.35915 0.792718,0.10749 0.79323,0.10697 0.85886,0.52968 0.85887,0.52917 0.150373,-0.39171 0.14984,-0.39171 -1.141013,-1.08468 -1.14154,-1.08469 -0.57619,0.13332 -0.576189,0.13333 -0.547254,-0.76843 -0.546738,-0.76791 v -1.464 -1.46399 l 0.206706,-0.12764 0.20619,-0.12764 1.709455,1.13946 1.70997,1.13947 0.462513,-0.2434 0.4625,-0.24339 -0.008,-0.32143 -0.008,-0.32091 -0.990643,-1.14618 -0.99012,-1.14567 -0.85214,-0.0589 -0.851627,-0.0584 v 0.1602 0.1602 l -0.890903,0.32246 -0.891418,0.32246 -0.16278,0.9865 -0.163298,0.9865 -0.0026,0.72709 -0.0031,0.72709 h -0.396307 -0.396359 v -1.32189 -1.32189 h -0.231511 -0.230992 l -0.806153,0.16124 -0.805635,0.16123 -0.31626,0.76377 -0.316777,0.7643 H 90.98107 90.79865 l -0.601512,-0.81391 -0.601514,-0.8139 0.112654,-0.11265 0.112655,-0.11318 1.298112,-0.0868 1.298112,-0.0873 0.660426,-0.28008 0.66094,-0.28009 1.189074,-0.46612 1.189075,-0.46664 0.343133,-0.2651 0.342614,-0.26562 -0.300241,-0.18551 -0.300755,-0.18604 -2.288751,0.0305 -2.288231,0.0305 0.06563,0.33021 0.06615,0.33073 -0.245462,-0.0661 -0.245462,-0.0662 -0.349334,0.44804 -0.348816,0.44855 -0.790131,0.1912 -0.790133,0.19121 0.45992,-0.46044 0.45992,-0.45992 v -0.38603 -0.38602 l -0.388091,-0.14883 z m 67.733855,0 -1.13171,0.37775 -1.13223,0.37724 v 0.34882 0.3483 l 0.99115,0.51469 0.99064,0.51418 -0.18345,0.29714 -0.18345,0.29663 -0.0501,1.233 -0.0496,1.23248 -0.32918,1.02216 -0.32969,1.02268 -0.21808,0.2775 -0.21859,0.2775 -0.18242,1.14153 -0.18242,1.14205 0.6997,-0.45837 0.69918,-0.45837 v 0.18759 0.1881 l -0.54622,0.76791 -0.54673,0.76791 h -0.262 -0.262 l 0.13901,-0.22479 0.13849,-0.22427 -0.62632,-0.33538 -0.62631,-0.33538 -0.28991,0.1788 -0.28939,0.1788 v 0.37209 0.37156 l 0.46251,0.23771 0.4625,0.23823 0.33021,-0.11886 0.33073,-0.11834 -0.002,0.22014 -0.002,0.22066 -0.46096,0.69867 -0.46043,0.69866 -0.21239,0.0946 -0.21239,0.094 -0.71262,-1.31464 -0.71262,-1.31517 -1.0573,-0.59738 -1.05678,-0.59738 -0.66095,0.0822 -0.66042,0.0827 -0.0687,0.64027 -0.0682,0.64027 0.2005,0.27854 0.20051,0.27853 1.94096,1.53686 1.94097,1.53737 0.64802,-0.29559 0.64854,-0.29559 h 0.13539 0.13488 l -0.16175,0.26252 -0.16226,0.26252 1.99626,0.94774 1.99678,0.94827 v 0.22169 0.22169 l -0.50695,1.18236 -0.50643,1.18287 -0.24339,0.15038 -0.24288,0.15038 -1.01286,-1.03767 -1.01286,-1.03766 0.37517,-0.13281 0.37517,-0.13281 0.50023,0.0574 0.50023,0.0579 0.11059,-0.31367 0.1111,-0.31368 -0.70383,-0.46095 -0.70384,-0.46147 -0.43563,0.28784 -0.43615,0.28732 0.0729,0.30902 0.0723,0.30851 -0.24494,-0.15141 -0.24495,-0.15193 -0.52917,0.83664 -0.52968,0.83613 0.13436,0.35036 0.13436,0.34985 1.09605,0.28319 1.09606,0.28319 0.46251,0.13435 0.4625,0.13385 v 0.77566 l 5.3e-4,0.77515 h 0.21963 0.21962 l 1.59474,-2.44585 1.59421,-2.44533 0.29456,-0.56689 0.29455,-0.56741 -0.39377,-0.32711 -0.39429,-0.32711 0.29714,-0.35812 0.29714,-0.35812 -0.20774,-0.46612 -0.20774,-0.46612 -0.41961,-1.30069 -0.41962,-1.3007 -0.32711,-0.10955 -0.32711,-0.10904 v 1.82004 1.81953 l 0.31264,0.31316 0.31265,0.31264 -0.14418,0.14418 -0.14366,0.14366 -0.71934,-0.27337 -0.71985,-0.27388 -0.24185,0.14986 -0.24236,0.14986 v -0.25218 -0.25167 l 0.39636,-0.15192 0.39636,-0.15245 v -0.65319 -0.65371 l -0.25322,-0.15709 -0.25373,-0.15658 -1.04541,0.94516 -1.04593,0.94464 -0.16227,-0.26251 -0.16226,-0.26252 1.56166,-1.50533 1.56166,-1.50585 -0.5178,-1.16996 -0.51728,-1.16995 0.1447,-0.37724 0.14469,-0.37724 h 0.43305 0.43253 l 0.52193,0.66353 0.52142,0.66352 0.21911,-0.13539 0.21859,-0.13539 1.33945,1.05936 1.33945,1.05937 2.03709,-0.0806 2.03657,-0.0806 0.11575,-0.34778 0.11576,-0.34726 -0.75861,-0.60875 -0.75913,-0.60875 -0.74104,0.14624 -0.74052,0.14625 -0.75086,-0.71934 -0.75034,-0.71934 -1.54771,0.13798 -1.54771,0.13746 0.60978,-0.13539 0.60978,-0.13591 -0.0811,-0.23926 -0.0816,-0.23978 -1.17564,-0.59945 -1.17615,-0.59893 -0.11007,-0.35605 -0.10956,-0.35657 0.54157,0.29042 0.54157,0.28991 h 0.82217 0.82166 l 0.69711,0.64699 0.69712,0.64647 0.21704,-0.13384 0.21704,-0.13436 -0.2651,-0.49506 -0.2651,-0.49558 v -0.18293 -0.18293 l 0.99115,1.0418 0.99116,1.04179 0.79272,0.35967 0.79271,0.35915 0.79272,0.10749 0.79323,0.10697 0.85886,0.52968 0.85887,0.52917 0.15037,-0.39171 0.14986,-0.39171 -1.14101,-1.08468 -1.14153,-1.08469 -0.57619,0.13332 -0.5762,0.13333 -0.54725,-0.76843 -0.54674,-0.76791 v -1.464 -1.46399 l 0.20671,-0.12764 0.20619,-0.12764 1.70945,1.13946 1.70998,1.13947 0.4625,-0.2434 0.4625,-0.24339 -0.008,-0.32143 -0.008,-0.32091 -0.99064,-1.14618 -0.99012,-1.14567 -0.85215,-0.0589 -0.85162,-0.0584 v 0.1602 0.1602 l -0.89091,0.32246 -0.89141,0.32246 -0.16279,0.9865 -0.16329,0.9865 -0.003,0.72709 -0.003,0.72709 h -0.39636 -0.39636 v -1.32189 -1.32189 h -0.23151 -0.23099 l -0.80616,0.16124 -0.80563,0.16123 -0.31626,0.76377 -0.31678,0.7643 h -0.18242 -0.18241 l -0.60152,-0.81391 -0.60151,-0.8139 0.11265,-0.11265 0.11266,-0.11318 1.29811,-0.0868 1.29811,-0.0873 0.66043,-0.28008 0.66094,-0.28009 1.18907,-0.46612 1.18908,-0.46664 0.34313,-0.2651 0.34261,-0.26562 -0.30023,-0.18551 -0.30076,-0.18604 -2.28875,0.0305 -2.28823,0.0305 0.0656,0.33021 0.0656,0.33073 -0.24546,-0.0661 -0.24546,-0.0662 -0.34934,0.44804 -0.34881,0.44855 -0.79013,0.1912 -0.79014,0.19121 0.45992,-0.46044 0.45992,-0.45992 v -0.38603 -0.38602 l -0.38809,-0.14883 z m -103.693418,0.0501 h 0.132292 0.131776 v 0.13229 0.13178 h -0.131776 -0.132292 v -0.13178 z m 67.733858,0 h 0.13229 0.13177 v 0.13229 0.13178 h -0.13177 -0.13229 v -0.13178 z m -53.459275,1.02371 -0.840261,0.0832 -0.840259,0.0827 -0.09405,0.2868 -0.09405,0.28681 0.60203,0.29042 h 5.3e-4 l 0.60203,0.2899 0.131776,0.0139 0.132291,0.0139 0.36897,-0.23357 0.368969,-0.23358 -0.168981,-0.44028 z m 67.733855,0 -0.84026,0.0832 -0.84026,0.0827 -0.0946,0.2868 -0.0935,0.28681 0.60203,0.29042 h 5.3e-4 l 0.60203,0.2899 0.13178,0.0139 0.13229,0.0139 0.36897,-0.23357 0.36897,-0.23358 -0.16899,-0.44028 z m -78.969346,0.74672 -0.871781,0.23823 -0.8723,0.23875 0.07907,0.26406 0.07958,0.26459 1.238168,-0.0134 1.238168,-0.0129 -0.100769,0.16278 -0.100769,0.1633 0.712618,0.41961 0.712102,0.41961 1.18959,0.17467 1.189075,0.17415 0.396359,0.0568 0.396357,0.0563 0.264583,0.15968 0.264067,0.1602 0.888318,0.19068 0.887801,0.19069 -0.383439,0.38395 -0.383956,0.38344 -1.95802,0.36742 -1.957504,0.3669 -0.925007,0.2248 -0.92501,0.22427 -0.33021,-0.0444 -0.330729,-0.045 -1.89601,-0.0331 -1.896007,-0.0331 0.602547,-0.6413 0.60203,-0.64131 -0.182933,-0.29662 -0.183451,-0.29662 -1.166855,0.17518 -1.167371,0.17518 -1.46141,-0.59376 -1.461926,-0.59324 -0.160197,0.16019 -0.160197,0.1602 0.349333,0.42116 0.349333,0.42168 0.481624,-0.12609 0.481108,-0.12609 -0.149345,0.24185 -0.149345,0.24133 0.479557,0.16484 0.479041,0.16434 0.660941,0.75654 0.660424,0.75654 1.057302,0.12971 1.057299,0.12971 0.660423,0.14159 0.660943,0.14159 0.528132,0.11938 0.528651,0.11885 1.137914,0.30903 1.137399,0.30851 0.712618,-0.34727 0.712103,-0.34778 0.925007,-0.10594 0.925007,-0.10645 0.528651,-0.47232 0.528132,-0.47233 0.713652,-0.45372 0.714169,-0.4532 -0.147796,0.90951 -0.147794,0.91002 1.350306,0.87488 1.349788,0.8754 v 0.1757 0.1757 l -0.158647,0.15865 -0.158647,0.15864 -0.635103,-0.2899 -0.635619,-0.28939 -0.137462,0.13694 -0.13694,0.13746 0.163814,0.42737 0.163814,0.42684 0.910021,0.17105 0.910022,0.17053 0.455787,-0.41237 0.455787,-0.4129 0.855244,0.41445 0.854729,0.41444 v 0.31368 0.31419 l -0.815454,0.7767 -0.815454,0.77669 -0.253732,0.46768 -0.253731,0.46818 0.161745,0.262 0.161748,0.262 1.567863,-1.36425 1.568381,-1.36478 v -0.33798 -0.33796 l -0.357087,-0.34933 -0.357085,-0.34934 -2.285648,-2.07945 -2.285648,-2.07895 v -0.23409 -0.2341 h 0.31936 0.318842 l 1.002006,0.97876 1.002006,0.97823 0.291457,-0.29145 0.291455,-0.29198 -0.621152,-0.88521 -0.621668,-0.8847 -0.158647,-0.13229 -0.158646,-0.1323 -0.303856,-0.57722 -0.303858,-0.57775 v -0.54622 -0.54622 l -1.123445,-0.031 -1.122928,-0.0315 -0.248047,0.0481 -0.248047,0.0481 -2.33164,0.0677 -2.331125,0.0682 0.14056,-0.4439 0.141076,-0.4439 -0.411345,-0.34158 -0.411343,-0.34107 -1.246436,-5.3e-4 z m 67.733856,0 -0.87179,0.23823 -0.87229,0.23875 0.0791,0.26406 0.0796,0.26459 1.23816,-0.0134 1.23817,-0.0129 -0.10077,0.16278 -0.10077,0.1633 0.71262,0.41961 0.7121,0.41961 1.18959,0.17467 1.18908,0.17415 0.39636,0.0568 0.39636,0.0563 0.26458,0.15968 0.26406,0.1602 0.88832,0.19068 0.8878,0.19069 -0.38343,0.38395 -0.38396,0.38344 -1.95802,0.36742 -1.9575,0.3669 -0.92501,0.2248 -0.92501,0.22427 -0.33021,-0.0444 -0.33073,-0.045 -1.89601,-0.0331 -1.89601,-0.0331 0.60255,-0.6413 0.60203,-0.64131 -0.18294,-0.29662 -0.18345,-0.29662 -1.16685,0.17518 -1.16737,0.17518 -1.46141,-0.59376 -1.46193,-0.59324 -0.16019,0.16019 -0.1602,0.1602 0.34933,0.42116 0.34933,0.42168 0.48163,-0.12609 0.4811,-0.12609 -0.14934,0.24185 -0.14934,0.24133 0.47955,0.16484 0.47905,0.16434 0.66094,0.75654 0.66042,0.75654 1.0573,0.12971 1.0573,0.12971 0.66043,0.14159 0.66094,0.14159 0.52813,0.11938 0.52865,0.11885 1.13792,0.30903 1.13739,0.30851 0.71262,-0.34727 0.7121,-0.34778 0.92501,-0.10594 0.92501,-0.10645 0.52865,-0.47232 0.52813,-0.47233 0.71365,-0.45372 0.71417,-0.4532 -0.14779,0.90951 -0.1478,0.91002 1.35031,0.87488 1.34978,0.8754 v 0.1757 0.1757 l -0.15864,0.15865 -0.15865,0.15864 -0.6351,-0.2899 -0.63562,-0.28939 -0.13746,0.13694 -0.13694,0.13746 0.16381,0.42737 0.16382,0.42684 0.91002,0.17105 0.91002,0.17053 0.45578,-0.41237 0.45579,-0.4129 0.85525,0.41445 0.85473,0.41444 v 0.31368 0.31419 l -0.81546,0.7767 -0.81545,0.77669 -0.25374,0.46768 -0.25373,0.46818 0.16175,0.262 0.16175,0.262 1.56786,-1.36425 1.56838,-1.36478 v -0.33798 -0.33796 l -0.35708,-0.34933 -0.35709,-0.34934 -2.28565,-2.07945 -2.28564,-2.07895 v -0.23409 -0.2341 h 0.31936 0.31884 l 1.00201,0.97876 1.002,0.97823 0.29146,-0.29145 0.29145,-0.29198 -0.62115,-0.88521 -0.62167,-0.8847 -0.15864,-0.13229 -0.15865,-0.1323 -0.30386,-0.57722 -0.30386,-0.57775 v -0.54622 -0.54622 l -1.12344,-0.031 -1.12293,-0.0315 -0.24805,0.0481 -0.24804,0.0481 -2.33164,0.0677 -2.33113,0.0682 0.14056,-0.4439 0.14108,-0.4439 -0.41134,-0.34158 -0.41135,-0.34107 -1.24644,-5.3e-4 z m -41.376292,0.87336 h 0.35915 0.35967 l 0.370519,0.5948 0.37052,0.59479 -0.12919,0.99167 -0.129191,0.99116 h -0.196371 -0.196887 l -0.723988,-0.67076 -0.723468,-0.67128 0.186549,-0.45268 0.186553,-0.45217 0.13281,-0.46302 z m 67.733852,0 h 0.35916 0.35966 l 0.37052,0.5948 0.37052,0.59479 -0.12919,0.99167 -0.12919,0.99116 h -0.19637 -0.19689 l -0.72398,-0.67076 -0.72347,-0.67128 0.18655,-0.45268 0.18655,-0.45217 0.13281,-0.46302 z m -51.674883,0.44029 0.17622,0.17621 0.17621,0.17622 -0.17621,0.17673 -0.17622,0.17622 v -0.35296 z m 67.733853,0 0.17622,0.17621 0.17622,0.17622 -0.17622,0.17673 -0.17622,0.17622 v -0.35296 z m -84.943138,0.0884 h 0.132291 0.132292 l 0.163296,0.26458 0.163298,0.26406 h -0.132292 -0.132291 l -0.163299,-0.26406 z m 67.733858,0 h 0.13229 0.13229 l 0.1633,0.26458 0.16329,0.26406 h -0.13229 -0.13229 l -0.16329,-0.26406 z m -108.401142,0.26405 h 0.75189 0.75189 l 0.40773,0.46302 0.40824,0.4625 0.168468,0.79582 0.168465,0.79634 1.070735,1.25263 1.070736,1.25316 h 0.375688 0.375687 v -0.34365 -0.34365 l -0.330212,-0.38137 -0.330212,-0.38138 0.858862,0.77464 0.858863,0.77411 v 0.34726 0.34727 h -0.264067 -0.264584 v 0.26717 0.26665 l -0.95498,1.38544 -0.954981,1.38545 -0.417028,0.33021 -0.416512,0.33073 h -0.204639 -0.204122 l -0.312642,-0.5948 -0.312125,-0.59479 -1.04283,-1.25626 -1.04335,-1.25573 h 0.40566 0.40514 l 0.15297,0.24804 0.15348,0.24753 0.7214,0.36432 0.721402,0.36484 0.559656,0.35501 0.559655,0.3545 0.433565,-0.16639 0.433566,-0.1664 0.309025,-0.67851 0.309025,-0.678 -0.377238,-0.37672 -0.377238,-0.37724 -2.510958,-0.28112 -2.51044,-0.28163 -0.84904,-0.98392 -0.84905,-0.98444 -0.009,-0.19844 -0.01,-0.19792 h 0.2651 0.2651 l 1.96164,1.06402 1.96112,1.06454 0.192235,-0.31161 0.192236,-0.3111 -0.451131,-0.33021 -0.45062,-0.32969 -0.91106,-1.28158 -0.91054,-1.28157 v -0.46354 z m 67.733852,0 h 0.75189 0.75189 l 0.40773,0.46302 0.40824,0.4625 0.16847,0.79582 0.16846,0.79634 1.07074,1.25263 1.07073,1.25316 h 0.37569 0.37569 v -0.34365 -0.34365 l -0.33021,-0.38137 -0.33021,-0.38138 0.85886,0.77464 0.85886,0.77411 v 0.34726 0.34727 h -0.26407 -0.26458 v 0.26717 0.26665 l -0.95498,1.38544 -0.95498,1.38545 -0.41703,0.33021 -0.41651,0.33073 h -0.20464 -0.20412 l -0.31264,-0.5948 -0.31213,-0.59479 -1.04283,-1.25626 -1.04335,-1.25573 h 0.40566 0.40515 l 0.15296,0.24804 0.15348,0.24753 0.7214,0.36432 0.7214,0.36484 0.55966,0.35501 0.55965,0.3545 0.43357,-0.16639 0.43357,-0.1664 0.30902,-0.67851 0.30903,-0.678 -0.37724,-0.37672 -0.37724,-0.37724 -2.51096,-0.28112 -2.51044,-0.28163 -0.84904,-0.98392 -0.84905,-0.98444 -0.01,-0.19844 -0.01,-0.19792 h 0.2651 0.2651 l 1.96164,1.06402 1.96112,1.06454 0.19224,-0.31161 0.19223,-0.3111 -0.45113,-0.33021 -0.45062,-0.32969 -0.91106,-1.28158 -0.91054,-1.28157 v -0.46354 z m -12.235434,0.26407 v 0.64182 0.64182 l 0.383439,0.38396 0.383952,0.38447 -0.12815,0.12816 -0.128677,0.12867 1.080037,0.1726 1.08055,0.1726 0.90382,0.90434 0.903833,0.90433 0.94102,0.447 0.94155,0.447 0.16691,-0.16691 0.1664,-0.16691 -0.50643,-0.004 -0.50643,-0.004 0.39636,-0.2558 0.39636,-0.25683 0.99115,-0.004 0.99116,-0.004 v 0.24236 0.24236 l 0.29352,0.22945 v -4.45515 l -1.40405,-0.25838 -0.50229,0.45423 -0.50178,0.45424 v 0.48782 0.48783 h 0.77153 0.77101 l 0.41806,0.16071 0.41806,0.1602 -5.3e-4,0.17002 v 0.17001 l -1.48569,-0.015 -1.48518,-0.015 -0.65681,-0.58497 -0.65629,-0.58446 -1.035083,-0.23307 -1.03508,-0.23254 -0.90124,-0.68781 -0.901234,-0.6873 h -0.282152 z m 67.733854,0 v 0.64182 0.64182 l 0.38344,0.38396 0.38396,0.38447 -0.12816,0.12816 -0.12868,0.12867 1.08004,0.1726 1.08056,0.1726 0.90382,0.90434 0.90382,0.90433 0.94103,0.447 0.94154,0.447 0.16692,-0.16691 0.16639,-0.16691 -0.50642,-0.004 -0.50643,-0.004 0.39635,-0.2558 0.39636,-0.25683 0.99116,-0.004 0.99115,-0.004 v 0.24236 0.24236 l 0.29352,0.22945 v -4.45515 l -1.40405,-0.25838 -0.50229,0.45423 -0.50178,0.45424 v 0.48782 0.48783 h 0.77153 0.77101 l 0.41807,0.16071 0.41806,0.1602 -5.3e-4,0.17002 v 0.17001 l -1.4857,-0.015 -1.48518,-0.015 -0.65681,-0.58497 -0.65629,-0.58446 -1.03508,-0.23307 -1.03508,-0.23254 -0.90123,-0.68781 -0.90124,-0.6873 h -0.28215 z m -95.086707,1.19062 0.462505,0.36277 0.462505,0.36277 v 0.0997 0.0992 h -0.09974 -0.09974 l -0.362759,-0.4625 z m 67.733857,0 0.4625,0.36277 0.46251,0.36277 v 0.0997 0.0992 h -0.0997 -0.0997 l -0.36277,-0.46251 z m -58.88065,0.13178 h 0.132292 0.131776 v 0.13229 0.13229 H 77.881642 77.74935 v -0.13229 z m 67.73386,0 h 0.13229 0.13177 v 0.13229 0.13229 h -0.13177 -0.13229 v -0.13229 z m -89.668955,0.52916 v 0.13178 0.13229 h 0.132291 0.132292 v -0.13229 -0.13178 h -0.132292 z m 67.733855,0 v 0.13178 0.13229 h 0.13229 0.13229 v -0.13229 -0.13178 h -0.13229 z m -77.776136,0.54571 0.566891,0.22686 0.622184,0.24959 -0.594279,0.0165 -0.594796,0.0171 v -0.28008 z m 67.733856,0 0.56689,0.22686 0.62218,0.24959 -0.59428,0.0165 -0.59479,0.0171 v -0.28008 z m -64.03434,0.51159 v 0.13229 0.1323 h 0.132292 0.132292 v -0.1323 -0.13229 h -0.132292 z m 67.73385,0 v 0.13229 0.1323 h 0.13229 0.1323 v -0.1323 -0.13229 h -0.1323 z m -41.379902,0.26459 h 0.301273 0.301273 v 0.25063 h 0.0011 v 0.25063 l -0.660943,0.71313 -0.660942,0.71314 0.0083,-0.50126 0.0083,-0.50126 0.351401,-0.46251 z m 67.733852,0 h 0.30128 0.30127 v 0.25063 h 10e-4 v 0.25063 l -0.66094,0.71313 -0.66094,0.71314 0.008,-0.50126 0.008,-0.50126 0.3514,-0.46251 z m -94.820571,0.48265 -0.171049,0.27596 -0.170533,0.27647 1.321884,0.56895 1.321883,0.56896 0.302307,0.36432 0.302306,0.36483 0.204639,-0.1266 0.204639,-0.12609 0.29559,0.35656 0.29559,0.35605 2.115632,0.0512 2.115632,0.0512 0.172083,-0.44855 0.172082,-0.44855 -0.428913,-0.31419 -0.429432,-0.31419 -0.806151,0.11833 -0.806154,0.11834 -0.144693,0.2341 -0.144176,0.23409 h -0.392743 -0.392223 l 0.07751,-0.45527 0.07803,-0.45527 -0.925008,-0.30747 -0.925009,-0.30748 -1.057299,-0.14469 -1.0573,-0.14469 -0.564824,-0.17312 z m 67.733851,0 -0.17105,0.27596 -0.17053,0.27647 1.32188,0.56895 1.32189,0.56896 0.3023,0.36432 0.30231,0.36483 0.20464,-0.1266 0.20464,-0.12609 0.29559,0.35656 0.29559,0.35605 2.11563,0.0512 2.11563,0.0512 0.17209,-0.44855 0.17208,-0.44855 -0.42892,-0.31419 -0.42943,-0.31419 -0.80615,0.11833 -0.80615,0.11834 -0.1447,0.2341 -0.14417,0.23409 h -0.39275 -0.39222 l 0.0775,-0.45527 0.078,-0.45527 -0.92501,-0.30747 -0.925,-0.30748 -1.05731,-0.14469 -1.05729,-0.14469 -0.56483,-0.17312 z m -12.1667,1.36736 -0.39946,5.3e-4 -1.25212,0.54312 -1.25263,0.54312 -1.36374,0.66611 -1.363233,0.66663 -0.3545,0.0656 -0.35398,0.0656 -1.048,0.45372 -1.047999,0.4532 -0.198438,0.32039 -0.198953,0.3204 -0.97255,-1.00046 -0.97255,-1.00097 -0.291457,0.0961 -0.291455,0.0961 -0.221176,2.05982 -0.220657,2.05982 0.224277,1.2237 0.223758,1.2237 0.520898,5.3e-4 0.520899,5.3e-4 0.159163,0.9772 0.158646,0.9772 0.374137,0.46095 0.374139,0.46096 -0.345715,-0.20774 -0.345715,-0.20826 -1.041797,0.72192 -1.041797,0.72244 v 0.21032 0.21033 l 0.858862,0.60564 0.85938,0.60565 0.502293,0.46095 0.502295,0.46044 0.194821,-0.1204 0.194302,-0.11989 -0.03617,0.35811 -0.03669,0.35812 1.786969,1.88619 1.78697,1.88619 h 0.25425 0.25477 l 0.40566,-0.78548 0.406173,-0.78497 0.50643,-0.2713 0.50643,-0.2713 0.0853,0.35709 0.0853,0.35708 1.66708,1.38286 1.66708,1.38286 0.26407,-0.10128 v -1.16634 l -1.19579,-1.62522 -1.21181,-1.64642 -0.46302,-0.0295 -0.46302,-0.0295 -0.66095,0.0563 -0.66042,0.0563 -0.408763,0.21808 -0.40876,0.21807 -0.91261,-0.43305 -0.9126,-0.43304 -1.252641,-0.8692 -1.252636,-0.86972 h -0.267168 -0.26665 v -0.28525 -0.28577 l 0.72657,0.14779 0.726572,0.1478 0.66094,0.12661 0.660423,0.12609 0.5917,0.17363 0.59118,0.17363 0.16898,-0.44028 0.16846,-0.43977 -0.62787,-0.67334 -0.62786,-0.67283 -1.811264,0.17622 -1.810742,0.17673 0.162266,-0.26303 0.162264,-0.26252 0.85576,-0.18293 0.855763,-0.18345 0.318844,-0.25632 0.318326,-0.25631 -0.233061,-0.44029 -0.233061,-0.43976 -0.161748,-0.39688 -0.162263,-0.39636 -0.324012,-0.52865 -0.324011,-0.52865 -0.743622,-1.10277 -0.744141,-1.10226 0.08733,-0.61598 0.08733,-0.61599 0.796335,-0.078 0.795816,-0.0786 0.563274,0.52503 0.563272,0.52504 0.09405,-0.0915 0.09404,-0.091 0.016,1.53944 0.016,1.53996 0.33383,0.40204 0.33384,0.40256 0.44286,-0.16433 0.44339,-0.16485 0.78548,-0.54674 0.785998,-0.54673 0.36483,-0.339 0.36535,-0.339 1.0294,-0.52555 1.02942,-0.52558 v -0.27854 -0.27905 l -2.38952,0.18707 -2.390028,0.18706 -0.37673,-0.49764 -0.37672,-0.49764 -0.008,-0.29508 -0.008,-0.29455 2.31252,-1.40715 2.312518,-1.40663 0.66043,-0.40308 0.66094,-0.40307 -0.48369,0.56275 -0.48369,0.56224 0.28577,0.5333 0.28525,0.5333 v 0.31109 0.3111 l -0.5271,-0.62425 -0.52658,-0.62374 -0.79065,0.85886 -0.79117,0.85938 h -0.367928 -0.36742 l -0.33436,0.40308 -0.33435,0.40307 0.10387,0.0791 0.10335,0.0796 1.982308,-0.16691 1.98231,-0.1664 0.19379,0.27905 0.1943,0.27906 0.004,0.52865 0.004,0.52916 -0.91054,0.72709 -0.91106,0.72657 h -0.15864 -0.15917 l -1.473288,0.9431 -1.4733,0.94309 0.72554,0.75758 0.72554,0.75757 0.0315,1.14154 0.032,1.14153 -0.21962,1.12345 -0.21911,1.12344 h 0.39687 0.396878 l 0.69246,-1.2392 0.69246,-1.2392 -0.15502,-0.40515 -0.15555,-0.40462 0.19069,0.19068 0.19068,0.19069 0.50075,-0.4532 0.50022,-0.45269 -0.18706,1.41232 -0.18759,1.41283 0.49506,-0.27698 0.49506,-0.2775 0.28319,0.83715 0.2837,0.83716 0.30748,-0.063 0.30799,-0.0631 -0.14728,0.38447 -0.14728,0.38396 0.4992,0.73639 0.37258,0.54984 v -4.6483 l -0.37052,-0.14211 -0.35553,0.48627 -0.35553,0.4868 -0.18242,-0.18242 -0.18191,-0.18242 0.56586,-0.76584 0.56586,-0.76533 -0.35347,-0.29404 -0.35346,-0.29352 -1.86966,-0.061 -1.86965,-0.061 0.14211,-0.66094 0.14211,-0.66094 1.09347,-0.98392 1.09348,-0.98341 0.73329,0.7028 0.73328,0.7028 v 0.21498 0.21445 l -0.72708,0.004 -0.72658,0.004 -0.36586,0.23203 -0.36639,0.23151 0.50333,0.26975 0.50385,0.26975 2.00142,0.41341 v -2.76468 l -0.1018,-0.0191 -0.93431,-0.50126 -0.93431,-0.50075 0.43098,-0.16536 0.43047,-0.16537 1.002,0.32298 0.10697,0.0346 v -2.26492 l -0.22619,-0.25063 -0.67851,-0.75189 0.3054,-1.65778 0.30541,-1.6583 v -0.6966 -0.69608 z m 67.73386,0 -0.39946,5.3e-4 -1.25212,0.54312 -1.25264,0.54312 -1.36374,0.66611 -1.36323,0.66663 -0.3545,0.0656 -0.35398,0.0656 -1.048,0.45372 -1.04799,0.4532 -0.19844,0.32039 -0.19896,0.3204 -0.97255,-1.00046 -0.97255,-1.00097 -0.29145,0.0961 -0.29146,0.0961 -0.22117,2.05982 -0.22066,2.05982 0.22427,1.2237 0.22376,1.2237 0.5209,5.3e-4 0.5209,5.3e-4 0.15916,0.9772 0.15865,0.9772 0.37414,0.46095 0.37413,0.46096 -0.34571,-0.20774 -0.34572,-0.20826 -1.04179,0.72192 -1.0418,0.72244 v 0.21032 0.21033 l 0.85886,0.60564 0.85938,0.60565 0.5023,0.46095 0.50229,0.46044 0.19482,-0.1204 0.19431,-0.11989 -0.0362,0.35811 -0.0372,0.35812 1.78698,1.88619 1.78748,1.88619 h 0.25373 0.25529 l 0.40566,-0.78548 0.40617,-0.78497 0.50592,-0.2713 0.50642,-0.2713 0.0858,0.35709 0.0853,0.35708 1.66708,1.38286 1.66709,1.38286 0.26406,-0.10128 v -1.16634 l -1.19579,-1.62522 -1.21181,-1.64642 -0.46302,-0.0295 -0.46302,-0.0295 -0.66094,0.0563 -0.66043,0.0563 -0.40876,0.21808 -0.40876,0.21807 -0.91261,-0.43305 -0.9126,-0.43304 -1.25264,-0.8692 -1.25264,-0.86972 h -0.26716 -0.26665 v -0.28525 -0.28577 l 0.72657,0.14779 0.72657,0.1478 0.66094,0.12661 0.66042,0.12609 0.5917,0.17363 0.59118,0.17363 0.16898,-0.44028 0.16846,-0.43977 -0.62786,-0.67334 -0.62787,-0.67283 -1.81126,0.17622 -1.81074,0.17673 0.16226,-0.26303 0.16226,-0.26252 0.85577,-0.18293 0.85576,-0.18345 0.31884,-0.25632 0.31833,-0.25631 -0.23306,-0.44029 -0.23306,-0.43976 -0.16175,-0.39688 -0.16227,-0.39636 -0.324,-0.52865 -0.32402,-0.52865 -0.74362,-1.10277 -0.74414,-1.10226 0.0873,-0.61598 0.0873,-0.61599 0.79633,-0.078 0.79581,-0.0786 0.56328,0.52503 0.56275,0.52504 0.0946,-0.0915 0.094,-0.091 0.016,1.53944 0.016,1.53996 0.33383,0.40204 0.33383,0.40256 0.44287,-0.16433 0.44338,-0.16485 0.78548,-0.54674 0.786,-0.54673 0.36484,-0.339 0.36535,-0.339 1.02939,-0.52555 1.0294,-0.52555 v -0.27853 -0.27906 l -2.38952,0.18707 -2.39004,0.18707 -0.37672,-0.49764 -0.37672,-0.49765 -0.008,-0.29507 -0.008,-0.29455 2.31252,-1.40715 2.31252,-1.40664 0.66043,-0.40307 0.66094,-0.40308 -0.48369,0.56276 -0.48369,0.56224 0.28577,0.5333 0.28525,0.5333 v 0.31109 0.31109 l -0.5271,-0.62425 -0.52658,-0.62373 -0.79065,0.85886 -0.79117,0.85938 h -0.36793 -0.36742 l -0.33435,0.40307 -0.33435,0.40308 0.10387,0.0791 0.10336,0.0796 1.9823,-0.16691 1.98231,-0.1664 0.19379,0.27905 0.1943,0.27905 0.004,0.52865 0.004,0.52917 -0.91054,0.72709 -0.91106,0.72657 h -0.15864 -0.15917 l -1.47329,0.94309 -1.4733,0.9431 0.72554,0.75758 0.72554,0.75757 0.0315,1.14153 0.032,1.14153 -0.21963,1.12345 -0.2191,1.12345 h 0.39687 0.39688 l 0.69246,-1.2392 0.69247,-1.23921 -0.15503,-0.40514 -0.15555,-0.40462 0.19069,0.19068 0.19068,0.19069 0.50075,-0.45321 0.50022,-0.45268 -0.18706,1.41232 -0.18759,1.41283 0.49506,-0.27699 0.49506,-0.2775 0.28319,0.83716 0.2837,0.83716 0.30748,-0.063 0.30799,-0.063 -0.14728,0.38447 -0.14728,0.38396 0.4992,0.73639 0.37259,0.54983 v -4.64829 l -0.37053,-0.14211 -0.35553,0.48627 -0.35554,0.4868 -0.18241,-0.18242 -0.1819,-0.18242 0.56585,-0.76585 0.56586,-0.76532 -0.35347,-0.29404 -0.35346,-0.29352 -1.86966,-0.061 -1.86965,-0.061 0.14211,-0.66094 0.14211,-0.66095 1.09347,-0.98392 1.09348,-0.9834 0.73329,0.7028 0.73328,0.7028 v 0.21497 0.21446 l -0.72708,0.004 -0.72657,0.004 -0.36587,0.23203 -0.36639,0.23151 0.50333,0.26975 0.50384,0.26975 2.00144,0.41341 v -2.76463 l -0.10181,-0.0191 -0.93431,-0.50126 -0.93431,-0.50075 0.43098,-0.16536 0.43047,-0.16537 1.002,0.32298 0.10698,0.0346 v -2.26498 l -0.22635,-0.25063 -0.67851,-0.75189 0.30541,-1.65778 0.30541,-1.6583 v -0.69659 -0.69609 z m -109.127715,0.26355 -0.761196,5.3e-4 -0.761709,0.001 -0.672827,0.30696 -0.673344,0.30644 v 0.33848 0.33848 l 0.269232,0.1664 0.269235,0.1664 0.985986,-0.59635 0.986504,-0.59634 -0.48369,0.55603 -0.483693,0.55553 0.285255,0.5333 0.285253,0.53381 v 0.3111 0.31057 l -0.526582,-0.62373 -0.526584,-0.62426 -0.791165,0.85938 -0.790649,0.85887 h -0.367938 -0.367935 l -0.337965,0.40772 -0.338479,0.40773 0.305925,0.30644 0.305924,0.30593 v -0.31734 -0.31729 h 0.75189 0.751893 l 0.434081,0.48007 0.434599,0.48008 0.172083,0.90795 0.1726,0.90796 0.190686,0.26458 0.190685,0.26407 0.159165,0.66921 0.159163,0.66869 -0.517282,0.78548 -0.517281,0.78497 -0.0021,0.85886 -0.0021,0.85938 0.33021,0.004 0.330213,0.004 -0.396359,0.25631 -0.396356,0.2558 0.346231,0.004 0.345715,0.004 -0.138493,0.22428 -0.13901,0.22479 0.610299,0.32659 0.609782,0.32712 0.833541,-0.13178 0.833024,-0.13126 0.131776,0.21343 0.131773,0.21342 -0.416512,0.15968 -0.41651,0.1602 h -0.612916 -0.613399 l -0.268717,0.77049 -0.268202,0.7705 0.154514,0.15451 0.154511,0.15503 h 0.367937 0.367935 l -0.188618,-0.30541 -0.188619,-0.3054 0.334864,0.20722 0.334346,0.20671 0.220658,-0.35657 0.220141,-0.35657 0.123507,0.12454 0.123508,0.12506 -0.20619,1.05678 -0.206706,1.05782 -0.177768,0.66094 -0.177766,0.66094 0.737939,0.30799 0.737423,0.30799 0.876432,0.17984 0.876951,0.17931 0.68988,0.35812 0.68988,0.35812 0.214458,-0.13229 0.214974,-0.13333 -0.662493,-1.30793 -0.662493,-1.30793 -0.259932,-0.0331 -0.259932,-0.0331 -0.330213,-0.0351 -0.330729,-0.0357 -0.627351,0.74053 -0.627351,0.74052 -0.141594,-0.1416 -0.142111,-0.14159 0.420645,-0.46509 0.420648,-0.46508 0.388088,-0.74776 0.387575,-0.74776 -0.359669,-0.6935 -0.359667,-0.6935 0.125056,-0.12505 0.125058,-0.12506 0.771011,0.73897 0.770496,0.73898 0.315743,0.76171 0.315743,0.76222 h 0.19017 0.190169 l 0.321426,1.07177 0.320911,1.07126 1.019577,0.9219 1.020093,0.92139 -0.68213,0.68265 -0.682128,0.68213 -1.409734,-0.33848 -1.409732,-0.33848 v -0.23358 -0.23358 l 0.330213,0.0429 0.330211,0.0429 0.484725,-0.0315 0.484727,-0.0315 -0.105421,-0.31574 -0.10542,-0.31626 -0.775663,-0.22583 -0.775664,-0.22634 -0.725019,-0.0677 -0.725022,-0.0677 -0.144692,0.45527 -0.14418,0.45527 0.157615,0.61753 0.157613,0.61702 1.002006,0.38757 h 4.242117 l 0.804603,-0.87178 v 0.67231 0.19947 h 1.720308 l 0.01757,-0.0553 0.150379,-0.47335 -0.878501,-0.37207 -0.877983,-0.37207 0.43615,-0.17002 0.435633,-0.17053 1.395781,0.41496 1.39578,0.41445 h 0.513146 0.513146 l -0.293005,-0.35295 -0.293004,-0.35295 -1.258838,-0.63252 -1.259355,-0.63201 -0.662491,-0.47128 -0.662493,-0.47078 -0.85731,0.0997 -0.856798,0.0997 v -0.20154 -0.20102 l 0.396359,-0.15244 0.396359,-0.15193 v -0.52142 -0.52193 l 0.264584,-0.1633 0.264064,-0.16329 v -0.38086 -0.38086 H 70.48096 70.084601 v -0.24236 -0.24236 l 0.330213,-0.1111 0.330211,-0.11111 -0.313675,-0.63769 -0.313676,-0.6382 -0.180867,-0.64027 -0.180869,-0.63976 -1.090888,-1.0883 -1.09089,-1.08779 -2.037601,-1.03663 -2.037085,-1.03714 -0.180867,0.18086 -0.180353,0.18087 0.349335,0.42116 0.349331,0.42117 0.461471,-0.12041 0.460954,-0.12092 -0.15658,0.40928 -0.157097,0.40927 0.563791,-0.14779 0.564306,-0.14728 -0.02222,0.17105 -0.02222,0.17105 0.03101,0.36122 0.03152,0.36173 0.462505,-0.12092 0.462505,-0.12144 0.03566,0.58394 0.03617,0.58395 -0.898136,0.27543 -0.898136,0.27595 -0.270269,-0.50487 -0.270267,-0.5054 h -0.346231 -0.346233 l -0.450617,-0.49765 -0.45062,-0.49816 0.18035,-1.35857 0.180351,-1.35857 0.202054,-0.12506 0.202573,-0.12506 0.801502,0.1602 0.8015,0.16072 0.494543,0.43304 0.494028,0.43357 0.647506,0.37155 0.646989,0.37155 0.396359,0.19431 0.396356,0.1943 1.255221,0.59893 1.255739,0.59945 v 0.23823 0.23874 l 0.197918,-0.12247 0.198438,-0.12247 0.05943,0.96583 0.05891,0.96635 0.0088,1.43919 0.0078,1.43867 0.329694,0.20929 0.329179,0.20929 0.859896,0.004 0.859896,0.004 0.990121,0.55345 0.990121,0.55397 -0.792716,-0.15554 -0.792718,-0.15555 -1.26814,-0.17208 -1.268137,-0.17208 0.07855,0.35915 0.07906,0.35915 0.660424,0.3762 0.660942,0.37569 0.792716,0.41806 0.792718,0.41806 0.594794,0.0837 0.594797,0.0837 v -0.27337 -0.27336 h 0.363802 0.364318 l 0.351401,0.42426 0.351917,0.42375 -0.436666,0.76171 -0.437184,0.76119 0.40101,0.40101 0.400492,0.40049 h 0.355534 0.355534 l 0.133323,-0.33021 0.133326,-0.33073 0.02066,0.447 0.02066,0.447 -0.03565,0.0222 h 0.920872 l -0.03824,-0.28628 -0.419095,-0.46354 -0.419613,-0.46302 0.318328,-0.84336 0.317809,-0.84284 h 0.243396 0.243395 l 0.336415,0.46043 0.336413,0.46044 0.961181,0.0372 0.961183,0.0377 0.145728,0.14572 0.145211,0.14521 -0.16795,0.27182 -0.167949,0.27182 -0.673344,-0.2558 -0.673859,-0.25631 -0.239263,0.14831 -0.239778,0.14779 0.04082,1.04387 0.0093,0.24081 h 0.743624 l 1.037664,-0.71779 1.049547,-0.72657 0.01035,-0.28939 0.0098,-0.2899 -0.528648,-0.47852 -0.528135,-0.47801 v -0.26855 -0.26872 l -0.370589,-0.41754 -0.370002,-0.41754 -0.269234,-0.99116 -0.269235,-0.99167 h 0.227893 0.22841 l 0.468188,0.79323 0.468188,0.79324 h 0.201023 0.200504 l 0.525549,1.15393 0.525548,1.15393 0.575677,-0.0305 0.575675,-0.0305 0.292489,-0.4687 0.293005,-0.46871 -1.368393,-1.24953 -1.368907,-1.24954 -0.283188,-0.57774 -0.282671,-0.57723 v -0.41393 -0.41393 h 0.264068 0.264067 v 0.38086 0.38086 l 0.305406,0.18861 0.304893,0.18862 -0.213424,-0.34623 -0.213942,-0.34571 0.309541,0.1912 0.309026,0.1912 -0.135909,0.22014 -0.05529,0.0894 -0.08062,0.13074 1.47433,1.34773 1.474327,1.34772 h 0.430464 0.430466 l 2.455664,-0.6966 2.455146,-0.69712 v -0.37827 -0.37827 l -0.528649,0.16743 -0.52865,0.16795 v -0.39481 -0.39532 l -1.493965,-0.68368 -1.493451,-0.6842 -0.134874,0.13488 -0.134877,0.13487 0.290939,0.63924 0.291457,0.63872 0.544669,0.17312 0.544668,0.17311 v 0.18035 l -5.29e-4,0.18036 -1.867585,-0.0274 -1.867588,-0.0269 -0.429948,-0.43047 -0.429948,-0.42995 0.574125,0.11059 0.574643,0.11059 0.128675,-0.20826 0.128675,-0.20825 -1.181325,-1.42782 -1.180807,-1.42782 -0.423746,-0.44545 -0.423746,-0.44546 -0.649573,0.24702 -0.650089,0.24701 h -0.379307 -0.378788 v -0.25735 -0.25786 l 0.779283,-0.40308 0.779795,-0.40359 h 0.252183 0.251663 l 2.040187,2.51199 2.039667,2.51147 h 0.232027 0.232029 v -0.27169 -0.2713 l -1.181325,-2.204 -1.181323,-2.204 0.143661,-0.14366 0.143661,-0.14366 -0.422714,-0.81752 -0.422714,-0.81804 -0.455785,-0.031 -0.455787,-0.0305 -0.448035,0.0455 -0.448551,0.0444 -0.49971,-0.47697 -0.499711,-0.47646 -0.463539,-0.26665 -0.463021,-0.26665 0.180351,-0.96273 0.180869,-0.96273 0.725535,-0.10697 0.725538,-0.10646 0.889868,1.40612 0.889867,1.40611 0.259935,-0.0868 0.259932,-0.0863 0.305406,-1.3565 0.304892,-1.35651 -0.18035,-0.29197 -0.179835,-0.29197 -0.334864,0.40359 -0.334862,0.4036 -0.4346,-0.23462 -0.435115,-0.23461 -1.526005,-1.33842 -1.526006,-1.33842 -1.050581,0.54777 -1.050581,0.54777 v 0.24443 0.24392 l 0.72657,0.30075 0.727088,0.30024 0.181901,-0.0372 0.181901,-0.0372 0.172598,0.54312 0.172601,0.54312 -0.108521,0.10852 -0.108003,0.10801 -0.988571,-0.50385 -0.988571,-0.50436 -1.041796,-0.1757 -1.041281,-0.17622 v -0.24133 -0.24081 h 0.894003 0.894003 l 0.159679,-0.59479 0.159163,-0.5948 0.0041,-1.00924 0.0036,-1.00873 -0.273368,-0.51108 -0.273367,-0.51159 h -0.279054 -0.278537 l -0.496094,0.5948 -0.496093,0.59479 v 0.39687 l -5.3e-4,0.39636 0.357085,-0.47025 0.356568,-0.47077 0.145209,0.37878 0.145211,0.37879 -0.357084,0.48834 -0.356566,0.48783 -1.145151,-0.80719 -1.145667,-0.8077 -0.593762,0.71727 -0.593762,0.71727 v 0.42116 0.42065 h 1.041281 1.041797 l 0.163298,0.26458 0.163295,0.26407 h -1.053682 -1.054198 l -0.349334,0.33073 -0.348816,0.33021 -0.396357,-0.007 -0.396875,-0.007 -0.30644,-0.19223 -0.306443,-0.19224 -0.420129,0.16175 -0.42013,0.16123 v -0.29301 -0.29249 h -0.301789 -0.301791 l -0.750343,0.78548 -0.749824,0.78497 0.151411,0.39429 0.150897,0.39481 0.537435,0.17053 0.536916,0.17053 0.227378,-0.35915 0.227375,-0.35863 0.0031,-0.447 0.0041,-0.44701 0.264065,-0.16329 0.264583,-0.16382 -0.01913,0.47853 -0.01963,0.478 -0.44855,0.7643 -0.448551,0.76429 -2.569872,0.0351 -2.570384,0.0346 0.122473,-0.40256 0.122473,-0.40307 -0.850077,-0.9431 -0.850593,-0.94309 -0.528651,-0.30437 -0.528651,-0.3049 0.56224,-0.008 0.562239,-0.008 0.339516,0.40928 0.339514,0.40876 1.409215,0.66714 1.409735,0.66714 0.595828,-0.0915 0.595829,-0.0915 -1.963704,-1.27795 -1.963705,-1.27796 -0.367419,-0.36742 -0.367419,-0.36794 h 0.56224 0.562755 l 1.107943,0.61805 1.107942,0.61754 0.396875,-0.12196 0.396359,-0.12196 0.71727,-0.66817 0.717267,-0.6687 -0.138491,-0.22376 -0.137978,-0.22427 H 66.402064 64.59959 l -0.332795,-0.80357 -0.332796,-0.80409 -0.511079,-0.65009 z m 67.734885,0 -0.76171,5.3e-4 -0.76223,0.001 -0.67283,0.30696 -0.67334,0.30644 v 0.33848 0.33848 l 0.26924,0.1664 0.26923,0.1664 0.98599,-0.59635 0.9865,-0.59634 -0.48369,0.55603 -0.4837,0.55553 0.28526,0.5333 0.28525,0.53381 v 0.3111 0.31057 l -0.52658,-0.62373 -0.52658,-0.62426 -0.79117,0.85938 -0.79065,0.85887 h -0.36794 -0.36793 l -0.33796,0.40772 -0.33848,0.40773 0.30592,0.30644 0.30592,0.30593 v -0.31734 -0.31729 h 0.7519 0.75189 l 0.43408,0.48007 0.4346,0.48008 0.17208,0.90795 0.1726,0.90796 0.19069,0.26458 0.19068,0.26407 0.15917,0.66921 0.15916,0.66869 -0.51728,0.78548 -0.51728,0.78497 -0.002,0.85886 -0.002,0.85938 0.33021,0.004 0.33021,0.004 -0.39636,0.25631 -0.39636,0.2558 0.34624,0.004 0.34571,0.004 -0.13849,0.22428 -0.13901,0.22479 0.6103,0.32659 0.60978,0.32712 0.83354,-0.13178 0.83303,-0.13126 0.13177,0.21343 0.13178,0.21342 -0.41652,0.15968 -0.41651,0.1602 h -0.61288 -0.6134 l -0.26872,0.77049 -0.2682,0.7705 0.15451,0.15451 0.15452,0.15503 h 0.36793 0.36794 l -0.18862,-0.30541 -0.18862,-0.3054 0.33486,0.20722 0.33435,0.20671 0.22066,-0.35657 0.22014,-0.35657 0.12351,0.12454 0.1235,0.12506 -0.20618,1.05678 -0.20671,1.05782 -0.17777,0.66094 -0.17776,0.66094 0.73794,0.30799 0.73742,0.30799 0.87643,0.17984 0.87695,0.17931 0.68988,0.35812 0.68988,0.35812 0.21446,-0.13229 0.21497,-0.13333 -0.66249,-1.30793 -0.66249,-1.30793 -0.25993,-0.0331 -0.25994,-0.0331 -0.33021,-0.0351 -0.33073,-0.0357 -0.62735,0.74053 -0.62735,0.74052 -0.1416,-0.1416 -0.14211,-0.14159 0.42065,-0.46509 0.42065,-0.46508 0.38809,-0.74776 0.38757,-0.74776 -0.35967,-0.6935 -0.35967,-0.6935 0.12506,-0.12505 0.12506,-0.12506 0.77101,0.73897 0.7705,0.73898 0.31574,0.76171 0.31574,0.76222 h 0.19017 0.19017 l 0.32143,1.07177 0.32091,1.07126 1.01957,0.9219 1.0201,0.92139 -0.68213,0.68265 -0.68213,0.68213 -1.40973,-0.33848 -1.40974,-0.33848 v -0.23358 -0.23358 l 0.33021,0.0429 0.33022,0.0429 0.48472,-0.0315 0.48473,-0.0315 -0.10542,-0.31574 -0.10542,-0.31626 -0.77566,-0.22583 -0.77567,-0.22634 -0.72502,-0.0677 -0.72502,-0.0677 -0.14469,0.45527 -0.14418,0.45527 0.15761,0.61753 0.15762,0.61702 1.002,0.38757 h 4.24212 l 0.8046,-0.87178 v 0.67231 0.19947 h 1.72031 l 0.0176,-0.0553 0.15038,-0.47335 -0.8785,-0.37207 -0.87798,-0.37207 0.43615,-0.17002 0.43563,-0.17053 1.39578,0.41496 1.39578,0.41445 h 0.51315 0.51314 l -0.293,-0.35295 -0.29301,-0.35295 -1.25884,-0.63252 -1.25935,-0.63201 -0.66249,-0.47128 -0.66249,-0.47078 -0.85732,0.0997 -0.85679,0.0997 v -0.20154 -0.20102 l 0.39636,-0.15244 0.39635,-0.15193 v -0.52142 -0.52193 l 0.26459,-0.1633 0.26406,-0.16329 v -0.38086 -0.38086 h -0.39636 -0.39635 v -0.24236 -0.24236 l 0.33021,-0.1111 0.33021,-0.11111 -0.31367,-0.63769 -0.31368,-0.6382 -0.18087,-0.64027 -0.18086,-0.63976 -1.09089,-1.0883 -1.09089,-1.08779 -2.03761,-1.03663 -2.03708,-1.03714 -0.18087,0.18086 -0.18035,0.18087 0.34933,0.42116 0.34934,0.42117 0.46147,-0.12041 0.46095,-0.12092 -0.15658,0.40928 -0.15709,0.40927 0.56379,-0.14779 0.5643,-0.14728 -0.0222,0.17105 -0.0222,0.17105 0.031,0.36122 0.0315,0.36173 0.46251,-0.12092 0.4625,-0.12144 0.0357,0.58394 0.0362,0.58395 -0.89814,0.27543 -0.89814,0.27595 -0.27026,-0.50487 -0.27027,-0.5054 h -0.34623 -0.34623 l -0.45062,-0.49765 -0.45062,-0.49816 0.18035,-1.35857 0.18035,-1.35857 0.20206,-0.12506 0.20257,-0.12506 0.8015,0.1602 0.8015,0.16072 0.49454,0.43304 0.49403,0.43357 0.64751,0.37155 0.64699,0.37155 0.39635,0.19431 0.39636,0.1943 1.25522,0.59893 1.25574,0.59945 v 0.23823 0.23874 l 0.19792,-0.12247 0.19844,-0.12247 0.0594,0.96583 0.0589,0.96635 0.008,1.43919 0.008,1.43867 0.32969,0.20929 0.32918,0.20929 0.8599,0.004 0.85989,0.004 0.99012,0.55345 0.99012,0.55397 -0.79271,-0.15554 -0.79272,-0.15555 -1.26814,-0.17208 -1.26814,-0.17208 0.0785,0.35915 0.0791,0.35915 0.66043,0.3762 0.66094,0.37569 0.79272,0.41806 0.79271,0.41806 0.5948,0.0837 0.59479,0.0837 v -0.27337 -0.27336 h 0.36381 0.36432 l 0.3514,0.42426 0.35191,0.42375 -0.43666,0.76171 -0.43719,0.76119 0.40101,0.40101 0.40049,0.40049 h 0.35554 0.35553 l 0.13333,-0.33021 0.13332,-0.33073 0.0207,0.447 0.0207,0.447 -0.0357,0.0222 h 0.92088 l -0.0382,-0.28628 -0.4191,-0.46354 -0.41961,-0.46302 0.31833,-0.84336 0.31781,-0.84284 h 0.24339 0.2434 l 0.33641,0.46043 0.33641,0.46044 0.96119,0.0372 0.96118,0.0377 0.14573,0.14572 0.14521,0.14521 -0.16795,0.27182 -0.16795,0.27182 -0.67334,-0.2558 -0.67386,-0.25631 -0.23927,0.14831 -0.23978,0.14779 0.0408,1.04387 0.009,0.24081 h 0.74363 l 1.03766,-0.71779 1.04955,-0.72657 0.0103,-0.28939 0.0104,-0.2899 -0.52865,-0.47852 -0.52813,-0.47801 v -0.26872 -0.26872 l -0.37052,-0.41754 -0.37001,-0.41755 -0.26923,-0.99115 -0.26924,-0.99167 h 0.2279 0.22841 l 0.46818,0.79323 0.46819,0.79324 h 0.20103 0.2005 l 0.52555,1.15393 0.52555,1.15393 0.57567,-0.0305 0.57568,-0.0305 0.29249,-0.4687 0.293,-0.46871 -1.36839,-1.24954 -1.36891,-1.24953 -0.28318,-0.57774 -0.28267,-0.57723 v -0.41393 -0.41393 h 0.26406 0.26407 v 0.38086 0.38085 l 0.30541,0.18862 0.30489,0.18862 -0.21343,-0.34623 -0.21394,-0.34571 0.30955,0.1912 0.30902,0.1912 -0.13591,0.22014 -0.0553,0.0894 -0.0806,0.13074 1.47433,1.34772 1.47433,1.34773 h 0.43046 0.43047 l 2.45566,-0.6966 2.45515,-0.69712 v -0.37815 -0.37827 l -0.52865,0.16743 -0.52865,0.16795 v -0.39481 -0.39532 l -1.49397,-0.68368 -1.49344,-0.6842 -0.13488,0.13488 -0.13487,0.13487 0.29093,0.63924 0.29146,0.63872 0.54467,0.17312 0.54467,0.17311 v 0.18035 l -5.3e-4,0.18035 -1.86759,-0.0274 -1.86758,-0.0269 -0.42995,-0.43046 -0.42995,-0.42995 0.57413,0.11059 0.57464,0.11059 0.12867,-0.20826 0.12868,-0.20825 -1.18132,-1.42783 -1.18081,-1.42781 -0.42375,-0.44545 -0.42375,-0.44546 -0.64957,0.24702 -0.65009,0.24701 h -0.3793 -0.37879 v -0.25735 -0.25786 l 0.77928,-0.40308 0.7798,-0.40359 h 0.25218 0.25166 l 2.04019,2.51199 2.03967,2.51147 h 0.23202 0.23203 v -0.27164 -0.2713 l -1.18132,-2.204 -1.18133,-2.204 0.14366,-0.14366 0.14367,-0.14366 -0.42272,-0.81752 -0.42271,-0.81804 -0.45579,-0.031 -0.45578,-0.0305 -0.44804,0.0455 -0.44855,0.0444 -0.49971,-0.47697 -0.49971,-0.47646 -0.46354,-0.26665 -0.46302,-0.26665 0.18035,-0.96273 0.18087,-0.96273 0.72554,-0.10697 0.72553,-0.10646 0.88987,1.40612 0.88987,1.40611 0.25993,-0.0868 0.25993,-0.0863 0.30541,-1.3565 0.30489,-1.35651 -0.18035,-0.29197 -0.17983,-0.29197 -0.33487,0.40359 -0.33486,0.4036 -0.4346,-0.23462 -0.43511,-0.23461 -1.52601,-1.33842 -1.526,-1.33842 -1.05059,0.54777 -1.05058,0.54777 v 0.24443 0.24392 l 0.72657,0.30075 0.72709,0.30024 0.1819,-0.0372 0.1819,-0.0372 0.1726,0.54312 0.1726,0.54312 -0.10852,0.10852 -0.108,0.10801 -0.98857,-0.50385 -0.98857,-0.50436 -1.0418,-0.1757 -1.04128,-0.17622 v -0.24133 -0.24081 h 0.894 0.894 l 0.15969,-0.59479 0.15916,-0.5948 0.004,-1.00924 0.004,-1.00873 -0.27337,-0.51108 -0.27336,-0.51159 h -0.27906 -0.27853 l -0.4961,0.5948 -0.49609,0.59479 v 0.39687 l -5.3e-4,0.39636 0.35708,-0.47025 0.35657,-0.47077 0.14521,0.37878 0.14522,0.37879 -0.35709,0.48834 -0.35657,0.48783 -1.14515,-0.80719 -1.14566,-0.8077 -0.59376,0.71727 -0.59377,0.71727 v 0.42116 0.42065 h 1.04128 1.0418 l 0.1633,0.26458 0.1633,0.26407 h -1.05369 -1.0542 l -0.34933,0.33073 -0.34882,0.33021 -0.39635,-0.007 -0.39688,-0.007 -0.30644,-0.19223 -0.30644,-0.19224 -0.42013,0.16175 -0.42013,0.16123 v -0.29301 -0.29249 h -0.30179 -0.30179 l -0.75034,0.78548 -0.74983,0.78497 0.15141,0.39429 0.1509,0.39481 0.53743,0.17053 0.53692,0.17053 0.22738,-0.35915 0.22738,-0.35863 0.004,-0.447 0.004,-0.44701 0.26407,-0.16329 0.26458,-0.16382 -0.0191,0.47853 -0.0196,0.478 -0.44855,0.7643 -0.44856,0.76429 -2.56987,0.0351 -2.57038,0.0346 0.12247,-0.40256 0.12247,-0.40307 -0.85007,-0.9431 -0.8506,-0.94309 -0.52865,-0.30437 -0.52865,-0.3049 0.56224,-0.008 0.56224,-0.008 0.33952,0.40928 0.33951,0.40876 1.40922,0.66714 1.40973,0.66714 0.59583,-0.0915 0.59583,-0.0915 -1.9637,-1.27795 -1.96371,-1.27796 -0.36742,-0.36742 -0.36742,-0.36794 h 0.56224 0.56276 l 1.10794,0.61805 1.10794,0.61754 0.39688,-0.12196 0.39636,-0.12196 0.71727,-0.66817 0.71726,-0.6687 -0.13849,-0.22376 -0.13798,-0.22427 h -1.80247 -1.80247 l -0.3328,-0.80357 -0.33279,-0.80409 -0.51108,-0.65009 z m -59.768964,0.26562 h 0.132292 0.132291 v 0.13229 0.13229 h -0.132291 -0.132292 v -0.13229 z m 67.733854,0 h 0.13229 0.13229 v 0.13229 0.13229 h -0.13229 -0.13229 v -0.13229 z m -43.948744,0.52865 h 0.132292 0.131776 v 0.13229 0.13229 h -0.131776 -0.132292 v -0.13229 z m 67.733854,0 h 0.1323 0.13177 v 0.13229 0.13229 h -0.13177 -0.1323 v -0.13229 z m -109.752994,0.68678 -0.235643,0.25115 -0.235646,0.25166 -0.183968,2.04897 -0.183451,2.04897 0.352949,0.004 0.352435,0.004 -0.396359,0.25632 -0.396359,0.25631 0.321945,0.004 0.322461,0.004 -0.168981,0.43977 -0.168982,0.44028 0.375688,-0.22634 0.375171,-0.22634 -0.33383,0.41186 -0.333314,0.41238 0.405661,0.33692 0.406175,0.33745 0.182936,-0.18293 0.182933,-0.18294 0.293523,1.00459 0.29404,1.00408 0.329179,-0.0729 0.329694,-0.0729 -0.170016,0.27543 -0.170016,0.27544 -0.207737,-0.12868 -0.207741,-0.12815 -0.61288,0.65267 -0.612884,0.65267 h -0.334862 -0.334864 l -0.164331,0.26614 -0.164332,0.26613 1.404048,1.31 1.404049,1.31051 0.374655,0.0103 0.374137,0.0103 -0.135909,0.13591 -0.135908,0.13591 0.818554,0.9524 0.819071,0.95239 0.836642,0.89452 0.836641,0.89452 h 0.226343 0.226343 l 0.487307,-0.90537 0.48731,-0.90537 0.431498,0.15244 0.432015,0.15245 0.483174,0.416 0.483693,0.41651 -0.159163,1.0635 -0.158647,1.06402 0.530198,1.03921 0.530202,1.03973 -0.09767,0.0977 -0.09818,0.0982 -0.558623,-0.71055 -0.558622,-0.71055 v -0.32505 -0.32556 l -0.54777,-0.6966 -0.547769,-0.69659 h -0.21911 -0.219625 l -0.275953,0.79323 -0.276468,0.79323 h 0.136943 0.137459 l -0.361217,0.36174 -0.361736,0.36121 -0.355534,1.07746 -0.355018,1.07745 0.0098,0.0212 h 5.881295 l 0.077,-0.57464 0.139528,-1.04386 0.419094,-0.4625 0.418579,-0.46303 v -0.31006 -0.30954 h -0.601514 -0.60203 l -0.424781,-0.49609 -0.424778,-0.49609 0.120404,-0.63097 0.120407,-0.63097 -1.242817,-1.26091 -1.242819,-1.26142 -0.888834,0.29301 -0.88832,0.29352 -1.526003,-0.92708 -1.526005,-0.92707 -0.655775,-0.58343 -0.655773,-0.58291 1.189075,0.1943 1.189074,0.19431 0.832507,0.12402 0.83199,0.12454 0.201022,-0.32556 0.20102,-0.32556 -0.843875,-0.75396 -0.84336,-0.75396 -1.643311,0.13798 -1.642792,0.13849 0.513146,-0.39894 0.51263,-0.39843 h 0.486275 0.486794 l 0.151929,-0.39636 0.151929,-0.39687 -0.163817,-0.33021 -0.163814,-0.33073 -0.8015,-1.32189 -0.801502,-1.32188 -0.400492,-0.88987 -0.40101,-0.88987 0.126092,-0.32917 0.126606,-0.32918 0.586528,-0.15348 0.586529,-0.15348 0.757057,0.75758 0.75706,0.75705 0.02635,0.88006 0.02635,0.87953 0.178285,0.63665 0.177765,0.63665 0.471289,0.0692 0.471289,0.0687 0.877467,-0.77049 0.877467,-0.7705 0.705898,-0.36639 0.7059,-0.36638 -0.427879,-0.4284 -0.427881,-0.42788 h -1.272276 -1.271757 l -0.422711,-0.64492 -0.422714,-0.64544 0.692464,-0.54415 0.691947,-0.54467 0.294555,-0.0315 0.294558,-0.031 0.173114,0.0227 0.172601,0.0227 0.2682,-0.32246 0.267685,-0.32298 -0.361736,-0.49454 -0.361736,-0.49507 -1.730642,0.46871 -1.730645,0.46871 v 0.35708 0.3576 h -0.187052 -0.187069 l -1.002006,-0.97875 z m 67.733854,0 -0.23565,0.25115 -0.23564,0.25166 -0.18397,2.04897 -0.18345,2.04897 0.35295,0.004 0.35243,0.004 -0.39636,0.25632 -0.39635,0.25631 0.32194,0.004 0.32246,0.004 -0.16898,0.43977 -0.16898,0.44028 0.37569,-0.22634 0.37517,-0.22634 -0.33383,0.41186 -0.33332,0.41238 0.40566,0.33692 0.40618,0.33745 0.18294,-0.18293 0.18293,-0.18294 0.29352,1.00459 0.29404,1.00408 0.32918,-0.0729 0.32969,-0.0729 -0.17001,0.27543 -0.17001,0.27544 -0.20774,-0.12868 -0.20774,-0.12815 -0.61289,0.65267 -0.61288,0.65267 h -0.33486 -0.33487 l -0.16433,0.26614 -0.16433,0.26613 1.40405,1.31 1.40405,1.31051 0.37465,0.0103 0.37414,0.0103 -0.13591,0.13591 -0.13591,0.13591 0.81856,0.9524 0.81907,0.95239 0.83664,0.89452 0.83664,0.89452 h 0.22634 0.22635 l 0.48731,-0.90537 0.4873,-0.90537 0.4315,0.15244 0.43202,0.15245 0.48317,0.416 0.48369,0.41651 -0.15916,1.0635 -0.15865,1.06402 0.53021,1.03921 0.53019,1.03973 -0.0977,0.0977 -0.0987,0.0982 -0.55862,-0.71055 -0.55862,-0.71055 v -0.32505 -0.32556 l -0.54777,-0.6966 -0.54777,-0.69659 h -0.21859 -0.21963 l -0.27595,0.79323 -0.27647,0.79323 h 0.13694 0.13746 l -0.36121,0.36174 -0.36174,0.36121 -0.35553,1.07746 -0.35502,1.07745 0.0103,0.0212 h 5.88129 l 0.077,-0.57464 0.13953,-1.04386 0.4191,-0.4625 0.41858,-0.46303 v -0.30996 -0.30954 h -0.60152 -0.60203 l -0.42478,-0.4961 -0.42479,-0.49609 0.12041,-0.63097 0.12041,-0.63097 -1.24282,-1.2609 -1.24282,-1.26142 -0.88883,0.293 -0.88832,0.29352 -1.52601,-0.92707 -1.526,-0.92708 -0.65577,-0.58342 -0.65578,-0.58291 1.18907,0.1943 1.18908,0.1943 0.83251,0.12403 0.83199,0.12454 0.20102,-0.32557 0.20102,-0.32556 -0.84387,-0.75396 -0.84336,-0.75395 -1.64332,0.13797 -1.64279,0.13849 0.51315,-0.39894 0.51263,-0.39842 h 0.48627 0.48679 l 0.15193,-0.39636 0.15193,-0.39688 -0.16381,-0.33021 -0.16382,-0.33073 -0.8015,-1.32188 -0.8015,-1.32189 -0.40049,-0.88986 -0.40101,-0.88987 0.12609,-0.32918 0.12661,-0.32918 0.58652,-0.15348 0.58653,-0.15348 0.75706,0.75758 0.75706,0.75706 0.0263,0.88005 0.0264,0.87953 0.17828,0.63665 0.17777,0.63666 0.47129,0.0692 0.47129,0.0687 0.87747,-0.7705 0.87746,-0.77049 0.7059,-0.36639 0.7059,-0.36638 -0.42788,-0.4284 -0.42788,-0.42788 h -1.27227 -1.27176 l -0.42271,-0.64493 -0.42272,-0.64543 0.69247,-0.54416 0.69195,-0.54467 0.29455,-0.0315 0.29456,-0.031 0.17311,0.0227 0.1726,0.0227 0.2682,-0.32246 0.26769,-0.32298 -0.36174,-0.49454 -0.36173,-0.49506 -1.73065,0.46871 -1.73064,0.4687 v 0.35708 0.3576 h -0.18706 -0.18707 l -1.00201,-0.97875 z m -38.716503,0.37052 h 0.171048 0.170532 l 1.308965,1.38751 1.308963,1.387 v 0.19895 0.19947 h -0.106453 -0.105936 l -1.373561,-1.58647 z m 67.733853,0 h 0.17105 0.17053 l 1.30897,1.38751 1.30896,1.387 v 0.19895 0.19947 h -0.10645 -0.10594 l -1.37356,-1.58647 z m -56.34902,0.79323 h 0.132292 0.132292 l 0.163298,0.26459 0.163298,0.26406 h -0.132292 -0.132291 l -0.163299,-0.26406 z m 67.73386,0 h 0.13229 0.13229 l 0.1633,0.26459 0.1633,0.26406 h -0.1323 -0.13229 l -0.16329,-0.26406 z m -108.137076,0.17622 0.176215,0.17622 0.176218,0.17621 h -0.352433 -0.352435 l 0.176217,-0.17621 z m 67.733856,0 0.17621,0.17622 0.17622,0.17621 h -0.35243 -0.35244 l 0.17622,-0.17621 z m -78.335792,0.88108 h 0.13177 0.13229 l 0.1633,0.26459 0.1633,0.26458 h -0.13229 -0.13178 l -0.16329,-0.26458 z m 67.733852,0 h 0.13177 0.13229 l 0.1633,0.26459 0.1633,0.26458 h -0.13229 -0.13178 l -0.1633,-0.26458 z m -29.911355,0.26459 h 0.132291 0.132292 v 0.13229 0.13229 h -0.132292 -0.132291 v -0.13229 z m 67.733855,0 h 0.13229 0.13229 v 0.13229 0.13229 h -0.13229 -0.13229 v -0.13229 z m -108.921002,0.66507 -0.18294,0.18294 -0.18345,0.18345 1.94717,1.95285 1.94717,1.95233 0.39635,0.13953 0.39636,0.13901 0.11782,-0.10387 0.117826,-0.10335 0.09043,-0.45527 0.09043,-0.45475 0.162264,-1.0325 0.162264,-1.03249 -1.002522,0.16278 -1.00304,0.16278 -1.52807,-0.84698 z m 67.733852,0 -0.18294,0.18294 -0.18345,0.18345 1.94717,1.95285 1.94716,1.95233 0.39636,0.13953 0.39636,0.13901 0.11782,-0.10387 0.11783,-0.10335 0.0904,-0.45527 0.0904,-0.45475 0.16226,-1.0325 0.16226,-1.03249 -1.00252,0.16278 -1.00304,0.16278 -1.52807,-0.84698 z m -47.424502,0.12816 v 0.13229 0.13229 h 0.132291 0.131776 v -0.13229 -0.13229 h -0.131776 z m 67.733852,0 v 0.13229 0.13229 h 0.13229 0.13178 v -0.13229 -0.13229 h -0.13178 z m -76.71935,0.44028 0.176217,0.17622 0.176217,0.17673 H 50.00014 49.647707 l 0.176217,-0.17673 z m 67.73385,0 0.17622,0.17622 0.17622,0.17673 h -0.35244 -0.35243 l 0.17622,-0.17673 z m -80.467952,0.16175 v 2.32595 l 0.97306,0.31368 0.38137,0.29559 0.38086,0.29611 -0.23358,-0.39636 -0.23357,-0.39688 0.43821,0.35554 0.43822,0.35553 0.29094,-0.0971 0.29093,-0.0966 -1.09812,-1.18391 -1.09812,-1.1839 z m 67.733852,0 v 2.32595 l 0.97306,0.31368 0.38137,0.29559 0.38086,0.29611 -0.23358,-0.39636 -0.23357,-0.39688 0.43821,0.35554 0.43822,0.35553 0.29094,-0.0971 0.29093,-0.0966 -1.09812,-1.18391 -1.09812,-1.1839 z m -32.323097,0.68316 1.093989,0.32815 1.094507,0.32762 -0.342098,0.32298 -0.34158,0.32298 -0.59273,0.17777 -0.592212,0.17776 -0.309541,-0.67902 -0.309026,-0.67955 0.149344,-0.14934 z m 67.733857,0 1.09399,0.32815 1.0945,0.32762 -0.34209,0.32298 -0.34158,0.32298 -0.59273,0.17777 -0.59222,0.17776 -0.30954,-0.67902 -0.30902,-0.67955 0.14934,-0.14934 z m -69.216455,0.19534 0.256315,0.45785 0.256315,0.45837 0.01707,0.85059 0.01654,0.8506 0.262001,0.33021 0.261999,0.33073 -0.230992,-0.0398 -0.230479,-0.0398 -0.726569,-0.11007 -0.726573,-0.11007 v -0.0667 -0.0672 l 0.422199,-1.42265 z m 67.733855,0 0.25632,0.45785 0.25631,0.45837 0.0165,0.85059 0.0165,0.8506 0.262,0.33021 0.262,0.33073 -0.23099,-0.0398 -0.23048,-0.0398 -0.72657,-0.11007 -0.72657,-0.11007 v -0.0667 -0.0672 l 0.4222,-1.42265 z m -81.792429,0.0176 0.176218,0.17621 0.176217,0.17622 h -0.352435 -0.352433 l 0.176218,-0.17622 z m 67.733849,0 0.17622,0.17621 0.17622,0.17622 h -0.35244 -0.35243 l 0.17622,-0.17622 z m -40.513289,0.85008 v 0.13229 0.13229 l -0.264064,0.16329 -0.264584,0.1633 v -0.13229 -0.13229 l 0.264584,-0.1633 z m 67.733859,0 v 0.13229 0.13229 l -0.26407,0.16329 -0.26458,0.1633 v -0.13229 -0.13229 l 0.26458,-0.1633 z m -91.681748,0.27801 -0.645441,0.53227 -0.644922,0.53279 -0.264583,0.21652 -0.264065,0.21652 -0.462505,0.17674 -0.462504,0.17673 v 0.27285 0.27234 l 0.330213,0.0315 0.330213,0.031 0.264583,-0.0532 0.264065,-0.0532 -0.187584,0.18758 -0.187587,0.1881 0.401526,0.7767 0.401527,0.7767 -0.237194,1.56786 -0.237196,1.56786 0.133326,0.13333 0.133323,0.13332 h 0.359154 0.35915 l 0.257866,-0.72708 0.257347,-0.72709 0.264583,-0.45889 0.264068,-0.45889 v -0.2682 -0.26768 h -0.396359 -0.396357 v -0.26458 -0.26459 h 0.285253 0.285255 l -0.1788,-0.81442 -0.179319,-0.81493 0.561724,-0.5979 0.561721,-0.5979 0.114207,-0.59376 0.114205,-0.59376 -0.364321,0.30282 -0.364834,0.30231 -0.234611,-0.41961 z m 67.733848,0 -0.64543,0.53227 -0.64493,0.53279 -0.26458,0.21652 -0.26407,0.21652 -0.4625,0.17674 -0.46251,0.17673 v 0.27285 0.27234 l 0.33022,0.0315 0.33021,0.031 0.26458,-0.0532 0.26407,-0.0532 -0.18759,0.18758 -0.18758,0.1881 0.40153,0.7767 0.40152,0.7767 -0.23719,1.56786 -0.2372,1.56786 0.13333,0.13333 0.13332,0.13332 h 0.35915 0.35915 l 0.25787,-0.72708 0.25735,-0.72709 0.26458,-0.45889 0.26407,-0.45889 v -0.2682 -0.26768 h -0.39636 -0.39636 v -0.26458 -0.26459 h 0.28525 0.28526 l -0.1788,-0.81442 -0.17932,-0.81493 0.56172,-0.5979 0.56173,-0.5979 0.1142,-0.59376 0.11421,-0.59376 -0.36432,0.30282 -0.36484,0.30231 -0.23461,-0.41961 z m -52.967826,0.26149 0.102836,0.10335 0.102835,0.10284 -0.520379,1.16272 -0.520383,1.16323 h -0.210841 -0.210839 l 0.05426,1.03301 0.05374,1.03353 -0.399457,-0.5705 -0.39946,-0.57051 h -0.24443 -0.243911 l -0.165881,0.66094 -0.165883,0.66094 h -0.35243 -0.351917 l -0.174665,-0.28267 -0.174667,-0.28267 0.759642,-1.22835 0.759127,-1.22887 1.151353,-0.87849 z m 67.733856,0 0.10284,0.10335 0.10283,0.10284 -0.52038,1.16272 -0.52038,1.16323 h -0.21084 -0.21084 l 0.0543,1.03301 0.0537,1.03353 -0.39946,-0.5705 -0.39946,-0.57051 h -0.24442 -0.24392 l -0.16588,0.66094 -0.16588,0.66094 h -0.35243 -0.35192 l -0.17467,-0.28267 -0.17466,-0.28267 0.75964,-1.22835 0.75913,-1.22887 1.15135,-0.87849 z m -64.868397,0.50539 0.669726,0.43925 0.669727,0.43874 0.383955,0.91932 0.383956,0.91932 0.781865,-0.1235 0.781865,-0.12351 0.133323,0.21549 0.13281,0.21549 -0.83199,0.28991 -0.831993,0.29042 -0.290938,-0.0258 -0.290936,-0.0264 -0.533818,-0.30438 -0.533818,-0.30437 -0.86868,-0.62373 -0.868164,-0.62322 0.08113,-0.69608 0.08061,-0.6966 0.47594,-0.0899 z m 67.733857,0 0.66972,0.43925 0.66973,0.43874 0.38396,0.91932 0.38395,0.91932 0.78187,-0.1235 0.78186,-0.12351 0.13333,0.21549 0.13281,0.21549 -0.83199,0.28991 -0.83199,0.29042 -0.29094,-0.0258 -0.29094,-0.0264 -0.53382,-0.30438 -0.53382,-0.30437 -0.86868,-0.62373 -0.86816,-0.62322 0.0811,-0.69608 0.0801,-0.6966 0.47594,-0.0899 z m -63.795598,0.30799 v 0.1323 0.13229 h 0.131776 0.132292 v -0.13229 -0.1323 h -0.132292 z m 67.733858,0 v 0.1323 0.13229 h 0.13177 0.1323 v -0.13229 -0.1323 h -0.1323 z m -112.445852,0.23203 v 2.76314 l 0.10852,0.0222 2.0314,0.41961 h 0.71572 0.7152 l 1.50585,1.52032 1.505333,1.52032 0.967383,0.87127 0.967382,0.87075 0.271302,-0.16743 0.271301,-0.16744 -0.243913,-0.30695 -0.243913,-0.30696 -1.127579,-2.11512 -1.12758,-2.11511 -0.16123,-0.13229 -0.161748,-0.1323 -0.385508,-0.74724 -0.3855,-0.74776 -1.53376,0.0863 -1.53376,0.0868 -0.13746,-0.43459 -0.13746,-0.43512 -0.95188,-0.1788 z m 67.733852,0 v 2.76314 l 0.10852,0.0222 2.0314,0.41961 h 0.71572 0.7152 l 1.50585,1.52032 1.50533,1.52032 0.96738,0.87127 0.96739,0.87074 0.2713,-0.16743 0.2713,-0.16743 -0.24391,-0.30696 -0.24391,-0.30696 -1.12758,-2.11511 -1.12758,-2.11512 -0.16123,-0.13229 -0.16175,-0.13229 -0.38551,-0.74724 -0.3855,-0.74776 -1.53376,0.0863 -1.53376,0.0868 -0.13746,-0.4346 -0.13746,-0.43511 -0.95188,-0.1788 z m -35.954919,0.42943 0.388091,0.51315 0.388091,0.51314 v 0.21343 h 5.29e-4 v 0.21394 h -0.235643 -0.236162 l -0.160713,-0.41806 -0.160197,-0.41807 0.0088,-0.30902 z m 67.733859,0 0.38808,0.51315 0.3881,0.51314 v 0.21343 h 5.3e-4 v 0.21394 h -0.23565 -0.23616 l -0.16071,-0.41806 -0.1602,-0.41807 0.008,-0.30902 z m -85.70537,0.0279 -0.19172,0.1912 -0.191719,0.19172 -0.0584,0.84698 -0.05839,0.84698 0.125574,0.20308 0.125573,0.20361 h 0.219108 0.219625 l 0.623734,-0.51366 0.624252,-0.51315 -0.71882,-0.72864 z m 67.73385,0 -0.19172,0.1912 -0.19172,0.19172 -0.0584,0.84698 -0.0584,0.84698 0.12558,0.20308 0.12557,0.20361 h 0.21911 0.21963 l 0.62373,-0.51366 0.62425,-0.51315 -0.71882,-0.72864 z m -73.563986,0.0155 0.176217,0.17673 0.176217,0.17622 h -0.352434 -0.352433 l 0.176217,-0.17622 z m 67.733856,0 0.17621,0.17673 0.17622,0.17622 h -0.35243 -0.35244 l 0.17622,-0.17622 z m -21.09691,0.37724 -0.29197,0.18603 -0.291455,0.18604 0.07131,0.79323 0.07131,0.79324 0.02585,0.19792 0.02635,0.19843 h 0.375171 0.374655 l 0.418063,-0.16019 0.418063,-0.16072 v -0.45423 -0.45424 l -0.598923,-0.56275 z m 67.73386,0 -0.29198,0.18603 -0.29145,0.18604 0.0713,0.79323 0.0713,0.79324 0.0253,0.19792 0.0269,0.19843 h 0.37517 0.37465 l 0.41807,-0.16019 0.41806,-0.16072 v -0.45423 -0.45424 l -0.59893,-0.56275 z m -84.721451,0.90123 0.403592,0.5948 0.403075,0.5948 h 0.275436 0.274918 l 1.257289,0.80718 1.257803,0.80719 0.183968,1.09037 0.184486,1.09037 -0.478523,0.34934 -0.478007,0.34984 H 78.0067 77.8372 l -0.176215,-0.17621 -0.176218,-0.17622 v -0.71675 -0.71675 l -0.396359,-0.32918 -0.396356,-0.32918 -0.0062,-0.29817 -0.0057,-0.29766 -0.892969,-0.99167 -0.892969,-0.99115 h -0.343133 -0.34313 l 0.342615,-0.33073 z m 67.733851,0 0.4036,0.5948 0.40307,0.5948 h 0.27544 0.27492 l 1.25728,0.80718 1.25781,0.80719 0.18397,1.09037 0.18448,1.09037 -0.47852,0.34934 -0.47801,0.34984 h -0.17001 -0.1695 l -0.17622,-0.17621 -0.17622,-0.17622 v -0.71675 -0.71675 l -0.39635,-0.32918 -0.39636,-0.32918 -0.006,-0.29817 -0.006,-0.29766 -0.89297,-0.99167 -0.89297,-0.99115 h -0.34313 -0.34313 l 0.34261,-0.33073 z m -92.887356,0.3111 -0.538468,0.48782 -0.538985,0.48783 -0.541569,0.87643 -0.541569,0.87695 h -0.248564 -0.248564 l -1.1467,-1.05782 -1.147217,-1.05729 h -0.300757 -0.300756 v 0.13952 0.14004 l 0.858862,1.61593 0.858862,1.61592 0.287838,0.48989 0.287838,0.48938 0.480074,0.53071 0.480074,0.5302 h 1.03818 1.038179 l -0.08837,-0.25993 -0.08785,-0.25993 -1.176156,-0.59893 -1.176156,-0.59945 -0.110071,-0.35605 -0.109554,-0.35605 0.54157,0.2899 0.542085,0.28991 h 0.524516 0.525033 l 0.173632,-0.85886 0.173117,-0.85938 0.414444,-1.12965 0.414446,-1.12965 -0.168982,-0.16846 z m 67.733856,0 -0.53847,0.48782 -0.53899,0.48783 -0.54157,0.87643 -0.54157,0.87695 h -0.24856 -0.24856 l -1.1467,-1.05782 -1.14722,-1.05729 h -0.30076 -0.30075 v 0.13952 0.14004 l 0.85886,1.61593 0.85886,1.61592 0.28784,0.48989 0.28784,0.48938 0.48007,0.53071 0.48007,0.5302 h 1.03818 1.03818 l -0.0884,-0.25993 -0.0879,-0.25993 -1.17615,-0.59893 -1.17616,-0.59945 -0.11007,-0.35605 -0.10955,-0.35605 0.54157,0.2899 0.54208,0.28991 h 0.52452 0.52503 l 0.17364,-0.85886 0.17311,-0.85938 0.41445,-1.12965 0.41444,-1.12965 -0.16898,-0.16846 z m -46.6261,0.0853 h 0.132291 0.131776 l 0.163295,0.26458 0.163817,0.26407 h -0.132291 -0.132292 l -0.163298,-0.26407 z m 67.73385,0 h 0.1323 0.13177 l 0.1633,0.26458 0.16381,0.26407 h -0.13229 -0.13229 l -0.1633,-0.26407 z m -48.232715,0.4439 -0.551389,0.66042 -0.551386,0.66094 -0.531233,0.73484 -0.530717,0.73484 -1.365293,-1.22783 -1.365289,-1.22783 -0.127125,0.20567 -0.126608,0.20567 0.781865,1.66967 0.781865,1.66966 0.753959,-0.16536 0.753441,-0.16588 0.173117,0.28008 0.172598,0.27957 h 0.507981 0.507979 l 0.160713,-0.72657 0.16123,-0.72709 0.27492,-0.92552 0.274918,-0.92553 0.242364,-0.30695 0.242877,-0.30644 -0.320392,-0.19844 z m 67.733855,0 -0.55139,0.66042 -0.55138,0.66094 -0.53124,0.73484 -0.53072,0.73484 -1.36529,-1.22783 -1.36529,-1.22783 -0.12712,0.20567 -0.12661,0.20567 0.78187,1.66967 0.78186,1.66966 0.75396,-0.16536 0.75344,-0.16588 0.17312,0.28008 0.1726,0.27957 h 0.50798 0.50798 l 0.16071,-0.72657 0.16123,-0.72709 0.27492,-0.92552 0.27492,-0.92553 0.24236,-0.30695 0.24288,-0.30644 -0.32039,-0.19844 z m -96.220489,0.34933 h 0.132292 0.132291 l 0.163299,0.26407 0.163298,0.26458 h -0.132292 -0.132292 l -0.163298,-0.26458 z m 67.733859,0 h 0.13229 0.13229 l 0.16329,0.26407 0.1633,0.26458 h -0.13229 -0.13229 l -0.1633,-0.26459 z m -89.603842,0.72347 -0.41341,0.15864 -0.41341,0.15865 v 0.20929 0.20929 l 0.69195,0.74621 0.69143,0.74621 -0.49351,-0.0527 -0.493,-0.0522 -0.33073,0.0305 -0.33021,0.0305 v 0.23667 0.2372 l 1.33067,0.85369 1.33067,0.85421 1.688266,1.24696 v -10e-4 l 1.68827,1.24695 1.936315,-0.47852 1.936317,-0.47905 0.991154,-0.28318 0.990637,-0.28319 v -0.26562 -0.2651 l -3.237012,0.16278 -3.237529,0.16278 -0.52865,-0.40721 -0.528649,-0.40721 0.594795,-0.008 0.594796,-0.008 v -0.33228 -0.33227 l -1.59784,-1.52949 -1.59731,-1.5291 -0.63201,-0.28836 z m 67.733852,0 -0.41341,0.15864 -0.41341,0.15865 v 0.20929 0.20929 l 0.69195,0.74621 0.69143,0.74621 -0.49351,-0.0527 -0.493,-0.0522 -0.33073,0.0305 -0.33021,0.0305 v 0.23667 0.2372 l 1.33067,0.85369 1.33067,0.85421 1.68827,1.24696 v -10e-4 l 1.68827,1.24695 1.93631,-0.47852 1.93632,-0.47905 0.99115,-0.28318 0.99064,-0.28319 v -0.26562 -0.2651 l -3.23701,0.16278 -3.23753,0.16278 -0.52865,-0.40721 -0.52865,-0.40721 0.59479,-0.008 0.5948,-0.008 v -0.33228 -0.33227 l -1.59783,-1.52949 -1.59732,-1.5291 -0.632,-0.28836 z m -68.296092,0.59789 h 0.13229 0.13178 v 0.1323 0.13229 h -0.13178 -0.13229 v -0.13229 z m 67.733852,0 h 0.13229 0.13178 v 0.1323 0.13229 h -0.13178 -0.13229 v -0.13229 z m -33.641876,5.3e-4 h 0.469739 0.469739 l 0.566891,0.3974 0.567406,0.39739 0.31006,0.93999 0.310058,0.94051 0.05323,0.31471 0.05271,0.31471 0.317812,0.57671 0.317291,0.57723 0.520383,0.16536 0.520382,0.16485 0.984436,-0.6687 0.984435,-0.6692 0.100253,0.10025 0.100769,0.10077 -0.413927,0.80098 -0.41393,0.80099 0.179834,0.47955 0.179319,0.47905 -0.456822,-0.37156 -0.456819,-0.37207 -0.750342,0.55449 -0.749824,0.555 -0.517797,-0.57929 -0.517282,-0.57929 -0.329695,-0.83664 -0.329697,-0.83664 -0.742074,-0.30748 -0.742072,-0.30747 -1.21698,0.18241 -1.217499,0.18294 v -0.28267 -0.28216 l 0.915192,-0.17208 0.915707,-0.17156 0.286803,-0.34572 0.286287,-0.3452 -0.276985,-0.17105 -0.276987,-0.17156 v -0.77773 z m 67.733856,0 h 0.46974 0.46974 l 0.56689,0.3974 0.56741,0.39739 0.31005,0.93999 0.31006,0.94051 0.0532,0.31471 0.0522,0.31471 0.31781,0.57671 0.31781,0.57723 0.52038,0.16536 0.52039,0.16485 0.98443,-0.6687 0.98444,-0.6692 0.0997,0.10025 0.10077,0.10077 -0.41392,0.80098 -0.41342,0.80099 0.17984,0.47955 0.17932,0.47905 -0.45682,-0.37156 -0.45683,-0.37207 -0.75034,0.55449 -0.74982,0.555 -0.51832,-0.57929 -0.51728,-0.57929 -0.32918,-0.83664 -0.32969,-0.83664 -0.74207,-0.30748 -0.74259,-0.30747 -1.21698,0.18241 -1.21698,0.18294 v -0.28267 -0.28216 l 0.91518,-0.17208 0.91519,-0.17156 0.28732,-0.34572 0.28578,-0.3452 -0.27647,-0.17105 -0.27751,-0.17156 v -0.77773 z m -42.627893,0.23307 v 0.13177 0.13229 l -0.26407,0.1633 -0.26458,0.16381 v -0.13229 -0.13229 l 0.26458,-0.1633 z m 67.733853,0 v 0.13177 0.13229 l -0.26406,0.1633 -0.26459,0.16381 v -0.13229 -0.13229 l 0.26459,-0.1633 z m -129.094962,0.0574 v 4.56199 l 0.20515,0.30282 0.51625,1.12035 0.51676,1.12086 0.46251,0.003 0.4625,0.003 v 0.66973 0.66921 l 0.59376,0.23926 h 5.3e-4 l 0.59428,0.23926 0.047,0.0176 0.047,0.016 0.41083,-0.41083 0.41031,-0.41031 -0.8046,-1.50632 -0.8046,-1.50586 h -0.54777 -0.54726 l -0.34623,-1.16788 -0.34571,-1.16789 0.0238,-0.15399 0.0243,-0.154 -0.20877,-1.14618 -0.20825,-1.14619 -0.39688,-0.15296 z m 67.733852,0 v 4.56199 l 0.20515,0.30282 0.51625,1.12035 0.51676,1.12086 0.46251,0.003 0.4625,0.003 v 0.66973 0.66921 l 0.59376,0.23926 h 5.3e-4 l 0.59428,0.23926 0.047,0.0176 0.047,0.016 0.41083,-0.41083 0.41031,-0.41031 -0.8046,-1.50636 -0.80461,-1.50586 h -0.54777 -0.54725 l -0.34623,-1.16788 -0.34572,-1.16789 0.0238,-0.154 0.0243,-0.15399 -0.20877,-1.14619 -0.20825,-1.14618 -0.39688,-0.15296 z m -37.49591,0.23822 h 0.359669 0.35967 l 0.370519,0.5948 0.37052,0.59479 -0.129191,0.99168 -0.129193,0.99115 h -0.196887 -0.196368 l -0.723988,-0.67076 -0.723471,-0.67128 0.186552,-0.45217 0.186553,-0.45268 0.132807,-0.46302 z m 67.73385,0 h 0.35967 0.35967 l 0.37052,0.5948 0.37052,0.59479 -0.12919,0.99168 -0.12919,0.99115 h -0.19689 -0.19637 l -0.72399,-0.67076 -0.72347,-0.67128 0.18655,-0.45217 0.18656,-0.45268 0.1328,-0.46302 z m -83.984019,0.0434 -1.034563,0.5395 -1.034045,0.53951 0.0956,0.2868 0.0956,0.2868 1.302763,0.45631 1.303279,0.45682 1.314132,0.67179 1.314133,0.67231 0.232542,-0.23254 0.232029,-0.23203 -1.150318,-1.2454 -1.1498,-1.24489 -0.760677,-0.47749 z m 67.733849,0 -1.03456,0.5395 -1.03404,0.53951 0.0956,0.2868 0.0956,0.2868 1.30276,0.45631 1.30328,0.45682 1.31413,0.67179 1.31413,0.67231 0.23255,-0.23254 0.23202,-0.23203 -1.15032,-1.2454 -1.1498,-1.24489 -0.76067,-0.47749 z m -67.93022,0.22066 h 0.131775 0.132292 v 0.13229 0.13229 H 51.189215 51.05744 v -0.13229 z m 67.73385,0 h 0.13178 0.13229 v 0.13229 0.13229 h -0.13229 -0.13178 v -0.13229 z m -26.408206,0.22944 -1.106395,0.44287 -1.106392,0.44287 v 0.31832 0.31833 l 0.982887,0.37982 0.982369,0.37982 1.329635,0.70745 h 5.29e-4 l 1.329634,0.70746 0.330729,0.0196 0.330214,0.0196 -0.0083,-0.33021 -0.0078,-0.33073 -1.528588,-1.53738 z m 67.733856,0 -1.10639,0.44287 -1.1064,0.44287 v 0.31832 0.31833 l 0.98289,0.37982 0.98237,0.37982 1.32963,0.70745 h 5.3e-4 l 1.32964,0.70746 0.33073,0.0196 0.33021,0.0196 -0.008,-0.33021 -0.008,-0.33073 -1.52859,-1.53738 z m -93.76276,0.0351 h 0.132292 0.131776 l 0.163814,0.26459 0.163298,0.26406 h -0.132292 -0.132291 l -0.163299,-0.26406 z m 67.73385,0 h 0.1323 0.13177 l 0.16381,0.26459 0.1633,0.26406 h -0.13229 -0.13229 l -0.1633,-0.26406 z m -62.448385,0.79324 h 0.132292 0.132291 l 0.163299,0.26458 0.163298,0.26407 h -0.132292 -0.132292 l -0.163298,-0.26407 z m 67.733855,0 h 0.13229 0.1323 l 0.16329,0.26458 0.1633,0.26407 h -0.13229 -0.13229 l -0.1633,-0.26407 z m -35.49189,0.26406 h 0.13229 0.13178 l 0.16329,0.26459 0.16382,0.26406 h -0.1323 -0.13229 l -0.16329,-0.26458 z m 67.73385,0 h 0.13229 0.13178 l 0.1633,0.26459 0.16381,0.26406 h -0.13229 -0.13229 l -0.1633,-0.26458 z m -89.37336,5.3e-4 h 0.132291 0.131776 v 0.13178 0.13229 H 82.374391 82.2421 v -0.13229 z m 67.73386,0 h 0.13229 0.13177 v 0.13178 0.13229 h -0.13177 -0.13229 v -0.13229 z m -70.641176,0.52865 h 0.132292 0.132291 v 0.1323 0.13177 h -0.132291 -0.132292 v -0.13177 z m 67.733856,0 h 0.13229 0.13229 v 0.1323 0.13177 h -0.13229 -0.13229 v -0.13178 z m -106.662742,1.29605 -0.25425,0.25476 -0.25425,0.25425 0.9927,1.60869 0.99271,1.6092 h 0.72295 0.722955 l 0.316259,-0.38137 0.31626,-0.38137 -0.614433,-0.52142 -0.614431,-0.52193 -1.16324,-0.96015 z m 67.733852,0 -0.25425,0.25476 -0.25425,0.25425 0.99271,1.60869 0.9927,1.6092 h 0.72295 0.72295 l 0.31627,-0.38137 0.31625,-0.38137 -0.61443,-0.52142 -0.61443,-0.52193 -1.16324,-0.96015 z m -18.762168,0.46664 0.176217,0.17621 0.176215,0.17622 h -0.352432 -0.352433 l 0.176215,-0.17622 z m 67.733858,0 0.17621,0.17621 0.17622,0.17622 h -0.35243 -0.35244 l 0.17622,-0.17622 z m -85.704856,0.26406 -0.176215,0.17622 -0.176218,0.17621 h 0.352433 0.352436 l -0.176218,-0.17621 z m 67.733856,0 -0.17622,0.17622 -0.17621,0.17621 h 0.35243 0.35243 l -0.17621,-0.17621 z m -83.854833,0.0501 -1.519288,0.1726 -1.519804,0.17312 -0.429948,0.11782 -0.429948,0.11834 -0.95188,1.43402 -0.952396,1.43454 0.304374,0.18758 0.303857,0.1881 -0.590661,0.2186 -0.590662,0.21859 0.177767,0.28835 0.177767,0.28784 0.565857,-0.13953 0.565857,-0.14004 1.850016,-0.17363 1.850017,-0.17312 0.168465,-0.1018 0.167947,-0.10181 0.261483,0.32712 0.261482,0.32763 -0.190169,0.52348 -0.190169,0.52296 0.145727,0.13436 h 2.073259 l -0.604097,-0.91622 -0.649573,-1.25574 -0.650089,-1.25573 H 54.2929 53.695006 l -1.252638,0.55035 -1.252119,0.55035 -0.462504,0.24495 -0.462505,0.24494 0.0026,-0.2005 0.0031,-0.2005 0.988054,-0.64131 0.987537,-0.6413 1.519803,-0.89142 1.519288,-0.89194 v -0.27027 z m 67.733853,0 -1.51929,0.1726 -1.5198,0.17312 -0.42995,0.11782 -0.42995,0.11834 -0.95188,1.43402 -0.95239,1.43454 0.30437,0.18758 0.30386,0.1881 -0.59067,0.2186 -0.59066,0.21859 0.17777,0.28835 0.17777,0.28784 0.56585,-0.13953 0.56586,-0.14004 1.85002,-0.17363 1.85001,-0.17312 0.16847,-0.1018 0.16795,-0.10181 0.26148,0.32712 0.26148,0.32763 -0.19017,0.52348 -0.19017,0.52296 0.14573,0.13436 h 2.07326 l -0.6041,-0.91622 -0.64957,-1.25574 -0.65009,-1.25573 h -0.5979 -0.59789 l -1.25264,0.55035 -1.25212,0.55035 -0.4625,0.24495 -0.46251,0.24494 0.003,-0.2005 0.003,-0.2005 0.98806,-0.64131 0.98753,-0.6413 1.5198,-0.89142 1.51929,-0.89194 v -0.27027 z m -27.035047,0.5147 -1.651577,0.18345 -1.65158,0.18293 -0.594796,0.37776 -0.594797,0.37775 v 0.34985 0.34985 l -0.528648,0.60978 -0.528135,0.60979 v 0.20825 0.20826 l 0.309026,0.1912 0.309541,0.19172 -0.639752,0.27854 -0.639754,0.27905 1.243851,0.0884 1.244367,0.0879 1.331703,-0.24236 1.331701,-0.24185 0.453202,0.33177 0.453719,0.33176 -0.384472,0.46354 -0.09405,0.11317 h 1.799375 l -0.303343,-0.65939 -0.483174,-1.05059 -0.387059,-0.59479 -0.386538,-0.5948 -0.7953,0.005 -0.7953,0.005 -1.387512,0.76481 -1.387513,0.76533 0.0088,-0.17518 0.0078,-0.17519 1.115176,-0.81028 1.115179,-0.8108 1.255221,-0.64286 1.25522,-0.64337 v -0.35666 z m 67.733857,0 -1.65158,0.18345 -1.65158,0.18293 -0.59479,0.37776 -0.5948,0.37775 v 0.34985 0.34985 l -0.52865,0.60978 -0.52813,0.60979 v 0.20825 0.20826 l 0.30902,0.1912 0.30954,0.19172 -0.63975,0.27854 -0.63975,0.27905 1.24385,0.0884 1.24437,0.0879 1.3317,-0.24236 1.3317,-0.24185 0.4532,0.33177 0.45372,0.33176 -0.38447,0.46354 -0.0946,0.11317 h 1.79937 l -0.30334,-0.65939 -0.48317,-1.05059 -0.38706,-0.59479 -0.38654,-0.5948 -0.7953,0.005 -0.7953,0.005 -1.38751,0.76481 -1.38751,0.76533 0.008,-0.17518 0.008,-0.17519 1.11517,-0.81028 1.11518,-0.8108 1.25522,-0.64286 1.25522,-0.64337 v -0.35666 z m -114.431781,0.58084 -0.807186,0.28112 -0.807186,0.28163 -0.614433,1.37098 -0.614433,1.37098 -0.195337,0.4625 -0.19482,0.46251 h 0.353984 0.3545 l 1.487248,-1.85415 1.487248,-1.85416 v -0.26096 -0.26045 h -0.224793 z m 67.733851,0 -0.80719,0.28112 -0.80718,0.28163 -0.61443,1.37098 -0.61444,1.37098 -0.19533,0.4625 -0.19482,0.46251 h 0.35398 0.3545 l 1.48725,-1.85415 1.48725,-1.85416 v -0.26096 -0.26045 h -0.2248 z m -61.703211,0.26407 -0.148828,0.24081 -0.148312,0.24029 0.161231,0.42065 0.16123,0.42013 h 0.772562 0.773081 l 0.162263,-0.42323 0.162264,-0.42323 -0.36897,-0.23358 -0.368453,-0.23358 -0.579292,-0.004 z m 67.733851,0 -0.14883,0.24081 -0.14831,0.24029 0.16123,0.42065 0.16123,0.42013 h 0.77257 0.77307 l 0.16227,-0.42323 0.16226,-0.42323 -0.36897,-0.23358 -0.36845,-0.23358 -0.57929,-0.004 z m -32.857945,0.18138 -0.849561,0.24391 -0.849558,0.24391 -0.373105,1.11932 -0.373105,1.11983 h -0.270267 -0.270785 l 0.194305,-0.46251 0.194818,-0.46302 0.127124,-0.58498 0.127125,-0.58549 -0.623735,0.11937 -0.623734,0.11989 -0.300757,0.40928 -0.300241,0.40979 -0.269751,-0.076 -0.269234,-0.076 -1.338935,0.99116 -1.339453,0.99167 h -0.262517 -0.263033 l 0.160197,0.41754 0.141076,0.36639 h 0.185002 l 0.392742,-0.12299 0.558105,-0.17518 0.660423,-0.15142 0.660943,-0.15192 0.594796,-0.38603 0.594278,-0.38602 0.0088,-0.43253 0.0078,-0.43202 0.269235,0.46251 0.26975,0.4625 h 0.376722 0.376722 l -0.240298,0.632 -0.239778,0.63149 0.51935,-0.13591 0.51883,-0.13591 0.257865,-0.48162 0.257866,-0.48163 1.072287,-1.23971 1.072285,-1.23972 -0.269751,-0.26975 z m 67.733855,0 -0.84956,0.24391 -0.84956,0.24391 -0.3731,1.11932 -0.37311,1.11983 h -0.27027 -0.27078 l 0.1943,-0.46251 0.19482,-0.46302 0.12713,-0.58498 0.12712,-0.58549 -0.62373,0.11937 -0.62374,0.11989 -0.30075,0.40928 -0.30024,0.40979 -0.26975,-0.076 -0.26924,-0.076 -1.33894,0.99116 -1.33945,0.99167 h -0.26252 -0.26303 l 0.1602,0.41754 0.14108,0.36639 h 0.185 l 0.39274,-0.12299 0.5581,-0.17518 0.66043,-0.15142 0.66094,-0.15192 0.5948,-0.38603 0.59427,-0.38602 0.008,-0.43253 0.008,-0.43202 0.26923,0.46251 0.26975,0.4625 h 0.37672 0.37673 l -0.2403,0.632 -0.23978,0.63149 0.51935,-0.13591 0.51883,-0.13591 0.25787,-0.48162 0.25786,-0.48163 1.07229,-1.23971 1.07228,-1.23972 -0.26975,-0.26975 z m -57.38203,0.0744 -0.40256,0.15452 -0.402563,0.15451 -0.12764,0.57671 -0.12764,0.57722 -0.60978,1.64331 -0.41703,1.12345 h 0.66249 l -0.0966,-0.12299 0.15658,0.12299 h 1.037663 l 0.17984,-1.09503 0.23047,-1.40714 0.91571,0.0749 0.91571,0.0749 0.0884,0.25528 0.0879,0.25528 h 0.24546 0.24495 l 1.87327,0.92552 v -1.22059 l -0.59635,-0.40876 -2.0593,-1.41025 -0.60255,0.0987 -0.60306,0.0987 -0.29663,-0.23565 z m 67.73385,0 -0.40255,0.15452 -0.40256,0.15451 -0.12765,0.57671 -0.12764,0.57722 -0.60978,1.64331 -0.41703,1.12345 h 0.6625 l -0.0966,-0.12299 0.15658,0.12299 h 1.03766 l 0.17984,-1.09503 0.23047,-1.40714 0.91571,0.0749 0.91571,0.0749 0.0884,0.25528 0.0884,0.25528 h 0.24546 0.24495 l 1.87327,0.92552 v -1.22059 l -0.59635,-0.40876 -2.0593,-1.41025 -0.60255,0.0987 -0.60306,0.0987 -0.29663,-0.23565 z m -131.012672,0.002 v 1.30276 l 0.20722,-0.0796 0.39222,-0.15037 -0.2527,-0.47284 -0.25269,-0.47232 z m 67.733852,0 v 1.30276 l 0.20722,-0.0796 0.39222,-0.15037 -0.25269,-0.47284 -0.2527,-0.47232 z m -58.888918,0.077 -0.433566,0.24288 -0.434082,0.24288 v 0.37517 0.37517 l -0.372587,-0.14314 -0.372587,-0.14315 -0.750858,0.39068 -0.750344,0.39016 -0.66094,0.57722 -0.66042,0.57723 -0.36742,0.2067 -0.36742,0.20619 0.18448,0.29921 0.185,0.2992 h 0.32815 0.32763 l 0.25114,-0.22531 0.25115,-0.22531 1.247988,-0.33589 1.247469,-0.33538 0.161747,-0.51057 0.162264,-0.51056 0.385506,0.31988 0.38499,0.32039 0.217041,-0.24029 0.217041,-0.23978 0.278019,-0.83458 0.278019,-0.83405 -0.468705,-0.12248 z m 67.733848,0 -0.43356,0.24288 -0.43408,0.24288 v 0.37517 0.37517 l -0.37259,-0.14314 -0.37259,-0.14315 -0.75085,0.39068 -0.75035,0.39016 -0.66094,0.57722 -0.66042,0.57723 -0.36742,0.2067 -0.36742,0.20619 0.18448,0.29921 0.185,0.2992 h 0.32815 0.32763 l 0.25114,-0.22531 0.25115,-0.2253 1.24799,-0.3359 1.24747,-0.33538 0.16174,-0.51056 0.16227,-0.51057 0.3855,0.31988 0.38499,0.32039 0.21704,-0.24029 0.21705,-0.23978 0.27802,-0.83458 0.27802,-0.83405 -0.46871,-0.12248 z m -17.864024,0.16123 -0.173117,0.45165 -0.173114,0.45166 0.465603,0.34054 0.465606,0.34055 0.644403,-0.29352 0.64492,-0.29404 -0.0786,-0.41548 -0.0785,-0.41548 -0.858344,-0.0832 z m 67.733854,0 -0.17311,0.45165 -0.17312,0.45166 0.46561,0.34054 0.4656,0.34055 0.6444,-0.29352 0.64493,-0.29404 -0.0791,-0.41548 -0.0786,-0.41548 -0.85834,-0.0832 z m -126.448612,1.80196 v 1.23455 l 0.34416,0.17001 1.58647,0.78394 h 1.28829 v -0.0584 -0.33177 l -0.83974,-0.37207 -0.83974,-0.37207 z m 67.733852,0 v 1.23455 l 0.34416,0.17001 1.58647,0.78394 h 1.28829 v -0.0584 -0.33177 l -0.83974,-0.37207 -0.83974,-0.37207 z m -27.25054,0.0827 h 0.132292 0.131776 v 0.13229 0.13229 H 77.881642 77.74935 v -0.13229 z m 67.73386,0 h 0.13229 0.13177 v 0.13229 0.13229 h -0.13177 -0.13229 v -0.13229 z m -44.4898,0.4532 -0.16329,0.16381 -0.16382,0.1633 0.34985,0.42168 0.34933,0.42116 0.48163,-0.12609 0.48111,-0.12557 -0.12455,0.20102 -0.12402,0.20154 0.35295,0.33176 h 2.56677 v -0.30954 l -0.29611,-0.0475 -0.96428,-0.15399 -1.37252,-0.57103 z m 67.73386,0 -0.1633,0.16381 -0.16382,0.1633 0.34985,0.42168 0.34934,0.42116 0.48162,-0.12609 0.48111,-0.12557 -0.12454,0.20102 -0.12402,0.20154 0.35294,0.33176 h 2.56677 v -0.30954 l -0.2961,-0.0475 -0.96429,-0.154 -1.37252,-0.57102 z m -123.73871,0.77256 -1.240235,0.38551 -1.240747,0.38551 -0.0362,0.10904 h 3.00447 l 0.151929,-0.24082 -0.31936,-0.31936 z m 0.487308,0.88006 -2.9869,5.2e-4 -0.0832,0.24909 -0.1018,0.30592 0.87488,0.0837 0.874885,0.0842 0.513147,-0.0212 0.51263,-0.0207 0.274402,-0.4346 0.155546,-0.24701 z m 67.246542,-0.88006 -1.24023,0.38551 -1.24075,0.38551 -0.0362,0.10904 h 3.00447 l 0.15192,-0.24082 -0.31936,-0.31936 z m 0.48731,0.88006 -2.9869,5.2e-4 -0.0832,0.24909 -0.1018,0.30592 0.87489,0.0837 0.87488,0.0842 0.51314,-0.0212 0.51263,-0.0207 0.27441,-0.4346 0.15554,-0.24701 z m -61.407104,-0.71262 -2.288751,0.0305 -2.288749,0.03 0.06615,0.33073 0.0646,0.32143 h 4.607472 l 0.09767,-0.0755 0.342614,-0.26562 -0.300241,-0.18552 z m 67.733854,0 -2.28875,0.0305 -2.28875,0.03 0.0661,0.33073 0.0646,0.32143 h 4.60747 l 0.0977,-0.0755 0.34261,-0.26562 -0.30023,-0.18552 z m -82.270432,0.39119 v 0.32143 h 0.91777 l -0.1726,-0.20258 z m 67.733852,0 v 0.32143 h 0.91777 l -0.1726,-0.203 z m -18.989028,0.0289 -0.962216,0.18035 -0.595828,0.11162 h 1.850017 l -0.02066,-0.0207 z m 67.733858,0 -0.96222,0.18035 -0.59583,0.11162 h 1.85002 l -0.0207,-0.0207 z m -64.763498,0.10542 -0.46302,0.11575 -0.282671,0.0708 h 4.96869 l -0.04134,-0.12299 -2.090827,-0.0315 z m 67.733858,0 -0.46302,0.11575 -0.28267,0.0708 h 4.96869 l -0.0413,-0.12299 -2.09083,-0.0315 z m -110.018614,0.0641 0.01395,0.12299 h 0.602548 l -0.285771,-0.0568 z m 67.733854,0 0.0139,0.12299 h 0.60255 l -0.28577,-0.0569 z m -44.30841,0.12299 -4.427638,5.3e-4 0.903822,0.34933 1.768883,0.6842 0.365352,1.16633 0.365353,1.16686 0.29559,0.57102 0.295589,0.57154 1.651061,1.74202 1.65158,1.74201 h 0.270266 0.27027 l 0.296105,-0.65009 0.296106,-0.65009 0.427363,0.22893 0.427882,0.22892 0.790133,-0.14676 0.790133,-0.14676 0.746723,-0.62167 0.747241,-0.62166 h 0.243915 0.243911 v -0.39688 -0.39636 l -0.197919,-0.0202 -0.198437,-0.0207 -0.39636,-0.0775 -0.396359,-0.077 -0.594796,0.22066 -0.594278,0.22169 v 0.40566 0.40463 H 75.898818 75.63475 v -0.38086 -0.38137 l -0.594794,0.11369 -0.59428,0.11317 -0.280086,0.38189 -0.280085,0.38137 -1.753383,-1.31413 -1.753381,-1.3131 -0.465605,-1.05523 -0.465088,-1.05472 -0.342098,0.13177 -0.342614,0.13075 v -0.0801 -0.0796 l 1.057299,-1.14567 z m 67.73386,0 -4.42765,5.3e-4 0.90383,0.34933 1.76888,0.6842 0.36535,1.16633 0.36536,1.16686 0.29558,0.57102 0.2956,0.57154 1.65106,1.74202 1.65158,1.74201 h 0.27027 0.27026 l 0.29611,-0.65009 0.2961,-0.65009 0.42737,0.22893 0.42788,0.22892 0.79013,-0.14676 0.79014,-0.14676 0.74672,-0.62167 0.74724,-0.62166 h 0.24391 0.24392 v -0.39688 -0.39636 l -0.19792,-0.0202 -0.19844,-0.0207 -0.39636,-0.0775 -0.39636,-0.077 -0.59479,0.22066 -0.59428,0.22169 v 0.40566 0.40463 h -0.26459 -0.26406 v -0.38086 -0.38137 l -0.5948,0.11369 -0.59428,0.11317 -0.28008,0.38189 -0.28009,0.38137 -1.75338,-1.31413 -1.75338,-1.3131 -0.46561,-1.05523 -0.46509,-1.05472 -0.3421,0.13177 -0.34261,0.13075 v -0.0801 -0.0796 l 1.0573,-1.14567 z m -100.589732,5.2e-4 v 2.4412 h 0.0176 l 0.16329,0.26458 0.1633,0.26459 h -0.13177 -0.13229 l -0.0801,-0.12971 v 1.81694 l 0.49402,0.77825 0.64182,1.01079 -0.0816,0.24185 -0.0816,0.24133 -0.66043,-0.34314 -0.31212,-0.16226 v 2.00143 l 1.71979,-0.1447 0.15503,-0.2098 0.15503,-0.21033 0.59118,-0.33021 0.59117,-0.33073 h 0.40825 0.40824 l 0.11937,-0.33021 0.11938,-0.33073 -0.34727,-1.6521 -0.34726,-1.65261 h 0.20463 0.20464 l 0.46819,0.79324 0.46819,0.79323 h 0.18965 0.18965 l 0.1695,0.53433 0.1695,0.53434 -1.20509,1.34048 -1.2051,1.34101 0.26665,0.49816 0.26665,0.49816 0.5886,0.30231 0.58859,0.30179 0.52814,0.47749 0.528646,0.47697 1.494999,1.35651 1.494483,1.35702 0.172599,-0.27905 0.172599,-0.27957 -0.163297,-0.26407 -0.163298,-0.26458 h 0.238745 0.239262 l 0.429948,0.47594 0.430465,0.47542 -0.719853,1.01338 -0.719336,1.01337 -0.134359,-0.75964 -0.134358,-0.76016 -0.79065,-0.16899 -0.790649,-0.16898 -1.884636,-0.0315 -1.88464,-0.0315 -0.69195,-0.90744 -0.69246,-0.90796 v -0.14934 -0.14986 h 0.28112 0.28111 l 1.68982,0.81545 1.69034,0.81545 0.262,-0.16174 0.261483,-0.16175 -1.081593,-1.44694 -1.08158,-1.44694 -0.29249,-0.0331 -0.29197,-0.0331 -0.79324,-0.0331 -0.79271,-0.0331 0.0894,-0.63407 0.0894,-0.63407 -1.24954,0.17104 -0.95911,0.13229 v 1.69447 l 0.0718,0.0212 -0.0718,0.0682 v 1.19527 l 0.57619,-0.35657 v 0.13385 0.13281 l -0.51573,1.1529 -0.0605,0.13539 v 3.31091 l 0.11472,-0.57568 h 0.2005 0.20051 l 0.12815,0.4899 0.12765,0.48885 1.51722,0.89917 1.5167,0.89866 0.69866,0.46509 0.69815,0.46612 0.50902,0.1726 0.509009,0.17208 -0.579289,0.21446 -0.5793,0.21393 -0.98702,-0.54621 -0.9865,-0.54726 -0.25115,-0.23978 -0.25114,-0.23874 h -0.47543 -0.47594 v 0.24495 0.24598 l 0.36484,0.34933 0.36483,0.34881 1.56167,1.49603 1.56217,1.49604 0.507983,0.0899 0.508496,0.0899 0.21084,-1.42317 0.21084,-1.42369 -0.257349,-0.31005 -0.257348,-0.31006 0.782898,-0.46251 0.782897,-0.4625 v 0.34985 0.34985 l 1.615922,0.64233 1.615406,0.64183 0.614433,0.48369 0.614433,0.48317 -0.403076,0.98496 -0.403593,0.98495 -0.357084,0.37103 -0.356568,0.37052 -0.922425,-0.76687 -0.922424,-0.7674 -0.01912,-0.46767 -0.01912,-0.46819 0.645955,0.16226 0.645439,0.16227 0.292489,-0.18087 0.291972,-0.18035 -0.33228,-0.40049 -0.332279,-0.40049 -0.626319,-0.23823 -0.626835,-0.23823 -0.35605,0.19947 -0.356568,0.19947 -0.830957,1.14774 -0.830957,1.14773 0.121956,0.31832 0.121957,0.31833 1.753898,0.3483 1.753899,0.34882 0.278535,0.52141 0.279053,0.52142 -0.08733,0.0703 -0.08785,0.0708 -0.837159,0.28267 -0.837161,0.28214 -0.458886,-0.50746 -0.458887,-0.50746 h -0.33383 -0.333313 l -0.109037,0.32814 -0.109554,0.32815 -0.375171,-0.39429 -0.375171,-0.39429 -0.38654,-0.74828 -0.386027,-0.74827 -1.40146,0.0868 -1.40095,0.0873 -0.13746,-0.4346 -0.13746,-0.43512 -0.98185,-0.18448 -0.98237,-0.18397 -0.70952,-0.42375 v 1.56993 l 0.0491,0.0548 v 0.36794 0.36793 l -0.0491,-0.005 v 0.78858 l 0.70952,0.10702 0.79272,0.11937 1.03714,0.14315 1.03715,0.14314 0.35037,0.29094 0.35036,0.29042 v 0.56999 0.56947 l 0.38396,0.54881 0.38447,0.54828 -0.71468,-0.12815 -0.71417,-0.12868 -0.26459,-0.20412 -0.26406,-0.20412 -0.81442,-0.12713 -0.81391,-0.1266 -0.32711,0.52399 -0.32763,0.52452 0.67903,0.97979 0.67903,0.9803 v 0.31626 0.31574 l 0.19792,-0.0444 0.19844,-0.0444 0.98133,0.20464 0.98186,0.20412 0.30385,0.36587 0.30334,0.36638 0.27544,-0.17053 0.27492,-0.17001 -0.19586,0.31677 -0.19533,0.31678 0.32246,0.38912 0.322976,0.38913 -0.300236,1.49396 -0.29973,1.49448 v 0.22015 0.22014 h 0.41135 0.410826 l 0.526066,-1.18959 0.526066,-1.18959 h 0.507979 0.507979 l -0.168464,0.43976 -0.168982,0.43977 0.37517,-0.22634 0.375171,-0.22635 -0.347782,0.42995 -0.348299,0.42943 0.720886,0.47232 0.720886,0.47233 0.287838,-0.50488 0.287838,-0.5054 0.638204,-0.66559 0.637687,-0.66559 0.155029,0.43201 0.15503,0.43202 1.189074,0.88883 1.189075,0.88884 0.660941,0.30282 -0.0031,5.3e-4 0.660943,0.30282 0.03411,0.0181 0.03411,0.0176 1.508953,-0.90899 1.509469,-0.90899 1.036111,-1.59577 1.03663,-1.59525 -0.260967,-1.13067 -0.260448,-1.13069 -0.0062,-1.75596 -0.0062,-1.75648 -0.330211,-0.11627 -0.330213,-0.11576 -0.659392,0.16537 -0.659392,0.16536 -0.08992,0.47077 -0.09043,0.47077 0.420129,0.46458 0.420129,0.46457 -0.175181,0.17518 -0.175183,0.17518 0.499711,0.55242 0.49971,0.55243 -0.737408,-0.33645 -0.737939,-0.3359 -0.534853,-1.20613 -0.535366,-1.20612 -0.505912,-0.99943 -0.505913,-0.99942 v -0.78548 -0.78497 h 0.513147 0.51263 l 0.163298,-0.26406 0.163296,-0.26458 h 0.653708 0.65319 l 0.164846,-0.42892 0.164849,-0.42943 -0.417028,-0.23358 -0.416513,-0.23306 -0.54932,-0.88883 -0.548804,-0.88884 v -0.82785 -0.82838 h 0.773597 0.773597 l 0.516763,0.65732 0.516765,0.65733 0.179832,1.43919 0.179835,1.43919 0.324011,0.26923 0.324012,0.26872 0.650089,-0.37207 0.650608,-0.37207 0.594278,-0.31729 0.594796,-0.3173 v -0.22169 -0.22221 h 0.264584 0.264064 l -0.0083,0.33073 -0.0083,0.33021 -1.207677,0.73381 -1.207677,0.7338 0.299722,0.36122 0.299723,0.36122 0.535884,0.14056 0.536403,0.14004 0.144177,-0.3762 0.144177,-0.37569 h 0.72037 0.720887 l 0.162263,-0.16278 0.162264,-0.16226 -0.412896,-0.63097 -0.412895,-0.63046 h 0.209291 0.20929 l 0.720368,0.85938 0.719855,0.85886 0.20412,-0.19998 0.203605,-0.19999 -0.599445,-1.20096 -0.599448,-1.20096 -0.647504,-0.64802 -0.648023,-0.64751 h -1.422654 -1.422651 l -0.414962,-0.41548 -0.415478,-0.41548 v -0.36535 -0.36483 l 1.599901,-0.93793 1.599904,-0.93793 h 0.186552 0.187068 l 0.762228,-0.70745 0.762743,-0.70745 -0.718301,-0.61805 -0.718304,-0.61856 -0.245462,0.15192 -0.244946,0.15141 v 0.49403 0.49351 l -2.18023,0.83768 -2.180228,0.83715 -0.436149,0.38861 -0.43615,0.38861 -0.687295,-0.90124 -0.686782,-0.90124 v -0.17311 -0.17364 h 1.717726 1.717725 v -0.53485 -0.53536 l -0.726054,-0.27647 -0.726054,-0.27595 -0.702283,0.41496 -0.701765,0.41496 h -0.307475 -0.307475 l 0.160713,-0.50746 0.161232,-0.50747 -0.473358,-0.13384 -0.473871,-0.13384 -0.792719,-0.15658 -0.792715,-0.15606 -0.52865,-0.10284 -0.52865,-0.10335 -0.697632,-0.17828 -0.698148,-0.17829 -0.156063,0.2527 -0.15658,0.25321 2.068091,1.202 2.068092,1.20199 -0.224793,1.54047 -0.224277,1.541 0.157613,2.31303 0.15813,2.31356 -0.222207,-0.004 -0.222211,-0.004 -0.38137,-0.24133 -0.380856,-0.24081 -0.302307,0.41289 -0.30179,0.41341 0.119372,0.62529 0.119372,0.62528 0.431498,0.0305 0.432017,0.0305 -0.482142,0.12558 -0.481625,0.12454 0.141077,0.36793 0.141076,0.36742 -0.337446,0.80305 -0.337964,0.80357 -0.114205,-0.0925 -0.114722,-0.0925 -0.456303,0.47853 -0.456303,0.47852 0.456303,0.23564 0.456303,0.23565 1.345653,0.31574 1.345655,0.31523 1.410767,1.27072 1.410766,1.27021 -0.01963,1.22835 -0.01963,1.22887 -0.430467,0.65732 -0.430464,0.65681 h -0.217558 -0.218075 l -0.58446,-0.50695 -0.584978,-0.50746 -0.08371,-0.61599 -0.08423,-0.6165 -0.202055,-1.14618 -0.201538,-1.14618 -0.397394,-0.15296 -0.397391,-0.15245 -0.355534,0.48628 -0.355533,0.48679 -0.181901,-0.18242 -0.182418,-0.18294 0.566373,-0.76481 0.565856,-0.76584 -0.353983,-0.29352 -0.353466,-0.29404 -1.869653,-0.0615 -1.869653,-0.061 0.14211,-0.66095 0.142627,-0.66094 1.099674,-0.99063 1.100191,-0.99064 0.197921,-5.3e-4 0.198438,-0.001 v -0.39584 -0.39688 H 50.27874 50.030176 l -0.163297,0.26459 -0.163298,0.26406 -0.578776,-0.0134 -0.579292,-0.0145 0.594795,-0.41496 0.594279,-0.41496 v -0.33228 -0.33176 l 0.418063,-0.34727 0.418062,-0.34674 0.49351,-0.94103 0.492993,-0.94103 0.329179,-0.61392 0.329178,-0.61391 -0.356049,-0.22014 -0.356051,-0.22015 -1.412834,-0.17621 -1.412834,-0.17673 v -0.19276 -0.19223 l 0.297657,-0.29818 0.297656,-0.29766 -0.172083,-0.68626 -0.172082,-0.68574 -0.529167,0.28318 -0.529683,0.28371 0.181901,0.31677 0.181901,0.3173 -0.221175,-0.20051 -0.220659,-0.2005 -0.590662,0.555 -0.590661,0.55501 -0.464055,-0.0894 -0.464571,-0.0899 -0.08733,-0.26459 -0.08733,-0.26458 0.629936,-0.39636 0.630452,-0.39635 1.332736,-1.05782 1.332735,-1.0573 0.148828,-0.34727 0.148828,-0.34726 -0.825273,-0.75396 -0.825272,-0.75396 0.170015,-0.67748 0.170016,-0.67799 -0.994692,-0.62841 -0.994254,-0.62787 -0.264584,-0.0579 -0.264066,-0.0568 -0.39642,-0.337 -0.396358,-0.33796 -0.430464,-0.15193 -0.430465,-0.1509 -0.273368,0.27337 -0.273369,0.27337 -0.317293,-0.19637 -0.317812,-0.19637 0.140045,-1.04335 0.140043,-1.04438 0.387574,-0.44235 0.387573,-0.44183 0.187068,-0.6134 0.187069,-0.6134 -0.522449,-0.13643 -0.522448,-0.13694 -0.421685,-0.9679 -0.42167,-0.96893 -0.27596,-0.76223 -0.27543,-0.76171 -1.1529,0.15813 -1.1529,0.15813 -0.86972,-1.02268 -0.74311,-0.87281 z m 1.82262,0 0.66198,0.32712 h 0.36742 0.3669 v -0.32712 z m 7.615559,0 0.06356,0.56948 0.0708,0.63975 0.270785,0.3266 0.271301,0.32659 0.318843,-0.0667 0.318328,-0.0661 0.660941,-0.27698 0.660425,-0.27699 1.189591,-0.46664 1.189074,-0.46663 0.313677,-0.24237 h -4.686536 l 0.0124,0.062 -0.309542,-0.062 z m 7.959206,0 1.126027,1.03715 h 5.29e-4 l 1.213879,1.1188 0.315225,0.0104 0.314711,0.0108 0.135393,-0.21963 0.135908,-0.21963 -0.857313,-1.3007 -0.288354,-0.43718 z m 2.936769,0 -0.01034,0.0315 0.440801,0.92915 0.440799,0.92914 0.305924,0.18965 0.306443,0.18914 2.556949,0.19844 2.556949,0.19791 1.024226,0.54933 1.024745,0.54932 0.160713,0.45837 0.160197,0.45785 -0.121957,0.46715 -0.121954,0.46664 H 66.09941 65.875652 l -0.280604,-0.524 -0.280604,-0.52451 -1.380276,-0.63614 -1.380794,-0.63614 -1.778187,-0.16846 -1.778186,-0.16795 0.146246,0.38086 0.146243,0.38137 1.00924,0.6997 1.009243,0.6997 1.313098,0.34623 1.313097,0.34675 0.498676,0.2899 0.499195,0.28991 -0.264583,0.0119 -0.264065,0.0124 0.347266,0.22014 0.346747,0.22014 1.701189,-0.4718 1.70067,-0.47181 v 0.24753 0.24753 h 0.52865 0.528651 v -0.36432 -0.36432 l -0.406178,-0.97203 -0.406177,-0.97255 -0.525032,0.16691 -0.524515,0.1664 -0.509013,-1.15032 -0.508498,-1.15083 -0.608748,-0.54829 -0.608229,-0.54828 -0.429948,-0.1509 -0.430466,-0.15089 -0.273368,0.27388 -0.273367,0.27337 -0.317813,-0.19637 -0.31729,-0.19637 0.07028,-0.52193 z m 13.277744,0 v 0.52607 l 0.330211,0.27234 0.330213,0.27181 1.189074,0.17364 1.189593,0.17414 0.396357,0.062 0.396359,0.062 0.528651,0.28888 0.528648,0.28939 0.937929,-0.0863 0.938443,-0.0863 0.314709,0.50384 0.314711,0.50385 -0.7028,-0.26717 -0.702283,-0.26717 -0.194302,0.31471 -0.194305,0.31471 -1.383379,-0.16433 -1.383377,-0.16382 -0.439251,-0.39739 -0.439766,-0.39791 -0.977718,-0.15554 -0.977717,-0.15555 v 0.48266 0.48214 l 1.433505,1.12035 1.433504,1.11982 h 0.39274 0.392742 l 1.54564,-0.4811 1.545127,-0.48111 0.916739,0.37414 0.916223,0.37413 0.799433,0.70177 0.79892,0.70228 -0.07855,1.63453 -0.07803,1.63452 0.238228,0.87695 0.238228,0.87695 0.322461,-0.0734 0.321945,-0.0724 -0.147278,0.23875 -0.147796,0.23823 0.891419,0.94516 0.890902,0.94568 0.690398,0.17311 0.68988,0.17312 v -0.2496 -0.24959 l -0.963766,-1.23817 -0.964282,-1.23765 0.159679,-0.15968 0.159681,-0.15968 1.398882,1.33273 1.399397,1.33274 0.707966,0.555 0.708486,0.55449 0.156578,-0.25321 0.15658,-0.25322 -1.195276,-1.34668 -1.195277,-1.34617 v -0.11524 -0.11472 l 0.330214,0.14418 0.330729,0.14366 1.348756,1.61282 1.349271,1.61282 -0.802536,1.13895 -0.802535,1.13895 -0.10542,-0.10542 -0.105418,-0.10542 0.280085,-0.52349 0.280085,-0.52399 -0.325043,-0.25735 -0.324527,-0.25787 -1.057302,-0.21756 -1.056783,-0.21807 -0.859379,0.0718 -0.858862,0.0718 v -0.28474 -0.28525 h -0.249597 -0.249597 l -1.197859,-1.25574 -1.197343,-1.25574 -0.0062,-0.99529 -0.0062,-0.99477 -0.248563,-0.4594 -0.248563,-0.45889 -0.451136,-1.26452 -0.451651,-1.26504 -0.290939,0.0992 -0.290938,0.0992 -0.02894,0.63665 -0.02842,0.63717 -0.03772,0.46251 -0.03721,0.4625 h -0.496094 -0.496094 l -0.316259,0.38137 -0.316261,0.38086 -0.901753,-0.50643 -0.901237,-0.50643 -0.334346,0.13178 -0.334346,0.13177 -0.564309,1.68362 -0.564306,1.68362 0.54777,0.54777 0.547772,0.54828 0.941543,-0.56895 0.941544,-0.56844 -0.462502,0.53278 -0.462505,0.53227 v 0.31884 0.31936 l -0.461987,0.70539 -0.461988,0.70538 -0.134874,-0.77876 -0.134877,-0.77877 -0.790649,-0.16898 -0.790649,-0.1695 -1.884641,-0.031 -1.88464,-0.0315 -0.691946,-0.90744 -0.691946,-0.90795 v -0.14986 -0.14987 h 0.280601 0.28112 l 1.718241,0.82941 1.718241,0.82889 0.258384,-0.2589 0.258382,-0.25838 -0.407729,-0.33848 -0.407209,-0.33848 -0.0093,-0.29766 -0.0088,-0.29817 -0.496093,-0.5948 -0.496094,-0.59531 h -0.278535 -0.279053 l -0.273368,-0.51108 -0.273886,-0.5116 v -0.11627 -0.11679 l 0.793234,-0.15864 0.792716,-0.15865 v -0.41341 -0.41393 l -1.18494,0.0765 -1.184941,0.077 -0.522449,1.21491 -0.522965,1.21491 -0.406694,0.33745 -0.406693,0.33745 v 0.36432 0.36432 h 0.250631 0.25063 l -0.0067,1.53272 -0.0067,1.53272 -1.10226,-0.0367 -1.101741,-0.0372 -0.264583,-0.062 -0.264067,-0.0615 0.92501,-0.33434 0.925007,-0.33383 v -0.63356 -0.63355 l -0.497126,-0.0961 -0.496612,-0.0956 -0.216525,0.35036 -0.216524,0.34985 -0.872297,-0.99735 -0.872299,-0.99787 -0.793232,-0.0532 -0.792718,-0.0537 0.102836,0.39635 0.10232,0.39688 -0.03462,0.79271 -0.03462,0.79324 0.196371,0.27854 0.196371,0.27801 1.585434,1.08417 1.585949,1.08366 0.618051,0.18345 0.618048,0.18294 1.580266,0.96635 1.580782,0.96635 0.708483,0.4656 0.708485,0.4656 0.509014,0.17209 0.50901,0.17208 -0.578776,0.21446 -0.578776,0.21394 -1.251603,-0.68627 -1.251601,-0.68626 -0.251148,-0.23203 -0.251148,-0.23151 h -1.214913 -1.214914 l -1.021641,-1.04644 -1.021127,-1.04697 -0.224274,0.13901 -0.224277,0.13849 0.06149,0.80667 0.0615,0.80615 0.271301,0.0801 0.27182,0.0791 0.727085,0.15969 0.726572,0.15916 v 0.78807 0.78806 h 0.232027 0.232026 l 0.399976,-0.59479 0.39946,-0.5948 0.199988,0.19275 0.199469,0.19275 -0.711584,1.07642 -0.712102,1.07591 -1.314129,-0.9648 -1.314133,-0.9648 -0.391189,0.15038 -0.391192,0.14986 v 0.27544 0.27543 l 0.54932,0.45992 0.54932,0.45992 0.391708,0.74466 0.391192,0.74466 0.75189,-0.16537 0.751893,-0.16536 0.173117,0.28008 0.172598,0.28009 h 0.507979 0.507981 l 0.160197,-0.72709 0.160195,-0.72708 0.196887,-0.66095 0.196887,-0.66094 0.771014,-0.14728 0.771528,-0.14727 1.189075,0.99787 1.189074,0.99787 1.038699,0.91984 1.038177,0.92036 0.213942,-0.13178 0.21394,-0.13229 -0.12609,0.34417 -0.12609,0.34416 1.15135,1.22577 1.150835,1.22576 0.695563,-0.13281 0.696081,-0.13332 v -0.20309 -0.20361 l -0.386537,-0.74517 -0.386541,-0.74517 0.127125,-0.12713 0.127124,-0.12712 1.063501,1.03869 1.0635,1.03922 0.149344,0.59634 0.149863,0.59635 h 1.275374 1.275373 l 0.668695,0.25425 0.668692,0.25424 0.163814,-0.26613 0.16433,-0.26561 -0.321942,-0.3881 -0.321945,-0.3886 0.709001,-0.65733 0.709518,-0.65784 h 0.134358 0.133842 l -0.144693,0.2341 -0.144695,0.23461 0.581361,0.15193 0.580842,0.15193 -0.571542,0.60926 -0.572058,0.60927 0.22221,0.36018 0.222723,0.36019 0.300242,-0.18552 0.300241,-0.18604 -0.07235,0.35037 -0.07286,0.34985 0.350366,-0.0729 0.349848,-0.0729 -0.134358,0.21756 -0.134358,0.21755 0.180867,0.26975 0.180866,0.27027 2.155426,1.59215 -0.0011,-0.002 2.155426,1.59215 1.808673,-0.47129 1.808676,-0.4718 1.107426,-0.0155 1.106909,-0.0155 1.221115,-1.0573 1.221629,-1.05782 h 0.24805 0.24856 v -0.32042 -0.31988 l -1.11258,-1.13378 -1.112081,-1.13378 h -0.341064 -0.341579 v 0.14314 0.14263 l 0.528648,1.03611 0.52865,1.03663 v 0.14211 0.14367 h -0.202054 -0.202054 l -0.627354,-1.32241 -0.627351,-1.32188 h -0.228409 -0.227894 v -0.47904 -0.47904 l -0.781865,-0.57878 -0.782381,-0.57774 h -0.176733 -0.17725 l 0.132292,1.17357 0.132291,1.17409 -0.381373,-0.38034 -0.380854,-0.38137 h -0.501777 -0.501264 l 0.170016,0.44183 0.1695,0.44287 -0.416512,-0.15968 -0.416513,-0.15968 -0.155546,0.15503 -0.155545,0.15606 0.294039,0.3545 0.294555,0.35502 0.56224,0.002 0.562239,0.002 0.76481,0.50436 0.764294,0.50437 0.358635,-0.13798 0.358635,-0.13746 v 0.13022 0.13023 l -0.356566,0.68729 -0.356052,0.68678 -0.16433,-0.16381 -0.163815,-0.16433 -1.312582,0.56482 -1.312582,0.56483 h -0.787548 -0.788064 l -0.484209,-0.6563 -0.484724,-0.65577 -0.660943,-0.1173 -0.660423,-0.11783 -0.156065,-0.0196 -0.156062,-0.0196 -0.329697,-1.12344 -0.329695,-1.12396 -0.436665,-0.92501 -0.436666,-0.92553 -0.24443,-0.17466 -0.243911,-0.17467 -0.947746,0.14573 -0.947748,0.14624 -0.72657,0.36587 -0.726569,0.36587 v 0.52193 0.52194 h -0.360185 -0.360186 l -1.027327,-0.81494 -1.027326,-0.81546 -0.219626,-0.3886 -0.219109,-0.38861 0.376722,-0.58084 0.376721,-0.58033 0.147278,-0.78341 0.146762,-0.7829 -1.030947,-1.00098 -1.031462,-1.00149 v -0.3054 -0.30593 l 0.462505,0.37156 0.462505,0.37155 0.591177,0.33073 0.590661,0.33021 h 0.363802 0.363802 l 0.997874,0.79324 0.997354,0.79323 h -0.250113 -0.250113 l -0.513149,-0.38809 -0.51263,-0.38861 -0.170016,-0.008 -0.170013,-0.008 -0.159682,0.416 -0.159162,0.41548 0.314192,0.57567 0.314709,0.57568 -0.07648,0.79323 -0.07648,0.79323 -0.245465,0.29973 -0.24598,0.29972 0.422198,0.16175 0.422196,0.16226 0.575675,-0.29869 0.575675,-0.29817 0.320395,-0.25373 0.320394,-0.25373 -0.409278,-0.62477 -0.409276,-0.62529 0.170531,-0.27595 0.170532,-0.27595 h 0.761712 0.761193 l 0.163298,0.26458 0.163814,0.26407 h 0.264065 0.233061 v 0.23978 0.27026 l 0.532267,0.28526 0.532787,0.28525 0.09767,-0.3421 0.09818,-0.34158 0.306959,-1.12913 0.306441,-1.12913 -0.160198,-0.25941 -0.160713,-0.25994 -0.495062,0.26511 -0.495059,0.2651 h -0.48731 -0.487307 l -2.01073,-2.00557 -2.011248,-2.00556 -0.151411,0.24495 -0.150894,0.24443 0.517797,0.96686 0.517798,0.96687 v 0.13281 0.13332 h -0.2589 -0.258898 l -0.519866,-1.02009 -0.52038,-1.02009 -1.279509,0.12299 -1.278991,0.12299 -0.352436,-0.42478 -0.352432,-0.42478 -0.56224,0.004 -0.56224,0.004 -0.594794,0.15968 -0.594796,0.15916 v 0.36587 0.36587 l -0.197922,-0.004 -0.198437,-0.004 -0.792716,-0.72244 -0.792718,-0.72295 -0.858861,-1.233 -0.858861,-1.233 v -0.18697 -0.18759 l 0.407209,0.33848 0.407728,0.33797 1.243852,0.63458 1.244367,0.63407 1.717725,0.21911 1.718241,0.21859 0.239779,-0.2222 0.239779,-0.22273 -0.270786,-0.34158 -0.270266,-0.3421 -0.130741,-0.72709 -0.13126,-0.72657 h 0.236162 0.235646 l 0.156061,0.40618 0.156065,0.40618 0.785998,0.40669 0.786513,0.40721 -0.167947,0.57464 -0.168465,0.57464 -0.106453,0.46302 -0.106455,0.46251 h 0.381373 0.380855 v -0.2465 -0.2465 l 0.52865,-0.16794 0.528651,-0.16795 v -0.47853 -0.47852 l -0.396359,-0.32918 -0.396359,-0.32918 v -0.27285 -0.27337 l -0.66094,-0.86661 -0.660426,-0.86661 v -0.14987 -0.14934 h 0.644922 0.644922 l 0.163298,-0.26458 0.163298,-0.26459 h 0.238744 0.238228 l 0.27027,1.00304 0.26975,1.00252 0.55862,0.59997 0.558623,0.59944 0.664043,0.2527 0.664041,0.2527 -0.278019,0.33486 -0.278535,0.33538 0.223242,0.98961 0.223243,0.99012 0.351917,0.45527 0.352433,0.45475 0.728636,0.72709 0.728638,0.72708 h 0.26665 0.26665 v -0.24494 -0.24547 l -0.660423,-0.51986 -0.660942,-0.51986 v -0.34314 -0.34261 l 0.330729,0.38344 0.330213,0.38395 0.714685,0.62684 0.714168,0.62683 1.796272,-1.65416 1.796275,-1.65364 0.968933,-0.61754 0.968934,-0.61753 -0.137462,-0.5271 -0.137975,-0.52658 -0.650089,-0.42633 -0.650608,-0.42634 0.146246,-0.70951 0.146243,-0.71004 -1.853634,-1.12344 -1.854149,-1.12345 H 85.521983 85.11684 l 0.163298,0.26407 0.163298,0.26458 h -0.247531 -0.247528 l -0.306443,-0.36949 -0.306956,-0.37 0.117821,-0.65009 0.117822,-0.65009 0.555522,-1.1498 0.555006,-1.14928 -0.635104,-0.54054 -0.634587,-0.54053 -0.470257,-1.28158 -0.470255,-1.28157 -0.377237,-0.14521 -0.377754,-0.1447 -0.233579,0.36897 -0.233577,0.36897 -0.0036,0.21394 -0.0036,0.21394 0.330211,-0.19843 0.330213,-0.19844 -0.323495,0.39997 -0.323493,0.4005 1.050581,1.02577 1.050065,1.0263 v 0.22841 0.22841 l -0.714169,0.93637 -0.714168,0.9369 -0.49816,-0.61598 -0.498676,-0.61599 0.287837,-0.0961 0.287319,-0.0956 v -0.31419 -0.3142 l -0.810802,-0.98443 -0.811321,-0.98392 0.187071,-0.59635 0.18655,-0.59634 0.48886,-0.6258 0.488341,-0.6258 -0.144177,-0.23307 -0.144176,-0.23358 H 81.6282 81.310906 l -0.330213,-0.52916 -0.330729,-0.52968 0.08837,-0.0615 h -0.821655 l 0.03359,0.85524 h 0.203089 0.203089 l 0.172083,0.54157 0.171563,0.54105 -0.318325,0.38396 -0.318844,0.38395 H 79.840716 79.61799 l -0.244946,-0.46302 -0.245462,-0.4625 -0.133326,-1.00666 -0.102836,-0.77359 h -0.879533 l 0.0021,0.031 -0.301274,0.18603 h -5.29e-4 l -0.301275,0.18655 -2.472717,0.0336 -2.4722,0.0341 0.149344,-0.47077 z m 11.661304,0 0.04031,0.10491 0.334346,-0.10491 z m 2.19573,0 -0.649055,0.12196 -0.144695,0.23409 -0.144693,0.23462 0.163298,0.26458 0.163296,0.26407 h 0.87695 0.876949 l 0.338481,-0.40773 0.338479,-0.40773 -0.271817,-0.2713 -0.03256,-0.0326 z m 2.300636,0 -5.29e-4,0.003 0.01188,-0.003 z m 1.410251,0 -0.390158,0.0977 -0.28267,0.52866 -0.283189,0.52864 0.42168,0.64338 0.421164,0.64285 h 0.174667 0.174665 l 1.074354,-0.49299 1.074869,-0.493 1.26814,-0.45888 1.268656,-0.4594 -0.102835,-0.30335 -0.07855,-0.23357 z m 6.95203,0 -0.334865,0.40308 0.512115,0.29197 0.511595,0.29197 1.072285,0.98496 v -0.001 l 1.07229,0.98495 0.18241,0.007 0.18242,0.007 0.1602,-0.2589 0.15968,-0.25839 -0.60668,-0.86506 -0.60668,-0.86506 -0.18501,-0.13953 -0.18448,-0.13953 -0.20412,-0.44338 z m 3.07991,0 -0.2129,0.5731 0.44545,0.49299 0.44596,0.49247 v 0.43667 0.43718 l 0.60617,0.15193 0.606683,0.15245 0.71055,-0.12919 0.71055,-0.12868 0.13488,0.21808 0.13539,0.21859 -0.41651,0.15968 -0.41651,0.1602 h -0.65784 -0.657333 l 0.0847,0.56585 0.0842,0.56638 0.58705,0.21549 0.58704,0.216 0.38499,-0.3855 0.38499,-0.38499 h 0.14469 0.14418 l -0.14986,0.85886 -0.14935,0.85938 -0.39945,1.27279 -0.39895,1.27331 0.1478,0.14728 0.14728,0.14779 0.41392,-0.15865 0.41393,-0.15864 0.1664,-0.46871 0.1664,-0.4687 0.33796,-0.3974 0.33797,-0.39687 0.38757,-0.74827 0.38809,-0.74776 -0.35967,-0.6935 -0.35967,-0.6935 0.12041,-0.1204 0.12092,-0.12093 0.56431,0.5054 0.56431,0.50488 0.22479,0.35398 v -1.81126 l -0.16175,-0.262 -0.1633,-0.26458 h 0.13229 0.1323 l 0.0605,0.0982 v -2.53938 h -2.62413 l 0.34313,0.32246 0.63924,0.60048 0.34364,-0.13178 0.34417,-0.13177 0.0357,0.59221 0.0362,0.5917 -0.89814,0.27595 -0.89813,0.27595 -0.27027,-0.50539 -0.27027,-0.50489 h -0.34623 -0.34623 l -0.46044,-0.50901 -0.46095,-0.50953 0.0599,-0.36638 h -1.113642 l 0.3731,0.29249 0.4625,0.36328 v 0.0997 0.0997 h -0.0997 -0.0997 l -0.36277,-0.4625 -0.30747,-0.39274 z m 6.522093,0 v 2.4412 h 0.0176 l 0.16329,0.26458 0.1633,0.26459 h -0.13177 -0.1323 l -0.0801,-0.12971 v 1.81694 l 0.49403,0.77825 0.64182,1.01079 -0.0816,0.24185 -0.0817,0.24133 -0.66042,-0.34314 -0.31213,-0.16226 v 2.00143 l 1.71979,-0.1447 0.15503,-0.2098 0.15503,-0.21033 0.59118,-0.33021 0.59118,-0.33073 h 0.40824 0.40825 l 0.11937,-0.33021 0.11937,-0.33073 -0.34726,-1.6521 -0.34727,-1.65261 h 0.20464 0.20464 l 0.46819,0.79324 0.46819,0.79323 h 0.18965 0.18965 l 0.1695,0.53433 0.1695,0.53434 -1.2051,1.34048 -1.20509,1.34101 0.26665,0.49816 0.26665,0.49816 0.58859,0.30231 0.5886,0.30179 0.52813,0.47749 0.52865,0.47697 1.495,1.35651 1.49448,1.35702 0.1726,-0.27905 0.1726,-0.27957 -0.16329,-0.26407 -0.1633,-0.26458 h 0.23874 0.23926 l 0.42995,0.47594 0.43047,0.47542 -0.71986,1.01338 -0.71933,1.01337 -0.13436,-0.75964 -0.13436,-0.76016 -0.79065,-0.16899 -0.79065,-0.16898 -1.88464,-0.0315 -1.88464,-0.0315 -0.69195,-0.90744 -0.69246,-0.90795 v -0.14934 -0.14987 h 0.28112 0.28112 l 1.68982,0.81546 1.69034,0.81545 0.262,-0.16175 0.26148,-0.16174 -1.08159,-1.44694 -1.08159,-1.44694 -0.29249,-0.0331 -0.29197,-0.0331 -0.79323,-0.0331 -0.79272,-0.0331 0.0894,-0.63408 0.0894,-0.63406 -1.24953,0.17104 -0.95912,0.1323 v 1.69447 l 0.0718,0.0212 -0.0718,0.0682 v 1.19527 l 0.5762,-0.35657 v 0.13385 0.13281 l -0.51574,1.1529 -0.0605,0.13539 v 3.31091 l 0.11473,-0.57568 h 0.2005 0.20051 l 0.12815,0.4899 0.12764,0.48885 1.51722,0.89917 1.51671,0.89866 0.69866,0.46509 0.69815,0.46612 0.50901,0.1726 0.50902,0.17208 -0.5793,0.21446 -0.57929,0.21393 -0.98702,-0.54621 -0.9865,-0.54726 -0.25115,-0.23978 -0.25115,-0.23874 h -0.47542 -0.47594 v 0.24495 0.24598 l 0.36484,0.34933 0.36483,0.34881 1.56166,1.49603 1.56218,1.49604 0.50798,0.0899 0.5085,0.0899 0.21084,-1.42317 0.21084,-1.42369 -0.25735,-0.31005 -0.25735,-0.31006 0.7829,-0.46251 0.78289,-0.4625 v 0.34985 0.34985 l 1.61593,0.64233 1.6154,0.64183 0.61444,0.48369 0.61443,0.48317 -0.40308,0.98496 -0.40359,0.98495 -0.35708,0.37103 -0.35657,0.37052 -0.92243,-0.76687 -0.92242,-0.7674 -0.0191,-0.46767 -0.0191,-0.46819 0.64595,0.16226 0.64544,0.16227 0.29249,-0.18087 0.29197,-0.18035 -0.33228,-0.40049 -0.33228,-0.40049 -0.62631,-0.23823 -0.62684,-0.23823 -0.35605,0.19947 -0.35657,0.19947 -0.83095,1.14774 -0.83096,1.14773 0.12195,0.31832 0.12196,0.31833 1.7539,0.3483 1.7539,0.34882 0.27853,0.52141 0.27906,0.52142 -0.0873,0.0703 -0.0879,0.0708 -0.83716,0.28267 -0.83716,0.28215 -0.45889,-0.50746 -0.45888,-0.50746 h -0.33383 -0.33332 l -0.10903,0.32814 -0.10956,0.32815 -0.37517,-0.39429 -0.37517,-0.3943 -0.38654,-0.74827 -0.38602,-0.74828 -1.40147,0.0868 -1.40095,0.0873 -0.13746,-0.4346 -0.13746,-0.43513 -0.98185,-0.18448 -0.98237,-0.18397 -0.70952,-0.42375 v 1.56993 l 0.0491,0.0548 v 0.36794 0.36794 l -0.0491,-0.005 v 0.78858 l 0.70952,0.10697 0.79272,0.11937 1.03715,0.14315 1.03714,0.14314 0.35037,0.29094 0.35036,0.29042 v 0.56999 0.56947 l 0.38396,0.54881 0.38447,0.54828 -0.71468,-0.12815 -0.71417,-0.12868 -0.26459,-0.20412 -0.26406,-0.20412 -0.81442,-0.12713 -0.81391,-0.1266 -0.32711,0.524 -0.32763,0.52451 0.67903,0.97979 0.67903,0.9803 v 0.31626 0.31574 l 0.19792,-0.0444 0.19844,-0.0444 0.98133,0.20464 0.98186,0.20412 0.30385,0.36587 0.30334,0.36639 0.27544,-0.17053 0.27492,-0.17002 -0.19585,0.31678 -0.19534,0.31678 0.32246,0.38912 0.32298,0.38913 -0.30024,1.49396 -0.29973,1.49448 v 0.22015 0.22014 h 0.41135 0.41082 l 0.52607,-1.18959 0.52607,-1.18959 h 0.50798 0.50798 l -0.16847,0.43976 -0.16898,0.43977 0.37517,-0.22634 0.37517,-0.22635 -0.34778,0.42995 -0.3483,0.42943 0.72089,0.47232 0.72088,0.47233 0.28784,-0.50488 0.28784,-0.5054 0.6382,-0.66559 0.63769,-0.66559 0.15503,0.43201 0.15503,0.43202 1.18907,0.88883 1.18908,0.88884 0.66094,0.30282 -0.003,5.3e-4 0.66094,0.30282 0.0341,0.0181 0.0341,0.0176 1.50895,-0.90899 1.50947,-0.90899 1.03611,-1.59577 1.03663,-1.59525 -0.26096,-1.13068 -0.26046,-1.13068 -0.006,-1.75597 -0.006,-1.75648 -0.33021,-0.11627 -0.33021,-0.11576 -0.65939,0.16537 -0.65939,0.16536 -0.0904,0.47077 -0.0904,0.47078 0.42013,0.46457 0.42012,0.46457 -0.17518,0.17518 -0.17518,0.17518 0.49971,0.55243 0.49971,0.55242 -0.73742,-0.33642 -0.73794,-0.3359 -0.53485,-1.20612 -0.53537,-1.20613 -0.50591,-0.99942 -0.50591,-0.99942 v -0.78548 -0.78497 h 0.51314 0.51263 l 0.1633,-0.26406 0.1633,-0.26458 h 0.65371 0.65319 l 0.16484,-0.42892 0.16485,-0.42943 -0.41703,-0.23358 -0.41651,-0.23306 -0.54932,-0.88883 -0.5488,-0.88884 v -0.82785 -0.82838 h 0.77359 0.7736 l 0.51676,0.65732 0.51677,0.65733 0.17983,1.43919 0.17983,1.43919 0.32402,0.26923 0.32401,0.26872 0.65009,-0.37207 0.6506,-0.37207 0.59428,-0.31729 0.5948,-0.3173 v -0.22169 -0.22221 h 0.26458 0.26407 l -0.008,0.33073 -0.008,0.33021 -1.20768,0.73381 -1.20768,0.7338 0.29972,0.36122 0.29973,0.36122 0.53588,0.14056 0.5364,0.14004 0.14418,-0.3762 0.14418,-0.37569 h 0.72037 0.72088 l 0.16227,-0.16278 0.16226,-0.16226 -0.41289,-0.63097 -0.4129,-0.63046 h 0.20929 0.20929 l 0.72037,0.85938 0.71985,0.85886 0.20412,-0.19998 0.20361,-0.19999 -0.59945,-1.20096 -0.59944,-1.20096 -0.64751,-0.64802 -0.64802,-0.64751 h -1.42265 -1.42266 l -0.41496,-0.41548 -0.41548,-0.41548 v -0.36535 -0.36483 l 1.59991,-0.93793 1.5999,-0.93793 h 0.18654 0.18707 l 0.76222,-0.70745 0.76275,-0.70745 -0.7183,-0.61805 -0.71831,-0.61856 -0.24546,0.15192 -0.24495,0.15141 v 0.49403 0.49351 l -2.18022,0.83768 -2.18023,0.83715 -0.43615,0.38861 -0.43615,0.38861 -0.6873,-0.90124 -0.68678,-0.90124 v -0.17311 -0.17364 h 1.71773 1.71772 v -0.53485 -0.53536 l -0.72605,-0.27647 -0.72606,-0.27595 -0.70228,0.41496 -0.70177,0.41496 h -0.30747 -0.30748 l 0.16072,-0.50746 0.16123,-0.50747 -0.47336,-0.13384 -0.47387,-0.13384 -0.79272,-0.15658 -0.79271,-0.15606 -0.52865,-0.10284 -0.52865,-0.10335 -0.69763,-0.17828 -0.69815,-0.17829 -0.15607,0.2527 -0.15657,0.25321 2.06808,1.202 2.0681,1.20199 -0.2248,1.54047 -0.22427,1.541 0.15761,2.31303 0.15813,2.31356 -0.22221,-0.004 -0.22221,-0.004 -0.38137,-0.24133 -0.38085,-0.24081 -0.30231,0.41289 -0.30179,0.41341 0.11937,0.62529 0.11937,0.62528 0.4315,0.0305 0.43202,0.0305 -0.48214,0.12558 -0.48163,0.12454 0.14108,0.36793 0.14108,0.36742 -0.33745,0.80305 -0.33797,0.80357 -0.1142,-0.0925 -0.11472,-0.0925 -0.45631,0.47853 -0.4563,0.47852 0.4563,0.23564 0.45631,0.23565 1.34565,0.31574 1.34566,0.31523 1.41076,1.27072 1.41077,1.27021 -0.0196,1.22835 -0.0196,1.22887 -0.43046,0.65732 -0.43047,0.65681 h -0.21756 -0.21807 l -0.58446,-0.50695 -0.58498,-0.50746 -0.0837,-0.61599 -0.0842,-0.6165 -0.20205,-1.14618 -0.20154,-1.14618 -0.39739,-0.15296 -0.3974,-0.15245 -0.35553,0.48628 -0.35553,0.48679 -0.1819,-0.18242 -0.18242,-0.18294 0.56637,-0.76481 0.56586,-0.76584 -0.35398,-0.29352 -0.35347,-0.29404 -1.86965,-0.0615 -1.86966,-0.061 0.14211,-0.66095 0.14263,-0.66094 1.09967,-0.99063 1.10019,-0.99064 0.19793,-5.3e-4 0.19843,-0.001 v -0.39584 -0.39688 h -0.24908 -0.24856 l -0.1633,0.26459 -0.1633,0.26406 -0.57877,-0.0134 -0.57929,-0.0145 0.59479,-0.41496 0.59428,-0.41496 v -0.33228 -0.33176 l 0.41806,-0.34727 0.41807,-0.34674 0.4935,-0.94103 0.493,-0.94103 0.32918,-0.61392 0.32918,-0.61391 -0.35606,-0.22014 -0.35604,-0.22015 -1.41284,-0.17621 -1.41283,-0.17673 v -0.19276 -0.19223 l 0.29765,-0.29818 0.29766,-0.29766 -0.17208,-0.68626 -0.17209,-0.68574 -0.52916,0.28318 -0.52968,0.28371 0.1819,0.31677 0.1819,0.3173 -0.22118,-0.20051 -0.22066,-0.2005 -0.59066,0.555 -0.59066,0.55501 -0.46405,-0.0894 -0.46457,-0.0899 -0.0873,-0.26459 -0.0873,-0.26458 0.62993,-0.39636 0.63045,-0.39635 1.33274,-1.05782 1.33273,-1.0573 0.14883,-0.34727 0.14883,-0.34726 -0.82527,-0.75396 -0.82527,-0.75396 0.17001,-0.67748 0.17001,-0.67799 -0.99477,-0.62839 -0.99425,-0.62787 -0.26458,-0.0579 -0.26407,-0.0568 -0.39636,-0.33693 -0.39636,-0.33796 -0.43046,-0.15193 -0.43048,-0.15096 -0.27336,0.27337 -0.27337,0.27337 -0.3173,-0.19637 -0.31781,-0.19637 0.14005,-1.04335 0.14004,-1.04438 0.38757,-0.44235 0.38758,-0.44184 0.18707,-0.6134 0.18706,-0.61339 -0.52244,-0.13643 -0.52245,-0.13694 -0.42168,-0.9679 -0.42168,-0.96893 -0.27596,-0.76223 -0.27543,-0.76171 -1.1529,0.15813 -1.1529,0.15813 -0.86972,-1.02268 -0.7431,-0.87282 z m 1.82262,0 0.66198,0.32712 h 0.36742 0.3669 v -0.32712 z m 7.61556,0 0.0636,0.56948 0.0708,0.63975 0.27079,0.3266 0.2713,0.32659 0.31884,-0.0667 0.31833,-0.0661 0.66094,-0.27698 0.66042,-0.27699 1.1896,-0.46664 1.18907,-0.46663 0.31367,-0.24237 h -4.68653 l 0.0124,0.062 -0.30954,-0.062 z m 7.9592,0 1.12603,1.03715 h 5.3e-4 l 1.21388,1.1188 0.31523,0.0104 0.31471,0.0108 0.13539,-0.21963 0.13591,-0.21963 -0.85731,-1.3007 -0.28836,-0.43718 z m 2.93678,0 -0.0103,0.0315 0.44079,0.92915 0.44081,0.92914 0.30592,0.18965 0.30644,0.18914 2.55695,0.19844 2.55695,0.19791 1.02423,0.54933 1.02474,0.54932 0.16072,0.45837 0.16019,0.45785 -0.12195,0.46715 -0.12196,0.46664 h -0.22427 -0.22376 l -0.28061,-0.524 -0.2806,-0.52451 -1.38027,-0.63614 -1.3808,-0.63614 -1.77818,-0.16846 -1.77819,-0.16795 0.14624,0.38086 0.14625,0.38137 1.00924,0.6997 1.00924,0.6997 1.3131,0.34623 1.3131,0.34675 0.49867,0.2899 0.4992,0.28991 -0.26458,0.0119 -0.26407,0.0124 0.34726,0.22014 0.34675,0.22014 1.70119,-0.4718 1.70067,-0.47181 v 0.24753 0.24753 h 0.52865 0.52865 v -0.36432 -0.36432 l -0.40618,-0.97203 -0.40617,-0.97255 -0.52504,0.16691 -0.52451,0.1664 -0.50901,-1.15032 -0.5085,-1.15083 -0.60875,-0.54829 -0.60823,-0.54828 -0.42995,-0.1509 -0.43046,-0.15089 -0.27337,0.27388 -0.27337,0.27337 -0.31781,-0.19637 -0.31729,-0.19637 0.0703,-0.52193 z m 13.27774,0 v 0.52607 l 0.33021,0.27234 0.33022,0.27181 1.18907,0.17364 1.18959,0.17414 0.39636,0.062 0.39636,0.062 0.52865,0.28888 0.52865,0.28939 0.93793,-0.0863 0.93844,-0.0863 0.31471,0.50384 0.31471,0.50385 -0.7028,-0.26717 -0.70228,-0.26717 -0.19431,0.31471 -0.1943,0.31471 -1.38338,-0.16433 -1.38338,-0.16382 -0.43924,-0.39739 -0.43977,-0.39791 -0.97772,-0.15554 -0.97772,-0.15555 v 0.48266 0.48214 l 1.43351,1.12035 1.4335,1.11982 h 0.39274 0.39274 l 1.54565,-0.4811 1.54512,-0.48111 0.91674,0.37414 0.91622,0.37413 0.79944,0.70177 0.79891,0.70228 -0.0785,1.63453 -0.078,1.63452 0.23823,0.87695 0.23823,0.87695 0.32246,-0.0734 0.32195,-0.0724 -0.14728,0.23875 -0.14779,0.23823 0.89141,0.94516 0.8909,0.94568 0.6904,0.17311 0.68988,0.17312 v -0.2496 -0.24959 l -0.96376,-1.23817 -0.96429,-1.23765 0.15968,-0.15968 0.15968,-0.15968 1.39888,1.33273 1.3994,1.33274 0.70797,0.555 0.70848,0.55449 0.15658,-0.25321 0.15658,-0.25322 -1.19527,-1.34669 -1.19528,-1.34617 v -0.11523 -0.11472 l 0.33021,0.14418 0.33073,0.14366 1.34876,1.61282 1.34927,1.61282 -0.80253,1.13895 -0.80254,1.13895 -0.10542,-0.10542 -0.10542,-0.10542 0.28009,-0.52349 0.28008,-0.52399 -0.32504,-0.25735 -0.32453,-0.25787 -1.0573,-0.21756 -1.05678,-0.21807 -0.85938,0.0718 -0.85887,0.0718 v -0.28474 -0.28525 h -0.24959 -0.2496 l -1.19786,-1.25574 -1.19734,-1.25574 -0.006,-0.99529 -0.006,-0.99477 -0.24908,-0.4594 -0.24805,-0.45889 -0.45165,-1.26452 -0.45114,-1.26504 -0.29145,0.0992 -0.29042,0.0992 -0.0289,0.63665 -0.0284,0.63717 -0.0377,0.46251 -0.0372,0.4625 h -0.49609 -0.49609 l -0.31626,0.38137 -0.31626,0.38086 -0.90175,-0.50643 -0.90124,-0.50643 -0.33435,0.13178 -0.33435,0.13177 -0.5643,1.68362 -0.56431,1.68362 0.54777,0.54777 0.54777,0.54828 0.94155,-0.56895 0.94154,-0.56844 -0.4625,0.53278 -0.46251,0.53227 v 0.31884 0.31936 l -0.46199,0.70539 -0.46198,0.70538 -0.13488,-0.77876 -0.13487,-0.77877 -0.79065,-0.16898 -0.79065,-0.1695 -1.88464,-0.031 -1.88464,-0.0315 -0.69195,-0.90744 -0.69195,-0.90795 v -0.14986 -0.14987 h 0.2806 0.28112 l 1.71825,0.82941 1.71824,0.82889 0.25838,-0.2589 0.25839,-0.25838 -0.40773,-0.33848 -0.40721,-0.33848 -0.009,-0.29766 -0.009,-0.29817 -0.4961,-0.5948 -0.49609,-0.59531 h -0.27854 -0.27905 l -0.27337,-0.51108 -0.27389,-0.5116 v -0.11627 -0.11679 l 0.79324,-0.15864 0.79272,-0.15865 v -0.41341 -0.41393 l -1.18495,0.0765 -1.18494,0.077 -0.52245,1.21491 -0.52296,1.21491 -0.4067,0.33745 -0.40669,0.33745 v 0.36432 0.36432 h 0.25063 0.25063 l -0.007,1.53272 -0.007,1.53272 -1.10225,-0.0367 -1.10175,-0.0372 -0.26458,-0.062 -0.26407,-0.0615 0.92501,-0.33434 0.92501,-0.33383 v -0.63356 -0.63355 l -0.49713,-0.0961 -0.49661,-0.0956 -0.21652,0.35036 -0.21653,0.34985 -0.8723,-0.99735 -0.87229,-0.99787 -0.79324,-0.0532 -0.79271,-0.0537 0.10283,0.39635 0.10232,0.39688 -0.0346,0.79271 -0.0346,0.79324 0.19638,0.27854 0.19636,0.27801 1.58544,1.08417 1.58595,1.08366 0.61805,0.18345 0.61805,0.18294 1.58026,0.96635 1.58078,0.96635 0.70849,0.4656 0.70849,0.4656 0.50901,0.17209 0.50902,0.17208 -0.57878,0.21446 -0.57878,0.21394 -1.25161,-0.68627 -1.2516,-0.68626 -0.25115,-0.23203 -0.25115,-0.23151 h -1.21511 -1.21492 l -1.02164,-1.04644 -1.02113,-1.04697 -0.22427,0.13901 -0.22428,0.13849 0.0615,0.80667 0.0615,0.80615 0.2713,0.0801 0.27182,0.0791 0.72709,0.15969 0.72657,0.15916 v 0.78807 0.78806 h 0.23202 0.23203 l 0.39998,-0.59479 0.39946,-0.5948 0.19998,0.19275 0.19948,0.19275 -0.71159,1.07642 -0.7121,1.07591 -1.31413,-0.9648 -1.31414,-0.9648 -0.39118,0.15038 -0.3912,0.14986 v 0.27544 0.27543 l 0.54932,0.45992 0.54933,0.45992 0.3917,0.74466 0.39119,0.74466 0.7519,-0.16537 0.75189,-0.16536 0.17311,0.28008 0.1726,0.28009 h 0.50798 0.50798 l 0.1602,-0.72709 0.1602,-0.72708 0.19688,-0.66095 0.19689,-0.66094 0.77101,-0.14728 0.77153,-0.14727 1.18908,0.99787 1.18908,0.99787 1.03869,0.91984 1.03818,0.92036 0.21394,-0.13178 0.21394,-0.13229 -0.12609,0.34417 -0.12609,0.34416 1.15135,1.22577 1.15084,1.22576 0.69556,-0.13281 0.69608,-0.13332 v -0.20309 -0.20361 l -0.38654,-0.74517 -0.38654,-0.74517 0.12713,-0.12713 0.12712,-0.12712 1.0635,1.03869 1.0635,1.03922 0.14935,0.59634 0.14986,0.59635 h 1.27537 1.27538 l 0.66869,0.25425 0.66869,0.25424 0.16382,-0.26613 0.16433,-0.26561 -0.32194,-0.3881 -0.32195,-0.3886 0.709,-0.65733 0.70952,-0.65784 h 0.13436 0.13384 l -0.14469,0.2341 -0.1447,0.23461 0.58136,0.15193 0.58084,0.15193 -0.57154,0.60926 -0.57205,0.60927 0.2222,0.36018 0.22273,0.36019 0.30024,-0.18552 0.30024,-0.18604 -0.0724,0.35037 -0.0729,0.34985 0.35037,-0.0729 0.34985,-0.0729 -0.13436,0.21756 -0.13436,0.21755 0.18086,0.26975 0.18087,0.27027 2.15543,1.59215 -0.001,-0.002 2.15542,1.59215 1.80868,-0.47129 1.80867,-0.4718 1.10743,-0.0155 1.10691,-0.0155 1.22111,-1.0573 1.22163,-1.05782 h 0.24805 0.24856 v -0.32042 -0.31988 l -1.11259,-1.13378 -1.11208,-1.13378 h -0.34107 -0.34157 v 0.14314 0.14263 l 0.52865,1.03611 0.52864,1.03663 v 0.14211 0.14367 h -0.20205 -0.20205 l -0.62736,-1.32241 -0.62735,-1.32188 h -0.22789 -0.22789 v -0.47904 -0.47904 l -0.78187,-0.57878 -0.78238,-0.57774 h -0.17673 -0.17725 l 0.13229,1.17357 0.13229,1.17409 -0.38137,-0.38034 -0.38086,-0.38137 h -0.50178 -0.50126 l 0.17002,0.44183 0.1695,0.44287 -0.41652,-0.15968 -0.41651,-0.15968 -0.15554,0.15503 -0.15555,0.15606 0.29404,0.3545 0.29455,0.35502 0.56224,0.002 0.56224,0.002 0.76482,0.50436 0.76429,0.50437 0.35863,-0.13798 0.35864,-0.13746 v 0.13022 0.13023 l -0.35657,0.68729 -0.35605,0.68678 -0.16433,-0.16381 -0.16381,-0.16433 -1.31259,0.56482 -1.31258,0.56483 h -0.78755 -0.78806 l -0.48421,-0.6563 -0.48473,-0.65577 -0.66094,-0.1173 -0.66042,-0.11783 -0.15606,-0.0196 -0.15607,-0.0196 -0.32969,-1.12344 -0.3297,-1.12396 -0.43666,-0.92501 -0.43667,-0.92553 -0.24443,-0.17466 -0.24391,-0.17467 -0.94775,0.14573 -0.94774,0.14624 -0.72657,0.36587 -0.72658,0.36587 v 0.52193 0.52194 h -0.36018 -0.36018 l -1.02733,-0.81494 -1.02733,-0.81546 -0.21963,-0.3886 -0.2191,-0.38861 0.37672,-0.58084 0.37672,-0.58033 0.14728,-0.78341 0.14676,-0.7829 -1.03095,-1.00098 -1.03146,-1.00149 v -0.3054 -0.30593 l 0.46251,0.37156 0.4625,0.37155 0.59118,0.33073 0.59066,0.33021 h 0.3638 0.3638 l 0.99788,0.79324 0.99735,0.79323 h -0.25011 -0.25012 l -0.51314,-0.38809 -0.51263,-0.38861 -0.17002,-0.008 -0.17001,-0.008 -0.15968,0.416 -0.15917,0.41548 0.31419,0.57567 0.31472,0.57568 -0.0765,0.79323 -0.0765,0.79323 -0.24546,0.29973 -0.24598,0.29972 0.42219,0.16175 0.4222,0.16226 0.57568,-0.29869 0.57567,-0.29817 0.3204,-0.25373 0.32039,-0.25373 -0.40928,-0.62477 -0.40927,-0.62529 0.17053,-0.27595 0.17053,-0.27595 h 0.76171 0.7612 l 0.16329,0.26458 0.16382,0.26407 h 0.26406 0.23306 v 0.23978 0.27026 l 0.53227,0.28526 0.53279,0.28525 0.0977,-0.3421 0.0982,-0.34158 0.30696,-1.12913 0.30644,-1.12913 -0.1602,-0.25941 -0.16071,-0.25994 -0.49506,0.26511 -0.49506,0.2651 h -0.48731 -0.48731 l -2.01073,-2.00557 -2.01125,-2.00556 -0.15141,0.24495 -0.15089,0.24443 0.51779,0.96686 0.5178,0.96687 v 0.13281 0.13332 h -0.2589 -0.2589 l -0.51986,-1.02009 -0.52038,-1.02009 -1.27951,0.12299 -1.27899,0.12299 -0.35244,-0.42478 -0.35243,-0.42478 -0.56224,0.004 -0.56224,0.004 -0.59479,0.15968 -0.5948,0.15916 v 0.36587 0.36587 l -0.19792,-0.004 -0.19844,-0.004 -0.79272,-0.72244 -0.79271,-0.72295 -0.85886,-1.233 -0.85887,-1.233 v -0.18697 -0.18759 l 0.40721,0.33848 0.40773,0.33797 1.24385,0.63458 1.24437,0.63407 1.71773,0.21911 1.71824,0.21859 0.23978,-0.2222 0.23978,-0.22273 -0.27079,-0.34158 -0.27027,-0.3421 -0.13074,-0.72709 -0.13126,-0.72657 h 0.23616 0.23565 l 0.15606,0.40618 0.15606,0.40618 0.786,0.40669 0.78652,0.40721 -0.16795,0.57464 -0.16846,0.57464 -0.10646,0.46302 -0.10645,0.46251 h 0.38137 0.38086 v -0.2465 -0.2465 l 0.52865,-0.16794 0.52864,-0.16795 v -0.47853 -0.47852 l -0.39635,-0.32918 -0.39636,-0.32918 v -0.27285 -0.27337 l -0.66094,-0.86661 -0.66043,-0.86661 v -0.14987 -0.14934 h 0.64492 0.64493 l 0.1633,-0.26458 0.16329,-0.26459 h 0.23875 0.23823 l 0.27026,1.00304 0.26975,1.00252 0.55863,0.59997 0.55862,0.59944 0.66404,0.2527 0.66404,0.2527 -0.27802,0.33486 -0.27853,0.33538 0.22324,0.98961 0.22324,0.99012 0.35192,0.45527 0.35243,0.45475 0.72864,0.72709 0.72864,0.72708 h 0.26665 0.26665 v -0.24494 -0.24547 l -0.66043,-0.51986 -0.66094,-0.51986 v -0.34314 -0.34261 l 0.33073,0.38344 0.33021,0.38395 0.71469,0.62684 0.71417,0.62683 1.79627,-1.65416 1.79627,-1.65364 0.96893,-0.61754 0.96894,-0.61753 -0.13746,-0.5271 -0.13798,-0.52658 -0.65009,-0.42633 -0.6506,-0.42634 0.14624,-0.70951 0.14625,-0.71004 -1.85364,-1.12344 -1.85415,-1.12345 h -0.40463 -0.40514 l 0.1633,0.26407 0.1633,0.26458 h -0.24753 -0.24753 l -0.30644,-0.36949 -0.30696,-0.37 0.11782,-0.65009 0.11782,-0.65009 0.55552,-1.1498 0.55501,-1.14928 -0.63511,-0.54054 -0.63458,-0.54053 -0.47026,-1.28158 -0.47025,-1.28157 -0.37724,-0.14521 -0.37776,-0.1447 -0.23357,0.36897 -0.23358,0.36897 -0.004,0.21394 -0.004,0.21394 0.33021,-0.19843 0.33021,-0.19844 -0.32349,0.39997 -0.3235,0.4005 1.05058,1.02577 1.05007,1.0263 v 0.22841 0.22841 l -0.71417,0.93637 -0.71416,0.9369 -0.49817,-0.61598 -0.49867,-0.61599 0.28783,-0.0961 0.28733,-0.0956 v -0.31419 -0.3142 l -0.81081,-0.98443 -0.81132,-0.98392 0.18707,-0.59635 0.18655,-0.59634 0.48886,-0.6258 0.48834,-0.6258 -0.14418,-0.23307 -0.14417,-0.23358 h -0.3173 -0.31729 l -0.33021,-0.52916 -0.33073,-0.52968 0.0884,-0.0615 h -0.82166 l 0.0336,0.85524 h 0.20309 0.20309 l 0.17208,0.54157 0.17157,0.54105 -0.31833,0.38396 -0.31884,0.38395 h -0.22221 -0.22273 l -0.24494,-0.46302 -0.24547,-0.4625 -0.13332,-1.00666 -0.10284,-0.77359 h -0.87953 l 0.002,0.031 -0.30128,0.18603 h -5.3e-4 l -0.30127,0.18655 -2.47272,0.0336 -2.4722,0.0341 0.14935,-0.47077 z m 11.66131,0 0.0403,0.10491 0.33435,-0.10491 z m 2.19573,0 -0.64906,0.12196 -0.14469,0.23409 -0.1447,0.23462 0.1633,0.26458 0.1633,0.26407 h 0.87695 0.87694 l 0.33849,-0.40773 0.33848,-0.40773 -0.27182,-0.2713 -0.0331,-0.0326 z m 2.30063,0 -0.001,0.003 0.0119,-0.003 z m 1.41025,0 -0.39016,0.0977 -0.28267,0.52866 -0.28318,0.52864 0.42168,0.64338 0.42116,0.64285 h 0.17467 0.17466 l 1.07435,-0.49299 1.07487,-0.493 1.26814,-0.45888 1.26866,-0.4594 -0.10284,-0.30335 -0.0791,-0.23357 z m 6.95203,0 -0.33486,0.40308 0.51211,0.29197 0.5116,0.29197 1.07228,0.98496 v -0.001 l 1.07229,0.98495 0.18242,0.007 0.18242,0.007 0.16019,-0.2589 0.15968,-0.25839 -0.60668,-0.86506 -0.60668,-0.86506 -0.185,-0.13953 -0.18449,-0.13953 -0.20412,-0.44338 z m 3.07992,0 -0.21291,0.5731 0.44545,0.49299 0.44597,0.49247 v 0.43667 0.43718 l 0.60616,0.15193 0.60668,0.15245 0.71056,-0.12919 0.71055,-0.12868 0.13487,0.21808 0.13539,0.21859 -0.41651,0.15968 -0.41651,0.1602 h -0.65784 -0.65732 l 0.0847,0.56585 0.0842,0.56638 0.58704,0.21549 0.58705,0.216 0.38499,-0.3855 0.38499,-0.38499 h 0.14469 0.14417 l -0.14986,0.85886 -0.14934,0.85938 -0.39946,1.27279 -0.39894,1.27331 0.14779,0.14728 0.14728,0.14779 0.41393,-0.15865 0.41393,-0.15864 0.16639,-0.46871 0.1664,-0.4687 0.33797,-0.3974 0.33796,-0.39687 0.38757,-0.74827 0.38809,-0.74776 -0.35966,-0.6935 -0.35967,-0.6935 0.12041,-0.1204 0.12092,-0.12093 0.5643,0.5054 0.56431,0.50488 0.22479,0.35398 v -1.81126 l -0.16175,-0.262 -0.16329,-0.26458 h 0.13229 0.13229 l 0.0605,0.0982 v -2.53938 h -2.62413 l 0.34314,0.32246 0.63923,0.60048 0.34365,-0.13178 0.34417,-0.13177 0.0357,0.59221 0.0362,0.5917 -0.89814,0.27595 -0.89814,0.27595 -0.27026,-0.50539 -0.27027,-0.50489 h -0.34623 -0.34624 l -0.46043,-0.50901 -0.46096,-0.50953 0.0599,-0.36638 h -1.11363 l 0.3731,0.29249 0.46251,0.36328 v 0.0997 0.0997 h -0.0997 -0.0997 l -0.36277,-0.4625 -0.30748,-0.39274 z m -113.832853,0.16374 v 0.1602 0.16071 l -0.89607,0.32401 -0.896069,0.32402 -0.149862,1.11672 -0.150378,1.11725 -0.1726,1.85053 -0.172082,1.85053 -0.397392,0.85938 -0.397391,0.85938 h -0.362252 -0.362769 l -1.192692,-0.31936 -1.193209,-0.31936 v -0.22118 -0.22117 l 0.330212,0.0434 0.330729,0.0429 0.461988,-0.0315 0.462504,-0.0315 v -0.21446 -0.21446 l -0.765845,-0.56689 -0.766361,-0.56689 -0.683679,-0.17157 -0.683163,-0.17156 -0.279053,0.73484 -0.279053,0.73432 0.160197,0.73019 0.160197,0.72967 0.709518,0.16898 0.709517,0.16898 1.189592,0.59687 1.189075,0.59634 0.474906,-0.23513 0.47439,-0.23564 1.166337,-1.5844 1.16582,-1.5844 -0.156579,-2.46031 -0.15658,-2.4598 0.254248,-0.1571 0.254247,-0.15761 0.904338,0.62322 0.904338,0.6227 1.123445,0.68988 1.122929,0.68988 v 0.39325 0.39326 H 55.477842 55.14143 l -1.404049,-0.92552 -1.404567,-0.92501 h -0.241329 -0.241329 v 0.64182 0.64234 l 0.351401,0.3514 0.351917,0.35191 -0.109556,0.32815 -0.109037,0.32815 h 1.917197 1.917195 l 0.476456,-0.4315 0.476456,-0.4315 0.674894,0.44235 0.674897,0.44235 0.226859,-0.14004 0.227375,-0.14056 -0.03669,0.42478 -0.03617,0.42426 -0.725538,0.7891 -0.726053,0.78962 0.173632,0.30334 0.173633,0.30385 -0.216524,-0.19637 -0.216006,-0.19585 -0.354499,0.29456 -0.355018,0.29455 v 0.23203 0.23202 h 0.441833 0.441317 l 1.431954,-1.51515 1.431954,-1.51515 -1.278475,-1.05782 -1.278993,-1.05833 -1.896007,-1.81384 -1.895493,-1.81436 -0.813385,-0.0563 z m 67.733853,0 v 0.1602 0.16071 l -0.89607,0.32401 -0.89607,0.32402 -0.14986,1.11672 -0.15038,1.11725 -0.1726,1.85053 -0.17208,1.85053 -0.39739,0.85938 -0.39739,0.85938 h -0.36226 -0.36277 l -1.19269,-0.31936 -1.19321,-0.31936 v -0.22118 -0.22117 l 0.33022,0.0434 0.33072,0.0429 0.46199,-0.0315 0.46251,-0.0315 v -0.21446 -0.21446 l -0.76585,-0.56689 -0.76636,-0.56689 -0.68368,-0.17157 -0.68316,-0.17156 -0.27905,0.73484 -0.27906,0.73432 0.1602,0.73019 0.1602,0.72967 0.70952,0.16898 0.70951,0.16898 1.18959,0.59687 1.18908,0.59634 0.4749,-0.23513 0.47439,-0.23564 1.16634,-1.5844 1.16582,-1.5844 -0.15658,-2.46031 -0.15658,-2.4598 0.25425,-0.1571 0.25425,-0.15761 0.90433,0.62322 0.90434,0.6227 1.12345,0.68988 1.12293,0.68988 v 0.39325 0.39326 h -0.33642 -0.33641 l -1.40405,-0.92552 -1.40456,-0.92501 h -0.24133 -0.24133 v 0.64182 0.64234 l 0.3514,0.3514 0.35192,0.35191 -0.10956,0.32815 -0.10904,0.32815 h 1.9172 1.91719 l 0.47646,-0.4315 0.47646,-0.4315 0.67489,0.44235 0.6749,0.44235 0.22686,-0.14004 0.22737,-0.14056 -0.0367,0.42478 -0.0367,0.42426 -0.72502,0.7891 -0.72657,0.78962 0.17364,0.30334 0.17415,0.30385 -0.21705,-0.19637 -0.216,-0.19585 -0.3545,0.29456 -0.35502,0.29455 v 0.23203 0.23202 h 0.44183 0.44184 l 1.43143,-1.51515 1.43247,-1.51515 -1.27899,-1.05782 -1.27899,-1.05833 -1.89601,-1.81384 -1.89549,-1.81436 -0.81338,-0.0563 z m -58.48429,0.42685 h 0.396359 0.396359 v 0.52865 0.52865 H 62.024729 61.62837 v -0.52865 z m 67.73385,0 h 0.39636 0.39636 v 0.52865 0.52865 h -0.39636 -0.39636 v -0.52865 z m -34.876423,0.0227 -0.968418,0.29765 -0.968414,0.29715 v 0.23564 0.23564 l -0.24288,-0.15037 -0.243395,-0.14987 -0.376206,0.37621 -0.376203,0.3762 -0.07131,1.54306 -0.07132,1.54254 -0.07855,1.05782 -0.07803,1.0573 -0.02379,0.43356 -0.02429,0.43305 -0.481107,0.5948 -0.481624,0.59428 -1.368393,-0.35089 -1.36891,-0.35088 v -0.21446 -0.21394 h 0.680062 0.680579 l -0.08578,-0.43718 -0.08526,-0.43718 -0.952916,-0.49455 -0.953429,-0.49454 -0.398425,0.15296 -0.398425,0.15297 -0.280604,0.61598 -0.280086,0.61547 0.391708,0.55965 0.392224,0.56017 1.107942,0.48163 1.107943,0.48162 0.660424,0.29301 0.660942,0.29352 0.131776,0.0119 0.132292,0.0119 0.548285,-0.45682 0.548804,-0.45682 0.987536,-1.52394 0.988055,-1.52393 -0.154514,-0.48628 -0.154511,-0.48679 -0.209807,-1.7446 -0.210323,-1.74511 0.546219,-0.0791 0.545704,-0.0775 0.481623,0.59531 0.481627,0.5948 h 0.221691 0.221176 l 1.081069,0.70796 1.080556,0.70797 v 0.17312 0.17363 l -0.165883,0.16588 -0.165881,0.16588 -1.221113,-0.67489 -1.221631,-0.6749 -0.251148,-0.24029 -0.251148,-0.23978 h -0.497644 -0.497644 l 0.136943,0.33021 0.136943,0.33073 0.322977,0.99116 0.323495,0.99167 h 1.853115 1.853632 l 0.42117,-0.38138 0.42116,-0.38137 0.85473,0.41445 0.85524,0.41444 v 0.31368 0.31419 l -0.81545,0.7767 -0.81597,0.77618 -0.25373,0.46819 -0.25374,0.46819 0.16175,0.26199 0.16175,0.26201 1.56838,-1.36478 1.568383,-1.36426 v -0.34259 -0.3421 l -1.235583,-1.13843 -1.23507,-1.13792 -0.42582,-0.39687 -0.42529,-0.39636 -1.599388,-1.37666 z m 67.733853,0 -0.96841,0.29765 -0.96842,0.29715 v 0.23564 0.23564 l -0.24288,-0.15037 -0.2434,-0.14987 -0.3762,0.37621 -0.3762,0.3762 -0.0713,1.54306 -0.0713,1.54254 -0.0785,1.05782 -0.078,1.0573 -0.0238,0.43356 -0.0243,0.43305 -0.48111,0.5948 -0.48162,0.59428 -1.36839,-0.35089 -1.36891,-0.35088 v -0.21446 -0.21394 h 0.68006 0.68058 l -0.0863,-0.43718 -0.0853,-0.43718 -0.95291,-0.49455 -0.95343,-0.49454 -0.39843,0.15296 -0.39842,0.15297 -0.2806,0.61598 -0.28009,0.61547 0.39171,0.55965 0.39222,0.56017 1.10794,0.48163 1.10795,0.48162 0.66042,0.29301 0.66094,0.29352 0.13178,0.0119 0.13229,0.0119 0.54829,-0.45682 0.5488,-0.45682 0.98754,-1.52394 0.98805,-1.52393 -0.15451,-0.48628 -0.15451,-0.48679 -0.20981,-1.7446 -0.21032,-1.74511 0.54622,-0.0791 0.5457,-0.0775 0.48162,0.59531 0.48163,0.5948 h 0.22169 0.22118 l 1.08106,0.70796 1.08056,0.70797 v 0.17312 0.17363 l -0.16588,0.16588 -0.16588,0.16588 -1.22112,-0.67489 -1.22163,-0.6749 -0.25115,-0.24029 -0.25114,-0.23978 h -0.49765 -0.49764 l 0.13694,0.33021 0.13694,0.33073 0.32298,0.99116 0.3235,0.99167 h 1.85311 1.85364 l 0.42116,-0.38138 0.42116,-0.38137 0.85473,0.41445 0.85525,0.41444 v 0.31368 0.31419 l -0.81546,0.7767 -0.81597,0.77618 -0.25373,0.46819 -0.25373,0.46819 0.16175,0.26199 0.16174,0.26201 1.56838,-1.36478 1.56838,-1.36426 v -0.34259 -0.3421 l -1.23558,-1.13843 -1.23507,-1.13792 -0.42581,-0.39687 -0.4253,-0.39636 -1.59938,-1.37666 z m -117.108617,0.59066 -1.255221,0.11627 -1.255224,0.11679 v 0.24029 0.2403 l 0.56431,0.45992 0.564824,0.45992 1.417484,1.44074 1.417485,1.44074 v 0.19224 0.19223 l 0.462504,0.10542 0.462504,0.1049 0.185002,-0.0935 0.185001,-0.093 -1.047998,-2.16833 -1.048515,-2.16834 -0.326078,-0.29353 z m 67.733847,0 -1.25522,0.11627 -1.25522,0.11679 v 0.24029 0.2403 l 0.56431,0.45992 0.56482,0.45992 1.41749,1.44074 1.41748,1.44074 v 0.19224 0.19223 l 0.46251,0.10542 0.4625,0.1049 0.185,-0.0935 0.185,-0.093 -1.04799,-2.16834 -1.04852,-2.16834 -0.32608,-0.29352 z m -28.596186,0.47956 -0.198953,0.12298 -0.198953,0.12248 0.154511,0.40359 0.15503,0.40308 0.375687,-0.14418 0.376206,-0.14418 -0.143145,0.231 -0.142626,0.23151 0.351917,0.29197 0.351398,0.29197 0.188103,-0.18759 0.187584,-0.1881 -0.191719,0.50075 -0.192236,0.50023 0.439251,-0.16847 0.439248,-0.16847 -0.06304,0.32092 -0.06305,0.32091 0.350366,-0.0734 0.349851,-0.0724 -0.157615,0.25476 -0.157612,0.25528 0.825788,0.94103 0.826307,0.94154 h 0.368969 0.36897 v -0.0884 -0.0884 l -1.144633,-2.31923 -1.145148,-2.31976 -1.155486,-0.0863 z m 67.733856,0 -0.19895,0.12298 -0.19896,0.12248 0.15452,0.40359 0.15502,0.40308 0.37569,-0.14418 0.37621,-0.14418 -0.14315,0.231 -0.14262,0.23151 0.35191,0.29197 0.3514,0.29197 0.1881,-0.18759 0.18759,-0.1881 -0.19172,0.50075 -0.19223,0.50023 0.43924,-0.16847 0.43925,-0.16847 -0.0636,0.32092 -0.063,0.32091 0.35036,-0.0734 0.34985,-0.0724 -0.15761,0.25476 -0.15761,0.25528 0.82578,0.94103 0.82631,0.94154 h 0.36897 0.36897 v -0.0884 -0.0884 l -1.14463,-2.31923 -1.14515,-2.31976 -1.15549,-0.0863 z m -102.501758,0.16846 -0.994771,0.18655 -0.995288,0.18656 -0.163815,0.26509 -0.163814,0.26562 0.501778,1.36271 0.502295,1.36271 0.303858,0.60099 0.30334,0.601 0.282671,-0.0941 0.28267,-0.0935 0.07028,-2.32182 z m 67.733858,0 -0.99478,0.18655 -0.99529,0.18656 -0.16381,0.26509 -0.16381,0.26562 0.50178,1.36271 0.50229,1.36271 0.30386,0.60099 0.30334,0.601 0.28267,-0.0941 0.28267,-0.0935 0.0703,-2.32182 z m -79.045312,0.0605 h 0.35967 0.35915 l 0.37104,0.59479 0.37052,0.5948 -0.1292,0.99167 -0.12919,0.99116 h -0.19688 -0.19689 l -0.72347,-0.67076 -0.72399,-0.67076 0.18655,-0.45269 0.18656,-0.45268 0.13332,-0.46302 z m 67.733852,0 h 0.35967 0.35915 l 0.37103,0.59479 0.37053,0.5948 -0.1292,0.99167 -0.12919,0.99116 h -0.19688 -0.19689 l -0.72347,-0.67077 -0.72399,-0.67075 0.18656,-0.45269 0.18655,-0.45269 0.13332,-0.46302 z m -33.175237,0.26458 h 0.132292 0.132291 v 0.1323 0.13177 h -0.132291 -0.132292 v -0.13177 z m 67.733857,0 h 0.13229 0.13229 v 0.1323 0.13177 h -0.13229 -0.13229 v -0.13177 z m -86.232986,0.17622 0.176215,0.17622 0.176218,0.17621 -0.176218,0.17622 -0.176215,0.17621 v -0.35243 z m 67.733856,0 0.17621,0.17622 0.17622,0.17621 -0.17622,0.17622 -0.17621,0.17621 v -0.35243 z m -31.937076,0.1018 -0.786516,0.21032 -0.786514,0.21033 -0.08785,0.4563 -0.08785,0.4563 0.3483,0.41962 0.3483,0.41961 0.01188,0.29507 0.01241,0.29456 0.450101,1.0144 h 5.29e-4 l 0.450101,1.01493 0.334346,-0.11214 0.33383,-0.11213 -0.09043,-2.09238 -0.09147,-2.09238 -0.179316,-0.19121 z m 67.733856,0 -0.78651,0.21032 -0.78652,0.21033 -0.0884,0.4563 -0.0873,0.4563 0.3483,0.41962 0.3483,0.41961 0.0119,0.29507 0.0124,0.29456 0.4501,1.0144 h 5.3e-4 l 0.4501,1.01493 0.33435,-0.11214 0.33382,-0.11213 -0.0904,-2.09238 -0.0915,-2.09238 -0.17931,-0.19121 z m -56.75364,1.8371 h 0.13229 0.13177 v 0.13177 0.13229 h -0.13177 -0.13229 v -0.13229 z m 67.73385,0 h 0.13229 0.13178 v 0.13177 0.13229 h -0.13178 -0.13229 v -0.13229 z m -116.228572,1.89807 -0.241329,0.23048 -0.241329,0.23048 0.637688,0.28112 0.637686,0.28112 0.89762,0.65422 0.898136,0.65422 h 0.336931 0.337447 l 0.812871,-0.68471 0.813385,-0.68419 v -0.33642 -0.33641 l -2.444811,-0.1447 z m 67.733852,0 -0.24133,0.23048 -0.24133,0.23048 0.63769,0.28112 0.63769,0.28112 0.89762,0.65422 0.89813,0.65422 h 0.33693 0.33745 l 0.81287,-0.68471 0.81339,-0.68419 v -0.33642 -0.33641 l -2.44482,-0.1447 z m -15.67088,0.0532 -0.26458,0.008 -0.26407,0.008 -0.59479,0.70642 -0.59428,0.70745 v 0.4625 0.46302 l 1.89291,-0.15916 0.25011,-0.0212 v -1.9544 z m 67.73386,0 -0.26459,0.008 -0.26406,0.008 -0.5948,0.70642 -0.59428,0.70745 v 0.4625 0.46302 l 1.89291,-0.15916 0.25011,-0.0212 v -1.9544 z m -110.97153,0.045 -0.253214,0.38964 -0.252699,0.38964 0.152445,0.64492 0.151929,0.64493 0.775663,0.79323 0.775148,0.79323 v 0.18345 0.18345 l 0.513146,0.13437 0.513146,0.13435 0.136427,-0.13642 0.135908,-0.13591 -0.518831,-1.01699 -0.518314,-1.017 0.363802,0.13953 0.364318,0.14004 0.603581,1.17409 0.604099,1.17461 h 0.222724 0.222726 v -0.24443 -0.24392 l 0.618567,-0.74724 0.61805,-0.74724 0.284221,-0.83457 0.284218,-0.83406 -0.468704,-0.12247 -0.468704,-0.12299 -0.433567,0.24288 -0.434081,0.24339 v 0.3452 0.34572 l -1.300697,-0.29301 -1.300694,-0.29301 -0.69505,-0.6537 z m 67.73385,0 -0.25321,0.38964 -0.2527,0.38964 0.15244,0.64492 0.15193,0.64493 0.77567,0.79323 0.77514,0.79323 v 0.18345 0.18345 l 0.51315,0.13437 0.51315,0.13435 0.13642,-0.13642 0.13591,-0.13591 -0.51883,-1.01699 -0.51831,-1.017 0.3638,0.13953 0.36432,0.14004 0.60358,1.17409 0.6041,1.17461 h 0.22272 0.22273 v -0.24443 -0.24392 l 0.61856,-0.74724 0.61805,-0.74724 0.28422,-0.83457 0.28422,-0.83406 -0.4687,-0.12247 -0.46871,-0.12299 -0.43356,0.24288 -0.43408,0.24339 v 0.3452 0.34572 l -1.3007,-0.29301 -1.3007,-0.29301 -0.69504,-0.6537 z m -35.682577,0.35864 -0.171048,0.27698 -0.171051,0.27699 0.610817,0.2589 0.610299,0.25941 1.057299,0.62322 1.056783,0.62373 0.436149,-0.1142 0.435636,-0.11369 0.72915,-0.76171 0.72967,-0.76119 -0.37259,-0.11938 -0.37207,-0.11885 -2.289779,-0.16485 z m 67.733857,0 -0.17105,0.27698 -0.17105,0.27699 0.61082,0.2589 0.6103,0.25941 1.05729,0.62322 1.05679,0.62373 0.43615,-0.1142 0.43563,-0.11369 0.72915,-0.76171 0.72968,-0.76119 -0.37259,-0.11938 -0.37207,-0.11885 -2.28978,-0.16485 z m -109.495132,0.71933 -0.417029,0.34572 -0.416512,0.34571 v 0.6196 0.61909 l 0.492476,0.26355 0.491959,0.26355 0.763262,0.14056 0.76326,0.14107 0.792718,0.2434 v -5.3e-4 l 0.792715,0.2434 0.759127,0.0227 0.759127,0.0222 -0.305406,-0.36794 -0.305409,-0.36845 -0.850077,-0.34365 -0.850077,-0.34313 -1.057301,-0.67386 -1.056783,-0.67386 -0.178285,-0.25012 z m 67.733852,0 -0.41703,0.34572 -0.41651,0.34571 v 0.6196 0.61909 l 0.49248,0.26355 0.49195,0.26355 0.76327,0.14056 0.76326,0.14107 0.79271,0.2434 v -5.3e-4 l 0.79272,0.2434 0.75913,0.0227 0.75912,0.0222 -0.3054,-0.36794 -0.30541,-0.36845 -0.85008,-0.34365 -0.85008,-0.34313 -1.0573,-0.67386 -1.05678,-0.67386 -0.17828,-0.25012 z m -37.910866,0.01 0.176215,0.17622 0.176218,0.17622 h -0.352433 -0.352435 l 0.176217,-0.17622 z m 67.733856,0 0.17621,0.17622 0.17622,0.17622 h -0.35243 -0.35243 l 0.17621,-0.17622 z m -74.076622,0.35245 v 0.13229 0.13229 h 0.132292 0.131775 v -0.13229 -0.13229 H 75.23891 Z m 67.733852,0 v 0.13229 0.13229 h 0.13229 0.13178 v -0.13229 -0.13229 h -0.13178 z m -50.364369,0.17363 -0.360185,0.49248 -0.359669,0.49247 v 0.1633 0.1633 l 0.330729,0.45269 0.330729,0.4532 0.660426,0.12815 0.659908,0.12816 1.321366,0.37104 1.321367,0.37104 0.627355,0.0238 0.62683,0.0238 -0.30799,-0.37104 -0.30748,-0.37104 -1.376654,-0.70435 -1.376143,-0.70435 -0.895038,-0.55655 z m 67.733859,0 -0.36019,0.49248 -0.35967,0.49247 v 0.1633 0.1633 l 0.33073,0.45269 0.33073,0.4532 0.66043,0.12815 0.6599,0.12816 1.32137,0.37104 1.32137,0.37104 0.62735,0.0238 0.62684,0.0238 -0.308,-0.37104 -0.30747,-0.37104 -1.37666,-0.70435 -1.37614,-0.70435 -0.89504,-0.55655 z m -81.931959,0.091 h 0.131776 0.132292 v 0.13229 0.1323 h -0.132292 -0.131776 v -0.1323 z m 67.733859,0 h 0.13177 0.13229 v 0.13229 0.1323 h -0.13229 -0.13177 v -0.1323 z m -75.930259,0.23048 -0.173114,0.45165 -0.173117,0.45165 0.465603,0.34107 0.465606,0.34054 0.644406,-0.29403 0.644922,-0.29404 -0.07855,-0.41548 -0.07855,-0.41548 -0.858345,-0.0827 z m 67.733859,0 -0.17312,0.45165 -0.17311,0.45165 0.4656,0.34107 0.4656,0.34054 0.64441,-0.29403 0.64492,-0.29404 -0.0791,-0.41548 -0.078,-0.41548 -0.85835,-0.0827 z m -78.976065,0.29352 -0.853178,0.72915 -0.853179,0.72968 0.160714,0.58084 0.160713,0.58033 0.435115,0.093 0.435634,0.093 0.516763,-0.93793 0.517282,-0.93793 0.01138,-0.37465 0.01138,-0.37466 -0.271301,-0.0904 z m 67.733855,0 -0.85318,0.72915 -0.85318,0.72968 0.16071,0.58084 0.16072,0.58033 0.43511,0.093 0.43564,0.093 0.51676,-0.93793 0.51728,-0.93793 0.0114,-0.37465 0.0114,-0.37466 -0.2713,-0.0904 z m -21.57388,0.48318 -0.3669,0.0506 h -0.73743 -0.7369 l -0.34933,0.33021 -0.34882,0.33073 -0.39688,-0.007 -0.39635,-0.007 -0.30645,-0.19224 -0.30644,-0.19224 -0.42013,0.16124 -0.42012,0.16123 v -0.29249 -0.29249 h -0.301803 -0.30179 l -0.75034,0.78496 -0.74982,0.78549 0.15089,0.39429 0.15141,0.39429 0.53744,0.17053 0.53692,0.17053 0.22737,-0.35863 0.22738,-0.35864 0.004,-0.447 0.004,-0.447 0.264063,-0.16381 0.26459,-0.1633 -0.0196,0.47852 -0.0191,0.47801 -0.448553,0.7643 -0.44855,0.76429 -2.57039,0.0351 -2.569869,0.0351 0.136943,-0.4315 0.136943,-0.4315 -0.336415,-0.27802 -0.336413,-0.27802 -0.968417,-0.18138 -0.968415,-0.18087 -0.947748,0.34262 -0.947227,0.34261 v 0.35192 0.35192 l 0.375687,0.14417 0.375688,0.14418 0.535368,-0.2868 0.535369,-0.28629 0.639236,0.63924 0.639238,0.63923 1.554943,0.20826 1.554943,0.20826 0.132292,0.0362 0.131776,0.0367 0.396878,0.14934 0.39636,0.14986 1.23403,0.31885 1.23455,0.31832 0.274923,-0.17001 0.27491,-0.17002 0.16485,-0.98185 0.16433,-0.98237 0.27596,-0.89865 0.27543,-0.89866 0.26148,0.46768 0.26149,0.46715 -0.0139,1.02423 -0.0145,1.02371 0.41392,0.41393 0.41393,0.41392 0.69298,-0.78496 0.69247,-0.78548 0.72657,-0.45011 0.22737,-0.14056 z m 67.73385,0 -0.3669,0.0506 h -0.73742 -0.73691 l -0.34933,0.33021 -0.34882,0.33073 -0.39687,-0.007 -0.39636,-0.007 -0.30644,-0.19224 -0.30644,-0.19224 -0.42013,0.16124 -0.42013,0.16123 v -0.29249 -0.29249 h -0.30179 -0.30179 l -0.75034,0.78496 -0.74983,0.78549 0.1509,0.39429 0.15141,0.39429 0.53743,0.17053 0.53692,0.17053 0.22738,-0.35863 0.22737,-0.35864 0.004,-0.447 0.004,-0.447 0.26458,-0.16381 0.26407,-0.1633 -0.0191,0.47852 -0.0191,0.47801 -0.44856,0.7643 -0.44855,0.76429 -2.57038,0.0351 -2.56987,0.0351 0.13694,-0.4315 0.13694,-0.4315 -0.33641,-0.27802 -0.33641,-0.27802 -0.96842,-0.18138 -0.96842,-0.18087 -0.94774,0.34262 -0.94723,0.34261 v 0.35192 0.35192 l 0.37569,0.14417 0.37569,0.14418 0.53536,-0.2868 0.53537,-0.28629 0.63924,0.63924 0.63923,0.63923 1.55495,0.20826 1.55494,0.20826 0.13229,0.0362 0.13178,0.0367 0.39688,0.14934 0.39635,0.14986 1.23404,0.31885 1.23455,0.31832 0.27491,-0.17001 0.27492,-0.17002 0.16485,-0.98185 0.16433,-0.98237 0.27596,-0.89865 0.27543,-0.89866 0.26148,0.46768 0.26148,0.46715 -0.0139,1.02423 -0.0145,1.02371 0.41392,0.41393 0.41394,0.41392 0.69298,-0.78496 0.69246,-0.78548 0.72657,-0.45011 0.22738,-0.14056 z m -113.071654,0.447 -0.438732,1.18959 -0.439251,1.18959 -2.937806,0.0749 -2.93832,0.0744 v -0.22012 -0.22014 l 0.308507,-0.30851 0.307991,-0.30851 -0.419611,-0.16123 -0.420129,-0.16123 -0.350885,-0.0532 -0.350882,-0.0532 -0.335897,-0.20929 -0.33538,-0.2098 -0.985986,0.31522 -0.985469,0.31471 -0.240296,0.22169 -0.239779,0.22118 0.325562,0.39171 0.325045,0.39222 0.443384,-0.16278 0.442867,-0.16227 0.232544,-0.3886 0.232543,-0.38809 0.334347,0.79478 0.333828,0.79479 1.944069,0.2899 1.944068,0.29042 1.057299,0.36794 1.056783,0.36845 0.898136,-0.0274 0.89762,-0.0269 0.500745,-1.71876 0.501261,-1.71824 0.05478,-0.39687 0.05478,-0.39636 h -0.389123 z m 67.733854,0 -0.43873,1.18959 -0.43926,1.18959 -2.9378,0.0749 -2.93832,0.0744 v -0.22012 -0.22014 l 0.30851,-0.30851 0.30799,-0.30851 -0.41961,-0.16123 -0.42013,-0.16123 -0.35089,-0.0532 -0.35088,-0.0532 -0.3359,-0.20929 -0.33538,-0.2098 -0.98598,0.31522 -0.98547,0.31471 -0.2403,0.22169 -0.23978,0.22118 0.32557,0.39171 0.32504,0.39222 0.44338,-0.16278 0.44287,-0.16227 0.23254,-0.3886 0.23255,-0.38809 0.33435,0.79478 0.33383,0.79479 1.94406,0.2899 1.94407,0.29042 1.0573,0.36794 1.05678,0.36845 0.89814,-0.0274 0.89762,-0.0269 0.50074,-1.71876 0.50126,-1.71824 0.0548,-0.39687 0.0548,-0.39636 h -0.38912 z m -53.081517,0.39635 h 0.874363 0.874366 l 0.486791,0.35657 v -5.3e-4 l 0.487309,0.35657 -0.267684,0.16536 -0.267166,0.16537 -0.145211,-0.14521 -0.144695,-0.1447 -0.486791,-0.092 -0.486275,-0.092 -0.462505,-0.0202 -0.462502,-0.0207 v -0.26406 z m 67.733857,0 h 0.87436 0.87437 l 0.48679,0.35657 v -5.3e-4 l 0.48731,0.35657 -0.26768,0.16536 -0.26717,0.16537 -0.14521,-0.14521 -0.1447,-0.1447 -0.48679,-0.092 -0.48628,-0.092 -0.4625,-0.0202 -0.4625,-0.0207 v -0.26406 z m -39.24361,0.2279 1.09451,0.32814 1.09399,0.32763 -0.34158,0.32298 -0.3421,0.32298 -0.59221,0.17776 -0.59273,0.17777 -0.30902,-0.67903 -0.30954,-0.67954 0.14934,-0.14935 z m 67.73386,0 1.09451,0.32814 1.09398,0.32763 -0.34157,0.32298 -0.3421,0.32298 -0.59221,0.17776 -0.59273,0.17777 -0.30903,-0.67903 -0.30954,-0.67954 0.14934,-0.14935 z m -91.995941,0.0367 h 0.132291 0.132292 v 0.13229 0.13177 H 78.67436 78.542069 v -0.13177 z m 67.733851,0 h 0.1323 0.13229 v 0.13229 0.13177 h -0.13229 -0.1323 v -0.13175 z m -102.188597,0.26408 h 0.14056 0.140043 l 0.756543,0.65061 0.756543,0.65009 -0.140043,0.14004 -0.140044,0.14004 -0.756543,-0.79013 z m 37.626126,0 h 0.132292 0.132291 v 0.13229 0.13229 h -0.132291 -0.132292 v -0.13229 z m 30.107721,0 h 0.14056 0.14005 l 0.75654,0.65061 0.75654,0.65009 -0.14004,0.14004 -0.14004,0.14004 -0.75654,-0.79013 z m 37.62614,0 h 0.13229 0.13229 v 0.13229 0.13229 h -0.13229 -0.13229 v -0.13229 z m -58.975221,2.45721 -0.342099,0.21136 -0.341582,0.21136 0.124542,0.1018 0.124539,0.1018 1.321367,0.74208 1.321366,0.74155 0.72967,0.38138 0.729674,0.38085 -0.184486,0.29818 -0.183968,0.29817 -0.115239,1.46554 -0.115237,1.46606 -0.02066,0.79272 -0.02119,0.79323 0.159681,0.84336 0.159679,0.84284 0.181385,0.29353 0.181385,0.29352 0.338998,-0.28164 0.338997,-0.28164 0.201539,0.86352 0.201019,0.86351 -0.01654,0.14159 -0.01654,0.1416 0.443903,0.031 0.443383,0.031 1.057302,0.17673 1.0573,0.17725 -0.52865,-0.49454 -0.52865,-0.49455 -0.328666,-0.51624 -0.329179,-0.51573 -0.791681,-1.32189 -0.791683,-1.32188 -0.0021,-0.60307 -0.0021,-0.60306 0.437701,-0.16795 0.4377,-0.16846 0.664559,0.37465 0.664039,0.37465 0.42065,1.84795 0.42064,1.84744 0.48059,0.0925 0.48008,0.0925 1.498623,-1.01028 1.49861,-1.01027 0.52607,-0.27544 0.52658,-0.27595 0.077,-0.40049 0.077,-0.40101 -2.07171,0.0884 -2.072223,0.0879 -0.51315,-0.57361 -0.51366,-0.57361 0.49661,-0.29662 0.49661,-0.29714 1.749763,-1.14773 1.74977,-1.14773 0.59479,-0.55036 0.59438,-0.55087 v 0.31057 0.31058 h -0.29873 -0.29869 l 0.14831,0.91622 0.14883,0.91623 -0.5023,-0.3142 -0.50281,-0.31367 -0.54415,0.58446 -0.54416,0.58446 -0.80976,0.41909 -0.809773,0.41858 0.16588,0.16588 0.16588,0.16589 1.090893,0.0563 1.09089,0.0558 0.61546,-0.2341 0.61547,-0.23409 0.34107,0.13126 0.34106,0.13074 -0.0289,0.66352 -0.0294,0.66405 -0.90434,0.77307 -0.90434,0.7736 -0.29765,0.0108 -0.29817,0.0109 -0.30903,0.37207 -0.30851,0.37207 -0.92811,0.4408 -0.928623,0.4408 0.1049,0.31058 0.10439,0.31057 0.751373,-0.0904 0.75138,-0.092 0.67902,-0.42013 0.67903,-0.42013 0.59532,-0.52658 0.59531,-0.52658 0.7922,0.88728 0.7922,0.8878 v 0.36742 0.36794 l -0.72657,-0.0744 -0.72709,-0.0749 -0.29662,-0.21291 -0.29714,-0.2129 -0.42995,0.16484 -0.42943,0.16537 v 0.23616 0.23616 h -0.49661 -0.4961 l -0.33434,0.40256 -0.33435,0.40307 0.10387,0.0868 0.10387,0.0868 2.11408,-0.21807 2.11409,-0.21756 0.16174,0.0243 v -3.1099 l -0.41341,-0.2465 -1.04593,-0.62373 0.39894,-0.15297 0.39894,-0.15348 0.66146,0.30076 v -2.68201 l -0.28577,-0.37775 -0.004,-0.42995 -0.004,-0.42943 0.16485,-0.82631 0.12867,-0.64285 v -3.08974 l -0.016,0.0362 -0.51573,1.15239 -0.14521,-0.0662 -0.14469,-0.0661 -0.1323,0.0331 -0.13229,0.0331 -0.19792,0.0336 -0.19844,0.0336 -2.24637,1.09502 -2.246383,1.09451 -1.05678,0.34675 -1.0573,0.34726 -0.33796,0.4036 -0.337965,0.40359 -0.643372,-0.78807 -0.643887,-0.78806 -0.0098,-0.19844 -0.01035,-0.19792 0.726569,-0.0259 0.727089,-0.0258 1.012336,0.0475 1.01234,0.0475 -0.0873,-0.59583 -0.0873,-0.59583 -0.7369,-0.24443 -0.736906,-0.24443 -0.888834,0.42168 -0.888836,0.4222 -0.356565,-0.0212 -0.356053,-0.0207 0.330213,-0.13333 0.330214,-0.13332 v -0.50695 -0.50643 h -0.396359 -0.396359 l -0.06615,-0.016 -0.06615,-0.016 -1.76475,-0.47387 z m 67.733851,0 -0.34209,0.21136 -0.34158,0.21136 0.12454,0.1018 0.12453,0.1018 1.32137,0.74208 1.32137,0.74155 0.72967,0.38138 0.72967,0.38085 -0.18449,0.29818 -0.18396,0.29817 -0.11524,1.46554 -0.11524,1.46606 -0.0207,0.79272 -0.0217,0.79323 0.15968,0.84336 0.15968,0.84284 0.18139,0.29353 0.18138,0.29352 0.339,-0.28164 0.339,-0.28164 0.20154,0.86352 0.20101,0.86351 -0.016,0.14159 -0.0165,0.1416 0.44391,0.031 0.44338,0.031 1.0573,0.17673 1.0573,0.17725 -0.52865,-0.49454 -0.52865,-0.49455 -0.32866,-0.51624 -0.32918,-0.51573 -0.79168,-1.32189 -0.79169,-1.32188 -0.002,-0.60307 -0.002,-0.60306 0.4377,-0.16795 0.4377,-0.16846 0.66456,0.37465 0.66404,0.37465 0.42065,1.84795 0.42064,1.84744 0.48059,0.0925 0.48008,0.0925 1.49861,-1.01028 1.49862,-1.01027 0.52607,-0.27544 0.52658,-0.27595 0.077,-0.40049 0.077,-0.40101 -2.07171,0.0884 -2.07222,0.0879 -0.51315,-0.57361 -0.51366,-0.57361 0.49661,-0.29662 0.49661,-0.29714 1.74976,-1.14773 1.74977,-1.14773 0.59479,-0.55036 0.59428,-0.55087 v 0.31057 0.31058 h -0.29869 -0.29869 l 0.14832,0.91622 0.14882,0.91623 -0.50229,-0.3142 -0.50281,-0.31367 -0.54416,0.58446 -0.54415,0.58446 -0.80977,0.41909 -0.80977,0.41858 0.16588,0.16588 0.16588,0.16589 1.09089,0.0563 1.09089,0.0558 0.61547,-0.2341 0.61547,-0.23409 0.34106,0.13126 0.34106,0.13074 -0.0289,0.66352 -0.0289,0.66405 -0.90434,0.77307 -0.90434,0.7736 -0.29765,0.0108 -0.29818,0.0109 -0.30902,0.37207 -0.30851,0.37207 -0.92811,0.4408 -0.92862,0.4408 0.1049,0.31058 0.10439,0.31057 0.75137,-0.0904 0.75137,-0.092 0.67903,-0.42013 0.67903,-0.42013 0.59532,-0.52658 0.59531,-0.52658 0.7922,0.88728 0.7922,0.8878 v 0.36742 0.36794 l -0.72658,-0.0744 -0.72708,-0.0749 -0.29663,-0.21291 -0.29713,-0.2129 -0.42995,0.16484 -0.42943,0.16537 v 0.23616 0.23616 h -0.49661 -0.4961 l -0.33434,0.40256 -0.33435,0.40307 0.10387,0.0868 0.10387,0.0868 2.11408,-0.21807 2.11409,-0.21756 0.16174,0.0243 v -3.10988 l -0.41341,-0.24649 -1.04593,-0.62374 0.39894,-0.15296 0.39894,-0.15348 0.66146,0.30076 v -2.68201 l -0.28577,-0.37775 -0.004,-0.42995 -0.004,-0.42943 0.16484,-0.82631 0.12868,-0.64285 v -3.08974 l -0.016,0.0362 -0.51573,1.15238 -0.14521,-0.0662 -0.1447,-0.0661 -0.13229,0.0331 -0.13229,0.0331 -0.19792,0.0336 -0.19844,0.0336 -2.24637,1.09503 -2.24638,1.0945 -1.05678,0.34675 -1.0573,0.34727 -0.33796,0.40359 -0.33797,0.4036 -0.64337,-0.78807 -0.64389,-0.78807 -0.01,-0.19843 -0.0104,-0.19792 0.72657,-0.0259 0.72709,-0.0258 1.01234,0.0475 1.01234,0.0475 -0.0873,-0.59583 -0.0873,-0.59583 -0.73691,-0.24443 -0.73691,-0.24443 -0.88883,0.42168 -0.88883,0.42219 -0.35657,-0.0212 -0.35605,-0.0207 0.33021,-0.13332 0.33021,-0.13333 v -0.50694 -0.50643 h -0.39636 -0.39635 l -0.0661,-0.016 -0.0662,-0.016 -1.76475,-0.47387 z m -91.292103,0.89194 0.176216,0.17622 0.176217,0.17621 h -0.352433 -0.352435 l 0.176218,-0.17621 z m 67.733853,0 0.17621,0.17622 0.17622,0.17621 h -0.35243 -0.35243 l 0.17621,-0.17621 z m -93.368462,0.79892 0.4625,0.39222 0.46251,0.39223 1.522383,0.72708 1.521871,0.72709 -0.174666,0.31006 -0.175183,0.30954 -0.397392,0.46251 -0.396875,0.4625 h -0.164848 -0.164331 l -0.389124,-0.47439 -0.389125,-0.47439 -0.85886,-1.22111 -0.85886,-1.22112 v -0.19585 z m 67.733852,0 0.4625,0.39222 0.4625,0.39223 1.52239,0.72708 1.52187,0.72709 -0.17466,0.31006 -0.17518,0.30954 -0.3974,0.46251 -0.39687,0.4625 h -0.16485 -0.16433 l -0.38912,-0.47439 -0.38913,-0.47439 -0.85886,-1.22111 -0.85886,-1.22112 v -0.19585 z m -41.799004,0.0749 1.10536,0.80305 1.105358,0.80254 0.660424,0.51004 0.660942,0.50953 -0.605647,-0.0439 -0.605131,-0.0444 -0.434599,-0.48007 -0.434081,-0.48007 -0.877983,-0.54312 -0.877983,-0.54261 0.151411,-0.24546 z m 67.733854,0 1.10536,0.80305 1.10536,0.80254 0.66043,0.51004 0.66094,0.50953 -0.60565,-0.0439 -0.60513,-0.0444 -0.43461,-0.48007 -0.43408,-0.48007 -0.87798,-0.54312 -0.87798,-0.54261 0.15141,-0.24546 z m -96.752242,0.13953 0.11008,0.33021 0.11007,0.33073 h -0.44029 -0.44028 l 0.0879,-0.26459 0.0884,-0.26458 0.24184,-0.0661 z m 67.733852,0 0.11008,0.33021 0.11007,0.33073 h -0.44029 -0.44028 l 0.0879,-0.26459 0.0884,-0.26458 0.24185,-0.0661 z m -55.688071,0.3793 -0.252698,0.15658 -0.252697,0.15606 0.12454,1.71566 0.12454,1.71617 0.15503,0.25115 0.155545,0.25167 h 0.62942 0.62942 l 0.160194,-0.2589 0.159682,-0.2589 -0.298172,-0.55759 -0.298174,-0.55759 -0.125574,-0.70383 -0.126091,-0.70383 -0.392741,-0.60307 z m 67.733851,0 -0.2527,0.15658 -0.25269,0.15606 0.12454,1.71566 0.12454,1.71617 0.15502,0.25115 0.15555,0.25167 h 0.62942 0.62942 l 0.1602,-0.2589 0.15968,-0.2589 -0.29818,-0.55759 -0.29817,-0.55759 -0.12557,-0.70383 -0.12609,-0.70383 -0.39274,-0.60307 z m -34.903296,0.008 0.707966,0.4992 0.708483,0.49971 1.153419,0.52503 1.152901,0.52503 -0.756542,0.83613 -0.75706,0.83612 -1.267105,-1.59732 -1.267624,-1.59732 0.162779,-0.26355 z m 67.733856,0 0.70797,0.4992 0.70848,0.49971 1.15342,0.52503 1.1529,0.52503 -0.75654,0.83613 -0.75706,0.83612 -1.26711,-1.59732 -1.26762,-1.59732 0.16278,-0.26355 z m -59.915213,0.48576 0.155546,1.76785 0.155546,1.76837 0.309542,0.3731 0.309544,0.37362 -0.626838,-0.0181 -0.626835,-0.0186 -0.509529,-0.19999 -0.509014,-0.19947 0.442868,-0.17001 0.443383,-0.17002 v -0.67748 -0.67799 l -0.412377,-0.15813 -0.411861,-0.15813 -0.764812,0.73277 -0.764294,0.73277 0.05323,0.29249 0.05374,0.29352 -0.264583,-0.0424 -0.264068,-0.0408 -0.404108,-0.0904 -0.404628,-0.091 -0.124023,0.26459 -0.12454,0.26458 1.982309,0.97358 1.98179,0.97359 0.197922,0.0837 0.197919,0.0832 -0.567407,1.14722 -0.567407,1.1467 -0.318844,0.12247 -0.31936,0.12247 -0.962732,-0.56844 -0.963247,-0.56844 0.0041,-0.17208 0.0036,-0.17208 0.226859,-0.35812 0.226343,-0.3576 0.546222,0.29249 0.546219,0.29249 0.190169,-0.308 0.19017,-0.30799 -0.599964,-0.48576 -0.599964,-0.48627 h -0.45625 -0.456819 l -0.853178,0.93793 -0.85266,0.93741 -0.09819,0.51056 -0.0987,0.51108 1.10691,0.30076 1.106909,0.30075 0.396359,0.0811 0.396875,0.0806 0.197921,0.0207 0.198438,0.0207 v 0.50695 0.50694 l 0.33021,0.13281 v 5.3e-4 l 0.330729,0.13281 0.958599,-1.03404 0.958599,-1.03353 0.957045,-1.60766 0.957567,-1.60765 v -0.37776 -0.37775 l -0.462505,-0.0155 -0.462505,-0.0155 0.433049,-0.29507 0.432533,-0.29456 -0.345718,-1.07745 -0.345196,-1.07797 -0.224793,-0.79065 -0.224793,-0.79013 -0.493511,-0.0951 z m 67.733853,0 0.15555,1.76785 0.15554,1.76837 0.30955,0.3731 0.30954,0.37362 -0.62684,-0.0181 -0.62683,-0.0186 -0.50953,-0.19999 -0.50901,-0.19947 0.44286,-0.17001 0.44339,-0.17002 v -0.67748 -0.67799 l -0.41238,-0.15813 -0.41186,-0.15813 -0.76481,0.73277 -0.7643,0.73277 0.0532,0.29249 0.0532,0.29352 -0.26459,-0.0424 -0.26406,-0.0408 -0.40411,-0.0904 -0.40463,-0.091 -0.12402,0.26459 -0.12454,0.26458 1.98231,0.97358 1.98179,0.97359 0.19792,0.0837 0.19792,0.0832 -0.56741,1.14722 -0.56741,1.1467 -0.31884,0.12247 -0.31936,0.12247 -0.96273,-0.56844 -0.96325,-0.56844 0.004,-0.17208 0.004,-0.17208 0.22686,-0.35812 0.22634,-0.3576 0.54623,0.29249 0.54621,0.29249 0.19017,-0.308 0.19017,-0.30799 -0.59996,-0.48576 -0.59996,-0.48627 h -0.45631 -0.45682 l -0.85317,0.93793 -0.85266,0.93741 -0.0982,0.51056 -0.0987,0.51108 1.10691,0.30076 1.1069,0.30075 0.39636,0.0811 0.39688,0.0806 0.19792,0.0207 0.19844,0.0207 v 0.50695 0.50694 l 0.33021,0.13281 v 5.3e-4 l 0.33073,0.13281 0.9586,-1.03404 0.9586,-1.03353 0.95704,-1.60766 0.95757,-1.60765 v -0.37776 -0.37775 l -0.46251,-0.0155 -0.4625,-0.0155 0.43305,-0.29507 0.43253,-0.29456 -0.34572,-1.07745 -0.3452,-1.07797 -0.22479,-0.79065 -0.22479,-0.79013 -0.49351,-0.0951 z m -119.159652,0.0455 1.10536,0.80305 1.10536,0.80305 0.66042,0.50953 0.66094,0.51005 -0.60513,-0.0444 -0.60565,-0.0439 -0.43408,-0.48064 -0.4346,-0.48007 -0.87798,-0.54261 -0.87798,-0.54311 0.15141,-0.24547 z m 67.733852,0 1.10536,0.80305 1.10536,0.80305 0.66042,0.50953 0.66094,0.51005 -0.60513,-0.0444 -0.60565,-0.0439 -0.43408,-0.48059 -0.4346,-0.48008 -0.87798,-0.5426 -0.87798,-0.54312 0.15141,-0.24546 z m -46.812651,2.12235 -0.832506,0.29042 -0.83199,0.28991 v 0.39894 0.39946 l 0.462502,-0.19069 0.461989,-0.19068 0.462502,-0.13281 0.462505,-0.13281 v -0.36591 -0.36587 h -0.0925 z m 67.733851,0 -0.83251,0.29042 -0.83199,0.28991 v 0.39894 0.39946 l 0.46251,-0.19069 0.46199,-0.19068 0.4625,-0.13281 0.4625,-0.13281 v -0.36591 -0.36587 h -0.0925 z m -56.7955,0.71055 0.900203,0.19379 0.900205,0.19327 0.264065,0.0718 0.264067,0.0708 0.744141,0.30489 0.74414,0.30541 h 0.262517 0.262515 l -0.191202,0.30902 -0.190685,0.30954 0.423746,-0.16278 0.424262,-0.16278 0.08165,0.84491 0.08165,0.84491 -0.925008,0.32608 -0.924491,0.32659 -0.660942,-0.0269 -0.660424,-0.0269 -0.462505,-0.12092 -0.462505,-0.12092 v -0.25533 -0.25476 l 0.594281,0.0517 0.594794,0.0512 0.462505,-0.0408 0.462505,-0.0408 v -0.41445 -0.41444 l -0.498163,0.15812 -0.497644,0.15813 -0.170014,-0.67851 -0.170534,-0.67851 -0.627351,-0.23874 -0.62787,-0.23875 -0.198953,-0.32194 z m 67.73386,0 0.9002,0.19379 0.9002,0.19327 0.26407,0.0718 0.26407,0.0708 0.74414,0.30489 0.74414,0.30541 h 0.26251 0.26252 l -0.1912,0.30902 -0.19069,0.30954 0.42375,-0.16278 0.42426,-0.16278 0.0811,0.84491 0.0816,0.84491 -0.92501,0.32608 -0.92449,0.32659 -0.66094,-0.0269 -0.66042,-0.0269 -0.46251,-0.12092 -0.4625,-0.12092 v -0.25533 -0.25476 l 0.59428,0.0517 0.59479,0.0512 0.46251,-0.0408 0.4625,-0.0408 v -0.41445 -0.41444 l -0.49816,0.15812 -0.49765,0.15813 -0.17001,-0.67851 -0.17053,-0.67851 -0.62735,-0.23874 -0.62787,-0.23875 -0.19896,-0.32194 z m -101.792242,0.2258 v 2.75022 l 0.72347,0.32866 1.30741,0.59428 0.5948,0.0589 0.59427,0.0589 v -0.15038 -0.15089 l -1.12292,-1.10071 -1.12345,-1.10122 -0.59066,-0.78135 z m 67.733852,0 v 2.75022 l 0.72347,0.32866 1.30741,0.59428 0.5948,0.0589 0.59427,0.0589 v -0.15038 -0.15089 l -1.12292,-1.10071 -1.12345,-1.10122 -0.59066,-0.78135 z m -17.208258,0.38551 v 0.13229 0.13229 h 0.132292 0.132291 v -0.13229 -0.13229 h -0.132291 z m 67.733858,0 v 0.13229 0.13229 h 0.13229 0.13229 v -0.13229 -0.13229 h -0.13229 z m -86.927519,1.55132 -1.106392,0.44287 -1.106392,0.44287 v 0.31832 0.31833 l 0.982884,0.37982 0.982369,0.37982 1.330153,0.70745 1.330151,0.70746 0.330213,0.0191 0.33021,0.0196 -0.0078,-0.33022 -0.0083,-0.33072 -1.52859,-1.53738 z m 67.733849,0 -1.10639,0.44287 -1.10639,0.44287 v 0.31832 0.31833 l 0.98289,0.37982 0.98236,0.37982 1.33016,0.70745 1.33015,0.70746 0.33021,0.0191 0.33022,0.0196 -0.008,-0.33022 -0.008,-0.33072 -1.52859,-1.53738 z m -52.740964,0.30541 -0.161232,0.26148 -0.161748,0.26149 H 83.019313 82.77075 v -0.10387 -0.10387 l 0.409792,-0.15762 z m 67.733854,0 -0.16123,0.26148 -0.16175,0.26149 h -0.24856 -0.24856 v -0.10387 -0.10387 l 0.40979,-0.15762 z m -67.365919,0.70125 -0.195853,0.21652 -0.195855,0.21653 0.328147,0.40514 0.328144,0.40566 -0.330729,-0.19844 -0.311608,-0.18706 -0.139528,-0.22635 -0.151929,-0.24598 0.334864,-0.19275 z m 67.733859,0 -0.19586,0.21652 -0.19585,0.21653 0.32814,0.40514 0.32815,0.40566 -0.33073,-0.19844 -0.31161,-0.18706 -0.13952,-0.22635 -0.15193,-0.24598 0.33486,-0.19275 z m -97.992477,0.35037 h 0.132292 0.131775 v 0.13229 0.13177 h -0.131775 -0.132292 v -0.13177 z m 67.733847,0 h 0.1323 0.13177 v 0.13229 0.13177 h -0.13177 -0.1323 v -0.13177 z m -57.771665,0.25734 -0.134874,0.13488 -0.134877,0.13488 0.290938,0.63872 0.290939,0.63923 0.544671,0.17312 0.544668,0.1726 v 0.18087 0.18035 l -1.78387,0.006 -1.783871,0.006 -0.749308,0.1788 -0.749824,0.17828 -0.375172,0.31161 -0.374655,0.3111 -1.254186,0.0413 -1.25367,0.0408 -0.345199,-0.47078 -0.345199,-0.47128 h -0.381889 -0.38137 v 0.39635 0.39688 l -0.330214,0.0207 -0.330213,0.0207 0.315227,0.12867 0.315743,0.12816 -0.135392,0.35347 -0.135393,0.35295 1.537375,0.0196 1.537891,0.0202 0.396359,0.0987 0.396356,0.0987 0.396359,0.14986 0.396875,0.15038 0.739489,0.16226 0.73949,0.16278 0.978236,0.91003 v 5.2e-4 l 0.978233,0.91003 0.133842,0.007 0.133842,0.007 0.328663,-1.05317 0.328663,-1.05368 v -0.2682 -0.26872 l -0.198438,0.031 -0.197921,0.0315 -0.330729,-0.0315 -0.330214,-0.031 v -0.26458 -0.26407 h 0.419098 0.419613 l 1.959052,-0.56948 1.959054,-0.56947 v -0.37362 -0.37362 l -0.528132,0.16743 -0.528651,0.16795 v -0.39475 -0.39533 l -1.493967,-0.68419 z m 67.733855,0 -0.13488,0.13488 -0.13487,0.13488 0.29093,0.63872 0.29094,0.63923 0.54467,0.17312 0.54467,0.1726 v 0.18087 0.18035 l -1.78387,0.006 -1.78387,0.006 -0.74931,0.1788 -0.74982,0.17828 -0.37517,0.31161 -0.37466,0.3111 -1.25418,0.0413 -1.25367,0.0408 -0.3452,-0.47078 -0.3452,-0.47128 h -0.38189 -0.38137 v 0.39635 0.39688 l -0.33022,0.0207 -0.33021,0.0207 0.31523,0.12867 0.31574,0.12816 -0.13539,0.35347 -0.13539,0.35295 1.53737,0.0196 1.53789,0.0202 0.39636,0.0987 0.39636,0.0987 0.39636,0.14986 0.39687,0.15038 0.73949,0.16226 0.73949,0.16278 0.97824,0.91003 v 5.2e-4 l 0.97823,0.91003 0.13384,0.007 0.13385,0.007 0.32866,-1.05317 0.32866,-1.05368 v -0.2682 -0.26872 l -0.19844,0.031 -0.19792,0.0315 -0.33073,-0.0315 -0.33021,-0.031 v -0.26458 -0.26407 h 0.4191 0.41961 l 1.95905,-0.56948 1.95905,-0.56947 v -0.37362 -0.37362 l -0.52813,0.16743 -0.52865,0.16795 v -0.39475 -0.39533 l -1.49396,-0.68419 z m -75.317372,0.007 v 0.1323 0.13229 h 0.131776 0.132291 v -0.13227 -0.1323 h -0.132291 z m 67.733852,0 v 0.1323 0.13229 h 0.13178 0.13229 v -0.13229 -0.1323 h -0.13229 z m -46.887578,0.26459 h 0.132292 0.132292 l 0.163295,0.26458 0.163299,0.26407 h -0.132292 -0.131773 l -0.163817,-0.26407 z m 67.733858,0 h 0.13229 0.13229 l 0.1633,0.26458 0.1633,0.26407 h -0.13229 -0.13178 l -0.16381,-0.26407 z m -98.886996,0.70489 0.176217,0.17621 0.1757,0.17622 h -0.351917 -0.352433 l 0.176217,-0.17622 z m 67.733856,0 0.17621,0.17621 0.1757,0.17622 h -0.35191 -0.35244 l 0.17622,-0.17622 z m -47.913359,0.79323 0.176215,0.17622 0.176218,0.17621 h -0.352433 -0.352435 l 0.176217,-0.17622 z m 67.733849,0 0.17622,0.17622 0.17622,0.17621 h -0.35244 -0.35243 l 0.17622,-0.17621 z m -61.126502,0.82786 -1.651579,0.18861 -1.651577,0.18862 -0.425297,0.22324 -0.425299,0.22325 -0.439766,0.67179 -0.439767,0.6718 h -0.408241 -0.408245 l 0.167947,-0.52917 0.167434,-0.52865 h -0.396875 -0.396875 l -0.653709,0.24856 -0.65319,0.24857 -0.176215,0.80305 -0.176218,0.80305 0.170532,0.53847 0.171051,0.53847 0.242361,-0.14935 0.241845,-0.14986 -0.174665,0.4563 -0.175183,0.45579 0.43925,-0.16847 0.439248,-0.16846 -0.06305,0.32091 -0.06304,0.32091 0.350367,-0.0729 0.349848,-0.0724 -0.155027,0.25063 -0.15503,0.25063 0.843875,0.601 0.843875,0.60099 -0.230992,-0.3824 -0.230478,-0.3824 0.438216,0.35553 0.438216,0.35553 0.293008,-0.0977 0.292486,-0.0977 -0.680061,-0.7338 -0.680577,-0.73433 v -0.43201 -0.43202 l -0.574128,-0.61185 -0.57464,-0.61184 0.376203,0.009 0.376206,0.009 0.61495,0.51211 0.614949,0.51263 -0.167949,0.27182 -0.167947,0.27182 h 0.298688 0.298691 l 0.417028,0.41702 0.417028,0.41703 0.489376,-0.12764 0.489376,-0.12816 -0.124023,0.20103 -0.124539,0.20153 0.639236,0.60048 0.639238,0.60048 0.343649,-0.13177 0.343646,-0.13177 0.03669,0.60564 0.03669,0.60514 -1.886706,0.22582 -1.886707,0.22634 -0.238228,-0.4687 -0.238744,-0.46871 -1.214914,-0.008 -1.214914,-0.008 -2.103231,-1.94924 -2.103231,-1.94923 -0.966864,-0.28991 -0.966351,-0.28938 h -0.271301 -0.271817 l -0.166399,0.4346 -0.166915,0.43511 0.443902,0.49041 0.443383,0.49041 h 0.199988 0.199469 l 1.080556,0.70797 1.081072,0.70796 v 0.17312 0.17363 l -0.165883,0.16588 -0.165881,0.16589 -1.221631,-0.6749 -1.221629,-0.67489 -0.251148,-0.2403 -0.251148,-0.23978 h -0.497644 -0.497644 l 0.136943,0.33022 0.136943,0.33073 0.323493,0.99115 0.322976,0.99167 h 1.853634 1.853118 l 0.421164,-0.38137 0.421161,-0.38138 0.855247,0.41445 0.854728,0.41444 v 0.31368 0.31419 l -0.815456,0.7767 -0.815454,0.77618 -0.25373,0.46819 -0.253733,0.46818 0.168985,0.27389 0.168981,0.27388 1.412832,-1.33686 1.413352,-1.33687 h 0.657323 0.657325 l 0.54777,0.69659 0.547253,0.6966 v 0.35192 0.3514 l 0.583428,0.31213 0.583427,0.31212 0.275434,-0.48524 0.275952,-0.48576 0.637689,-0.66559 0.637685,-0.66611 0.15503,0.41393 0.15503,0.41341 1.66243,1.37872 1.66243,1.37873 0.318328,-0.10645 0.318844,-0.10594 0.0011,-0.50746 0.0011,-0.50695 -0.367419,-0.28783 -0.367419,-0.28784 0.241845,-0.43202 0.241845,-0.43201 0.654741,0.33951 0.65474,0.34003 1.361673,-0.0165 1.36116,-0.0165 -0.0987,0.1602 -0.0987,0.15968 0.639239,0.60048 0.639236,0.60048 0.343648,-0.13178 0.343649,-0.13177 0.03617,0.59738 0.03669,0.59789 -0.829408,0.24598 -0.828889,0.2465 -0.528649,-0.48938 -0.52865,-0.48885 -1.004591,-0.82424 -1.004589,-0.82424 -0.257866,0.25735 -0.257349,0.25786 0.92501,1.16944 0.925007,1.16944 0.535368,0.0336 0.535369,0.0331 0.198437,0.0434 0.197919,0.0439 -0.721402,0.39171 -0.721402,0.39171 -0.929662,-0.38861 -0.930174,-0.38861 -1.689304,-1.20612 -1.689817,-1.20613 -0.623218,0.1018 -0.623218,0.10129 -0.296624,-0.23565 -0.297138,-0.23564 -0.402561,0.15451 -0.402558,0.15451 -0.127641,0.57723 -0.127124,0.57722 -0.610298,1.6428 -0.609783,1.64331 0.445969,0.49248 0.445965,0.49299 v 0.43666 0.43667 l 0.606166,0.15244 0.606166,0.15245 0.711067,-0.12919 0.71055,-0.12868 0.134876,0.21808 0.134874,0.21859 -0.416512,0.15968 -0.41651,0.1602 h -0.657408 -0.657323 l 0.08423,0.56585 0.08423,0.56586 0.587044,0.21601 0.587563,0.21549 0.38499,-0.38499 0.384987,-0.38551 h 0.134361 0.134358 l -0.156062,0.99168 -0.155549,0.99115 -0.35605,1.02474 -0.356049,1.02475 v 0.25063 0.24856 l 0.455784,-0.0879 0.455787,-0.0879 0.271301,-0.53175 0.270786,-0.53227 0.557072,-0.78755 0.556553,-0.78755 0.123508,-0.38963 0.123507,-0.38965 -0.340031,-0.65577 -0.340032,-0.65577 0.127124,-0.12713 0.127124,-0.12712 1.058852,1.03456 1.059365,1.03456 0.432533,-0.27285 0.432531,-0.27285 0.06976,-0.47697 0.07028,-0.47698 0.547769,-0.58342 0.54777,-0.58343 v -0.2713 -0.2713 l -1.123445,-1.18649 -1.122929,-1.18701 -0.925007,-0.1788 -0.92501,-0.1788 -1.39733,-0.56172 -1.396813,-0.56173 -0.160197,0.16072 -0.160197,0.16019 0.349332,0.42117 0.349851,0.42168 0.481107,-0.1261 0.481105,-0.12609 -0.12402,0.20154 -0.124542,0.20102 0.639238,0.601 0.639236,0.60048 0.343649,-0.13178 0.343649,-0.13229 0.03617,0.59222 0.03565,0.59221 -0.898136,0.27595 -0.898136,0.27543 -0.270267,-0.50487 -0.270269,-0.50488 h -0.346215 -0.345715 l -0.460955,-0.50953 -0.460436,-0.50902 0.230476,-1.40766 0.230476,-1.40767 0.915707,0.0754 0.916223,0.0749 0.08785,0.25528 0.08837,0.25529 h 0.227375 0.227893 l 2.424142,1.16995 2.423626,1.16944 0.365868,-0.14056 0.365353,-0.14005 v -0.23616 -0.23616 h 0.257865 0.257347 l -0.14986,0.85938 -0.149346,0.85886 -0.399458,1.27331 -0.398941,1.27279 0.147793,0.14779 0.147278,0.1478 0.413928,-0.15916 0.41393,-0.15865 0.166396,-0.46871 0.166399,-0.4687 0.337963,-0.39739 0.337966,-0.39688 0.387572,-0.74827 0.388091,-0.74776 -0.35967,-0.6935 -0.359666,-0.6935 0.120406,-0.1204 0.120923,-0.12092 0.564306,0.50539 0.564306,0.50488 0.641821,1.01079 0.642339,1.01079 -0.08165,0.24185 -0.08165,0.24184 -0.792715,-0.41186 -0.793235,-0.41186 -0.02739,-0.0475 -0.02739,-0.0475 -0.699183,0.83095 -0.699182,0.83148 v 0.39222 0.39223 l 1.651579,10e-4 1.651579,0.001 1.255221,0.185 1.25522,0.18552 v -0.28629 -0.28628 l 0.553972,-0.55397 0.553971,-0.55397 -0.656291,-0.70177 -0.656291,-0.70177 -0.172598,-0.57206 -0.172601,-0.57257 0.171566,-0.68368 0.171566,-0.68316 0.169498,0.006 0.1695,0.006 0.74414,1.05213 0.743623,1.05161 h 0.278021 0.278019 l -0.187587,-0.59479 -0.187584,-0.5948 -0.139526,-0.79323 -0.140044,-0.79323 -0.426331,-0.48628 -0.426847,-0.48627 -0.95963,0.15347 -0.959633,0.15348 -0.875398,-1.02888 -0.875398,-1.02887 -1.059368,-0.1695 -1.059368,-0.1695 -1.29346,-0.65009 -1.292945,-0.64957 h -1.797303 -1.796788 l -0.691949,-0.90796 -0.691946,-0.90744 v -0.14985 -0.14987 h 0.28112 0.280604 l 1.690335,0.81545 1.690336,0.81546 0.261482,-0.16175 0.261483,-0.16174 -1.081588,-1.44694 -1.081587,-1.44694 -0.291971,-0.0326 -0.292489,-0.0331 -0.759645,-0.0331 -0.759642,-0.0331 -0.06615,-0.83199 -0.06666,-0.83199 -0.495062,-0.69557 -0.495578,-0.69556 -0.925007,0.11834 -0.925007,0.11782 -0.792718,0.17105 -0.792716,0.17105 0.528651,-0.42685 0.528132,-0.42633 1.387512,-0.70332 1.387512,-0.70383 v -0.36742 z m 67.733852,0 -1.65157,0.18861 -1.65159,0.18862 -0.42529,0.22324 -0.4253,0.22325 -0.43977,0.67179 -0.43976,0.6718 h -0.40825 -0.40824 l 0.16795,-0.52917 0.16743,-0.52865 h -0.39688 -0.39687 l -0.65371,0.24856 -0.65319,0.24857 -0.17621,0.80305 -0.17622,0.80305 0.17053,0.53847 0.17105,0.53847 0.24236,-0.14935 0.24185,-0.14986 -0.17467,0.4563 -0.17518,0.45579 0.43925,-0.16847 0.43925,-0.16846 -0.0631,0.32091 -0.0631,0.32091 0.35036,-0.0729 0.34985,-0.0724 -0.15503,0.25063 -0.15503,0.25063 0.84388,0.601 0.84388,0.60099 -0.231,-0.3824 -0.23047,-0.3824 0.43821,0.35553 0.43822,0.35553 0.293,-0.0977 0.29249,-0.0977 -0.68006,-0.7338 -0.68058,-0.73433 v -0.43201 -0.43202 l -0.57412,-0.61185 -0.57465,-0.61184 0.37621,0.009 0.3762,0.009 0.61495,0.51211 0.61495,0.51263 -0.16795,0.27182 -0.16794,0.27182 h 0.29869 0.29869 l 0.41702,0.41702 0.41703,0.41703 0.48938,-0.12764 0.48938,-0.12816 -0.12403,0.20103 -0.12454,0.20153 0.63924,0.60048 0.63924,0.60048 0.34365,-0.13177 0.34365,-0.13177 0.0367,0.60564 0.0367,0.60514 -1.88671,0.22582 -1.88671,0.22634 -0.23823,-0.4687 -0.23874,-0.46871 -1.21492,-0.008 -1.21491,-0.008 -2.10323,-1.94924 -2.10323,-1.94923 -0.96687,-0.28991 -0.96634,-0.28938 h -0.27131 -0.27182 l -0.16639,0.4346 -0.16692,0.43511 0.4439,0.49041 0.44339,0.49041 h 0.19998 0.19948 l 1.08055,0.70797 1.08107,0.70796 v 0.17312 0.17363 l -0.16589,0.16595 -0.16588,0.16588 -1.22163,-0.67489 -1.22163,-0.6749 -0.25115,-0.24029 -0.25115,-0.23978 h -0.49764 -0.49765 l 0.13695,0.33021 0.13694,0.33073 0.32349,0.99115 0.32298,0.99168 h 1.85363 1.85312 l 0.42116,-0.38138 0.42117,-0.38137 0.85524,0.41445 0.85473,0.41444 v 0.31368 0.31419 l -0.81545,0.7767 -0.81546,0.77618 -0.25373,0.46819 -0.25373,0.46818 0.16898,0.27389 0.16898,0.27388 1.41284,-1.33686 1.41335,-1.33687 h 0.65732 0.65732 l 0.54777,0.69659 0.54726,0.6966 v 0.35192 0.3514 l 0.58343,0.31213 0.58342,0.31212 0.27544,-0.48524 0.27595,-0.48576 0.63769,-0.66559 0.63769,-0.66611 0.15503,0.41393 0.15503,0.41341 1.66243,1.37872 1.66243,1.37873 0.31832,-0.10645 0.31885,-0.10594 5.3e-4,-0.50746 0.001,-0.50695 -0.36742,-0.28783 -0.36742,-0.28784 0.24184,-0.43202 0.24185,-0.43201 0.65474,0.33951 0.65474,0.34003 1.36167,-0.0165 1.36116,-0.0165 -0.0987,0.1602 -0.0987,0.15968 0.63923,0.60048 0.63924,0.60048 0.34365,-0.13178 0.34365,-0.13177 0.0362,0.59738 0.0372,0.59789 -0.82941,0.24598 -0.82889,0.2465 -0.52865,-0.48938 -0.52865,-0.48885 -1.00459,-0.82424 -1.00459,-0.82424 -0.25838,0.25735 -0.25683,0.25786 0.92449,1.16944 0.92552,1.16944 0.53537,0.0336 0.53537,0.0331 0.19844,0.0434 0.19792,0.0439 -0.72141,0.39171 -0.7214,0.39171 -0.92966,-0.38861 -0.93069,-0.38861 -1.68878,-1.20612 -1.68982,-1.20613 -0.62322,0.1018 -0.62322,0.10129 -0.29662,-0.23565 -0.29714,-0.23564 -0.40256,0.15451 -0.40256,0.15451 -0.12764,0.57723 -0.12713,0.57722 -0.6103,1.6428 -0.60978,1.64331 0.44597,0.49248 0.44597,0.49299 v 0.43666 0.43667 l 0.60616,0.15244 0.60617,0.15245 0.71107,-0.12919 0.71055,-0.12868 0.13487,0.21808 0.13488,0.21859 -0.41651,0.15968 -0.41652,0.1602 h -0.65732 -0.65732 l 0.0842,0.56585 0.0842,0.56586 0.58705,0.21601 0.58756,0.21549 0.38499,-0.38499 0.38499,-0.38551 h 0.13435 0.13436 l -0.15606,0.99168 -0.15555,0.99115 -0.35605,1.02474 -0.35605,1.02475 v 0.25063 0.24856 l 0.45579,-0.0879 0.45578,-0.0879 0.2713,-0.53175 0.27079,-0.53227 0.55707,-0.78755 0.55656,-0.78755 0.1235,-0.38963 0.12351,-0.38965 -0.34003,-0.65577 -0.34003,-0.65577 0.12712,-0.12713 0.12713,-0.12712 1.05885,1.03456 1.05936,1.03456 0.43254,-0.27285 0.43253,-0.27285 0.0698,-0.47697 0.0703,-0.47698 0.54777,-0.58342 0.54777,-0.58343 v -0.2713 -0.2713 l -1.12345,-1.18649 -1.12292,-1.18701 -0.92501,-0.1788 -0.92501,-0.1788 -1.39733,-0.56172 -1.39681,-0.56173 -0.1602,0.16072 -0.1602,0.16019 0.34933,0.42117 0.34985,0.42168 0.48111,-0.1261 0.48111,-0.12609 -0.12402,0.20154 -0.12455,0.20102 0.63924,0.601 0.63924,0.60048 0.34365,-0.13178 0.34365,-0.13229 0.0362,0.59222 0.0357,0.59221 -0.89814,0.27595 -0.89814,0.27543 -0.27026,-0.50487 -0.27027,-0.50488 h -0.34623 -0.34572 l -0.46095,-0.50953 -0.46044,-0.50902 0.23048,-1.40766 0.23047,-1.40767 0.91571,0.0754 0.91622,0.0749 0.0879,0.25528 0.0884,0.25529 h 0.22738 0.22789 l 2.42414,1.16995 2.42363,1.16944 0.36586,-0.14056 0.36536,-0.14005 v -0.23616 -0.23616 h 0.25786 0.25735 l -0.14986,0.85938 -0.14934,0.85886 -0.39946,1.27331 -0.39895,1.27279 0.1478,0.14779 0.14728,0.1478 0.41393,-0.15916 0.41392,-0.15865 0.1664,-0.46871 0.1664,-0.4687 0.33796,-0.39739 0.33797,-0.39688 0.38757,-0.74827 0.38809,-0.74776 -0.35967,-0.6935 -0.35967,-0.6935 0.12041,-0.1204 0.12092,-0.12092 0.56431,0.50539 0.56431,0.50488 0.64182,1.01079 0.64234,1.01079 -0.0811,0.24185 -0.0816,0.24184 -0.79272,-0.41186 -0.79323,-0.41186 -0.0274,-0.0475 -0.0274,-0.0475 -0.69918,0.83095 -0.69919,0.83148 v 0.39222 0.39223 l 1.65158,0.001 1.65158,0.001 1.25522,0.185 1.25522,0.18552 v -0.28629 -0.28628 l 0.55397,-0.55397 0.55397,-0.55397 -0.65628,-0.70177 -0.6563,-0.70177 -0.1726,-0.57206 -0.17259,-0.57257 0.17156,-0.68368 0.17157,-0.68316 0.1695,0.006 0.16949,0.006 0.74414,1.05213 0.74363,1.05161 h 0.27802 0.27802 l -0.18759,-0.59479 -0.18759,-0.5948 -0.13952,-0.79323 -0.14004,-0.79323 -0.42633,-0.48628 -0.42685,-0.48627 -0.95963,0.15347 -0.95963,0.15348 -0.8754,-1.02888 -0.8754,-1.02887 -1.05937,-0.1695 -1.05937,-0.1695 -1.29346,-0.65009 -1.29294,-0.64957 h -1.79731 -1.79679 l -0.69194,-0.90796 -0.69195,-0.90744 v -0.14986 -0.14986 h 0.28112 0.2806 l 1.69034,0.81545 1.69033,0.81546 0.26149,-0.16175 0.26148,-0.16174 -1.08159,-1.44694 -1.08159,-1.44694 -0.29197,-0.0326 -0.29249,-0.0331 -0.75964,-0.0331 -0.75965,-0.0331 -0.0661,-0.83199 -0.0667,-0.832 -0.49506,-0.69556 -0.49558,-0.69556 -0.92501,0.11833 -0.92501,0.11783 -0.79272,0.17105 -0.79271,0.17104 0.52865,-0.42684 0.52813,-0.42633 1.38752,-0.70332 1.38751,-0.70383 v -0.36742 z m -56.370204,0.58239 v 0.27957 0.28009 l 0.264067,-0.1633 0.264584,-0.1633 v -0.11679 -0.11627 h -0.264584 z m 67.733854,0 v 0.27957 0.28009 l 0.26407,-0.1633 0.26458,-0.1633 v -0.11679 -0.11627 h -0.26458 z m -53.462893,0.22221 v 0.28473 0.28423 l 0.95395,1.05626 0.95343,1.05627 0.21756,-0.13436 0.217043,-0.13436 0.18758,0.30386 0.18759,0.30385 1.87534,-0.15709 1.87533,-0.15761 0.0915,-0.27441 0.0915,-0.2744 h 0.50695 0.007 v -0.99012 l -0.39119,-0.39171 -2.08825,0.18242 -2.08876,0.18242 -0.439253,-0.38757 -0.43977,-0.38706 -0.85886,-0.18293 z m 67.733853,0 v 0.28473 0.28423 l 0.95395,1.05626 0.95343,1.05627 0.21756,-0.13436 0.21704,-0.13436 0.18759,0.30386 0.18758,0.30385 1.87534,-0.15709 1.87534,-0.15761 0.0915,-0.27441 0.0915,-0.2744 h 0.50695 0.007 v -0.99012 l -0.39119,-0.39171 -2.08824,0.18242 -2.08876,0.18242 -0.43925,-0.38757 -0.43977,-0.38706 -0.85886,-0.18293 z m -79.437012,0.0109 -0.213423,0.21394 -0.213424,0.21342 0.415994,0.85938 0.415997,0.85938 0.23151,0.0331 0.230995,0.0331 0.198437,0.0496 0.197919,0.0496 1.515155,0.33176 1.515152,0.33177 0.152445,0.24649 0.151929,0.2465 h 0.348816 0.348298 l 0.281638,-0.33952 0.281636,-0.33951 -0.183452,-0.28215 -0.182935,-0.28164 -0.577226,-0.30437 -0.577225,-0.30386 h -0.798918 -0.798401 l -1.370457,-0.80822 z m 67.733852,0 -0.21342,0.21394 -0.21342,0.21342 0.41599,0.85938 0.416,0.85938 0.23151,0.0331 0.23099,0.0331 0.19844,0.0496 0.19792,0.0496 1.51515,0.33176 1.51516,0.33177 0.15244,0.24649 0.15193,0.2465 h 0.34882 0.3483 l 0.28163,-0.33952 0.28164,-0.33951 -0.18345,-0.28215 -0.18294,-0.28164 -0.57722,-0.30437 -0.57723,-0.30386 h -0.79892 -0.7984 l -1.37046,-0.80822 z m -77.996274,0.50229 -0.08113,0.0951 -0.08113,0.0946 -0.299207,0.57671 -0.299722,0.57619 0.386537,0.34882 0.387057,0.34882 0.405143,0.34106 0.405662,0.34106 v -0.11575 -0.11524 l 1.519803,0.45424 1.519288,0.45475 0.330729,0.003 0.330211,0.003 v -0.22066 -0.22014 h 0.537953 0.537951 l 0.651124,-0.42685 0.651639,-0.42736 v -0.36587 -0.36639 l -2.18023,-0.0202 -2.180743,-0.0202 -0.452686,-0.0868 -0.453202,-0.0873 -0.817523,-0.58239 z m 67.733854,0 -0.0811,0.0951 -0.0811,0.0946 -0.29921,0.57671 -0.29972,0.57619 0.38654,0.34882 0.38705,0.34882 0.40515,0.34106 0.40566,0.34106 v -0.11575 -0.11524 l 1.5198,0.45424 1.51929,0.45475 0.33073,0.003 0.33021,0.003 v -0.22066 -0.22014 h 0.53795 0.53795 l 0.65113,-0.42685 0.65164,-0.42736 v -0.36587 -0.36639 l -2.18023,-0.0202 -2.18075,-0.0202 -0.45268,-0.0868 -0.45321,-0.0873 -0.81752,-0.58239 z m -71.407015,0.0238 -0.173116,0.45166 -0.173117,0.45165 0.465605,0.34054 0.465604,0.34107 0.644921,-0.29404 0.644406,-0.29404 -0.07855,-0.41548 -0.07855,-0.41547 -0.858345,-0.0827 z m 67.733855,0 -0.17312,0.45166 -0.17311,0.45165 0.4656,0.34054 0.46561,0.34107 0.64492,-0.29404 0.6444,-0.29404 -0.0785,-0.41548 -0.0786,-0.41547 -0.85835,-0.0827 z m -56.102007,0.21033 0.176216,0.17621 0.176217,0.17622 h -0.352433 -0.351917 l 0.1757,-0.17622 z m 67.733857,0 0.17622,0.17621 0.17621,0.17622 h -0.35243 -0.35192 l 0.1757,-0.17622 z m -106.120662,0.32453 0.860413,1.08623 0.859896,1.08676 0.02997,1.10846 0.03049,1.10846 -0.219625,1.12396 -0.219625,1.12344 h 0.397392 0.396875 l 0.692464,-1.23919 0.692464,-1.23972 -0.155029,-0.40463 -0.155546,-0.40514 0.190686,0.19068 0.190686,0.19121 0.500744,-0.4532 0.500228,-0.45321 -0.187068,1.41284 -0.187586,1.41231 0.49506,-0.27698 0.495061,-0.27699 0.283186,0.83716 0.283187,0.83716 0.307992,-0.063 0.307992,-0.063 -0.130225,0.34003 -0.130741,0.34003 0.668692,0.62838 0.668694,0.62787 v 0.61495 0.61495 h -0.242879 -0.242364 l -1.313097,-1.4981 -1.313615,-1.4981 -0.957565,0.0362 -0.957047,0.0367 -0.472323,0.2527 -0.472323,0.2527 -0.912605,-0.43266 -0.912606,-0.43305 -1.252637,-0.86971 -1.252638,-0.8692 h -0.26717 -0.26665 v -0.28577 -0.28526 l 0.72657,0.1478 0.727092,0.14779 0.660425,0.12609 0.660941,0.12661 0.591179,0.17363 0.591178,0.17312 0.168982,-0.43977 0.168982,-0.44028 -0.628386,-0.67283 -0.627868,-0.67334 -1.850016,0.17725 -1.850019,0.17725 0.26459,-0.26303 0.26406,-0.26304 0.92088,-0.23461 0.92087,-0.23513 0.290938,-1.04128 0.290939,-1.04179 0.538985,-0.0801 z m 67.733852,0 0.86041,1.08623 0.8599,1.08676 0.03,1.10846 0.0305,1.10846 -0.21963,1.12396 -0.21962,1.12344 h 0.39739 0.39687 l 0.69247,-1.23919 0.69246,-1.23972 -0.15503,-0.40463 -0.15554,-0.40514 0.19068,0.19068 0.19069,0.19121 0.50074,-0.4532 0.50023,-0.45321 -0.18707,1.41284 -0.18758,1.41231 0.49506,-0.27698 0.49506,-0.27699 0.28319,0.83716 0.28318,0.83716 0.30799,-0.063 0.308,-0.063 -0.13023,0.34003 -0.13074,0.34003 0.66869,0.62838 0.6687,0.62787 v 0.61495 0.61495 h -0.24288 -0.24237 l -1.3131,-1.4981 -1.31361,-1.4981 -0.95756,0.0362 -0.95705,0.0367 -0.47232,0.2527 -0.47233,0.2527 -0.9126,-0.43253 -0.91261,-0.43305 -1.25263,-0.86971 -1.25264,-0.8692 h -0.26717 -0.26665 v -0.28577 -0.28526 l 0.72657,0.1478 0.72709,0.14779 0.66042,0.12609 0.66095,0.12661 0.59117,0.17364 0.59118,0.17311 0.16899,-0.43976 0.16898,-0.44029 -0.62839,-0.67282 -0.62787,-0.67335 -1.85002,0.17725 -1.85001,0.17725 0.26458,-0.26303 0.26407,-0.26303 0.92087,-0.23462 0.92088,-0.23512 0.29094,-1.04128 0.29093,-1.0418 0.53899,-0.0801 z m -75.908542,0.0165 v 1.06867 h 0.0708 0.50643 v -0.24546 -0.24547 l -0.44493,-0.44545 z m 67.733852,0 v 1.06867 h 0.0708 0.50642 v -0.24546 -0.24547 l -0.44493,-0.44545 z m -0.41807,2.08721 -1.55649,0.18087 -1.55649,0.18087 -1.486223,0.66042 -1.48673,0.65991 -1.07435,0.49971 -1.074354,0.49971 -0.511599,0.006 -0.511079,0.006 -0.730705,1.03353 -0.730705,1.03404 0.31316,0.19379 0.313677,0.19379 -0.618567,0.22892 -0.618569,0.22893 0.257866,0.25786 0.257865,0.25787 1.187524,-0.22169 1.187527,-0.22221 0.515728,0.20205 0.515211,0.20154 0.74259,0.0186 0.74208,0.0186 -0.17984,-0.29145 -0.17983,-0.29146 -0.95912,-0.41702 -0.958591,-0.41703 -0.528651,0.0734 -0.52865,0.0739 -0.330211,0.27079 -0.330213,0.27078 v -0.26665 -0.26665 l 0.898652,-0.42633 0.898655,-0.42685 h 0.390157 0.390672 l 0.31781,-0.38343 0.31781,-0.38344 1.10174,-0.51625 1.102263,-0.51677 1.03404,-0.35553 1.03405,-0.35605 0.11111,0.33021 0.1111,0.33073 h 0.23771 0.23771 l 2.15181,1.05213 v -1.19476 l -0.42582,-0.32039 0.004,-0.84491 z m 67.73386,0 -1.5565,0.18087 -1.55649,0.18087 -1.48622,0.66042 -1.48673,0.65991 -1.07435,0.49971 -1.07435,0.49971 -0.5116,0.006 -0.51108,0.006 -0.7307,1.03353 -0.73071,1.03404 0.31316,0.19379 0.31368,0.19379 -0.61857,0.22892 -0.61857,0.22893 0.25787,0.25786 0.25787,0.25787 1.18752,-0.22169 1.18752,-0.22221 0.51573,0.20205 0.51522,0.20154 0.74259,0.0186 0.74207,0.0186 -0.17983,-0.29145 -0.17984,-0.29146 -0.95911,-0.41702 -0.9586,-0.41703 -0.52865,0.0734 -0.52865,0.0739 -0.33021,0.27079 -0.33021,0.27078 v -0.26665 -0.26665 l 0.89865,-0.42633 0.89865,-0.42685 h 0.39016 0.39067 l 0.31781,-0.38343 0.31781,-0.38344 1.10175,-0.51625 1.10225,-0.51677 1.03405,-0.35553 1.03404,-0.35605 0.11111,0.33021 0.1111,0.33073 h 0.23771 0.23772 l 2.1518,1.05213 v -1.19476 l -0.42581,-0.32039 0.004,-0.84491 z m -103.287245,0.0326 1.122929,0.15761 1.122928,0.1571 0.33073,0.1018 0.330213,0.10232 v 0.27234 0.27285 l -0.462505,-0.0274 -0.462502,-0.0274 -0.991156,-0.26303 -0.990637,-0.26356 v -0.24132 z m 67.733855,0 1.12293,0.15761 1.12293,0.1571 0.33073,0.1018 0.33021,0.10232 v 0.27234 0.27285 l -0.4625,-0.0274 -0.46251,-0.0274 -0.99115,-0.26303 -0.99064,-0.26356 v -0.24132 z m -61.265515,0.0227 -0.591695,0.15503 -0.591178,0.15451 v 0.23048 0.22996 l 1.056783,0.66766 1.057299,0.66766 v 0.22479 0.22479 l 0.645438,-0.0708 0.645956,-0.0713 0.279054,-0.17259 0.279569,-0.1726 v -0.4806 -0.48111 l -0.330213,-0.25063 -0.330729,-0.25011 -1.059884,-0.30231 z m 67.733855,0 -0.5917,0.15503 -0.59117,0.15451 v 0.23048 0.22996 l 1.05678,0.66766 1.0573,0.66766 v 0.22479 0.22479 l 0.64544,-0.0708 0.64595,-0.0713 0.27906,-0.17259 0.27957,-0.1726 v -0.4806 -0.48111 l -0.33022,-0.25063 -0.33073,-0.25011 -1.05988,-0.30231 z m -48.502988,0.24805 h 0.09974 0.09973 v 0.23616 0.23616 l -0.433565,0.1664 -0.433565,0.1664 0.333828,-0.40256 z m 67.733858,0 h 0.0997 0.0992 v 0.23616 0.23616 l -0.43356,0.1664 -0.43357,0.1664 0.33383,-0.40256 z m -77.656765,0.23926 -0.254765,0.25425 -0.254248,0.25425 0.992703,1.6092 0.992706,1.60869 h 0.722953 0.722953 l 0.316259,-0.38085 0.316259,-0.38138 -0.613916,-0.52193 -0.614431,-0.52193 -1.163238,-0.96015 z m 67.733855,0 -0.25476,0.25425 -0.25425,0.25425 0.9927,1.6092 0.99271,1.60869 h 0.72295 0.72295 l 0.31626,-0.38085 0.31626,-0.38138 -0.61392,-0.52193 -0.61443,-0.52193 -1.16323,-0.96015 z m -70.040691,0.062 -0.621152,0.11266 -0.621667,0.11265 -1.025777,0.42323 -1.026295,0.42271 -0.594794,0.54984 -0.594796,0.54932 v 0.33435 0.33382 l 0.760677,0.83303 0.760677,0.83302 2.212269,1.1498 2.212784,1.1498 0.462502,0.0165 0.462505,0.016 v -0.39636 -0.39636 h -0.250113 -0.250113 l -1.581301,-0.92708 -1.581298,-0.92759 -0.811319,-0.81132 -0.811321,-0.81183 v -0.29559 -0.29611 l 0.907439,0.88005 0.907436,0.88005 0.443902,-0.17053 0.4439,-0.17053 -0.424262,-0.5917 -0.424265,-0.59169 -0.275434,-0.46251 -0.275952,-0.4625 h 0.237709 0.237197 l 0.697113,0.69711 0.6966,0.6966 v 0.3607 0.3607 h 0.51108 0.51108 l 0.0832,0.69815 0.08372,0.69867 0.587044,0.21549 0.587045,0.21549 0.396356,-0.39636 0.395843,-0.39636 -0.827341,-1.57923 -0.827855,-1.57975 -0.428916,0.13643 -0.428914,0.13643 -0.457853,-0.77463 z m 67.733851,0 -0.62115,0.11266 -0.62167,0.11265 -1.02577,0.42323 -1.02629,0.42271 -0.5948,0.54984 -0.5948,0.54932 v 0.33435 0.33382 l 0.76068,0.83303 0.76068,0.83302 2.21227,1.1498 2.21278,1.1498 0.46251,0.0165 0.4625,0.016 v -0.39636 -0.39636 h -0.25012 -0.25011 l -1.5813,-0.92708 -1.5813,-0.92759 -0.81132,-0.81132 -0.81132,-0.81183 v -0.29559 -0.29611 l 0.90744,0.88005 0.90744,0.88005 0.4439,-0.17053 0.4439,-0.17053 -0.42426,-0.5917 -0.42427,-0.59169 -0.27543,-0.46251 -0.27595,-0.4625 h 0.23771 0.23719 l 0.69712,0.69711 0.6966,0.6966 v 0.3607 0.3607 h 0.51108 0.51108 l 0.0832,0.69815 0.0837,0.69867 0.58704,0.21549 0.58705,0.21549 0.39636,-0.39636 0.39584,-0.39636 -0.82734,-1.57923 -0.82786,-1.57975 -0.42891,0.13643 -0.42892,0.13643 -0.45785,-0.77463 z m -104.195709,1.25371 v 0.13229 0.13229 l -0.264067,0.1633 -0.264583,0.1633 v -0.1323 -0.13177 l 0.264583,-0.16382 z m 67.733849,0 v 0.13229 0.13229 l -0.26406,0.1633 -0.26459,0.1633 v -0.1323 -0.13177 l 0.26459,-0.16382 z m -76.503852,0.0935 v 1.21543 l 0.17725,0.0868 2.25102,1.10071 v 0.21445 0.21446 l -0.62735,-0.23823 -0.62684,-0.23874 -0.30799,0.67592 -0.30747,0.67593 -0.14366,-0.14366 -0.14366,-0.14366 0.26716,-0.49971 0.26717,-0.49971 -0.17983,-0.27802 -0.17984,-0.27802 -0.44596,-0.0822 v 6.8797 h 0.42116 0.65371 l 0.15813,-0.25683 0.15864,-0.25632 -0.40721,-0.78807 -0.40721,-0.78754 v -0.80616 -0.80666 h 0.22738 0.22737 l 0.96222,-0.65268 0.9617,-0.65319 v 0.23461 0.2341 l -0.28526,0.0951 -0.28525,0.0951 -0.27595,2.24018 -0.27595,2.24017 -0.16589,0.17829 -0.16536,0.17776 -1.41387,-0.261 -0.0884,-0.016 v 1.942 l 0.0486,0.0186 v 0.17001 l -5.3e-4,0.17002 -0.0481,-5.3e-4 v 2.10788 l 2.01797,1.57613 2.23345,1.7446 0.16072,0.25993 0.16071,0.26045 h -0.10025 -0.10025 l -1.69913,-1.3193 -1.69963,-1.31981 -0.1695,-0.002 -0.17002,-0.002 -0.15968,0.416 -0.15916,0.41548 0.24598,0.46043 0.2465,0.45992 1.64176,0.86145 1.64176,0.86093 0.25011,-0.34933 0.25011,-0.34882 -0.14417,0.4501 -0.14366,0.44959 0.77618,0.38757 0.77618,0.38757 0.730184,-0.19688 0.730188,-0.19689 0.792717,0.48214 0.793233,0.48214 0.429948,0.001 0.429948,10e-4 0.334347,0.40308 0.334346,0.40255 0.130742,-0.13074 0.130741,-0.13074 0.771529,0.54984 0.771529,0.54932 -0.379822,0.43408 -0.380338,0.43408 -0.173633,0.57103 -0.173633,0.57102 -0.382405,0.3173 -0.382406,0.31781 -0.909505,-0.75655 -0.910022,-0.75602 -0.01912,-0.47284 -0.0186,-0.47284 0.698665,0.0765 0.699182,0.076 0.10697,-0.30437 0.107487,-0.30437 -0.800468,-0.39946 -0.799951,-0.39946 -0.66921,0.52658 -0.66921,0.52658 0.143144,0.23151 0.143144,0.23203 -0.681612,0.44649 -0.681096,0.44648 0.07855,0.40256 0.07803,0.40256 1.850017,0.42788 1.849499,0.42788 -0.07855,0.99219 -0.07855,0.99064 0.541053,-0.33849 0.541569,-0.33796 v -0.24598 -0.24598 l 0.438733,-0.48524 0.439249,-0.48576 0.287322,-0.49764 0.287837,-0.49765 0.991154,-1.62935 0.991155,-1.62988 v -0.25011 -0.25012 H 51.18967 50.793312 v -0.24236 -0.24236 l 0.330212,-0.11111 0.330213,-0.1111 -0.309542,-0.63821 -0.310059,-0.63768 -0.456303,-1.26504 -0.456303,-1.26452 -0.290938,0.0977 -0.290938,0.0982 0.07028,2.03243 0.0708,2.03244 -0.731221,-0.1757 -0.731222,-0.1757 -0.130224,-0.11472 -0.129708,-0.11473 0.460437,-0.25786 0.45992,-0.25735 v -0.524 -0.524 l -0.395841,-0.15193 -0.396359,-0.15244 -0.766878,0.82166 -0.766878,0.82113 h -0.55501 -0.554488 v -0.26458 -0.26407 l 0.198438,-0.005 0.197921,-0.004 1.585949,-1.44281 1.585434,-1.4428 0.462504,-0.15659 0.462504,-0.15709 v -0.34727 -0.34726 l -0.937927,-0.71572 -0.937928,-0.71572 0.343132,-0.41393 0.343648,-0.41393 -0.08527,-0.15761 -0.08475,-0.15761 -0.389124,-0.42995 -0.389123,-0.43046 0.222208,-1.2883 0.222726,-1.28829 0.901753,0.0749 0.902271,0.0744 0.14211,0.19689 0.142627,0.19741 1.100191,0.48472 1.100191,0.48524 0.275953,-0.17053 0.275952,-0.17053 1.79524,0.32091 1.795238,0.32143 0.720371,0.59014 0.720367,0.59066 0.336931,-0.0568 0.336415,-0.0563 0.594794,-0.38137 0.594797,-0.38137 v -0.3328 -0.3328 l -0.330729,-0.0196 -0.330214,-0.0196 -0.651639,-0.11989 -0.652156,-0.11937 -0.627869,-0.41187 -0.627351,-0.41134 -1.23145,0.002 -1.230932,0.002 -1.551326,-0.3607 -1.551845,-0.36018 -0.584977,-0.54984 -0.584977,-0.54932 -0.638204,0.10387 -0.638204,0.10387 -0.297139,-0.23565 -0.296623,-0.23564 -0.363802,0.14314 -0.363803,0.14263 -0.564306,1.64641 -0.564824,1.64589 -0.189652,0.46096 -0.190169,0.46095 0.0062,0.003 -0.191203,0.11834 -0.240295,0.14831 -0.684713,-0.81391 -0.684713,-0.81442 v -0.50229 -0.5023 l 0.660942,-0.43304 0.660424,-0.43305 v -0.35037 -0.35088 l -0.246489,-0.15272 -0.247014,-0.15244 -1.033528,0.35605 -1.033526,0.35657 -0.53692,-0.19896 -0.53692,-0.19844 -0.56121,-0.78858 -0.5612,-0.78858 v -0.15762 -0.15709 h 0.66869 0.66921 l 0.15813,-0.41238 0.15813,-0.41238 -0.71417,-0.74569 -0.71365,-0.74517 0.0847,-0.47233 0.0853,-0.4718 -1.30483,-0.33796 -1.30432,-0.33849 -0.67747,-0.51056 z m 67.733852,0 v 1.21543 l 0.17725,0.0868 2.25102,1.10071 v 0.21445 0.21446 l -0.62735,-0.23823 -0.62684,-0.23874 -0.30799,0.67592 -0.30747,0.67593 -0.14366,-0.14366 -0.14366,-0.14366 0.26717,-0.49971 0.26716,-0.49971 -0.17983,-0.27802 -0.17984,-0.27802 -0.44596,-0.0822 v 0.0145 l -0.63407,-0.11679 -1.00149,-0.18397 -1.18753,-0.50901 -1.18752,-0.50953 -1.048523,0.41961 -1.04851,0.41962 -0.004,0.43408 -0.004,0.43408 -0.16071,0.59893 -0.1602,0.59841 0.36225,-0.0925 0.36225,-0.093 -0.19843,0.11111 -0.19792,0.11059 v 0.50177 0.50178 l 0.60616,0.15245 0.606163,0.15193 0.71107,-0.12868 0.71055,-0.12919 0.13488,0.21859 0.13488,0.21808 -0.41652,0.16019 -0.41651,0.15969 h -0.63924 -0.638723 v 0.23202 0.23203 l 0.422203,0.35088 0.4222,0.35037 0.50281,0.0765 0.50281,0.077 v -0.26302 -0.26252 h 0.25735 0.25786 l -0.16278,0.85938 -0.16278,0.85886 -0.21962,0.28267 -0.21963,0.28216 -0.0734,0.8971 -0.0739,0.8971 0.46354,0.0961 0.46354,0.0956 0.17776,-0.48214 0.17777,-0.48214 0.66301,-0.8816 0.66249,-0.88212 -0.27595,-1.03508 -0.27647,-1.03456 h 0.19534 0.19533 l 0.3173,0.38241 0.31729,0.38292 0.12402,0.87281 0.12351,0.87334 0.11162,0.33021 0.1111,0.33073 h 0.31058 0.42116 0.65371 l 0.15813,-0.25683 0.15865,-0.25632 -0.40721,-0.78807 -0.40721,-0.78754 v -0.80616 -0.80666 h 0.22737 0.22738 l 0.96221,-0.65268 0.9617,-0.65319 v 0.23461 0.2341 l -0.28525,0.0951 -0.28525,0.0951 -0.27596,2.24018 -0.27595,2.24017 -0.16588,0.17829 -0.16536,0.17776 -1.41387,-0.26096 -0.0884,-0.016 v 1.942 l 0.0486,0.0186 v 0.17001 l -5.3e-4,0.17002 -0.0481,-5.3e-4 v 2.10788 l 2.01797,1.57613 2.23345,1.7446 0.16071,0.25993 0.16072,0.26045 h -0.10026 -0.10025 l -1.69912,-1.3193 -1.69964,-1.31981 -0.1695,-0.002 -0.17001,-0.002 -0.15968,0.41548 -0.15916,0.41548 0.24598,0.46044 0.24649,0.45992 1.64176,0.86144 1.64176,0.86093 0.25012,-0.34933 0.25011,-0.34882 -0.14418,0.45062 -0.14366,0.44907 0.77618,0.38758 0.77618,0.38757 0.73019,-0.19689 0.73019,-0.19689 0.79272,0.48214 0.79323,0.48215 0.42995,0.001 0.42995,0.001 0.33434,0.40308 0.33435,0.40256 0.13074,-0.13074 0.13074,-0.13075 0.77153,0.54984 0.77153,0.54932 -0.37982,0.43409 -0.38034,0.43408 -0.17363,0.57102 -0.17364,0.57103 -0.3824,0.31729 -0.38241,0.31781 -0.9095,-0.75654 -0.91003,-0.75603 -0.0191,-0.47284 -0.0186,-0.47284 0.69867,0.0765 0.69918,0.076 0.10697,-0.30438 0.10749,-0.30437 -0.80047,-0.39946 -0.79995,-0.39946 -0.66921,0.52659 -0.66921,0.52658 0.14314,0.23151 0.14315,0.23202 -0.68161,0.44649 -0.6811,0.44648 0.0786,0.40256 0.078,0.40256 1.85002,0.42788 1.8495,0.42789 -0.0785,0.99218 -0.0786,0.99064 0.54105,-0.33848 0.54157,-0.33796 v -0.24599 -0.24598 l 0.43873,-0.48524 0.43925,-0.48576 0.28732,-0.49764 0.28784,-0.49764 0.99116,-1.62936 0.99115,-1.62988 v -0.25011 -0.25011 h -0.39636 -0.39636 v -0.24237 -0.24236 l 0.33021,-0.1111 0.33022,-0.11111 -0.30954,-0.6382 -0.31006,-0.63769 -0.45631,-1.26504 -0.4563,-1.26452 -0.29094,0.0982 -0.29094,0.0977 0.0703,2.03244 0.0708,2.03243 -0.73122,-0.1757 -0.73122,-0.1757 -0.13023,-0.11472 -0.1297,-0.11472 0.46043,-0.25787 0.45992,-0.25734 v -0.524 -0.524 l -0.39584,-0.15193 -0.39636,-0.15245 -0.76687,0.82166 -0.76688,0.82114 h -0.55501 -0.55449 v -0.26459 -0.26406 l 0.19844,-0.005 0.19792,-0.004 1.58595,-1.4428 1.58544,-1.44281 0.4625,-0.15658 0.4625,-0.1571 v -0.34726 -0.34727 l -0.93792,-0.71572 -0.93793,-0.71572 0.34313,-0.41393 0.34365,-0.41392 -0.0853,-0.15761 -0.0847,-0.15762 -0.38912,-0.42995 -0.38913,-0.43046 0.22224,-1.28827 0.22273,-1.28829 0.90175,0.0749 0.90227,0.0744 0.14211,0.19689 0.14263,0.1974 1.10019,0.48473 1.10019,0.48524 0.27595,-0.17053 0.27595,-0.17054 1.79524,0.32091 1.79524,0.32143 0.72037,0.59015 0.72037,0.59066 0.33693,-0.0569 0.33641,-0.0563 0.5948,-0.38138 0.5948,-0.38137 v -0.33279 -0.3328 l -0.33073,-0.0196 -0.33021,-0.0196 -0.65164,-0.1199 -0.65216,-0.11937 -0.62787,-0.41186 -0.62735,-0.41134 -1.23145,0.002 -1.23093,0.002 -1.55133,-0.3607 -1.55185,-0.36019 -0.58497,-0.54983 -0.58498,-0.54932 -0.6382,0.10387 -0.63821,0.10387 -0.29714,-0.23565 -0.29662,-0.23564 -0.3638,0.14314 -0.3638,0.14262 -0.56431,1.64642 -0.56482,1.64589 -0.18966,0.46095 -0.19016,0.46096 0.006,0.003 -0.1912,0.11834 -0.2403,0.14831 -0.68471,-0.8139 -0.68472,-0.81442 v -0.50229 -0.5023 l 0.66095,-0.43305 0.66042,-0.43305 v -0.35036 -0.35089 l -0.2465,-0.15244 -0.24701,-0.15245 -1.03353,0.35605 -1.03353,0.35657 -0.53692,-0.19895 -0.53691,-0.19844 -0.56121,-0.78858 -0.5612,-0.78859 v -0.15761 -0.1571 h 0.66869 0.66921 l 0.15813,-0.41237 0.15813,-0.41238 -0.71417,-0.74569 -0.71365,-0.74518 0.0847,-0.47232 0.0853,-0.4718 -1.30483,-0.33797 -1.30431,-0.33848 -0.67748,-0.51056 z m -11.315077,0.46664 -0.807186,0.28164 -0.806669,0.28112 -0.61495,1.37097 -0.614434,1.37098 -0.194818,0.4625 -0.194821,0.46302 h 0.353984 0.353983 l 1.487247,-1.85466 1.487249,-1.85415 v -0.26097 -0.26045 h -0.224792 z m 67.733857,0 -0.80719,0.28164 -0.80667,0.28112 -0.61495,1.37097 -0.61443,1.37098 -0.19482,0.4625 -0.19482,0.46302 h 0.35398 0.35399 l 1.48725,-1.85466 1.48724,-1.85415 v -0.26097 -0.26045 h -0.22479 z m 7.30446,0.0103 -1.04851,0.41961 -1.04852,0.41961 -0.004,0.43409 -0.004,0.43408 -0.16071,0.59893 -0.1602,0.59842 0.36225,-0.0925 0.36225,-0.093 -0.19843,0.11109 -0.19792,0.11059 v 0.50178 0.50178 l 0.60616,0.15244 0.60616,0.15193 0.71107,-0.12868 0.71055,-0.12919 0.13488,0.2186 0.13488,0.21807 -0.41652,0.1602 -0.41651,0.15968 h -0.63924 -0.63872 v 0.23202 0.23203 l 0.4222,0.35088 0.4222,0.35037 0.50281,0.0765 0.50281,0.077 v -0.26302 -0.26252 h 0.25735 0.25786 l -0.16278,0.85938 -0.16278,0.85886 -0.21962,0.28267 -0.21963,0.28216 -0.0739,0.8971 -0.0739,0.8971 0.46353,0.0961 0.46406,0.0956 0.17777,-0.48214 0.17725,-0.48214 0.663,-0.8816 0.6625,-0.88212 -0.27596,-1.03508 -0.27646,-1.03456 h 0.19585 0.19533 l 0.3173,0.38241 0.31678,0.38292 0.12454,0.87281 0.12298,0.87334 0.11163,0.33021 0.11162,0.33073 h 0.31006 v -6.86522 l -0.63407,-0.11678 -1.00149,-0.18397 -1.18753,-0.50901 z m -78.213317,0.58756 -0.434083,0.24288 -0.434081,0.24287 v 0.37518 0.37516 l -0.372589,-0.14314 -0.372586,-0.14262 -0.750343,0.39016 -0.750858,0.39068 -0.660424,0.57722 -0.660942,0.57723 -0.367419,0.20619 -0.367419,0.20618 0.185002,0.29921 0.185002,0.29921 h 0.327628 0.328144 l 0.251148,-0.22531 0.251148,-0.22531 1.247468,-0.3359 1.247987,-0.33538 0.161747,-0.51056 0.161748,-0.51005 0.385506,0.31988 0.385506,0.31988 0.21704,-0.23978 0.21704,-0.2403 0.278019,-0.83405 0.277503,-0.83458 -0.468188,-0.12248 z m 67.733857,0 -0.43409,0.24288 -0.43408,0.24287 v 0.37518 0.37516 l -0.37258,-0.14314 -0.37259,-0.14262 -0.75034,0.39016 -0.75086,0.39068 -0.66043,0.57722 -0.66094,0.57723 -0.36742,0.20619 -0.36742,0.20618 0.18501,0.29921 0.185,0.29921 h 0.32763 0.32814 l 0.25115,-0.22531 0.25115,-0.22531 1.24747,-0.3359 1.24798,-0.33538 0.16175,-0.51056 0.16175,-0.51005 0.3855,0.31988 0.38551,0.31988 0.21704,-0.23978 0.21704,-0.2403 0.27802,-0.83405 0.2775,-0.83458 -0.46819,-0.12248 z m -104.077375,0.1695 -0.166915,0.16795 -0.166915,0.16795 0.621667,0.50436 0.622184,0.50437 0.237196,-0.14625 0.236678,-0.14624 v -0.35244 -0.35243 l -0.691949,-0.17364 z m 67.733855,0 -0.16692,0.16795 -0.16691,0.16795 0.62166,0.50436 0.62219,0.50437 0.23719,-0.14625 0.23668,-0.14624 v -0.35244 -0.35243 l -0.69194,-0.17364 z m -19.87424,0.13591 -0.10542,0.17105 -0.10542,0.17053 0.63872,0.60048 0.63924,0.60048 0.34364,-0.13177 0.34417,-0.13178 0.0357,0.59221 0.0362,0.59221 -0.89865,0.27543 -0.89814,0.27596 -0.27027,-0.50488 -0.26975,-0.5054 h -0.34106 -0.34107 l -0.56275,-0.59893 -0.562243,-0.59892 0.18603,-0.29198 0.186043,-0.29249 0.97255,-0.11109 z m 67.73385,0 -0.10542,0.17105 -0.10542,0.17053 0.63872,0.60048 0.63924,0.60048 0.34365,-0.13177 0.34416,-0.13178 0.0357,0.59221 0.0362,0.59221 -0.89865,0.27543 -0.89814,0.27596 -0.27026,-0.50488 -0.26975,-0.5054 h -0.34107 -0.34106 l -0.56276,-0.59893 -0.56224,-0.59892 0.18603,-0.29198 0.18604,-0.29249 0.97255,-0.11109 z m -118.469259,0.41858 h 0.132292 0.131776 l 0.163295,0.26407 0.163299,0.26458 h -0.131776 -0.132292 l -0.163296,-0.26458 z m 67.733849,0 h 0.13229 0.13178 l 0.1633,0.26407 0.16329,0.26458 h -0.13177 -0.13229 l -0.1633,-0.26458 z m -60.785435,0.2403 -0.171051,0.27698 -0.171048,0.27699 0.610299,0.25941 0.610814,0.2589 1.056783,0.62374 1.057302,0.62322 0.436147,-0.11421 0.435634,-0.11369 0.729154,-0.76119 0.729155,-0.76171 -0.37207,-0.11886 -0.372589,-0.11937 -2.289265,-0.16485 z m 67.733855,0 -0.17105,0.27698 -0.17105,0.27699 0.6103,0.25941 0.61081,0.2589 1.05679,0.62374 1.0573,0.62322 0.43615,-0.11421 0.43563,-0.11369 0.72915,-0.76119 0.72916,-0.76171 -0.37207,-0.11886 -0.37259,-0.11937 -2.28927,-0.16485 z m -86.014912,0.28835 h 0.13178 0.13229 v 0.13229 0.13178 h -0.13229 -0.13178 v -0.13178 z m 67.733852,0 h 0.13178 0.13229 v 0.13229 0.13178 h -0.13229 -0.13178 v -0.13178 z m -50.364369,0.96635 -0.360183,0.49299 -0.360185,0.49248 v 0.1633 0.16329 l 0.331245,0.45269 0.330729,0.45269 0.659908,0.12815 0.660426,0.12868 1.321367,0.37103 1.321366,0.37104 0.626835,0.0238 0.627351,0.0238 -0.307991,-0.37104 -0.307991,-0.37103 -1.376146,-0.70435 -1.376143,-0.70435 -0.895551,-0.55656 z m 67.733849,0 -0.36018,0.49299 -0.36019,0.49248 v 0.1633 0.16329 l 0.33125,0.45269 0.33073,0.45269 0.65991,0.12815 0.66042,0.12868 1.32137,0.37103 1.32137,0.37104 0.62683,0.0238 0.62735,0.0238 -0.30799,-0.37104 -0.30799,-0.37103 -1.37614,-0.70435 -1.37615,-0.70435 -0.89555,-0.55656 z m -83.253832,0.32401 v 0.13229 0.1323 l -0.26407,0.16329 -0.26406,0.1633 v -0.13177 -0.1323 l 0.26406,-0.16329 z m 67.733852,0 v 0.13229 0.1323 l -0.26406,0.16329 -0.26407,0.1633 v -0.13177 -0.1323 l 0.26407,-0.16329 z m -44.877365,0.56017 -0.848527,0.92553 -0.849045,0.92501 0.130225,0.33951 0.130225,0.33952 0.638204,0.0527 0.637688,0.0527 0.165365,-0.52194 0.165881,-0.52193 -0.168982,-0.27337 -0.168465,-0.27337 0.217556,0.0486 0.218075,0.0486 0.462505,-0.20206 0.462505,-0.20257 v -0.36845 -0.36846 h -0.596863 z m 67.733855,0 -0.84853,0.92553 -0.84904,0.92501 0.13022,0.33951 0.13022,0.33952 0.63821,0.0527 0.63769,0.0527 0.16536,-0.52194 0.16588,-0.52193 -0.16898,-0.27337 -0.16846,-0.27337 0.21755,0.0486 0.21808,0.0486 0.4625,-0.20206 0.46251,-0.20257 v -0.36845 -0.36846 h -0.59687 z m -43.266615,0.21446 -1.131713,0.37776 -1.132231,0.37723 v 0.34882 0.3483 l 0.991153,0.5147 0.990637,0.51418 -0.183452,0.29714 -0.183451,0.29662 -0.05013,1.233 -0.04961,1.23248 -0.329179,1.02216 -0.329694,1.02268 -0.218075,0.2775 -0.218591,0.2775 -0.18242,1.14154 -0.182417,1.14205 0.699699,-0.45838 0.699183,-0.45837 v 0.18759 0.1881 l -0.546219,0.76791 -0.546738,0.76792 h -0.261993 -0.262001 l 0.139009,-0.2248 0.138494,-0.22427 -0.626319,-0.33538 -0.62632,-0.33538 -0.289903,0.1788 -0.289388,0.1788 v 0.37207 0.37155 l 0.462504,0.23771 0.462503,0.23823 0.330213,-0.11885 0.330729,-0.11834 -0.0021,0.22014 -0.0021,0.22066 -0.460955,0.69866 -0.460438,0.69867 -0.212389,0.0946 -0.212389,0.094 -0.712618,-1.31465 -0.712619,-1.31517 -1.057301,-0.59738 -1.056783,-0.59738 -0.66094,0.0822 -0.660426,0.0827 -0.06873,0.64027 -0.06822,0.64027 0.200506,0.27854 0.200504,0.27854 1.940968,1.53685 1.940965,1.53738 0.648022,-0.29559 0.648542,-0.29559 h 0.13539 0.134876 l -0.161747,0.26251 -0.162264,0.26252 1.99626,0.94775 1.996779,0.94826 v 0.22169 0.22169 l -0.506947,1.18236 -0.506429,1.18287 -0.243395,0.15038 -0.24288,0.15038 -1.012859,-1.03766 -1.012857,-1.03766 0.375171,-0.13281 0.375172,-0.13281 0.500226,0.0574 0.500229,0.0579 0.110586,-0.31368 0.111106,-0.31367 -0.703834,-0.46096 -0.703834,-0.46147 -0.435631,0.28784 -0.43615,0.28732 0.07286,0.30903 0.07235,0.3085 -0.244946,-0.15141 -0.244945,-0.15193 -0.529167,0.83664 -0.529685,0.83613 0.13436,0.35036 0.134358,0.34985 1.096058,0.28319 1.096058,0.28319 0.462502,0.13435 0.462505,0.13385 v 0.77566 l 5.29e-4,0.77515 h 0.219625 0.219626 l 1.594733,-2.44585 1.594218,-2.44533 0.294555,-0.56689 0.294558,-0.56689 -0.393776,-0.32763 -0.39429,-0.32711 0.29714,-0.35812 0.297138,-0.35811 -0.207738,-0.46612 -0.20774,-0.46613 -0.419614,-1.30069 -0.41961,-1.3007 -0.327112,-0.10955 -0.327113,-0.10904 v 1.82004 1.81953 l 0.312642,0.31316 0.312643,0.31264 -0.144177,0.14418 -0.143661,0.14366 -0.719336,-0.27337 -0.719852,-0.27388 -0.241845,0.14986 -0.242363,0.14986 v -0.25218 -0.25115 l 0.396359,-0.15244 0.396356,-0.15245 v -0.65319 -0.65371 l -0.253214,-0.15709 -0.25373,-0.15658 -1.045414,0.94516 -1.045932,0.94516 -0.162264,-0.26303 -0.162264,-0.26252 1.561661,-1.50533 1.561664,-1.50585 -0.5178,-1.16996 -0.517279,-1.16995 0.144692,-0.37724 0.144696,-0.37724 h 0.433046 0.432533 l 0.521933,0.66353 0.521414,0.66352 0.219109,-0.13539 0.218591,-0.13539 1.339453,1.05937 1.339453,1.05936 2.037086,-0.0801 2.036568,-0.0806 0.11575,-0.34778 0.11576,-0.34727 -0.75861,-0.60875 -0.759128,-0.60875 -0.74104,0.14625 -0.740524,0.14624 -0.750858,-0.71933 -0.75034,-0.71934 -1.547709,0.13798 -1.54771,0.13746 0.60978,-0.13539 0.609783,-0.13592 -0.08113,-0.23926 -0.08165,-0.23977 -1.175639,-0.59945 -1.176067,-0.59892 -0.110072,-0.35605 -0.109554,-0.35657 0.541568,0.29042 0.54157,0.28991 h 0.822172 0.821655 l 0.697114,0.64699 0.697116,0.64647 0.217041,-0.13384 0.21704,-0.13436 -0.265099,-0.49506 -0.2651,-0.49558 v -0.18293 -0.18294 l 0.991153,1.0418 0.991156,1.0418 0.792715,0.35966 0.792716,0.35915 0.792721,0.10749 0.79323,0.10697 0.85886,0.52968 0.85886,0.52917 0.150383,-0.3917 0.14986,-0.39171 -1.141013,-1.08469 -1.14154,-1.08469 -0.57619,0.13332 -0.576187,0.13333 -0.547254,-0.76843 -0.546737,-0.76791 v -1.46399 -1.464 l 0.206705,-0.12764 0.20619,-0.12764 1.709453,1.13947 1.70997,1.13946 0.462513,-0.24339 0.4625,-0.2434 -0.008,-0.32143 -0.008,-0.32091 -0.990633,-1.14618 -0.99012,-1.14567 -0.85215,-0.0589 -0.851625,-0.0584 v 0.16019 0.1602 l -0.890902,0.32246 -0.891419,0.32246 -0.162779,0.98651 -0.163299,0.9865 -0.0026,0.72709 -0.0031,0.72709 h -0.396359 -0.396359 v -1.32189 -1.32188 h -0.231511 -0.230991 l -0.806154,0.16123 -0.805635,0.16123 -0.316259,0.76378 -0.316778,0.76429 H 90.98113 90.79871 l -0.601511,-0.8139 -0.601515,-0.81391 0.112655,-0.11265 0.112654,-0.11317 1.298112,-0.0868 1.298112,-0.0873 0.660426,-0.28009 0.66094,-0.28008 1.189075,-0.46613 1.189074,-0.46663 0.343133,-0.2651 0.342614,-0.26562 -0.300241,-0.18552 -0.300754,-0.18604 -2.288752,0.0305 -2.288231,0.0305 0.06563,0.33022 0.06615,0.33073 -0.245462,-0.0662 -0.245462,-0.0661 -0.349335,0.44804 -0.348816,0.44855 -0.79013,0.1912 -0.790134,0.1912 0.45992,-0.46043 0.45992,-0.45992 v -0.38603 -0.38602 l -0.388091,-0.14883 z m 67.733855,0 -1.13171,0.37776 -1.13223,0.37723 v 0.34882 0.3483 l 0.99115,0.5147 0.99064,0.51418 -0.18345,0.29714 -0.18345,0.29662 -0.0501,1.233 -0.0496,1.23248 -0.32918,1.02216 -0.32969,1.02268 -0.21808,0.2775 -0.21859,0.2775 -0.18242,1.14154 -0.18242,1.14205 0.6997,-0.45838 0.69918,-0.45837 v 0.18759 0.1881 l -0.54622,0.76791 -0.54673,0.76792 h -0.262 -0.262 l 0.13901,-0.2248 0.13849,-0.22427 -0.62632,-0.33538 -0.62631,-0.33538 -0.28991,0.1788 -0.28939,0.1788 v 0.37207 0.37155 l 0.46251,0.23771 0.4625,0.23823 0.33021,-0.11885 0.33073,-0.11834 -0.002,0.22014 -0.002,0.22066 -0.46096,0.69866 -0.46043,0.69867 -0.21239,0.0946 -0.21239,0.094 -0.71262,-1.31465 -0.71262,-1.31517 -1.0573,-0.59738 -1.05678,-0.59738 -0.66094,0.0822 -0.66043,0.0827 -0.0687,0.64027 -0.0682,0.64027 0.2005,0.27854 0.20051,0.27854 1.94096,1.53685 1.94097,1.53738 0.64802,-0.29559 0.64854,-0.29559 h 0.1354 0.13487 l -0.16175,0.26251 -0.16226,0.26252 1.99626,0.94775 1.99678,0.94826 v 0.22169 0.22169 l -0.50695,1.18236 -0.50643,1.18287 -0.24339,0.15038 -0.24288,0.15038 -1.01286,-1.03766 -1.01286,-1.03766 0.37517,-0.13281 0.37517,-0.13281 0.50023,0.0574 0.50023,0.0579 0.11059,-0.31368 0.1111,-0.31367 -0.70383,-0.46096 -0.70383,-0.46147 -0.43564,0.28784 -0.43615,0.28732 0.0729,0.30903 0.0723,0.3085 -0.24494,-0.15141 -0.24495,-0.15193 -0.52917,0.83664 -0.52968,0.83613 0.13436,0.35036 0.13436,0.34985 1.09606,0.28319 1.09605,0.28319 0.46251,0.13435 0.4625,0.13385 v 0.77566 l 5.3e-4,0.77515 h 0.21962 0.21963 l 1.59473,-2.44585 1.59422,-2.44533 0.29456,-0.56689 0.29455,-0.56689 -0.39377,-0.32763 -0.39429,-0.32711 0.29714,-0.35812 0.29714,-0.35811 -0.20774,-0.46612 -0.20774,-0.46613 -0.41962,-1.30069 -0.41961,-1.3007 -0.32711,-0.10955 -0.32711,-0.10904 v 1.82004 1.81953 l 0.31264,0.31316 0.31264,0.31264 -0.14418,0.14418 -0.14366,0.14366 -0.71933,-0.27337 -0.71985,-0.27388 -0.24185,0.14986 -0.24236,0.14986 v -0.25218 -0.25115 l 0.39636,-0.15244 0.39636,-0.15245 v -0.65319 -0.65371 l -0.25322,-0.15709 -0.25373,-0.15658 -1.04542,0.94516 -1.04593,0.94516 -0.16226,-0.26303 -0.16226,-0.26252 1.56166,-1.50533 1.56166,-1.50585 -0.5178,-1.16996 -0.51728,-1.16995 0.14469,-0.37724 0.1447,-0.37724 h 0.43305 0.43253 l 0.52202,0.66354 0.52141,0.66352 0.21911,-0.13539 0.21859,-0.13539 1.33946,1.05937 1.33945,1.05936 2.03709,-0.0801 2.03656,-0.0806 0.11576,-0.34778 0.11575,-0.34727 -0.7586,-0.60875 -0.75913,-0.60874 -0.74104,0.14624 -0.74052,0.14624 -0.75086,-0.71933 -0.75035,-0.71934 -1.5477,0.13798 -1.54771,0.13746 0.60978,-0.13539 0.60978,-0.13591 -0.0811,-0.23926 -0.0811,-0.23978 -1.17563,-0.59945 -1.17616,-0.59893 -0.11007,-0.35605 -0.10955,-0.35657 0.54157,0.29042 0.54156,0.28991 h 0.82218 0.82165 l 0.69712,0.64699 0.69711,0.64647 0.21704,-0.13384 0.21704,-0.13436 -0.2651,-0.49506 -0.2651,-0.49558 v -0.18293 -0.18294 l 0.99116,1.0418 0.99115,1.0418 0.79272,0.35966 0.79271,0.35915 0.79272,0.10749 0.79323,0.10697 0.85887,0.52968 0.85886,0.52917 0.15038,-0.3917 0.14986,-0.39171 -1.14102,-1.08469 -1.14153,-1.08469 -0.57619,0.13332 -0.57619,0.13333 -0.54726,-0.76843 -0.54673,-0.76791 v -1.46399 -1.464 l 0.2067,-0.12764 0.20619,-0.12764 1.70946,1.13947 1.70997,1.13946 0.46251,-0.24339 0.4625,-0.2434 -0.008,-0.32143 -0.008,-0.32091 -0.99064,-1.14618 -0.99012,-1.14567 -0.85214,-0.0589 -0.85163,-0.0584 v 0.16019 0.1602 l -0.8909,0.32246 -0.89142,0.32246 -0.16278,0.98651 -0.1633,0.9865 -0.003,0.72709 -0.003,0.72709 h -0.39636 -0.39635 v -1.32189 -1.32188 h -0.23151 -0.231 l -0.80615,0.16123 -0.80564,0.16123 -0.31626,0.76378 -0.31677,0.76429 h -0.18242 -0.18242 l -0.60151,-0.8139 -0.60152,-0.81391 0.11266,-0.11265 0.11265,-0.11317 1.29811,-0.0868 1.29812,-0.0873 0.66042,-0.28009 0.66094,-0.28008 1.18908,-0.46613 1.18907,-0.46663 0.34313,-0.2651 0.34262,-0.26562 -0.30024,-0.18552 -0.30076,-0.18604 -2.28875,0.0305 -2.28823,0.0305 0.0656,0.33022 0.0656,0.33073 -0.24546,-0.0662 -0.24547,-0.0661 -0.34933,0.44804 -0.34882,0.44855 -0.79013,0.1912 -0.79013,0.1912 0.45992,-0.46043 0.45992,-0.45992 v -0.38603 -0.38602 l -0.38809,-0.14883 z m -103.693418,0.0501 h 0.132292 0.131776 v 0.13229 0.13177 h -0.131776 -0.132292 v -0.13177 z m 67.733858,0 h 0.13229 0.13177 v 0.13229 0.13177 h -0.13177 -0.13229 v -0.13177 z m -53.459275,1.02371 -0.840261,0.0832 -0.840259,0.0827 -0.09405,0.2868 -0.09405,0.28681 0.60203,0.29042 h 5.3e-4 l 0.60203,0.2899 0.131776,0.0139 0.132291,0.0139 0.36897,-0.23358 0.368969,-0.23357 -0.168981,-0.44029 z m 67.733855,0 -0.84026,0.0832 -0.84026,0.0827 -0.0946,0.2868 -0.0935,0.28681 0.60203,0.29042 h 5.3e-4 l 0.60203,0.2899 0.13178,0.0139 0.13229,0.0139 0.36897,-0.23358 0.36897,-0.23357 -0.16899,-0.44029 z m -78.969346,0.74672 -0.871781,0.23823 -0.8723,0.23875 0.07907,0.26406 0.07958,0.26458 1.238168,-0.0134 1.238168,-0.0129 -0.100769,0.16278 -0.100769,0.1633 0.712618,0.41961 0.712102,0.41962 1.18959,0.17466 1.189075,0.17415 0.396359,0.0568 0.396357,0.0563 0.264583,0.15968 0.264067,0.1602 0.888318,0.19069 0.887801,0.19068 -0.383439,0.38396 -0.383956,0.38344 -1.95802,0.36742 -1.957504,0.3669 -0.925007,0.22479 -0.92501,0.22428 -0.33021,-0.0444 -0.330729,-0.045 -1.89601,-0.0331 -1.896007,-0.0331 0.602547,-0.6413 0.60203,-0.64131 -0.182933,-0.29662 -0.183451,-0.29662 -1.166855,0.17518 -1.167371,0.17519 -1.46141,-0.59377 -1.461926,-0.59324 -0.160197,0.16019 -0.160197,0.1602 0.349333,0.42116 0.349333,0.42168 0.481624,-0.12609 0.481108,-0.12609 -0.149345,0.24185 -0.149345,0.24133 0.479557,0.16485 0.479041,0.16433 0.660941,0.75654 0.660424,0.75654 1.057302,0.12971 1.057299,0.12971 0.660423,0.14159 0.660943,0.14159 0.528132,0.11938 0.528651,0.11885 1.137914,0.30903 1.137399,0.30851 0.712618,-0.34727 0.712103,-0.34778 0.925007,-0.10594 0.925007,-0.10645 0.528651,-0.47233 0.528132,-0.47232 0.713652,-0.45372 0.714169,-0.4532 -0.147796,0.90951 -0.147794,0.91002 1.350306,0.87488 1.349788,0.8754 v 0.1757 0.1757 l -0.158647,0.15864 -0.158647,0.15865 -0.635103,-0.2899 -0.635619,-0.28939 -0.137462,0.13694 -0.13694,0.13746 0.163814,0.42736 0.163814,0.42685 0.910021,0.17105 0.910022,0.17053 0.455787,-0.41237 0.455787,-0.4129 0.855244,0.41445 0.854729,0.41444 v 0.31368 0.31419 l -0.815454,0.7767 -0.815454,0.77669 -0.253732,0.46767 -0.253731,0.46819 0.161745,0.262 0.161748,0.262 1.567863,-1.36426 1.568381,-1.36477 v -0.33796 -0.33797 l -0.357084,-0.34933 -0.357085,-0.34933 -2.285648,-2.07946 -2.285648,-2.07894 v -0.2341 -0.23409 h 0.31936 0.318842 l 1.002006,0.97875 1.002006,0.97823 0.291457,-0.29145 0.291455,-0.29198 -0.621152,-0.88521 -0.621668,-0.88469 -0.158647,-0.1323 -0.158646,-0.13229 -0.303856,-0.57722 -0.303858,-0.57774 v -0.54623 -0.54622 l -1.123445,-0.031 -1.122928,-0.0315 -0.248047,0.0481 -0.248047,0.0481 -2.33164,0.0677 -2.331125,0.0682 0.14056,-0.4439 0.141076,-0.4439 -0.411345,-0.34158 -0.411343,-0.34106 -1.246436,-5.3e-4 z m 67.733856,0 -0.87179,0.23823 -0.87229,0.23875 0.0791,0.26406 0.0796,0.26458 1.23816,-0.0134 1.23817,-0.0129 -0.10077,0.16278 -0.10077,0.1633 0.71262,0.41961 0.7121,0.41962 1.18959,0.17466 1.18908,0.17415 0.39636,0.0568 0.39636,0.0563 0.26458,0.15968 0.26406,0.1602 0.88832,0.19069 0.8878,0.19068 -0.38343,0.38396 -0.38396,0.38344 -1.95802,0.36742 -1.9575,0.3669 -0.92501,0.22479 -0.92501,0.22428 -0.33021,-0.0444 -0.33073,-0.045 -1.89601,-0.0331 -1.89601,-0.0331 0.60255,-0.6413 0.60203,-0.64131 -0.18294,-0.29662 -0.18345,-0.29662 -1.16685,0.17518 -1.16737,0.17519 -1.46141,-0.59377 -1.46193,-0.59324 -0.16019,0.16019 -0.1602,0.1602 0.34933,0.42116 0.34933,0.42168 0.48163,-0.12609 0.4811,-0.12609 -0.14934,0.24185 -0.14934,0.24133 0.47955,0.16485 0.47905,0.16433 0.66094,0.75654 0.66042,0.75654 1.0573,0.12971 1.0573,0.12971 0.66043,0.14159 0.66094,0.14159 0.52813,0.11938 0.52865,0.11885 1.13792,0.30903 1.13739,0.30851 0.71262,-0.34727 0.7121,-0.34778 0.92501,-0.10594 0.92501,-0.10645 0.52865,-0.47233 0.52813,-0.47232 0.71365,-0.45372 0.71417,-0.4532 -0.14779,0.90951 -0.1478,0.91002 1.35031,0.87488 1.34978,0.8754 v 0.1757 0.1757 l -0.15864,0.15864 -0.15865,0.15865 -0.6351,-0.2899 -0.63562,-0.28939 -0.13746,0.13694 -0.13694,0.13746 0.16381,0.42736 0.16382,0.42685 0.91002,0.17105 0.91002,0.17053 0.45578,-0.41237 0.45579,-0.4129 0.85525,0.41445 0.85473,0.41444 v 0.31368 0.31419 l -0.81546,0.7767 -0.81545,0.77669 -0.25374,0.46767 -0.25373,0.46819 0.16175,0.262 0.16175,0.262 1.56786,-1.36426 1.56838,-1.36477 v -0.33796 -0.33797 l -0.35708,-0.34933 -0.35709,-0.34933 -2.28565,-2.07946 -2.28564,-2.07894 v -0.2341 -0.23409 h 0.31936 0.31884 l 1.00201,0.97875 1.002,0.97823 0.29146,-0.29145 0.29145,-0.29198 -0.62115,-0.88521 -0.62167,-0.8847 -0.15864,-0.13229 -0.15865,-0.1323 -0.30386,-0.57722 -0.30386,-0.57774 v -0.54622 -0.54622 l -1.12344,-0.031 -1.12293,-0.0315 -0.24805,0.0481 -0.24804,0.0481 -2.33164,0.0677 -2.33113,0.0682 0.14056,-0.4439 0.14108,-0.44389 -0.41134,-0.34159 -0.41135,-0.34106 -1.24644,-5.3e-4 z m -41.376292,0.87333 h 0.35915 0.35967 l 0.370519,0.5948 0.37052,0.5948 -0.12919,0.99167 -0.129191,0.99115 h -0.196371 -0.196887 l -0.723988,-0.67076 -0.723468,-0.67128 0.186549,-0.45268 0.186553,-0.45217 0.13281,-0.46302 z m 67.733852,0 h 0.35916 0.35966 l 0.37052,0.5948 0.37052,0.5948 -0.12919,0.99167 -0.12919,0.99115 h -0.19637 -0.19689 l -0.72398,-0.67076 -0.72347,-0.67128 0.18655,-0.45268 0.18655,-0.45217 0.13281,-0.46302 z m -51.674883,0.44029 0.17622,0.17621 0.17621,0.17622 -0.17621,0.17674 -0.17622,0.17621 v -0.35295 z m 67.733853,0 0.17622,0.17621 0.17622,0.17622 -0.17622,0.17674 -0.17622,0.17621 v -0.35295 z m -84.943138,0.0884 h 0.132291 0.132292 l 0.163296,0.26459 0.163298,0.26406 h -0.132292 -0.132291 l -0.163299,-0.26406 z m 67.733858,0 h 0.13229 0.13229 l 0.1633,0.26459 0.16329,0.26406 h -0.13229 -0.13229 l -0.16329,-0.26406 z m -108.401142,0.26406 h 0.75189 0.75189 l 0.40773,0.46302 0.40824,0.4625 0.168468,0.79582 0.168465,0.79634 1.070735,1.25263 1.070736,1.25316 h 0.375688 0.375687 v -0.34365 -0.34365 l -0.330212,-0.38137 -0.330212,-0.38137 0.858862,0.77464 0.858863,0.77411 v 0.34726 0.34727 h -0.264067 -0.264584 v 0.26717 0.26665 l -0.95498,1.38544 -0.954981,1.38545 -0.417028,0.33021 -0.416512,0.33073 h -0.204639 -0.204122 l -0.312642,-0.59479 -0.312125,-0.5948 -1.04283,-1.25626 -1.04335,-1.25573 h 0.40566 0.40514 l 0.15297,0.24804 0.15348,0.24754 0.7214,0.36431 0.721402,0.36484 0.559656,0.35501 0.559655,0.35451 0.433565,-0.1664 0.433566,-0.1664 0.309025,-0.67851 0.309025,-0.678 -0.377238,-0.37672 -0.377238,-0.37724 -2.510958,-0.28112 -2.51044,-0.28163 -0.84904,-0.98392 -0.84905,-0.98444 -0.009,-0.19844 -0.01,-0.19792 h 0.2651 0.2651 l 1.96164,1.06402 1.96112,1.06454 0.192236,-0.31161 0.192236,-0.3111 -0.451132,-0.33021 -0.45062,-0.32969 -0.91106,-1.28158 -0.91054,-1.28157 v -0.46354 z m 67.733852,0 h 0.75189 0.75189 l 0.40773,0.46302 0.40824,0.4625 0.16847,0.79582 0.16846,0.79634 1.07074,1.25263 1.07074,1.25316 h 0.37568 0.37569 v -0.34365 -0.34365 l -0.33021,-0.38137 -0.33021,-0.38137 0.85886,0.77463 0.85886,0.77411 v 0.34726 0.34727 h -0.26407 -0.26458 v 0.26717 0.26665 l -0.95498,1.38544 -0.95498,1.38545 -0.41703,0.33021 -0.41651,0.33073 h -0.20464 -0.20412 l -0.31264,-0.5948 -0.31213,-0.59479 -1.04283,-1.25626 -1.04335,-1.25573 h 0.40566 0.40515 l 0.15296,0.24804 0.15348,0.24753 0.7214,0.36432 0.7214,0.36484 0.55966,0.35501 0.55965,0.35451 0.43357,-0.1664 0.43357,-0.1664 0.30902,-0.67851 0.30903,-0.678 -0.37724,-0.37672 -0.37724,-0.37724 -2.51096,-0.28112 -2.51044,-0.28163 -0.84904,-0.98392 -0.84905,-0.98444 -0.01,-0.19844 -0.01,-0.19792 h 0.2651 0.2651 l 1.96164,1.06402 1.96112,1.06454 0.19224,-0.31161 0.19223,-0.3111 -0.45113,-0.33021 -0.45062,-0.32969 -0.91106,-1.28158 -0.91054,-1.28158 v -0.46353 z m -12.235434,0.26356 v 0.64182 0.64182 l 0.383439,0.38396 0.383952,0.38447 -0.12815,0.12816 -0.128677,0.12867 1.080037,0.1726 1.08056,0.1726 0.90381,0.90434 0.903833,0.90434 0.94102,0.447 0.94155,0.447 0.16691,-0.16692 0.1664,-0.16691 -0.50643,-0.004 -0.50643,-0.004 0.39636,-0.2558 0.39636,-0.25683 0.99115,-0.004 0.99116,-0.004 v 0.24236 0.24237 l 0.29352,0.22944 v -4.45502 l -1.40405,-0.25839 -0.50229,0.45424 -0.50178,0.45424 v 0.48782 0.48783 h 0.77153 0.77101 l 0.41806,0.16071 0.41806,0.1602 -5.3e-4,0.17001 v 0.17002 l -1.48569,-0.015 -1.48518,-0.015 -0.65681,-0.58498 -0.65629,-0.58446 -1.035083,-0.23306 -1.03508,-0.23254 -0.90124,-0.68782 -0.901234,-0.68729 h -0.282152 z m 67.733854,0 v 0.64182 0.64182 l 0.38344,0.38396 0.38396,0.38447 -0.12816,0.12816 -0.12868,0.12867 1.08004,0.1726 1.08056,0.1726 0.90382,0.90434 0.90382,0.90434 0.94103,0.447 0.94154,0.447 0.16692,-0.16692 0.16639,-0.16691 -0.50642,-0.004 -0.50643,-0.004 0.39635,-0.2558 0.39636,-0.25683 0.99116,-0.004 0.99115,-0.004 v 0.24236 0.24237 l 0.29352,0.22944 v -4.45502 l -1.40405,-0.25839 -0.50229,0.45424 -0.50178,0.45424 v 0.48782 0.48783 h 0.77153 0.77101 l 0.41807,0.16071 0.41806,0.1602 -5.3e-4,0.17001 v 0.17002 l -1.4857,-0.015 -1.48518,-0.015 -0.65681,-0.58498 -0.65629,-0.58446 -1.03508,-0.23306 -1.03508,-0.23254 -0.90123,-0.68782 -0.90124,-0.68729 h -0.28215 z m -95.086707,1.19063 0.462505,0.36276 0.462505,0.36277 v 0.0997 0.0997 h -0.09974 -0.09974 l -0.362767,-0.4625 z m 67.733857,0 0.4625,0.36276 0.46251,0.36277 v 0.0997 0.0997 h -0.0997 -0.0997 l -0.36277,-0.4625 z m -58.88065,0.13177 h 0.132292 0.131776 v 0.13229 0.13229 H 77.881642 77.74935 v -0.13229 z m 67.73386,0 h 0.13229 0.13177 v 0.13229 0.13229 h -0.13177 -0.13229 v -0.13229 z m -89.668955,0.52917 v 0.13177 0.13229 h 0.132291 0.132292 v -0.13229 -0.13177 h -0.132292 z m 67.733855,0 v 0.13177 0.13229 h 0.13229 0.13229 v -0.13229 -0.13177 h -0.13229 z m -77.776136,0.5457 0.566891,0.22686 0.622184,0.2496 -0.594279,0.0165 -0.594796,0.0171 v -0.28009 z m 67.733856,0 0.56689,0.22686 0.62218,0.2496 -0.59428,0.0165 -0.59479,0.0171 v -0.28009 z m -64.03434,0.5116 v 0.13229 0.13229 h 0.132292 0.132292 v -0.13229 -0.13229 h -0.132292 z m 67.73385,0 v 0.13229 0.13229 h 0.13229 0.1323 v -0.13229 -0.13229 h -0.1323 z m -41.379902,0.26458 h 0.301273 0.301273 v 0.25063 h 0.0011 v 0.25063 l -0.660943,0.71314 -0.660942,0.71313 0.0083,-0.50126 0.0083,-0.50126 0.351401,-0.4625 z m 67.733852,0 h 0.30128 0.30127 v 0.25063 h 10e-4 v 0.25063 l -0.66094,0.71314 -0.66094,0.71313 0.008,-0.50126 0.008,-0.50126 0.3514,-0.4625 z m -94.820571,0.48266 -0.171049,0.27595 -0.170533,0.27647 1.321884,0.56896 1.321883,0.56895 0.302307,0.36432 0.302306,0.36484 0.204639,-0.12661 0.204639,-0.12609 0.29559,0.35657 0.29559,0.35605 2.115632,0.0512 2.115632,0.0512 0.172083,-0.44855 0.172082,-0.44855 -0.428913,-0.3142 -0.429432,-0.31419 -0.806151,0.11834 -0.806154,0.11834 -0.144693,0.23409 -0.144176,0.2341 h -0.392743 -0.392223 l 0.07751,-0.45527 0.07803,-0.45527 -0.925008,-0.30748 -0.925009,-0.30747 -1.057299,-0.1447 -1.0573,-0.14469 -0.564824,-0.17311 z m 67.733851,0 -0.17105,0.27595 -0.17053,0.27647 1.32188,0.56896 1.32189,0.56895 0.3023,0.36432 0.30231,0.36484 0.20464,-0.12661 0.20464,-0.12609 0.29559,0.35657 0.29559,0.35605 2.11563,0.0512 2.11563,0.0512 0.17209,-0.44855 0.17208,-0.44855 -0.42892,-0.3142 -0.42943,-0.31419 -0.80615,0.11834 -0.80615,0.11834 -0.1447,0.23409 -0.14417,0.2341 h -0.39275 -0.39222 l 0.0775,-0.45527 0.078,-0.45527 -0.92501,-0.30748 -0.925,-0.30747 -1.05731,-0.1447 -1.05729,-0.14469 -0.56483,-0.17311 z m -11.76724,1.36684 -0.39946,5.3e-4 -0.39946,5.3e-4 -1.25212,0.54312 -1.25263,0.54312 -1.36374,0.66611 -1.363233,0.66662 -0.3545,0.0656 -0.35398,0.0656 -1.048,0.45372 -1.047999,0.4532 -0.198438,0.3204 -0.198953,0.32039 -0.97255,-1.00046 -0.97255,-1.00097 -0.291457,0.0966 -0.291455,0.0956 -0.221176,2.05982 -0.220657,2.05982 0.224277,1.2237 0.223758,1.2237 0.520898,5.3e-4 0.520899,5.3e-4 0.159163,0.9772 0.158646,0.9772 0.374137,0.46095 0.374139,0.46096 -0.345715,-0.20774 -0.345715,-0.20826 -1.041797,0.72192 -1.041797,0.72244 v 0.21032 0.21033 l 0.858862,0.60564 0.85938,0.60565 0.502293,0.46095 0.502295,0.46044 0.194821,-0.1204 0.194302,-0.11989 -0.03617,0.35811 -0.03669,0.35812 1.786969,1.88619 1.78697,1.88619 h 0.25425 0.25477 l 0.40566,-0.78548 0.406173,-0.78497 0.50643,-0.2713 0.50643,-0.2713 0.0853,0.35709 0.0853,0.35708 1.66708,1.38286 1.66708,1.38286 0.26407,-0.10128 v -1.16634 l -1.19579,-1.62522 -1.21181,-1.64642 -0.46302,-0.0294 -0.46302,-0.0295 -0.66095,0.0563 -0.66042,0.0563 -0.408763,0.21807 -0.40876,0.21808 -0.91261,-0.43305 -0.9126,-0.43305 -1.252641,-0.8692 -1.252636,-0.86971 h -0.267168 -0.26665 v -0.28526 -0.28577 l 0.72657,0.1478 0.726572,0.14779 0.66094,0.12661 0.660423,0.12609 0.5917,0.17363 0.59118,0.17364 0.16898,-0.44029 0.16846,-0.43976 -0.62787,-0.67335 -0.62786,-0.67282 -1.811264,0.17621 -1.810742,0.17673 0.162266,-0.26303 0.162264,-0.26251 0.85576,-0.18294 0.855763,-0.18345 0.318844,-0.25631 0.318326,-0.25632 -0.233061,-0.44028 -0.233061,-0.43977 -0.161748,-0.39687 -0.162263,-0.39636 -0.324012,-0.52865 -0.324011,-0.52865 -0.743622,-1.10278 -0.744141,-1.10226 0.08733,-0.61598 0.08733,-0.61598 0.796335,-0.078 0.795816,-0.0786 0.563274,0.52503 0.563272,0.52503 0.09405,-0.0915 0.09404,-0.091 0.016,1.53945 0.016,1.53996 0.33383,0.40204 0.33384,0.40256 0.44286,-0.16433 0.44339,-0.16485 0.78548,-0.54674 0.785998,-0.54674 0.36483,-0.33899 0.36535,-0.339 1.0294,-0.52555 1.02942,-0.5256 v -0.27853 -0.27906 l -2.38952,0.18707 -2.390028,0.18707 -0.37673,-0.49765 -0.37672,-0.49764 -0.008,-0.29507 -0.008,-0.29456 2.31252,-1.40715 2.312518,-1.40663 0.66043,-0.40308 0.66094,-0.40307 -0.48369,0.56276 -0.48369,0.56223 0.28577,0.5333 0.28525,0.53331 v 0.31109 0.31109 l -0.5271,-0.62425 -0.52658,-0.62373 -0.79065,0.85886 -0.79117,0.85938 h -0.367928 -0.36742 l -0.33436,0.40307 -0.33435,0.40308 0.10387,0.0791 0.10335,0.0796 1.982308,-0.16691 1.98231,-0.1664 0.19379,0.27905 0.1943,0.27906 0.004,0.52865 0.004,0.52916 -0.91054,0.72709 -0.91106,0.72657 h -0.15864 -0.15917 l -1.473288,0.9431 -1.4733,0.94309 0.72554,0.75758 0.72554,0.75758 0.0315,1.14153 0.032,1.14153 -0.21962,1.12345 -0.21911,1.12344 h 0.39687 0.396878 l 0.69246,-1.2392 0.69246,-1.2392 -0.15502,-0.40514 -0.15555,-0.40463 0.19069,0.19069 0.19068,0.19068 0.50075,-0.4532 0.50022,-0.45269 -0.18706,1.41232 -0.18759,1.41283 0.49506,-0.27698 0.49506,-0.2775 0.28319,0.83716 0.2837,0.83715 0.30748,-0.063 0.30799,-0.0631 -0.14728,0.38447 -0.14728,0.38396 0.4992,0.73639 0.37258,0.54984 v -4.6483 l -0.37052,-0.14211 -0.35553,0.48628 -0.35553,0.48679 -0.18242,-0.18242 -0.18191,-0.18242 0.56586,-0.76584 0.56586,-0.76533 -0.35347,-0.29404 -0.35346,-0.29352 -1.86966,-0.061 -1.86965,-0.061 0.14211,-0.66094 0.14211,-0.66094 1.09347,-0.98392 1.09348,-0.9834 0.73329,0.7028 0.73328,0.7028 v 0.21497 0.21446 l -0.72708,0.004 -0.72658,0.004 -0.36586,0.23203 -0.36639,0.23151 0.50333,0.26975 0.50385,0.26975 2.00142,0.41341 v -2.76469 l -0.1018,-0.0191 -0.93431,-0.50126 -0.93431,-0.50023 0.43098,-0.16588 0.43047,-0.16485 1.002,0.32298 0.10697,0.0341 v -2.26498 l -0.22634,-0.25063 -0.67851,-0.75189 0.3054,-1.65779 0.30541,-1.65829 v -0.6966 z m 67.73385,0 -0.39945,5.3e-4 -0.39946,5.3e-4 -1.25212,0.54312 -1.25264,0.54312 -1.36374,0.66611 -1.36323,0.66662 -0.3545,0.0656 -0.35398,0.0656 -1.048,0.45372 -1.04799,0.4532 -0.19844,0.3204 -0.19896,0.32039 -0.97255,-1.00046 -0.97255,-1.00097 -0.29145,0.0966 -0.29146,0.0956 -0.22117,2.05982 -0.22066,2.05982 0.22427,1.2237 0.22376,1.2237 0.5209,5.3e-4 0.5209,5.3e-4 0.15916,0.9772 0.15865,0.9772 0.37414,0.46095 0.37413,0.46096 -0.34571,-0.20774 -0.34572,-0.20826 -1.04179,0.72192 -1.0418,0.72244 v 0.21032 0.21033 l 0.85886,0.60564 0.85938,0.60565 0.5023,0.46095 0.50229,0.46044 0.19482,-0.1204 0.19431,-0.11989 -0.0362,0.35811 -0.0372,0.35812 1.78698,1.88619 1.78748,1.88619 h 0.25373 0.25529 l 0.40566,-0.78548 0.40617,-0.78497 0.50592,-0.2713 0.50642,-0.2713 0.0858,0.35709 0.0853,0.35708 1.66708,1.38286 1.66709,1.38286 0.26406,-0.10128 v -1.16634 l -1.19579,-1.62522 -1.21181,-1.64642 -0.46302,-0.0294 -0.46302,-0.0295 -0.66094,0.0563 -0.66043,0.0563 -0.40876,0.21807 -0.40876,0.21808 -0.91261,-0.43305 -0.9126,-0.43305 -1.25264,-0.8692 -1.25264,-0.86971 h -0.26716 -0.26665 v -0.28526 -0.28577 l 0.72657,0.1478 0.72657,0.14779 0.66094,0.12661 0.66042,0.12609 0.5917,0.17363 0.59118,0.17364 0.16898,-0.44029 0.16846,-0.43976 -0.62786,-0.67335 -0.62787,-0.67282 -1.81126,0.17621 -1.81074,0.17673 0.16226,-0.26303 0.16226,-0.26251 0.85577,-0.18294 0.85576,-0.18345 0.31884,-0.25631 0.31833,-0.25632 -0.23306,-0.44028 -0.23306,-0.43977 -0.16175,-0.39687 -0.16227,-0.39636 -0.324,-0.52865 -0.32402,-0.52865 -0.74362,-1.10278 -0.74414,-1.10226 0.0873,-0.61598 0.0873,-0.61598 0.79633,-0.078 0.79581,-0.0786 0.56328,0.52503 0.56275,0.52503 0.0946,-0.0915 0.094,-0.091 0.016,1.53945 0.016,1.53996 0.33383,0.40204 0.33383,0.40256 0.44287,-0.16433 0.44338,-0.16485 0.78548,-0.54674 0.786,-0.54674 0.36484,-0.33899 0.36535,-0.339 1.02939,-0.52555 1.0294,-0.52555 v -0.27853 -0.27906 l -2.38952,0.18707 -2.39004,0.18707 -0.37672,-0.49765 -0.37672,-0.49764 -0.008,-0.29507 -0.008,-0.29456 2.31252,-1.40715 2.31252,-1.40663 0.66043,-0.40308 0.66094,-0.40307 -0.48369,0.56276 -0.48369,0.56223 0.28577,0.5333 0.28525,0.53331 v 0.31109 0.31109 l -0.5271,-0.62425 -0.52658,-0.62373 -0.79065,0.85886 -0.79117,0.85938 h -0.36793 -0.36742 l -0.33435,0.40307 -0.33435,0.40308 0.10387,0.0791 0.10336,0.0796 1.9823,-0.16692 1.98231,-0.1664 0.19379,0.27905 0.1943,0.27906 0.004,0.52865 0.004,0.52917 -0.91054,0.72708 -0.91106,0.72657 h -0.15864 -0.15917 l -1.47329,0.9431 -1.4733,0.94309 0.72554,0.75758 0.72554,0.75758 0.0315,1.14153 0.0315,1.14153 -0.21962,1.12345 -0.21911,1.12344 h 0.39687 0.39688 l 0.69246,-1.2392 0.69247,-1.2392 -0.15503,-0.40514 -0.15555,-0.40463 0.19069,0.19069 0.19069,0.19068 0.50074,-0.4532 0.50023,-0.45269 -0.18707,1.41232 -0.18759,1.41284 0.49506,-0.27699 0.49506,-0.2775 0.28319,0.83716 0.28371,0.83715 0.30747,-0.063 0.30799,-0.063 -0.14728,0.38447 -0.14727,0.38396 0.49919,0.73639 0.37259,0.54984 V 205.989 l -0.37052,-0.14211 -0.35554,0.48628 -0.35553,0.48679 -0.18242,-0.18242 -0.1819,-0.18242 0.56586,-0.76584 0.56585,-0.76533 -0.35346,-0.29404 -0.35347,-0.29352 -1.86965,-0.061 -1.86966,-0.061 0.14211,-0.66094 0.14211,-0.66094 1.09348,-0.98392 1.09347,-0.9834 0.73329,0.7028 0.73329,0.7028 v 0.21497 0.21446 l -0.72709,0.004 -0.72657,0.004 -0.36587,0.23203 -0.36638,0.23151 0.50332,0.26975 0.50385,0.26975 2.00143,0.41341 v -2.76469 l -0.1018,-0.0191 -0.93431,-0.50126 -0.93431,-0.50023 0.43098,-0.16588 0.43046,-0.16485 1.00201,0.32298 0.10697,0.0341 v -2.26498 l -0.22635,-0.25063 -0.67851,-0.75189 0.30541,-1.65779 0.30541,-1.65829 v -0.6966 z m -109.527165,0.26407 -0.761196,5.3e-4 -0.761709,0.001 -0.672827,0.30696 -0.673344,0.30644 v 0.33848 0.33848 l 0.269232,0.1664 0.269235,0.1664 0.985986,-0.59635 0.986504,-0.59634 -0.48369,0.55604 -0.483693,0.55552 0.285255,0.5333 0.285253,0.53382 v 0.31109 0.31057 l -0.526582,-0.62373 -0.526584,-0.62425 -0.791165,0.85938 -0.790649,0.85886 h -0.367938 -0.367935 l -0.337965,0.40773 -0.338479,0.40772 0.305925,0.30645 0.305924,0.30592 v -0.31729 -0.3173 h 0.75189 0.751893 l 0.434081,0.48008 0.434599,0.48007 0.172083,0.90796 0.1726,0.90795 0.190686,0.26459 0.190685,0.26406 0.159165,0.66921 0.159163,0.66869 -0.517282,0.78548 -0.517281,0.78497 -0.0021,0.85886 -0.0021,0.85938 0.33021,0.004 0.330213,0.004 -0.396359,0.25632 -0.396356,0.2558 0.346231,0.004 0.345715,0.004 -0.138493,0.22428 -0.13901,0.22479 0.610299,0.3266 0.609782,0.32659 0.833541,-0.13126 0.833024,-0.13126 0.131776,0.21343 0.131773,0.21342 -0.416512,0.15968 -0.41651,0.1602 h -0.612916 -0.613399 l -0.268717,0.77049 -0.268202,0.7705 0.154514,0.15451 0.154511,0.15503 h 0.367937 0.367935 l -0.188618,-0.30541 -0.188619,-0.3054 0.334864,0.20722 0.334346,0.2067 0.220658,-0.35656 0.220141,-0.35657 0.123507,0.12454 0.123508,0.12454 -0.20619,1.0573 -0.206706,1.05782 -0.177768,0.66094 -0.177766,0.66094 0.737939,0.30799 0.737423,0.30799 0.876432,0.17984 0.876951,0.17931 0.68988,0.35812 0.68988,0.35812 0.214458,-0.13281 0.214974,-0.13281 -0.662493,-1.30793 -0.662493,-1.30793 -0.259932,-0.0331 -0.259932,-0.0336 -0.330213,-0.0346 -0.330729,-0.0362 -0.627351,0.74053 -0.627351,0.74052 -0.141594,-0.14159 -0.142111,-0.1416 0.420645,-0.46509 0.420648,-0.46508 0.388088,-0.74776 0.387575,-0.74776 -0.359669,-0.6935 -0.359667,-0.69349 0.125056,-0.12506 0.125058,-0.12506 0.771011,0.73897 0.770496,0.73898 0.315743,0.76171 0.315743,0.76223 h 0.19017 0.190169 l 0.321426,1.07176 0.320911,1.07126 1.019577,0.9219 1.020093,0.92139 -0.68213,0.68265 -0.682128,0.68213 -1.409734,-0.33848 -1.409732,-0.33848 v -0.23358 -0.23358 l 0.330213,0.0429 0.330211,0.0434 0.484725,-0.0315 0.484727,-0.0315 -0.105421,-0.31575 -0.10542,-0.31625 -0.775663,-0.22583 -0.775664,-0.22635 -0.725019,-0.0677 -0.725022,-0.0677 -0.144692,0.45527 -0.14418,0.45527 0.157615,0.61753 0.157613,0.61702 1.002006,0.38758 h 4.242117 l 0.804603,-0.87179 v 0.67231 0.19948 h 1.720308 l 0.01757,-0.0553 0.150379,-0.47336 -0.878501,-0.37207 -0.877983,-0.37207 0.43615,-0.17001 0.435633,-0.17053 1.395781,0.41496 1.39578,0.41444 h 0.513146 0.513146 l -0.293005,-0.35295 -0.293004,-0.35295 -1.258838,-0.63251 -1.259355,-0.63201 -0.662491,-0.47129 -0.662493,-0.47077 -0.85731,0.0997 -0.856798,0.0992 v -0.20153 -0.20103 l 0.396359,-0.15244 0.396359,-0.15193 v -0.52141 -0.52194 l 0.264584,-0.16329 0.264064,-0.1633 v -0.38086 -0.38085 H 70.48096 70.084601 v -0.24236 -0.24237 l 0.330213,-0.1111 0.330211,-0.11111 -0.313675,-0.63768 -0.313676,-0.63821 -0.180867,-0.64027 -0.180869,-0.63975 -1.090888,-1.08831 -1.09089,-1.08779 -2.037601,-1.03663 -2.037085,-1.03714 -0.180867,0.18087 -0.180353,0.18086 0.349335,0.42117 0.349331,0.42116 0.461471,-0.12041 0.460954,-0.12092 -0.15658,0.40928 -0.157097,0.40927 0.563791,-0.14779 0.564306,-0.14728 -0.02222,0.17105 -0.02222,0.17105 0.03101,0.36122 0.03152,0.36173 0.462505,-0.12092 0.462505,-0.12144 0.03566,0.58395 0.03617,0.58394 -0.898136,0.27543 -0.898136,0.27596 -0.270269,-0.50488 -0.270267,-0.5054 h -0.346231 -0.346233 l -0.450617,-0.49764 -0.45062,-0.49816 0.18035,-1.35858 0.180351,-1.35857 0.202054,-0.12506 0.202573,-0.12505 0.801502,0.16019 0.8015,0.16072 0.494543,0.43305 0.494028,0.43356 0.647506,0.37156 0.646989,0.37155 0.396359,0.1943 0.396356,0.1943 1.255221,0.59893 1.255739,0.59945 v 0.23823 0.23874 l 0.197918,-0.12247 0.198438,-0.12247 0.05943,0.96583 0.05891,0.96635 0.0088,1.43919 0.0078,1.43867 0.329694,0.20929 0.329179,0.20929 0.859896,0.004 0.859896,0.004 0.990121,0.55346 0.990121,0.55397 -0.792716,-0.15554 -0.792718,-0.15555 -1.26814,-0.17208 -1.268137,-0.17209 0.07855,0.35916 0.07906,0.35915 0.660424,0.3762 0.660942,0.37569 0.792716,0.41806 0.792718,0.41806 0.594794,0.0837 0.594797,0.0837 v -0.27336 -0.27337 h 0.363802 0.364318 l 0.351401,0.42426 0.351917,0.42375 -0.436666,0.76171 -0.437184,0.76119 0.40101,0.40101 0.400492,0.40049 h 0.355534 0.355534 l 0.133323,-0.33021 0.133326,-0.33073 0.02066,0.447 0.02066,0.447 -0.03565,0.0222 h 0.920872 l -0.03824,-0.28629 -0.419095,-0.46354 -0.419613,-0.46302 0.318328,-0.84336 0.317809,-0.84284 h 0.243396 0.243395 l 0.336415,0.46044 0.336413,0.46043 0.961181,0.0372 0.961183,0.0377 0.145728,0.14572 0.145211,0.14521 -0.16795,0.27182 -0.167949,0.27182 -0.673344,-0.2558 -0.673859,-0.25631 -0.239263,0.14831 -0.239778,0.14779 0.04082,1.04387 0.0093,0.24081 h 0.743624 l 1.037664,-0.71779 1.049547,-0.72657 0.01035,-0.28939 0.0098,-0.2899 -0.528648,-0.47852 -0.528135,-0.47801 v -0.26872 -0.26872 l -0.370519,-0.41754 -0.370002,-0.41755 -0.269234,-0.99115 -0.269235,-0.99167 h 0.227893 0.22841 l 0.468188,0.79323 0.468188,0.79323 h 0.201023 0.200504 l 0.525549,1.15394 0.525548,1.15393 0.575677,-0.0305 0.575675,-0.0305 0.292489,-0.46871 0.293005,-0.4687 -1.368393,-1.24954 -1.368907,-1.24954 -0.283188,-0.57774 -0.282671,-0.57723 v -0.41392 -0.41393 h 0.264068 0.264067 v 0.38085 0.38086 l 0.305406,0.18862 0.304893,0.18862 -0.213424,-0.34624 -0.213942,-0.34571 0.309541,0.1912 0.309026,0.1912 -0.135909,0.22015 -0.05529,0.0894 -0.08062,0.13074 1.47433,1.34772 1.474327,1.34772 h 0.430464 0.430466 l 2.455664,-0.6966 2.455146,-0.69711 v -0.37827 -0.37828 l -0.528649,0.16744 -0.52865,0.16794 v -0.3948 -0.39533 l -1.493965,-0.68368 -1.493451,-0.68419 -0.134874,0.13487 -0.134877,0.13488 0.290939,0.63923 0.291457,0.63873 0.544669,0.17311 0.544668,0.17312 v 0.18033 l -5.29e-4,0.18036 -1.867585,-0.0274 -1.867588,-0.0269 -0.429948,-0.43046 -0.429948,-0.42995 0.574125,0.11059 0.574643,0.11059 0.128675,-0.20826 0.128675,-0.20825 -1.181325,-1.42782 -1.180807,-1.42782 -0.423746,-0.44545 -0.423746,-0.44546 -0.649573,0.24702 -0.650089,0.24701 h -0.379307 -0.378788 v -0.25735 -0.25786 l 0.779283,-0.40308 0.779795,-0.40359 h 0.252183 0.251663 l 2.040187,2.51199 2.039667,2.51147 h 0.232027 0.232029 v -0.27181 -0.27131 l -1.181325,-2.204 -1.181323,-2.204 0.143661,-0.14366 0.143661,-0.14365 -0.422714,-0.81753 -0.422714,-0.81804 -0.455785,-0.0305 -0.455787,-0.0305 -0.448035,0.045 -0.448551,0.0444 -0.49971,-0.47698 -0.499711,-0.47645 -0.463539,-0.26665 -0.463021,-0.26665 0.180351,-0.96274 0.180869,-0.96273 0.725535,-0.10697 0.725538,-0.10645 0.889868,1.40612 0.889867,1.40611 0.259935,-0.0868 0.259932,-0.0863 0.305406,-1.3565 0.304892,-1.35651 -0.18035,-0.29197 -0.179835,-0.29197 -0.334864,0.40359 -0.334862,0.40359 -0.4346,-0.23461 -0.435115,-0.23461 -1.526005,-1.33842 -1.526006,-1.33842 -1.050581,0.54777 -1.050581,0.54777 v 0.24443 0.24392 l 0.72657,0.30075 0.727088,0.30024 0.181901,-0.0372 0.181901,-0.0372 0.172598,0.54312 0.172601,0.54312 -0.108521,0.10852 -0.108003,0.108 -0.988571,-0.50385 -0.988571,-0.50436 -1.041796,-0.1757 -1.041281,-0.17621 v -0.24133 -0.24081 h 0.894003 0.894003 l 0.159679,-0.5948 0.159163,-0.59479 0.0041,-1.00925 0.0036,-1.00872 -0.273368,-0.51108 -0.273367,-0.5116 h -0.279054 -0.278537 l -0.496094,0.5948 -0.496093,0.59479 v 0.39688 l -5.3e-4,0.39636 0.357085,-0.47026 0.356568,-0.47077 0.145209,0.37879 0.145211,0.37879 -0.357084,0.48834 -0.356566,0.48782 -1.145151,-0.80718 -1.145667,-0.8077 -0.593762,0.71726 -0.593762,0.71727 v 0.42117 0.42064 h 1.041281 1.041797 l 0.163298,0.26459 0.163295,0.26406 h -1.053682 -1.054198 l -0.349334,0.33073 -0.348816,0.33021 -0.396357,-0.007 -0.396875,-0.007 -0.30644,-0.19223 -0.306443,-0.19224 -0.420129,0.16175 -0.42013,0.16123 v -0.293 -0.29249 h -0.301789 -0.301791 l -0.750343,0.78548 -0.749824,0.78496 0.151411,0.39429 0.150897,0.39481 0.537435,0.17053 0.536916,0.17054 0.227378,-0.35915 0.227375,-0.35864 0.0031,-0.447 0.0041,-0.447 0.264065,-0.1633 0.264583,-0.16381 -0.01913,0.47852 -0.01963,0.47801 -0.44855,0.76429 -0.448551,0.7643 -2.569872,0.0351 -2.570384,0.0346 0.122473,-0.40256 0.122473,-0.40308 -0.850077,-0.94309 -0.850593,-0.94309 -0.528651,-0.30438 -0.528651,-0.30489 0.56224,-0.008 0.562239,-0.008 0.339516,0.40928 0.339514,0.40876 1.409215,0.66714 1.409735,0.66714 0.595828,-0.0915 0.595829,-0.0915 -1.963704,-1.27796 -1.963705,-1.27796 -0.367419,-0.36742 -0.367419,-0.36793 h 0.56224 0.562755 l 1.107943,0.61805 1.107942,0.61753 0.396875,-0.12195 0.396359,-0.12196 0.71727,-0.66818 0.717267,-0.66869 -0.138491,-0.22376 -0.137978,-0.22427 H 66.402064 64.59959 l -0.332795,-0.80357 -0.332796,-0.80409 -0.511079,-0.65009 z m 67.734365,0 -0.76119,5.3e-4 -0.76223,0.001 -0.67283,0.30696 -0.67334,0.30644 v 0.33848 0.33848 l 0.26924,0.1664 0.26923,0.1664 0.98599,-0.59635 0.9865,-0.59634 -0.48369,0.55604 -0.4837,0.55552 0.28526,0.5333 0.28525,0.53382 v 0.31109 0.31057 l -0.52658,-0.62373 -0.52658,-0.62425 -0.79117,0.85938 -0.79065,0.85886 h -0.36794 -0.36793 l -0.33796,0.40773 -0.33848,0.40772 0.30592,0.30645 0.30592,0.30592 v -0.31729 -0.3173 h 0.7519 0.75189 l 0.43408,0.48008 0.4346,0.48007 0.17208,0.90796 0.1726,0.90795 0.19069,0.26459 0.19068,0.26406 0.15917,0.66921 0.15916,0.66869 -0.51728,0.78548 -0.51728,0.78497 -0.002,0.85886 -0.002,0.85938 0.33021,0.004 0.33021,0.004 -0.39636,0.25632 -0.39636,0.2558 0.34624,0.004 0.34571,0.004 -0.13849,0.22428 -0.13901,0.22479 0.6103,0.3266 0.60978,0.32659 0.83354,-0.13126 0.83302,-0.13126 0.13178,0.21343 0.13178,0.21342 -0.41652,0.15968 -0.41651,0.1602 h -0.61288 -0.6134 l -0.26872,0.77049 -0.2682,0.7705 0.15451,0.15451 0.15451,0.15503 h 0.36794 0.36794 l -0.18862,-0.30541 -0.18862,-0.3054 0.33486,0.20722 0.33435,0.2067 0.22066,-0.35656 0.22014,-0.35657 0.12351,0.12454 0.1235,0.12454 -0.20619,1.0573 -0.2067,1.05782 -0.17777,0.66094 -0.17777,0.66094 0.73795,0.30799 0.73742,0.30799 0.87643,0.17984 0.87695,0.17931 0.68988,0.35812 0.68988,0.35812 0.21446,-0.13281 0.21497,-0.13281 -0.66249,-1.30793 -0.66249,-1.30793 -0.25994,-0.0331 -0.25993,-0.0336 -0.33021,-0.0346 -0.33073,-0.0362 -0.62735,0.74053 -0.62735,0.74052 -0.1416,-0.14159 -0.14211,-0.1416 0.42065,-0.46509 0.42064,-0.46508 0.3881,-0.74776 0.38757,-0.74776 -0.35967,-0.6935 -0.35967,-0.69349 0.12506,-0.12506 0.12506,-0.12506 0.77101,0.73897 0.77049,0.73898 0.31575,0.76171 0.31574,0.76223 h 0.19017 0.19017 l 0.32143,1.07176 0.32091,1.07126 1.01957,0.9219 1.0201,0.92139 -0.68213,0.68265 -0.68213,0.68213 -1.40973,-0.33848 -1.40974,-0.33848 v -0.23358 -0.23358 l 0.33021,0.0429 0.33022,0.0434 0.48472,-0.0315 0.48473,-0.0315 -0.10542,-0.31575 -0.10542,-0.31625 -0.77567,-0.22583 -0.77566,-0.22635 -0.72502,-0.0677 -0.72502,-0.0677 -0.14469,0.45527 -0.14418,0.45527 0.15761,0.61753 0.15761,0.61702 1.00201,0.38758 h 4.24212 l 0.8046,-0.87179 v 0.67231 0.19948 h 1.72031 l 0.0176,-0.0553 0.15038,-0.47336 -0.8785,-0.37207 -0.87799,-0.37207 0.43615,-0.17001 0.43563,-0.17053 1.39579,0.41496 1.39578,0.41444 h 0.51314 0.51315 l -0.293,-0.35295 -0.29301,-0.35295 -1.25884,-0.63251 -1.25935,-0.63201 -0.6625,-0.47129 -0.66249,-0.47077 -0.85731,0.0997 -0.85679,0.0992 v -0.20153 -0.20103 l 0.39635,-0.15244 0.39636,-0.15193 v -0.52141 -0.52194 l 0.26458,-0.16329 0.26407,-0.1633 v -0.38086 -0.38085 h -0.39636 -0.39636 v -0.24236 -0.24237 l 0.33022,-0.1111 0.33021,-0.11111 -0.31368,-0.63768 -0.31367,-0.63821 -0.18087,-0.64027 -0.18087,-0.63975 -1.09089,-1.08831 -1.09089,-1.08779 -2.0376,-1.03663 -2.03708,-1.03714 -0.18087,0.18087 -0.18035,0.18086 0.34933,0.42117 0.34933,0.42116 0.46147,-0.12041 0.46096,-0.12092 -0.15658,0.40928 -0.1571,0.40927 0.56379,-0.14779 0.56431,-0.14728 -0.0222,0.17105 -0.0222,0.17105 0.031,0.36122 0.0315,0.36173 0.4625,-0.12092 0.46251,-0.12144 0.0357,0.58395 0.0367,0.58394 -0.89814,0.27543 -0.89814,0.27596 -0.27026,-0.50488 -0.27027,-0.5054 h -0.34623 -0.34624 l -0.45061,-0.49764 -0.45062,-0.49816 0.18035,-1.35858 0.18035,-1.35857 0.20205,-0.12506 0.20258,-0.12505 0.8015,0.16019 0.8015,0.16072 0.49454,0.43305 0.49403,0.43356 0.6475,0.37156 0.64699,0.37155 0.39636,0.1943 0.39636,0.1943 1.25522,0.59893 1.25574,0.59945 v 0.23823 0.23874 l 0.19792,-0.12247 0.19844,-0.12247 0.0589,0.96583 0.0589,0.96635 0.008,1.43919 0.008,1.43867 0.3297,0.20929 0.32917,0.20929 0.8599,0.004 0.8599,0.004 0.99012,0.55346 0.99012,0.55397 -0.79272,-0.15554 -0.79272,-0.15555 -1.26814,-0.17208 -1.26813,-0.17209 0.0785,0.35916 0.0791,0.35915 0.66042,0.3762 0.66095,0.37569 0.79271,0.41806 0.79272,0.41806 0.59479,0.0837 0.5948,0.0837 v -0.27336 -0.27337 h 0.3638 0.36432 l 0.3514,0.42426 0.35192,0.42375 -0.43667,0.76171 -0.43718,0.76119 0.40101,0.40101 0.40049,0.40049 h 0.35553 0.35554 l 0.13332,-0.33021 0.13333,-0.33073 0.0207,0.447 0.0207,0.447 -0.0357,0.0222 h 0.92087 l -0.0382,-0.28629 -0.41909,-0.46354 -0.41962,-0.46302 0.31833,-0.84336 0.31781,-0.84284 h 0.2434 0.24339 l 0.33642,0.46044 0.33641,0.46043 0.96118,0.0372 0.96118,0.0377 0.14573,0.14572 0.14521,0.14521 -0.16795,0.27182 -0.16795,0.27182 -0.67334,-0.2558 -0.67386,-0.25631 -0.23926,0.14831 -0.23978,0.14779 0.0408,1.04387 0.009,0.24081 h 0.74362 l 1.03767,-0.71779 1.04954,-0.72657 0.01,-0.28939 0.0103,-0.2899 -0.52864,-0.47852 -0.52814,-0.47801 v -0.26872 -0.26872 l -0.37052,-0.41754 -0.37,-0.41755 -0.26923,-0.99115 -0.26924,-0.99167 h 0.22789 0.22841 l 0.46819,0.79323 0.46819,0.79323 h 0.20102 0.20051 l 0.52555,1.15394 0.52554,1.15393 0.57568,-0.0305 0.57568,-0.0305 0.29249,-0.46871 0.293,-0.4687 -1.36839,-1.24954 -1.36891,-1.24954 -0.28319,-0.57774 -0.28267,-0.57723 v -0.41392 -0.41393 h 0.26407 0.26407 v 0.38085 0.38086 l 0.3054,0.18862 0.3049,0.18862 -0.21343,-0.34624 -0.21394,-0.34571 0.30954,0.1912 0.30903,0.1912 -0.13591,0.22015 -0.0553,0.0894 -0.0806,0.13074 1.47433,1.34772 1.47433,1.34772 h 0.43046 0.43047 l 2.45566,-0.6966 2.45515,-0.69711 v -0.37827 -0.37828 l -0.52865,0.16744 -0.52865,0.16794 v -0.3948 -0.39533 l -1.49397,-0.68368 -1.49345,-0.68419 -0.13487,0.13487 -0.13488,0.13488 0.29094,0.63923 0.29146,0.63873 0.54467,0.17311 0.54466,0.17312 v 0.18033 l -5.3e-4,0.18036 -1.86758,-0.0274 -1.86759,-0.0269 -0.42995,-0.43046 -0.42994,-0.42995 0.57412,0.11059 0.57464,0.11059 0.12868,-0.20826 0.12867,-0.20825 -1.18132,-1.42782 -1.18081,-1.42782 -0.42374,-0.44545 -0.42375,-0.44546 -0.64957,0.24702 -0.65009,0.24701 h -0.37931 -0.37879 v -0.25735 -0.25786 l 0.77929,-0.40308 0.77979,-0.40359 h 0.25218 0.25167 l 2.04018,2.51199 2.03967,2.51147 h 0.23203 0.23203 v -0.27181 -0.27131 l -1.18133,-2.204 -1.18132,-2.204 0.14366,-0.14366 0.14366,-0.14365 -0.42271,-0.81753 -0.42272,-0.81804 -0.45578,-0.0305 -0.45579,-0.0305 -0.44803,0.045 -0.44855,0.0444 -0.49972,-0.47698 -0.49971,-0.47645 -0.46354,-0.26665 -0.46302,-0.26665 0.18035,-0.96274 0.18087,-0.96273 0.72554,-0.10697 0.72554,-0.10645 0.88986,1.40612 0.88987,1.40611 0.25994,-0.0868 0.25993,-0.0863 0.3054,-1.3565 0.3049,-1.35651 -0.18035,-0.29197 -0.17984,-0.29197 -0.33486,0.40359 -0.33486,0.40359 -0.4346,-0.23461 -0.43512,-0.23461 -1.526,-1.33842 -1.52601,-1.33842 -1.05058,0.54777 -1.05058,0.54777 v 0.24443 0.24392 l 0.72657,0.30075 0.72709,0.30024 0.1819,-0.0372 0.1819,-0.0372 0.1726,0.54312 0.1726,0.54312 -0.10852,0.10852 -0.10801,0.108 -0.98857,-0.50385 -0.98857,-0.50436 -1.0418,-0.1757 -1.04128,-0.17621 v -0.24133 -0.24081 h 0.89401 0.894 l 0.15968,-0.5948 0.15916,-0.59479 0.004,-1.00925 0.004,-1.00872 -0.27337,-0.51108 -0.27337,-0.5116 h -0.27905 -0.27854 l -0.49609,0.5948 -0.49609,0.59479 v 0.39688 l -5.3e-4,0.39636 0.35708,-0.47026 0.35657,-0.47077 0.14521,0.37879 0.14521,0.37879 -0.35708,0.48834 -0.35657,0.48782 -1.14515,-0.80718 -1.14567,-0.8077 -0.59376,0.71726 -0.59376,0.71727 v 0.42117 0.42064 h 1.04128 1.04179 l 0.1633,0.26459 0.1633,0.26406 h -1.05368 -1.0542 l -0.34933,0.33073 -0.34882,0.33021 -0.39636,-0.007 -0.39687,-0.007 -0.30644,-0.19223 -0.30645,-0.19224 -0.42013,0.16175 -0.42013,0.16123 v -0.293 -0.29249 h -0.30178 -0.3018 l -0.75034,0.78548 -0.74983,0.78496 0.15141,0.39429 0.1509,0.39481 0.53743,0.17053 0.53692,0.17054 0.22738,-0.35915 0.22738,-0.35864 0.004,-0.447 0.004,-0.447 0.26407,-0.1633 0.26458,-0.16381 -0.0191,0.47852 -0.0196,0.47801 -0.44855,0.76429 -0.44856,0.7643 -2.56987,0.0351 -2.57038,0.0346 0.12247,-0.40256 0.12247,-0.40308 -0.85007,-0.94309 -0.8506,-0.94309 -0.52865,-0.30438 -0.52865,-0.30489 0.56224,-0.008 0.56224,-0.008 0.33952,0.40928 0.33951,0.40876 1.40922,0.66714 1.40973,0.66714 0.59583,-0.0915 0.59583,-0.0915 -1.96371,-1.27796 -1.9637,-1.27796 -0.36742,-0.36742 -0.36742,-0.36793 h 0.56224 0.56276 l 1.10794,0.61805 1.10794,0.61753 0.39688,-0.12195 0.39636,-0.12196 0.71726,-0.66818 0.71727,-0.66869 -0.13849,-0.22376 -0.13798,-0.22427 h -1.80247 -1.80247 l -0.3328,-0.80357 -0.3328,-0.80409 -0.51108,-0.65009 z m -59.768444,0.26561 h 0.132292 0.132291 v 0.1323 0.13229 h -0.132291 -0.132292 v -0.13229 z m 67.733854,0 h 0.13229 0.13229 v 0.1323 0.13229 h -0.13229 -0.13229 v -0.13229 z m -43.948744,0.52865 h 0.132292 0.131776 v 0.1323 0.13229 H 94.795338 94.663046 V 193.64 Z m 67.733854,0 h 0.1323 0.13177 v 0.1323 0.13229 h -0.13177 -0.1323 V 193.64 Z m -109.752994,0.68678 -0.235643,0.25115 -0.235646,0.25167 -0.183968,2.04897 -0.183451,2.04897 0.352949,0.004 0.352435,0.004 -0.396359,0.25631 -0.396359,0.25632 0.321945,0.004 0.322461,0.004 -0.168981,0.43977 -0.168982,0.44028 0.375688,-0.22634 0.375171,-0.22634 -0.33383,0.41186 -0.333314,0.41238 0.405661,0.33693 0.406175,0.33744 0.182936,-0.18293 0.182933,-0.18294 0.293523,1.00459 0.29404,1.00408 0.329179,-0.0724 0.329694,-0.0729 -0.170016,0.27543 -0.170016,0.27544 -0.207737,-0.12868 -0.207741,-0.12815 -0.61288,0.65267 -0.612884,0.65267 h -0.334862 -0.334864 l -0.164331,0.26614 -0.164332,0.26613 1.404048,1.31 1.404049,1.31051 0.374655,0.01 0.374137,0.0103 -0.135909,0.13591 -0.135908,0.13591 0.818554,0.9524 0.819071,0.95239 0.836642,0.89452 0.836641,0.89452 h 0.226343 0.226343 l 0.487307,-0.90537 0.48731,-0.90537 0.431498,0.15244 0.432015,0.15245 0.483174,0.416 0.483693,0.41651 -0.159163,1.0635 -0.158647,1.06402 0.530198,1.03921 0.530202,1.03973 -0.09767,0.0977 -0.09818,0.0982 -0.558623,-0.71055 -0.558622,-0.71055 v -0.32504 -0.32557 l -0.54777,-0.69659 -0.547769,-0.6966 h -0.21911 -0.219625 l -0.275953,0.79323 -0.276468,0.79323 h 0.136943 0.137459 l -0.361217,0.36174 -0.361736,0.36122 -0.355534,1.07745 -0.355018,1.07745 0.0098,0.0212 h 5.881295 l 0.077,-0.57464 0.139528,-1.04387 0.419094,-0.4625 0.418579,-0.46302 v -0.31006 -0.30954 h -0.601514 -0.60203 l -0.424781,-0.4961 -0.424778,-0.49609 0.120404,-0.63097 0.120407,-0.63097 -1.242817,-1.26091 -1.242819,-1.26141 -0.888834,0.293 -0.88832,0.29352 -1.526003,-0.92707 -1.526005,-0.92708 -0.655775,-0.58343 -0.655773,-0.58291 1.189075,0.19431 1.189074,0.1943 0.832507,0.12403 0.83199,0.12453 0.201022,-0.32556 0.20102,-0.32556 -0.843875,-0.75396 -0.84336,-0.75396 -1.643311,0.13798 -1.642792,0.13849 0.513146,-0.39894 0.51263,-0.39843 h 0.486275 0.486794 l 0.151929,-0.39635 0.151929,-0.39688 -0.163817,-0.33021 -0.163814,-0.33073 -0.8015,-1.32188 -0.801502,-1.32189 -0.400492,-0.88986 -0.40101,-0.88987 0.126092,-0.32918 0.126606,-0.32918 0.586528,-0.15348 0.586529,-0.15348 0.757057,0.75758 0.75706,0.75706 0.02635,0.88005 0.02635,0.87953 0.178285,0.63665 0.177765,0.63666 0.471289,0.0692 0.471289,0.0687 0.877467,-0.77049 0.877467,-0.7705 0.705898,-0.36638 0.7059,-0.36639 -0.427879,-0.4284 -0.427881,-0.42788 h -1.272276 -1.271757 l -0.422711,-0.64492 -0.422714,-0.64544 0.692464,-0.54415 0.691947,-0.54467 0.294555,-0.0315 0.294558,-0.031 0.173114,0.0227 0.172601,0.0227 0.2682,-0.32247 0.267685,-0.32297 -0.361736,-0.49455 -0.361736,-0.49506 -1.730642,0.46871 -1.730645,0.4687 v 0.35709 0.3576 h -0.187052 -0.187069 l -1.002006,-0.97875 z m 67.733854,0 -0.23565,0.25115 -0.23564,0.25167 -0.18397,2.04897 -0.18345,2.04897 0.35295,0.004 0.35243,0.004 -0.39636,0.25631 -0.39635,0.25632 0.32194,0.004 0.32246,0.004 -0.16898,0.43977 -0.16898,0.44028 0.37569,-0.22634 0.37517,-0.22634 -0.33383,0.41186 -0.33332,0.41238 0.40566,0.33693 0.40618,0.33744 0.18294,-0.18293 0.18293,-0.18294 0.29352,1.00459 0.29404,1.00408 0.32918,-0.0724 0.32969,-0.0729 -0.17001,0.27543 -0.17001,0.27544 -0.20774,-0.12868 -0.20774,-0.12815 -0.61289,0.65267 -0.61288,0.65267 h -0.33486 -0.33487 l -0.16433,0.26614 -0.16433,0.26613 1.40405,1.31 1.40405,1.31051 0.37465,0.01 0.37414,0.0103 -0.13591,0.13591 -0.13591,0.13591 0.81856,0.9524 0.81907,0.95239 0.83664,0.89452 0.83664,0.89452 h 0.22634 0.22635 l 0.48731,-0.90537 0.4873,-0.90537 0.4315,0.15244 0.43202,0.15245 0.48317,0.416 0.48369,0.41651 -0.15916,1.0635 -0.15865,1.06402 0.53021,1.03921 0.53019,1.03973 -0.0977,0.0977 -0.0987,0.0982 -0.55862,-0.71055 -0.55862,-0.71055 v -0.32504 -0.32557 l -0.54777,-0.69659 -0.54777,-0.6966 h -0.21859 -0.21963 l -0.27595,0.79323 -0.27647,0.79323 h 0.13694 0.13746 l -0.36121,0.36174 -0.36174,0.36122 -0.35553,1.07745 -0.35502,1.07745 0.01,0.0212 h 5.8813 l 0.077,-0.57464 0.13952,-1.04387 0.4191,-0.4625 0.41858,-0.46302 v -0.31006 -0.30954 h -0.60152 -0.60203 l -0.42478,-0.4961 -0.42478,-0.49609 0.12041,-0.63097 0.12041,-0.63097 -1.24282,-1.26091 -1.24282,-1.26141 -0.88884,0.293 -0.88831,0.29352 -1.52601,-0.92707 -1.526,-0.92708 -0.65578,-0.58343 -0.65577,-0.58291 1.18907,0.19431 1.18908,0.1943 0.83251,0.12403 0.83199,0.12453 0.20102,-0.32556 0.20102,-0.32556 -0.84388,-0.75396 -0.84336,-0.75396 -1.64331,0.13798 -1.64279,0.13849 0.51315,-0.39894 0.51263,-0.39843 h 0.48627 0.48679 l 0.15193,-0.39635 0.15193,-0.39688 -0.16381,-0.33021 -0.16382,-0.33073 -0.8015,-1.32188 -0.8015,-1.32189 -0.40049,-0.88986 -0.40101,-0.88987 0.12609,-0.32918 0.1266,-0.32918 0.58653,-0.15348 0.58653,-0.15348 0.75706,0.75758 0.75706,0.75706 0.0264,0.88005 0.0263,0.87953 0.17828,0.63665 0.17777,0.63666 0.47129,0.0692 0.47129,0.0687 0.87746,-0.77049 0.87747,-0.7705 0.7059,-0.36638 0.7059,-0.36639 -0.42788,-0.4284 -0.42788,-0.42788 h -1.27228 -1.27175 l -0.42272,-0.64492 -0.42271,-0.64544 0.69246,-0.54415 0.69195,-0.54467 0.29456,-0.0315 0.29455,-0.031 0.17312,0.0227 0.1726,0.0227 0.2682,-0.32247 0.26768,-0.32297 -0.36173,-0.49455 -0.36174,-0.49506 -1.73064,0.46871 -1.73065,0.4687 v 0.35709 0.3576 h -0.18706 -0.18707 l -1.00201,-0.97875 z M 81.661257,194.565 h 0.171048 0.170532 l 1.308965,1.38752 1.308963,1.38699 v 0.19896 0.19947 h -0.106453 -0.105936 l -1.373561,-1.58647 z m 67.733853,0 h 0.17105 0.17053 l 1.30897,1.38752 1.30896,1.38699 v 0.19896 0.19947 h -0.10645 -0.10594 l -1.37356,-1.58647 z m -56.34902,0.79324 h 0.132292 0.132292 l 0.163298,0.26458 0.163298,0.26407 h -0.132292 -0.132291 l -0.163299,-0.26407 z m 67.73386,0 h 0.13229 0.13229 l 0.1633,0.26458 0.1633,0.26407 h -0.1323 -0.13229 l -0.16329,-0.26407 z m -108.137076,0.17621 0.176215,0.17622 0.176218,0.17622 h -0.352433 -0.352435 l 0.176217,-0.17622 z m 67.733856,0 0.17621,0.17622 0.17622,0.17622 h -0.35243 -0.35244 l 0.17622,-0.17622 z m -78.335792,0.88109 h 0.13177 0.13229 l 0.1633,0.26458 0.1633,0.26458 h -0.13229 -0.13178 l -0.16329,-0.26458 z m 67.733852,0 h 0.13177 0.13229 l 0.1633,0.26458 0.1633,0.26458 h -0.13229 -0.13178 l -0.1633,-0.26458 z m -29.911355,0.26458 h 0.132291 0.132292 v 0.13229 0.13229 h -0.132292 -0.132291 v -0.13229 z m 67.733855,0 h 0.13229 0.13229 v 0.13229 0.13229 h -0.13229 -0.13229 v -0.13229 z m -108.921002,0.66507 -0.18294,0.18294 -0.18345,0.18345 1.94717,1.95285 1.94717,1.95234 0.39635,0.13953 0.39636,0.13901 0.11782,-0.10387 0.117826,-0.10336 0.09043,-0.45527 0.09043,-0.45475 0.162264,-1.03249 0.162264,-1.0325 -1.002522,0.16278 -1.00304,0.16278 -1.52807,-0.84697 z m 67.733852,0 -0.18294,0.18294 -0.18345,0.18345 1.94717,1.95285 1.94716,1.95234 0.39636,0.13953 0.39636,0.13901 0.11782,-0.10387 0.11783,-0.10336 0.0904,-0.45527 0.0904,-0.45475 0.16226,-1.03249 0.16226,-1.0325 -1.00252,0.16278 -1.00304,0.16278 -1.52807,-0.84697 z m -47.424502,0.12816 v 0.1323 0.13229 h 0.132291 0.131776 v -0.13229 -0.1323 h -0.131776 z m 67.733852,0 v 0.1323 0.13229 h 0.13229 0.13178 v -0.13229 -0.1323 h -0.13178 z m -76.71935,0.44029 0.176217,0.17621 0.176217,0.17674 H 50.00014 49.647707 l 0.176217,-0.17674 z m 67.73385,0 0.17622,0.17621 0.17622,0.17674 h -0.35244 -0.35243 l 0.17622,-0.17674 z m -80.467952,0.16174 v 2.32596 l 0.97306,0.31368 0.38137,0.29559 0.38086,0.2961 -0.23358,-0.39636 -0.23357,-0.39687 0.43821,0.35553 0.43822,0.35553 0.29094,-0.0971 0.29093,-0.0966 -1.09812,-1.18391 -1.09812,-1.18391 z m 67.733852,0 v 2.32596 l 0.97306,0.31368 0.38137,0.29559 0.38086,0.2961 -0.23358,-0.39636 -0.23357,-0.39687 0.43821,0.35553 0.43822,0.35553 0.29094,-0.0971 0.29093,-0.0966 -1.09812,-1.18391 -1.09812,-1.18391 z m -32.323097,0.68317 1.093989,0.32814 1.094507,0.32763 -0.342098,0.32298 -0.34158,0.32297 -0.59273,0.17777 -0.592212,0.17777 -0.309541,-0.67903 -0.309026,-0.67955 0.149344,-0.14934 z m 67.733857,0 1.09399,0.32814 1.0945,0.32763 -0.34209,0.32298 -0.34158,0.32297 -0.59273,0.17777 -0.59222,0.17777 -0.30954,-0.67903 -0.30902,-0.67955 0.14934,-0.14934 z m -69.216455,0.19533 0.256315,0.45786 0.256315,0.45837 0.01707,0.85059 0.01654,0.85059 0.262001,0.33022 0.261999,0.33072 -0.230992,-0.0398 -0.230479,-0.0398 -0.726569,-0.11007 -0.726573,-0.11007 v -0.0667 -0.0667 l 0.422199,-1.42266 z m 67.733855,0 0.25632,0.45786 0.25631,0.45837 0.0165,0.85059 0.0165,0.85059 0.262,0.33022 0.262,0.33072 -0.23099,-0.0398 -0.23048,-0.0398 -0.72657,-0.11007 -0.72657,-0.11007 v -0.0667 -0.0667 l 0.4222,-1.42266 z m -81.792429,0.0176 0.176218,0.17622 0.176217,0.17621 h -0.352435 -0.352433 l 0.176218,-0.17621 z m 67.733849,0 0.17622,0.17622 0.17622,0.17621 h -0.35244 -0.35243 l 0.17622,-0.17621 z m -40.513289,0.85008 v 0.13229 0.13229 l -0.264064,0.1633 -0.264584,0.1633 v -0.1323 -0.13229 l 0.264584,-0.1633 z m 67.733859,0 v 0.13229 0.13229 l -0.26407,0.1633 -0.26458,0.1633 v -0.1323 -0.13229 l 0.26458,-0.1633 z m -91.681748,0.27802 -0.645441,0.53226 -0.644922,0.53279 -0.264583,0.21652 -0.264065,0.21653 -0.462505,0.17673 -0.462504,0.17673 v 0.27285 0.27234 l 0.330213,0.0315 0.330213,0.031 0.264583,-0.0532 0.264065,-0.0532 -0.187584,0.18758 -0.187587,0.1881 0.401526,0.7767 0.401527,0.7767 -0.237194,1.56786 -0.237196,1.56786 0.133326,0.13333 0.133323,0.13332 h 0.359154 0.35915 l 0.257866,-0.72709 0.257347,-0.72708 0.264583,-0.45889 0.264068,-0.45889 v -0.2682 -0.26768 h -0.396359 -0.396357 v -0.26458 -0.26459 h 0.285253 0.285255 l -0.1788,-0.81442 -0.179319,-0.81494 0.561724,-0.59789 0.561721,-0.5979 0.114207,-0.59376 0.114205,-0.59376 -0.364321,0.30282 -0.364834,0.30231 -0.234611,-0.41961 z m 67.733848,0 -0.64543,0.53226 -0.64493,0.53279 -0.26458,0.21652 -0.26407,0.21653 -0.4625,0.17673 -0.46251,0.17673 v 0.27285 0.27234 l 0.33022,0.0315 0.33021,0.031 0.26458,-0.0532 0.26407,-0.0532 -0.18759,0.18758 -0.18758,0.1881 0.40153,0.7767 0.40152,0.7767 -0.23719,1.56786 -0.2372,1.56786 0.13333,0.13333 0.13332,0.13332 h 0.35915 0.35915 l 0.25787,-0.72709 0.25735,-0.72708 0.26458,-0.45889 0.26407,-0.45889 v -0.2682 -0.26768 h -0.39636 -0.39636 v -0.26458 -0.26459 h 0.28525 0.28526 l -0.1788,-0.81442 -0.17932,-0.81494 0.56172,-0.59789 0.56173,-0.5979 0.1142,-0.59376 0.11421,-0.59376 -0.36432,0.30282 -0.36484,0.30231 -0.23461,-0.41961 z m -52.967826,0.26148 0.102836,0.10335 0.102835,0.10284 -0.520379,1.16272 -0.520383,1.16323 h -0.210841 -0.210839 l 0.05426,1.03302 0.05374,1.03353 -0.399457,-0.57051 -0.39946,-0.57051 h -0.24443 -0.243911 l -0.165881,0.66094 -0.165883,0.66094 h -0.35243 -0.351917 l -0.174665,-0.28267 -0.174667,-0.28267 0.759642,-1.22835 0.759127,-1.22886 1.151353,-0.8785 z m 67.733856,0 0.10284,0.10335 0.10283,0.10284 -0.52038,1.16272 -0.52038,1.16323 h -0.21084 -0.21084 l 0.0543,1.03302 0.0537,1.03353 -0.39946,-0.57051 -0.39946,-0.57051 h -0.24442 -0.24392 l -0.16588,0.66094 -0.16588,0.66094 h -0.35243 -0.35192 l -0.17467,-0.28267 -0.17466,-0.28267 0.75964,-1.22835 0.75913,-1.22886 1.15135,-0.8785 z m -64.868397,0.5054 0.669726,0.43924 0.669727,0.43874 0.383955,0.91932 0.383956,0.91932 0.781865,-0.1235 0.781865,-0.12351 0.133323,0.21549 0.13281,0.21549 -0.83199,0.28991 -0.831993,0.29042 -0.290938,-0.0259 -0.290936,-0.0263 -0.533818,-0.30438 -0.533818,-0.30437 -0.86868,-0.62374 -0.868164,-0.62321 0.08113,-0.69609 0.08061,-0.69659 0.47594,-0.0899 z m 67.733857,0 0.66972,0.43924 0.66973,0.43874 0.38396,0.91932 0.38395,0.91932 0.78187,-0.1235 0.78186,-0.12351 0.13333,0.21549 0.13281,0.21549 -0.83199,0.28991 -0.83199,0.29042 -0.29094,-0.0259 -0.29094,-0.0263 -0.53382,-0.30438 -0.53382,-0.30437 -0.86868,-0.62374 -0.86816,-0.62321 0.0811,-0.69609 0.0801,-0.69659 0.47594,-0.0899 z m -63.795598,0.30799 v 0.13229 0.13229 h 0.131776 0.132292 v -0.13229 -0.13229 h -0.132292 z m 67.733858,0 v 0.13229 0.13229 h 0.13177 0.1323 v -0.13229 -0.13229 h -0.1323 z m -112.445852,0.23199 v 2.76314 l 0.10852,0.0222 2.0314,0.41961 h 0.71572 0.7152 l 1.50585,1.52032 1.505333,1.52032 0.967383,0.87127 0.967382,0.87074 0.271302,-0.16743 0.271301,-0.16743 -0.243913,-0.30696 -0.243913,-0.30695 -1.127579,-2.11512 -1.12758,-2.11512 -0.16123,-0.13229 -0.161748,-0.13229 -0.385508,-0.74724 -0.3855,-0.74776 -1.53376,0.0863 -1.53376,0.0868 -0.13746,-0.4346 -0.13746,-0.43512 -0.95188,-0.1788 z m 67.733852,0 v 2.76314 l 0.10852,0.0222 2.0314,0.41961 h 0.71572 0.7152 l 1.50585,1.52032 1.50533,1.52032 0.96738,0.87127 0.96739,0.87074 0.2713,-0.16743 0.2713,-0.16743 -0.24391,-0.30696 -0.24391,-0.30695 -1.12758,-2.11512 -1.12758,-2.11512 -0.16123,-0.13229 -0.16175,-0.13229 -0.38551,-0.74724 -0.3855,-0.74776 -1.53376,0.0863 -1.53376,0.0868 -0.13746,-0.4346 -0.13746,-0.43512 -0.95188,-0.1788 z m -35.954919,0.42944 0.388091,0.51314 0.388091,0.51315 v 0.21342 h 5.29e-4 v 0.21394 h -0.235643 -0.236162 l -0.160713,-0.41806 -0.160197,-0.41806 0.0088,-0.30903 z m 67.733859,0 0.38808,0.51314 0.3881,0.51315 v 0.21342 h 5.3e-4 v 0.21394 h -0.23565 -0.23616 l -0.16071,-0.41806 -0.1602,-0.41806 0.008,-0.30903 z m -85.70537,0.0279 -0.19172,0.1912 -0.191719,0.19172 -0.0584,0.84698 -0.05839,0.84698 0.125574,0.20308 0.125573,0.20361 h 0.219108 0.219625 l 0.623734,-0.51366 0.624252,-0.51315 -0.71882,-0.72864 z m 67.73385,0 -0.19172,0.1912 -0.19172,0.19172 -0.0584,0.84698 -0.0584,0.84698 0.12558,0.20308 0.12557,0.20361 h 0.21911 0.21963 l 0.62373,-0.51366 0.62425,-0.51315 -0.71882,-0.72864 z m -73.563986,0.0155 0.176217,0.17673 0.176217,0.17621 h -0.352434 -0.352433 l 0.176217,-0.17621 z m 67.733856,0 0.17621,0.17673 0.17622,0.17621 h -0.35243 -0.35244 l 0.17622,-0.17621 z m -21.09691,0.37723 -0.29197,0.18604 -0.291455,0.18603 0.07131,0.79324 0.07131,0.79323 0.02585,0.19792 0.02635,0.19844 h 0.375171 0.374655 l 0.418063,-0.1602 0.418063,-0.16071 v -0.45424 -0.45423 l -0.598932,-0.56276 z m 67.73386,0 -0.29198,0.18604 -0.29145,0.18603 0.0713,0.79324 0.0713,0.79323 0.0253,0.19792 0.0269,0.19844 h 0.37517 0.37465 l 0.41807,-0.1602 0.41806,-0.16071 v -0.45424 -0.45423 l -0.59893,-0.56276 z m -84.721451,0.90124 0.403592,0.5948 0.403075,0.59479 h 0.275436 0.274918 l 1.257289,0.80719 1.257803,0.80718 0.183968,1.09038 0.184486,1.09037 -0.478523,0.34933 -0.478007,0.34985 H 78.0067 77.8372 l -0.176215,-0.17621 -0.176218,-0.17622 v -0.71675 -0.71676 l -0.396359,-0.32918 -0.396356,-0.32917 -0.0062,-0.29818 -0.0057,-0.29765 -0.892969,-0.99167 -0.892969,-0.99116 h -0.343133 -0.34313 l 0.342615,-0.33073 z m 67.733851,0 0.4036,0.5948 0.40307,0.59479 h 0.27544 0.27492 l 1.25728,0.80719 1.25781,0.80718 0.18397,1.09038 0.18448,1.09037 -0.47852,0.34933 -0.47801,0.34985 h -0.17001 -0.1695 l -0.17622,-0.17621 -0.17622,-0.17622 v -0.71675 -0.71676 l -0.39635,-0.32918 -0.39636,-0.32917 -0.006,-0.29818 -0.006,-0.29765 -0.89297,-0.99167 -0.89297,-0.99116 h -0.34313 -0.34313 l 0.34261,-0.33073 z m -92.887356,0.31109 -0.538468,0.48783 -0.538985,0.48782 -0.541569,0.87644 -0.541569,0.87695 h -0.248564 -0.248564 l -1.1467,-1.05782 -1.147217,-1.0573 h -0.300757 -0.300756 v 0.13953 0.14004 l 0.858862,1.61592 0.858862,1.61592 0.287838,0.48989 0.287838,0.48938 0.480074,0.53072 0.480074,0.5302 h 1.03818 1.038179 l -0.08837,-0.25994 -0.08785,-0.25993 -1.176156,-0.59893 -1.176156,-0.59944 -0.110071,-0.35606 -0.109554,-0.35605 0.54157,0.28991 0.542085,0.28991 h 0.524516 0.525033 l 0.173632,-0.85887 0.173117,-0.85938 0.414444,-1.12964 0.414446,-1.12965 -0.168982,-0.16847 z m 67.733856,0 -0.53847,0.48783 -0.53899,0.48782 -0.54157,0.87644 -0.54157,0.87695 h -0.24856 -0.24856 l -1.1467,-1.05782 -1.14722,-1.0573 h -0.30076 -0.30075 v 0.13953 0.14004 l 0.85886,1.61592 0.85886,1.61592 0.28784,0.48989 0.28784,0.48938 0.48007,0.53072 0.48007,0.5302 h 1.03818 1.03818 l -0.0884,-0.25994 -0.0879,-0.25993 -1.17615,-0.59893 -1.17616,-0.59944 -0.11007,-0.35606 -0.10955,-0.35605 0.54157,0.28991 0.54208,0.28991 h 0.52452 0.52503 l 0.17364,-0.85887 0.17311,-0.85938 0.41445,-1.12964 0.41444,-1.12965 -0.16898,-0.16847 z m -46.6261,0.0853 h 0.132291 0.131776 l 0.163295,0.26458 0.163817,0.26407 h -0.132291 -0.132292 l -0.163298,-0.26407 z m 67.73385,0 h 0.1323 0.13177 l 0.1633,0.26458 0.16381,0.26407 h -0.13229 -0.13229 l -0.1633,-0.26407 z m -48.232715,0.4439 -0.551389,0.66042 -0.551386,0.66094 -0.531233,0.73485 -0.530717,0.73483 -1.365293,-1.22783 -1.365289,-1.22783 -0.127125,0.20567 -0.126608,0.20567 0.781865,1.66967 0.781865,1.66966 0.753959,-0.16536 0.753441,-0.16588 0.173117,0.28008 0.172598,0.27957 h 0.507981 0.507979 l 0.160713,-0.72657 0.16123,-0.72708 0.27492,-0.92553 0.274918,-0.92552 0.242364,-0.30696 0.242877,-0.30644 -0.320392,-0.19844 z m 67.733855,0 -0.55139,0.66042 -0.55138,0.66094 -0.53124,0.73485 -0.53072,0.73483 -1.36529,-1.22783 -1.36529,-1.22783 -0.12712,0.20567 -0.12661,0.20567 0.78187,1.66967 0.78186,1.66966 0.75396,-0.16536 0.75344,-0.16588 0.17312,0.28008 0.1726,0.27957 h 0.50798 0.50798 l 0.16071,-0.72657 0.16123,-0.72708 0.27492,-0.92553 0.27492,-0.92552 0.24236,-0.30696 0.24288,-0.30644 -0.32039,-0.19844 z m -96.220489,0.34933 h 0.132292 0.132291 l 0.163299,0.26407 0.163298,0.26458 h -0.132292 -0.132292 l -0.163298,-0.26458 z m 67.733859,0 h 0.13229 0.13229 l 0.16329,0.26407 0.1633,0.26458 h -0.13229 -0.13229 l -0.1633,-0.26458 z m -89.603842,0.72347 -0.41341,0.15865 -0.41341,0.15865 v 0.20928 0.20929 l 0.69195,0.74621 0.69143,0.74621 -0.49351,-0.0527 -0.493,-0.0522 -0.33073,0.0305 -0.33021,0.0305 v 0.23668 0.2372 l 1.33067,0.85369 1.33067,0.85421 1.688266,1.24695 v -0.001 l 1.68827,1.24695 1.936315,-0.47853 1.936317,-0.47904 0.991154,-0.28318 0.990637,-0.28319 v -0.26562 -0.2651 l -3.237012,0.16278 -3.237529,0.16278 -0.52865,-0.40721 -0.528649,-0.4072 0.594795,-0.008 0.594796,-0.008 v -0.33228 -0.33228 l -1.59784,-1.52973 -1.59731,-1.52911 -0.63201,-0.28835 z m 67.733852,0 -0.41341,0.15865 -0.41341,0.15865 v 0.20928 0.20929 l 0.69195,0.74621 0.69143,0.74621 -0.49351,-0.0527 -0.493,-0.0522 -0.33073,0.0305 -0.33021,0.0305 v 0.23668 0.2372 l 1.33067,0.85369 1.33067,0.85421 1.68827,1.24695 v -0.001 l 1.68827,1.24695 1.93631,-0.47853 1.93632,-0.47904 0.99115,-0.28318 0.99064,-0.28319 v -0.26562 -0.2651 l -3.23701,0.16278 -3.23753,0.16278 -0.52865,-0.40721 -0.52865,-0.4072 0.59479,-0.008 0.5948,-0.008 v -0.33228 -0.33228 l -1.59783,-1.52962 -1.59732,-1.52911 -0.632,-0.28835 z m -68.296092,0.5979 h 0.13229 0.13178 v 0.13229 0.13229 h -0.13178 -0.13229 v -0.13229 z m 67.733852,0 h 0.13229 0.13178 v 0.13229 0.13229 h -0.13178 -0.13229 v -0.13229 z m -33.641876,5.3e-4 h 0.469739 0.469739 l 0.566891,0.39739 0.567406,0.39739 0.31006,0.94 0.310058,0.94051 0.05323,0.31471 0.05271,0.31471 0.317812,0.5767 0.317291,0.57723 0.520383,0.16536 0.520382,0.16485 0.984436,-0.66869 0.984435,-0.66921 0.100253,0.10025 0.100769,0.10077 -0.413927,0.80099 -0.41393,0.80098 0.179834,0.47956 0.179319,0.47904 -0.456822,-0.37155 -0.456819,-0.37208 -0.750342,0.55449 -0.749824,0.55501 -0.517797,-0.57929 -0.517282,-0.5793 -0.329695,-0.83664 -0.329697,-0.83664 -0.742074,-0.30747 -0.742072,-0.30748 -1.21698,0.18242 -1.217499,0.18293 v -0.28267 -0.28215 l 0.915192,-0.17208 0.915707,-0.17157 0.286803,-0.34572 0.286287,-0.34519 -0.276985,-0.17105 -0.276987,-0.17157 v -0.77773 z m 67.733856,0 h 0.46974 0.46974 l 0.56689,0.39739 0.56741,0.39739 0.31005,0.94 0.31006,0.94051 0.0532,0.31471 0.0522,0.31471 0.31781,0.5767 0.31781,0.57723 0.52038,0.16536 0.52039,0.16485 0.98443,-0.66869 0.98444,-0.66921 0.0997,0.10025 0.10077,0.10077 -0.41392,0.80099 -0.41342,0.80098 0.17984,0.47956 0.17932,0.47904 -0.45682,-0.37155 -0.45683,-0.37208 -0.75034,0.55449 -0.74982,0.55501 -0.51832,-0.57929 -0.51728,-0.5793 -0.32918,-0.83664 -0.32969,-0.83664 -0.74207,-0.30747 -0.74259,-0.30748 -1.21698,0.18242 -1.21698,0.18293 v -0.28267 -0.28215 l 0.91518,-0.17208 0.91519,-0.17157 0.28732,-0.34572 0.28578,-0.34519 -0.27647,-0.17105 -0.27751,-0.17157 v -0.77773 z m -42.627893,0.23306 v 0.13177 0.13229 l -0.26407,0.1633 -0.26458,0.16382 v -0.1323 -0.13229 l 0.26458,-0.16329 z m 67.733853,0 v 0.13177 0.13229 l -0.26406,0.1633 -0.26459,0.16382 v -0.1323 -0.13229 l 0.26459,-0.16329 z m -129.094962,0.0573 v 4.56199 l 0.20515,0.30283 0.51625,1.12034 0.51676,1.12087 0.46251,0.003 0.4625,0.003 v 0.67024 0.66921 l 0.59376,0.23926 h 5.3e-4 l 0.59428,0.23875 0.047,0.0171 0.047,0.0165 0.41083,-0.41083 0.41031,-0.41031 -0.8046,-1.50637 -0.8046,-1.50585 h -0.54777 -0.54726 l -0.34623,-1.16789 -0.34571,-1.16788 0.0238,-0.154 0.0243,-0.15399 -0.20877,-1.14619 -0.20825,-1.14618 -0.39688,-0.15296 z m 67.733852,0 v 4.56199 l 0.20515,0.30283 0.51625,1.12034 0.51676,1.12087 0.46251,0.003 0.4625,0.003 v 0.67024 0.66921 l 0.59376,0.23926 h 5.3e-4 l 0.59428,0.23875 0.047,0.0171 0.047,0.0165 0.41083,-0.41083 0.41031,-0.41031 -0.8046,-1.50637 -0.80461,-1.50585 h -0.54777 -0.54725 l -0.34623,-1.16789 -0.34572,-1.16788 0.0238,-0.154 0.0243,-0.15399 -0.20877,-1.14619 -0.20825,-1.14618 -0.39688,-0.15296 z m -37.49591,0.23823 h 0.359669 0.35967 l 0.370519,0.59479 0.37052,0.5948 -0.129191,0.99167 -0.129193,0.99115 h -0.196887 -0.196368 l -0.723988,-0.67076 -0.723471,-0.67127 0.186552,-0.45217 0.186553,-0.45269 0.132807,-0.46302 z m 67.73385,0 h 0.35967 0.35967 l 0.37052,0.59479 0.37052,0.5948 -0.12919,0.99167 -0.12919,0.99115 h -0.19689 -0.19637 l -0.72399,-0.67076 -0.72347,-0.67127 0.18655,-0.45217 0.18656,-0.45269 0.1328,-0.46302 z m -83.984019,0.0434 -1.034563,0.5395 -1.034045,0.5395 0.0956,0.2868 0.0956,0.28681 1.302763,0.4563 1.303279,0.45682 1.314132,0.6718 1.314133,0.6723 0.232542,-0.23254 0.232029,-0.23203 -1.150318,-1.2454 -1.1498,-1.24488 -0.760677,-0.47749 z m 67.733849,0 -1.03456,0.5395 -1.03404,0.5395 0.0956,0.2868 0.0956,0.28681 1.30276,0.4563 1.30328,0.45682 1.31413,0.6718 1.31413,0.6723 0.23255,-0.23254 0.23202,-0.23203 -1.15032,-1.2454 -1.1498,-1.24488 -0.76067,-0.47749 z m -67.93022,0.22065 h 0.131775 0.132292 v 0.1323 0.13229 H 51.189215 51.05744 v -0.13229 z m 67.73385,0 h 0.13178 0.13229 v 0.1323 0.13229 h -0.13229 -0.13178 v -0.13229 z m -26.408206,0.22945 -1.106395,0.44287 -1.106392,0.44286 v 0.31833 0.31833 l 0.982887,0.37982 0.982369,0.37982 1.329635,0.70745 h 5.29e-4 l 1.329634,0.70745 0.330729,0.0196 0.330214,0.0196 -0.0083,-0.33022 -0.0078,-0.33072 -1.528588,-1.53738 z m 67.733856,0 -1.10639,0.44287 -1.1064,0.44286 v 0.31833 0.31833 l 0.98289,0.37982 0.98237,0.37982 1.32963,0.70745 h 5.3e-4 l 1.32964,0.70745 0.33073,0.0196 0.33021,0.0196 -0.008,-0.33022 -0.008,-0.33072 -1.52859,-1.53738 z m -93.76276,0.0351 h 0.132292 0.131776 l 0.163814,0.26458 0.163298,0.26407 h -0.132292 -0.132291 l -0.163299,-0.26407 z m 67.73385,0 h 0.1323 0.13177 l 0.16381,0.26458 0.1633,0.26407 h -0.13229 -0.13229 l -0.1633,-0.26407 z m -62.448385,0.79323 h 0.132292 0.132291 l 0.163299,0.26458 0.163298,0.26407 h -0.132292 -0.132292 l -0.163298,-0.26407 z m 67.733855,0 h 0.13229 0.1323 l 0.16329,0.26458 0.1633,0.26407 h -0.13229 -0.13229 l -0.1633,-0.26407 z m -35.49189,0.26407 h 0.13229 0.13178 l 0.16329,0.26458 0.16382,0.26407 h -0.1323 -0.13229 l -0.16329,-0.26459 z m 67.73385,0 h 0.13229 0.13178 l 0.1633,0.26458 0.16381,0.26407 h -0.13229 -0.13229 l -0.1633,-0.26459 z m -89.37336,5.3e-4 h 0.132291 0.131776 v 0.13177 0.1323 H 82.374391 82.2421 v -0.1323 z m 67.73386,0 h 0.13229 0.13177 v 0.13177 0.1323 h -0.13177 -0.13229 v -0.1323 z m -70.641176,0.52865 h 0.132292 0.132291 v 0.13229 0.13177 h -0.132291 -0.132292 v -0.13177 z m 67.733856,0 h 0.13229 0.13229 v 0.13229 0.13177 h -0.13229 -0.13229 v -0.13177 z m -106.662742,1.29604 -0.25425,0.25477 -0.25425,0.25424 0.9927,1.60869 0.99271,1.60921 h 0.72295 0.722955 l 0.316259,-0.38137 0.31626,-0.38138 -0.614433,-0.52141 -0.614431,-0.52193 -1.16324,-0.96015 z m 67.733852,0 -0.25425,0.25477 -0.25425,0.25424 0.99271,1.60869 0.9927,1.60921 h 0.72295 0.72295 l 0.31627,-0.38137 0.31625,-0.38138 -0.61443,-0.52141 -0.61443,-0.52193 -1.16324,-0.96015 z m -18.762168,0.46664 0.176217,0.17622 0.176215,0.17621 h -0.352432 -0.352433 l 0.176215,-0.17621 z m 67.733858,0 0.17621,0.17622 0.17622,0.17621 h -0.35243 -0.35244 l 0.17622,-0.17621 z m -85.704856,0.26407 -0.176215,0.17621 -0.176218,0.17622 h 0.352433 0.352436 l -0.176218,-0.17622 z m 67.733856,0 -0.17622,0.17621 -0.17621,0.17622 h 0.35243 0.35243 l -0.17621,-0.17622 z m -83.854833,0.0501 -1.519288,0.1726 -1.519804,0.17312 -0.429948,0.11782 -0.429948,0.11834 -0.95188,1.43402 -0.952396,1.43454 0.304374,0.18759 0.303857,0.1881 -0.590661,0.21859 -0.590662,0.21859 0.177767,0.28835 0.177767,0.28784 0.565857,-0.13952 0.565857,-0.14005 1.850016,-0.17363 1.850017,-0.17312 0.168465,-0.1018 0.167947,-0.1018 0.261483,0.32711 0.261482,0.32763 -0.190169,0.52348 -0.190169,0.52297 0.145727,0.13435 h 2.073259 l -0.604097,-0.91622 -0.649573,-1.25574 -0.650089,-1.25573 H 54.2929 53.695006 l -1.252638,0.55035 -1.252119,0.55035 -0.462504,0.24495 -0.462505,0.24495 0.0026,-0.20051 0.0031,-0.2005 0.988054,-0.64131 0.987537,-0.6413 1.519803,-0.89142 1.519288,-0.89193 v -0.27027 z m 67.733853,0 -1.51929,0.1726 -1.5198,0.17312 -0.42995,0.11782 -0.42995,0.11834 -0.95188,1.43402 -0.95239,1.43454 0.30437,0.18759 0.30386,0.1881 -0.59067,0.21859 -0.59066,0.21859 0.17777,0.28835 0.17777,0.28784 0.56585,-0.13952 0.56586,-0.14005 1.85002,-0.17363 1.85001,-0.17312 0.16847,-0.1018 0.16795,-0.1018 0.26148,0.32711 0.26148,0.32763 -0.19017,0.52348 -0.19017,0.52297 0.14573,0.13435 h 2.07326 l -0.6041,-0.91622 -0.64957,-1.25574 -0.65009,-1.25573 h -0.5979 -0.59789 l -1.25264,0.55035 -1.25212,0.55035 -0.4625,0.24495 -0.46251,0.24495 0.003,-0.20051 0.003,-0.2005 0.98806,-0.64131 0.98753,-0.6413 1.5198,-0.89142 1.51929,-0.89193 v -0.27027 z m -27.035047,0.5147 -1.651577,0.18345 -1.65158,0.18294 -0.594796,0.37775 -0.594797,0.37776 v 0.34985 0.34984 l -0.528648,0.60979 -0.528135,0.60978 v 0.20826 0.20825 l 0.309026,0.1912 0.309541,0.19172 -0.639752,0.27854 -0.639754,0.27905 1.243851,0.0884 1.244367,0.0879 1.331703,-0.24236 1.331701,-0.24185 0.453202,0.33176 0.453719,0.33176 -0.384472,0.46354 -0.09405,0.11317 h 1.799375 l -0.303343,-0.65939 -0.483174,-1.05058 -0.387059,-0.59479 -0.386538,-0.5948 -0.7953,0.005 -0.7953,0.005 -1.387512,0.76481 -1.387513,0.76532 0.0088,-0.17518 0.0078,-0.17518 1.115176,-0.81029 1.115179,-0.8108 1.255221,-0.64286 1.25522,-0.64337 v -0.35657 z m 67.733857,0 -1.65158,0.18345 -1.65158,0.18294 -0.59479,0.37775 -0.5948,0.37776 v 0.34985 0.34984 l -0.52865,0.60979 -0.52813,0.60978 v 0.20826 0.20825 l 0.30902,0.1912 0.30954,0.19172 -0.63975,0.27854 -0.63975,0.27905 1.24385,0.0884 1.24437,0.0879 1.3317,-0.24236 1.3317,-0.24185 0.4532,0.33176 0.45372,0.33176 -0.38447,0.46354 -0.0946,0.11317 h 1.79937 l -0.30334,-0.65939 -0.48317,-1.05058 -0.38706,-0.59479 -0.38654,-0.5948 -0.7953,0.005 -0.7953,0.005 -1.38751,0.76481 -1.38751,0.76532 0.008,-0.17518 0.008,-0.17518 1.11517,-0.81029 1.11518,-0.8108 1.25522,-0.64286 1.25522,-0.64337 v -0.35657 z m -114.431781,0.58084 -0.807186,0.28112 -0.807186,0.28164 -0.614433,1.37097 -0.614433,1.37098 -0.195337,0.46251 -0.19482,0.4625 h 0.353984 0.3545 l 1.487248,-1.85415 1.487248,-1.85415 v -0.26097 -0.26045 h -0.224793 z m 67.733851,0 -0.80719,0.28112 -0.80718,0.28164 -0.61443,1.37097 -0.61444,1.37098 -0.19533,0.46251 -0.19482,0.4625 h 0.35398 0.3545 l 1.48725,-1.85415 1.48725,-1.85415 v -0.26097 -0.26045 h -0.2248 z m -61.703211,0.26407 -0.148828,0.24081 -0.148312,0.2403 0.161231,0.42064 0.16123,0.42013 h 0.772562 0.773081 l 0.162263,-0.42323 0.162264,-0.42323 -0.36897,-0.23357 -0.368453,-0.23358 -0.579292,-0.004 z m 67.733851,0 -0.14883,0.24081 -0.14831,0.2403 0.16123,0.42064 0.16123,0.42013 h 0.77257 0.77307 l 0.16227,-0.42323 0.16226,-0.42323 -0.36897,-0.23357 -0.36845,-0.23358 -0.57929,-0.004 z m -32.857945,0.18138 -0.849561,0.24392 -0.849558,0.24391 -0.373105,1.11931 -0.373105,1.11983 h -0.270267 -0.270785 l 0.194305,-0.4625 0.194818,-0.46302 0.127124,-0.58498 0.127125,-0.5855 -0.623735,0.11938 -0.623734,0.11989 -0.300757,0.40927 -0.300241,0.4098 -0.269751,-0.076 -0.269234,-0.076 -1.338935,0.99115 -1.339453,0.99167 h -0.262517 -0.263033 l 0.160197,0.41755 0.141076,0.36638 h 0.185002 l 0.392742,-0.12298 0.558105,-0.17519 0.660423,-0.15141 0.660943,-0.15193 0.594796,-0.38602 0.594278,-0.38602 0.0088,-0.43254 0.0078,-0.43201 0.269235,0.4625 0.26975,0.46251 h 0.376722 0.376722 l -0.240298,0.632 -0.239778,0.63148 0.51935,-0.1359 0.51883,-0.13591 0.257865,-0.48163 0.257866,-0.48162 1.072287,-1.23972 1.072285,-1.23972 -0.269751,-0.26975 z m 67.733855,0 -0.84956,0.24392 -0.84956,0.24391 -0.3731,1.11931 -0.37311,1.11983 h -0.27027 -0.27078 l 0.1943,-0.4625 0.19482,-0.46302 0.12713,-0.58498 0.12712,-0.5855 -0.62373,0.11938 -0.62374,0.11989 -0.30075,0.40927 -0.30024,0.4098 -0.26975,-0.076 -0.26924,-0.076 -1.33894,0.99115 -1.33945,0.99167 h -0.26252 -0.26303 l 0.1602,0.41755 0.14108,0.36638 h 0.185 l 0.39274,-0.12298 0.5581,-0.17519 0.66043,-0.15141 0.66094,-0.15193 0.5948,-0.38602 0.59427,-0.38602 0.008,-0.43254 0.008,-0.43201 0.26924,0.4625 0.26975,0.46251 h 0.37672 0.37672 l -0.2403,0.632 -0.23978,0.63148 0.51935,-0.1359 0.51883,-0.13591 0.25787,-0.48163 0.25786,-0.48162 1.07229,-1.23972 1.07229,-1.23972 -0.26975,-0.26975 z m -57.38203,0.0744 -0.40256,0.15451 -0.402563,0.15451 -0.12764,0.57671 -0.12764,0.57723 -0.60978,1.64331 -0.41703,1.12344 h 0.66249 l -0.0966,-0.12298 0.15658,0.12298 h 1.037663 l 0.17984,-1.09502 0.23047,-1.40715 0.91571,0.0749 0.91571,0.0754 0.0884,0.25528 0.0879,0.25528 h 0.24546 0.24495 l 1.87327,0.92553 v -1.2206 l -0.59635,-0.40876 -2.0593,-1.41025 -0.60255,0.0982 -0.60306,0.0987 -0.29663,-0.23565 z m 67.73385,0 -0.40255,0.15451 -0.40256,0.15451 -0.12765,0.57671 -0.12764,0.57723 -0.60978,1.64331 -0.41703,1.12344 h 0.6625 l -0.0966,-0.12298 0.15658,0.12298 h 1.03766 l 0.17984,-1.09502 0.23047,-1.40715 0.91571,0.0749 0.91571,0.0754 0.0884,0.25528 0.0879,0.25528 h 0.24547 0.24494 l 1.87327,0.92553 v -1.2206 l -0.59634,-0.40876 -2.05931,-1.41025 -0.60255,0.0982 -0.60306,0.0987 -0.29662,-0.23565 z m -131.012672,0.002 v 1.30276 l 0.20722,-0.0796 0.39222,-0.15038 -0.2527,-0.47283 -0.25269,-0.47233 z m 67.733852,0 v 1.30276 l 0.20722,-0.0796 0.39222,-0.15038 -0.25269,-0.47283 -0.2527,-0.47233 z m -58.888918,0.0765 -0.433566,0.24288 -0.434082,0.24288 v 0.37518 0.37516 l -0.372587,-0.14314 -0.372587,-0.14314 -0.750858,0.39067 -0.750344,0.39016 -0.66094,0.57723 -0.66042,0.57722 -0.36742,0.20671 -0.36742,0.20618 0.18448,0.29921 0.185,0.29921 h 0.32815 0.32763 l 0.25114,-0.22531 0.25115,-0.22531 1.247988,-0.3359 1.247469,-0.33538 0.161747,-0.51056 0.162264,-0.51056 0.385506,0.31987 0.38499,0.3204 0.217041,-0.2403 0.217041,-0.23978 0.278019,-0.83457 0.278019,-0.83406 -0.468705,-0.12247 z m 67.733848,0 -0.43356,0.24288 -0.43408,0.24288 v 0.37518 0.37516 l -0.37259,-0.14314 -0.37259,-0.14314 -0.75085,0.39067 -0.75035,0.39016 -0.66094,0.57723 -0.66042,0.57722 -0.36742,0.20671 -0.36742,0.20618 0.18448,0.29921 0.185,0.29921 h 0.32815 0.32763 l 0.25114,-0.22531 0.25115,-0.22531 1.24799,-0.3359 1.24747,-0.33538 0.16174,-0.51056 0.16227,-0.51056 0.3855,0.31987 0.38499,0.3204 0.21704,-0.2403 0.21705,-0.23978 0.27802,-0.83457 0.27802,-0.83406 -0.46871,-0.12247 z m -17.864024,0.16123 -0.173117,0.45166 -0.173114,0.45165 0.465603,0.34055 0.465606,0.34055 0.644403,-0.29353 0.64492,-0.29404 -0.0786,-0.41548 -0.0785,-0.41547 -0.858344,-0.0827 z m 67.733854,0 -0.17311,0.45166 -0.17312,0.45165 0.46561,0.34055 0.4656,0.34055 0.6444,-0.29353 0.64493,-0.29404 -0.0791,-0.41548 -0.0786,-0.41547 -0.85834,-0.0827 z m -126.448612,1.80194 v 1.23455 l 0.34416,0.17002 1.58647,0.78393 h 1.28829 v -0.0584 -0.33176 l -0.83974,-0.37207 -0.83974,-0.37207 z m 67.733852,0 v 1.23455 l 0.34416,0.17002 1.58647,0.78393 h 1.28829 v -0.0584 -0.33176 l -0.83974,-0.37207 -0.83974,-0.37207 z m -27.25054,0.0827 h 0.132292 0.131776 v 0.1323 0.13229 H 77.881642 77.74935 v -0.13229 z m 67.73386,0 h 0.13229 0.13177 v 0.1323 0.13229 h -0.13177 -0.13229 v -0.13229 z m -44.4898,0.45321 -0.16329,0.16381 -0.16382,0.1633 0.34985,0.42168 0.34933,0.42116 0.48163,-0.12609 0.48111,-0.12557 -0.12455,0.20102 -0.12402,0.20154 0.35295,0.33176 h 2.56677 v -0.30954 l -0.29611,-0.0475 -0.96428,-0.154 -1.37252,-0.57103 z m 67.73386,0 -0.1633,0.16381 -0.16382,0.1633 0.34985,0.42168 0.34934,0.42116 0.48162,-0.12609 0.48111,-0.12557 -0.12454,0.20102 -0.12402,0.20154 0.35294,0.33176 h 2.56677 v -0.30954 l -0.2961,-0.0475 -0.96429,-0.154 -1.37252,-0.57103 z m -123.73871,0.77256 -1.240235,0.3855 -1.240747,0.38551 -0.0362,0.10904 h 3.00447 l 0.151929,-0.24081 -0.319361,-0.31936 z m 67.73385,0 -1.24023,0.3855 -1.24075,0.38551 -0.0362,0.10904 h 3.00447 l 0.15192,-0.24081 -0.31936,-0.31936 z m -60.919794,0.16743 -2.288751,0.0305 -2.288749,0.03 0.06615,0.33073 0.0646,0.32143 h 4.607472 l 0.09767,-0.0754 0.342614,-0.26562 -0.300241,-0.18551 z m 67.733854,0 -2.28875,0.0305 -2.28875,0.03 0.0661,0.33073 0.0646,0.32143 h 4.60747 l 0.0977,-0.0754 0.34261,-0.26562 -0.30023,-0.18551 z m -82.270432,0.39117 v 0.32143 h 0.91777 l -0.1726,-0.20257 z m 67.733852,0 v 0.32143 h 0.91777 l -0.1726,-0.203 z m -18.989028,0.0295 -0.962216,0.18035 -0.595828,0.11162 h 1.850017 l -0.02066,-0.0207 z m 67.733858,0 -0.96222,0.18035 -0.59583,0.11162 h 1.85002 l -0.0207,-0.0207 z m -64.763498,0.10542 -0.46302,0.11575 -0.282671,0.0708 h 4.96869 l -0.04134,-0.12299 -2.090827,-0.032 z m 67.733858,0 -0.46302,0.11575 -0.28267,0.0708 h 4.96869 l -0.0413,-0.12299 -2.09083,-0.032 z m -110.018614,0.0636 0.01395,0.12299 h 0.602547 l -0.285771,-0.0568 z m 67.733854,0 0.0139,0.12299 h 0.60255 l -0.28577,-0.0569 z"
       style="fill:{{pk_fill}};stroke-width:1" />
  </g>
</svg>`, pT = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (http://www.inkscape.org/) -->
<!-- ClipArt by Arvin61r58 (http://openclipart.org/user-detail/Arvin61r58) -->
<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="{{pk_dimension}}"
   height="{{pk_dimension}}"
   viewBox="0 0 299 299"
   id="svg4155"
   version="1.1">
  <title
     id="title4709">Spotty</title>
  <defs
     id="defs4157">
     {{pk_gradient}}
   </defs>
  <metadata
     id="metadata4160">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title>Spotty</dc:title>
        <dc:creator>
          <cc:Agent>
            <dc:title>Arvin61r58</dc:title>
          </cc:Agent>
        </dc:creator>
        <dc:publisher>
          <cc:Agent>
            <dc:title>Openclipart.org</dc:title>
          </cc:Agent>
        </dc:publisher>
        <dc:identifier>https://openclipart.org/</dc:identifier>
        <dc:source>https://openclipart.org/user-detail/Arvin61r58</dc:source>
        <dc:description>spots pattern</dc:description>
        <dc:subject>
          <rdf:Bag>
            <rdf:li>spots</rdf:li>
            <rdf:li>spotty</rdf:li>
            <rdf:li>pattern</rdf:li>
          </rdf:Bag>
        </dc:subject>
        <cc:license
           rdf:resource="http://creativecommons.org/publicdomain/zero/1.0/" />
      </cc:Work>
      <cc:License
         rdf:about="http://creativecommons.org/publicdomain/zero/1.0/">
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#Reproduction" />
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#Distribution" />
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#DerivativeWorks" />
      </cc:License>
    </rdf:RDF>
  </metadata>
  {{pk_gradient}}
  <g
     id="layer1"
     transform="translate(-222.04724,-376.1811)">
    <path
       style="fill:{{pk_fill}}"
       d="m 235.0824,376.1811 c -0.25639,0.26371 -0.51251,0.52491 -0.76563,0.80664 -6.60902,7.35632 -7.85193,12.65005 -3.89844,16.60352 3.95348,3.9535 9.2472,2.71058 16.60352,-3.89844 5.00135,-4.4933 7.16341,-9.5459 6.09961,-13.51172 l -18.03906,0 z m 31.33007,0 c -1.27232,8.75372 -0.71059,11.05504 3.4961,15.26172 8.47956,8.47956 29.69763,4.51077 33.09375,-6.18945 0.96918,-3.05361 1.57035,-6.13504 1.82422,-9.07227 l -38.41407,0 z m 118.66993,0 c -0.25639,0.26371 -0.51251,0.52491 -0.76563,0.80664 -6.60902,7.35632 -7.85193,12.65005 -3.89844,16.60352 3.95348,3.9535 9.24722,2.71058 16.60352,-3.89844 5.00136,-4.4933 7.16341,-9.5459 6.09961,-13.51172 l -18.03906,0 z m 31.33007,0 c -1.27232,8.75372 -0.71059,11.05504 3.4961,15.26172 8.47954,8.47956 29.69763,4.51077 33.09375,-6.18945 0.96918,-3.05361 1.57035,-6.13504 1.82422,-9.07227 l -38.41407,0 z m -75.50195,2.56446 c -3.29318,-0.0258 -7.10831,1.00725 -11.98047,3.04297 -5.23024,2.18533 -8.66848,5.72429 -10.4082,10.71484 -2.28647,6.55894 -1.96299,8.08974 2.70312,12.75586 3.96171,3.96171 7.49282,5.12882 13.96485,4.61914 11.96272,-0.94211 17.18548,-4.2419 20.14258,-12.72461 2.22686,-6.38797 1.85125,-7.92612 -3.16211,-12.93945 -3.65283,-3.65282 -7.02568,-5.43559 -11.25977,-5.46875 z m 150,0 c -3.29318,-0.0258 -7.10831,1.00725 -11.98047,3.04297 -5.23024,2.18533 -8.66848,5.72429 -10.4082,10.71484 -2.28647,6.55894 -1.96299,8.08974 2.70312,12.75586 3.96171,3.96171 7.49282,5.12882 13.96485,4.61914 11.96272,-0.94211 17.18548,-4.2419 20.14258,-12.72461 2.22686,-6.38797 1.85123,-7.92612 -3.16211,-12.93945 -3.65283,-3.65282 -7.02568,-5.43559 -11.25977,-5.46875 z m -225.96094,26.66797 c -7.92964,-0.2551 -11.20628,14.18043 -3.11132,22.27539 4.13027,4.13027 11.47751,4.36935 11.95117,0.38867 0.0986,-0.82888 0.59183,-3.61523 1.0957,-6.19336 1.34514,-6.88282 -0.96774,-12.56192 -6.27148,-15.40039 -1.3031,-0.6974 -2.53126,-1.03387 -3.66407,-1.07031 z m 150,0 c -7.92965,-0.2551 -11.2063,14.18043 -3.11132,22.27539 4.13027,4.13027 11.47751,4.36935 11.95117,0.38867 0.0986,-0.82888 0.59185,-3.61523 1.0957,-6.19336 1.34514,-6.88282 -0.96774,-12.56192 -6.27148,-15.40039 -1.3031,-0.6974 -2.53126,-1.03387 -3.66407,-1.07031 z m -182.27929,1.43554 c -1.38436,0.018 -3.0472,0.12271 -5.08789,0.25586 -2.27213,0.14825 -4.06053,0.28869 -5.53516,0.50391 l 0,31.80664 c 0.75468,0.029 1.55166,0.0469 2.44727,0.0469 18.94625,0 25.32098,-7.94687 18.53515,-23.10351 -3.59443,-8.02844 -4.36051,-9.58761 -10.35937,-9.50977 z m 150,0 c -1.38436,0.018 -3.0472,0.12271 -5.08789,0.25586 -10.55752,0.68886 -11.12179,1.09696 -14.55469,10.54492 -2.83401,7.79959 -3.00793,11.06616 -0.8418,15.82032 2.27967,5.00329 4.30887,5.99218 12.3086,5.99218 18.94627,0 25.32098,-7.94687 18.53515,-23.10351 -3.59442,-8.02844 -4.36051,-9.58761 -10.35937,-9.50977 z m 139.37695,0.75977 c -5.37729,0.78478 -6.32544,2.62639 -9.01953,10.04101 -2.83401,7.79959 -3.00793,11.06616 -0.8418,15.82032 2.02445,4.44314 3.87506,5.71517 9.86133,5.94531 l 0,-31.80664 z m -221.94727,7.37109 c -4.99972,0.14781 -9.54811,1.83014 -11.76171,4.85742 -4.729,6.4673 -3.79655,23.52377 1.58007,28.90039 3.25399,3.25398 6.83297,4.30725 12.30469,3.61915 10.42307,-1.31078 15.91797,-8.66337 15.91797,-21.29688 0,-8.78831 -0.90673,-10.69587 -6.44531,-13.55273 -3.54623,-1.8292 -7.70703,-2.64231 -11.59571,-2.52735 z m 150,0 c -4.99972,0.14781 -9.54812,1.83014 -11.76171,4.85742 -4.72902,6.4673 -3.79655,23.52377 1.58007,28.90039 3.25399,3.25398 6.83297,4.30725 12.30469,3.61915 10.42306,-1.31078 15.91797,-8.66337 15.91797,-21.29688 0,-8.78831 -0.90673,-10.69587 -6.44531,-13.55273 -3.54624,-1.8292 -7.70703,-2.64231 -11.59571,-2.52735 z m -109.97461,12.33789 c -4.49884,-0.0469 -8.07223,2.77406 -10.13867,8.24219 -2.38438,6.30941 0.88216,12.92149 7.64453,15.47656 13.75864,5.19847 22.24757,-15.08164 9.14844,-21.85547 -2.37295,-1.22709 -4.60937,-1.84196 -6.6543,-1.86328 z m 150,0 c -4.49884,-0.0469 -8.07223,2.77406 -10.13867,8.24219 -2.38438,6.30941 0.88216,12.92149 7.64453,15.47656 13.75864,5.19847 22.24757,-15.08164 9.14844,-21.85547 -2.37295,-1.22709 -4.60937,-1.84196 -6.6543,-1.86328 z m -227.08203,16.42969 c -2.77121,0.0579 -6.05708,1.00642 -10.06054,2.79883 -7.89784,3.53595 -9.8418,5.60647 -9.8418,10.48633 0,3.34429 2.58315,8.66322 5.74023,11.82031 4.8339,4.83391 6.7094,5.37095 11.87696,3.40625 15.54249,-5.90925 18.42168,-10.67334 12.79883,-21.17969 -2.70495,-5.05422 -5.89498,-7.42852 -10.51368,-7.33203 z m 150,0 c -2.77122,0.0579 -6.05708,1.00642 -10.06054,2.79883 -7.89784,3.53595 -9.8418,5.60647 -9.8418,10.48633 0,3.34429 2.58316,8.66322 5.74023,11.82031 4.83392,4.83391 6.70943,5.37095 11.87696,3.40625 15.5425,-5.90925 18.42167,-10.67334 12.79883,-21.17969 -2.70494,-5.05422 -5.89498,-7.42852 -10.51368,-7.33203 z m -52.23242,12.27344 c -3.53902,0.0897 -5.92651,1.56955 -7.48437,4.48047 -1.96972,3.68044 -1.50403,5.60925 2.26172,9.375 5.72552,5.72552 24.55938,6.75457 26.59375,1.45312 1.72341,-4.49116 -2.93416,-10.06463 -10.87305,-13.01172 -4.29644,-1.59493 -7.74547,-2.36664 -10.49805,-2.29687 z m 150,0 c -3.53902,0.0897 -5.92651,1.56955 -7.48437,4.48047 -1.96972,3.68044 -1.50403,5.60925 2.26172,9.375 3.16568,3.16568 10.33356,4.88817 16.45898,4.90625 l 0,-16.16797 c -0.24606,-0.0991 -0.48547,-0.20303 -0.73828,-0.29688 -4.29644,-1.59493 -7.74547,-2.36664 -10.49805,-2.29687 z m -288.76367,2.59375 0,16.16797 c 4.95315,0.0146 9.22522,-1.08289 10.13477,-3.45313 1.66854,-4.34814 -2.65404,-9.70323 -10.13477,-12.71484 z m 80.94336,7.95508 c -1.67343,-0.0722 -3.56655,0.55889 -6.5,1.75585 -4.64677,1.89609 -8.55192,5.83567 -10.49024,10.58594 -2.85658,7.00071 -2.65907,7.99523 2.63868,13.29297 5.09924,5.09927 6.54225,5.44078 13.17968,3.12695 5.15203,-1.79598 8.53282,-5.18715 10.95508,-10.98437 3.39999,-8.13739 3.32058,-8.54327 -2.68945,-13.71289 -3.15624,-2.71489 -4.9422,-3.97165 -7.09375,-4.06445 z m 150,0 c -1.67343,-0.0722 -3.56655,0.55889 -6.5,1.75585 -4.64677,1.89609 -8.55193,5.83567 -10.49024,10.58594 -2.85659,7.00071 -2.65907,7.99523 2.63868,13.29297 5.09925,5.09927 6.54225,5.44078 13.17968,3.12695 5.15203,-1.79598 8.53284,-5.18715 10.95508,-10.98437 3.39999,-8.13739 3.32058,-8.54327 -2.68945,-13.71289 -3.15624,-2.71489 -4.9422,-3.97165 -7.09375,-4.06445 z m 30.16797,1.62695 c -1.56964,0.0736 -3.14526,0.63375 -4.58203,1.82617 -4.41288,3.66237 -4.31659,8.03498 0.27929,12.63086 4.59587,4.59589 8.96655,4.69217 12.62891,0.2793 5.16713,-6.22601 -1.5244,-15.05527 -8.32617,-14.73633 z m -149.66406,0.11133 c -1.77997,0.0119 -3.515,0.55048 -4.91797,1.71484 -4.41288,3.66237 -4.31659,8.03498 0.27929,12.63086 2.02566,2.02568 5.06046,3.68359 6.74414,3.68359 4.84593,0 8.8498,-6.3657 7.22461,-11.48632 -1.28277,-4.0416 -5.41414,-6.56918 -9.33007,-6.54297 z m -76.36133,14.97461 c -1.33463,0.0738 -2.89722,0.46195 -4.76563,1.11328 -8.9696,3.12683 -9.39664,4.09975 -5.68554,12.92578 2.56168,6.09261 4.09802,7.18327 8.57812,6.08398 8.50313,-2.08642 11.58318,-5.49117 9.91211,-10.95508 -2.07532,-6.78553 -4.03518,-9.38928 -8.03906,-9.16796 z m 150,0 c -1.33463,0.0738 -2.89722,0.46195 -4.76563,1.11328 -8.9696,3.12683 -9.39662,4.09975 -5.68554,12.92578 2.5617,6.09261 4.09802,7.18327 8.57812,6.08398 8.50313,-2.08642 11.5832,-5.49117 9.91211,-10.95508 -2.07532,-6.78553 -4.03518,-9.38928 -8.03906,-9.16796 z m -41.67188,2.98437 c -6.78789,-0.17977 -12.87698,1.46823 -15.125,4.67774 -3.59368,5.1307 -3.28322,18.57274 0.59766,25.82421 1.95495,3.65284 4.89988,4.72461 12.99219,4.72461 14.12867,0 19.83984,-5.75176 19.83984,-19.98047 0,-9.22708 -0.78085,-10.90184 -6.01172,-12.89062 -3.89635,-1.48139 -8.22023,-2.24761 -12.29297,-2.35547 z m 150,0 c -6.78789,-0.17977 -12.87698,1.46823 -15.125,4.67774 -3.59368,5.1307 -3.28322,18.57274 0.59766,25.82421 1.95495,3.65284 4.89989,4.72461 12.99219,4.72461 3.11377,0 5.79606,-0.29886 8.12109,-0.88671 l 0,-33.59571 c -2.19907,-0.43555 -4.42697,-0.68696 -6.58594,-0.74414 z m -293.41406,0.74414 0,33.59571 c 8.22472,-2.07954 11.71875,-8.00088 11.71875,-19.09376 0,-9.22708 -0.78085,-10.90184 -6.01172,-12.89062 -1.83087,-0.6961 -3.75773,-1.22524 -5.70703,-1.61133 z m 254.51562,13.99805 c -6.80178,-0.31894 -13.49527,8.51032 -8.32812,14.73633 3.66236,4.41287 8.03302,4.31659 12.62891,-0.2793 4.59588,-4.59588 4.69411,-8.96849 0.28125,-12.63086 -1.43678,-1.19242 -3.01239,-1.75257 -4.58204,-1.82617 z m -151.5371,0.13281 c -0.66413,0.0366 -1.32477,0.15232 -1.96485,0.35547 -5.87869,1.86583 -8.55214,9.75855 -4.82617,14.24805 3.66236,4.41287 8.03302,4.31659 12.62891,-0.2793 2.02567,-2.02565 3.68359,-5.06045 3.68359,-6.74414 0,-4.2402 -4.87262,-7.83622 -9.52148,-7.58008 z m -32.25977,6.44141 c -1.78502,0.01 -3.96074,0.14479 -6.66602,0.36914 -6.96046,0.57721 -13.83103,2.22556 -15.26953,3.66406 -1.43848,1.4385 -3.37231,7.60124 -4.29687,13.69336 -1.44699,9.53461 -0.97744,11.78038 3.375,16.13281 8.47956,8.47958 29.69763,4.51078 33.09375,-6.18945 2.91075,-9.17096 2.56601,-18.62408 -0.85742,-23.51172 -2.17368,-3.10334 -4.02384,-4.18834 -9.37891,-4.1582 z m 150,0 c -1.78502,0.01 -3.96074,0.14479 -6.66602,0.36914 -6.96046,0.57721 -13.83103,2.22556 -15.26953,3.66406 -1.4385,1.4385 -3.37233,7.60124 -4.29687,13.69336 -1.44699,9.53461 -0.97744,11.78038 3.375,16.13281 8.47954,8.47958 29.69763,4.51078 33.09375,-6.18945 2.91075,-9.17096 2.56601,-18.62408 -0.85742,-23.51172 -2.17368,-3.10334 -4.02384,-4.18834 -9.37891,-4.1582 z M 245.59607,520.6147 c -3.5302,0.0715 -7.59422,2.27128 -11.2793,6.37304 -6.60902,7.3563 -7.85193,12.65005 -3.89844,16.60352 3.95348,3.9535 9.2472,2.71058 16.60352,-3.89844 6.56278,-5.89612 8.25385,-12.76179 4.1543,-16.86133 -1.53733,-1.53733 -3.46196,-2.25972 -5.58008,-2.21679 z m 150,0 c -3.5302,0.0715 -7.59422,2.27128 -11.2793,6.37304 -6.60902,7.3563 -7.85193,12.65005 -3.89844,16.60352 3.95348,3.9535 9.24722,2.71058 16.60352,-3.89844 6.5628,-5.89612 8.25385,-12.76179 4.1543,-16.86133 -1.53733,-1.53733 -3.46196,-2.25972 -5.58008,-2.21679 z m -54.68555,8.13086 c -3.29318,-0.0258 -7.10831,1.00724 -11.98047,3.04297 -5.23024,2.18533 -8.66848,5.72427 -10.4082,10.71484 -2.28647,6.55894 -1.96299,8.08973 2.70312,12.75586 3.96171,3.9617 7.49282,5.12884 13.96485,4.61914 11.96272,-0.94212 17.18548,-4.2419 20.14258,-12.72461 2.22686,-6.38795 1.85125,-7.9261 -3.16211,-12.93945 -3.65283,-3.65282 -7.02568,-5.43559 -11.25977,-5.46875 z m 150,0 c -3.29318,-0.0258 -7.10831,1.00724 -11.98047,3.04297 -5.23024,2.18533 -8.66848,5.72427 -10.4082,10.71484 -2.28647,6.55894 -1.96299,8.08973 2.70312,12.75586 3.96171,3.9617 7.49282,5.12884 13.96485,4.61914 11.96272,-0.94212 17.18548,-4.2419 20.14258,-12.72461 2.22686,-6.38795 1.85123,-7.9261 -3.16211,-12.93945 -3.65283,-3.65282 -7.02568,-5.43559 -11.25977,-5.46875 z m -225.96094,26.66797 c -7.92964,-0.2551 -11.20628,14.18041 -3.11132,22.27539 4.13027,4.13027 11.47751,4.36935 11.95117,0.38867 0.0986,-0.82887 0.59183,-3.61524 1.0957,-6.19336 1.34514,-6.88283 -0.96774,-12.56188 -6.27148,-15.40039 -1.3031,-0.6974 -2.53126,-1.03387 -3.66407,-1.07031 z m 150,0 c -7.92965,-0.2551 -11.2063,14.18041 -3.11132,22.27539 4.13027,4.13027 11.47751,4.36935 11.95117,0.38867 0.0986,-0.82887 0.59185,-3.61524 1.0957,-6.19336 1.34514,-6.88283 -0.96774,-12.56188 -6.27148,-15.40039 -1.3031,-0.6974 -2.53126,-1.03387 -3.66407,-1.07031 z m -182.27929,1.43554 c -1.38436,0.018 -3.0472,0.12271 -5.08789,0.25586 -2.27213,0.14825 -4.06053,0.2887 -5.53516,0.50391 l 0,31.80664 c 0.75468,0.029 1.55166,0.0469 2.44727,0.0469 18.94625,0 25.32098,-7.94688 18.53515,-23.10351 -3.59443,-8.02844 -4.36051,-9.58761 -10.35937,-9.50977 z m 150,0 c -1.38436,0.018 -3.0472,0.12271 -5.08789,0.25586 -10.55752,0.68884 -11.12179,1.09697 -14.55469,10.54492 -2.83401,7.79957 -3.00793,11.06617 -0.8418,15.82032 2.27967,5.00329 4.30887,5.99218 12.3086,5.99218 18.94627,0 25.32098,-7.9469 18.53515,-23.10351 -3.59442,-8.02844 -4.36051,-9.58761 -10.35937,-9.50977 z m 139.37695,0.75977 c -5.37729,0.78478 -6.32544,2.62639 -9.01953,10.04101 -2.83401,7.79957 -3.00793,11.06617 -0.8418,15.82032 2.02445,4.44314 3.87506,5.71517 9.86133,5.94531 l 0,-31.80664 z m -221.94727,7.37109 c -4.99972,0.14781 -9.54811,1.83012 -11.76171,4.85742 -4.729,6.46729 -3.79655,23.52377 1.58007,28.90039 3.25399,3.25399 6.83297,4.30725 12.30469,3.61915 10.42307,-1.31077 15.91797,-8.66335 15.91797,-21.29688 0,-8.78831 -0.90673,-10.69586 -6.44531,-13.55273 -3.54623,-1.82918 -7.70703,-2.64231 -11.59571,-2.52735 z m 150,0 c -4.99972,0.14781 -9.54812,1.83012 -11.76171,4.85742 -4.72902,6.46729 -3.79655,23.52377 1.58007,28.90039 3.25399,3.25399 6.83297,4.30725 12.30469,3.61915 10.42306,-1.31077 15.91797,-8.66335 15.91797,-21.29688 0,-8.78831 -0.90673,-10.69586 -6.44531,-13.55273 -3.54624,-1.82918 -7.70703,-2.64231 -11.59571,-2.52735 z m -109.97461,12.33789 c -4.49884,-0.0469 -8.07223,2.77409 -10.13867,8.24219 -2.38438,6.30942 0.88216,12.9215 7.64453,15.47656 13.75864,5.19849 22.24757,-15.08166 9.14844,-21.85547 -2.37295,-1.2271 -4.60937,-1.84196 -6.6543,-1.86328 z m 150,0 c -4.49884,-0.0469 -8.07223,2.77409 -10.13867,8.24219 -2.38438,6.30942 0.88216,12.9215 7.64453,15.47656 13.75864,5.19849 22.24757,-15.08166 9.14844,-21.85547 -2.37295,-1.2271 -4.60937,-1.84196 -6.6543,-1.86328 z m -227.08203,16.42969 c -2.77121,0.0579 -6.05708,1.00642 -10.06054,2.79883 -7.89784,3.53597 -9.8418,5.60648 -9.8418,10.48633 0,3.34427 2.58315,8.66322 5.74023,11.82031 4.8339,4.83392 6.7094,5.37095 11.87696,3.40625 15.54249,-5.90925 18.42168,-10.67333 12.79883,-21.17969 -2.70495,-5.05424 -5.89498,-7.42852 -10.51368,-7.33203 z m 150,0 c -2.77122,0.0579 -6.05708,1.00642 -10.06054,2.79883 -7.89784,3.53597 -9.8418,5.60648 -9.8418,10.48633 0,3.34427 2.58316,8.66322 5.74023,11.82031 4.83392,4.83392 6.70943,5.37095 11.87696,3.40625 15.5425,-5.90925 18.42167,-10.67333 12.79883,-21.17969 -2.70494,-5.05424 -5.89498,-7.42852 -10.51368,-7.33203 z m -52.23242,12.27344 c -3.53902,0.0897 -5.92651,1.56956 -7.48437,4.48047 -1.96972,3.68044 -1.50403,5.60925 2.26172,9.375 5.72552,5.72552 24.55938,6.75457 26.59375,1.45312 1.72341,-4.49117 -2.93416,-10.06465 -10.87305,-13.01172 -4.29644,-1.59493 -7.74547,-2.36664 -10.49805,-2.29687 z m 150,0 c -3.53902,0.0897 -5.92651,1.56956 -7.48437,4.48047 -1.96972,3.68044 -1.50403,5.60925 2.26172,9.375 3.16568,3.16568 10.33356,4.88816 16.45898,4.90625 l 0,-16.16797 c -0.24606,-0.0991 -0.48547,-0.20303 -0.73828,-0.29688 -4.29644,-1.59493 -7.74547,-2.36664 -10.49805,-2.29687 z m -288.76367,2.59375 0,16.16797 c 4.95315,0.0146 9.22522,-1.08289 10.13477,-3.45313 1.66854,-4.34815 -2.65404,-9.70324 -10.13477,-12.71484 z m 80.94336,7.95508 c -1.67343,-0.0722 -3.56655,0.55889 -6.5,1.75585 -4.64677,1.8961 -8.55192,5.83566 -10.49024,10.58594 -2.85658,7.0007 -2.65907,7.99523 2.63868,13.29297 5.09924,5.09927 6.54225,5.44077 13.17968,3.12695 5.15203,-1.79599 8.53282,-5.18715 10.95508,-10.98437 3.39999,-8.13739 3.32058,-8.54327 -2.68945,-13.71289 -3.15624,-2.71489 -4.9422,-3.97165 -7.09375,-4.06445 z m 150,0 c -1.67343,-0.0722 -3.56655,0.55889 -6.5,1.75585 -4.64677,1.8961 -8.55193,5.83566 -10.49024,10.58594 -2.85659,7.0007 -2.65907,7.99523 2.63868,13.29297 5.09925,5.09927 6.54225,5.44077 13.17968,3.12695 5.15203,-1.79599 8.53284,-5.18715 10.95508,-10.98437 3.39999,-8.13739 3.32058,-8.54327 -2.68945,-13.71289 -3.15624,-2.71489 -4.9422,-3.97165 -7.09375,-4.06445 z m -119.83203,1.62695 c -1.56964,0.0736 -3.14526,0.6357 -4.58203,1.82812 -4.41288,3.66236 -4.31659,8.03302 0.27929,12.62891 4.59587,4.59588 8.96655,4.69216 12.62891,0.2793 5.16713,-6.22602 -1.5244,-15.05528 -8.32617,-14.73633 z m 150.33594,0.11133 c -1.77997,0.0119 -3.515,0.55243 -4.91797,1.71679 -4.41288,3.66236 -4.31659,8.03302 0.27929,12.62891 2.02566,2.02567 5.06046,3.68359 6.74414,3.68359 4.84593,0 8.8498,-6.3657 7.22461,-11.48632 -1.28275,-4.04159 -5.41414,-6.56918 -9.33007,-6.54297 z m -226.36133,14.97461 c -1.33463,0.0738 -2.89722,0.46195 -4.76563,1.11328 -8.9696,3.12682 -9.39664,4.09974 -5.68554,12.92578 2.56168,6.0926 4.09802,7.18328 8.57812,6.08398 8.50313,-2.08642 11.58318,-5.49119 9.91211,-10.95508 -2.07532,-6.78555 -4.03518,-9.38929 -8.03906,-9.16796 z m 150,0 c -1.33463,0.0738 -2.89722,0.46195 -4.76563,1.11328 -8.9696,3.12682 -9.39662,4.09974 -5.68554,12.92578 2.5617,6.0926 4.09802,7.18328 8.57812,6.08398 8.50313,-2.08642 11.5832,-5.49119 9.91211,-10.95508 -2.07532,-6.78555 -4.03518,-9.38929 -8.03906,-9.16796 z m -41.67188,2.98437 c -6.78789,-0.17977 -12.87698,1.46822 -15.125,4.67774 -3.59368,5.13069 -3.28322,18.57274 0.59766,25.82421 1.95495,3.65284 4.89988,4.72461 12.99219,4.72461 14.12867,0 19.83984,-5.75176 19.83984,-19.98047 0,-9.22708 -0.78085,-10.90185 -6.01172,-12.89062 -3.89635,-1.48139 -8.22023,-2.24761 -12.29297,-2.35547 z m 150,0 c -6.78789,-0.17977 -12.87698,1.46822 -15.125,4.67774 -3.59368,5.13069 -3.28322,18.57274 0.59766,25.82421 1.95495,3.65284 4.89989,4.72461 12.99219,4.72461 3.11377,0 5.79606,-0.29886 8.12109,-0.88671 l 0,-33.59571 c -2.19907,-0.43556 -4.42697,-0.68696 -6.58594,-0.74414 z m -293.41406,0.74414 0,33.59571 c 8.22472,-2.07954 11.71875,-8.00088 11.71875,-19.09376 0,-9.22708 -0.78085,-10.90185 -6.01172,-12.89062 -1.83087,-0.6961 -3.75773,-1.22524 -5.70703,-1.61133 z m 104.51562,13.99805 c -6.80178,-0.31895 -13.49527,8.51031 -8.32812,14.73633 3.66236,4.41287 8.03302,4.31658 12.62891,-0.2793 4.59588,-4.59589 4.69411,-8.96655 0.28125,-12.62891 -1.43678,-1.19242 -3.01239,-1.75452 -4.58204,-1.82812 z m 148.4629,0.13281 c -0.66413,0.0366 -1.32477,0.15232 -1.96485,0.35547 -5.87871,1.86585 -8.55214,9.75855 -4.82617,14.24805 3.66236,4.41287 8.03302,4.31658 12.62891,-0.2793 2.02567,-2.02566 3.68359,-5.06044 3.68359,-6.74414 0,-4.24019 -4.87262,-7.83622 -9.52148,-7.58008 z m -182.25977,6.44141 c -1.78502,0.01 -3.96074,0.14479 -6.66602,0.36914 -6.96046,0.57722 -13.83103,2.22556 -15.26953,3.66406 -1.43848,1.4385 -3.37231,7.60124 -4.29687,13.69336 -0.0485,0.31929 -0.077,0.5678 -0.1211,0.87109 l 38.41407,0 c 0.50832,-5.88367 -0.39827,-11.17948 -2.68164,-14.43945 -2.17368,-3.10335 -4.02384,-4.18834 -9.37891,-4.1582 z m 150,0 c -1.78502,0.01 -3.96074,0.14479 -6.66602,0.36914 -6.96046,0.57722 -13.83103,2.22556 -15.26953,3.66406 -1.4385,1.4385 -3.37233,7.60124 -4.29687,13.69336 -0.0485,0.31929 -0.077,0.5678 -0.1211,0.87109 l 38.41407,0 c 0.50832,-5.88367 -0.39827,-11.17948 -2.68164,-14.43945 -2.17368,-3.10335 -4.02384,-4.18834 -9.37891,-4.1582 z M 245.59607,670.6147 c -3.28773,0.0666 -7.03732,1.99081 -10.51367,5.5664 l 18.03906,0 c -0.33212,-1.23813 -0.96994,-2.37423 -1.94531,-3.34961 -1.53733,-1.53733 -3.46196,-2.25972 -5.58008,-2.21679 z m 150,0 c -3.28773,0.0666 -7.03732,1.99081 -10.51367,5.5664 l 18.03906,0 c -0.33212,-1.23813 -0.96994,-2.37423 -1.94531,-3.34961 -1.53733,-1.53733 -3.46196,-2.25972 -5.58008,-2.21679 z"
       id="path4326" />
  </g>
</svg>
`, gT = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="{{pk_dimension}}"
   height="{{pk_dimension}}"
   viewBox="0 0 300 300.00001"
   id="svg4159"
   version="1.1">
  <title
     id="title4163">Squiggles</title>
  <defs
     id="defs4161">
     {{pk_gradient}}
   </defs>
  <metadata
     id="metadata4164">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title>Squiggles</dc:title>
        <dc:subject>
          <rdf:Bag>
            <rdf:li>squiggles</rdf:li>
            <rdf:li>marks</rdf:li>
            <rdf:li>pattern</rdf:li>
            <rdf:li>texture</rdf:li>
            <rdf:li>seamless</rdf:li>
            <rdf:li>tileable</rdf:li>
            <rdf:li>black and white</rdf:li>
            <rdf:li>black &amp; white</rdf:li>
            <rdf:li>monochrome</rdf:li>
            <rdf:li>gray scale</rdf:li>
            <rdf:li>grey scale</rdf:li>
            <rdf:li />
          </rdf:Bag>
        </dc:subject>
        <dc:description>A seamless pattern based on a pattern from Memphis Group (Memphis-Milano) a circa 1980's architecture and design company.</dc:description>
        <dc:creator>
          <cc:Agent>
            <dc:title>Arvin61r58</dc:title>
          </cc:Agent>
        </dc:creator>
        <dc:publisher>
          <cc:Agent>
            <dc:title>Openclipart.org</dc:title>
          </cc:Agent>
        </dc:publisher>
        <dc:identifier>https://openclipart.org/</dc:identifier>
        <dc:source>https://openclipart.org/user-detail/Arvin61r58</dc:source>
        <cc:license
           rdf:resource="http://creativecommons.org/publicdomain/zero/1.0/" />
      </cc:Work>
      <cc:License
         rdf:about="http://creativecommons.org/publicdomain/zero/1.0/">
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#Reproduction" />
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#Distribution" />
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#DerivativeWorks" />
      </cc:License>
    </rdf:RDF>
  </metadata>
  <g
     transform="translate(-222.04724,-376.18114)"
     id="layer1">
    <path
       style="fill:{{pk_fill}}"
       d="m 259.6859,376.18119 c -0.20571,2.25986 -0.0266,4.32909 0.63868,4.99415 1.09356,1.09328 2.76562,-0.22644 2.76562,-2.18358 0,-1.97049 1.10884,-2.09981 5.07619,-0.59181 2.0403,0.7755 3.50821,0.63852 5.01756,-0.46485 1.10233,-0.80583 1.50343,-1.24201 0.99025,-1.75391 l -14.4883,0 z m 21.34376,0 c 0.41004,0.2943 0.85818,0.58853 1.39454,0.89259 3.29435,1.86762 6.44531,1.71477 6.44531,-0.31445 0,-0.17958 -0.0491,-0.37665 -0.1211,-0.57814 l -7.71875,0 z m 15.16602,0 c -0.0233,0.0733 -0.0543,0.14606 -0.0684,0.21876 -0.27969,1.45204 0.725,2.04013 4.09571,2.39843 6.88581,0.73197 7.81671,0.45412 8.54687,-2.61719 l -12.57422,0 z m 42.18747,0 c 0.21013,0.135 0.42698,0.26298 0.6504,0.38086 4.54954,2.40048 9.8715,2.4179 9.39063,0.0312 -0.0251,-0.12481 -0.098,-0.26679 -0.17969,-0.41211 l -9.86134,0 z m 16.69337,0 c -1.00599,3.85186 -2.75736,6.76595 -4.88281,7.95508 -1.19927,0.67099 -1.63591,1.82696 -1.16017,3.0664 1.88018,4.89834 10.14453,-3.33109 10.14453,-10.10155 0,-0.33009 0.0153,-0.63399 0.043,-0.91993 l -4.14454,0 z m 42.74218,0 c -0.10577,2.01011 -0.57219,2.29651 -2.02344,1.69923 -1.12784,-0.4642 -2.97175,-1.1094 -4.09961,-1.43359 -3.00111,-0.86269 -2.60074,2.68241 0.55274,4.89062 5.13552,3.59611 10.15731,1.03495 10.27344,-5.15626 l -4.70313,0 z m 15.61719,0 c -0.22835,0.40263 -0.35547,0.85008 -0.35547,1.33789 0,1.9496 0.67664,2.24917 4.36327,1.93165 3.40788,-0.29354 4.62654,0.13427 5.56642,1.95898 0.66184,1.28489 1.62917,2.99537 2.15039,3.80078 1.24414,1.92246 4.24052,1.87705 4.99023,-0.0762 0.68288,-1.7791 -1.59109,-6.4888 -4.1621,-8.95313 l -12.55274,0 z m 47.30078,0 c 0.59609,0.72776 1.72728,1.09458 3.00781,0.91211 0.72529,-0.10335 1.32952,-0.38254 1.88671,-0.91211 l -4.89452,0 z m 43.88866,0 c 0.0576,0.74075 0.16894,1.42192 0.33984,1.86719 0.81301,2.11816 3.03125,1.002 3.03125,-1.52539 0,-0.12614 0.01,-0.23506 0.0215,-0.3418 l -3.39258,0 z m 7.03711,0 c 3.26471,1.04516 6.32204,0.97319 8.55664,0 l -8.55664,0 z m -195.24021,2.46679 c -2.11048,-0.0204 -3.77105,0.65229 -5.21875,2.09963 -1.32697,1.32663 -2.91515,2.41211 -3.52929,2.41211 -4.27503,0 -9.14522,4.64831 -7.55861,7.21483 0.38952,0.63011 1.57797,0.78605 2.64064,0.34571 1.06266,-0.44035 3.69805,-1.22387 5.85547,-1.74023 2.1574,-0.51638 4.66661,-2.00058 5.57616,-3.29883 0.90957,-1.29826 2.83486,-2.52923 4.2793,-2.73436 4.09514,-0.58167 3.24467,-3.82623 -1.11327,-4.24806 -0.32055,-0.031 -0.63017,-0.0479 -0.93165,-0.0508 z m -79.74999,1.22657 c -1.77749,-0.0995 -3.53885,0.89628 -3.79688,2.70118 -0.21266,1.48752 0.64124,2.82372 2.3418,3.66211 5.75449,2.83697 12.63867,1.6509 12.63867,-2.17774 0,-1.98623 -0.54446,-2.25503 -3.41211,-1.68164 -2.2881,0.4575 -3.89525,0.10053 -4.87696,-1.08202 -0.7548,-0.90927 -1.82803,-1.36218 -2.89452,-1.42189 z m 211.76951,0.51172 c -1.32946,-0.0663 -2.55079,0.79391 -2.55079,2.31447 0,0.89751 1.00858,2.63975 2.24219,3.87302 1.83882,1.83836 3.0255,2.06693 6.58788,1.2637 2.38989,-0.5389 4.86744,-1.50239 5.50588,-2.14062 2.09468,-2.09418 -0.28461,-3.81209 -4.25001,-3.06839 -2.64773,0.4966 -4.23752,0.17442 -5.26759,-1.0664 -0.63325,-0.76282 -1.4699,-1.136 -2.26756,-1.17578 z m 69.09178,0.3711 c -1.24951,-0.0559 -2.78487,0.73081 -3.67968,2.40235 -0.78019,1.4574 -2.45675,2.34464 -4.43555,2.34764 -3.31473,0.005 -10.79688,3.91364 -10.79688,5.64062 0,0.54642 0.35158,1.34587 0.78126,1.77541 1.16248,1.1622 3.6669,0.94438 4.49218,-0.39063 0.39831,-0.64432 2.19598,-1.17187 3.99609,-1.17187 4.31159,0 11.1389,-4.6725 11.61133,-7.94727 0.24533,-1.70057 -0.71923,-2.60037 -1.96875,-2.65625 z m -24.67382,0.43749 c -0.58521,0.0164 -1.23827,0.28267 -1.9004,0.83203 -0.93507,0.77577 -2.84362,1.11123 -4.24023,0.7461 -2.77193,-0.7247 -6.8457,0.94668 -6.8457,2.80859 0,0.64242 1.18469,1.64579 2.63476,2.22852 5.96196,2.39579 12.59768,0.57945 12.59768,-3.44922 0,-2.02841 -0.95863,-3.2021 -2.24611,-3.16602 z m -114.11523,0.0703 c -0.89938,-0.0489 -2.32806,0.0932 -4.55077,0.34179 -6.72608,0.75219 -10.32813,2.99229 -10.32813,6.42189 0,2.57702 2.66061,2.84489 4.63477,0.46679 0.77359,-0.93189 3.60605,-1.8551 6.29491,-2.05079 4.01857,-0.29245 4.95499,-0.8167 5.25781,-2.94531 0.21915,-1.54048 0.1904,-2.15284 -1.30859,-2.23437 z m -49.03319,5.9961 c -1.05778,0 -1.49286,1.22918 -1.30468,3.69337 l 0.2832,3.69531 -7.86134,-0.17971 c -6.53461,-0.14974 -7.93017,0.15442 -8.26562,1.80275 -0.3255,1.59954 0.68755,2.06748 5.23633,2.42381 13.99272,1.09618 16.82214,0.91881 17.59764,-1.10155 0.91638,-2.38738 -3.45554,-10.33398 -5.68553,-10.33398 z m 108.08592,1.33202 c -4.31677,0.0842 -4.25584,2.47362 0.38476,5.21096 2.80152,1.65249 4.19338,3.33485 4.19338,5.06639 0,1.42566 1.07457,3.74611 2.38866,5.15625 2.984,3.2021 6.98438,3.40978 6.98438,0.36327 0,-1.20975 -0.78912,-2.85608 -1.75586,-3.6582 -0.96673,-0.8021 -1.75781,-2.96157 -1.75781,-4.80078 0,-3.98909 -3.99197,-7.06272 -9.51564,-7.32421 -0.32663,-0.0155 -0.63408,-0.0193 -0.92187,-0.0137 z m -175.22262,0.90819 c -1.3393,-0.0643 -3.33247,1.14839 -5.44922,3.55861 -2.4735,2.81643 -4.56929,4.13679 -6.20898,3.91212 -3.63005,-0.49742 -4.00965,4.12034 -0.47852,5.8203 1.48025,0.71262 3.28763,1.33139 4.01562,1.375 1.80604,0.10818 9.80859,-9.81443 9.80859,-12.16211 0,-1.63132 -0.64582,-2.45393 -1.68749,-2.50392 z m 19.66796,0.68751 c -2.07044,0 -1.95014,3.50822 0.21876,6.37501 2.51176,3.32 2.1129,4.54859 -2.1133,6.51171 -3.99901,1.85759 -5.03041,4.22996 -3.86327,8.87891 0.93384,3.71976 3.93606,3.63838 4.88282,-0.13281 0.41004,-1.63329 2.25879,-3.75134 4.10742,-4.70704 5.54042,-2.86431 5.59143,-8.61873 0.13281,-14.875 -0.9838,-1.12757 -2.49839,-2.05078 -3.36524,-2.05078 z m 191.81442,0.33202 c -0.87265,-0.12412 -2.24801,0.41918 -4.93164,1.73829 -2.79007,1.37146 -5.99938,2.76958 -7.1328,3.10743 -3.10305,0.92498 -5.10088,6.01842 -3.24025,8.25977 2.03182,2.44755 4.41105,2.25207 5.26369,-0.4336 0.38876,-1.22458 2.13745,-2.58164 3.8867,-3.01563 2.98586,-0.74078 8.47515,-4.89579 8.43555,-6.38477 -0.01,-0.37091 -0.49452,-1.42955 -1.07812,-2.35154 -0.3368,-0.53208 -0.67954,-0.84545 -1.20313,-0.91995 z m -51.9414,0.10354 c -1.61268,0.0131 -4.40465,1.79686 -7.82031,5.1582 -6.40982,6.30785 -6.92085,7.74141 -3.93751,11.03711 2.41261,2.66521 4.35718,2.18287 4.85549,-1.20313 0.20611,-1.40067 1.38575,-3.08797 2.62304,-3.74999 2.24177,-1.19945 5.78907,-6.9056 5.78907,-9.31251 0,-1.30773 -0.54217,-1.93754 -1.50978,-1.92968 z m -190.11912,0.10547 c -0.37021,-0.004 -0.70045,0.0431 -0.96484,0.14453 -2.16619,0.83105 -2.50054,2.33531 -0.75781,3.4121 3.45972,2.13766 3.41776,5.03144 -0.15235,10.41993 -3.6703,5.53968 -3.8915,9.54649 -0.73437,13.34961 1.63477,1.96927 5.13101,1.20529 4.54101,-0.9922 -1.5079,-5.61622 -1.31134,-7.07208 1.50977,-11.22264 3.92951,-5.78126 4.04203,-11.42976 0.2793,-13.89453 -1.14031,-0.74699 -2.61007,-1.20545 -3.72071,-1.2168 z m 164.75584,1.00975 c -0.66087,-0.0386 -1.43088,0.25444 -2.57812,0.86331 -1.52528,0.80945 -3.41266,2.37317 -4.19531,3.47459 -0.91594,1.28908 -2.44093,1.80837 -4.2793,1.45702 -3.83224,-0.73237 -5.63385,3.98061 -2.41992,6.33008 3.08166,2.2528 5.09524,1.94058 10.17968,-1.58202 5.87615,-4.07115 7.55121,-7.09001 5.22462,-9.416 -0.71791,-0.71772 -1.27078,-1.08839 -1.93165,-1.12698 z m 89.38476,4.35938 c -0.98539,0.0905 -1.92384,0.6617 -2.3086,1.66406 -0.36217,0.9436 0.48001,3.31565 1.87306,5.27148 2.7935,3.9221 4.85579,4.45501 7.04297,1.82032 1.27285,-1.53328 1.73026,-1.53328 3.91992,0 3.21532,2.25156 6.26232,2.20831 7.55859,-0.10741 0.56752,-1.01382 2.30808,-2.47876 3.86718,-3.25587 3.47381,-1.73143 3.83618,-5.02369 0.49219,-4.47462 -1.28897,0.21168 -3.88108,1.13709 -5.75976,2.05665 -3.00199,1.4694 -3.66102,1.45176 -5.42968,-0.14844 -1.29572,-1.17221 -3.05864,-1.55884 -4.95117,-1.08397 -1.64958,0.4139 -3.28332,0.18334 -3.72266,-0.52736 -0.5657,-0.91508 -1.59664,-1.30531 -2.58204,-1.21484 z m -135.85351,0.45313 c -0.58185,0.0117 -1.00148,0.71383 -1.60351,2.29688 -0.6392,1.68083 -1.66489,3.05469 -2.27929,3.05469 -2.12026,0 -4.87776,3.76864 -4.23633,5.78906 0.50123,1.5788 -0.46127,2.35219 -4.35547,3.50389 -6.64304,1.9647 -8.12208,2.77463 -9.60547,5.25783 -0.98354,1.64646 -0.7855,2.37856 0.92774,3.43554 1.1977,0.73894 3.49752,2.35077 5.11132,3.58205 l 2.93359,2.23827 -2.6582,2.00586 c -1.68989,1.27436 -2.39113,2.69967 -1.92578,3.9121 0.96788,2.52157 1.87993,2.40716 5.125,-0.64064 3.24295,-3.04578 3.37291,-4.72581 0.68555,-8.82615 -1.42454,-2.17357 -1.61574,-3.22909 -0.64454,-3.55273 2.77354,-0.92429 7.35743,-5.20513 7.35743,-6.87111 0,-0.94119 1.84586,-3.55543 4.10156,-5.81054 4.47794,-4.47676 5.02399,-6.48577 2.36328,-8.69336 -0.54023,-0.44825 -0.94775,-0.68867 -1.29688,-0.68164 z m 20.64259,1.77539 c -1.1268,0.0794 -2.8423,1.86412 -3.97851,4.70312 -1.08729,2.71669 -3.20559,5.34292 -5.10743,6.33203 -4.4185,2.29798 -8.94246,7.3159 -7.98828,8.85938 0.89745,1.45177 4.06408,0.0849 6.44335,-2.78123 0.83153,-1.00168 2.44735,-1.82228 3.58986,-1.82228 2.12184,0 8.18163,-9.96103 8.18163,-13.44923 0,-1.32206 -0.46454,-1.88943 -1.14062,-1.84179 z m -76.3418,5.41993 c -0.17126,0.005 -0.31852,0.0298 -0.43944,0.0762 -3.62548,1.39087 -1.54357,4.14478 5.56443,7.35936 6.29146,2.8453 7.58464,3.08536 9.17385,1.70314 2.41048,-2.09654 5.11886,-2.0442 6.92773,0.13476 1.76329,2.12406 3.52539,1.24967 3.52539,-1.74804 0,-4.65421 -8.72432,-7.70479 -11.71876,-4.09766 -1.93461,2.33046 -2.46121,2.25065 -7.45115,-1.13477 -2.05177,-1.39199 -4.38309,-2.32886 -5.58205,-2.29297 z m 136.57226,1.79687 c -1.02166,-0.01 -2.15487,0.82358 -2.96874,2.60938 -1.078,2.36535 -0.88127,3.84077 1.06444,7.99023 1.31264,2.79931 2.67722,6.01305 3.03126,7.14063 0.95581,3.04422 4.08006,2.48005 4.92576,-0.88868 0.47888,-1.90746 -0.007,-4.06382 -1.3867,-6.15041 -1.16832,-1.76717 -2.1491,-4.78529 -2.17969,-6.70896 -0.0409,-2.5717 -1.17278,-3.97933 -2.48633,-3.99219 z m -185.61912,1.63476 c -1.39838,-0.005 -2.51027,0.21456 -3.125,0.72462 -3.1781,2.63692 -1.14531,8.22043 2.22266,6.10546 2.6095,-1.63866 9.36486,-1.49481 11.85936,0.25196 2.98232,2.08834 6.59841,2.21755 6.5879,0.23634 -0.0155,-3.0651 -11.48527,-7.29761 -17.54492,-7.31838 z m 131.78905,1.89258 c -1.66581,0.0847 -1.93168,0.79092 -2.38477,2.5957 -1.01979,4.06215 0.18061,5.79582 2.97851,4.29884 3.17181,-1.69706 9.7673,-1.44393 13.55665,0.52147 3.20847,1.66416 5.19726,1.48144 5.19726,-0.47851 0,-2.03339 -8.23879,-5.7399 -14.4961,-6.52148 -2.34897,-0.29342 -3.85206,-0.46684 -4.85155,-0.41602 z m 96.85545,1.66016 c -1.00492,-0.0339 -2.30303,0.26573 -3.81836,1.02149 -2.60233,1.29787 -5.4796,1.61143 -10.23828,1.11717 -5.70293,-0.59234 -6.91738,-0.35417 -8.78318,1.71486 -1.191,1.3207 -1.89419,2.8404 -1.56251,3.37694 0.33169,0.53657 5.08948,0.91851 10.57423,0.84961 7.21353,-0.0905 10.80722,-0.67091 12.98826,-2.09961 4.23969,-2.77723 3.85464,-5.87886 0.83984,-5.98046 z m 30.62695,0.59373 c -0.87537,0.0887 -1.67169,0.45105 -2.08593,1.12112 -0.39831,0.64431 -2.19737,1.17187 -3.99609,1.17187 -1.79874,0 -5.45817,1.58451 -8.13282,3.52148 -4.80167,3.47742 -5.61006,4.71458 -4.08202,6.2422 1.40389,1.40354 3.50371,0.82401 5.66405,-1.56251 1.16652,-1.28864 3.37901,-2.34376 4.91603,-2.34376 4.41048,0 12.11707,-4.38673 11.32616,-6.44725 -0.4743,-1.23569 -2.15042,-1.85098 -3.60938,-1.70315 z m -85.41599,2.66408 c -1.74643,-0.0477 -2.95722,3.46898 -1.8418,6.36523 0.68261,1.77246 1.57926,4.93128 1.99218,7.0215 0.4129,2.0902 1.63149,4.31479 2.70899,4.94334 1.07747,0.62858 2.37141,1.1601 2.87499,1.17969 1.62913,0.0634 2.3652,-3.59804 0.99806,-4.96482 -0.73007,-0.72991 -1.32812,-2.45692 -1.32812,-3.83985 0,-2.66401 -3.00303,-9.44975 -4.62698,-10.45314 -0.26611,-0.16443 -0.52785,-0.24513 -0.77732,-0.25195 z m 93.02928,1.97265 c -2.98649,0 -2.58354,1.38196 1.43164,4.9043 3.00205,2.63359 3.51562,3.91731 3.51562,8.78711 0,3.26519 0.77973,6.81584 1.82422,8.30664 0.9828,1.40277 2.00145,2.23665 2.85352,2.54297 l 0,-14.58397 c -1.55658,-5.89591 -5.30492,-9.95705 -9.625,-9.95705 z m -224.00583,5.98438 c -2.78692,0.0424 -5.73644,0.58729 -7.41602,1.68751 -2.10524,1.37906 -4.28284,1.74331 -7.42968,1.24021 -3.22185,-0.51503 -4.9622,-0.20345 -6.29492,1.12893 -1.93452,1.93402 -2.37717,4.26185 -1.06056,5.57813 1.13484,1.13453 3.65831,0.95739 4.44336,-0.31252 0.37209,-0.60189 2.53342,-0.79395 4.80275,-0.42577 3.17624,0.5153 4.72276,0.11155 6.71678,-1.75587 1.63083,-1.52729 4.54341,-2.56341 7.86329,-2.79686 3.74113,-0.26308 5.27342,-0.88024 5.27342,-2.12697 0,-1.49427 -3.31523,-2.27129 -6.89842,-2.21679 z m 112.50388,0.2129 c -0.92813,0.0111 -1.96659,0.41639 -2.91601,1.27539 -1.28818,1.16549 -4.15886,1.89842 -7.42968,1.89842 -3.45351,0 -5.87802,0.66029 -6.88477,1.87306 -1.11354,1.34136 -2.70987,1.68351 -5.63477,1.20899 -4.77623,-0.77488 -7.16016,0.78284 -7.16016,4.67772 0,2.81459 2.70346,3.87414 4.10353,1.60937 0.41072,-0.66438 2.65492,-0.86494 5.16992,-0.46289 3.44532,0.55079 4.60675,0.28907 5.16601,-1.16796 0.54539,-1.42087 2.35038,-1.88087 7.40234,-1.88087 7.19529,0 10.96876,-2.0884 10.96876,-6.07422 0,-1.89815 -1.2383,-2.97552 -2.78517,-2.95701 z m -83.85741,1.08007 c -0.4828,-0.0208 -0.95215,0.16321 -1.37892,0.58984 -0.889,0.8888 -0.8566,1.99017 0.10744,3.79102 0.76674,1.43227 1.02104,4.07119 0.58398,6.06056 -0.55994,2.54867 -0.19616,4.16321 1.31445,5.83201 2.32741,2.57108 6.03107,2.43581 5.23828,-0.19139 -0.2801,-0.92822 -0.72398,-4.15386 -0.98632,-7.16799 -0.42416,-4.87312 -2.78679,-8.82393 -4.87891,-8.91405 z m 165.34373,2.09374 c -2.43634,0 -5.40146,0.71135 -6.58984,1.58009 -2.36814,1.73119 -1.56753,4.27733 1.3457,4.27733 1.0117,0 3.88212,1.84645 6.37892,4.10158 4.78142,4.3186 10.85267,5.51377 13.67381,2.69335 2.69601,-2.69529 1.4847,-4.30977 -3.50586,-4.67577 -4.44563,-0.32604 -5.00505,-0.72205 -5.89257,-4.16798 -0.88882,-3.45113 -1.39487,-3.8086 -5.41016,-3.8086 z m -228.32223,0.12891 c -1.21959,6e-4 -2.4126,0.74308 -3.89648,2.22657 -1.89627,1.89575 -3.26565,2.20911 -7.02931,1.60741 -3.71361,-0.59368 -4.67579,-0.38363 -4.67579,1.01758 0,0.97025 1.18664,2.59029 2.63673,3.60156 3.5355,2.4657 10.11276,2.52035 11.04493,0.0918 0.51193,-1.33372 1.64556,-1.6848 3.95703,-1.22264 4.27369,0.85453 5.39072,-1.96149 2.02149,-5.09959 -1.59129,-1.48191 -2.839,-2.22328 -4.0586,-2.22268 z m -32.03711,0.375 0,14.6582 c 1.504,0.55333 2.49455,-0.5432 1.84179,-3.15428 -0.44296,-1.77189 -0.95133,-5.06521 -1.1289,-7.32032 -0.11579,-1.47044 -0.36127,-2.87239 -0.71289,-4.1836 z m 239.57809,3.01171 c -3.62442,0 -3.84061,3.49937 -0.35154,5.67776 2.19882,1.37282 2.40641,2.27762 1.77343,7.66209 -0.53694,4.56724 -0.25099,6.76901 1.13282,8.74413 2.9618,4.22749 4.52952,2.39664 4.91599,-5.74022 0.55472,-11.67961 -1.57783,-16.34376 -7.4707,-16.34376 z m -105.92968,1.57621 c -2.06115,0.14308 -2.92383,2.8551 -2.92383,8.76171 0,6.34612 -0.21007,6.84877 -3.53514,8.45509 -3.76795,1.82028 -4.76574,4.25512 -3.61719,8.83008 0.89554,3.56723 3.76993,3.68577 4.81444,0.19923 0.43432,-1.44971 1.83439,-3.46268 3.11133,-4.47461 1.57265,-1.24628 2.63116,-4.08203 3.2793,-8.78712 0.52629,-3.82046 1.31427,-8.05907 1.75,-9.41993 0.56519,-1.76515 0.20519,-2.69926 -1.25584,-3.25976 -0.60741,-0.23302 -1.1474,-0.33772 -1.62307,-0.30469 z m 57.48633,1.4922 c -0.98538,-0.0303 -2.14825,0.68927 -3.16602,2.24217 -1.26346,1.92779 -1.62667,3.96815 -1.08983,6.1133 0.44313,1.77066 1.08879,4.9333 1.43553,7.02734 0.69461,4.19447 3.66318,5.14665 6.26562,2.01172 1.16456,-1.40283 1.19497,-2.77356 0.14258,-6.28517 -0.74037,-2.47049 -1.3457,-5.82494 -1.3457,-7.4531 0,-2.33884 -0.97527,-3.61731 -2.24218,-3.65626 z m -115.17186,1.89648 c -0.74553,0.049 -1.64773,0.33093 -2.67187,0.87891 -3.51794,1.88223 -3.85886,5.73367 -0.94336,10.66796 1.89455,3.20638 4.83163,4.37297 6.58789,2.61719 0.43192,-0.4318 -0.006,-1.99146 -0.97267,-3.4668 -1.41297,-2.15591 -1.49024,-3.27236 -0.38866,-5.68946 1.45811,-3.19937 0.62525,-5.15482 -1.61133,-5.0078 z m 150.45703,2.26952 c -1.06752,0.0392 -3.33236,0.79872 -8.11916,2.32618 -9.14929,2.91954 -10.2625,3.66003 -9.29687,6.17579 0.86932,2.26483 2.1775,2.27471 9.43944,0.0723 6.81519,-2.06698 8.91603,-3.61735 8.91603,-6.58009 0,-1.35184 0.12805,-2.03329 -0.93944,-1.99415 z m -53.77737,1.17775 c -2.85859,0.55432 -2.9568,2.28316 -0.37107,6.52343 2.42267,3.97294 5.18273,4.94805 6.23632,2.20313 0.9267,-2.41428 -3.60977,-9.16393 -5.86525,-8.72656 z m -81.76366,3.88084 c -0.39341,0.019 -0.81676,0.27051 -1.35936,0.72071 -1.01403,0.84137 -1.49467,2.49607 -1.13672,3.92188 0.41436,1.65049 -0.1418,2.94289 -1.68163,3.90429 -1.26598,0.7904 -2.30274,2.22453 -2.30274,3.18555 0,2.22601 2.11882,2.2114 7.53905,-0.0527 4.64121,-1.93872 4.83429,-3.70999 1.0508,-9.70119 -0.88344,-1.3989 -1.4537,-2.01023 -2.1094,-1.97851 z m -37.22654,0.85548 c -1.66307,-0.0284 -2.76584,0.58869 -4.20118,2.12889 -2.21881,2.38102 -2.77757,2.48316 -6.07615,1.11722 -2.82321,-1.16919 -3.94579,-1.19041 -5.03321,-0.0996 -1.08564,1.08897 -0.74314,1.90315 1.52929,3.63085 1.61123,1.22501 3.98446,2.44182 5.27345,2.70508 1.28897,0.26328 2.65752,0.55097 3.041,0.63867 0.3835,0.0877 1.69577,-0.943 2.91603,-2.29102 1.68428,-1.86056 3.13247,-2.30205 6.01758,-1.83398 7.25065,1.17631 5.74626,-4.29605 -1.58399,-5.76172 -0.71236,-0.14244 -1.32846,-0.22489 -1.88282,-0.23437 z m 239.44723,1.5 c -1.41464,0.0513 -3.54326,0.75582 -6.2617,2.13087 -3.40843,1.72405 -7.37558,3.13474 -8.81642,3.13474 -2.9112,0 -3.33805,1.15665 -1.21288,3.28126 3.46228,3.46138 15.95962,-0.38737 17.94921,-5.52734 0.80136,-2.07023 0.16062,-3.08543 -1.65821,-3.01953 z m -32.90234,1.75196 c -2.9509,0 -4.0921,2.02672 -2.33398,4.14452 0.77587,0.93455 1.13835,3.11877 0.80664,4.85354 -0.33178,1.73472 -0.33848,3.8471 -0.0137,4.69334 l 0.002,0 c 0.86064,2.24223 2.30211,1.8895 4.37304,-1.06642 3.32937,-4.7521 1.5625,-12.62498 -2.83398,-12.62498 z m -101.19725,0.2324 c -1.40382,0.04 -2.57276,0.65438 -4.43555,2.03124 -3.09759,2.28955 -3.9926,2.45036 -6.91015,1.24219 -4.15688,-1.72138 -6.61588,-0.58469 -4.42969,2.04882 0.83666,1.00786 3.0766,2.4865 4.97657,3.28516 3.68958,1.55094 5.91794,1.18128 9.04883,-1.49999 1.07593,-0.92146 3.44723,-1.49915 5.27148,-1.28516 2.64672,0.31046 3.31835,-0.0755 3.31835,-1.91016 0,-1.59499 -1.18305,-2.63886 -3.85938,-3.40624 -1.21166,-0.34742 -2.13816,-0.52986 -2.98046,-0.50586 z m -41.92382,1.07226 c -0.17799,-0.005 -0.3814,0.0202 -0.61132,0.0645 -2.18659,0.42099 -5.50618,10.48785 -4.6543,14.11328 0.28642,1.21895 -0.40325,2.2869 -1.75195,2.71485 -2.50979,0.79636 -2.9796,3.56076 -0.75782,4.45701 2.41048,0.97241 2.86077,0.86335 5.31836,-1.27538 1.82501,-1.58821 2.52751,-4.11596 3.11717,-11.22461 0.60293,-7.26808 0.58579,-8.81394 -0.66014,-8.8496 z m -100.82031,1.36913 c -0.12383,-0.0119 -0.22969,-0.005 -0.3164,0.0234 -2.02667,0.66598 -2.12232,4.9876 -0.14649,6.62697 1.01662,0.8435 1.81446,3.34068 1.81446,5.6797 0,2.67335 0.91508,5.1502 2.54687,6.8867 3.11197,3.3117 6.82617,3.59007 6.82617,0.51172 0,-1.20975 -0.78912,-2.85609 -1.75586,-3.6582 -1.01613,-0.84308 -1.75781,-3.39829 -1.75781,-6.05664 0,-3.47983 -0.76209,-5.3054 -3.13281,-7.50196 -1.50768,-1.39691 -3.21131,-2.4283 -4.07813,-2.51172 z m 91.62304,3.19141 c -1.15701,0.025 -3.0364,1.60109 -4.82812,4.36915 -1.5583,2.40742 -3.88702,4.53746 -5.17579,4.73243 -6.23522,0.94319 -7.61718,1.59805 -7.61718,3.61717 0,1.1765 -1.05476,3.09356 -2.34375,4.25978 -1.28898,1.1662 -2.34376,2.59828 -2.34376,3.18163 0,0.5833 1.97773,0.89725 4.39454,0.69727 3.99462,-0.33052 4.39454,-0.67633 4.39454,-3.79492 0,-2.8623 0.61127,-3.58924 3.68944,-4.39454 3.90966,-1.02284 10.95898,-8.07209 10.95898,-10.95898 0,-1.1806 -0.4347,-1.72395 -1.1289,-1.70899 z m -70.70507,1.54297 c -0.30194,-0.006 -0.56245,0.0483 -0.76561,0.17383 -1.6818,1.03914 -1.54612,4.13281 0.18164,4.13281 1.09367,0 1.09367,0.31286 0,1.40625 -0.77339,0.7732 -1.40625,2.09013 -1.40625,2.92775 0,0.83762 1.01682,1.52344 2.25975,1.52344 2.64039,0 5.94337,-2.9607 5.94337,-5.32813 0,-1.82857 -4.09926,-4.79577 -6.2129,-4.83595 z m 163.29296,0.94141 c -0.35844,0.0366 -0.82565,0.15147 -1.42187,0.32616 -1.50671,0.44149 -3.91496,0.96918 -5.35158,1.1719 -1.43662,0.20272 -3.34356,0.97639 -4.23828,1.71874 -1.24731,1.03493 -1.95568,0.95156 -3.03906,-0.35352 -0.77711,-0.93612 -2.16633,-1.41334 -3.08594,-1.06055 -2.03476,0.78062 -2.19994,5.25171 -0.26562,7.18555 1.83327,1.8328 3.96357,1.77689 7.78711,-0.20702 1.71065,-0.88763 4.69347,-2.08509 6.62696,-2.66017 2.41485,-0.71827 3.6382,-1.91542 3.91014,-3.82226 0.25849,-1.81247 0.15342,-2.40855 -0.92186,-2.29883 z m 21.916,1.02149 c -6.36783,0 -11.42968,2.29268 -11.42968,5.17578 0,2.22091 15.81447,2.22097 17.65821,0 2.68563,-3.23518 0.35119,-5.17578 -6.22853,-5.17578 z m -80.45898,1.17188 c -4.03289,0 -5.58336,1.7359 -3.64061,4.07616 0.97902,1.17934 1.00568,2.28012 0.0996,3.97266 -1.89781,3.54516 -1.50974,6.92256 1.09179,9.52342 2.76115,2.76045 3.92691,2.91246 5.72851,0.7422 1.01141,-1.21837 0.90652,-1.95387 -0.4414,-3.07226 -2.24757,-1.86482 -2.22947,-3.42237 0.0937,-8.07813 2.40878,-4.82726 1.45257,-7.16405 -2.93164,-7.16405 z m 30.18947,2.45702 c -0.62886,0.0512 -1.42313,0.87848 -2.25977,2.52148 -0.73825,1.44973 -3.26166,4.30497 -5.60742,6.34375 l -4.26564,3.70704 -3.78711,-2.32617 c -3.62659,-2.2264 -6.17382,-2.11501 -6.17382,0.26951 0,0.61578 1.71401,2.16467 3.80859,3.44143 5.78726,3.52764 9.45876,2.99203 14.89063,-2.17384 3.58115,-3.40575 4.73631,-5.40687 4.73631,-8.20116 0,-2.4289 -0.53325,-3.6478 -1.34177,-3.58204 z m -169.20898,3.55273 c -1.21353,-0.0171 -2.29222,0.71846 -2.90429,1.77149 l 0,3.91016 c 0.74904,1.47934 0.77538,2.49257 0.0332,2.95118 -0.0112,0.007 -0.0221,0.0233 -0.0332,0.0312 l 0,8.51758 c 0.9733,0.35494 2.52782,-1.01885 4.51367,-4.12698 3.02898,-4.74072 2.7433,-11.58329 -0.53711,-12.84178 -0.36312,-0.1393 -0.72353,-0.20796 -1.07227,-0.21289 z m 69.58788,0.51368 c -0.7973,-0.0272 -1.82902,1.07231 -2.76366,3.30859 -1.98669,4.75361 -4.93244,6.7393 -8.58204,5.78517 -5.40642,-1.41344 -6.73273,2.36835 -4.09765,11.68749 0.98363,3.47863 4.55836,1.85906 4.16016,-1.88476 -0.23793,-2.23693 0.29065,-3.40159 1.75782,-3.87502 8.51702,-2.74813 10.88671,-5.26662 10.88671,-11.57227 0,-2.26812 -0.56401,-3.42202 -1.36134,-3.4492 z m 59.35741,0.96093 c -0.81826,-0.1157 -1.89395,0.62289 -3.47656,2.33008 -2.80695,3.028 -3.88117,7.61926 -2.17968,9.32031 1.1505,1.15021 1.08208,1.21993 4.49804,-4.60742 2.25173,-3.8413 2.79802,-5.74909 1.9004,-6.64648 -0.2244,-0.22435 -0.46943,-0.35792 -0.7422,-0.39649 z m 168.15039,0.26758 c -0.63438,1.06914 -0.78795,2.47368 -0.10157,3.75587 0.0444,0.0831 0.0615,0.1483 0.10157,0.22851 l 0,-3.98438 z m -16.80665,0.0586 c -0.64608,-0.0655 -1.28608,0.19695 -1.8457,0.87109 -1.03849,1.25097 -1.08368,2.34212 -0.16796,4.05273 0.68919,1.28747 1.2539,3.78337 1.2539,5.54688 0,1.76349 0.87282,4.17128 1.93945,5.34961 1.06661,1.17828 2.61651,2.14258 3.44531,2.14258 2.53721,0 3.1491,-2.37655 1.17383,-4.55861 -1.02986,-1.1377 -1.87109,-3.92385 -1.87109,-6.18945 0,-3.86754 -1.9895,-7.01838 -3.92774,-7.21483 z m -234.23238,1.71874 c -0.17677,-0.005 -0.37305,0.0187 -0.59375,0.0605 -1.39177,0.26356 -2.17345,1.70222 -2.42968,4.47852 -0.23006,2.4925 -1.44366,5.00594 -3.10938,6.43359 -2.21545,1.89881 -2.87951,3.9528 -3.50196,10.83593 -0.63501,7.02239 -0.47185,8.49414 0.94532,8.49414 1.97035,0 4.28711,-5.80626 4.28711,-10.74414 0,-2.45226 0.79466,-3.72669 2.92969,-4.69922 2.64399,-1.20437 2.92968,-2.00996 2.92968,-8.26171 0,-5.21844 -0.21966,-6.56618 -1.45703,-6.59767 z m 189.55271,0.0781 c -0.38225,-0.0286 -0.76532,0.0244 -1.14452,0.16991 -1.53035,0.58711 -1.85446,1.48083 -1.23438,3.41603 0.462,1.4419 0.93039,4.53449 1.041,6.8711 0.1106,2.33659 0.91283,5.10429 1.78127,6.15038 0.86839,1.0461 2.58414,1.90235 3.81445,1.90235 2.52384,0 4.51569,-3.70848 2.37498,-4.4219 -0.76044,-0.25339 -1.3828,-2.46572 -1.3828,-4.91796 0,-4.7538 -2.57421,-8.96989 -5.25,-9.16991 z m -49.90822,2.21483 c -1.45718,0.004 -2.64059,0.75655 -3.4453,2.25979 -1.48954,2.78249 -0.64333,4.64701 2.13281,4.6992 1.08982,0.0205 3.0372,0.83595 4.32618,1.81055 l 0,-0.002 c 1.42613,1.07831 4.17898,1.63763 7.03125,1.42774 3.84125,-0.28263 4.75368,-0.82033 5.06054,-2.98047 0.3206,-2.25665 -0.15809,-2.63671 -3.33008,-2.63671 -2.03776,0 -5.04688,-1.05315 -6.68553,-2.34181 -1.90179,-1.49551 -3.63266,-2.24047 -5.08987,-2.23633 z m 76.29494,0.92581 c -2.44809,-0.0697 -4.99129,0.78282 -6.04884,2.77539 -0.76943,1.44969 -2.40326,3.34815 -3.63085,4.21874 -2.13059,1.51094 -2.1374,1.68478 -0.17775,3.84961 2.60852,2.88163 5.24889,2.38276 7.11329,-1.34374 1.02645,-2.05166 2.4199,-2.91797 4.6914,-2.91797 2.22747,0 3.36507,-0.68469 3.66407,-2.20315 0.52701,-2.67645 -2.46381,-4.28932 -5.61132,-4.37888 z m 35.0996,1.9082 c -0.63974,0.42167 -1.16211,2.54138 -1.16211,4.74218 0,2.28696 0.41127,3.55253 1.16211,3.80469 l 0,-8.54687 z m -75.57227,0.83788 c -1.31258,0.0761 -2.24184,1.03891 -1.97459,2.70896 1.55011,9.68715 2.52532,12.84631 4.38671,14.20706 2.71592,1.98543 4.57266,1.98139 6.23046,-0.0156 1.00035,-1.20503 0.7556,-2.08044 -1.02929,-3.69531 -1.43048,-1.29422 -2.33984,-3.60821 -2.33984,-5.95315 0,-2.10923 -0.85349,-4.68967 -1.89843,-5.73436 -1.10047,-1.10017 -2.35411,-1.57677 -3.37502,-1.51757 z m -118.70897,2.42577 c -1.05524,-0.10181 -1.1115,1.45813 -0.59959,7.5625 0.61761,7.365 0.4389,8.33769 -1.94142,10.5547 -1.44226,1.34334 -2.27062,3.0114 -1.84179,3.70508 1.1104,1.79621 1.89385,1.59168 4.95897,-1.2871 2.35622,-2.21299 2.71289,-3.67299 2.71289,-11.12891 0,-4.72009 -0.22071,-8.58204 -0.49023,-8.58204 -0.26954,0 -1.29849,-0.30897 -2.28515,-0.6875 -0.19283,-0.074 -0.36293,-0.12218 -0.51368,-0.13673 z m 28.98243,1.44924 c -0.70982,-0.0104 -2.15477,0.94775 -3.46289,2.33983 -1.495,1.59096 -3.21603,2.89258 -3.82422,2.89258 -0.60819,0 -2.90728,1.58268 -5.10938,3.51563 -2.20211,1.93296 -4.51466,3.51367 -5.13672,3.51367 -0.62207,0 -1.13086,0.79133 -1.13086,1.75782 0,1.29009 1.34388,1.75584 5.0508,1.75584 5.3383,0 8.97285,-1.83585 9.40038,-4.74803 0.14173,-0.96541 1.42975,-2.9282 2.86328,-4.36133 2.68133,-2.68063 3.36992,-5.50938 1.60546,-6.59961 -0.0689,-0.0426 -0.15445,-0.0649 -0.25585,-0.0664 z m -108.85547,2.89062 c -1.69088,0 -9.47883,8.42834 -11.15819,12.07618 -0.94653,2.05597 -2.34157,4.5889 -3.10157,5.62889 -0.76002,1.03997 -1.05107,2.75257 -0.64648,3.80664 0.40459,1.05404 1.41048,1.91321 2.23633,1.90821 1.70302,-0.009 6.77539,-6.95388 6.77539,-9.27734 0,-0.83997 2.20231,-3.54168 4.89453,-6.00194 4.18308,-3.82274 4.67261,-4.73883 3.3711,-6.30666 -0.83766,-1.00905 -1.9044,-1.83398 -2.37111,-1.83398 z m 152.04686,1.14649 c -0.73342,0.0137 -1.74846,0.68318 -2.80468,2.07421 -2.27409,2.99498 -1.99202,4.87197 1.40625,9.32617 2.96452,3.88569 6.24489,4.71903 7.20703,1.83007 0.26339,-0.79087 -0.90204,-2.71745 -2.58985,-4.28124 -2.3848,-2.20961 -2.89985,-3.52187 -2.30664,-5.88477 0.50596,-2.0154 0.0309,-3.08205 -0.91211,-3.06444 z m 13.01563,4.71093 c -2.44321,0 -2.73227,0.88835 -1.11524,3.44337 0.69208,1.09351 0.4639,2.85941 -0.6504,5.01365 -0.94596,1.8289 -1.4042,3.8375 -1.01755,4.4629 1.12253,1.81586 2.6385,1.33231 4.5996,-1.4668 3.15791,-4.5074 2.05637,-11.45312 -1.81641,-11.45312 z m -116.45897,0.67578 c -0.64635,0.0251 -1.25626,0.22093 -1.92382,0.57813 -3.32832,1.78077 -2.2962,5.17598 1.59375,5.24219 1.73947,0.0296 3.56076,0.45346 4.04882,0.9414 1.91241,1.91192 12.87442,-2.87968 11.53711,-5.04297 -0.34559,-0.55899 -2.23533,-0.41102 -4.19922,0.33008 -2.95317,1.1144 -4.18251,0.99689 -7.11132,-0.68358 -1.6925,-0.9711 -2.86807,-1.40702 -3.94532,-1.36525 z m 76.16209,2.09571 c -3.01039,-0.23521 -4.32774,2.81412 -1.17772,5.42773 0.96672,0.80211 1.75781,3.33705 1.75781,5.63279 0,2.67338 0.91704,5.14828 2.54882,6.88478 2.69832,2.87148 6.17017,3.54743 7.46485,1.45313 0.4278,-0.69201 -0.40008,-2.51081 -1.83985,-4.04297 -1.72742,-1.83824 -2.39347,-3.64172 -1.95899,-5.30273 0.87245,-3.33538 -1.14558,-7.53914 -4.4746,-9.32031 -0.84102,-0.44999 -1.62561,-0.67815 -2.32032,-0.73242 z m 66.88281,0.76171 c -1.98895,-0.0553 -4.42111,0.58772 -5.11328,1.82422 -0.56752,1.01384 -2.30207,2.47575 -3.85547,3.25 -1.55338,0.77426 -2.9988,2.3183 -3.21288,3.42969 -0.667,3.46257 5.29859,2.43597 10.38671,-1.78711 2.52299,-2.09403 4.59573,-4.4661 4.60743,-5.2715 0.0136,-0.93659 -1.26554,-1.40227 -2.81251,-1.4453 z m 45.76954,0.57032 c -0.46676,-0.006 -0.88136,0.20323 -1.3379,0.58203 -2.33286,1.93556 -2.25232,2.45743 1.17188,7.50195 1.61121,2.37365 2.92968,5.76943 2.92968,7.54492 0,1.77548 0.64919,3.87596 1.44141,4.66796 3.05708,3.05632 4.82899,1.02112 4.92579,-5.65625 0.0857,-5.91786 -0.26396,-6.81186 -4.30861,-10.97851 -2.5178,-2.59375 -3.79543,-3.64965 -4.82225,-3.6621 z m 32.30858,3.08008 c -1.50951,0.0845 -3.00793,0.77472 -3.72656,2.11718 -0.71051,1.32724 -2.3294,2.41405 -3.5957,2.41405 -2.57486,0 -3.03798,2.3083 -0.89454,4.45119 3.73462,3.73364 13.43458,-1.2491 12.45704,-6.39845 -0.34175,-1.80026 -2.29944,-2.69261 -4.24024,-2.58397 z m -158.20311,0.0508 c -0.2546,-0.005 -0.51063,0.004 -0.76563,0.0293 -2.75247,0.26923 -3.66591,0.99524 -3.9707,3.15039 -0.32841,2.32238 0.0139,2.69119 2.00781,2.16992 1.33389,-0.34872 3.00785,0.0997 3.76172,1.00781 1.79653,2.1641 4.48951,2.0818 5.35157,-0.16406 1.05883,-2.75862 -2.56583,-6.11369 -6.38477,-6.19336 z m 111.16015,0.0957 c -0.95183,0.0303 -2.05449,0.91997 -2.94923,2.89648 -0.61262,1.35333 -2.60509,2.75703 -4.42577,3.12109 -3.80285,0.76035 -9.58542,6.02071 -8.51759,7.74805 1.05348,1.70408 3.59728,1.41638 5.26759,-0.59572 0.80232,-0.96648 2.42379,-1.75781 3.60351,-1.75781 3.82048,0 8.15422,-2.67544 8.85547,-5.46874 0.91857,-3.65894 -0.24759,-5.9939 -1.83398,-5.94335 z m -154.14647,4.38476 c -2.32038,0 -3.46421,2.29987 -1.91406,3.84961 1.58473,1.58433 1.74016,6.69335 0.20312,6.69335 -0.60646,0 -1.42979,-0.52755 -1.82812,-1.17188 -0.91889,-1.48636 -5.27345,-1.54123 -5.27345,-0.0664 0,0.60777 1.18663,1.94253 2.63674,2.96679 3.12573,2.20786 7.81153,1.91712 9.37499,-0.58203 1.51102,-2.41529 -1.02754,-11.68945 -3.19922,-11.68945 z m 78.61913,1.37695 c -2.27589,-0.0847 -4.7098,0.59549 -5.11719,1.83594 -0.2632,0.80142 0.94195,1.99842 2.67775,2.65819 2.56238,0.97396 3.00279,1.69129 2.34372,3.81446 -0.44641,1.43823 -1.09411,3.80029 -1.43943,5.25001 -0.87007,3.65233 2.33504,3.48342 4.78321,-0.25197 2.34752,-3.58185 2.46326,-10.41118 0.20701,-12.28318 -0.77996,-0.64716 -2.08953,-0.97265 -3.45507,-1.02345 z m -115.61131,0.96486 c -5.03699,0 -0.86466,6.80163 6.45703,10.52537 2.5531,1.29847 5.83092,2.36135 7.28319,2.36135 1.45226,0 3.20472,1.05511 3.89454,2.34374 1.33835,2.50006 2.96055,3.01446 4.03319,1.27928 1.03731,-1.67793 -5.46146,-10.80351 -7.21483,-10.13085 -1.83531,0.70408 -9.893,-2.82094 -11.23243,-4.91406 -0.51538,-0.8054 -1.96374,-1.46483 -3.22069,-1.46483 z m 165.31052,1.17186 c -2.02828,0 -6.79731,6.43497 -5.68163,7.66601 0.20864,0.23024 1.96105,2.27753 3.89452,4.55078 3.98049,4.68007 3.9507,4.66828 6.73829,2.55273 3.06498,-2.32605 2.48329,-4.93342 -1.46484,-6.56836 -3.62278,-1.5002 -4.38732,-2.83889 -2.34376,-4.10155 2.04976,-1.26651 1.25984,-4.09961 -1.14258,-4.09961 z m -175.69333,0.32813 c -0.39036,0.0264 -0.79705,0.10578 -1.22071,0.24022 -2.79661,0.88739 -3.19296,3.88682 -0.64257,4.86525 0.96673,0.37087 1.75781,2.09489 1.75781,3.83008 0,1.73514 0.63286,3.78736 1.40625,4.56054 1.82199,1.82151 2.6887,1.77149 4.36523,-0.24804 0.93803,-1.12999 0.98446,-1.89314 0.14452,-2.41211 -0.67579,-0.41755 -1.2285,-2.50831 -1.2285,-4.6465 0,-3.98164 -1.84955,-6.37402 -4.58203,-6.18944 z m 87.79881,3.21288 c -1.42111,-0.0652 -3.36114,0.57211 -5.4336,1.92969 -2.56276,1.67876 -3.56698,1.74767 -7.07225,0.48046 -3.43071,-1.24022 -4.40101,-1.1994 -6.05274,0.25391 -1.27379,1.12049 -3.35615,1.51699 -5.90625,1.12501 -4.08366,-0.62769 -5.96861,0.7919 -6.0039,4.52149 -0.0146,1.54596 1.24175,1.86945 6.83398,1.75781 3.76834,-0.0753 7.62341,-0.78004 8.56836,-1.56447 1.03351,-0.85795 3.36776,-1.15781 5.85743,-0.75389 5.20106,0.84378 11.53318,-2.15493 11.53318,-5.46288 0,-1.45274 -0.9031,-2.22188 -2.32421,-2.28713 z m -132.01366,2.70121 c -0.92217,0.0676 -1.89807,0.41817 -2.79296,0.93162 l 0,6.44923 c 0.14031,-0.10006 0.28104,-0.20686 0.41992,-0.34569 0.42969,-0.42957 4.07745,-0.68439 8.10546,-0.56446 8.00321,0.23825 10.98687,-0.91188 9.87501,-3.80859 -0.51984,-1.35432 -2.2764,-1.87893 -6.32227,-1.89063 -3.08154,-0.009 -6.6877,-0.30799 -8.01367,-0.66408 -0.40061,-0.10754 -0.83009,-0.13972 -1.27149,-0.1074 z m 297.20701,0.91991 c -2.11294,1.20489 -3.77226,3.34006 -3.15235,4.95509 0.69942,1.8222 1.93791,2.37173 3.15235,1.49021 l 0,-6.4453 z M 418.8226,507.523 c -3.33226,-0.0527 -4.57031,0.75681 -4.57031,2.66211 0,0.94846 2.13214,1.82236 5.56641,2.28127 3.06133,0.40904 7.14664,1.75647 9.08007,2.99413 4.44082,2.84263 4.85041,2.87019 5.80665,0.3789 1.20822,-3.14769 -4.61988,-7.08499 -11.82029,-7.98438 -1.60791,-0.20084 -2.95177,-0.31449 -4.06253,-0.33203 z m -160.50193,1.01171 c -0.48366,0.0235 -0.91852,0.54543 -1.6875,1.58205 -1.57659,2.12531 -3.75502,2.13938 -9.17383,0.0605 -1.19532,-0.45855 -2.4057,0.50994 -3.6543,2.92382 -1.43252,2.76949 -2.6571,3.60939 -5.2578,3.60939 -4.57324,0 -7.09571,1.08653 -7.09571,3.05468 0,1.19729 1.71892,1.63085 6.45313,1.63085 5.34551,0 6.8707,-0.48018 8.89061,-2.80272 1.98238,-2.27945 3.2417,-2.69516 6.73633,-2.22657 3.36519,0.45126 4.7882,0.0337 6.55665,-1.91992 2.14784,-2.37269 2.15837,-2.59502 0.21483,-4.50975 -0.96652,-0.95222 -1.49876,-1.42587 -1.98241,-1.40236 z m 124.34959,4.66213 c -2.80912,0 -3.1645,2.59308 -0.64258,4.68555 1.00939,0.83749 1.75783,3.39134 1.75783,6 0,3.52651 0.45881,4.55378 2.05077,4.59177 1.12786,0.027 3.89665,1.0603 6.15235,2.29494 8.2963,4.54084 9.91923,1.15603 2.17578,-4.53711 -2.71352,-1.99501 -5.78768,-5.65668 -6.97266,-8.30274 -1.47799,-3.3003 -2.84741,-4.73241 -4.52149,-4.73241 z m 87.23828,0.008 c -1.96569,0.008 -3.37545,1.7384 -1.95312,4.2793 0.77359,1.38197 0.44549,3.02954 -1.10547,5.57227 -2.68568,4.40308 -2.74929,5.83532 -0.36914,8.21483 2.20294,2.20238 3.10331,2.28682 4.92773,0.4629 1.02283,-1.02264 1.03717,-1.78644 0.0605,-2.96289 -1.00699,-1.21303 -0.72385,-2.21513 1.20118,-4.26368 2.85355,-3.03668 3.162,-6.26263 0.88478,-9.26172 -1.08679,-1.43129 -2.46709,-2.04581 -3.64649,-2.04101 z m 30.15039,2.37305 c -2.3546,0.0672 -4.11275,0.89072 -5.1543,2.45899 -1.61307,2.42875 -1.76694,2.44251 -5.55078,0.48632 -2.64,-1.36485 -4.27486,-1.62924 -5.08399,-0.82032 -1.84128,1.84081 -0.32791,4.27038 3.98438,6.39454 5.41601,2.66784 9.9955,2.52601 11.53907,-0.35741 0.87195,-1.62887 2.45403,-2.34378 5.18944,-2.34378 5.3516,0 6.36966,-2.93191 1.5957,-4.59568 -2.49514,-0.8696 -4.68816,-1.27495 -6.51952,-1.22266 z m 20.55859,0.19141 c -0.63102,-0.005 -1.25456,0.53434 -1.68946,1.72265 -0.43226,1.18113 -2.01409,3.63768 -3.51562,5.45899 -2.64388,3.20697 -3.57387,7.75469 -1.92383,9.40429 1.4034,1.40303 3.28183,0.0807 3.67383,-2.58593 0.20803,-1.41514 1.68523,-3.42983 3.2832,-4.47656 0.68638,-0.4496 1.20247,-0.88695 1.60157,-1.35156 l 0,-7.16603 c -0.42084,-0.64327 -0.92657,-1.0016 -1.42969,-1.00585 z m -201.45897,0.34369 c -4.45512,-0.0652 -12.00447,1.71402 -14.09962,3.80862 -1.32628,1.32593 -2.05371,2.9899 -1.61521,3.6992 1.077,1.74217 3.12484,1.5668 5.86328,-0.50389 1.25103,-0.94601 3.91838,-1.72072 5.92772,-1.72072 4.41302,0 8.74818,-2.80331 7.03126,-4.54686 -0.48037,-0.48783 -1.62238,-0.7146 -3.10743,-0.73635 z m -97.11131,0.63086 0,7.22071 c 0.90792,-1.04292 1.1589,-2.2346 0.9707,-4.11717 -0.13491,-1.34944 -0.50155,-2.40226 -0.9707,-3.10354 z m 140.70116,1.1387 c -6.1336,0 -8.20771,4.1303 -2.69141,5.35936 12.79704,2.85124 15.92255,9.46849 6.07226,12.85351 -2.98189,1.02472 -3.91262,1.95358 -3.59571,3.59181 0.23518,1.21559 0.55431,4.05543 0.70899,6.31053 0.1547,2.25513 0.35758,4.49528 0.45118,4.97852 0.31492,1.62731 3.4287,0.8954 4.14648,-0.97461 0.39121,-1.01916 0.71094,-3.60281 0.71094,-5.74219 0,-3.26874 0.5615,-4.08567 3.51562,-5.11523 2.41358,-0.84115 3.51562,-2.00173 3.51562,-3.70509 0,-1.36451 0.54897,-3.50884 1.2207,-4.76365 0.68493,-1.27947 0.7974,-3.03848 0.25586,-4.00588 -1.37568,-2.45755 -11.68368,-8.78708 -14.31053,-8.78708 z m 86.63085,0.0214 c -2.30164,-0.0521 -5.09048,1.34508 -7.82422,4.07813 -2.25572,2.25512 -4.70807,4.11013 -5.44922,4.11913 -2.58303,0.0344 -4.35162,1.93891 -3.60546,3.88282 1.28365,3.34428 9.875,1.6008 9.875,-2.0039 0,-2.83355 4.39302,-5.74003 7.49804,-4.96093 3.40741,0.85497 5.02817,-0.99556 3.00586,-3.43166 -0.91311,-1.09994 -2.11904,-1.65233 -3.5,-1.68359 z m -187.97069,1.18751 c -1.04178,0.0301 -1.83398,0.46754 -1.83398,1.35155 0,2.90354 5.08042,6.81056 8.85547,6.81056 2.8376,0 3.91941,0.60562 4.40624,2.46679 0.95499,3.65094 3.67199,2.04202 4.10937,-2.4336 0.45303,-4.63555 -1.33362,-6.10519 -6.31445,-5.19531 -2.46853,0.45095 -4.06905,0.0782 -5.12304,-1.1914 -1.00812,-1.2144 -2.76018,-1.84731 -4.09961,-1.80859 z m 145.72656,0.36328 c -0.48209,-0.0651 -0.87967,0.0966 -1.24416,0.46094 -1.53115,1.53076 2.21646,6.99778 6.40821,9.34765 1.39598,0.78258 3.9824,1.43999 5.74609,1.46289 2.59953,0.0337 3.54404,-0.76863 4.99414,-4.23828 2.2029,-5.27097 1.50846,-6.13932 -2.85156,-3.56443 -4.5384,2.68018 -5.83393,2.52301 -9.68751,-1.16799 -1.52195,-1.45776 -2.56174,-2.19237 -3.36521,-2.30078 z m -62.78711,0.76953 c -3.52655,0 -3.67837,3.4827 -0.28517,6.55273 2.01774,1.82551 2.35857,3.17174 1.87696,7.44336 -0.32338,2.86823 -0.12635,6.42758 0.4375,7.91016 0.62643,1.64724 1.99423,2.69531 3.51758,2.69531 2.37745,0 2.47218,-0.45373 2.07813,-9.83399 -0.45463,-10.8217 -2.4909,-14.76757 -7.625,-14.76757 z m -54.29883,1.166 c -1.52293,0.0514 -3.08484,1.25974 -4.75977,3.61133 -1.96804,2.76314 -2.24465,3.92526 -1.1875,4.97852 1.0558,1.05194 1.91714,0.68738 3.67384,-1.55469 2.24834,-2.86958 2.3218,-2.88161 3.66602,-0.58592 0.75455,1.28862 2.81805,3.79257 4.58397,5.56444 4.83732,4.85365 11.59179,3.86512 11.59179,-1.69727 0,-2.61503 -1.86909,-2.74815 -3.27734,-0.23243 -1.79684,3.20994 -5.3766,1.29586 -8.43945,-4.51366 -1.99803,-3.78981 -3.89352,-5.63649 -5.85156,-5.57032 z m -38.66991,3.99025 c -0.97615,-0.0185 -2.10114,0.37363 -3.99805,1.166 -2.31673,0.96774 -4.21094,2.55475 -4.21094,3.52735 0,1.39757 1.39177,1.71843 6.64062,1.52538 7.44153,-0.27365 9.0996,-2.01886 4.67384,-4.91796 -1.30206,-0.85289 -2.12934,-1.28231 -3.10547,-1.30077 z m 66.63474,0.25584 c -1.1609,0.0556 -2.19335,1.04259 -2.19335,2.75391 0,1.13185 1.39075,3.44783 3.08985,5.14649 3.6792,3.67825 6.17797,3.88715 9.72851,0.80859 1.44719,-1.25481 3.24227,-2.50613 3.98829,-2.77929 1.00389,-0.36754 1.01871,-1.06861 0.0586,-2.69726 -1.70751,-2.89638 -4.42756,-3.33942 -6.67969,-1.08789 -2.42679,2.42616 -3.99093,2.28909 -5.47461,-0.48243 -0.63377,-1.18391 -1.61465,-1.70533 -2.51758,-1.66212 z m 89.13086,6.30275 c -5.18394,0 -9.00391,4.59057 -6.17383,7.41992 1.12943,1.12914 1.43146,1.0346 5.18946,-1.64063 3.96166,-2.82022 4.46634,-5.77929 0.98437,-5.77929 z m 95.05859,2.39843 c -0.61401,-0.0426 -1.55049,0.0698 -2.92579,0.29298 -5.41734,0.87888 -12.375,5.13028 -12.375,7.56249 0,1.02428 0.89032,2.84668 1.97853,4.04883 2.61873,2.8929 5.63866,2.19511 5.63866,-1.30274 0,-1.52464 0.79109,-3.14381 1.75781,-3.59961 5.35026,-2.52259 6.483,-3.39934 6.85743,-5.30468 0.2213,-1.12615 0.0917,-1.62622 -0.93164,-1.69727 z m -51.50781,0.20117 c -0.58555,0.0499 -1.1073,0.26368 -1.51758,0.67383 -1.19495,1.19464 -0.83121,2.00091 1.875,4.1582 2.88934,2.30328 3.17214,3.02137 2.02929,5.15625 -1.05478,1.97037 -0.9513,2.85766 0.50978,4.31837 3.61959,3.61863 8.67918,1.67746 6.53711,-2.50781 -0.59051,-1.15379 -1.53779,-3.66118 -2.10547,-5.57422 -1.05475,-3.55432 -4.79071,-6.44067 -7.32813,-6.22462 z m -222.25584,0.32617 c -1.43269,0.0988 -4.16009,0.99861 -6.39257,1.98244 l 0,7.95897 c 1.11814,-0.66432 2.39778,-1.54299 3.61327,-2.51953 4.48283,-3.60157 5.68443,-6.03625 3.60938,-7.31836 -0.1614,-0.0997 -0.44902,-0.12979 -0.83008,-0.10352 z m 30.42774,0.58985 c -1.25592,0 -1.44304,1.50686 -0.86915,6.99609 0.70772,6.76923 0.63147,7.03433 -2.36132,8.17189 -1.93719,0.73632 -3.09375,2.06126 -3.09375,3.54686 0,1.30459 0.6107,2.37111 1.35546,2.37111 2.58182,0 9.19141,-5.98732 9.19141,-8.32619 0,-4.75064 -2.65059,-12.75976 -4.22265,-12.75976 z m 31.07813,1.26563 c -0.98304,-0.013 -2.39781,1.21399 -3.73049,3.55468 -1.88297,3.30727 -2.44359,3.56363 -6.24022,2.85156 -5.11181,-0.95873 -7.50977,0.75147 -7.50977,5.35743 0,3.64271 3.04287,4.79389 4.26369,1.61328 0.39003,-1.01617 2.14179,-1.75586 4.15428,-1.75586 4.1194,0 10.33009,-5.58202 10.33009,-9.28321 0,-1.56845 -0.50304,-2.32778 -1.26758,-2.33788 z m 133.16013,0.041 c -1.61845,-0.0865 -3.14872,0.396 -4.17383,1.63086 -1.23503,1.48774 -0.88959,1.96647 2.19921,3.04296 2.74299,0.95595 3.66604,1.99085 3.66604,4.10938 0,1.91624 1.18717,3.5511 3.66992,5.06055 3.85849,2.34589 6.87693,2.086 6.87693,-0.5918 0,-0.87488 -1.05477,-2.1541 -2.34374,-2.84375 -1.28898,-0.68968 -2.34375,-2.29066 -2.34375,-3.55663 0,-3.72113 -3.99018,-6.66118 -7.55078,-6.85157 z m 98.9414,0.0781 c -1.93299,0.85029 -3.50586,1.76281 -3.50586,2.29102 0,0.53794 -1.82582,1.74116 -4.0586,2.67382 -4.04868,1.69122 -6.43183,6.12637 -4.75195,8.84376 0.50428,0.81572 2.03849,0.2117 4.30078,-1.69141 1.93461,-1.62743 4.29884,-2.95899 5.25391,-2.95899 0.50055,0 1.53504,-0.47281 2.76172,-1.20313 l 0,-7.95507 z m -279.67966,0.10938 c -0.48867,0.0133 -0.82379,0.71862 -1.41211,2.26561 -1.22869,3.23085 -7.05061,7.95509 -9.80274,7.95509 -0.93167,0 -3.90082,1.59826 -6.59961,3.55274 -0.93045,0.67384 -1.76127,1.36191 -2.50585,2.05078 l 0,8.05664 c 2.32684,-3.47788 6.39515,-6.61517 10.39648,-7.91211 6.14985,-1.99334 10.19601,-5.15248 11.91797,-9.30859 1.28543,-3.1025 1.22872,-3.89278 -0.38477,-5.50586 -0.757,-0.75681 -1.2293,-1.16462 -1.60937,-1.1543 z m 231.97067,2.01952 c -2.09595,0 -1.87609,4.28922 0.26172,5.10938 2.44356,0.93745 2.19365,3.50472 -0.58594,6.01953 -1.28898,1.16622 -2.34374,3.09442 -2.34374,4.28321 0,3.09902 2.0137,2.67082 5.94921,-1.26368 4.2677,-4.26655 4.62627,-9.6591 0.82031,-12.32421 -1.43237,-1.003 -3.27822,-1.82423 -4.10156,-1.82423 z M 300.2816,540.3863 c -2.0306,-0.0918 -4.68814,1.63675 -6.0742,4.31641 -0.91718,1.77314 -2.49273,3.90873 -3.50196,4.7461 -1.00923,0.83737 -1.83593,2.51096 -1.83593,3.7207 0,4.66642 4.92501,1.62032 11.58007,-7.16211 1.91788,-2.53095 2.4125,-4.06037 1.58202,-4.89063 -0.46743,-0.46731 -1.07313,-0.69988 -1.75,-0.73047 z m 92.37304,1.26563 c -1.94048,-0.0915 -3.61037,1.77307 -4.6504,5.39844 -0.58955,2.05515 -2.57218,4.80317 -4.40429,6.10743 -3.19135,2.27183 -4.59666,7.58357 -2.54883,9.63086 1.49155,1.49115 2.51183,0.76264 3.69922,-2.64259 0.65658,-1.88306 2.42084,-4.05516 3.92189,-4.82812 3.74279,-1.9274 9.17381,-7.12033 9.17381,-8.77147 0,-0.74607 -1.0854,-2.33875 -2.4121,-3.53908 -0.95986,-0.86843 -1.89726,-1.31387 -2.7793,-1.35547 z m 17.28514,1.18947 c -0.41702,-0.0627 -0.79186,0.58514 -1.35742,2.07224 -0.61433,1.61546 -1.99148,3.66378 -3.06053,4.55079 -3.31069,2.7469 -4.48695,5.85769 -2.9258,7.73828 1.50526,1.81327 9.31251,2.35507 9.31251,0.64649 0,-0.56918 -1.16517,-1.33848 -2.58984,-1.71094 l -2.5918,-0.67773 2.5918,-2.75782 c 2.73779,-2.91349 3.26643,-6.16317 1.46679,-9.00781 -0.33007,-0.52177 -0.59547,-0.8159 -0.84571,-0.8535 z m -89.06638,1.08983 c -1.51643,-0.0717 -2.71287,0.42494 -3.9961,1.58594 -1.35352,1.22461 -3.80821,2.0297 -5.73633,1.8828 -4.1231,-0.31408 -5.34317,1.29615 -2.86328,3.77539 2.37862,2.37804 5.68951,2.35219 9.39062,-0.0723 2.36831,-1.55138 3.50446,-1.66489 5.87306,-0.58595 3.42617,1.56067 7.51366,1.76287 7.51366,0.3711 0,-1.77483 -5.23204,-5.87753 -8.54296,-6.69923 -0.59129,-0.14673 -1.1332,-0.23391 -1.63867,-0.25779 z m 33.68163,5.83008 c -0.67114,0.0726 -1.42355,0.80195 -2.54297,2.32812 -1.34187,1.82945 -3.02013,2.89577 -3.98046,2.52736 -3.90648,-1.49869 -10.78728,6.54937 -7.99023,9.34568 0.43106,0.43094 1.72711,-0.0694 2.88085,-1.11327 1.15378,-1.04388 3.81461,-2.24885 5.9121,-2.67774 4.6271,-0.94609 9.25011,-7.5476 6.9043,-9.85937 -0.40666,-0.40076 -0.7809,-0.59436 -1.18359,-0.55078 z m 167.49218,2.99414 c -3.80757,3.51466 -5.13827,7.0907 -3.26954,9.34179 1.28202,1.54434 1.60337,1.50144 2.66211,-0.35937 0.18007,-0.31648 0.39768,-0.62753 0.60743,-0.93945 l 0,-8.04297 z m -21.17774,1.02344 c -0.94343,0.0259 -1.72865,0.37795 -2.30664,1.07422 -1.45698,1.7551 -0.5753,4.00971 1.59181,4.07031 2.68884,0.0751 6.94568,4.57859 6.18944,6.54883 -0.4029,1.04964 -0.0863,2.6877 0.70313,3.63867 1.24304,1.49739 1.71627,1.38236 3.53515,-0.86328 2.98918,-3.69051 2.60672,-5.92632 -1.7207,-10.06055 -3.07614,-2.93883 -5.91663,-4.46522 -7.99219,-4.4082 z m -51.02538,2.76173 c -1.17433,0 -1.44311,0.83972 -0.92773,2.89256 0.48583,1.9352 -0.12652,4.27129 -1.84961,7.0586 -1.41654,2.29139 -2.2768,4.94442 -1.91211,5.89453 1.18427,3.08537 4.17643,1.82887 5.99217,-2.51563 2.7551,-6.59218 2.09719,-13.33006 -1.30272,-13.33006 z m -212.5449,1.18163 c -1.36548,0.0482 -2.46732,0.43359 -2.98047,1.26367 -1.17621,1.90266 1.15784,3.65794 6.1543,4.62501 6.57966,1.2735 7.38281,1.2563 7.38281,-0.14649 0,-2.99952 -6.46022,-5.8868 -10.55664,-5.74219 z m 222.16013,0.69139 c -0.43641,-0.008 -0.88903,0.15823 -1.34571,0.53712 -1.20722,1.00166 -1.3151,1.9357 -0.41601,3.61524 0.66665,1.24532 0.88381,3.2982 0.48244,4.56248 -0.40134,1.26433 -0.39546,3.35395 0.0137,4.6426 0.94018,2.96124 2.50065,2.99011 4.06057,0.0762 2.53049,-4.72705 0.25989,-13.37583 -2.79493,-13.43361 z m -154.98827,0.41603 c -3.42171,-0.2065 -8.5703,2.49877 -8.5703,5.5078 0,1.86266 3.69032,2.10414 5.43944,0.35548 0.84742,-0.84721 1.68007,-0.66959 2.72071,0.58397 1.85089,2.2296 4.76038,2.31484 7.625,0.22071 2.85032,-2.08367 1.58476,-5.90528 -1.61914,-4.88865 -1.2379,0.39276 -2.58939,0.16465 -3.00391,-0.50587 -0.50227,-0.81248 -1.45123,-1.20461 -2.5918,-1.27344 z m -17.38865,2.46289 c -0.98208,0.0823 -2.03865,0.65334 -2.9004,1.69141 -0.80231,0.96647 -2.60637,1.75781 -4.00975,1.75781 -4.76021,0 -7.27882,5.8158 -3.95704,9.13671 0.77339,0.7732 1.58446,1.40624 1.80273,1.40624 1.58723,0 12.16616,-11.70713 11.52148,-12.74997 -0.56768,-0.91833 -1.47495,-1.32447 -2.45702,-1.2422 z m 82.09567,0.0781 c -2.78306,-0.0584 -4.26115,0.65496 -6.65038,2.94336 -3.69934,3.54327 -6.24821,10.89101 -5.06835,14.60743 1.18309,3.72665 3.34838,1.91338 4.45311,-3.72852 1.34031,-6.84512 2.39271,-7.9156 8.19531,-8.33788 3.98907,-0.29028 4.88867,-0.78748 4.88867,-2.69922 0,-1.87578 -0.90424,-2.41679 -4.53906,-2.71484 -0.45736,-0.0375 -0.88171,-0.062 -1.2793,-0.0703 z m 117.2168,1.19142 c -0.32766,0.004 -0.67804,0.0276 -1.05665,0.0644 -4.72952,0.46017 -6.06778,4.45899 -1.49219,4.45899 3.0319,0 5.4004,2.83782 5.4004,6.47072 0,1.06631 -2.37325,4.2426 -5.27344,7.06053 -2.90019,2.81795 -5.27149,5.93527 -5.27149,6.92578 0,4.38717 5.12751,1.29107 12.23633,-7.38866 4.96649,-6.06399 5.17253,-8.60226 1.12892,-13.90237 -2.18375,-2.86224 -3.37832,-3.71797 -5.67188,-3.68943 z m -228.74997,1.08984 c -1.82535,-0.14647 -1.7624,0.66333 -1.04298,6.41993 0.96367,7.71093 -0.10185,9.13289 -5.35546,7.15039 -2.91016,-1.09818 -3.75053,-0.92667 -5.87891,1.20117 -3.0767,3.07589 -1.88283,5.42566 2.30859,4.54687 1.71098,-0.35874 3.90045,-0.13331 4.8672,0.5 2.69588,1.7661 4.37425,1.42543 7.03125,-1.42579 3.24991,-3.48748 4.02274,-7.09748 2.78319,-12.99413 -0.81822,-3.89242 -1.59694,-4.97394 -3.81053,-5.28711 -0.3414,-0.0483 -0.64158,-0.0904 -0.90235,-0.11133 z m 166.07224,0.0664 c -1.19205,-0.008 -2.66749,0.0272 -4.48439,0.0957 -8.9392,0.3368 -9.08813,0.39332 -9.45311,3.56445 -0.42242,3.67021 -1.17558,3.92669 -4.38477,1.50001 -2.94115,-2.22395 -5.20508,-2.25158 -5.20508,-0.0645 0,0.95107 1.9777,2.7856 4.39454,4.07616 6.1171,3.26648 10.14817,2.73067 10.625,-1.4121 0.33291,-2.89271 0.83007,-3.22266 4.88282,-3.22266 5.68652,0 8.2207,-0.95679 8.2207,-3.10352 0,-1.00876 -1.01957,-1.41072 -4.59571,-1.43359 z m -109.62303,4.53711 c -0.95019,0 -2.59719,1.71454 -3.6582,3.80859 -3.24792,6.41024 -5.16495,7.90625 -10.13086,7.90625 -4.04322,0 -4.7711,0.43149 -5.93555,3.51563 -0.7901,2.09262 -2.17159,3.51367 -3.41406,3.51367 -3.13143,0 -2.51122,2.70781 1.13672,4.9668 4.33039,2.68159 5.49886,2.09074 5.92967,-3.00586 0.34344,-4.06313 0.59068,-4.30275 4.44727,-4.30275 4.74521,0 9.03486,-3.65472 11.6582,-9.93163 2.13877,-5.11723 2.13269,-6.4707 -0.0332,-6.4707 z m 32.34179,0 c -1.93182,0 -9.36658,7.63882 -10.60548,10.89647 -1.0689,2.81075 -1.56417,3.08165 -3.61131,1.98634 -2.98858,-1.59903 -4.32359,0.9779 -2.38479,4.59961 1.46123,2.72962 6.87931,3.33497 9.1875,1.02734 0.77339,-0.77318 1.40626,-3.04569 1.40626,-5.05078 0,-2.69227 0.91953,-4.32525 3.51564,-6.24414 3.2302,-2.38758 4.89801,-7.21484 2.49218,-7.21484 z m 134.51951,2.29103 c -2.5047,0.0247 -6.60105,1.586 -10.63281,4.3496 -3.44831,2.36366 -8.37909,4.60577 -10.95702,4.98047 -5.4913,0.79813 -5.59471,2.45967 -0.2754,4.42383 4.26178,1.57362 8.74186,0.99161 11.5,-1.49219 1.01747,-0.9163 2.44921,-1.66602 3.18163,-1.66602 2.01496,0 9.61525,-7.0397 9.61525,-8.90626 0,-1.16531 -0.92883,-1.70429 -2.43165,-1.68943 z m -258.33591,2.39647 c -0.20384,0 -0.39093,0.0118 -0.57226,0.0293 l 0,8.67576 c 0.53513,-0.4168 1.06146,-0.91865 1.69531,-1.58005 3.58167,-3.7375 3.04779,-7.12502 -1.12305,-7.12502 z m 299.42771,0.0293 c -1.5493,0.14343 -2.30639,0.92631 -2.54493,2.60546 -0.35295,2.4845 -0.83195,2.61377 -8.32812,2.23633 -7.88023,-0.39679 -11.38085,0.77783 -11.38085,3.81836 0,0.93692 3.312,1.42022 10.416,1.51951 7.82379,0.10937 9.87627,0.0176 11.8379,-1.52147 l 0,-8.65819 z m -88.37305,3.71876 c -0.90447,-0.0633 -1.78387,0.57685 -2.16992,2.05271 -0.43414,1.65974 -1.58883,2.39844 -3.74412,2.39844 -5.02487,0 -7.64845,2.02359 -7.64845,5.89846 0,3.81252 1.26141,4.42988 3.51368,1.71677 0.8023,-0.96648 3.20321,-1.7578 5.33397,-1.7578 4.79022,0 7.79953,-2.82198 7.32812,-6.87305 -0.24577,-2.1123 -1.45038,-3.35422 -2.61328,-3.43553 z m -54.2578,2.28125 c -1.54201,0.0339 -2.97486,0.43131 -4.05663,1.29099 -2.69895,2.14488 -5.769,7.38553 -4.85939,8.29493 1.47836,1.47795 3.50271,0.78324 6.25391,-2.14454 3.32728,-3.54078 5.23642,-3.68274 7.88868,-0.58592 2.54557,2.97234 5.00193,3.01491 5.00193,0.0859 0,-3.86265 -5.60251,-7.0431 -10.2285,-6.9414 z m -145.61131,3.49608 c -0.73034,-0.0461 -1.76168,1.0816 -2.95703,3.39257 -1.00922,1.95109 -3.39522,4.93754 -5.30274,6.63672 -2.46302,2.19399 -3.46875,4.16517 -3.46875,6.80079 0,2.04122 0.33787,4.04891 0.75,4.46093 1.08357,1.08328 2.76563,-0.22145 2.76563,-2.14453 0,-0.90579 1.08278,-2.22549 2.40625,-2.9336 3.47388,-1.85868 6.95984,-8.14443 6.96484,-12.56055 0.003,-2.38631 -0.42787,-3.60618 -1.1582,-3.65233 z m 44.23436,5.79882 c -4.15627,0.096 -5.95144,2.76349 -1.67186,4.71289 1.82192,0.82991 3.67319,3.3126 4.93554,6.61719 1.11115,2.90873 3.00431,6.27219 4.20704,7.47461 2.52544,2.52478 4.64646,2.77488 6.63868,0.7832 1.09008,-1.0898 0.79159,-2.07023 -1.33204,-4.39256 -1.50377,-1.64453 -3.65478,-5.49492 -4.78125,-8.55666 -1.45454,-3.95345 -2.84188,-5.76582 -4.78711,-6.25391 -1.16515,-0.29233 -2.24984,-0.4069 -3.209,-0.38476 z m 73.31641,0.0742 c -2.34457,-0.01 -5.02201,0.78373 -7.1328,2.47265 -1.90211,1.52192 0.24555,4.38672 3.28905,4.38672 1.16048,0 3.72421,1.61144 5.69531,3.58201 3.05847,3.05772 4.31535,3.531 8.58398,3.22267 4.22929,-0.30547 5.0633,-0.78597 5.39257,-3.11133 0.35653,-2.51771 0.0791,-2.68298 -3.27148,-1.94725 -4.38172,0.96214 -7.07813,-0.86598 -7.07813,-4.79689 0,-2.45924 -2.46407,-3.79634 -5.4785,-3.80858 z m -90.13865,1.01757 c -2.91698,0.0518 -6.31308,2.1295 -7.60158,5.51757 -1.71637,4.51331 0.51135,6.13197 3.96875,2.88478 1.50017,-1.40897 2.95761,-2.55965 3.2383,-2.55665 0.2807,0.002 0.53796,2.17987 0.57225,4.83984 0.0464,3.58982 0.75866,5.40066 2.76564,7.02539 5.00235,4.04963 13.24264,1.72559 11.35156,-3.20116 -0.58074,-1.51301 -1.07895,-1.61653 -2.41992,-0.5039 -0.92818,0.77009 -2.76603,1.05943 -4.08595,0.64062 -1.89145,-0.60018 -2.40038,-1.75551 -2.40038,-5.44729 0,-2.5762 -0.54574,-5.70293 -1.21289,-6.94921 -0.84751,-1.58315 -2.4256,-2.28105 -4.17578,-2.24999 z m 203.23434,2.26758 c -1.71931,0.0405 -3.55217,0.30817 -5.43556,0.8125 -4.69072,1.25609 -2.60791,4.40108 3.49221,5.27342 3.00244,0.42938 6.42428,1.34187 7.6035,2.02735 5.94953,3.4585 8.33737,-0.2108 3.36914,-5.17772 -2.0134,-2.01289 -5.2468,-3.02463 -9.02929,-2.93555 z m -142.34374,0.0586 c -1.05395,0 -3.15696,1.33846 -4.67187,2.97267 -2.43093,2.62231 -3.40902,2.89203 -8.33594,2.30076 -6.52714,-0.78331 -11.84077,2.18903 -10.43944,5.83987 0.5755,1.49935 1.47894,1.81602 3.40625,1.19723 1.44225,-0.46304 5.41293,-0.75465 8.8242,-0.64841 5.57184,0.17358 6.55523,-0.18431 9.66796,-3.51563 3.80608,-4.07336 4.58052,-8.14649 1.54884,-8.14649 z m 179.5117,0 c -1.03176,0 -2.4768,1.31889 -3.21093,2.92968 -0.73413,1.61081 -2.00307,2.92774 -2.82032,2.92774 -2.26324,0 -5.16991,3.39484 -5.16991,6.03907 0,1.29631 0.39553,2.15501 0.87892,1.90624 0.48335,-0.24872 2.82056,-1.34001 5.19334,-2.42382 4.93951,-2.25627 5.0857,-2.43463 6.18749,-7.57032 0.65433,-3.04999 0.44417,-3.80859 -1.05859,-3.80859 z m -60.04102,0.0801 c -4.88622,-0.0878 -11.74395,1.25946 -14.55859,3.33986 -1.82871,1.3517 -5.08481,2.4375 -7.30468,2.4375 -2.20291,0 -4.65615,0.78605 -5.45312,1.74609 -1.19841,1.44361 -0.97086,1.93835 1.32031,2.85547 4.49387,1.7989 7.50526,1.43052 13.68359,-1.67185 4.14632,-2.08207 7.73142,-2.92971 12.4004,-2.92971 6.86543,0 8.5105,-1.61539 4.78906,-4.70314 -0.84183,-0.69847 -2.65595,-1.03429 -4.87697,-1.07422 z m -41.66795,0.47659 c -0.45933,-0.058 -0.84406,0.10001 -1.20117,0.457 -0.95226,0.95201 -0.55848,2.09039 1.47461,4.25392 l 2.77734,2.95311 -2.61133,3.52932 c -1.43579,1.94149 -2.29212,4.0472 -1.90233,4.67773 1.19377,1.93107 2.64621,1.29837 5.17772,-2.25586 3.22526,-4.5283 3.05622,-7.78848 -0.5957,-11.43944 -1.38252,-1.38217 -2.35362,-2.07907 -3.11914,-2.17578 z m -64.18555,1.83789 c -0.72732,-0.0216 -1.05724,0.75591 -0.58788,2.23436 0.39887,1.25644 -0.0938,3.86567 -1.09375,5.79883 -2.17941,4.21341 -2.37317,10.80703 -0.37695,12.80274 0.79218,0.79199 2.21432,1.29148 3.16015,1.10937 2.1995,-0.42347 3.16548,-17.94046 1.12501,-20.39845 -0.85529,-1.03025 -1.66089,-1.53005 -2.22658,-1.54685 z m -96.44529,1.21093 c -0.7938,0.0799 -0.85918,0.72013 -0.44727,2.29492 0.4765,1.82165 -0.0642,3.22998 -1.77539,4.61524 -1.45899,1.18111 -2.1029,2.57417 -1.58009,3.41991 1.26073,2.03933 7.80225,1.09165 9.33204,-1.35157 1.6218,-2.59019 -1.24039,-8.26018 -4.48437,-8.88474 -0.43617,-0.084 -0.78033,-0.12039 -1.04492,-0.0937 z m 208.9492,6.68945 c -2.73151,-0.1071 -2.151,2.90157 1.17773,4.64062 1.88929,0.98702 4.80042,1.27048 8.20117,0.79884 6.23163,-0.86426 7.03124,-1.26308 7.03124,-3.50978 0,-1.29831 -1.58327,-1.66876 -6.73826,-1.58006 -3.70581,0.0638 -7.79112,-0.0652 -9.08009,-0.28517 -0.21169,-0.0361 -0.4097,-0.0573 -0.59179,-0.0644 z m -64.06835,0.25 c -0.79989,0.0507 -1.65308,0.83266 -2.15822,2.42384 -0.99082,3.12093 -7.25836,6.93735 -11.40038,6.94335 -3.69414,0.005 -4.38739,2.72332 -1.17188,4.5957 2.7754,1.61608 4.37359,1.55147 8.9668,-0.3672 4.751,-1.98457 7.73242,-5.97171 7.73242,-10.34178 0,-2.1764 -0.94034,-3.31914 -1.96874,-3.25391 z m -33.02149,6.28126 c -0.64816,-0.0151 -1.2478,0.19126 -1.7246,0.66797 -0.96492,0.96469 -0.94769,1.89103 0.0684,3.51756 0.79048,1.26556 1.08871,4.00059 0.69727,6.41213 -0.54606,3.36403 -0.30698,4.20702 1.19726,4.20702 2.64565,0 5.67194,-6.34509 4.75977,-9.97852 -0.68792,-2.7402 -3.05358,-4.78099 -4.99805,-4.82616 z m 71.09764,0.74803 c -1.51079,0 -0.25762,5.46186 2.08204,9.07814 3.12837,4.83533 13.36915,2.83817 13.36915,-2.60743 0,-3.62404 -2.2912,-5.04462 -4.11525,-2.55077 -1.87333,2.56129 -2.53802,2.4623 -6.64453,-0.99219 -1.91481,-1.6108 -4.02652,-2.92775 -4.69141,-2.92775 z m 92.97656,0.13476 c -0.67013,-0.0998 -1.6964,0.6375 -3.11719,2.20704 -1.1665,1.28864 -3.03612,2.34375 -4.15624,2.34375 -2.15697,0 -3.45899,2.24094 -3.45899,5.95312 0,2.81068 1.73243,2.89229 3.74219,0.17774 0.84214,-1.13747 2.97962,-2.70662 4.75196,-3.48828 2.2875,-1.00887 3.22265,-2.27817 3.22265,-4.37499 0,-1.78117 -0.31425,-2.71856 -0.98438,-2.81838 z m -16.7207,0.74611 c -2.72932,0.28859 -16.53006,10.64609 -15.68946,12.00585 0.9314,1.50666 7.69272,-0.29963 8.78907,-2.34765 0.60962,-1.13878 2.40497,-2.39519 3.99023,-2.79298 3.12487,-0.78407 5.14653,-4.93793 3.30078,-6.7832 -0.0759,-0.0759 -0.20867,-0.10126 -0.39062,-0.082 z m -257.19724,1.66209 c -1.91819,-0.0129 -3.15431,0.79092 -5.53515,3.07032 -2.04731,1.96006 -5.03175,3.73859 -6.63282,3.95312 -1.74482,0.23383 -3.85769,1.89737 -5.27343,4.15236 -0.69455,1.10626 -1.27613,1.94403 -1.80664,2.53906 l 0,5.1543 c 1.25395,-0.60014 2.49434,-1.54342 3.71484,-2.84961 2.61,-2.79329 3.78212,-3.36605 4.80468,-2.34375 2.30288,2.30227 3.97292,1.52821 7.19141,-3.33399 3.2988,-4.98352 5.39348,-5.7735 7.75586,-2.92772 1.88531,2.27109 4.57097,2.24825 5.45117,-0.0449 1.00242,-2.61161 -2.79895,-6.2338 -7.45703,-7.10745 -0.85843,-0.161 -1.57349,-0.2574 -2.21289,-0.26172 z m 222.56444,0.97071 c -3.87912,0 -13.9529,9.45108 -12.92579,12.12696 1.07655,2.80469 2.1764,2.41763 6.0996,-2.14454 1.92733,-2.24118 4.58507,-4.08561 5.90626,-4.09961 1.32121,-0.0139 2.99377,-0.617 3.71679,-1.33983 1.99763,-1.99709 0.43032,-4.54298 -2.79686,-4.54298 z M 290.0316,614.0308 c -1.22055,-0.0938 -1.30918,0.63837 -0.75584,3.4043 0.4103,2.05098 0.1827,4.78212 -0.50587,6.06838 -0.68855,1.28623 -0.91576,3.21603 -0.50391,4.28904 0.64589,1.68269 1.06177,1.55074 3.02344,-0.96874 4.51615,-5.80029 4.20573,-11.74857 -0.66405,-12.70508 -0.22203,-0.0436 -0.41938,-0.0745 -0.59377,-0.0879 z m 109.30468,1.12696 c -1.55762,0.0906 -3.78716,1.04337 -5.79296,2.70899 -1.82179,1.51278 -4.7628,3.10467 -6.53517,3.53711 -3.03925,0.74155 -4.1786,2.90975 -2.4414,4.64649 1.67718,1.67674 4.84961,0.60074 10.66406,-3.61328 3.33384,-2.41621 6.07876,-5.05201 6.09765,-5.85743 0.0246,-1.04179 -0.78071,-1.49232 -1.99218,-1.42188 z m 18.12499,1.95703 c -0.91292,-0.0257 -2.18262,0.4567 -3.59373,1.5664 -3.87854,3.05004 -3.88447,3.80346 -0.0703,8.80275 1.68292,2.20584 3.52681,3.72108 4.0996,3.36717 1.40615,-0.86883 1.32762,-6.04813 -0.10546,-6.93359 -0.72409,-0.4474 -0.62673,-1.54336 0.26367,-2.96874 1.45763,-2.33345 0.92779,-3.79115 -0.59376,-3.83399 z m -95.26366,0.4004 c -2.61272,0.0854 -5.20508,1.74588 -5.20508,4.27733 0,0.83761 1.18665,1.54007 2.63673,1.56057 1.4501,0.0205 3.66107,0.81181 4.91211,1.7578 4.57776,3.46154 14.18056,1.21015 11.02928,-2.58593 -0.70806,-0.85295 -2.73997,-1.55079 -4.51562,-1.55079 -1.77562,0 -3.88518,-0.79133 -4.68749,-1.7578 -1.0266,-1.23666 -2.60229,-1.75246 -4.16993,-1.70118 z m 150.72069,1.11522 c -3.04002,0 -3.29984,4.0579 -0.36914,5.75977 1.85933,1.07973 1.73183,1.44994 -1.36133,3.96484 -1.99527,1.6223 -3.06009,3.3401 -2.56641,4.13868 1.11014,1.79578 2.47479,1.72323 6.48047,-0.34767 7.62965,-3.94442 6.08308,-13.51562 -2.18359,-13.51562 z m -210.69724,0.24806 c -1.18259,-0.0484 -2.28592,0.42501 -4.30077,1.38086 -4.37741,2.07667 -5.50555,4.97356 -2.40235,6.16405 0.99073,0.38009 2.85226,-0.25975 4.13673,-1.42188 2.25532,-2.0405 2.50415,-2.02572 7.27929,0.39846 5.04069,2.55895 9.97803,2.50444 11.65234,-0.12696 1.66977,-2.62428 0.88661,-3.39045 -2.89844,-2.83399 -2.42069,0.35588 -5.58621,-0.30209 -8.68555,-1.80663 -2.33614,-1.13408 -3.59863,-1.70549 -4.78125,-1.75391 z m 252.35349,4.82616 c -0.25396,-0.003 -0.47521,0.0465 -0.64649,0.15235 -1.94857,1.20398 -1.46156,5.07491 0.80469,6.39453 2.46821,1.43723 4.91744,1.56488 7.31446,0.41015 l 0,-5.16406 c -1.54106,1.74171 -2.64661,1.41347 -4.80469,-0.53906 -0.85348,-0.77223 -1.90608,-1.24473 -2.66797,-1.25391 z m -203.31054,1.32424 c -0.88956,-0.073 -2.06402,1.17883 -2.95508,3.80076 -2.012,5.92039 -3.53893,6.91367 -8.09763,5.26564 -2.13993,-0.77363 -4.7661,-1.40628 -5.83594,-1.40628 -2.10041,0 -3.89895,4.88733 -2.58205,7.0176 0.57898,0.93652 1.25815,0.91728 2.45313,-0.0742 1.26566,-1.05016 2.48667,-1.02669 5.22071,0.10548 6.37187,2.63864 12.25172,-2.12415 13.04101,-10.56445 0.25011,-2.67452 -0.35457,-4.07154 -1.24415,-4.14453 z m 62.84181,1.04492 c -0.92506,-0.11513 -0.90036,1.24341 -0.42384,4.22265 0.5058,3.16227 0.30744,5.58774 -0.53905,6.6074 -0.73559,0.88613 -1.00416,2.93555 -0.59767,4.5547 1.0603,4.2235 2.48585,3.65369 5.27736,-2.11133 2.98275,-6.15993 3.0565,-8.11657 0.39648,-10.40039 -2.10008,-1.80304 -3.3938,-2.7835 -4.11328,-2.87303 z m 118.90038,0.0684 c -0.74795,-0.0394 -1.43228,0.21574 -2.07618,0.75 -2.5588,2.12307 -2.05839,4.63863 0.85938,4.31835 1.91352,-0.21002 3.74665,1.42159 7.41016,6.59766 2.6771,3.78238 6.14708,7.58509 7.71093,8.45117 3.37248,1.86778 10.45898,2.17203 10.45898,0.44922 0,-0.66456 -0.92292,-1.50486 -2.05078,-1.86718 -7.16441,-2.30166 -9.0339,-3.70224 -13.28125,-9.95509 -3.97657,-5.85424 -6.78738,-8.62585 -9.03124,-8.74413 z m -137.0996,0.81443 c -0.83206,-0.0581 -1.41602,1.48099 -1.41602,4.49026 0,2.53924 -0.52738,4.94356 -1.17187,5.34176 -1.52679,0.94339 -1.49751,4.81778 0.0586,7.72464 1.483,2.77027 3.45703,1.87906 3.45703,-1.56054 0,-1.36596 0.57453,-4.10334 1.27736,-6.08205 0.90987,-2.56138 0.91842,-4.5247 0.0293,-6.81836 -0.79025,-2.0385 -1.58724,-3.05047 -2.23439,-3.09571 z m 91.64062,2.09378 c -0.77316,-0.0504 -1.62346,1.00551 -2.20899,3.33788 -1.16391,4.6362 -2.80114,6.15819 -6.62306,6.15819 -3.62302,0 -4.22279,1.02196 -1.93943,3.30468 0.78745,0.78727 2.23776,1.0766 3.22265,0.64259 0.98486,-0.43402 2.87183,-0.8774 4.19335,-0.98437 4.15967,-0.33649 5.21485,-1.77789 5.21485,-7.13281 0,-3.36653 -0.86534,-5.26137 -1.85937,-5.32616 z m -167.88281,3.98436 c -1.04904,-0.0222 -2.28201,1.14578 -5.00974,4.21875 -3.02495,3.40779 -4.53322,6.22824 -4.53322,8.47266 0,1.85007 0.39555,3.3434 0.87892,3.32033 1.74481,-0.0836 6.97932,-5.31887 9.47264,-9.47462 2.34026,-3.90061 2.39086,-4.37566 0.63088,-5.83594 -0.52394,-0.43472 -0.96261,-0.6911 -1.43948,-0.70118 z m -24.62302,0.9668 c -2.51682,-0.0232 -4.0676,0.91606 -7.3047,4.07617 -4.28876,4.18678 -4.64747,4.31494 -7.75392,2.75975 -1.79143,-0.89683 -3.65334,-1.82312 -4.13671,-2.05858 -2.1344,-1.03967 -0.61833,3.33202 1.72461,4.97264 4.05329,2.8383 8.27001,2.2457 12.04297,-1.6914 2.44385,-2.55016 4.45671,-3.51367 7.33595,-3.51367 3.1458,0 3.88806,-0.42545 3.58008,-2.05077 -0.25982,-1.37123 -1.6969,-2.17638 -4.3418,-2.42969 -0.40667,-0.0389 -0.78695,-0.0611 -1.14648,-0.0646 z m 228.63278,1.02931 c -4.14235,0 -3.87963,1.5899 1.1035,6.666 5.43009,5.53142 7.98439,6.367 7.98439,2.61523 0,-3.05223 -6.0991,-9.28123 -9.08789,-9.28123 z M 334.1898,638.5289 c -1.79142,0.0454 -3.24722,0.42159 -3.72069,1.1875 -0.39833,0.64433 -1.90728,1.17188 -3.35158,1.17188 -4.69525,0 -7.17746,4.82136 -4.07812,7.91992 1.75918,1.75872 3.32813,0.75435 3.32813,-2.13087 0,-2.67143 0.40256,-2.76312 3.60156,-0.81054 2.04387,1.24755 2.65274,1.12533 4.10547,-0.83398 1.50738,-2.03304 2.1387,-2.13648 5.44531,-0.88867 5.13015,1.9359 7.28944,-0.17372 3.41602,-3.3379 -1.84405,-1.5064 -5.76039,-2.35304 -8.7461,-2.27734 z m 129.53319,0.19335 c -0.66113,0.0125 -1.40668,0.18707 -2.33008,0.51174 -4.06442,1.42899 -5.33526,5.84725 -1.38476,4.81445 1.917,-0.50117 3.25152,0.0931 4.88867,2.17382 1.91471,2.43355 2.62446,2.66056 4.74609,1.52538 2.10119,-1.12422 2.7585,-0.9376 4.16211,1.1758 2.12038,3.1926 4.89648,3.24179 4.89648,0.0879 0,-4.44676 -2.19916,-6.95116 -6.10155,-6.95116 -2.02116,0 -4.65542,-0.88671 -5.85352,-1.97072 -1.05572,-0.95514 -1.92153,-1.38802 -3.02344,-1.36717 z m -65.68358,0.91992 c -2.76647,0.0423 -2.48628,2.82456 1.89063,6.88477 2.5891,2.40178 5.00276,5.92201 5.4375,7.92969 0.58533,2.70322 2.01951,4.24528 5.71092,6.13477 5.93595,3.03841 5.99822,3.04325 7.9668,0.67186 1.32883,-1.60071 1.22705,-2.1303 -0.66797,-3.51561 -1.2267,-0.89675 -2.9274,-1.6289 -3.7793,-1.6289 -0.85188,0 -2.93255,-2.92455 -4.625,-6.49806 -1.93596,-4.08777 -4.2984,-7.12964 -6.37109,-8.20116 -2.41773,-1.24995 -4.30501,-1.79659 -5.56249,-1.77736 z m 24.17577,2.04101 c -3.60551,0.0417 -4.01157,2.49963 -0.28514,3.91604 3.07501,1.16882 3.15759,1.4263 2.42382,7.66798 -0.44729,3.80467 -0.25501,7.40383 0.46874,8.75585 1.42066,2.6538 7.00586,3.18329 7.00586,0.66405 0,-0.89754 -0.73261,-1.91396 -1.6289,-2.25781 -1.24626,-0.4781 -1.49011,-2.37579 -1.03321,-8.06641 0.6647,-8.2783 -0.4702,-10.23475 -6.18748,-10.6543 -0.26856,-0.0197 -0.52332,-0.0282 -0.76369,-0.0254 z m -36,0.37696 c -0.65076,0 -0.75853,5.82137 -0.20312,11.04688 0.0637,0.59929 2.56306,3.367 5.55273,6.1504 5.95577,5.54484 7.16443,6.0068 8.25783,3.15821 0.49398,-1.287 -0.83015,-3.34274 -4.09376,-6.35548 -2.65309,-2.44913 -5.1797,-5.94143 -5.61523,-7.76171 -0.83356,-3.48374 -2.55501,-6.2383 -3.89845,-6.2383 z m -90.63866,5.9297 c -1.8025,0.0318 -3.59939,0.55457 -5.01758,1.59375 -1.33646,0.97934 -3.60464,1.40242 -5.49803,1.02539 -2.43545,-0.48495 -3.22266,-0.18587 -3.22266,1.2246 0,1.02646 1.45032,2.65398 3.22266,3.61525 4.12409,2.23675 5.524,2.25253 7.32422,0.084 1.88891,-2.27535 4.56377,-2.23205 7.15818,0.11523 4.19944,3.79945 6.29994,-1.30464 2.2168,-5.38671 -1.53951,-1.53912 -3.86609,-2.31234 -6.18359,-2.27148 z m 14.25195,0.29687 c -1.10041,-0.085 -1.30527,1.32675 -0.33985,4.04689 0.92831,2.61543 0.72181,3.53744 -1.13865,5.05859 -1.25927,1.02956 -1.90126,2.46932 -1.43556,3.22265 1.22209,1.97687 8.36394,1.66937 10.11132,-0.43555 1.76899,-2.13094 0.16783,-5.87776 -4.30857,-10.08203 -1.24601,-1.17025 -2.22845,-1.75952 -2.88869,-1.81055 z m -53.81052,0.80274 c -2.39374,0 -3.17613,2.8359 -1.13087,4.0996 1.83289,1.13249 1.37282,5.2715 -0.58594,5.2715 -0.96675,0 -1.75781,0.79132 -1.75781,1.7578 0,2.12565 4.77523,2.37269 6.79686,0.35156 3.14796,-3.14713 0.73641,-11.48046 -3.32224,-11.48046 z m -31.56837,0.70704 c -0.58182,-0.0298 -1.40309,0.3147 -2.40234,0.94725 l 0,5.58008 c 1.95484,-1.9678 3.54492,-4.08497 3.54492,-4.73242 0,-1.1612 -0.39139,-1.75643 -1.14258,-1.79491 z m 17.77539,0.74804 c -0.79453,-0.0866 -1.39844,1.12713 -1.39844,3.68946 0,2.29323 -1.05328,5.89624 -2.33984,8.00585 -2.62164,4.29875 -2.91983,7.02091 -1.13477,10.35546 1.90564,3.5598 3.47461,2.66244 3.47461,-1.98828 0,-2.34015 1.11896,-6.06623 2.48828,-8.28126 1.98213,-3.20635 2.27721,-4.769 1.44726,-7.66211 -0.75875,-2.64494 -1.74257,-4.03256 -2.5371,-4.11912 z m 279.82224,0.18553 c -1.15449,0.72777 -2.55559,1.85833 -4.22852,3.46095 -4.58205,4.38953 -5.32591,5.69934 -4.68359,8.25781 0.94862,3.77868 2.78967,3.91352 4.16211,0.30469 0.57239,-1.50509 2.66859,-4.36443 4.6582,-6.35351 0.0326,-0.0326 0.0596,-0.0651 0.0918,-0.0977 l 0,-5.57227 z m -176.22459,2.15223 c -3.36962,0.11531 -6.97191,0.70036 -8.46094,1.67576 -3.41537,2.23726 -3.46145,3.18769 -0.35937,7.54298 2.79583,3.92541 4.59764,3.49356 4.59764,-1.10351 0,-2.9804 0.28577,-3.15785 4.46095,-2.75978 4.43899,0.42322 8.24273,-1.92264 6.82812,-4.21092 -0.55966,-0.90529 -3.69678,-1.25984 -7.0664,-1.14453 z m 151.11326,0.40625 c -0.66031,0.0286 -1.53665,0.73687 -2.51171,2.2246 -1.13936,1.73845 -3.2896,3.62395 -4.77735,4.18944 -1.9973,0.7592 -2.90586,2.28781 -3.47461,5.84377 -0.5876,3.67369 -1.21767,4.68851 -2.65625,4.27929 -1.03725,-0.29509 -2.64577,-0.73109 -3.57422,-0.9707 -3.24923,-0.83862 -2.64983,3.46259 0.73828,5.29882 6.44588,3.49346 9.73829,1.71178 9.73829,-5.26952 0,-3.71658 0.47941,-4.50303 3.3457,-5.50196 2.46959,-0.86068 3.5459,-2.17556 4.11524,-5.02148 0.65587,-3.27845 0.15714,-5.11996 -0.94337,-5.07226 z m -34.625,1.0078 c -0.95885,-0.0456 -1.87029,0.25949 -3.16407,0.89455 -4.17758,2.05057 -6.01732,5.1179 -4.17578,6.95897 1.09976,1.09948 1.92833,0.94218 3.75978,-0.71483 1.9235,-1.74031 2.67179,-1.85743 4.1289,-0.64846 2.41012,1.99972 2.239,4.27015 -0.67774,8.98829 -1.35164,2.18645 -2.14572,4.78984 -1.76367,5.78515 0.0894,0.23325 0.23139,0.43735 0.40235,0.6211 l 4.69142,0 c 1.06071,-0.92737 1.93652,-2.74203 3.08787,-6.15819 2.71845,-8.06599 1.94001,-12.04648 -2.83984,-14.51759 -1.48361,-0.76702 -2.49038,-1.16343 -3.44922,-1.20899 z m -191.6406,0.67383 c -1.0977,-0.088 -1.72069,0.39174 -1.72069,1.48632 0,0.83004 2.40233,3.51588 5.33984,5.97072 4.49857,3.75934 5.23833,4.95366 4.68945,7.57032 -0.6299,3.00282 -0.13723,4.57282 2.17968,6.18358 l 7.625,0 c -0.26922,-0.87916 -1.19569,-1.92345 -2.29883,-2.51367 -1.91289,-1.02349 -2.24445,-2.02089 -1.67772,-5.04103 0.64765,-3.4514 0.19747,-4.17813 -5.39062,-8.72265 -3.7707,-3.06651 -6.91661,-4.78695 -8.74611,-4.93359 z m 105.27928,2.38868 c -1.57165,0.0529 -2.80965,0.73817 -3.22265,2.03906 -1.08408,3.41475 0.0574,9.50564 2.23046,11.90625 1.10956,1.22571 2.75787,1.94333 3.66406,1.5957 2.1688,-0.83204 2.1066,-4.39965 -0.10937,-6.2383 -2.72198,-2.25843 -2.09369,-3.5156 1.75781,-3.5156 4.16767,0 4.5087,-1.51336 0.91015,-4.03321 -1.75359,-1.22793 -3.65879,-1.80682 -5.23046,-1.7539 z m -10.25976,4.61719 c -1.03177,0 -2.42491,1.20747 -3.09766,2.68359 -0.67274,1.47613 -2.37102,3.18872 -3.77342,3.80663 -1.66557,0.73388 -2.78364,2.54632 -3.22268,5.22461 -0.14293,0.87204 -0.33341,1.69401 -0.54492,2.49024 l 4.16017,0 c 0.16188,-1.92694 0.95332,-2.92435 2.78124,-3.61916 3.3227,-1.26294 3.68454,-1.77654 4.75781,-6.77928 0.65433,-3.05002 0.44222,-3.80663 -1.06054,-3.80663 z m 82.55272,0.50976 c -0.74747,0.0448 -1.63486,0.39604 -2.58985,1.09179 -1.48032,1.07847 -5.19647,3.57593 -8.25781,5.55078 -5.44231,3.51087 -6.31021,4.59839 -4.84179,6.0664 2.46411,2.46349 17.0414,-4.88586 17.83204,-8.99022 0.4693,-2.43633 -0.49813,-3.81729 -2.14259,-3.71875 z m -45.63867,4.23827 c -1.37051,-0.007 -2.7244,0.67038 -3.54492,2.20313 -0.66716,1.24626 -1.21289,3.93818 -1.21289,5.98244 0,0.49633 -0.0127,0.90368 -0.0351,1.27147 l 4.70704,0 c 0.003,-0.10537 0.0156,-0.20304 0.0156,-0.31054 0,-2.97663 0.35614,-3.39631 2.34375,-2.76563 1.77247,0.56241 2.34374,0.20919 2.34374,-1.44531 0,-3.01255 -2.33299,-4.92371 -4.61718,-4.93556 z m 119.40234,0.29101 c -0.76909,0.0195 -1.64044,0.85957 -2.30664,2.61134 -1.03047,2.70961 -1.65442,3.04188 -4.40233,2.33984 -1.7606,-0.44976 -4.78139,-0.90533 -6.71486,-1.0117 -2.85609,-0.15704 -3.58905,0.3166 -3.90234,2.52731 -0.11831,0.83479 -0.12102,1.81616 -0.0449,2.69924 l 3.37696,0 c 0.08,-1.05904 0.68754,-1.26869 2.03319,-0.69336 0.65606,0.2805 1.30566,0.50143 1.94922,0.69336 l 7.98438,0 c 0.79089,-0.31373 1.49561,-0.72446 2.06836,-1.24609 l 0,-7.91407 c -0.0139,-1.9e-4 -0.027,-0.006 -0.041,-0.006 z m -299.95895,0.002 0,7.93359 c 1.1256,-1.01641 1.7871,-2.41315 1.7871,-4.12693 0,-2.48304 -0.80807,-3.81161 -1.7871,-3.80666 z m 41.66795,0.92578 c -0.94135,0.0982 -1.95709,1.06469 -2.78123,2.87307 -0.67344,1.47762 -1.09648,3.4927 -1.25781,5.36521 l 14.59766,0 c -0.33646,-0.42982 -1.32918,-0.89463 -3.19923,-1.67578 -2.33382,-0.97489 -4.59369,-2.8752 -5.02149,-4.22265 -0.52926,-1.66719 -1.39651,-2.43804 -2.3379,-2.33985 z m 52.08203,0.36524 c -3.82614,-0.0558 -8.73501,0.81198 -11.18945,2.47265 -1.88868,1.27787 -4.48588,2.61052 -5.77147,2.96095 -1.23678,0.33711 -2.40298,1.41588 -2.67189,2.43944 l 12.57812,0 c 0.0137,-0.0558 0.0295,-0.0965 0.043,-0.1543 0.58967,-2.51989 1.48465,-3.00277 6.49608,-3.5078 4.12495,-0.4157 5.81249,-1.09667 5.81249,-2.34376 0,-1.22153 -2.32098,-1.82376 -5.29685,-1.86718 z m 20.18555,0.46875 c -0.4181,-0.0335 -0.71045,0.0384 -0.83398,0.23828 -1.21515,1.96561 0.44128,5.35531 3.39453,7.16601 l 9.74413,0 c -1.12103,-2.29279 -9.50886,-7.18006 -12.30468,-7.40429 z m 83.55273,4.85546 c -2.73,-0.0433 -5.28416,0.89332 -6.14257,2.54883 l 12.69725,0 c -0.28548,-0.281 -0.57516,-0.54208 -0.86524,-0.76172 -1.57635,-1.19361 -3.67769,-1.75516 -5.68944,-1.78711 z"
       id="use4153" />
  </g>
</svg>
`, kT = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (http://www.inkscape.org/) -->
<!-- ClipArt by Arvin61r58 (http://openclipart.org/user-detail/Arvin61r58) -->

<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   version="1.1"
   id="svg2"
   viewBox="0 0 299.99999 299.99999"
   height="{{pk_dimension}}"
   width="{{pk_dimension}}">
  <title
     id="title4142">Psychedelic Zebra</title>
  <defs
     id="defs4">
     {{pk_gradient}}
  </defs>
  <metadata
     id="metadata7">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title>Psychedelic Zebra</dc:title>
        <dc:creator>
          <cc:Agent>
            <dc:title>Arvin61r58</dc:title>
          </cc:Agent>
        </dc:creator>
        <dc:publisher>
          <cc:Agent>
            <dc:title>Openclipart.org</dc:title>
          </cc:Agent>
        </dc:publisher>
        <dc:identifier>https://openclipart.org/</dc:identifier>
        <dc:source>https://openclipart.org/user-detail/Arvin61r58</dc:source>
        <dc:description>seamless black &amp; white  psychedelic pattern</dc:description>
        <dc:subject>
          <rdf:Bag>
            <rdf:li>sealless pattern</rdf:li>
            <rdf:li>tile</rdf:li>
            <rdf:li>pattern</rdf:li>
            <rdf:li>psychedelic</rdf:li>
            <rdf:li>black and white</rdf:li>
          </rdf:Bag>
        </dc:subject>
      </cc:Work>
    </rdf:RDF>
  </metadata>
  <g
     transform="translate(-222.04724,-376.18109)"
     id="layer1">
    <path
       id="path4668"
       d="m 226.80974,376.1811 c -0.19506,4.16471 0.65645,8.44453 2.025,8.44453 0.79074,0 1.91696,-2.34376 2.50313,-5.21016 0.21132,-1.03333 0.6051,-2.15444 1.10156,-3.23437 l -5.62969,0 z m 10.77656,0 c -3.41374,4.0036 -5.75698,10.92058 -4.33124,14.58751 1.04336,2.68346 1.28875,2.62809 4.07812,-0.89531 1.63207,-2.06159 3.93657,-4.92723 5.12109,-6.37033 5.5297,-6.73694 18.19728,0.19206 24.15937,13.21642 1.99307,4.3539 4.03405,11.3778 4.53516,15.60937 1.17552,9.92643 3.8413,7.71353 4.00078,-3.32109 0.18829,-13.02668 -8.1993,-26.4556 -17.88047,-32.82657 l -19.68281,0 z m 25.42969,0 c 4.16404,3.88839 8.48394,8.8843 10.2375,12.19454 1.71586,3.23907 2.0641,3.37531 2.55938,1.00547 0.72513,-3.46977 -1.63601,-8.49226 -5.53594,-13.20001 l -7.26094,0 z m 12.06797,0 c 0.65604,1.73689 1.50436,3.7693 2.53594,5.95079 3.7088,7.8431 4.9604,9.24141 8.27813,9.24141 5.39152,0 20.20547,14.53879 20.20547,19.83046 0,2.08547 -1.00352,4.6247 -2.23126,5.64375 -1.22773,1.01904 -1.86282,2.45162 -1.41094,3.18282 1.10075,1.78122 9.15817,1.69261 12.57891,-0.13829 1.50816,-0.80724 3.4495,-3.49862 4.31485,-5.98124 1.35518,-3.88786 1.07972,-5.0994 -1.98516,-8.7422 -1.95711,-2.32614 -6.64213,-6.1792 -10.41094,-8.56171 -3.76881,-2.38249 -6.85312,-5.27514 -6.85312,-6.42656 0,-3.66123 -4.61293,-10.07308 -9.80859,-13.6336 -0.18041,-0.12364 -0.37725,-0.244 -0.56719,-0.36563 l -14.6461,0 z m 23.67422,0 c 1.90487,1.41899 3.90791,2.93272 6.11485,4.64063 2.45789,1.90214 4.3847,2.5158 4.96171,1.58203 1.63133,-2.63983 7.33628,-1.56167 12.00938,2.26875 4.82184,3.95233 7.22983,4.07784 7.94061,0.41485 0.26581,-1.36985 -1.38954,-3.04905 -4.12263,-4.18126 -2.51181,-1.04054 -4.56798,-2.50016 -4.56798,-3.24374 0,-0.74362 1.70977,-0.23332 3.79688,1.13437 4.60448,3.0173 6.63252,1.65037 3.19218,-2.15156 -0.13189,-0.14577 -0.26022,-0.30399 -0.38671,-0.46407 l -28.93829,0 z m 36.43126,0 c -0.57277,2.13558 -0.65418,4.42926 -0.34454,7.13907 0.67569,5.91312 3.14282,5.4087 4.43438,-0.90704 0.42049,-2.05616 1.57424,-4.46788 2.88046,-6.23203 l -6.9703,0 z m 14.44218,0 c 0.77643,1.29455 1.10852,1.4055 1.27266,0 l -1.27266,0 z m 4.74141,0 c 0.49002,6.10122 2.02299,11.3304 4.3875,14.33673 4.59851,5.84669 5.97875,4.61744 2.82656,-2.5172 -1.73815,-3.9341 -2.91368,-7.89836 -3.53438,-11.81953 l -3.67968,0 z m 7.67108,0 c 1.7248,8.80875 5.37131,17.0806 9.63047,19.56094 5.08077,2.95888 6.98273,0.73465 2.53126,-2.96015 -3.81474,-3.16634 -6.6093,-9.40439 -7.97343,-16.60079 l -4.1883,0 z m 7.1836,0 c 0.4105,2.0803 0.96127,4.01647 1.70156,5.64141 2.2219,4.87722 4.69339,4.48344 3.57188,-0.56954 -0.39867,-1.7963 -0.71123,-3.46099 -0.98438,-5.07187 l -4.28906,0 z m 9.09845,0 c -0.10765,3.56578 0.26047,6.98347 1.17187,9.74532 0.98861,2.99594 4.53479,7.7572 7.96874,10.69688 6.3107,5.40225 9.00382,5.9675 9.76407,2.05077 0.24801,-1.27754 -1.82796,-3.27253 -4.95702,-4.76484 -5.93454,-2.83032 -9.56832,-9.50222 -9.70079,-17.72813 l -4.24687,0 z m 6.47812,0 c -0.32869,6.83358 2.18879,12.59917 7.42265,16.02891 5.52105,3.61793 6.41793,1.64442 1.76484,-3.88594 -3.04896,-3.62393 -4.4629,-7.6681 -4.27734,-12.14297 l -4.91015,0 z m 7.01484,0 c -0.0907,3.21533 0.55618,6.42816 2.05078,9.31876 3.31727,6.41555 5.3403,4.02222 4.29844,-5.08594 -0.19095,-1.66919 -0.30884,-3.04077 -0.32813,-4.23282 l -6.02109,0 z m 10.54218,0 c 0.97673,2.71065 4.17473,2.44655 7.08047,0 l -7.08047,0 z m 23.21017,0 c 0.80928,0.11789 1.71212,0.19923 2.80311,0.19923 0.83774,0 1.6174,-0.082 2.36953,-0.19923 l -5.17264,0 z m 26.58515,0 c -1.20665,3.13044 -2.67402,3.99552 -5.50781,5.40937 -5.66796,2.82784 -11.20935,2.84116 -16.11328,0.0375 -4.94135,-2.82489 -15.54161,-2.81625 -21.01875,0.0164 -5.25924,2.71995 -7.46484,6.45083 -7.46484,12.62812 0,3.83781 0.58529,4.59845 3.55546,4.59845 1.95662,0 6.51113,-1.29248 10.12032,-2.87109 8.9109,-3.89751 13.19351,-4.16253 18.85545,-1.1672 2.63892,1.396 7.36249,2.54973 10.49533,2.56173 3.13308,0.0126 6.70847,0.67717 7.94531,1.47656 3.06923,1.98371 2.89681,2.04794 7.61953,-2.89453 l 4.2,-4.39453 -0.72656,-15.40079 -11.96016,0 z m 17.41642,0 c 0.41514,2.63517 0.90019,5.1681 1.44843,7.3711 3.18432,12.79547 2.55475,18.51131 -2.23829,20.35078 -3.45696,1.32668 -1.43115,3.80715 5.78674,7.08516 7.71179,3.5023 7.39627,3.51007 10.81639,-0.26954 3.76656,-4.16247 2.98194,-9.01891 -3.26719,-20.21953 -1.88885,-3.38533 -4.17601,-8.93308 -6.00234,-14.31797 l -6.54374,0 z m 15.46406,0 c 2.00748,2.10371 2.91708,2.0392 2.53593,0 l -2.53593,0 z m 8.2664,0 c 1.10416,1.52506 2.11985,2.67011 2.80313,3.06797 5.08067,2.95888 6.98276,0.73463 2.53124,-2.96015 -0.0409,-0.034 -0.0788,-0.0734 -0.11952,-0.10782 l -5.21484,0 z m 14.7,0 c 1.25529,1.57025 2.71705,3.05275 4.40156,4.44141 5.97492,4.92549 8.52089,5.35485 9.25782,1.55859 0.24792,-1.27754 -1.82791,-3.27253 -4.95704,-4.76484 -0.74143,-0.35361 -1.44482,-0.76722 -2.11172,-1.23516 l -6.59062,0 z m 9.34219,0 c 3.70875,2.57655 5.21983,2.40441 4.08516,0 l -4.08516,0 z m -170.16563,1.02657 c -0.3439,-0.0311 -0.85548,0.2634 -1.59141,0.87422 -2.81306,2.33489 -5.61757,12.5401 -4.34298,15.80391 0.95753,2.4519 1.45328,2.26785 4.75783,-1.7625 2.61431,-3.1885 3.43531,-5.58825 2.82187,-8.24533 -0.47594,-2.06158 -0.95028,-4.58152 -1.05469,-5.59921 -0.0701,-0.6836 -0.24671,-1.04004 -0.59062,-1.07109 z m 133.66641,0.67266 c -1.66092,0 3.97915,9.60118 10.62187,18.08437 6.81768,8.70648 8.23793,14.61533 4.29844,17.88516 -1.22772,1.01906 -1.86274,2.45161 -1.41094,3.18281 1.10076,1.78121 9.1582,1.69263 12.57892,-0.13828 1.50815,-0.80723 3.4806,-3.59245 4.38515,-6.1875 1.54391,-4.4291 1.29132,-5.04996 -4.125,-10.15079 -10.07688,-9.48979 -25.39876,-22.67577 -26.34844,-22.67577 z m -52.09688,6.0328 c 7.5888,-0.0547 4.42786,2.34747 -5.71406,4.34298 -6.00024,1.18063 -9.68704,2.7706 -10.89142,4.69922 -1.84793,2.95939 -5.59686,4.01899 -5.59686,1.58203 0,-5.47721 10.58309,-10.54035 22.20234,-10.62423 z m -126.30468,0.18984 c -0.72728,-0.0598 -0.38806,0.70678 0.19686,2.23126 0.51849,1.35127 6.55411,5.04897 13.41094,8.2172 13.87368,6.41033 15.99697,9.56031 12.66329,18.78046 -0.99708,2.75693 -1.44761,5.59951 -1.00313,6.31875 0.44446,0.71923 -0.52661,2.51642 -2.15626,3.9914 -1.62964,1.47496 -2.96357,3.75656 -2.96718,5.07188 -0.01,4.02282 -5.50128,11.67806 -10.4789,14.60858 -2.59375,1.52705 -6.04192,4.92005 -7.66406,7.53986 -1.62216,2.61979 -6.51806,7.13348 -10.87969,10.0289 -4.36168,2.89538 -8.85786,6.38009 -9.99142,7.74609 -1.13355,1.36601 -5.12954,3.98115 -8.88046,5.81015 -11.60221,5.65737 -33.58037,19.89721 -38.20781,24.75469 -2.42177,2.54217 -5.62783,4.62187 -7.12266,4.62187 -1.92458,0 -2.7164,1.13226 -2.7164,3.88126 0,1.96883 -1.80528,4.93874 -4.60079,8.12812 l 0,9.6 c 9.60274,-5.88252 16.22072,-12.01343 20.74453,-19.11562 5.66251,-8.88993 12.01051,-12.83687 20.78672,-12.92579 4.83832,-0.0491 6.71411,-0.84837 8.54297,-3.63984 2.81825,-4.30165 15.07058,-11.4164 19.65938,-11.4164 4.38619,0 15.23176,9.45516 18.7453,16.34297 1.55042,3.03937 3.83942,9.4389 5.0883,14.22187 2.11955,8.11751 5.8884,14.41406 8.62734,14.41406 0.6504,0 -0.26967,-3.20329 -2.04376,-7.12031 -4.08237,-9.01353 -4.45325,-28.17213 -0.71249,-36.73594 3.41583,-7.81993 6.04185,-7.19873 3.17108,0.75 -1.26575,3.50471 -2.32239,11.13884 -2.34843,16.96406 -0.0382,8.50586 0.72272,12.1127 3.86485,18.31406 3.65909,7.22166 9.04879,12.19284 11.04844,10.19297 0.48233,-0.48237 -0.50981,-2.39237 -2.20313,-4.24453 -6.48142,-7.08949 -8.63669,-13.39474 -8.61797,-25.2164 0.0155,-9.77995 0.69957,-12.74071 4.9336,-21.34218 3.91938,-7.96227 6.79994,-11.41043 14.20547,-17.01329 5.10843,-3.86492 10.23991,-7.75579 11.40467,-8.64609 1.53639,-1.17425 1.94877,-1.15136 1.5,0.0821 -0.34022,0.93504 -4.81217,5.19022 -9.93749,9.45703 -12.24836,10.19672 -18.9053,22.98103 -19.04531,36.57187 -0.0956,9.28107 2.70325,18.99141 5.475,18.99141 0.94457,0 1.01666,-2.04433 0.19687,-5.62266 -4.22509,-18.44227 1.15415,-34.03824 16.25157,-47.11875 5.04323,-4.36951 10.57228,-8.64359 12.28828,-9.49921 3.74286,-1.86623 4.82354,-6.05242 2.33671,-9.04923 -2.94027,-3.54316 -5.19195,-2.63857 -16.71562,6.72423 -20.17108,16.38866 -31.30831,27.94755 -33.61171,34.88437 l -2.13984,6.44063 0.81093,-6.46876 c 0.71172,-5.67974 2.25549,-7.87625 12.65156,-17.99297 6.51258,-6.33756 16.25654,-15.508 21.65156,-20.3789 9.66177,-8.72315 16.56674,-19.6358 15.59999,-24.65624 -0.29725,-1.54372 -2.23027,0.63914 -5.15624,5.82421 -4.30091,7.62161 -10.19917,13.51611 -45.12656,45.10078 -4.29095,3.88029 -4.87266,4.06006 -4.87266,1.51172 0,-1.65434 2.81141,-5.04208 6.56485,-7.91016 15.02795,-11.48313 32.92332,-27.48342 36.94453,-33.03515 5.05145,-6.97406 9.60281,-18.14475 8.54531,-20.97422 -0.40789,-1.09135 -2.502,1.9079 -4.65234,6.66329 -4.53035,10.01879 -12.93958,19.63963 -25.66406,29.36483 -4.94728,3.78116 -9.85434,7.7077 -10.90547,8.72578 -4.02286,3.89634 -14.93201,12.48516 -15.85783,12.48516 -0.5335,0 -0.9703,-0.58241 -0.9703,-1.2961 0,-1.60961 19.7995,-17.94597 27.14297,-22.39453 6.64113,-4.02309 18.13712,-16.12975 21.51093,-22.65467 1.37506,-2.65936 2.26701,-6.30742 1.98282,-8.10704 -0.42021,-2.66101 -1.25229,-1.86084 -4.45078,4.27734 -4.65406,8.9315 -13.60163,18.5142 -22.52344,24.12422 -8.61068,5.4144 -31.78095,24.55312 -29.72577,24.55312 2.88441,0 15.05858,12.27789 15.05858,15.1875 0,2.1674 -1.23066,1.45229 -5.36484,-3.12421 -5.27748,-5.84219 -8.9526,-7.86021 -14.87578,-8.16329 -4.41106,-0.2257 -3.68166,-2.15051 2.51718,-6.64687 3.03344,-2.20031 10.72678,-8.55481 17.09532,-14.1211 6.36854,-5.56629 12.47807,-10.12031 13.57734,-10.12031 1.09931,0 3.72276,-2.60376 5.82891,-5.78672 4.34211,-6.56205 6.66156,-16.7039 3.8203,-16.7039 -1.20834,0 -1.03081,-1.07117 0.55313,-3.33281 1.29514,-1.84925 2.33438,-6.41711 2.33438,-10.26329 0,-8.86315 -3.21368,-11.91092 -14.40703,-13.6664 -4.63299,-0.72659 -11.17221,-2.64722 -14.53125,-4.27031 -3.68243,-1.77936 -5.47663,-2.66594 -6.2039,-2.72579 z m 198.3914,1.45547 c -3.44659,0.0353 0.1572,3.02999 9.09845,6.9797 11.72482,5.17926 13.91614,8.8319 10.67578,17.79375 -0.99217,2.75692 -1.44762,5.60184 -1.00314,6.32109 0.44437,0.71922 -0.44776,2.44506 -1.98282,3.83438 -1.53503,1.38931 -3.2064,4.60422 -3.71484,7.14608 -2.58744,12.93872 -30.26686,26.30351 -55.64062,26.86642 -4.94736,0.1098 -11.01706,0.69187 -13.49062,1.2914 l -4.49767,1.08984 3.74767,1.63594 c 2.06148,0.8999 8.13117,1.66598 13.49062,1.70391 25.6294,0.18148 53.31503,-11.82569 64.52812,-27.23438 l 0,-43.34061 c -1.58551,-0.57318 -3.45062,-1.03073 -5.67187,-1.39923 -3.92279,-0.6508 -9.32497,-1.64776 -12.00469,-2.21484 -1.56746,-0.33169 -2.739,-0.4816 -3.53437,-0.47345 z m -251.30157,1.51407 c -2.77587,0.0859 -5.42107,1.84585 -8.6789,5.40235 -4.54433,4.96093 -8.06031,13.045 -6.3961,14.70937 0.33148,0.3315 3.12178,-1.10783 6.19922,-3.19922 6.93565,-4.71341 12.37787,-4.27511 16.54687,1.33359 4.14784,5.58028 5.16333,23.07243 1.9711,33.96329 -2.9124,9.93623 -0.23546,9.53124 4.95,-0.74766 7.58521,-15.03577 3.60865,-40.75343 -7.52813,-48.68437 -2.66723,-1.89943 -4.90505,-2.84413 -7.06406,-2.77735 z m -27.4875,2.51485 0,13.38047 c 0.092,0.72933 0.0887,1.50479 0,2.32968 l 0,27.91875 c 1.19012,-1.6085 2.20385,-3.25503 3.01406,-4.9289 3.33833,-6.8968 4.03701,-12.92344 1.5,-12.92344 -0.88796,0 -0.55809,-1.46503 0.75,-3.33282 1.29514,-1.84924 2.33438,-6.41709 2.33438,-10.26327 0,-6.73801 -1.97082,-10.20164 -7.59844,-12.18047 z m 134.60157,4.82344 c -1.6998,-0.0572 1.69672,5.93896 6.49922,11.4703 2.27377,2.61881 4.61075,7.00401 5.19374,9.74532 0.58301,2.74132 2.11685,6.18214 3.40781,7.64531 3.36572,3.81454 5.49475,2.43424 6.03049,-3.90703 0.42972,-5.08684 -0.3215,-6.25678 -9.74532,-15.21094 -5.61561,-5.33575 -10.73852,-9.72124 -11.38594,-9.74296 z m -6.26719,2.72109 c -3.68856,-0.2031 -8.29688,5.24063 -8.29688,11.75391 0,2.01948 0.53987,1.97599 4.12266,-0.32813 9.38981,-6.03868 9.20207,-5.80365 7.35234,-9.1711 -0.81978,-1.49244 -1.9486,-2.18698 -3.17812,-2.25468 z m 75.25781,0.39844 c -2.58032,0.005 -4.80072,0.79884 -7.01953,2.35311 -4.68495,3.28176 -27.01038,5.24822 -35.74219,3.14766 -7.92022,-1.90528 -9.50972,-0.68101 -4.36874,3.36329 3.16002,2.48602 3.9842,4.55273 4.35,10.89141 0.51595,8.94093 2.81792,10.30924 4.39218,2.61093 0.58623,-2.86637 2.54578,-6.40734 4.35235,-7.87031 3.65175,-2.95736 12.79297,-3.49843 20.7164,-1.22578 3.67311,1.05355 6.76383,0.83506 11.63906,-0.82031 3.65089,-1.23966 7.32942,-1.82488 8.17735,-1.30079 2.51364,1.55369 -1.34864,4.98803 -7.77657,6.91406 -4.82831,1.44676 -7.31461,1.28898 -14.61328,-0.92109 -7.66677,-2.32157 -9.35118,-2.3967 -13.11796,-0.59531 -4.89905,2.34283 -9.29149,12.45664 -7.45782,17.17266 1.0433,2.68348 1.28648,2.63045 4.07579,-0.89297 7.69282,-9.71731 6.11409,-9.13002 21.9328,-8.15156 8.03352,0.49689 15.49965,1.18191 16.59142,1.52343 1.09188,0.34155 5.00845,-1.45977 8.70469,-4.00312 5.87304,-4.0412 6.66216,-5.22142 6.26016,-9.36563 -0.39469,-4.06743 -1.61787,-5.3299 -8.59923,-8.86641 -5.26757,-2.66835 -9.17931,-3.96877 -12.49688,-3.96327 z m -133.00546,7.33827 c -0.45624,0 -2.79202,5.14067 -5.1914,11.42579 -9.11369,23.87294 -23.06291,40.30926 -48.30939,56.92264 -7.97631,5.24879 -14.99928,10.18113 -17.08594,11.96486 l 0,1.99453 c 4.69352,-0.27497 25.68479,-12.0262 36.82032,-21.33047 11.8928,-9.93702 18.82749,-17.8553 29.62265,-33.82265 9.21798,-13.63451 10.46972,-17.56335 7.33594,-23.03204 -1.29949,-2.26776 -2.73596,-4.12266 -3.19218,-4.12266 z m -11.5758,2.8125 c -0.89427,-0.0173 -2.33817,3.03292 -4.26327,9.10547 -7.45133,23.50435 -23.41461,41.71115 -49.2211,56.14453 -1.93628,1.08295 -3.79992,2.23033 -5.52656,3.33985 l 0,4.18594 c 8.5948,-3.73781 21.21111,-11.43588 29.23359,-18.05392 17.12477,-14.12682 30.83673,-35.95588 30.83673,-49.09453 0,-3.74442 -0.36383,-5.61391 -1.05939,-5.62734 z m -28.32656,1.56329 c -0.80885,0.15327 -2.37827,2.68937 -4.82578,7.76484 -5.41819,11.2359 -14.40811,20.71413 -25.85859,27.6914 l 0,4.79766 c 11.73496,-6.54979 21.98367,-16.79402 27.1875,-27.36562 2.56881,-5.21856 4.39493,-10.73301 4.05703,-12.25313 -0.105,-0.47262 -0.29054,-0.68624 -0.56016,-0.63515 z m -7.6875,1.23281 c -0.63829,0.14501 -1.73293,1.93111 -3.75937,5.82187 -3.71981,7.14208 -12.30318,16.84854 -19.2375,22.06875 l 0,4.32657 c 11.01234,-6.24504 24.90363,-23.52549 23.7539,-30.80625 -0.15699,-0.99424 -0.37405,-1.49794 -0.75703,-1.41094 z m 213.97736,0.74063 c -1.33284,-0.15066 -1.30343,0.66053 -0.64453,3.28593 1.43555,5.72024 -2.65264,10.91009 -10.22344,12.97968 -4.13976,1.13169 -13.30259,1.4597 -26.13046,0.93752 -20.86391,-0.8493 -20.60466,-0.9115 -27.20392,6.63046 -3.52642,4.03019 -6.01433,16.8659 -4.19062,21.61874 1.17967,3.07462 3.92578,1.3515 3.92578,-2.46327 0,-4.20521 6.90922,-17.30586 9.68907,-18.37266 1.28221,-0.49208 4.18021,-0.1868 6.44062,0.67969 6.3466,2.43278 44.78058,2.46841 53.10234,0.0492 14.38297,-4.18124 17.65913,-14.62054 6.47813,-20.64374 -3.2982,-1.77676 -7.54154,-3.69342 -9.4289,-4.26095 -0.77428,-0.23279 -1.36979,-0.39039 -1.81407,-0.44061 z m -219.38204,0.88359 c -0.72275,-0.0234 -2.11775,0.93484 -4.05703,3.20391 -2.44014,2.85506 -4.43672,5.72301 -4.43672,6.37265 0,2.41261 2.87577,1.06124 5.8875,-2.76797 3.14486,-3.99846 3.81082,-6.76963 2.60625,-6.80859 z m 107.94141,2.99765 c -0.72275,-0.0234 -2.12009,0.93719 -4.05937,3.20626 -2.44014,2.85506 -4.43673,5.72301 -4.43673,6.37265 0,2.41262 2.87578,1.0589 5.8875,-2.77031 3.14486,-3.99845 3.81317,-6.76965 2.6086,-6.8086 z m -91.74844,2.98829 c -0.76863,0.0499 -2.31601,2.13438 -4.65703,6.27187 -5.84862,10.33672 -17.73856,21.61304 -29.12813,27.74531 l 0,4.28438 c 6.72241,-3.38262 12.8113,-7.47923 18.13126,-12.24845 8.63338,-7.73961 17.0258,-20.94177 16.16249,-25.42499 -0.0838,-0.43505 -0.25239,-0.64475 -0.50859,-0.62812 z m 242.26875,3.4125 c -1.5765,-0.0274 -3.41604,0.14791 -5.50077,0.53906 -4.39681,0.82492 -5.09767,1.5508 -5.09767,5.27812 0,5.32828 -4.72644,9.3254 -15.45,13.0664 -6.21947,2.16968 -12.38665,2.71007 -30.64921,2.68595 -12.57431,-0.0167 -22.86093,0.4673 -22.86093,1.07343 0,1.28494 4.92452,4.07141 10.40623,5.88984 5.69028,1.88759 36.98657,0.27782 47.19845,-2.42812 12.41304,-3.28918 22.85761,-9.35069 26.62969,-15.45468 4.08583,-6.61182 2.15574,-10.53146 -4.67579,-10.65 z m -189.97501,3.26718 c -4.94902,-0.12918 -12.21337,6.02374 -21.76873,18.44296 -9.13319,11.87051 -24.2341,25.86861 -35.67188,33.06563 -12.83663,8.07722 -22.53985,15.43044 -22.53985,17.0836 0,4.33705 28.21081,-11.71517 45.58359,-25.93828 6.29235,-5.15155 9.18678,-6.71257 10.00079,-5.39532 0.79551,1.28733 3.12713,-0.31868 7.63594,-5.25937 3.57051,-3.9125 9.66307,-10.4851 13.53984,-14.6039 8.17352,-8.68388 9.91878,-12.72152 6.83203,-15.8086 -1.02174,-1.02186 -2.22601,-1.55054 -3.61173,-1.58672 z m 65.66251,4.18829 c -1.88271,0.0348 -3.52796,0.71414 -4.64296,2.05781 -1.45818,1.75714 -0.94112,2.59418 2.79374,4.52578 8.62614,4.4612 7.85524,17.52234 -1.30546,22.125 -4.98467,2.50446 -11.89658,9.57101 -12.0047,12.27187 -0.0305,0.762 5.14226,0.94642 11.91329,0.42421 11.05062,-0.85224 12.09289,-0.68719 13.61953,2.16563 0.90922,1.69915 1.24574,4.71366 0.74765,6.69844 -0.64201,2.55826 -0.27837,3.60937 1.24923,3.60937 5.35745,0 6.89765,-1.84717 6.89765,-8.27344 0,-5.32973 -0.78316,-7.11165 -4.49765,-10.2375 -2.47365,-2.08165 -4.49766,-4.84104 -4.49766,-6.13124 0,-1.29019 -0.71306,-2.3461 -1.58438,-2.3461 -0.88785,0 -0.55811,-1.465 0.75,-3.3328 1.30945,-1.86969 2.33204,-6.42714 2.33204,-10.38516 0,-5.835 -0.68175,-7.5921 -3.94923,-10.1625 -2.58626,-2.03459 -5.40045,-3.05413 -7.82109,-3.00937 z m -119.17735,5.21015 c -1.1993,0.16946 -4.77008,3.09761 -10.34766,8.73515 -6.92968,7.00421 -13.92406,12.26554 -22.2164,16.47423 l 0,4.43203 c 12.0434,-5.97341 22.94967,-13.90923 28.67813,-21.81797 3.91302,-5.40235 5.08524,-7.9929 3.88593,-7.82344 z m 267.43594,4.07578 c -1.09434,0.83173 -2.15294,1.56199 -3.14295,2.14687 -2.42856,1.43471 -4.41564,3.18353 -4.41564,3.88594 0,0.70239 1.51734,0.80576 3.37267,0.22969 1.3182,-0.40932 2.72934,-1.06468 4.18592,-1.90313 l 0,-4.35937 z m -116.5289,5.55234 c -1.81333,0.0247 -2.86741,1.5695 -4.58438,4.35 -6.08881,9.86034 -6.3209,21.32096 -0.32108,15.89063 4.72766,-4.27901 6.64734,-1.76811 2.45624,3.21327 -2.10171,2.49799 -4.29645,6.42762 -4.87501,8.73282 l -1.05,4.19063 4.13439,-2.70938 c 3.99405,-2.61726 4.20244,-2.61542 6.15234,0.0516 1.7683,2.41849 1.46691,3.45752 -2.43047,8.3789 -2.44702,3.08989 -4.44843,6.02755 -4.44843,6.52735 0,0.49983 1.02596,0.90937 2.28047,0.90937 3.0955,0 14.2125,-7.48306 14.2125,-9.56953 10e-4,-0.9212 2.73558,-4.24755 6.07733,-7.39219 5.45413,-5.13256 6.03,-6.35107 5.62033,-11.90624 -0.4176,-5.66364 -1.21975,-6.73359 -9.45236,-12.60937 -7.85672,-5.60762 -11.44044,-8.08954 -13.77187,-8.05782 z m -151.24454,0.28829 c -0.79281,0.0913 -4.87051,3.36209 -9.47109,7.62187 -5.24729,4.85858 -13.26405,10.23047 -22.75547,15.29531 l 0,5.03672 c 11.98124,-5.91547 24.67153,-14.99857 29.29219,-21.79922 2.04228,-3.00581 3.41441,-5.76601 3.04921,-6.13125 -0.0228,-0.0228 -0.0619,-0.0295 -0.11484,-0.0234 z m 267.77344,0.51797 c -7.82487,4.79448 -16.79565,8.42907 -26.60859,10.6125 -6.01368,1.33806 -10.93358,3.04095 -10.93358,3.7828 0,3.63646 20.02718,-0.9229 34.06875,-7.75546 1.17197,-0.57028 2.32697,-1.19112 3.47342,-1.83516 l 0,-4.80468 z m 0,7.41561 c -0.49398,0.26802 -0.98721,0.54162 -1.4789,0.78985 -15.33492,7.74186 -28.6404,10.40128 -52.95,10.58672 -26.37024,0.20116 -28.08751,0.55536 -28.08751,5.77969 0,2.66341 -1.82491,5.72636 -5.44686,9.14296 l -5.44687,5.13984 4.69687,3.9211 c 5.6994,4.75853 6.01066,6.37764 0.85078,4.41563 -5.1882,-1.97278 -15.09845,-1.84705 -19.11563,0.2414 -3.42639,1.78141 -8.89192,6.50709 -16.13905,13.95469 -5.48088,5.63255 -7.23325,4.17894 -2.18906,-1.8164 4.39413,-5.22269 4.67481,-6.34453 1.57967,-6.34453 -3.05339,0 -15.75937,17.7699 -15.75937,22.04061 0,2.13001 0.89854,3.44766 2.34843,3.44766 3.59406,0 8.14688,-2.8659 8.14688,-5.12813 0,-3.25113 7.27007,-7.11374 12.40782,-6.59296 4.30024,0.43588 4.7971,0.028 5.77266,-4.73438 0.5872,-2.86636 2.54578,-6.4097 4.35233,-7.87265 4.02119,-3.25654 14.90488,-3.53183 20.71875,-0.525 4.07616,2.10806 14.28765,12.57832 17.75157,18.2039 1.67051,2.71307 1.78985,2.6489 1.87266,-1.00078 0.0485,-2.14579 -1.54872,-6.19328 -3.55079,-8.99531 -4.14,-5.79419 -12.85079,-22.14991 -12.85079,-24.12891 0,-0.72193 1.25998,-0.63714 2.80079,0.1875 3.40967,1.82508 4.69453,0.74102 4.69453,-3.96094 0,-1.96162 1.65588,-5.22277 3.67969,-7.24687 3.4206,-3.42095 4.74627,-3.67969 18.80391,-3.67969 19.65991,0 37.65734,-4.01496 52.53749,-11.54061 l 0,-4.28439 z m -159.975,6.0211 c -0.44227,0.01 -1.07132,0.13077 -1.87968,0.34219 -7.26805,1.90084 -22.44148,21.11049 -22.57266,28.57734 -0.0716,4.07693 2.90509,1.47197 7.37813,-6.45468 2.58477,-4.58043 7.70787,-11.21057 11.38594,-14.73516 5.98744,-5.7376 7.6048,-7.77294 5.68827,-7.72969 z m 159.975,1.2539 c -7.36791,3.75987 -15.75709,6.68406 -26.08359,9.22735 -8.12748,2.00169 -15.15475,4.01725 -15.6164,4.47891 -0.46164,0.46165 2.16844,0.8414 5.84296,0.8414 10.36256,0 23.69932,-4.06206 35.85703,-10.11563 l 0,-4.43203 z m 0,7.61953 c -0.97094,0.51943 -1.94031,1.03945 -2.9414,1.55157 -9.13523,4.6733 -16.61015,8.86072 -16.61015,9.30469 0,0.44394 2.19282,0.32885 4.87265,-0.25547 4.26452,-0.92989 9.40748,-2.9405 14.6789,-5.55469 l 0,-5.0461 z m -58.1578,4.1836 c -0.86404,-0.0221 -1.79835,0.0697 -2.88516,0.24609 -2.88804,0.46871 -6.19981,1.6392 -7.35937,2.60157 -2.90604,2.41207 -5.7573,12.57168 -4.4625,15.9 0.97632,2.50934 1.31,2.42718 4.03123,-1.01016 1.63213,-2.06159 3.93671,-4.92955 5.12111,-6.37266 2.69544,-3.28377 8.64465,-3.37167 13.48593,-0.19921 3.01716,1.97716 5.8341,2.22422 15.2625,1.34062 10.63728,-0.99692 11.32703,-1.2595 8.61563,-3.29766 -2.10576,-1.58298 -5.0806,-1.97487 -10.41797,-1.37109 -6.74328,0.76286 -8.03083,0.39293 -13.24687,-3.79921 -3.58758,-2.88338 -5.55242,-3.97218 -8.14453,-4.03829 z m -107.43515,4.24219 c -3.33539,0 -13.65735,12.70198 -15.60471,19.20234 -3.82267,12.76038 -1.74918,21.92535 6.91876,30.57656 8.70614,8.68936 9.08144,8.17723 5.35313,-7.3289 -3.05385,-12.70109 -2.817,-17.42225 1.23515,-24.63282 2.76074,-4.91261 12.96376,-14.06676 14.24766,-12.78281 0.24538,0.24545 -2.61944,3.64605 -6.36797,7.5586 -7.12193,7.43367 -10.32955,13.48535 -8.99297,16.96874 1.32373,3.45 6.24391,-0.3397 12.43359,-9.57655 10.88345,-16.24123 10.40232,-15.11377 7.62657,-17.88985 -3.23619,-3.23652 -7.9023,-2.00664 -15.14766,3.99609 -11.02487,9.13403 -15.39034,23.51323 -10.1836,33.53907 3.55493,6.8452 3.05292,8.94988 -0.75,3.1453 -4.44735,-6.78826 -4.52942,-17.13356 -0.2039,-25.63359 2.07016,-4.06802 5.51639,-9.03052 7.65937,-11.02968 4.35205,-4.06 4.9493,-6.1125 1.77658,-6.1125 z m 165.59295,0.82968 c -2.99297,1.91479 -5.45625,3.69282 -6.19218,4.57969 -1.8888,2.2762 -1.73191,2.4102 1.64298,1.38281 1.31728,-0.40103 2.8664,-1.00406 4.5492,-1.7414 l 0,-4.2211 z m -117.65623,4.23516 c -0.43021,0.005 -1.07818,0.15829 -1.96643,0.48047 -3.45865,1.25456 -14.3432,8.72811 -23.30624,16.00313 -15.04884,12.21467 -18.60581,31.15821 -7.49063,39.90233 6.97645,5.48835 8.49527,3.65356 2.68829,-3.24843 -9.0016,-10.69895 -2.09759,-28.90289 14.99062,-39.52031 10.44628,-6.49061 18.0957,-13.65415 15.08439,-13.61719 z m -113.22891,4.12734 c -2.14079,0.0745 -4.23431,1.05358 -6.59533,2.91095 -4.10115,3.22629 -5.09123,8.33688 -2.52656,13.03124 0.78229,1.43194 1.82865,5.76211 2.325,9.6211 0.86751,6.74481 5.41557,14.72343 8.39297,14.72343 0.78589,0 0.40019,-1.98969 -0.85781,-4.42266 -2.73131,-5.28233 -3.00681,-15.25073 -0.48984,-17.76796 4.71232,-4.71282 13.19297,2.09991 13.19297,10.59843 0,2.47319 0.66658,6.93685 1.48124,9.91876 0.81464,2.9819 2.1695,8.2087 3.00938,11.61562 1.57689,6.3965 6.17258,9.73966 13.93125,10.13203 2.44232,0.12352 3.79542,1.66516 5.18437,5.90625 2.23157,6.81399 1.13097,12.49489 -2.83125,14.61563 -3.75217,2.0083 -2.31023,4.06161 5.27109,7.50468 7.71177,3.50229 7.39629,3.51006 10.81642,-0.26952 3.845,-4.24916 3.0669,-8.08868 -4.73906,-23.38829 -3.65027,-7.15449 -6.6375,-13.78097 -6.6375,-14.72578 0,-1.6398 -10.84988,-11.21719 -12.70782,-11.21719 -0.48964,0 -0.19035,1.30651 0.66329,2.90157 1.987,3.71341 1.97818,6.09609 -0.0234,6.09609 -2.63942,0 -5.92032,-9.95521 -5.92032,-17.9625 0,-9.58814 -4.65671,-19.6971 -11.77266,-25.56328 -3.58268,-2.95347 -6.41397,-4.35437 -9.1664,-4.2586 z m 230.88514,0.52032 c -0.40136,0.33539 -0.70298,0.60679 -0.7828,0.73594 -0.67365,1.09012 -0.31526,1.49932 0.7828,1.3828 l 0,-2.11874 z m -21.32812,1.1625 c -2.38084,-0.0124 -5.02762,0.11112 -7.96874,0.36094 -17.07277,1.44984 -17.332,1.45215 -24.24844,0.1828 -5.26896,-0.967 -6.75132,-0.65527 -9.37032,1.96407 -1.79268,1.79282 -3.11015,5.05409 -3.11015,7.69687 0,2.66658 -0.6264,4.20041 -1.49532,3.66329 -1.557,-0.96237 0.0486,4.23788 3.02579,9.80156 1.49988,2.80268 1.62059,2.80254 6.37031,-0.0937 2.6628,-1.62373 5.98482,-2.95541 7.38282,-2.95781 1.398,-0.004 3.42196,-1.82855 4.49764,-4.05469 2.832,-5.86062 10.48738,-9.75749 19.63126,-9.99374 9.76549,-0.25234 10.72585,3.10569 1.65468,5.78437 -11.57124,3.41695 -11.62218,5.62758 -0.26249,11.42343 5.78315,2.95065 13.2532,2.82257 19.37813,-0.3328 4.3578,-2.245 5.70945,-9.0519 2.95545,-14.88516 -2.78742,-5.9041 -8.12364,-8.50585 -18.44062,-8.55937 z m -124.77656,5.61797 c -3.33536,0 -13.65735,12.70197 -15.60469,19.20234 -3.96254,13.22715 -1.23252,23.78899 8.14688,31.52109 5.97486,4.92551 8.5186,5.3525 9.25546,1.55624 0.24803,-1.27754 -1.8256,-3.27019 -4.95468,-4.76248 -6.06734,-2.89366 -9.7125,-9.75607 -9.7125,-18.28126 0,-6.31934 5.60616,-18.00506 11.09531,-23.12577 4.35204,-4.06 4.94708,-6.11016 1.77422,-6.11016 z m -110.96953,4.71797 c -2.67707,0.19681 -7.04511,3.2567 -13.18126,9.22265 -7.06073,6.86488 -19.98205,17.7879 -29.74453,25.32657 l 0,9.83437 c 3.51904,-2.43182 6.60242,-4.12032 7.73672,-4.12032 1.61618,0 5.96238,-3.02525 9.6586,-6.72187 l 6.72187,-6.72187 -0.92579,5.78437 c -1.25034,7.82009 1.64308,9.33984 4.875,2.56172 2.05959,-4.31946 2.16425,-5.66739 0.58126,-7.575 -3.0235,-3.64349 -8.09956,-2.73575 -12.89766,2.30625 -4.86619,5.11354 -9.65156,8.17932 -9.65156,6.18516 0,-2.54224 15.47312,-13.81173 18.96328,-13.81173 1.96155,0 4.89575,-0.82987 6.52031,-1.84453 2.43538,-1.52108 3.39196,-1.40592 5.45626,0.6586 4.66915,4.66965 1.84782,17.96433 -4.41797,20.81953 -1.93691,0.88261 -4.35358,3.91018 -5.37189,6.72656 -2.69974,7.46686 -10.27125,12.58476 -20.82421,14.07656 -1.85264,0.2619 -4.10307,0.74564 -6.42422,1.35468 l 0,6.74766 c 1.03741,-0.81949 1.98167,-1.5175 2.62734,-1.8539 1.80103,-0.93835 7.53535,-1.72685 12.74298,-1.75313 5.9382,-0.0299 10.55457,-0.86707 12.37968,-2.24765 3.2087,-2.42719 5.33437,-2.83716 5.33437,-1.02656 0,2.18254 -8.71453,6.34608 -16.29374,7.78358 -4.14072,0.78537 -10.05382,2.48186 -13.13907,3.7711 -1.77825,0.74309 -2.93949,1.27086 -3.65156,1.74142 l 0,2.53358 c 0.14168,0.15277 0.27186,0.29762 0.44532,0.4711 2.61006,2.61032 8.4453,1.93713 11.92031,-1.37578 1.08834,-1.03757 4.67759,-2.62969 7.97577,-3.53906 3.29819,-0.90938 7.00849,-1.97429 8.24532,-2.36484 1.2367,-0.39059 1.74341,-0.42558 1.125,-0.0797 -1.81663,1.01605 -1.28809,3.37874 0.75,3.3539 4.75869,-0.0583 6.17311,-2.85182 6.27187,-12.38437 0.0925,-8.93929 0.49943,-10.08448 5.61563,-15.74766 l 5.51718,-6.10781 -0.83203,-19.97579 c -0.45776,-10.98751 -1.35343,-20.55038 -1.99218,-21.25077 -0.51913,-0.56926 -1.22406,-0.82264 -2.1164,-0.75703 z m 126.0539,1.72969 c -1.47442,-0.15129 -5.78046,2.46189 -9.76875,6.13827 -8.7751,8.08863 -11.32546,17.91983 -6.87891,26.51953 3.27336,6.33057 5.4427,4.05327 4.30548,-4.52109 -1.06179,-8.00437 0.0596,-10.92509 7.8586,-20.49375 2.75777,-3.38348 5.01327,-6.5681 5.01327,-7.07578 0,-0.35041 -0.18943,-0.53227 -0.52969,-0.56718 z m 35.04376,1.54687 c -1.8928,0.004 -3.73066,0.38884 -5.45625,1.21406 -4.89979,2.34319 -9.29173,12.45857 -7.45782,17.175 1.04331,2.68347 1.28878,2.62809 4.07813,-0.89532 1.63211,-2.06159 3.93669,-4.9272 5.1211,-6.37031 5.52984,-6.73694 18.19716,0.19205 24.15937,13.21641 1.99296,4.3539 4.03404,11.3778 4.53515,15.60937 1.17553,9.92642 3.84117,7.71353 4.00078,-3.32108 0.25913,-17.93291 -15.73098,-36.65125 -28.98046,-36.62813 z m -152.16798,0.43124 c -1.73432,0.1696 -0.50847,19.24182 2.22656,30.23203 3.18427,12.79547 2.55479,18.51132 -2.23828,20.35079 -3.4569,1.32668 -1.43118,3.80714 5.78672,7.08515 7.71176,3.50229 7.39628,3.51006 10.81641,-0.26953 3.76659,-4.16249 2.98193,-9.01655 -3.26718,-20.21718 -2.79863,-5.01615 -6.50101,-14.79503 -8.22657,-21.72891 -1.72556,-6.93385 -3.73337,-13.62458 -4.4625,-14.86875 -0.24434,-0.41692 -0.45575,-0.60114 -0.63516,-0.5836 z m 5.14687,0.4711 c -0.25101,0.0376 -0.52657,0.19374 -0.81797,0.48516 -0.48755,0.48762 -0.34229,2.45586 0.3211,4.37343 l 1.2047,3.4875 0.55076,-3.50156 c 0.46275,-2.94108 -0.17087,-5.00743 -1.25859,-4.84453 z m 206.18673,9.225 c -1.32826,-0.0275 -2.78766,0.043 -4.50234,0.18516 -11.48568,0.95259 -16.02414,5.25998 -15.4125,14.62968 0.5094,7.80241 2.96782,8.51294 4.4461,1.28438 1.39248,-6.80882 6.15231,-10.23047 14.2289,-10.23047 6.78192,0 15.50157,3.39432 15.50157,6.03515 0,1.94197 -0.66832,1.86887 -8.79376,-0.95156 -5.43636,-1.887 -7.86181,-2.0523 -11.14453,-0.75937 -4.75824,1.87411 -8.54148,9.39126 -8.55468,16.99219 -0.005,2.70656 -0.61477,7.2833 -1.3547,10.16953 -0.73991,2.88623 -1.75928,7.2714 -2.2664,9.74531 l -0.92343,4.49766 3.74764,-4.17423 c 2.06112,-2.29619 5.20351,-9.0428 6.98203,-14.99297 1.77864,-5.95017 3.89981,-11.66488 4.71329,-12.69843 0.819,-1.04052 4.23787,-1.77998 7.66171,-1.65703 7.82412,0.28092 26.42344,-7.17477 26.42344,-10.59141 0,-0.55808 -2.42126,-0.73203 -5.37891,-0.38672 -3.81467,0.44539 -7.73705,-0.56554 -13.50233,-3.48281 -5.07016,-2.56592 -7.88633,-3.53166 -11.8711,-3.61406 z m -189.11953,3.60469 c -0.26529,-0.0306 -0.5037,0.0121 -0.70781,0.13828 -1.88612,1.16581 -1.63498,2.30566 1.72734,7.82109 3.23315,5.3035 6.73487,5.16715 5.10234,-0.19922 -1.14102,-3.75066 -4.2649,-7.54619 -6.12187,-7.76015 z m 133.31719,0.96094 c -2.77586,0.0859 -5.42115,1.84584 -8.67891,5.40234 -4.54434,4.96094 -8.05794,13.04498 -6.39376,14.70937 0.3315,0.3315 3.11936,-1.10782 6.19689,-3.19921 11.59667,-7.88114 19.30873,-1.62074 20.21953,16.41562 0.30228,5.98565 -0.16355,13.46892 -1.03595,16.62891 -1.13532,4.11367 -1.1081,7.5302 0.0961,12.0328 1.29732,4.85105 1.23214,7.8012 -0.27891,12.90703 -2.49563,8.43393 -2.46211,15.65883 0.10309,22.62188 l -0.002,0 c 2.69976,7.32788 4.91034,5.586 3.64219,-2.87109 -0.65305,-4.35516 -0.0702,-11.42912 1.64297,-19.90548 2.109,-10.43472 2.33212,-14.57234 1.07812,-20.05311 -1.42141,-6.21187 -0.37464,-9.72411 1.5,-5.03203 0.41184,1.03078 0.58037,-5.21165 0.37265,-13.87032 -0.42624,-17.76135 -3.83094,-27.62082 -11.39765,-33.00937 -2.66727,-1.89944 -4.90505,-2.84414 -7.06406,-2.77734 z m 92.61327,1.13203 c -4.27185,4.92924 -10.98734,10.4274 -17.27342,13.61953 -4.32229,2.19492 -8.74344,5.87754 -10.49531,8.74218 -1.66465,2.72207 -6.67435,10.14404 -11.13283,16.49297 -10.92108,15.55183 -21.57951,35.99259 -26.35311,50.54062 -4.0824,12.44127 -6.59887,34.3545 -4.50235,39.20626 0.804,1.86078 1.77464,-1.88234 2.97656,-11.48204 0.98076,-7.83404 2.95487,-18.29281 4.38516,-23.24062 5.244,-18.13959 22.61085,-46.46779 37.22109,-60.71016 8.02501,-7.82298 8.81556,-9.57811 3.37501,-7.50937 -2.92741,1.11307 -3.75,0.9488 -3.75,-0.74531 0,-1.24502 5.58832,-4.86554 13.11796,-8.49843 4.62896,-2.23341 8.74454,-4.46361 12.43124,-6.73126 l 0,-9.68437 z m -235.95938,9.1664 c -1.78003,0 3.62536,9.32299 10.48595,18.08437 6.81762,8.70649 8.23792,14.61533 4.29843,17.88516 -1.22771,1.01905 -1.86279,2.45161 -1.41093,3.18281 1.10074,1.78122 9.15817,1.69264 12.5789,-0.13828 1.50816,-0.80722 3.4775,-3.57522 4.37579,-6.15234 1.51084,-4.33447 1.27533,-4.98328 -3.15,-8.65312 -2.63113,-2.18195 -9.58711,-8.52201 -15.45703,-14.08829 -5.86992,-5.5663 -11.14393,-10.12031 -11.72111,-10.12031 z m 113.37423,0.225 c -11.14084,0.039 -17.43937,5.99668 -16.6125,15.95626 0.58156,7.00528 3.00097,7.19576 4.40156,0.34687 1.2214,-5.97247 6.03861,-10.53047 11.12812,-10.53047 5.33671,0 5.78093,2.62669 0.63516,3.75703 -6.68259,1.46789 -12.25382,11.95313 -9.75234,18.35391 0.91403,2.33893 1.38413,2.19694 4.28438,-1.29376 1.79169,-2.15652 5.10867,-4.36044 7.37109,-4.89844 4.83095,-1.14876 9.02055,-9.52816 8.32265,-16.64296 -0.417,-4.25247 -0.86652,-4.55163 -7.48593,-4.97813 -0.78509,-0.0505 -1.54947,-0.073 -2.29219,-0.0703 z m -52.95703,5.11641 c -0.0521,10e-4 -0.0974,0.0127 -0.13359,0.0352 -1.71395,1.05939 2.53799,9.07854 5.83124,10.99687 2.95384,1.72064 4.87266,2.02711 4.87266,0.78046 0,-1.92835 -8.95725,-11.84554 -10.57031,-11.81249 z m -8.49141,0.65625 c -2.76429,0 -2.38698,1.56577 1.33359,5.52657 4.59078,4.88716 6.40342,4.3126 3.24843,-1.02892 -1.46121,-2.47391 -3.52297,-4.49765 -4.58202,-4.49765 z m 184.03359,0.15468 c -3.31777,2.56547 -6.28665,4.75589 -8.54061,6.26485 -6.45084,4.3185 -14.93973,14.14152 -13.48126,15.6 1.85604,1.85628 8.36498,-1.3422 17.25469,-8.47735 1.59828,-1.28285 3.22342,-2.47609 4.76718,-3.53671 l 0,-9.85079 z m -29.73983,1.72735 c -2.56817,0.0718 -8.1904,5.73747 -12.57657,12.97265 -3.2034,5.2839 -7.82308,11.88457 -10.26796,14.66953 -2.445,2.78497 -4.4461,5.69034 -4.4461,6.45469 0,0.76438 -3.09114,7.99229 -6.86719,16.06407 -7.5918,16.2282 -10.44347,25.8413 -12.48047,42.06562 -1.27573,10.16065 -0.14249,27.68463 2.18203,33.74297 2.07288,5.40233 2.52451,2.14701 1.50703,-10.86095 -1.31724,-16.83967 0.8534,-31.8069 7.24689,-49.97343 6.64416,-18.87815 7.43569,-20.26284 34.29374,-60.01406 1.57608,-2.33259 2.61496,-4.49127 2.3086,-4.79765 -0.22979,-0.22981 -0.53313,-0.33368 -0.9,-0.32344 z m -31.15782,2.48906 c -0.9721,-0.0714 -2.77284,3.83762 -5.45859,11.79141 -3.3678,9.97381 -4.212,14.67446 -3.56017,19.8211 0.58333,4.60586 -0.0918,9.76333 -2.12576,16.25155 -1.63896,5.22745 -2.97892,10.17464 -2.97892,10.99453 0,0.81987 0.84419,1.21435 1.875,0.87656 1.03068,-0.33781 3.35585,-5.18436 5.16797,-10.76953 2.83536,-8.7386 3.08089,-11.30381 1.76953,-18.39843 -1.48404,-8.02908 -0.80163,-12.72822 1.02189,-7.04063 2.766,8.62647 3.62378,8.58765 3.46405,-0.15937 -0.22511,-12.33527 -0.016,-14.24531 1.55391,-14.24531 0.74736,0 1.02579,1.27269 0.61875,2.8289 -0.40693,1.55622 -0.008,3.28501 0.88829,3.83907 0.8964,0.55404 1.63124,0.0388 1.63124,-1.14376 0,-1.18254 0.38399,-4.42622 0.85547,-7.20937 0.81132,-4.78967 0.73267,-4.90634 -1.49766,-2.15156 -2.28791,2.8267 -2.35781,2.80193 -2.35781,-0.87422 0,-2.89263 -0.28392,-4.36812 -0.86719,-4.41094 z m -28.51172,1.49298 c -0.79876,0.13051 -2.34348,2.6159 -4.76249,7.6289 -3.41544,7.07783 -8.20926,13.19415 -17.5125,22.34063 -7.04541,6.92676 -12.8086,13.53221 -12.8086,14.6789 0,1.99527 2.2434,0.19566 19.80702,-15.87188 7.67341,-7.01976 16.88612,-23.38791 15.83205,-28.12968 -0.10537,-0.47389 -0.28923,-0.69039 -0.55548,-0.64687 z m -194.39766,0.3539 c -1.39434,0.11028 -3.54255,1.2846 -7.17657,3.5789 -3.97141,2.50732 -6.9976,4.84476 -9.0164,6.91875 l 0,7.10391 c 0.80608,0.1104 1.77832,0.16875 2.9789,0.16875 3.23076,0 6.92728,-0.40352 8.21486,-0.89766 3.72619,-1.43003 8.74083,-10.64937 7.65468,-14.07187 -0.62126,-1.95762 -1.26113,-2.9111 -2.65547,-2.80078 z m 186.74532,0.79687 c -0.60624,0.0331 -1.65766,1.76393 -3.74296,5.72813 -4.14517,7.87987 -9.47761,14.05058 -20.73751,23.99063 -6.28693,5.5501 -13.44609,14.25512 -13.44609,16.34999 0,1.8694 2.58643,0.76841 5.36015,-2.28048 1.58721,-1.74467 8.17076,-8.29822 14.62968,-14.56405 12.88259,-12.4976 19.50445,-22.27162 18.67501,-27.56485 -0.17037,-1.08722 -0.37454,-1.67928 -0.73828,-1.65937 z m -5.44452,1.71797 c -0.72275,-0.0234 -2.1201,0.93484 -4.05939,3.2039 -2.44018,2.85507 -4.43671,5.72303 -4.43671,6.37266 0,2.41261 2.87806,1.06125 5.88984,-2.76797 3.14483,-3.99846 3.81083,-6.76964 2.60626,-6.80859 z m -82.61487,0.2625 c -1.66092,0 3.97681,9.60354 10.61954,18.08672 6.81763,8.70648 8.2379,14.61299 4.29844,17.88281 -1.22774,1.01906 -1.8628,2.45161 -1.41094,3.18281 1.10074,1.78122 9.15817,1.69263 12.57891,-0.13828 1.50815,-0.80723 3.48296,-3.5901 4.38749,-6.18516 1.54391,-4.4291 1.29139,-5.05229 -4.125,-10.15313 -10.07686,-9.48979 -25.39878,-22.67577 -26.34844,-22.67577 z m 98.78674,5.73516 c -0.78784,0.13632 -2.37982,2.27675 -4.63126,6.26015 -5.20404,9.20772 -22.73247,27.51025 -29.72812,31.04062 -6.35302,3.2061 -11.29688,8.00501 -11.29688,10.96876 0,1.37772 -1.33285,3.71175 -2.96251,5.18671 -1.62966,1.47498 -2.60253,3.2676 -2.16093,3.98203 0.44149,0.71443 3.18679,1.29844 6.09843,1.29844 6.29353,0 10.92201,-4.57901 16.86798,-16.68515 2.14335,-4.36376 4.80535,-8.20751 5.91798,-8.54297 1.46176,-0.44074 1.30279,0.49235 -0.57656,3.36094 -1.43047,2.18335 -2.18925,4.38027 -1.68516,4.88437 1.68135,1.68155 5.36553,-2.72249 9.10077,-10.88203 2.03316,-4.44158 5.34434,-10.27826 7.35938,-12.97031 5.26885,-7.03883 8.77163,-14.44843 8.21015,-17.36485 -0.0782,-0.40622 -0.25067,-0.58216 -0.51327,-0.53671 z m -179.78674,0.98906 c 1.01344,-0.19985 0.76499,1.20802 -1.27968,4.32891 -2.53605,3.8709 -12.33104,11.53251 -11.3414,8.87109 0.32077,-0.86264 3.16493,-4.41038 6.32108,-7.88203 3.01039,-3.31133 5.28658,-5.11813 6.3,-5.31797 z m 266.1211,0.81328 c -2.00708,2.01621 -3.06093,3.78553 -3.06093,5.20781 0,1.18945 0.90615,1.84074 3.06093,2.10469 l 0,-7.3125 z M 356.916,547.48813 c -3.44658,0.0353 0.15715,3.02998 9.09843,6.97969 11.72476,5.17926 13.91604,8.83189 10.67578,17.79374 -0.99221,2.75692 -1.44761,5.60187 -1.00312,6.3211 0.44437,0.71923 -0.51229,2.50057 -2.12578,3.96093 -3.14826,2.84946 -5.37333,11.27716 -3.95391,14.97657 1.31928,3.43821 3.21031,2.75832 8.22657,-2.95547 4.90515,-5.58777 7.93485,-15.95336 4.95234,-16.94766 -1.2057,-0.40194 -1.04727,-1.53448 0.52734,-3.78281 1.23567,-1.76441 2.24532,-6.32718 2.24532,-10.13906 0,-8.59474 -3.17847,-11.87409 -13.10626,-13.5211 -3.9228,-0.65079 -9.32491,-1.64541 -12.00468,-2.2125 -1.56745,-0.33168 -2.73667,-0.48158 -3.53203,-0.47343 z m 49.68046,2.32266 c -0.56731,0.0168 -1.5959,0.40538 -3.2414,1.02656 -6.14314,2.31904 -11.5616,8.40342 -12.74297,14.31094 -0.91353,4.56811 -0.75786,4.85876 1.84688,3.44296 4.94069,-2.68557 12.2759,-10.73092 13.81875,-15.15703 0.92393,-2.65077 1.26427,-3.65142 0.31874,-3.62343 z m -144.51563,6.49687 c -2.62723,-0.006 -2.65006,0.2165 -0.375,3.68906 5.49767,8.39142 1.45784,14.1919 -10.95234,15.72657 -10.31573,1.27566 -9.25162,4.06705 1.35,3.5414 14.53346,-0.7206 10.83405,2.93625 -7.85156,7.76016 -7.39893,1.91012 -15.06354,5.21889 -22.20469,9.37734 l 0,4.85624 c 7.79779,-4.79387 16.62328,-8.64859 26.05079,-11.20077 5.51696,-1.49355 10.03124,-3.29151 10.03124,-3.99375 0,-0.70225 3.01198,-1.275 6.69376,-1.275 9.07353,0 17.68286,-7.09672 16.99687,-14.01094 -0.37116,-3.74114 -1.94266,-5.46134 -8.69766,-9.51562 -4.53501,-2.72189 -9.50361,-4.95229 -11.04141,-4.95469 z m 244.10862,1.49766 c -11.51125,0.007 -16.41596,2.98998 -25.05704,15.2414 -13.06116,18.51805 -20.50217,35.21298 -22.93829,51.45937 -1.6356,10.90907 1.69885,7.99621 4.65469,-4.0664 3.43716,-14.02717 13.59514,-34.20466 23.76094,-47.19844 8.05452,-10.29519 8.06204,-10.3014 15.98672,-10.56796 4.82317,-0.16226 8.82911,-1.16724 10.23047,-2.56876 2.07192,-2.07217 1.40502,-2.30401 -6.63749,-2.29921 z m -71.7797,2.06484 c -1.85604,0.0614 -8.16378,9.52765 -12.53203,19.00079 -2.45124,5.31619 -6.82998,12.19857 -9.72892,15.2953 -2.89904,3.09673 -5.68497,7.84273 -6.19218,10.54687 -1.10424,5.88632 -5.05948,11.95275 -7.00782,10.74844 -0.76817,-0.47478 -1.39452,0.22093 -1.39452,1.54687 0,1.38294 2.71533,3.64466 6.3703,5.30392 7.84215,3.56012 7.02677,3.57006 10.96877,-0.1336 2.8682,-2.69492 3.10518,-3.80337 1.84686,-8.62266 -3.30276,-12.64997 -3.22982,-13.73443 1.36407,-20.24297 5.41427,-7.67101 17.67575,-32.26711 16.61484,-33.32812 -0.0823,-0.0823 -0.18563,-0.11892 -0.30937,-0.11484 z m 87.63749,0.69375 c -3.84499,1.00042 -7.9091,2.35385 -10.71093,3.63047 -4.45068,2.02782 -9.76476,4.21204 -11.81015,4.85391 -6.53317,2.05014 -12.10614,7.2252 -19.08282,17.7164 -6.74928,10.14914 -13.45548,25.0125 -11.28516,25.0125 1.37976,0 4.01167,-4.11985 9.60703,-15.03984 4.84704,-9.45945 16.85034,-23.74649 18.55782,-22.0875 0.62724,0.60934 -2.33728,4.78596 -6.58828,9.28124 -7.28663,7.70527 -9.35984,11.35313 -6.45704,11.35313 0.699,0 5.07718,-3.99373 9.73127,-8.87344 4.65395,-4.8797 8.82744,-8.28145 9.2742,-7.55859 0.44665,0.72289 -3.45576,5.5608 -8.6742,10.74843 -10.43844,10.37674 -13.74613,14.73783 -19.64533,25.9125 -3.14592,5.95944 -3.95155,6.73793 -3.95155,3.82266 0,-11.87727 -11.40114,17.16423 -14.99766,38.20313 -1.76179,10.30602 -2.6987,15.58287 -3.90937,18.64218 l 12.0164,0 -0.15703,-3.33047 c -0.60384,-12.77844 -0.25073,-21.8444 1.13203,-28.9664 1.10688,-5.70171 2.26654,-9.18688 2.57578,-7.74376 0.94188,4.39657 2.76795,2.95575 4.74843,-3.74765 3.96984,-13.43731 12.58176,-27.06946 24.44532,-38.69765 6.39504,-6.26798 11.62735,-11.91573 11.62735,-12.55078 0,-1.44061 8.54632,-10.0031 13.55389,-13.91953 l 0,-6.66094 z m -219.77577,7.78359 c -1.89137,-0.005 -4.00435,0.28199 -6.2039,0.87188 -2.34228,0.62817 -3.4213,2.22576 -3.74766,5.55234 -0.7816,7.9665 -12.17277,13.31588 -38.47033,18.06563 -11.79612,2.13056 -22.64101,6.43435 -31.80234,12.22734 l 0,4.63593 c 12.1992,-8.67244 26.37353,-12.72615 48.72422,-14.47968 15.95169,-1.2515 18.19563,-1.12998 20.70001,1.13672 3.65089,3.30436 20.01533,4.4053 28.82577,1.93828 13.7127,-3.83973 17.10033,-14.57026 6.39376,-20.25469 l -5.64844,-3 -3.82969,4.875 c -5.035,6.40507 -15.39448,12.36797 -21.48516,12.36797 -6.73135,0 -5.26627,-3.13992 2.8711,-6.15 8.06453,-2.98312 13.92101,-11.47119 10.64062,-15.42422 -1.28067,-1.54327 -3.8157,-2.35511 -6.96796,-2.3625 z m 131.31094,2.94609 c -1.20576,0 -6.01117,9.0628 -6.08437,11.47266 -0.0211,0.70001 -2.33582,4.87773 -5.14453,9.28594 -5.59752,8.78549 -5.52354,10.22676 0.94686,18.19219 4.63717,5.70857 5.49266,12.11593 2.00391,15.01171 -3.4578,2.87002 -1.23336,4.51172 6.11484,4.51172 4.99355,0 6.9692,0.67088 7.73672,2.625 0.74292,1.89137 1.30714,0.96096 2.02031,-3.33282 1.30932,-7.88181 1.29978,-7.91534 -4.45781,-16.27264 -4.89708,-7.10854 -5.35012,-10.18415 -2.80312,-19.00313 2.4774,-8.57795 2.8808,-10.73166 2.15156,-11.46094 -1.12321,-1.12345 -6.41795,9.57119 -7.71563,15.5836 -0.57841,2.68006 -1.6738,4.87265 -2.43281,4.87265 -2.36639,0 -1.4963,-4.93227 2.31094,-13.11094 4.42044,-9.49562 7.00601,-18.375 5.35313,-18.375 z m 88.46483,2.37891 c -1.41458,0.87228 -1.22784,1.52978 0,2.80782 l 0,-2.80782 z m -0.9703,8.43516 c -2.68694,-0.46569 -13.69963,6.82382 -22.5211,15.05625 -11.36112,10.60235 -18.12873,20.39781 -22.82109,33.03515 -3.23604,8.71538 -4.32099,23.58386 -2.11875,29.05782 0.7026,1.74595 1.489,-1.40588 2.15859,-8.65313 2.19804,-23.78675 11.70858,-40.16532 33.14299,-57.075 7.31927,-5.77427 12.98233,-10.8254 12.58357,-11.22422 -0.10199,-0.102 -0.24509,-0.16583 -0.42421,-0.19687 z M 354.36365,583.31 c -8.0503,0.0409 -10.58897,1.53148 -11.07187,6.50391 -0.4038,4.15801 -1.5973,5.27946 -10.0172,9.42421 -9.40153,4.62798 -9.92671,4.70657 -32.23124,4.79297 -23.59453,0.0913 -34.47115,1.90152 -45.5836,7.58437 -7.14109,3.65193 -13.8211,9.85546 -13.8211,12.83439 0,1.80729 1.78693,2.3203 8.07423,2.3203 6.9458,0 8.41442,-0.52052 10.5164,-3.7289 5.75045,-8.77725 24.27524,-13.53938 46.36173,-11.91797 l 13.78828,1.01015 19.03592,-9.03749 c 15.57748,-7.39659 19.20703,-9.72908 19.98751,-12.83906 1.2631,-5.03312 -0.14417,-6.97184 -5.03906,-6.94688 z m -119.89922,0.13594 c -2.61848,0.0937 -7.20158,1.81626 -12.41719,4.60078 l 0,4.5539 c 2.32446,-1.38603 4.77154,-2.77027 7.37813,-4.16484 4.41444,-2.36179 7.2873,-4.53884 6.38437,-4.83984 -0.35974,-0.11988 -0.81173,-0.1691 -1.34531,-0.15 z m 287.58281,4.51641 c -2.27463,1.20743 -4.6619,2.60465 -7.07577,4.1789 -20.9892,13.68869 -35.12111,34.89464 -36.22032,54.34921 -0.7644,13.52962 0.71498,22.66818 4.43906,27.40313 0.75312,0.95753 1.40654,1.70384 1.97579,2.2875 l 2.42345,0 c -0.19188,-1.16664 -0.83497,-3.02784 -1.98047,-5.55703 -2.42317,-5.3503 -3.23491,-10.1046 -3.26251,-19.11563 -0.0324,-10.46998 0.58595,-13.31695 4.86563,-22.4039 7.35111,-15.60845 17.24856,-26.14195 34.83514,-36.6 l 0,-4.54218 z m 0,8.34608 c -10.04713,5.82538 -19.06394,13.34831 -24.80155,21.14532 -12.07921,16.41502 -15.18508,37.61838 -7.67811,52.43437 1.16573,2.30068 2.56423,4.55752 3.83436,6.29297 l 5.26171,0 c -0.01,-0.008 -0.0162,-0.0155 -0.0258,-0.0234 -5.66544,-4.70242 -8.83507,-13.86901 -8.82187,-25.50937 0.0108,-9.75947 0.69497,-12.74036 4.87265,-21.22735 5.36918,-10.90751 15.08847,-20.75775 27.35859,-28.26563 l 0,-4.84688 z m -249.15234,0.39376 c -14.09959,0.15563 -33.54095,8.1413 -43.96876,18.87187 -3.72668,3.83491 -6.77577,7.58541 -6.77577,8.33437 0,1.8752 4.04763,1.70881 7.84453,-0.32344 1.7327,-0.92743 6.6866,-4.56758 11.0086,-8.08827 8.52291,-6.94274 21.01645,-12.31114 31.95233,-13.72734 9.71863,-1.25855 12.53213,-2.95938 7.13203,-4.31485 -2.15337,-0.54052 -4.58193,-0.78117 -7.19296,-0.75234 z m 85.20938,4.57969 c -3.20985,0 -31.01496,11.95302 -31.01016,13.33124 0.001,0.5008 -7.92556,0.68518 -17.61563,0.41016 -27.28741,-0.77445 -40.85391,3.61228 -40.85391,13.20703 0,3.14612 1.25903,5.04724 4.87266,7.36172 2.67977,1.71636 6.68179,3.13422 8.89453,3.14766 3.26248,0.0205 4.11297,-0.74008 4.49766,-4.02423 0.32484,-2.77321 2.12804,-5.01905 5.7211,-7.12265 4.74262,-2.77659 7.41047,-3.04026 27.73594,-2.72812 32.8224,0.50402 47.22421,-3.99682 47.22421,-14.76328 0,-4.48481 -4.65364,-8.81953 -9.4664,-8.81953 z m 163.94296,3.68437 c -17.56987,11.05271 -28.99995,27.57542 -29.17732,44.79374 -0.0523,5.08529 0.82607,11.43869 1.95,14.11876 2.85707,6.81253 5.33983,6.312 3.72186,-0.75 -4.02431,-17.56652 1.04898,-33.33914 14.95312,-46.49063 2.79059,-2.63952 5.61612,-4.9731 8.55234,-7.04766 l 0,-4.62421 z m -133.79062,2.31328 c -1.96911,-0.0394 -4.26976,0.26094 -6.82031,0.94453 -2.45301,0.65744 -3.37266,2.01968 -3.37266,4.99453 0,7.20924 -8.73411,12.21059 -27.63515,15.82735 -5.87602,1.12439 -12.508,2.73964 -14.73985,3.58828 -4.5021,1.71188 -4.35967,2.85729 1.87266,15.075 1.69695,3.32661 3.65781,6.04921 4.35937,6.04921 0.70158,0 1.71464,-3.30206 2.25,-7.33828 0.53537,-4.0362 1.80338,-7.99452 2.81719,-8.79374 1.01383,-0.79921 5.83587,-1.90075 10.71797,-2.44922 10.86843,-1.22102 20.00519,-5.11389 26.43751,-11.26173 2.67237,-2.55405 5.78657,-4.64297 6.91874,-4.64297 1.13218,0 2.81714,-1.66593 3.74531,-3.70311 2.27908,-5.0025 -0.64345,-8.17166 -6.55078,-8.28985 z m -162.69141,5.10235 c -0.84147,0.059 -2.08275,0.55265 -3.51797,1.34062 l 0,4.40391 c 2.8212,-2.86014 4.75393,-5.19525 4.45079,-5.49845 -0.19776,-0.19777 -0.51642,-0.27531 -0.93282,-0.24608 z m 296.48203,1.25155 c -3.55302,1.91374 -8.38365,5.72281 -11.36249,9.3586 -4.82999,5.89497 -9.68906,15.28297 -9.68906,18.72188 0,3.72712 3.06557,0.9242 7.41329,-6.78048 2.58467,-4.5804 7.8233,-11.32258 11.64373,-14.98358 0.71994,-0.6899 1.35995,-1.34074 1.99453,-1.9875 l 0,-4.32892 z m 0,10.08516 c -0.0196,0.0619 -0.0632,0.147 -0.0632,0.18984 0,0.13106 0.0252,0.24978 0.0632,0.36095 l 0,-0.55079 z m -127.86092,1.75547 c -2.84349,-0.0653 -5.46187,1.3388 -8.79845,4.30079 -5.53771,4.916 -15.66044,8.53322 -27.92344,9.975 -8.92173,1.04893 -10.66997,2.53488 -11.90156,10.125 -1.06009,6.5333 1.21249,7.09774 3.55781,0.88358 0.9337,-2.47388 2.36634,-4.49765 3.18282,-4.49765 3.13428,0 -4.04308,14.12539 -9.94688,19.57734 -4.06032,3.74958 -6.29999,6.82243 -7.20704,10.34297 l 6.91407,0 c 0.54353,-0.75192 1.11294,-1.40469 1.67345,-1.8586 3.32355,-2.69154 3.43436,-2.67797 5.31561,0.7125 0.25642,0.46211 0.46998,0.83237 0.66329,1.1461 l 1.17421,0 c 0.11028,-0.83207 0.15301,-2.24493 0.1875,-4.43203 0.0584,-3.71087 1.06351,-8.43372 2.2336,-10.49531 1.99141,-3.50871 2.0736,-3.25395 1.25625,3.97968 -0.42622,3.77222 -0.4711,7.5003 -0.18516,10.94766 l 3.69142,0 c -1.01039,-6.25605 -0.59868,-12.40261 1.27029,-18.14297 3.22613,-9.90859 6.04718,-13.28354 11.08126,-13.2539 6.63235,0.0391 8.18297,1.96783 7.08751,8.81953 -1.18496,7.41104 0.70183,7.93155 4.63123,1.27734 2.21543,-3.75172 4.57831,-5.32438 10.26798,-6.83906 14.21244,-3.78353 18.94342,-13.88888 9.26484,-19.79062 -2.93045,-1.78694 -5.27903,-2.72658 -7.49061,-2.77735 z m -78.18048,2.79375 c -4.05603,0 -16.09404,5.96807 -15.14297,7.50704 0.521,0.8431 3.4303,2.8129 6.46641,4.37811 11.19702,5.77247 22.65934,22.82807 20.66953,30.75702 -0.46827,1.8659 -0.37686,3.86762 0.2039,4.44844 1.76506,1.76527 4.88673,-3.88563 4.88673,-8.84765 0,-6.42823 -6.64767,-19.19323 -12.81563,-24.60937 -3.06629,-2.69252 -4.47671,-4.89179 -3.51797,-5.48438 1.96091,-1.21205 11.20546,7.44525 14.5125,13.5914 1.98374,3.68678 2.52452,4.00333 3.00234,1.75549 0.32065,-1.50833 -0.22738,-4.69489 -1.2164,-7.08282 -2.09282,-5.05308 -13.89195,-16.41328 -17.04844,-16.41328 z m 203.85704,1.5 c -3.33541,0 -13.65734,12.70199 -15.6047,19.20234 -3.27129,10.91981 -1.96912,20.01678 3.85782,27.21094 l 6.68438,0 c -4.91338,-3.32733 -7.80703,-9.58931 -7.80703,-17.17734 0,-6.31934 5.60614,-18.00506 11.0953,-23.12579 4.35205,-4.05998 4.94702,-6.11015 1.77423,-6.11015 z m -286.45079,0.21094 c -2.24085,0.11676 -5.5797,1.5512 -8.83125,3.83671 -0.8813,0.61947 -1.72312,1.27231 -2.5336,1.94766 l 0,6.70782 c 2.11508,-2.28441 4.625,-4.44505 7.53282,-6.39141 7.37346,-4.93545 7.90668,-5.61782 4.72265,-6.06797 -0.27177,-0.0384 -0.57051,-0.0494 -0.89062,-0.0328 z m 17.66249,1.41797 c -3.31978,-0.0862 -7.47431,0.86159 -12.81328,2.85937 -6.84758,2.56229 -12.41545,6.68201 -16.21406,11.48906 l 0,26.61328 c 0.97783,-0.57348 1.34143,-3.34242 0.72656,-7.97812 -1.11182,-8.3822 1.30785,-14.19547 8.38829,-20.1539 4.99864,-4.2065 17.22485,-8.43114 24.6164,-8.50782 4.36929,-0.0452 4.45384,-0.1592 1.68984,-2.25 -1.73494,-1.31238 -3.8117,-2.00482 -6.39375,-2.07187 z m 176.65314,1.38984 c -7.96105,0.0414 -10.68515,1.58378 -10.68515,6.04453 0,6.89021 -12.12949,13.80318 -26.88283,15.3211 -4.20692,0.43282 -5.68495,1.56907 -8.10703,6.23672 -2.28182,4.39741 -3.58313,10.28147 -3.73123,15.79218 l 4.25623,0 c -0.004,-0.19906 -0.0164,-0.39444 -0.0164,-0.59531 0,-5.36286 5.59717,-18.82969 7.82579,-18.82969 0.67701,0 -0.0766,2.56223 -1.67345,5.69297 -2.44645,4.79594 -3.72958,9.47222 -3.9117,13.73203 l 4.90546,0 c 0.13777,-3.99702 1.55613,-8.33951 4.28437,-13.05234 2.48444,-4.29145 4.71211,-6.37266 6.82501,-6.37266 2.87781,0 2.7963,0.26921 -0.99376,3.25079 -5.04781,3.97104 -7.87374,10.08523 -8.00624,16.17421 l 6.02811,0 c -0.0781,-3.59729 0.70134,-5.54848 2.9625,-8.8711 3.5967,-5.28494 14.01149,-13.4121 17.30157,-13.50234 6.10801,-0.16755 10.5729,13.88069 5.69766,17.92734 -2.90178,2.4084 -1.65644,4.1245 2.94141,4.4461 l 2.89687,0 c 8.61018,-0.67905 12.186,-8.22783 7.66171,-16.90313 -1.21236,-2.3244 -2.33403,-8.39799 -2.49374,-13.49531 -0.33456,-10.68166 -1.61185,-13.02465 -7.08516,-12.99609 z m 94.31952,2.84297 c -13.88292,11.44071 -17.40417,30.51407 -6.56953,39.03749 0.75397,0.59314 1.42967,1.0864 2.05547,1.51407 l 3.96094,0 c -0.48878,-1.09455 -1.54725,-2.67079 -3.25781,-4.70391 -6.87864,-8.17574 -5.00656,-19.79787 3.81093,-29.19375 l 0,-6.6539 z m -266.16563,4.14375 c -11.79344,-0.11832 -20.57846,3.38257 -26.09531,10.39687 -3.91598,4.9789 -4.20063,11.09244 -0.51562,11.06016 3.65852,-0.032 6.34548,-1.9748 8.38359,-6.06328 4.81415,-9.65729 23.69708,-12.59506 39.56953,-6.15468 6.04873,2.45431 8.7385,2.85027 11.71641,1.71796 6.35063,-2.41478 10.53024,-1.69756 14.76094,2.5336 4.8586,4.85912 2.51586,7.40166 -3.80624,4.13203 -4.71393,-2.43794 -11.78204,-2.85422 -11.78204,-0.69375 0,0.79533 -3.03883,0.14354 -6.75235,-1.44844 -10.19037,-4.36855 -20.02875,-5.2471 -26.84765,-2.39766 -4.97033,2.07696 -5.48075,2.71968 -3.7875,4.76016 3.01578,3.63416 13.09315,8.3499 14.15859,6.62577 1.35202,-2.18786 10.55937,-1.81132 16.50937,0.675 3.7966,1.5865 9.36473,5.16333 17.54298,11.26407 l 28.8703,0 c -1.23915,-1.51103 -2.21483,-3.64895 -2.21483,-4.94064 0,-7.57115 -11.32547,-22.8071 -20.67422,-27.81093 -3.12303,-1.67157 -26.73259,-3.4325 -49.03595,-3.65625 z m 185.04143,4.9875 c -2.25312,0 -1.59904,8.42371 1.1906,15.3375 1.68277,4.1703 2.7648,5.49296 3.10548,3.78984 0.76692,-3.83334 -2.66792,-19.12734 -4.29608,-19.12734 z m 81.1242,0.78281 c -5.76753,7.17497 -7.57571,15.92162 -3.74529,23.32969 1.59745,3.08946 2.92905,4.11694 3.74529,3.37266 l 0,-26.70235 z m -147.46874,3.91172 c -0.21722,0.0148 -0.46884,0.055 -0.75702,0.11016 -4.65469,0.89077 -6.71922,15.91706 -4.56564,26.61563 l 4.28203,0 c -1.39774,-8.16422 -1.21749,-14.1712 0.55314,-19.88671 1.79996,-5.81027 2.00802,-6.94232 0.48749,-6.83906 z m -8.68126,1.99688 c -0.99603,-0.0749 -2.68194,1.98349 -3.83436,5.75156 -1.54466,5.05051 -1.34177,12.18149 0.005,18.97734 l 4.18828,0 c -1.25871,-6.54426 -1.33372,-13.89229 0.13827,-20.48203 0.63427,-2.83967 0.27784,-4.18865 -0.49687,-4.24687 z m 102.90001,1.73437 c -1.39254,0.13616 -0.87577,12.45381 0.79687,22.99453 l 6.56719,0 c -0.89874,-2.63997 -1.69574,-5.24913 -2.2664,-7.54218 -1.72548,-6.93387 -3.7335,-13.62458 -4.4625,-14.86876 -0.24433,-0.41691 -0.45575,-0.60114 -0.63516,-0.58359 z m -56.47032,8.07187 c -1.61326,0.14028 -3.86592,1.60057 -6.39609,4.60782 -2.13458,2.53716 -3.8789,6.24932 -3.8789,8.24766 0,0.8283 0.12358,1.51251 0.34452,2.06718 l 6.89531,0 c 1.58093,-1.28545 3.08468,-3.21263 4.10626,-5.65782 2.53273,-6.06227 1.61768,-9.49861 -1.0711,-9.26485 z m -167.70469,1.61251 c -8.26784,0.1995 -15.90113,3.82038 -17.30156,9.40078 -0.29937,1.19288 -0.46623,2.54788 -0.52265,3.90937 l 5.58515,0 c 0.88483,-1.96488 2.12319,-3.8127 3.30469,-4.76953 4.01642,-3.25264 14.92605,-3.53505 20.6414,-0.53438 1.82544,0.9584 4.30406,2.9345 6.82734,5.30391 l 7.23516,0 c -3.84212,-4.67922 -9.2185,-9.0648 -14.62734,-11.32501 -3.49363,-1.45988 -7.38408,-2.07584 -11.14219,-1.98514 z m 30.7664,8.24062 c -0.73716,0.0353 -1.25342,0.2101 -1.4625,0.54843 -0.21674,0.35076 0.30531,2.14506 1.20939,4.5211 l 14.80078,0 c -4.41017,-2.89285 -11.43699,-5.21866 -14.54767,-5.06953 z m -29.21953,1.13672 c -1.89277,0.004 -3.7283,0.38884 -5.4539,1.21406 -1.13278,0.54172 -2.23588,1.50908 -3.24375,2.71875 l 20.00391,0 c -3.70772,-2.48308 -7.61304,-3.93925 -11.30626,-3.93281 z"
       style="fill:{{pk_fill}}" />
  </g>
</svg>
`, vT = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (http://www.inkscape.org/) -->
<!-- ClipArt by Arvin61r58 (http://openclipart.org/user-detail/Arvin61r58) -->

<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   version="1.1"
   id="svg2"
   viewBox="0 0 318 318"
   height="{{pk_dimension}}"
   width="{{pk_dimension}}">
  <title
     id="title4170">Alternating Tile Pattern</title>
  <defs
     id="defs4">
      {{pk_gradient}}
   </defs>
  <metadata
     id="metadata7">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title>Alternating Tile Pattern</dc:title>
        <dc:creator>
          <cc:Agent>
            <dc:title>Arvin61r58</dc:title>
          </cc:Agent>
        </dc:creator>
        <dc:publisher>
          <cc:Agent>
            <dc:title>Openclipart.org</dc:title>
          </cc:Agent>
        </dc:publisher>
        <dc:identifier>https://openclipart.org/</dc:identifier>
        <dc:source>https://openclipart.org/user-detail/Arvin61r58</dc:source>
        <dc:description>alternating black and white tile pattern</dc:description>
        <dc:subject>
          <rdf:Bag>
            <rdf:li>pattern</rdf:li>
            <rdf:li>tile</rdf:li>
            <rdf:li>seamless</rdf:li>
            <rdf:li>tileable</rdf:li>
          </rdf:Bag>
        </dc:subject>
        <cc:license
           rdf:resource="http://creativecommons.org/publicdomain/zero/1.0/" />
      </cc:Work>
      <cc:License
         rdf:about="http://creativecommons.org/publicdomain/zero/1.0/">
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#Reproduction" />
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#Distribution" />
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#DerivativeWorks" />
      </cc:License>
    </rdf:RDF>
  </metadata>
  <g
     transform="translate(-212.04725,-366.18202)"
     id="layer1">
    <path
       id="path4147"
       d="m 220.22692,366.18202 -1.26562,1.27343 36.84767,36.86314 36.84571,36.86117 9.99999,-9.99995 9.99999,-9.99801 -36.23242,-36.24987 c -7.00275,-7.00581 -13.2737,-13.18981 -18.95508,-18.74991 l -37.24024,0 z m 51.28126,0 c 3.64847,3.69461 7.40764,7.49175 11.46875,11.55463 19.76118,19.76993 36.22748,35.94519 36.59179,35.94519 0.36432,0 5.00397,-4.36718 10.31055,-9.70505 l 9.64844,-9.70505 -28.10156,-28.08972 -39.91797,0 z m 53.65821,0 21.23828,21.24796 9.99999,-9.99995 10.00002,-9.99801 -1.25001,-1.25 -39.98828,0 z m 55.02539,0 -1.25196,1.25194 36.84964,36.86509 36.84765,36.86315 9.71874,-9.66208 9.71874,-9.66012 -36.88476,-36.88463 -18.77343,-18.77335 -36.22462,0 z m 49.98439,0 11.24804,11.25189 c 19.92824,19.93703 36.78518,36.24793 37.46095,36.24793 1.64509,0 19.41211,-17.71154 19.41211,-19.35151 0,-0.59186 -11.5878,-12.65564 -26.9375,-28.14831 l -41.1836,0 z m 54.99025,0 21.23828,21.24796 9.99999,-9.99995 10.00001,-9.99801 -1.25001,-1.25 -39.98827,0 z m -112.51176,7.50193 -36.84568,36.86116 -36.84767,36.86314 9.32423,9.38667 c 5.12824,5.16267 9.90412,9.38671 10.61328,9.38671 0.70914,0 17.59517,-16.31283 37.52343,-36.24986 l 36.23242,-36.24792 -9.99999,-9.99995 -10.00002,-9.99995 z m -159.95899,1.24803 c -0.0658,0 -0.3145,0.18428 -0.64843,0.45509 l 0,38.91388 20.59179,-20.58973 -9.32812,-9.39062 c -5.12968,-5.16413 -9.9061,-9.38862 -10.61524,-9.38862 z m 319.3516,0.45509 c -3.26399,2.64705 -18.78964,17.70337 -36.86329,35.785 l -36.22461,36.23814 9.9668,10.02339 9.96484,10.02535 36.87306,-36.87485 16.2832,-16.28315 0,-38.91388 z m -132.52151,25.20693 -36.8535,36.83773 -36.85546,36.83971 9.64841,9.70504 c 5.3066,5.33787 9.94631,9.70504 10.31057,9.70504 0.36425,0 17.11758,-16.46237 37.22852,-36.58189 l 36.56444,-36.57994 -10.02149,-9.96286 -10.02149,-9.96283 z m -160.00392,0.004 -27.4746,27.46278 0,41.24203 10.84179,-10.83785 c 28.4488,-28.43641 36.2648,-36.92117 35.41994,-38.44908 -0.59623,-1.07823 -5.06735,-5.88835 -9.93555,-10.68941 l -8.85158,-8.72869 z m 292.52543,27.46278 -9.37891,9.37495 -36.85351,36.83582 10.28711,10.33979 10.28515,10.33979 25.66016,-25.64832 0,-41.24203 z m -265.00199,0.0132 -36.86328,36.8475 -18.13476,18.1269 0,37.5604 0.59374,0.59763 36.88478,-36.8846 36.88476,-36.88268 -9.68359,-9.68355 -9.68165,-9.6816 z m 159.4004,0.60742 c -0.70913,0 -17.58949,16.30711 -37.51171,36.23812 l -36.22266,36.23815 9.32421,9.38668 c 5.12822,5.16264 9.90415,9.38669 10.61329,9.38669 0.70916,0 17.58952,-16.30713 37.51172,-36.23816 l 36.22267,-36.23812 -9.32423,-9.38668 c -5.12819,-5.16265 -9.90412,-9.38668 -10.61329,-9.38668 z m -133.79687,26.25013 c -0.70915,0 -5.48503,4.22402 -10.6133,9.38668 l -9.32421,9.38668 36.84765,36.86119 36.84572,36.86314 9.99999,-9.99996 10.00002,-9.99997 -36.23242,-36.24986 c -19.92826,-19.93693 -36.8143,-36.2478 -37.52345,-36.2478 z m 160.00002,0 c -0.70915,0 -5.48506,4.22402 -10.6133,9.38668 l -9.32421,9.38668 36.84765,36.86119 36.84573,36.86314 9.99999,-9.99996 10.00001,-9.99997 -36.23244,-36.24986 c -19.92823,-19.93738 -36.81428,-36.24825 -37.52343,-36.24825 z m -186.84962,25.64443 -10.30471,10.30466 -10.30468,10.30269 36.23438,36.24984 c 19.92822,19.93703 36.78517,36.24986 37.46094,36.24986 1.64512,0 19.41212,-17.71153 19.41212,-19.35147 0,-0.70914 -16.31094,-17.59515 -36.24805,-37.5233 l -36.25,-36.23194 z m 160.02149,0.0199 -9.38673,9.32418 c -5.16268,5.12822 -9.38672,9.89729 -9.38672,10.59762 0,0.70032 16.16853,17.4487 35.92969,37.2186 19.7612,19.76993 36.22746,35.94516 36.5918,35.94516 0.36432,0 5.00397,-4.36717 10.31055,-9.70502 l 9.64843,-9.70505 -36.85349,-36.83776 -36.85353,-36.83773 z m 106.22657,2.45311 -18.73047,18.72259 9.66211,9.71674 9.06836,9.12108 0,-37.56041 z m -293.74222,25.02138 -9.68163,9.68357 -9.68361,9.68159 36.84963,36.86314 36.84765,36.86507 9.71874,-9.66205 9.71875,-9.66208 -36.88476,-36.88461 -36.88477,-36.88463 z m 160.59376,0.61328 c -0.70914,0 -5.48502,4.22403 -10.61326,9.3867 l -9.32423,9.38667 36.84767,36.86118 36.84569,36.86313 10.00002,-9.99995 9.99999,-9.99995 -36.23242,-36.24987 C 416.494,524.99468 399.60797,508.68382 398.89881,508.68382 Z m -186.24414,25.00186 -0.60743,0.60741 0,40.00963 20.60741,-20.61711 -9.99999,-9.99995 -9.99999,-9.99998 z m 319.3926,0.60741 -36.2383,36.25573 -36.84763,36.86313 9.32422,9.38474 c 5.12824,5.16267 9.90412,9.38668 10.61326,9.38668 0.70916,0 17.5952,-16.31138 37.52346,-36.2479 l 15.62499,-15.63275 0,-40.00963 z m -159.35158,0.64061 c -0.70917,0 -17.58897,16.30855 -37.51174,36.24013 l -36.2246,36.23812 9.9668,10.02535 9.96483,10.02341 36.87307,-36.87487 36.87499,-36.87288 -9.32811,-9.39061 c -5.12967,-5.1641 -9.90609,-9.38865 -10.61524,-9.38865 z m -133.16994,25.66204 -27.47851,27.46864 0,39.96077 c 3.52526,-3.50632 7.09097,-7.05421 10.95704,-10.92183 l 36.56444,-36.58189 -10.02149,-9.96286 -10.02148,-9.96283 z m 159.99611,0.007 -36.85351,36.83579 -36.85352,36.83774 10.28711,10.33981 10.28514,10.33785 36.50198,-36.48618 c 28.44879,-28.43641 36.26478,-36.91925 35.41993,-38.44713 -0.59624,-1.07824 -5.06736,-5.88836 -9.93556,-10.6894 l -8.85157,-8.72848 z m 132.52541,27.46277 -9.37499,9.37105 -36.85549,36.83777 9.64844,9.70502 c 5.3066,5.3379 9.9463,9.70504 10.31054,9.70504 0.29425,0 11.45859,-10.92475 26.2715,-25.65809 l 0,-39.96079 z m -105.00197,0.011 -36.86329,36.84944 -36.86521,36.84754 9.66209,9.71871 9.66211,9.71871 36.88476,-36.88463 36.88478,-36.88462 -9.6836,-9.68161 -9.68164,-9.68354 z m -160.59963,0.6074 c -0.70914,0 -17.5895,16.30711 -37.51172,36.23816 l -16.88671,16.89447 0,37.82015 c 0.27434,0.17699 0.4958,0.29686 0.60156,0.29686 0.70914,0 17.58952,-16.30711 37.51173,-36.23814 l 36.22264,-36.23812 -9.32421,-9.38668 c -5.1282,-5.16265 -9.90413,-9.3867 -10.61329,-9.3867 z m 26.20314,26.2499 c -0.70915,0 -5.48503,4.22402 -10.6133,9.38669 l -9.32421,9.38668 36.84765,36.86313 15.60548,15.61129 39.98827,0 -34.98044,-34.99792 c -19.92826,-19.93696 -36.8143,-36.2498 -37.52345,-36.2498 z m 160.00002,0 c -0.70915,0 -5.48506,4.22402 -10.6133,9.38669 l -9.32421,9.38668 36.84765,36.86313 15.60549,15.61129 39.98827,0 -34.98047,-34.99792 c -19.92823,-19.93703 -36.81428,-36.24987 -37.52343,-36.24987 z m -26.8496,25.64249 -10.3047,10.30464 -10.30471,10.30466 24.98441,24.996 41.18357,0 c -3.04086,-3.06922 -6.01217,-6.07613 -9.3086,-9.37106 l -36.24997,-36.23417 z m -159.97855,0.0221 -9.38673,9.32418 c -5.16268,5.12822 -9.38671,9.8973 -9.38671,10.5976 0,0.55638 10.3551,11.37973 24.45898,25.66202 l 39.91798,0 -8.75,-8.74607 -36.85352,-36.83773 z m 266.22659,1.21874 -19.33594,19.34368 9.32421,9.38668 c 4.3634,4.39268 8.4465,8.07996 10.01173,9.08982 l 0,-37.82018 z m -133.7422,26.25575 -9.68165,9.68161 -8.42968,8.4277 36.2207,0 -18.10937,-18.10931 z m -159.40626,0.61137 c -0.70916,0 -5.48505,4.22397 -10.61328,9.38668 l -8.05665,8.1113 37.23631,0 C 246.97977,675.91967 239.35873,668.6833 238.89881,668.6833 Z"
       style="fill:{{pk_fill}}" />
  </g>
</svg>
`, yT = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   version="1.1"
   id="svg4226"
   viewBox="0 0 255.99994 256"
   height="{{pk_dimension}}"
   width="{{pk_dimension}}">
  <title
     id="title4820">Tileable Wave Pattern 2</title>
  <defs id="defs4228">
      {{pk_gradient}}
  </defs>
  <metadata
     id="metadata4231">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title>Tileable Wave Pattern 2</dc:title>
        <dc:subject>
          <rdf:Bag>
            <rdf:li>black &amp; white</rdf:li>
            <rdf:li>black and white</rdf:li>
            <rdf:li>GrayScale</rdf:li>
            <rdf:li>gray scale</rdf:li>
            <rdf:li>grey scale</rdf:li>
            <rdf:li>GreyScale</rdf:li>
            <rdf:li>monochrome</rdf:li>
            <rdf:li>pattern</rdf:li>
            <rdf:li>seamless</rdf:li>
            <rdf:li>sine wave</rdf:li>
            <rdf:li>tile</rdf:li>
            <rdf:li>tileable</rdf:li>
            <rdf:li>wave</rdf:li>
          </rdf:Bag>
        </dc:subject>
        <dc:description>Tileable (seamless) wave pattern</dc:description>
        <dc:creator>
          <cc:Agent>
            <dc:title>Arvin61r58</dc:title>
          </cc:Agent>
        </dc:creator>
        <dc:publisher>
          <cc:Agent>
            <dc:title>Openclipart.org</dc:title>
          </cc:Agent>
        </dc:publisher>
        <dc:identifier>https://openclipart.org/</dc:identifier>
        <dc:source>https://openclipart.org/user-detail/Arvin61r58</dc:source>
        <cc:license
           rdf:resource="http://creativecommons.org/publicdomain/zero/1.0/" />
      </cc:Work>
      <cc:License
         rdf:about="http://creativecommons.org/publicdomain/zero/1.0/">
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#Reproduction" />
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#Distribution" />
        <cc:permits
           rdf:resource="http://creativecommons.org/ns#DerivativeWorks" />
      </cc:License>
    </rdf:RDF>
  </metadata>
  <g
     transform="translate(-244.04727,-398.1811)"
     id="layer1">
    <path
       id="path4772"
       d="m 244.04727,398.1811 0,5.37108 c 1.64278,-1.34434 2.8282,-3.19266 3.35548,-5.37108 l -3.35548,0 z m 11.0586,0 c 1.3527,6.7732 -4.38974,13.86226 -11.0586,15.08592 l 0,5.85156 c 0.96084,0.1918 1.91502,0.48343 2.84376,0.98047 11.05342,5.9156 20.98984,-4.02079 15.07422,-15.07421 -1.18918,-2.22198 -1.4193,-4.58042 -1.00392,-6.84374 l -5.85546,0 z m 15.56639,0 c -2.59813,3.1756 -3.28349,8.0316 -0.54296,13.15234 5.18992,9.69741 -7.23227,22.11957 -16.92969,16.92967 -3.28184,-1.7564 -6.45342,-2.08998 -9.15234,-1.4375 l 0,40.72655 c 3.67852,-3.01026 5.09282,-8.59509 1.91798,-14.52733 -5.18989,-9.69742 7.22836,-22.11568 16.92578,-16.92578 11.05341,5.9156 20.98981,-4.0208 15.07421,-15.07422 -5.1899,-9.69741 7.22836,-22.11567 16.92578,-16.92577 7.77044,4.1586 14.96521,0.47148 16.51171,-5.91796 l -40.73047,0 z m 48.43359,0 c 1.81176,9.07184 -9.13744,18.77494 -17.90625,14.08202 -11.05342,-5.9156 -20.9859,4.0169 -15.0703,15.07031 5.1899,9.69742 -7.23228,22.11958 -16.92969,16.92968 -11.05342,-5.9156 -20.9859,4.0169 -15.0703,15.07032 4.0008,7.47555 -2.4673,16.53635 -10.08204,17.93357 l 0,5.85156 c 0.96084,0.1918 1.91502,0.48342 2.84376,0.98048 11.05342,5.9156 20.98982,-4.02082 15.07422,-15.07422 -5.1899,-9.69741 7.22836,-22.11567 16.92577,-16.92577 11.05342,5.9156 20.98982,-4.0208 15.07422,-15.07422 -3.17046,-5.92406 -0.1324,-12.98284 7.30078,-16.96094 3.88967,-2.08163 5.68157,-2.07529 9.62499,0.0352 11.05342,5.9156 20.98982,-4.02079 15.07422,-15.07421 -1.18918,-2.22198 -1.4193,-4.58042 -1.00392,-6.84374 l -5.85546,0 z m 15.5664,0 c -2.59814,3.1756 -3.2835,8.0316 -0.54296,13.15234 5.18992,9.69741 -7.2323,22.11957 -16.9297,16.92967 -11.05342,-5.9156 -20.98591,4.0169 -15.07029,15.07032 5.18989,9.69742 -7.23228,22.11957 -16.9297,16.92968 -11.0534,-5.9156 -20.98591,4.01689 -15.0703,15.07031 5.1899,9.69742 -7.23227,22.1196 -16.92969,16.92968 -3.28184,-1.7564 -6.45342,-2.08998 -9.15234,-1.4375 l 0,40.72655 c 3.67852,-3.01026 5.09282,-8.5951 1.91798,-14.52734 -5.18989,-9.69742 7.22836,-22.11569 16.92578,-16.92577 11.05341,5.91559 20.98981,-4.02082 15.07421,-15.07422 -5.1899,-9.69742 7.22836,-22.1157 16.92578,-16.92578 11.05341,5.9156 20.98981,-4.02082 15.07421,-15.07421 -5.1899,-9.69742 7.22836,-22.11568 16.92578,-16.92578 6.85992,3.6713 14.7975,1.1992 16.3789,-5.10156 0.72404,-2.88472 0.1554,-7.24428 -1.30468,-9.97266 -5.18992,-9.69741 7.22835,-22.11567 16.92577,-16.92577 7.77044,4.1586 14.9652,0.47148 16.51172,-5.91796 l -40.73047,0 z m 48.43359,0 c 1.81176,9.07184 -9.13742,18.77494 -17.90626,14.08202 -11.0534,-5.9156 -20.98589,4.0169 -15.0703,15.07031 5.18992,9.69742 -7.23225,22.11958 -16.92969,16.92968 -11.0534,-5.9156 -20.9859,4.0169 -15.0703,15.07032 5.18992,9.69741 -7.23228,22.11959 -16.92969,16.92967 -11.05342,-5.9156 -20.9859,4.01688 -15.0703,15.07032 5.1899,9.69742 -7.23228,22.11959 -16.92969,16.92967 -11.05342,-5.91559 -20.9859,4.01688 -15.0703,15.07032 4.0008,7.47556 -2.4673,16.53636 -10.08204,17.93358 l 0,5.85156 c 0.96084,0.1918 1.91502,0.48341 2.84376,0.98047 11.0534,5.9156 20.98982,-4.02079 15.07422,-15.07421 -5.18992,-9.69742 7.22836,-22.1157 16.92577,-16.92578 11.0534,5.9156 20.98982,-4.0208 15.07422,-15.07421 -3.17048,-5.92402 -0.1324,-12.98284 7.30078,-16.96094 3.88967,-2.08164 5.68157,-2.07532 9.62499,0.0352 11.05342,5.9156 20.98982,-4.02082 15.07422,-15.07422 -5.18992,-9.69741 7.22836,-22.11567 16.92578,-16.92577 11.05341,5.9156 20.98981,-4.0208 15.07421,-15.07422 -5.18992,-9.69742 7.22836,-22.11567 16.92578,-16.92578 11.05342,5.9156 20.98981,-4.02079 15.07421,-15.07421 -1.18917,-2.22198 -1.41929,-4.58042 -1.00391,-6.84374 l -5.85546,0 z m 15.56639,0 c -2.59814,3.1756 -3.2835,8.0316 -0.54296,13.15234 5.18992,9.69741 -7.23228,22.11957 -16.92969,16.92967 -11.05342,-5.9156 -20.9859,4.0169 -15.0703,15.07032 5.18992,9.69742 -7.23228,22.11957 -16.9297,16.92968 -11.05341,-5.9156 -20.98589,4.01689 -15.07029,15.07031 5.18992,9.69742 -7.23228,22.1196 -16.9297,16.92968 -11.05342,-5.9156 -20.98591,4.01688 -15.07029,15.07031 5.18989,9.69742 -7.23228,22.1196 -16.9297,16.92968 -11.05342,-5.9156 -20.98591,4.01688 -15.0703,15.07032 5.1899,9.69741 -7.23227,22.11959 -16.92969,16.92967 -3.28186,-1.7564 -6.45342,-2.08998 -9.15234,-1.4375 l 0,40.72655 c 3.67852,-3.01026 5.09282,-8.59509 1.91798,-14.52733 -5.18989,-9.69742 7.22836,-22.1157 16.92578,-16.92578 11.05339,5.9156 20.98981,-4.02082 15.07421,-15.07422 -5.1899,-9.69741 7.22836,-22.11569 16.92578,-16.92577 11.05339,5.9156 20.98981,-4.02082 15.07421,-15.07422 -5.1899,-9.69742 7.22836,-22.11569 16.92578,-16.92577 2.72836,1.4601 7.08792,2.0287 9.97266,1.30468 6.30078,-1.5814 8.77286,-9.51898 5.10156,-16.3789 -5.18992,-9.69742 7.22835,-22.1157 16.92577,-16.92578 11.05342,5.9156 20.98982,-4.02082 15.07422,-15.07421 -5.18992,-9.69742 7.22836,-22.11568 16.92577,-16.92578 11.05342,5.9156 20.98982,-4.0208 15.07422,-15.07422 -5.18992,-9.69741 7.22836,-22.11567 16.92578,-16.92577 7.77044,4.1586 14.96521,0.47148 16.51171,-5.91796 l -40.73047,0 z m 48.43359,0 c 1.81176,9.07184 -9.13744,18.77494 -17.90625,14.08202 -11.05342,-5.9156 -20.9859,4.0169 -15.0703,15.07031 5.18992,9.69742 -7.23228,22.11958 -16.9297,16.92968 -11.05341,-5.9156 -20.98589,4.0169 -15.07029,15.07032 5.18992,9.69741 -7.23228,22.11959 -16.9297,16.92967 -11.0534,-5.9156 -20.98589,4.01688 -15.0703,15.07032 5.18992,9.69742 -7.23227,22.11959 -16.92969,16.92967 -11.0534,-5.91559 -20.9859,4.01688 -15.0703,15.07032 5.18992,9.69742 -7.23228,22.1196 -16.92969,16.92968 -11.0534,-5.9156 -20.9859,4.01688 -15.0703,15.07031 5.1899,9.69742 -7.23226,22.1196 -16.92969,16.92968 -11.0534,-5.9156 -20.9859,4.01688 -15.0703,15.07032 4.0008,7.47555 -2.46728,16.53635 -10.08204,17.93357 l 0,5.85156 c 0.96084,0.1918 1.91502,0.48342 2.84376,0.98048 11.0534,5.9156 20.98982,-4.02082 15.07422,-15.07422 -5.1899,-9.69741 7.22836,-22.11569 16.92577,-16.92577 11.0534,5.9156 20.98982,-4.02082 15.07422,-15.07422 -5.1899,-9.69742 7.22836,-22.11569 16.92577,-16.92578 11.05342,5.9156 20.98982,-4.02081 15.07422,-15.07421 -5.18992,-9.69742 7.22834,-22.1157 16.92578,-16.92578 11.05341,5.9156 20.98981,-4.02082 15.07421,-15.07421 -5.18992,-9.69742 7.22834,-22.1157 16.92578,-16.92578 11.05342,5.9156 20.98981,-4.02082 15.07421,-15.07422 -5.18991,-9.69741 7.22834,-22.11567 16.92578,-16.92577 6.85992,3.6713 14.79752,1.1992 16.3789,-5.10156 0.72402,-2.88472 0.1554,-7.24428 -1.30468,-9.97266 -5.18992,-9.69742 7.22836,-22.11567 16.92577,-16.92578 11.05344,5.9156 20.98982,-4.02079 15.07422,-15.07421 -1.18918,-2.22198 -1.4193,-4.58042 -1.00392,-6.84374 l -5.85546,0 z m 15.5664,0 c -2.59814,3.1756 -3.2835,8.0316 -0.54296,13.15234 5.18992,9.69741 -7.2323,22.11957 -16.9297,16.92967 -11.05342,-5.9156 -20.98589,4.0169 -15.07029,15.07032 5.18991,9.69742 -7.23228,22.11957 -16.9297,16.92968 -11.05342,-5.9156 -20.9859,4.01689 -15.0703,15.07031 5.18992,9.69742 -7.23228,22.1196 -16.92969,16.92968 -11.05342,-5.9156 -20.9859,4.01688 -15.0703,15.07031 5.18992,9.69742 -7.23228,22.1196 -16.9297,16.92968 -11.05341,-5.9156 -20.98589,4.01688 -15.07029,15.07032 5.18992,9.69741 -7.23228,22.11959 -16.9297,16.92967 -11.05342,-5.9156 -20.98591,4.01688 -15.07029,15.07032 5.18989,9.69742 -7.23228,22.11959 -16.9297,16.92968 -11.05342,-5.9156 -20.98591,4.01689 -15.0703,15.07031 5.1899,9.69744 -7.23227,22.1196 -16.92969,16.92968 -3.28186,-1.7564 -6.45342,-2.08998 -9.15234,-1.4375 l 0,35.35547 3.35548,0 c 0.65338,-2.69952 0.31948,-5.87328 -1.4375,-9.15626 -5.18991,-9.69742 7.22836,-22.11569 16.92578,-16.92577 11.05339,5.91559 20.98981,-4.02082 15.07421,-15.07422 -5.18992,-9.69742 7.22836,-22.1157 16.92578,-16.92578 11.05339,5.9156 20.98981,-4.02082 15.07421,-15.07421 -5.1899,-9.69742 7.22836,-22.1157 16.92578,-16.92578 11.05342,5.9156 20.98981,-4.02082 15.07422,-15.07422 -5.18992,-9.69741 7.22835,-22.11569 16.92577,-16.92577 11.05342,5.9156 20.98982,-4.02082 15.07422,-15.07422 -5.18992,-9.69742 7.22836,-22.11569 16.92577,-16.92577 11.05342,5.91559 20.98982,-4.02082 15.07422,-15.07422 -5.18992,-9.69742 7.22836,-22.1157 16.92578,-16.92578 11.05341,5.9156 20.98981,-4.02082 15.07421,-15.07421 -5.18992,-9.69742 7.22834,-22.11568 16.92578,-16.92578 11.05342,5.9156 20.98981,-4.0208 15.07422,-15.07422 -5.18992,-9.69741 7.22833,-22.11567 16.92577,-16.92577 5.12116,2.74076 9.98066,2.05182 13.15624,-0.54688 l 0,-5.37108 -37.37499,0 z m 24.52733,12.32812 c -8.21902,-0.39806 -13.87671,7.8433 -9.0703,16.82421 5.18992,9.69742 -7.23227,22.11958 -16.92969,16.92968 -11.05342,-5.9156 -20.9859,4.0169 -15.0703,15.07032 5.18992,9.69741 -7.23228,22.11959 -16.92969,16.92967 -2.72836,-1.4601 -7.08402,-2.03262 -9.96874,-1.3086 -6.30078,1.5814 -8.77286,9.519 -5.10156,16.37892 5.18992,9.69742 -7.23228,22.11959 -16.9297,16.92967 -11.05341,-5.91559 -20.98589,4.01688 -15.07029,15.07032 5.18992,9.69742 -7.23228,22.1196 -16.9297,16.92968 -11.05342,-5.9156 -20.98589,4.01688 -15.0703,15.07031 5.18992,9.69742 -7.23227,22.1196 -16.92969,16.92968 -11.05342,-5.9156 -20.9859,4.01688 -15.0703,15.07032 5.18992,9.69741 -7.23228,22.11959 -16.92969,16.92967 -11.05342,-5.9156 -20.98592,4.01692 -15.0703,15.07032 5.1899,9.69744 -7.23228,22.11959 -16.92969,16.92967 -11.05342,-5.91559 -20.98592,4.01692 -15.0703,15.07032 0.49698,0.9286 0.7847,1.88694 0.97656,2.84766 l 5.85546,0 c 1.39748,-7.6146 10.45423,-14.0828 17.92969,-10.08204 11.0534,5.9156 20.98982,-4.02082 15.07422,-15.07421 -5.18992,-9.69742 7.22836,-22.1157 16.92577,-16.92578 11.0534,5.9156 20.98982,-4.02082 15.07422,-15.07422 -5.18992,-9.69741 7.22836,-22.11569 16.92578,-16.92577 11.05341,5.9156 20.98981,-4.02082 15.07421,-15.07422 -5.18992,-9.69742 7.22836,-22.11569 16.92578,-16.92578 11.05342,5.9156 20.98981,-4.02081 15.07421,-15.07421 -5.18991,-9.69742 7.22836,-22.1157 16.92578,-16.92578 11.05342,5.9156 20.98982,-4.02082 15.07422,-15.07421 -5.18992,-9.69742 7.22836,-22.1157 16.92577,-16.92578 11.05342,5.9156 20.98982,-4.02082 15.07422,-15.07422 -5.18992,-9.69741 7.22834,-22.11567 16.92578,-16.92577 11.05341,5.9156 20.98981,-4.0208 15.07421,-15.07422 -4.69288,-8.76868 5.01028,-19.71757 14.08202,-17.90625 l 0,-5.85156 c -2.2632,0.41528 -4.6258,0.1852 -6.84766,-1.0039 -2.0725,-1.10918 -4.1033,-1.66204 -6,-1.7539 z m 12.84766,16.31639 c -6.39114,1.54508 -10.07718,8.73626 -5.91796,16.50782 5.18992,9.69742 -7.23228,22.11957 -16.9297,16.92968 -11.05341,-5.9156 -20.98589,4.01689 -15.07029,15.07031 5.18992,9.69742 -7.23228,22.1196 -16.9297,16.92968 -11.05342,-5.9156 -20.98589,4.01688 -15.07029,15.07031 5.18991,9.69742 -7.23228,22.1196 -16.9297,16.92968 -11.05342,-5.9156 -20.9859,4.01688 -15.0703,15.07032 5.18992,9.69741 -7.23228,22.11959 -16.92969,16.92967 -11.05342,-5.9156 -20.9859,4.01688 -15.0703,15.07032 5.18992,9.69742 -7.23228,22.11959 -16.9297,16.92968 -11.05341,-5.9156 -20.98589,4.01691 -15.07029,15.07031 5.18992,9.69744 -7.23228,22.1196 -16.9297,16.92968 -11.0534,-5.9156 -20.98589,4.01692 -15.07029,15.07031 5.18989,9.69744 -7.23226,22.1196 -16.9297,16.92968 -5.93266,-3.17506 -11.51724,-1.76116 -14.52734,1.91798 l 40.73047,0 c 0.65338,-2.69952 0.31948,-5.87328 -1.4375,-9.15626 -5.1899,-9.69742 7.22834,-22.11569 16.92578,-16.92577 11.05342,5.91559 20.98981,-4.0208 15.07422,-15.07422 -5.18992,-9.69742 7.22833,-22.1157 16.92577,-16.92578 11.05342,5.9156 20.98982,-4.0208 15.07422,-15.07421 -5.18992,-9.69742 7.22834,-22.1157 16.92577,-16.92578 11.05342,5.9156 20.98982,-4.0208 15.07422,-15.07422 -5.18992,-9.69741 7.22834,-22.11569 16.92578,-16.92577 11.05341,5.9156 20.98981,-4.0208 15.07421,-15.07422 -5.18992,-9.69742 7.22836,-22.11569 16.92578,-16.92577 11.05344,5.91559 20.98981,-4.0208 15.07422,-15.07422 -5.18992,-9.69742 7.22835,-22.1157 16.92577,-16.92578 5.12118,2.74076 9.98066,2.05182 13.15624,-0.54688 l 0,-40.72655 z m -12.84766,47.68359 c -8.21902,-0.39806 -13.87671,7.8433 -9.0703,16.82422 5.18992,9.69742 -7.23229,22.11959 -16.92969,16.92967 -11.05342,-5.91559 -20.9859,4.01688 -15.0703,15.07032 5.18992,9.69742 -7.2323,22.1196 -16.92969,16.92968 -11.05342,-5.9156 -20.9859,4.01688 -15.0703,15.07031 5.18992,9.69742 -7.23228,22.1196 -16.9297,16.92968 -11.05341,-5.9156 -20.98589,4.01688 -15.07029,15.07032 5.18992,9.69741 -7.23228,22.11959 -16.9297,16.92967 -11.05342,-5.9156 -20.98589,4.01692 -15.0703,15.07032 5.18992,9.69744 -7.23227,22.11959 -16.92969,16.92967 -11.05342,-5.91559 -20.9859,4.01692 -15.0703,15.07032 0.49698,0.9286 0.7847,1.88694 0.97656,2.84766 l 5.85546,0 c 1.39748,-7.6146 10.45424,-14.0828 17.9297,-10.08204 11.05341,5.9156 20.98981,-4.0208 15.07421,-15.07421 -5.18992,-9.69742 7.22836,-22.1157 16.92578,-16.92578 11.05342,5.9156 20.98981,-4.0208 15.07421,-15.07422 -5.18991,-9.69741 7.22836,-22.11569 16.92578,-16.92577 11.05342,5.9156 20.98982,-4.0208 15.07422,-15.07422 -5.18992,-9.69742 7.22836,-22.11569 16.92577,-16.92578 11.05342,5.9156 20.98982,-4.02079 15.07422,-15.07421 -5.18992,-9.69742 7.22834,-22.1157 16.92578,-16.92578 11.05341,5.9156 20.98981,-4.02082 15.07421,-15.07421 -4.69288,-8.76868 5.01028,-19.7176 14.08202,-17.90626 l 0,-5.85156 c -2.2632,0.41528 -4.62582,0.1852 -6.84766,-1.0039 -2.0725,-1.10918 -4.1033,-1.66204 -6,-1.7539 z m 12.84766,16.3164 c -6.39114,1.54508 -10.07718,8.73624 -5.91796,16.50781 5.18992,9.69742 -7.23228,22.1196 -16.9297,16.92968 -11.05341,-5.9156 -20.98589,4.01688 -15.07029,15.07032 5.18992,9.69741 -7.23228,22.11959 -16.9297,16.92967 -2.72836,-1.4601 -7.08402,-2.03262 -9.96874,-1.3086 -6.30077,1.5814 -8.77285,9.519 -5.10155,16.37892 5.18991,9.69742 -7.23228,22.11959 -16.9297,16.92968 -11.05342,-5.9156 -20.9859,4.01691 -15.0703,15.07031 5.18992,9.69744 -7.23228,22.1196 -16.92969,16.92968 -11.05342,-5.9156 -20.9859,4.01692 -15.0703,15.07031 5.18992,9.69744 -7.23228,22.1196 -16.9297,16.92968 -5.93267,-3.17506 -11.51723,-1.76116 -14.52733,1.91798 l 40.73047,0 c 0.65338,-2.69952 0.31948,-5.87328 -1.4375,-9.15626 -5.18992,-9.69742 7.22834,-22.11569 16.92577,-16.92577 6.85992,3.6713 14.79752,1.19922 16.3789,-5.10156 0.72402,-2.88472 0.1554,-7.24432 -1.30468,-9.97266 -5.18992,-9.69742 7.22834,-22.1157 16.92578,-16.92578 11.05341,5.9156 20.98981,-4.0208 15.07421,-15.07421 -5.18992,-9.69742 7.22836,-22.1157 16.92578,-16.92578 11.05344,5.9156 20.98981,-4.0208 15.07422,-15.07422 -5.18992,-9.69741 7.22835,-22.11569 16.92577,-16.92577 5.12118,2.74076 9.98066,2.05182 13.15624,-0.54688 l 0,-40.72655 z m -12.84766,47.68359 c -8.21902,-0.39806 -13.87671,7.8433 -9.0703,16.82421 5.18992,9.69742 -7.23227,22.1196 -16.92969,16.92968 -11.05342,-5.9156 -20.9859,4.01688 -15.0703,15.07032 5.18992,9.69741 -7.23228,22.11959 -16.92969,16.92967 -11.05342,-5.9156 -20.9859,4.01692 -15.0703,15.07032 5.18992,9.69744 -7.23226,22.11959 -16.9297,16.92967 -11.05341,-5.91559 -20.98589,4.01692 -15.07029,15.07032 0.49698,0.9286 0.7847,1.88694 0.97656,2.84766 l 5.85546,0 c 1.39747,-7.6146 10.45423,-14.0828 17.92969,-10.08204 2.72836,1.46012 7.08792,2.02868 9.97266,1.30468 6.30074,-1.5814 8.77286,-9.51898 5.10156,-16.37889 -5.18992,-9.69742 7.22836,-22.1157 16.92577,-16.92578 11.05342,5.9156 20.98982,-4.0208 15.07422,-15.07422 -5.18992,-9.69741 7.22836,-22.11569 16.92578,-16.92577 11.05341,5.9156 20.98981,-4.0208 15.07421,-15.07422 -4.69288,-8.76868 5.0103,-19.71759 14.08202,-17.90625 l 0,-5.85156 c -2.2632,0.41528 -4.6258,0.1852 -6.84766,-1.0039 -2.0725,-1.10918 -4.1033,-1.66204 -6,-1.7539 z m 12.84766,16.29295 c -0.27854,0.0442 -0.55908,0.0878 -0.8164,0.1524 -6.30078,1.5814 -8.77284,9.519 -5.10156,16.37892 5.18992,9.69742 -7.23228,22.11959 -16.9297,16.92968 -11.05341,-5.9156 -20.98589,4.01691 -15.07029,15.07031 5.18992,9.69744 -7.23228,22.1196 -16.9297,16.92968 -11.05342,-5.9156 -20.98589,4.01692 -15.07029,15.07031 5.18991,9.69744 -7.23228,22.1196 -16.9297,16.92968 -5.93268,-3.17506 -11.51724,-1.76116 -14.52734,1.91798 l 40.73047,0 c 0.65338,-2.69952 0.31948,-5.87328 -1.4375,-9.15626 -5.18992,-9.69742 7.22836,-22.11569 16.92578,-16.92577 2.72836,1.46012 7.08792,2.02868 9.97266,1.30468 6.30076,-1.5814 8.77286,-9.51898 5.10156,-16.3789 -5.18992,-9.69742 7.22835,-22.1157 16.92577,-16.92578 5.12118,2.74076 9.98066,2.05182 13.15624,-0.54688 l 0,-40.74999 z m -12.84766,47.70703 c -8.21902,-0.39806 -13.87671,7.84332 -9.0703,16.82422 5.18992,9.69744 -7.23227,22.11959 -16.92969,16.92967 -11.0534,-5.91559 -20.9859,4.01692 -15.0703,15.07032 0.49698,0.9286 0.7847,1.88694 0.97656,2.84766 l 5.85156,0 c 1.39724,-7.61476 10.45802,-14.08286 17.9336,-10.08204 2.72836,1.46012 7.08791,2.02868 9.97265,1.30468 6.30076,-1.5814 8.77286,-9.51898 5.10156,-16.37889 -4.69288,-8.76868 5.0103,-19.71758 14.08202,-17.90626 l 0,-5.85156 c -2.2632,0.41528 -4.6258,0.1852 -6.84766,-1.0039 -2.0725,-1.10918 -4.1033,-1.66204 -6,-1.7539 z m 12.84766,16.3164 c -6.39114,1.54508 -10.07718,8.73626 -5.91796,16.50781 5.18992,9.69744 -7.23228,22.1196 -16.9297,16.92968 -5.93265,-3.17506 -11.51721,-1.76116 -14.52733,1.91798 l 37.37499,0 0,-35.35547 z"
       style="fill:{{pk_fill}}" />
  </g>
</svg>`, bT = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev/svgjs" viewBox="0 0 800 800" width="{{pk_dimension}}" height="{{pk_dimension}}">
<defs>     
{{pk_gradient}}
</defs>
<g stroke-width="60" stroke="{{pk_fill}}" fill="none">
<line x1="0" y1="0" x2="0" y2="800" stroke-linecap="square" ></line>
<line x1="100" y1="0" x2="100" y2="800" stroke-linecap="square" ></line>
<line x1="200" y1="0" x2="200" y2="800" stroke-linecap="square" ></line>
<line x1="300" y1="0" x2="300" y2="800" stroke-linecap="square" ></line>
<line x1="400" y1="0" x2="400" y2="800" stroke-linecap="square" ></line>
<line x1="500" y1="0" x2="500" y2="800" stroke-linecap="square" ></line>
<line x1="600" y1="0" x2="600" y2="800" stroke-linecap="square" ></line>
<line x1="700" y1="0" x2="700" y2="800" stroke-linecap="square" ></line>
<line x1="800" y1="0" x2="800" y2="800" stroke-linecap="square" ></line>
</g></svg>`, xT = {
  abstract: nT,
  centerPoint: oT,
  circles: sT,
  circlesBig: iT,
  diamond: cT,
  diagonal: aT,
  diagonalOpp: lT,
  horizontal: uT,
  vertical: bT,
  maze: hT,
  sea: mT,
  seamless: fT,
  security: dT,
  spotty: pT,
  squiggles: gT,
  tieDie: kT,
  tile: vT,
  waves: yT
}, wT = (e, t, r = 200, n = 200) => {
  const o = Le.gradient(), s = LT(e.arrayValue), i = Ra(e.rotation + 360 - t, r, n);
  return o.colorStops = s, o.coords = i, o;
}, LT = (e) => e.map((t) => ({
  offset: t.percentage / 200,
  color: t.colour
})), Ra = (e, t = 200, r = 200) => {
  const n = -parseInt(e, 10) * (Math.PI / 180);
  return {
    x1: Math.round(100 + Math.sin(n) * 100) * t / 200 || 0,
    y1: Math.round(100 + Math.cos(n) * 100) * r / 200 || 0,
    x2: Math.round(100 + Math.sin(n + Math.PI) * 100) * t / 200 || 0,
    y2: Math.round(100 + Math.cos(n + Math.PI) * 100) * r / 200 || 0
  };
}, zT = (e) => {
  const t = Ra(e.rotation);
  return `x1="${t.x1}%" x2="${t.x2}%" y1="${t.y1}%" y2="${t.y2}%"`;
}, Z5 = [
  {
    name: "spotty",
    url: "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/assets/textures/svg/spotty.svg",
    free: !0
  },
  {
    name: "vertical",
    url: "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/assets/textures/svg/vertical.svg",
    free: !0
  },
  {
    name: "horizontal",
    url: "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/assets/textures/svg/horizontal.svg",
    free: !0
  },
  {
    name: "waves",
    url: "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/assets/textures/svg/waves.svg",
    free: !0
  },
  {
    name: "sea",
    url: "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/assets/textures/svg/sea.svg",
    free: !0
  },
  {
    name: "diagonal",
    url: "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/assets/textures/svg/diagonal.svg",
    free: !0
  },
  {
    name: "abstract",
    url: "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/assets/textures/svg/abstract.svg",
    free: !0
  },
  {
    name: "squiggles",
    url: "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/assets/textures/svg/squiggles.svg",
    free: !0
  },
  {
    name: "security",
    url: "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/assets/textures/svg/security.svg",
    free: !0
  },
  {
    name: "diagonalOpp",
    url: "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/assets/textures/svg/diagonalOpp.svg"
  },
  {
    name: "circles",
    url: "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/assets/textures/svg/circles.svg"
  },
  {
    name: "circlesBig",
    url: "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/assets/textures/svg/circlesBig.svg"
  },
  {
    name: "tile",
    url: "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/assets/textures/svg/tile.svg"
  },
  {
    name: "maze",
    url: "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/assets/textures/svg/maze.svg"
  },
  {
    name: "seamless",
    url: "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/assets/textures/svg/seamless.svg"
  },
  {
    name: "tieDie",
    url: "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/assets/textures/svg/tie-die.svg"
  },
  {
    name: "centerPoint",
    url: "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/assets/textures/svg/center-point.svg"
  },
  {
    name: "diamond",
    url: "https://pattern-kid-main.s3.eu-west-1.amazonaws.com/assets/textures/svg/diamond.svg"
  }
], CT = (e) => {
  const t = e.colours.map((o, s) => `<stop offset="${e.percentages[s]}%" stop-color="${o}" />`);
  return { pk_gradient: `
    <linearGradient id="pk_gradient" ${zT(e)} >
      ${t}
    </linearGradient>`, pk_fill: "url(#pk_gradient)" };
}, ST = (e) => typeof e == "string" ? { pk_fill: e, pk_gradient: null } : CT(e), $T = (e) => xT[e], Ia = (e, t, r = rT.resolution) => {
  const n = $T(e), { pk_fill: o, pk_gradient: s } = ST(t);
  return n.replaceAll("{{pk_fill}}", o).replaceAll("{{pk_gradient}}", s).replaceAll("{{pk_dimension}}", `${r}px`);
}, C50 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  list: Z5,
  buildPkSvg: Ia,
  default: Z5
}, Symbol.toStringTag, { value: "Module" }));
function _a(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: AT } = Object.prototype, { getPrototypeOf: l9 } = Object, M8 = ((e) => (t) => {
  const r = AT.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), J1 = (e) => (e = e.toLowerCase(), (t) => M8(t) === e), j8 = (e) => (t) => typeof t === e, { isArray: h2 } = Array, h7 = j8("undefined");
function MT(e) {
  return e !== null && !h7(e) && e.constructor !== null && !h7(e.constructor) && S1(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Fa = J1("ArrayBuffer");
function jT(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Fa(e.buffer), t;
}
const ET = j8("string"), S1 = j8("function"), Ba = j8("number"), E8 = (e) => e !== null && typeof e == "object", TT = (e) => e === !0 || e === !1, Br = (e) => {
  if (M8(e) !== "object")
    return !1;
  const t = l9(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, PT = J1("Date"), NT = J1("File"), DT = J1("Blob"), OT = J1("FileList"), RT = (e) => E8(e) && S1(e.pipe), IT = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || S1(e.append) && ((t = M8(e)) === "formdata" || t === "object" && S1(e.toString) && e.toString() === "[object FormData]"));
}, _T = J1("URLSearchParams"), FT = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function y7(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, o;
  if (typeof e != "object" && (e = [e]), h2(e))
    for (n = 0, o = e.length; n < o; n++)
      t.call(null, e[n], n, e);
  else {
    const s = r ? Object.getOwnPropertyNames(e) : Object.keys(e), i = s.length;
    let l;
    for (n = 0; n < i; n++)
      l = s[n], t.call(null, e[l], l, e);
  }
}
function Za(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, o;
  for (; n-- > 0; )
    if (o = r[n], t === o.toLowerCase())
      return o;
  return null;
}
const qa = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), Ua = (e) => !h7(e) && e !== qa;
function ro() {
  const { caseless: e } = Ua(this) && this || {}, t = {}, r = (n, o) => {
    const s = e && Za(t, o) || o;
    Br(t[s]) && Br(n) ? t[s] = ro(t[s], n) : Br(n) ? t[s] = ro({}, n) : h2(n) ? t[s] = n.slice() : t[s] = n;
  };
  for (let n = 0, o = arguments.length; n < o; n++)
    arguments[n] && y7(arguments[n], r);
  return t;
}
const BT = (e, t, r, { allOwnKeys: n } = {}) => (y7(t, (o, s) => {
  r && S1(o) ? e[s] = _a(o, r) : e[s] = o;
}, { allOwnKeys: n }), e), ZT = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), qT = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, UT = (e, t, r, n) => {
  let o, s, i;
  const l = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (o = Object.getOwnPropertyNames(e), s = o.length; s-- > 0; )
      i = o[s], (!n || n(i, e, t)) && !l[i] && (t[i] = e[i], l[i] = !0);
    e = r !== !1 && l9(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, HT = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, GT = (e) => {
  if (!e)
    return null;
  if (h2(e))
    return e;
  let t = e.length;
  if (!Ba(t))
    return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, WT = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && l9(Uint8Array)), VT = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = n.next()) && !o.done; ) {
    const s = o.value;
    t.call(e, s[0], s[1]);
  }
}, XT = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, YT = J1("HTMLFormElement"), KT = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, o) {
    return n.toUpperCase() + o;
  }
), q5 = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), QT = J1("RegExp"), Ha = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  y7(r, (o, s) => {
    let i;
    (i = t(o, s, e)) !== !1 && (n[s] = i || o);
  }), Object.defineProperties(e, n);
}, JT = (e) => {
  Ha(e, (t, r) => {
    if (S1(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (!!S1(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, eP = (e, t) => {
  const r = {}, n = (o) => {
    o.forEach((s) => {
      r[s] = !0;
    });
  };
  return h2(e) ? n(e) : n(String(e).split(t)), r;
}, tP = () => {
}, rP = (e, t) => (e = +e, Number.isFinite(e) ? e : t), F4 = "abcdefghijklmnopqrstuvwxyz", U5 = "0123456789", Ga = {
  DIGIT: U5,
  ALPHA: F4,
  ALPHA_DIGIT: F4 + F4.toUpperCase() + U5
}, nP = (e = 16, t = Ga.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = t;
  for (; e--; )
    r += t[Math.random() * n | 0];
  return r;
};
function oP(e) {
  return !!(e && S1(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const sP = (e) => {
  const t = new Array(10), r = (n, o) => {
    if (E8(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[o] = n;
        const s = h2(n) ? [] : {};
        return y7(n, (i, l) => {
          const c = r(i, o + 1);
          !h7(c) && (s[l] = c);
        }), t[o] = void 0, s;
      }
    }
    return n;
  };
  return r(e, 0);
}, iP = J1("AsyncFunction"), aP = (e) => e && (E8(e) || S1(e)) && S1(e.then) && S1(e.catch), T = {
  isArray: h2,
  isArrayBuffer: Fa,
  isBuffer: MT,
  isFormData: IT,
  isArrayBufferView: jT,
  isString: ET,
  isNumber: Ba,
  isBoolean: TT,
  isObject: E8,
  isPlainObject: Br,
  isUndefined: h7,
  isDate: PT,
  isFile: NT,
  isBlob: DT,
  isRegExp: QT,
  isFunction: S1,
  isStream: RT,
  isURLSearchParams: _T,
  isTypedArray: WT,
  isFileList: OT,
  forEach: y7,
  merge: ro,
  extend: BT,
  trim: FT,
  stripBOM: ZT,
  inherits: qT,
  toFlatObject: UT,
  kindOf: M8,
  kindOfTest: J1,
  endsWith: HT,
  toArray: GT,
  forEachEntry: VT,
  matchAll: XT,
  isHTMLForm: YT,
  hasOwnProperty: q5,
  hasOwnProp: q5,
  reduceDescriptors: Ha,
  freezeMethods: JT,
  toObjectSet: eP,
  toCamelCase: KT,
  noop: tP,
  toFiniteNumber: rP,
  findKey: Za,
  global: qa,
  isContextDefined: Ua,
  ALPHABET: Ga,
  generateString: nP,
  isSpecCompliantForm: oP,
  toJSONObject: sP,
  isAsyncFn: iP,
  isThenable: aP
};
function u0(e, t, r, n, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), o && (this.response = o);
}
T.inherits(u0, Error, {
  toJSON: function() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: T.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Wa = u0.prototype, Va = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
].forEach((e) => {
  Va[e] = { value: e };
});
Object.defineProperties(u0, Va);
Object.defineProperty(Wa, "isAxiosError", { value: !0 });
u0.from = (e, t, r, n, o, s) => {
  const i = Object.create(Wa);
  return T.toFlatObject(e, i, function(c) {
    return c !== Error.prototype;
  }, (l) => l !== "isAxiosError"), u0.call(i, e.message, t, r, n, o), i.cause = e, i.name = e.name, s && Object.assign(i, s), i;
};
const lP = null;
function no(e) {
  return T.isPlainObject(e) || T.isArray(e);
}
function Xa(e) {
  return T.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function H5(e, t, r) {
  return e ? e.concat(t).map(function(o, s) {
    return o = Xa(o), !r && s ? "[" + o + "]" : o;
  }).join(r ? "." : "") : t;
}
function cP(e) {
  return T.isArray(e) && !e.some(no);
}
const uP = T.toFlatObject(T, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function T8(e, t, r) {
  if (!T.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = T.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(k, b) {
    return !T.isUndefined(b[k]);
  });
  const n = r.metaTokens, o = r.visitor || u, s = r.dots, i = r.indexes, c = (r.Blob || typeof Blob < "u" && Blob) && T.isSpecCompliantForm(t);
  if (!T.isFunction(o))
    throw new TypeError("visitor must be a function");
  function a(d) {
    if (d === null)
      return "";
    if (T.isDate(d))
      return d.toISOString();
    if (!c && T.isBlob(d))
      throw new u0("Blob is not supported. Use a Buffer instead.");
    return T.isArrayBuffer(d) || T.isTypedArray(d) ? c && typeof Blob == "function" ? new Blob([d]) : Buffer.from(d) : d;
  }
  function u(d, k, b) {
    let w = d;
    if (d && !b && typeof d == "object") {
      if (T.endsWith(k, "{}"))
        k = n ? k : k.slice(0, -2), d = JSON.stringify(d);
      else if (T.isArray(d) && cP(d) || (T.isFileList(d) || T.endsWith(k, "[]")) && (w = T.toArray(d)))
        return k = Xa(k), w.forEach(function(A, C) {
          !(T.isUndefined(A) || A === null) && t.append(
            i === !0 ? H5([k], C, s) : i === null ? k : k + "[]",
            a(A)
          );
        }), !1;
    }
    return no(d) ? !0 : (t.append(H5(b, k, s), a(d)), !1);
  }
  const h = [], m = Object.assign(uP, {
    defaultVisitor: u,
    convertValue: a,
    isVisitable: no
  });
  function f(d, k) {
    if (!T.isUndefined(d)) {
      if (h.indexOf(d) !== -1)
        throw Error("Circular reference detected in " + k.join("."));
      h.push(d), T.forEach(d, function(w, L) {
        (!(T.isUndefined(w) || w === null) && o.call(
          t,
          w,
          T.isString(L) ? L.trim() : L,
          k,
          m
        )) === !0 && f(w, k ? k.concat(L) : [L]);
      }), h.pop();
    }
  }
  if (!T.isObject(e))
    throw new TypeError("data must be an object");
  return f(e), t;
}
function G5(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function c9(e, t) {
  this._pairs = [], e && T8(e, this, t);
}
const Ya = c9.prototype;
Ya.append = function(t, r) {
  this._pairs.push([t, r]);
};
Ya.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, G5);
  } : G5;
  return this._pairs.map(function(o) {
    return r(o[0]) + "=" + r(o[1]);
  }, "").join("&");
};
function hP(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Ka(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || hP, o = r && r.serialize;
  let s;
  if (o ? s = o(t, r) : s = T.isURLSearchParams(t) ? t.toString() : new c9(t, r).toString(n), s) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class mP {
  constructor() {
    this.handlers = [];
  }
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(t) {
    T.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const W5 = mP, Qa = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, fP = typeof URLSearchParams < "u" ? URLSearchParams : c9, dP = typeof FormData < "u" ? FormData : null, pP = typeof Blob < "u" ? Blob : null, gP = {
  isBrowser: !0,
  classes: {
    URLSearchParams: fP,
    FormData: dP,
    Blob: pP
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Ja = typeof window < "u" && typeof document < "u", kP = ((e) => Ja && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), vP = (() => typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), yP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Ja,
  hasStandardBrowserWebWorkerEnv: vP,
  hasStandardBrowserEnv: kP
}, Symbol.toStringTag, { value: "Module" })), K1 = {
  ...yP,
  ...gP
};
function bP(e, t) {
  return T8(e, new K1.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, o, s) {
      return K1.isNode && T.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : s.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function xP(e) {
  return T.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function wP(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const o = r.length;
  let s;
  for (n = 0; n < o; n++)
    s = r[n], t[s] = e[s];
  return t;
}
function el(e) {
  function t(r, n, o, s) {
    let i = r[s++];
    const l = Number.isFinite(+i), c = s >= r.length;
    return i = !i && T.isArray(o) ? o.length : i, c ? (T.hasOwnProp(o, i) ? o[i] = [o[i], n] : o[i] = n, !l) : ((!o[i] || !T.isObject(o[i])) && (o[i] = []), t(r, n, o[i], s) && T.isArray(o[i]) && (o[i] = wP(o[i])), !l);
  }
  if (T.isFormData(e) && T.isFunction(e.entries)) {
    const r = {};
    return T.forEachEntry(e, (n, o) => {
      t(xP(n), o, r, 0);
    }), r;
  }
  return null;
}
function LP(e, t, r) {
  if (T.isString(e))
    try {
      return (t || JSON.parse)(e), T.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const u9 = {
  transitional: Qa,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", o = n.indexOf("application/json") > -1, s = T.isObject(t);
    if (s && T.isHTMLForm(t) && (t = new FormData(t)), T.isFormData(t))
      return o && o ? JSON.stringify(el(t)) : t;
    if (T.isArrayBuffer(t) || T.isBuffer(t) || T.isStream(t) || T.isFile(t) || T.isBlob(t))
      return t;
    if (T.isArrayBufferView(t))
      return t.buffer;
    if (T.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let l;
    if (s) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return bP(t, this.formSerializer).toString();
      if ((l = T.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return T8(
          l ? { "files[]": t } : t,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return s || o ? (r.setContentType("application/json", !1), LP(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || u9.transitional, n = r && r.forcedJSONParsing, o = this.responseType === "json";
    if (t && T.isString(t) && (n && !this.responseType || o)) {
      const i = !(r && r.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (l) {
        if (i)
          throw l.name === "SyntaxError" ? u0.from(l, u0.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return t;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: K1.classes.FormData,
    Blob: K1.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
T.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  u9.headers[e] = {};
});
const h9 = u9, zP = T.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), CP = (e) => {
  const t = {};
  let r, n, o;
  return e && e.split(`
`).forEach(function(i) {
    o = i.indexOf(":"), r = i.substring(0, o).trim().toLowerCase(), n = i.substring(o + 1).trim(), !(!r || t[r] && zP[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, V5 = Symbol("internals");
function S3(e) {
  return e && String(e).trim().toLowerCase();
}
function Zr(e) {
  return e === !1 || e == null ? e : T.isArray(e) ? e.map(Zr) : String(e);
}
function SP(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const $P = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function B4(e, t, r, n, o) {
  if (T.isFunction(n))
    return n.call(this, t, r);
  if (o && (t = r), !!T.isString(t)) {
    if (T.isString(n))
      return t.indexOf(n) !== -1;
    if (T.isRegExp(n))
      return n.test(t);
  }
}
function AP(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function MP(e, t) {
  const r = T.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(o, s, i) {
        return this[n].call(this, t, o, s, i);
      },
      configurable: !0
    });
  });
}
class P8 {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const o = this;
    function s(l, c, a) {
      const u = S3(c);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const h = T.findKey(o, u);
      (!h || o[h] === void 0 || a === !0 || a === void 0 && o[h] !== !1) && (o[h || c] = Zr(l));
    }
    const i = (l, c) => T.forEach(l, (a, u) => s(a, u, c));
    return T.isPlainObject(t) || t instanceof this.constructor ? i(t, r) : T.isString(t) && (t = t.trim()) && !$P(t) ? i(CP(t), r) : t != null && s(r, t, n), this;
  }
  get(t, r) {
    if (t = S3(t), t) {
      const n = T.findKey(this, t);
      if (n) {
        const o = this[n];
        if (!r)
          return o;
        if (r === !0)
          return SP(o);
        if (T.isFunction(r))
          return r.call(this, o, n);
        if (T.isRegExp(r))
          return r.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = S3(t), t) {
      const n = T.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || B4(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let o = !1;
    function s(i) {
      if (i = S3(i), i) {
        const l = T.findKey(n, i);
        l && (!r || B4(n, n[l], l, r)) && (delete n[l], o = !0);
      }
    }
    return T.isArray(t) ? t.forEach(s) : s(t), o;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, o = !1;
    for (; n--; ) {
      const s = r[n];
      (!t || B4(this, this[s], s, t, !0)) && (delete this[s], o = !0);
    }
    return o;
  }
  normalize(t) {
    const r = this, n = {};
    return T.forEach(this, (o, s) => {
      const i = T.findKey(n, s);
      if (i) {
        r[i] = Zr(o), delete r[s];
        return;
      }
      const l = t ? AP(s) : String(s).trim();
      l !== s && delete r[s], r[l] = Zr(o), n[l] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return T.forEach(this, (n, o) => {
      n != null && n !== !1 && (r[o] = t && T.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((o) => n.set(o)), n;
  }
  static accessor(t) {
    const n = (this[V5] = this[V5] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function s(i) {
      const l = S3(i);
      n[l] || (MP(o, i), n[l] = !0);
    }
    return T.isArray(t) ? t.forEach(s) : s(t), this;
  }
}
P8.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
T.reduceDescriptors(P8.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
T.freezeMethods(P8);
const he = P8;
function Z4(e, t) {
  const r = this || h9, n = t || r, o = he.from(n.headers);
  let s = n.data;
  return T.forEach(e, function(l) {
    s = l.call(r, s, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), s;
}
function tl(e) {
  return !!(e && e.__CANCEL__);
}
function b7(e, t, r) {
  u0.call(this, e == null ? "canceled" : e, u0.ERR_CANCELED, t, r), this.name = "CanceledError";
}
T.inherits(b7, u0, {
  __CANCEL__: !0
});
function jP(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new u0(
    "Request failed with status code " + r.status,
    [u0.ERR_BAD_REQUEST, u0.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
const EP = K1.hasStandardBrowserEnv ? {
  write(e, t, r, n, o, s) {
    const i = [e + "=" + encodeURIComponent(t)];
    T.isNumber(r) && i.push("expires=" + new Date(r).toGMTString()), T.isString(n) && i.push("path=" + n), T.isString(o) && i.push("domain=" + o), s === !0 && i.push("secure"), document.cookie = i.join("; ");
  },
  read(e) {
    const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
    return t ? decodeURIComponent(t[3]) : null;
  },
  remove(e) {
    this.write(e, "", Date.now() - 864e5);
  }
} : {
  write() {
  },
  read() {
    return null;
  },
  remove() {
  }
};
function TP(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function PP(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function rl(e, t) {
  return e && !TP(t) ? PP(e, t) : t;
}
const NP = K1.hasStandardBrowserEnv ? function() {
  const t = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a");
  let n;
  function o(s) {
    let i = s;
    return t && (r.setAttribute("href", i), i = r.href), r.setAttribute("href", i), {
      href: r.href,
      protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
      host: r.host,
      search: r.search ? r.search.replace(/^\?/, "") : "",
      hash: r.hash ? r.hash.replace(/^#/, "") : "",
      hostname: r.hostname,
      port: r.port,
      pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
    };
  }
  return n = o(window.location.href), function(i) {
    const l = T.isString(i) ? o(i) : i;
    return l.protocol === n.protocol && l.host === n.host;
  };
}() : function() {
  return function() {
    return !0;
  };
}();
function DP(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function OP(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let o = 0, s = 0, i;
  return t = t !== void 0 ? t : 1e3, function(c) {
    const a = Date.now(), u = n[s];
    i || (i = a), r[o] = c, n[o] = a;
    let h = s, m = 0;
    for (; h !== o; )
      m += r[h++], h = h % e;
    if (o = (o + 1) % e, o === s && (s = (s + 1) % e), a - i < t)
      return;
    const f = u && a - u;
    return f ? Math.round(m * 1e3 / f) : void 0;
  };
}
function X5(e, t) {
  let r = 0;
  const n = OP(50, 250);
  return (o) => {
    const s = o.loaded, i = o.lengthComputable ? o.total : void 0, l = s - r, c = n(l), a = s <= i;
    r = s;
    const u = {
      loaded: s,
      total: i,
      progress: i ? s / i : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && i && a ? (i - s) / c : void 0,
      event: o
    };
    u[t ? "download" : "upload"] = !0, e(u);
  };
}
const RP = typeof XMLHttpRequest < "u", IP = RP && function(e) {
  return new Promise(function(r, n) {
    let o = e.data;
    const s = he.from(e.headers).normalize();
    let { responseType: i, withXSRFToken: l } = e, c;
    function a() {
      e.cancelToken && e.cancelToken.unsubscribe(c), e.signal && e.signal.removeEventListener("abort", c);
    }
    let u;
    if (T.isFormData(o)) {
      if (K1.hasStandardBrowserEnv || K1.hasStandardBrowserWebWorkerEnv)
        s.setContentType(!1);
      else if ((u = s.getContentType()) !== !1) {
        const [k, ...b] = u ? u.split(";").map((w) => w.trim()).filter(Boolean) : [];
        s.setContentType([k || "multipart/form-data", ...b].join("; "));
      }
    }
    let h = new XMLHttpRequest();
    if (e.auth) {
      const k = e.auth.username || "", b = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      s.set("Authorization", "Basic " + btoa(k + ":" + b));
    }
    const m = rl(e.baseURL, e.url);
    h.open(e.method.toUpperCase(), Ka(m, e.params, e.paramsSerializer), !0), h.timeout = e.timeout;
    function f() {
      if (!h)
        return;
      const k = he.from(
        "getAllResponseHeaders" in h && h.getAllResponseHeaders()
      ), w = {
        data: !i || i === "text" || i === "json" ? h.responseText : h.response,
        status: h.status,
        statusText: h.statusText,
        headers: k,
        config: e,
        request: h
      };
      jP(function(A) {
        r(A), a();
      }, function(A) {
        n(A), a();
      }, w), h = null;
    }
    if ("onloadend" in h ? h.onloadend = f : h.onreadystatechange = function() {
      !h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.indexOf("file:") === 0) || setTimeout(f);
    }, h.onabort = function() {
      !h || (n(new u0("Request aborted", u0.ECONNABORTED, e, h)), h = null);
    }, h.onerror = function() {
      n(new u0("Network Error", u0.ERR_NETWORK, e, h)), h = null;
    }, h.ontimeout = function() {
      let b = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const w = e.transitional || Qa;
      e.timeoutErrorMessage && (b = e.timeoutErrorMessage), n(new u0(
        b,
        w.clarifyTimeoutError ? u0.ETIMEDOUT : u0.ECONNABORTED,
        e,
        h
      )), h = null;
    }, K1.hasStandardBrowserEnv && (l && T.isFunction(l) && (l = l(e)), l || l !== !1 && NP(m))) {
      const k = e.xsrfHeaderName && e.xsrfCookieName && EP.read(e.xsrfCookieName);
      k && s.set(e.xsrfHeaderName, k);
    }
    o === void 0 && s.setContentType(null), "setRequestHeader" in h && T.forEach(s.toJSON(), function(b, w) {
      h.setRequestHeader(w, b);
    }), T.isUndefined(e.withCredentials) || (h.withCredentials = !!e.withCredentials), i && i !== "json" && (h.responseType = e.responseType), typeof e.onDownloadProgress == "function" && h.addEventListener("progress", X5(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && h.upload && h.upload.addEventListener("progress", X5(e.onUploadProgress)), (e.cancelToken || e.signal) && (c = (k) => {
      !h || (n(!k || k.type ? new b7(null, e, h) : k), h.abort(), h = null);
    }, e.cancelToken && e.cancelToken.subscribe(c), e.signal && (e.signal.aborted ? c() : e.signal.addEventListener("abort", c)));
    const d = DP(m);
    if (d && K1.protocols.indexOf(d) === -1) {
      n(new u0("Unsupported protocol " + d + ":", u0.ERR_BAD_REQUEST, e));
      return;
    }
    h.send(o || null);
  });
}, oo = {
  http: lP,
  xhr: IP
};
T.forEach(oo, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Y5 = (e) => `- ${e}`, _P = (e) => T.isFunction(e) || e === null || e === !1, nl = {
  getAdapter: (e) => {
    e = T.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const o = {};
    for (let s = 0; s < t; s++) {
      r = e[s];
      let i;
      if (n = r, !_P(r) && (n = oo[(i = String(r)).toLowerCase()], n === void 0))
        throw new u0(`Unknown adapter '${i}'`);
      if (n)
        break;
      o[i || "#" + s] = n;
    }
    if (!n) {
      const s = Object.entries(o).map(
        ([l, c]) => `adapter ${l} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = t ? s.length > 1 ? `since :
` + s.map(Y5).join(`
`) : " " + Y5(s[0]) : "as no adapter specified";
      throw new u0(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: oo
};
function q4(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new b7(null, e);
}
function K5(e) {
  return q4(e), e.headers = he.from(e.headers), e.data = Z4.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), nl.getAdapter(e.adapter || h9.adapter)(e).then(function(n) {
    return q4(e), n.data = Z4.call(
      e,
      e.transformResponse,
      n
    ), n.headers = he.from(n.headers), n;
  }, function(n) {
    return tl(n) || (q4(e), n && n.response && (n.response.data = Z4.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = he.from(n.response.headers))), Promise.reject(n);
  });
}
const Q5 = (e) => e instanceof he ? e.toJSON() : e;
function r2(e, t) {
  t = t || {};
  const r = {};
  function n(a, u, h) {
    return T.isPlainObject(a) && T.isPlainObject(u) ? T.merge.call({ caseless: h }, a, u) : T.isPlainObject(u) ? T.merge({}, u) : T.isArray(u) ? u.slice() : u;
  }
  function o(a, u, h) {
    if (T.isUndefined(u)) {
      if (!T.isUndefined(a))
        return n(void 0, a, h);
    } else
      return n(a, u, h);
  }
  function s(a, u) {
    if (!T.isUndefined(u))
      return n(void 0, u);
  }
  function i(a, u) {
    if (T.isUndefined(u)) {
      if (!T.isUndefined(a))
        return n(void 0, a);
    } else
      return n(void 0, u);
  }
  function l(a, u, h) {
    if (h in t)
      return n(a, u);
    if (h in e)
      return n(void 0, a);
  }
  const c = {
    url: s,
    method: s,
    data: s,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: l,
    headers: (a, u) => o(Q5(a), Q5(u), !0)
  };
  return T.forEach(Object.keys(Object.assign({}, e, t)), function(u) {
    const h = c[u] || o, m = h(e[u], t[u], u);
    T.isUndefined(m) && h !== l || (r[u] = m);
  }), r;
}
const ol = "1.6.2", m9 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  m9[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const J5 = {};
m9.transitional = function(t, r, n) {
  function o(s, i) {
    return "[Axios v" + ol + "] Transitional option '" + s + "'" + i + (n ? ". " + n : "");
  }
  return (s, i, l) => {
    if (t === !1)
      throw new u0(
        o(i, " has been removed" + (r ? " in " + r : "")),
        u0.ERR_DEPRECATED
      );
    return r && !J5[i] && (J5[i] = !0, console.warn(
      o(
        i,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(s, i, l) : !0;
  };
};
function FP(e, t, r) {
  if (typeof e != "object")
    throw new u0("options must be an object", u0.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let o = n.length;
  for (; o-- > 0; ) {
    const s = n[o], i = t[s];
    if (i) {
      const l = e[s], c = l === void 0 || i(l, s, e);
      if (c !== !0)
        throw new u0("option " + s + " must be " + c, u0.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new u0("Unknown option " + s, u0.ERR_BAD_OPTION);
  }
}
const so = {
  assertOptions: FP,
  validators: m9
}, pe = so.validators;
class s8 {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new W5(),
      response: new W5()
    };
  }
  request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = r2(this.defaults, r);
    const { transitional: n, paramsSerializer: o, headers: s } = r;
    n !== void 0 && so.assertOptions(n, {
      silentJSONParsing: pe.transitional(pe.boolean),
      forcedJSONParsing: pe.transitional(pe.boolean),
      clarifyTimeoutError: pe.transitional(pe.boolean)
    }, !1), o != null && (T.isFunction(o) ? r.paramsSerializer = {
      serialize: o
    } : so.assertOptions(o, {
      encode: pe.function,
      serialize: pe.function
    }, !0)), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let i = s && T.merge(
      s.common,
      s[r.method]
    );
    s && T.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (d) => {
        delete s[d];
      }
    ), r.headers = he.concat(i, s);
    const l = [];
    let c = !0;
    this.interceptors.request.forEach(function(k) {
      typeof k.runWhen == "function" && k.runWhen(r) === !1 || (c = c && k.synchronous, l.unshift(k.fulfilled, k.rejected));
    });
    const a = [];
    this.interceptors.response.forEach(function(k) {
      a.push(k.fulfilled, k.rejected);
    });
    let u, h = 0, m;
    if (!c) {
      const d = [K5.bind(this), void 0];
      for (d.unshift.apply(d, l), d.push.apply(d, a), m = d.length, u = Promise.resolve(r); h < m; )
        u = u.then(d[h++], d[h++]);
      return u;
    }
    m = l.length;
    let f = r;
    for (h = 0; h < m; ) {
      const d = l[h++], k = l[h++];
      try {
        f = d(f);
      } catch (b) {
        k.call(this, b);
        break;
      }
    }
    try {
      u = K5.call(this, f);
    } catch (d) {
      return Promise.reject(d);
    }
    for (h = 0, m = a.length; h < m; )
      u = u.then(a[h++], a[h++]);
    return u;
  }
  getUri(t) {
    t = r2(this.defaults, t);
    const r = rl(t.baseURL, t.url);
    return Ka(r, t.params, t.paramsSerializer);
  }
}
T.forEach(["delete", "get", "head", "options"], function(t) {
  s8.prototype[t] = function(r, n) {
    return this.request(r2(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
T.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(s, i, l) {
      return this.request(r2(l || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: i
      }));
    };
  }
  s8.prototype[t] = r(), s8.prototype[t + "Form"] = r(!0);
});
const qr = s8;
class f9 {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(s) {
      r = s;
    });
    const n = this;
    this.promise.then((o) => {
      if (!n._listeners)
        return;
      let s = n._listeners.length;
      for (; s-- > 0; )
        n._listeners[s](o);
      n._listeners = null;
    }), this.promise.then = (o) => {
      let s;
      const i = new Promise((l) => {
        n.subscribe(l), s = l;
      }).then(o);
      return i.cancel = function() {
        n.unsubscribe(s);
      }, i;
    }, t(function(s, i, l) {
      n.reason || (n.reason = new b7(s, i, l), r(n.reason));
    });
  }
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  static source() {
    let t;
    return {
      token: new f9(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
const BP = f9;
function ZP(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function qP(e) {
  return T.isObject(e) && e.isAxiosError === !0;
}
const io = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(io).forEach(([e, t]) => {
  io[t] = e;
});
const UP = io;
function sl(e) {
  const t = new qr(e), r = _a(qr.prototype.request, t);
  return T.extend(r, qr.prototype, t, { allOwnKeys: !0 }), T.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(o) {
    return sl(r2(e, o));
  }, r;
}
const E0 = sl(h9);
E0.Axios = qr;
E0.CanceledError = b7;
E0.CancelToken = BP;
E0.isCancel = tl;
E0.VERSION = ol;
E0.toFormData = T8;
E0.AxiosError = u0;
E0.Cancel = E0.CanceledError;
E0.all = function(t) {
  return Promise.all(t);
};
E0.spread = ZP;
E0.isAxiosError = qP;
E0.mergeConfig = r2;
E0.AxiosHeaders = he;
E0.formToJSON = (e) => el(T.isHTMLForm(e) ? new FormData(e) : e);
E0.getAdapter = nl.getAdapter;
E0.HttpStatusCode = UP;
E0.default = E0;
const HP = E0, il = (e) => `https://pattern-kid-main.s3.eu-west-1.amazonaws.com/uploaded-images/${e.uuid}.${e.type}`, al = (e, t) => `https://pattern-kid-main.s3.eu-west-1.amazonaws.com/development/images/${t}/${e.uuid}.${e.type}`, GP = (e) => {
  let t = [];
  for (let n = 0; n < e.length; ) {
    let o = n + 32767;
    t.push(String.fromCodePoint.apply(null, e.slice(n, o))), n = o;
  }
  return t.join("");
}, es = async (e) => {
  try {
    const { data: t } = await HP.get(e, {
      responseType: "arraybuffer"
    });
    return window.btoa(GP(new Uint8Array(t)));
  } catch {
    return !1;
  }
}, WP = async (e, t) => {
  let r, n;
  const o = {
    "Small PNG": 400,
    "Medium PNG": 1e3,
    "Large PNG": 3e3,
    SVG: 0
  }, s = e.height / e.width, i = e.toDataURL({
    multiplier: 4,
    format: "png"
  });
  return s >= 1 && (r = o[t], n = Math.round(o[t] / s)), s < 1 && (n = o[t], r = Math.round(o[t] * s)), (await d9(i, n, r)).replace("data:image/png;base64,", "");
}, ll = async (e) => {
  const t = al(e, 400), r = il(e), n = t.split(".").pop(), o = await es(t);
  if (o)
    return `data:image/${n};base64,${o}`;
  const s = await es(r);
  return await d9(
    `data:image/${n};base64,${s}`,
    400,
    400
  );
}, VP = async (e) => "data:image/svg+xml;base64," + window.btoa(e), XP = (e) => URL.createObjectURL(
  new Blob([e], {
    type: "image/svg+xml"
  })
), cl = (e, t) => new Promise((r, n) => {
  try {
    const o = document.createElement("img");
    o.setAttribute("style", "opacity: 0"), document.body.appendChild(o), o.onload = () => {
      const i = document.createElement("canvas");
      i.width = o.clientWidth, i.height = o.clientHeight;
      const l = i.getContext("2d");
      l.translate(i.width / 2, i.height / 2), l.rotate(t * Math.PI / 180), l.drawImage(o, o.width / -2, o.height / -2), r([i.toDataURL(), () => document.body.removeChild(o)]);
    };
    const s = `data:image/svg+xml;base64,${window.btoa(e)}`;
    o.src = s;
  } catch (o) {
    n(o);
  }
}), YP = (e, t) => new Promise((r, n) => {
  try {
    const o = document.createElement("canvas"), s = o.getContext("2d"), i = new Image();
    i.onload = function() {
      o.width = t % 180 === 0 ? i.width : i.height, o.height = t % 180 === 0 ? i.height : i.width, s.translate(o.width / 2, o.height / 2), s.rotate(t * Math.PI / 180), s.drawImage(
        i,
        i.width / -2,
        i.height / -2
      ), r(o.toDataURL());
    }, i.src = e;
  } catch (o) {
    n(o);
  }
}), d9 = (e, t, r) => new Promise((n, o) => {
  try {
    const s = document.createElement("canvas");
    s.width = t, s.height = r;
    const i = s.getContext("2d"), l = new Image();
    l.onload = function() {
      i.drawImage(l, 0, 0, t, r), n(s.toDataURL());
    }, l.src = e;
  } catch (s) {
    o(s);
  }
}), KP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getCdnFallback: il,
  getCdnUrl: al,
  getCanvasPng: WP,
  getDataUrl: ll,
  getSvgDataUrl: VP,
  getSvgUrl: XP,
  svgToPngDataUrl: cl,
  rotateImage: YP,
  resizeImage: d9
}, Symbol.toStringTag, { value: "Module" })), Te = {
  height: 400,
  width: 400,
  padding: 40
}, QP = (e) => {
  e = "" + e;
  const t = e.indexOf("#") == 0, r = e.indexOf("rgb") == 0;
  let n, o, s;
  if (t) {
    const i = e.length == 7, l = e.substr(1).match(i ? /(\S{2})/g : /(\S{1})/g);
    l && (n = parseInt(l[0] + (i ? "" : l[0]), 16), o = parseInt(l[1] + (i ? "" : l[1]), 16), s = parseInt(l[2] + (i ? "" : l[2]), 16));
  }
  if (r) {
    const i = e.match(/(\d+){3}/g);
    i && (n = i[0], o = i[1], s = i[2]);
  }
  return typeof n < "u" ? (n * 299 + o * 587 + s * 114) / 1e3 : 0;
}, JP = (e) => {
  const t = Te.height - Te.padding * 2;
  return Math.round(t / e);
}, eN = (e, t, r) => {
  const n = Te.width - Te.padding * 2, o = [];
  let s = { text: "", totalWidth: 0 };
  for (let i = 0; i < e.length; i++) {
    const l = e[i], c = s.text ? ` ${l.text}` : l.text, a = s.text ? t.width + l.width : l.width;
    if (s.totalWidth + a < n)
      s.text = `${s.text}${c}`, s.totalWidth += a;
    else {
      if (!s.text)
        return !1;
      o.push({ ...s }), s.text = l.text, s.totalWidth = l.width;
    }
  }
  if (s.totalWidth < n)
    o.push(s);
  else
    return !1;
  return o.length > r ? !1 : o;
}, tN = (e, t, r) => {
  let n = !1, o = 200;
  for (; !n; ) {
    e.canvas.width = Te.width, e.canvas.height = Te.height, e.font = `${o}pt ${r}`;
    const s = t.split(" ").map((u) => ({ text: u, width: e.measureText(u).width })), i = e.measureText(" "), l = e.measureText(t), c = l.actualBoundingBoxAscent + l.actualBoundingBoxDescent + 20, a = JP(c);
    if (n = eN(s, i, a), o -= 5, n)
      return { lines: n, textHeight: c };
  }
  return !1;
}, rN = async (e, t) => {
  const r = t.replace("http://", "https://"), n = new FontFace(e, `url("${r}")`, {
    style: "normal",
    weight: "400"
  });
  await n.load(), document.fonts.add(n);
}, nN = async (e, t, r) => {
  const n = document.createElement("canvas"), o = n.getContext("2d");
  await rN(t.family, t.files.regular);
  const s = tN(o, e, t.family);
  if (!s)
    return "";
  const l = QP(r) < 210 ? "white" : "#444444";
  return o.textAlign = "left", o.textBaseline = "top", o.fillStyle = l, s.lines.forEach((c, a) => {
    o.fillText(
      c.text,
      Te.padding,
      Te.padding + s.textHeight * a
    );
  }), n.toDataURL();
}, Oe = 200;
class ul {
  constructor(t) {
    K(this, "paddingOptions");
    K(this, "border");
    K(this, "opacity");
    K(this, "shadow");
    K(this, "shadowType");
    K(this, "textures");
    this.paddingOptions = t.paddingOptions, this.border = t.border, this.opacity = t.opacity, this.shadow = t.shadow, this.shadowType = t.shadowType, this.textures = t.textures;
  }
  async addShape(t, r, n, o, s, i = 1, l = null, c = null, a = null, u = 0) {
    const h = Le.shape(), m = Oe / 2 - u / i / 2, f = (Oe - u / i) / Oe;
    if (this.setCoords(h, r, n), this.setPath(h, o), this.setScale(h, i), this.setPadding(h, f, m), this.setAngle(h, o, m), this.setFlip(h, o.flip), this.setOpacity(h), this.setFill(h.objects[1].objects[1], o, s), o.svg = N8(o.outerSvg), h.pk_shape = o, h.pk_fill = s, h.pk_rotation = o.rotation, h.selectable = !1, c && await this.setTexture(h, o, s), l && await this.setImage(h, l, o), a && await this.setText(h, a, o, s), t)
      t.objects.push(h);
    else
      return h;
  }
  setCoords(t, r, n) {
    t.pk_left = n * Oe, t.pk_top = r * Oe, t.left = t.pk_left + this.border, t.top = t.pk_top + this.border;
  }
  setPath(t, r) {
    t.objects[1].objects[1].path = r.path;
  }
  setScale(t, r) {
    t.scaleX = r, t.scaleY = r;
  }
  setFill(t, r, n, o = Oe, s = Oe) {
    if (typeof n == "string" || n === void 0)
      t.fill = n;
    else {
      const i = wT(
        n,
        r.rotation,
        o,
        s
      );
      t.fill = i;
    }
  }
  async setImage(t, r, n) {
    const o = Le.image(), s = await ll(r);
    o.path = n.path, o.fill.source = s, t.objects[1].objects.push(o), t.pk_image = r;
  }
  async setText(t, r, n, o) {
    const s = Le.text(), i = await nN(
      r.text,
      r.font,
      o
    );
    s.path = n.path, s.fill.source = i, t.objects[1].objects.push(s), t.pk_text = r;
  }
  async setTexture(t, r, n) {
    const o = Le.texture(), s = le(this.textures), i = Ia(s.name, n), [l, c] = await cl(
      i,
      360 - r.rotation
    );
    c(), o.source = l, o.patternTransform = [
      1 / t.scaleX,
      0,
      0,
      1 / t.scaleX,
      0,
      0
    ], t.objects[1].objects[1].fill = o, t.pk_texture = s;
  }
  setPadding(t, r, n) {
    t.objects[1].scaleX = r, t.objects[1].scaleY = r, t.objects[1].left = -n, t.objects[1].top = -n;
  }
  setAngle(t, r, n) {
    r.height && (t.objects[1].objects[1].height = r.height, t.objects[1].objects[1].top = 100 - r.height), r.width && (t.objects[1].objects[1].width = r.width, t.objects[1].objects[1].left = 100 - r.width), t.objects[1].angle = r.rotation, t.objects[1].rotation = r.rotation, [90, 180].includes(r.rotation) && (t.objects[1].left = n), [270, 180].includes(r.rotation) && (t.objects[1].top = n);
  }
  setFlip(t, r = !1) {
    t.objects[1].flipX = r;
  }
  setOpacity(t) {
    t.opacity = this.opacity;
  }
  setShadow(t, r) {
    const n = Le.shadow();
    n.blur = this.shadow;
    const o = r.arrayValue ? r.arrayValue[0] : r;
    n.color = this.shadowType === "black" ? "black" : o, t.objects[1].objects[1].shadow = n;
  }
}
const p9 = Oa, oN = [
  "circles",
  "triangles",
  "rectangles",
  "miscellanious"
], N8 = (e) => `<svg xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 200 200" >
            <path id="rect" d="M0,0 L200,0 200,200 0,200 Z" fill="transparent" />   
            <path id="shape" stroke-width="0" fill-rule="nonzero" d="${e} Z" /> 
          </svg>`, sN = (e, t) => !e.innerSvg || !t ? "" : e.innerSvg(t), ao = JSON.parse(JSON.stringify(p9)).map((e) => (e.svg = N8(e.outerSvg), e)), iN = ao.filter((e) => !e.hidden), aN = (e, t) => {
  const r = {
    ...p9.find((o) => o.name === e),
    svg: ""
  }, n = `${r.outerSvg} ${sN(r, t)}`;
  return r.svg = N8(n), r;
}, G3 = (e) => p9.find((t) => t.name === e), hl = (e) => tT[e], S50 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  categories: oN,
  getSvg: N8,
  list: ao,
  userList: iN,
  getShapeByName: aN,
  getShapePathByName: G3,
  getShapeBlockByName: hl,
  default: ao,
  builder: ul
}, Symbol.toStringTag, { value: "Module" }));
class lN {
  constructor() {
    K(this, "record", {});
  }
  add(t, r) {
    this.record[t] = r;
  }
  get(t, r) {
    console.log(t, r);
  }
}
const vr = 200;
class cN {
  constructor(t) {
    K(this, "blank");
    K(this, "cells");
    K(this, "componentCells");
    K(this, "config");
    K(this, "Shape");
    K(this, "imageConfig");
    K(this, "textConfig");
    K(this, "width");
    K(this, "height");
    K(this, "border");
    K(this, "colours");
    K(this, "gradients");
    K(this, "background");
    K(this, "backgroundColour");
    K(this, "padding");
    K(this, "paddingOptions");
    K(this, "opacity");
    K(this, "backgroundOpacity");
    K(this, "density");
    K(this, "designView");
    K(this, "backgroundView");
    K(this, "gradientsView");
    K(this, "paddingView");
    K(this, "shapes");
    K(this, "weightedShapes");
    K(this, "weightedImageShapes");
    K(this, "templates");
    K(this, "template");
    K(this, "blocks");
    K(this, "images");
    K(this, "textures");
    K(this, "text");
    K(this, "font");
    K(this, "shadow");
    K(this, "shadowType");
    K(this, "grid");
    K(this, "history");
    this.width = t.width, this.height = t.height, this.border = t.border, this.colours = [...t.colours], this.background = t.background, this.gradients = [...t.gradients], this.padding = t.padding, this.opacity = t.opacity, this.backgroundOpacity = t.backgroundOpacity, this.density = t.density, this.designView = t.designView, this.backgroundView = t.backgroundView, this.gradientsView = t.gradientsView, this.paddingView = t.paddingView, this.shapes = t.shapes, this.templates = t.templates, this.blocks = t.blocks, this.images = t.images, this.textures = t.textures, this.text = t.text, this.font = t.font, this.shadow = t.shadow, this.shadowType = t.shadowType, this.grid = t.grid, this.init();
  }
  async init() {
    this.initPadding(), this.initShape(), this.initTemplate(), this.initColours(), this.initCells(), this.initComponentCells(), this.createTextConfig(), this.createImageConfig(), this.weightedImageShapes = this.getWeightedShapes(this.template.imageShapes), this.history = new lN(), this.blank = Le.blank();
  }
  initShape() {
    const { paddingOptions: t, border: r, opacity: n, shadow: o, shadowType: s, textures: i } = this;
    this.Shape = new ul({
      paddingOptions: t,
      border: r,
      opacity: n,
      shadow: o,
      shadowType: s,
      textures: i
    });
  }
  initTemplate() {
    switch (this.designView) {
      case "templates":
        this.template = t2[le(this.templates)];
        return;
      case "shapes":
        this.template = {
          type: "shapes",
          randomFactor: 0.4,
          shapes: this.shapes,
          imageShapes: this.shapes
        };
        return;
      case "blocks":
        this.template = to(this.blocks);
        return;
      case "random":
        this.template = to();
        return;
      default:
        return;
    }
  }
  initColours() {
    if (this.gradientsView === "on" && (this.colours = this.colours.concat(this.gradients)), this.colours.length === 1) {
      this.backgroundColour = "";
      return;
    }
    switch (this.backgroundView) {
      case "random":
        const t = A8(this.colours);
        this.backgroundColour = this.colours[t], this.colours.splice(t, 1);
        return;
      case "white":
        this.backgroundColour = "#fff";
        return;
      case "black":
        this.backgroundColour = "#000";
        return;
      case "manual":
        const r = this.colours.indexOf(this.background);
        r !== -1 && this.colours.splice(r, 1), this.backgroundColour = this.background;
        return;
      default:
        this.backgroundColour = "";
    }
  }
  initCells() {
    this.cells = [];
    for (let t = 0; t < this.height; t++)
      for (let r = 0; r < this.width; r++)
        this.cells.push([t, r]);
  }
  initComponentCells() {
    this.componentCells = [];
    for (let t = 0; t < this.height; t += 2)
      for (let r = 0; r < this.width; r += 2)
        this.componentCells.push([t, r]);
  }
  initPadding() {
    const t = this.padding < 90 ? le([120, 140, 160, 180]) : le([0, 40, 60]);
    this.paddingOptions = this.paddingView ? [this.padding, t] : [this.padding];
  }
  createTextConfig() {
    if (this.text) {
      const t = Jn(this.componentCells);
      this.textConfig = { text: { text: this.text, font: this.font }, coords: t };
    }
  }
  createImageConfig() {
    this.imageConfig = [];
    const t = this.text && this.font ? 1 : 0, r = this.width / 2 * (this.height / 2) - t, n = this.images.length <= r ? this.images : Fr(r, this.images);
    for (let o of n) {
      const s = Jn(this.componentCells);
      this.imageConfig.push({ image: o, coords: s });
    }
  }
  async build() {
    this.addBackground(), await this.addImages(), await this.addText();
    for (let t of this.cells)
      if (this.shapeCheck(t) && this.densityCheck()) {
        const [r, n] = t;
        await this.buildCell(r, n);
      }
    return { pattern: this.blank, background: this.backgroundColour };
  }
  addBackground() {
    if (this.backgroundView === "none")
      return;
    const t = Le.background();
    t.width = this.width * vr + this.border * 2, t.height = this.height * vr + this.border * 2, t.opacity = this.backgroundOpacity, this.Shape.setFill(
      t,
      { rotation: 0 },
      this.backgroundColour,
      this.width * vr,
      this.height * vr
    ), this.blank.objects.push(t);
  }
  async addText() {
    if (!this.textConfig)
      return;
    const t = le(this.colours), r = G3("square"), { coords: n, text: o } = this.textConfig, [s, i] = n;
    await this.Shape.addShape(
      this.blank,
      s,
      i,
      r,
      t,
      2,
      null,
      null,
      o
    );
  }
  async addImages() {
    for (let t of this.imageConfig) {
      const r = le(this.weightedImageShapes), n = this.grid ? 2 : 1, o = Fr(n, this.colours);
      this.grid && this.colours.length >= 3 && this.addGrid(t.coords[0], t.coords[1], o[1]), await this.Shape.addShape(
        this.blank,
        t.coords[0],
        t.coords[1],
        r,
        o[0],
        2,
        t.image,
        this.textureCheck()
      );
    }
  }
  async buildCell(t, r) {
    this.template.type === "blocks" && this.topLeftCheck(t, r) && await this.handleBlockTemplate(t, r);
  }
  getBlock(t) {
    if (t.includes("block"))
      return Da(t);
    if (t.includes("shape"))
      return hl(t);
  }
  async handleBlockTemplate(t, r) {
    const n = ja(
      this.template.blocks,
      this.template.blockWeights
    ), o = this.getBlock(n);
    if (!o)
      return;
    const s = this.grid ? o.colourCount + 1 : o.colourCount, i = Fr(s, this.colours);
    this.grid && this.colours.length >= 3 && this.addGrid(t, r, i[i.length - 1]);
    const l = [], c = o.rotate ? this.getRandomRotation() : 0, a = le(this.paddingOptions);
    for (let u of o.shapes) {
      const h = i[u.colour], m = G3(u.name);
      let f = u.rotation + c;
      f = f >= 360 ? f - 360 : f, m.rotation = f, m.flip = u.flip;
      let d;
      h && !l.includes(u.position.join("-")) && (d = this.textureCheck(), l.push(u.position.join("-"))), h && await this.Shape.addShape(
        this.blank,
        t + u.position[1],
        r + u.position[0],
        m,
        h,
        u.size,
        null,
        d,
        null,
        a
      );
    }
  }
  async addGrid(t, r, n) {
    const o = G3("square");
    await this.Shape.addShape(
      this.blank,
      t,
      r,
      o,
      n,
      2,
      null,
      null
    );
  }
  getRandomRotation() {
    return Ea(0, 3) * 90;
  }
  getWeightedShapes(t) {
    const r = [];
    return t.forEach((n) => {
      const o = G3(n);
      for (let s = 0; s < o.symmetry; s++)
        o.rotation = s * 90, r.push({ ...o, rotation: s * 90 });
    }), r;
  }
  shapeCheck(t) {
    const r = [...this.imageConfig];
    this.text && r.push(this.textConfig);
    const [n, o] = t;
    return !r.filter((s) => JSON.stringify(t) === JSON.stringify(s.coords) || JSON.stringify([n - 1, o]) === JSON.stringify(s.coords) || JSON.stringify([n, o - 1]) === JSON.stringify(s.coords) || JSON.stringify([n - 1, o - 1]) === JSON.stringify(s.coords)).length;
  }
  textureCheck(t = 0.3) {
    return this.textures.length ? Math.random() < t : !1;
  }
  densityCheck() {
    return Math.random() < this.density / 10;
  }
  topLeftCheck(t, r) {
    return [t, r].every((o) => o % 2 === 0);
  }
  randomFactorCheck(t = this.template.randomFactor) {
    return Math.random() < t;
  }
}
var V = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ml(e) {
  var t = e.default;
  if (typeof t == "function") {
    var r = function() {
      return t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
const uN = {}, hN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uN
}, Symbol.toStringTag, { value: "Module" })), mN = /* @__PURE__ */ ml(hN);
var lo = { exports: {} };
/*! https://mths.be/punycode v1.3.2 by @mathias */
(function(e, t) {
  (function(r) {
    var n = t && !t.nodeType && t, o = e && !e.nodeType && e, s = typeof V == "object" && V;
    (s.global === s || s.window === s || s.self === s) && (r = s);
    var i, l = 2147483647, c = 36, a = 1, u = 26, h = 38, m = 700, f = 72, d = 128, k = "-", b = /^xn--/, w = /[^\x20-\x7E]/, L = /[\x2E\u3002\uFF0E\uFF61]/g, A = {
      overflow: "Overflow: input needs wider integers to process",
      "not-basic": "Illegal input >= 0x80 (not a basic code point)",
      "invalid-input": "Invalid input"
    }, C = c - a, g = Math.floor, M = String.fromCharCode, P;
    function x(B) {
      throw RangeError(A[B]);
    }
    function j(B, Y) {
      for (var r0 = B.length, v = []; r0--; )
        v[r0] = Y(B[r0]);
      return v;
    }
    function O(B, Y) {
      var r0 = B.split("@"), v = "";
      r0.length > 1 && (v = r0[0] + "@", B = r0[1]), B = B.replace(L, ".");
      var p = B.split("."), N = j(p, Y).join(".");
      return v + N;
    }
    function y(B) {
      for (var Y = [], r0 = 0, v = B.length, p, N; r0 < v; )
        p = B.charCodeAt(r0++), p >= 55296 && p <= 56319 && r0 < v ? (N = B.charCodeAt(r0++), (N & 64512) == 56320 ? Y.push(((p & 1023) << 10) + (N & 1023) + 65536) : (Y.push(p), r0--)) : Y.push(p);
      return Y;
    }
    function D(B) {
      return j(B, function(Y) {
        var r0 = "";
        return Y > 65535 && (Y -= 65536, r0 += M(Y >>> 10 & 1023 | 55296), Y = 56320 | Y & 1023), r0 += M(Y), r0;
      }).join("");
    }
    function E(B) {
      return B - 48 < 10 ? B - 22 : B - 65 < 26 ? B - 65 : B - 97 < 26 ? B - 97 : c;
    }
    function W(B, Y) {
      return B + 22 + 75 * (B < 26) - ((Y != 0) << 5);
    }
    function U(B, Y, r0) {
      var v = 0;
      for (B = r0 ? g(B / m) : B >> 1, B += g(B / Y); B > C * u >> 1; v += c)
        B = g(B / C);
      return g(v + (C + 1) * B / (B + h));
    }
    function i0(B) {
      var Y = [], r0 = B.length, v, p = 0, N = d, z = f, f0, p0, b0, M0, y0, q0, _0, R0, te;
      for (f0 = B.lastIndexOf(k), f0 < 0 && (f0 = 0), p0 = 0; p0 < f0; ++p0)
        B.charCodeAt(p0) >= 128 && x("not-basic"), Y.push(B.charCodeAt(p0));
      for (b0 = f0 > 0 ? f0 + 1 : 0; b0 < r0; ) {
        for (M0 = p, y0 = 1, q0 = c; b0 >= r0 && x("invalid-input"), _0 = E(B.charCodeAt(b0++)), (_0 >= c || _0 > g((l - p) / y0)) && x("overflow"), p += _0 * y0, R0 = q0 <= z ? a : q0 >= z + u ? u : q0 - z, !(_0 < R0); q0 += c)
          te = c - R0, y0 > g(l / te) && x("overflow"), y0 *= te;
        v = Y.length + 1, z = U(p - M0, v, M0 == 0), g(p / v) > l - N && x("overflow"), N += g(p / v), p %= v, Y.splice(p++, 0, N);
      }
      return D(Y);
    }
    function Q(B) {
      var Y, r0, v, p, N, z, f0, p0, b0, M0, y0, q0 = [], _0, R0, te, Mt;
      for (B = y(B), _0 = B.length, Y = d, r0 = 0, N = f, z = 0; z < _0; ++z)
        y0 = B[z], y0 < 128 && q0.push(M(y0));
      for (v = p = q0.length, p && q0.push(k); v < _0; ) {
        for (f0 = l, z = 0; z < _0; ++z)
          y0 = B[z], y0 >= Y && y0 < f0 && (f0 = y0);
        for (R0 = v + 1, f0 - Y > g((l - r0) / R0) && x("overflow"), r0 += (f0 - Y) * R0, Y = f0, z = 0; z < _0; ++z)
          if (y0 = B[z], y0 < Y && ++r0 > l && x("overflow"), y0 == Y) {
            for (p0 = r0, b0 = c; M0 = b0 <= N ? a : b0 >= N + u ? u : b0 - N, !(p0 < M0); b0 += c)
              Mt = p0 - M0, te = c - M0, q0.push(
                M(W(M0 + Mt % te, 0))
              ), p0 = g(Mt / te);
            q0.push(M(W(p0, 0))), N = U(r0, R0, v == p), r0 = 0, ++v;
          }
        ++r0, ++Y;
      }
      return q0.join("");
    }
    function v0(B) {
      return O(B, function(Y) {
        return b.test(Y) ? i0(Y.slice(4).toLowerCase()) : Y;
      });
    }
    function N0(B) {
      return O(B, function(Y) {
        return w.test(Y) ? "xn--" + Q(Y) : Y;
      });
    }
    if (i = {
      version: "1.3.2",
      ucs2: {
        decode: y,
        encode: D
      },
      decode: i0,
      encode: Q,
      toASCII: N0,
      toUnicode: v0
    }, n && o)
      if (e.exports == n)
        o.exports = i;
      else
        for (P in i)
          i.hasOwnProperty(P) && (n[P] = i[P]);
    else
      r.punycode = i;
  })(V);
})(lo, lo.exports);
var m7 = {};
function fN(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
var dN = function(e, t, r, n) {
  t = t || "&", r = r || "=";
  var o = {};
  if (typeof e != "string" || e.length === 0)
    return o;
  var s = /\+/g;
  e = e.split(t);
  var i = 1e3;
  n && typeof n.maxKeys == "number" && (i = n.maxKeys);
  var l = e.length;
  i > 0 && l > i && (l = i);
  for (var c = 0; c < l; ++c) {
    var a = e[c].replace(s, "%20"), u = a.indexOf(r), h, m, f, d;
    u >= 0 ? (h = a.substr(0, u), m = a.substr(u + 1)) : (h = a, m = ""), f = decodeURIComponent(h), d = decodeURIComponent(m), fN(o, f) ? Array.isArray(o[f]) ? o[f].push(d) : o[f] = [o[f], d] : o[f] = d;
  }
  return o;
}, $3 = function(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "boolean":
      return e ? "true" : "false";
    case "number":
      return isFinite(e) ? e : "";
    default:
      return "";
  }
}, pN = function(e, t, r, n) {
  return t = t || "&", r = r || "=", e === null && (e = void 0), typeof e == "object" ? Object.keys(e).map(function(o) {
    var s = encodeURIComponent($3(o)) + r;
    return Array.isArray(e[o]) ? e[o].map(function(i) {
      return s + encodeURIComponent($3(i));
    }).join(t) : s + encodeURIComponent($3(e[o]));
  }).join(t) : n ? encodeURIComponent($3(n)) + r + encodeURIComponent($3(e)) : "";
};
m7.decode = m7.parse = dN;
m7.encode = m7.stringify = pN;
var gN = lo.exports;
function me() {
  this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
}
var kN = /^([a-z0-9.+-]+:)/i, vN = /:[0-9]*$/, yN = ["<", ">", '"', "`", " ", "\r", `
`, "	"], bN = ["{", "}", "|", "\\", "^", "`"].concat(yN), co = ["'"].concat(bN), ts = ["%", "/", "?", ";", "#"].concat(co), rs = ["/", "?", "#"], xN = 255, ns = /^[a-z0-9A-Z_-]{0,63}$/, wN = /^([a-z0-9A-Z_-]{0,63})(.*)$/, LN = {
  javascript: !0,
  "javascript:": !0
}, uo = {
  javascript: !0,
  "javascript:": !0
}, Kt = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
}, fl = m7;
function zN(e, t, r) {
  if (e && pl(e) && e instanceof me)
    return e;
  var n = new me();
  return n.parse(e, t, r), n;
}
me.prototype.parse = function(e, t, r) {
  if (!dl(e))
    throw new TypeError("Parameter 'url' must be a string, not " + typeof e);
  var n = e;
  n = n.trim();
  var o = kN.exec(n);
  if (o) {
    o = o[0];
    var s = o.toLowerCase();
    this.protocol = s, n = n.substr(o.length);
  }
  if (r || o || n.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var i = n.substr(0, 2) === "//";
    i && !(o && uo[o]) && (n = n.substr(2), this.slashes = !0);
  }
  if (!uo[o] && (i || o && !Kt[o])) {
    for (var l = -1, c = 0; c < rs.length; c++) {
      var a = n.indexOf(rs[c]);
      a !== -1 && (l === -1 || a < l) && (l = a);
    }
    var u, h;
    l === -1 ? h = n.lastIndexOf("@") : h = n.lastIndexOf("@", l), h !== -1 && (u = n.slice(0, h), n = n.slice(h + 1), this.auth = decodeURIComponent(u)), l = -1;
    for (var c = 0; c < ts.length; c++) {
      var a = n.indexOf(ts[c]);
      a !== -1 && (l === -1 || a < l) && (l = a);
    }
    l === -1 && (l = n.length), this.host = n.slice(0, l), n = n.slice(l), this.parseHost(), this.hostname = this.hostname || "";
    var m = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!m)
      for (var f = this.hostname.split(/\./), c = 0, d = f.length; c < d; c++) {
        var k = f[c];
        if (!!k && !k.match(ns)) {
          for (var b = "", w = 0, L = k.length; w < L; w++)
            k.charCodeAt(w) > 127 ? b += "x" : b += k[w];
          if (!b.match(ns)) {
            var A = f.slice(0, c), C = f.slice(c + 1), g = k.match(wN);
            g && (A.push(g[1]), C.unshift(g[2])), C.length && (n = "/" + C.join(".") + n), this.hostname = A.join(".");
            break;
          }
        }
      }
    if (this.hostname.length > xN ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), !m) {
      for (var M = this.hostname.split("."), P = [], c = 0; c < M.length; ++c) {
        var x = M[c];
        P.push(x.match(/[^A-Za-z0-9_-]/) ? "xn--" + gN.encode(x) : x);
      }
      this.hostname = P.join(".");
    }
    var j = this.port ? ":" + this.port : "", O = this.hostname || "";
    this.host = O + j, this.href += this.host, m && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), n[0] !== "/" && (n = "/" + n));
  }
  if (!LN[s])
    for (var c = 0, d = co.length; c < d; c++) {
      var y = co[c], D = encodeURIComponent(y);
      D === y && (D = escape(y)), n = n.split(y).join(D);
    }
  var E = n.indexOf("#");
  E !== -1 && (this.hash = n.substr(E), n = n.slice(0, E));
  var W = n.indexOf("?");
  if (W !== -1 ? (this.search = n.substr(W), this.query = n.substr(W + 1), t && (this.query = fl.parse(this.query)), n = n.slice(0, W)) : t && (this.search = "", this.query = {}), n && (this.pathname = n), Kt[s] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
    var j = this.pathname || "", x = this.search || "";
    this.path = j + x;
  }
  return this.href = this.format(), this;
};
me.prototype.format = function() {
  var e = this.auth || "";
  e && (e = encodeURIComponent(e), e = e.replace(/%3A/i, ":"), e += "@");
  var t = this.protocol || "", r = this.pathname || "", n = this.hash || "", o = !1, s = "";
  this.host ? o = e + this.host : this.hostname && (o = e + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (o += ":" + this.port)), this.query && pl(this.query) && Object.keys(this.query).length && (s = fl.stringify(this.query));
  var i = this.search || s && "?" + s || "";
  return t && t.substr(-1) !== ":" && (t += ":"), this.slashes || (!t || Kt[t]) && o !== !1 ? (o = "//" + (o || ""), r && r.charAt(0) !== "/" && (r = "/" + r)) : o || (o = ""), n && n.charAt(0) !== "#" && (n = "#" + n), i && i.charAt(0) !== "?" && (i = "?" + i), r = r.replace(/[?#]/g, function(l) {
    return encodeURIComponent(l);
  }), i = i.replace("#", "%23"), t + o + r + i + n;
};
me.prototype.resolve = function(e) {
  return this.resolveObject(zN(e, !1, !0)).format();
};
me.prototype.resolveObject = function(e) {
  if (dl(e)) {
    var t = new me();
    t.parse(e, !1, !0), e = t;
  }
  var r = new me();
  if (Object.keys(this).forEach(function(L) {
    r[L] = this[L];
  }, this), r.hash = e.hash, e.href === "")
    return r.href = r.format(), r;
  if (e.slashes && !e.protocol)
    return Object.keys(e).forEach(function(L) {
      L !== "protocol" && (r[L] = e[L]);
    }), Kt[r.protocol] && r.hostname && !r.pathname && (r.path = r.pathname = "/"), r.href = r.format(), r;
  if (e.protocol && e.protocol !== r.protocol) {
    if (!Kt[e.protocol])
      return Object.keys(e).forEach(function(L) {
        r[L] = e[L];
      }), r.href = r.format(), r;
    if (r.protocol = e.protocol, !e.host && !uo[e.protocol]) {
      for (var u = (e.pathname || "").split("/"); u.length && !(e.host = u.shift()); )
        ;
      e.host || (e.host = ""), e.hostname || (e.hostname = ""), u[0] !== "" && u.unshift(""), u.length < 2 && u.unshift(""), r.pathname = u.join("/");
    } else
      r.pathname = e.pathname;
    if (r.search = e.search, r.query = e.query, r.host = e.host || "", r.auth = e.auth, r.hostname = e.hostname || e.host, r.port = e.port, r.pathname || r.search) {
      var n = r.pathname || "", o = r.search || "";
      r.path = n + o;
    }
    return r.slashes = r.slashes || e.slashes, r.href = r.format(), r;
  }
  var s = r.pathname && r.pathname.charAt(0) === "/", i = e.host || e.pathname && e.pathname.charAt(0) === "/", l = i || s || r.host && e.pathname, c = l, a = r.pathname && r.pathname.split("/") || [], u = e.pathname && e.pathname.split("/") || [], h = r.protocol && !Kt[r.protocol];
  if (h && (r.hostname = "", r.port = null, r.host && (a[0] === "" ? a[0] = r.host : a.unshift(r.host)), r.host = "", e.protocol && (e.hostname = null, e.port = null, e.host && (u[0] === "" ? u[0] = e.host : u.unshift(e.host)), e.host = null), l = l && (u[0] === "" || a[0] === "")), i)
    r.host = e.host || e.host === "" ? e.host : r.host, r.hostname = e.hostname || e.hostname === "" ? e.hostname : r.hostname, r.search = e.search, r.query = e.query, a = u;
  else if (u.length)
    a || (a = []), a.pop(), a = a.concat(u), r.search = e.search, r.query = e.query;
  else if (!CN(e.search)) {
    if (h) {
      r.hostname = r.host = a.shift();
      var m = r.host && r.host.indexOf("@") > 0 ? r.host.split("@") : !1;
      m && (r.auth = m.shift(), r.host = r.hostname = m.shift());
    }
    return r.search = e.search, r.query = e.query, (!yr(r.pathname) || !yr(r.search)) && (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.href = r.format(), r;
  }
  if (!a.length)
    return r.pathname = null, r.search ? r.path = "/" + r.search : r.path = null, r.href = r.format(), r;
  for (var f = a.slice(-1)[0], d = (r.host || e.host) && (f === "." || f === "..") || f === "", k = 0, b = a.length; b >= 0; b--)
    f = a[b], f == "." ? a.splice(b, 1) : f === ".." ? (a.splice(b, 1), k++) : k && (a.splice(b, 1), k--);
  if (!l && !c)
    for (; k--; k)
      a.unshift("..");
  l && a[0] !== "" && (!a[0] || a[0].charAt(0) !== "/") && a.unshift(""), d && a.join("/").substr(-1) !== "/" && a.push("");
  var w = a[0] === "" || a[0] && a[0].charAt(0) === "/";
  if (h) {
    r.hostname = r.host = w ? "" : a.length ? a.shift() : "";
    var m = r.host && r.host.indexOf("@") > 0 ? r.host.split("@") : !1;
    m && (r.auth = m.shift(), r.host = r.hostname = m.shift());
  }
  return l = l || r.host && a.length, l && !w && a.unshift(""), a.length ? r.pathname = a.join("/") : (r.pathname = null, r.path = null), (!yr(r.pathname) || !yr(r.search)) && (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.auth = e.auth || r.auth, r.slashes = r.slashes || e.slashes, r.href = r.format(), r;
};
me.prototype.parseHost = function() {
  var e = this.host, t = vN.exec(e);
  t && (t = t[0], t !== ":" && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e);
};
function dl(e) {
  return typeof e == "string";
}
function pl(e) {
  return typeof e == "object" && e !== null;
}
function yr(e) {
  return e === null;
}
function CN(e) {
  return e == null;
}
var gl = {}, kl = {}, vl = {};
(function(e) {
  (function(t) {
    t.parser = function(v, p) {
      return new n(v, p);
    }, t.SAXParser = n, t.MAX_BUFFER_LENGTH = 64 * 1024;
    var r = [
      "comment",
      "sgmlDecl",
      "textNode",
      "tagName",
      "doctype",
      "procInstName",
      "procInstBody",
      "entity",
      "attribName",
      "attribValue",
      "cdata",
      "script"
    ];
    t.EVENTS = [
      "text",
      "processinginstruction",
      "sgmldeclaration",
      "doctype",
      "comment",
      "opentagstart",
      "attribute",
      "opentag",
      "closetag",
      "opencdata",
      "cdata",
      "closecdata",
      "error",
      "end",
      "ready",
      "script",
      "opennamespace",
      "closenamespace"
    ];
    function n(v, p) {
      if (!(this instanceof n))
        return new n(v, p);
      var N = this;
      s(N), N.q = N.c = "", N.bufferCheckPosition = t.MAX_BUFFER_LENGTH, N.opt = p || {}, N.opt.lowercase = N.opt.lowercase || N.opt.lowercasetags, N.looseCase = N.opt.lowercase ? "toLowerCase" : "toUpperCase", N.tags = [], N.closed = N.closedRoot = N.sawRoot = !1, N.tag = N.error = null, N.strict = !!v, N.noscript = !!(v || N.opt.noscript), N.state = g.BEGIN, N.strictEntities = N.opt.strictEntities, N.ENTITIES = N.strictEntities ? Object.create(t.XML_ENTITIES) : Object.create(t.ENTITIES), N.attribList = [], N.opt.xmlns && (N.ns = Object.create(h)), N.trackPosition = N.opt.position !== !1, N.trackPosition && (N.position = N.line = N.column = 0), P(N, "onready");
    }
    Object.create || (Object.create = function(v) {
      function p() {
      }
      p.prototype = v;
      var N = new p();
      return N;
    }), Object.keys || (Object.keys = function(v) {
      var p = [];
      for (var N in v)
        v.hasOwnProperty(N) && p.push(N);
      return p;
    });
    function o(v) {
      for (var p = Math.max(t.MAX_BUFFER_LENGTH, 10), N = 0, z = 0, f0 = r.length; z < f0; z++) {
        var p0 = v[r[z]].length;
        if (p0 > p)
          switch (r[z]) {
            case "textNode":
              j(v);
              break;
            case "cdata":
              x(v, "oncdata", v.cdata), v.cdata = "";
              break;
            case "script":
              x(v, "onscript", v.script), v.script = "";
              break;
            default:
              y(v, "Max buffer length exceeded: " + r[z]);
          }
        N = Math.max(N, p0);
      }
      var b0 = t.MAX_BUFFER_LENGTH - N;
      v.bufferCheckPosition = b0 + v.position;
    }
    function s(v) {
      for (var p = 0, N = r.length; p < N; p++)
        v[r[p]] = "";
    }
    function i(v) {
      j(v), v.cdata !== "" && (x(v, "oncdata", v.cdata), v.cdata = ""), v.script !== "" && (x(v, "onscript", v.script), v.script = "");
    }
    n.prototype = {
      end: function() {
        D(this);
      },
      write: r0,
      resume: function() {
        return this.error = null, this;
      },
      close: function() {
        return this.write(null);
      },
      flush: function() {
        i(this);
      }
    };
    var l = "[CDATA[", c = "DOCTYPE", a = "http://www.w3.org/XML/1998/namespace", u = "http://www.w3.org/2000/xmlns/", h = { xml: a, xmlns: u }, m = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, f = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/, d = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, k = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
    function b(v) {
      return v === " " || v === `
` || v === "\r" || v === "	";
    }
    function w(v) {
      return v === '"' || v === "'";
    }
    function L(v) {
      return v === ">" || b(v);
    }
    function A(v, p) {
      return v.test(p);
    }
    function C(v, p) {
      return !A(v, p);
    }
    var g = 0;
    t.STATE = {
      BEGIN: g++,
      BEGIN_WHITESPACE: g++,
      TEXT: g++,
      TEXT_ENTITY: g++,
      OPEN_WAKA: g++,
      SGML_DECL: g++,
      SGML_DECL_QUOTED: g++,
      DOCTYPE: g++,
      DOCTYPE_QUOTED: g++,
      DOCTYPE_DTD: g++,
      DOCTYPE_DTD_QUOTED: g++,
      COMMENT_STARTING: g++,
      COMMENT: g++,
      COMMENT_ENDING: g++,
      COMMENT_ENDED: g++,
      CDATA: g++,
      CDATA_ENDING: g++,
      CDATA_ENDING_2: g++,
      PROC_INST: g++,
      PROC_INST_BODY: g++,
      PROC_INST_ENDING: g++,
      OPEN_TAG: g++,
      OPEN_TAG_SLASH: g++,
      ATTRIB: g++,
      ATTRIB_NAME: g++,
      ATTRIB_NAME_SAW_WHITE: g++,
      ATTRIB_VALUE: g++,
      ATTRIB_VALUE_QUOTED: g++,
      ATTRIB_VALUE_CLOSED: g++,
      ATTRIB_VALUE_UNQUOTED: g++,
      ATTRIB_VALUE_ENTITY_Q: g++,
      ATTRIB_VALUE_ENTITY_U: g++,
      CLOSE_TAG: g++,
      CLOSE_TAG_SAW_WHITE: g++,
      SCRIPT: g++,
      SCRIPT_ENDING: g++
    }, t.XML_ENTITIES = {
      amp: "&",
      gt: ">",
      lt: "<",
      quot: '"',
      apos: "'"
    }, t.ENTITIES = {
      amp: "&",
      gt: ">",
      lt: "<",
      quot: '"',
      apos: "'",
      AElig: 198,
      Aacute: 193,
      Acirc: 194,
      Agrave: 192,
      Aring: 197,
      Atilde: 195,
      Auml: 196,
      Ccedil: 199,
      ETH: 208,
      Eacute: 201,
      Ecirc: 202,
      Egrave: 200,
      Euml: 203,
      Iacute: 205,
      Icirc: 206,
      Igrave: 204,
      Iuml: 207,
      Ntilde: 209,
      Oacute: 211,
      Ocirc: 212,
      Ograve: 210,
      Oslash: 216,
      Otilde: 213,
      Ouml: 214,
      THORN: 222,
      Uacute: 218,
      Ucirc: 219,
      Ugrave: 217,
      Uuml: 220,
      Yacute: 221,
      aacute: 225,
      acirc: 226,
      aelig: 230,
      agrave: 224,
      aring: 229,
      atilde: 227,
      auml: 228,
      ccedil: 231,
      eacute: 233,
      ecirc: 234,
      egrave: 232,
      eth: 240,
      euml: 235,
      iacute: 237,
      icirc: 238,
      igrave: 236,
      iuml: 239,
      ntilde: 241,
      oacute: 243,
      ocirc: 244,
      ograve: 242,
      oslash: 248,
      otilde: 245,
      ouml: 246,
      szlig: 223,
      thorn: 254,
      uacute: 250,
      ucirc: 251,
      ugrave: 249,
      uuml: 252,
      yacute: 253,
      yuml: 255,
      copy: 169,
      reg: 174,
      nbsp: 160,
      iexcl: 161,
      cent: 162,
      pound: 163,
      curren: 164,
      yen: 165,
      brvbar: 166,
      sect: 167,
      uml: 168,
      ordf: 170,
      laquo: 171,
      not: 172,
      shy: 173,
      macr: 175,
      deg: 176,
      plusmn: 177,
      sup1: 185,
      sup2: 178,
      sup3: 179,
      acute: 180,
      micro: 181,
      para: 182,
      middot: 183,
      cedil: 184,
      ordm: 186,
      raquo: 187,
      frac14: 188,
      frac12: 189,
      frac34: 190,
      iquest: 191,
      times: 215,
      divide: 247,
      OElig: 338,
      oelig: 339,
      Scaron: 352,
      scaron: 353,
      Yuml: 376,
      fnof: 402,
      circ: 710,
      tilde: 732,
      Alpha: 913,
      Beta: 914,
      Gamma: 915,
      Delta: 916,
      Epsilon: 917,
      Zeta: 918,
      Eta: 919,
      Theta: 920,
      Iota: 921,
      Kappa: 922,
      Lambda: 923,
      Mu: 924,
      Nu: 925,
      Xi: 926,
      Omicron: 927,
      Pi: 928,
      Rho: 929,
      Sigma: 931,
      Tau: 932,
      Upsilon: 933,
      Phi: 934,
      Chi: 935,
      Psi: 936,
      Omega: 937,
      alpha: 945,
      beta: 946,
      gamma: 947,
      delta: 948,
      epsilon: 949,
      zeta: 950,
      eta: 951,
      theta: 952,
      iota: 953,
      kappa: 954,
      lambda: 955,
      mu: 956,
      nu: 957,
      xi: 958,
      omicron: 959,
      pi: 960,
      rho: 961,
      sigmaf: 962,
      sigma: 963,
      tau: 964,
      upsilon: 965,
      phi: 966,
      chi: 967,
      psi: 968,
      omega: 969,
      thetasym: 977,
      upsih: 978,
      piv: 982,
      ensp: 8194,
      emsp: 8195,
      thinsp: 8201,
      zwnj: 8204,
      zwj: 8205,
      lrm: 8206,
      rlm: 8207,
      ndash: 8211,
      mdash: 8212,
      lsquo: 8216,
      rsquo: 8217,
      sbquo: 8218,
      ldquo: 8220,
      rdquo: 8221,
      bdquo: 8222,
      dagger: 8224,
      Dagger: 8225,
      bull: 8226,
      hellip: 8230,
      permil: 8240,
      prime: 8242,
      Prime: 8243,
      lsaquo: 8249,
      rsaquo: 8250,
      oline: 8254,
      frasl: 8260,
      euro: 8364,
      image: 8465,
      weierp: 8472,
      real: 8476,
      trade: 8482,
      alefsym: 8501,
      larr: 8592,
      uarr: 8593,
      rarr: 8594,
      darr: 8595,
      harr: 8596,
      crarr: 8629,
      lArr: 8656,
      uArr: 8657,
      rArr: 8658,
      dArr: 8659,
      hArr: 8660,
      forall: 8704,
      part: 8706,
      exist: 8707,
      empty: 8709,
      nabla: 8711,
      isin: 8712,
      notin: 8713,
      ni: 8715,
      prod: 8719,
      sum: 8721,
      minus: 8722,
      lowast: 8727,
      radic: 8730,
      prop: 8733,
      infin: 8734,
      ang: 8736,
      and: 8743,
      or: 8744,
      cap: 8745,
      cup: 8746,
      int: 8747,
      there4: 8756,
      sim: 8764,
      cong: 8773,
      asymp: 8776,
      ne: 8800,
      equiv: 8801,
      le: 8804,
      ge: 8805,
      sub: 8834,
      sup: 8835,
      nsub: 8836,
      sube: 8838,
      supe: 8839,
      oplus: 8853,
      otimes: 8855,
      perp: 8869,
      sdot: 8901,
      lceil: 8968,
      rceil: 8969,
      lfloor: 8970,
      rfloor: 8971,
      lang: 9001,
      rang: 9002,
      loz: 9674,
      spades: 9824,
      clubs: 9827,
      hearts: 9829,
      diams: 9830
    }, Object.keys(t.ENTITIES).forEach(function(v) {
      var p = t.ENTITIES[v], N = typeof p == "number" ? String.fromCharCode(p) : p;
      t.ENTITIES[v] = N;
    });
    for (var M in t.STATE)
      t.STATE[t.STATE[M]] = M;
    g = t.STATE;
    function P(v, p, N) {
      v[p] && v[p](N);
    }
    function x(v, p, N) {
      v.textNode && j(v), P(v, p, N);
    }
    function j(v) {
      v.textNode = O(v.opt, v.textNode), v.textNode && P(v, "ontext", v.textNode), v.textNode = "";
    }
    function O(v, p) {
      return v.trim && (p = p.trim()), v.normalize && (p = p.replace(/\s+/g, " ")), p;
    }
    function y(v, p) {
      j(v);
      const N = p + `
Line: ` + v.line + `
Column: ` + v.column + `
Char: ` + v.c, z = new Error(N);
      return z.reason = p, z.line = v.line, z.column = v.column, v.error = z, P(v, "onerror", z), v;
    }
    function D(v) {
      return v.sawRoot && !v.closedRoot && E(v, "Unclosed root tag"), v.state !== g.BEGIN && v.state !== g.BEGIN_WHITESPACE && v.state !== g.TEXT && y(v, "Unexpected end"), j(v), v.c = "", v.closed = !0, P(v, "onend"), n.call(v, v.strict, v.opt), v;
    }
    function E(v, p) {
      if (typeof v != "object" || !(v instanceof n))
        throw new Error("bad call to strictFail");
      v.strict && y(v, p);
    }
    function W(v) {
      v.strict || (v.tagName = v.tagName[v.looseCase]());
      var p = v.tags[v.tags.length - 1] || v, N = v.tag = { name: v.tagName, attributes: {} };
      v.opt.xmlns && (N.ns = p.ns), v.attribList.length = 0, x(v, "onopentagstart", N);
    }
    function U(v, p) {
      var N = v.indexOf(":"), z = N < 0 ? ["", v] : v.split(":"), f0 = z[0], p0 = z[1];
      return p && v === "xmlns" && (f0 = "xmlns", p0 = ""), { prefix: f0, local: p0 };
    }
    function i0(v) {
      if (v.strict || (v.attribName = v.attribName[v.looseCase]()), v.attribList.indexOf(v.attribName) !== -1 || v.tag.attributes.hasOwnProperty(v.attribName)) {
        v.attribName = v.attribValue = "";
        return;
      }
      if (v.opt.xmlns) {
        var p = U(v.attribName, !0), N = p.prefix, z = p.local;
        if (N === "xmlns")
          if (z === "xml" && v.attribValue !== a)
            E(
              v,
              "xml: prefix must be bound to " + a + `
Actual: ` + v.attribValue
            );
          else if (z === "xmlns" && v.attribValue !== u)
            E(
              v,
              "xmlns: prefix must be bound to " + u + `
Actual: ` + v.attribValue
            );
          else {
            var f0 = v.tag, p0 = v.tags[v.tags.length - 1] || v;
            f0.ns === p0.ns && (f0.ns = Object.create(p0.ns)), f0.ns[z] = v.attribValue;
          }
        v.attribList.push([v.attribName, v.attribValue]);
      } else
        v.tag.attributes[v.attribName] = v.attribValue, x(v, "onattribute", {
          name: v.attribName,
          value: v.attribValue
        });
      v.attribName = v.attribValue = "";
    }
    function Q(v, p) {
      if (v.opt.xmlns) {
        var N = v.tag, z = U(v.tagName);
        N.prefix = z.prefix, N.local = z.local, N.uri = N.ns[z.prefix] || "", N.prefix && !N.uri && (E(v, "Unbound namespace prefix: " + JSON.stringify(v.tagName)), N.uri = z.prefix);
        var f0 = v.tags[v.tags.length - 1] || v;
        N.ns && f0.ns !== N.ns && Object.keys(N.ns).forEach(function(F5) {
          x(v, "onopennamespace", {
            prefix: F5,
            uri: N.ns[F5]
          });
        });
        for (var p0 = 0, b0 = v.attribList.length; p0 < b0; p0++) {
          var M0 = v.attribList[p0], y0 = M0[0], q0 = M0[1], _0 = U(y0, !0), R0 = _0.prefix, te = _0.local, Mt = R0 === "" ? "" : N.ns[R0] || "", _4 = {
            name: y0,
            value: q0,
            prefix: R0,
            local: te,
            uri: Mt
          };
          R0 && R0 !== "xmlns" && !Mt && (E(v, "Unbound namespace prefix: " + JSON.stringify(R0)), _4.uri = R0), v.tag.attributes[y0] = _4, x(v, "onattribute", _4);
        }
        v.attribList.length = 0;
      }
      v.tag.isSelfClosing = !!p, v.sawRoot = !0, v.tags.push(v.tag), x(v, "onopentag", v.tag), p || (!v.noscript && v.tagName.toLowerCase() === "script" ? v.state = g.SCRIPT : v.state = g.TEXT, v.tag = null, v.tagName = ""), v.attribName = v.attribValue = "", v.attribList.length = 0;
    }
    function v0(v) {
      if (!v.tagName) {
        E(v, "Weird empty close tag."), v.textNode += "</>", v.state = g.TEXT;
        return;
      }
      if (v.script) {
        if (v.tagName !== "script") {
          v.script += "</" + v.tagName + ">", v.tagName = "", v.state = g.SCRIPT;
          return;
        }
        x(v, "onscript", v.script), v.script = "";
      }
      var p = v.tags.length, N = v.tagName;
      v.strict || (N = N[v.looseCase]());
      for (var z = N; p--; ) {
        var f0 = v.tags[p];
        if (f0.name !== z)
          E(v, "Unexpected close tag");
        else
          break;
      }
      if (p < 0) {
        E(v, "Unmatched closing tag: " + v.tagName), v.textNode += "</" + v.tagName + ">", v.state = g.TEXT;
        return;
      }
      v.tagName = N;
      for (var p0 = v.tags.length; p0-- > p; ) {
        var b0 = v.tag = v.tags.pop();
        v.tagName = v.tag.name, x(v, "onclosetag", v.tagName);
        var M0 = {};
        for (var y0 in b0.ns)
          M0[y0] = b0.ns[y0];
        var q0 = v.tags[v.tags.length - 1] || v;
        v.opt.xmlns && b0.ns !== q0.ns && Object.keys(b0.ns).forEach(function(_0) {
          var R0 = b0.ns[_0];
          x(v, "onclosenamespace", { prefix: _0, uri: R0 });
        });
      }
      p === 0 && (v.closedRoot = !0), v.tagName = v.attribValue = v.attribName = "", v.attribList.length = 0, v.state = g.TEXT;
    }
    function N0(v) {
      var p = v.entity, N = p.toLowerCase(), z, f0 = "";
      return v.ENTITIES[p] ? v.ENTITIES[p] : v.ENTITIES[N] ? v.ENTITIES[N] : (p = N, p.charAt(0) === "#" && (p.charAt(1) === "x" ? (p = p.slice(2), z = parseInt(p, 16), f0 = z.toString(16)) : (p = p.slice(1), z = parseInt(p, 10), f0 = z.toString(10))), p = p.replace(/^0+/, ""), isNaN(z) || f0.toLowerCase() !== p ? (E(v, "Invalid character entity"), "&" + v.entity + ";") : String.fromCodePoint(z));
    }
    function B(v, p) {
      p === "<" ? (v.state = g.OPEN_WAKA, v.startTagPosition = v.position) : b(p) || (E(v, "Non-whitespace before first tag."), v.textNode = p, v.state = g.TEXT);
    }
    function Y(v, p) {
      var N = "";
      return p < v.length && (N = v.charAt(p)), N;
    }
    function r0(v) {
      var p = this;
      if (this.error)
        throw this.error;
      if (p.closed)
        return y(
          p,
          "Cannot write after close. Assign an onready handler."
        );
      if (v === null)
        return D(p);
      typeof v == "object" && (v = v.toString());
      for (var N = 0, z = ""; z = Y(v, N++), p.c = z, !!z; )
        switch (p.trackPosition && (p.position++, z === `
` ? (p.line++, p.column = 0) : p.column++), p.state) {
          case g.BEGIN:
            if (p.state = g.BEGIN_WHITESPACE, z === "\uFEFF")
              continue;
            B(p, z);
            continue;
          case g.BEGIN_WHITESPACE:
            B(p, z);
            continue;
          case g.TEXT:
            if (p.sawRoot && !p.closedRoot) {
              for (var f0 = N - 1; z && z !== "<" && z !== "&"; )
                z = Y(v, N++), z && p.trackPosition && (p.position++, z === `
` ? (p.line++, p.column = 0) : p.column++);
              p.textNode += v.substring(f0, N - 1);
            }
            z === "<" && !(p.sawRoot && p.closedRoot && !p.strict) ? (p.state = g.OPEN_WAKA, p.startTagPosition = p.position) : (!b(z) && (!p.sawRoot || p.closedRoot) && E(p, "Text data outside of root node."), z === "&" ? p.state = g.TEXT_ENTITY : p.textNode += z);
            continue;
          case g.SCRIPT:
            z === "<" ? p.state = g.SCRIPT_ENDING : p.script += z;
            continue;
          case g.SCRIPT_ENDING:
            z === "/" ? p.state = g.CLOSE_TAG : (p.script += "<" + z, p.state = g.SCRIPT);
            continue;
          case g.OPEN_WAKA:
            if (z === "!")
              p.state = g.SGML_DECL, p.sgmlDecl = "";
            else if (!b(z))
              if (A(m, z))
                p.state = g.OPEN_TAG, p.tagName = z;
              else if (z === "/")
                p.state = g.CLOSE_TAG, p.tagName = "";
              else if (z === "?")
                p.state = g.PROC_INST, p.procInstName = p.procInstBody = "";
              else {
                if (E(p, "Unencoded <"), p.startTagPosition + 1 < p.position) {
                  var p0 = p.position - p.startTagPosition;
                  z = new Array(p0).join(" ") + z;
                }
                p.textNode += "<" + z, p.state = g.TEXT;
              }
            continue;
          case g.SGML_DECL:
            (p.sgmlDecl + z).toUpperCase() === l ? (x(p, "onopencdata"), p.state = g.CDATA, p.sgmlDecl = "", p.cdata = "") : p.sgmlDecl + z === "--" ? (p.state = g.COMMENT, p.comment = "", p.sgmlDecl = "") : (p.sgmlDecl + z).toUpperCase() === c ? (p.state = g.DOCTYPE, (p.doctype || p.sawRoot) && E(
              p,
              "Inappropriately located doctype declaration"
            ), p.doctype = "", p.sgmlDecl = "") : z === ">" ? (x(p, "onsgmldeclaration", p.sgmlDecl), p.sgmlDecl = "", p.state = g.TEXT) : (w(z) && (p.state = g.SGML_DECL_QUOTED), p.sgmlDecl += z);
            continue;
          case g.SGML_DECL_QUOTED:
            z === p.q && (p.state = g.SGML_DECL, p.q = ""), p.sgmlDecl += z;
            continue;
          case g.DOCTYPE:
            z === ">" ? (p.state = g.TEXT, x(p, "ondoctype", p.doctype), p.doctype = !0) : (p.doctype += z, z === "[" ? p.state = g.DOCTYPE_DTD : w(z) && (p.state = g.DOCTYPE_QUOTED, p.q = z));
            continue;
          case g.DOCTYPE_QUOTED:
            p.doctype += z, z === p.q && (p.q = "", p.state = g.DOCTYPE);
            continue;
          case g.DOCTYPE_DTD:
            p.doctype += z, z === "]" ? p.state = g.DOCTYPE : w(z) && (p.state = g.DOCTYPE_DTD_QUOTED, p.q = z);
            continue;
          case g.DOCTYPE_DTD_QUOTED:
            p.doctype += z, z === p.q && (p.state = g.DOCTYPE_DTD, p.q = "");
            continue;
          case g.COMMENT:
            z === "-" ? p.state = g.COMMENT_ENDING : p.comment += z;
            continue;
          case g.COMMENT_ENDING:
            z === "-" ? (p.state = g.COMMENT_ENDED, p.comment = O(p.opt, p.comment), p.comment && x(p, "oncomment", p.comment), p.comment = "") : (p.comment += "-" + z, p.state = g.COMMENT);
            continue;
          case g.COMMENT_ENDED:
            z !== ">" ? (E(p, "Malformed comment"), p.comment += "--" + z, p.state = g.COMMENT) : p.state = g.TEXT;
            continue;
          case g.CDATA:
            z === "]" ? p.state = g.CDATA_ENDING : p.cdata += z;
            continue;
          case g.CDATA_ENDING:
            z === "]" ? p.state = g.CDATA_ENDING_2 : (p.cdata += "]" + z, p.state = g.CDATA);
            continue;
          case g.CDATA_ENDING_2:
            z === ">" ? (p.cdata && x(p, "oncdata", p.cdata), x(p, "onclosecdata"), p.cdata = "", p.state = g.TEXT) : z === "]" ? p.cdata += "]" : (p.cdata += "]]" + z, p.state = g.CDATA);
            continue;
          case g.PROC_INST:
            z === "?" ? p.state = g.PROC_INST_ENDING : b(z) ? p.state = g.PROC_INST_BODY : p.procInstName += z;
            continue;
          case g.PROC_INST_BODY:
            if (!p.procInstBody && b(z))
              continue;
            z === "?" ? p.state = g.PROC_INST_ENDING : p.procInstBody += z;
            continue;
          case g.PROC_INST_ENDING:
            z === ">" ? (x(p, "onprocessinginstruction", {
              name: p.procInstName,
              body: p.procInstBody
            }), p.procInstName = p.procInstBody = "", p.state = g.TEXT) : (p.procInstBody += "?" + z, p.state = g.PROC_INST_BODY);
            continue;
          case g.OPEN_TAG:
            A(f, z) ? p.tagName += z : (W(p), z === ">" ? Q(p) : z === "/" ? p.state = g.OPEN_TAG_SLASH : (b(z) || E(p, "Invalid character in tag name"), p.state = g.ATTRIB));
            continue;
          case g.OPEN_TAG_SLASH:
            z === ">" ? (Q(p, !0), v0(p)) : (E(p, "Forward-slash in opening tag not followed by >"), p.state = g.ATTRIB);
            continue;
          case g.ATTRIB:
            if (b(z))
              continue;
            z === ">" ? Q(p) : z === "/" ? p.state = g.OPEN_TAG_SLASH : A(m, z) ? (p.attribName = z, p.attribValue = "", p.state = g.ATTRIB_NAME) : E(p, "Invalid attribute name");
            continue;
          case g.ATTRIB_NAME:
            z === "=" ? p.state = g.ATTRIB_VALUE : z === ">" ? (E(p, "Attribute without value"), p.attribValue = p.attribName, i0(p), Q(p)) : b(z) ? p.state = g.ATTRIB_NAME_SAW_WHITE : A(f, z) ? p.attribName += z : E(p, "Invalid attribute name");
            continue;
          case g.ATTRIB_NAME_SAW_WHITE:
            if (z === "=")
              p.state = g.ATTRIB_VALUE;
            else {
              if (b(z))
                continue;
              E(p, "Attribute without value"), p.tag.attributes[p.attribName] = "", p.attribValue = "", x(p, "onattribute", {
                name: p.attribName,
                value: ""
              }), p.attribName = "", z === ">" ? Q(p) : A(m, z) ? (p.attribName = z, p.state = g.ATTRIB_NAME) : (E(p, "Invalid attribute name"), p.state = g.ATTRIB);
            }
            continue;
          case g.ATTRIB_VALUE:
            if (b(z))
              continue;
            w(z) ? (p.q = z, p.state = g.ATTRIB_VALUE_QUOTED) : (E(p, "Unquoted attribute value"), p.state = g.ATTRIB_VALUE_UNQUOTED, p.attribValue = z);
            continue;
          case g.ATTRIB_VALUE_QUOTED:
            if (z !== p.q) {
              z === "&" ? p.state = g.ATTRIB_VALUE_ENTITY_Q : p.attribValue += z;
              continue;
            }
            i0(p), p.q = "", p.state = g.ATTRIB_VALUE_CLOSED;
            continue;
          case g.ATTRIB_VALUE_CLOSED:
            b(z) ? p.state = g.ATTRIB : z === ">" ? Q(p) : z === "/" ? p.state = g.OPEN_TAG_SLASH : A(m, z) ? (E(p, "No whitespace between attributes"), p.attribName = z, p.attribValue = "", p.state = g.ATTRIB_NAME) : E(p, "Invalid attribute name");
            continue;
          case g.ATTRIB_VALUE_UNQUOTED:
            if (!L(z)) {
              z === "&" ? p.state = g.ATTRIB_VALUE_ENTITY_U : p.attribValue += z;
              continue;
            }
            i0(p), z === ">" ? Q(p) : p.state = g.ATTRIB;
            continue;
          case g.CLOSE_TAG:
            if (p.tagName)
              z === ">" ? v0(p) : A(f, z) ? p.tagName += z : p.script ? (p.script += "</" + p.tagName, p.tagName = "", p.state = g.SCRIPT) : (b(z) || E(p, "Invalid tagname in closing tag"), p.state = g.CLOSE_TAG_SAW_WHITE);
            else {
              if (b(z))
                continue;
              C(m, z) ? p.script ? (p.script += "</" + z, p.state = g.SCRIPT) : E(p, "Invalid tagname in closing tag.") : p.tagName = z;
            }
            continue;
          case g.CLOSE_TAG_SAW_WHITE:
            if (b(z))
              continue;
            z === ">" ? v0(p) : E(p, "Invalid characters in closing tag");
            continue;
          case g.TEXT_ENTITY:
          case g.ATTRIB_VALUE_ENTITY_Q:
          case g.ATTRIB_VALUE_ENTITY_U:
            var b0, M0;
            switch (p.state) {
              case g.TEXT_ENTITY:
                b0 = g.TEXT, M0 = "textNode";
                break;
              case g.ATTRIB_VALUE_ENTITY_Q:
                b0 = g.ATTRIB_VALUE_QUOTED, M0 = "attribValue";
                break;
              case g.ATTRIB_VALUE_ENTITY_U:
                b0 = g.ATTRIB_VALUE_UNQUOTED, M0 = "attribValue";
                break;
            }
            if (z === ";") {
              var y0 = N0(p);
              p.state === g.TEXT_ENTITY && !t.ENTITIES[p.entity] && y0 !== "&" + p.entity + ";" ? v = v.slice(0, N) + y0 + v.slice(N) : p[M0] += y0, p.entity = "", p.state = b0;
            } else
              A(p.entity.length ? k : d, z) ? p.entity += z : (E(p, "Invalid character in entity name"), p[M0] += "&" + p.entity + z, p.entity = "", p.state = b0);
            continue;
          default:
            throw new Error(p, "Unknown state: " + p.state);
        }
      return p.position >= p.bufferCheckPosition && o(p), p;
    }
  })(e);
})(vl);
var C0 = {};
(function(e) {
  e.elemsGroups = {
    animation: [
      "animate",
      "animateColor",
      "animateMotion",
      "animateTransform",
      "set"
    ],
    descriptive: ["desc", "metadata", "title"],
    shape: ["circle", "ellipse", "line", "path", "polygon", "polyline", "rect"],
    structural: ["defs", "g", "svg", "symbol", "use"],
    paintServer: [
      "solidColor",
      "linearGradient",
      "radialGradient",
      "meshGradient",
      "pattern",
      "hatch"
    ],
    nonRendering: [
      "linearGradient",
      "radialGradient",
      "pattern",
      "clipPath",
      "mask",
      "marker",
      "symbol",
      "filter",
      "solidColor"
    ],
    container: [
      "a",
      "defs",
      "g",
      "marker",
      "mask",
      "missing-glyph",
      "pattern",
      "svg",
      "switch",
      "symbol",
      "foreignObject"
    ],
    textContent: [
      "altGlyph",
      "altGlyphDef",
      "altGlyphItem",
      "glyph",
      "glyphRef",
      "textPath",
      "text",
      "tref",
      "tspan"
    ],
    textContentChild: ["altGlyph", "textPath", "tref", "tspan"],
    lightSource: [
      "feDiffuseLighting",
      "feSpecularLighting",
      "feDistantLight",
      "fePointLight",
      "feSpotLight"
    ],
    filterPrimitive: [
      "feBlend",
      "feColorMatrix",
      "feComponentTransfer",
      "feComposite",
      "feConvolveMatrix",
      "feDiffuseLighting",
      "feDisplacementMap",
      "feDropShadow",
      "feFlood",
      "feFuncA",
      "feFuncB",
      "feFuncG",
      "feFuncR",
      "feGaussianBlur",
      "feImage",
      "feMerge",
      "feMergeNode",
      "feMorphology",
      "feOffset",
      "feSpecularLighting",
      "feTile",
      "feTurbulence"
    ]
  }, e.textElems = [...e.elemsGroups.textContent, "title", "pre"], e.pathElems = ["path", "glyph", "missing-glyph"], e.attrsGroups = {
    animationAddition: ["additive", "accumulate"],
    animationAttributeTarget: ["attributeType", "attributeName"],
    animationEvent: ["onbegin", "onend", "onrepeat", "onload"],
    animationTiming: [
      "begin",
      "dur",
      "end",
      "min",
      "max",
      "restart",
      "repeatCount",
      "repeatDur",
      "fill"
    ],
    animationValue: [
      "calcMode",
      "values",
      "keyTimes",
      "keySplines",
      "from",
      "to",
      "by"
    ],
    conditionalProcessing: [
      "requiredFeatures",
      "requiredExtensions",
      "systemLanguage"
    ],
    core: ["id", "tabindex", "xml:base", "xml:lang", "xml:space"],
    graphicalEvent: [
      "onfocusin",
      "onfocusout",
      "onactivate",
      "onclick",
      "onmousedown",
      "onmouseup",
      "onmouseover",
      "onmousemove",
      "onmouseout",
      "onload"
    ],
    presentation: [
      "alignment-baseline",
      "baseline-shift",
      "clip",
      "clip-path",
      "clip-rule",
      "color",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "cursor",
      "direction",
      "display",
      "dominant-baseline",
      "enable-background",
      "fill",
      "fill-opacity",
      "fill-rule",
      "filter",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "mask",
      "opacity",
      "overflow",
      "paint-order",
      "pointer-events",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "stroke",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-overflow",
      "text-rendering",
      "transform",
      "transform-origin",
      "unicode-bidi",
      "vector-effect",
      "visibility",
      "word-spacing",
      "writing-mode"
    ],
    xlink: [
      "xlink:href",
      "xlink:show",
      "xlink:actuate",
      "xlink:type",
      "xlink:role",
      "xlink:arcrole",
      "xlink:title"
    ],
    documentEvent: [
      "onabort",
      "onerror",
      "onresize",
      "onscroll",
      "onunload",
      "onzoom"
    ],
    documentElementEvent: ["oncopy", "oncut", "onpaste"],
    globalEvent: [
      "oncancel",
      "oncanplay",
      "oncanplaythrough",
      "onchange",
      "onclick",
      "onclose",
      "oncuechange",
      "ondblclick",
      "ondrag",
      "ondragend",
      "ondragenter",
      "ondragleave",
      "ondragover",
      "ondragstart",
      "ondrop",
      "ondurationchange",
      "onemptied",
      "onended",
      "onerror",
      "onfocus",
      "oninput",
      "oninvalid",
      "onkeydown",
      "onkeypress",
      "onkeyup",
      "onload",
      "onloadeddata",
      "onloadedmetadata",
      "onloadstart",
      "onmousedown",
      "onmouseenter",
      "onmouseleave",
      "onmousemove",
      "onmouseout",
      "onmouseover",
      "onmouseup",
      "onmousewheel",
      "onpause",
      "onplay",
      "onplaying",
      "onprogress",
      "onratechange",
      "onreset",
      "onresize",
      "onscroll",
      "onseeked",
      "onseeking",
      "onselect",
      "onshow",
      "onstalled",
      "onsubmit",
      "onsuspend",
      "ontimeupdate",
      "ontoggle",
      "onvolumechange",
      "onwaiting"
    ],
    filterPrimitive: ["x", "y", "width", "height", "result"],
    transferFunction: [
      "type",
      "tableValues",
      "slope",
      "intercept",
      "amplitude",
      "exponent",
      "offset"
    ]
  }, e.attrsGroupsDefaults = {
    core: { "xml:space": "default" },
    presentation: {
      clip: "auto",
      "clip-path": "none",
      "clip-rule": "nonzero",
      mask: "none",
      opacity: "1",
      "stop-color": "#000",
      "stop-opacity": "1",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      fill: "#000",
      stroke: "none",
      "stroke-width": "1",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "paint-order": "normal",
      "vector-effect": "none",
      display: "inline",
      visibility: "visible",
      "marker-start": "none",
      "marker-mid": "none",
      "marker-end": "none",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "color-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "image-rendering": "auto",
      "font-style": "normal",
      "font-variant": "normal",
      "font-weight": "normal",
      "font-stretch": "normal",
      "font-size": "medium",
      "font-size-adjust": "none",
      kerning: "auto",
      "letter-spacing": "normal",
      "word-spacing": "normal",
      "text-decoration": "none",
      "text-anchor": "start",
      "text-overflow": "clip",
      "writing-mode": "lr-tb",
      "glyph-orientation-vertical": "auto",
      "glyph-orientation-horizontal": "0deg",
      direction: "ltr",
      "unicode-bidi": "normal",
      "dominant-baseline": "auto",
      "alignment-baseline": "baseline",
      "baseline-shift": "baseline"
    },
    transferFunction: {
      slope: "1",
      intercept: "0",
      amplitude: "1",
      exponent: "1",
      offset: "0"
    }
  }, e.elems = {
    a: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "graphicalEvent",
        "presentation",
        "xlink"
      ],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "transform",
        "target"
      ],
      defaults: {
        target: "_self"
      },
      contentGroups: [
        "animation",
        "descriptive",
        "shape",
        "structural",
        "paintServer"
      ],
      content: [
        "a",
        "altGlyphDef",
        "clipPath",
        "color-profile",
        "cursor",
        "filter",
        "font",
        "font-face",
        "foreignObject",
        "image",
        "marker",
        "mask",
        "pattern",
        "script",
        "style",
        "switch",
        "text",
        "view",
        "tspan"
      ]
    },
    altGlyph: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "graphicalEvent",
        "presentation",
        "xlink"
      ],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "x",
        "y",
        "dx",
        "dy",
        "glyphRef",
        "format",
        "rotate"
      ]
    },
    altGlyphDef: {
      attrsGroups: ["core"],
      content: ["glyphRef"]
    },
    altGlyphItem: {
      attrsGroups: ["core"],
      content: ["glyphRef", "altGlyphItem"]
    },
    animate: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "animationAddition",
        "animationAttributeTarget",
        "animationEvent",
        "animationTiming",
        "animationValue",
        "presentation",
        "xlink"
      ],
      attrs: ["externalResourcesRequired"],
      contentGroups: ["descriptive"]
    },
    animateColor: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "animationEvent",
        "xlink",
        "animationAttributeTarget",
        "animationTiming",
        "animationValue",
        "animationAddition",
        "presentation"
      ],
      attrs: ["externalResourcesRequired"],
      contentGroups: ["descriptive"]
    },
    animateMotion: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "animationEvent",
        "xlink",
        "animationTiming",
        "animationValue",
        "animationAddition"
      ],
      attrs: [
        "externalResourcesRequired",
        "path",
        "keyPoints",
        "rotate",
        "origin"
      ],
      defaults: {
        rotate: "0"
      },
      contentGroups: ["descriptive"],
      content: ["mpath"]
    },
    animateTransform: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "animationEvent",
        "xlink",
        "animationAttributeTarget",
        "animationTiming",
        "animationValue",
        "animationAddition"
      ],
      attrs: ["externalResourcesRequired", "type"],
      contentGroups: ["descriptive"]
    },
    circle: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "graphicalEvent",
        "presentation"
      ],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "transform",
        "cx",
        "cy",
        "r"
      ],
      defaults: {
        cx: "0",
        cy: "0"
      },
      contentGroups: ["animation", "descriptive"]
    },
    clipPath: {
      attrsGroups: ["conditionalProcessing", "core", "presentation"],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "transform",
        "clipPathUnits"
      ],
      defaults: {
        clipPathUnits: "userSpaceOnUse"
      },
      contentGroups: ["animation", "descriptive", "shape"],
      content: ["text", "use"]
    },
    "color-profile": {
      attrsGroups: ["core", "xlink"],
      attrs: ["local", "name", "rendering-intent"],
      defaults: {
        name: "sRGB",
        "rendering-intent": "auto"
      },
      contentGroups: ["descriptive"]
    },
    cursor: {
      attrsGroups: ["core", "conditionalProcessing", "xlink"],
      attrs: ["externalResourcesRequired", "x", "y"],
      defaults: {
        x: "0",
        y: "0"
      },
      contentGroups: ["descriptive"]
    },
    defs: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "graphicalEvent",
        "presentation"
      ],
      attrs: ["class", "style", "externalResourcesRequired", "transform"],
      contentGroups: [
        "animation",
        "descriptive",
        "shape",
        "structural",
        "paintServer"
      ],
      content: [
        "a",
        "altGlyphDef",
        "clipPath",
        "color-profile",
        "cursor",
        "filter",
        "font",
        "font-face",
        "foreignObject",
        "image",
        "marker",
        "mask",
        "pattern",
        "script",
        "style",
        "switch",
        "text",
        "view"
      ]
    },
    desc: {
      attrsGroups: ["core"],
      attrs: ["class", "style"]
    },
    ellipse: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "graphicalEvent",
        "presentation"
      ],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "transform",
        "cx",
        "cy",
        "rx",
        "ry"
      ],
      defaults: {
        cx: "0",
        cy: "0"
      },
      contentGroups: ["animation", "descriptive"]
    },
    feBlend: {
      attrsGroups: ["core", "presentation", "filterPrimitive"],
      attrs: [
        "class",
        "style",
        "in",
        "in2",
        "mode"
      ],
      defaults: {
        mode: "normal"
      },
      content: ["animate", "set"]
    },
    feColorMatrix: {
      attrsGroups: ["core", "presentation", "filterPrimitive"],
      attrs: ["class", "style", "in", "type", "values"],
      defaults: {
        type: "matrix"
      },
      content: ["animate", "set"]
    },
    feComponentTransfer: {
      attrsGroups: ["core", "presentation", "filterPrimitive"],
      attrs: ["class", "style", "in"],
      content: ["feFuncA", "feFuncB", "feFuncG", "feFuncR"]
    },
    feComposite: {
      attrsGroups: ["core", "presentation", "filterPrimitive"],
      attrs: ["class", "style", "in", "in2", "operator", "k1", "k2", "k3", "k4"],
      defaults: {
        operator: "over",
        k1: "0",
        k2: "0",
        k3: "0",
        k4: "0"
      },
      content: ["animate", "set"]
    },
    feConvolveMatrix: {
      attrsGroups: ["core", "presentation", "filterPrimitive"],
      attrs: [
        "class",
        "style",
        "in",
        "order",
        "kernelMatrix",
        "divisor",
        "bias",
        "targetX",
        "targetY",
        "edgeMode",
        "kernelUnitLength",
        "preserveAlpha"
      ],
      defaults: {
        order: "3",
        bias: "0",
        edgeMode: "duplicate",
        preserveAlpha: "false"
      },
      content: ["animate", "set"]
    },
    feDiffuseLighting: {
      attrsGroups: ["core", "presentation", "filterPrimitive"],
      attrs: [
        "class",
        "style",
        "in",
        "surfaceScale",
        "diffuseConstant",
        "kernelUnitLength"
      ],
      defaults: {
        surfaceScale: "1",
        diffuseConstant: "1"
      },
      contentGroups: ["descriptive"],
      content: [
        "feDistantLight",
        "fePointLight",
        "feSpotLight"
      ]
    },
    feDisplacementMap: {
      attrsGroups: ["core", "presentation", "filterPrimitive"],
      attrs: [
        "class",
        "style",
        "in",
        "in2",
        "scale",
        "xChannelSelector",
        "yChannelSelector"
      ],
      defaults: {
        scale: "0",
        xChannelSelector: "A",
        yChannelSelector: "A"
      },
      content: ["animate", "set"]
    },
    feDistantLight: {
      attrsGroups: ["core"],
      attrs: ["azimuth", "elevation"],
      defaults: {
        azimuth: "0",
        elevation: "0"
      },
      content: ["animate", "set"]
    },
    feFlood: {
      attrsGroups: ["core", "presentation", "filterPrimitive"],
      attrs: ["class", "style"],
      content: ["animate", "animateColor", "set"]
    },
    feFuncA: {
      attrsGroups: ["core", "transferFunction"],
      content: ["set", "animate"]
    },
    feFuncB: {
      attrsGroups: ["core", "transferFunction"],
      content: ["set", "animate"]
    },
    feFuncG: {
      attrsGroups: ["core", "transferFunction"],
      content: ["set", "animate"]
    },
    feFuncR: {
      attrsGroups: ["core", "transferFunction"],
      content: ["set", "animate"]
    },
    feGaussianBlur: {
      attrsGroups: ["core", "presentation", "filterPrimitive"],
      attrs: ["class", "style", "in", "stdDeviation"],
      defaults: {
        stdDeviation: "0"
      },
      content: ["set", "animate"]
    },
    feImage: {
      attrsGroups: ["core", "presentation", "filterPrimitive", "xlink"],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "preserveAspectRatio",
        "href",
        "xlink:href"
      ],
      defaults: {
        preserveAspectRatio: "xMidYMid meet"
      },
      content: ["animate", "animateTransform", "set"]
    },
    feMerge: {
      attrsGroups: ["core", "presentation", "filterPrimitive"],
      attrs: ["class", "style"],
      content: ["feMergeNode"]
    },
    feMergeNode: {
      attrsGroups: ["core"],
      attrs: ["in"],
      content: ["animate", "set"]
    },
    feMorphology: {
      attrsGroups: ["core", "presentation", "filterPrimitive"],
      attrs: ["class", "style", "in", "operator", "radius"],
      defaults: {
        operator: "erode",
        radius: "0"
      },
      content: ["animate", "set"]
    },
    feOffset: {
      attrsGroups: ["core", "presentation", "filterPrimitive"],
      attrs: ["class", "style", "in", "dx", "dy"],
      defaults: {
        dx: "0",
        dy: "0"
      },
      content: ["animate", "set"]
    },
    fePointLight: {
      attrsGroups: ["core"],
      attrs: ["x", "y", "z"],
      defaults: {
        x: "0",
        y: "0",
        z: "0"
      },
      content: ["animate", "set"]
    },
    feSpecularLighting: {
      attrsGroups: ["core", "presentation", "filterPrimitive"],
      attrs: [
        "class",
        "style",
        "in",
        "surfaceScale",
        "specularConstant",
        "specularExponent",
        "kernelUnitLength"
      ],
      defaults: {
        surfaceScale: "1",
        specularConstant: "1",
        specularExponent: "1"
      },
      contentGroups: [
        "descriptive",
        "lightSource"
      ]
    },
    feSpotLight: {
      attrsGroups: ["core"],
      attrs: [
        "x",
        "y",
        "z",
        "pointsAtX",
        "pointsAtY",
        "pointsAtZ",
        "specularExponent",
        "limitingConeAngle"
      ],
      defaults: {
        x: "0",
        y: "0",
        z: "0",
        pointsAtX: "0",
        pointsAtY: "0",
        pointsAtZ: "0",
        specularExponent: "1"
      },
      content: ["animate", "set"]
    },
    feTile: {
      attrsGroups: ["core", "presentation", "filterPrimitive"],
      attrs: ["class", "style", "in"],
      content: ["animate", "set"]
    },
    feTurbulence: {
      attrsGroups: ["core", "presentation", "filterPrimitive"],
      attrs: [
        "class",
        "style",
        "baseFrequency",
        "numOctaves",
        "seed",
        "stitchTiles",
        "type"
      ],
      defaults: {
        baseFrequency: "0",
        numOctaves: "1",
        seed: "0",
        stitchTiles: "noStitch",
        type: "turbulence"
      },
      content: ["animate", "set"]
    },
    filter: {
      attrsGroups: ["core", "presentation", "xlink"],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "x",
        "y",
        "width",
        "height",
        "filterRes",
        "filterUnits",
        "primitiveUnits",
        "href",
        "xlink:href"
      ],
      defaults: {
        primitiveUnits: "userSpaceOnUse",
        x: "-10%",
        y: "-10%",
        width: "120%",
        height: "120%"
      },
      contentGroups: ["descriptive", "filterPrimitive"],
      content: ["animate", "set"]
    },
    font: {
      attrsGroups: ["core", "presentation"],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "horiz-origin-x",
        "horiz-origin-y",
        "horiz-adv-x",
        "vert-origin-x",
        "vert-origin-y",
        "vert-adv-y"
      ],
      defaults: {
        "horiz-origin-x": "0",
        "horiz-origin-y": "0"
      },
      contentGroups: ["descriptive"],
      content: ["font-face", "glyph", "hkern", "missing-glyph", "vkern"]
    },
    "font-face": {
      attrsGroups: ["core"],
      attrs: [
        "font-family",
        "font-style",
        "font-variant",
        "font-weight",
        "font-stretch",
        "font-size",
        "unicode-range",
        "units-per-em",
        "panose-1",
        "stemv",
        "stemh",
        "slope",
        "cap-height",
        "x-height",
        "accent-height",
        "ascent",
        "descent",
        "widths",
        "bbox",
        "ideographic",
        "alphabetic",
        "mathematical",
        "hanging",
        "v-ideographic",
        "v-alphabetic",
        "v-mathematical",
        "v-hanging",
        "underline-position",
        "underline-thickness",
        "strikethrough-position",
        "strikethrough-thickness",
        "overline-position",
        "overline-thickness"
      ],
      defaults: {
        "font-style": "all",
        "font-variant": "normal",
        "font-weight": "all",
        "font-stretch": "normal",
        "unicode-range": "U+0-10FFFF",
        "units-per-em": "1000",
        "panose-1": "0 0 0 0 0 0 0 0 0 0",
        slope: "0"
      },
      contentGroups: ["descriptive"],
      content: [
        "font-face-src"
      ]
    },
    "font-face-format": {
      attrsGroups: ["core"],
      attrs: ["string"]
    },
    "font-face-name": {
      attrsGroups: ["core"],
      attrs: ["name"]
    },
    "font-face-src": {
      attrsGroups: ["core"],
      content: ["font-face-name", "font-face-uri"]
    },
    "font-face-uri": {
      attrsGroups: ["core", "xlink"],
      attrs: ["href", "xlink:href"],
      content: ["font-face-format"]
    },
    foreignObject: {
      attrsGroups: [
        "core",
        "conditionalProcessing",
        "graphicalEvent",
        "presentation"
      ],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "transform",
        "x",
        "y",
        "width",
        "height"
      ],
      defaults: {
        x: "0",
        y: "0"
      }
    },
    g: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "graphicalEvent",
        "presentation"
      ],
      attrs: ["class", "style", "externalResourcesRequired", "transform"],
      contentGroups: [
        "animation",
        "descriptive",
        "shape",
        "structural",
        "paintServer"
      ],
      content: [
        "a",
        "altGlyphDef",
        "clipPath",
        "color-profile",
        "cursor",
        "filter",
        "font",
        "font-face",
        "foreignObject",
        "image",
        "marker",
        "mask",
        "pattern",
        "script",
        "style",
        "switch",
        "text",
        "view"
      ]
    },
    glyph: {
      attrsGroups: ["core", "presentation"],
      attrs: [
        "class",
        "style",
        "d",
        "horiz-adv-x",
        "vert-origin-x",
        "vert-origin-y",
        "vert-adv-y",
        "unicode",
        "glyph-name",
        "orientation",
        "arabic-form",
        "lang"
      ],
      defaults: {
        "arabic-form": "initial"
      },
      contentGroups: [
        "animation",
        "descriptive",
        "shape",
        "structural",
        "paintServer"
      ],
      content: [
        "a",
        "altGlyphDef",
        "clipPath",
        "color-profile",
        "cursor",
        "filter",
        "font",
        "font-face",
        "foreignObject",
        "image",
        "marker",
        "mask",
        "pattern",
        "script",
        "style",
        "switch",
        "text",
        "view"
      ]
    },
    glyphRef: {
      attrsGroups: ["core", "presentation"],
      attrs: [
        "class",
        "style",
        "d",
        "horiz-adv-x",
        "vert-origin-x",
        "vert-origin-y",
        "vert-adv-y"
      ],
      contentGroups: [
        "animation",
        "descriptive",
        "shape",
        "structural",
        "paintServer"
      ],
      content: [
        "a",
        "altGlyphDef",
        "clipPath",
        "color-profile",
        "cursor",
        "filter",
        "font",
        "font-face",
        "foreignObject",
        "image",
        "marker",
        "mask",
        "pattern",
        "script",
        "style",
        "switch",
        "text",
        "view"
      ]
    },
    hatch: {
      attrsGroups: ["core", "presentation", "xlink"],
      attrs: [
        "class",
        "style",
        "x",
        "y",
        "pitch",
        "rotate",
        "hatchUnits",
        "hatchContentUnits",
        "transform"
      ],
      defaults: {
        hatchUnits: "objectBoundingBox",
        hatchContentUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        pitch: "0",
        rotate: "0"
      },
      contentGroups: ["animation", "descriptive"],
      content: ["hatchPath"]
    },
    hatchPath: {
      attrsGroups: ["core", "presentation", "xlink"],
      attrs: ["class", "style", "d", "offset"],
      defaults: {
        offset: "0"
      },
      contentGroups: ["animation", "descriptive"]
    },
    hkern: {
      attrsGroups: ["core"],
      attrs: ["u1", "g1", "u2", "g2", "k"]
    },
    image: {
      attrsGroups: [
        "core",
        "conditionalProcessing",
        "graphicalEvent",
        "xlink",
        "presentation"
      ],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "preserveAspectRatio",
        "transform",
        "x",
        "y",
        "width",
        "height",
        "href",
        "xlink:href"
      ],
      defaults: {
        x: "0",
        y: "0",
        preserveAspectRatio: "xMidYMid meet"
      },
      contentGroups: ["animation", "descriptive"]
    },
    line: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "graphicalEvent",
        "presentation"
      ],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "transform",
        "x1",
        "y1",
        "x2",
        "y2"
      ],
      defaults: {
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "0"
      },
      contentGroups: ["animation", "descriptive"]
    },
    linearGradient: {
      attrsGroups: ["core", "presentation", "xlink"],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "x1",
        "y1",
        "x2",
        "y2",
        "gradientUnits",
        "gradientTransform",
        "spreadMethod",
        "href",
        "xlink:href"
      ],
      defaults: {
        x1: "0",
        y1: "0",
        x2: "100%",
        y2: "0",
        spreadMethod: "pad"
      },
      contentGroups: ["descriptive"],
      content: ["animate", "animateTransform", "set", "stop"]
    },
    marker: {
      attrsGroups: ["core", "presentation"],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "viewBox",
        "preserveAspectRatio",
        "refX",
        "refY",
        "markerUnits",
        "markerWidth",
        "markerHeight",
        "orient"
      ],
      defaults: {
        markerUnits: "strokeWidth",
        refX: "0",
        refY: "0",
        markerWidth: "3",
        markerHeight: "3"
      },
      contentGroups: [
        "animation",
        "descriptive",
        "shape",
        "structural",
        "paintServer"
      ],
      content: [
        "a",
        "altGlyphDef",
        "clipPath",
        "color-profile",
        "cursor",
        "filter",
        "font",
        "font-face",
        "foreignObject",
        "image",
        "marker",
        "mask",
        "pattern",
        "script",
        "style",
        "switch",
        "text",
        "view"
      ]
    },
    mask: {
      attrsGroups: ["conditionalProcessing", "core", "presentation"],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "x",
        "y",
        "width",
        "height",
        "mask-type",
        "maskUnits",
        "maskContentUnits"
      ],
      defaults: {
        maskUnits: "objectBoundingBox",
        maskContentUnits: "userSpaceOnUse",
        x: "-10%",
        y: "-10%",
        width: "120%",
        height: "120%"
      },
      contentGroups: [
        "animation",
        "descriptive",
        "shape",
        "structural",
        "paintServer"
      ],
      content: [
        "a",
        "altGlyphDef",
        "clipPath",
        "color-profile",
        "cursor",
        "filter",
        "font",
        "font-face",
        "foreignObject",
        "image",
        "marker",
        "mask",
        "pattern",
        "script",
        "style",
        "switch",
        "text",
        "view"
      ]
    },
    metadata: {
      attrsGroups: ["core"]
    },
    "missing-glyph": {
      attrsGroups: ["core", "presentation"],
      attrs: [
        "class",
        "style",
        "d",
        "horiz-adv-x",
        "vert-origin-x",
        "vert-origin-y",
        "vert-adv-y"
      ],
      contentGroups: [
        "animation",
        "descriptive",
        "shape",
        "structural",
        "paintServer"
      ],
      content: [
        "a",
        "altGlyphDef",
        "clipPath",
        "color-profile",
        "cursor",
        "filter",
        "font",
        "font-face",
        "foreignObject",
        "image",
        "marker",
        "mask",
        "pattern",
        "script",
        "style",
        "switch",
        "text",
        "view"
      ]
    },
    mpath: {
      attrsGroups: ["core", "xlink"],
      attrs: ["externalResourcesRequired", "href", "xlink:href"],
      contentGroups: ["descriptive"]
    },
    path: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "graphicalEvent",
        "presentation"
      ],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "transform",
        "d",
        "pathLength"
      ],
      contentGroups: ["animation", "descriptive"]
    },
    pattern: {
      attrsGroups: ["conditionalProcessing", "core", "presentation", "xlink"],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "viewBox",
        "preserveAspectRatio",
        "x",
        "y",
        "width",
        "height",
        "patternUnits",
        "patternContentUnits",
        "patternTransform",
        "href",
        "xlink:href"
      ],
      defaults: {
        patternUnits: "objectBoundingBox",
        patternContentUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "0",
        height: "0",
        preserveAspectRatio: "xMidYMid meet"
      },
      contentGroups: [
        "animation",
        "descriptive",
        "paintServer",
        "shape",
        "structural"
      ],
      content: [
        "a",
        "altGlyphDef",
        "clipPath",
        "color-profile",
        "cursor",
        "filter",
        "font",
        "font-face",
        "foreignObject",
        "image",
        "marker",
        "mask",
        "pattern",
        "script",
        "style",
        "switch",
        "text",
        "view"
      ]
    },
    polygon: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "graphicalEvent",
        "presentation"
      ],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "transform",
        "points"
      ],
      contentGroups: ["animation", "descriptive"]
    },
    polyline: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "graphicalEvent",
        "presentation"
      ],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "transform",
        "points"
      ],
      contentGroups: ["animation", "descriptive"]
    },
    radialGradient: {
      attrsGroups: ["core", "presentation", "xlink"],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "cx",
        "cy",
        "r",
        "fx",
        "fy",
        "fr",
        "gradientUnits",
        "gradientTransform",
        "spreadMethod",
        "href",
        "xlink:href"
      ],
      defaults: {
        gradientUnits: "objectBoundingBox",
        cx: "50%",
        cy: "50%",
        r: "50%"
      },
      contentGroups: ["descriptive"],
      content: ["animate", "animateTransform", "set", "stop"]
    },
    meshGradient: {
      attrsGroups: ["core", "presentation", "xlink"],
      attrs: ["class", "style", "x", "y", "gradientUnits", "transform"],
      contentGroups: ["descriptive", "paintServer", "animation"],
      content: ["meshRow"]
    },
    meshRow: {
      attrsGroups: ["core", "presentation"],
      attrs: ["class", "style"],
      contentGroups: ["descriptive"],
      content: ["meshPatch"]
    },
    meshPatch: {
      attrsGroups: ["core", "presentation"],
      attrs: ["class", "style"],
      contentGroups: ["descriptive"],
      content: ["stop"]
    },
    rect: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "graphicalEvent",
        "presentation"
      ],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "transform",
        "x",
        "y",
        "width",
        "height",
        "rx",
        "ry"
      ],
      defaults: {
        x: "0",
        y: "0"
      },
      contentGroups: ["animation", "descriptive"]
    },
    script: {
      attrsGroups: ["core", "xlink"],
      attrs: ["externalResourcesRequired", "type", "href", "xlink:href"]
    },
    set: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "animation",
        "xlink",
        "animationAttributeTarget",
        "animationTiming"
      ],
      attrs: ["externalResourcesRequired", "to"],
      contentGroups: ["descriptive"]
    },
    solidColor: {
      attrsGroups: ["core", "presentation"],
      attrs: ["class", "style"],
      contentGroups: ["paintServer"]
    },
    stop: {
      attrsGroups: ["core", "presentation"],
      attrs: ["class", "style", "offset", "path"],
      content: ["animate", "animateColor", "set"]
    },
    style: {
      attrsGroups: ["core"],
      attrs: ["type", "media", "title"],
      defaults: {
        type: "text/css"
      }
    },
    svg: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "documentEvent",
        "graphicalEvent",
        "presentation"
      ],
      attrs: [
        "class",
        "style",
        "x",
        "y",
        "width",
        "height",
        "viewBox",
        "preserveAspectRatio",
        "zoomAndPan",
        "version",
        "baseProfile",
        "contentScriptType",
        "contentStyleType"
      ],
      defaults: {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        zoomAndPan: "magnify",
        version: "1.1",
        baseProfile: "none",
        contentScriptType: "application/ecmascript",
        contentStyleType: "text/css"
      },
      contentGroups: [
        "animation",
        "descriptive",
        "shape",
        "structural",
        "paintServer"
      ],
      content: [
        "a",
        "altGlyphDef",
        "clipPath",
        "color-profile",
        "cursor",
        "filter",
        "font",
        "font-face",
        "foreignObject",
        "image",
        "marker",
        "mask",
        "pattern",
        "script",
        "style",
        "switch",
        "text",
        "view"
      ]
    },
    switch: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "graphicalEvent",
        "presentation"
      ],
      attrs: ["class", "style", "externalResourcesRequired", "transform"],
      contentGroups: ["animation", "descriptive", "shape"],
      content: [
        "a",
        "foreignObject",
        "g",
        "image",
        "svg",
        "switch",
        "text",
        "use"
      ]
    },
    symbol: {
      attrsGroups: ["core", "graphicalEvent", "presentation"],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "preserveAspectRatio",
        "viewBox",
        "refX",
        "refY"
      ],
      defaults: {
        refX: "0",
        refY: "0"
      },
      contentGroups: [
        "animation",
        "descriptive",
        "shape",
        "structural",
        "paintServer"
      ],
      content: [
        "a",
        "altGlyphDef",
        "clipPath",
        "color-profile",
        "cursor",
        "filter",
        "font",
        "font-face",
        "foreignObject",
        "image",
        "marker",
        "mask",
        "pattern",
        "script",
        "style",
        "switch",
        "text",
        "view"
      ]
    },
    text: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "graphicalEvent",
        "presentation"
      ],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "transform",
        "lengthAdjust",
        "x",
        "y",
        "dx",
        "dy",
        "rotate",
        "textLength"
      ],
      defaults: {
        x: "0",
        y: "0",
        lengthAdjust: "spacing"
      },
      contentGroups: ["animation", "descriptive", "textContentChild"],
      content: ["a"]
    },
    textPath: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "graphicalEvent",
        "presentation",
        "xlink"
      ],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "href",
        "xlink:href",
        "startOffset",
        "method",
        "spacing",
        "d"
      ],
      defaults: {
        startOffset: "0",
        method: "align",
        spacing: "exact"
      },
      contentGroups: ["descriptive"],
      content: [
        "a",
        "altGlyph",
        "animate",
        "animateColor",
        "set",
        "tref",
        "tspan"
      ]
    },
    title: {
      attrsGroups: ["core"],
      attrs: ["class", "style"]
    },
    tref: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "graphicalEvent",
        "presentation",
        "xlink"
      ],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "href",
        "xlink:href"
      ],
      contentGroups: ["descriptive"],
      content: ["animate", "animateColor", "set"]
    },
    tspan: {
      attrsGroups: [
        "conditionalProcessing",
        "core",
        "graphicalEvent",
        "presentation"
      ],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "x",
        "y",
        "dx",
        "dy",
        "rotate",
        "textLength",
        "lengthAdjust"
      ],
      contentGroups: ["descriptive"],
      content: [
        "a",
        "altGlyph",
        "animate",
        "animateColor",
        "set",
        "tref",
        "tspan"
      ]
    },
    use: {
      attrsGroups: [
        "core",
        "conditionalProcessing",
        "graphicalEvent",
        "presentation",
        "xlink"
      ],
      attrs: [
        "class",
        "style",
        "externalResourcesRequired",
        "transform",
        "x",
        "y",
        "width",
        "height",
        "href",
        "xlink:href"
      ],
      defaults: {
        x: "0",
        y: "0"
      },
      contentGroups: ["animation", "descriptive"]
    },
    view: {
      attrsGroups: ["core"],
      attrs: [
        "externalResourcesRequired",
        "viewBox",
        "preserveAspectRatio",
        "zoomAndPan",
        "viewTarget"
      ],
      contentGroups: ["descriptive"]
    },
    vkern: {
      attrsGroups: ["core"],
      attrs: ["u1", "g1", "u2", "g2", "k"]
    }
  }, e.editorNamespaces = [
    "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    "http://inkscape.sourceforge.net/DTD/sodipodi-0.dtd",
    "http://www.inkscape.org/namespaces/inkscape",
    "http://www.bohemiancoding.com/sketch/ns",
    "http://ns.adobe.com/AdobeIllustrator/10.0/",
    "http://ns.adobe.com/Graphs/1.0/",
    "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "http://ns.adobe.com/Variables/1.0/",
    "http://ns.adobe.com/SaveForWeb/1.0/",
    "http://ns.adobe.com/Extensibility/1.0/",
    "http://ns.adobe.com/Flows/1.0/",
    "http://ns.adobe.com/ImageReplacement/1.0/",
    "http://ns.adobe.com/GenericCustomNamespace/1.0/",
    "http://ns.adobe.com/XPath/1.0/",
    "http://schemas.microsoft.com/visio/2003/SVGExtensions/",
    "http://taptrix.com/vectorillustrator/svg_extensions",
    "http://www.figma.com/figma/ns",
    "http://purl.org/dc/elements/1.1/",
    "http://creativecommons.org/ns#",
    "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    "http://www.serif.com/",
    "http://www.vector.evaxdesign.sk"
  ], e.referencesProps = [
    "clip-path",
    "color-profile",
    "fill",
    "filter",
    "marker-start",
    "marker-mid",
    "marker-end",
    "mask",
    "stroke",
    "style"
  ], e.inheritableAttrs = [
    "clip-rule",
    "color",
    "color-interpolation",
    "color-interpolation-filters",
    "color-profile",
    "color-rendering",
    "cursor",
    "direction",
    "dominant-baseline",
    "fill",
    "fill-opacity",
    "fill-rule",
    "font",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-weight",
    "glyph-orientation-horizontal",
    "glyph-orientation-vertical",
    "image-rendering",
    "letter-spacing",
    "marker",
    "marker-end",
    "marker-mid",
    "marker-start",
    "paint-order",
    "pointer-events",
    "shape-rendering",
    "stroke",
    "stroke-dasharray",
    "stroke-dashoffset",
    "stroke-linecap",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke-width",
    "text-anchor",
    "text-rendering",
    "transform",
    "visibility",
    "word-spacing",
    "writing-mode"
  ], e.presentationNonInheritableGroupAttrs = [
    "display",
    "clip-path",
    "filter",
    "mask",
    "opacity",
    "text-decoration",
    "transform",
    "unicode-bidi"
  ], e.colorsNames = {
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aqua: "#0ff",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    black: "#000",
    blanchedalmond: "#ffebcd",
    blue: "#00f",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#0ff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkgrey: "#a9a9a9",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkslategrey: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    fuchsia: "#f0f",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    gold: "#ffd700",
    goldenrod: "#daa520",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#adff2f",
    grey: "#808080",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    indianred: "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavender: "#e6e6fa",
    lavenderblush: "#fff0f5",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgray: "#d3d3d3",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#789",
    lightslategrey: "#789",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    lime: "#0f0",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#f0f",
    maroon: "#800000",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370db",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    navy: "#000080",
    oldlace: "#fdf5e6",
    olive: "#808000",
    olivedrab: "#6b8e23",
    orange: "#ffa500",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#db7093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    purple: "#800080",
    rebeccapurple: "#639",
    red: "#f00",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    teal: "#008080",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    white: "#fff",
    whitesmoke: "#f5f5f5",
    yellow: "#ff0",
    yellowgreen: "#9acd32"
  }, e.colorsShortNames = {
    "#f0ffff": "azure",
    "#f5f5dc": "beige",
    "#ffe4c4": "bisque",
    "#a52a2a": "brown",
    "#ff7f50": "coral",
    "#ffd700": "gold",
    "#808080": "gray",
    "#008000": "green",
    "#4b0082": "indigo",
    "#fffff0": "ivory",
    "#f0e68c": "khaki",
    "#faf0e6": "linen",
    "#800000": "maroon",
    "#000080": "navy",
    "#808000": "olive",
    "#ffa500": "orange",
    "#da70d6": "orchid",
    "#cd853f": "peru",
    "#ffc0cb": "pink",
    "#dda0dd": "plum",
    "#800080": "purple",
    "#f00": "red",
    "#ff0000": "red",
    "#fa8072": "salmon",
    "#a0522d": "sienna",
    "#c0c0c0": "silver",
    "#fffafa": "snow",
    "#d2b48c": "tan",
    "#008080": "teal",
    "#ff6347": "tomato",
    "#ee82ee": "violet",
    "#f5deb3": "wheat"
  }, e.colorsProps = [
    "color",
    "fill",
    "stroke",
    "stop-color",
    "flood-color",
    "lighting-color"
  ];
})(C0);
const SN = vl, { textElems: $N } = C0;
class g9 extends Error {
  constructor(t, r, n, o, s) {
    super(t), this.name = "SvgoParserError", this.message = `${s || "<input>"}:${r}:${n}: ${t}`, this.reason = t, this.line = r, this.column = n, this.source = o, Error.captureStackTrace && Error.captureStackTrace(this, g9);
  }
  toString() {
    const t = this.source.split(/\r?\n/), r = Math.max(this.line - 3, 0), n = Math.min(this.line + 2, t.length), o = String(n).length, s = Math.max(this.column - 54, 0), i = Math.max(this.column + 20, 80), l = t.slice(r, n).map((c, a) => {
      const u = c.slice(s, i);
      let h = "", m = "";
      s !== 0 && (h = s > c.length - 1 ? " " : "\u2026"), i < c.length - 1 && (m = "\u2026");
      const f = r + 1 + a, d = ` ${f.toString().padStart(o)} | `;
      if (f === this.line) {
        const k = d.replace(/[^|]/g, " "), b = (h + c.slice(s, this.column - 1)).replace(/[^\t]/g, " "), w = k + b;
        return `>${d}${h}${u}${m}
 ${w}^`;
      }
      return ` ${d}${h}${u}${m}`;
    }).join(`
`);
    return `${this.name}: ${this.message}

${l}
`;
  }
}
const U4 = /<!ENTITY\s+(\S+)\s+(?:'([^']+)'|"([^"]+)")\s*>/g, os = {
  strict: !0,
  trim: !1,
  normalize: !1,
  lowercase: !0,
  xmlns: !0,
  position: !0
}, AN = (e, t) => {
  const r = SN.parser(os.strict, os), n = { type: "root", children: [] };
  let o = n;
  const s = [n], i = (l) => {
    Object.defineProperty(l, "parentNode", {
      writable: !0,
      value: o
    }), o.children.push(l);
  };
  return r.ondoctype = (l) => {
    i({
      type: "doctype",
      name: "svg",
      data: {
        doctype: l
      }
    });
    const a = l.indexOf("[");
    if (a >= 0) {
      U4.lastIndex = a;
      let u = U4.exec(e);
      for (; u != null; )
        r.ENTITIES[u[1]] = u[2] || u[3], u = U4.exec(e);
    }
  }, r.onprocessinginstruction = (l) => {
    const c = {
      type: "instruction",
      name: l.name,
      value: l.body
    };
    i(c);
  }, r.oncomment = (l) => {
    const c = {
      type: "comment",
      value: l.trim()
    };
    i(c);
  }, r.oncdata = (l) => {
    i({
      type: "cdata",
      value: l
    });
  }, r.onopentag = (l) => {
    let c = {
      type: "element",
      name: l.name,
      attributes: {},
      children: []
    };
    for (const [a, u] of Object.entries(l.attributes))
      c.attributes[a] = u.value;
    i(c), o = c, s.push(c);
  }, r.ontext = (l) => {
    if (o.type === "element") {
      if ($N.includes(o.name))
        i({
          type: "text",
          value: l
        });
      else if (/\S/.test(l)) {
        const c = {
          type: "text",
          value: l.trim()
        };
        i(c);
      }
    }
  }, r.onclosetag = () => {
    s.pop(), o = s[s.length - 1];
  }, r.onerror = (l) => {
    const c = new g9(
      l.reason,
      l.line + 1,
      l.column,
      e,
      t
    );
    if (l.message.indexOf("Unexpected end") === -1)
      throw c;
  }, r.write(e).close(), n;
};
kl.parseSvg = AN;
var yl = {};
const { textElems: MN } = C0, jN = (e) => EN[e], Be = {
  doctypeStart: "<!DOCTYPE",
  doctypeEnd: ">",
  procInstStart: "<?",
  procInstEnd: "?>",
  tagOpenStart: "<",
  tagOpenEnd: ">",
  tagCloseStart: "</",
  tagCloseEnd: ">",
  tagShortStart: "<",
  tagShortEnd: "/>",
  attrStart: '="',
  attrEnd: '"',
  commentStart: "<!--",
  commentEnd: "-->",
  cdataStart: "<![CDATA[",
  cdataEnd: "]]>",
  textStart: "",
  textEnd: "",
  indent: 4,
  regEntities: /[&'"<>]/g,
  regValEntities: /[&"<>]/g,
  encodeEntity: jN,
  pretty: !1,
  useShortTags: !0,
  eol: "lf",
  finalNewline: !1
}, EN = {
  "&": "&amp;",
  "'": "&apos;",
  '"': "&quot;",
  ">": "&gt;",
  "<": "&lt;"
}, TN = (e, t = {}) => {
  const r = { ...Be, ...t }, n = r.indent;
  let o = "    ";
  typeof n == "number" && Number.isNaN(n) === !1 ? o = n < 0 ? "	" : " ".repeat(n) : typeof n == "string" && (o = n);
  const s = {
    indent: o,
    textContext: null,
    indentLevel: 0
  }, i = r.eol === "crlf" ? `\r
` : `
`;
  r.pretty && (r.doctypeEnd += i, r.procInstEnd += i, r.commentEnd += i, r.cdataEnd += i, r.tagShortEnd += i, r.tagOpenEnd += i, r.tagCloseEnd += i, r.textEnd += i);
  let l = bl(e, r, s);
  return r.finalNewline && l.length > 0 && !l.endsWith(`
`) && (l += i), l;
};
yl.stringifySvg = TN;
const bl = (e, t, r) => {
  let n = "";
  r.indentLevel += 1;
  for (const o of e.children)
    o.type === "element" && (n += RN(o, t, r)), o.type === "text" && (n += IN(o, t, r)), o.type === "doctype" && (n += PN(o, t)), o.type === "instruction" && (n += NN(o, t)), o.type === "comment" && (n += DN(o, t)), o.type === "cdata" && (n += ON(o, t, r));
  return r.indentLevel -= 1, n;
}, Ht = (e, t) => {
  let r = "";
  return e.pretty && t.textContext == null && (r = t.indent.repeat(t.indentLevel - 1)), r;
}, PN = (e, t) => t.doctypeStart + e.data.doctype + t.doctypeEnd, NN = (e, t) => t.procInstStart + e.name + " " + e.value + t.procInstEnd, DN = (e, t) => t.commentStart + e.value + t.commentEnd, ON = (e, t, r) => Ht(t, r) + t.cdataStart + e.value + t.cdataEnd, RN = (e, t, r) => {
  if (e.children.length === 0)
    return t.useShortTags ? Ht(t, r) + t.tagShortStart + e.name + H4(e, t) + t.tagShortEnd : Ht(t, r) + t.tagShortStart + e.name + H4(e, t) + t.tagOpenEnd + t.tagCloseStart + e.name + t.tagCloseEnd;
  {
    let n = t.tagOpenStart, o = t.tagOpenEnd, s = t.tagCloseStart, i = t.tagCloseEnd, l = Ht(t, r), c = Ht(t, r);
    r.textContext ? (n = Be.tagOpenStart, o = Be.tagOpenEnd, s = Be.tagCloseStart, i = Be.tagCloseEnd, l = "") : MN.includes(e.name) && (o = Be.tagOpenEnd, s = Be.tagCloseStart, c = "", r.textContext = e);
    const a = bl(e, t, r);
    return r.textContext === e && (r.textContext = null), l + n + e.name + H4(e, t) + o + a + c + s + e.name + i;
  }
}, H4 = (e, t) => {
  let r = "";
  for (const [n, o] of Object.entries(e.attributes))
    if (o !== void 0) {
      const s = o.toString().replace(t.regValEntities, t.encodeEntity);
      r += " " + n + t.attrStart + s + t.attrEnd;
    } else
      r += " " + n;
  return r;
}, IN = (e, t, r) => Ht(t, r) + t.textStart + e.value.replace(t.regEntities, t.encodeEntity) + (r.textContext ? "" : t.textEnd);
var xl = {}, D8 = {}, a0 = {}, wl = {}, Ll = {}, u1 = {}, tt = {}, x7 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Doctype = e.CDATA = e.Tag = e.Style = e.Script = e.Comment = e.Directive = e.Text = e.Root = e.isTag = e.ElementType = void 0;
  var t;
  (function(n) {
    n.Root = "root", n.Text = "text", n.Directive = "directive", n.Comment = "comment", n.Script = "script", n.Style = "style", n.Tag = "tag", n.CDATA = "cdata", n.Doctype = "doctype";
  })(t = e.ElementType || (e.ElementType = {}));
  function r(n) {
    return n.type === t.Tag || n.type === t.Script || n.type === t.Style;
  }
  e.isTag = r, e.Root = t.Root, e.Text = t.Text, e.Directive = t.Directive, e.Comment = t.Comment, e.Script = t.Script, e.Style = t.Style, e.Tag = t.Tag, e.CDATA = t.CDATA, e.Doctype = t.Doctype;
})(x7);
var l0 = {}, Pe = V && V.__extends || function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, o) {
      n.__proto__ = o;
    } || function(n, o) {
      for (var s in o)
        Object.prototype.hasOwnProperty.call(o, s) && (n[s] = o[s]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), i7 = V && V.__assign || function() {
  return i7 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, i7.apply(this, arguments);
};
Object.defineProperty(l0, "__esModule", { value: !0 });
l0.cloneNode = l0.hasChildren = l0.isDocument = l0.isDirective = l0.isComment = l0.isText = l0.isCDATA = l0.isTag = l0.Element = l0.Document = l0.CDATA = l0.NodeWithChildren = l0.ProcessingInstruction = l0.Comment = l0.Text = l0.DataNode = l0.Node = void 0;
var o1 = x7, k9 = function() {
  function e() {
    this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
  }
  return Object.defineProperty(e.prototype, "parentNode", {
    get: function() {
      return this.parent;
    },
    set: function(t) {
      this.parent = t;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "previousSibling", {
    get: function() {
      return this.prev;
    },
    set: function(t) {
      this.prev = t;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "nextSibling", {
    get: function() {
      return this.next;
    },
    set: function(t) {
      this.next = t;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.cloneNode = function(t) {
    return t === void 0 && (t = !1), v9(this, t);
  }, e;
}();
l0.Node = k9;
var O8 = function(e) {
  Pe(t, e);
  function t(r) {
    var n = e.call(this) || this;
    return n.data = r, n;
  }
  return Object.defineProperty(t.prototype, "nodeValue", {
    get: function() {
      return this.data;
    },
    set: function(r) {
      this.data = r;
    },
    enumerable: !1,
    configurable: !0
  }), t;
}(k9);
l0.DataNode = O8;
var zl = function(e) {
  Pe(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.type = o1.ElementType.Text, r;
  }
  return Object.defineProperty(t.prototype, "nodeType", {
    get: function() {
      return 3;
    },
    enumerable: !1,
    configurable: !0
  }), t;
}(O8);
l0.Text = zl;
var Cl = function(e) {
  Pe(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.type = o1.ElementType.Comment, r;
  }
  return Object.defineProperty(t.prototype, "nodeType", {
    get: function() {
      return 8;
    },
    enumerable: !1,
    configurable: !0
  }), t;
}(O8);
l0.Comment = Cl;
var Sl = function(e) {
  Pe(t, e);
  function t(r, n) {
    var o = e.call(this, n) || this;
    return o.name = r, o.type = o1.ElementType.Directive, o;
  }
  return Object.defineProperty(t.prototype, "nodeType", {
    get: function() {
      return 1;
    },
    enumerable: !1,
    configurable: !0
  }), t;
}(O8);
l0.ProcessingInstruction = Sl;
var R8 = function(e) {
  Pe(t, e);
  function t(r) {
    var n = e.call(this) || this;
    return n.children = r, n;
  }
  return Object.defineProperty(t.prototype, "firstChild", {
    get: function() {
      var r;
      return (r = this.children[0]) !== null && r !== void 0 ? r : null;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "lastChild", {
    get: function() {
      return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "childNodes", {
    get: function() {
      return this.children;
    },
    set: function(r) {
      this.children = r;
    },
    enumerable: !1,
    configurable: !0
  }), t;
}(k9);
l0.NodeWithChildren = R8;
var $l = function(e) {
  Pe(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.type = o1.ElementType.CDATA, r;
  }
  return Object.defineProperty(t.prototype, "nodeType", {
    get: function() {
      return 4;
    },
    enumerable: !1,
    configurable: !0
  }), t;
}(R8);
l0.CDATA = $l;
var Al = function(e) {
  Pe(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.type = o1.ElementType.Root, r;
  }
  return Object.defineProperty(t.prototype, "nodeType", {
    get: function() {
      return 9;
    },
    enumerable: !1,
    configurable: !0
  }), t;
}(R8);
l0.Document = Al;
var Ml = function(e) {
  Pe(t, e);
  function t(r, n, o, s) {
    o === void 0 && (o = []), s === void 0 && (s = r === "script" ? o1.ElementType.Script : r === "style" ? o1.ElementType.Style : o1.ElementType.Tag);
    var i = e.call(this, o) || this;
    return i.name = r, i.attribs = n, i.type = s, i;
  }
  return Object.defineProperty(t.prototype, "nodeType", {
    get: function() {
      return 1;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "tagName", {
    get: function() {
      return this.name;
    },
    set: function(r) {
      this.name = r;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "attributes", {
    get: function() {
      var r = this;
      return Object.keys(this.attribs).map(function(n) {
        var o, s;
        return {
          name: n,
          value: r.attribs[n],
          namespace: (o = r["x-attribsNamespace"]) === null || o === void 0 ? void 0 : o[n],
          prefix: (s = r["x-attribsPrefix"]) === null || s === void 0 ? void 0 : s[n]
        };
      });
    },
    enumerable: !1,
    configurable: !0
  }), t;
}(R8);
l0.Element = Ml;
function jl(e) {
  return (0, o1.isTag)(e);
}
l0.isTag = jl;
function El(e) {
  return e.type === o1.ElementType.CDATA;
}
l0.isCDATA = El;
function Tl(e) {
  return e.type === o1.ElementType.Text;
}
l0.isText = Tl;
function Pl(e) {
  return e.type === o1.ElementType.Comment;
}
l0.isComment = Pl;
function Nl(e) {
  return e.type === o1.ElementType.Directive;
}
l0.isDirective = Nl;
function Dl(e) {
  return e.type === o1.ElementType.Root;
}
l0.isDocument = Dl;
function _N(e) {
  return Object.prototype.hasOwnProperty.call(e, "children");
}
l0.hasChildren = _N;
function v9(e, t) {
  t === void 0 && (t = !1);
  var r;
  if (Tl(e))
    r = new zl(e.data);
  else if (Pl(e))
    r = new Cl(e.data);
  else if (jl(e)) {
    var n = t ? G4(e.children) : [], o = new Ml(e.name, i7({}, e.attribs), n);
    n.forEach(function(c) {
      return c.parent = o;
    }), e.namespace != null && (o.namespace = e.namespace), e["x-attribsNamespace"] && (o["x-attribsNamespace"] = i7({}, e["x-attribsNamespace"])), e["x-attribsPrefix"] && (o["x-attribsPrefix"] = i7({}, e["x-attribsPrefix"])), r = o;
  } else if (El(e)) {
    var n = t ? G4(e.children) : [], s = new $l(n);
    n.forEach(function(a) {
      return a.parent = s;
    }), r = s;
  } else if (Dl(e)) {
    var n = t ? G4(e.children) : [], i = new Al(n);
    n.forEach(function(a) {
      return a.parent = i;
    }), e["x-mode"] && (i["x-mode"] = e["x-mode"]), r = i;
  } else if (Nl(e)) {
    var l = new Sl(e.name, e.data);
    e["x-name"] != null && (l["x-name"] = e["x-name"], l["x-publicId"] = e["x-publicId"], l["x-systemId"] = e["x-systemId"]), r = l;
  } else
    throw new Error("Not implemented yet: ".concat(e.type));
  return r.startIndex = e.startIndex, r.endIndex = e.endIndex, e.sourceCodeLocation != null && (r.sourceCodeLocation = e.sourceCodeLocation), r;
}
l0.cloneNode = v9;
function G4(e) {
  for (var t = e.map(function(n) {
    return v9(n, !0);
  }), r = 1; r < t.length; r++)
    t[r].prev = t[r - 1], t[r - 1].next = t[r];
  return t;
}
(function(e) {
  var t = V && V.__createBinding || (Object.create ? function(l, c, a, u) {
    u === void 0 && (u = a);
    var h = Object.getOwnPropertyDescriptor(c, a);
    (!h || ("get" in h ? !c.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return c[a];
    } }), Object.defineProperty(l, u, h);
  } : function(l, c, a, u) {
    u === void 0 && (u = a), l[u] = c[a];
  }), r = V && V.__exportStar || function(l, c) {
    for (var a in l)
      a !== "default" && !Object.prototype.hasOwnProperty.call(c, a) && t(c, l, a);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.DomHandler = void 0;
  var n = x7, o = l0;
  r(l0, e);
  var s = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, i = function() {
    function l(c, a, u) {
      this.dom = [], this.root = new o.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof a == "function" && (u = a, a = s), typeof c == "object" && (a = c, c = void 0), this.callback = c != null ? c : null, this.options = a != null ? a : s, this.elementCB = u != null ? u : null;
    }
    return l.prototype.onparserinit = function(c) {
      this.parser = c;
    }, l.prototype.onreset = function() {
      this.dom = [], this.root = new o.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
    }, l.prototype.onend = function() {
      this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
    }, l.prototype.onerror = function(c) {
      this.handleCallback(c);
    }, l.prototype.onclosetag = function() {
      this.lastNode = null;
      var c = this.tagStack.pop();
      this.options.withEndIndices && (c.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(c);
    }, l.prototype.onopentag = function(c, a) {
      var u = this.options.xmlMode ? n.ElementType.Tag : void 0, h = new o.Element(c, a, void 0, u);
      this.addNode(h), this.tagStack.push(h);
    }, l.prototype.ontext = function(c) {
      var a = this.lastNode;
      if (a && a.type === n.ElementType.Text)
        a.data += c, this.options.withEndIndices && (a.endIndex = this.parser.endIndex);
      else {
        var u = new o.Text(c);
        this.addNode(u), this.lastNode = u;
      }
    }, l.prototype.oncomment = function(c) {
      if (this.lastNode && this.lastNode.type === n.ElementType.Comment) {
        this.lastNode.data += c;
        return;
      }
      var a = new o.Comment(c);
      this.addNode(a), this.lastNode = a;
    }, l.prototype.oncommentend = function() {
      this.lastNode = null;
    }, l.prototype.oncdatastart = function() {
      var c = new o.Text(""), a = new o.CDATA([c]);
      this.addNode(a), c.parent = a, this.lastNode = c;
    }, l.prototype.oncdataend = function() {
      this.lastNode = null;
    }, l.prototype.onprocessinginstruction = function(c, a) {
      var u = new o.ProcessingInstruction(c, a);
      this.addNode(u);
    }, l.prototype.handleCallback = function(c) {
      if (typeof this.callback == "function")
        this.callback(c, this.dom);
      else if (c)
        throw c;
    }, l.prototype.addNode = function(c) {
      var a = this.tagStack[this.tagStack.length - 1], u = a.children[a.children.length - 1];
      this.options.withStartIndices && (c.startIndex = this.parser.startIndex), this.options.withEndIndices && (c.endIndex = this.parser.endIndex), a.children.push(c), u && (c.prev = u, u.next = c), c.parent = a, this.lastNode = null;
    }, l;
  }();
  e.DomHandler = i, e.default = i;
})(tt);
var w7 = {}, Ol = {}, ho = {}, y9 = {};
Object.defineProperty(y9, "__esModule", { value: !0 });
y9.default = new Uint16Array(
  '\u1D41<\xD5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\0\0\0\0\0\0\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7F\x84\x8B\x90\x95\x98\xA6\xB3\xB9\xC8\xCFlig\u803B\xC6\u40C6P\u803B&\u4026cute\u803B\xC1\u40C1reve;\u4102\u0100iyx}rc\u803B\xC2\u40C2;\u4410r;\uC000\u{1D504}rave\u803B\xC0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9D\xA1on;\u4104f;\uC000\u{1D538}plyFunction;\u6061ing\u803B\xC5\u40C5\u0100cs\xBE\xC3r;\uC000\u{1D49C}ign;\u6254ilde\u803B\xC3\u40C3ml\u803B\xC4\u40C4\u0400aceforsu\xE5\xFB\xFE\u0117\u011C\u0122\u0127\u012A\u0100cr\xEA\xF2kslash;\u6216\u0176\xF6\xF8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\u{1D505}pf;\uC000\u{1D539}eve;\u42D8c\xF2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xA9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xC7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xF2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\u{1D49E}p\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\u{1D507}\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\0\0\0\u0342\u0354\0\u0405f;\uC000\u{1D53B}\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xEC\u0239o\u0274\u0379\0\0\u037B\xBB\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xE5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\0\0\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\0\u0446\0\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\0\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\u{1D49F}rok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xD0\u40D0cute\u803B\xC9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xCA\u40CA;\u442Dot;\u4116r;\uC000\u{1D508}rave\u803B\xC8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\u{1D53C}silon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xCB\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\u{1D509}lled\u0253\u0597\0\0\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\0\u05BF\0\0\u05C4f;\uC000\u{1D53D}All;\u6200riertrf;\u6131c\xF2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\u{1D50A};\u62D9pf;\uC000\u{1D53E}eater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\u{1D4A2};\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\0\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xF2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xF0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xCD\u40CD\u0100iy\u0713\u0718rc\u803B\xCE\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xCC\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xF3\u03DD\u01F4\u0749\0\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\u{1D540}a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\0\u079Ecy;\u4406l\u803B\xCF\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\u{1D50D}pf;\uC000\u{1D541}\u01E3\u07C7\0\u07CCr;\uC000\u{1D4A5}rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\u{1D50E}pf;\uC000\u{1D542}cr;\uC000\u{1D4A6}\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\0\u08C3bleBracket;\u67E6n\u01D4\u08C8\0\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xE1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\u{1D50F}\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xE1\u03BFight\xE1\u03CAf;\uC000\u{1D543}er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xF2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\u{1D510}nusPlus;\u6213pf;\uC000\u{1D544}c\xF2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xEB\u0AD9eryThi\xEE\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xF2\u0673essLes\xF3\u0A48Line;\u400Ar;\uC000\u{1D511}\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\u{1D4A9}ilde\u803B\xD1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xD3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xD4\u40D4;\u441Eblac;\u4150r;\uC000\u{1D512}rave\u803B\xD2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\u{1D546}enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\u{1D4AA}ash\u803B\xD8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xD5\u40D5es;\u6A37ml\u803B\xD6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\u{1D513}i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xE5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\u{1D4AB};\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B"\u4022r;\uC000\u{1D514}pf;\u611Acr;\uC000\u{1D4AC}\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xAE\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xBB\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\0\u1005bleBracket;\u67E7n\u01D4\u100A\0\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\u{1D516}ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xBB\u041EeftArrow\xBB\u089AightArrow\xBB\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\u{1D54A}\u0272\u116D\0\0\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\u{1D4AE}ar;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xE1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xBB\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xDE\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\u{1D517}\u0100ei\u127B\u1289\u01F2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\u{1D54B}ipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\u{1D4AF}rok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\0\u132C\u1331\0\0\0\0\0\u1338\u133D\u1377\u1385\0\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xDA\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\0\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xDB\u40DB;\u4423blac;\u4170r;\uC000\u{1D518}rave\u803B\xD9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\u{1D54C}\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xE1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\u{1D4B0}ilde;\u4168ml\u803B\xDC\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\u{1D519}pf;\uC000\u{1D54D}cr;\uC000\u{1D4B1}dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\u{1D51A}pf;\uC000\u{1D54E}cr;\uC000\u{1D4B2}\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\u{1D51B};\u439Epf;\uC000\u{1D54F}cr;\uC000\u{1D4B3}\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xDD\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\u{1D51C}pf;\uC000\u{1D550}cr;\uC000\u{1D4B4}ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\0\u155BoWidt\xE8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\u{1D4B5}\u0BE1\u1583\u158A\u1590\0\u15B0\u15B6\u15BF\0\0\0\0\u15C6\u15DB\u15EB\u165F\u166D\0\u1695\u169B\u16B2\u16B9\0\u16BEcute\u803B\xE1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xE2\u40E2te\u80BB\xB4\u0306;\u4430lig\u803B\xE6\u40E6\u0100;r\xB2\u15BA;\uC000\u{1D51E}rave\u803B\xE0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xE8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\0\0\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xBB\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xBB\xB9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\u{1D552}\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xF1\u1683ing\u803B\xE5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\u{1D4B6};\u402Amp\u0100;e\u12C1\u16AF\xF1\u0288ilde\u803B\xE3\u40E3ml\u803B\xE4\u40E4\u0100ci\u16C2\u16C8onin\xF4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xBB\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xE9\u170Cno\xF5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\u{1D51F}g\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xF0\u0760rc;\u65EFp\xBB\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\0\0\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xE5\u1444\xE5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\0\u1833\u01B2\u182F\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\u{1D553}\u0100;t\u13CB\u1863om\xBB\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xA6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\u{1D4B7}mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xBB\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\0\u19E8\u1A11\u1A15\u1A32\0\u1A37\u1A50\0\0\u1AB4\0\0\u1AC1\0\0\u1B21\u1B2E\u1B4D\u1B52\0\u1BFD\0\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xEE\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\0\u19F8s;\u6A4Don;\u410Ddil\u803B\xE7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xB8\u01ADptyv;\u69B2t\u8100\xA2;e\u1A2D\u1A2E\u40A2r\xE4\u01B2r;\uC000\u{1D520}\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xBB\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\0\0\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xBB\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xBB\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\0\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xC7\xC6\u026D\u1AD9\0\0\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xEE\u1160e\u0100mx\u1AF1\u1AF6ent\xBB\u1AE9e\xF3\u024D\u01E7\u1AFE\0\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xF4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\u{1D554}o\xE4\u0254\u8100\xA9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\u{1D4B8}\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\0\0\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\0\0\u1BD2re\xE3\u1B73u\xE3\u1B75ee;\u62CEedge;\u62CFen\u803B\xA4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xBB\u1B80ight\xBB\u1BBDe\xE4\u1BDD\u0100ci\u1C01\u1C07onin\xF4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xF2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xF2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xBB\u090A\u016B\u1C61\u1C67arow;\u690Fa\xE3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xB0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\u{1D521}ar\u0100lr\u1CB3\u1CB5\xBB\u08DC\xBB\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xF7;o\u1CE7\u1CF0ntimes;\u62C7n\xF8\u1CF7cy;\u4452c\u026F\u1D06\0\0\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\u{1D555}\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xE5\xFAn\u0180adh\u112E\u1D5D\u1D67ownarrow\xF3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xF4\u1CB4igh\xF4\u1CB6\u0162\u1D7F\u1D85karo\xF7\u0F42\u026F\u1D8A\0\0\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\u{1D4B9};\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xF2\u0429a\xF2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xF4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xE9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xEA\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\u{1D522}\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xE8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xBB\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\u{1D556}\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xBB\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xBB\u1E2E\u0269\u1EF9\0\0\u1EFB\xED\u0548ant\u0100gl\u1F02\u1F06tr\xBB\u1E5Dess\xBB\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xF4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xF0\u40F0\u0100mr\u1F53\u1F57l\u803B\xEB\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xF4\u056E\u0100eo\u1F6C\u1F74ctatio\xEE\u0559nential\xE5\u0579\u09E1\u1F92\0\u1F9E\0\u1FA1\u1FA7\0\0\u1FC6\u1FCC\0\u1FD3\0\u1FE6\u1FEA\u2000\0\u2008\u205Allingdotse\xF1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\0\0\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\u{1D523}lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\0\u1FF3f;\uC000\u{1D557}\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\0\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\0\u202E\u803B\xBD\u40BD;\u6153\u803B\xBC\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\0\u2036;\u6154;\u6156\u02B4\u203E\u2041\0\0\u2043\u803B\xBE\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\0\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\u{1D4BB}\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xF4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\u{1D524}\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xBB\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\u{1D558}\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\0\u218Epro\xF8\u209Er;\u6978q\u0100lq\u063F\u2196les\xF3\u2088i\xED\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xC5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xF2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xF0\u1484f\xBB\u2024il\xF4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xBB\u220Alip;\u6026con;\u62B9r;\uC000\u{1D525}s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\u{1D559}bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\u{1D4BD}as\xE8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xBB\u1C5B\u0AE1\u22A3\0\u22AA\0\u22B8\u22C5\u22CE\0\u22D5\u22F3\0\0\u22F8\u2322\u2367\u2362\u237F\0\u2386\u23AA\u23B4cute\u803B\xED\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xEE\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xA1\u40A1\u0100fr\u039F\u22C9;\uC000\u{1D526}rave\u803B\xEC\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xE5\u078Ear\xF4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xF4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xF3\u1563\xE3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\u{1D55A}a;\u43B9uest\u803B\xBF\u40BF\u0100ci\u238A\u238Fr;\uC000\u{1D4BE}n\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\0\u23BCcy;\u4456l\u803B\xEF\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\u{1D527}ath;\u4237pf;\uC000\u{1D55B}\u01E3\u23EC\0\u23F1r;\uC000\u{1D4BF}rcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\u{1D528}reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\u{1D55C}cr;\uC000\u{1D4C0}\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xF2\u09C6\xF2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\0\u24AA\0\u24B1\0\0\0\0\0\u24B5\u24BA\0\u24C6\u24C8\u24CD\0\u24F9ute;\u413Amptyv;\u69B4ra\xEE\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xE5\u088E;\u6A85uo\u803B\xAB\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xEB\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xEC\u08B0\xE2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xE9\u24F6arpoon\u0100du\u25AF\u25B4own\xBB\u045Ap\xBB\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xF3\u0F98quigarro\xF7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xF4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xF8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xF4\u0989gt\xF2\u248C\xF4\u099Bi\xED\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\u{1D529}\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xF2\u25C1orne\xF2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xBB\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xBB\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xEB\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xE1\u09F2apsto;\u67FCight\xE1\u09FDparrow\u0100lr\u2725\u2729ef\xF4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\u{1D55D}us;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xE1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xBB\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xF2\u08A8orne\xF2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\u{1D4C1}m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xE5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xC5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xAF\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xBB\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xEE\u048Cef\xF4\u090F\xF0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xBB\u1626r;\uC000\u{1D52A}o;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xB5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xF4\u16A7ir;\u6AF0ot\u80BB\xB7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xF2\u2212\xF0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\u{1D55E}\u0100ct\u28F8\u28FDr;\uC000\u{1D4C2}pos\xBB\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xBB\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xF8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\0\u29E3p\u80BB\xA0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\0\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xF6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xED\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\u{1D52B}\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xF4\u0BE2i\xED\u0BEA\u0100;r\u0BB6\u2A81\xBB\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xF2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xF2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xF7\u2AC1ightarro\xF7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xF4\u0C55\u0100;s\u0C55\u2AF4\xBB\u0C36i\xED\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xE4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\u{1D55F}\u8180\xAC;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xEC\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xE5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xF1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xF2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xBB\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xE5\u0D45;\uC000\u{1D4C3}ort\u026D\u2B05\0\0\u2BD6ar\xE1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xE5\u0CF8\xE5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xF1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xEC\u0BD7lde\u803B\xF1\u40F1\xE7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xF1\u0C26ight\u0100;e\u0CCB\u2C65\xF1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2D2D\0\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\0\0\u2D8D\u2DAB\0\u2DC8\u2DCE\0\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xF3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xF4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\u{1D52C}\u036F\u2D79\0\0\u2D7C\0\u2D82n;\u42DBave\u803B\xF2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xF2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xE5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\u{1D560}\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xF2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xBB\u2DFF\u803B\xAA\u40AA\u803B\xBA\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xF2\u2E01ash\u803B\xF8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xF5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xF6\u40F6bar;\u633D\u0AE1\u2E5E\0\u2E7D\0\u2E80\u2E9D\0\u2EA2\u2EB9\0\0\u2ECB\u0E9C\0\u2F13\0\0\u2F2B\u2FBC\0\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xB6;l\u2E6D\u2E6E\u40B6le\xEC\u0403\u0269\u2E78\0\0\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\u{1D52D}\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xF4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xBB\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xF6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xB1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\u{1D561}nd\u803B\xA3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xE5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xF8\u2F43urlye\xF1\u0ED9\xF1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xED\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xF0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xEF\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\u{1D4C5};\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\u{1D52E}pf;\uC000\u{1D562}rime;\u6057cr;\uC000\u{1D4C6}\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xF3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xF1\u1F19\xF4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xF2\u10B3\xF2\u03DDail;\u691Car\xF2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xE3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xE5\u0FD1uo\u803B\xBB\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xEB\u225D\xF0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xF3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xF2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xEC\u0FF2\xE2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xE5\u10BBar\xF4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\u{1D52F}\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xBB\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xE9\u30C8arpoon\u0100du\u31BB\u31BFow\xEE\u317Ep\xBB\u1092eft\u0100ah\u31CA\u31D0rrow\xF3\u0FEAarpoon\xF3\u0551ightarrows;\u61C9quigarro\xF7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xF1\u1F32\u0180ahm\u320D\u3210\u3213r\xF2\u0FEAa\xF2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xBB\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xEB\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\u{1D563}us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xF2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\u{1D4C7}\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xE5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\0\u337A\u33A4\0\0\u33EC\u33F0\0\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\0\u3616\0\0\u3633cute;\u415Bqu\xEF\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\0\u32FC;\u6AB8on;\u4161u\xE5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xED\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xEB\u2228\u0100;o\u0A36\u0A34t\u803B\xA7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xF0nu\xF3\xF1t;\u6736r\u0100;o\u3376\u2055\uC000\u{1D530}\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\0\0\u339Ci\xE4\u1464ara\xEC\u2E6F\u803B\xAD\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xF2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xE9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\u{1D564}a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xBB\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xF1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xF1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xBB\u117Car\xF2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\u{1D4C8}tm\xEE\xF1i\xEC\u3415ar\xE6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xEE\u1EE0h\xE9\u2EAFs\xBB\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xF8\u32FAurlye\xF1\u11FE\xF1\u11F3\u0180aes\u3582\u3588\u331Bppro\xF8\u331Aq\xF1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xB9\u40B9\u803B\xB2\u40B2\u803B\xB3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xEB\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xDF\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\0\u367E\u36C2\0\0\0\0\0\u36DB\u3703\0\u3709\u376C\0\0\0\u3787\u0272\u3656\0\0\u365Bget;\u6316;\u43C4r\xEB\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\u{1D531}\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xF8\u12C1im\xBB\u12ACs\xF0\u129E\u0100as\u36BA\u36AE\xF0\u12C1rn\u803B\xFE\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xD7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xE1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\u{1D565}rk;\u6ADA\xE1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xE5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xBB\u1DBBeft\u0100;e\u2800\u373E\xF1\u092E;\u625Cight\u0100;e\u32AA\u374B\xF1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\u{1D4C9};\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xF4\u1777head\u0100lr\u3797\u37A0eftarro\xF7\u084Fightarrow\xBB\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xF2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xFA\u40FA\xF2\u1150r\u01E3\u37EA\0\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xFB\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xF2\u13ADlac;\u4171a\xF2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\u{1D532}rave\u803B\xF9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xBB\u0957\xBB\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\0\0\u384Arn\u0100;e\u3845\u3846\u631Cr\xBB\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xA8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\u{1D566}\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xE1\u13B3arpoon\u0100lr\u3888\u388Cef\xF4\u382Digh\xF4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xBB\u13FAon\xBB\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\0\0\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xBB\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\u{1D4CA}\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xBB\u1813\u0100am\u38EF\u38F2r\xF2\u38A8l\u803B\xFC\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xF2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xE8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xE1\u2415othin\xE7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xF4\u2FB5\u0100;h\u13B7\u3962\xEF\u318D\u0100iu\u3969\u396Dgm\xE1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xE1\u369Ciangle\u0100lr\u39AA\u39AFeft\xBB\u0925ight\xBB\u1051y;\u4432ash\xBB\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xF2\u1469r;\uC000\u{1D533}tr\xE9\u39AEsu\u0100bp\u39EF\u39F1\xBB\u0D1C\xBB\u0D59pf;\uC000\u{1D567}ro\xF0\u0EFBtr\xE9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\u{1D4CB}\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xBB\u397En\u0100Ee\u3992\u3A1E\xBB\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\u{1D534}pf;\uC000\u{1D568}\u0100;e\u1479\u3A66at\xE8\u1479cr;\uC000\u{1D4CC}\u0AE3\u178E\u3A87\0\u3A8B\0\u3A90\u3A9B\0\0\u3A9D\u3AA8\u3AAB\u3AAF\0\0\u3AC3\u3ACE\0\u3AD8\u17DC\u17DFtr\xE9\u17D1r;\uC000\u{1D535}\u0100Aa\u3A94\u3A97r\xF2\u03C3r\xF2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xF2\u03B8r\xF2\u09EBa\xF0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\u{1D569}im\xE5\u17B2\u0100Aa\u3AC7\u3ACAr\xF2\u03CEr\xF2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\u{1D4CD}\u0100pt\u17D6\u3ADCr\xE9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xFD\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xA5\u40A5r;\uC000\u{1D536}cy;\u4457pf;\uC000\u{1D56A}cr;\uC000\u{1D4CE}\u0100cm\u3B26\u3B29y;\u444El\u803B\xFF\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xE6\u155Fa;\u43B6r;\uC000\u{1D537}cy;\u4436grarr;\u61DDpf;\uC000\u{1D56B}cr;\uC000\u{1D4CF}\u0100jn\u3B85\u3B87;\u600Dj;\u600C'.split("").map(function(e) {
    return e.charCodeAt(0);
  })
);
var b9 = {};
Object.defineProperty(b9, "__esModule", { value: !0 });
b9.default = new Uint16Array(
  "\u0200aglq	\x1B\u026D\0\0p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map(function(e) {
    return e.charCodeAt(0);
  })
);
var mo = {};
(function(e) {
  var t;
  Object.defineProperty(e, "__esModule", { value: !0 }), e.replaceCodePoint = e.fromCodePoint = void 0;
  var r = /* @__PURE__ */ new Map([
    [0, 65533],
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376]
  ]);
  e.fromCodePoint = (t = String.fromCodePoint) !== null && t !== void 0 ? t : function(s) {
    var i = "";
    return s > 65535 && (s -= 65536, i += String.fromCharCode(s >>> 10 & 1023 | 55296), s = 56320 | s & 1023), i += String.fromCharCode(s), i;
  };
  function n(s) {
    var i;
    return s >= 55296 && s <= 57343 || s > 1114111 ? 65533 : (i = r.get(s)) !== null && i !== void 0 ? i : s;
  }
  e.replaceCodePoint = n;
  function o(s) {
    return (0, e.fromCodePoint)(n(s));
  }
  e.default = o;
})(mo);
(function(e) {
  var t = V && V.__createBinding || (Object.create ? function(y, D, E, W) {
    W === void 0 && (W = E);
    var U = Object.getOwnPropertyDescriptor(D, E);
    (!U || ("get" in U ? !D.__esModule : U.writable || U.configurable)) && (U = { enumerable: !0, get: function() {
      return D[E];
    } }), Object.defineProperty(y, W, U);
  } : function(y, D, E, W) {
    W === void 0 && (W = E), y[W] = D[E];
  }), r = V && V.__setModuleDefault || (Object.create ? function(y, D) {
    Object.defineProperty(y, "default", { enumerable: !0, value: D });
  } : function(y, D) {
    y.default = D;
  }), n = V && V.__importStar || function(y) {
    if (y && y.__esModule)
      return y;
    var D = {};
    if (y != null)
      for (var E in y)
        E !== "default" && Object.prototype.hasOwnProperty.call(y, E) && t(D, y, E);
    return r(D, y), D;
  }, o = V && V.__importDefault || function(y) {
    return y && y.__esModule ? y : { default: y };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeXML = e.decodeHTMLStrict = e.decodeHTMLAttribute = e.decodeHTML = e.determineBranch = e.EntityDecoder = e.DecodingMode = e.BinTrieFlags = e.fromCodePoint = e.replaceCodePoint = e.decodeCodePoint = e.xmlDecodeTree = e.htmlDecodeTree = void 0;
  var s = o(y9);
  e.htmlDecodeTree = s.default;
  var i = o(b9);
  e.xmlDecodeTree = i.default;
  var l = n(mo);
  e.decodeCodePoint = l.default;
  var c = mo;
  Object.defineProperty(e, "replaceCodePoint", { enumerable: !0, get: function() {
    return c.replaceCodePoint;
  } }), Object.defineProperty(e, "fromCodePoint", { enumerable: !0, get: function() {
    return c.fromCodePoint;
  } });
  var a;
  (function(y) {
    y[y.NUM = 35] = "NUM", y[y.SEMI = 59] = "SEMI", y[y.EQUALS = 61] = "EQUALS", y[y.ZERO = 48] = "ZERO", y[y.NINE = 57] = "NINE", y[y.LOWER_A = 97] = "LOWER_A", y[y.LOWER_F = 102] = "LOWER_F", y[y.LOWER_X = 120] = "LOWER_X", y[y.LOWER_Z = 122] = "LOWER_Z", y[y.UPPER_A = 65] = "UPPER_A", y[y.UPPER_F = 70] = "UPPER_F", y[y.UPPER_Z = 90] = "UPPER_Z";
  })(a || (a = {}));
  var u = 32, h;
  (function(y) {
    y[y.VALUE_LENGTH = 49152] = "VALUE_LENGTH", y[y.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", y[y.JUMP_TABLE = 127] = "JUMP_TABLE";
  })(h = e.BinTrieFlags || (e.BinTrieFlags = {}));
  function m(y) {
    return y >= a.ZERO && y <= a.NINE;
  }
  function f(y) {
    return y >= a.UPPER_A && y <= a.UPPER_F || y >= a.LOWER_A && y <= a.LOWER_F;
  }
  function d(y) {
    return y >= a.UPPER_A && y <= a.UPPER_Z || y >= a.LOWER_A && y <= a.LOWER_Z || m(y);
  }
  function k(y) {
    return y === a.EQUALS || d(y);
  }
  var b;
  (function(y) {
    y[y.EntityStart = 0] = "EntityStart", y[y.NumericStart = 1] = "NumericStart", y[y.NumericDecimal = 2] = "NumericDecimal", y[y.NumericHex = 3] = "NumericHex", y[y.NamedEntity = 4] = "NamedEntity";
  })(b || (b = {}));
  var w;
  (function(y) {
    y[y.Legacy = 0] = "Legacy", y[y.Strict = 1] = "Strict", y[y.Attribute = 2] = "Attribute";
  })(w = e.DecodingMode || (e.DecodingMode = {}));
  var L = function() {
    function y(D, E, W) {
      this.decodeTree = D, this.emitCodePoint = E, this.errors = W, this.state = b.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = w.Strict;
    }
    return y.prototype.startEntity = function(D) {
      this.decodeMode = D, this.state = b.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
    }, y.prototype.write = function(D, E) {
      switch (this.state) {
        case b.EntityStart:
          return D.charCodeAt(E) === a.NUM ? (this.state = b.NumericStart, this.consumed += 1, this.stateNumericStart(D, E + 1)) : (this.state = b.NamedEntity, this.stateNamedEntity(D, E));
        case b.NumericStart:
          return this.stateNumericStart(D, E);
        case b.NumericDecimal:
          return this.stateNumericDecimal(D, E);
        case b.NumericHex:
          return this.stateNumericHex(D, E);
        case b.NamedEntity:
          return this.stateNamedEntity(D, E);
      }
    }, y.prototype.stateNumericStart = function(D, E) {
      return E >= D.length ? -1 : (D.charCodeAt(E) | u) === a.LOWER_X ? (this.state = b.NumericHex, this.consumed += 1, this.stateNumericHex(D, E + 1)) : (this.state = b.NumericDecimal, this.stateNumericDecimal(D, E));
    }, y.prototype.addToNumericResult = function(D, E, W, U) {
      if (E !== W) {
        var i0 = W - E;
        this.result = this.result * Math.pow(U, i0) + parseInt(D.substr(E, i0), U), this.consumed += i0;
      }
    }, y.prototype.stateNumericHex = function(D, E) {
      for (var W = E; E < D.length; ) {
        var U = D.charCodeAt(E);
        if (m(U) || f(U))
          E += 1;
        else
          return this.addToNumericResult(D, W, E, 16), this.emitNumericEntity(U, 3);
      }
      return this.addToNumericResult(D, W, E, 16), -1;
    }, y.prototype.stateNumericDecimal = function(D, E) {
      for (var W = E; E < D.length; ) {
        var U = D.charCodeAt(E);
        if (m(U))
          E += 1;
        else
          return this.addToNumericResult(D, W, E, 10), this.emitNumericEntity(U, 2);
      }
      return this.addToNumericResult(D, W, E, 10), -1;
    }, y.prototype.emitNumericEntity = function(D, E) {
      var W;
      if (this.consumed <= E)
        return (W = this.errors) === null || W === void 0 || W.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      if (D === a.SEMI)
        this.consumed += 1;
      else if (this.decodeMode === w.Strict)
        return 0;
      return this.emitCodePoint((0, l.replaceCodePoint)(this.result), this.consumed), this.errors && (D !== a.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
    }, y.prototype.stateNamedEntity = function(D, E) {
      for (var W = this.decodeTree, U = W[this.treeIndex], i0 = (U & h.VALUE_LENGTH) >> 14; E < D.length; E++, this.excess++) {
        var Q = D.charCodeAt(E);
        if (this.treeIndex = C(W, U, this.treeIndex + Math.max(1, i0), Q), this.treeIndex < 0)
          return this.result === 0 || this.decodeMode === w.Attribute && (i0 === 0 || k(Q)) ? 0 : this.emitNotTerminatedNamedEntity();
        if (U = W[this.treeIndex], i0 = (U & h.VALUE_LENGTH) >> 14, i0 !== 0) {
          if (Q === a.SEMI)
            return this.emitNamedEntityData(this.treeIndex, i0, this.consumed + this.excess);
          this.decodeMode !== w.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
        }
      }
      return -1;
    }, y.prototype.emitNotTerminatedNamedEntity = function() {
      var D, E = this, W = E.result, U = E.decodeTree, i0 = (U[W] & h.VALUE_LENGTH) >> 14;
      return this.emitNamedEntityData(W, i0, this.consumed), (D = this.errors) === null || D === void 0 || D.missingSemicolonAfterCharacterReference(), this.consumed;
    }, y.prototype.emitNamedEntityData = function(D, E, W) {
      var U = this.decodeTree;
      return this.emitCodePoint(E === 1 ? U[D] & ~h.VALUE_LENGTH : U[D + 1], W), E === 3 && this.emitCodePoint(U[D + 2], W), W;
    }, y.prototype.end = function() {
      var D;
      switch (this.state) {
        case b.NamedEntity:
          return this.result !== 0 && (this.decodeMode !== w.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
        case b.NumericDecimal:
          return this.emitNumericEntity(0, 2);
        case b.NumericHex:
          return this.emitNumericEntity(0, 3);
        case b.NumericStart:
          return (D = this.errors) === null || D === void 0 || D.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
        case b.EntityStart:
          return 0;
      }
    }, y;
  }();
  e.EntityDecoder = L;
  function A(y) {
    var D = "", E = new L(y, function(W) {
      return D += (0, l.fromCodePoint)(W);
    });
    return function(U, i0) {
      for (var Q = 0, v0 = 0; (v0 = U.indexOf("&", v0)) >= 0; ) {
        D += U.slice(Q, v0), E.startEntity(i0);
        var N0 = E.write(
          U,
          v0 + 1
        );
        if (N0 < 0) {
          Q = v0 + E.end();
          break;
        }
        Q = v0 + N0, v0 = N0 === 0 ? Q + 1 : Q;
      }
      var B = D + U.slice(Q);
      return D = "", B;
    };
  }
  function C(y, D, E, W) {
    var U = (D & h.BRANCH_LENGTH) >> 7, i0 = D & h.JUMP_TABLE;
    if (U === 0)
      return i0 !== 0 && W === i0 ? E : -1;
    if (i0) {
      var Q = W - i0;
      return Q < 0 || Q >= U ? -1 : y[E + Q] - 1;
    }
    for (var v0 = E, N0 = v0 + U - 1; v0 <= N0; ) {
      var B = v0 + N0 >>> 1, Y = y[B];
      if (Y < W)
        v0 = B + 1;
      else if (Y > W)
        N0 = B - 1;
      else
        return y[B + U];
    }
    return -1;
  }
  e.determineBranch = C;
  var g = A(s.default), M = A(i.default);
  function P(y, D) {
    return D === void 0 && (D = w.Legacy), g(y, D);
  }
  e.decodeHTML = P;
  function x(y) {
    return g(y, w.Attribute);
  }
  e.decodeHTMLAttribute = x;
  function j(y) {
    return g(y, w.Strict);
  }
  e.decodeHTMLStrict = j;
  function O(y) {
    return M(y, w.Strict);
  }
  e.decodeXML = O;
})(ho);
var et = {}, x9 = {};
Object.defineProperty(x9, "__esModule", { value: !0 });
function br(e) {
  for (var t = 1; t < e.length; t++)
    e[t][0] += e[t - 1][0] + 1;
  return e;
}
x9.default = new Map(/* @__PURE__ */ br([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ br([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ br([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ br([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
var i8 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.escapeText = e.escapeAttribute = e.escapeUTF8 = e.escape = e.encodeXML = e.getCodePoint = e.xmlReplacer = void 0, e.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
  var t = /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [39, "&apos;"],
    [60, "&lt;"],
    [62, "&gt;"]
  ]);
  e.getCodePoint = String.prototype.codePointAt != null ? function(o, s) {
    return o.codePointAt(s);
  } : function(o, s) {
    return (o.charCodeAt(s) & 64512) === 55296 ? (o.charCodeAt(s) - 55296) * 1024 + o.charCodeAt(s + 1) - 56320 + 65536 : o.charCodeAt(s);
  };
  function r(o) {
    for (var s = "", i = 0, l; (l = e.xmlReplacer.exec(o)) !== null; ) {
      var c = l.index, a = o.charCodeAt(c), u = t.get(a);
      u !== void 0 ? (s += o.substring(i, c) + u, i = c + 1) : (s += "".concat(o.substring(i, c), "&#x").concat((0, e.getCodePoint)(o, c).toString(16), ";"), i = e.xmlReplacer.lastIndex += Number((a & 64512) === 55296));
    }
    return s + o.substr(i);
  }
  e.encodeXML = r, e.escape = r;
  function n(o, s) {
    return function(l) {
      for (var c, a = 0, u = ""; c = o.exec(l); )
        a !== c.index && (u += l.substring(a, c.index)), u += s.get(c[0].charCodeAt(0)), a = c.index + 1;
      return u + l.substring(a);
    };
  }
  e.escapeUTF8 = n(/[&<>'"]/g, t), e.escapeAttribute = n(/["&\u00A0]/g, /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [160, "&nbsp;"]
  ])), e.escapeText = n(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
    [38, "&amp;"],
    [60, "&lt;"],
    [62, "&gt;"],
    [160, "&nbsp;"]
  ]));
})(i8);
var FN = V && V.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(et, "__esModule", { value: !0 });
et.encodeNonAsciiHTML = et.encodeHTML = void 0;
var BN = FN(x9), Rl = i8, ZN = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function qN(e) {
  return Il(ZN, e);
}
et.encodeHTML = qN;
function UN(e) {
  return Il(Rl.xmlReplacer, e);
}
et.encodeNonAsciiHTML = UN;
function Il(e, t) {
  for (var r = "", n = 0, o; (o = e.exec(t)) !== null; ) {
    var s = o.index;
    r += t.substring(n, s);
    var i = t.charCodeAt(s), l = BN.default.get(i);
    if (typeof l == "object") {
      if (s + 1 < t.length) {
        var c = t.charCodeAt(s + 1), a = typeof l.n == "number" ? l.n === c ? l.o : void 0 : l.n.get(c);
        if (a !== void 0) {
          r += a, n = e.lastIndex += 1;
          continue;
        }
      }
      l = l.v;
    }
    if (l !== void 0)
      r += l, n = s + 1;
    else {
      var u = (0, Rl.getCodePoint)(t, s);
      r += "&#x".concat(u.toString(16), ";"), n = e.lastIndex += Number(u !== i);
    }
  }
  return r + t.substr(n);
}
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeXMLStrict = e.decodeHTML5Strict = e.decodeHTML4Strict = e.decodeHTML5 = e.decodeHTML4 = e.decodeHTMLAttribute = e.decodeHTMLStrict = e.decodeHTML = e.decodeXML = e.DecodingMode = e.EntityDecoder = e.encodeHTML5 = e.encodeHTML4 = e.encodeNonAsciiHTML = e.encodeHTML = e.escapeText = e.escapeAttribute = e.escapeUTF8 = e.escape = e.encodeXML = e.encode = e.decodeStrict = e.decode = e.EncodingMode = e.EntityLevel = void 0;
  var t = ho, r = et, n = i8, o;
  (function(m) {
    m[m.XML = 0] = "XML", m[m.HTML = 1] = "HTML";
  })(o = e.EntityLevel || (e.EntityLevel = {}));
  var s;
  (function(m) {
    m[m.UTF8 = 0] = "UTF8", m[m.ASCII = 1] = "ASCII", m[m.Extensive = 2] = "Extensive", m[m.Attribute = 3] = "Attribute", m[m.Text = 4] = "Text";
  })(s = e.EncodingMode || (e.EncodingMode = {}));
  function i(m, f) {
    f === void 0 && (f = o.XML);
    var d = typeof f == "number" ? f : f.level;
    if (d === o.HTML) {
      var k = typeof f == "object" ? f.mode : void 0;
      return (0, t.decodeHTML)(m, k);
    }
    return (0, t.decodeXML)(m);
  }
  e.decode = i;
  function l(m, f) {
    var d;
    f === void 0 && (f = o.XML);
    var k = typeof f == "number" ? { level: f } : f;
    return (d = k.mode) !== null && d !== void 0 || (k.mode = t.DecodingMode.Strict), i(m, k);
  }
  e.decodeStrict = l;
  function c(m, f) {
    f === void 0 && (f = o.XML);
    var d = typeof f == "number" ? { level: f } : f;
    return d.mode === s.UTF8 ? (0, n.escapeUTF8)(m) : d.mode === s.Attribute ? (0, n.escapeAttribute)(m) : d.mode === s.Text ? (0, n.escapeText)(m) : d.level === o.HTML ? d.mode === s.ASCII ? (0, r.encodeNonAsciiHTML)(m) : (0, r.encodeHTML)(m) : (0, n.encodeXML)(m);
  }
  e.encode = c;
  var a = i8;
  Object.defineProperty(e, "encodeXML", { enumerable: !0, get: function() {
    return a.encodeXML;
  } }), Object.defineProperty(e, "escape", { enumerable: !0, get: function() {
    return a.escape;
  } }), Object.defineProperty(e, "escapeUTF8", { enumerable: !0, get: function() {
    return a.escapeUTF8;
  } }), Object.defineProperty(e, "escapeAttribute", { enumerable: !0, get: function() {
    return a.escapeAttribute;
  } }), Object.defineProperty(e, "escapeText", { enumerable: !0, get: function() {
    return a.escapeText;
  } });
  var u = et;
  Object.defineProperty(e, "encodeHTML", { enumerable: !0, get: function() {
    return u.encodeHTML;
  } }), Object.defineProperty(e, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
    return u.encodeNonAsciiHTML;
  } }), Object.defineProperty(e, "encodeHTML4", { enumerable: !0, get: function() {
    return u.encodeHTML;
  } }), Object.defineProperty(e, "encodeHTML5", { enumerable: !0, get: function() {
    return u.encodeHTML;
  } });
  var h = ho;
  Object.defineProperty(e, "EntityDecoder", { enumerable: !0, get: function() {
    return h.EntityDecoder;
  } }), Object.defineProperty(e, "DecodingMode", { enumerable: !0, get: function() {
    return h.DecodingMode;
  } }), Object.defineProperty(e, "decodeXML", { enumerable: !0, get: function() {
    return h.decodeXML;
  } }), Object.defineProperty(e, "decodeHTML", { enumerable: !0, get: function() {
    return h.decodeHTML;
  } }), Object.defineProperty(e, "decodeHTMLStrict", { enumerable: !0, get: function() {
    return h.decodeHTMLStrict;
  } }), Object.defineProperty(e, "decodeHTMLAttribute", { enumerable: !0, get: function() {
    return h.decodeHTMLAttribute;
  } }), Object.defineProperty(e, "decodeHTML4", { enumerable: !0, get: function() {
    return h.decodeHTML;
  } }), Object.defineProperty(e, "decodeHTML5", { enumerable: !0, get: function() {
    return h.decodeHTML;
  } }), Object.defineProperty(e, "decodeHTML4Strict", { enumerable: !0, get: function() {
    return h.decodeHTMLStrict;
  } }), Object.defineProperty(e, "decodeHTML5Strict", { enumerable: !0, get: function() {
    return h.decodeHTMLStrict;
  } }), Object.defineProperty(e, "decodeXMLStrict", { enumerable: !0, get: function() {
    return h.decodeXML;
  } });
})(Ol);
var n2 = {};
Object.defineProperty(n2, "__esModule", { value: !0 });
n2.attributeNames = n2.elementNames = void 0;
n2.elementNames = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map(function(e) {
  return [e.toLowerCase(), e];
}));
n2.attributeNames = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map(function(e) {
  return [e.toLowerCase(), e];
}));
var Gt = V && V.__assign || function() {
  return Gt = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Gt.apply(this, arguments);
}, HN = V && V.__createBinding || (Object.create ? function(e, t, r, n) {
  n === void 0 && (n = r);
  var o = Object.getOwnPropertyDescriptor(t, r);
  (!o || ("get" in o ? !t.__esModule : o.writable || o.configurable)) && (o = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, n, o);
} : function(e, t, r, n) {
  n === void 0 && (n = r), e[n] = t[r];
}), GN = V && V.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), WN = V && V.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var r in e)
      r !== "default" && Object.prototype.hasOwnProperty.call(e, r) && HN(t, e, r);
  return GN(t, e), t;
};
Object.defineProperty(w7, "__esModule", { value: !0 });
w7.render = void 0;
var re = WN(x7), a8 = Ol, _l = n2, VN = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function XN(e) {
  return e.replace(/"/g, "&quot;");
}
function YN(e, t) {
  var r;
  if (!!e) {
    var n = ((r = t.encodeEntities) !== null && r !== void 0 ? r : t.decodeEntities) === !1 ? XN : t.xmlMode || t.encodeEntities !== "utf8" ? a8.encodeXML : a8.escapeAttribute;
    return Object.keys(e).map(function(o) {
      var s, i, l = (s = e[o]) !== null && s !== void 0 ? s : "";
      return t.xmlMode === "foreign" && (o = (i = _l.attributeNames.get(o)) !== null && i !== void 0 ? i : o), !t.emptyAttrs && !t.xmlMode && l === "" ? o : "".concat(o, '="').concat(n(l), '"');
    }).join(" ");
  }
}
var ss = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function I8(e, t) {
  t === void 0 && (t = {});
  for (var r = ("length" in e) ? e : [e], n = "", o = 0; o < r.length; o++)
    n += KN(r[o], t);
  return n;
}
w7.render = I8;
w7.default = I8;
function KN(e, t) {
  switch (e.type) {
    case re.Root:
      return I8(e.children, t);
    case re.Doctype:
    case re.Directive:
      return tD(e);
    case re.Comment:
      return oD(e);
    case re.CDATA:
      return nD(e);
    case re.Script:
    case re.Style:
    case re.Tag:
      return eD(e, t);
    case re.Text:
      return rD(e, t);
  }
}
var QN = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), JN = /* @__PURE__ */ new Set(["svg", "math"]);
function eD(e, t) {
  var r;
  t.xmlMode === "foreign" && (e.name = (r = _l.elementNames.get(e.name)) !== null && r !== void 0 ? r : e.name, e.parent && QN.has(e.parent.name) && (t = Gt(Gt({}, t), { xmlMode: !1 }))), !t.xmlMode && JN.has(e.name) && (t = Gt(Gt({}, t), { xmlMode: "foreign" }));
  var n = "<".concat(e.name), o = YN(e.attribs, t);
  return o && (n += " ".concat(o)), e.children.length === 0 && (t.xmlMode ? t.selfClosingTags !== !1 : t.selfClosingTags && ss.has(e.name)) ? (t.xmlMode || (n += " "), n += "/>") : (n += ">", e.children.length > 0 && (n += I8(e.children, t)), (t.xmlMode || !ss.has(e.name)) && (n += "</".concat(e.name, ">"))), n;
}
function tD(e) {
  return "<".concat(e.data, ">");
}
function rD(e, t) {
  var r, n = e.data || "";
  return ((r = t.encodeEntities) !== null && r !== void 0 ? r : t.decodeEntities) !== !1 && !(!t.xmlMode && e.parent && VN.has(e.parent.name)) && (n = t.xmlMode || t.encodeEntities !== "utf8" ? (0, a8.encodeXML)(n) : (0, a8.escapeText)(n)), n;
}
function nD(e) {
  return "<![CDATA[".concat(e.children[0].data, "]]>");
}
function oD(e) {
  return "<!--".concat(e.data, "-->");
}
var sD = V && V.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(u1, "__esModule", { value: !0 });
u1.innerText = u1.textContent = u1.getText = u1.getInnerHTML = u1.getOuterHTML = void 0;
var Q1 = tt, iD = sD(w7), aD = x7;
function Fl(e, t) {
  return (0, iD.default)(e, t);
}
u1.getOuterHTML = Fl;
function lD(e, t) {
  return (0, Q1.hasChildren)(e) ? e.children.map(function(r) {
    return Fl(r, t);
  }).join("") : "";
}
u1.getInnerHTML = lD;
function Ur(e) {
  return Array.isArray(e) ? e.map(Ur).join("") : (0, Q1.isTag)(e) ? e.name === "br" ? `
` : Ur(e.children) : (0, Q1.isCDATA)(e) ? Ur(e.children) : (0, Q1.isText)(e) ? e.data : "";
}
u1.getText = Ur;
function fo(e) {
  return Array.isArray(e) ? e.map(fo).join("") : (0, Q1.hasChildren)(e) && !(0, Q1.isComment)(e) ? fo(e.children) : (0, Q1.isText)(e) ? e.data : "";
}
u1.textContent = fo;
function po(e) {
  return Array.isArray(e) ? e.map(po).join("") : (0, Q1.hasChildren)(e) && (e.type === aD.ElementType.Tag || (0, Q1.isCDATA)(e)) ? po(e.children) : (0, Q1.isText)(e) ? e.data : "";
}
u1.innerText = po;
var I0 = {};
Object.defineProperty(I0, "__esModule", { value: !0 });
I0.prevElementSibling = I0.nextElementSibling = I0.getName = I0.hasAttrib = I0.getAttributeValue = I0.getSiblings = I0.getParent = I0.getChildren = void 0;
var w9 = tt;
function Bl(e) {
  return (0, w9.hasChildren)(e) ? e.children : [];
}
I0.getChildren = Bl;
function Zl(e) {
  return e.parent || null;
}
I0.getParent = Zl;
function cD(e) {
  var t, r, n = Zl(e);
  if (n != null)
    return Bl(n);
  for (var o = [e], s = e.prev, i = e.next; s != null; )
    o.unshift(s), t = s, s = t.prev;
  for (; i != null; )
    o.push(i), r = i, i = r.next;
  return o;
}
I0.getSiblings = cD;
function uD(e, t) {
  var r;
  return (r = e.attribs) === null || r === void 0 ? void 0 : r[t];
}
I0.getAttributeValue = uD;
function hD(e, t) {
  return e.attribs != null && Object.prototype.hasOwnProperty.call(e.attribs, t) && e.attribs[t] != null;
}
I0.hasAttrib = hD;
function mD(e) {
  return e.name;
}
I0.getName = mD;
function fD(e) {
  for (var t, r = e.next; r !== null && !(0, w9.isTag)(r); )
    t = r, r = t.next;
  return r;
}
I0.nextElementSibling = fD;
function dD(e) {
  for (var t, r = e.prev; r !== null && !(0, w9.isTag)(r); )
    t = r, r = t.prev;
  return r;
}
I0.prevElementSibling = dD;
var Q0 = {};
Object.defineProperty(Q0, "__esModule", { value: !0 });
Q0.prepend = Q0.prependChild = Q0.append = Q0.appendChild = Q0.replaceElement = Q0.removeElement = void 0;
function L7(e) {
  if (e.prev && (e.prev.next = e.next), e.next && (e.next.prev = e.prev), e.parent) {
    var t = e.parent.children, r = t.lastIndexOf(e);
    r >= 0 && t.splice(r, 1);
  }
  e.next = null, e.prev = null, e.parent = null;
}
Q0.removeElement = L7;
function pD(e, t) {
  var r = t.prev = e.prev;
  r && (r.next = t);
  var n = t.next = e.next;
  n && (n.prev = t);
  var o = t.parent = e.parent;
  if (o) {
    var s = o.children;
    s[s.lastIndexOf(e)] = t, e.parent = null;
  }
}
Q0.replaceElement = pD;
function gD(e, t) {
  if (L7(t), t.next = null, t.parent = e, e.children.push(t) > 1) {
    var r = e.children[e.children.length - 2];
    r.next = t, t.prev = r;
  } else
    t.prev = null;
}
Q0.appendChild = gD;
function kD(e, t) {
  L7(t);
  var r = e.parent, n = e.next;
  if (t.next = n, t.prev = e, e.next = t, t.parent = r, n) {
    if (n.prev = t, r) {
      var o = r.children;
      o.splice(o.lastIndexOf(n), 0, t);
    }
  } else
    r && r.children.push(t);
}
Q0.append = kD;
function vD(e, t) {
  if (L7(t), t.parent = e, t.prev = null, e.children.unshift(t) !== 1) {
    var r = e.children[1];
    r.prev = t, t.next = r;
  } else
    t.next = null;
}
Q0.prependChild = vD;
function yD(e, t) {
  L7(t);
  var r = e.parent;
  if (r) {
    var n = r.children;
    n.splice(n.indexOf(e), 0, t);
  }
  e.prev && (e.prev.next = t), t.parent = r, t.prev = e.prev, t.next = e, e.prev = t;
}
Q0.prepend = yD;
var V0 = {};
Object.defineProperty(V0, "__esModule", { value: !0 });
V0.findAll = V0.existsOne = V0.findOne = V0.findOneChild = V0.find = V0.filter = void 0;
var _8 = tt;
function bD(e, t, r, n) {
  return r === void 0 && (r = !0), n === void 0 && (n = 1 / 0), ql(e, Array.isArray(t) ? t : [t], r, n);
}
V0.filter = bD;
function ql(e, t, r, n) {
  for (var o = [], s = [t], i = [0]; ; ) {
    if (i[0] >= s[0].length) {
      if (i.length === 1)
        return o;
      s.shift(), i.shift();
      continue;
    }
    var l = s[0][i[0]++];
    if (e(l) && (o.push(l), --n <= 0))
      return o;
    r && (0, _8.hasChildren)(l) && l.children.length > 0 && (i.unshift(0), s.unshift(l.children));
  }
}
V0.find = ql;
function xD(e, t) {
  return t.find(e);
}
V0.findOneChild = xD;
function Ul(e, t, r) {
  r === void 0 && (r = !0);
  for (var n = null, o = 0; o < t.length && !n; o++) {
    var s = t[o];
    if ((0, _8.isTag)(s))
      e(s) ? n = s : r && s.children.length > 0 && (n = Ul(e, s.children, !0));
    else
      continue;
  }
  return n;
}
V0.findOne = Ul;
function Hl(e, t) {
  return t.some(function(r) {
    return (0, _8.isTag)(r) && (e(r) || Hl(e, r.children));
  });
}
V0.existsOne = Hl;
function wD(e, t) {
  for (var r = [], n = [t], o = [0]; ; ) {
    if (o[0] >= n[0].length) {
      if (n.length === 1)
        return r;
      n.shift(), o.shift();
      continue;
    }
    var s = n[0][o[0]++];
    !(0, _8.isTag)(s) || (e(s) && r.push(s), s.children.length > 0 && (o.unshift(0), n.unshift(s.children)));
  }
}
V0.findAll = wD;
var h1 = {};
Object.defineProperty(h1, "__esModule", { value: !0 });
h1.getElementsByTagType = h1.getElementsByTagName = h1.getElementById = h1.getElements = h1.testElement = void 0;
var Ve = tt, F8 = V0, l8 = {
  tag_name: function(e) {
    return typeof e == "function" ? function(t) {
      return (0, Ve.isTag)(t) && e(t.name);
    } : e === "*" ? Ve.isTag : function(t) {
      return (0, Ve.isTag)(t) && t.name === e;
    };
  },
  tag_type: function(e) {
    return typeof e == "function" ? function(t) {
      return e(t.type);
    } : function(t) {
      return t.type === e;
    };
  },
  tag_contains: function(e) {
    return typeof e == "function" ? function(t) {
      return (0, Ve.isText)(t) && e(t.data);
    } : function(t) {
      return (0, Ve.isText)(t) && t.data === e;
    };
  }
};
function Gl(e, t) {
  return typeof t == "function" ? function(r) {
    return (0, Ve.isTag)(r) && t(r.attribs[e]);
  } : function(r) {
    return (0, Ve.isTag)(r) && r.attribs[e] === t;
  };
}
function LD(e, t) {
  return function(r) {
    return e(r) || t(r);
  };
}
function Wl(e) {
  var t = Object.keys(e).map(function(r) {
    var n = e[r];
    return Object.prototype.hasOwnProperty.call(l8, r) ? l8[r](n) : Gl(r, n);
  });
  return t.length === 0 ? null : t.reduce(LD);
}
function zD(e, t) {
  var r = Wl(e);
  return r ? r(t) : !0;
}
h1.testElement = zD;
function CD(e, t, r, n) {
  n === void 0 && (n = 1 / 0);
  var o = Wl(e);
  return o ? (0, F8.filter)(o, t, r, n) : [];
}
h1.getElements = CD;
function SD(e, t, r) {
  return r === void 0 && (r = !0), Array.isArray(t) || (t = [t]), (0, F8.findOne)(Gl("id", e), t, r);
}
h1.getElementById = SD;
function $D(e, t, r, n) {
  return r === void 0 && (r = !0), n === void 0 && (n = 1 / 0), (0, F8.filter)(l8.tag_name(e), t, r, n);
}
h1.getElementsByTagName = $D;
function AD(e, t, r, n) {
  return r === void 0 && (r = !0), n === void 0 && (n = 1 / 0), (0, F8.filter)(l8.tag_type(e), t, r, n);
}
h1.getElementsByTagType = AD;
var Vl = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.uniqueSort = e.compareDocumentPosition = e.DocumentPosition = e.removeSubsets = void 0;
  var t = tt;
  function r(i) {
    for (var l = i.length; --l >= 0; ) {
      var c = i[l];
      if (l > 0 && i.lastIndexOf(c, l - 1) >= 0) {
        i.splice(l, 1);
        continue;
      }
      for (var a = c.parent; a; a = a.parent)
        if (i.includes(a)) {
          i.splice(l, 1);
          break;
        }
    }
    return i;
  }
  e.removeSubsets = r;
  var n;
  (function(i) {
    i[i.DISCONNECTED = 1] = "DISCONNECTED", i[i.PRECEDING = 2] = "PRECEDING", i[i.FOLLOWING = 4] = "FOLLOWING", i[i.CONTAINS = 8] = "CONTAINS", i[i.CONTAINED_BY = 16] = "CONTAINED_BY";
  })(n = e.DocumentPosition || (e.DocumentPosition = {}));
  function o(i, l) {
    var c = [], a = [];
    if (i === l)
      return 0;
    for (var u = (0, t.hasChildren)(i) ? i : i.parent; u; )
      c.unshift(u), u = u.parent;
    for (u = (0, t.hasChildren)(l) ? l : l.parent; u; )
      a.unshift(u), u = u.parent;
    for (var h = Math.min(c.length, a.length), m = 0; m < h && c[m] === a[m]; )
      m++;
    if (m === 0)
      return n.DISCONNECTED;
    var f = c[m - 1], d = f.children, k = c[m], b = a[m];
    return d.indexOf(k) > d.indexOf(b) ? f === l ? n.FOLLOWING | n.CONTAINED_BY : n.FOLLOWING : f === i ? n.PRECEDING | n.CONTAINS : n.PRECEDING;
  }
  e.compareDocumentPosition = o;
  function s(i) {
    return i = i.filter(function(l, c, a) {
      return !a.includes(l, c + 1);
    }), i.sort(function(l, c) {
      var a = o(l, c);
      return a & n.PRECEDING ? -1 : a & n.FOLLOWING ? 1 : 0;
    }), i;
  }
  e.uniqueSort = s;
})(Vl);
var B8 = {};
Object.defineProperty(B8, "__esModule", { value: !0 });
B8.getFeed = void 0;
var MD = u1, z7 = h1;
function jD(e) {
  var t = c8(DD, e);
  return t ? t.name === "feed" ? ED(t) : TD(t) : null;
}
B8.getFeed = jD;
function ED(e) {
  var t, r = e.children, n = {
    type: "atom",
    items: (0, z7.getElementsByTagName)("entry", r).map(function(i) {
      var l, c = i.children, a = { media: Xl(c) };
      K0(a, "id", "id", c), K0(a, "title", "title", c);
      var u = (l = c8("link", c)) === null || l === void 0 ? void 0 : l.attribs.href;
      u && (a.link = u);
      var h = Ce("summary", c) || Ce("content", c);
      h && (a.description = h);
      var m = Ce("updated", c);
      return m && (a.pubDate = new Date(m)), a;
    })
  };
  K0(n, "id", "id", r), K0(n, "title", "title", r);
  var o = (t = c8("link", r)) === null || t === void 0 ? void 0 : t.attribs.href;
  o && (n.link = o), K0(n, "description", "subtitle", r);
  var s = Ce("updated", r);
  return s && (n.updated = new Date(s)), K0(n, "author", "email", r, !0), n;
}
function TD(e) {
  var t, r, n = (r = (t = c8("channel", e.children)) === null || t === void 0 ? void 0 : t.children) !== null && r !== void 0 ? r : [], o = {
    type: e.name.substr(0, 3),
    id: "",
    items: (0, z7.getElementsByTagName)("item", e.children).map(function(i) {
      var l = i.children, c = { media: Xl(l) };
      K0(c, "id", "guid", l), K0(c, "title", "title", l), K0(c, "link", "link", l), K0(c, "description", "description", l);
      var a = Ce("pubDate", l) || Ce("dc:date", l);
      return a && (c.pubDate = new Date(a)), c;
    })
  };
  K0(o, "title", "title", n), K0(o, "link", "link", n), K0(o, "description", "description", n);
  var s = Ce("lastBuildDate", n);
  return s && (o.updated = new Date(s)), K0(o, "author", "managingEditor", n, !0), o;
}
var PD = ["url", "type", "lang"], ND = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function Xl(e) {
  return (0, z7.getElementsByTagName)("media:content", e).map(function(t) {
    for (var r = t.attribs, n = {
      medium: r.medium,
      isDefault: !!r.isDefault
    }, o = 0, s = PD; o < s.length; o++) {
      var i = s[o];
      r[i] && (n[i] = r[i]);
    }
    for (var l = 0, c = ND; l < c.length; l++) {
      var i = c[l];
      r[i] && (n[i] = parseInt(r[i], 10));
    }
    return r.expression && (n.expression = r.expression), n;
  });
}
function c8(e, t) {
  return (0, z7.getElementsByTagName)(e, t, !0, 1)[0];
}
function Ce(e, t, r) {
  return r === void 0 && (r = !1), (0, MD.textContent)((0, z7.getElementsByTagName)(e, t, r, 1)).trim();
}
function K0(e, t, r, n, o) {
  o === void 0 && (o = !1);
  var s = Ce(r, n, o);
  s && (e[t] = s);
}
function DD(e) {
  return e === "rss" || e === "feed" || e === "rdf:RDF";
}
(function(e) {
  var t = V && V.__createBinding || (Object.create ? function(o, s, i, l) {
    l === void 0 && (l = i);
    var c = Object.getOwnPropertyDescriptor(s, i);
    (!c || ("get" in c ? !s.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
      return s[i];
    } }), Object.defineProperty(o, l, c);
  } : function(o, s, i, l) {
    l === void 0 && (l = i), o[l] = s[i];
  }), r = V && V.__exportStar || function(o, s) {
    for (var i in o)
      i !== "default" && !Object.prototype.hasOwnProperty.call(s, i) && t(s, o, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.hasChildren = e.isDocument = e.isComment = e.isText = e.isCDATA = e.isTag = void 0, r(u1, e), r(I0, e), r(Q0, e), r(V0, e), r(h1, e), r(Vl, e), r(B8, e);
  var n = tt;
  Object.defineProperty(e, "isTag", { enumerable: !0, get: function() {
    return n.isTag;
  } }), Object.defineProperty(e, "isCDATA", { enumerable: !0, get: function() {
    return n.isCDATA;
  } }), Object.defineProperty(e, "isText", { enumerable: !0, get: function() {
    return n.isText;
  } }), Object.defineProperty(e, "isComment", { enumerable: !0, get: function() {
    return n.isComment;
  } }), Object.defineProperty(e, "isDocument", { enumerable: !0, get: function() {
    return n.isDocument;
  } }), Object.defineProperty(e, "hasChildren", { enumerable: !0, get: function() {
    return n.hasChildren;
  } });
})(Ll);
var m2 = {
  trueFunc: function() {
    return !0;
  },
  falseFunc: function() {
    return !1;
  }
}, Ee = {}, c0;
(function(e) {
  e.Attribute = "attribute", e.Pseudo = "pseudo", e.PseudoElement = "pseudo-element", e.Tag = "tag", e.Universal = "universal", e.Adjacent = "adjacent", e.Child = "child", e.Descendant = "descendant", e.Parent = "parent", e.Sibling = "sibling", e.ColumnCombinator = "column-combinator";
})(c0 || (c0 = {}));
const OD = {
  Unknown: null,
  QuirksMode: "quirks",
  IgnoreCase: !0,
  CaseSensitive: !1
};
var S0;
(function(e) {
  e.Any = "any", e.Element = "element", e.End = "end", e.Equals = "equals", e.Exists = "exists", e.Hyphen = "hyphen", e.Not = "not", e.Start = "start";
})(S0 || (S0 = {}));
const is = /^[^\\#]?(?:\\(?:[\da-f]{1,6}\s?|.)|[\w\-\u00b0-\uFFFF])+/, RD = /\\([\da-f]{1,6}\s?|(\s)|.)/gi, ID = /* @__PURE__ */ new Map([
  [126, S0.Element],
  [94, S0.Start],
  [36, S0.End],
  [42, S0.Any],
  [33, S0.Not],
  [124, S0.Hyphen]
]), _D = /* @__PURE__ */ new Set([
  "has",
  "not",
  "matches",
  "is",
  "where",
  "host",
  "host-context"
]);
function Yl(e) {
  switch (e.type) {
    case c0.Adjacent:
    case c0.Child:
    case c0.Descendant:
    case c0.Parent:
    case c0.Sibling:
    case c0.ColumnCombinator:
      return !0;
    default:
      return !1;
  }
}
const FD = /* @__PURE__ */ new Set(["contains", "icontains"]);
function BD(e, t, r) {
  const n = parseInt(t, 16) - 65536;
  return n !== n || r ? t : n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode(n >> 10 | 55296, n & 1023 | 56320);
}
function A3(e) {
  return e.replace(RD, BD);
}
function W4(e) {
  return e === 39 || e === 34;
}
function as(e) {
  return e === 32 || e === 9 || e === 10 || e === 12 || e === 13;
}
function ZD(e) {
  const t = [], r = Kl(t, `${e}`, 0);
  if (r < e.length)
    throw new Error(`Unmatched selector: ${e.slice(r)}`);
  return t;
}
function Kl(e, t, r) {
  let n = [];
  function o(m) {
    const f = t.slice(r + m).match(is);
    if (!f)
      throw new Error(`Expected name, found ${t.slice(r)}`);
    const [d] = f;
    return r += m + d.length, A3(d);
  }
  function s(m) {
    for (r += m; r < t.length && as(t.charCodeAt(r)); )
      r++;
  }
  function i() {
    r += 1;
    const m = r;
    let f = 1;
    for (; f > 0 && r < t.length; r++)
      t.charCodeAt(r) === 40 && !l(r) ? f++ : t.charCodeAt(r) === 41 && !l(r) && f--;
    if (f)
      throw new Error("Parenthesis not matched");
    return A3(t.slice(m, r - 1));
  }
  function l(m) {
    let f = 0;
    for (; t.charCodeAt(--m) === 92; )
      f++;
    return (f & 1) === 1;
  }
  function c() {
    if (n.length > 0 && Yl(n[n.length - 1]))
      throw new Error("Did not expect successive traversals.");
  }
  function a(m) {
    if (n.length > 0 && n[n.length - 1].type === c0.Descendant) {
      n[n.length - 1].type = m;
      return;
    }
    c(), n.push({ type: m });
  }
  function u(m, f) {
    n.push({
      type: c0.Attribute,
      name: m,
      action: f,
      value: o(1),
      namespace: null,
      ignoreCase: "quirks"
    });
  }
  function h() {
    if (n.length && n[n.length - 1].type === c0.Descendant && n.pop(), n.length === 0)
      throw new Error("Empty sub-selector");
    e.push(n);
  }
  if (s(0), t.length === r)
    return r;
  e:
    for (; r < t.length; ) {
      const m = t.charCodeAt(r);
      switch (m) {
        case 32:
        case 9:
        case 10:
        case 12:
        case 13: {
          (n.length === 0 || n[0].type !== c0.Descendant) && (c(), n.push({ type: c0.Descendant })), s(1);
          break;
        }
        case 62: {
          a(c0.Child), s(1);
          break;
        }
        case 60: {
          a(c0.Parent), s(1);
          break;
        }
        case 126: {
          a(c0.Sibling), s(1);
          break;
        }
        case 43: {
          a(c0.Adjacent), s(1);
          break;
        }
        case 46: {
          u("class", S0.Element);
          break;
        }
        case 35: {
          u("id", S0.Equals);
          break;
        }
        case 91: {
          s(1);
          let f, d = null;
          t.charCodeAt(r) === 124 ? f = o(1) : t.startsWith("*|", r) ? (d = "*", f = o(2)) : (f = o(0), t.charCodeAt(r) === 124 && t.charCodeAt(r + 1) !== 61 && (d = f, f = o(1))), s(0);
          let k = S0.Exists;
          const b = ID.get(t.charCodeAt(r));
          if (b) {
            if (k = b, t.charCodeAt(r + 1) !== 61)
              throw new Error("Expected `=`");
            s(2);
          } else
            t.charCodeAt(r) === 61 && (k = S0.Equals, s(1));
          let w = "", L = null;
          if (k !== "exists") {
            if (W4(t.charCodeAt(r))) {
              const g = t.charCodeAt(r);
              let M = r + 1;
              for (; M < t.length && (t.charCodeAt(M) !== g || l(M)); )
                M += 1;
              if (t.charCodeAt(M) !== g)
                throw new Error("Attribute value didn't end");
              w = A3(t.slice(r + 1, M)), r = M + 1;
            } else {
              const g = r;
              for (; r < t.length && (!as(t.charCodeAt(r)) && t.charCodeAt(r) !== 93 || l(r)); )
                r += 1;
              w = A3(t.slice(g, r));
            }
            s(0);
            const C = t.charCodeAt(r) | 32;
            C === 115 ? (L = !1, s(1)) : C === 105 && (L = !0, s(1));
          }
          if (t.charCodeAt(r) !== 93)
            throw new Error("Attribute selector didn't terminate");
          r += 1;
          const A = {
            type: c0.Attribute,
            name: f,
            action: k,
            value: w,
            namespace: d,
            ignoreCase: L
          };
          n.push(A);
          break;
        }
        case 58: {
          if (t.charCodeAt(r + 1) === 58) {
            n.push({
              type: c0.PseudoElement,
              name: o(2).toLowerCase(),
              data: t.charCodeAt(r) === 40 ? i() : null
            });
            continue;
          }
          const f = o(1).toLowerCase();
          let d = null;
          if (t.charCodeAt(r) === 40)
            if (_D.has(f)) {
              if (W4(t.charCodeAt(r + 1)))
                throw new Error(`Pseudo-selector ${f} cannot be quoted`);
              if (d = [], r = Kl(d, t, r + 1), t.charCodeAt(r) !== 41)
                throw new Error(`Missing closing parenthesis in :${f} (${t})`);
              r += 1;
            } else {
              if (d = i(), FD.has(f)) {
                const k = d.charCodeAt(0);
                k === d.charCodeAt(d.length - 1) && W4(k) && (d = d.slice(1, -1));
              }
              d = A3(d);
            }
          n.push({ type: c0.Pseudo, name: f, data: d });
          break;
        }
        case 44: {
          h(), n = [], s(1);
          break;
        }
        default: {
          if (t.startsWith("/*", r)) {
            const k = t.indexOf("*/", r + 2);
            if (k < 0)
              throw new Error("Comment was not terminated");
            r = k + 2, n.length === 0 && s(0);
            break;
          }
          let f = null, d;
          if (m === 42)
            r += 1, d = "*";
          else if (m === 124) {
            if (d = "", t.charCodeAt(r + 1) === 124) {
              a(c0.ColumnCombinator), s(2);
              break;
            }
          } else if (is.test(t.slice(r)))
            d = o(0);
          else
            break e;
          t.charCodeAt(r) === 124 && t.charCodeAt(r + 1) !== 124 && (f = d, t.charCodeAt(r + 1) === 42 ? (d = "*", r += 2) : d = o(1)), n.push(d === "*" ? { type: c0.Universal, namespace: f } : { type: c0.Tag, name: d, namespace: f });
        }
      }
    }
  return h(), r;
}
const Ql = ["\\", '"'], Jl = [...Ql, "(", ")"], qD = new Set(Ql.map((e) => e.charCodeAt(0))), ls = new Set(Jl.map((e) => e.charCodeAt(0))), Wt = new Set([
  ...Jl,
  "~",
  "^",
  "$",
  "*",
  "+",
  "!",
  "|",
  ":",
  "[",
  "]",
  " ",
  "."
].map((e) => e.charCodeAt(0)));
function ec(e) {
  return e.map((t) => t.map(UD).join("")).join(", ");
}
function UD(e, t, r) {
  switch (e.type) {
    case c0.Child:
      return t === 0 ? "> " : " > ";
    case c0.Parent:
      return t === 0 ? "< " : " < ";
    case c0.Sibling:
      return t === 0 ? "~ " : " ~ ";
    case c0.Adjacent:
      return t === 0 ? "+ " : " + ";
    case c0.Descendant:
      return " ";
    case c0.ColumnCombinator:
      return t === 0 ? "|| " : " || ";
    case c0.Universal:
      return e.namespace === "*" && t + 1 < r.length && "name" in r[t + 1] ? "" : `${tc(e.namespace)}*`;
    case c0.Tag:
      return cs(e);
    case c0.PseudoElement:
      return `::${ae(e.name, Wt)}${e.data === null ? "" : `(${ae(e.data, ls)})`}`;
    case c0.Pseudo:
      return `:${ae(e.name, Wt)}${e.data === null ? "" : `(${typeof e.data == "string" ? ae(e.data, ls) : ec(e.data)})`}`;
    case c0.Attribute: {
      if (e.name === "id" && e.action === S0.Equals && e.ignoreCase === "quirks" && !e.namespace)
        return `#${ae(e.value, Wt)}`;
      if (e.name === "class" && e.action === S0.Element && e.ignoreCase === "quirks" && !e.namespace)
        return `.${ae(e.value, Wt)}`;
      const n = cs(e);
      return e.action === S0.Exists ? `[${n}]` : `[${n}${HD(e.action)}="${ae(e.value, qD)}"${e.ignoreCase === null ? "" : e.ignoreCase ? " i" : " s"}]`;
    }
  }
}
function HD(e) {
  switch (e) {
    case S0.Equals:
      return "";
    case S0.Element:
      return "~";
    case S0.Start:
      return "^";
    case S0.End:
      return "$";
    case S0.Any:
      return "*";
    case S0.Not:
      return "!";
    case S0.Hyphen:
      return "|";
    case S0.Exists:
      throw new Error("Shouldn't be here");
  }
}
function cs(e) {
  return `${tc(e.namespace)}${ae(e.name, Wt)}`;
}
function tc(e) {
  return e !== null ? `${e === "*" ? "*" : ae(e, Wt)}|` : "";
}
function ae(e, t) {
  let r = 0, n = "";
  for (let o = 0; o < e.length; o++)
    t.has(e.charCodeAt(o)) && (n += `${e.slice(r, o)}\\${e.charAt(o)}`, r = o + 1);
  return n.length > 0 ? n + e.slice(r) : e;
}
const GD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isTraversal: Yl,
  parse: ZD,
  stringify: ec,
  get SelectorType() {
    return c0;
  },
  IgnoreCaseMode: OD,
  get AttributeAction() {
    return S0;
  }
}, Symbol.toStringTag, { value: "Module" })), C7 = /* @__PURE__ */ ml(GD);
var f2 = {};
Object.defineProperty(f2, "__esModule", { value: !0 });
f2.isTraversal = void 0;
var c1 = C7, rc = /* @__PURE__ */ new Map([
  [c1.SelectorType.Universal, 50],
  [c1.SelectorType.Tag, 30],
  [c1.SelectorType.Attribute, 1],
  [c1.SelectorType.Pseudo, 0]
]);
function WD(e) {
  return !rc.has(e.type);
}
f2.isTraversal = WD;
var VD = /* @__PURE__ */ new Map([
  [c1.AttributeAction.Exists, 10],
  [c1.AttributeAction.Equals, 8],
  [c1.AttributeAction.Not, 7],
  [c1.AttributeAction.Start, 6],
  [c1.AttributeAction.End, 6],
  [c1.AttributeAction.Any, 5]
]);
function XD(e) {
  for (var t = e.map(nc), r = 1; r < e.length; r++) {
    var n = t[r];
    if (!(n < 0))
      for (var o = r - 1; o >= 0 && n < t[o]; o--) {
        var s = e[o + 1];
        e[o + 1] = e[o], e[o] = s, t[o + 1] = t[o], t[o] = n;
      }
  }
}
f2.default = XD;
function nc(e) {
  var t, r, n = (t = rc.get(e.type)) !== null && t !== void 0 ? t : -1;
  return e.type === c1.SelectorType.Attribute ? (n = (r = VD.get(e.action)) !== null && r !== void 0 ? r : 4, e.action === c1.AttributeAction.Equals && e.name === "id" && (n = 9), e.ignoreCase && (n >>= 1)) : e.type === c1.SelectorType.Pseudo && (e.data ? e.name === "has" || e.name === "contains" ? n = 0 : Array.isArray(e.data) ? (n = Math.min.apply(Math, e.data.map(function(o) {
    return Math.min.apply(Math, o.map(nc));
  })), n < 0 && (n = 0)) : n = 2 : n = 3), n;
}
var Z8 = {}, q8 = {}, YD = V && V.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(q8, "__esModule", { value: !0 });
q8.attributeRules = void 0;
var xr = YD(m2), KD = /[-[\]{}()*+?.,\\^$|#\s]/g;
function us(e) {
  return e.replace(KD, "\\$&");
}
var QD = /* @__PURE__ */ new Set([
  "accept",
  "accept-charset",
  "align",
  "alink",
  "axis",
  "bgcolor",
  "charset",
  "checked",
  "clear",
  "codetype",
  "color",
  "compact",
  "declare",
  "defer",
  "dir",
  "direction",
  "disabled",
  "enctype",
  "face",
  "frame",
  "hreflang",
  "http-equiv",
  "lang",
  "language",
  "link",
  "media",
  "method",
  "multiple",
  "nohref",
  "noresize",
  "noshade",
  "nowrap",
  "readonly",
  "rel",
  "rev",
  "rules",
  "scope",
  "scrolling",
  "selected",
  "shape",
  "target",
  "text",
  "type",
  "valign",
  "valuetype",
  "vlink"
]);
function Re(e, t) {
  return typeof e.ignoreCase == "boolean" ? e.ignoreCase : e.ignoreCase === "quirks" ? !!t.quirksMode : !t.xmlMode && QD.has(e.name);
}
q8.attributeRules = {
  equals: function(e, t, r) {
    var n = r.adapter, o = t.name, s = t.value;
    return Re(t, r) ? (s = s.toLowerCase(), function(i) {
      var l = n.getAttributeValue(i, o);
      return l != null && l.length === s.length && l.toLowerCase() === s && e(i);
    }) : function(i) {
      return n.getAttributeValue(i, o) === s && e(i);
    };
  },
  hyphen: function(e, t, r) {
    var n = r.adapter, o = t.name, s = t.value, i = s.length;
    return Re(t, r) ? (s = s.toLowerCase(), function(c) {
      var a = n.getAttributeValue(c, o);
      return a != null && (a.length === i || a.charAt(i) === "-") && a.substr(0, i).toLowerCase() === s && e(c);
    }) : function(c) {
      var a = n.getAttributeValue(c, o);
      return a != null && (a.length === i || a.charAt(i) === "-") && a.substr(0, i) === s && e(c);
    };
  },
  element: function(e, t, r) {
    var n = r.adapter, o = t.name, s = t.value;
    if (/\s/.test(s))
      return xr.default.falseFunc;
    var i = new RegExp("(?:^|\\s)".concat(us(s), "(?:$|\\s)"), Re(t, r) ? "i" : "");
    return function(c) {
      var a = n.getAttributeValue(c, o);
      return a != null && a.length >= s.length && i.test(a) && e(c);
    };
  },
  exists: function(e, t, r) {
    var n = t.name, o = r.adapter;
    return function(s) {
      return o.hasAttrib(s, n) && e(s);
    };
  },
  start: function(e, t, r) {
    var n = r.adapter, o = t.name, s = t.value, i = s.length;
    return i === 0 ? xr.default.falseFunc : Re(t, r) ? (s = s.toLowerCase(), function(l) {
      var c = n.getAttributeValue(l, o);
      return c != null && c.length >= i && c.substr(0, i).toLowerCase() === s && e(l);
    }) : function(l) {
      var c;
      return !!(!((c = n.getAttributeValue(l, o)) === null || c === void 0) && c.startsWith(s)) && e(l);
    };
  },
  end: function(e, t, r) {
    var n = r.adapter, o = t.name, s = t.value, i = -s.length;
    return i === 0 ? xr.default.falseFunc : Re(t, r) ? (s = s.toLowerCase(), function(l) {
      var c;
      return ((c = n.getAttributeValue(l, o)) === null || c === void 0 ? void 0 : c.substr(i).toLowerCase()) === s && e(l);
    }) : function(l) {
      var c;
      return !!(!((c = n.getAttributeValue(l, o)) === null || c === void 0) && c.endsWith(s)) && e(l);
    };
  },
  any: function(e, t, r) {
    var n = r.adapter, o = t.name, s = t.value;
    if (s === "")
      return xr.default.falseFunc;
    if (Re(t, r)) {
      var i = new RegExp(us(s), "i");
      return function(c) {
        var a = n.getAttributeValue(c, o);
        return a != null && a.length >= s.length && i.test(a) && e(c);
      };
    }
    return function(l) {
      var c;
      return !!(!((c = n.getAttributeValue(l, o)) === null || c === void 0) && c.includes(s)) && e(l);
    };
  },
  not: function(e, t, r) {
    var n = r.adapter, o = t.name, s = t.value;
    return s === "" ? function(i) {
      return !!n.getAttributeValue(i, o) && e(i);
    } : Re(t, r) ? (s = s.toLowerCase(), function(i) {
      var l = n.getAttributeValue(i, o);
      return (l == null || l.length !== s.length || l.toLowerCase() !== s) && e(i);
    }) : function(i) {
      return n.getAttributeValue(i, o) !== s && e(i);
    };
  }
};
var L9 = {}, oc = {}, sc = {}, U8 = {};
Object.defineProperty(U8, "__esModule", { value: !0 });
U8.parse = void 0;
var JD = /* @__PURE__ */ new Set([9, 10, 12, 13, 32]), hs = "0".charCodeAt(0), eO = "9".charCodeAt(0);
function tO(e) {
  if (e = e.trim().toLowerCase(), e === "even")
    return [2, 0];
  if (e === "odd")
    return [2, 1];
  var t = 0, r = 0, n = s(), o = i();
  if (t < e.length && e.charAt(t) === "n" && (t++, r = n * (o != null ? o : 1), l(), t < e.length ? (n = s(), l(), o = i()) : n = o = 0), o === null || t < e.length)
    throw new Error("n-th rule couldn't be parsed ('".concat(e, "')"));
  return [r, n * o];
  function s() {
    return e.charAt(t) === "-" ? (t++, -1) : (e.charAt(t) === "+" && t++, 1);
  }
  function i() {
    for (var c = t, a = 0; t < e.length && e.charCodeAt(t) >= hs && e.charCodeAt(t) <= eO; )
      a = a * 10 + (e.charCodeAt(t) - hs), t++;
    return t === c ? null : a;
  }
  function l() {
    for (; t < e.length && JD.has(e.charCodeAt(t)); )
      t++;
  }
}
U8.parse = tO;
var o2 = {}, rO = V && V.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(o2, "__esModule", { value: !0 });
o2.generate = o2.compile = void 0;
var ms = rO(m2);
function nO(e) {
  var t = e[0], r = e[1] - 1;
  if (r < 0 && t <= 0)
    return ms.default.falseFunc;
  if (t === -1)
    return function(s) {
      return s <= r;
    };
  if (t === 0)
    return function(s) {
      return s === r;
    };
  if (t === 1)
    return r < 0 ? ms.default.trueFunc : function(s) {
      return s >= r;
    };
  var n = Math.abs(t), o = (r % n + n) % n;
  return t > 1 ? function(s) {
    return s >= r && s % n === o;
  } : function(s) {
    return s <= r && s % n === o;
  };
}
o2.compile = nO;
function oO(e) {
  var t = e[0], r = e[1] - 1, n = 0;
  if (t < 0) {
    var o = -t, s = (r % o + o) % o;
    return function() {
      var i = s + o * n++;
      return i > r ? null : i;
    };
  }
  return t === 0 ? r < 0 ? function() {
    return null;
  } : function() {
    return n++ === 0 ? r : null;
  } : (r < 0 && (r += t * Math.ceil(-r / t)), function() {
    return t * n++ + r;
  });
}
o2.generate = oO;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.sequence = e.generate = e.compile = e.parse = void 0;
  var t = U8;
  Object.defineProperty(e, "parse", { enumerable: !0, get: function() {
    return t.parse;
  } });
  var r = o2;
  Object.defineProperty(e, "compile", { enumerable: !0, get: function() {
    return r.compile;
  } }), Object.defineProperty(e, "generate", { enumerable: !0, get: function() {
    return r.generate;
  } });
  function n(s) {
    return (0, r.compile)((0, t.parse)(s));
  }
  e.default = n;
  function o(s) {
    return (0, r.generate)((0, t.parse)(s));
  }
  e.sequence = o;
})(sc);
(function(e) {
  var t = V && V.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.filters = void 0;
  var r = t(sc), n = t(m2);
  function o(i, l) {
    return function(c) {
      var a = l.getParent(c);
      return a != null && l.isTag(a) && i(c);
    };
  }
  e.filters = {
    contains: function(i, l, c) {
      var a = c.adapter;
      return function(h) {
        return i(h) && a.getText(h).includes(l);
      };
    },
    icontains: function(i, l, c) {
      var a = c.adapter, u = l.toLowerCase();
      return function(m) {
        return i(m) && a.getText(m).toLowerCase().includes(u);
      };
    },
    "nth-child": function(i, l, c) {
      var a = c.adapter, u = c.equals, h = (0, r.default)(l);
      return h === n.default.falseFunc ? n.default.falseFunc : h === n.default.trueFunc ? o(i, a) : function(f) {
        for (var d = a.getSiblings(f), k = 0, b = 0; b < d.length && !u(f, d[b]); b++)
          a.isTag(d[b]) && k++;
        return h(k) && i(f);
      };
    },
    "nth-last-child": function(i, l, c) {
      var a = c.adapter, u = c.equals, h = (0, r.default)(l);
      return h === n.default.falseFunc ? n.default.falseFunc : h === n.default.trueFunc ? o(i, a) : function(f) {
        for (var d = a.getSiblings(f), k = 0, b = d.length - 1; b >= 0 && !u(f, d[b]); b--)
          a.isTag(d[b]) && k++;
        return h(k) && i(f);
      };
    },
    "nth-of-type": function(i, l, c) {
      var a = c.adapter, u = c.equals, h = (0, r.default)(l);
      return h === n.default.falseFunc ? n.default.falseFunc : h === n.default.trueFunc ? o(i, a) : function(f) {
        for (var d = a.getSiblings(f), k = 0, b = 0; b < d.length; b++) {
          var w = d[b];
          if (u(f, w))
            break;
          a.isTag(w) && a.getName(w) === a.getName(f) && k++;
        }
        return h(k) && i(f);
      };
    },
    "nth-last-of-type": function(i, l, c) {
      var a = c.adapter, u = c.equals, h = (0, r.default)(l);
      return h === n.default.falseFunc ? n.default.falseFunc : h === n.default.trueFunc ? o(i, a) : function(f) {
        for (var d = a.getSiblings(f), k = 0, b = d.length - 1; b >= 0; b--) {
          var w = d[b];
          if (u(f, w))
            break;
          a.isTag(w) && a.getName(w) === a.getName(f) && k++;
        }
        return h(k) && i(f);
      };
    },
    root: function(i, l, c) {
      var a = c.adapter;
      return function(u) {
        var h = a.getParent(u);
        return (h == null || !a.isTag(h)) && i(u);
      };
    },
    scope: function(i, l, c, a) {
      var u = c.equals;
      return !a || a.length === 0 ? e.filters.root(i, l, c) : a.length === 1 ? function(h) {
        return u(a[0], h) && i(h);
      } : function(h) {
        return a.includes(h) && i(h);
      };
    },
    hover: s("isHovered"),
    visited: s("isVisited"),
    active: s("isActive")
  };
  function s(i) {
    return function(c, a, u) {
      var h = u.adapter, m = h[i];
      return typeof m != "function" ? n.default.falseFunc : function(d) {
        return m(d) && c(d);
      };
    };
  }
})(oc);
var s2 = {};
Object.defineProperty(s2, "__esModule", { value: !0 });
s2.verifyPseudoArgs = s2.pseudos = void 0;
s2.pseudos = {
  empty: function(e, t) {
    var r = t.adapter;
    return !r.getChildren(e).some(function(n) {
      return r.isTag(n) || r.getText(n) !== "";
    });
  },
  "first-child": function(e, t) {
    var r = t.adapter, n = t.equals;
    if (r.prevElementSibling)
      return r.prevElementSibling(e) == null;
    var o = r.getSiblings(e).find(function(s) {
      return r.isTag(s);
    });
    return o != null && n(e, o);
  },
  "last-child": function(e, t) {
    for (var r = t.adapter, n = t.equals, o = r.getSiblings(e), s = o.length - 1; s >= 0; s--) {
      if (n(e, o[s]))
        return !0;
      if (r.isTag(o[s]))
        break;
    }
    return !1;
  },
  "first-of-type": function(e, t) {
    for (var r = t.adapter, n = t.equals, o = r.getSiblings(e), s = r.getName(e), i = 0; i < o.length; i++) {
      var l = o[i];
      if (n(e, l))
        return !0;
      if (r.isTag(l) && r.getName(l) === s)
        break;
    }
    return !1;
  },
  "last-of-type": function(e, t) {
    for (var r = t.adapter, n = t.equals, o = r.getSiblings(e), s = r.getName(e), i = o.length - 1; i >= 0; i--) {
      var l = o[i];
      if (n(e, l))
        return !0;
      if (r.isTag(l) && r.getName(l) === s)
        break;
    }
    return !1;
  },
  "only-of-type": function(e, t) {
    var r = t.adapter, n = t.equals, o = r.getName(e);
    return r.getSiblings(e).every(function(s) {
      return n(e, s) || !r.isTag(s) || r.getName(s) !== o;
    });
  },
  "only-child": function(e, t) {
    var r = t.adapter, n = t.equals;
    return r.getSiblings(e).every(function(o) {
      return n(e, o) || !r.isTag(o);
    });
  }
};
function sO(e, t, r, n) {
  if (r === null) {
    if (e.length > n)
      throw new Error("Pseudo-class :".concat(t, " requires an argument"));
  } else if (e.length === n)
    throw new Error("Pseudo-class :".concat(t, " doesn't have any arguments"));
}
s2.verifyPseudoArgs = sO;
var H8 = {};
Object.defineProperty(H8, "__esModule", { value: !0 });
H8.aliases = void 0;
H8.aliases = {
  "any-link": ":is(a, area, link)[href]",
  link: ":any-link:not(:visited)",
  disabled: `:is(
        :is(button, input, select, textarea, optgroup, option)[disabled],
        optgroup[disabled] > option,
        fieldset[disabled]:not(fieldset[disabled] legend:first-of-type *)
    )`,
  enabled: ":not(:disabled)",
  checked: ":is(:is(input[type=radio], input[type=checkbox])[checked], option:selected)",
  required: ":is(input, select, textarea)[required]",
  optional: ":is(input, select, textarea):not([required])",
  selected: "option:is([selected], select:not([multiple]):not(:has(> option[selected])) > :first-of-type)",
  checkbox: "[type=checkbox]",
  file: "[type=file]",
  password: "[type=password]",
  radio: "[type=radio]",
  reset: "[type=reset]",
  image: "[type=image]",
  submit: "[type=submit]",
  parent: ":not(:empty)",
  header: ":is(h1, h2, h3, h4, h5, h6)",
  button: ":is(button, input[type=button])",
  input: ":is(input, textarea, select, button)",
  text: "input:is(:not([type!='']), [type=text])"
};
var G8 = {};
(function(e) {
  var t = V && V.__spreadArray || function(a, u, h) {
    if (h || arguments.length === 2)
      for (var m = 0, f = u.length, d; m < f; m++)
        (d || !(m in u)) && (d || (d = Array.prototype.slice.call(u, 0, m)), d[m] = u[m]);
    return a.concat(d || Array.prototype.slice.call(u));
  }, r = V && V.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.subselects = e.getNextSiblings = e.ensureIsTag = e.PLACEHOLDER_ELEMENT = void 0;
  var n = r(m2), o = f2;
  e.PLACEHOLDER_ELEMENT = {};
  function s(a, u) {
    return a === n.default.falseFunc ? n.default.falseFunc : function(h) {
      return u.isTag(h) && a(h);
    };
  }
  e.ensureIsTag = s;
  function i(a, u) {
    var h = u.getSiblings(a);
    if (h.length <= 1)
      return [];
    var m = h.indexOf(a);
    return m < 0 || m === h.length - 1 ? [] : h.slice(m + 1).filter(u.isTag);
  }
  e.getNextSiblings = i;
  function l(a) {
    return {
      xmlMode: !!a.xmlMode,
      lowerCaseAttributeNames: !!a.lowerCaseAttributeNames,
      lowerCaseTags: !!a.lowerCaseTags,
      quirksMode: !!a.quirksMode,
      cacheResults: !!a.cacheResults,
      pseudos: a.pseudos,
      adapter: a.adapter,
      equals: a.equals
    };
  }
  var c = function(a, u, h, m, f) {
    var d = f(u, l(h), m);
    return d === n.default.trueFunc ? a : d === n.default.falseFunc ? n.default.falseFunc : function(k) {
      return d(k) && a(k);
    };
  };
  e.subselects = {
    is: c,
    matches: c,
    where: c,
    not: function(a, u, h, m, f) {
      var d = f(u, l(h), m);
      return d === n.default.falseFunc ? a : d === n.default.trueFunc ? n.default.falseFunc : function(k) {
        return !d(k) && a(k);
      };
    },
    has: function(a, u, h, m, f) {
      var d = h.adapter, k = l(h);
      k.relativeSelector = !0;
      var b = u.some(function(g) {
        return g.some(o.isTraversal);
      }) ? [e.PLACEHOLDER_ELEMENT] : void 0, w = f(u, k, b);
      if (w === n.default.falseFunc)
        return n.default.falseFunc;
      var L = s(w, d);
      if (b && w !== n.default.trueFunc) {
        var A = w.shouldTestNextSiblings, C = A === void 0 ? !1 : A;
        return function(g) {
          if (!a(g))
            return !1;
          b[0] = g;
          var M = d.getChildren(g), P = C ? t(t([], M, !0), i(g, d), !0) : M;
          return d.existsOne(L, P);
        };
      }
      return function(g) {
        return a(g) && d.existsOne(L, d.getChildren(g));
      };
    }
  };
})(G8);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.compilePseudoSelector = e.aliases = e.pseudos = e.filters = void 0;
  var t = C7, r = oc;
  Object.defineProperty(e, "filters", { enumerable: !0, get: function() {
    return r.filters;
  } });
  var n = s2;
  Object.defineProperty(e, "pseudos", { enumerable: !0, get: function() {
    return n.pseudos;
  } });
  var o = H8;
  Object.defineProperty(e, "aliases", { enumerable: !0, get: function() {
    return o.aliases;
  } });
  var s = G8;
  function i(l, c, a, u, h) {
    var m, f = c.name, d = c.data;
    if (Array.isArray(d)) {
      if (!(f in s.subselects))
        throw new Error("Unknown pseudo-class :".concat(f, "(").concat(d, ")"));
      return s.subselects[f](l, d, a, u, h);
    }
    var k = (m = a.pseudos) === null || m === void 0 ? void 0 : m[f], b = typeof k == "string" ? k : o.aliases[f];
    if (typeof b == "string") {
      if (d != null)
        throw new Error("Pseudo ".concat(f, " doesn't have any arguments"));
      var w = (0, t.parse)(b);
      return s.subselects.is(l, w, a, u, h);
    }
    if (typeof k == "function")
      return (0, n.verifyPseudoArgs)(k, f, d, 1), function(A) {
        return k(A, d) && l(A);
      };
    if (f in r.filters)
      return r.filters[f](l, d, a, u);
    if (f in n.pseudos) {
      var L = n.pseudos[f];
      return (0, n.verifyPseudoArgs)(L, f, d, 2), function(A) {
        return L(A, a, d) && l(A);
      };
    }
    throw new Error("Unknown pseudo-class :".concat(f));
  }
  e.compilePseudoSelector = i;
})(L9);
Object.defineProperty(Z8, "__esModule", { value: !0 });
Z8.compileGeneralSelector = void 0;
var iO = q8, aO = L9, A1 = C7;
function V4(e, t) {
  var r = t.getParent(e);
  return r && t.isTag(r) ? r : null;
}
function lO(e, t, r, n, o) {
  var s = r.adapter, i = r.equals;
  switch (t.type) {
    case A1.SelectorType.PseudoElement:
      throw new Error("Pseudo-elements are not supported by css-select");
    case A1.SelectorType.ColumnCombinator:
      throw new Error("Column combinators are not yet supported by css-select");
    case A1.SelectorType.Attribute: {
      if (t.namespace != null)
        throw new Error("Namespaced attributes are not yet supported by css-select");
      return (!r.xmlMode || r.lowerCaseAttributeNames) && (t.name = t.name.toLowerCase()), iO.attributeRules[t.action](e, t, r);
    }
    case A1.SelectorType.Pseudo:
      return (0, aO.compilePseudoSelector)(e, t, r, n, o);
    case A1.SelectorType.Tag: {
      if (t.namespace != null)
        throw new Error("Namespaced tag names are not yet supported by css-select");
      var l = t.name;
      return (!r.xmlMode || r.lowerCaseTags) && (l = l.toLowerCase()), function(u) {
        return s.getName(u) === l && e(u);
      };
    }
    case A1.SelectorType.Descendant: {
      if (r.cacheResults === !1 || typeof WeakSet > "u")
        return function(u) {
          for (var h = u; h = V4(h, s); )
            if (e(h))
              return !0;
          return !1;
        };
      var c = /* @__PURE__ */ new WeakSet();
      return function(u) {
        for (var h = u; h = V4(h, s); )
          if (!c.has(h)) {
            if (s.isTag(h) && e(h))
              return !0;
            c.add(h);
          }
        return !1;
      };
    }
    case "_flexibleDescendant":
      return function(u) {
        var h = u;
        do
          if (e(h))
            return !0;
        while (h = V4(h, s));
        return !1;
      };
    case A1.SelectorType.Parent:
      return function(u) {
        return s.getChildren(u).some(function(h) {
          return s.isTag(h) && e(h);
        });
      };
    case A1.SelectorType.Child:
      return function(u) {
        var h = s.getParent(u);
        return h != null && s.isTag(h) && e(h);
      };
    case A1.SelectorType.Sibling:
      return function(u) {
        for (var h = s.getSiblings(u), m = 0; m < h.length; m++) {
          var f = h[m];
          if (i(u, f))
            break;
          if (s.isTag(f) && e(f))
            return !0;
        }
        return !1;
      };
    case A1.SelectorType.Adjacent:
      return s.prevElementSibling ? function(u) {
        var h = s.prevElementSibling(u);
        return h != null && e(h);
      } : function(u) {
        for (var h = s.getSiblings(u), m, f = 0; f < h.length; f++) {
          var d = h[f];
          if (i(u, d))
            break;
          s.isTag(d) && (m = d);
        }
        return !!m && e(m);
      };
    case A1.SelectorType.Universal: {
      if (t.namespace != null && t.namespace !== "*")
        throw new Error("Namespaced universal selectors are not yet supported by css-select");
      return e;
    }
  }
}
Z8.compileGeneralSelector = lO;
var cO = V && V.__createBinding || (Object.create ? function(e, t, r, n) {
  n === void 0 && (n = r);
  var o = Object.getOwnPropertyDescriptor(t, r);
  (!o || ("get" in o ? !t.__esModule : o.writable || o.configurable)) && (o = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, n, o);
} : function(e, t, r, n) {
  n === void 0 && (n = r), e[n] = t[r];
}), uO = V && V.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), hO = V && V.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var r in e)
      r !== "default" && Object.prototype.hasOwnProperty.call(e, r) && cO(t, e, r);
  return uO(t, e), t;
}, mO = V && V.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ee, "__esModule", { value: !0 });
Ee.compileToken = Ee.compileUnsafe = Ee.compile = void 0;
var ce = C7, Se = mO(m2), go = hO(f2), fO = Z8, ic = G8;
function dO(e, t, r) {
  var n = ac(e, t, r);
  return (0, ic.ensureIsTag)(n, t.adapter);
}
Ee.compile = dO;
function ac(e, t, r) {
  var n = typeof e == "string" ? (0, ce.parse)(e) : e;
  return z9(n, t, r);
}
Ee.compileUnsafe = ac;
function lc(e) {
  return e.type === ce.SelectorType.Pseudo && (e.name === "scope" || Array.isArray(e.data) && e.data.some(function(t) {
    return t.some(lc);
  }));
}
var pO = { type: ce.SelectorType.Descendant }, gO = {
  type: "_flexibleDescendant"
}, kO = {
  type: ce.SelectorType.Pseudo,
  name: "scope",
  data: null
};
function vO(e, t, r) {
  for (var n = t.adapter, o = !!(r != null && r.every(function(c) {
    var a = n.isTag(c) && n.getParent(c);
    return c === ic.PLACEHOLDER_ELEMENT || a && n.isTag(a);
  })), s = 0, i = e; s < i.length; s++) {
    var l = i[s];
    if (!(l.length > 0 && (0, go.isTraversal)(l[0]) && l[0].type !== ce.SelectorType.Descendant))
      if (o && !l.some(lc))
        l.unshift(pO);
      else
        continue;
    l.unshift(kO);
  }
}
function z9(e, t, r) {
  var n;
  e.forEach(go.default), r = (n = t.context) !== null && n !== void 0 ? n : r;
  var o = Array.isArray(r), s = r && (Array.isArray(r) ? r : [r]);
  if (t.relativeSelector !== !1)
    vO(e, t, s);
  else if (e.some(function(c) {
    return c.length > 0 && (0, go.isTraversal)(c[0]);
  }))
    throw new Error("Relative selectors are not allowed when the `relativeSelector` option is disabled");
  var i = !1, l = e.map(function(c) {
    if (c.length >= 2) {
      var a = c[0], u = c[1];
      a.type !== ce.SelectorType.Pseudo || a.name !== "scope" || (o && u.type === ce.SelectorType.Descendant ? c[1] = gO : (u.type === ce.SelectorType.Adjacent || u.type === ce.SelectorType.Sibling) && (i = !0));
    }
    return yO(c, t, s);
  }).reduce(bO, Se.default.falseFunc);
  return l.shouldTestNextSiblings = i, l;
}
Ee.compileToken = z9;
function yO(e, t, r) {
  var n;
  return e.reduce(function(o, s) {
    return o === Se.default.falseFunc ? Se.default.falseFunc : (0, fO.compileGeneralSelector)(o, s, t, r, z9);
  }, (n = t.rootFunc) !== null && n !== void 0 ? n : Se.default.trueFunc);
}
function bO(e, t) {
  return t === Se.default.falseFunc || e === Se.default.trueFunc ? e : e === Se.default.falseFunc || t === Se.default.trueFunc ? t : function(n) {
    return e(n) || t(n);
  };
}
(function(e) {
  var t = V && V.__createBinding || (Object.create ? function(L, A, C, g) {
    g === void 0 && (g = C);
    var M = Object.getOwnPropertyDescriptor(A, C);
    (!M || ("get" in M ? !A.__esModule : M.writable || M.configurable)) && (M = { enumerable: !0, get: function() {
      return A[C];
    } }), Object.defineProperty(L, g, M);
  } : function(L, A, C, g) {
    g === void 0 && (g = C), L[g] = A[C];
  }), r = V && V.__setModuleDefault || (Object.create ? function(L, A) {
    Object.defineProperty(L, "default", { enumerable: !0, value: A });
  } : function(L, A) {
    L.default = A;
  }), n = V && V.__importStar || function(L) {
    if (L && L.__esModule)
      return L;
    var A = {};
    if (L != null)
      for (var C in L)
        C !== "default" && Object.prototype.hasOwnProperty.call(L, C) && t(A, L, C);
    return r(A, L), A;
  }, o = V && V.__importDefault || function(L) {
    return L && L.__esModule ? L : { default: L };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.aliases = e.pseudos = e.filters = e.is = e.selectOne = e.selectAll = e.prepareContext = e._compileToken = e._compileUnsafe = e.compile = void 0;
  var s = n(Ll), i = o(m2), l = Ee, c = G8, a = function(L, A) {
    return L === A;
  }, u = {
    adapter: s,
    equals: a
  };
  function h(L) {
    var A, C, g, M, P = L != null ? L : u;
    return (A = P.adapter) !== null && A !== void 0 || (P.adapter = s), (C = P.equals) !== null && C !== void 0 || (P.equals = (M = (g = P.adapter) === null || g === void 0 ? void 0 : g.equals) !== null && M !== void 0 ? M : a), P;
  }
  function m(L) {
    return function(C, g, M) {
      var P = h(g);
      return L(C, P, M);
    };
  }
  e.compile = m(l.compile), e._compileUnsafe = m(l.compileUnsafe), e._compileToken = m(l.compileToken);
  function f(L) {
    return function(C, g, M) {
      var P = h(M);
      typeof C != "function" && (C = (0, l.compileUnsafe)(C, P, g));
      var x = d(g, P.adapter, C.shouldTestNextSiblings);
      return L(C, x, P);
    };
  }
  function d(L, A, C) {
    return C === void 0 && (C = !1), C && (L = k(L, A)), Array.isArray(L) ? A.removeSubsets(L) : A.getChildren(L);
  }
  e.prepareContext = d;
  function k(L, A) {
    for (var C = Array.isArray(L) ? L.slice(0) : [L], g = C.length, M = 0; M < g; M++) {
      var P = (0, c.getNextSiblings)(C[M], A);
      C.push.apply(C, P);
    }
    return C;
  }
  e.selectAll = f(function(L, A, C) {
    return L === i.default.falseFunc || !A || A.length === 0 ? [] : C.adapter.findAll(L, A);
  }), e.selectOne = f(function(L, A, C) {
    return L === i.default.falseFunc || !A || A.length === 0 ? null : C.adapter.findOne(L, A);
  });
  function b(L, A, C) {
    var g = h(C);
    return (typeof A == "function" ? A : (0, l.compile)(A, g))(L);
  }
  e.is = b, e.default = e.selectAll;
  var w = L9;
  Object.defineProperty(e, "filters", { enumerable: !0, get: function() {
    return w.filters;
  } }), Object.defineProperty(e, "pseudos", { enumerable: !0, get: function() {
    return w.pseudos;
  } }), Object.defineProperty(e, "aliases", { enumerable: !0, get: function() {
    return w.aliases;
  } });
})(wl);
const W8 = (e) => e.type === "element", cc = (e, t) => t.some((r) => W8(r) ? e(r) || cc(e, S7(r)) : !1), xO = (e, t) => e.attributes[t], S7 = (e) => e.children || [], wO = (e) => e.name, C9 = (e) => e.parentNode || null, LO = (e) => {
  var t = C9(e);
  return t ? S7(t) : [];
}, zO = (e) => e.children[0].type === "text" && e.children[0].type === "cdata" ? e.children[0].value : "", CO = (e, t) => e.attributes[t] !== void 0, SO = (e) => {
  let t = e.length, r, n, o;
  for (; --t > -1; ) {
    for (r = n = e[t], e[t] = null, o = !0; n; ) {
      if (e.includes(n)) {
        o = !1, e.splice(t, 1);
        break;
      }
      n = C9(n);
    }
    o && (e[t] = r);
  }
  return e;
}, uc = (e, t) => {
  const r = [];
  for (const n of t)
    W8(n) && (e(n) && r.push(n), r.push(...uc(e, S7(n))));
  return r;
}, hc = (e, t) => {
  for (const r of t)
    if (W8(r)) {
      if (e(r))
        return r;
      const n = hc(e, S7(r));
      if (n)
        return n;
    }
  return null;
}, $O = {
  isTag: W8,
  existsOne: cc,
  getAttributeValue: xO,
  getChildren: S7,
  getName: wO,
  getParent: C9,
  getSiblings: LO,
  getText: zO,
  hasAttrib: CO,
  removeSubsets: SO,
  findAll: uc,
  findOne: hc
};
var AO = $O;
const { selectAll: MO, selectOne: jO, is: EO } = wl, TO = AO, S9 = {
  xmlMode: !0,
  adapter: TO
}, PO = (e, t) => MO(t, e, S9);
a0.querySelectorAll = PO;
const NO = (e, t) => jO(t, e, S9);
a0.querySelector = NO;
const DO = (e, t) => EO(e, t, S9);
a0.matches = DO;
const mc = Symbol();
a0.visitSkip = mc;
const ko = (e, t, r) => {
  const n = t[e.type];
  if (!(n && n.enter && n.enter(e, r) === mc)) {
    if (e.type === "root")
      for (const o of e.children)
        ko(o, t, e);
    if (e.type === "element" && r.children.includes(e))
      for (const o of e.children)
        ko(o, t, e);
    n && n.exit && n.exit(e, r);
  }
};
a0.visit = ko;
const OO = (e, t) => {
  t.children = t.children.filter((r) => r !== e);
};
a0.detachNodeFromParent = OO;
const { visit: RO } = a0, fc = (e, t, r, n, o) => {
  for (const s of r) {
    const i = n == null ? void 0 : n[s.name];
    if (i === !1)
      continue;
    const l = { ...s.params, ...o, ...i }, c = s.fn(e, l, t);
    c != null && RO(e, c);
  }
};
D8.invokePlugins = fc;
const IO = ({ name: e, plugins: t }) => ({
  name: e,
  fn: (r, n, o) => {
    const { floatPrecision: s, overrides: i } = n, l = {};
    if (s != null && (l.floatPrecision = s), i) {
      const c = t.map(({ name: a }) => a);
      for (const a of Object.keys(i))
        c.includes(a) || console.warn(
          `You are trying to configure ${a} which is not part of ${e}.
Try to put it before or after, for example

plugins: [
  {
    name: '${e}',
  },
  '${a}'
]
`
        );
    }
    fc(r, o, t, i, l);
  }
});
D8.createPreset = IO;
var $7 = {};
const { detachNodeFromParent: _O } = a0;
$7.name = "removeDoctype";
$7.description = "removes doctype declaration";
$7.fn = () => ({
  doctype: {
    enter: (e, t) => {
      _O(e, t);
    }
  }
});
var A7 = {};
const { detachNodeFromParent: FO } = a0;
A7.name = "removeXMLProcInst";
A7.description = "removes XML processing instructions";
A7.fn = () => ({
  instruction: {
    enter: (e, t) => {
      e.name === "xml" && FO(e, t);
    }
  }
});
var M7 = {};
const { detachNodeFromParent: BO } = a0;
M7.name = "removeComments";
M7.description = "removes comments";
const ZO = [/^!/];
M7.fn = (e, t) => {
  const { preservePatterns: r = ZO } = t;
  return {
    comment: {
      enter: (n, o) => {
        if (r) {
          if (!Array.isArray(r))
            throw Error(
              `Expected array in removeComments preservePatterns parameter but received ${r}`
            );
          if (r.some((i) => new RegExp(i).test(n.value)))
            return;
        }
        BO(n, o);
      }
    }
  };
};
var j7 = {};
const { detachNodeFromParent: qO } = a0;
j7.name = "removeMetadata";
j7.description = "removes <metadata>";
j7.fn = () => ({
  element: {
    enter: (e, t) => {
      e.name === "metadata" && qO(e, t);
    }
  }
});
var E7 = {};
const { detachNodeFromParent: UO } = a0, { editorNamespaces: fs } = C0;
E7.name = "removeEditorsNSData";
E7.description = "removes editors namespaces, elements and attributes";
E7.fn = (e, t) => {
  let r = fs;
  Array.isArray(t.additionalNamespaces) && (r = [...fs, ...t.additionalNamespaces]);
  const n = [];
  return {
    element: {
      enter: (o, s) => {
        if (o.name === "svg")
          for (const [i, l] of Object.entries(o.attributes))
            i.startsWith("xmlns:") && r.includes(l) && (n.push(i.slice(6)), delete o.attributes[i]);
        for (const i of Object.keys(o.attributes))
          if (i.includes(":")) {
            const [l] = i.split(":");
            n.includes(l) && delete o.attributes[i];
          }
        if (o.name.includes(":")) {
          const [i] = o.name.split(":");
          n.includes(i) && UO(o, s);
        }
      }
    }
  };
};
var T7 = {};
T7.name = "cleanupAttrs";
T7.description = "cleanups attributes from newlines, trailing and repeating spaces";
const HO = /(\S)\r?\n(\S)/g, GO = /\r?\n/g, WO = /\s{2,}/g;
T7.fn = (e, t) => {
  const { newlines: r = !0, trim: n = !0, spaces: o = !0 } = t;
  return {
    element: {
      enter: (s) => {
        for (const i of Object.keys(s.attributes))
          r && (s.attributes[i] = s.attributes[i].replace(
            HO,
            (l, c, a) => c + " " + a
          ), s.attributes[i] = s.attributes[i].replace(
            GO,
            ""
          )), n && (s.attributes[i] = s.attributes[i].trim()), o && (s.attributes[i] = s.attributes[i].replace(
            WO,
            " "
          ));
      }
    }
  };
};
var P7 = {};
const { visitSkip: VO, detachNodeFromParent: ds } = a0;
P7.name = "mergeStyles";
P7.description = "merge multiple style elements into one";
P7.fn = () => {
  let e = null, t = "", r = "text";
  return {
    element: {
      enter: (n, o) => {
        if (n.name === "foreignObject")
          return VO;
        if (n.name !== "style" || n.attributes.type != null && n.attributes.type !== "" && n.attributes.type !== "text/css")
          return;
        let s = "";
        for (const i of n.children)
          i.type === "text" && (s += i.value), i.type === "cdata" && (r = "cdata", s += i.value);
        if (s.trim().length === 0) {
          ds(n, o);
          return;
        }
        if (n.attributes.media == null ? t += s : (t += `@media ${n.attributes.media}{${s}}`, delete n.attributes.media), e == null)
          e = n;
        else {
          ds(n, o);
          const i = { type: r, value: t };
          Object.defineProperty(i, "parentNode", {
            writable: !0,
            value: e
          }), e.children = [i];
        }
      }
    }
  };
};
var N7 = {}, d0 = {}, Z = {}, R = {};
const XO = 0, YO = 1, KO = 2, QO = 3, JO = 4, eR = 5, tR = 6, rR = 7, nR = 8, oR = 9, sR = 10, iR = 11, aR = 12, lR = 13, cR = 14, uR = 15, hR = 16, mR = 17, fR = 18, dR = 19, pR = 20, gR = 21, kR = 22, vR = 23, yR = 24, bR = 25;
R.AtKeyword = QO;
R.BadString = tR;
R.BadUrl = nR;
R.CDC = uR;
R.CDO = cR;
R.Colon = hR;
R.Comma = fR;
R.Comment = bR;
R.Delim = oR;
R.Dimension = aR;
R.EOF = XO;
R.Function = KO;
R.Hash = JO;
R.Ident = YO;
R.LeftCurlyBracket = vR;
R.LeftParenthesis = gR;
R.LeftSquareBracket = dR;
R.Number = sR;
R.Percentage = iR;
R.RightCurlyBracket = yR;
R.RightParenthesis = kR;
R.RightSquareBracket = pR;
R.Semicolon = mR;
R.String = eR;
R.Url = rR;
R.WhiteSpace = lR;
var h0 = {};
const xR = 0;
function $e(e) {
  return e >= 48 && e <= 57;
}
function wR(e) {
  return $e(e) || e >= 65 && e <= 70 || e >= 97 && e <= 102;
}
function dc(e) {
  return e >= 65 && e <= 90;
}
function pc(e) {
  return e >= 97 && e <= 122;
}
function gc(e) {
  return dc(e) || pc(e);
}
function kc(e) {
  return e >= 128;
}
function f7(e) {
  return gc(e) || kc(e) || e === 95;
}
function LR(e) {
  return f7(e) || $e(e) || e === 45;
}
function vc(e) {
  return e >= 0 && e <= 8 || e === 11 || e >= 14 && e <= 31 || e === 127;
}
function $9(e) {
  return e === 10 || e === 13 || e === 12;
}
function yc(e) {
  return $9(e) || e === 32 || e === 9;
}
function vo(e, t) {
  return !(e !== 92 || $9(t) || t === xR);
}
function zR(e, t, r) {
  return e === 45 ? f7(t) || t === 45 || vo(t, r) : f7(e) ? !0 : e === 92 ? vo(e, t) : !1;
}
function CR(e, t, r) {
  return e === 43 || e === 45 ? $e(t) ? 2 : t === 46 && $e(r) ? 3 : 0 : e === 46 ? $e(t) ? 2 : 0 : $e(e) ? 1 : 0;
}
function SR(e) {
  return e === 65279 || e === 65534 ? 1 : 0;
}
const yo = new Array(128), bc = 128, xc = 130, wc = 131, A9 = 132, Lc = 133;
for (let e = 0; e < yo.length; e++)
  yo[e] = yc(e) && xc || $e(e) && wc || f7(e) && A9 || vc(e) && Lc || e || bc;
function $R(e) {
  return e < 128 ? yo[e] : A9;
}
h0.DigitCategory = wc;
h0.EofCategory = bc;
h0.NameStartCategory = A9;
h0.NonPrintableCategory = Lc;
h0.WhiteSpaceCategory = xc;
h0.charCodeCategory = $R;
h0.isBOM = SR;
h0.isDigit = $e;
h0.isHexDigit = wR;
h0.isIdentifierStart = zR;
h0.isLetter = gc;
h0.isLowercaseLetter = pc;
h0.isName = LR;
h0.isNameStart = f7;
h0.isNewline = $9;
h0.isNonAscii = kc;
h0.isNonPrintable = vc;
h0.isNumberStart = CR;
h0.isUppercaseLetter = dc;
h0.isValidEscape = vo;
h0.isWhiteSpace = yc;
var T0 = {};
const X0 = h0;
function Qt(e, t) {
  return t < e.length ? e.charCodeAt(t) : 0;
}
function zc(e, t, r) {
  return r === 13 && Qt(e, t + 1) === 10 ? 2 : 1;
}
function Cc(e, t, r) {
  let n = e.charCodeAt(t);
  return X0.isUppercaseLetter(n) && (n = n | 32), n === r;
}
function AR(e, t, r, n) {
  if (r - t !== n.length || t < 0 || r > e.length)
    return !1;
  for (let o = t; o < r; o++) {
    const s = n.charCodeAt(o - t);
    let i = e.charCodeAt(o);
    if (X0.isUppercaseLetter(i) && (i = i | 32), i !== s)
      return !1;
  }
  return !0;
}
function MR(e, t) {
  for (; t >= 0 && X0.isWhiteSpace(e.charCodeAt(t)); t--)
    ;
  return t + 1;
}
function jR(e, t) {
  for (; t < e.length && X0.isWhiteSpace(e.charCodeAt(t)); t++)
    ;
  return t;
}
function Hr(e, t) {
  for (; t < e.length && X0.isDigit(e.charCodeAt(t)); t++)
    ;
  return t;
}
function M9(e, t) {
  if (t += 2, X0.isHexDigit(Qt(e, t - 1))) {
    for (const n = Math.min(e.length, t + 5); t < n && X0.isHexDigit(Qt(e, t)); t++)
      ;
    const r = Qt(e, t);
    X0.isWhiteSpace(r) && (t += zc(e, t, r));
  }
  return t;
}
function ER(e, t) {
  for (; t < e.length; t++) {
    const r = e.charCodeAt(t);
    if (!X0.isName(r)) {
      if (X0.isValidEscape(r, Qt(e, t + 1))) {
        t = M9(e, t) - 1;
        continue;
      }
      break;
    }
  }
  return t;
}
function TR(e, t) {
  let r = e.charCodeAt(t);
  if ((r === 43 || r === 45) && (r = e.charCodeAt(t += 1)), X0.isDigit(r) && (t = Hr(e, t + 1), r = e.charCodeAt(t)), r === 46 && X0.isDigit(e.charCodeAt(t + 1)) && (t += 2, t = Hr(e, t)), Cc(e, t, 101)) {
    let n = 0;
    r = e.charCodeAt(t + 1), (r === 45 || r === 43) && (n = 1, r = e.charCodeAt(t + 2)), X0.isDigit(r) && (t = Hr(e, t + 1 + n + 1));
  }
  return t;
}
function PR(e, t) {
  for (; t < e.length; t++) {
    const r = e.charCodeAt(t);
    if (r === 41) {
      t++;
      break;
    }
    X0.isValidEscape(r, Qt(e, t + 1)) && (t = M9(e, t));
  }
  return t;
}
function NR(e) {
  if (e.length === 1 && !X0.isHexDigit(e.charCodeAt(0)))
    return e[0];
  let t = parseInt(e, 16);
  return (t === 0 || t >= 55296 && t <= 57343 || t > 1114111) && (t = 65533), String.fromCodePoint(t);
}
T0.cmpChar = Cc;
T0.cmpStr = AR;
T0.consumeBadUrlRemnants = PR;
T0.consumeEscaped = M9;
T0.consumeName = ER;
T0.consumeNumber = TR;
T0.decodeEscaped = NR;
T0.findDecimalNumberEnd = Hr;
T0.findWhiteSpaceEnd = jR;
T0.findWhiteSpaceStart = MR;
T0.getNewlineLength = zc;
const DR = [
  "EOF-token",
  "ident-token",
  "function-token",
  "at-keyword-token",
  "hash-token",
  "string-token",
  "bad-string-token",
  "url-token",
  "bad-url-token",
  "delim-token",
  "number-token",
  "percentage-token",
  "dimension-token",
  "whitespace-token",
  "CDO-token",
  "CDC-token",
  "colon-token",
  "semicolon-token",
  "comma-token",
  "[-token",
  "]-token",
  "(-token",
  ")-token",
  "{-token",
  "}-token"
];
var V8 = DR, j9 = {}, E9 = {};
const OR = 16 * 1024;
function RR(e = null, t) {
  return e === null || e.length < t ? new Uint32Array(Math.max(t + 1024, OR)) : e;
}
E9.adoptBuffer = RR;
const ps = E9, IR = h0, gs = 10, _R = 12, ks = 13;
function vs(e) {
  const t = e.source, r = t.length, n = t.length > 0 ? IR.isBOM(t.charCodeAt(0)) : 0, o = ps.adoptBuffer(e.lines, r), s = ps.adoptBuffer(e.columns, r);
  let i = e.startLine, l = e.startColumn;
  for (let c = n; c < r; c++) {
    const a = t.charCodeAt(c);
    o[c] = i, s[c] = l++, (a === gs || a === ks || a === _R) && (a === ks && c + 1 < r && t.charCodeAt(c + 1) === gs && (c++, o[c] = i, s[c] = l), i++, l = 1);
  }
  o[r] = i, s[r] = l, e.lines = o, e.columns = s, e.computed = !0;
}
class FR {
  constructor() {
    this.lines = null, this.columns = null, this.computed = !1;
  }
  setSource(t, r = 0, n = 1, o = 1) {
    this.source = t, this.startOffset = r, this.startLine = n, this.startColumn = o, this.computed = !1;
  }
  getLocation(t, r) {
    return this.computed || vs(this), {
      source: r,
      offset: this.startOffset + t,
      line: this.lines[t],
      column: this.columns[t]
    };
  }
  getLocationRange(t, r, n) {
    return this.computed || vs(this), {
      source: n,
      start: {
        offset: this.startOffset + t,
        line: this.lines[t],
        column: this.columns[t]
      },
      end: {
        offset: this.startOffset + r,
        line: this.lines[r],
        column: this.columns[r]
      }
    };
  }
}
j9.OffsetToLocation = FR;
var X8 = {};
const ys = E9, BR = T0, ZR = V8, D0 = R, p1 = 16777215, ge = 24, qR = /* @__PURE__ */ new Map([
  [D0.Function, D0.RightParenthesis],
  [D0.LeftParenthesis, D0.RightParenthesis],
  [D0.LeftSquareBracket, D0.RightSquareBracket],
  [D0.LeftCurlyBracket, D0.RightCurlyBracket]
]);
class UR {
  constructor(t, r) {
    this.setSource(t, r);
  }
  reset() {
    this.eof = !1, this.tokenIndex = -1, this.tokenType = 0, this.tokenStart = this.firstCharOffset, this.tokenEnd = this.firstCharOffset;
  }
  setSource(t = "", r = () => {
  }) {
    t = String(t || "");
    const n = t.length, o = ys.adoptBuffer(this.offsetAndType, t.length + 1), s = ys.adoptBuffer(this.balance, t.length + 1);
    let i = 0, l = 0, c = 0, a = -1;
    for (this.offsetAndType = null, this.balance = null, r(t, (u, h, m) => {
      switch (u) {
        default:
          s[i] = n;
          break;
        case l: {
          let f = c & p1;
          for (c = s[f], l = c >> ge, s[i] = f, s[f++] = i; f < i; f++)
            s[f] === n && (s[f] = i);
          break;
        }
        case D0.LeftParenthesis:
        case D0.Function:
        case D0.LeftSquareBracket:
        case D0.LeftCurlyBracket:
          s[i] = c, l = qR.get(u), c = l << ge | i;
          break;
      }
      o[i++] = u << ge | m, a === -1 && (a = h);
    }), o[i] = D0.EOF << ge | n, s[i] = n, s[n] = n; c !== 0; ) {
      const u = c & p1;
      c = s[u], s[u] = n;
    }
    this.source = t, this.firstCharOffset = a === -1 ? 0 : a, this.tokenCount = i, this.offsetAndType = o, this.balance = s, this.reset(), this.next();
  }
  lookupType(t) {
    return t += this.tokenIndex, t < this.tokenCount ? this.offsetAndType[t] >> ge : D0.EOF;
  }
  lookupOffset(t) {
    return t += this.tokenIndex, t < this.tokenCount ? this.offsetAndType[t - 1] & p1 : this.source.length;
  }
  lookupValue(t, r) {
    return t += this.tokenIndex, t < this.tokenCount ? BR.cmpStr(
      this.source,
      this.offsetAndType[t - 1] & p1,
      this.offsetAndType[t] & p1,
      r
    ) : !1;
  }
  getTokenStart(t) {
    return t === this.tokenIndex ? this.tokenStart : t > 0 ? t < this.tokenCount ? this.offsetAndType[t - 1] & p1 : this.offsetAndType[this.tokenCount] & p1 : this.firstCharOffset;
  }
  substrToCursor(t) {
    return this.source.substring(t, this.tokenStart);
  }
  isBalanceEdge(t) {
    return this.balance[this.tokenIndex] < t;
  }
  isDelim(t, r) {
    return r ? this.lookupType(r) === D0.Delim && this.source.charCodeAt(this.lookupOffset(r)) === t : this.tokenType === D0.Delim && this.source.charCodeAt(this.tokenStart) === t;
  }
  skip(t) {
    let r = this.tokenIndex + t;
    r < this.tokenCount ? (this.tokenIndex = r, this.tokenStart = this.offsetAndType[r - 1] & p1, r = this.offsetAndType[r], this.tokenType = r >> ge, this.tokenEnd = r & p1) : (this.tokenIndex = this.tokenCount, this.next());
  }
  next() {
    let t = this.tokenIndex + 1;
    t < this.tokenCount ? (this.tokenIndex = t, this.tokenStart = this.tokenEnd, t = this.offsetAndType[t], this.tokenType = t >> ge, this.tokenEnd = t & p1) : (this.eof = !0, this.tokenIndex = this.tokenCount, this.tokenType = D0.EOF, this.tokenStart = this.tokenEnd = this.source.length);
  }
  skipSC() {
    for (; this.tokenType === D0.WhiteSpace || this.tokenType === D0.Comment; )
      this.next();
  }
  skipUntilBalanced(t, r) {
    let n = t, o, s;
    e:
      for (; n < this.tokenCount; n++) {
        if (o = this.balance[n], o < t)
          break e;
        switch (s = n > 0 ? this.offsetAndType[n - 1] & p1 : this.firstCharOffset, r(this.source.charCodeAt(s))) {
          case 1:
            break e;
          case 2:
            n++;
            break e;
          default:
            this.balance[o] === n && (n = o);
        }
      }
    this.skip(n - this.tokenIndex);
  }
  forEachToken(t) {
    for (let r = 0, n = this.firstCharOffset; r < this.tokenCount; r++) {
      const o = n, s = this.offsetAndType[r], i = s & p1, l = s >> ge;
      n = i, t(l, o, i, r);
    }
  }
  dump() {
    const t = new Array(this.tokenCount);
    return this.forEachToken((r, n, o, s) => {
      t[s] = {
        idx: s,
        type: ZR[r],
        chunk: this.source.substring(n, o),
        balance: this.balance[s]
      };
    }), t;
  }
}
X8.TokenStream = UR;
const H = R, J = h0, g0 = T0, HR = V8, GR = j9, WR = X8;
function VR(e, t) {
  function r(h) {
    return h < l ? e.charCodeAt(h) : 0;
  }
  function n() {
    if (a = g0.consumeNumber(e, a), J.isIdentifierStart(r(a), r(a + 1), r(a + 2))) {
      u = H.Dimension, a = g0.consumeName(e, a);
      return;
    }
    if (r(a) === 37) {
      u = H.Percentage, a++;
      return;
    }
    u = H.Number;
  }
  function o() {
    const h = a;
    if (a = g0.consumeName(e, a), g0.cmpStr(e, h, a, "url") && r(a) === 40) {
      if (a = g0.findWhiteSpaceEnd(e, a + 1), r(a) === 34 || r(a) === 39) {
        u = H.Function, a = h + 4;
        return;
      }
      i();
      return;
    }
    if (r(a) === 40) {
      u = H.Function, a++;
      return;
    }
    u = H.Ident;
  }
  function s(h) {
    for (h || (h = r(a++)), u = H.String; a < e.length; a++) {
      const m = e.charCodeAt(a);
      switch (J.charCodeCategory(m)) {
        case h:
          a++;
          return;
        case J.WhiteSpaceCategory:
          if (J.isNewline(m)) {
            a += g0.getNewlineLength(e, a, m), u = H.BadString;
            return;
          }
          break;
        case 92:
          if (a === e.length - 1)
            break;
          const f = r(a + 1);
          J.isNewline(f) ? a += g0.getNewlineLength(e, a + 1, f) : J.isValidEscape(m, f) && (a = g0.consumeEscaped(e, a) - 1);
          break;
      }
    }
  }
  function i() {
    for (u = H.Url, a = g0.findWhiteSpaceEnd(e, a); a < e.length; a++) {
      const h = e.charCodeAt(a);
      switch (J.charCodeCategory(h)) {
        case 41:
          a++;
          return;
        case J.WhiteSpaceCategory:
          if (a = g0.findWhiteSpaceEnd(e, a), r(a) === 41 || a >= e.length) {
            a < e.length && a++;
            return;
          }
          a = g0.consumeBadUrlRemnants(e, a), u = H.BadUrl;
          return;
        case 34:
        case 39:
        case 40:
        case J.NonPrintableCategory:
          a = g0.consumeBadUrlRemnants(e, a), u = H.BadUrl;
          return;
        case 92:
          if (J.isValidEscape(h, r(a + 1))) {
            a = g0.consumeEscaped(e, a) - 1;
            break;
          }
          a = g0.consumeBadUrlRemnants(e, a), u = H.BadUrl;
          return;
      }
    }
  }
  e = String(e || "");
  const l = e.length;
  let c = J.isBOM(r(0)), a = c, u;
  for (; a < l; ) {
    const h = e.charCodeAt(a);
    switch (J.charCodeCategory(h)) {
      case J.WhiteSpaceCategory:
        u = H.WhiteSpace, a = g0.findWhiteSpaceEnd(e, a + 1);
        break;
      case 34:
        s();
        break;
      case 35:
        J.isName(r(a + 1)) || J.isValidEscape(r(a + 1), r(a + 2)) ? (u = H.Hash, a = g0.consumeName(e, a + 1)) : (u = H.Delim, a++);
        break;
      case 39:
        s();
        break;
      case 40:
        u = H.LeftParenthesis, a++;
        break;
      case 41:
        u = H.RightParenthesis, a++;
        break;
      case 43:
        J.isNumberStart(h, r(a + 1), r(a + 2)) ? n() : (u = H.Delim, a++);
        break;
      case 44:
        u = H.Comma, a++;
        break;
      case 45:
        J.isNumberStart(h, r(a + 1), r(a + 2)) ? n() : r(a + 1) === 45 && r(a + 2) === 62 ? (u = H.CDC, a = a + 3) : J.isIdentifierStart(h, r(a + 1), r(a + 2)) ? o() : (u = H.Delim, a++);
        break;
      case 46:
        J.isNumberStart(h, r(a + 1), r(a + 2)) ? n() : (u = H.Delim, a++);
        break;
      case 47:
        r(a + 1) === 42 ? (u = H.Comment, a = e.indexOf("*/", a + 2), a = a === -1 ? e.length : a + 2) : (u = H.Delim, a++);
        break;
      case 58:
        u = H.Colon, a++;
        break;
      case 59:
        u = H.Semicolon, a++;
        break;
      case 60:
        r(a + 1) === 33 && r(a + 2) === 45 && r(a + 3) === 45 ? (u = H.CDO, a = a + 4) : (u = H.Delim, a++);
        break;
      case 64:
        J.isIdentifierStart(r(a + 1), r(a + 2), r(a + 3)) ? (u = H.AtKeyword, a = g0.consumeName(e, a + 1)) : (u = H.Delim, a++);
        break;
      case 91:
        u = H.LeftSquareBracket, a++;
        break;
      case 92:
        J.isValidEscape(h, r(a + 1)) ? o() : (u = H.Delim, a++);
        break;
      case 93:
        u = H.RightSquareBracket, a++;
        break;
      case 123:
        u = H.LeftCurlyBracket, a++;
        break;
      case 125:
        u = H.RightCurlyBracket, a++;
        break;
      case J.DigitCategory:
        n();
        break;
      case J.NameStartCategory:
        o();
        break;
      default:
        u = H.Delim, a++;
    }
    t(u, c, c = a);
  }
}
Z.AtKeyword = H.AtKeyword;
Z.BadString = H.BadString;
Z.BadUrl = H.BadUrl;
Z.CDC = H.CDC;
Z.CDO = H.CDO;
Z.Colon = H.Colon;
Z.Comma = H.Comma;
Z.Comment = H.Comment;
Z.Delim = H.Delim;
Z.Dimension = H.Dimension;
Z.EOF = H.EOF;
Z.Function = H.Function;
Z.Hash = H.Hash;
Z.Ident = H.Ident;
Z.LeftCurlyBracket = H.LeftCurlyBracket;
Z.LeftParenthesis = H.LeftParenthesis;
Z.LeftSquareBracket = H.LeftSquareBracket;
Z.Number = H.Number;
Z.Percentage = H.Percentage;
Z.RightCurlyBracket = H.RightCurlyBracket;
Z.RightParenthesis = H.RightParenthesis;
Z.RightSquareBracket = H.RightSquareBracket;
Z.Semicolon = H.Semicolon;
Z.String = H.String;
Z.Url = H.Url;
Z.WhiteSpace = H.WhiteSpace;
Z.tokenTypes = H;
Z.DigitCategory = J.DigitCategory;
Z.EofCategory = J.EofCategory;
Z.NameStartCategory = J.NameStartCategory;
Z.NonPrintableCategory = J.NonPrintableCategory;
Z.WhiteSpaceCategory = J.WhiteSpaceCategory;
Z.charCodeCategory = J.charCodeCategory;
Z.isBOM = J.isBOM;
Z.isDigit = J.isDigit;
Z.isHexDigit = J.isHexDigit;
Z.isIdentifierStart = J.isIdentifierStart;
Z.isLetter = J.isLetter;
Z.isLowercaseLetter = J.isLowercaseLetter;
Z.isName = J.isName;
Z.isNameStart = J.isNameStart;
Z.isNewline = J.isNewline;
Z.isNonAscii = J.isNonAscii;
Z.isNonPrintable = J.isNonPrintable;
Z.isNumberStart = J.isNumberStart;
Z.isUppercaseLetter = J.isUppercaseLetter;
Z.isValidEscape = J.isValidEscape;
Z.isWhiteSpace = J.isWhiteSpace;
Z.cmpChar = g0.cmpChar;
Z.cmpStr = g0.cmpStr;
Z.consumeBadUrlRemnants = g0.consumeBadUrlRemnants;
Z.consumeEscaped = g0.consumeEscaped;
Z.consumeName = g0.consumeName;
Z.consumeNumber = g0.consumeNumber;
Z.decodeEscaped = g0.decodeEscaped;
Z.findDecimalNumberEnd = g0.findDecimalNumberEnd;
Z.findWhiteSpaceEnd = g0.findWhiteSpaceEnd;
Z.findWhiteSpaceStart = g0.findWhiteSpaceStart;
Z.getNewlineLength = g0.getNewlineLength;
Z.tokenNames = HR;
Z.OffsetToLocation = GR.OffsetToLocation;
Z.TokenStream = WR.TokenStream;
Z.tokenize = VR;
var Sc = {}, rt = {};
let jt = null;
class x1 {
  static createItem(t) {
    return {
      prev: null,
      next: null,
      data: t
    };
  }
  constructor() {
    this.head = null, this.tail = null, this.cursor = null;
  }
  createItem(t) {
    return x1.createItem(t);
  }
  allocateCursor(t, r) {
    let n;
    return jt !== null ? (n = jt, jt = jt.cursor, n.prev = t, n.next = r, n.cursor = this.cursor) : n = {
      prev: t,
      next: r,
      cursor: this.cursor
    }, this.cursor = n, n;
  }
  releaseCursor() {
    const { cursor: t } = this;
    this.cursor = t.cursor, t.prev = null, t.next = null, t.cursor = jt, jt = t;
  }
  updateCursors(t, r, n, o) {
    let { cursor: s } = this;
    for (; s !== null; )
      s.prev === t && (s.prev = r), s.next === n && (s.next = o), s = s.cursor;
  }
  *[Symbol.iterator]() {
    for (let t = this.head; t !== null; t = t.next)
      yield t.data;
  }
  get size() {
    let t = 0;
    for (let r = this.head; r !== null; r = r.next)
      t++;
    return t;
  }
  get isEmpty() {
    return this.head === null;
  }
  get first() {
    return this.head && this.head.data;
  }
  get last() {
    return this.tail && this.tail.data;
  }
  fromArray(t) {
    let r = null;
    this.head = null;
    for (let n of t) {
      const o = x1.createItem(n);
      r !== null ? r.next = o : this.head = o, o.prev = r, r = o;
    }
    return this.tail = r, this;
  }
  toArray() {
    return [...this];
  }
  toJSON() {
    return [...this];
  }
  forEach(t, r = this) {
    const n = this.allocateCursor(null, this.head);
    for (; n.next !== null; ) {
      const o = n.next;
      n.next = o.next, t.call(r, o.data, o, this);
    }
    this.releaseCursor();
  }
  forEachRight(t, r = this) {
    const n = this.allocateCursor(this.tail, null);
    for (; n.prev !== null; ) {
      const o = n.prev;
      n.prev = o.prev, t.call(r, o.data, o, this);
    }
    this.releaseCursor();
  }
  reduce(t, r, n = this) {
    let o = this.allocateCursor(null, this.head), s = r, i;
    for (; o.next !== null; )
      i = o.next, o.next = i.next, s = t.call(n, s, i.data, i, this);
    return this.releaseCursor(), s;
  }
  reduceRight(t, r, n = this) {
    let o = this.allocateCursor(this.tail, null), s = r, i;
    for (; o.prev !== null; )
      i = o.prev, o.prev = i.prev, s = t.call(n, s, i.data, i, this);
    return this.releaseCursor(), s;
  }
  some(t, r = this) {
    for (let n = this.head; n !== null; n = n.next)
      if (t.call(r, n.data, n, this))
        return !0;
    return !1;
  }
  map(t, r = this) {
    const n = new x1();
    for (let o = this.head; o !== null; o = o.next)
      n.appendData(t.call(r, o.data, o, this));
    return n;
  }
  filter(t, r = this) {
    const n = new x1();
    for (let o = this.head; o !== null; o = o.next)
      t.call(r, o.data, o, this) && n.appendData(o.data);
    return n;
  }
  nextUntil(t, r, n = this) {
    if (t === null)
      return;
    const o = this.allocateCursor(null, t);
    for (; o.next !== null; ) {
      const s = o.next;
      if (o.next = s.next, r.call(n, s.data, s, this))
        break;
    }
    this.releaseCursor();
  }
  prevUntil(t, r, n = this) {
    if (t === null)
      return;
    const o = this.allocateCursor(t, null);
    for (; o.prev !== null; ) {
      const s = o.prev;
      if (o.prev = s.prev, r.call(n, s.data, s, this))
        break;
    }
    this.releaseCursor();
  }
  clear() {
    this.head = null, this.tail = null;
  }
  copy() {
    const t = new x1();
    for (let r of this)
      t.appendData(r);
    return t;
  }
  prepend(t) {
    return this.updateCursors(null, t, this.head, t), this.head !== null ? (this.head.prev = t, t.next = this.head) : this.tail = t, this.head = t, this;
  }
  prependData(t) {
    return this.prepend(x1.createItem(t));
  }
  append(t) {
    return this.insert(t);
  }
  appendData(t) {
    return this.insert(x1.createItem(t));
  }
  insert(t, r = null) {
    if (r !== null)
      if (this.updateCursors(r.prev, t, r, t), r.prev === null) {
        if (this.head !== r)
          throw new Error("before doesn't belong to list");
        this.head = t, r.prev = t, t.next = r, this.updateCursors(null, t);
      } else
        r.prev.next = t, t.prev = r.prev, r.prev = t, t.next = r;
    else
      this.updateCursors(this.tail, t, null, t), this.tail !== null ? (this.tail.next = t, t.prev = this.tail) : this.head = t, this.tail = t;
    return this;
  }
  insertData(t, r) {
    return this.insert(x1.createItem(t), r);
  }
  remove(t) {
    if (this.updateCursors(t, t.prev, t, t.next), t.prev !== null)
      t.prev.next = t.next;
    else {
      if (this.head !== t)
        throw new Error("item doesn't belong to list");
      this.head = t.next;
    }
    if (t.next !== null)
      t.next.prev = t.prev;
    else {
      if (this.tail !== t)
        throw new Error("item doesn't belong to list");
      this.tail = t.prev;
    }
    return t.prev = null, t.next = null, t;
  }
  push(t) {
    this.insert(x1.createItem(t));
  }
  pop() {
    return this.tail !== null ? this.remove(this.tail) : null;
  }
  unshift(t) {
    this.prepend(x1.createItem(t));
  }
  shift() {
    return this.head !== null ? this.remove(this.head) : null;
  }
  prependList(t) {
    return this.insertList(t, this.head);
  }
  appendList(t) {
    return this.insertList(t);
  }
  insertList(t, r) {
    return t.head === null ? this : (r != null ? (this.updateCursors(r.prev, t.tail, r, t.head), r.prev !== null ? (r.prev.next = t.head, t.head.prev = r.prev) : this.head = t.head, r.prev = t.tail, t.tail.next = r) : (this.updateCursors(this.tail, t.tail, null, t.head), this.tail !== null ? (this.tail.next = t.head, t.head.prev = this.tail) : this.head = t.head, this.tail = t.tail), t.head = null, t.tail = null, this);
  }
  replace(t, r) {
    "head" in r ? this.insertList(r, t) : this.insert(r, t), this.remove(t);
  }
}
rt.List = x1;
var $c = {}, Y8 = {};
function XR(e, t) {
  const r = Object.create(SyntaxError.prototype), n = new Error();
  return Object.assign(r, {
    name: e,
    message: t,
    get stack() {
      return (n.stack || "").replace(/^(.+\n){1,3}/, `${e}: ${t}
`);
    }
  });
}
Y8.createCustomError = XR;
const YR = Y8, X4 = 100, bs = 60, xs = "    ";
function ws({ source: e, line: t, column: r }, n) {
  function o(u, h) {
    return s.slice(u, h).map(
      (m, f) => String(u + f + 1).padStart(c) + " |" + m
    ).join(`
`);
  }
  const s = e.split(/\r\n?|\n|\f/), i = Math.max(1, t - n) - 1, l = Math.min(t + n, s.length + 1), c = Math.max(4, String(l).length) + 1;
  let a = 0;
  r += (xs.length - 1) * (s[t - 1].substr(0, r - 1).match(/\t/g) || []).length, r > X4 && (a = r - bs + 3, r = bs - 2);
  for (let u = i; u <= l; u++)
    u >= 0 && u < s.length && (s[u] = s[u].replace(/\t/g, xs), s[u] = (a > 0 && s[u].length > a ? "\u2026" : "") + s[u].substr(a, X4 - 2) + (s[u].length > a + X4 - 1 ? "\u2026" : ""));
  return [
    o(i, t),
    new Array(r + c + 2).join("-") + "^",
    o(t, l)
  ].filter(Boolean).join(`
`);
}
function KR(e, t, r, n, o) {
  return Object.assign(YR.createCustomError("SyntaxError", e), {
    source: t,
    offset: r,
    line: n,
    column: o,
    sourceFragment(i) {
      return ws({ source: t, line: n, column: o }, isNaN(i) ? 0 : i);
    },
    get formattedMessage() {
      return `Parse error: ${e}
` + ws({ source: t, line: n, column: o }, 2);
    }
  });
}
$c.SyntaxError = KR;
var Ac = {};
const Ls = R;
function QR(e) {
  const t = this.createList();
  let r = !1;
  const n = {
    recognizer: e
  };
  for (; !this.eof; ) {
    switch (this.tokenType) {
      case Ls.Comment:
        this.next();
        continue;
      case Ls.WhiteSpace:
        r = !0, this.next();
        continue;
    }
    let o = e.getNode.call(this, n);
    if (o === void 0)
      break;
    r && (e.onWhiteSpace && e.onWhiteSpace.call(this, o, t, n), r = !1), t.push(o);
  }
  return r && e.onWhiteSpace && e.onWhiteSpace.call(this, null, t, n), t;
}
Ac.readSequence = QR;
const zs = rt, Cs = $c, JR = Z, eI = Ac, tI = j9, rI = X8, M3 = T0, F1 = R, nI = V8, Ss = () => {
}, oI = 33, sI = 35, Y4 = 59, $s = 123, As = 0;
function iI(e) {
  return function() {
    return this[e]();
  };
}
function K4(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const r in e) {
    const n = e[r], o = n.parse || n;
    o && (t[r] = o);
  }
  return t;
}
function aI(e) {
  const t = {
    context: /* @__PURE__ */ Object.create(null),
    scope: Object.assign(/* @__PURE__ */ Object.create(null), e.scope),
    atrule: K4(e.atrule),
    pseudo: K4(e.pseudo),
    node: K4(e.node)
  };
  for (const r in e.parseContext)
    switch (typeof e.parseContext[r]) {
      case "function":
        t.context[r] = e.parseContext[r];
        break;
      case "string":
        t.context[r] = iI(e.parseContext[r]);
        break;
    }
  return {
    config: t,
    ...t,
    ...t.node
  };
}
function lI(e) {
  let t = "", r = "<unknown>", n = !1, o = Ss, s = !1;
  const i = new tI.OffsetToLocation(), l = Object.assign(new rI.TokenStream(), aI(e || {}), {
    parseAtrulePrelude: !0,
    parseRulePrelude: !0,
    parseValue: !0,
    parseCustomProperty: !1,
    readSequence: eI.readSequence,
    consumeUntilBalanceEnd: () => 0,
    consumeUntilLeftCurlyBracket(a) {
      return a === $s ? 1 : 0;
    },
    consumeUntilLeftCurlyBracketOrSemicolon(a) {
      return a === $s || a === Y4 ? 1 : 0;
    },
    consumeUntilExclamationMarkOrSemicolon(a) {
      return a === oI || a === Y4 ? 1 : 0;
    },
    consumeUntilSemicolonIncluded(a) {
      return a === Y4 ? 2 : 0;
    },
    createList() {
      return new zs.List();
    },
    createSingleNodeList(a) {
      return new zs.List().appendData(a);
    },
    getFirstListNode(a) {
      return a && a.first;
    },
    getLastListNode(a) {
      return a && a.last;
    },
    parseWithFallback(a, u) {
      const h = this.tokenIndex;
      try {
        return a.call(this);
      } catch (m) {
        if (s)
          throw m;
        const f = u.call(this, h);
        return s = !0, o(m, f), s = !1, f;
      }
    },
    lookupNonWSType(a) {
      let u;
      do
        if (u = this.lookupType(a++), u !== F1.WhiteSpace)
          return u;
      while (u !== As);
      return As;
    },
    charCodeAt(a) {
      return a >= 0 && a < t.length ? t.charCodeAt(a) : 0;
    },
    substring(a, u) {
      return t.substring(a, u);
    },
    substrToCursor(a) {
      return this.source.substring(a, this.tokenStart);
    },
    cmpChar(a, u) {
      return M3.cmpChar(t, a, u);
    },
    cmpStr(a, u, h) {
      return M3.cmpStr(t, a, u, h);
    },
    consume(a) {
      const u = this.tokenStart;
      return this.eat(a), this.substrToCursor(u);
    },
    consumeFunctionName() {
      const a = t.substring(this.tokenStart, this.tokenEnd - 1);
      return this.eat(F1.Function), a;
    },
    consumeNumber(a) {
      const u = t.substring(this.tokenStart, M3.consumeNumber(t, this.tokenStart));
      return this.eat(a), u;
    },
    eat(a) {
      if (this.tokenType !== a) {
        const u = nI[a].slice(0, -6).replace(/-/g, " ").replace(/^./, (f) => f.toUpperCase());
        let h = `${/[[\](){}]/.test(u) ? `"${u}"` : u} is expected`, m = this.tokenStart;
        switch (a) {
          case F1.Ident:
            this.tokenType === F1.Function || this.tokenType === F1.Url ? (m = this.tokenEnd - 1, h = "Identifier is expected but function found") : h = "Identifier is expected";
            break;
          case F1.Hash:
            this.isDelim(sI) && (this.next(), m++, h = "Name is expected");
            break;
          case F1.Percentage:
            this.tokenType === F1.Number && (m = this.tokenEnd, h = "Percent sign is expected");
            break;
        }
        this.error(h, m);
      }
      this.next();
    },
    eatIdent(a) {
      (this.tokenType !== F1.Ident || this.lookupValue(0, a) === !1) && this.error(`Identifier "${a}" is expected`), this.next();
    },
    eatDelim(a) {
      this.isDelim(a) || this.error(`Delim "${String.fromCharCode(a)}" is expected`), this.next();
    },
    getLocation(a, u) {
      return n ? i.getLocationRange(
        a,
        u,
        r
      ) : null;
    },
    getLocationFromList(a) {
      if (n) {
        const u = this.getFirstListNode(a), h = this.getLastListNode(a);
        return i.getLocationRange(
          u !== null ? u.loc.start.offset - i.startOffset : this.tokenStart,
          h !== null ? h.loc.end.offset - i.startOffset : this.tokenStart,
          r
        );
      }
      return null;
    },
    error(a, u) {
      const h = typeof u < "u" && u < t.length ? i.getLocation(u) : this.eof ? i.getLocation(M3.findWhiteSpaceStart(t, t.length - 1)) : i.getLocation(this.tokenStart);
      throw new Cs.SyntaxError(
        a || "Unexpected input",
        t,
        h.offset,
        h.line,
        h.column
      );
    }
  });
  return Object.assign(function(a, u) {
    t = a, u = u || {}, l.setSource(t, JR.tokenize), i.setSource(
      t,
      u.offset,
      u.line,
      u.column
    ), r = u.filename || "<unknown>", n = Boolean(u.positions), o = typeof u.onParseError == "function" ? u.onParseError : Ss, s = !1, l.parseAtrulePrelude = "parseAtrulePrelude" in u ? Boolean(u.parseAtrulePrelude) : !0, l.parseRulePrelude = "parseRulePrelude" in u ? Boolean(u.parseRulePrelude) : !0, l.parseValue = "parseValue" in u ? Boolean(u.parseValue) : !0, l.parseCustomProperty = "parseCustomProperty" in u ? Boolean(u.parseCustomProperty) : !1;
    const { context: h = "default", onComment: m } = u;
    if (!(h in l.context))
      throw new Error("Unknown context `" + h + "`");
    typeof m == "function" && l.forEachToken((d, k, b) => {
      if (d === F1.Comment) {
        const w = l.getLocation(k, b), L = M3.cmpStr(t, b - 2, b, "*/") ? t.slice(k + 2, b - 2) : t.slice(k + 2, b);
        m(L, w);
      }
    });
    const f = l.context[h].call(l, u);
    return l.eof || l.error(), f;
  }, {
    SyntaxError: Cs.SyntaxError,
    config: l.config
  });
}
Sc.createParser = lI;
var Mc = {}, jc = {}, T9 = {}, P9 = {}, N9 = {}, Ms = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
N9.encode = function(e) {
  if (0 <= e && e < Ms.length)
    return Ms[e];
  throw new TypeError("Must be between 0 and 63: " + e);
};
N9.decode = function(e) {
  var t = 65, r = 90, n = 97, o = 122, s = 48, i = 57, l = 43, c = 47, a = 26, u = 52;
  return t <= e && e <= r ? e - t : n <= e && e <= o ? e - n + a : s <= e && e <= i ? e - s + u : e == l ? 62 : e == c ? 63 : -1;
};
var Ec = N9, D9 = 5, Tc = 1 << D9, Pc = Tc - 1, Nc = Tc;
function cI(e) {
  return e < 0 ? (-e << 1) + 1 : (e << 1) + 0;
}
function uI(e) {
  var t = (e & 1) === 1, r = e >> 1;
  return t ? -r : r;
}
P9.encode = function(t) {
  var r = "", n, o = cI(t);
  do
    n = o & Pc, o >>>= D9, o > 0 && (n |= Nc), r += Ec.encode(n);
  while (o > 0);
  return r;
};
P9.decode = function(t, r, n) {
  var o = t.length, s = 0, i = 0, l, c;
  do {
    if (r >= o)
      throw new Error("Expected more digits in base 64 VLQ value.");
    if (c = Ec.decode(t.charCodeAt(r++)), c === -1)
      throw new Error("Invalid base64 digit: " + t.charAt(r - 1));
    l = !!(c & Nc), c &= Pc, s = s + (c << i), i += D9;
  } while (l);
  n.value = uI(s), n.rest = r;
};
var K8 = {};
(function(e) {
  function t(x, j, O) {
    if (j in x)
      return x[j];
    if (arguments.length === 3)
      return O;
    throw new Error('"' + j + '" is a required argument.');
  }
  e.getArg = t;
  var r = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/, n = /^data:.+\,.+$/;
  function o(x) {
    var j = x.match(r);
    return j ? {
      scheme: j[1],
      auth: j[2],
      host: j[3],
      port: j[4],
      path: j[5]
    } : null;
  }
  e.urlParse = o;
  function s(x) {
    var j = "";
    return x.scheme && (j += x.scheme + ":"), j += "//", x.auth && (j += x.auth + "@"), x.host && (j += x.host), x.port && (j += ":" + x.port), x.path && (j += x.path), j;
  }
  e.urlGenerate = s;
  var i = 32;
  function l(x) {
    var j = [];
    return function(O) {
      for (var y = 0; y < j.length; y++)
        if (j[y].input === O) {
          var D = j[0];
          return j[0] = j[y], j[y] = D, j[0].result;
        }
      var E = x(O);
      return j.unshift({
        input: O,
        result: E
      }), j.length > i && j.pop(), E;
    };
  }
  var c = l(function(j) {
    var O = j, y = o(j);
    if (y) {
      if (!y.path)
        return j;
      O = y.path;
    }
    for (var D = e.isAbsolute(O), E = [], W = 0, U = 0; ; )
      if (W = U, U = O.indexOf("/", W), U === -1) {
        E.push(O.slice(W));
        break;
      } else
        for (E.push(O.slice(W, U)); U < O.length && O[U] === "/"; )
          U++;
    for (var i0, Q = 0, U = E.length - 1; U >= 0; U--)
      i0 = E[U], i0 === "." ? E.splice(U, 1) : i0 === ".." ? Q++ : Q > 0 && (i0 === "" ? (E.splice(U + 1, Q), Q = 0) : (E.splice(U, 2), Q--));
    return O = E.join("/"), O === "" && (O = D ? "/" : "."), y ? (y.path = O, s(y)) : O;
  });
  e.normalize = c;
  function a(x, j) {
    x === "" && (x = "."), j === "" && (j = ".");
    var O = o(j), y = o(x);
    if (y && (x = y.path || "/"), O && !O.scheme)
      return y && (O.scheme = y.scheme), s(O);
    if (O || j.match(n))
      return j;
    if (y && !y.host && !y.path)
      return y.host = j, s(y);
    var D = j.charAt(0) === "/" ? j : c(x.replace(/\/+$/, "") + "/" + j);
    return y ? (y.path = D, s(y)) : D;
  }
  e.join = a, e.isAbsolute = function(x) {
    return x.charAt(0) === "/" || r.test(x);
  };
  function u(x, j) {
    x === "" && (x = "."), x = x.replace(/\/$/, "");
    for (var O = 0; j.indexOf(x + "/") !== 0; ) {
      var y = x.lastIndexOf("/");
      if (y < 0 || (x = x.slice(0, y), x.match(/^([^\/]+:\/)?\/*$/)))
        return j;
      ++O;
    }
    return Array(O + 1).join("../") + j.substr(x.length + 1);
  }
  e.relative = u;
  var h = function() {
    var x = /* @__PURE__ */ Object.create(null);
    return !("__proto__" in x);
  }();
  function m(x) {
    return x;
  }
  function f(x) {
    return k(x) ? "$" + x : x;
  }
  e.toSetString = h ? m : f;
  function d(x) {
    return k(x) ? x.slice(1) : x;
  }
  e.fromSetString = h ? m : d;
  function k(x) {
    if (!x)
      return !1;
    var j = x.length;
    if (j < 9 || x.charCodeAt(j - 1) !== 95 || x.charCodeAt(j - 2) !== 95 || x.charCodeAt(j - 3) !== 111 || x.charCodeAt(j - 4) !== 116 || x.charCodeAt(j - 5) !== 111 || x.charCodeAt(j - 6) !== 114 || x.charCodeAt(j - 7) !== 112 || x.charCodeAt(j - 8) !== 95 || x.charCodeAt(j - 9) !== 95)
      return !1;
    for (var O = j - 10; O >= 0; O--)
      if (x.charCodeAt(O) !== 36)
        return !1;
    return !0;
  }
  function b(x, j, O) {
    var y = C(x.source, j.source);
    return y !== 0 || (y = x.originalLine - j.originalLine, y !== 0) || (y = x.originalColumn - j.originalColumn, y !== 0 || O) || (y = x.generatedColumn - j.generatedColumn, y !== 0) || (y = x.generatedLine - j.generatedLine, y !== 0) ? y : C(x.name, j.name);
  }
  e.compareByOriginalPositions = b;
  function w(x, j, O) {
    var y;
    return y = x.originalLine - j.originalLine, y !== 0 || (y = x.originalColumn - j.originalColumn, y !== 0 || O) || (y = x.generatedColumn - j.generatedColumn, y !== 0) || (y = x.generatedLine - j.generatedLine, y !== 0) ? y : C(x.name, j.name);
  }
  e.compareByOriginalPositionsNoSource = w;
  function L(x, j, O) {
    var y = x.generatedLine - j.generatedLine;
    return y !== 0 || (y = x.generatedColumn - j.generatedColumn, y !== 0 || O) || (y = C(x.source, j.source), y !== 0) || (y = x.originalLine - j.originalLine, y !== 0) || (y = x.originalColumn - j.originalColumn, y !== 0) ? y : C(x.name, j.name);
  }
  e.compareByGeneratedPositionsDeflated = L;
  function A(x, j, O) {
    var y = x.generatedColumn - j.generatedColumn;
    return y !== 0 || O || (y = C(x.source, j.source), y !== 0) || (y = x.originalLine - j.originalLine, y !== 0) || (y = x.originalColumn - j.originalColumn, y !== 0) ? y : C(x.name, j.name);
  }
  e.compareByGeneratedPositionsDeflatedNoLine = A;
  function C(x, j) {
    return x === j ? 0 : x === null ? 1 : j === null ? -1 : x > j ? 1 : -1;
  }
  function g(x, j) {
    var O = x.generatedLine - j.generatedLine;
    return O !== 0 || (O = x.generatedColumn - j.generatedColumn, O !== 0) || (O = C(x.source, j.source), O !== 0) || (O = x.originalLine - j.originalLine, O !== 0) || (O = x.originalColumn - j.originalColumn, O !== 0) ? O : C(x.name, j.name);
  }
  e.compareByGeneratedPositionsInflated = g;
  function M(x) {
    return JSON.parse(x.replace(/^\)]}'[^\n]*\n/, ""));
  }
  e.parseSourceMapInput = M;
  function P(x, j, O) {
    if (j = j || "", x && (x[x.length - 1] !== "/" && j[0] !== "/" && (x += "/"), j = x + j), O) {
      var y = o(O);
      if (!y)
        throw new Error("sourceMapURL could not be parsed");
      if (y.path) {
        var D = y.path.lastIndexOf("/");
        D >= 0 && (y.path = y.path.substring(0, D + 1));
      }
      j = a(s(y), j);
    }
    return c(j);
  }
  e.computeSourceURL = P;
})(K8);
var Dc = {}, O9 = K8, R9 = Object.prototype.hasOwnProperty, Je = typeof Map < "u";
function fe() {
  this._array = [], this._set = Je ? /* @__PURE__ */ new Map() : /* @__PURE__ */ Object.create(null);
}
fe.fromArray = function(t, r) {
  for (var n = new fe(), o = 0, s = t.length; o < s; o++)
    n.add(t[o], r);
  return n;
};
fe.prototype.size = function() {
  return Je ? this._set.size : Object.getOwnPropertyNames(this._set).length;
};
fe.prototype.add = function(t, r) {
  var n = Je ? t : O9.toSetString(t), o = Je ? this.has(t) : R9.call(this._set, n), s = this._array.length;
  (!o || r) && this._array.push(t), o || (Je ? this._set.set(t, s) : this._set[n] = s);
};
fe.prototype.has = function(t) {
  if (Je)
    return this._set.has(t);
  var r = O9.toSetString(t);
  return R9.call(this._set, r);
};
fe.prototype.indexOf = function(t) {
  if (Je) {
    var r = this._set.get(t);
    if (r >= 0)
      return r;
  } else {
    var n = O9.toSetString(t);
    if (R9.call(this._set, n))
      return this._set[n];
  }
  throw new Error('"' + t + '" is not in the set.');
};
fe.prototype.at = function(t) {
  if (t >= 0 && t < this._array.length)
    return this._array[t];
  throw new Error("No element indexed by " + t);
};
fe.prototype.toArray = function() {
  return this._array.slice();
};
Dc.ArraySet = fe;
var Oc = {}, Rc = K8;
function hI(e, t) {
  var r = e.generatedLine, n = t.generatedLine, o = e.generatedColumn, s = t.generatedColumn;
  return n > r || n == r && s >= o || Rc.compareByGeneratedPositionsInflated(e, t) <= 0;
}
function Q8() {
  this._array = [], this._sorted = !0, this._last = { generatedLine: -1, generatedColumn: 0 };
}
Q8.prototype.unsortedForEach = function(t, r) {
  this._array.forEach(t, r);
};
Q8.prototype.add = function(t) {
  hI(this._last, t) ? (this._last = t, this._array.push(t)) : (this._sorted = !1, this._array.push(t));
};
Q8.prototype.toArray = function() {
  return this._sorted || (this._array.sort(Rc.compareByGeneratedPositionsInflated), this._sorted = !0), this._array;
};
Oc.MappingList = Q8;
var j3 = P9, j0 = K8, u8 = Dc.ArraySet, mI = Oc.MappingList;
function $1(e) {
  e || (e = {}), this._file = j0.getArg(e, "file", null), this._sourceRoot = j0.getArg(e, "sourceRoot", null), this._skipValidation = j0.getArg(e, "skipValidation", !1), this._sources = new u8(), this._names = new u8(), this._mappings = new mI(), this._sourcesContents = null;
}
$1.prototype._version = 3;
$1.fromSourceMap = function(t) {
  var r = t.sourceRoot, n = new $1({
    file: t.file,
    sourceRoot: r
  });
  return t.eachMapping(function(o) {
    var s = {
      generated: {
        line: o.generatedLine,
        column: o.generatedColumn
      }
    };
    o.source != null && (s.source = o.source, r != null && (s.source = j0.relative(r, s.source)), s.original = {
      line: o.originalLine,
      column: o.originalColumn
    }, o.name != null && (s.name = o.name)), n.addMapping(s);
  }), t.sources.forEach(function(o) {
    var s = o;
    r !== null && (s = j0.relative(r, o)), n._sources.has(s) || n._sources.add(s);
    var i = t.sourceContentFor(o);
    i != null && n.setSourceContent(o, i);
  }), n;
};
$1.prototype.addMapping = function(t) {
  var r = j0.getArg(t, "generated"), n = j0.getArg(t, "original", null), o = j0.getArg(t, "source", null), s = j0.getArg(t, "name", null);
  this._skipValidation || this._validateMapping(r, n, o, s), o != null && (o = String(o), this._sources.has(o) || this._sources.add(o)), s != null && (s = String(s), this._names.has(s) || this._names.add(s)), this._mappings.add({
    generatedLine: r.line,
    generatedColumn: r.column,
    originalLine: n != null && n.line,
    originalColumn: n != null && n.column,
    source: o,
    name: s
  });
};
$1.prototype.setSourceContent = function(t, r) {
  var n = t;
  this._sourceRoot != null && (n = j0.relative(this._sourceRoot, n)), r != null ? (this._sourcesContents || (this._sourcesContents = /* @__PURE__ */ Object.create(null)), this._sourcesContents[j0.toSetString(n)] = r) : this._sourcesContents && (delete this._sourcesContents[j0.toSetString(n)], Object.keys(this._sourcesContents).length === 0 && (this._sourcesContents = null));
};
$1.prototype.applySourceMap = function(t, r, n) {
  var o = r;
  if (r == null) {
    if (t.file == null)
      throw new Error(
        `SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map's "file" property. Both were omitted.`
      );
    o = t.file;
  }
  var s = this._sourceRoot;
  s != null && (o = j0.relative(s, o));
  var i = new u8(), l = new u8();
  this._mappings.unsortedForEach(function(c) {
    if (c.source === o && c.originalLine != null) {
      var a = t.originalPositionFor({
        line: c.originalLine,
        column: c.originalColumn
      });
      a.source != null && (c.source = a.source, n != null && (c.source = j0.join(n, c.source)), s != null && (c.source = j0.relative(s, c.source)), c.originalLine = a.line, c.originalColumn = a.column, a.name != null && (c.name = a.name));
    }
    var u = c.source;
    u != null && !i.has(u) && i.add(u);
    var h = c.name;
    h != null && !l.has(h) && l.add(h);
  }, this), this._sources = i, this._names = l, t.sources.forEach(function(c) {
    var a = t.sourceContentFor(c);
    a != null && (n != null && (c = j0.join(n, c)), s != null && (c = j0.relative(s, c)), this.setSourceContent(c, a));
  }, this);
};
$1.prototype._validateMapping = function(t, r, n, o) {
  if (r && typeof r.line != "number" && typeof r.column != "number")
    throw new Error(
      "original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values."
    );
  if (!(t && "line" in t && "column" in t && t.line > 0 && t.column >= 0 && !r && !n && !o)) {
    if (t && "line" in t && "column" in t && r && "line" in r && "column" in r && t.line > 0 && t.column >= 0 && r.line > 0 && r.column >= 0 && n)
      return;
    throw new Error("Invalid mapping: " + JSON.stringify({
      generated: t,
      source: n,
      original: r,
      name: o
    }));
  }
};
$1.prototype._serializeMappings = function() {
  for (var t = 0, r = 1, n = 0, o = 0, s = 0, i = 0, l = "", c, a, u, h, m = this._mappings.toArray(), f = 0, d = m.length; f < d; f++) {
    if (a = m[f], c = "", a.generatedLine !== r)
      for (t = 0; a.generatedLine !== r; )
        c += ";", r++;
    else if (f > 0) {
      if (!j0.compareByGeneratedPositionsInflated(a, m[f - 1]))
        continue;
      c += ",";
    }
    c += j3.encode(a.generatedColumn - t), t = a.generatedColumn, a.source != null && (h = this._sources.indexOf(a.source), c += j3.encode(h - i), i = h, c += j3.encode(a.originalLine - 1 - o), o = a.originalLine - 1, c += j3.encode(a.originalColumn - n), n = a.originalColumn, a.name != null && (u = this._names.indexOf(a.name), c += j3.encode(u - s), s = u)), l += c;
  }
  return l;
};
$1.prototype._generateSourcesContent = function(t, r) {
  return t.map(function(n) {
    if (!this._sourcesContents)
      return null;
    r != null && (n = j0.relative(r, n));
    var o = j0.toSetString(n);
    return Object.prototype.hasOwnProperty.call(this._sourcesContents, o) ? this._sourcesContents[o] : null;
  }, this);
};
$1.prototype.toJSON = function() {
  var t = {
    version: this._version,
    sources: this._sources.toArray(),
    names: this._names.toArray(),
    mappings: this._serializeMappings()
  };
  return this._file != null && (t.file = this._file), this._sourceRoot != null && (t.sourceRoot = this._sourceRoot), this._sourcesContents && (t.sourcesContent = this._generateSourcesContent(t.sources, t.sourceRoot)), t;
};
$1.prototype.toString = function() {
  return JSON.stringify(this.toJSON());
};
T9.SourceMapGenerator = $1;
const fI = T9, js = /* @__PURE__ */ new Set(["Atrule", "Selector", "Declaration"]);
function dI(e) {
  const t = new fI.SourceMapGenerator(), r = {
    line: 1,
    column: 0
  }, n = {
    line: 0,
    column: 0
  }, o = {
    line: 1,
    column: 0
  }, s = {
    generated: o
  };
  let i = 1, l = 0, c = !1;
  const a = e.node;
  e.node = function(m) {
    if (m.loc && m.loc.start && js.has(m.type)) {
      const f = m.loc.start.line, d = m.loc.start.column - 1;
      (n.line !== f || n.column !== d) && (n.line = f, n.column = d, r.line = i, r.column = l, c && (c = !1, (r.line !== o.line || r.column !== o.column) && t.addMapping(s)), c = !0, t.addMapping({
        source: m.loc.source,
        original: n,
        generated: r
      }));
    }
    a.call(this, m), c && js.has(m.type) && (o.line = i, o.column = l);
  };
  const u = e.emit;
  e.emit = function(m, f, d) {
    for (let k = 0; k < m.length; k++)
      m.charCodeAt(k) === 10 ? (i++, l = 0) : l++;
    u(m, f, d);
  };
  const h = e.result;
  return e.result = function() {
    return c && t.addMapping(s), {
      css: h(),
      map: t
    };
  }, e;
}
jc.generateSourceMap = dI;
var I9 = {};
const S = R, pI = 43, gI = 45, Q4 = (e, t) => {
  if (e === S.Delim && (e = t), typeof e == "string") {
    const r = e.charCodeAt(0);
    return r > 127 ? 32768 : r << 8;
  }
  return e;
}, Ic = [
  [S.Ident, S.Ident],
  [S.Ident, S.Function],
  [S.Ident, S.Url],
  [S.Ident, S.BadUrl],
  [S.Ident, "-"],
  [S.Ident, S.Number],
  [S.Ident, S.Percentage],
  [S.Ident, S.Dimension],
  [S.Ident, S.CDC],
  [S.Ident, S.LeftParenthesis],
  [S.AtKeyword, S.Ident],
  [S.AtKeyword, S.Function],
  [S.AtKeyword, S.Url],
  [S.AtKeyword, S.BadUrl],
  [S.AtKeyword, "-"],
  [S.AtKeyword, S.Number],
  [S.AtKeyword, S.Percentage],
  [S.AtKeyword, S.Dimension],
  [S.AtKeyword, S.CDC],
  [S.Hash, S.Ident],
  [S.Hash, S.Function],
  [S.Hash, S.Url],
  [S.Hash, S.BadUrl],
  [S.Hash, "-"],
  [S.Hash, S.Number],
  [S.Hash, S.Percentage],
  [S.Hash, S.Dimension],
  [S.Hash, S.CDC],
  [S.Dimension, S.Ident],
  [S.Dimension, S.Function],
  [S.Dimension, S.Url],
  [S.Dimension, S.BadUrl],
  [S.Dimension, "-"],
  [S.Dimension, S.Number],
  [S.Dimension, S.Percentage],
  [S.Dimension, S.Dimension],
  [S.Dimension, S.CDC],
  ["#", S.Ident],
  ["#", S.Function],
  ["#", S.Url],
  ["#", S.BadUrl],
  ["#", "-"],
  ["#", S.Number],
  ["#", S.Percentage],
  ["#", S.Dimension],
  ["#", S.CDC],
  ["-", S.Ident],
  ["-", S.Function],
  ["-", S.Url],
  ["-", S.BadUrl],
  ["-", "-"],
  ["-", S.Number],
  ["-", S.Percentage],
  ["-", S.Dimension],
  ["-", S.CDC],
  [S.Number, S.Ident],
  [S.Number, S.Function],
  [S.Number, S.Url],
  [S.Number, S.BadUrl],
  [S.Number, S.Number],
  [S.Number, S.Percentage],
  [S.Number, S.Dimension],
  [S.Number, "%"],
  [S.Number, S.CDC],
  ["@", S.Ident],
  ["@", S.Function],
  ["@", S.Url],
  ["@", S.BadUrl],
  ["@", "-"],
  ["@", S.CDC],
  [".", S.Number],
  [".", S.Percentage],
  [".", S.Dimension],
  ["+", S.Number],
  ["+", S.Percentage],
  ["+", S.Dimension],
  ["/", "*"]
], kI = Ic.concat([
  [S.Ident, S.Hash],
  [S.Dimension, S.Hash],
  [S.Hash, S.Hash],
  [S.AtKeyword, S.LeftParenthesis],
  [S.AtKeyword, S.String],
  [S.AtKeyword, S.Colon],
  [S.Percentage, S.Percentage],
  [S.Percentage, S.Dimension],
  [S.Percentage, S.Function],
  [S.Percentage, "-"],
  [S.RightParenthesis, S.Ident],
  [S.RightParenthesis, S.Function],
  [S.RightParenthesis, S.Percentage],
  [S.RightParenthesis, S.Dimension],
  [S.RightParenthesis, S.Hash],
  [S.RightParenthesis, "-"]
]);
function _c(e) {
  const t = new Set(
    e.map(([r, n]) => Q4(r) << 16 | Q4(n))
  );
  return function(r, n, o) {
    const s = Q4(n, o), i = o.charCodeAt(0);
    return (i === gI && n !== S.Ident && n !== S.Function && n !== S.CDC || i === pI ? t.has(r << 16 | i << 8) : t.has(r << 16 | s)) && this.emit(" ", S.WhiteSpace, !0), s;
  };
}
const vI = _c(Ic), yI = _c(kI);
I9.safe = yI;
I9.spec = vI;
const bI = Z, xI = jc, J4 = I9, Es = R, wI = 92;
function LI(e, t) {
  if (typeof t == "function") {
    let r = null;
    e.children.forEach((n) => {
      r !== null && t.call(this, r), this.node(n), r = n;
    });
    return;
  }
  e.children.forEach(this.node, this);
}
function zI(e) {
  bI.tokenize(e, (t, r, n) => {
    this.token(t, e.slice(r, n));
  });
}
function CI(e) {
  const t = /* @__PURE__ */ new Map();
  for (let r in e.node) {
    const n = e.node[r];
    typeof (n.generate || n) == "function" && t.set(r, n.generate || n);
  }
  return function(r, n) {
    let o = "", s = 0, i = {
      node(c) {
        if (t.has(c.type))
          t.get(c.type).call(l, c);
        else
          throw new Error("Unknown node type: " + c.type);
      },
      tokenBefore: J4.safe,
      token(c, a) {
        s = this.tokenBefore(s, c, a), this.emit(a, c, !1), c === Es.Delim && a.charCodeAt(0) === wI && this.emit(`
`, Es.WhiteSpace, !0);
      },
      emit(c) {
        o += c;
      },
      result() {
        return o;
      }
    };
    n && (typeof n.decorator == "function" && (i = n.decorator(i)), n.sourceMap && (i = xI.generateSourceMap(i)), n.mode in J4 && (i.tokenBefore = J4[n.mode]));
    const l = {
      node: (c) => i.node(c),
      children: LI,
      token: (c, a) => i.token(c, a),
      tokenize: zI
    };
    return i.node(r), i.result();
  };
}
Mc.createGenerator = CI;
var Fc = {};
const en = rt;
function SI(e) {
  return {
    fromPlainObject(t) {
      return e(t, {
        enter(r) {
          r.children && !(r.children instanceof en.List) && (r.children = new en.List().fromArray(r.children));
        }
      }), t;
    },
    toPlainObject(t) {
      return e(t, {
        leave(r) {
          r.children && r.children instanceof en.List && (r.children = r.children.toArray());
        }
      }), t;
    }
  };
}
Fc.createConvertor = SI;
var Bc = {};
const { hasOwnProperty: _9 } = Object.prototype, W3 = function() {
};
function Ts(e) {
  return typeof e == "function" ? e : W3;
}
function Ps(e, t) {
  return function(r, n, o) {
    r.type === t && e.call(this, r, n, o);
  };
}
function $I(e, t) {
  const r = t.structure, n = [];
  for (const o in r) {
    if (_9.call(r, o) === !1)
      continue;
    let s = r[o];
    const i = {
      name: o,
      type: !1,
      nullable: !1
    };
    Array.isArray(s) || (s = [s]);
    for (const l of s)
      l === null ? i.nullable = !0 : typeof l == "string" ? i.type = "node" : Array.isArray(l) && (i.type = "list");
    i.type && n.push(i);
  }
  return n.length ? {
    context: t.walkContext,
    fields: n
  } : null;
}
function AI(e) {
  const t = {};
  for (const r in e.node)
    if (_9.call(e.node, r)) {
      const n = e.node[r];
      if (!n.structure)
        throw new Error("Missed `structure` field in `" + r + "` node type definition");
      t[r] = $I(r, n);
    }
  return t;
}
function Ns(e, t) {
  const r = e.fields.slice(), n = e.context, o = typeof n == "string";
  return t && r.reverse(), function(s, i, l, c) {
    let a;
    o && (a = i[n], i[n] = s);
    for (const u of r) {
      const h = s[u.name];
      if (!u.nullable || h) {
        if (u.type === "list") {
          if (t ? h.reduceRight(c, !1) : h.reduce(c, !1))
            return !0;
        } else if (l(h))
          return !0;
      }
    }
    o && (i[n] = a);
  };
}
function Ds({
  StyleSheet: e,
  Atrule: t,
  Rule: r,
  Block: n,
  DeclarationList: o
}) {
  return {
    Atrule: {
      StyleSheet: e,
      Atrule: t,
      Rule: r,
      Block: n
    },
    Rule: {
      StyleSheet: e,
      Atrule: t,
      Rule: r,
      Block: n
    },
    Declaration: {
      StyleSheet: e,
      Atrule: t,
      Rule: r,
      Block: n,
      DeclarationList: o
    }
  };
}
function MI(e) {
  const t = AI(e), r = {}, n = {}, o = Symbol("break-walk"), s = Symbol("skip-node");
  for (const a in t)
    _9.call(t, a) && t[a] !== null && (r[a] = Ns(t[a], !1), n[a] = Ns(t[a], !0));
  const i = Ds(r), l = Ds(n), c = function(a, u) {
    function h(w, L, A) {
      const C = m.call(b, w, L, A);
      return C === o ? !0 : C === s ? !1 : !!(d.hasOwnProperty(w.type) && d[w.type](w, b, h, k) || f.call(b, w, L, A) === o);
    }
    let m = W3, f = W3, d = r, k = (w, L, A, C) => w || h(L, A, C);
    const b = {
      break: o,
      skip: s,
      root: a,
      stylesheet: null,
      atrule: null,
      atrulePrelude: null,
      rule: null,
      selector: null,
      block: null,
      declaration: null,
      function: null
    };
    if (typeof u == "function")
      m = u;
    else if (u && (m = Ts(u.enter), f = Ts(u.leave), u.reverse && (d = n), u.visit)) {
      if (i.hasOwnProperty(u.visit))
        d = u.reverse ? l[u.visit] : i[u.visit];
      else if (!t.hasOwnProperty(u.visit))
        throw new Error("Bad value `" + u.visit + "` for `visit` option (should be: " + Object.keys(t).sort().join(", ") + ")");
      m = Ps(m, u.visit), f = Ps(f, u.visit);
    }
    if (m === W3 && f === W3)
      throw new Error("Neither `enter` nor `leave` walker handler is set or both aren't a function");
    h(a);
  };
  return c.break = o, c.skip = s, c.find = function(a, u) {
    let h = null;
    return c(a, function(m, f, d) {
      if (u.call(this, m, f, d))
        return h = m, o;
    }), h;
  }, c.findLast = function(a, u) {
    let h = null;
    return c(a, {
      reverse: !0,
      enter(m, f, d) {
        if (u.call(this, m, f, d))
          return h = m, o;
      }
    }), h;
  }, c.findAll = function(a, u) {
    const h = [];
    return c(a, function(m, f, d) {
      u.call(this, m, f, d) && h.push(m);
    }), h;
  }, c;
}
Bc.createWalker = MI;
var F9 = {}, B9 = {}, J8 = {};
function jI(e) {
  return e;
}
function EI(e) {
  const { min: t, max: r, comma: n } = e;
  return t === 0 && r === 0 ? n ? "#?" : "*" : t === 0 && r === 1 ? "?" : t === 1 && r === 0 ? n ? "#" : "+" : t === 1 && r === 1 ? "" : (n ? "#" : "") + (t === r ? "{" + t + "}" : "{" + t + "," + (r !== 0 ? r : "") + "}");
}
function TI(e) {
  switch (e.type) {
    case "Range":
      return " [" + (e.min === null ? "-\u221E" : e.min) + "," + (e.max === null ? "\u221E" : e.max) + "]";
    default:
      throw new Error("Unknown node type `" + e.type + "`");
  }
}
function PI(e, t, r, n) {
  const o = e.combinator === " " || n ? e.combinator : " " + e.combinator + " ", s = e.terms.map((i) => Z9(i, t, r, n)).join(o);
  return e.explicit || r ? (n || s[0] === "," ? "[" : "[ ") + s + (n ? "]" : " ]") : s;
}
function Z9(e, t, r, n) {
  let o;
  switch (e.type) {
    case "Group":
      o = PI(e, t, r, n) + (e.disallowEmpty ? "!" : "");
      break;
    case "Multiplier":
      return Z9(e.term, t, r, n) + t(EI(e), e);
    case "Type":
      o = "<" + e.name + (e.opts ? t(TI(e.opts), e.opts) : "") + ">";
      break;
    case "Property":
      o = "<'" + e.name + "'>";
      break;
    case "Keyword":
      o = e.name;
      break;
    case "AtKeyword":
      o = "@" + e.name;
      break;
    case "Function":
      o = e.name + "(";
      break;
    case "String":
    case "Token":
      o = e.value;
      break;
    case "Comma":
      o = ",";
      break;
    default:
      throw new Error("Unknown node type `" + e.type + "`");
  }
  return t(o, e);
}
function NI(e, t) {
  let r = jI, n = !1, o = !1;
  return typeof t == "function" ? r = t : t && (n = Boolean(t.forceBraces), o = Boolean(t.compact), typeof t.decorate == "function" && (r = t.decorate)), Z9(e, r, n, o);
}
J8.generate = NI;
const Zc = Y8, DI = J8, Os = { offset: 0, line: 1, column: 1 };
function OI(e, t) {
  const r = e.tokens, n = e.longestMatch, o = n < r.length && r[n].node || null, s = o !== t ? o : null;
  let i = 0, l = 0, c = 0, a = "", u, h;
  for (let m = 0; m < r.length; m++) {
    const f = r[m].value;
    m === n && (l = f.length, i = a.length), s !== null && r[m].node === s && (m <= n ? c++ : c = 0), a += f;
  }
  return n === r.length || c > 1 ? (u = wr(s || t, "end") || V3(Os, a), h = V3(u)) : (u = wr(s, "start") || V3(wr(t, "start") || Os, a.slice(0, i)), h = wr(s, "end") || V3(u, a.substr(i, l))), {
    css: a,
    mismatchOffset: i,
    mismatchLength: l,
    start: u,
    end: h
  };
}
function wr(e, t) {
  const r = e && e.loc && e.loc[t];
  return r ? "line" in r ? V3(r) : r : null;
}
function V3({ offset: e, line: t, column: r }, n) {
  const o = {
    offset: e,
    line: t,
    column: r
  };
  if (n) {
    const s = n.split(/\n|\r\n?|\f/);
    o.offset += n.length, o.line += s.length - 1, o.column = s.length === 1 ? o.column + n.length : s.pop().length + 1;
  }
  return o;
}
const RI = function(e, t) {
  const r = Zc.createCustomError(
    "SyntaxReferenceError",
    e + (t ? " `" + t + "`" : "")
  );
  return r.reference = t, r;
}, II = function(e, t, r, n) {
  const o = Zc.createCustomError("SyntaxMatchError", e), {
    css: s,
    mismatchOffset: i,
    mismatchLength: l,
    start: c,
    end: a
  } = OI(n, r);
  return o.rawMessage = e, o.syntax = t ? DI.generate(t) : "<generic>", o.css = s, o.mismatchOffset = i, o.mismatchLength = l, o.message = e + `
  syntax: ` + o.syntax + `
   value: ` + (s || "<empty string>") + `
  --------` + new Array(o.mismatchOffset + 1).join("-") + "^", Object.assign(o, c), o.loc = {
    source: r && r.loc && r.loc.source || "<unknown>",
    start: c,
    end: a
  }, o;
};
B9.SyntaxMatchError = II;
B9.SyntaxReferenceError = RI;
var nt = {};
const Lr = /* @__PURE__ */ new Map(), Et = /* @__PURE__ */ new Map(), h8 = 45, _I = ZI, FI = qI, BI = U9;
function q9(e, t) {
  return t = t || 0, e.length - t >= 2 && e.charCodeAt(t) === h8 && e.charCodeAt(t + 1) === h8;
}
function U9(e, t) {
  if (t = t || 0, e.length - t >= 3 && e.charCodeAt(t) === h8 && e.charCodeAt(t + 1) !== h8) {
    const r = e.indexOf("-", t + 2);
    if (r !== -1)
      return e.substring(t, r + 1);
  }
  return "";
}
function ZI(e) {
  if (Lr.has(e))
    return Lr.get(e);
  const t = e.toLowerCase();
  let r = Lr.get(t);
  if (r === void 0) {
    const n = q9(t, 0), o = n ? "" : U9(t, 0);
    r = Object.freeze({
      basename: t.substr(o.length),
      name: t,
      prefix: o,
      vendor: o,
      custom: n
    });
  }
  return Lr.set(e, r), r;
}
function qI(e) {
  if (Et.has(e))
    return Et.get(e);
  let t = e, r = e[0];
  r === "/" ? r = e[1] === "/" ? "//" : "/" : r !== "_" && r !== "*" && r !== "$" && r !== "#" && r !== "+" && r !== "&" && (r = "");
  const n = q9(t, r.length);
  if (!n && (t = t.toLowerCase(), Et.has(t))) {
    const l = Et.get(t);
    return Et.set(e, l), l;
  }
  const o = n ? "" : U9(t, r.length), s = t.substr(0, r.length + o.length), i = Object.freeze({
    basename: t.substr(s.length),
    name: t.substr(r.length),
    hack: r,
    vendor: o,
    prefix: s,
    custom: n
  });
  return Et.set(e, i), i;
}
nt.isCustomProperty = q9;
nt.keyword = _I;
nt.property = FI;
nt.vendorPrefix = BI;
var H9 = {};
const UI = [
  "initial",
  "inherit",
  "unset",
  "revert",
  "revert-layer"
];
H9.cssWideKeywords = UI;
var D7 = {};
const qc = h0, P1 = R, tn = T0, d7 = 43, q1 = 45, rn = 110, Tt = !0, HI = !1;
function bo(e, t) {
  return e !== null && e.type === P1.Delim && e.value.charCodeAt(0) === t;
}
function a7(e, t, r) {
  for (; e !== null && (e.type === P1.WhiteSpace || e.type === P1.Comment); )
    e = r(++t);
  return t;
}
function be(e, t, r, n) {
  if (!e)
    return 0;
  const o = e.value.charCodeAt(t);
  if (o === d7 || o === q1) {
    if (r)
      return 0;
    t++;
  }
  for (; t < e.value.length; t++)
    if (!qc.isDigit(e.value.charCodeAt(t)))
      return 0;
  return n + 1;
}
function nn(e, t, r) {
  let n = !1, o = a7(e, t, r);
  if (e = r(o), e === null)
    return t;
  if (e.type !== P1.Number)
    if (bo(e, d7) || bo(e, q1)) {
      if (n = !0, o = a7(r(++o), o, r), e = r(o), e === null || e.type !== P1.Number)
        return 0;
    } else
      return t;
  if (!n) {
    const s = e.value.charCodeAt(0);
    if (s !== d7 && s !== q1)
      return 0;
  }
  return be(e, n ? 0 : 1, n, o);
}
function GI(e, t) {
  let r = 0;
  if (!e)
    return 0;
  if (e.type === P1.Number)
    return be(e, 0, HI, r);
  if (e.type === P1.Ident && e.value.charCodeAt(0) === q1) {
    if (!tn.cmpChar(e.value, 1, rn))
      return 0;
    switch (e.value.length) {
      case 2:
        return nn(t(++r), r, t);
      case 3:
        return e.value.charCodeAt(2) !== q1 ? 0 : (r = a7(t(++r), r, t), e = t(r), be(e, 0, Tt, r));
      default:
        return e.value.charCodeAt(2) !== q1 ? 0 : be(e, 3, Tt, r);
    }
  } else if (e.type === P1.Ident || bo(e, d7) && t(r + 1).type === P1.Ident) {
    if (e.type !== P1.Ident && (e = t(++r)), e === null || !tn.cmpChar(e.value, 0, rn))
      return 0;
    switch (e.value.length) {
      case 1:
        return nn(t(++r), r, t);
      case 2:
        return e.value.charCodeAt(1) !== q1 ? 0 : (r = a7(t(++r), r, t), e = t(r), be(e, 0, Tt, r));
      default:
        return e.value.charCodeAt(1) !== q1 ? 0 : be(e, 2, Tt, r);
    }
  } else if (e.type === P1.Dimension) {
    let n = e.value.charCodeAt(0), o = n === d7 || n === q1 ? 1 : 0, s = o;
    for (; s < e.value.length && qc.isDigit(e.value.charCodeAt(s)); s++)
      ;
    return s === o || !tn.cmpChar(e.value, s, rn) ? 0 : s + 1 === e.value.length ? nn(t(++r), r, t) : e.value.charCodeAt(s + 1) !== q1 ? 0 : s + 2 === e.value.length ? (r = a7(t(++r), r, t), e = t(r), be(e, 0, Tt, r)) : be(e, s + 2, Tt, r);
  }
  return 0;
}
var WI = GI;
const VI = h0, Ze = R, XI = T0, YI = 43, Uc = 45, Hc = 63, KI = 117;
function xo(e, t) {
  return e !== null && e.type === Ze.Delim && e.value.charCodeAt(0) === t;
}
function QI(e, t) {
  return e.value.charCodeAt(0) === t;
}
function X3(e, t, r) {
  let n = 0;
  for (let o = t; o < e.value.length; o++) {
    const s = e.value.charCodeAt(o);
    if (s === Uc && r && n !== 0)
      return X3(e, t + n + 1, !1), 6;
    if (!VI.isHexDigit(s) || ++n > 6)
      return 0;
  }
  return n;
}
function zr(e, t, r) {
  if (!e)
    return 0;
  for (; xo(r(t), Hc); ) {
    if (++e > 6)
      return 0;
    t++;
  }
  return t;
}
function JI(e, t) {
  let r = 0;
  if (e === null || e.type !== Ze.Ident || !XI.cmpChar(e.value, 0, KI) || (e = t(++r), e === null))
    return 0;
  if (xo(e, YI))
    return e = t(++r), e === null ? 0 : e.type === Ze.Ident ? zr(X3(e, 0, !0), ++r, t) : xo(e, Hc) ? zr(1, ++r, t) : 0;
  if (e.type === Ze.Number) {
    const n = X3(e, 1, !0);
    return n === 0 ? 0 : (e = t(++r), e === null ? r : e.type === Ze.Dimension || e.type === Ze.Number ? !QI(e, Uc) || !X3(e, 1, !1) ? 0 : r + 1 : zr(n, r, t));
  }
  return e.type === Ze.Dimension ? zr(X3(e, 1, !0), ++r, t) : 0;
}
var e_ = JI;
const t_ = H9, r_ = WI, n_ = e_, F = R, e4 = h0, G9 = T0, o_ = ["calc(", "-moz-calc(", "-webkit-calc("], W9 = /* @__PURE__ */ new Map([
  [F.Function, F.RightParenthesis],
  [F.LeftParenthesis, F.RightParenthesis],
  [F.LeftSquareBracket, F.RightSquareBracket],
  [F.LeftCurlyBracket, F.RightCurlyBracket]
]);
function I1(e, t) {
  return t < e.length ? e.charCodeAt(t) : 0;
}
function Gc(e, t) {
  return G9.cmpStr(e, 0, e.length, t);
}
function Wc(e, t) {
  for (let r = 0; r < t.length; r++)
    if (Gc(e, t[r]))
      return !0;
  return !1;
}
function Vc(e, t) {
  return t !== e.length - 2 ? !1 : I1(e, t) === 92 && e4.isDigit(I1(e, t + 1));
}
function t4(e, t, r) {
  if (e && e.type === "Range") {
    const n = Number(
      r !== void 0 && r !== t.length ? t.substr(0, r) : t
    );
    if (isNaN(n) || e.min !== null && n < e.min && typeof e.min != "string" || e.max !== null && n > e.max && typeof e.max != "string")
      return !0;
  }
  return !1;
}
function s_(e, t) {
  let r = 0, n = [], o = 0;
  e:
    do {
      switch (e.type) {
        case F.RightCurlyBracket:
        case F.RightParenthesis:
        case F.RightSquareBracket:
          if (e.type !== r)
            break e;
          if (r = n.pop(), n.length === 0) {
            o++;
            break e;
          }
          break;
        case F.Function:
        case F.LeftParenthesis:
        case F.LeftSquareBracket:
        case F.LeftCurlyBracket:
          n.push(r), r = W9.get(e.type);
          break;
      }
      o++;
    } while (e = t(o));
  return o;
}
function L1(e) {
  return function(t, r, n) {
    return t === null ? 0 : t.type === F.Function && Wc(t.value, o_) ? s_(t, r) : e(t, r, n);
  };
}
function z0(e) {
  return function(t) {
    return t === null || t.type !== e ? 0 : 1;
  };
}
function i_(e) {
  if (e === null || e.type !== F.Ident)
    return 0;
  const t = e.value.toLowerCase();
  return Wc(t, t_.cssWideKeywords) || Gc(t, "default") ? 0 : 1;
}
function a_(e) {
  return e === null || e.type !== F.Ident || I1(e.value, 0) !== 45 || I1(e.value, 1) !== 45 ? 0 : 1;
}
function l_(e) {
  if (e === null || e.type !== F.Hash)
    return 0;
  const t = e.value.length;
  if (t !== 4 && t !== 5 && t !== 7 && t !== 9)
    return 0;
  for (let r = 1; r < t; r++)
    if (!e4.isHexDigit(I1(e.value, r)))
      return 0;
  return 1;
}
function c_(e) {
  return e === null || e.type !== F.Hash || !e4.isIdentifierStart(I1(e.value, 1), I1(e.value, 2), I1(e.value, 3)) ? 0 : 1;
}
function u_(e, t) {
  if (!e)
    return 0;
  let r = 0, n = [], o = 0;
  e:
    do {
      switch (e.type) {
        case F.BadString:
        case F.BadUrl:
          break e;
        case F.RightCurlyBracket:
        case F.RightParenthesis:
        case F.RightSquareBracket:
          if (e.type !== r)
            break e;
          r = n.pop();
          break;
        case F.Semicolon:
          if (r === 0)
            break e;
          break;
        case F.Delim:
          if (r === 0 && e.value === "!")
            break e;
          break;
        case F.Function:
        case F.LeftParenthesis:
        case F.LeftSquareBracket:
        case F.LeftCurlyBracket:
          n.push(r), r = W9.get(e.type);
          break;
      }
      o++;
    } while (e = t(o));
  return o;
}
function h_(e, t) {
  if (!e)
    return 0;
  let r = 0, n = [], o = 0;
  e:
    do {
      switch (e.type) {
        case F.BadString:
        case F.BadUrl:
          break e;
        case F.RightCurlyBracket:
        case F.RightParenthesis:
        case F.RightSquareBracket:
          if (e.type !== r)
            break e;
          r = n.pop();
          break;
        case F.Function:
        case F.LeftParenthesis:
        case F.LeftSquareBracket:
        case F.LeftCurlyBracket:
          n.push(r), r = W9.get(e.type);
          break;
      }
      o++;
    } while (e = t(o));
  return o;
}
function ne(e) {
  return e && (e = new Set(e)), function(t, r, n) {
    if (t === null || t.type !== F.Dimension)
      return 0;
    const o = G9.consumeNumber(t.value, 0);
    if (e !== null) {
      const s = t.value.indexOf("\\", o), i = s === -1 || !Vc(t.value, s) ? t.value.substr(o) : t.value.substring(o, s);
      if (e.has(i.toLowerCase()) === !1)
        return 0;
    }
    return t4(n, t.value, o) ? 0 : 1;
  };
}
function m_(e, t, r) {
  return e === null || e.type !== F.Percentage || t4(r, e.value, e.value.length - 1) ? 0 : 1;
}
function Xc(e) {
  return typeof e != "function" && (e = function() {
    return 0;
  }), function(t, r, n) {
    return t !== null && t.type === F.Number && Number(t.value) === 0 ? 1 : e(t, r, n);
  };
}
function f_(e, t, r) {
  if (e === null)
    return 0;
  const n = G9.consumeNumber(e.value, 0);
  return !(n === e.value.length) && !Vc(e.value, n) || t4(r, e.value, n) ? 0 : 1;
}
function d_(e, t, r) {
  if (e === null || e.type !== F.Number)
    return 0;
  let n = I1(e.value, 0) === 43 || I1(e.value, 0) === 45 ? 1 : 0;
  for (; n < e.value.length; n++)
    if (!e4.isDigit(I1(e.value, n)))
      return 0;
  return t4(r, e.value, n) ? 0 : 1;
}
const Yc = {
  "ident-token": z0(F.Ident),
  "function-token": z0(F.Function),
  "at-keyword-token": z0(F.AtKeyword),
  "hash-token": z0(F.Hash),
  "string-token": z0(F.String),
  "bad-string-token": z0(F.BadString),
  "url-token": z0(F.Url),
  "bad-url-token": z0(F.BadUrl),
  "delim-token": z0(F.Delim),
  "number-token": z0(F.Number),
  "percentage-token": z0(F.Percentage),
  "dimension-token": z0(F.Dimension),
  "whitespace-token": z0(F.WhiteSpace),
  "CDO-token": z0(F.CDO),
  "CDC-token": z0(F.CDC),
  "colon-token": z0(F.Colon),
  "semicolon-token": z0(F.Semicolon),
  "comma-token": z0(F.Comma),
  "[-token": z0(F.LeftSquareBracket),
  "]-token": z0(F.RightSquareBracket),
  "(-token": z0(F.LeftParenthesis),
  ")-token": z0(F.RightParenthesis),
  "{-token": z0(F.LeftCurlyBracket),
  "}-token": z0(F.RightCurlyBracket)
}, Kc = {
  string: z0(F.String),
  ident: z0(F.Ident),
  percentage: L1(m_),
  zero: Xc(),
  number: L1(f_),
  integer: L1(d_),
  "custom-ident": i_,
  "custom-property-name": a_,
  "hex-color": l_,
  "id-selector": c_,
  "an-plus-b": r_,
  urange: n_,
  "declaration-value": u_,
  "any-value": h_
};
function Qc(e) {
  const {
    angle: t,
    decibel: r,
    frequency: n,
    flex: o,
    length: s,
    resolution: i,
    semitones: l,
    time: c
  } = e || {};
  return {
    dimension: L1(ne(null)),
    angle: L1(ne(t)),
    decibel: L1(ne(r)),
    frequency: L1(ne(n)),
    flex: L1(ne(o)),
    length: L1(Xc(ne(s))),
    resolution: L1(ne(i)),
    semitones: L1(ne(l)),
    time: L1(ne(c))
  };
}
function p_(e) {
  return {
    ...Yc,
    ...Kc,
    ...Qc(e)
  };
}
D7.createDemensionTypes = Qc;
D7.createGenericTypes = p_;
D7.productionTypes = Kc;
D7.tokenTypes = Yc;
var de = {};
const g_ = [
  "cm",
  "mm",
  "q",
  "in",
  "pt",
  "pc",
  "px",
  "em",
  "rem",
  "ex",
  "rex",
  "cap",
  "rcap",
  "ch",
  "rch",
  "ic",
  "ric",
  "lh",
  "rlh",
  "vw",
  "svw",
  "lvw",
  "dvw",
  "vh",
  "svh",
  "lvh",
  "dvh",
  "vi",
  "svi",
  "lvi",
  "dvi",
  "vb",
  "svb",
  "lvb",
  "dvb",
  "vmin",
  "svmin",
  "lvmin",
  "dvmin",
  "vmax",
  "svmax",
  "lvmax",
  "dvmax",
  "cqw",
  "cqh",
  "cqi",
  "cqb",
  "cqmin",
  "cqmax"
], k_ = ["deg", "grad", "rad", "turn"], v_ = ["s", "ms"], y_ = ["hz", "khz"], b_ = ["dpi", "dpcm", "dppx", "x"], x_ = ["fr"], w_ = ["db"], L_ = ["st"];
de.angle = k_;
de.decibel = w_;
de.flex = x_;
de.frequency = y_;
de.length = g_;
de.resolution = b_;
de.semitones = L_;
de.time = v_;
const z_ = Z, C_ = {
  decorator(e) {
    const t = [];
    let r = null;
    return {
      ...e,
      node(n) {
        const o = r;
        r = n, e.node.call(this, n), r = o;
      },
      emit(n, o, s) {
        t.push({
          type: o,
          value: n,
          node: s ? null : r
        });
      },
      result() {
        return t;
      }
    };
  }
};
function S_(e) {
  const t = [];
  return z_.tokenize(
    e,
    (r, n, o) => t.push({
      type: r,
      value: e.slice(n, o),
      node: null
    })
  ), t;
}
function $_(e, t) {
  return typeof e == "string" ? S_(e) : t.generate(e, C_);
}
var A_ = $_, d2 = {}, r4 = {}, Jc = {}, V9 = {};
const M_ = Y8;
function j_(e, t, r) {
  return Object.assign(M_.createCustomError("SyntaxError", e), {
    input: t,
    offset: r,
    rawMessage: e,
    message: e + `
  ` + t + `
--` + new Array((r || t.length) + 1).join("-") + "^"
  });
}
V9.SyntaxError = j_;
const E_ = V9, T_ = 9, P_ = 10, N_ = 12, D_ = 13, O_ = 32;
class R_ {
  constructor(t) {
    this.str = t, this.pos = 0;
  }
  charCodeAt(t) {
    return t < this.str.length ? this.str.charCodeAt(t) : 0;
  }
  charCode() {
    return this.charCodeAt(this.pos);
  }
  nextCharCode() {
    return this.charCodeAt(this.pos + 1);
  }
  nextNonWsCode(t) {
    return this.charCodeAt(this.findWsEnd(t));
  }
  findWsEnd(t) {
    for (; t < this.str.length; t++) {
      const r = this.str.charCodeAt(t);
      if (r !== D_ && r !== P_ && r !== N_ && r !== O_ && r !== T_)
        break;
    }
    return t;
  }
  substringToPos(t) {
    return this.str.substring(this.pos, this.pos = t);
  }
  eat(t) {
    this.charCode() !== t && this.error("Expect `" + String.fromCharCode(t) + "`"), this.pos++;
  }
  peek() {
    return this.pos < this.str.length ? this.str.charAt(this.pos++) : "";
  }
  error(t) {
    throw new E_.SyntaxError(t, this.str, this.pos);
  }
}
Jc.Tokenizer = R_;
const I_ = Jc, __ = 9, F_ = 10, B_ = 12, Z_ = 13, q_ = 32, eu = 33, X9 = 35, Rs = 38, m8 = 39, tu = 40, U_ = 41, ru = 42, Y9 = 43, K9 = 44, Is = 45, Q9 = 60, nu = 62, wo = 63, H_ = 64, n4 = 91, J9 = 93, f8 = 123, _s = 124, Fs = 125, Bs = 8734, p7 = new Uint8Array(128).map(
  (e, t) => /[a-zA-Z0-9\-]/.test(String.fromCharCode(t)) ? 1 : 0
), Zs = {
  " ": 1,
  "&&": 2,
  "||": 3,
  "|": 4
};
function d8(e) {
  return e.substringToPos(
    e.findWsEnd(e.pos)
  );
}
function i2(e) {
  let t = e.pos;
  for (; t < e.str.length; t++) {
    const r = e.str.charCodeAt(t);
    if (r >= 128 || p7[r] === 0)
      break;
  }
  return e.pos === t && e.error("Expect a keyword"), e.substringToPos(t);
}
function p8(e) {
  let t = e.pos;
  for (; t < e.str.length; t++) {
    const r = e.str.charCodeAt(t);
    if (r < 48 || r > 57)
      break;
  }
  return e.pos === t && e.error("Expect a number"), e.substringToPos(t);
}
function G_(e) {
  const t = e.str.indexOf("'", e.pos + 1);
  return t === -1 && (e.pos = e.str.length, e.error("Expect an apostrophe")), e.substringToPos(t + 1);
}
function qs(e) {
  let t = null, r = null;
  return e.eat(f8), t = p8(e), e.charCode() === K9 ? (e.pos++, e.charCode() !== Fs && (r = p8(e))) : r = t, e.eat(Fs), {
    min: Number(t),
    max: r ? Number(r) : 0
  };
}
function W_(e) {
  let t = null, r = !1;
  switch (e.charCode()) {
    case ru:
      e.pos++, t = {
        min: 0,
        max: 0
      };
      break;
    case Y9:
      e.pos++, t = {
        min: 1,
        max: 0
      };
      break;
    case wo:
      e.pos++, t = {
        min: 0,
        max: 1
      };
      break;
    case X9:
      e.pos++, r = !0, e.charCode() === f8 ? t = qs(e) : e.charCode() === wo ? (e.pos++, t = {
        min: 0,
        max: 0
      }) : t = {
        min: 1,
        max: 0
      };
      break;
    case f8:
      t = qs(e);
      break;
    default:
      return null;
  }
  return {
    type: "Multiplier",
    comma: r,
    min: t.min,
    max: t.max,
    term: null
  };
}
function a2(e, t) {
  const r = W_(e);
  return r !== null ? (r.term = t, e.charCode() === X9 && e.charCodeAt(e.pos - 1) === Y9 ? a2(e, r) : r) : t;
}
function on(e) {
  const t = e.peek();
  return t === "" ? null : {
    type: "Token",
    value: t
  };
}
function V_(e) {
  let t;
  return e.eat(Q9), e.eat(m8), t = i2(e), e.eat(m8), e.eat(nu), a2(e, {
    type: "Property",
    name: t
  });
}
function X_(e) {
  let t = null, r = null, n = 1;
  return e.eat(n4), e.charCode() === Is && (e.peek(), n = -1), n == -1 && e.charCode() === Bs ? e.peek() : (t = n * Number(p8(e)), p7[e.charCode()] !== 0 && (t += i2(e))), d8(e), e.eat(K9), d8(e), e.charCode() === Bs ? e.peek() : (n = 1, e.charCode() === Is && (e.peek(), n = -1), r = n * Number(p8(e)), p7[e.charCode()] !== 0 && (r += i2(e))), e.eat(J9), {
    type: "Range",
    min: t,
    max: r
  };
}
function Y_(e) {
  let t, r = null;
  return e.eat(Q9), t = i2(e), e.charCode() === tu && e.nextCharCode() === U_ && (e.pos += 2, t += "()"), e.charCodeAt(e.findWsEnd(e.pos)) === n4 && (d8(e), r = X_(e)), e.eat(nu), a2(e, {
    type: "Type",
    name: t,
    opts: r
  });
}
function K_(e) {
  const t = i2(e);
  return e.charCode() === tu ? (e.pos++, {
    type: "Function",
    name: t
  }) : a2(e, {
    type: "Keyword",
    name: t
  });
}
function Q_(e, t) {
  function r(o, s) {
    return {
      type: "Group",
      terms: o,
      combinator: s,
      disallowEmpty: !1,
      explicit: !1
    };
  }
  let n;
  for (t = Object.keys(t).sort((o, s) => Zs[o] - Zs[s]); t.length > 0; ) {
    n = t.shift();
    let o = 0, s = 0;
    for (; o < e.length; o++) {
      const i = e[o];
      i.type === "Combinator" && (i.value === n ? (s === -1 && (s = o - 1), e.splice(o, 1), o--) : (s !== -1 && o - s > 1 && (e.splice(
        s,
        o - s,
        r(e.slice(s, o), n)
      ), o = s + 1), s = -1));
    }
    s !== -1 && t.length && e.splice(
      s,
      o - s,
      r(e.slice(s, o), n)
    );
  }
  return n;
}
function ou(e) {
  const t = [], r = {};
  let n, o = null, s = e.pos;
  for (; n = eF(e); )
    n.type !== "Spaces" && (n.type === "Combinator" ? ((o === null || o.type === "Combinator") && (e.pos = s, e.error("Unexpected combinator")), r[n.value] = !0) : o !== null && o.type !== "Combinator" && (r[" "] = !0, t.push({
      type: "Combinator",
      value: " "
    })), t.push(n), o = n, s = e.pos);
  return o !== null && o.type === "Combinator" && (e.pos -= s, e.error("Unexpected combinator")), {
    type: "Group",
    terms: t,
    combinator: Q_(t, r) || " ",
    disallowEmpty: !1,
    explicit: !1
  };
}
function J_(e) {
  let t;
  return e.eat(n4), t = ou(e), e.eat(J9), t.explicit = !0, e.charCode() === eu && (e.pos++, t.disallowEmpty = !0), t;
}
function eF(e) {
  let t = e.charCode();
  if (t < 128 && p7[t] === 1)
    return K_(e);
  switch (t) {
    case J9:
      break;
    case n4:
      return a2(e, J_(e));
    case Q9:
      return e.nextCharCode() === m8 ? V_(e) : Y_(e);
    case _s:
      return {
        type: "Combinator",
        value: e.substringToPos(
          e.pos + (e.nextCharCode() === _s ? 2 : 1)
        )
      };
    case Rs:
      return e.pos++, e.eat(Rs), {
        type: "Combinator",
        value: "&&"
      };
    case K9:
      return e.pos++, {
        type: "Comma"
      };
    case m8:
      return a2(e, {
        type: "String",
        value: G_(e)
      });
    case q_:
    case __:
    case F_:
    case Z_:
    case B_:
      return {
        type: "Spaces",
        value: d8(e)
      };
    case H_:
      return t = e.nextCharCode(), t < 128 && p7[t] === 1 ? (e.pos++, {
        type: "AtKeyword",
        name: i2(e)
      }) : on(e);
    case ru:
    case Y9:
    case wo:
    case X9:
    case eu:
      break;
    case f8:
      if (t = e.nextCharCode(), t < 48 || t > 57)
        return on(e);
      break;
    default:
      return on(e);
  }
}
function tF(e) {
  const t = new I_.Tokenizer(e), r = ou(t);
  return t.pos !== e.length && t.error("Unexpected input"), r.terms.length === 1 && r.terms[0].type === "Group" ? r.terms[0] : r;
}
r4.parse = tF;
const rF = r4, $0 = { type: "Match" }, G0 = { type: "Mismatch" }, e5 = { type: "DisallowEmpty" }, nF = 40, oF = 41;
function U0(e, t, r) {
  return t === $0 && r === G0 || e === $0 && t === $0 && r === $0 ? e : (e.type === "If" && e.else === G0 && t === $0 && (t = e.then, e = e.match), {
    type: "If",
    match: e,
    then: t,
    else: r
  });
}
function su(e) {
  return e.length > 2 && e.charCodeAt(e.length - 2) === nF && e.charCodeAt(e.length - 1) === oF;
}
function Us(e) {
  return e.type === "Keyword" || e.type === "AtKeyword" || e.type === "Function" || e.type === "Type" && su(e.name);
}
function Lo(e, t, r) {
  switch (e) {
    case " ": {
      let n = $0;
      for (let o = t.length - 1; o >= 0; o--) {
        const s = t[o];
        n = U0(
          s,
          n,
          G0
        );
      }
      return n;
    }
    case "|": {
      let n = G0, o = null;
      for (let s = t.length - 1; s >= 0; s--) {
        let i = t[s];
        if (Us(i) && (o === null && s > 0 && Us(t[s - 1]) && (o = /* @__PURE__ */ Object.create(null), n = U0(
          {
            type: "Enum",
            map: o
          },
          $0,
          n
        )), o !== null)) {
          const l = (su(i.name) ? i.name.slice(0, -1) : i.name).toLowerCase();
          if (!(l in o)) {
            o[l] = i;
            continue;
          }
        }
        o = null, n = U0(
          i,
          $0,
          n
        );
      }
      return n;
    }
    case "&&": {
      if (t.length > 5)
        return {
          type: "MatchOnce",
          terms: t,
          all: !0
        };
      let n = G0;
      for (let o = t.length - 1; o >= 0; o--) {
        const s = t[o];
        let i;
        t.length > 1 ? i = Lo(
          e,
          t.filter(function(l) {
            return l !== s;
          }),
          !1
        ) : i = $0, n = U0(
          s,
          i,
          n
        );
      }
      return n;
    }
    case "||": {
      if (t.length > 5)
        return {
          type: "MatchOnce",
          terms: t,
          all: !1
        };
      let n = r ? $0 : G0;
      for (let o = t.length - 1; o >= 0; o--) {
        const s = t[o];
        let i;
        t.length > 1 ? i = Lo(
          e,
          t.filter(function(l) {
            return l !== s;
          }),
          !0
        ) : i = $0, n = U0(
          s,
          i,
          n
        );
      }
      return n;
    }
  }
}
function sF(e) {
  let t = $0, r = t5(e.term);
  if (e.max === 0)
    r = U0(
      r,
      e5,
      G0
    ), t = U0(
      r,
      null,
      G0
    ), t.then = U0(
      $0,
      $0,
      t
    ), e.comma && (t.then.else = U0(
      { type: "Comma", syntax: e },
      t,
      G0
    ));
  else
    for (let n = e.min || 1; n <= e.max; n++)
      e.comma && t !== $0 && (t = U0(
        { type: "Comma", syntax: e },
        t,
        G0
      )), t = U0(
        r,
        U0(
          $0,
          $0,
          t
        ),
        G0
      );
  if (e.min === 0)
    t = U0(
      $0,
      $0,
      t
    );
  else
    for (let n = 0; n < e.min - 1; n++)
      e.comma && t !== $0 && (t = U0(
        { type: "Comma", syntax: e },
        t,
        G0
      )), t = U0(
        r,
        t,
        G0
      );
  return t;
}
function t5(e) {
  if (typeof e == "function")
    return {
      type: "Generic",
      fn: e
    };
  switch (e.type) {
    case "Group": {
      let t = Lo(
        e.combinator,
        e.terms.map(t5),
        !1
      );
      return e.disallowEmpty && (t = U0(
        t,
        e5,
        G0
      )), t;
    }
    case "Multiplier":
      return sF(e);
    case "Type":
    case "Property":
      return {
        type: e.type,
        name: e.name,
        syntax: e
      };
    case "Keyword":
      return {
        type: e.type,
        name: e.name.toLowerCase(),
        syntax: e
      };
    case "AtKeyword":
      return {
        type: e.type,
        name: "@" + e.name.toLowerCase(),
        syntax: e
      };
    case "Function":
      return {
        type: e.type,
        name: e.name.toLowerCase() + "(",
        syntax: e
      };
    case "String":
      return e.value.length === 3 ? {
        type: "Token",
        value: e.value.charAt(1),
        syntax: e
      } : {
        type: e.type,
        value: e.value.substr(1, e.value.length - 2).replace(/\\'/g, "'"),
        syntax: e
      };
    case "Token":
      return {
        type: e.type,
        value: e.value,
        syntax: e
      };
    case "Comma":
      return {
        type: e.type,
        syntax: e
      };
    default:
      throw new Error("Unknown node type:", e.type);
  }
}
function iF(e, t) {
  return typeof e == "string" && (e = rF.parse(e)), {
    type: "MatchGraph",
    match: t5(e),
    syntax: t || null,
    source: e
  };
}
d2.DISALLOW_EMPTY = e5;
d2.MATCH = $0;
d2.MISMATCH = G0;
d2.buildMatchGraph = iF;
var r5 = {};
const x0 = d2, e1 = R, { hasOwnProperty: Hs } = Object.prototype, aF = 0, lF = 1, g8 = 2, n5 = 3, Gs = "Match", cF = "Mismatch", uF = "Maximum iteration number exceeded (please fill an issue on https://github.com/csstree/csstree/issues)", Ws = 15e3;
function iu(e) {
  let t = null, r = null, n = e;
  for (; n !== null; )
    r = n.prev, n.prev = t, t = n, n = r;
  return t;
}
function sn(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++) {
    const n = t.charCodeAt(r);
    let o = e.charCodeAt(r);
    if (o >= 65 && o <= 90 && (o = o | 32), o !== n)
      return !1;
  }
  return !0;
}
function hF(e) {
  return e.type !== e1.Delim ? !1 : e.value !== "?";
}
function Vs(e) {
  return e === null ? !0 : e.type === e1.Comma || e.type === e1.Function || e.type === e1.LeftParenthesis || e.type === e1.LeftSquareBracket || e.type === e1.LeftCurlyBracket || hF(e);
}
function Xs(e) {
  return e === null ? !0 : e.type === e1.RightParenthesis || e.type === e1.RightSquareBracket || e.type === e1.RightCurlyBracket || e.type === e1.Delim && e.value === "/";
}
function au(e, t, r) {
  function n() {
    do
      L++, w = L < e.length ? e[L] : null;
    while (w !== null && (w.type === e1.WhiteSpace || w.type === e1.Comment));
  }
  function o(g) {
    const M = L + g;
    return M < e.length ? e[M] : null;
  }
  function s(g, M) {
    return {
      nextState: g,
      matchStack: C,
      syntaxStack: h,
      thenStack: m,
      tokenIndex: L,
      prev: M
    };
  }
  function i(g) {
    m = {
      nextState: g,
      matchStack: C,
      syntaxStack: h,
      prev: m
    };
  }
  function l(g) {
    f = s(g, f);
  }
  function c() {
    C = {
      type: lF,
      syntax: t.syntax,
      token: w,
      prev: C
    }, n(), d = null, L > A && (A = L);
  }
  function a() {
    h = {
      syntax: t.syntax,
      opts: t.syntax.opts || h !== null && h.opts || null,
      prev: h
    }, C = {
      type: g8,
      syntax: t.syntax,
      token: C.token,
      prev: C
    };
  }
  function u() {
    C.type === g8 ? C = C.prev : C = {
      type: n5,
      syntax: h.syntax,
      token: C.token,
      prev: C
    }, h = h.prev;
  }
  let h = null, m = null, f = null, d = null, k = 0, b = null, w = null, L = -1, A = 0, C = {
    type: aF,
    syntax: null,
    token: null,
    prev: null
  };
  for (n(); b === null && ++k < Ws; )
    switch (t.type) {
      case "Match":
        if (m === null) {
          if (w !== null && (L !== e.length - 1 || w.value !== "\\0" && w.value !== "\\9")) {
            t = x0.MISMATCH;
            break;
          }
          b = Gs;
          break;
        }
        if (t = m.nextState, t === x0.DISALLOW_EMPTY)
          if (m.matchStack === C) {
            t = x0.MISMATCH;
            break;
          } else
            t = x0.MATCH;
        for (; m.syntaxStack !== h; )
          u();
        m = m.prev;
        break;
      case "Mismatch":
        if (d !== null && d !== !1)
          (f === null || L > f.tokenIndex) && (f = d, d = !1);
        else if (f === null) {
          b = cF;
          break;
        }
        t = f.nextState, m = f.thenStack, h = f.syntaxStack, C = f.matchStack, L = f.tokenIndex, w = L < e.length ? e[L] : null, f = f.prev;
        break;
      case "MatchGraph":
        t = t.match;
        break;
      case "If":
        t.else !== x0.MISMATCH && l(t.else), t.then !== x0.MATCH && i(t.then), t = t.match;
        break;
      case "MatchOnce":
        t = {
          type: "MatchOnceBuffer",
          syntax: t,
          index: 0,
          mask: 0
        };
        break;
      case "MatchOnceBuffer": {
        const P = t.syntax.terms;
        if (t.index === P.length) {
          if (t.mask === 0 || t.syntax.all) {
            t = x0.MISMATCH;
            break;
          }
          t = x0.MATCH;
          break;
        }
        if (t.mask === (1 << P.length) - 1) {
          t = x0.MATCH;
          break;
        }
        for (; t.index < P.length; t.index++) {
          const x = 1 << t.index;
          if ((t.mask & x) === 0) {
            l(t), i({
              type: "AddMatchOnce",
              syntax: t.syntax,
              mask: t.mask | x
            }), t = P[t.index++];
            break;
          }
        }
        break;
      }
      case "AddMatchOnce":
        t = {
          type: "MatchOnceBuffer",
          syntax: t.syntax,
          index: 0,
          mask: t.mask
        };
        break;
      case "Enum":
        if (w !== null) {
          let P = w.value.toLowerCase();
          if (P.indexOf("\\") !== -1 && (P = P.replace(/\\[09].*$/, "")), Hs.call(t.map, P)) {
            t = t.map[P];
            break;
          }
        }
        t = x0.MISMATCH;
        break;
      case "Generic": {
        const P = h !== null ? h.opts : null, x = L + Math.floor(t.fn(w, o, P));
        if (!isNaN(x) && x > L) {
          for (; L < x; )
            c();
          t = x0.MATCH;
        } else
          t = x0.MISMATCH;
        break;
      }
      case "Type":
      case "Property": {
        const P = t.type === "Type" ? "types" : "properties", x = Hs.call(r, P) ? r[P][t.name] : null;
        if (!x || !x.match)
          throw new Error(
            "Bad syntax reference: " + (t.type === "Type" ? "<" + t.name + ">" : "<'" + t.name + "'>")
          );
        if (d !== !1 && w !== null && t.type === "Type" && (t.name === "custom-ident" && w.type === e1.Ident || t.name === "length" && w.value === "0")) {
          d === null && (d = s(t, f)), t = x0.MISMATCH;
          break;
        }
        a(), t = x.match;
        break;
      }
      case "Keyword": {
        const P = t.name;
        if (w !== null) {
          let x = w.value;
          if (x.indexOf("\\") !== -1 && (x = x.replace(/\\[09].*$/, "")), sn(x, P)) {
            c(), t = x0.MATCH;
            break;
          }
        }
        t = x0.MISMATCH;
        break;
      }
      case "AtKeyword":
      case "Function":
        if (w !== null && sn(w.value, t.name)) {
          c(), t = x0.MATCH;
          break;
        }
        t = x0.MISMATCH;
        break;
      case "Token":
        if (w !== null && w.value === t.value) {
          c(), t = x0.MATCH;
          break;
        }
        t = x0.MISMATCH;
        break;
      case "Comma":
        w !== null && w.type === e1.Comma ? Vs(C.token) ? t = x0.MISMATCH : (c(), t = Xs(w) ? x0.MISMATCH : x0.MATCH) : t = Vs(C.token) || Xs(w) ? x0.MATCH : x0.MISMATCH;
        break;
      case "String":
        let g = "", M = L;
        for (; M < e.length && g.length < t.value.length; M++)
          g += e[M].value;
        if (sn(g, t.value)) {
          for (; L < M; )
            c();
          t = x0.MATCH;
        } else
          t = x0.MISMATCH;
        break;
      default:
        throw new Error("Unknown node type: " + t.type);
    }
  switch (b) {
    case null:
      console.warn("[csstree-match] BREAK after " + Ws + " iterations"), b = uF, C = null;
      break;
    case Gs:
      for (; h !== null; )
        u();
      break;
    default:
      C = null;
  }
  return {
    tokens: e,
    reason: b,
    iterations: k,
    match: C,
    longestMatch: A
  };
}
function mF(e, t, r) {
  const n = au(e, t, r || {});
  if (n.match !== null) {
    let o = iu(n.match).prev;
    for (n.match = []; o !== null; ) {
      switch (o.type) {
        case g8:
        case n5:
          n.match.push({
            type: o.type,
            syntax: o.syntax
          });
          break;
        default:
          n.match.push({
            token: o.token.value,
            node: o.token.node
          });
          break;
      }
      o = o.prev;
    }
  }
  return n;
}
function fF(e, t, r) {
  const n = au(e, t, r || {});
  if (n.match === null)
    return n;
  let o = n.match, s = n.match = {
    syntax: t.syntax || null,
    match: []
  };
  const i = [s];
  for (o = iu(o).prev; o !== null; ) {
    switch (o.type) {
      case g8:
        s.match.push(s = {
          syntax: o.syntax,
          match: []
        }), i.push(s);
        break;
      case n5:
        i.pop(), s = i[i.length - 1];
        break;
      default:
        s.match.push({
          syntax: o.syntax || null,
          token: o.token.value,
          node: o.token.node
        });
    }
    o = o.prev;
  }
  return n;
}
r5.matchAsList = mF;
r5.matchAsTree = fF;
var O7 = {};
function lu(e) {
  function t(o) {
    return o === null ? !1 : o.type === "Type" || o.type === "Property" || o.type === "Keyword";
  }
  function r(o) {
    if (Array.isArray(o.match)) {
      for (let s = 0; s < o.match.length; s++)
        if (r(o.match[s]))
          return t(o.syntax) && n.unshift(o.syntax), !0;
    } else if (o.node === e)
      return n = t(o.syntax) ? [o.syntax] : [], !0;
    return !1;
  }
  let n = null;
  return this.matched !== null && r(this.matched), n;
}
function dF(e, t) {
  return o5(this, e, (r) => r.type === "Type" && r.name === t);
}
function pF(e, t) {
  return o5(this, e, (r) => r.type === "Property" && r.name === t);
}
function gF(e) {
  return o5(this, e, (t) => t.type === "Keyword");
}
function o5(e, t, r) {
  const n = lu.call(e, t);
  return n === null ? !1 : n.some(r);
}
O7.getTrace = lu;
O7.isKeyword = gF;
O7.isProperty = pF;
O7.isType = dF;
var cu = {};
const kF = rt;
function uu(e) {
  return "node" in e ? e.node : uu(e.match[0]);
}
function hu(e) {
  return "node" in e ? e.node : hu(e.match[e.match.length - 1]);
}
function vF(e, t, r, n, o) {
  function s(l) {
    if (l.syntax !== null && l.syntax.type === n && l.syntax.name === o) {
      const c = uu(l), a = hu(l);
      e.syntax.walk(t, function(u, h, m) {
        if (u === c) {
          const f = new kF.List();
          do {
            if (f.appendData(h.data), h.data === a)
              break;
            h = h.next;
          } while (h !== null);
          i.push({
            parent: m,
            nodes: f
          });
        }
      });
    }
    Array.isArray(l.match) && l.match.forEach(s);
  }
  const i = [];
  return r.matched !== null && s(r.matched), i;
}
cu.matchFragments = vF;
var mu = {};
const yF = rt, { hasOwnProperty: l7 } = Object.prototype;
function an(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && e >= 0;
}
function Ys(e) {
  return Boolean(e) && an(e.offset) && an(e.line) && an(e.column);
}
function bF(e, t) {
  return function(n, o) {
    if (!n || n.constructor !== Object)
      return o(n, "Type of node should be an Object");
    for (let s in n) {
      let i = !0;
      if (l7.call(n, s) !== !1) {
        if (s === "type")
          n.type !== e && o(n, "Wrong node type `" + n.type + "`, expected `" + e + "`");
        else if (s === "loc") {
          if (n.loc === null)
            continue;
          if (n.loc && n.loc.constructor === Object)
            if (typeof n.loc.source != "string")
              s += ".source";
            else if (!Ys(n.loc.start))
              s += ".start";
            else if (!Ys(n.loc.end))
              s += ".end";
            else
              continue;
          i = !1;
        } else if (t.hasOwnProperty(s)) {
          i = !1;
          for (let l = 0; !i && l < t[s].length; l++) {
            const c = t[s][l];
            switch (c) {
              case String:
                i = typeof n[s] == "string";
                break;
              case Boolean:
                i = typeof n[s] == "boolean";
                break;
              case null:
                i = n[s] === null;
                break;
              default:
                typeof c == "string" ? i = n[s] && n[s].type === c : Array.isArray(c) && (i = n[s] instanceof yF.List);
            }
          }
        } else
          o(n, "Unknown field `" + s + "` for " + e + " node type");
        i || o(n, "Bad value for `" + e + "." + s + "`");
      }
    }
    for (const s in t)
      l7.call(t, s) && l7.call(n, s) === !1 && o(n, "Field `" + e + "." + s + "` is missed");
  };
}
function xF(e, t) {
  const r = t.structure, n = {
    type: String,
    loc: !0
  }, o = {
    type: '"' + e + '"'
  };
  for (const s in r) {
    if (l7.call(r, s) === !1)
      continue;
    const i = [], l = n[s] = Array.isArray(r[s]) ? r[s].slice() : [r[s]];
    for (let c = 0; c < l.length; c++) {
      const a = l[c];
      if (a === String || a === Boolean)
        i.push(a.name);
      else if (a === null)
        i.push("null");
      else if (typeof a == "string")
        i.push("<" + a + ">");
      else if (Array.isArray(a))
        i.push("List");
      else
        throw new Error("Wrong value `" + a + "` in `" + e + "." + s + "` structure definition");
    }
    o[s] = i.join(" | ");
  }
  return {
    docs: o,
    check: bF(e, n)
  };
}
function wF(e) {
  const t = {};
  if (e.node) {
    for (const r in e.node)
      if (l7.call(e.node, r)) {
        const n = e.node[r];
        if (n.structure)
          t[r] = xF(r, n);
        else
          throw new Error("Missed `structure` field in `" + r + "` node type definition");
      }
  }
  return t;
}
mu.getStructureFromConfig = wF;
var s5 = {};
const Y3 = function() {
};
function Ks(e) {
  return typeof e == "function" ? e : Y3;
}
function LF(e, t, r) {
  function n(i) {
    switch (o.call(r, i), i.type) {
      case "Group":
        i.terms.forEach(n);
        break;
      case "Multiplier":
        n(i.term);
        break;
      case "Type":
      case "Property":
      case "Keyword":
      case "AtKeyword":
      case "Function":
      case "String":
      case "Token":
      case "Comma":
        break;
      default:
        throw new Error("Unknown type: " + i.type);
    }
    s.call(r, i);
  }
  let o = Y3, s = Y3;
  if (typeof t == "function" ? o = t : t && (o = Ks(t.enter), s = Ks(t.leave)), o === Y3 && s === Y3)
    throw new Error("Neither `enter` nor `leave` walker handler is set or both aren't a function");
  n(e);
}
s5.walk = LF;
const Zt = B9, E3 = nt, zF = H9, CF = D7, Qs = de, SF = A_, zo = d2, Js = r5, $F = O7, ei = cu, AF = mu, MF = r4, fu = J8, jF = s5, EF = zo.buildMatchGraph(zF.cssWideKeywords.join(" | "));
function Co(e, t, r) {
  const n = {};
  for (const o in e)
    e[o].syntax && (n[o] = r ? e[o].syntax : fu.generate(e[o].syntax, { compact: t }));
  return n;
}
function TF(e, t, r) {
  const n = {};
  for (const [o, s] of Object.entries(e))
    n[o] = {
      prelude: s.prelude && (r ? s.prelude.syntax : fu.generate(s.prelude.syntax, { compact: t })),
      descriptors: s.descriptors && Co(s.descriptors, t, r)
    };
  return n;
}
function PF(e) {
  for (let t = 0; t < e.length; t++)
    if (e[t].value.toLowerCase() === "var(")
      return !0;
  return !1;
}
function E1(e, t, r) {
  return {
    matched: e,
    iterations: r,
    error: t,
    ...$F
  };
}
function Pt(e, t, r, n) {
  const o = SF(r, e.syntax);
  let s;
  return PF(o) ? E1(null, new Error("Matching for a tree with var() is not supported")) : (n && (s = Js.matchAsTree(o, e.cssWideKeywordsSyntax, e)), (!n || !s.match) && (s = Js.matchAsTree(o, t.match, e), !s.match) ? E1(
    null,
    new Zt.SyntaxMatchError(s.reason, t.syntax, r, s),
    s.iterations
  ) : E1(s.match, null, s.iterations));
}
class NF {
  constructor(t, r, n) {
    if (this.cssWideKeywordsSyntax = EF, this.syntax = r, this.generic = !1, this.units = { ...Qs }, this.atrules = /* @__PURE__ */ Object.create(null), this.properties = /* @__PURE__ */ Object.create(null), this.types = /* @__PURE__ */ Object.create(null), this.structure = n || AF.getStructureFromConfig(t), t) {
      if (t.units)
        for (const o of Object.keys(Qs))
          Array.isArray(t.units[o]) && (this.units[o] = t.units[o]);
      if (t.types)
        for (const o in t.types)
          this.addType_(o, t.types[o]);
      if (t.generic) {
        this.generic = !0;
        for (const [o, s] of Object.entries(CF.createGenericTypes(this.units)))
          this.addType_(o, s);
      }
      if (t.atrules)
        for (const o in t.atrules)
          this.addAtrule_(o, t.atrules[o]);
      if (t.properties)
        for (const o in t.properties)
          this.addProperty_(o, t.properties[o]);
    }
  }
  checkStructure(t) {
    function r(s, i) {
      o.push({ node: s, message: i });
    }
    const n = this.structure, o = [];
    return this.syntax.walk(t, function(s) {
      n.hasOwnProperty(s.type) ? n[s.type].check(s, r) : r(s, "Unknown node type `" + s.type + "`");
    }), o.length ? o : !1;
  }
  createDescriptor(t, r, n, o = null) {
    const s = {
      type: r,
      name: n
    }, i = {
      type: r,
      name: n,
      parent: o,
      serializable: typeof t == "string" || t && typeof t.type == "string",
      syntax: null,
      match: null
    };
    return typeof t == "function" ? i.match = zo.buildMatchGraph(t, s) : (typeof t == "string" ? Object.defineProperty(i, "syntax", {
      get() {
        return Object.defineProperty(i, "syntax", {
          value: MF.parse(t)
        }), i.syntax;
      }
    }) : i.syntax = t, Object.defineProperty(i, "match", {
      get() {
        return Object.defineProperty(i, "match", {
          value: zo.buildMatchGraph(i.syntax, s)
        }), i.match;
      }
    })), i;
  }
  addAtrule_(t, r) {
    !r || (this.atrules[t] = {
      type: "Atrule",
      name: t,
      prelude: r.prelude ? this.createDescriptor(r.prelude, "AtrulePrelude", t) : null,
      descriptors: r.descriptors ? Object.keys(r.descriptors).reduce(
        (n, o) => (n[o] = this.createDescriptor(r.descriptors[o], "AtruleDescriptor", o, t), n),
        /* @__PURE__ */ Object.create(null)
      ) : null
    });
  }
  addProperty_(t, r) {
    !r || (this.properties[t] = this.createDescriptor(r, "Property", t));
  }
  addType_(t, r) {
    !r || (this.types[t] = this.createDescriptor(r, "Type", t));
  }
  checkAtruleName(t) {
    if (!this.getAtrule(t))
      return new Zt.SyntaxReferenceError("Unknown at-rule", "@" + t);
  }
  checkAtrulePrelude(t, r) {
    const n = this.checkAtruleName(t);
    if (n)
      return n;
    const o = this.getAtrule(t);
    if (!o.prelude && r)
      return new SyntaxError("At-rule `@" + t + "` should not contain a prelude");
    if (o.prelude && !r && !Pt(this, o.prelude, "", !1).matched)
      return new SyntaxError("At-rule `@" + t + "` should contain a prelude");
  }
  checkAtruleDescriptorName(t, r) {
    const n = this.checkAtruleName(t);
    if (n)
      return n;
    const o = this.getAtrule(t), s = E3.keyword(r);
    if (!o.descriptors)
      return new SyntaxError("At-rule `@" + t + "` has no known descriptors");
    if (!o.descriptors[s.name] && !o.descriptors[s.basename])
      return new Zt.SyntaxReferenceError("Unknown at-rule descriptor", r);
  }
  checkPropertyName(t) {
    if (!this.getProperty(t))
      return new Zt.SyntaxReferenceError("Unknown property", t);
  }
  matchAtrulePrelude(t, r) {
    const n = this.checkAtrulePrelude(t, r);
    if (n)
      return E1(null, n);
    const o = this.getAtrule(t);
    return o.prelude ? Pt(this, o.prelude, r || "", !1) : E1(null, null);
  }
  matchAtruleDescriptor(t, r, n) {
    const o = this.checkAtruleDescriptorName(t, r);
    if (o)
      return E1(null, o);
    const s = this.getAtrule(t), i = E3.keyword(r);
    return Pt(this, s.descriptors[i.name] || s.descriptors[i.basename], n, !1);
  }
  matchDeclaration(t) {
    return t.type !== "Declaration" ? E1(null, new Error("Not a Declaration node")) : this.matchProperty(t.property, t.value);
  }
  matchProperty(t, r) {
    if (E3.property(t).custom)
      return E1(null, new Error("Lexer matching doesn't applicable for custom properties"));
    const n = this.checkPropertyName(t);
    return n ? E1(null, n) : Pt(this, this.getProperty(t), r, !0);
  }
  matchType(t, r) {
    const n = this.getType(t);
    return n ? Pt(this, n, r, !1) : E1(null, new Zt.SyntaxReferenceError("Unknown type", t));
  }
  match(t, r) {
    return typeof t != "string" && (!t || !t.type) ? E1(null, new Zt.SyntaxReferenceError("Bad syntax")) : ((typeof t == "string" || !t.match) && (t = this.createDescriptor(t, "Type", "anonymous")), Pt(this, t, r, !1));
  }
  findValueFragments(t, r, n, o) {
    return ei.matchFragments(this, r, this.matchProperty(t, r), n, o);
  }
  findDeclarationValueFragments(t, r, n) {
    return ei.matchFragments(this, t.value, this.matchDeclaration(t), r, n);
  }
  findAllFragments(t, r, n) {
    const o = [];
    return this.syntax.walk(t, {
      visit: "Declaration",
      enter: (s) => {
        o.push.apply(o, this.findDeclarationValueFragments(s, r, n));
      }
    }), o;
  }
  getAtrule(t, r = !0) {
    const n = E3.keyword(t);
    return (n.vendor && r ? this.atrules[n.name] || this.atrules[n.basename] : this.atrules[n.name]) || null;
  }
  getAtrulePrelude(t, r = !0) {
    const n = this.getAtrule(t, r);
    return n && n.prelude || null;
  }
  getAtruleDescriptor(t, r) {
    return this.atrules.hasOwnProperty(t) && this.atrules.declarators && this.atrules[t].declarators[r] || null;
  }
  getProperty(t, r = !0) {
    const n = E3.property(t);
    return (n.vendor && r ? this.properties[n.name] || this.properties[n.basename] : this.properties[n.name]) || null;
  }
  getType(t) {
    return hasOwnProperty.call(this.types, t) ? this.types[t] : null;
  }
  validate() {
    function t(o, s, i, l) {
      if (i.has(s))
        return i.get(s);
      i.set(s, !1), l.syntax !== null && jF.walk(l.syntax, function(c) {
        if (c.type !== "Type" && c.type !== "Property")
          return;
        const a = c.type === "Type" ? o.types : o.properties, u = c.type === "Type" ? r : n;
        (!hasOwnProperty.call(a, c.name) || t(o, c.name, u, a[c.name])) && i.set(s, !0);
      }, this);
    }
    let r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
    for (const o in this.types)
      t(this, o, r, this.types[o]);
    for (const o in this.properties)
      t(this, o, n, this.properties[o]);
    return r = [...r.keys()].filter((o) => r.get(o)), n = [...n.keys()].filter((o) => n.get(o)), r.length || n.length ? {
      types: r,
      properties: n
    } : null;
  }
  dump(t, r) {
    return {
      generic: this.generic,
      units: this.units,
      types: Co(this.types, !r, t),
      properties: Co(this.properties, !r, t),
      atrules: TF(this.atrules, !r, t)
    };
  }
  toString() {
    return JSON.stringify(this.dump());
  }
}
F9.Lexer = NF;
function ln(e, t) {
  return typeof t == "string" && /^\s*\|/.test(t) ? typeof e == "string" ? e + t : t.replace(/^\s*\|\s*/, "") : t || null;
}
function ti(e, t) {
  const r = /* @__PURE__ */ Object.create(null);
  for (const [n, o] of Object.entries(e))
    if (o) {
      r[n] = {};
      for (const s of Object.keys(o))
        t.includes(s) && (r[n][s] = o[s]);
    }
  return r;
}
function DF(e, t) {
  const r = { ...e };
  for (const [n, o] of Object.entries(t))
    switch (n) {
      case "generic":
        r[n] = Boolean(o);
        break;
      case "units":
        r[n] = { ...e[n] };
        for (const [s, i] of Object.entries(o))
          r[n][s] = Array.isArray(i) ? i : [];
        break;
      case "atrules":
        r[n] = { ...e[n] };
        for (const [s, i] of Object.entries(o)) {
          const l = r[n][s] || {}, c = r[n][s] = {
            prelude: l.prelude || null,
            descriptors: {
              ...l.descriptors
            }
          };
          if (!!i) {
            c.prelude = i.prelude ? ln(c.prelude, i.prelude) : c.prelude || null;
            for (const [a, u] of Object.entries(i.descriptors || {}))
              c.descriptors[a] = u ? ln(c.descriptors[a], u) : null;
            Object.keys(c.descriptors).length || (c.descriptors = null);
          }
        }
        break;
      case "types":
      case "properties":
        r[n] = { ...e[n] };
        for (const [s, i] of Object.entries(o))
          r[n][s] = ln(r[n][s], i);
        break;
      case "scope":
        r[n] = { ...e[n] };
        for (const [s, i] of Object.entries(o))
          r[n][s] = { ...r[n][s], ...i };
        break;
      case "parseContext":
        r[n] = {
          ...e[n],
          ...o
        };
        break;
      case "atrule":
      case "pseudo":
        r[n] = {
          ...e[n],
          ...ti(o, ["parse"])
        };
        break;
      case "node":
        r[n] = {
          ...e[n],
          ...ti(o, ["name", "structure", "parse", "generate", "walkContext"])
        };
        break;
    }
  return r;
}
var OF = DF;
const RF = Z, IF = Sc, _F = Mc, FF = Fc, BF = Bc, ri = F9, So = OF;
function du(e) {
  const t = IF.createParser(e), r = BF.createWalker(e), n = _F.createGenerator(e), { fromPlainObject: o, toPlainObject: s } = FF.createConvertor(r), i = {
    lexer: null,
    createLexer: (l) => new ri.Lexer(l, i, i.lexer.structure),
    tokenize: RF.tokenize,
    parse: t,
    generate: n,
    walk: r,
    find: r.find,
    findLast: r.findLast,
    findAll: r.findAll,
    fromPlainObject: o,
    toPlainObject: s,
    fork(l) {
      const c = So({}, e);
      return du(
        typeof l == "function" ? l(c, Object.assign) : So(c, l)
      );
    }
  };
  return i.lexer = new ri.Lexer({
    generic: !0,
    units: e.units,
    types: e.types,
    atrules: e.atrules,
    properties: e.properties,
    node: e.node
  }, i), i;
}
const ZF = (e) => du(So({}, e));
var pu = ZF, qF = {
  generic: !0,
  units: {
    angle: [
      "deg",
      "grad",
      "rad",
      "turn"
    ],
    decibel: [
      "db"
    ],
    flex: [
      "fr"
    ],
    frequency: [
      "hz",
      "khz"
    ],
    length: [
      "cm",
      "mm",
      "q",
      "in",
      "pt",
      "pc",
      "px",
      "em",
      "rem",
      "ex",
      "rex",
      "cap",
      "rcap",
      "ch",
      "rch",
      "ic",
      "ric",
      "lh",
      "rlh",
      "vw",
      "svw",
      "lvw",
      "dvw",
      "vh",
      "svh",
      "lvh",
      "dvh",
      "vi",
      "svi",
      "lvi",
      "dvi",
      "vb",
      "svb",
      "lvb",
      "dvb",
      "vmin",
      "svmin",
      "lvmin",
      "dvmin",
      "vmax",
      "svmax",
      "lvmax",
      "dvmax",
      "cqw",
      "cqh",
      "cqi",
      "cqb",
      "cqmin",
      "cqmax"
    ],
    resolution: [
      "dpi",
      "dpcm",
      "dppx",
      "x"
    ],
    semitones: [
      "st"
    ],
    time: [
      "s",
      "ms"
    ]
  },
  types: {
    "abs()": "abs( <calc-sum> )",
    "absolute-size": "xx-small|x-small|small|medium|large|x-large|xx-large|xxx-large",
    "acos()": "acos( <calc-sum> )",
    "alpha-value": "<number>|<percentage>",
    "angle-percentage": "<angle>|<percentage>",
    "angular-color-hint": "<angle-percentage>",
    "angular-color-stop": "<color>&&<color-stop-angle>?",
    "angular-color-stop-list": "[<angular-color-stop> [, <angular-color-hint>]?]# , <angular-color-stop>",
    "animateable-feature": "scroll-position|contents|<custom-ident>",
    "asin()": "asin( <calc-sum> )",
    "atan()": "atan( <calc-sum> )",
    "atan2()": "atan2( <calc-sum> , <calc-sum> )",
    attachment: "scroll|fixed|local",
    "attr()": "attr( <attr-name> <type-or-unit>? [, <attr-fallback>]? )",
    "attr-matcher": "['~'|'|'|'^'|'$'|'*']? '='",
    "attr-modifier": "i|s",
    "attribute-selector": "'[' <wq-name> ']'|'[' <wq-name> <attr-matcher> [<string-token>|<ident-token>] <attr-modifier>? ']'",
    "auto-repeat": "repeat( [auto-fill|auto-fit] , [<line-names>? <fixed-size>]+ <line-names>? )",
    "auto-track-list": "[<line-names>? [<fixed-size>|<fixed-repeat>]]* <line-names>? <auto-repeat> [<line-names>? [<fixed-size>|<fixed-repeat>]]* <line-names>?",
    axis: "block|inline|vertical|horizontal",
    "baseline-position": "[first|last]? baseline",
    "basic-shape": "<inset()>|<circle()>|<ellipse()>|<polygon()>|<path()>",
    "bg-image": "none|<image>",
    "bg-layer": "<bg-image>||<bg-position> [/ <bg-size>]?||<repeat-style>||<attachment>||<box>||<box>",
    "bg-position": "[[left|center|right|top|bottom|<length-percentage>]|[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]|[center|[left|right] <length-percentage>?]&&[center|[top|bottom] <length-percentage>?]]",
    "bg-size": "[<length-percentage>|auto]{1,2}|cover|contain",
    "blur()": "blur( <length> )",
    "blend-mode": "normal|multiply|screen|overlay|darken|lighten|color-dodge|color-burn|hard-light|soft-light|difference|exclusion|hue|saturation|color|luminosity",
    box: "border-box|padding-box|content-box",
    "brightness()": "brightness( <number-percentage> )",
    "calc()": "calc( <calc-sum> )",
    "calc-sum": "<calc-product> [['+'|'-'] <calc-product>]*",
    "calc-product": "<calc-value> ['*' <calc-value>|'/' <number>]*",
    "calc-value": "<number>|<dimension>|<percentage>|<calc-constant>|( <calc-sum> )",
    "calc-constant": "e|pi|infinity|-infinity|NaN",
    "cf-final-image": "<image>|<color>",
    "cf-mixing-image": "<percentage>?&&<image>",
    "circle()": "circle( [<shape-radius>]? [at <position>]? )",
    "clamp()": "clamp( <calc-sum>#{3} )",
    "class-selector": "'.' <ident-token>",
    "clip-source": "<url>",
    color: "<rgb()>|<rgba()>|<hsl()>|<hsla()>|<hwb()>|<lab()>|<lch()>|<hex-color>|<named-color>|currentcolor|<deprecated-system-color>",
    "color-stop": "<color-stop-length>|<color-stop-angle>",
    "color-stop-angle": "<angle-percentage>{1,2}",
    "color-stop-length": "<length-percentage>{1,2}",
    "color-stop-list": "[<linear-color-stop> [, <linear-color-hint>]?]# , <linear-color-stop>",
    combinator: "'>'|'+'|'~'|['||']",
    "common-lig-values": "[common-ligatures|no-common-ligatures]",
    "compat-auto": "searchfield|textarea|push-button|slider-horizontal|checkbox|radio|square-button|menulist|listbox|meter|progress-bar|button",
    "composite-style": "clear|copy|source-over|source-in|source-out|source-atop|destination-over|destination-in|destination-out|destination-atop|xor",
    "compositing-operator": "add|subtract|intersect|exclude",
    "compound-selector": "[<type-selector>? <subclass-selector>* [<pseudo-element-selector> <pseudo-class-selector>*]*]!",
    "compound-selector-list": "<compound-selector>#",
    "complex-selector": "<compound-selector> [<combinator>? <compound-selector>]*",
    "complex-selector-list": "<complex-selector>#",
    "conic-gradient()": "conic-gradient( [from <angle>]? [at <position>]? , <angular-color-stop-list> )",
    "contextual-alt-values": "[contextual|no-contextual]",
    "content-distribution": "space-between|space-around|space-evenly|stretch",
    "content-list": "[<string>|contents|<image>|<counter>|<quote>|<target>|<leader()>|<attr()>]+",
    "content-position": "center|start|end|flex-start|flex-end",
    "content-replacement": "<image>",
    "contrast()": "contrast( [<number-percentage>] )",
    "cos()": "cos( <calc-sum> )",
    counter: "<counter()>|<counters()>",
    "counter()": "counter( <counter-name> , <counter-style>? )",
    "counter-name": "<custom-ident>",
    "counter-style": "<counter-style-name>|symbols( )",
    "counter-style-name": "<custom-ident>",
    "counters()": "counters( <counter-name> , <string> , <counter-style>? )",
    "cross-fade()": "cross-fade( <cf-mixing-image> , <cf-final-image>? )",
    "cubic-bezier-timing-function": "ease|ease-in|ease-out|ease-in-out|cubic-bezier( <number [0,1]> , <number> , <number [0,1]> , <number> )",
    "deprecated-system-color": "ActiveBorder|ActiveCaption|AppWorkspace|Background|ButtonFace|ButtonHighlight|ButtonShadow|ButtonText|CaptionText|GrayText|Highlight|HighlightText|InactiveBorder|InactiveCaption|InactiveCaptionText|InfoBackground|InfoText|Menu|MenuText|Scrollbar|ThreeDDarkShadow|ThreeDFace|ThreeDHighlight|ThreeDLightShadow|ThreeDShadow|Window|WindowFrame|WindowText",
    "discretionary-lig-values": "[discretionary-ligatures|no-discretionary-ligatures]",
    "display-box": "contents|none",
    "display-inside": "flow|flow-root|table|flex|grid|ruby",
    "display-internal": "table-row-group|table-header-group|table-footer-group|table-row|table-cell|table-column-group|table-column|table-caption|ruby-base|ruby-text|ruby-base-container|ruby-text-container",
    "display-legacy": "inline-block|inline-list-item|inline-table|inline-flex|inline-grid",
    "display-listitem": "<display-outside>?&&[flow|flow-root]?&&list-item",
    "display-outside": "block|inline|run-in",
    "drop-shadow()": "drop-shadow( <length>{2,3} <color>? )",
    "east-asian-variant-values": "[jis78|jis83|jis90|jis04|simplified|traditional]",
    "east-asian-width-values": "[full-width|proportional-width]",
    "element()": "element( <custom-ident> , [first|start|last|first-except]? )|element( <id-selector> )",
    "ellipse()": "ellipse( [<shape-radius>{2}]? [at <position>]? )",
    "ending-shape": "circle|ellipse",
    "env()": "env( <custom-ident> , <declaration-value>? )",
    "exp()": "exp( <calc-sum> )",
    "explicit-track-list": "[<line-names>? <track-size>]+ <line-names>?",
    "family-name": "<string>|<custom-ident>+",
    "feature-tag-value": "<string> [<integer>|on|off]?",
    "feature-type": "@stylistic|@historical-forms|@styleset|@character-variant|@swash|@ornaments|@annotation",
    "feature-value-block": "<feature-type> '{' <feature-value-declaration-list> '}'",
    "feature-value-block-list": "<feature-value-block>+",
    "feature-value-declaration": "<custom-ident> : <integer>+ ;",
    "feature-value-declaration-list": "<feature-value-declaration>",
    "feature-value-name": "<custom-ident>",
    "fill-rule": "nonzero|evenodd",
    "filter-function": "<blur()>|<brightness()>|<contrast()>|<drop-shadow()>|<grayscale()>|<hue-rotate()>|<invert()>|<opacity()>|<saturate()>|<sepia()>",
    "filter-function-list": "[<filter-function>|<url>]+",
    "final-bg-layer": "<'background-color'>||<bg-image>||<bg-position> [/ <bg-size>]?||<repeat-style>||<attachment>||<box>||<box>",
    "fixed-breadth": "<length-percentage>",
    "fixed-repeat": "repeat( [<integer [1,\u221E]>] , [<line-names>? <fixed-size>]+ <line-names>? )",
    "fixed-size": "<fixed-breadth>|minmax( <fixed-breadth> , <track-breadth> )|minmax( <inflexible-breadth> , <fixed-breadth> )",
    "font-stretch-absolute": "normal|ultra-condensed|extra-condensed|condensed|semi-condensed|semi-expanded|expanded|extra-expanded|ultra-expanded|<percentage>",
    "font-variant-css21": "[normal|small-caps]",
    "font-weight-absolute": "normal|bold|<number [1,1000]>",
    "frequency-percentage": "<frequency>|<percentage>",
    "general-enclosed": "[<function-token> <any-value> )]|( <ident> <any-value> )",
    "generic-family": "serif|sans-serif|cursive|fantasy|monospace|-apple-system",
    "generic-name": "serif|sans-serif|cursive|fantasy|monospace",
    "geometry-box": "<shape-box>|fill-box|stroke-box|view-box",
    gradient: "<linear-gradient()>|<repeating-linear-gradient()>|<radial-gradient()>|<repeating-radial-gradient()>|<conic-gradient()>|<repeating-conic-gradient()>|<-legacy-gradient>",
    "grayscale()": "grayscale( <number-percentage> )",
    "grid-line": "auto|<custom-ident>|[<integer>&&<custom-ident>?]|[span&&[<integer>||<custom-ident>]]",
    "historical-lig-values": "[historical-ligatures|no-historical-ligatures]",
    "hsl()": "hsl( <hue> <percentage> <percentage> [/ <alpha-value>]? )|hsl( <hue> , <percentage> , <percentage> , <alpha-value>? )",
    "hsla()": "hsla( <hue> <percentage> <percentage> [/ <alpha-value>]? )|hsla( <hue> , <percentage> , <percentage> , <alpha-value>? )",
    hue: "<number>|<angle>",
    "hue-rotate()": "hue-rotate( <angle> )",
    "hwb()": "hwb( [<hue>|none] [<percentage>|none] [<percentage>|none] [/ [<alpha-value>|none]]? )",
    "hypot()": "hypot( <calc-sum># )",
    image: "<url>|<image()>|<image-set()>|<element()>|<paint()>|<cross-fade()>|<gradient>",
    "image()": "image( <image-tags>? [<image-src>? , <color>?]! )",
    "image-set()": "image-set( <image-set-option># )",
    "image-set-option": "[<image>|<string>] [<resolution>||type( <string> )]",
    "image-src": "<url>|<string>",
    "image-tags": "ltr|rtl",
    "inflexible-breadth": "<length-percentage>|min-content|max-content|auto",
    "inset()": "inset( <length-percentage>{1,4} [round <'border-radius'>]? )",
    "invert()": "invert( <number-percentage> )",
    "keyframes-name": "<custom-ident>|<string>",
    "keyframe-block": "<keyframe-selector># { <declaration-list> }",
    "keyframe-block-list": "<keyframe-block>+",
    "keyframe-selector": "from|to|<percentage>",
    "lab()": "lab( [<percentage>|<number>|none] [<percentage>|<number>|none] [<percentage>|<number>|none] [/ [<alpha-value>|none]]? )",
    "layer()": "layer( <layer-name> )",
    "layer-name": "<ident> ['.' <ident>]*",
    "lch()": "lch( [<percentage>|<number>|none] [<percentage>|<number>|none] [<hue>|none] [/ [<alpha-value>|none]]? )",
    "leader()": "leader( <leader-type> )",
    "leader-type": "dotted|solid|space|<string>",
    "length-percentage": "<length>|<percentage>",
    "line-names": "'[' <custom-ident>* ']'",
    "line-name-list": "[<line-names>|<name-repeat>]+",
    "line-style": "none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset",
    "line-width": "<length>|thin|medium|thick",
    "linear-color-hint": "<length-percentage>",
    "linear-color-stop": "<color> <color-stop-length>?",
    "linear-gradient()": "linear-gradient( [<angle>|to <side-or-corner>]? , <color-stop-list> )",
    "log()": "log( <calc-sum> , <calc-sum>? )",
    "mask-layer": "<mask-reference>||<position> [/ <bg-size>]?||<repeat-style>||<geometry-box>||[<geometry-box>|no-clip]||<compositing-operator>||<masking-mode>",
    "mask-position": "[<length-percentage>|left|center|right] [<length-percentage>|top|center|bottom]?",
    "mask-reference": "none|<image>|<mask-source>",
    "mask-source": "<url>",
    "masking-mode": "alpha|luminance|match-source",
    "matrix()": "matrix( <number>#{6} )",
    "matrix3d()": "matrix3d( <number>#{16} )",
    "max()": "max( <calc-sum># )",
    "media-and": "<media-in-parens> [and <media-in-parens>]+",
    "media-condition": "<media-not>|<media-and>|<media-or>|<media-in-parens>",
    "media-condition-without-or": "<media-not>|<media-and>|<media-in-parens>",
    "media-feature": "( [<mf-plain>|<mf-boolean>|<mf-range>] )",
    "media-in-parens": "( <media-condition> )|<media-feature>|<general-enclosed>",
    "media-not": "not <media-in-parens>",
    "media-or": "<media-in-parens> [or <media-in-parens>]+",
    "media-query": "<media-condition>|[not|only]? <media-type> [and <media-condition-without-or>]?",
    "media-query-list": "<media-query>#",
    "media-type": "<ident>",
    "mf-boolean": "<mf-name>",
    "mf-name": "<ident>",
    "mf-plain": "<mf-name> : <mf-value>",
    "mf-range": "<mf-name> ['<'|'>']? '='? <mf-value>|<mf-value> ['<'|'>']? '='? <mf-name>|<mf-value> '<' '='? <mf-name> '<' '='? <mf-value>|<mf-value> '>' '='? <mf-name> '>' '='? <mf-value>",
    "mf-value": "<number>|<dimension>|<ident>|<ratio>",
    "min()": "min( <calc-sum># )",
    "minmax()": "minmax( [<length-percentage>|min-content|max-content|auto] , [<length-percentage>|<flex>|min-content|max-content|auto] )",
    "mod()": "mod( <calc-sum> , <calc-sum> )",
    "name-repeat": "repeat( [<integer [1,\u221E]>|auto-fill] , <line-names>+ )",
    "named-color": "transparent|aliceblue|antiquewhite|aqua|aquamarine|azure|beige|bisque|black|blanchedalmond|blue|blueviolet|brown|burlywood|cadetblue|chartreuse|chocolate|coral|cornflowerblue|cornsilk|crimson|cyan|darkblue|darkcyan|darkgoldenrod|darkgray|darkgreen|darkgrey|darkkhaki|darkmagenta|darkolivegreen|darkorange|darkorchid|darkred|darksalmon|darkseagreen|darkslateblue|darkslategray|darkslategrey|darkturquoise|darkviolet|deeppink|deepskyblue|dimgray|dimgrey|dodgerblue|firebrick|floralwhite|forestgreen|fuchsia|gainsboro|ghostwhite|gold|goldenrod|gray|green|greenyellow|grey|honeydew|hotpink|indianred|indigo|ivory|khaki|lavender|lavenderblush|lawngreen|lemonchiffon|lightblue|lightcoral|lightcyan|lightgoldenrodyellow|lightgray|lightgreen|lightgrey|lightpink|lightsalmon|lightseagreen|lightskyblue|lightslategray|lightslategrey|lightsteelblue|lightyellow|lime|limegreen|linen|magenta|maroon|mediumaquamarine|mediumblue|mediumorchid|mediumpurple|mediumseagreen|mediumslateblue|mediumspringgreen|mediumturquoise|mediumvioletred|midnightblue|mintcream|mistyrose|moccasin|navajowhite|navy|oldlace|olive|olivedrab|orange|orangered|orchid|palegoldenrod|palegreen|paleturquoise|palevioletred|papayawhip|peachpuff|peru|pink|plum|powderblue|purple|rebeccapurple|red|rosybrown|royalblue|saddlebrown|salmon|sandybrown|seagreen|seashell|sienna|silver|skyblue|slateblue|slategray|slategrey|snow|springgreen|steelblue|tan|teal|thistle|tomato|turquoise|violet|wheat|white|whitesmoke|yellow|yellowgreen|<-non-standard-color>",
    "namespace-prefix": "<ident>",
    "ns-prefix": "[<ident-token>|'*']? '|'",
    "number-percentage": "<number>|<percentage>",
    "numeric-figure-values": "[lining-nums|oldstyle-nums]",
    "numeric-fraction-values": "[diagonal-fractions|stacked-fractions]",
    "numeric-spacing-values": "[proportional-nums|tabular-nums]",
    nth: "<an-plus-b>|even|odd",
    "opacity()": "opacity( [<number-percentage>] )",
    "overflow-position": "unsafe|safe",
    "outline-radius": "<length>|<percentage>",
    "page-body": "<declaration>? [; <page-body>]?|<page-margin-box> <page-body>",
    "page-margin-box": "<page-margin-box-type> '{' <declaration-list> '}'",
    "page-margin-box-type": "@top-left-corner|@top-left|@top-center|@top-right|@top-right-corner|@bottom-left-corner|@bottom-left|@bottom-center|@bottom-right|@bottom-right-corner|@left-top|@left-middle|@left-bottom|@right-top|@right-middle|@right-bottom",
    "page-selector-list": "[<page-selector>#]?",
    "page-selector": "<pseudo-page>+|<ident> <pseudo-page>*",
    "page-size": "A5|A4|A3|B5|B4|JIS-B5|JIS-B4|letter|legal|ledger",
    "path()": "path( [<fill-rule> ,]? <string> )",
    "paint()": "paint( <ident> , <declaration-value>? )",
    "perspective()": "perspective( [<length [0,\u221E]>|none] )",
    "polygon()": "polygon( <fill-rule>? , [<length-percentage> <length-percentage>]# )",
    position: "[[left|center|right]||[top|center|bottom]|[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]?|[[left|right] <length-percentage>]&&[[top|bottom] <length-percentage>]]",
    "pow()": "pow( <calc-sum> , <calc-sum> )",
    "pseudo-class-selector": "':' <ident-token>|':' <function-token> <any-value> ')'",
    "pseudo-element-selector": "':' <pseudo-class-selector>",
    "pseudo-page": ": [left|right|first|blank]",
    quote: "open-quote|close-quote|no-open-quote|no-close-quote",
    "radial-gradient()": "radial-gradient( [<ending-shape>||<size>]? [at <position>]? , <color-stop-list> )",
    ratio: "<number [0,\u221E]> [/ <number [0,\u221E]>]?",
    "relative-selector": "<combinator>? <complex-selector>",
    "relative-selector-list": "<relative-selector>#",
    "relative-size": "larger|smaller",
    "rem()": "rem( <calc-sum> , <calc-sum> )",
    "repeat-style": "repeat-x|repeat-y|[repeat|space|round|no-repeat]{1,2}",
    "repeating-conic-gradient()": "repeating-conic-gradient( [from <angle>]? [at <position>]? , <angular-color-stop-list> )",
    "repeating-linear-gradient()": "repeating-linear-gradient( [<angle>|to <side-or-corner>]? , <color-stop-list> )",
    "repeating-radial-gradient()": "repeating-radial-gradient( [<ending-shape>||<size>]? [at <position>]? , <color-stop-list> )",
    "reversed-counter-name": "reversed( <counter-name> )",
    "rgb()": "rgb( <percentage>{3} [/ <alpha-value>]? )|rgb( <number>{3} [/ <alpha-value>]? )|rgb( <percentage>#{3} , <alpha-value>? )|rgb( <number>#{3} , <alpha-value>? )",
    "rgba()": "rgba( <percentage>{3} [/ <alpha-value>]? )|rgba( <number>{3} [/ <alpha-value>]? )|rgba( <percentage>#{3} , <alpha-value>? )|rgba( <number>#{3} , <alpha-value>? )",
    "rotate()": "rotate( [<angle>|<zero>] )",
    "rotate3d()": "rotate3d( <number> , <number> , <number> , [<angle>|<zero>] )",
    "rotateX()": "rotateX( [<angle>|<zero>] )",
    "rotateY()": "rotateY( [<angle>|<zero>] )",
    "rotateZ()": "rotateZ( [<angle>|<zero>] )",
    "round()": "round( <rounding-strategy>? , <calc-sum> , <calc-sum> )",
    "rounding-strategy": "nearest|up|down|to-zero",
    "saturate()": "saturate( <number-percentage> )",
    "scale()": "scale( [<number>|<percentage>]#{1,2} )",
    "scale3d()": "scale3d( [<number>|<percentage>]#{3} )",
    "scaleX()": "scaleX( [<number>|<percentage>] )",
    "scaleY()": "scaleY( [<number>|<percentage>] )",
    "scaleZ()": "scaleZ( [<number>|<percentage>] )",
    scroller: "root|nearest",
    "self-position": "center|start|end|self-start|self-end|flex-start|flex-end",
    "shape-radius": "<length-percentage>|closest-side|farthest-side",
    "sign()": "sign( <calc-sum> )",
    "skew()": "skew( [<angle>|<zero>] , [<angle>|<zero>]? )",
    "skewX()": "skewX( [<angle>|<zero>] )",
    "skewY()": "skewY( [<angle>|<zero>] )",
    "sepia()": "sepia( <number-percentage> )",
    shadow: "inset?&&<length>{2,4}&&<color>?",
    "shadow-t": "[<length>{2,3}&&<color>?]",
    shape: "rect( <top> , <right> , <bottom> , <left> )|rect( <top> <right> <bottom> <left> )",
    "shape-box": "<box>|margin-box",
    "side-or-corner": "[left|right]||[top|bottom]",
    "sin()": "sin( <calc-sum> )",
    "single-animation": "<time>||<easing-function>||<time>||<single-animation-iteration-count>||<single-animation-direction>||<single-animation-fill-mode>||<single-animation-play-state>||[none|<keyframes-name>]",
    "single-animation-direction": "normal|reverse|alternate|alternate-reverse",
    "single-animation-fill-mode": "none|forwards|backwards|both",
    "single-animation-iteration-count": "infinite|<number>",
    "single-animation-play-state": "running|paused",
    "single-animation-timeline": "auto|none|<timeline-name>|scroll( <axis>? <scroller>? )",
    "single-transition": "[none|<single-transition-property>]||<time>||<easing-function>||<time>",
    "single-transition-property": "all|<custom-ident>",
    size: "closest-side|farthest-side|closest-corner|farthest-corner|<length>|<length-percentage>{2}",
    "sqrt()": "sqrt( <calc-sum> )",
    "step-position": "jump-start|jump-end|jump-none|jump-both|start|end",
    "step-timing-function": "step-start|step-end|steps( <integer> [, <step-position>]? )",
    "subclass-selector": "<id-selector>|<class-selector>|<attribute-selector>|<pseudo-class-selector>",
    "supports-condition": "not <supports-in-parens>|<supports-in-parens> [and <supports-in-parens>]*|<supports-in-parens> [or <supports-in-parens>]*",
    "supports-in-parens": "( <supports-condition> )|<supports-feature>|<general-enclosed>",
    "supports-feature": "<supports-decl>|<supports-selector-fn>",
    "supports-decl": "( <declaration> )",
    "supports-selector-fn": "selector( <complex-selector> )",
    symbol: "<string>|<image>|<custom-ident>",
    "tan()": "tan( <calc-sum> )",
    target: "<target-counter()>|<target-counters()>|<target-text()>",
    "target-counter()": "target-counter( [<string>|<url>] , <custom-ident> , <counter-style>? )",
    "target-counters()": "target-counters( [<string>|<url>] , <custom-ident> , <string> , <counter-style>? )",
    "target-text()": "target-text( [<string>|<url>] , [content|before|after|first-letter]? )",
    "time-percentage": "<time>|<percentage>",
    "timeline-name": "<custom-ident>|<string>",
    "easing-function": "linear|<cubic-bezier-timing-function>|<step-timing-function>",
    "track-breadth": "<length-percentage>|<flex>|min-content|max-content|auto",
    "track-list": "[<line-names>? [<track-size>|<track-repeat>]]+ <line-names>?",
    "track-repeat": "repeat( [<integer [1,\u221E]>] , [<line-names>? <track-size>]+ <line-names>? )",
    "track-size": "<track-breadth>|minmax( <inflexible-breadth> , <track-breadth> )|fit-content( <length-percentage> )",
    "transform-function": "<matrix()>|<translate()>|<translateX()>|<translateY()>|<scale()>|<scaleX()>|<scaleY()>|<rotate()>|<skew()>|<skewX()>|<skewY()>|<matrix3d()>|<translate3d()>|<translateZ()>|<scale3d()>|<scaleZ()>|<rotate3d()>|<rotateX()>|<rotateY()>|<rotateZ()>|<perspective()>",
    "transform-list": "<transform-function>+",
    "translate()": "translate( <length-percentage> , <length-percentage>? )",
    "translate3d()": "translate3d( <length-percentage> , <length-percentage> , <length> )",
    "translateX()": "translateX( <length-percentage> )",
    "translateY()": "translateY( <length-percentage> )",
    "translateZ()": "translateZ( <length> )",
    "type-or-unit": "string|color|url|integer|number|length|angle|time|frequency|cap|ch|em|ex|ic|lh|rlh|rem|vb|vi|vw|vh|vmin|vmax|mm|Q|cm|in|pt|pc|px|deg|grad|rad|turn|ms|s|Hz|kHz|%",
    "type-selector": "<wq-name>|<ns-prefix>? '*'",
    "var()": "var( <custom-property-name> , <declaration-value>? )",
    "viewport-length": "auto|<length-percentage>",
    "visual-box": "content-box|padding-box|border-box",
    "wq-name": "<ns-prefix>? <ident-token>",
    "-legacy-gradient": "<-webkit-gradient()>|<-legacy-linear-gradient>|<-legacy-repeating-linear-gradient>|<-legacy-radial-gradient>|<-legacy-repeating-radial-gradient>",
    "-legacy-linear-gradient": "-moz-linear-gradient( <-legacy-linear-gradient-arguments> )|-webkit-linear-gradient( <-legacy-linear-gradient-arguments> )|-o-linear-gradient( <-legacy-linear-gradient-arguments> )",
    "-legacy-repeating-linear-gradient": "-moz-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )|-webkit-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )|-o-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )",
    "-legacy-linear-gradient-arguments": "[<angle>|<side-or-corner>]? , <color-stop-list>",
    "-legacy-radial-gradient": "-moz-radial-gradient( <-legacy-radial-gradient-arguments> )|-webkit-radial-gradient( <-legacy-radial-gradient-arguments> )|-o-radial-gradient( <-legacy-radial-gradient-arguments> )",
    "-legacy-repeating-radial-gradient": "-moz-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )|-webkit-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )|-o-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )",
    "-legacy-radial-gradient-arguments": "[<position> ,]? [[[<-legacy-radial-gradient-shape>||<-legacy-radial-gradient-size>]|[<length>|<percentage>]{2}] ,]? <color-stop-list>",
    "-legacy-radial-gradient-size": "closest-side|closest-corner|farthest-side|farthest-corner|contain|cover",
    "-legacy-radial-gradient-shape": "circle|ellipse",
    "-non-standard-font": "-apple-system-body|-apple-system-headline|-apple-system-subheadline|-apple-system-caption1|-apple-system-caption2|-apple-system-footnote|-apple-system-short-body|-apple-system-short-headline|-apple-system-short-subheadline|-apple-system-short-caption1|-apple-system-short-footnote|-apple-system-tall-body",
    "-non-standard-color": "-moz-ButtonDefault|-moz-ButtonHoverFace|-moz-ButtonHoverText|-moz-CellHighlight|-moz-CellHighlightText|-moz-Combobox|-moz-ComboboxText|-moz-Dialog|-moz-DialogText|-moz-dragtargetzone|-moz-EvenTreeRow|-moz-Field|-moz-FieldText|-moz-html-CellHighlight|-moz-html-CellHighlightText|-moz-mac-accentdarkestshadow|-moz-mac-accentdarkshadow|-moz-mac-accentface|-moz-mac-accentlightesthighlight|-moz-mac-accentlightshadow|-moz-mac-accentregularhighlight|-moz-mac-accentregularshadow|-moz-mac-chrome-active|-moz-mac-chrome-inactive|-moz-mac-focusring|-moz-mac-menuselect|-moz-mac-menushadow|-moz-mac-menutextselect|-moz-MenuHover|-moz-MenuHoverText|-moz-MenuBarText|-moz-MenuBarHoverText|-moz-nativehyperlinktext|-moz-OddTreeRow|-moz-win-communicationstext|-moz-win-mediatext|-moz-activehyperlinktext|-moz-default-background-color|-moz-default-color|-moz-hyperlinktext|-moz-visitedhyperlinktext|-webkit-activelink|-webkit-focus-ring-color|-webkit-link|-webkit-text",
    "-non-standard-image-rendering": "optimize-contrast|-moz-crisp-edges|-o-crisp-edges|-webkit-optimize-contrast",
    "-non-standard-overflow": "-moz-scrollbars-none|-moz-scrollbars-horizontal|-moz-scrollbars-vertical|-moz-hidden-unscrollable",
    "-non-standard-width": "fill-available|min-intrinsic|intrinsic|-moz-available|-moz-fit-content|-moz-min-content|-moz-max-content|-webkit-min-content|-webkit-max-content",
    "-webkit-gradient()": "-webkit-gradient( <-webkit-gradient-type> , <-webkit-gradient-point> [, <-webkit-gradient-point>|, <-webkit-gradient-radius> , <-webkit-gradient-point>] [, <-webkit-gradient-radius>]? [, <-webkit-gradient-color-stop>]* )",
    "-webkit-gradient-color-stop": "from( <color> )|color-stop( [<number-zero-one>|<percentage>] , <color> )|to( <color> )",
    "-webkit-gradient-point": "[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]",
    "-webkit-gradient-radius": "<length>|<percentage>",
    "-webkit-gradient-type": "linear|radial",
    "-webkit-mask-box-repeat": "repeat|stretch|round",
    "-webkit-mask-clip-style": "border|border-box|padding|padding-box|content|content-box|text",
    "-ms-filter-function-list": "<-ms-filter-function>+",
    "-ms-filter-function": "<-ms-filter-function-progid>|<-ms-filter-function-legacy>",
    "-ms-filter-function-progid": "'progid:' [<ident-token> '.']* [<ident-token>|<function-token> <any-value>? )]",
    "-ms-filter-function-legacy": "<ident-token>|<function-token> <any-value>? )",
    "-ms-filter": "<string>",
    age: "child|young|old",
    "attr-name": "<wq-name>",
    "attr-fallback": "<any-value>",
    "bg-clip": "<box>|border|text",
    bottom: "<length>|auto",
    "generic-voice": "[<age>? <gender> <integer>?]",
    gender: "male|female|neutral",
    left: "<length>|auto",
    "mask-image": "<mask-reference>#",
    paint: "none|<color>|<url> [none|<color>]?|context-fill|context-stroke",
    right: "<length>|auto",
    "scroll-timeline-axis": "block|inline|vertical|horizontal",
    "scroll-timeline-name": "none|<custom-ident>",
    "single-animation-composition": "replace|add|accumulate",
    "svg-length": "<percentage>|<length>|<number>",
    "svg-writing-mode": "lr-tb|rl-tb|tb-rl|lr|rl|tb",
    top: "<length>|auto",
    x: "<number>",
    y: "<number>",
    declaration: "<ident-token> : <declaration-value>? ['!' important]?",
    "declaration-list": "[<declaration>? ';']* <declaration>?",
    url: "url( <string> <url-modifier>* )|<url-token>",
    "url-modifier": "<ident>|<function-token> <any-value> )",
    "number-zero-one": "<number [0,1]>",
    "number-one-or-greater": "<number [1,\u221E]>",
    "-non-standard-display": "-ms-inline-flexbox|-ms-grid|-ms-inline-grid|-webkit-flex|-webkit-inline-flex|-webkit-box|-webkit-inline-box|-moz-inline-stack|-moz-box|-moz-inline-box"
  },
  properties: {
    "--*": "<declaration-value>",
    "-ms-accelerator": "false|true",
    "-ms-block-progression": "tb|rl|bt|lr",
    "-ms-content-zoom-chaining": "none|chained",
    "-ms-content-zooming": "none|zoom",
    "-ms-content-zoom-limit": "<'-ms-content-zoom-limit-min'> <'-ms-content-zoom-limit-max'>",
    "-ms-content-zoom-limit-max": "<percentage>",
    "-ms-content-zoom-limit-min": "<percentage>",
    "-ms-content-zoom-snap": "<'-ms-content-zoom-snap-type'>||<'-ms-content-zoom-snap-points'>",
    "-ms-content-zoom-snap-points": "snapInterval( <percentage> , <percentage> )|snapList( <percentage># )",
    "-ms-content-zoom-snap-type": "none|proximity|mandatory",
    "-ms-filter": "<string>",
    "-ms-flow-from": "[none|<custom-ident>]#",
    "-ms-flow-into": "[none|<custom-ident>]#",
    "-ms-grid-columns": "none|<track-list>|<auto-track-list>",
    "-ms-grid-rows": "none|<track-list>|<auto-track-list>",
    "-ms-high-contrast-adjust": "auto|none",
    "-ms-hyphenate-limit-chars": "auto|<integer>{1,3}",
    "-ms-hyphenate-limit-lines": "no-limit|<integer>",
    "-ms-hyphenate-limit-zone": "<percentage>|<length>",
    "-ms-ime-align": "auto|after",
    "-ms-overflow-style": "auto|none|scrollbar|-ms-autohiding-scrollbar",
    "-ms-scrollbar-3dlight-color": "<color>",
    "-ms-scrollbar-arrow-color": "<color>",
    "-ms-scrollbar-base-color": "<color>",
    "-ms-scrollbar-darkshadow-color": "<color>",
    "-ms-scrollbar-face-color": "<color>",
    "-ms-scrollbar-highlight-color": "<color>",
    "-ms-scrollbar-shadow-color": "<color>",
    "-ms-scrollbar-track-color": "<color>",
    "-ms-scroll-chaining": "chained|none",
    "-ms-scroll-limit": "<'-ms-scroll-limit-x-min'> <'-ms-scroll-limit-y-min'> <'-ms-scroll-limit-x-max'> <'-ms-scroll-limit-y-max'>",
    "-ms-scroll-limit-x-max": "auto|<length>",
    "-ms-scroll-limit-x-min": "<length>",
    "-ms-scroll-limit-y-max": "auto|<length>",
    "-ms-scroll-limit-y-min": "<length>",
    "-ms-scroll-rails": "none|railed",
    "-ms-scroll-snap-points-x": "snapInterval( <length-percentage> , <length-percentage> )|snapList( <length-percentage># )",
    "-ms-scroll-snap-points-y": "snapInterval( <length-percentage> , <length-percentage> )|snapList( <length-percentage># )",
    "-ms-scroll-snap-type": "none|proximity|mandatory",
    "-ms-scroll-snap-x": "<'-ms-scroll-snap-type'> <'-ms-scroll-snap-points-x'>",
    "-ms-scroll-snap-y": "<'-ms-scroll-snap-type'> <'-ms-scroll-snap-points-y'>",
    "-ms-scroll-translation": "none|vertical-to-horizontal",
    "-ms-text-autospace": "none|ideograph-alpha|ideograph-numeric|ideograph-parenthesis|ideograph-space",
    "-ms-touch-select": "grippers|none",
    "-ms-user-select": "none|element|text",
    "-ms-wrap-flow": "auto|both|start|end|maximum|clear",
    "-ms-wrap-margin": "<length>",
    "-ms-wrap-through": "wrap|none",
    "-moz-appearance": "none|button|button-arrow-down|button-arrow-next|button-arrow-previous|button-arrow-up|button-bevel|button-focus|caret|checkbox|checkbox-container|checkbox-label|checkmenuitem|dualbutton|groupbox|listbox|listitem|menuarrow|menubar|menucheckbox|menuimage|menuitem|menuitemtext|menulist|menulist-button|menulist-text|menulist-textfield|menupopup|menuradio|menuseparator|meterbar|meterchunk|progressbar|progressbar-vertical|progresschunk|progresschunk-vertical|radio|radio-container|radio-label|radiomenuitem|range|range-thumb|resizer|resizerpanel|scale-horizontal|scalethumbend|scalethumb-horizontal|scalethumbstart|scalethumbtick|scalethumb-vertical|scale-vertical|scrollbarbutton-down|scrollbarbutton-left|scrollbarbutton-right|scrollbarbutton-up|scrollbarthumb-horizontal|scrollbarthumb-vertical|scrollbartrack-horizontal|scrollbartrack-vertical|searchfield|separator|sheet|spinner|spinner-downbutton|spinner-textfield|spinner-upbutton|splitter|statusbar|statusbarpanel|tab|tabpanel|tabpanels|tab-scroll-arrow-back|tab-scroll-arrow-forward|textfield|textfield-multiline|toolbar|toolbarbutton|toolbarbutton-dropdown|toolbargripper|toolbox|tooltip|treeheader|treeheadercell|treeheadersortarrow|treeitem|treeline|treetwisty|treetwistyopen|treeview|-moz-mac-unified-toolbar|-moz-win-borderless-glass|-moz-win-browsertabbar-toolbox|-moz-win-communicationstext|-moz-win-communications-toolbox|-moz-win-exclude-glass|-moz-win-glass|-moz-win-mediatext|-moz-win-media-toolbox|-moz-window-button-box|-moz-window-button-box-maximized|-moz-window-button-close|-moz-window-button-maximize|-moz-window-button-minimize|-moz-window-button-restore|-moz-window-frame-bottom|-moz-window-frame-left|-moz-window-frame-right|-moz-window-titlebar|-moz-window-titlebar-maximized",
    "-moz-binding": "<url>|none",
    "-moz-border-bottom-colors": "<color>+|none",
    "-moz-border-left-colors": "<color>+|none",
    "-moz-border-right-colors": "<color>+|none",
    "-moz-border-top-colors": "<color>+|none",
    "-moz-context-properties": "none|[fill|fill-opacity|stroke|stroke-opacity]#",
    "-moz-float-edge": "border-box|content-box|margin-box|padding-box",
    "-moz-force-broken-image-icon": "0|1",
    "-moz-image-region": "<shape>|auto",
    "-moz-orient": "inline|block|horizontal|vertical",
    "-moz-outline-radius": "<outline-radius>{1,4} [/ <outline-radius>{1,4}]?",
    "-moz-outline-radius-bottomleft": "<outline-radius>",
    "-moz-outline-radius-bottomright": "<outline-radius>",
    "-moz-outline-radius-topleft": "<outline-radius>",
    "-moz-outline-radius-topright": "<outline-radius>",
    "-moz-stack-sizing": "ignore|stretch-to-fit",
    "-moz-text-blink": "none|blink",
    "-moz-user-focus": "ignore|normal|select-after|select-before|select-menu|select-same|select-all|none",
    "-moz-user-input": "auto|none|enabled|disabled",
    "-moz-user-modify": "read-only|read-write|write-only",
    "-moz-window-dragging": "drag|no-drag",
    "-moz-window-shadow": "default|menu|tooltip|sheet|none",
    "-webkit-appearance": "none|button|button-bevel|caps-lock-indicator|caret|checkbox|default-button|inner-spin-button|listbox|listitem|media-controls-background|media-controls-fullscreen-background|media-current-time-display|media-enter-fullscreen-button|media-exit-fullscreen-button|media-fullscreen-button|media-mute-button|media-overlay-play-button|media-play-button|media-seek-back-button|media-seek-forward-button|media-slider|media-sliderthumb|media-time-remaining-display|media-toggle-closed-captions-button|media-volume-slider|media-volume-slider-container|media-volume-sliderthumb|menulist|menulist-button|menulist-text|menulist-textfield|meter|progress-bar|progress-bar-value|push-button|radio|scrollbarbutton-down|scrollbarbutton-left|scrollbarbutton-right|scrollbarbutton-up|scrollbargripper-horizontal|scrollbargripper-vertical|scrollbarthumb-horizontal|scrollbarthumb-vertical|scrollbartrack-horizontal|scrollbartrack-vertical|searchfield|searchfield-cancel-button|searchfield-decoration|searchfield-results-button|searchfield-results-decoration|slider-horizontal|slider-vertical|sliderthumb-horizontal|sliderthumb-vertical|square-button|textarea|textfield|-apple-pay-button",
    "-webkit-border-before": "<'border-width'>||<'border-style'>||<color>",
    "-webkit-border-before-color": "<color>",
    "-webkit-border-before-style": "<'border-style'>",
    "-webkit-border-before-width": "<'border-width'>",
    "-webkit-box-reflect": "[above|below|right|left]? <length>? <image>?",
    "-webkit-line-clamp": "none|<integer>",
    "-webkit-mask": "[<mask-reference>||<position> [/ <bg-size>]?||<repeat-style>||[<box>|border|padding|content|text]||[<box>|border|padding|content]]#",
    "-webkit-mask-attachment": "<attachment>#",
    "-webkit-mask-clip": "[<box>|border|padding|content|text]#",
    "-webkit-mask-composite": "<composite-style>#",
    "-webkit-mask-image": "<mask-reference>#",
    "-webkit-mask-origin": "[<box>|border|padding|content]#",
    "-webkit-mask-position": "<position>#",
    "-webkit-mask-position-x": "[<length-percentage>|left|center|right]#",
    "-webkit-mask-position-y": "[<length-percentage>|top|center|bottom]#",
    "-webkit-mask-repeat": "<repeat-style>#",
    "-webkit-mask-repeat-x": "repeat|no-repeat|space|round",
    "-webkit-mask-repeat-y": "repeat|no-repeat|space|round",
    "-webkit-mask-size": "<bg-size>#",
    "-webkit-overflow-scrolling": "auto|touch",
    "-webkit-tap-highlight-color": "<color>",
    "-webkit-text-fill-color": "<color>",
    "-webkit-text-stroke": "<length>||<color>",
    "-webkit-text-stroke-color": "<color>",
    "-webkit-text-stroke-width": "<length>",
    "-webkit-touch-callout": "default|none",
    "-webkit-user-modify": "read-only|read-write|read-write-plaintext-only",
    "accent-color": "auto|<color>",
    "align-content": "normal|<baseline-position>|<content-distribution>|<overflow-position>? <content-position>",
    "align-items": "normal|stretch|<baseline-position>|[<overflow-position>? <self-position>]",
    "align-self": "auto|normal|stretch|<baseline-position>|<overflow-position>? <self-position>",
    "align-tracks": "[normal|<baseline-position>|<content-distribution>|<overflow-position>? <content-position>]#",
    all: "initial|inherit|unset|revert|revert-layer",
    animation: "<single-animation>#",
    "animation-composition": "<single-animation-composition>#",
    "animation-delay": "<time>#",
    "animation-direction": "<single-animation-direction>#",
    "animation-duration": "<time>#",
    "animation-fill-mode": "<single-animation-fill-mode>#",
    "animation-iteration-count": "<single-animation-iteration-count>#",
    "animation-name": "[none|<keyframes-name>]#",
    "animation-play-state": "<single-animation-play-state>#",
    "animation-timing-function": "<easing-function>#",
    "animation-timeline": "<single-animation-timeline>#",
    appearance: "none|auto|textfield|menulist-button|<compat-auto>",
    "aspect-ratio": "auto|<ratio>",
    azimuth: "<angle>|[[left-side|far-left|left|center-left|center|center-right|right|far-right|right-side]||behind]|leftwards|rightwards",
    "backdrop-filter": "none|<filter-function-list>",
    "backface-visibility": "visible|hidden",
    background: "[<bg-layer> ,]* <final-bg-layer>",
    "background-attachment": "<attachment>#",
    "background-blend-mode": "<blend-mode>#",
    "background-clip": "<bg-clip>#",
    "background-color": "<color>",
    "background-image": "<bg-image>#",
    "background-origin": "<box>#",
    "background-position": "<bg-position>#",
    "background-position-x": "[center|[[left|right|x-start|x-end]? <length-percentage>?]!]#",
    "background-position-y": "[center|[[top|bottom|y-start|y-end]? <length-percentage>?]!]#",
    "background-repeat": "<repeat-style>#",
    "background-size": "<bg-size>#",
    "block-overflow": "clip|ellipsis|<string>",
    "block-size": "<'width'>",
    border: "<line-width>||<line-style>||<color>",
    "border-block": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-block-color": "<'border-top-color'>{1,2}",
    "border-block-style": "<'border-top-style'>",
    "border-block-width": "<'border-top-width'>",
    "border-block-end": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-block-end-color": "<'border-top-color'>",
    "border-block-end-style": "<'border-top-style'>",
    "border-block-end-width": "<'border-top-width'>",
    "border-block-start": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-block-start-color": "<'border-top-color'>",
    "border-block-start-style": "<'border-top-style'>",
    "border-block-start-width": "<'border-top-width'>",
    "border-bottom": "<line-width>||<line-style>||<color>",
    "border-bottom-color": "<'border-top-color'>",
    "border-bottom-left-radius": "<length-percentage>{1,2}",
    "border-bottom-right-radius": "<length-percentage>{1,2}",
    "border-bottom-style": "<line-style>",
    "border-bottom-width": "<line-width>",
    "border-collapse": "collapse|separate",
    "border-color": "<color>{1,4}",
    "border-end-end-radius": "<length-percentage>{1,2}",
    "border-end-start-radius": "<length-percentage>{1,2}",
    "border-image": "<'border-image-source'>||<'border-image-slice'> [/ <'border-image-width'>|/ <'border-image-width'>? / <'border-image-outset'>]?||<'border-image-repeat'>",
    "border-image-outset": "[<length>|<number>]{1,4}",
    "border-image-repeat": "[stretch|repeat|round|space]{1,2}",
    "border-image-slice": "<number-percentage>{1,4}&&fill?",
    "border-image-source": "none|<image>",
    "border-image-width": "[<length-percentage>|<number>|auto]{1,4}",
    "border-inline": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-inline-end": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-inline-color": "<'border-top-color'>{1,2}",
    "border-inline-style": "<'border-top-style'>",
    "border-inline-width": "<'border-top-width'>",
    "border-inline-end-color": "<'border-top-color'>",
    "border-inline-end-style": "<'border-top-style'>",
    "border-inline-end-width": "<'border-top-width'>",
    "border-inline-start": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-inline-start-color": "<'border-top-color'>",
    "border-inline-start-style": "<'border-top-style'>",
    "border-inline-start-width": "<'border-top-width'>",
    "border-left": "<line-width>||<line-style>||<color>",
    "border-left-color": "<color>",
    "border-left-style": "<line-style>",
    "border-left-width": "<line-width>",
    "border-radius": "<length-percentage>{1,4} [/ <length-percentage>{1,4}]?",
    "border-right": "<line-width>||<line-style>||<color>",
    "border-right-color": "<color>",
    "border-right-style": "<line-style>",
    "border-right-width": "<line-width>",
    "border-spacing": "<length> <length>?",
    "border-start-end-radius": "<length-percentage>{1,2}",
    "border-start-start-radius": "<length-percentage>{1,2}",
    "border-style": "<line-style>{1,4}",
    "border-top": "<line-width>||<line-style>||<color>",
    "border-top-color": "<color>",
    "border-top-left-radius": "<length-percentage>{1,2}",
    "border-top-right-radius": "<length-percentage>{1,2}",
    "border-top-style": "<line-style>",
    "border-top-width": "<line-width>",
    "border-width": "<line-width>{1,4}",
    bottom: "<length>|<percentage>|auto",
    "box-align": "start|center|end|baseline|stretch",
    "box-decoration-break": "slice|clone",
    "box-direction": "normal|reverse|inherit",
    "box-flex": "<number>",
    "box-flex-group": "<integer>",
    "box-lines": "single|multiple",
    "box-ordinal-group": "<integer>",
    "box-orient": "horizontal|vertical|inline-axis|block-axis|inherit",
    "box-pack": "start|center|end|justify",
    "box-shadow": "none|<shadow>#",
    "box-sizing": "content-box|border-box",
    "break-after": "auto|avoid|always|all|avoid-page|page|left|right|recto|verso|avoid-column|column|avoid-region|region",
    "break-before": "auto|avoid|always|all|avoid-page|page|left|right|recto|verso|avoid-column|column|avoid-region|region",
    "break-inside": "auto|avoid|avoid-page|avoid-column|avoid-region",
    "caption-side": "top|bottom|block-start|block-end|inline-start|inline-end",
    caret: "<'caret-color'>||<'caret-shape'>",
    "caret-color": "auto|<color>",
    "caret-shape": "auto|bar|block|underscore",
    clear: "none|left|right|both|inline-start|inline-end",
    clip: "<shape>|auto",
    "clip-path": "<clip-source>|[<basic-shape>||<geometry-box>]|none",
    color: "<color>",
    "print-color-adjust": "economy|exact",
    "color-scheme": "normal|[light|dark|<custom-ident>]+&&only?",
    "column-count": "<integer>|auto",
    "column-fill": "auto|balance|balance-all",
    "column-gap": "normal|<length-percentage>",
    "column-rule": "<'column-rule-width'>||<'column-rule-style'>||<'column-rule-color'>",
    "column-rule-color": "<color>",
    "column-rule-style": "<'border-style'>",
    "column-rule-width": "<'border-width'>",
    "column-span": "none|all",
    "column-width": "<length>|auto",
    columns: "<'column-width'>||<'column-count'>",
    contain: "none|strict|content|[[size||inline-size]||layout||style||paint]",
    "contain-intrinsic-size": "[none|<length>|auto <length>]{1,2}",
    "contain-intrinsic-block-size": "none|<length>|auto <length>",
    "contain-intrinsic-height": "none|<length>|auto <length>",
    "contain-intrinsic-inline-size": "none|<length>|auto <length>",
    "contain-intrinsic-width": "none|<length>|auto <length>",
    content: "normal|none|[<content-replacement>|<content-list>] [/ [<string>|<counter>]+]?",
    "content-visibility": "visible|auto|hidden",
    "counter-increment": "[<counter-name> <integer>?]+|none",
    "counter-reset": "[<counter-name> <integer>?|<reversed-counter-name> <integer>?]+|none",
    "counter-set": "[<counter-name> <integer>?]+|none",
    cursor: "[[<url> [<x> <y>]? ,]* [auto|default|none|context-menu|help|pointer|progress|wait|cell|crosshair|text|vertical-text|alias|copy|move|no-drop|not-allowed|e-resize|n-resize|ne-resize|nw-resize|s-resize|se-resize|sw-resize|w-resize|ew-resize|ns-resize|nesw-resize|nwse-resize|col-resize|row-resize|all-scroll|zoom-in|zoom-out|grab|grabbing|hand|-webkit-grab|-webkit-grabbing|-webkit-zoom-in|-webkit-zoom-out|-moz-grab|-moz-grabbing|-moz-zoom-in|-moz-zoom-out]]",
    direction: "ltr|rtl",
    display: "[<display-outside>||<display-inside>]|<display-listitem>|<display-internal>|<display-box>|<display-legacy>|<-non-standard-display>",
    "empty-cells": "show|hide",
    filter: "none|<filter-function-list>|<-ms-filter-function-list>",
    flex: "none|[<'flex-grow'> <'flex-shrink'>?||<'flex-basis'>]",
    "flex-basis": "content|<'width'>",
    "flex-direction": "row|row-reverse|column|column-reverse",
    "flex-flow": "<'flex-direction'>||<'flex-wrap'>",
    "flex-grow": "<number>",
    "flex-shrink": "<number>",
    "flex-wrap": "nowrap|wrap|wrap-reverse",
    float: "left|right|none|inline-start|inline-end",
    font: "[[<'font-style'>||<font-variant-css21>||<'font-weight'>||<'font-stretch'>]? <'font-size'> [/ <'line-height'>]? <'font-family'>]|caption|icon|menu|message-box|small-caption|status-bar",
    "font-family": "[<family-name>|<generic-family>]#",
    "font-feature-settings": "normal|<feature-tag-value>#",
    "font-kerning": "auto|normal|none",
    "font-language-override": "normal|<string>",
    "font-optical-sizing": "auto|none",
    "font-variation-settings": "normal|[<string> <number>]#",
    "font-size": "<absolute-size>|<relative-size>|<length-percentage>",
    "font-size-adjust": "none|[ex-height|cap-height|ch-width|ic-width|ic-height]? [from-font|<number>]",
    "font-smooth": "auto|never|always|<absolute-size>|<length>",
    "font-stretch": "<font-stretch-absolute>",
    "font-style": "normal|italic|oblique <angle>?",
    "font-synthesis": "none|[weight||style||small-caps]",
    "font-variant": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>||stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )||[small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps]||<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero||<east-asian-variant-values>||<east-asian-width-values>||ruby]",
    "font-variant-alternates": "normal|[stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )]",
    "font-variant-caps": "normal|small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps",
    "font-variant-east-asian": "normal|[<east-asian-variant-values>||<east-asian-width-values>||ruby]",
    "font-variant-ligatures": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>]",
    "font-variant-numeric": "normal|[<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero]",
    "font-variant-position": "normal|sub|super",
    "font-weight": "<font-weight-absolute>|bolder|lighter",
    "forced-color-adjust": "auto|none",
    gap: "<'row-gap'> <'column-gap'>?",
    grid: "<'grid-template'>|<'grid-template-rows'> / [auto-flow&&dense?] <'grid-auto-columns'>?|[auto-flow&&dense?] <'grid-auto-rows'>? / <'grid-template-columns'>",
    "grid-area": "<grid-line> [/ <grid-line>]{0,3}",
    "grid-auto-columns": "<track-size>+",
    "grid-auto-flow": "[row|column]||dense",
    "grid-auto-rows": "<track-size>+",
    "grid-column": "<grid-line> [/ <grid-line>]?",
    "grid-column-end": "<grid-line>",
    "grid-column-gap": "<length-percentage>",
    "grid-column-start": "<grid-line>",
    "grid-gap": "<'grid-row-gap'> <'grid-column-gap'>?",
    "grid-row": "<grid-line> [/ <grid-line>]?",
    "grid-row-end": "<grid-line>",
    "grid-row-gap": "<length-percentage>",
    "grid-row-start": "<grid-line>",
    "grid-template": "none|[<'grid-template-rows'> / <'grid-template-columns'>]|[<line-names>? <string> <track-size>? <line-names>?]+ [/ <explicit-track-list>]?",
    "grid-template-areas": "none|<string>+",
    "grid-template-columns": "none|<track-list>|<auto-track-list>|subgrid <line-name-list>?",
    "grid-template-rows": "none|<track-list>|<auto-track-list>|subgrid <line-name-list>?",
    "hanging-punctuation": "none|[first||[force-end|allow-end]||last]",
    height: "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )",
    "hyphenate-character": "auto|<string>",
    hyphens: "none|manual|auto",
    "image-orientation": "from-image|<angle>|[<angle>? flip]",
    "image-rendering": "auto|crisp-edges|pixelated|optimizeSpeed|optimizeQuality|<-non-standard-image-rendering>",
    "image-resolution": "[from-image||<resolution>]&&snap?",
    "ime-mode": "auto|normal|active|inactive|disabled",
    "initial-letter": "normal|[<number> <integer>?]",
    "initial-letter-align": "[auto|alphabetic|hanging|ideographic]",
    "inline-size": "<'width'>",
    "input-security": "auto|none",
    inset: "<'top'>{1,4}",
    "inset-block": "<'top'>{1,2}",
    "inset-block-end": "<'top'>",
    "inset-block-start": "<'top'>",
    "inset-inline": "<'top'>{1,2}",
    "inset-inline-end": "<'top'>",
    "inset-inline-start": "<'top'>",
    isolation: "auto|isolate",
    "justify-content": "normal|<content-distribution>|<overflow-position>? [<content-position>|left|right]",
    "justify-items": "normal|stretch|<baseline-position>|<overflow-position>? [<self-position>|left|right]|legacy|legacy&&[left|right|center]",
    "justify-self": "auto|normal|stretch|<baseline-position>|<overflow-position>? [<self-position>|left|right]",
    "justify-tracks": "[normal|<content-distribution>|<overflow-position>? [<content-position>|left|right]]#",
    left: "<length>|<percentage>|auto",
    "letter-spacing": "normal|<length-percentage>",
    "line-break": "auto|loose|normal|strict|anywhere",
    "line-clamp": "none|<integer>",
    "line-height": "normal|<number>|<length>|<percentage>",
    "line-height-step": "<length>",
    "list-style": "<'list-style-type'>||<'list-style-position'>||<'list-style-image'>",
    "list-style-image": "<image>|none",
    "list-style-position": "inside|outside",
    "list-style-type": "<counter-style>|<string>|none",
    margin: "[<length>|<percentage>|auto]{1,4}",
    "margin-block": "<'margin-left'>{1,2}",
    "margin-block-end": "<'margin-left'>",
    "margin-block-start": "<'margin-left'>",
    "margin-bottom": "<length>|<percentage>|auto",
    "margin-inline": "<'margin-left'>{1,2}",
    "margin-inline-end": "<'margin-left'>",
    "margin-inline-start": "<'margin-left'>",
    "margin-left": "<length>|<percentage>|auto",
    "margin-right": "<length>|<percentage>|auto",
    "margin-top": "<length>|<percentage>|auto",
    "margin-trim": "none|in-flow|all",
    mask: "<mask-layer>#",
    "mask-border": "<'mask-border-source'>||<'mask-border-slice'> [/ <'mask-border-width'>? [/ <'mask-border-outset'>]?]?||<'mask-border-repeat'>||<'mask-border-mode'>",
    "mask-border-mode": "luminance|alpha",
    "mask-border-outset": "[<length>|<number>]{1,4}",
    "mask-border-repeat": "[stretch|repeat|round|space]{1,2}",
    "mask-border-slice": "<number-percentage>{1,4} fill?",
    "mask-border-source": "none|<image>",
    "mask-border-width": "[<length-percentage>|<number>|auto]{1,4}",
    "mask-clip": "[<geometry-box>|no-clip]#",
    "mask-composite": "<compositing-operator>#",
    "mask-image": "<mask-reference>#",
    "mask-mode": "<masking-mode>#",
    "mask-origin": "<geometry-box>#",
    "mask-position": "<position>#",
    "mask-repeat": "<repeat-style>#",
    "mask-size": "<bg-size>#",
    "mask-type": "luminance|alpha",
    "masonry-auto-flow": "[pack|next]||[definite-first|ordered]",
    "math-depth": "auto-add|add( <integer> )|<integer>",
    "math-shift": "normal|compact",
    "math-style": "normal|compact",
    "max-block-size": "<'max-width'>",
    "max-height": "none|<length-percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )",
    "max-inline-size": "<'max-width'>",
    "max-lines": "none|<integer>",
    "max-width": "none|<length-percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|<-non-standard-width>",
    "min-block-size": "<'min-width'>",
    "min-height": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )",
    "min-inline-size": "<'min-width'>",
    "min-width": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|<-non-standard-width>",
    "mix-blend-mode": "<blend-mode>|plus-lighter",
    "object-fit": "fill|contain|cover|none|scale-down",
    "object-position": "<position>",
    offset: "[<'offset-position'>? [<'offset-path'> [<'offset-distance'>||<'offset-rotate'>]?]?]! [/ <'offset-anchor'>]?",
    "offset-anchor": "auto|<position>",
    "offset-distance": "<length-percentage>",
    "offset-path": "none|ray( [<angle>&&<size>&&contain?] )|<path()>|<url>|[<basic-shape>||<geometry-box>]",
    "offset-position": "auto|<position>",
    "offset-rotate": "[auto|reverse]||<angle>",
    opacity: "<alpha-value>",
    order: "<integer>",
    orphans: "<integer>",
    outline: "[<'outline-color'>||<'outline-style'>||<'outline-width'>]",
    "outline-color": "<color>|invert",
    "outline-offset": "<length>",
    "outline-style": "auto|<'border-style'>",
    "outline-width": "<line-width>",
    overflow: "[visible|hidden|clip|scroll|auto]{1,2}|<-non-standard-overflow>",
    "overflow-anchor": "auto|none",
    "overflow-block": "visible|hidden|clip|scroll|auto",
    "overflow-clip-box": "padding-box|content-box",
    "overflow-clip-margin": "<visual-box>||<length [0,\u221E]>",
    "overflow-inline": "visible|hidden|clip|scroll|auto",
    "overflow-wrap": "normal|break-word|anywhere",
    "overflow-x": "visible|hidden|clip|scroll|auto",
    "overflow-y": "visible|hidden|clip|scroll|auto",
    "overscroll-behavior": "[contain|none|auto]{1,2}",
    "overscroll-behavior-block": "contain|none|auto",
    "overscroll-behavior-inline": "contain|none|auto",
    "overscroll-behavior-x": "contain|none|auto",
    "overscroll-behavior-y": "contain|none|auto",
    padding: "[<length>|<percentage>]{1,4}",
    "padding-block": "<'padding-left'>{1,2}",
    "padding-block-end": "<'padding-left'>",
    "padding-block-start": "<'padding-left'>",
    "padding-bottom": "<length>|<percentage>",
    "padding-inline": "<'padding-left'>{1,2}",
    "padding-inline-end": "<'padding-left'>",
    "padding-inline-start": "<'padding-left'>",
    "padding-left": "<length>|<percentage>",
    "padding-right": "<length>|<percentage>",
    "padding-top": "<length>|<percentage>",
    "page-break-after": "auto|always|avoid|left|right|recto|verso",
    "page-break-before": "auto|always|avoid|left|right|recto|verso",
    "page-break-inside": "auto|avoid",
    "paint-order": "normal|[fill||stroke||markers]",
    perspective: "none|<length>",
    "perspective-origin": "<position>",
    "place-content": "<'align-content'> <'justify-content'>?",
    "place-items": "<'align-items'> <'justify-items'>?",
    "place-self": "<'align-self'> <'justify-self'>?",
    "pointer-events": "auto|none|visiblePainted|visibleFill|visibleStroke|visible|painted|fill|stroke|all|inherit",
    position: "static|relative|absolute|sticky|fixed|-webkit-sticky",
    quotes: "none|auto|[<string> <string>]+",
    resize: "none|both|horizontal|vertical|block|inline",
    right: "<length>|<percentage>|auto",
    rotate: "none|<angle>|[x|y|z|<number>{3}]&&<angle>",
    "row-gap": "normal|<length-percentage>",
    "ruby-align": "start|center|space-between|space-around",
    "ruby-merge": "separate|collapse|auto",
    "ruby-position": "[alternate||[over|under]]|inter-character",
    scale: "none|<number>{1,3}",
    "scrollbar-color": "auto|<color>{2}",
    "scrollbar-gutter": "auto|stable&&both-edges?",
    "scrollbar-width": "auto|thin|none",
    "scroll-behavior": "auto|smooth",
    "scroll-margin": "<length>{1,4}",
    "scroll-margin-block": "<length>{1,2}",
    "scroll-margin-block-start": "<length>",
    "scroll-margin-block-end": "<length>",
    "scroll-margin-bottom": "<length>",
    "scroll-margin-inline": "<length>{1,2}",
    "scroll-margin-inline-start": "<length>",
    "scroll-margin-inline-end": "<length>",
    "scroll-margin-left": "<length>",
    "scroll-margin-right": "<length>",
    "scroll-margin-top": "<length>",
    "scroll-padding": "[auto|<length-percentage>]{1,4}",
    "scroll-padding-block": "[auto|<length-percentage>]{1,2}",
    "scroll-padding-block-start": "auto|<length-percentage>",
    "scroll-padding-block-end": "auto|<length-percentage>",
    "scroll-padding-bottom": "auto|<length-percentage>",
    "scroll-padding-inline": "[auto|<length-percentage>]{1,2}",
    "scroll-padding-inline-start": "auto|<length-percentage>",
    "scroll-padding-inline-end": "auto|<length-percentage>",
    "scroll-padding-left": "auto|<length-percentage>",
    "scroll-padding-right": "auto|<length-percentage>",
    "scroll-padding-top": "auto|<length-percentage>",
    "scroll-snap-align": "[none|start|end|center]{1,2}",
    "scroll-snap-coordinate": "none|<position>#",
    "scroll-snap-destination": "<position>",
    "scroll-snap-points-x": "none|repeat( <length-percentage> )",
    "scroll-snap-points-y": "none|repeat( <length-percentage> )",
    "scroll-snap-stop": "normal|always",
    "scroll-snap-type": "none|[x|y|block|inline|both] [mandatory|proximity]?",
    "scroll-snap-type-x": "none|mandatory|proximity",
    "scroll-snap-type-y": "none|mandatory|proximity",
    "scroll-timeline": "<scroll-timeline-name>||<scroll-timeline-axis>",
    "scroll-timeline-axis": "block|inline|vertical|horizontal",
    "scroll-timeline-name": "none|<custom-ident>",
    "shape-image-threshold": "<alpha-value>",
    "shape-margin": "<length-percentage>",
    "shape-outside": "none|[<shape-box>||<basic-shape>]|<image>",
    "tab-size": "<integer>|<length>",
    "table-layout": "auto|fixed",
    "text-align": "start|end|left|right|center|justify|match-parent",
    "text-align-last": "auto|start|end|left|right|center|justify",
    "text-combine-upright": "none|all|[digits <integer>?]",
    "text-decoration": "<'text-decoration-line'>||<'text-decoration-style'>||<'text-decoration-color'>||<'text-decoration-thickness'>",
    "text-decoration-color": "<color>",
    "text-decoration-line": "none|[underline||overline||line-through||blink]|spelling-error|grammar-error",
    "text-decoration-skip": "none|[objects||[spaces|[leading-spaces||trailing-spaces]]||edges||box-decoration]",
    "text-decoration-skip-ink": "auto|all|none",
    "text-decoration-style": "solid|double|dotted|dashed|wavy",
    "text-decoration-thickness": "auto|from-font|<length>|<percentage>",
    "text-emphasis": "<'text-emphasis-style'>||<'text-emphasis-color'>",
    "text-emphasis-color": "<color>",
    "text-emphasis-position": "[over|under]&&[right|left]",
    "text-emphasis-style": "none|[[filled|open]||[dot|circle|double-circle|triangle|sesame]]|<string>",
    "text-indent": "<length-percentage>&&hanging?&&each-line?",
    "text-justify": "auto|inter-character|inter-word|none",
    "text-orientation": "mixed|upright|sideways",
    "text-overflow": "[clip|ellipsis|<string>]{1,2}",
    "text-rendering": "auto|optimizeSpeed|optimizeLegibility|geometricPrecision",
    "text-shadow": "none|<shadow-t>#",
    "text-size-adjust": "none|auto|<percentage>",
    "text-transform": "none|capitalize|uppercase|lowercase|full-width|full-size-kana",
    "text-underline-offset": "auto|<length>|<percentage>",
    "text-underline-position": "auto|from-font|[under||[left|right]]",
    top: "<length>|<percentage>|auto",
    "touch-action": "auto|none|[[pan-x|pan-left|pan-right]||[pan-y|pan-up|pan-down]||pinch-zoom]|manipulation",
    transform: "none|<transform-list>",
    "transform-box": "content-box|border-box|fill-box|stroke-box|view-box",
    "transform-origin": "[<length-percentage>|left|center|right|top|bottom]|[[<length-percentage>|left|center|right]&&[<length-percentage>|top|center|bottom]] <length>?",
    "transform-style": "flat|preserve-3d",
    transition: "<single-transition>#",
    "transition-delay": "<time>#",
    "transition-duration": "<time>#",
    "transition-property": "none|<single-transition-property>#",
    "transition-timing-function": "<easing-function>#",
    translate: "none|<length-percentage> [<length-percentage> <length>?]?",
    "unicode-bidi": "normal|embed|isolate|bidi-override|isolate-override|plaintext|-moz-isolate|-moz-isolate-override|-moz-plaintext|-webkit-isolate|-webkit-isolate-override|-webkit-plaintext",
    "user-select": "auto|text|none|contain|all",
    "vertical-align": "baseline|sub|super|text-top|text-bottom|middle|top|bottom|<percentage>|<length>",
    visibility: "visible|hidden|collapse",
    "white-space": "normal|pre|nowrap|pre-wrap|pre-line|break-spaces",
    widows: "<integer>",
    width: "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|fill|stretch|intrinsic|-moz-max-content|-webkit-max-content|-moz-fit-content|-webkit-fit-content",
    "will-change": "auto|<animateable-feature>#",
    "word-break": "normal|break-all|keep-all|break-word",
    "word-spacing": "normal|<length>",
    "word-wrap": "normal|break-word",
    "writing-mode": "horizontal-tb|vertical-rl|vertical-lr|sideways-rl|sideways-lr|<svg-writing-mode>",
    "z-index": "auto|<integer>",
    zoom: "normal|reset|<number>|<percentage>",
    "-moz-background-clip": "padding|border",
    "-moz-border-radius-bottomleft": "<'border-bottom-left-radius'>",
    "-moz-border-radius-bottomright": "<'border-bottom-right-radius'>",
    "-moz-border-radius-topleft": "<'border-top-left-radius'>",
    "-moz-border-radius-topright": "<'border-bottom-right-radius'>",
    "-moz-control-character-visibility": "visible|hidden",
    "-moz-osx-font-smoothing": "auto|grayscale",
    "-moz-user-select": "none|text|all|-moz-none",
    "-ms-flex-align": "start|end|center|baseline|stretch",
    "-ms-flex-item-align": "auto|start|end|center|baseline|stretch",
    "-ms-flex-line-pack": "start|end|center|justify|distribute|stretch",
    "-ms-flex-negative": "<'flex-shrink'>",
    "-ms-flex-pack": "start|end|center|justify|distribute",
    "-ms-flex-order": "<integer>",
    "-ms-flex-positive": "<'flex-grow'>",
    "-ms-flex-preferred-size": "<'flex-basis'>",
    "-ms-interpolation-mode": "nearest-neighbor|bicubic",
    "-ms-grid-column-align": "start|end|center|stretch",
    "-ms-grid-row-align": "start|end|center|stretch",
    "-ms-hyphenate-limit-last": "none|always|column|page|spread",
    "-webkit-background-clip": "[<box>|border|padding|content|text]#",
    "-webkit-column-break-after": "always|auto|avoid",
    "-webkit-column-break-before": "always|auto|avoid",
    "-webkit-column-break-inside": "always|auto|avoid",
    "-webkit-font-smoothing": "auto|none|antialiased|subpixel-antialiased",
    "-webkit-mask-box-image": "[<url>|<gradient>|none] [<length-percentage>{4} <-webkit-mask-box-repeat>{2}]?",
    "-webkit-print-color-adjust": "economy|exact",
    "-webkit-text-security": "none|circle|disc|square",
    "-webkit-user-drag": "none|element|auto",
    "-webkit-user-select": "auto|none|text|all",
    "alignment-baseline": "auto|baseline|before-edge|text-before-edge|middle|central|after-edge|text-after-edge|ideographic|alphabetic|hanging|mathematical",
    "baseline-shift": "baseline|sub|super|<svg-length>",
    behavior: "<url>+",
    "clip-rule": "nonzero|evenodd",
    cue: "<'cue-before'> <'cue-after'>?",
    "cue-after": "<url> <decibel>?|none",
    "cue-before": "<url> <decibel>?|none",
    "dominant-baseline": "auto|use-script|no-change|reset-size|ideographic|alphabetic|hanging|mathematical|central|middle|text-after-edge|text-before-edge",
    fill: "<paint>",
    "fill-opacity": "<number-zero-one>",
    "fill-rule": "nonzero|evenodd",
    "glyph-orientation-horizontal": "<angle>",
    "glyph-orientation-vertical": "<angle>",
    kerning: "auto|<svg-length>",
    marker: "none|<url>",
    "marker-end": "none|<url>",
    "marker-mid": "none|<url>",
    "marker-start": "none|<url>",
    pause: "<'pause-before'> <'pause-after'>?",
    "pause-after": "<time>|none|x-weak|weak|medium|strong|x-strong",
    "pause-before": "<time>|none|x-weak|weak|medium|strong|x-strong",
    rest: "<'rest-before'> <'rest-after'>?",
    "rest-after": "<time>|none|x-weak|weak|medium|strong|x-strong",
    "rest-before": "<time>|none|x-weak|weak|medium|strong|x-strong",
    "shape-rendering": "auto|optimizeSpeed|crispEdges|geometricPrecision",
    src: "[<url> [format( <string># )]?|local( <family-name> )]#",
    speak: "auto|none|normal",
    "speak-as": "normal|spell-out||digits||[literal-punctuation|no-punctuation]",
    stroke: "<paint>",
    "stroke-dasharray": "none|[<svg-length>+]#",
    "stroke-dashoffset": "<svg-length>",
    "stroke-linecap": "butt|round|square",
    "stroke-linejoin": "miter|round|bevel",
    "stroke-miterlimit": "<number-one-or-greater>",
    "stroke-opacity": "<number-zero-one>",
    "stroke-width": "<svg-length>",
    "text-anchor": "start|middle|end",
    "unicode-range": "<urange>#",
    "voice-balance": "<number>|left|center|right|leftwards|rightwards",
    "voice-duration": "auto|<time>",
    "voice-family": "[[<family-name>|<generic-voice>] ,]* [<family-name>|<generic-voice>]|preserve",
    "voice-pitch": "<frequency>&&absolute|[[x-low|low|medium|high|x-high]||[<frequency>|<semitones>|<percentage>]]",
    "voice-range": "<frequency>&&absolute|[[x-low|low|medium|high|x-high]||[<frequency>|<semitones>|<percentage>]]",
    "voice-rate": "[normal|x-slow|slow|medium|fast|x-fast]||<percentage>",
    "voice-stress": "normal|strong|moderate|none|reduced",
    "voice-volume": "silent|[[x-soft|soft|medium|loud|x-loud]||<decibel>]"
  },
  atrules: {
    charset: {
      prelude: "<string>",
      descriptors: null
    },
    "counter-style": {
      prelude: "<counter-style-name>",
      descriptors: {
        "additive-symbols": "[<integer>&&<symbol>]#",
        fallback: "<counter-style-name>",
        negative: "<symbol> <symbol>?",
        pad: "<integer>&&<symbol>",
        prefix: "<symbol>",
        range: "[[<integer>|infinite]{2}]#|auto",
        "speak-as": "auto|bullets|numbers|words|spell-out|<counter-style-name>",
        suffix: "<symbol>",
        symbols: "<symbol>+",
        system: "cyclic|numeric|alphabetic|symbolic|additive|[fixed <integer>?]|[extends <counter-style-name>]"
      }
    },
    document: {
      prelude: "[<url>|url-prefix( <string> )|domain( <string> )|media-document( <string> )|regexp( <string> )]#",
      descriptors: null
    },
    "font-face": {
      prelude: null,
      descriptors: {
        "ascent-override": "normal|<percentage>",
        "descent-override": "normal|<percentage>",
        "font-display": "[auto|block|swap|fallback|optional]",
        "font-family": "<family-name>",
        "font-feature-settings": "normal|<feature-tag-value>#",
        "font-variation-settings": "normal|[<string> <number>]#",
        "font-stretch": "<font-stretch-absolute>{1,2}",
        "font-style": "normal|italic|oblique <angle>{0,2}",
        "font-weight": "<font-weight-absolute>{1,2}",
        "font-variant": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>||stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )||[small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps]||<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero||<east-asian-variant-values>||<east-asian-width-values>||ruby]",
        "line-gap-override": "normal|<percentage>",
        "size-adjust": "<percentage>",
        src: "[<url> [format( <string># )]?|local( <family-name> )]#",
        "unicode-range": "<urange>#"
      }
    },
    "font-feature-values": {
      prelude: "<family-name>#",
      descriptors: null
    },
    import: {
      prelude: "[<string>|<url>] [layer|layer( <layer-name> )]? [supports( [<supports-condition>|<declaration>] )]? <media-query-list>?",
      descriptors: null
    },
    keyframes: {
      prelude: "<keyframes-name>",
      descriptors: null
    },
    layer: {
      prelude: "[<layer-name>#|<layer-name>?]",
      descriptors: null
    },
    media: {
      prelude: "<media-query-list>",
      descriptors: null
    },
    namespace: {
      prelude: "<namespace-prefix>? [<string>|<url>]",
      descriptors: null
    },
    page: {
      prelude: "<page-selector-list>",
      descriptors: {
        bleed: "auto|<length>",
        marks: "none|[crop||cross]",
        size: "<length>{1,2}|auto|[<page-size>||[portrait|landscape]]"
      }
    },
    property: {
      prelude: "<custom-property-name>",
      descriptors: {
        syntax: "<string>",
        inherits: "true|false",
        "initial-value": "<string>"
      }
    },
    "scroll-timeline": {
      prelude: "<timeline-name>",
      descriptors: null
    },
    supports: {
      prelude: "<supports-condition>",
      descriptors: null
    },
    viewport: {
      prelude: null,
      descriptors: {
        height: "<viewport-length>{1,2}",
        "max-height": "<viewport-length>",
        "max-width": "<viewport-length>",
        "max-zoom": "auto|<number>|<percentage>",
        "min-height": "<viewport-length>",
        "min-width": "<viewport-length>",
        "min-zoom": "auto|<number>|<percentage>",
        orientation: "auto|portrait|landscape",
        "user-zoom": "zoom|fixed",
        "viewport-fit": "auto|contain|cover",
        width: "<viewport-length>{1,2}",
        zoom: "auto|<number>|<percentage>"
      }
    },
    nest: {
      prelude: "<complex-selector-list>",
      descriptors: null
    }
  }
}, t0 = {}, p2 = {};
const F0 = R, gu = h0, H1 = 43, a1 = 45, Gr = 110, qe = !0, UF = !1;
function Wr(e, t) {
  let r = this.tokenStart + e;
  const n = this.charCodeAt(r);
  for ((n === H1 || n === a1) && (t && this.error("Number sign is not allowed"), r++); r < this.tokenEnd; r++)
    gu.isDigit(this.charCodeAt(r)) || this.error("Integer is expected", r);
}
function Vt(e) {
  return Wr.call(this, 0, e);
}
function ke(e, t) {
  if (!this.cmpChar(this.tokenStart + e, t)) {
    let r = "";
    switch (t) {
      case Gr:
        r = "N is expected";
        break;
      case a1:
        r = "HyphenMinus is expected";
        break;
    }
    this.error(r, this.tokenStart + e);
  }
}
function cn() {
  let e = 0, t = 0, r = this.tokenType;
  for (; r === F0.WhiteSpace || r === F0.Comment; )
    r = this.lookupType(++e);
  if (r !== F0.Number)
    if (this.isDelim(H1, e) || this.isDelim(a1, e)) {
      t = this.isDelim(H1, e) ? H1 : a1;
      do
        r = this.lookupType(++e);
      while (r === F0.WhiteSpace || r === F0.Comment);
      r !== F0.Number && (this.skip(e), Vt.call(this, qe));
    } else
      return null;
  return e > 0 && this.skip(e), t === 0 && (r = this.charCodeAt(this.tokenStart), r !== H1 && r !== a1 && this.error("Number sign is expected")), Vt.call(this, t !== 0), t === a1 ? "-" + this.consume(F0.Number) : this.consume(F0.Number);
}
const HF = "AnPlusB", GF = {
  a: [String, null],
  b: [String, null]
};
function WF() {
  const e = this.tokenStart;
  let t = null, r = null;
  if (this.tokenType === F0.Number)
    Vt.call(this, UF), r = this.consume(F0.Number);
  else if (this.tokenType === F0.Ident && this.cmpChar(this.tokenStart, a1))
    switch (t = "-1", ke.call(this, 1, Gr), this.tokenEnd - this.tokenStart) {
      case 2:
        this.next(), r = cn.call(this);
        break;
      case 3:
        ke.call(this, 2, a1), this.next(), this.skipSC(), Vt.call(this, qe), r = "-" + this.consume(F0.Number);
        break;
      default:
        ke.call(this, 2, a1), Wr.call(this, 3, qe), this.next(), r = this.substrToCursor(e + 2);
    }
  else if (this.tokenType === F0.Ident || this.isDelim(H1) && this.lookupType(1) === F0.Ident) {
    let n = 0;
    switch (t = "1", this.isDelim(H1) && (n = 1, this.next()), ke.call(this, 0, Gr), this.tokenEnd - this.tokenStart) {
      case 1:
        this.next(), r = cn.call(this);
        break;
      case 2:
        ke.call(this, 1, a1), this.next(), this.skipSC(), Vt.call(this, qe), r = "-" + this.consume(F0.Number);
        break;
      default:
        ke.call(this, 1, a1), Wr.call(this, 2, qe), this.next(), r = this.substrToCursor(e + n + 1);
    }
  } else if (this.tokenType === F0.Dimension) {
    const n = this.charCodeAt(this.tokenStart), o = n === H1 || n === a1;
    let s = this.tokenStart + o;
    for (; s < this.tokenEnd && gu.isDigit(this.charCodeAt(s)); s++)
      ;
    s === this.tokenStart + o && this.error("Integer is expected", this.tokenStart + o), ke.call(this, s - this.tokenStart, Gr), t = this.substring(e, s), s + 1 === this.tokenEnd ? (this.next(), r = cn.call(this)) : (ke.call(this, s - this.tokenStart + 1, a1), s + 2 === this.tokenEnd ? (this.next(), this.skipSC(), Vt.call(this, qe), r = "-" + this.consume(F0.Number)) : (Wr.call(this, s - this.tokenStart + 2, qe), this.next(), r = this.substrToCursor(s + 1)));
  } else
    this.error();
  return t !== null && t.charCodeAt(0) === H1 && (t = t.substr(1)), r !== null && r.charCodeAt(0) === H1 && (r = r.substr(1)), {
    type: "AnPlusB",
    loc: this.getLocation(e, this.tokenStart),
    a: t,
    b: r
  };
}
function VF(e) {
  if (e.a) {
    const t = e.a === "+1" && "n" || e.a === "1" && "n" || e.a === "-1" && "-n" || e.a + "n";
    if (e.b) {
      const r = e.b[0] === "-" || e.b[0] === "+" ? e.b : "+" + e.b;
      this.tokenize(t + r);
    } else
      this.tokenize(t);
  } else
    this.tokenize(e.b);
}
p2.generate = VF;
p2.name = HF;
p2.parse = WF;
p2.structure = GF;
var ot = {};
const G1 = R;
function ni(e) {
  return this.Raw(e, this.consumeUntilLeftCurlyBracketOrSemicolon, !0);
}
function XF() {
  for (let e = 1, t; t = this.lookupType(e); e++) {
    if (t === G1.RightCurlyBracket)
      return !0;
    if (t === G1.LeftCurlyBracket || t === G1.AtKeyword)
      return !1;
  }
  return !1;
}
const YF = "Atrule", KF = "atrule", QF = {
  name: String,
  prelude: ["AtrulePrelude", "Raw", null],
  block: ["Block", null]
};
function JF(e = !1) {
  const t = this.tokenStart;
  let r, n, o = null, s = null;
  switch (this.eat(G1.AtKeyword), r = this.substrToCursor(t + 1), n = r.toLowerCase(), this.skipSC(), this.eof === !1 && this.tokenType !== G1.LeftCurlyBracket && this.tokenType !== G1.Semicolon && (this.parseAtrulePrelude ? o = this.parseWithFallback(this.AtrulePrelude.bind(this, r, e), ni) : o = ni.call(this, this.tokenIndex), this.skipSC()), this.tokenType) {
    case G1.Semicolon:
      this.next();
      break;
    case G1.LeftCurlyBracket:
      hasOwnProperty.call(this.atrule, n) && typeof this.atrule[n].block == "function" ? s = this.atrule[n].block.call(this, e) : s = this.Block(XF.call(this));
      break;
  }
  return {
    type: "Atrule",
    loc: this.getLocation(t, this.tokenStart),
    name: r,
    prelude: o,
    block: s
  };
}
function eB(e) {
  this.token(G1.AtKeyword, "@" + e.name), e.prelude !== null && this.node(e.prelude), e.block ? this.node(e.block) : this.token(G1.Semicolon, ";");
}
ot.generate = eB;
ot.name = YF;
ot.parse = JF;
ot.structure = QF;
ot.walkContext = KF;
var st = {};
const oi = R, tB = "AtrulePrelude", rB = "atrulePrelude", nB = {
  children: [[]]
};
function oB(e) {
  let t = null;
  return e !== null && (e = e.toLowerCase()), this.skipSC(), hasOwnProperty.call(this.atrule, e) && typeof this.atrule[e].prelude == "function" ? t = this.atrule[e].prelude.call(this) : t = this.readSequence(this.scope.AtrulePrelude), this.skipSC(), this.eof !== !0 && this.tokenType !== oi.LeftCurlyBracket && this.tokenType !== oi.Semicolon && this.error("Semicolon or block is expected"), {
    type: "AtrulePrelude",
    loc: this.getLocationFromList(t),
    children: t
  };
}
function sB(e) {
  this.children(e);
}
st.generate = sB;
st.name = tB;
st.parse = oB;
st.structure = nB;
st.walkContext = rB;
var g2 = {};
const z1 = R, iB = 36, ku = 42, Vr = 61, aB = 94, $o = 124, lB = 126;
function cB() {
  this.eof && this.error("Unexpected end of input");
  const e = this.tokenStart;
  let t = !1;
  return this.isDelim(ku) ? (t = !0, this.next()) : this.isDelim($o) || this.eat(z1.Ident), this.isDelim($o) ? this.charCodeAt(this.tokenStart + 1) !== Vr ? (this.next(), this.eat(z1.Ident)) : t && this.error("Identifier is expected", this.tokenEnd) : t && this.error("Vertical line is expected"), {
    type: "Identifier",
    loc: this.getLocation(e, this.tokenStart),
    name: this.substrToCursor(e)
  };
}
function uB() {
  const e = this.tokenStart, t = this.charCodeAt(e);
  return t !== Vr && t !== lB && t !== aB && t !== iB && t !== ku && t !== $o && this.error("Attribute selector (=, ~=, ^=, $=, *=, |=) is expected"), this.next(), t !== Vr && (this.isDelim(Vr) || this.error("Equal sign is expected"), this.next()), this.substrToCursor(e);
}
const hB = "AttributeSelector", mB = {
  name: "Identifier",
  matcher: [String, null],
  value: ["String", "Identifier", null],
  flags: [String, null]
};
function fB() {
  const e = this.tokenStart;
  let t, r = null, n = null, o = null;
  return this.eat(z1.LeftSquareBracket), this.skipSC(), t = cB.call(this), this.skipSC(), this.tokenType !== z1.RightSquareBracket && (this.tokenType !== z1.Ident && (r = uB.call(this), this.skipSC(), n = this.tokenType === z1.String ? this.String() : this.Identifier(), this.skipSC()), this.tokenType === z1.Ident && (o = this.consume(z1.Ident), this.skipSC())), this.eat(z1.RightSquareBracket), {
    type: "AttributeSelector",
    loc: this.getLocation(e, this.tokenStart),
    name: t,
    matcher: r,
    value: n,
    flags: o
  };
}
function dB(e) {
  this.token(z1.Delim, "["), this.node(e.name), e.matcher !== null && (this.tokenize(e.matcher), this.node(e.value)), e.flags !== null && this.token(z1.Ident, e.flags), this.token(z1.Delim, "]");
}
g2.generate = dB;
g2.name = hB;
g2.parse = fB;
g2.structure = mB;
var it = {};
const N1 = R, pB = 38;
function vu(e) {
  return this.Raw(e, null, !0);
}
function si() {
  return this.parseWithFallback(this.Rule, vu);
}
function ii(e) {
  return this.Raw(e, this.consumeUntilSemicolonIncluded, !0);
}
function gB() {
  if (this.tokenType === N1.Semicolon)
    return ii.call(this, this.tokenIndex);
  const e = this.parseWithFallback(this.Declaration, ii);
  return this.tokenType === N1.Semicolon && this.next(), e;
}
const kB = "Block", vB = "block", yB = {
  children: [[
    "Atrule",
    "Rule",
    "Declaration"
  ]]
};
function bB(e) {
  const t = e ? gB : si, r = this.tokenStart;
  let n = this.createList();
  this.eat(N1.LeftCurlyBracket);
  e:
    for (; !this.eof; )
      switch (this.tokenType) {
        case N1.RightCurlyBracket:
          break e;
        case N1.WhiteSpace:
        case N1.Comment:
          this.next();
          break;
        case N1.AtKeyword:
          n.push(this.parseWithFallback(this.Atrule.bind(this, e), vu));
          break;
        default:
          e && this.isDelim(pB) ? n.push(si.call(this)) : n.push(t.call(this));
      }
  return this.eof || this.eat(N1.RightCurlyBracket), {
    type: "Block",
    loc: this.getLocation(r, this.tokenStart),
    children: n
  };
}
function xB(e) {
  this.token(N1.LeftCurlyBracket, "{"), this.children(e, (t) => {
    t.type === "Declaration" && this.token(N1.Semicolon, ";");
  }), this.token(N1.RightCurlyBracket, "}");
}
it.generate = xB;
it.name = kB;
it.parse = bB;
it.structure = yB;
it.walkContext = vB;
var k2 = {};
const k8 = R, wB = "Brackets", LB = {
  children: [[]]
};
function zB(e, t) {
  const r = this.tokenStart;
  let n = null;
  return this.eat(k8.LeftSquareBracket), n = e.call(this, t), this.eof || this.eat(k8.RightSquareBracket), {
    type: "Brackets",
    loc: this.getLocation(r, this.tokenStart),
    children: n
  };
}
function CB(e) {
  this.token(k8.Delim, "["), this.children(e), this.token(k8.Delim, "]");
}
k2.generate = CB;
k2.name = wB;
k2.parse = zB;
k2.structure = LB;
var v2 = {};
const yu = R, SB = "CDC", $B = [];
function AB() {
  const e = this.tokenStart;
  return this.eat(yu.CDC), {
    type: "CDC",
    loc: this.getLocation(e, this.tokenStart)
  };
}
function MB() {
  this.token(yu.CDC, "-->");
}
v2.generate = MB;
v2.name = SB;
v2.parse = AB;
v2.structure = $B;
var y2 = {};
const bu = R, jB = "CDO", EB = [];
function TB() {
  const e = this.tokenStart;
  return this.eat(bu.CDO), {
    type: "CDO",
    loc: this.getLocation(e, this.tokenStart)
  };
}
function PB() {
  this.token(bu.CDO, "<!--");
}
y2.generate = PB;
y2.name = jB;
y2.parse = TB;
y2.structure = EB;
var b2 = {};
const Ao = R, NB = 46, DB = "ClassSelector", OB = {
  name: String
};
function RB() {
  return this.eatDelim(NB), {
    type: "ClassSelector",
    loc: this.getLocation(this.tokenStart - 1, this.tokenEnd),
    name: this.consume(Ao.Ident)
  };
}
function IB(e) {
  this.token(Ao.Delim, "."), this.token(Ao.Ident, e.name);
}
b2.generate = IB;
b2.name = DB;
b2.parse = RB;
b2.structure = OB;
var x2 = {};
const ai = R, _B = 43, li = 47, FB = 62, BB = 126, ZB = "Combinator", qB = {
  name: String
};
function UB() {
  const e = this.tokenStart;
  let t;
  switch (this.tokenType) {
    case ai.WhiteSpace:
      t = " ";
      break;
    case ai.Delim:
      switch (this.charCodeAt(this.tokenStart)) {
        case FB:
        case _B:
        case BB:
          this.next();
          break;
        case li:
          this.next(), this.eatIdent("deep"), this.eatDelim(li);
          break;
        default:
          this.error("Combinator is expected");
      }
      t = this.substrToCursor(e);
      break;
  }
  return {
    type: "Combinator",
    loc: this.getLocation(e, this.tokenStart),
    name: t
  };
}
function HB(e) {
  this.tokenize(e.name);
}
x2.generate = HB;
x2.name = ZB;
x2.parse = UB;
x2.structure = qB;
var w2 = {};
const xu = R, GB = 42, WB = 47, VB = "Comment", XB = {
  value: String
};
function YB() {
  const e = this.tokenStart;
  let t = this.tokenEnd;
  return this.eat(xu.Comment), t - e + 2 >= 2 && this.charCodeAt(t - 2) === GB && this.charCodeAt(t - 1) === WB && (t -= 2), {
    type: "Comment",
    loc: this.getLocation(e, this.tokenStart),
    value: this.substring(e + 2, t)
  };
}
function KB(e) {
  this.token(xu.Comment, "/*" + e.value + "*/");
}
w2.generate = KB;
w2.name = VB;
w2.parse = YB;
w2.structure = XB;
var at = {};
const QB = nt, r1 = R, wu = 33, JB = 35, eZ = 36, tZ = 38, rZ = 42, nZ = 43, ci = 47;
function oZ(e) {
  return this.Raw(e, this.consumeUntilExclamationMarkOrSemicolon, !0);
}
function sZ(e) {
  return this.Raw(e, this.consumeUntilExclamationMarkOrSemicolon, !1);
}
function iZ() {
  const e = this.tokenIndex, t = this.Value();
  return t.type !== "Raw" && this.eof === !1 && this.tokenType !== r1.Semicolon && this.isDelim(wu) === !1 && this.isBalanceEdge(e) === !1 && this.error(), t;
}
const aZ = "Declaration", lZ = "declaration", cZ = {
  important: [Boolean, String],
  property: String,
  value: ["Value", "Raw"]
};
function uZ() {
  const e = this.tokenStart, t = this.tokenIndex, r = mZ.call(this), n = QB.isCustomProperty(r), o = n ? this.parseCustomProperty : this.parseValue, s = n ? sZ : oZ;
  let i = !1, l;
  this.skipSC(), this.eat(r1.Colon);
  const c = this.tokenIndex;
  if (n || this.skipSC(), o ? l = this.parseWithFallback(iZ, s) : l = s.call(this, this.tokenIndex), n && l.type === "Value" && l.children.isEmpty) {
    for (let a = c - this.tokenIndex; a <= 0; a++)
      if (this.lookupType(a) === r1.WhiteSpace) {
        l.children.appendData({
          type: "WhiteSpace",
          loc: null,
          value: " "
        });
        break;
      }
  }
  return this.isDelim(wu) && (i = fZ.call(this), this.skipSC()), this.eof === !1 && this.tokenType !== r1.Semicolon && this.isBalanceEdge(t) === !1 && this.error(), {
    type: "Declaration",
    loc: this.getLocation(e, this.tokenStart),
    important: i,
    property: r,
    value: l
  };
}
function hZ(e) {
  this.token(r1.Ident, e.property), this.token(r1.Colon, ":"), this.node(e.value), e.important && (this.token(r1.Delim, "!"), this.token(r1.Ident, e.important === !0 ? "important" : e.important));
}
function mZ() {
  const e = this.tokenStart;
  if (this.tokenType === r1.Delim)
    switch (this.charCodeAt(this.tokenStart)) {
      case rZ:
      case eZ:
      case nZ:
      case JB:
      case tZ:
        this.next();
        break;
      case ci:
        this.next(), this.isDelim(ci) && this.next();
        break;
    }
  return this.tokenType === r1.Hash ? this.eat(r1.Hash) : this.eat(r1.Ident), this.substrToCursor(e);
}
function fZ() {
  this.eat(r1.Delim), this.skipSC();
  const e = this.consume(r1.Ident);
  return e === "important" ? !0 : e;
}
at.generate = hZ;
at.name = aZ;
at.parse = uZ;
at.structure = cZ;
at.walkContext = lZ;
var L2 = {};
const K3 = R, dZ = 38;
function un(e) {
  return this.Raw(e, this.consumeUntilSemicolonIncluded, !0);
}
const pZ = "DeclarationList", gZ = {
  children: [[
    "Declaration",
    "Atrule",
    "Rule"
  ]]
};
function kZ() {
  const e = this.createList();
  for (; !this.eof; )
    switch (this.tokenType) {
      case K3.WhiteSpace:
      case K3.Comment:
      case K3.Semicolon:
        this.next();
        break;
      case K3.AtKeyword:
        e.push(this.parseWithFallback(this.Atrule.bind(this, !0), un));
        break;
      default:
        this.isDelim(dZ) ? e.push(this.parseWithFallback(this.Rule, un)) : e.push(this.parseWithFallback(this.Declaration, un));
    }
  return {
    type: "DeclarationList",
    loc: this.getLocationFromList(e),
    children: e
  };
}
function vZ(e) {
  this.children(e, (t) => {
    t.type === "Declaration" && this.token(K3.Semicolon, ";");
  });
}
L2.generate = vZ;
L2.name = pZ;
L2.parse = kZ;
L2.structure = gZ;
var z2 = {};
const Lu = R, yZ = "Dimension", bZ = {
  value: String,
  unit: String
};
function xZ() {
  const e = this.tokenStart, t = this.consumeNumber(Lu.Dimension);
  return {
    type: "Dimension",
    loc: this.getLocation(e, this.tokenStart),
    value: t,
    unit: this.substring(e + t.length, this.tokenStart)
  };
}
function wZ(e) {
  this.token(Lu.Dimension, e.value + e.unit);
}
z2.generate = wZ;
z2.name = yZ;
z2.parse = xZ;
z2.structure = bZ;
var lt = {};
const Mo = R, LZ = "Function", zZ = "function", CZ = {
  name: String,
  children: [[]]
};
function SZ(e, t) {
  const r = this.tokenStart, n = this.consumeFunctionName(), o = n.toLowerCase();
  let s;
  return s = t.hasOwnProperty(o) ? t[o].call(this, t) : e.call(this, t), this.eof || this.eat(Mo.RightParenthesis), {
    type: "Function",
    loc: this.getLocation(r, this.tokenStart),
    name: n,
    children: s
  };
}
function $Z(e) {
  this.token(Mo.Function, e.name + "("), this.children(e), this.token(Mo.RightParenthesis, ")");
}
lt.generate = $Z;
lt.name = LZ;
lt.parse = SZ;
lt.structure = CZ;
lt.walkContext = zZ;
var ct = {};
const zu = R, AZ = "XXX", MZ = "Hash", jZ = {
  value: String
};
function EZ() {
  const e = this.tokenStart;
  return this.eat(zu.Hash), {
    type: "Hash",
    loc: this.getLocation(e, this.tokenStart),
    value: this.substrToCursor(e + 1)
  };
}
function TZ(e) {
  this.token(zu.Hash, "#" + e.value);
}
ct.generate = TZ;
ct.name = MZ;
ct.parse = EZ;
ct.structure = jZ;
ct.xxx = AZ;
var C2 = {};
const Cu = R, PZ = "Identifier", NZ = {
  name: String
};
function DZ() {
  return {
    type: "Identifier",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    name: this.consume(Cu.Ident)
  };
}
function OZ(e) {
  this.token(Cu.Ident, e.name);
}
C2.generate = OZ;
C2.name = PZ;
C2.parse = DZ;
C2.structure = NZ;
var S2 = {};
const Su = R, RZ = "IdSelector", IZ = {
  name: String
};
function _Z() {
  const e = this.tokenStart;
  return this.eat(Su.Hash), {
    type: "IdSelector",
    loc: this.getLocation(e, this.tokenStart),
    name: this.substrToCursor(e + 1)
  };
}
function FZ(e) {
  this.token(Su.Delim, "#" + e.name);
}
S2.generate = FZ;
S2.name = RZ;
S2.parse = _Z;
S2.structure = IZ;
var $2 = {};
const s1 = R, BZ = "MediaFeature", ZZ = {
  name: String,
  value: ["Identifier", "Number", "Dimension", "Ratio", null]
};
function qZ() {
  const e = this.tokenStart;
  let t, r = null;
  if (this.eat(s1.LeftParenthesis), this.skipSC(), t = this.consume(s1.Ident), this.skipSC(), this.tokenType !== s1.RightParenthesis) {
    switch (this.eat(s1.Colon), this.skipSC(), this.tokenType) {
      case s1.Number:
        this.lookupNonWSType(1) === s1.Delim ? r = this.Ratio() : r = this.Number();
        break;
      case s1.Dimension:
        r = this.Dimension();
        break;
      case s1.Ident:
        r = this.Identifier();
        break;
      default:
        this.error("Number, dimension, ratio or identifier is expected");
    }
    this.skipSC();
  }
  return this.eat(s1.RightParenthesis), {
    type: "MediaFeature",
    loc: this.getLocation(e, this.tokenStart),
    name: t,
    value: r
  };
}
function UZ(e) {
  this.token(s1.LeftParenthesis, "("), this.token(s1.Ident, e.name), e.value !== null && (this.token(s1.Colon, ":"), this.node(e.value)), this.token(s1.RightParenthesis, ")");
}
$2.generate = UZ;
$2.name = BZ;
$2.parse = qZ;
$2.structure = ZZ;
var A2 = {};
const Cr = R, HZ = "MediaQuery", GZ = {
  children: [[
    "Identifier",
    "MediaFeature",
    "WhiteSpace"
  ]]
};
function WZ() {
  const e = this.createList();
  let t = null;
  this.skipSC();
  e:
    for (; !this.eof; ) {
      switch (this.tokenType) {
        case Cr.Comment:
        case Cr.WhiteSpace:
          this.next();
          continue;
        case Cr.Ident:
          t = this.Identifier();
          break;
        case Cr.LeftParenthesis:
          t = this.MediaFeature();
          break;
        default:
          break e;
      }
      e.push(t);
    }
  return t === null && this.error("Identifier or parenthesis is expected"), {
    type: "MediaQuery",
    loc: this.getLocationFromList(e),
    children: e
  };
}
function VZ(e) {
  this.children(e);
}
A2.generate = VZ;
A2.name = HZ;
A2.parse = WZ;
A2.structure = GZ;
var M2 = {};
const $u = R, XZ = "MediaQueryList", YZ = {
  children: [[
    "MediaQuery"
  ]]
};
function KZ() {
  const e = this.createList();
  for (this.skipSC(); !this.eof && (e.push(this.MediaQuery()), this.tokenType === $u.Comma); )
    this.next();
  return {
    type: "MediaQueryList",
    loc: this.getLocationFromList(e),
    children: e
  };
}
function QZ(e) {
  this.children(e, () => this.token($u.Comma, ","));
}
M2.generate = QZ;
M2.name = XZ;
M2.parse = KZ;
M2.structure = YZ;
var j2 = {};
const JZ = R, eq = 38, tq = "NestingSelector", rq = {};
function nq() {
  const e = this.tokenStart;
  return this.eatDelim(eq), {
    type: "NestingSelector",
    loc: this.getLocation(e, this.tokenStart)
  };
}
function oq() {
  this.token(JZ.Delim, "&");
}
j2.generate = oq;
j2.name = tq;
j2.parse = nq;
j2.structure = rq;
var E2 = {};
const sq = R, iq = "Nth", aq = {
  nth: ["AnPlusB", "Identifier"],
  selector: ["SelectorList", null]
};
function lq() {
  this.skipSC();
  const e = this.tokenStart;
  let t = e, r = null, n;
  return this.lookupValue(0, "odd") || this.lookupValue(0, "even") ? n = this.Identifier() : n = this.AnPlusB(), t = this.tokenStart, this.skipSC(), this.lookupValue(0, "of") && (this.next(), r = this.SelectorList(), t = this.tokenStart), {
    type: "Nth",
    loc: this.getLocation(e, t),
    nth: n,
    selector: r
  };
}
function cq(e) {
  this.node(e.nth), e.selector !== null && (this.token(sq.Ident, "of"), this.node(e.selector));
}
E2.generate = cq;
E2.name = iq;
E2.parse = lq;
E2.structure = aq;
var T2 = {};
const Au = R, uq = "Number", hq = {
  value: String
};
function mq() {
  return {
    type: "Number",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    value: this.consume(Au.Number)
  };
}
function fq(e) {
  this.token(Au.Number, e.value);
}
T2.generate = fq;
T2.name = uq;
T2.parse = mq;
T2.structure = hq;
var P2 = {};
const dq = "Operator", pq = {
  value: String
};
function gq() {
  const e = this.tokenStart;
  return this.next(), {
    type: "Operator",
    loc: this.getLocation(e, this.tokenStart),
    value: this.substrToCursor(e)
  };
}
function kq(e) {
  this.tokenize(e.value);
}
P2.generate = kq;
P2.name = dq;
P2.parse = gq;
P2.structure = pq;
var N2 = {};
const v8 = R, vq = "Parentheses", yq = {
  children: [[]]
};
function bq(e, t) {
  const r = this.tokenStart;
  let n = null;
  return this.eat(v8.LeftParenthesis), n = e.call(this, t), this.eof || this.eat(v8.RightParenthesis), {
    type: "Parentheses",
    loc: this.getLocation(r, this.tokenStart),
    children: n
  };
}
function xq(e) {
  this.token(v8.LeftParenthesis, "("), this.children(e), this.token(v8.RightParenthesis, ")");
}
N2.generate = xq;
N2.name = vq;
N2.parse = bq;
N2.structure = yq;
var D2 = {};
const Mu = R, wq = "Percentage", Lq = {
  value: String
};
function zq() {
  return {
    type: "Percentage",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    value: this.consumeNumber(Mu.Percentage)
  };
}
function Cq(e) {
  this.token(Mu.Percentage, e.value + "%");
}
D2.generate = Cq;
D2.name = wq;
D2.parse = zq;
D2.structure = Lq;
var ut = {};
const Ae = R, Sq = "PseudoClassSelector", $q = "function", Aq = {
  name: String,
  children: [["Raw"], null]
};
function Mq() {
  const e = this.tokenStart;
  let t = null, r, n;
  return this.eat(Ae.Colon), this.tokenType === Ae.Function ? (r = this.consumeFunctionName(), n = r.toLowerCase(), hasOwnProperty.call(this.pseudo, n) ? (this.skipSC(), t = this.pseudo[n].call(this), this.skipSC()) : (t = this.createList(), t.push(
    this.Raw(this.tokenIndex, null, !1)
  )), this.eat(Ae.RightParenthesis)) : r = this.consume(Ae.Ident), {
    type: "PseudoClassSelector",
    loc: this.getLocation(e, this.tokenStart),
    name: r,
    children: t
  };
}
function jq(e) {
  this.token(Ae.Colon, ":"), e.children === null ? this.token(Ae.Ident, e.name) : (this.token(Ae.Function, e.name + "("), this.children(e), this.token(Ae.RightParenthesis, ")"));
}
ut.generate = jq;
ut.name = Sq;
ut.parse = Mq;
ut.structure = Aq;
ut.walkContext = $q;
var ht = {};
const W1 = R, Eq = "PseudoElementSelector", Tq = "function", Pq = {
  name: String,
  children: [["Raw"], null]
};
function Nq() {
  const e = this.tokenStart;
  let t = null, r, n;
  return this.eat(W1.Colon), this.eat(W1.Colon), this.tokenType === W1.Function ? (r = this.consumeFunctionName(), n = r.toLowerCase(), hasOwnProperty.call(this.pseudo, n) ? (this.skipSC(), t = this.pseudo[n].call(this), this.skipSC()) : (t = this.createList(), t.push(
    this.Raw(this.tokenIndex, null, !1)
  )), this.eat(W1.RightParenthesis)) : r = this.consume(W1.Ident), {
    type: "PseudoElementSelector",
    loc: this.getLocation(e, this.tokenStart),
    name: r,
    children: t
  };
}
function Dq(e) {
  this.token(W1.Colon, ":"), this.token(W1.Colon, ":"), e.children === null ? this.token(W1.Ident, e.name) : (this.token(W1.Function, e.name + "("), this.children(e), this.token(W1.RightParenthesis, ")"));
}
ht.generate = Dq;
ht.name = Eq;
ht.parse = Nq;
ht.structure = Pq;
ht.walkContext = Tq;
var O2 = {};
const Xr = R, Oq = h0, Rq = 47, Iq = 46;
function ui() {
  this.skipSC();
  const e = this.consume(Xr.Number);
  for (let t = 0; t < e.length; t++) {
    const r = e.charCodeAt(t);
    !Oq.isDigit(r) && r !== Iq && this.error("Unsigned number is expected", this.tokenStart - e.length + t);
  }
  return Number(e) === 0 && this.error("Zero number is not allowed", this.tokenStart - e.length), e;
}
const _q = "Ratio", Fq = {
  left: String,
  right: String
};
function Bq() {
  const e = this.tokenStart, t = ui.call(this);
  let r;
  return this.skipSC(), this.eatDelim(Rq), r = ui.call(this), {
    type: "Ratio",
    loc: this.getLocation(e, this.tokenStart),
    left: t,
    right: r
  };
}
function Zq(e) {
  this.token(Xr.Number, e.left), this.token(Xr.Delim, "/"), this.token(Xr.Number, e.right);
}
O2.generate = Zq;
O2.name = _q;
O2.parse = Bq;
O2.structure = Fq;
var R2 = {};
const qq = R;
function Uq() {
  return this.tokenIndex > 0 && this.lookupType(-1) === qq.WhiteSpace ? this.tokenIndex > 1 ? this.getTokenStart(this.tokenIndex - 1) : this.firstCharOffset : this.tokenStart;
}
const Hq = "Raw", Gq = {
  value: String
};
function Wq(e, t, r) {
  const n = this.getTokenStart(e);
  let o;
  return this.skipUntilBalanced(e, t || this.consumeUntilBalanceEnd), r && this.tokenStart > n ? o = Uq.call(this) : o = this.tokenStart, {
    type: "Raw",
    loc: this.getLocation(n, o),
    value: this.substring(n, o)
  };
}
function Vq(e) {
  this.tokenize(e.value);
}
R2.generate = Vq;
R2.name = Hq;
R2.parse = Wq;
R2.structure = Gq;
var mt = {};
const Xq = R;
function hi(e) {
  return this.Raw(e, this.consumeUntilLeftCurlyBracket, !0);
}
function Yq() {
  const e = this.SelectorList();
  return e.type !== "Raw" && this.eof === !1 && this.tokenType !== Xq.LeftCurlyBracket && this.error(), e;
}
const Kq = "Rule", Qq = "rule", Jq = {
  prelude: ["SelectorList", "Raw"],
  block: ["Block"]
};
function eU() {
  const e = this.tokenIndex, t = this.tokenStart;
  let r, n;
  return this.parseRulePrelude ? r = this.parseWithFallback(Yq, hi) : r = hi.call(this, e), n = this.Block(!0), {
    type: "Rule",
    loc: this.getLocation(t, this.tokenStart),
    prelude: r,
    block: n
  };
}
function tU(e) {
  this.node(e.prelude), this.node(e.block);
}
mt.generate = tU;
mt.name = Kq;
mt.parse = eU;
mt.structure = Jq;
mt.walkContext = Qq;
var I2 = {};
const rU = "Selector", nU = {
  children: [[
    "TypeSelector",
    "IdSelector",
    "ClassSelector",
    "AttributeSelector",
    "PseudoClassSelector",
    "PseudoElementSelector",
    "Combinator",
    "WhiteSpace"
  ]]
};
function oU() {
  const e = this.readSequence(this.scope.Selector);
  return this.getFirstListNode(e) === null && this.error("Selector is expected"), {
    type: "Selector",
    loc: this.getLocationFromList(e),
    children: e
  };
}
function sU(e) {
  this.children(e);
}
I2.generate = sU;
I2.name = rU;
I2.parse = oU;
I2.structure = nU;
var ft = {};
const ju = R, iU = "SelectorList", aU = "selector", lU = {
  children: [[
    "Selector",
    "Raw"
  ]]
};
function cU() {
  const e = this.createList();
  for (; !this.eof; ) {
    if (e.push(this.Selector()), this.tokenType === ju.Comma) {
      this.next();
      continue;
    }
    break;
  }
  return {
    type: "SelectorList",
    loc: this.getLocationFromList(e),
    children: e
  };
}
function uU(e) {
  this.children(e, () => this.token(ju.Comma, ","));
}
ft.generate = uU;
ft.name = iU;
ft.parse = cU;
ft.structure = lU;
ft.walkContext = aU;
var _2 = {}, R7 = {};
const jo = h0, mi = T0, Eo = 92, Eu = 34, Tu = 39;
function hU(e) {
  const t = e.length, r = e.charCodeAt(0), n = r === Eu || r === Tu ? 1 : 0, o = n === 1 && t > 1 && e.charCodeAt(t - 1) === r ? t - 2 : t - 1;
  let s = "";
  for (let i = n; i <= o; i++) {
    let l = e.charCodeAt(i);
    if (l === Eo) {
      if (i === o) {
        i !== t - 1 && (s = e.substr(i + 1));
        break;
      }
      if (l = e.charCodeAt(++i), jo.isValidEscape(Eo, l)) {
        const c = i - 1, a = mi.consumeEscaped(e, c);
        i = a - 1, s += mi.decodeEscaped(e.substring(c + 1, a));
      } else
        l === 13 && e.charCodeAt(i + 1) === 10 && i++;
    } else
      s += e[i];
  }
  return s;
}
function mU(e, t) {
  const r = t ? "'" : '"', n = t ? Tu : Eu;
  let o = "", s = !1;
  for (let i = 0; i < e.length; i++) {
    const l = e.charCodeAt(i);
    if (l === 0) {
      o += "\uFFFD";
      continue;
    }
    if (l <= 31 || l === 127) {
      o += "\\" + l.toString(16), s = !0;
      continue;
    }
    l === n || l === Eo ? (o += "\\" + e.charAt(i), s = !1) : (s && (jo.isHexDigit(l) || jo.isWhiteSpace(l)) && (o += " "), o += e.charAt(i), s = !1);
  }
  return r + o + r;
}
R7.decode = hU;
R7.encode = mU;
const Pu = R7, Nu = R, fU = "String", dU = {
  value: String
};
function pU() {
  return {
    type: "String",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    value: Pu.decode(this.consume(Nu.String))
  };
}
function gU(e) {
  this.token(Nu.String, Pu.encode(e.value));
}
_2.generate = gU;
_2.name = fU;
_2.parse = pU;
_2.structure = dU;
var dt = {};
const T3 = R, kU = 33;
function fi(e) {
  return this.Raw(e, null, !1);
}
const vU = "StyleSheet", yU = "stylesheet", bU = {
  children: [[
    "Comment",
    "CDO",
    "CDC",
    "Atrule",
    "Rule",
    "Raw"
  ]]
};
function xU() {
  const e = this.tokenStart, t = this.createList();
  let r;
  for (; !this.eof; ) {
    switch (this.tokenType) {
      case T3.WhiteSpace:
        this.next();
        continue;
      case T3.Comment:
        if (this.charCodeAt(this.tokenStart + 2) !== kU) {
          this.next();
          continue;
        }
        r = this.Comment();
        break;
      case T3.CDO:
        r = this.CDO();
        break;
      case T3.CDC:
        r = this.CDC();
        break;
      case T3.AtKeyword:
        r = this.parseWithFallback(this.Atrule, fi);
        break;
      default:
        r = this.parseWithFallback(this.Rule, fi);
    }
    t.push(r);
  }
  return {
    type: "StyleSheet",
    loc: this.getLocation(e, this.tokenStart),
    children: t
  };
}
function wU(e) {
  this.children(e);
}
dt.generate = wU;
dt.name = vU;
dt.parse = xU;
dt.structure = bU;
dt.walkContext = yU;
var F2 = {};
const LU = R, zU = 42, di = 124;
function hn() {
  this.tokenType !== LU.Ident && this.isDelim(zU) === !1 && this.error("Identifier or asterisk is expected"), this.next();
}
const CU = "TypeSelector", SU = {
  name: String
};
function $U() {
  const e = this.tokenStart;
  return this.isDelim(di) ? (this.next(), hn.call(this)) : (hn.call(this), this.isDelim(di) && (this.next(), hn.call(this))), {
    type: "TypeSelector",
    loc: this.getLocation(e, this.tokenStart),
    name: this.substrToCursor(e)
  };
}
function AU(e) {
  this.tokenize(e.name);
}
F2.generate = AU;
F2.name = CU;
F2.parse = $U;
F2.structure = SU;
var B2 = {};
const P3 = R, MU = h0, Du = 43, Ou = 45, To = 63;
function Q3(e, t) {
  let r = 0;
  for (let n = this.tokenStart + e; n < this.tokenEnd; n++) {
    const o = this.charCodeAt(n);
    if (o === Ou && t && r !== 0)
      return Q3.call(this, e + r + 1, !1), -1;
    MU.isHexDigit(o) || this.error(
      t && r !== 0 ? "Hyphen minus" + (r < 6 ? " or hex digit" : "") + " is expected" : r < 6 ? "Hex digit is expected" : "Unexpected input",
      n
    ), ++r > 6 && this.error("Too many hex digits", n);
  }
  return this.next(), r;
}
function Sr(e) {
  let t = 0;
  for (; this.isDelim(To); )
    ++t > e && this.error("Too many question marks"), this.next();
}
function jU(e) {
  this.charCodeAt(this.tokenStart) !== e && this.error((e === Du ? "Plus sign" : "Hyphen minus") + " is expected");
}
function EU() {
  let e = 0;
  switch (this.tokenType) {
    case P3.Number:
      if (e = Q3.call(this, 1, !0), this.isDelim(To)) {
        Sr.call(this, 6 - e);
        break;
      }
      if (this.tokenType === P3.Dimension || this.tokenType === P3.Number) {
        jU.call(this, Ou), Q3.call(this, 1, !1);
        break;
      }
      break;
    case P3.Dimension:
      e = Q3.call(this, 1, !0), e > 0 && Sr.call(this, 6 - e);
      break;
    default:
      if (this.eatDelim(Du), this.tokenType === P3.Ident) {
        e = Q3.call(this, 0, !0), e > 0 && Sr.call(this, 6 - e);
        break;
      }
      if (this.isDelim(To)) {
        this.next(), Sr.call(this, 5);
        break;
      }
      this.error("Hex digit or question mark is expected");
  }
}
const TU = "UnicodeRange", PU = {
  value: String
};
function NU() {
  const e = this.tokenStart;
  return this.eatIdent("u"), EU.call(this), {
    type: "UnicodeRange",
    loc: this.getLocation(e, this.tokenStart),
    value: this.substrToCursor(e)
  };
}
function DU(e) {
  this.tokenize(e.value);
}
B2.generate = DU;
B2.name = TU;
B2.parse = NU;
B2.structure = PU;
var Z2 = {}, o4 = {};
const Yr = h0, pi = T0, OU = 32, Po = 92, RU = 34, IU = 39, _U = 40, Ru = 41;
function FU(e) {
  const t = e.length;
  let r = 4, n = e.charCodeAt(t - 1) === Ru ? t - 2 : t - 1, o = "";
  for (; r < n && Yr.isWhiteSpace(e.charCodeAt(r)); )
    r++;
  for (; r < n && Yr.isWhiteSpace(e.charCodeAt(n)); )
    n--;
  for (let s = r; s <= n; s++) {
    let i = e.charCodeAt(s);
    if (i === Po) {
      if (s === n) {
        s !== t - 1 && (o = e.substr(s + 1));
        break;
      }
      if (i = e.charCodeAt(++s), Yr.isValidEscape(Po, i)) {
        const l = s - 1, c = pi.consumeEscaped(e, l);
        s = c - 1, o += pi.decodeEscaped(e.substring(l + 1, c));
      } else
        i === 13 && e.charCodeAt(s + 1) === 10 && s++;
    } else
      o += e[s];
  }
  return o;
}
function BU(e) {
  let t = "", r = !1;
  for (let n = 0; n < e.length; n++) {
    const o = e.charCodeAt(n);
    if (o === 0) {
      t += "\uFFFD";
      continue;
    }
    if (o <= 31 || o === 127) {
      t += "\\" + o.toString(16), r = !0;
      continue;
    }
    o === OU || o === Po || o === RU || o === IU || o === _U || o === Ru ? (t += "\\" + e.charAt(n), r = !1) : (r && Yr.isHexDigit(o) && (t += " "), t += e.charAt(n), r = !1);
  }
  return "url(" + t + ")";
}
o4.decode = FU;
o4.encode = BU;
const Iu = o4, ZU = R7, Ue = R, qU = "Url", UU = {
  value: String
};
function HU() {
  const e = this.tokenStart;
  let t;
  switch (this.tokenType) {
    case Ue.Url:
      t = Iu.decode(this.consume(Ue.Url));
      break;
    case Ue.Function:
      this.cmpStr(this.tokenStart, this.tokenEnd, "url(") || this.error("Function name must be `url`"), this.eat(Ue.Function), this.skipSC(), t = ZU.decode(this.consume(Ue.String)), this.skipSC(), this.eof || this.eat(Ue.RightParenthesis);
      break;
    default:
      this.error("Url or Function is expected");
  }
  return {
    type: "Url",
    loc: this.getLocation(e, this.tokenStart),
    value: t
  };
}
function GU(e) {
  this.token(Ue.Url, Iu.encode(e.value));
}
Z2.generate = GU;
Z2.name = qU;
Z2.parse = HU;
Z2.structure = UU;
var q2 = {};
const WU = "Value", VU = {
  children: [[]]
};
function XU() {
  const e = this.tokenStart, t = this.readSequence(this.scope.Value);
  return {
    type: "Value",
    loc: this.getLocation(e, this.tokenStart),
    children: t
  };
}
function YU(e) {
  this.children(e);
}
q2.generate = YU;
q2.name = WU;
q2.parse = XU;
q2.structure = VU;
var U2 = {};
const _u = R, KU = Object.freeze({
  type: "WhiteSpace",
  loc: null,
  value: " "
}), QU = "WhiteSpace", JU = {
  value: String
};
function eH() {
  return this.eat(_u.WhiteSpace), KU;
}
function tH(e) {
  this.token(_u.WhiteSpace, e.value);
}
U2.generate = tH;
U2.name = QU;
U2.parse = eH;
U2.structure = JU;
const rH = p2, nH = ot, oH = st, sH = g2, iH = it, aH = k2, lH = v2, cH = y2, uH = b2, hH = x2, mH = w2, fH = at, dH = L2, pH = z2, gH = lt, kH = ct, vH = C2, yH = S2, bH = $2, xH = A2, wH = M2, LH = j2, zH = E2, CH = T2, SH = P2, $H = N2, AH = D2, MH = ut, jH = ht, EH = O2, TH = R2, PH = mt, NH = I2, DH = ft, OH = _2, RH = dt, IH = F2, _H = B2, FH = Z2, BH = q2, ZH = U2;
t0.AnPlusB = rH;
t0.Atrule = nH;
t0.AtrulePrelude = oH;
t0.AttributeSelector = sH;
t0.Block = iH;
t0.Brackets = aH;
t0.CDC = lH;
t0.CDO = cH;
t0.ClassSelector = uH;
t0.Combinator = hH;
t0.Comment = mH;
t0.Declaration = fH;
t0.DeclarationList = dH;
t0.Dimension = pH;
t0.Function = gH;
t0.Hash = kH;
t0.Identifier = vH;
t0.IdSelector = yH;
t0.MediaFeature = bH;
t0.MediaQuery = xH;
t0.MediaQueryList = wH;
t0.NestingSelector = LH;
t0.Nth = zH;
t0.Number = CH;
t0.Operator = SH;
t0.Parentheses = $H;
t0.Percentage = AH;
t0.PseudoClassSelector = MH;
t0.PseudoElementSelector = jH;
t0.Ratio = EH;
t0.Raw = TH;
t0.Rule = PH;
t0.Selector = NH;
t0.SelectorList = DH;
t0.String = OH;
t0.StyleSheet = RH;
t0.TypeSelector = IH;
t0.UnicodeRange = _H;
t0.Url = FH;
t0.Value = BH;
t0.WhiteSpace = ZH;
const qH = qF, UH = t0, HH = {
  generic: !0,
  ...qH,
  node: UH
};
var GH = HH, s4 = {};
const g1 = R, WH = 35, VH = 42, gi = 43, XH = 45, YH = 47, KH = 117;
function QH(e) {
  switch (this.tokenType) {
    case g1.Hash:
      return this.Hash();
    case g1.Comma:
      return this.Operator();
    case g1.LeftParenthesis:
      return this.Parentheses(this.readSequence, e.recognizer);
    case g1.LeftSquareBracket:
      return this.Brackets(this.readSequence, e.recognizer);
    case g1.String:
      return this.String();
    case g1.Dimension:
      return this.Dimension();
    case g1.Percentage:
      return this.Percentage();
    case g1.Number:
      return this.Number();
    case g1.Function:
      return this.cmpStr(this.tokenStart, this.tokenEnd, "url(") ? this.Url() : this.Function(this.readSequence, e.recognizer);
    case g1.Url:
      return this.Url();
    case g1.Ident:
      return this.cmpChar(this.tokenStart, KH) && this.cmpChar(this.tokenStart + 1, gi) ? this.UnicodeRange() : this.Identifier();
    case g1.Delim: {
      const t = this.charCodeAt(this.tokenStart);
      if (t === YH || t === VH || t === gi || t === XH)
        return this.Operator();
      t === WH && this.error("Hex or identifier is expected", this.tokenStart + 1);
      break;
    }
  }
}
var Fu = QH;
const JH = Fu, eG = {
  getNode: JH
};
var tG = eG;
const oe = R, rG = 35, nG = 38, oG = 42, sG = 43, iG = 47, ki = 46, aG = 62, lG = 124, cG = 126;
function uG(e, t) {
  t.last !== null && t.last.type !== "Combinator" && e !== null && e.type !== "Combinator" && t.push({
    type: "Combinator",
    loc: null,
    name: " "
  });
}
function hG() {
  switch (this.tokenType) {
    case oe.LeftSquareBracket:
      return this.AttributeSelector();
    case oe.Hash:
      return this.IdSelector();
    case oe.Colon:
      return this.lookupType(1) === oe.Colon ? this.PseudoElementSelector() : this.PseudoClassSelector();
    case oe.Ident:
      return this.TypeSelector();
    case oe.Number:
    case oe.Percentage:
      return this.Percentage();
    case oe.Dimension:
      this.charCodeAt(this.tokenStart) === ki && this.error("Identifier is expected", this.tokenStart + 1);
      break;
    case oe.Delim: {
      switch (this.charCodeAt(this.tokenStart)) {
        case sG:
        case aG:
        case cG:
        case iG:
          return this.Combinator();
        case ki:
          return this.ClassSelector();
        case oG:
        case lG:
          return this.TypeSelector();
        case rG:
          return this.IdSelector();
        case nG:
          return this.NestingSelector();
      }
      break;
    }
  }
}
const mG = {
  onWhiteSpace: uG,
  getNode: hG
};
var fG = mG;
function dG() {
  return this.createSingleNodeList(
    this.Raw(this.tokenIndex, null, !1)
  );
}
var pG = dG;
const vi = R;
function gG() {
  const e = this.createList();
  if (this.skipSC(), e.push(this.Identifier()), this.skipSC(), this.tokenType === vi.Comma) {
    e.push(this.Operator());
    const t = this.tokenIndex, r = this.parseCustomProperty ? this.Value(null) : this.Raw(this.tokenIndex, this.consumeUntilExclamationMarkOrSemicolon, !1);
    if (r.type === "Value" && r.children.isEmpty) {
      for (let n = t - this.tokenIndex; n <= 0; n++)
        if (this.lookupType(n) === vi.WhiteSpace) {
          r.children.appendData({
            type: "WhiteSpace",
            loc: null,
            value: " "
          });
          break;
        }
    }
    e.push(r);
  }
  return e;
}
var kG = gG;
const vG = Fu, yG = pG, bG = kG;
function yi(e) {
  return e !== null && e.type === "Operator" && (e.value[e.value.length - 1] === "-" || e.value[e.value.length - 1] === "+");
}
const xG = {
  getNode: vG,
  onWhiteSpace(e, t) {
    yi(e) && (e.value = " " + e.value), yi(t.last) && (t.last.value += " ");
  },
  expression: yG,
  var: bG
};
var wG = xG;
const LG = tG, zG = fG, CG = wG;
s4.AtrulePrelude = LG;
s4.Selector = zG;
s4.Value = CG;
const SG = {
  parse: {
    prelude: null,
    block() {
      return this.Block(!0);
    }
  }
};
var $G = SG;
const N3 = R, AG = {
  parse: {
    prelude() {
      const e = this.createList();
      switch (this.skipSC(), this.tokenType) {
        case N3.String:
          e.push(this.String());
          break;
        case N3.Url:
        case N3.Function:
          e.push(this.Url());
          break;
        default:
          this.error("String or url() is expected");
      }
      return (this.lookupNonWSType(0) === N3.Ident || this.lookupNonWSType(0) === N3.LeftParenthesis) && e.push(this.MediaQueryList()), e;
    },
    block: null
  }
};
var MG = AG;
const jG = {
  parse: {
    prelude() {
      return this.createSingleNodeList(
        this.MediaQueryList()
      );
    },
    block(e = !1) {
      return this.Block(e);
    }
  }
};
var EG = jG;
const TG = {
  parse: {
    prelude() {
      return this.createSingleNodeList(
        this.SelectorList()
      );
    },
    block() {
      return this.Block(!0);
    }
  }
};
var PG = TG;
const NG = {
  parse: {
    prelude() {
      return this.createSingleNodeList(
        this.SelectorList()
      );
    },
    block() {
      return this.Block(!0);
    }
  }
};
var DG = NG;
const Xe = R;
function OG() {
  return this.createSingleNodeList(
    this.Raw(this.tokenIndex, null, !1)
  );
}
function RG() {
  return this.skipSC(), this.tokenType === Xe.Ident && this.lookupNonWSType(1) === Xe.Colon ? this.createSingleNodeList(
    this.Declaration()
  ) : Bu.call(this);
}
function Bu() {
  const e = this.createList();
  let t;
  this.skipSC();
  e:
    for (; !this.eof; ) {
      switch (this.tokenType) {
        case Xe.Comment:
        case Xe.WhiteSpace:
          this.next();
          continue;
        case Xe.Function:
          t = this.Function(OG, this.scope.AtrulePrelude);
          break;
        case Xe.Ident:
          t = this.Identifier();
          break;
        case Xe.LeftParenthesis:
          t = this.Parentheses(RG, this.scope.AtrulePrelude);
          break;
        default:
          break e;
      }
      e.push(t);
    }
  return e;
}
const IG = {
  parse: {
    prelude() {
      const e = Bu.call(this);
      return this.getFirstListNode(e) === null && this.error("Condition is expected"), e;
    },
    block(e = !1) {
      return this.Block(e);
    }
  }
};
var _G = IG;
const FG = $G, BG = MG, ZG = EG, qG = PG, UG = DG, HG = _G, GG = {
  "font-face": FG,
  import: BG,
  media: ZG,
  nest: qG,
  page: UG,
  supports: HG
};
var WG = GG;
const Ie = {
  parse() {
    return this.createSingleNodeList(
      this.SelectorList()
    );
  }
}, mn = {
  parse() {
    return this.createSingleNodeList(
      this.Selector()
    );
  }
}, bi = {
  parse() {
    return this.createSingleNodeList(
      this.Identifier()
    );
  }
}, $r = {
  parse() {
    return this.createSingleNodeList(
      this.Nth()
    );
  }
}, VG = {
  dir: bi,
  has: Ie,
  lang: bi,
  matches: Ie,
  is: Ie,
  "-moz-any": Ie,
  "-webkit-any": Ie,
  where: Ie,
  not: Ie,
  "nth-child": $r,
  "nth-last-child": $r,
  "nth-last-of-type": $r,
  "nth-of-type": $r,
  slotted: mn,
  host: mn,
  "host-context": mn
};
var XG = VG, n0 = {};
const YG = p2, KG = ot, QG = st, JG = g2, eW = it, tW = k2, rW = v2, nW = y2, oW = b2, sW = x2, iW = w2, aW = at, lW = L2, cW = z2, uW = lt, hW = ct, mW = C2, fW = S2, dW = $2, pW = A2, gW = M2, kW = j2, vW = E2, yW = T2, bW = P2, xW = N2, wW = D2, LW = ut, zW = ht, CW = O2, SW = R2, $W = mt, AW = I2, MW = ft, jW = _2, EW = dt, TW = F2, PW = B2, NW = Z2, DW = q2, OW = U2;
n0.AnPlusB = YG.parse;
n0.Atrule = KG.parse;
n0.AtrulePrelude = QG.parse;
n0.AttributeSelector = JG.parse;
n0.Block = eW.parse;
n0.Brackets = tW.parse;
n0.CDC = rW.parse;
n0.CDO = nW.parse;
n0.ClassSelector = oW.parse;
n0.Combinator = sW.parse;
n0.Comment = iW.parse;
n0.Declaration = aW.parse;
n0.DeclarationList = lW.parse;
n0.Dimension = cW.parse;
n0.Function = uW.parse;
n0.Hash = hW.parse;
n0.Identifier = mW.parse;
n0.IdSelector = fW.parse;
n0.MediaFeature = dW.parse;
n0.MediaQuery = pW.parse;
n0.MediaQueryList = gW.parse;
n0.NestingSelector = kW.parse;
n0.Nth = vW.parse;
n0.Number = yW.parse;
n0.Operator = bW.parse;
n0.Parentheses = xW.parse;
n0.Percentage = wW.parse;
n0.PseudoClassSelector = LW.parse;
n0.PseudoElementSelector = zW.parse;
n0.Ratio = CW.parse;
n0.Raw = SW.parse;
n0.Rule = $W.parse;
n0.Selector = AW.parse;
n0.SelectorList = MW.parse;
n0.String = jW.parse;
n0.StyleSheet = EW.parse;
n0.TypeSelector = TW.parse;
n0.UnicodeRange = PW.parse;
n0.Url = NW.parse;
n0.Value = DW.parse;
n0.WhiteSpace = OW.parse;
const RW = s4, IW = WG, _W = XG, FW = n0, BW = {
  parseContext: {
    default: "StyleSheet",
    stylesheet: "StyleSheet",
    atrule: "Atrule",
    atrulePrelude(e) {
      return this.AtrulePrelude(e.atrule ? String(e.atrule) : null);
    },
    mediaQueryList: "MediaQueryList",
    mediaQuery: "MediaQuery",
    rule: "Rule",
    selectorList: "SelectorList",
    selector: "Selector",
    block() {
      return this.Block(!0);
    },
    declarationList: "DeclarationList",
    declaration: "Declaration",
    value: "Value"
  },
  scope: RW,
  atrule: IW,
  pseudo: _W,
  node: FW
};
var ZW = BW;
const qW = t0, UW = {
  node: qW
};
var HW = UW;
const GW = pu, WW = GH, VW = ZW, XW = HW, YW = GW({
  ...WW,
  ...VW,
  ...XW
});
var KW = YW, QW = "2.3.1", I7 = {};
const JW = V9, eV = J8, tV = r4, rV = s5;
I7.SyntaxError = JW.SyntaxError;
I7.generate = eV.generate;
I7.parse = tV.parse;
I7.walk = rV.walk;
var Zu = {};
const nV = rt;
function No(e) {
  const t = {};
  for (const r in e) {
    let n = e[r];
    n && (Array.isArray(n) || n instanceof nV.List ? n = n.map(No) : n.constructor === Object && (n = No(n))), t[r] = n;
  }
  return t;
}
Zu.clone = No;
var i5 = {};
const qu = h0, xi = T0, wi = 92;
function oV(e) {
  const t = e.length - 1;
  let r = "";
  for (let n = 0; n < e.length; n++) {
    let o = e.charCodeAt(n);
    if (o === wi) {
      if (n === t)
        break;
      if (o = e.charCodeAt(++n), qu.isValidEscape(wi, o)) {
        const s = n - 1, i = xi.consumeEscaped(e, s);
        n = i - 1, r += xi.decodeEscaped(e.substring(s + 1, i));
      } else
        o === 13 && e.charCodeAt(n + 1) === 10 && n++;
    } else
      r += e[n];
  }
  return r;
}
function sV(e) {
  let t = "";
  if (e.length === 1 && e.charCodeAt(0) === 45)
    return "\\-";
  for (let r = 0; r < e.length; r++) {
    const n = e.charCodeAt(r);
    if (n === 0) {
      t += "\uFFFD";
      continue;
    }
    if (n <= 31 || n === 127 || n >= 48 && n <= 57 && (r === 0 || r === 1 && e.charCodeAt(0) === 45)) {
      t += "\\" + n.toString(16) + " ";
      continue;
    }
    qu.isName(n) ? t += e.charAt(r) : t += "\\" + e.charAt(r);
  }
  return t;
}
i5.decode = oV;
i5.encode = sV;
const iV = KW, aV = QW, lV = pu, cV = rt, uV = F9, hV = I7, mV = Zu, i4 = nt, fV = i5, dV = R7, pV = o4, gV = R, kV = V8, vV = X8, {
  tokenize: yV,
  parse: bV,
  generate: xV,
  lexer: wV,
  createLexer: LV,
  walk: zV,
  find: CV,
  findLast: SV,
  findAll: $V,
  toPlainObject: AV,
  fromPlainObject: MV,
  fork: jV
} = iV;
d0.version = aV.version;
d0.createSyntax = lV;
d0.List = cV.List;
d0.Lexer = uV.Lexer;
d0.definitionSyntax = hV;
d0.clone = mV.clone;
d0.isCustomProperty = i4.isCustomProperty;
d0.keyword = i4.keyword;
d0.property = i4.property;
d0.vendorPrefix = i4.vendorPrefix;
d0.ident = fV;
d0.string = dV;
d0.url = pV;
d0.tokenTypes = gV;
d0.tokenNames = kV;
d0.TokenStream = vV.TokenStream;
d0.createLexer = LV;
d0.find = CV;
d0.findAll = $V;
d0.findLast = SV;
d0.fork = jV;
d0.fromPlainObject = MV;
d0.generate = xV;
d0.lexer = wV;
d0.parse = bV;
d0.toPlainObject = AV;
d0.tokenize = yV;
d0.walk = zV;
var Ne = {}, EV = "5.0.5", f1 = {}, X = {}, q = {}, I = {};
const TV = 0, PV = 1, NV = 2, DV = 3, OV = 4, RV = 5, IV = 6, _V = 7, FV = 8, BV = 9, ZV = 10, qV = 11, UV = 12, HV = 13, GV = 14, WV = 15, VV = 16, XV = 17, YV = 18, KV = 19, QV = 20, JV = 21, eX = 22, tX = 23, rX = 24, nX = 25;
I.AtKeyword = DV;
I.BadString = IV;
I.BadUrl = FV;
I.CDC = WV;
I.CDO = GV;
I.Colon = VV;
I.Comma = YV;
I.Comment = nX;
I.Delim = BV;
I.Dimension = UV;
I.EOF = TV;
I.Function = NV;
I.Hash = OV;
I.Ident = PV;
I.LeftCurlyBracket = tX;
I.LeftParenthesis = JV;
I.LeftSquareBracket = KV;
I.Number = ZV;
I.Percentage = qV;
I.RightCurlyBracket = rX;
I.RightParenthesis = eX;
I.RightSquareBracket = QV;
I.Semicolon = XV;
I.String = RV;
I.Url = _V;
I.WhiteSpace = HV;
var m0 = {};
const oX = 0;
function Me(e) {
  return e >= 48 && e <= 57;
}
function sX(e) {
  return Me(e) || e >= 65 && e <= 70 || e >= 97 && e <= 102;
}
function Uu(e) {
  return e >= 65 && e <= 90;
}
function Hu(e) {
  return e >= 97 && e <= 122;
}
function Gu(e) {
  return Uu(e) || Hu(e);
}
function Wu(e) {
  return e >= 128;
}
function g7(e) {
  return Gu(e) || Wu(e) || e === 95;
}
function iX(e) {
  return g7(e) || Me(e) || e === 45;
}
function Vu(e) {
  return e >= 0 && e <= 8 || e === 11 || e >= 14 && e <= 31 || e === 127;
}
function a5(e) {
  return e === 10 || e === 13 || e === 12;
}
function Xu(e) {
  return a5(e) || e === 32 || e === 9;
}
function Do(e, t) {
  return !(e !== 92 || a5(t) || t === oX);
}
function aX(e, t, r) {
  return e === 45 ? g7(t) || t === 45 || Do(t, r) : g7(e) ? !0 : e === 92 ? Do(e, t) : !1;
}
function lX(e, t, r) {
  return e === 43 || e === 45 ? Me(t) ? 2 : t === 46 && Me(r) ? 3 : 0 : e === 46 ? Me(t) ? 2 : 0 : Me(e) ? 1 : 0;
}
function cX(e) {
  return e === 65279 || e === 65534 ? 1 : 0;
}
const Oo = new Array(128), Yu = 128, Ku = 130, Qu = 131, l5 = 132, Ju = 133;
for (let e = 0; e < Oo.length; e++)
  Oo[e] = Xu(e) && Ku || Me(e) && Qu || g7(e) && l5 || Vu(e) && Ju || e || Yu;
function uX(e) {
  return e < 128 ? Oo[e] : l5;
}
m0.DigitCategory = Qu;
m0.EofCategory = Yu;
m0.NameStartCategory = l5;
m0.NonPrintableCategory = Ju;
m0.WhiteSpaceCategory = Ku;
m0.charCodeCategory = uX;
m0.isBOM = cX;
m0.isDigit = Me;
m0.isHexDigit = sX;
m0.isIdentifierStart = aX;
m0.isLetter = Gu;
m0.isLowercaseLetter = Hu;
m0.isName = iX;
m0.isNameStart = g7;
m0.isNewline = a5;
m0.isNonAscii = Wu;
m0.isNonPrintable = Vu;
m0.isNumberStart = lX;
m0.isUppercaseLetter = Uu;
m0.isValidEscape = Do;
m0.isWhiteSpace = Xu;
var P0 = {};
const Y0 = m0;
function Jt(e, t) {
  return t < e.length ? e.charCodeAt(t) : 0;
}
function eh(e, t, r) {
  return r === 13 && Jt(e, t + 1) === 10 ? 2 : 1;
}
function th(e, t, r) {
  let n = e.charCodeAt(t);
  return Y0.isUppercaseLetter(n) && (n = n | 32), n === r;
}
function hX(e, t, r, n) {
  if (r - t !== n.length || t < 0 || r > e.length)
    return !1;
  for (let o = t; o < r; o++) {
    const s = n.charCodeAt(o - t);
    let i = e.charCodeAt(o);
    if (Y0.isUppercaseLetter(i) && (i = i | 32), i !== s)
      return !1;
  }
  return !0;
}
function mX(e, t) {
  for (; t >= 0 && Y0.isWhiteSpace(e.charCodeAt(t)); t--)
    ;
  return t + 1;
}
function fX(e, t) {
  for (; t < e.length && Y0.isWhiteSpace(e.charCodeAt(t)); t++)
    ;
  return t;
}
function Kr(e, t) {
  for (; t < e.length && Y0.isDigit(e.charCodeAt(t)); t++)
    ;
  return t;
}
function c5(e, t) {
  if (t += 2, Y0.isHexDigit(Jt(e, t - 1))) {
    for (const n = Math.min(e.length, t + 5); t < n && Y0.isHexDigit(Jt(e, t)); t++)
      ;
    const r = Jt(e, t);
    Y0.isWhiteSpace(r) && (t += eh(e, t, r));
  }
  return t;
}
function dX(e, t) {
  for (; t < e.length; t++) {
    const r = e.charCodeAt(t);
    if (!Y0.isName(r)) {
      if (Y0.isValidEscape(r, Jt(e, t + 1))) {
        t = c5(e, t) - 1;
        continue;
      }
      break;
    }
  }
  return t;
}
function pX(e, t) {
  let r = e.charCodeAt(t);
  if ((r === 43 || r === 45) && (r = e.charCodeAt(t += 1)), Y0.isDigit(r) && (t = Kr(e, t + 1), r = e.charCodeAt(t)), r === 46 && Y0.isDigit(e.charCodeAt(t + 1)) && (t += 2, t = Kr(e, t)), th(e, t, 101)) {
    let n = 0;
    r = e.charCodeAt(t + 1), (r === 45 || r === 43) && (n = 1, r = e.charCodeAt(t + 2)), Y0.isDigit(r) && (t = Kr(e, t + 1 + n + 1));
  }
  return t;
}
function gX(e, t) {
  for (; t < e.length; t++) {
    const r = e.charCodeAt(t);
    if (r === 41) {
      t++;
      break;
    }
    Y0.isValidEscape(r, Jt(e, t + 1)) && (t = c5(e, t));
  }
  return t;
}
function kX(e) {
  if (e.length === 1 && !Y0.isHexDigit(e.charCodeAt(0)))
    return e[0];
  let t = parseInt(e, 16);
  return (t === 0 || t >= 55296 && t <= 57343 || t > 1114111) && (t = 65533), String.fromCodePoint(t);
}
P0.cmpChar = th;
P0.cmpStr = hX;
P0.consumeBadUrlRemnants = gX;
P0.consumeEscaped = c5;
P0.consumeName = dX;
P0.consumeNumber = pX;
P0.decodeEscaped = kX;
P0.findDecimalNumberEnd = Kr;
P0.findWhiteSpaceEnd = fX;
P0.findWhiteSpaceStart = mX;
P0.getNewlineLength = eh;
const vX = [
  "EOF-token",
  "ident-token",
  "function-token",
  "at-keyword-token",
  "hash-token",
  "string-token",
  "bad-string-token",
  "url-token",
  "bad-url-token",
  "delim-token",
  "number-token",
  "percentage-token",
  "dimension-token",
  "whitespace-token",
  "CDO-token",
  "CDC-token",
  "colon-token",
  "semicolon-token",
  "comma-token",
  "[-token",
  "]-token",
  "(-token",
  ")-token",
  "{-token",
  "}-token"
];
var a4 = vX, u5 = {}, h5 = {};
const yX = 16 * 1024;
function bX(e = null, t) {
  return e === null || e.length < t ? new Uint32Array(Math.max(t + 1024, yX)) : e;
}
h5.adoptBuffer = bX;
const Li = h5, xX = m0, zi = 10, wX = 12, Ci = 13;
function Si(e) {
  const t = e.source, r = t.length, n = t.length > 0 ? xX.isBOM(t.charCodeAt(0)) : 0, o = Li.adoptBuffer(e.lines, r), s = Li.adoptBuffer(e.columns, r);
  let i = e.startLine, l = e.startColumn;
  for (let c = n; c < r; c++) {
    const a = t.charCodeAt(c);
    o[c] = i, s[c] = l++, (a === zi || a === Ci || a === wX) && (a === Ci && c + 1 < r && t.charCodeAt(c + 1) === zi && (c++, o[c] = i, s[c] = l), i++, l = 1);
  }
  o[r] = i, s[r] = l, e.lines = o, e.columns = s, e.computed = !0;
}
class LX {
  constructor() {
    this.lines = null, this.columns = null, this.computed = !1;
  }
  setSource(t, r = 0, n = 1, o = 1) {
    this.source = t, this.startOffset = r, this.startLine = n, this.startColumn = o, this.computed = !1;
  }
  getLocation(t, r) {
    return this.computed || Si(this), {
      source: r,
      offset: this.startOffset + t,
      line: this.lines[t],
      column: this.columns[t]
    };
  }
  getLocationRange(t, r, n) {
    return this.computed || Si(this), {
      source: n,
      start: {
        offset: this.startOffset + t,
        line: this.lines[t],
        column: this.columns[t]
      },
      end: {
        offset: this.startOffset + r,
        line: this.lines[r],
        column: this.columns[r]
      }
    };
  }
}
u5.OffsetToLocation = LX;
var l4 = {};
const $i = h5, zX = P0, CX = a4, O0 = I, k1 = 16777215, ve = 24, SX = /* @__PURE__ */ new Map([
  [O0.Function, O0.RightParenthesis],
  [O0.LeftParenthesis, O0.RightParenthesis],
  [O0.LeftSquareBracket, O0.RightSquareBracket],
  [O0.LeftCurlyBracket, O0.RightCurlyBracket]
]);
class $X {
  constructor(t, r) {
    this.setSource(t, r);
  }
  reset() {
    this.eof = !1, this.tokenIndex = -1, this.tokenType = 0, this.tokenStart = this.firstCharOffset, this.tokenEnd = this.firstCharOffset;
  }
  setSource(t = "", r = () => {
  }) {
    t = String(t || "");
    const n = t.length, o = $i.adoptBuffer(this.offsetAndType, t.length + 1), s = $i.adoptBuffer(this.balance, t.length + 1);
    let i = 0, l = 0, c = 0, a = -1;
    for (this.offsetAndType = null, this.balance = null, r(t, (u, h, m) => {
      switch (u) {
        default:
          s[i] = n;
          break;
        case l: {
          let f = c & k1;
          for (c = s[f], l = c >> ve, s[i] = f, s[f++] = i; f < i; f++)
            s[f] === n && (s[f] = i);
          break;
        }
        case O0.LeftParenthesis:
        case O0.Function:
        case O0.LeftSquareBracket:
        case O0.LeftCurlyBracket:
          s[i] = c, l = SX.get(u), c = l << ve | i;
          break;
      }
      o[i++] = u << ve | m, a === -1 && (a = h);
    }), o[i] = O0.EOF << ve | n, s[i] = n, s[n] = n; c !== 0; ) {
      const u = c & k1;
      c = s[u], s[u] = n;
    }
    this.source = t, this.firstCharOffset = a === -1 ? 0 : a, this.tokenCount = i, this.offsetAndType = o, this.balance = s, this.reset(), this.next();
  }
  lookupType(t) {
    return t += this.tokenIndex, t < this.tokenCount ? this.offsetAndType[t] >> ve : O0.EOF;
  }
  lookupOffset(t) {
    return t += this.tokenIndex, t < this.tokenCount ? this.offsetAndType[t - 1] & k1 : this.source.length;
  }
  lookupValue(t, r) {
    return t += this.tokenIndex, t < this.tokenCount ? zX.cmpStr(
      this.source,
      this.offsetAndType[t - 1] & k1,
      this.offsetAndType[t] & k1,
      r
    ) : !1;
  }
  getTokenStart(t) {
    return t === this.tokenIndex ? this.tokenStart : t > 0 ? t < this.tokenCount ? this.offsetAndType[t - 1] & k1 : this.offsetAndType[this.tokenCount] & k1 : this.firstCharOffset;
  }
  substrToCursor(t) {
    return this.source.substring(t, this.tokenStart);
  }
  isBalanceEdge(t) {
    return this.balance[this.tokenIndex] < t;
  }
  isDelim(t, r) {
    return r ? this.lookupType(r) === O0.Delim && this.source.charCodeAt(this.lookupOffset(r)) === t : this.tokenType === O0.Delim && this.source.charCodeAt(this.tokenStart) === t;
  }
  skip(t) {
    let r = this.tokenIndex + t;
    r < this.tokenCount ? (this.tokenIndex = r, this.tokenStart = this.offsetAndType[r - 1] & k1, r = this.offsetAndType[r], this.tokenType = r >> ve, this.tokenEnd = r & k1) : (this.tokenIndex = this.tokenCount, this.next());
  }
  next() {
    let t = this.tokenIndex + 1;
    t < this.tokenCount ? (this.tokenIndex = t, this.tokenStart = this.tokenEnd, t = this.offsetAndType[t], this.tokenType = t >> ve, this.tokenEnd = t & k1) : (this.eof = !0, this.tokenIndex = this.tokenCount, this.tokenType = O0.EOF, this.tokenStart = this.tokenEnd = this.source.length);
  }
  skipSC() {
    for (; this.tokenType === O0.WhiteSpace || this.tokenType === O0.Comment; )
      this.next();
  }
  skipUntilBalanced(t, r) {
    let n = t, o, s;
    e:
      for (; n < this.tokenCount; n++) {
        if (o = this.balance[n], o < t)
          break e;
        switch (s = n > 0 ? this.offsetAndType[n - 1] & k1 : this.firstCharOffset, r(this.source.charCodeAt(s))) {
          case 1:
            break e;
          case 2:
            n++;
            break e;
          default:
            this.balance[o] === n && (n = o);
        }
      }
    this.skip(n - this.tokenIndex);
  }
  forEachToken(t) {
    for (let r = 0, n = this.firstCharOffset; r < this.tokenCount; r++) {
      const o = n, s = this.offsetAndType[r], i = s & k1, l = s >> ve;
      n = i, t(l, o, i, r);
    }
  }
  dump() {
    const t = new Array(this.tokenCount);
    return this.forEachToken((r, n, o, s) => {
      t[s] = {
        idx: s,
        type: CX[r],
        chunk: this.source.substring(n, o),
        balance: this.balance[s]
      };
    }), t;
  }
}
l4.TokenStream = $X;
const G = I, e0 = m0, k0 = P0, AX = a4, MX = u5, jX = l4;
function EX(e, t) {
  function r(h) {
    return h < l ? e.charCodeAt(h) : 0;
  }
  function n() {
    if (a = k0.consumeNumber(e, a), e0.isIdentifierStart(r(a), r(a + 1), r(a + 2))) {
      u = G.Dimension, a = k0.consumeName(e, a);
      return;
    }
    if (r(a) === 37) {
      u = G.Percentage, a++;
      return;
    }
    u = G.Number;
  }
  function o() {
    const h = a;
    if (a = k0.consumeName(e, a), k0.cmpStr(e, h, a, "url") && r(a) === 40) {
      if (a = k0.findWhiteSpaceEnd(e, a + 1), r(a) === 34 || r(a) === 39) {
        u = G.Function, a = h + 4;
        return;
      }
      i();
      return;
    }
    if (r(a) === 40) {
      u = G.Function, a++;
      return;
    }
    u = G.Ident;
  }
  function s(h) {
    for (h || (h = r(a++)), u = G.String; a < e.length; a++) {
      const m = e.charCodeAt(a);
      switch (e0.charCodeCategory(m)) {
        case h:
          a++;
          return;
        case e0.WhiteSpaceCategory:
          if (e0.isNewline(m)) {
            a += k0.getNewlineLength(e, a, m), u = G.BadString;
            return;
          }
          break;
        case 92:
          if (a === e.length - 1)
            break;
          const f = r(a + 1);
          e0.isNewline(f) ? a += k0.getNewlineLength(e, a + 1, f) : e0.isValidEscape(m, f) && (a = k0.consumeEscaped(e, a) - 1);
          break;
      }
    }
  }
  function i() {
    for (u = G.Url, a = k0.findWhiteSpaceEnd(e, a); a < e.length; a++) {
      const h = e.charCodeAt(a);
      switch (e0.charCodeCategory(h)) {
        case 41:
          a++;
          return;
        case e0.WhiteSpaceCategory:
          if (a = k0.findWhiteSpaceEnd(e, a), r(a) === 41 || a >= e.length) {
            a < e.length && a++;
            return;
          }
          a = k0.consumeBadUrlRemnants(e, a), u = G.BadUrl;
          return;
        case 34:
        case 39:
        case 40:
        case e0.NonPrintableCategory:
          a = k0.consumeBadUrlRemnants(e, a), u = G.BadUrl;
          return;
        case 92:
          if (e0.isValidEscape(h, r(a + 1))) {
            a = k0.consumeEscaped(e, a) - 1;
            break;
          }
          a = k0.consumeBadUrlRemnants(e, a), u = G.BadUrl;
          return;
      }
    }
  }
  e = String(e || "");
  const l = e.length;
  let c = e0.isBOM(r(0)), a = c, u;
  for (; a < l; ) {
    const h = e.charCodeAt(a);
    switch (e0.charCodeCategory(h)) {
      case e0.WhiteSpaceCategory:
        u = G.WhiteSpace, a = k0.findWhiteSpaceEnd(e, a + 1);
        break;
      case 34:
        s();
        break;
      case 35:
        e0.isName(r(a + 1)) || e0.isValidEscape(r(a + 1), r(a + 2)) ? (u = G.Hash, a = k0.consumeName(e, a + 1)) : (u = G.Delim, a++);
        break;
      case 39:
        s();
        break;
      case 40:
        u = G.LeftParenthesis, a++;
        break;
      case 41:
        u = G.RightParenthesis, a++;
        break;
      case 43:
        e0.isNumberStart(h, r(a + 1), r(a + 2)) ? n() : (u = G.Delim, a++);
        break;
      case 44:
        u = G.Comma, a++;
        break;
      case 45:
        e0.isNumberStart(h, r(a + 1), r(a + 2)) ? n() : r(a + 1) === 45 && r(a + 2) === 62 ? (u = G.CDC, a = a + 3) : e0.isIdentifierStart(h, r(a + 1), r(a + 2)) ? o() : (u = G.Delim, a++);
        break;
      case 46:
        e0.isNumberStart(h, r(a + 1), r(a + 2)) ? n() : (u = G.Delim, a++);
        break;
      case 47:
        r(a + 1) === 42 ? (u = G.Comment, a = e.indexOf("*/", a + 2), a = a === -1 ? e.length : a + 2) : (u = G.Delim, a++);
        break;
      case 58:
        u = G.Colon, a++;
        break;
      case 59:
        u = G.Semicolon, a++;
        break;
      case 60:
        r(a + 1) === 33 && r(a + 2) === 45 && r(a + 3) === 45 ? (u = G.CDO, a = a + 4) : (u = G.Delim, a++);
        break;
      case 64:
        e0.isIdentifierStart(r(a + 1), r(a + 2), r(a + 3)) ? (u = G.AtKeyword, a = k0.consumeName(e, a + 1)) : (u = G.Delim, a++);
        break;
      case 91:
        u = G.LeftSquareBracket, a++;
        break;
      case 92:
        e0.isValidEscape(h, r(a + 1)) ? o() : (u = G.Delim, a++);
        break;
      case 93:
        u = G.RightSquareBracket, a++;
        break;
      case 123:
        u = G.LeftCurlyBracket, a++;
        break;
      case 125:
        u = G.RightCurlyBracket, a++;
        break;
      case e0.DigitCategory:
        n();
        break;
      case e0.NameStartCategory:
        o();
        break;
      default:
        u = G.Delim, a++;
    }
    t(u, c, c = a);
  }
}
q.AtKeyword = G.AtKeyword;
q.BadString = G.BadString;
q.BadUrl = G.BadUrl;
q.CDC = G.CDC;
q.CDO = G.CDO;
q.Colon = G.Colon;
q.Comma = G.Comma;
q.Comment = G.Comment;
q.Delim = G.Delim;
q.Dimension = G.Dimension;
q.EOF = G.EOF;
q.Function = G.Function;
q.Hash = G.Hash;
q.Ident = G.Ident;
q.LeftCurlyBracket = G.LeftCurlyBracket;
q.LeftParenthesis = G.LeftParenthesis;
q.LeftSquareBracket = G.LeftSquareBracket;
q.Number = G.Number;
q.Percentage = G.Percentage;
q.RightCurlyBracket = G.RightCurlyBracket;
q.RightParenthesis = G.RightParenthesis;
q.RightSquareBracket = G.RightSquareBracket;
q.Semicolon = G.Semicolon;
q.String = G.String;
q.Url = G.Url;
q.WhiteSpace = G.WhiteSpace;
q.tokenTypes = G;
q.DigitCategory = e0.DigitCategory;
q.EofCategory = e0.EofCategory;
q.NameStartCategory = e0.NameStartCategory;
q.NonPrintableCategory = e0.NonPrintableCategory;
q.WhiteSpaceCategory = e0.WhiteSpaceCategory;
q.charCodeCategory = e0.charCodeCategory;
q.isBOM = e0.isBOM;
q.isDigit = e0.isDigit;
q.isHexDigit = e0.isHexDigit;
q.isIdentifierStart = e0.isIdentifierStart;
q.isLetter = e0.isLetter;
q.isLowercaseLetter = e0.isLowercaseLetter;
q.isName = e0.isName;
q.isNameStart = e0.isNameStart;
q.isNewline = e0.isNewline;
q.isNonAscii = e0.isNonAscii;
q.isNonPrintable = e0.isNonPrintable;
q.isNumberStart = e0.isNumberStart;
q.isUppercaseLetter = e0.isUppercaseLetter;
q.isValidEscape = e0.isValidEscape;
q.isWhiteSpace = e0.isWhiteSpace;
q.cmpChar = k0.cmpChar;
q.cmpStr = k0.cmpStr;
q.consumeBadUrlRemnants = k0.consumeBadUrlRemnants;
q.consumeEscaped = k0.consumeEscaped;
q.consumeName = k0.consumeName;
q.consumeNumber = k0.consumeNumber;
q.decodeEscaped = k0.decodeEscaped;
q.findDecimalNumberEnd = k0.findDecimalNumberEnd;
q.findWhiteSpaceEnd = k0.findWhiteSpaceEnd;
q.findWhiteSpaceStart = k0.findWhiteSpaceStart;
q.getNewlineLength = k0.getNewlineLength;
q.tokenNames = AX;
q.OffsetToLocation = MX.OffsetToLocation;
q.TokenStream = jX.TokenStream;
q.tokenize = EX;
var rh = {}, pt = {};
let Nt = null;
class w1 {
  static createItem(t) {
    return {
      prev: null,
      next: null,
      data: t
    };
  }
  constructor() {
    this.head = null, this.tail = null, this.cursor = null;
  }
  createItem(t) {
    return w1.createItem(t);
  }
  allocateCursor(t, r) {
    let n;
    return Nt !== null ? (n = Nt, Nt = Nt.cursor, n.prev = t, n.next = r, n.cursor = this.cursor) : n = {
      prev: t,
      next: r,
      cursor: this.cursor
    }, this.cursor = n, n;
  }
  releaseCursor() {
    const { cursor: t } = this;
    this.cursor = t.cursor, t.prev = null, t.next = null, t.cursor = Nt, Nt = t;
  }
  updateCursors(t, r, n, o) {
    let { cursor: s } = this;
    for (; s !== null; )
      s.prev === t && (s.prev = r), s.next === n && (s.next = o), s = s.cursor;
  }
  *[Symbol.iterator]() {
    for (let t = this.head; t !== null; t = t.next)
      yield t.data;
  }
  get size() {
    let t = 0;
    for (let r = this.head; r !== null; r = r.next)
      t++;
    return t;
  }
  get isEmpty() {
    return this.head === null;
  }
  get first() {
    return this.head && this.head.data;
  }
  get last() {
    return this.tail && this.tail.data;
  }
  fromArray(t) {
    let r = null;
    this.head = null;
    for (let n of t) {
      const o = w1.createItem(n);
      r !== null ? r.next = o : this.head = o, o.prev = r, r = o;
    }
    return this.tail = r, this;
  }
  toArray() {
    return [...this];
  }
  toJSON() {
    return [...this];
  }
  forEach(t, r = this) {
    const n = this.allocateCursor(null, this.head);
    for (; n.next !== null; ) {
      const o = n.next;
      n.next = o.next, t.call(r, o.data, o, this);
    }
    this.releaseCursor();
  }
  forEachRight(t, r = this) {
    const n = this.allocateCursor(this.tail, null);
    for (; n.prev !== null; ) {
      const o = n.prev;
      n.prev = o.prev, t.call(r, o.data, o, this);
    }
    this.releaseCursor();
  }
  reduce(t, r, n = this) {
    let o = this.allocateCursor(null, this.head), s = r, i;
    for (; o.next !== null; )
      i = o.next, o.next = i.next, s = t.call(n, s, i.data, i, this);
    return this.releaseCursor(), s;
  }
  reduceRight(t, r, n = this) {
    let o = this.allocateCursor(this.tail, null), s = r, i;
    for (; o.prev !== null; )
      i = o.prev, o.prev = i.prev, s = t.call(n, s, i.data, i, this);
    return this.releaseCursor(), s;
  }
  some(t, r = this) {
    for (let n = this.head; n !== null; n = n.next)
      if (t.call(r, n.data, n, this))
        return !0;
    return !1;
  }
  map(t, r = this) {
    const n = new w1();
    for (let o = this.head; o !== null; o = o.next)
      n.appendData(t.call(r, o.data, o, this));
    return n;
  }
  filter(t, r = this) {
    const n = new w1();
    for (let o = this.head; o !== null; o = o.next)
      t.call(r, o.data, o, this) && n.appendData(o.data);
    return n;
  }
  nextUntil(t, r, n = this) {
    if (t === null)
      return;
    const o = this.allocateCursor(null, t);
    for (; o.next !== null; ) {
      const s = o.next;
      if (o.next = s.next, r.call(n, s.data, s, this))
        break;
    }
    this.releaseCursor();
  }
  prevUntil(t, r, n = this) {
    if (t === null)
      return;
    const o = this.allocateCursor(t, null);
    for (; o.prev !== null; ) {
      const s = o.prev;
      if (o.prev = s.prev, r.call(n, s.data, s, this))
        break;
    }
    this.releaseCursor();
  }
  clear() {
    this.head = null, this.tail = null;
  }
  copy() {
    const t = new w1();
    for (let r of this)
      t.appendData(r);
    return t;
  }
  prepend(t) {
    return this.updateCursors(null, t, this.head, t), this.head !== null ? (this.head.prev = t, t.next = this.head) : this.tail = t, this.head = t, this;
  }
  prependData(t) {
    return this.prepend(w1.createItem(t));
  }
  append(t) {
    return this.insert(t);
  }
  appendData(t) {
    return this.insert(w1.createItem(t));
  }
  insert(t, r = null) {
    if (r !== null)
      if (this.updateCursors(r.prev, t, r, t), r.prev === null) {
        if (this.head !== r)
          throw new Error("before doesn't belong to list");
        this.head = t, r.prev = t, t.next = r, this.updateCursors(null, t);
      } else
        r.prev.next = t, t.prev = r.prev, r.prev = t, t.next = r;
    else
      this.updateCursors(this.tail, t, null, t), this.tail !== null ? (this.tail.next = t, t.prev = this.tail) : this.head = t, this.tail = t;
    return this;
  }
  insertData(t, r) {
    return this.insert(w1.createItem(t), r);
  }
  remove(t) {
    if (this.updateCursors(t, t.prev, t, t.next), t.prev !== null)
      t.prev.next = t.next;
    else {
      if (this.head !== t)
        throw new Error("item doesn't belong to list");
      this.head = t.next;
    }
    if (t.next !== null)
      t.next.prev = t.prev;
    else {
      if (this.tail !== t)
        throw new Error("item doesn't belong to list");
      this.tail = t.prev;
    }
    return t.prev = null, t.next = null, t;
  }
  push(t) {
    this.insert(w1.createItem(t));
  }
  pop() {
    return this.tail !== null ? this.remove(this.tail) : null;
  }
  unshift(t) {
    this.prepend(w1.createItem(t));
  }
  shift() {
    return this.head !== null ? this.remove(this.head) : null;
  }
  prependList(t) {
    return this.insertList(t, this.head);
  }
  appendList(t) {
    return this.insertList(t);
  }
  insertList(t, r) {
    return t.head === null ? this : (r != null ? (this.updateCursors(r.prev, t.tail, r, t.head), r.prev !== null ? (r.prev.next = t.head, t.head.prev = r.prev) : this.head = t.head, r.prev = t.tail, t.tail.next = r) : (this.updateCursors(this.tail, t.tail, null, t.head), this.tail !== null ? (this.tail.next = t.head, t.head.prev = this.tail) : this.head = t.head, this.tail = t.tail), t.head = null, t.tail = null, this);
  }
  replace(t, r) {
    "head" in r ? this.insertList(r, t) : this.insert(r, t), this.remove(t);
  }
}
pt.List = w1;
var nh = {}, c4 = {};
function TX(e, t) {
  const r = Object.create(SyntaxError.prototype), n = new Error();
  return Object.assign(r, {
    name: e,
    message: t,
    get stack() {
      return (n.stack || "").replace(/^(.+\n){1,3}/, `${e}: ${t}
`);
    }
  });
}
c4.createCustomError = TX;
const PX = c4, fn = 100, Ai = 60, Mi = "    ";
function ji({ source: e, line: t, column: r }, n) {
  function o(u, h) {
    return s.slice(u, h).map(
      (m, f) => String(u + f + 1).padStart(c) + " |" + m
    ).join(`
`);
  }
  const s = e.split(/\r\n?|\n|\f/), i = Math.max(1, t - n) - 1, l = Math.min(t + n, s.length + 1), c = Math.max(4, String(l).length) + 1;
  let a = 0;
  r += (Mi.length - 1) * (s[t - 1].substr(0, r - 1).match(/\t/g) || []).length, r > fn && (a = r - Ai + 3, r = Ai - 2);
  for (let u = i; u <= l; u++)
    u >= 0 && u < s.length && (s[u] = s[u].replace(/\t/g, Mi), s[u] = (a > 0 && s[u].length > a ? "\u2026" : "") + s[u].substr(a, fn - 2) + (s[u].length > a + fn - 1 ? "\u2026" : ""));
  return [
    o(i, t),
    new Array(r + c + 2).join("-") + "^",
    o(t, l)
  ].filter(Boolean).join(`
`);
}
function NX(e, t, r, n, o) {
  return Object.assign(PX.createCustomError("SyntaxError", e), {
    source: t,
    offset: r,
    line: n,
    column: o,
    sourceFragment(i) {
      return ji({ source: t, line: n, column: o }, isNaN(i) ? 0 : i);
    },
    get formattedMessage() {
      return `Parse error: ${e}
` + ji({ source: t, line: n, column: o }, 2);
    }
  });
}
nh.SyntaxError = NX;
var oh = {};
const Ei = I;
function DX(e) {
  const t = this.createList();
  let r = !1;
  const n = {
    recognizer: e
  };
  for (; !this.eof; ) {
    switch (this.tokenType) {
      case Ei.Comment:
        this.next();
        continue;
      case Ei.WhiteSpace:
        r = !0, this.next();
        continue;
    }
    let o = e.getNode.call(this, n);
    if (o === void 0)
      break;
    r && (e.onWhiteSpace && e.onWhiteSpace.call(this, o, t, n), r = !1), t.push(o);
  }
  return r && e.onWhiteSpace && e.onWhiteSpace.call(this, null, t, n), t;
}
oh.readSequence = DX;
const Ti = pt, Pi = nh, OX = q, RX = oh, IX = u5, _X = l4, D3 = P0, B1 = I, FX = a4, Ni = () => {
}, BX = 33, ZX = 35, dn = 59, Di = 123, Oi = 0;
function qX(e) {
  return function() {
    return this[e]();
  };
}
function pn(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const r in e) {
    const n = e[r], o = n.parse || n;
    o && (t[r] = o);
  }
  return t;
}
function UX(e) {
  const t = {
    context: /* @__PURE__ */ Object.create(null),
    scope: Object.assign(/* @__PURE__ */ Object.create(null), e.scope),
    atrule: pn(e.atrule),
    pseudo: pn(e.pseudo),
    node: pn(e.node)
  };
  for (const r in e.parseContext)
    switch (typeof e.parseContext[r]) {
      case "function":
        t.context[r] = e.parseContext[r];
        break;
      case "string":
        t.context[r] = qX(e.parseContext[r]);
        break;
    }
  return {
    config: t,
    ...t,
    ...t.node
  };
}
function HX(e) {
  let t = "", r = "<unknown>", n = !1, o = Ni, s = !1;
  const i = new IX.OffsetToLocation(), l = Object.assign(new _X.TokenStream(), UX(e || {}), {
    parseAtrulePrelude: !0,
    parseRulePrelude: !0,
    parseValue: !0,
    parseCustomProperty: !1,
    readSequence: RX.readSequence,
    consumeUntilBalanceEnd: () => 0,
    consumeUntilLeftCurlyBracket(a) {
      return a === Di ? 1 : 0;
    },
    consumeUntilLeftCurlyBracketOrSemicolon(a) {
      return a === Di || a === dn ? 1 : 0;
    },
    consumeUntilExclamationMarkOrSemicolon(a) {
      return a === BX || a === dn ? 1 : 0;
    },
    consumeUntilSemicolonIncluded(a) {
      return a === dn ? 2 : 0;
    },
    createList() {
      return new Ti.List();
    },
    createSingleNodeList(a) {
      return new Ti.List().appendData(a);
    },
    getFirstListNode(a) {
      return a && a.first;
    },
    getLastListNode(a) {
      return a && a.last;
    },
    parseWithFallback(a, u) {
      const h = this.tokenIndex;
      try {
        return a.call(this);
      } catch (m) {
        if (s)
          throw m;
        const f = u.call(this, h);
        return s = !0, o(m, f), s = !1, f;
      }
    },
    lookupNonWSType(a) {
      let u;
      do
        if (u = this.lookupType(a++), u !== B1.WhiteSpace)
          return u;
      while (u !== Oi);
      return Oi;
    },
    charCodeAt(a) {
      return a >= 0 && a < t.length ? t.charCodeAt(a) : 0;
    },
    substring(a, u) {
      return t.substring(a, u);
    },
    substrToCursor(a) {
      return this.source.substring(a, this.tokenStart);
    },
    cmpChar(a, u) {
      return D3.cmpChar(t, a, u);
    },
    cmpStr(a, u, h) {
      return D3.cmpStr(t, a, u, h);
    },
    consume(a) {
      const u = this.tokenStart;
      return this.eat(a), this.substrToCursor(u);
    },
    consumeFunctionName() {
      const a = t.substring(this.tokenStart, this.tokenEnd - 1);
      return this.eat(B1.Function), a;
    },
    consumeNumber(a) {
      const u = t.substring(this.tokenStart, D3.consumeNumber(t, this.tokenStart));
      return this.eat(a), u;
    },
    eat(a) {
      if (this.tokenType !== a) {
        const u = FX[a].slice(0, -6).replace(/-/g, " ").replace(/^./, (f) => f.toUpperCase());
        let h = `${/[[\](){}]/.test(u) ? `"${u}"` : u} is expected`, m = this.tokenStart;
        switch (a) {
          case B1.Ident:
            this.tokenType === B1.Function || this.tokenType === B1.Url ? (m = this.tokenEnd - 1, h = "Identifier is expected but function found") : h = "Identifier is expected";
            break;
          case B1.Hash:
            this.isDelim(ZX) && (this.next(), m++, h = "Name is expected");
            break;
          case B1.Percentage:
            this.tokenType === B1.Number && (m = this.tokenEnd, h = "Percent sign is expected");
            break;
        }
        this.error(h, m);
      }
      this.next();
    },
    eatIdent(a) {
      (this.tokenType !== B1.Ident || this.lookupValue(0, a) === !1) && this.error(`Identifier "${a}" is expected`), this.next();
    },
    eatDelim(a) {
      this.isDelim(a) || this.error(`Delim "${String.fromCharCode(a)}" is expected`), this.next();
    },
    getLocation(a, u) {
      return n ? i.getLocationRange(
        a,
        u,
        r
      ) : null;
    },
    getLocationFromList(a) {
      if (n) {
        const u = this.getFirstListNode(a), h = this.getLastListNode(a);
        return i.getLocationRange(
          u !== null ? u.loc.start.offset - i.startOffset : this.tokenStart,
          h !== null ? h.loc.end.offset - i.startOffset : this.tokenStart,
          r
        );
      }
      return null;
    },
    error(a, u) {
      const h = typeof u < "u" && u < t.length ? i.getLocation(u) : this.eof ? i.getLocation(D3.findWhiteSpaceStart(t, t.length - 1)) : i.getLocation(this.tokenStart);
      throw new Pi.SyntaxError(
        a || "Unexpected input",
        t,
        h.offset,
        h.line,
        h.column
      );
    }
  });
  return Object.assign(function(a, u) {
    t = a, u = u || {}, l.setSource(t, OX.tokenize), i.setSource(
      t,
      u.offset,
      u.line,
      u.column
    ), r = u.filename || "<unknown>", n = Boolean(u.positions), o = typeof u.onParseError == "function" ? u.onParseError : Ni, s = !1, l.parseAtrulePrelude = "parseAtrulePrelude" in u ? Boolean(u.parseAtrulePrelude) : !0, l.parseRulePrelude = "parseRulePrelude" in u ? Boolean(u.parseRulePrelude) : !0, l.parseValue = "parseValue" in u ? Boolean(u.parseValue) : !0, l.parseCustomProperty = "parseCustomProperty" in u ? Boolean(u.parseCustomProperty) : !1;
    const { context: h = "default", onComment: m } = u;
    if (!(h in l.context))
      throw new Error("Unknown context `" + h + "`");
    typeof m == "function" && l.forEachToken((d, k, b) => {
      if (d === B1.Comment) {
        const w = l.getLocation(k, b), L = D3.cmpStr(t, b - 2, b, "*/") ? t.slice(k + 2, b - 2) : t.slice(k + 2, b);
        m(L, w);
      }
    });
    const f = l.context[h].call(l, u);
    return l.eof || l.error(), f;
  }, {
    SyntaxError: Pi.SyntaxError,
    config: l.config
  });
}
rh.createParser = HX;
var sh = {}, ih = {};
const GX = T9, Ri = /* @__PURE__ */ new Set(["Atrule", "Selector", "Declaration"]);
function WX(e) {
  const t = new GX.SourceMapGenerator(), r = {
    line: 1,
    column: 0
  }, n = {
    line: 0,
    column: 0
  }, o = {
    line: 1,
    column: 0
  }, s = {
    generated: o
  };
  let i = 1, l = 0, c = !1;
  const a = e.node;
  e.node = function(m) {
    if (m.loc && m.loc.start && Ri.has(m.type)) {
      const f = m.loc.start.line, d = m.loc.start.column - 1;
      (n.line !== f || n.column !== d) && (n.line = f, n.column = d, r.line = i, r.column = l, c && (c = !1, (r.line !== o.line || r.column !== o.column) && t.addMapping(s)), c = !0, t.addMapping({
        source: m.loc.source,
        original: n,
        generated: r
      }));
    }
    a.call(this, m), c && Ri.has(m.type) && (o.line = i, o.column = l);
  };
  const u = e.emit;
  e.emit = function(m, f, d) {
    for (let k = 0; k < m.length; k++)
      m.charCodeAt(k) === 10 ? (i++, l = 0) : l++;
    u(m, f, d);
  };
  const h = e.result;
  return e.result = function() {
    return c && t.addMapping(s), {
      css: h(),
      map: t
    };
  }, e;
}
ih.generateSourceMap = WX;
var m5 = {};
const $ = I, VX = 43, XX = 45, gn = (e, t) => {
  if (e === $.Delim && (e = t), typeof e == "string") {
    const r = e.charCodeAt(0);
    return r > 127 ? 32768 : r << 8;
  }
  return e;
}, ah = [
  [$.Ident, $.Ident],
  [$.Ident, $.Function],
  [$.Ident, $.Url],
  [$.Ident, $.BadUrl],
  [$.Ident, "-"],
  [$.Ident, $.Number],
  [$.Ident, $.Percentage],
  [$.Ident, $.Dimension],
  [$.Ident, $.CDC],
  [$.Ident, $.LeftParenthesis],
  [$.AtKeyword, $.Ident],
  [$.AtKeyword, $.Function],
  [$.AtKeyword, $.Url],
  [$.AtKeyword, $.BadUrl],
  [$.AtKeyword, "-"],
  [$.AtKeyword, $.Number],
  [$.AtKeyword, $.Percentage],
  [$.AtKeyword, $.Dimension],
  [$.AtKeyword, $.CDC],
  [$.Hash, $.Ident],
  [$.Hash, $.Function],
  [$.Hash, $.Url],
  [$.Hash, $.BadUrl],
  [$.Hash, "-"],
  [$.Hash, $.Number],
  [$.Hash, $.Percentage],
  [$.Hash, $.Dimension],
  [$.Hash, $.CDC],
  [$.Dimension, $.Ident],
  [$.Dimension, $.Function],
  [$.Dimension, $.Url],
  [$.Dimension, $.BadUrl],
  [$.Dimension, "-"],
  [$.Dimension, $.Number],
  [$.Dimension, $.Percentage],
  [$.Dimension, $.Dimension],
  [$.Dimension, $.CDC],
  ["#", $.Ident],
  ["#", $.Function],
  ["#", $.Url],
  ["#", $.BadUrl],
  ["#", "-"],
  ["#", $.Number],
  ["#", $.Percentage],
  ["#", $.Dimension],
  ["#", $.CDC],
  ["-", $.Ident],
  ["-", $.Function],
  ["-", $.Url],
  ["-", $.BadUrl],
  ["-", "-"],
  ["-", $.Number],
  ["-", $.Percentage],
  ["-", $.Dimension],
  ["-", $.CDC],
  [$.Number, $.Ident],
  [$.Number, $.Function],
  [$.Number, $.Url],
  [$.Number, $.BadUrl],
  [$.Number, $.Number],
  [$.Number, $.Percentage],
  [$.Number, $.Dimension],
  [$.Number, "%"],
  [$.Number, $.CDC],
  ["@", $.Ident],
  ["@", $.Function],
  ["@", $.Url],
  ["@", $.BadUrl],
  ["@", "-"],
  ["@", $.CDC],
  [".", $.Number],
  [".", $.Percentage],
  [".", $.Dimension],
  ["+", $.Number],
  ["+", $.Percentage],
  ["+", $.Dimension],
  ["/", "*"]
], YX = ah.concat([
  [$.Ident, $.Hash],
  [$.Dimension, $.Hash],
  [$.Hash, $.Hash],
  [$.AtKeyword, $.LeftParenthesis],
  [$.AtKeyword, $.String],
  [$.AtKeyword, $.Colon],
  [$.Percentage, $.Percentage],
  [$.Percentage, $.Dimension],
  [$.Percentage, $.Function],
  [$.Percentage, "-"],
  [$.RightParenthesis, $.Ident],
  [$.RightParenthesis, $.Function],
  [$.RightParenthesis, $.Percentage],
  [$.RightParenthesis, $.Dimension],
  [$.RightParenthesis, $.Hash],
  [$.RightParenthesis, "-"]
]);
function lh(e) {
  const t = new Set(
    e.map(([r, n]) => gn(r) << 16 | gn(n))
  );
  return function(r, n, o) {
    const s = gn(n, o), i = o.charCodeAt(0);
    return (i === XX && n !== $.Ident && n !== $.Function && n !== $.CDC || i === VX ? t.has(r << 16 | i << 8) : t.has(r << 16 | s)) && this.emit(" ", $.WhiteSpace, !0), s;
  };
}
const KX = lh(ah), QX = lh(YX);
m5.safe = QX;
m5.spec = KX;
const JX = q, eY = ih, kn = m5, Ii = I, tY = 92;
function rY(e, t) {
  if (typeof t == "function") {
    let r = null;
    e.children.forEach((n) => {
      r !== null && t.call(this, r), this.node(n), r = n;
    });
    return;
  }
  e.children.forEach(this.node, this);
}
function nY(e) {
  JX.tokenize(e, (t, r, n) => {
    this.token(t, e.slice(r, n));
  });
}
function oY(e) {
  const t = /* @__PURE__ */ new Map();
  for (let r in e.node) {
    const n = e.node[r];
    typeof (n.generate || n) == "function" && t.set(r, n.generate || n);
  }
  return function(r, n) {
    let o = "", s = 0, i = {
      node(c) {
        if (t.has(c.type))
          t.get(c.type).call(l, c);
        else
          throw new Error("Unknown node type: " + c.type);
      },
      tokenBefore: kn.safe,
      token(c, a) {
        s = this.tokenBefore(s, c, a), this.emit(a, c, !1), c === Ii.Delim && a.charCodeAt(0) === tY && this.emit(`
`, Ii.WhiteSpace, !0);
      },
      emit(c) {
        o += c;
      },
      result() {
        return o;
      }
    };
    n && (typeof n.decorator == "function" && (i = n.decorator(i)), n.sourceMap && (i = eY.generateSourceMap(i)), n.mode in kn && (i.tokenBefore = kn[n.mode]));
    const l = {
      node: (c) => i.node(c),
      children: rY,
      token: (c, a) => i.token(c, a),
      tokenize: nY
    };
    return i.node(r), i.result();
  };
}
sh.createGenerator = oY;
var ch = {};
const vn = pt;
function sY(e) {
  return {
    fromPlainObject(t) {
      return e(t, {
        enter(r) {
          r.children && !(r.children instanceof vn.List) && (r.children = new vn.List().fromArray(r.children));
        }
      }), t;
    },
    toPlainObject(t) {
      return e(t, {
        leave(r) {
          r.children && r.children instanceof vn.List && (r.children = r.children.toArray());
        }
      }), t;
    }
  };
}
ch.createConvertor = sY;
var uh = {};
const { hasOwnProperty: f5 } = Object.prototype, J3 = function() {
};
function _i(e) {
  return typeof e == "function" ? e : J3;
}
function Fi(e, t) {
  return function(r, n, o) {
    r.type === t && e.call(this, r, n, o);
  };
}
function iY(e, t) {
  const r = t.structure, n = [];
  for (const o in r) {
    if (f5.call(r, o) === !1)
      continue;
    let s = r[o];
    const i = {
      name: o,
      type: !1,
      nullable: !1
    };
    Array.isArray(s) || (s = [s]);
    for (const l of s)
      l === null ? i.nullable = !0 : typeof l == "string" ? i.type = "node" : Array.isArray(l) && (i.type = "list");
    i.type && n.push(i);
  }
  return n.length ? {
    context: t.walkContext,
    fields: n
  } : null;
}
function aY(e) {
  const t = {};
  for (const r in e.node)
    if (f5.call(e.node, r)) {
      const n = e.node[r];
      if (!n.structure)
        throw new Error("Missed `structure` field in `" + r + "` node type definition");
      t[r] = iY(r, n);
    }
  return t;
}
function Bi(e, t) {
  const r = e.fields.slice(), n = e.context, o = typeof n == "string";
  return t && r.reverse(), function(s, i, l, c) {
    let a;
    o && (a = i[n], i[n] = s);
    for (const u of r) {
      const h = s[u.name];
      if (!u.nullable || h) {
        if (u.type === "list") {
          if (t ? h.reduceRight(c, !1) : h.reduce(c, !1))
            return !0;
        } else if (l(h))
          return !0;
      }
    }
    o && (i[n] = a);
  };
}
function Zi({
  StyleSheet: e,
  Atrule: t,
  Rule: r,
  Block: n,
  DeclarationList: o
}) {
  return {
    Atrule: {
      StyleSheet: e,
      Atrule: t,
      Rule: r,
      Block: n
    },
    Rule: {
      StyleSheet: e,
      Atrule: t,
      Rule: r,
      Block: n
    },
    Declaration: {
      StyleSheet: e,
      Atrule: t,
      Rule: r,
      Block: n,
      DeclarationList: o
    }
  };
}
function lY(e) {
  const t = aY(e), r = {}, n = {}, o = Symbol("break-walk"), s = Symbol("skip-node");
  for (const a in t)
    f5.call(t, a) && t[a] !== null && (r[a] = Bi(t[a], !1), n[a] = Bi(t[a], !0));
  const i = Zi(r), l = Zi(n), c = function(a, u) {
    function h(w, L, A) {
      const C = m.call(b, w, L, A);
      return C === o ? !0 : C === s ? !1 : !!(d.hasOwnProperty(w.type) && d[w.type](w, b, h, k) || f.call(b, w, L, A) === o);
    }
    let m = J3, f = J3, d = r, k = (w, L, A, C) => w || h(L, A, C);
    const b = {
      break: o,
      skip: s,
      root: a,
      stylesheet: null,
      atrule: null,
      atrulePrelude: null,
      rule: null,
      selector: null,
      block: null,
      declaration: null,
      function: null
    };
    if (typeof u == "function")
      m = u;
    else if (u && (m = _i(u.enter), f = _i(u.leave), u.reverse && (d = n), u.visit)) {
      if (i.hasOwnProperty(u.visit))
        d = u.reverse ? l[u.visit] : i[u.visit];
      else if (!t.hasOwnProperty(u.visit))
        throw new Error("Bad value `" + u.visit + "` for `visit` option (should be: " + Object.keys(t).sort().join(", ") + ")");
      m = Fi(m, u.visit), f = Fi(f, u.visit);
    }
    if (m === J3 && f === J3)
      throw new Error("Neither `enter` nor `leave` walker handler is set or both aren't a function");
    h(a);
  };
  return c.break = o, c.skip = s, c.find = function(a, u) {
    let h = null;
    return c(a, function(m, f, d) {
      if (u.call(this, m, f, d))
        return h = m, o;
    }), h;
  }, c.findLast = function(a, u) {
    let h = null;
    return c(a, {
      reverse: !0,
      enter(m, f, d) {
        if (u.call(this, m, f, d))
          return h = m, o;
      }
    }), h;
  }, c.findAll = function(a, u) {
    const h = [];
    return c(a, function(m, f, d) {
      u.call(this, m, f, d) && h.push(m);
    }), h;
  }, c;
}
uh.createWalker = lY;
var d5 = {}, p5 = {}, u4 = {};
function cY(e) {
  return e;
}
function uY(e) {
  const { min: t, max: r, comma: n } = e;
  return t === 0 && r === 0 ? n ? "#?" : "*" : t === 0 && r === 1 ? "?" : t === 1 && r === 0 ? n ? "#" : "+" : t === 1 && r === 1 ? "" : (n ? "#" : "") + (t === r ? "{" + t + "}" : "{" + t + "," + (r !== 0 ? r : "") + "}");
}
function hY(e) {
  switch (e.type) {
    case "Range":
      return " [" + (e.min === null ? "-\u221E" : e.min) + "," + (e.max === null ? "\u221E" : e.max) + "]";
    default:
      throw new Error("Unknown node type `" + e.type + "`");
  }
}
function mY(e, t, r, n) {
  const o = e.combinator === " " || n ? e.combinator : " " + e.combinator + " ", s = e.terms.map((i) => g5(i, t, r, n)).join(o);
  return e.explicit || r ? (n || s[0] === "," ? "[" : "[ ") + s + (n ? "]" : " ]") : s;
}
function g5(e, t, r, n) {
  let o;
  switch (e.type) {
    case "Group":
      o = mY(e, t, r, n) + (e.disallowEmpty ? "!" : "");
      break;
    case "Multiplier":
      return g5(e.term, t, r, n) + t(uY(e), e);
    case "Type":
      o = "<" + e.name + (e.opts ? t(hY(e.opts), e.opts) : "") + ">";
      break;
    case "Property":
      o = "<'" + e.name + "'>";
      break;
    case "Keyword":
      o = e.name;
      break;
    case "AtKeyword":
      o = "@" + e.name;
      break;
    case "Function":
      o = e.name + "(";
      break;
    case "String":
    case "Token":
      o = e.value;
      break;
    case "Comma":
      o = ",";
      break;
    default:
      throw new Error("Unknown node type `" + e.type + "`");
  }
  return t(o, e);
}
function fY(e, t) {
  let r = cY, n = !1, o = !1;
  return typeof t == "function" ? r = t : t && (n = Boolean(t.forceBraces), o = Boolean(t.compact), typeof t.decorate == "function" && (r = t.decorate)), g5(e, r, n, o);
}
u4.generate = fY;
const hh = c4, dY = u4, qi = { offset: 0, line: 1, column: 1 };
function pY(e, t) {
  const r = e.tokens, n = e.longestMatch, o = n < r.length && r[n].node || null, s = o !== t ? o : null;
  let i = 0, l = 0, c = 0, a = "", u, h;
  for (let m = 0; m < r.length; m++) {
    const f = r[m].value;
    m === n && (l = f.length, i = a.length), s !== null && r[m].node === s && (m <= n ? c++ : c = 0), a += f;
  }
  return n === r.length || c > 1 ? (u = Ar(s || t, "end") || e7(qi, a), h = e7(u)) : (u = Ar(s, "start") || e7(Ar(t, "start") || qi, a.slice(0, i)), h = Ar(s, "end") || e7(u, a.substr(i, l))), {
    css: a,
    mismatchOffset: i,
    mismatchLength: l,
    start: u,
    end: h
  };
}
function Ar(e, t) {
  const r = e && e.loc && e.loc[t];
  return r ? "line" in r ? e7(r) : r : null;
}
function e7({ offset: e, line: t, column: r }, n) {
  const o = {
    offset: e,
    line: t,
    column: r
  };
  if (n) {
    const s = n.split(/\n|\r\n?|\f/);
    o.offset += n.length, o.line += s.length - 1, o.column = s.length === 1 ? o.column + n.length : s.pop().length + 1;
  }
  return o;
}
const gY = function(e, t) {
  const r = hh.createCustomError(
    "SyntaxReferenceError",
    e + (t ? " `" + t + "`" : "")
  );
  return r.reference = t, r;
}, kY = function(e, t, r, n) {
  const o = hh.createCustomError("SyntaxMatchError", e), {
    css: s,
    mismatchOffset: i,
    mismatchLength: l,
    start: c,
    end: a
  } = pY(n, r);
  return o.rawMessage = e, o.syntax = t ? dY.generate(t) : "<generic>", o.css = s, o.mismatchOffset = i, o.mismatchLength = l, o.message = e + `
  syntax: ` + o.syntax + `
   value: ` + (s || "<empty string>") + `
  --------` + new Array(o.mismatchOffset + 1).join("-") + "^", Object.assign(o, c), o.loc = {
    source: r && r.loc && r.loc.source || "<unknown>",
    start: c,
    end: a
  }, o;
};
p5.SyntaxMatchError = kY;
p5.SyntaxReferenceError = gY;
var gt = {};
const Mr = /* @__PURE__ */ new Map(), Dt = /* @__PURE__ */ new Map(), y8 = 45, vY = xY, yY = wY, bY = v5;
function k5(e, t) {
  return t = t || 0, e.length - t >= 2 && e.charCodeAt(t) === y8 && e.charCodeAt(t + 1) === y8;
}
function v5(e, t) {
  if (t = t || 0, e.length - t >= 3 && e.charCodeAt(t) === y8 && e.charCodeAt(t + 1) !== y8) {
    const r = e.indexOf("-", t + 2);
    if (r !== -1)
      return e.substring(t, r + 1);
  }
  return "";
}
function xY(e) {
  if (Mr.has(e))
    return Mr.get(e);
  const t = e.toLowerCase();
  let r = Mr.get(t);
  if (r === void 0) {
    const n = k5(t, 0), o = n ? "" : v5(t, 0);
    r = Object.freeze({
      basename: t.substr(o.length),
      name: t,
      prefix: o,
      vendor: o,
      custom: n
    });
  }
  return Mr.set(e, r), r;
}
function wY(e) {
  if (Dt.has(e))
    return Dt.get(e);
  let t = e, r = e[0];
  r === "/" ? r = e[1] === "/" ? "//" : "/" : r !== "_" && r !== "*" && r !== "$" && r !== "#" && r !== "+" && r !== "&" && (r = "");
  const n = k5(t, r.length);
  if (!n && (t = t.toLowerCase(), Dt.has(t))) {
    const l = Dt.get(t);
    return Dt.set(e, l), l;
  }
  const o = n ? "" : v5(t, r.length), s = t.substr(0, r.length + o.length), i = Object.freeze({
    basename: t.substr(s.length),
    name: t.substr(r.length),
    hack: r,
    vendor: o,
    prefix: s,
    custom: n
  });
  return Dt.set(e, i), i;
}
gt.isCustomProperty = k5;
gt.keyword = vY;
gt.property = yY;
gt.vendorPrefix = bY;
var y5 = {};
const LY = [
  "initial",
  "inherit",
  "unset",
  "revert",
  "revert-layer"
];
y5.cssWideKeywords = LY;
const mh = m0, D1 = I, yn = P0, k7 = 43, U1 = 45, bn = 110, Ot = !0, zY = !1;
function Ro(e, t) {
  return e !== null && e.type === D1.Delim && e.value.charCodeAt(0) === t;
}
function c7(e, t, r) {
  for (; e !== null && (e.type === D1.WhiteSpace || e.type === D1.Comment); )
    e = r(++t);
  return t;
}
function xe(e, t, r, n) {
  if (!e)
    return 0;
  const o = e.value.charCodeAt(t);
  if (o === k7 || o === U1) {
    if (r)
      return 0;
    t++;
  }
  for (; t < e.value.length; t++)
    if (!mh.isDigit(e.value.charCodeAt(t)))
      return 0;
  return n + 1;
}
function xn(e, t, r) {
  let n = !1, o = c7(e, t, r);
  if (e = r(o), e === null)
    return t;
  if (e.type !== D1.Number)
    if (Ro(e, k7) || Ro(e, U1)) {
      if (n = !0, o = c7(r(++o), o, r), e = r(o), e === null || e.type !== D1.Number)
        return 0;
    } else
      return t;
  if (!n) {
    const s = e.value.charCodeAt(0);
    if (s !== k7 && s !== U1)
      return 0;
  }
  return xe(e, n ? 0 : 1, n, o);
}
function CY(e, t) {
  let r = 0;
  if (!e)
    return 0;
  if (e.type === D1.Number)
    return xe(e, 0, zY, r);
  if (e.type === D1.Ident && e.value.charCodeAt(0) === U1) {
    if (!yn.cmpChar(e.value, 1, bn))
      return 0;
    switch (e.value.length) {
      case 2:
        return xn(t(++r), r, t);
      case 3:
        return e.value.charCodeAt(2) !== U1 ? 0 : (r = c7(t(++r), r, t), e = t(r), xe(e, 0, Ot, r));
      default:
        return e.value.charCodeAt(2) !== U1 ? 0 : xe(e, 3, Ot, r);
    }
  } else if (e.type === D1.Ident || Ro(e, k7) && t(r + 1).type === D1.Ident) {
    if (e.type !== D1.Ident && (e = t(++r)), e === null || !yn.cmpChar(e.value, 0, bn))
      return 0;
    switch (e.value.length) {
      case 1:
        return xn(t(++r), r, t);
      case 2:
        return e.value.charCodeAt(1) !== U1 ? 0 : (r = c7(t(++r), r, t), e = t(r), xe(e, 0, Ot, r));
      default:
        return e.value.charCodeAt(1) !== U1 ? 0 : xe(e, 2, Ot, r);
    }
  } else if (e.type === D1.Dimension) {
    let n = e.value.charCodeAt(0), o = n === k7 || n === U1 ? 1 : 0, s = o;
    for (; s < e.value.length && mh.isDigit(e.value.charCodeAt(s)); s++)
      ;
    return s === o || !yn.cmpChar(e.value, s, bn) ? 0 : s + 1 === e.value.length ? xn(t(++r), r, t) : e.value.charCodeAt(s + 1) !== U1 ? 0 : s + 2 === e.value.length ? (r = c7(t(++r), r, t), e = t(r), xe(e, 0, Ot, r)) : xe(e, s + 2, Ot, r);
  }
  return 0;
}
var SY = CY;
const $Y = m0, He = I, AY = P0, MY = 43, fh = 45, dh = 63, jY = 117;
function Io(e, t) {
  return e !== null && e.type === He.Delim && e.value.charCodeAt(0) === t;
}
function EY(e, t) {
  return e.value.charCodeAt(0) === t;
}
function t7(e, t, r) {
  let n = 0;
  for (let o = t; o < e.value.length; o++) {
    const s = e.value.charCodeAt(o);
    if (s === fh && r && n !== 0)
      return t7(e, t + n + 1, !1), 6;
    if (!$Y.isHexDigit(s) || ++n > 6)
      return 0;
  }
  return n;
}
function jr(e, t, r) {
  if (!e)
    return 0;
  for (; Io(r(t), dh); ) {
    if (++e > 6)
      return 0;
    t++;
  }
  return t;
}
function TY(e, t) {
  let r = 0;
  if (e === null || e.type !== He.Ident || !AY.cmpChar(e.value, 0, jY) || (e = t(++r), e === null))
    return 0;
  if (Io(e, MY))
    return e = t(++r), e === null ? 0 : e.type === He.Ident ? jr(t7(e, 0, !0), ++r, t) : Io(e, dh) ? jr(1, ++r, t) : 0;
  if (e.type === He.Number) {
    const n = t7(e, 1, !0);
    return n === 0 ? 0 : (e = t(++r), e === null ? r : e.type === He.Dimension || e.type === He.Number ? !EY(e, fh) || !t7(e, 1, !1) ? 0 : r + 1 : jr(n, r, t));
  }
  return e.type === He.Dimension ? jr(t7(e, 1, !0), ++r, t) : 0;
}
var PY = TY;
const NY = y5, DY = SY, OY = PY, _ = I, h4 = m0, b5 = P0, RY = ["calc(", "-moz-calc(", "-webkit-calc("], x5 = /* @__PURE__ */ new Map([
  [_.Function, _.RightParenthesis],
  [_.LeftParenthesis, _.RightParenthesis],
  [_.LeftSquareBracket, _.RightSquareBracket],
  [_.LeftCurlyBracket, _.RightCurlyBracket]
]), IY = [
  "cm",
  "mm",
  "q",
  "in",
  "pt",
  "pc",
  "px",
  "em",
  "rem",
  "ex",
  "rex",
  "cap",
  "rcap",
  "ch",
  "rch",
  "ic",
  "ric",
  "lh",
  "rlh",
  "vw",
  "svw",
  "lvw",
  "dvw",
  "vh",
  "svh",
  "lvh",
  "dvh",
  "vi",
  "svi",
  "lvi",
  "dvi",
  "vb",
  "svb",
  "lvb",
  "dvb",
  "vmin",
  "svmin",
  "lvmin",
  "dvmin",
  "vmax",
  "svmax",
  "lvmax",
  "dvmax",
  "cqw",
  "cqh",
  "cqi",
  "cqb",
  "cqmin",
  "cqmax"
], _Y = ["deg", "grad", "rad", "turn"], FY = ["s", "ms"], BY = ["hz", "khz"], ZY = ["dpi", "dpcm", "dppx", "x"], qY = ["fr"], UY = ["db"], HY = ["st"];
function _1(e, t) {
  return t < e.length ? e.charCodeAt(t) : 0;
}
function ph(e, t) {
  return b5.cmpStr(e, 0, e.length, t);
}
function gh(e, t) {
  for (let r = 0; r < t.length; r++)
    if (ph(e, t[r]))
      return !0;
  return !1;
}
function kh(e, t) {
  return t !== e.length - 2 ? !1 : _1(e, t) === 92 && h4.isDigit(_1(e, t + 1));
}
function m4(e, t, r) {
  if (e && e.type === "Range") {
    const n = Number(
      r !== void 0 && r !== t.length ? t.substr(0, r) : t
    );
    if (isNaN(n) || e.min !== null && n < e.min && typeof e.min != "string" || e.max !== null && n > e.max && typeof e.max != "string")
      return !0;
  }
  return !1;
}
function GY(e, t) {
  let r = 0, n = [], o = 0;
  e:
    do {
      switch (e.type) {
        case _.RightCurlyBracket:
        case _.RightParenthesis:
        case _.RightSquareBracket:
          if (e.type !== r)
            break e;
          if (r = n.pop(), n.length === 0) {
            o++;
            break e;
          }
          break;
        case _.Function:
        case _.LeftParenthesis:
        case _.LeftSquareBracket:
        case _.LeftCurlyBracket:
          n.push(r), r = x5.get(e.type);
          break;
      }
      o++;
    } while (e = t(o));
  return o;
}
function v1(e) {
  return function(t, r, n) {
    return t === null ? 0 : t.type === _.Function && gh(t.value, RY) ? GY(t, r) : e(t, r, n);
  };
}
function w0(e) {
  return function(t) {
    return t === null || t.type !== e ? 0 : 1;
  };
}
function WY(e) {
  if (e === null || e.type !== _.Ident)
    return 0;
  const t = e.value.toLowerCase();
  return gh(t, NY.cssWideKeywords) || ph(t, "default") ? 0 : 1;
}
function VY(e) {
  return e === null || e.type !== _.Ident || _1(e.value, 0) !== 45 || _1(e.value, 1) !== 45 ? 0 : 1;
}
function XY(e) {
  if (e === null || e.type !== _.Hash)
    return 0;
  const t = e.value.length;
  if (t !== 4 && t !== 5 && t !== 7 && t !== 9)
    return 0;
  for (let r = 1; r < t; r++)
    if (!h4.isHexDigit(_1(e.value, r)))
      return 0;
  return 1;
}
function YY(e) {
  return e === null || e.type !== _.Hash || !h4.isIdentifierStart(_1(e.value, 1), _1(e.value, 2), _1(e.value, 3)) ? 0 : 1;
}
function KY(e, t) {
  if (!e)
    return 0;
  let r = 0, n = [], o = 0;
  e:
    do {
      switch (e.type) {
        case _.BadString:
        case _.BadUrl:
          break e;
        case _.RightCurlyBracket:
        case _.RightParenthesis:
        case _.RightSquareBracket:
          if (e.type !== r)
            break e;
          r = n.pop();
          break;
        case _.Semicolon:
          if (r === 0)
            break e;
          break;
        case _.Delim:
          if (r === 0 && e.value === "!")
            break e;
          break;
        case _.Function:
        case _.LeftParenthesis:
        case _.LeftSquareBracket:
        case _.LeftCurlyBracket:
          n.push(r), r = x5.get(e.type);
          break;
      }
      o++;
    } while (e = t(o));
  return o;
}
function QY(e, t) {
  if (!e)
    return 0;
  let r = 0, n = [], o = 0;
  e:
    do {
      switch (e.type) {
        case _.BadString:
        case _.BadUrl:
          break e;
        case _.RightCurlyBracket:
        case _.RightParenthesis:
        case _.RightSquareBracket:
          if (e.type !== r)
            break e;
          r = n.pop();
          break;
        case _.Function:
        case _.LeftParenthesis:
        case _.LeftSquareBracket:
        case _.LeftCurlyBracket:
          n.push(r), r = x5.get(e.type);
          break;
      }
      o++;
    } while (e = t(o));
  return o;
}
function se(e) {
  return e && (e = new Set(e)), function(t, r, n) {
    if (t === null || t.type !== _.Dimension)
      return 0;
    const o = b5.consumeNumber(t.value, 0);
    if (e !== null) {
      const s = t.value.indexOf("\\", o), i = s === -1 || !kh(t.value, s) ? t.value.substr(o) : t.value.substring(o, s);
      if (e.has(i.toLowerCase()) === !1)
        return 0;
    }
    return m4(n, t.value, o) ? 0 : 1;
  };
}
function JY(e, t, r) {
  return e === null || e.type !== _.Percentage || m4(r, e.value, e.value.length - 1) ? 0 : 1;
}
function Ui(e) {
  return typeof e != "function" && (e = function() {
    return 0;
  }), function(t, r, n) {
    return t !== null && t.type === _.Number && Number(t.value) === 0 ? 1 : e(t, r, n);
  };
}
function eK(e, t, r) {
  if (e === null)
    return 0;
  const n = b5.consumeNumber(e.value, 0);
  return !(n === e.value.length) && !kh(e.value, n) || m4(r, e.value, n) ? 0 : 1;
}
function tK(e, t, r) {
  if (e === null || e.type !== _.Number)
    return 0;
  let n = _1(e.value, 0) === 43 || _1(e.value, 0) === 45 ? 1 : 0;
  for (; n < e.value.length; n++)
    if (!h4.isDigit(_1(e.value, n)))
      return 0;
  return m4(r, e.value, n) ? 0 : 1;
}
const rK = {
  "ident-token": w0(_.Ident),
  "function-token": w0(_.Function),
  "at-keyword-token": w0(_.AtKeyword),
  "hash-token": w0(_.Hash),
  "string-token": w0(_.String),
  "bad-string-token": w0(_.BadString),
  "url-token": w0(_.Url),
  "bad-url-token": w0(_.BadUrl),
  "delim-token": w0(_.Delim),
  "number-token": w0(_.Number),
  "percentage-token": w0(_.Percentage),
  "dimension-token": w0(_.Dimension),
  "whitespace-token": w0(_.WhiteSpace),
  "CDO-token": w0(_.CDO),
  "CDC-token": w0(_.CDC),
  "colon-token": w0(_.Colon),
  "semicolon-token": w0(_.Semicolon),
  "comma-token": w0(_.Comma),
  "[-token": w0(_.LeftSquareBracket),
  "]-token": w0(_.RightSquareBracket),
  "(-token": w0(_.LeftParenthesis),
  ")-token": w0(_.RightParenthesis),
  "{-token": w0(_.LeftCurlyBracket),
  "}-token": w0(_.RightCurlyBracket),
  string: w0(_.String),
  ident: w0(_.Ident),
  "custom-ident": WY,
  "custom-property-name": VY,
  "hex-color": XY,
  "id-selector": YY,
  "an-plus-b": DY,
  urange: OY,
  "declaration-value": KY,
  "any-value": QY,
  dimension: v1(se(null)),
  angle: v1(se(_Y)),
  decibel: v1(se(UY)),
  frequency: v1(se(BY)),
  flex: v1(se(qY)),
  length: v1(Ui(se(IY))),
  resolution: v1(se(ZY)),
  semitones: v1(se(HY)),
  time: v1(se(FY)),
  percentage: v1(JY),
  zero: Ui(),
  number: v1(eK),
  integer: v1(tK)
};
var nK = rK;
const oK = q, sK = {
  decorator(e) {
    const t = [];
    let r = null;
    return {
      ...e,
      node(n) {
        const o = r;
        r = n, e.node.call(this, n), r = o;
      },
      emit(n, o, s) {
        t.push({
          type: o,
          value: n,
          node: s ? null : r
        });
      },
      result() {
        return t;
      }
    };
  }
};
function iK(e) {
  const t = [];
  return oK.tokenize(
    e,
    (r, n, o) => t.push({
      type: r,
      value: e.slice(n, o),
      node: null
    })
  ), t;
}
function aK(e, t) {
  return typeof e == "string" ? iK(e) : t.generate(e, sK);
}
var lK = aK, H2 = {}, f4 = {}, vh = {}, w5 = {};
const cK = c4;
function uK(e, t, r) {
  return Object.assign(cK.createCustomError("SyntaxError", e), {
    input: t,
    offset: r,
    rawMessage: e,
    message: e + `
  ` + t + `
--` + new Array((r || t.length) + 1).join("-") + "^"
  });
}
w5.SyntaxError = uK;
const hK = w5, mK = 9, fK = 10, dK = 12, pK = 13, gK = 32;
class kK {
  constructor(t) {
    this.str = t, this.pos = 0;
  }
  charCodeAt(t) {
    return t < this.str.length ? this.str.charCodeAt(t) : 0;
  }
  charCode() {
    return this.charCodeAt(this.pos);
  }
  nextCharCode() {
    return this.charCodeAt(this.pos + 1);
  }
  nextNonWsCode(t) {
    return this.charCodeAt(this.findWsEnd(t));
  }
  findWsEnd(t) {
    for (; t < this.str.length; t++) {
      const r = this.str.charCodeAt(t);
      if (r !== pK && r !== fK && r !== dK && r !== gK && r !== mK)
        break;
    }
    return t;
  }
  substringToPos(t) {
    return this.str.substring(this.pos, this.pos = t);
  }
  eat(t) {
    this.charCode() !== t && this.error("Expect `" + String.fromCharCode(t) + "`"), this.pos++;
  }
  peek() {
    return this.pos < this.str.length ? this.str.charAt(this.pos++) : "";
  }
  error(t) {
    throw new hK.SyntaxError(t, this.str, this.pos);
  }
}
vh.Tokenizer = kK;
const vK = vh, yK = 9, bK = 10, xK = 12, wK = 13, LK = 32, yh = 33, L5 = 35, Hi = 38, b8 = 39, bh = 40, zK = 41, xh = 42, z5 = 43, C5 = 44, Gi = 45, S5 = 60, wh = 62, _o = 63, CK = 64, d4 = 91, $5 = 93, x8 = 123, Wi = 124, Vi = 125, Xi = 8734, v7 = new Uint8Array(128).map(
  (e, t) => /[a-zA-Z0-9\-]/.test(String.fromCharCode(t)) ? 1 : 0
), Yi = {
  " ": 1,
  "&&": 2,
  "||": 3,
  "|": 4
};
function w8(e) {
  return e.substringToPos(
    e.findWsEnd(e.pos)
  );
}
function l2(e) {
  let t = e.pos;
  for (; t < e.str.length; t++) {
    const r = e.str.charCodeAt(t);
    if (r >= 128 || v7[r] === 0)
      break;
  }
  return e.pos === t && e.error("Expect a keyword"), e.substringToPos(t);
}
function L8(e) {
  let t = e.pos;
  for (; t < e.str.length; t++) {
    const r = e.str.charCodeAt(t);
    if (r < 48 || r > 57)
      break;
  }
  return e.pos === t && e.error("Expect a number"), e.substringToPos(t);
}
function SK(e) {
  const t = e.str.indexOf("'", e.pos + 1);
  return t === -1 && (e.pos = e.str.length, e.error("Expect an apostrophe")), e.substringToPos(t + 1);
}
function Ki(e) {
  let t = null, r = null;
  return e.eat(x8), t = L8(e), e.charCode() === C5 ? (e.pos++, e.charCode() !== Vi && (r = L8(e))) : r = t, e.eat(Vi), {
    min: Number(t),
    max: r ? Number(r) : 0
  };
}
function $K(e) {
  let t = null, r = !1;
  switch (e.charCode()) {
    case xh:
      e.pos++, t = {
        min: 0,
        max: 0
      };
      break;
    case z5:
      e.pos++, t = {
        min: 1,
        max: 0
      };
      break;
    case _o:
      e.pos++, t = {
        min: 0,
        max: 1
      };
      break;
    case L5:
      e.pos++, r = !0, e.charCode() === x8 ? t = Ki(e) : e.charCode() === _o ? (e.pos++, t = {
        min: 0,
        max: 0
      }) : t = {
        min: 1,
        max: 0
      };
      break;
    case x8:
      t = Ki(e);
      break;
    default:
      return null;
  }
  return {
    type: "Multiplier",
    comma: r,
    min: t.min,
    max: t.max,
    term: null
  };
}
function c2(e, t) {
  const r = $K(e);
  return r !== null ? (r.term = t, e.charCode() === L5 && e.charCodeAt(e.pos - 1) === z5 ? c2(e, r) : r) : t;
}
function wn(e) {
  const t = e.peek();
  return t === "" ? null : {
    type: "Token",
    value: t
  };
}
function AK(e) {
  let t;
  return e.eat(S5), e.eat(b8), t = l2(e), e.eat(b8), e.eat(wh), c2(e, {
    type: "Property",
    name: t
  });
}
function MK(e) {
  let t = null, r = null, n = 1;
  return e.eat(d4), e.charCode() === Gi && (e.peek(), n = -1), n == -1 && e.charCode() === Xi ? e.peek() : (t = n * Number(L8(e)), v7[e.charCode()] !== 0 && (t += l2(e))), w8(e), e.eat(C5), w8(e), e.charCode() === Xi ? e.peek() : (n = 1, e.charCode() === Gi && (e.peek(), n = -1), r = n * Number(L8(e)), v7[e.charCode()] !== 0 && (r += l2(e))), e.eat($5), {
    type: "Range",
    min: t,
    max: r
  };
}
function jK(e) {
  let t, r = null;
  return e.eat(S5), t = l2(e), e.charCode() === bh && e.nextCharCode() === zK && (e.pos += 2, t += "()"), e.charCodeAt(e.findWsEnd(e.pos)) === d4 && (w8(e), r = MK(e)), e.eat(wh), c2(e, {
    type: "Type",
    name: t,
    opts: r
  });
}
function EK(e) {
  const t = l2(e);
  return e.charCode() === bh ? (e.pos++, {
    type: "Function",
    name: t
  }) : c2(e, {
    type: "Keyword",
    name: t
  });
}
function TK(e, t) {
  function r(o, s) {
    return {
      type: "Group",
      terms: o,
      combinator: s,
      disallowEmpty: !1,
      explicit: !1
    };
  }
  let n;
  for (t = Object.keys(t).sort((o, s) => Yi[o] - Yi[s]); t.length > 0; ) {
    n = t.shift();
    let o = 0, s = 0;
    for (; o < e.length; o++) {
      const i = e[o];
      i.type === "Combinator" && (i.value === n ? (s === -1 && (s = o - 1), e.splice(o, 1), o--) : (s !== -1 && o - s > 1 && (e.splice(
        s,
        o - s,
        r(e.slice(s, o), n)
      ), o = s + 1), s = -1));
    }
    s !== -1 && t.length && e.splice(
      s,
      o - s,
      r(e.slice(s, o), n)
    );
  }
  return n;
}
function Lh(e) {
  const t = [], r = {};
  let n, o = null, s = e.pos;
  for (; n = NK(e); )
    n.type !== "Spaces" && (n.type === "Combinator" ? ((o === null || o.type === "Combinator") && (e.pos = s, e.error("Unexpected combinator")), r[n.value] = !0) : o !== null && o.type !== "Combinator" && (r[" "] = !0, t.push({
      type: "Combinator",
      value: " "
    })), t.push(n), o = n, s = e.pos);
  return o !== null && o.type === "Combinator" && (e.pos -= s, e.error("Unexpected combinator")), {
    type: "Group",
    terms: t,
    combinator: TK(t, r) || " ",
    disallowEmpty: !1,
    explicit: !1
  };
}
function PK(e) {
  let t;
  return e.eat(d4), t = Lh(e), e.eat($5), t.explicit = !0, e.charCode() === yh && (e.pos++, t.disallowEmpty = !0), t;
}
function NK(e) {
  let t = e.charCode();
  if (t < 128 && v7[t] === 1)
    return EK(e);
  switch (t) {
    case $5:
      break;
    case d4:
      return c2(e, PK(e));
    case S5:
      return e.nextCharCode() === b8 ? AK(e) : jK(e);
    case Wi:
      return {
        type: "Combinator",
        value: e.substringToPos(
          e.pos + (e.nextCharCode() === Wi ? 2 : 1)
        )
      };
    case Hi:
      return e.pos++, e.eat(Hi), {
        type: "Combinator",
        value: "&&"
      };
    case C5:
      return e.pos++, {
        type: "Comma"
      };
    case b8:
      return c2(e, {
        type: "String",
        value: SK(e)
      });
    case LK:
    case yK:
    case bK:
    case wK:
    case xK:
      return {
        type: "Spaces",
        value: w8(e)
      };
    case CK:
      return t = e.nextCharCode(), t < 128 && v7[t] === 1 ? (e.pos++, {
        type: "AtKeyword",
        name: l2(e)
      }) : wn(e);
    case xh:
    case z5:
    case _o:
    case L5:
    case yh:
      break;
    case x8:
      if (t = e.nextCharCode(), t < 48 || t > 57)
        return wn(e);
      break;
    default:
      return wn(e);
  }
}
function DK(e) {
  const t = new vK.Tokenizer(e), r = Lh(t);
  return t.pos !== e.length && t.error("Unexpected input"), r.terms.length === 1 && r.terms[0].type === "Group" ? r.terms[0] : r;
}
f4.parse = DK;
const OK = f4, A0 = { type: "Match" }, W0 = { type: "Mismatch" }, A5 = { type: "DisallowEmpty" }, RK = 40, IK = 41;
function H0(e, t, r) {
  return t === A0 && r === W0 || e === A0 && t === A0 && r === A0 ? e : (e.type === "If" && e.else === W0 && t === A0 && (t = e.then, e = e.match), {
    type: "If",
    match: e,
    then: t,
    else: r
  });
}
function zh(e) {
  return e.length > 2 && e.charCodeAt(e.length - 2) === RK && e.charCodeAt(e.length - 1) === IK;
}
function Qi(e) {
  return e.type === "Keyword" || e.type === "AtKeyword" || e.type === "Function" || e.type === "Type" && zh(e.name);
}
function Fo(e, t, r) {
  switch (e) {
    case " ": {
      let n = A0;
      for (let o = t.length - 1; o >= 0; o--) {
        const s = t[o];
        n = H0(
          s,
          n,
          W0
        );
      }
      return n;
    }
    case "|": {
      let n = W0, o = null;
      for (let s = t.length - 1; s >= 0; s--) {
        let i = t[s];
        if (Qi(i) && (o === null && s > 0 && Qi(t[s - 1]) && (o = /* @__PURE__ */ Object.create(null), n = H0(
          {
            type: "Enum",
            map: o
          },
          A0,
          n
        )), o !== null)) {
          const l = (zh(i.name) ? i.name.slice(0, -1) : i.name).toLowerCase();
          if (!(l in o)) {
            o[l] = i;
            continue;
          }
        }
        o = null, n = H0(
          i,
          A0,
          n
        );
      }
      return n;
    }
    case "&&": {
      if (t.length > 5)
        return {
          type: "MatchOnce",
          terms: t,
          all: !0
        };
      let n = W0;
      for (let o = t.length - 1; o >= 0; o--) {
        const s = t[o];
        let i;
        t.length > 1 ? i = Fo(
          e,
          t.filter(function(l) {
            return l !== s;
          }),
          !1
        ) : i = A0, n = H0(
          s,
          i,
          n
        );
      }
      return n;
    }
    case "||": {
      if (t.length > 5)
        return {
          type: "MatchOnce",
          terms: t,
          all: !1
        };
      let n = r ? A0 : W0;
      for (let o = t.length - 1; o >= 0; o--) {
        const s = t[o];
        let i;
        t.length > 1 ? i = Fo(
          e,
          t.filter(function(l) {
            return l !== s;
          }),
          !0
        ) : i = A0, n = H0(
          s,
          i,
          n
        );
      }
      return n;
    }
  }
}
function _K(e) {
  let t = A0, r = M5(e.term);
  if (e.max === 0)
    r = H0(
      r,
      A5,
      W0
    ), t = H0(
      r,
      null,
      W0
    ), t.then = H0(
      A0,
      A0,
      t
    ), e.comma && (t.then.else = H0(
      { type: "Comma", syntax: e },
      t,
      W0
    ));
  else
    for (let n = e.min || 1; n <= e.max; n++)
      e.comma && t !== A0 && (t = H0(
        { type: "Comma", syntax: e },
        t,
        W0
      )), t = H0(
        r,
        H0(
          A0,
          A0,
          t
        ),
        W0
      );
  if (e.min === 0)
    t = H0(
      A0,
      A0,
      t
    );
  else
    for (let n = 0; n < e.min - 1; n++)
      e.comma && t !== A0 && (t = H0(
        { type: "Comma", syntax: e },
        t,
        W0
      )), t = H0(
        r,
        t,
        W0
      );
  return t;
}
function M5(e) {
  if (typeof e == "function")
    return {
      type: "Generic",
      fn: e
    };
  switch (e.type) {
    case "Group": {
      let t = Fo(
        e.combinator,
        e.terms.map(M5),
        !1
      );
      return e.disallowEmpty && (t = H0(
        t,
        A5,
        W0
      )), t;
    }
    case "Multiplier":
      return _K(e);
    case "Type":
    case "Property":
      return {
        type: e.type,
        name: e.name,
        syntax: e
      };
    case "Keyword":
      return {
        type: e.type,
        name: e.name.toLowerCase(),
        syntax: e
      };
    case "AtKeyword":
      return {
        type: e.type,
        name: "@" + e.name.toLowerCase(),
        syntax: e
      };
    case "Function":
      return {
        type: e.type,
        name: e.name.toLowerCase() + "(",
        syntax: e
      };
    case "String":
      return e.value.length === 3 ? {
        type: "Token",
        value: e.value.charAt(1),
        syntax: e
      } : {
        type: e.type,
        value: e.value.substr(1, e.value.length - 2).replace(/\\'/g, "'"),
        syntax: e
      };
    case "Token":
      return {
        type: e.type,
        value: e.value,
        syntax: e
      };
    case "Comma":
      return {
        type: e.type,
        syntax: e
      };
    default:
      throw new Error("Unknown node type:", e.type);
  }
}
function FK(e, t) {
  return typeof e == "string" && (e = OK.parse(e)), {
    type: "MatchGraph",
    match: M5(e),
    syntax: t || null,
    source: e
  };
}
H2.DISALLOW_EMPTY = A5;
H2.MATCH = A0;
H2.MISMATCH = W0;
H2.buildMatchGraph = FK;
var j5 = {};
const L0 = H2, t1 = I, { hasOwnProperty: Ji } = Object.prototype, BK = 0, ZK = 1, z8 = 2, E5 = 3, e6 = "Match", qK = "Mismatch", UK = "Maximum iteration number exceeded (please fill an issue on https://github.com/csstree/csstree/issues)", t6 = 15e3;
function Ch(e) {
  let t = null, r = null, n = e;
  for (; n !== null; )
    r = n.prev, n.prev = t, t = n, n = r;
  return t;
}
function Ln(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++) {
    const n = t.charCodeAt(r);
    let o = e.charCodeAt(r);
    if (o >= 65 && o <= 90 && (o = o | 32), o !== n)
      return !1;
  }
  return !0;
}
function HK(e) {
  return e.type !== t1.Delim ? !1 : e.value !== "?";
}
function r6(e) {
  return e === null ? !0 : e.type === t1.Comma || e.type === t1.Function || e.type === t1.LeftParenthesis || e.type === t1.LeftSquareBracket || e.type === t1.LeftCurlyBracket || HK(e);
}
function n6(e) {
  return e === null ? !0 : e.type === t1.RightParenthesis || e.type === t1.RightSquareBracket || e.type === t1.RightCurlyBracket || e.type === t1.Delim && e.value === "/";
}
function Sh(e, t, r) {
  function n() {
    do
      L++, w = L < e.length ? e[L] : null;
    while (w !== null && (w.type === t1.WhiteSpace || w.type === t1.Comment));
  }
  function o(g) {
    const M = L + g;
    return M < e.length ? e[M] : null;
  }
  function s(g, M) {
    return {
      nextState: g,
      matchStack: C,
      syntaxStack: h,
      thenStack: m,
      tokenIndex: L,
      prev: M
    };
  }
  function i(g) {
    m = {
      nextState: g,
      matchStack: C,
      syntaxStack: h,
      prev: m
    };
  }
  function l(g) {
    f = s(g, f);
  }
  function c() {
    C = {
      type: ZK,
      syntax: t.syntax,
      token: w,
      prev: C
    }, n(), d = null, L > A && (A = L);
  }
  function a() {
    h = {
      syntax: t.syntax,
      opts: t.syntax.opts || h !== null && h.opts || null,
      prev: h
    }, C = {
      type: z8,
      syntax: t.syntax,
      token: C.token,
      prev: C
    };
  }
  function u() {
    C.type === z8 ? C = C.prev : C = {
      type: E5,
      syntax: h.syntax,
      token: C.token,
      prev: C
    }, h = h.prev;
  }
  let h = null, m = null, f = null, d = null, k = 0, b = null, w = null, L = -1, A = 0, C = {
    type: BK,
    syntax: null,
    token: null,
    prev: null
  };
  for (n(); b === null && ++k < t6; )
    switch (t.type) {
      case "Match":
        if (m === null) {
          if (w !== null && (L !== e.length - 1 || w.value !== "\\0" && w.value !== "\\9")) {
            t = L0.MISMATCH;
            break;
          }
          b = e6;
          break;
        }
        if (t = m.nextState, t === L0.DISALLOW_EMPTY)
          if (m.matchStack === C) {
            t = L0.MISMATCH;
            break;
          } else
            t = L0.MATCH;
        for (; m.syntaxStack !== h; )
          u();
        m = m.prev;
        break;
      case "Mismatch":
        if (d !== null && d !== !1)
          (f === null || L > f.tokenIndex) && (f = d, d = !1);
        else if (f === null) {
          b = qK;
          break;
        }
        t = f.nextState, m = f.thenStack, h = f.syntaxStack, C = f.matchStack, L = f.tokenIndex, w = L < e.length ? e[L] : null, f = f.prev;
        break;
      case "MatchGraph":
        t = t.match;
        break;
      case "If":
        t.else !== L0.MISMATCH && l(t.else), t.then !== L0.MATCH && i(t.then), t = t.match;
        break;
      case "MatchOnce":
        t = {
          type: "MatchOnceBuffer",
          syntax: t,
          index: 0,
          mask: 0
        };
        break;
      case "MatchOnceBuffer": {
        const P = t.syntax.terms;
        if (t.index === P.length) {
          if (t.mask === 0 || t.syntax.all) {
            t = L0.MISMATCH;
            break;
          }
          t = L0.MATCH;
          break;
        }
        if (t.mask === (1 << P.length) - 1) {
          t = L0.MATCH;
          break;
        }
        for (; t.index < P.length; t.index++) {
          const x = 1 << t.index;
          if ((t.mask & x) === 0) {
            l(t), i({
              type: "AddMatchOnce",
              syntax: t.syntax,
              mask: t.mask | x
            }), t = P[t.index++];
            break;
          }
        }
        break;
      }
      case "AddMatchOnce":
        t = {
          type: "MatchOnceBuffer",
          syntax: t.syntax,
          index: 0,
          mask: t.mask
        };
        break;
      case "Enum":
        if (w !== null) {
          let P = w.value.toLowerCase();
          if (P.indexOf("\\") !== -1 && (P = P.replace(/\\[09].*$/, "")), Ji.call(t.map, P)) {
            t = t.map[P];
            break;
          }
        }
        t = L0.MISMATCH;
        break;
      case "Generic": {
        const P = h !== null ? h.opts : null, x = L + Math.floor(t.fn(w, o, P));
        if (!isNaN(x) && x > L) {
          for (; L < x; )
            c();
          t = L0.MATCH;
        } else
          t = L0.MISMATCH;
        break;
      }
      case "Type":
      case "Property": {
        const P = t.type === "Type" ? "types" : "properties", x = Ji.call(r, P) ? r[P][t.name] : null;
        if (!x || !x.match)
          throw new Error(
            "Bad syntax reference: " + (t.type === "Type" ? "<" + t.name + ">" : "<'" + t.name + "'>")
          );
        if (d !== !1 && w !== null && t.type === "Type" && (t.name === "custom-ident" && w.type === t1.Ident || t.name === "length" && w.value === "0")) {
          d === null && (d = s(t, f)), t = L0.MISMATCH;
          break;
        }
        a(), t = x.match;
        break;
      }
      case "Keyword": {
        const P = t.name;
        if (w !== null) {
          let x = w.value;
          if (x.indexOf("\\") !== -1 && (x = x.replace(/\\[09].*$/, "")), Ln(x, P)) {
            c(), t = L0.MATCH;
            break;
          }
        }
        t = L0.MISMATCH;
        break;
      }
      case "AtKeyword":
      case "Function":
        if (w !== null && Ln(w.value, t.name)) {
          c(), t = L0.MATCH;
          break;
        }
        t = L0.MISMATCH;
        break;
      case "Token":
        if (w !== null && w.value === t.value) {
          c(), t = L0.MATCH;
          break;
        }
        t = L0.MISMATCH;
        break;
      case "Comma":
        w !== null && w.type === t1.Comma ? r6(C.token) ? t = L0.MISMATCH : (c(), t = n6(w) ? L0.MISMATCH : L0.MATCH) : t = r6(C.token) || n6(w) ? L0.MATCH : L0.MISMATCH;
        break;
      case "String":
        let g = "", M = L;
        for (; M < e.length && g.length < t.value.length; M++)
          g += e[M].value;
        if (Ln(g, t.value)) {
          for (; L < M; )
            c();
          t = L0.MATCH;
        } else
          t = L0.MISMATCH;
        break;
      default:
        throw new Error("Unknown node type: " + t.type);
    }
  switch (b) {
    case null:
      console.warn("[csstree-match] BREAK after " + t6 + " iterations"), b = UK, C = null;
      break;
    case e6:
      for (; h !== null; )
        u();
      break;
    default:
      C = null;
  }
  return {
    tokens: e,
    reason: b,
    iterations: k,
    match: C,
    longestMatch: A
  };
}
function GK(e, t, r) {
  const n = Sh(e, t, r || {});
  if (n.match !== null) {
    let o = Ch(n.match).prev;
    for (n.match = []; o !== null; ) {
      switch (o.type) {
        case z8:
        case E5:
          n.match.push({
            type: o.type,
            syntax: o.syntax
          });
          break;
        default:
          n.match.push({
            token: o.token.value,
            node: o.token.node
          });
          break;
      }
      o = o.prev;
    }
  }
  return n;
}
function WK(e, t, r) {
  const n = Sh(e, t, r || {});
  if (n.match === null)
    return n;
  let o = n.match, s = n.match = {
    syntax: t.syntax || null,
    match: []
  };
  const i = [s];
  for (o = Ch(o).prev; o !== null; ) {
    switch (o.type) {
      case z8:
        s.match.push(s = {
          syntax: o.syntax,
          match: []
        }), i.push(s);
        break;
      case E5:
        i.pop(), s = i[i.length - 1];
        break;
      default:
        s.match.push({
          syntax: o.syntax || null,
          token: o.token.value,
          node: o.token.node
        });
    }
    o = o.prev;
  }
  return n;
}
j5.matchAsList = GK;
j5.matchAsTree = WK;
var _7 = {};
function $h(e) {
  function t(o) {
    return o === null ? !1 : o.type === "Type" || o.type === "Property" || o.type === "Keyword";
  }
  function r(o) {
    if (Array.isArray(o.match)) {
      for (let s = 0; s < o.match.length; s++)
        if (r(o.match[s]))
          return t(o.syntax) && n.unshift(o.syntax), !0;
    } else if (o.node === e)
      return n = t(o.syntax) ? [o.syntax] : [], !0;
    return !1;
  }
  let n = null;
  return this.matched !== null && r(this.matched), n;
}
function VK(e, t) {
  return T5(this, e, (r) => r.type === "Type" && r.name === t);
}
function XK(e, t) {
  return T5(this, e, (r) => r.type === "Property" && r.name === t);
}
function YK(e) {
  return T5(this, e, (t) => t.type === "Keyword");
}
function T5(e, t, r) {
  const n = $h.call(e, t);
  return n === null ? !1 : n.some(r);
}
_7.getTrace = $h;
_7.isKeyword = YK;
_7.isProperty = XK;
_7.isType = VK;
var Ah = {};
const KK = pt;
function Mh(e) {
  return "node" in e ? e.node : Mh(e.match[0]);
}
function jh(e) {
  return "node" in e ? e.node : jh(e.match[e.match.length - 1]);
}
function QK(e, t, r, n, o) {
  function s(l) {
    if (l.syntax !== null && l.syntax.type === n && l.syntax.name === o) {
      const c = Mh(l), a = jh(l);
      e.syntax.walk(t, function(u, h, m) {
        if (u === c) {
          const f = new KK.List();
          do {
            if (f.appendData(h.data), h.data === a)
              break;
            h = h.next;
          } while (h !== null);
          i.push({
            parent: m,
            nodes: f
          });
        }
      });
    }
    Array.isArray(l.match) && l.match.forEach(s);
  }
  const i = [];
  return r.matched !== null && s(r.matched), i;
}
Ah.matchFragments = QK;
var Eh = {};
const JK = pt, { hasOwnProperty: u7 } = Object.prototype;
function zn(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && e >= 0;
}
function o6(e) {
  return Boolean(e) && zn(e.offset) && zn(e.line) && zn(e.column);
}
function eQ(e, t) {
  return function(n, o) {
    if (!n || n.constructor !== Object)
      return o(n, "Type of node should be an Object");
    for (let s in n) {
      let i = !0;
      if (u7.call(n, s) !== !1) {
        if (s === "type")
          n.type !== e && o(n, "Wrong node type `" + n.type + "`, expected `" + e + "`");
        else if (s === "loc") {
          if (n.loc === null)
            continue;
          if (n.loc && n.loc.constructor === Object)
            if (typeof n.loc.source != "string")
              s += ".source";
            else if (!o6(n.loc.start))
              s += ".start";
            else if (!o6(n.loc.end))
              s += ".end";
            else
              continue;
          i = !1;
        } else if (t.hasOwnProperty(s)) {
          i = !1;
          for (let l = 0; !i && l < t[s].length; l++) {
            const c = t[s][l];
            switch (c) {
              case String:
                i = typeof n[s] == "string";
                break;
              case Boolean:
                i = typeof n[s] == "boolean";
                break;
              case null:
                i = n[s] === null;
                break;
              default:
                typeof c == "string" ? i = n[s] && n[s].type === c : Array.isArray(c) && (i = n[s] instanceof JK.List);
            }
          }
        } else
          o(n, "Unknown field `" + s + "` for " + e + " node type");
        i || o(n, "Bad value for `" + e + "." + s + "`");
      }
    }
    for (const s in t)
      u7.call(t, s) && u7.call(n, s) === !1 && o(n, "Field `" + e + "." + s + "` is missed");
  };
}
function tQ(e, t) {
  const r = t.structure, n = {
    type: String,
    loc: !0
  }, o = {
    type: '"' + e + '"'
  };
  for (const s in r) {
    if (u7.call(r, s) === !1)
      continue;
    const i = [], l = n[s] = Array.isArray(r[s]) ? r[s].slice() : [r[s]];
    for (let c = 0; c < l.length; c++) {
      const a = l[c];
      if (a === String || a === Boolean)
        i.push(a.name);
      else if (a === null)
        i.push("null");
      else if (typeof a == "string")
        i.push("<" + a + ">");
      else if (Array.isArray(a))
        i.push("List");
      else
        throw new Error("Wrong value `" + a + "` in `" + e + "." + s + "` structure definition");
    }
    o[s] = i.join(" | ");
  }
  return {
    docs: o,
    check: eQ(e, n)
  };
}
function rQ(e) {
  const t = {};
  if (e.node) {
    for (const r in e.node)
      if (u7.call(e.node, r)) {
        const n = e.node[r];
        if (n.structure)
          t[r] = tQ(r, n);
        else
          throw new Error("Missed `structure` field in `" + r + "` node type definition");
      }
  }
  return t;
}
Eh.getStructureFromConfig = rQ;
var P5 = {};
const r7 = function() {
};
function s6(e) {
  return typeof e == "function" ? e : r7;
}
function nQ(e, t, r) {
  function n(i) {
    switch (o.call(r, i), i.type) {
      case "Group":
        i.terms.forEach(n);
        break;
      case "Multiplier":
        n(i.term);
        break;
      case "Type":
      case "Property":
      case "Keyword":
      case "AtKeyword":
      case "Function":
      case "String":
      case "Token":
      case "Comma":
        break;
      default:
        throw new Error("Unknown type: " + i.type);
    }
    s.call(r, i);
  }
  let o = r7, s = r7;
  if (typeof t == "function" ? o = t : t && (o = s6(t.enter), s = s6(t.leave)), o === r7 && s === r7)
    throw new Error("Neither `enter` nor `leave` walker handler is set or both aren't a function");
  n(e);
}
P5.walk = nQ;
const qt = p5, O3 = gt, oQ = y5, i6 = nK, sQ = lK, Bo = H2, a6 = j5, iQ = _7, l6 = Ah, aQ = Eh, lQ = f4, Th = u4, cQ = P5, uQ = Bo.buildMatchGraph(oQ.cssWideKeywords.join(" | "));
function Zo(e, t, r) {
  const n = {};
  for (const o in e)
    e[o].syntax && (n[o] = r ? e[o].syntax : Th.generate(e[o].syntax, { compact: t }));
  return n;
}
function hQ(e, t, r) {
  const n = {};
  for (const [o, s] of Object.entries(e))
    n[o] = {
      prelude: s.prelude && (r ? s.prelude.syntax : Th.generate(s.prelude.syntax, { compact: t })),
      descriptors: s.descriptors && Zo(s.descriptors, t, r)
    };
  return n;
}
function mQ(e) {
  for (let t = 0; t < e.length; t++)
    if (e[t].value.toLowerCase() === "var(")
      return !0;
  return !1;
}
function T1(e, t, r) {
  return {
    matched: e,
    iterations: r,
    error: t,
    ...iQ
  };
}
function Rt(e, t, r, n) {
  const o = sQ(r, e.syntax);
  let s;
  return mQ(o) ? T1(null, new Error("Matching for a tree with var() is not supported")) : (n && (s = a6.matchAsTree(o, e.cssWideKeywordsSyntax, e)), (!n || !s.match) && (s = a6.matchAsTree(o, t.match, e), !s.match) ? T1(
    null,
    new qt.SyntaxMatchError(s.reason, t.syntax, r, s),
    s.iterations
  ) : T1(s.match, null, s.iterations));
}
class fQ {
  constructor(t, r, n) {
    if (this.cssWideKeywordsSyntax = uQ, this.syntax = r, this.generic = !1, this.atrules = /* @__PURE__ */ Object.create(null), this.properties = /* @__PURE__ */ Object.create(null), this.types = /* @__PURE__ */ Object.create(null), this.structure = n || aQ.getStructureFromConfig(t), t) {
      if (t.types)
        for (const o in t.types)
          this.addType_(o, t.types[o]);
      if (t.generic) {
        this.generic = !0;
        for (const o in i6)
          this.addType_(o, i6[o]);
      }
      if (t.atrules)
        for (const o in t.atrules)
          this.addAtrule_(o, t.atrules[o]);
      if (t.properties)
        for (const o in t.properties)
          this.addProperty_(o, t.properties[o]);
    }
  }
  checkStructure(t) {
    function r(s, i) {
      o.push({ node: s, message: i });
    }
    const n = this.structure, o = [];
    return this.syntax.walk(t, function(s) {
      n.hasOwnProperty(s.type) ? n[s.type].check(s, r) : r(s, "Unknown node type `" + s.type + "`");
    }), o.length ? o : !1;
  }
  createDescriptor(t, r, n, o = null) {
    const s = {
      type: r,
      name: n
    }, i = {
      type: r,
      name: n,
      parent: o,
      serializable: typeof t == "string" || t && typeof t.type == "string",
      syntax: null,
      match: null
    };
    return typeof t == "function" ? i.match = Bo.buildMatchGraph(t, s) : (typeof t == "string" ? Object.defineProperty(i, "syntax", {
      get() {
        return Object.defineProperty(i, "syntax", {
          value: lQ.parse(t)
        }), i.syntax;
      }
    }) : i.syntax = t, Object.defineProperty(i, "match", {
      get() {
        return Object.defineProperty(i, "match", {
          value: Bo.buildMatchGraph(i.syntax, s)
        }), i.match;
      }
    })), i;
  }
  addAtrule_(t, r) {
    !r || (this.atrules[t] = {
      type: "Atrule",
      name: t,
      prelude: r.prelude ? this.createDescriptor(r.prelude, "AtrulePrelude", t) : null,
      descriptors: r.descriptors ? Object.keys(r.descriptors).reduce(
        (n, o) => (n[o] = this.createDescriptor(r.descriptors[o], "AtruleDescriptor", o, t), n),
        /* @__PURE__ */ Object.create(null)
      ) : null
    });
  }
  addProperty_(t, r) {
    !r || (this.properties[t] = this.createDescriptor(r, "Property", t));
  }
  addType_(t, r) {
    !r || (this.types[t] = this.createDescriptor(r, "Type", t));
  }
  checkAtruleName(t) {
    if (!this.getAtrule(t))
      return new qt.SyntaxReferenceError("Unknown at-rule", "@" + t);
  }
  checkAtrulePrelude(t, r) {
    const n = this.checkAtruleName(t);
    if (n)
      return n;
    const o = this.getAtrule(t);
    if (!o.prelude && r)
      return new SyntaxError("At-rule `@" + t + "` should not contain a prelude");
    if (o.prelude && !r && !Rt(this, o.prelude, "", !1).matched)
      return new SyntaxError("At-rule `@" + t + "` should contain a prelude");
  }
  checkAtruleDescriptorName(t, r) {
    const n = this.checkAtruleName(t);
    if (n)
      return n;
    const o = this.getAtrule(t), s = O3.keyword(r);
    if (!o.descriptors)
      return new SyntaxError("At-rule `@" + t + "` has no known descriptors");
    if (!o.descriptors[s.name] && !o.descriptors[s.basename])
      return new qt.SyntaxReferenceError("Unknown at-rule descriptor", r);
  }
  checkPropertyName(t) {
    if (!this.getProperty(t))
      return new qt.SyntaxReferenceError("Unknown property", t);
  }
  matchAtrulePrelude(t, r) {
    const n = this.checkAtrulePrelude(t, r);
    if (n)
      return T1(null, n);
    const o = this.getAtrule(t);
    return o.prelude ? Rt(this, o.prelude, r || "", !1) : T1(null, null);
  }
  matchAtruleDescriptor(t, r, n) {
    const o = this.checkAtruleDescriptorName(t, r);
    if (o)
      return T1(null, o);
    const s = this.getAtrule(t), i = O3.keyword(r);
    return Rt(this, s.descriptors[i.name] || s.descriptors[i.basename], n, !1);
  }
  matchDeclaration(t) {
    return t.type !== "Declaration" ? T1(null, new Error("Not a Declaration node")) : this.matchProperty(t.property, t.value);
  }
  matchProperty(t, r) {
    if (O3.property(t).custom)
      return T1(null, new Error("Lexer matching doesn't applicable for custom properties"));
    const n = this.checkPropertyName(t);
    return n ? T1(null, n) : Rt(this, this.getProperty(t), r, !0);
  }
  matchType(t, r) {
    const n = this.getType(t);
    return n ? Rt(this, n, r, !1) : T1(null, new qt.SyntaxReferenceError("Unknown type", t));
  }
  match(t, r) {
    return typeof t != "string" && (!t || !t.type) ? T1(null, new qt.SyntaxReferenceError("Bad syntax")) : ((typeof t == "string" || !t.match) && (t = this.createDescriptor(t, "Type", "anonymous")), Rt(this, t, r, !1));
  }
  findValueFragments(t, r, n, o) {
    return l6.matchFragments(this, r, this.matchProperty(t, r), n, o);
  }
  findDeclarationValueFragments(t, r, n) {
    return l6.matchFragments(this, t.value, this.matchDeclaration(t), r, n);
  }
  findAllFragments(t, r, n) {
    const o = [];
    return this.syntax.walk(t, {
      visit: "Declaration",
      enter: (s) => {
        o.push.apply(o, this.findDeclarationValueFragments(s, r, n));
      }
    }), o;
  }
  getAtrule(t, r = !0) {
    const n = O3.keyword(t);
    return (n.vendor && r ? this.atrules[n.name] || this.atrules[n.basename] : this.atrules[n.name]) || null;
  }
  getAtrulePrelude(t, r = !0) {
    const n = this.getAtrule(t, r);
    return n && n.prelude || null;
  }
  getAtruleDescriptor(t, r) {
    return this.atrules.hasOwnProperty(t) && this.atrules.declarators && this.atrules[t].declarators[r] || null;
  }
  getProperty(t, r = !0) {
    const n = O3.property(t);
    return (n.vendor && r ? this.properties[n.name] || this.properties[n.basename] : this.properties[n.name]) || null;
  }
  getType(t) {
    return hasOwnProperty.call(this.types, t) ? this.types[t] : null;
  }
  validate() {
    function t(o, s, i, l) {
      if (i.has(s))
        return i.get(s);
      i.set(s, !1), l.syntax !== null && cQ.walk(l.syntax, function(c) {
        if (c.type !== "Type" && c.type !== "Property")
          return;
        const a = c.type === "Type" ? o.types : o.properties, u = c.type === "Type" ? r : n;
        (!hasOwnProperty.call(a, c.name) || t(o, c.name, u, a[c.name])) && i.set(s, !0);
      }, this);
    }
    let r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
    for (const o in this.types)
      t(this, o, r, this.types[o]);
    for (const o in this.properties)
      t(this, o, n, this.properties[o]);
    return r = [...r.keys()].filter((o) => r.get(o)), n = [...n.keys()].filter((o) => n.get(o)), r.length || n.length ? {
      types: r,
      properties: n
    } : null;
  }
  dump(t, r) {
    return {
      generic: this.generic,
      types: Zo(this.types, !r, t),
      properties: Zo(this.properties, !r, t),
      atrules: hQ(this.atrules, !r, t)
    };
  }
  toString() {
    return JSON.stringify(this.dump());
  }
}
d5.Lexer = fQ;
const { hasOwnProperty: e2 } = Object.prototype, dQ = {
  generic: !0,
  types: qo,
  atrules: {
    prelude: u6,
    descriptors: u6
  },
  properties: qo,
  parseContext: pQ,
  scope: Nh,
  atrule: ["parse"],
  pseudo: ["parse"],
  node: ["name", "structure", "parse", "generate", "walkContext"]
};
function p4(e) {
  return e && e.constructor === Object;
}
function Ph(e) {
  return p4(e) ? { ...e } : e;
}
function pQ(e, t) {
  return Object.assign(e, t);
}
function Nh(e, t) {
  for (const r in t)
    e2.call(t, r) && (p4(e[r]) ? Nh(e[r], t[r]) : e[r] = Ph(t[r]));
  return e;
}
function c6(e, t) {
  return typeof t == "string" && /^\s*\|/.test(t) ? typeof e == "string" ? e + t : t.replace(/^\s*\|\s*/, "") : t || null;
}
function qo(e, t) {
  if (typeof t == "string")
    return c6(e, t);
  const r = { ...e };
  for (let n in t)
    e2.call(t, n) && (r[n] = c6(e2.call(e, n) ? e[n] : void 0, t[n]));
  return r;
}
function u6(e, t) {
  const r = qo(e, t);
  return !p4(r) || Object.keys(r).length ? r : null;
}
function n7(e, t, r) {
  for (const n in r)
    if (e2.call(r, n) !== !1) {
      if (r[n] === !0)
        e2.call(t, n) && (e[n] = Ph(t[n]));
      else if (r[n]) {
        if (typeof r[n] == "function") {
          const o = r[n];
          e[n] = o({}, e[n]), e[n] = o(e[n] || {}, t[n]);
        } else if (p4(r[n])) {
          const o = {};
          for (let s in e[n])
            o[s] = n7({}, e[n][s], r[n]);
          for (let s in t[n])
            o[s] = n7(o[s] || {}, t[n][s], r[n]);
          e[n] = o;
        } else if (Array.isArray(r[n])) {
          const o = {}, s = r[n].reduce(function(i, l) {
            return i[l] = !0, i;
          }, {});
          for (const [i, l] of Object.entries(e[n] || {}))
            o[i] = {}, l && n7(o[i], l, s);
          for (const i in t[n])
            e2.call(t[n], i) && (o[i] || (o[i] = {}), t[n] && t[n][i] && n7(o[i], t[n][i], s));
          e[n] = o;
        }
      }
    }
  return e;
}
const gQ = (e, t) => n7(e, t, dQ);
var kQ = gQ;
const vQ = q, yQ = rh, bQ = sh, xQ = ch, wQ = uh, h6 = d5, Uo = kQ;
function Dh(e) {
  const t = yQ.createParser(e), r = wQ.createWalker(e), n = bQ.createGenerator(e), { fromPlainObject: o, toPlainObject: s } = xQ.createConvertor(r), i = {
    lexer: null,
    createLexer: (l) => new h6.Lexer(l, i, i.lexer.structure),
    tokenize: vQ.tokenize,
    parse: t,
    generate: n,
    walk: r,
    find: r.find,
    findLast: r.findLast,
    findAll: r.findAll,
    fromPlainObject: o,
    toPlainObject: s,
    fork(l) {
      const c = Uo({}, e);
      return Dh(
        typeof l == "function" ? l(c, Object.assign) : Uo(c, l)
      );
    }
  };
  return i.lexer = new h6.Lexer({
    generic: !0,
    types: e.types,
    atrules: e.atrules,
    properties: e.properties,
    node: e.node
  }, i), i;
}
const LQ = (e) => Dh(Uo({}, e));
var Oh = LQ, zQ = {
  generic: !0,
  types: {
    "absolute-size": "xx-small|x-small|small|medium|large|x-large|xx-large|xxx-large",
    "alpha-value": "<number>|<percentage>",
    "angle-percentage": "<angle>|<percentage>",
    "angular-color-hint": "<angle-percentage>",
    "angular-color-stop": "<color>&&<color-stop-angle>?",
    "angular-color-stop-list": "[<angular-color-stop> [, <angular-color-hint>]?]# , <angular-color-stop>",
    "animateable-feature": "scroll-position|contents|<custom-ident>",
    attachment: "scroll|fixed|local",
    "attr()": "attr( <attr-name> <type-or-unit>? [, <attr-fallback>]? )",
    "attr-matcher": "['~'|'|'|'^'|'$'|'*']? '='",
    "attr-modifier": "i|s",
    "attribute-selector": "'[' <wq-name> ']'|'[' <wq-name> <attr-matcher> [<string-token>|<ident-token>] <attr-modifier>? ']'",
    "auto-repeat": "repeat( [auto-fill|auto-fit] , [<line-names>? <fixed-size>]+ <line-names>? )",
    "auto-track-list": "[<line-names>? [<fixed-size>|<fixed-repeat>]]* <line-names>? <auto-repeat> [<line-names>? [<fixed-size>|<fixed-repeat>]]* <line-names>?",
    "baseline-position": "[first|last]? baseline",
    "basic-shape": "<inset()>|<circle()>|<ellipse()>|<polygon()>|<path()>",
    "bg-image": "none|<image>",
    "bg-layer": "<bg-image>||<bg-position> [/ <bg-size>]?||<repeat-style>||<attachment>||<box>||<box>",
    "bg-position": "[[left|center|right|top|bottom|<length-percentage>]|[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]|[center|[left|right] <length-percentage>?]&&[center|[top|bottom] <length-percentage>?]]",
    "bg-size": "[<length-percentage>|auto]{1,2}|cover|contain",
    "blur()": "blur( <length> )",
    "blend-mode": "normal|multiply|screen|overlay|darken|lighten|color-dodge|color-burn|hard-light|soft-light|difference|exclusion|hue|saturation|color|luminosity",
    box: "border-box|padding-box|content-box",
    "brightness()": "brightness( <number-percentage> )",
    "calc()": "calc( <calc-sum> )",
    "calc-sum": "<calc-product> [['+'|'-'] <calc-product>]*",
    "calc-product": "<calc-value> ['*' <calc-value>|'/' <number>]*",
    "calc-value": "<number>|<dimension>|<percentage>|( <calc-sum> )",
    "cf-final-image": "<image>|<color>",
    "cf-mixing-image": "<percentage>?&&<image>",
    "circle()": "circle( [<shape-radius>]? [at <position>]? )",
    "clamp()": "clamp( <calc-sum>#{3} )",
    "class-selector": "'.' <ident-token>",
    "clip-source": "<url>",
    color: "<rgb()>|<rgba()>|<hsl()>|<hsla()>|<hwb()>|<lab()>|<lch()>|<hex-color>|<named-color>|currentcolor|<deprecated-system-color>",
    "color-stop": "<color-stop-length>|<color-stop-angle>",
    "color-stop-angle": "<angle-percentage>{1,2}",
    "color-stop-length": "<length-percentage>{1,2}",
    "color-stop-list": "[<linear-color-stop> [, <linear-color-hint>]?]# , <linear-color-stop>",
    combinator: "'>'|'+'|'~'|['||']",
    "common-lig-values": "[common-ligatures|no-common-ligatures]",
    "compat-auto": "searchfield|textarea|push-button|slider-horizontal|checkbox|radio|square-button|menulist|listbox|meter|progress-bar|button",
    "composite-style": "clear|copy|source-over|source-in|source-out|source-atop|destination-over|destination-in|destination-out|destination-atop|xor",
    "compositing-operator": "add|subtract|intersect|exclude",
    "compound-selector": "[<type-selector>? <subclass-selector>* [<pseudo-element-selector> <pseudo-class-selector>*]*]!",
    "compound-selector-list": "<compound-selector>#",
    "complex-selector": "<compound-selector> [<combinator>? <compound-selector>]*",
    "complex-selector-list": "<complex-selector>#",
    "conic-gradient()": "conic-gradient( [from <angle>]? [at <position>]? , <angular-color-stop-list> )",
    "contextual-alt-values": "[contextual|no-contextual]",
    "content-distribution": "space-between|space-around|space-evenly|stretch",
    "content-list": "[<string>|contents|<image>|<counter>|<quote>|<target>|<leader()>|<attr()>]+",
    "content-position": "center|start|end|flex-start|flex-end",
    "content-replacement": "<image>",
    "contrast()": "contrast( [<number-percentage>] )",
    counter: "<counter()>|<counters()>",
    "counter()": "counter( <counter-name> , <counter-style>? )",
    "counter-name": "<custom-ident>",
    "counter-style": "<counter-style-name>|symbols( )",
    "counter-style-name": "<custom-ident>",
    "counters()": "counters( <counter-name> , <string> , <counter-style>? )",
    "cross-fade()": "cross-fade( <cf-mixing-image> , <cf-final-image>? )",
    "cubic-bezier-timing-function": "ease|ease-in|ease-out|ease-in-out|cubic-bezier( <number [0,1]> , <number> , <number [0,1]> , <number> )",
    "deprecated-system-color": "ActiveBorder|ActiveCaption|AppWorkspace|Background|ButtonFace|ButtonHighlight|ButtonShadow|ButtonText|CaptionText|GrayText|Highlight|HighlightText|InactiveBorder|InactiveCaption|InactiveCaptionText|InfoBackground|InfoText|Menu|MenuText|Scrollbar|ThreeDDarkShadow|ThreeDFace|ThreeDHighlight|ThreeDLightShadow|ThreeDShadow|Window|WindowFrame|WindowText",
    "discretionary-lig-values": "[discretionary-ligatures|no-discretionary-ligatures]",
    "display-box": "contents|none",
    "display-inside": "flow|flow-root|table|flex|grid|ruby",
    "display-internal": "table-row-group|table-header-group|table-footer-group|table-row|table-cell|table-column-group|table-column|table-caption|ruby-base|ruby-text|ruby-base-container|ruby-text-container",
    "display-legacy": "inline-block|inline-list-item|inline-table|inline-flex|inline-grid",
    "display-listitem": "<display-outside>?&&[flow|flow-root]?&&list-item",
    "display-outside": "block|inline|run-in",
    "drop-shadow()": "drop-shadow( <length>{2,3} <color>? )",
    "east-asian-variant-values": "[jis78|jis83|jis90|jis04|simplified|traditional]",
    "east-asian-width-values": "[full-width|proportional-width]",
    "element()": "element( <custom-ident> , [first|start|last|first-except]? )|element( <id-selector> )",
    "ellipse()": "ellipse( [<shape-radius>{2}]? [at <position>]? )",
    "ending-shape": "circle|ellipse",
    "env()": "env( <custom-ident> , <declaration-value>? )",
    "explicit-track-list": "[<line-names>? <track-size>]+ <line-names>?",
    "family-name": "<string>|<custom-ident>+",
    "feature-tag-value": "<string> [<integer>|on|off]?",
    "feature-type": "@stylistic|@historical-forms|@styleset|@character-variant|@swash|@ornaments|@annotation",
    "feature-value-block": "<feature-type> '{' <feature-value-declaration-list> '}'",
    "feature-value-block-list": "<feature-value-block>+",
    "feature-value-declaration": "<custom-ident> : <integer>+ ;",
    "feature-value-declaration-list": "<feature-value-declaration>",
    "feature-value-name": "<custom-ident>",
    "fill-rule": "nonzero|evenodd",
    "filter-function": "<blur()>|<brightness()>|<contrast()>|<drop-shadow()>|<grayscale()>|<hue-rotate()>|<invert()>|<opacity()>|<saturate()>|<sepia()>",
    "filter-function-list": "[<filter-function>|<url>]+",
    "final-bg-layer": "<'background-color'>||<bg-image>||<bg-position> [/ <bg-size>]?||<repeat-style>||<attachment>||<box>||<box>",
    "fit-content()": "fit-content( [<length>|<percentage>] )",
    "fixed-breadth": "<length-percentage>",
    "fixed-repeat": "repeat( [<integer [1,\u221E]>] , [<line-names>? <fixed-size>]+ <line-names>? )",
    "fixed-size": "<fixed-breadth>|minmax( <fixed-breadth> , <track-breadth> )|minmax( <inflexible-breadth> , <fixed-breadth> )",
    "font-stretch-absolute": "normal|ultra-condensed|extra-condensed|condensed|semi-condensed|semi-expanded|expanded|extra-expanded|ultra-expanded|<percentage>",
    "font-variant-css21": "[normal|small-caps]",
    "font-weight-absolute": "normal|bold|<number [1,1000]>",
    "frequency-percentage": "<frequency>|<percentage>",
    "general-enclosed": "[<function-token> <any-value> )]|( <ident> <any-value> )",
    "generic-family": "serif|sans-serif|cursive|fantasy|monospace|-apple-system",
    "generic-name": "serif|sans-serif|cursive|fantasy|monospace",
    "geometry-box": "<shape-box>|fill-box|stroke-box|view-box",
    gradient: "<linear-gradient()>|<repeating-linear-gradient()>|<radial-gradient()>|<repeating-radial-gradient()>|<conic-gradient()>|<repeating-conic-gradient()>|<-legacy-gradient>",
    "grayscale()": "grayscale( <number-percentage> )",
    "grid-line": "auto|<custom-ident>|[<integer>&&<custom-ident>?]|[span&&[<integer>||<custom-ident>]]",
    "historical-lig-values": "[historical-ligatures|no-historical-ligatures]",
    "hsl()": "hsl( <hue> <percentage> <percentage> [/ <alpha-value>]? )|hsl( <hue> , <percentage> , <percentage> , <alpha-value>? )",
    "hsla()": "hsla( <hue> <percentage> <percentage> [/ <alpha-value>]? )|hsla( <hue> , <percentage> , <percentage> , <alpha-value>? )",
    hue: "<number>|<angle>",
    "hue-rotate()": "hue-rotate( <angle> )",
    "hwb()": "hwb( [<hue>|none] [<percentage>|none] [<percentage>|none] [/ [<alpha-value>|none]]? )",
    image: "<url>|<image()>|<image-set()>|<element()>|<paint()>|<cross-fade()>|<gradient>",
    "image()": "image( <image-tags>? [<image-src>? , <color>?]! )",
    "image-set()": "image-set( <image-set-option># )",
    "image-set-option": "[<image>|<string>] [<resolution>||type( <string> )]",
    "image-src": "<url>|<string>",
    "image-tags": "ltr|rtl",
    "inflexible-breadth": "<length>|<percentage>|min-content|max-content|auto",
    "inset()": "inset( <length-percentage>{1,4} [round <'border-radius'>]? )",
    "invert()": "invert( <number-percentage> )",
    "keyframes-name": "<custom-ident>|<string>",
    "keyframe-block": "<keyframe-selector># { <declaration-list> }",
    "keyframe-block-list": "<keyframe-block>+",
    "keyframe-selector": "from|to|<percentage>",
    "layer()": "layer( <layer-name> )",
    "layer-name": "<ident> ['.' <ident>]*",
    "leader()": "leader( <leader-type> )",
    "leader-type": "dotted|solid|space|<string>",
    "length-percentage": "<length>|<percentage>",
    "line-names": "'[' <custom-ident>* ']'",
    "line-name-list": "[<line-names>|<name-repeat>]+",
    "line-style": "none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset",
    "line-width": "<length>|thin|medium|thick",
    "linear-color-hint": "<length-percentage>",
    "linear-color-stop": "<color> <color-stop-length>?",
    "linear-gradient()": "linear-gradient( [<angle>|to <side-or-corner>]? , <color-stop-list> )",
    "mask-layer": "<mask-reference>||<position> [/ <bg-size>]?||<repeat-style>||<geometry-box>||[<geometry-box>|no-clip]||<compositing-operator>||<masking-mode>",
    "mask-position": "[<length-percentage>|left|center|right] [<length-percentage>|top|center|bottom]?",
    "mask-reference": "none|<image>|<mask-source>",
    "mask-source": "<url>",
    "masking-mode": "alpha|luminance|match-source",
    "matrix()": "matrix( <number>#{6} )",
    "matrix3d()": "matrix3d( <number>#{16} )",
    "max()": "max( <calc-sum># )",
    "media-and": "<media-in-parens> [and <media-in-parens>]+",
    "media-condition": "<media-not>|<media-and>|<media-or>|<media-in-parens>",
    "media-condition-without-or": "<media-not>|<media-and>|<media-in-parens>",
    "media-feature": "( [<mf-plain>|<mf-boolean>|<mf-range>] )",
    "media-in-parens": "( <media-condition> )|<media-feature>|<general-enclosed>",
    "media-not": "not <media-in-parens>",
    "media-or": "<media-in-parens> [or <media-in-parens>]+",
    "media-query": "<media-condition>|[not|only]? <media-type> [and <media-condition-without-or>]?",
    "media-query-list": "<media-query>#",
    "media-type": "<ident>",
    "mf-boolean": "<mf-name>",
    "mf-name": "<ident>",
    "mf-plain": "<mf-name> : <mf-value>",
    "mf-range": "<mf-name> ['<'|'>']? '='? <mf-value>|<mf-value> ['<'|'>']? '='? <mf-name>|<mf-value> '<' '='? <mf-name> '<' '='? <mf-value>|<mf-value> '>' '='? <mf-name> '>' '='? <mf-value>",
    "mf-value": "<number>|<dimension>|<ident>|<ratio>",
    "min()": "min( <calc-sum># )",
    "minmax()": "minmax( [<length>|<percentage>|min-content|max-content|auto] , [<length>|<percentage>|<flex>|min-content|max-content|auto] )",
    "name-repeat": "repeat( [<integer [1,\u221E]>|auto-fill] , <line-names>+ )",
    "named-color": "transparent|aliceblue|antiquewhite|aqua|aquamarine|azure|beige|bisque|black|blanchedalmond|blue|blueviolet|brown|burlywood|cadetblue|chartreuse|chocolate|coral|cornflowerblue|cornsilk|crimson|cyan|darkblue|darkcyan|darkgoldenrod|darkgray|darkgreen|darkgrey|darkkhaki|darkmagenta|darkolivegreen|darkorange|darkorchid|darkred|darksalmon|darkseagreen|darkslateblue|darkslategray|darkslategrey|darkturquoise|darkviolet|deeppink|deepskyblue|dimgray|dimgrey|dodgerblue|firebrick|floralwhite|forestgreen|fuchsia|gainsboro|ghostwhite|gold|goldenrod|gray|green|greenyellow|grey|honeydew|hotpink|indianred|indigo|ivory|khaki|lavender|lavenderblush|lawngreen|lemonchiffon|lightblue|lightcoral|lightcyan|lightgoldenrodyellow|lightgray|lightgreen|lightgrey|lightpink|lightsalmon|lightseagreen|lightskyblue|lightslategray|lightslategrey|lightsteelblue|lightyellow|lime|limegreen|linen|magenta|maroon|mediumaquamarine|mediumblue|mediumorchid|mediumpurple|mediumseagreen|mediumslateblue|mediumspringgreen|mediumturquoise|mediumvioletred|midnightblue|mintcream|mistyrose|moccasin|navajowhite|navy|oldlace|olive|olivedrab|orange|orangered|orchid|palegoldenrod|palegreen|paleturquoise|palevioletred|papayawhip|peachpuff|peru|pink|plum|powderblue|purple|rebeccapurple|red|rosybrown|royalblue|saddlebrown|salmon|sandybrown|seagreen|seashell|sienna|silver|skyblue|slateblue|slategray|slategrey|snow|springgreen|steelblue|tan|teal|thistle|tomato|turquoise|violet|wheat|white|whitesmoke|yellow|yellowgreen|<-non-standard-color>",
    "namespace-prefix": "<ident>",
    "ns-prefix": "[<ident-token>|'*']? '|'",
    "number-percentage": "<number>|<percentage>",
    "numeric-figure-values": "[lining-nums|oldstyle-nums]",
    "numeric-fraction-values": "[diagonal-fractions|stacked-fractions]",
    "numeric-spacing-values": "[proportional-nums|tabular-nums]",
    nth: "<an-plus-b>|even|odd",
    "opacity()": "opacity( [<number-percentage>] )",
    "overflow-position": "unsafe|safe",
    "outline-radius": "<length>|<percentage>",
    "page-body": "<declaration>? [; <page-body>]?|<page-margin-box> <page-body>",
    "page-margin-box": "<page-margin-box-type> '{' <declaration-list> '}'",
    "page-margin-box-type": "@top-left-corner|@top-left|@top-center|@top-right|@top-right-corner|@bottom-left-corner|@bottom-left|@bottom-center|@bottom-right|@bottom-right-corner|@left-top|@left-middle|@left-bottom|@right-top|@right-middle|@right-bottom",
    "page-selector-list": "[<page-selector>#]?",
    "page-selector": "<pseudo-page>+|<ident> <pseudo-page>*",
    "page-size": "A5|A4|A3|B5|B4|JIS-B5|JIS-B4|letter|legal|ledger",
    "path()": "path( [<fill-rule> ,]? <string> )",
    "paint()": "paint( <ident> , <declaration-value>? )",
    "perspective()": "perspective( <length> )",
    "polygon()": "polygon( <fill-rule>? , [<length-percentage> <length-percentage>]# )",
    position: "[[left|center|right]||[top|center|bottom]|[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]?|[[left|right] <length-percentage>]&&[[top|bottom] <length-percentage>]]",
    "pseudo-class-selector": "':' <ident-token>|':' <function-token> <any-value> ')'",
    "pseudo-element-selector": "':' <pseudo-class-selector>",
    "pseudo-page": ": [left|right|first|blank]",
    quote: "open-quote|close-quote|no-open-quote|no-close-quote",
    "radial-gradient()": "radial-gradient( [<ending-shape>||<size>]? [at <position>]? , <color-stop-list> )",
    "relative-selector": "<combinator>? <complex-selector>",
    "relative-selector-list": "<relative-selector>#",
    "relative-size": "larger|smaller",
    "repeat-style": "repeat-x|repeat-y|[repeat|space|round|no-repeat]{1,2}",
    "repeating-conic-gradient()": "repeating-conic-gradient( [from <angle>]? [at <position>]? , <angular-color-stop-list> )",
    "repeating-linear-gradient()": "repeating-linear-gradient( [<angle>|to <side-or-corner>]? , <color-stop-list> )",
    "repeating-radial-gradient()": "repeating-radial-gradient( [<ending-shape>||<size>]? [at <position>]? , <color-stop-list> )",
    "rgb()": "rgb( <percentage>{3} [/ <alpha-value>]? )|rgb( <number>{3} [/ <alpha-value>]? )|rgb( <percentage>#{3} , <alpha-value>? )|rgb( <number>#{3} , <alpha-value>? )",
    "rgba()": "rgba( <percentage>{3} [/ <alpha-value>]? )|rgba( <number>{3} [/ <alpha-value>]? )|rgba( <percentage>#{3} , <alpha-value>? )|rgba( <number>#{3} , <alpha-value>? )",
    "rotate()": "rotate( [<angle>|<zero>] )",
    "rotate3d()": "rotate3d( <number> , <number> , <number> , [<angle>|<zero>] )",
    "rotateX()": "rotateX( [<angle>|<zero>] )",
    "rotateY()": "rotateY( [<angle>|<zero>] )",
    "rotateZ()": "rotateZ( [<angle>|<zero>] )",
    "saturate()": "saturate( <number-percentage> )",
    "scale()": "scale( <number> , <number>? )",
    "scale3d()": "scale3d( <number> , <number> , <number> )",
    "scaleX()": "scaleX( <number> )",
    "scaleY()": "scaleY( <number> )",
    "scaleZ()": "scaleZ( <number> )",
    "self-position": "center|start|end|self-start|self-end|flex-start|flex-end",
    "shape-radius": "<length-percentage>|closest-side|farthest-side",
    "skew()": "skew( [<angle>|<zero>] , [<angle>|<zero>]? )",
    "skewX()": "skewX( [<angle>|<zero>] )",
    "skewY()": "skewY( [<angle>|<zero>] )",
    "sepia()": "sepia( <number-percentage> )",
    shadow: "inset?&&<length>{2,4}&&<color>?",
    "shadow-t": "[<length>{2,3}&&<color>?]",
    shape: "rect( <top> , <right> , <bottom> , <left> )|rect( <top> <right> <bottom> <left> )",
    "shape-box": "<box>|margin-box",
    "side-or-corner": "[left|right]||[top|bottom]",
    "single-animation": "<time>||<easing-function>||<time>||<single-animation-iteration-count>||<single-animation-direction>||<single-animation-fill-mode>||<single-animation-play-state>||[none|<keyframes-name>]",
    "single-animation-direction": "normal|reverse|alternate|alternate-reverse",
    "single-animation-fill-mode": "none|forwards|backwards|both",
    "single-animation-iteration-count": "infinite|<number>",
    "single-animation-play-state": "running|paused",
    "single-animation-timeline": "auto|none|<timeline-name>",
    "single-transition": "[none|<single-transition-property>]||<time>||<easing-function>||<time>",
    "single-transition-property": "all|<custom-ident>",
    size: "closest-side|farthest-side|closest-corner|farthest-corner|<length>|<length-percentage>{2}",
    "step-position": "jump-start|jump-end|jump-none|jump-both|start|end",
    "step-timing-function": "step-start|step-end|steps( <integer> [, <step-position>]? )",
    "subclass-selector": "<id-selector>|<class-selector>|<attribute-selector>|<pseudo-class-selector>",
    "supports-condition": "not <supports-in-parens>|<supports-in-parens> [and <supports-in-parens>]*|<supports-in-parens> [or <supports-in-parens>]*",
    "supports-in-parens": "( <supports-condition> )|<supports-feature>|<general-enclosed>",
    "supports-feature": "<supports-decl>|<supports-selector-fn>",
    "supports-decl": "( <declaration> )",
    "supports-selector-fn": "selector( <complex-selector> )",
    symbol: "<string>|<image>|<custom-ident>",
    target: "<target-counter()>|<target-counters()>|<target-text()>",
    "target-counter()": "target-counter( [<string>|<url>] , <custom-ident> , <counter-style>? )",
    "target-counters()": "target-counters( [<string>|<url>] , <custom-ident> , <string> , <counter-style>? )",
    "target-text()": "target-text( [<string>|<url>] , [content|before|after|first-letter]? )",
    "time-percentage": "<time>|<percentage>",
    "timeline-name": "<custom-ident>|<string>",
    "easing-function": "linear|<cubic-bezier-timing-function>|<step-timing-function>",
    "track-breadth": "<length-percentage>|<flex>|min-content|max-content|auto",
    "track-list": "[<line-names>? [<track-size>|<track-repeat>]]+ <line-names>?",
    "track-repeat": "repeat( [<integer [1,\u221E]>] , [<line-names>? <track-size>]+ <line-names>? )",
    "track-size": "<track-breadth>|minmax( <inflexible-breadth> , <track-breadth> )|fit-content( [<length>|<percentage>] )",
    "transform-function": "<matrix()>|<translate()>|<translateX()>|<translateY()>|<scale()>|<scaleX()>|<scaleY()>|<rotate()>|<skew()>|<skewX()>|<skewY()>|<matrix3d()>|<translate3d()>|<translateZ()>|<scale3d()>|<scaleZ()>|<rotate3d()>|<rotateX()>|<rotateY()>|<rotateZ()>|<perspective()>",
    "transform-list": "<transform-function>+",
    "translate()": "translate( <length-percentage> , <length-percentage>? )",
    "translate3d()": "translate3d( <length-percentage> , <length-percentage> , <length> )",
    "translateX()": "translateX( <length-percentage> )",
    "translateY()": "translateY( <length-percentage> )",
    "translateZ()": "translateZ( <length> )",
    "type-or-unit": "string|color|url|integer|number|length|angle|time|frequency|cap|ch|em|ex|ic|lh|rlh|rem|vb|vi|vw|vh|vmin|vmax|mm|Q|cm|in|pt|pc|px|deg|grad|rad|turn|ms|s|Hz|kHz|%",
    "type-selector": "<wq-name>|<ns-prefix>? '*'",
    "var()": "var( <custom-property-name> , <declaration-value>? )",
    "viewport-length": "auto|<length-percentage>",
    "visual-box": "content-box|padding-box|border-box",
    "wq-name": "<ns-prefix>? <ident-token>",
    "-legacy-gradient": "<-webkit-gradient()>|<-legacy-linear-gradient>|<-legacy-repeating-linear-gradient>|<-legacy-radial-gradient>|<-legacy-repeating-radial-gradient>",
    "-legacy-linear-gradient": "-moz-linear-gradient( <-legacy-linear-gradient-arguments> )|-webkit-linear-gradient( <-legacy-linear-gradient-arguments> )|-o-linear-gradient( <-legacy-linear-gradient-arguments> )",
    "-legacy-repeating-linear-gradient": "-moz-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )|-webkit-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )|-o-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )",
    "-legacy-linear-gradient-arguments": "[<angle>|<side-or-corner>]? , <color-stop-list>",
    "-legacy-radial-gradient": "-moz-radial-gradient( <-legacy-radial-gradient-arguments> )|-webkit-radial-gradient( <-legacy-radial-gradient-arguments> )|-o-radial-gradient( <-legacy-radial-gradient-arguments> )",
    "-legacy-repeating-radial-gradient": "-moz-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )|-webkit-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )|-o-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )",
    "-legacy-radial-gradient-arguments": "[<position> ,]? [[[<-legacy-radial-gradient-shape>||<-legacy-radial-gradient-size>]|[<length>|<percentage>]{2}] ,]? <color-stop-list>",
    "-legacy-radial-gradient-size": "closest-side|closest-corner|farthest-side|farthest-corner|contain|cover",
    "-legacy-radial-gradient-shape": "circle|ellipse",
    "-non-standard-font": "-apple-system-body|-apple-system-headline|-apple-system-subheadline|-apple-system-caption1|-apple-system-caption2|-apple-system-footnote|-apple-system-short-body|-apple-system-short-headline|-apple-system-short-subheadline|-apple-system-short-caption1|-apple-system-short-footnote|-apple-system-tall-body",
    "-non-standard-color": "-moz-ButtonDefault|-moz-ButtonHoverFace|-moz-ButtonHoverText|-moz-CellHighlight|-moz-CellHighlightText|-moz-Combobox|-moz-ComboboxText|-moz-Dialog|-moz-DialogText|-moz-dragtargetzone|-moz-EvenTreeRow|-moz-Field|-moz-FieldText|-moz-html-CellHighlight|-moz-html-CellHighlightText|-moz-mac-accentdarkestshadow|-moz-mac-accentdarkshadow|-moz-mac-accentface|-moz-mac-accentlightesthighlight|-moz-mac-accentlightshadow|-moz-mac-accentregularhighlight|-moz-mac-accentregularshadow|-moz-mac-chrome-active|-moz-mac-chrome-inactive|-moz-mac-focusring|-moz-mac-menuselect|-moz-mac-menushadow|-moz-mac-menutextselect|-moz-MenuHover|-moz-MenuHoverText|-moz-MenuBarText|-moz-MenuBarHoverText|-moz-nativehyperlinktext|-moz-OddTreeRow|-moz-win-communicationstext|-moz-win-mediatext|-moz-activehyperlinktext|-moz-default-background-color|-moz-default-color|-moz-hyperlinktext|-moz-visitedhyperlinktext|-webkit-activelink|-webkit-focus-ring-color|-webkit-link|-webkit-text",
    "-non-standard-image-rendering": "optimize-contrast|-moz-crisp-edges|-o-crisp-edges|-webkit-optimize-contrast",
    "-non-standard-overflow": "-moz-scrollbars-none|-moz-scrollbars-horizontal|-moz-scrollbars-vertical|-moz-hidden-unscrollable",
    "-non-standard-width": "fill-available|min-intrinsic|intrinsic|-moz-available|-moz-fit-content|-moz-min-content|-moz-max-content|-webkit-min-content|-webkit-max-content",
    "-webkit-gradient()": "-webkit-gradient( <-webkit-gradient-type> , <-webkit-gradient-point> [, <-webkit-gradient-point>|, <-webkit-gradient-radius> , <-webkit-gradient-point>] [, <-webkit-gradient-radius>]? [, <-webkit-gradient-color-stop>]* )",
    "-webkit-gradient-color-stop": "from( <color> )|color-stop( [<number-zero-one>|<percentage>] , <color> )|to( <color> )",
    "-webkit-gradient-point": "[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]",
    "-webkit-gradient-radius": "<length>|<percentage>",
    "-webkit-gradient-type": "linear|radial",
    "-webkit-mask-box-repeat": "repeat|stretch|round",
    "-webkit-mask-clip-style": "border|border-box|padding|padding-box|content|content-box|text",
    "-ms-filter-function-list": "<-ms-filter-function>+",
    "-ms-filter-function": "<-ms-filter-function-progid>|<-ms-filter-function-legacy>",
    "-ms-filter-function-progid": "'progid:' [<ident-token> '.']* [<ident-token>|<function-token> <any-value>? )]",
    "-ms-filter-function-legacy": "<ident-token>|<function-token> <any-value>? )",
    "-ms-filter": "<string>",
    age: "child|young|old",
    "attr-name": "<wq-name>",
    "attr-fallback": "<any-value>",
    "bg-clip": "<box>|border|text",
    "border-radius": "<length-percentage>{1,2}",
    bottom: "<length>|auto",
    "generic-voice": "[<age>? <gender> <integer>?]",
    gender: "male|female|neutral",
    "lab()": "lab( [<percentage>|<number>|none] [<percentage>|<number>|none] [<percentage>|<number>|none] [/ [<alpha-value>|none]]? )",
    "lch()": "lch( [<percentage>|<number>|none] [<percentage>|<number>|none] [<hue>|none] [/ [<alpha-value>|none]]? )",
    left: "<length>|auto",
    "mask-image": "<mask-reference>#",
    paint: "none|<color>|<url> [none|<color>]?|context-fill|context-stroke",
    ratio: "<number [0,\u221E]> [/ <number [0,\u221E]>]?",
    "reversed-counter-name": "reversed( <counter-name> )",
    right: "<length>|auto",
    "svg-length": "<percentage>|<length>|<number>",
    "svg-writing-mode": "lr-tb|rl-tb|tb-rl|lr|rl|tb",
    top: "<length>|auto",
    "track-group": "'(' [<string>* <track-minmax> <string>*]+ ')' ['[' <positive-integer> ']']?|<track-minmax>",
    "track-list-v0": "[<string>* <track-group> <string>*]+|none",
    "track-minmax": "minmax( <track-breadth> , <track-breadth> )|auto|<track-breadth>|fit-content",
    x: "<number>",
    y: "<number>",
    declaration: "<ident-token> : <declaration-value>? ['!' important]?",
    "declaration-list": "[<declaration>? ';']* <declaration>?",
    url: "url( <string> <url-modifier>* )|<url-token>",
    "url-modifier": "<ident>|<function-token> <any-value> )",
    "number-zero-one": "<number [0,1]>",
    "number-one-or-greater": "<number [1,\u221E]>",
    "positive-integer": "<integer [0,\u221E]>",
    "-non-standard-display": "-ms-inline-flexbox|-ms-grid|-ms-inline-grid|-webkit-flex|-webkit-inline-flex|-webkit-box|-webkit-inline-box|-moz-inline-stack|-moz-box|-moz-inline-box"
  },
  properties: {
    "--*": "<declaration-value>",
    "-ms-accelerator": "false|true",
    "-ms-block-progression": "tb|rl|bt|lr",
    "-ms-content-zoom-chaining": "none|chained",
    "-ms-content-zooming": "none|zoom",
    "-ms-content-zoom-limit": "<'-ms-content-zoom-limit-min'> <'-ms-content-zoom-limit-max'>",
    "-ms-content-zoom-limit-max": "<percentage>",
    "-ms-content-zoom-limit-min": "<percentage>",
    "-ms-content-zoom-snap": "<'-ms-content-zoom-snap-type'>||<'-ms-content-zoom-snap-points'>",
    "-ms-content-zoom-snap-points": "snapInterval( <percentage> , <percentage> )|snapList( <percentage># )",
    "-ms-content-zoom-snap-type": "none|proximity|mandatory",
    "-ms-filter": "<string>",
    "-ms-flow-from": "[none|<custom-ident>]#",
    "-ms-flow-into": "[none|<custom-ident>]#",
    "-ms-grid-columns": "none|<track-list>|<auto-track-list>",
    "-ms-grid-rows": "none|<track-list>|<auto-track-list>",
    "-ms-high-contrast-adjust": "auto|none",
    "-ms-hyphenate-limit-chars": "auto|<integer>{1,3}",
    "-ms-hyphenate-limit-lines": "no-limit|<integer>",
    "-ms-hyphenate-limit-zone": "<percentage>|<length>",
    "-ms-ime-align": "auto|after",
    "-ms-overflow-style": "auto|none|scrollbar|-ms-autohiding-scrollbar",
    "-ms-scrollbar-3dlight-color": "<color>",
    "-ms-scrollbar-arrow-color": "<color>",
    "-ms-scrollbar-base-color": "<color>",
    "-ms-scrollbar-darkshadow-color": "<color>",
    "-ms-scrollbar-face-color": "<color>",
    "-ms-scrollbar-highlight-color": "<color>",
    "-ms-scrollbar-shadow-color": "<color>",
    "-ms-scrollbar-track-color": "<color>",
    "-ms-scroll-chaining": "chained|none",
    "-ms-scroll-limit": "<'-ms-scroll-limit-x-min'> <'-ms-scroll-limit-y-min'> <'-ms-scroll-limit-x-max'> <'-ms-scroll-limit-y-max'>",
    "-ms-scroll-limit-x-max": "auto|<length>",
    "-ms-scroll-limit-x-min": "<length>",
    "-ms-scroll-limit-y-max": "auto|<length>",
    "-ms-scroll-limit-y-min": "<length>",
    "-ms-scroll-rails": "none|railed",
    "-ms-scroll-snap-points-x": "snapInterval( <length-percentage> , <length-percentage> )|snapList( <length-percentage># )",
    "-ms-scroll-snap-points-y": "snapInterval( <length-percentage> , <length-percentage> )|snapList( <length-percentage># )",
    "-ms-scroll-snap-type": "none|proximity|mandatory",
    "-ms-scroll-snap-x": "<'-ms-scroll-snap-type'> <'-ms-scroll-snap-points-x'>",
    "-ms-scroll-snap-y": "<'-ms-scroll-snap-type'> <'-ms-scroll-snap-points-y'>",
    "-ms-scroll-translation": "none|vertical-to-horizontal",
    "-ms-text-autospace": "none|ideograph-alpha|ideograph-numeric|ideograph-parenthesis|ideograph-space",
    "-ms-touch-select": "grippers|none",
    "-ms-user-select": "none|element|text",
    "-ms-wrap-flow": "auto|both|start|end|maximum|clear",
    "-ms-wrap-margin": "<length>",
    "-ms-wrap-through": "wrap|none",
    "-moz-appearance": "none|button|button-arrow-down|button-arrow-next|button-arrow-previous|button-arrow-up|button-bevel|button-focus|caret|checkbox|checkbox-container|checkbox-label|checkmenuitem|dualbutton|groupbox|listbox|listitem|menuarrow|menubar|menucheckbox|menuimage|menuitem|menuitemtext|menulist|menulist-button|menulist-text|menulist-textfield|menupopup|menuradio|menuseparator|meterbar|meterchunk|progressbar|progressbar-vertical|progresschunk|progresschunk-vertical|radio|radio-container|radio-label|radiomenuitem|range|range-thumb|resizer|resizerpanel|scale-horizontal|scalethumbend|scalethumb-horizontal|scalethumbstart|scalethumbtick|scalethumb-vertical|scale-vertical|scrollbarbutton-down|scrollbarbutton-left|scrollbarbutton-right|scrollbarbutton-up|scrollbarthumb-horizontal|scrollbarthumb-vertical|scrollbartrack-horizontal|scrollbartrack-vertical|searchfield|separator|sheet|spinner|spinner-downbutton|spinner-textfield|spinner-upbutton|splitter|statusbar|statusbarpanel|tab|tabpanel|tabpanels|tab-scroll-arrow-back|tab-scroll-arrow-forward|textfield|textfield-multiline|toolbar|toolbarbutton|toolbarbutton-dropdown|toolbargripper|toolbox|tooltip|treeheader|treeheadercell|treeheadersortarrow|treeitem|treeline|treetwisty|treetwistyopen|treeview|-moz-mac-unified-toolbar|-moz-win-borderless-glass|-moz-win-browsertabbar-toolbox|-moz-win-communicationstext|-moz-win-communications-toolbox|-moz-win-exclude-glass|-moz-win-glass|-moz-win-mediatext|-moz-win-media-toolbox|-moz-window-button-box|-moz-window-button-box-maximized|-moz-window-button-close|-moz-window-button-maximize|-moz-window-button-minimize|-moz-window-button-restore|-moz-window-frame-bottom|-moz-window-frame-left|-moz-window-frame-right|-moz-window-titlebar|-moz-window-titlebar-maximized",
    "-moz-binding": "<url>|none",
    "-moz-border-bottom-colors": "<color>+|none",
    "-moz-border-left-colors": "<color>+|none",
    "-moz-border-right-colors": "<color>+|none",
    "-moz-border-top-colors": "<color>+|none",
    "-moz-context-properties": "none|[fill|fill-opacity|stroke|stroke-opacity]#",
    "-moz-float-edge": "border-box|content-box|margin-box|padding-box",
    "-moz-force-broken-image-icon": "0|1",
    "-moz-image-region": "<shape>|auto",
    "-moz-orient": "inline|block|horizontal|vertical",
    "-moz-outline-radius": "<outline-radius>{1,4} [/ <outline-radius>{1,4}]?",
    "-moz-outline-radius-bottomleft": "<outline-radius>",
    "-moz-outline-radius-bottomright": "<outline-radius>",
    "-moz-outline-radius-topleft": "<outline-radius>",
    "-moz-outline-radius-topright": "<outline-radius>",
    "-moz-stack-sizing": "ignore|stretch-to-fit",
    "-moz-text-blink": "none|blink",
    "-moz-user-focus": "ignore|normal|select-after|select-before|select-menu|select-same|select-all|none",
    "-moz-user-input": "auto|none|enabled|disabled",
    "-moz-user-modify": "read-only|read-write|write-only",
    "-moz-window-dragging": "drag|no-drag",
    "-moz-window-shadow": "default|menu|tooltip|sheet|none",
    "-webkit-appearance": "none|button|button-bevel|caps-lock-indicator|caret|checkbox|default-button|inner-spin-button|listbox|listitem|media-controls-background|media-controls-fullscreen-background|media-current-time-display|media-enter-fullscreen-button|media-exit-fullscreen-button|media-fullscreen-button|media-mute-button|media-overlay-play-button|media-play-button|media-seek-back-button|media-seek-forward-button|media-slider|media-sliderthumb|media-time-remaining-display|media-toggle-closed-captions-button|media-volume-slider|media-volume-slider-container|media-volume-sliderthumb|menulist|menulist-button|menulist-text|menulist-textfield|meter|progress-bar|progress-bar-value|push-button|radio|scrollbarbutton-down|scrollbarbutton-left|scrollbarbutton-right|scrollbarbutton-up|scrollbargripper-horizontal|scrollbargripper-vertical|scrollbarthumb-horizontal|scrollbarthumb-vertical|scrollbartrack-horizontal|scrollbartrack-vertical|searchfield|searchfield-cancel-button|searchfield-decoration|searchfield-results-button|searchfield-results-decoration|slider-horizontal|slider-vertical|sliderthumb-horizontal|sliderthumb-vertical|square-button|textarea|textfield|-apple-pay-button",
    "-webkit-border-before": "<'border-width'>||<'border-style'>||<color>",
    "-webkit-border-before-color": "<color>",
    "-webkit-border-before-style": "<'border-style'>",
    "-webkit-border-before-width": "<'border-width'>",
    "-webkit-box-reflect": "[above|below|right|left]? <length>? <image>?",
    "-webkit-line-clamp": "none|<integer>",
    "-webkit-mask": "[<mask-reference>||<position> [/ <bg-size>]?||<repeat-style>||[<box>|border|padding|content|text]||[<box>|border|padding|content]]#",
    "-webkit-mask-attachment": "<attachment>#",
    "-webkit-mask-clip": "[<box>|border|padding|content|text]#",
    "-webkit-mask-composite": "<composite-style>#",
    "-webkit-mask-image": "<mask-reference>#",
    "-webkit-mask-origin": "[<box>|border|padding|content]#",
    "-webkit-mask-position": "<position>#",
    "-webkit-mask-position-x": "[<length-percentage>|left|center|right]#",
    "-webkit-mask-position-y": "[<length-percentage>|top|center|bottom]#",
    "-webkit-mask-repeat": "<repeat-style>#",
    "-webkit-mask-repeat-x": "repeat|no-repeat|space|round",
    "-webkit-mask-repeat-y": "repeat|no-repeat|space|round",
    "-webkit-mask-size": "<bg-size>#",
    "-webkit-overflow-scrolling": "auto|touch",
    "-webkit-tap-highlight-color": "<color>",
    "-webkit-text-fill-color": "<color>",
    "-webkit-text-stroke": "<length>||<color>",
    "-webkit-text-stroke-color": "<color>",
    "-webkit-text-stroke-width": "<length>",
    "-webkit-touch-callout": "default|none",
    "-webkit-user-modify": "read-only|read-write|read-write-plaintext-only",
    "accent-color": "auto|<color>",
    "align-content": "normal|<baseline-position>|<content-distribution>|<overflow-position>? <content-position>",
    "align-items": "normal|stretch|<baseline-position>|[<overflow-position>? <self-position>]",
    "align-self": "auto|normal|stretch|<baseline-position>|<overflow-position>? <self-position>",
    "align-tracks": "[normal|<baseline-position>|<content-distribution>|<overflow-position>? <content-position>]#",
    all: "initial|inherit|unset|revert|revert-layer",
    animation: "<single-animation>#",
    "animation-delay": "<time>#",
    "animation-direction": "<single-animation-direction>#",
    "animation-duration": "<time>#",
    "animation-fill-mode": "<single-animation-fill-mode>#",
    "animation-iteration-count": "<single-animation-iteration-count>#",
    "animation-name": "[none|<keyframes-name>]#",
    "animation-play-state": "<single-animation-play-state>#",
    "animation-timing-function": "<easing-function>#",
    "animation-timeline": "<single-animation-timeline>#",
    appearance: "none|auto|textfield|menulist-button|<compat-auto>",
    "aspect-ratio": "auto|<ratio>",
    azimuth: "<angle>|[[left-side|far-left|left|center-left|center|center-right|right|far-right|right-side]||behind]|leftwards|rightwards",
    "backdrop-filter": "none|<filter-function-list>",
    "backface-visibility": "visible|hidden",
    background: "[<bg-layer> ,]* <final-bg-layer>",
    "background-attachment": "<attachment>#",
    "background-blend-mode": "<blend-mode>#",
    "background-clip": "<bg-clip>#",
    "background-color": "<color>",
    "background-image": "<bg-image>#",
    "background-origin": "<box>#",
    "background-position": "<bg-position>#",
    "background-position-x": "[center|[[left|right|x-start|x-end]? <length-percentage>?]!]#",
    "background-position-y": "[center|[[top|bottom|y-start|y-end]? <length-percentage>?]!]#",
    "background-repeat": "<repeat-style>#",
    "background-size": "<bg-size>#",
    "block-overflow": "clip|ellipsis|<string>",
    "block-size": "<'width'>",
    border: "<line-width>||<line-style>||<color>",
    "border-block": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-block-color": "<'border-top-color'>{1,2}",
    "border-block-style": "<'border-top-style'>",
    "border-block-width": "<'border-top-width'>",
    "border-block-end": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-block-end-color": "<'border-top-color'>",
    "border-block-end-style": "<'border-top-style'>",
    "border-block-end-width": "<'border-top-width'>",
    "border-block-start": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-block-start-color": "<'border-top-color'>",
    "border-block-start-style": "<'border-top-style'>",
    "border-block-start-width": "<'border-top-width'>",
    "border-bottom": "<line-width>||<line-style>||<color>",
    "border-bottom-color": "<'border-top-color'>",
    "border-bottom-left-radius": "<length-percentage>{1,2}",
    "border-bottom-right-radius": "<length-percentage>{1,2}",
    "border-bottom-style": "<line-style>",
    "border-bottom-width": "<line-width>",
    "border-collapse": "collapse|separate",
    "border-color": "<color>{1,4}",
    "border-end-end-radius": "<length-percentage>{1,2}",
    "border-end-start-radius": "<length-percentage>{1,2}",
    "border-image": "<'border-image-source'>||<'border-image-slice'> [/ <'border-image-width'>|/ <'border-image-width'>? / <'border-image-outset'>]?||<'border-image-repeat'>",
    "border-image-outset": "[<length>|<number>]{1,4}",
    "border-image-repeat": "[stretch|repeat|round|space]{1,2}",
    "border-image-slice": "<number-percentage>{1,4}&&fill?",
    "border-image-source": "none|<image>",
    "border-image-width": "[<length-percentage>|<number>|auto]{1,4}",
    "border-inline": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-inline-end": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-inline-color": "<'border-top-color'>{1,2}",
    "border-inline-style": "<'border-top-style'>",
    "border-inline-width": "<'border-top-width'>",
    "border-inline-end-color": "<'border-top-color'>",
    "border-inline-end-style": "<'border-top-style'>",
    "border-inline-end-width": "<'border-top-width'>",
    "border-inline-start": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-inline-start-color": "<'border-top-color'>",
    "border-inline-start-style": "<'border-top-style'>",
    "border-inline-start-width": "<'border-top-width'>",
    "border-left": "<line-width>||<line-style>||<color>",
    "border-left-color": "<color>",
    "border-left-style": "<line-style>",
    "border-left-width": "<line-width>",
    "border-radius": "<length-percentage>{1,4} [/ <length-percentage>{1,4}]?",
    "border-right": "<line-width>||<line-style>||<color>",
    "border-right-color": "<color>",
    "border-right-style": "<line-style>",
    "border-right-width": "<line-width>",
    "border-spacing": "<length> <length>?",
    "border-start-end-radius": "<length-percentage>{1,2}",
    "border-start-start-radius": "<length-percentage>{1,2}",
    "border-style": "<line-style>{1,4}",
    "border-top": "<line-width>||<line-style>||<color>",
    "border-top-color": "<color>",
    "border-top-left-radius": "<length-percentage>{1,2}",
    "border-top-right-radius": "<length-percentage>{1,2}",
    "border-top-style": "<line-style>",
    "border-top-width": "<line-width>",
    "border-width": "<line-width>{1,4}",
    bottom: "<length>|<percentage>|auto",
    "box-align": "start|center|end|baseline|stretch",
    "box-decoration-break": "slice|clone",
    "box-direction": "normal|reverse|inherit",
    "box-flex": "<number>",
    "box-flex-group": "<integer>",
    "box-lines": "single|multiple",
    "box-ordinal-group": "<integer>",
    "box-orient": "horizontal|vertical|inline-axis|block-axis|inherit",
    "box-pack": "start|center|end|justify",
    "box-shadow": "none|<shadow>#",
    "box-sizing": "content-box|border-box",
    "break-after": "auto|avoid|always|all|avoid-page|page|left|right|recto|verso|avoid-column|column|avoid-region|region",
    "break-before": "auto|avoid|always|all|avoid-page|page|left|right|recto|verso|avoid-column|column|avoid-region|region",
    "break-inside": "auto|avoid|avoid-page|avoid-column|avoid-region",
    "caption-side": "top|bottom|block-start|block-end|inline-start|inline-end",
    "caret-color": "auto|<color>",
    clear: "none|left|right|both|inline-start|inline-end",
    clip: "<shape>|auto",
    "clip-path": "<clip-source>|[<basic-shape>||<geometry-box>]|none",
    color: "<color>",
    "print-color-adjust": "economy|exact",
    "color-scheme": "normal|[light|dark|<custom-ident>]+&&only?",
    "column-count": "<integer>|auto",
    "column-fill": "auto|balance|balance-all",
    "column-gap": "normal|<length-percentage>",
    "column-rule": "<'column-rule-width'>||<'column-rule-style'>||<'column-rule-color'>",
    "column-rule-color": "<color>",
    "column-rule-style": "<'border-style'>",
    "column-rule-width": "<'border-width'>",
    "column-span": "none|all",
    "column-width": "<length>|auto",
    columns: "<'column-width'>||<'column-count'>",
    contain: "none|strict|content|[size||layout||style||paint]",
    content: "normal|none|[<content-replacement>|<content-list>] [/ [<string>|<counter>]+]?",
    "content-visibility": "visible|auto|hidden",
    "counter-increment": "[<counter-name> <integer>?]+|none",
    "counter-reset": "[<counter-name> <integer>?|<reversed-counter-name> <integer>?]+|none",
    "counter-set": "[<counter-name> <integer>?]+|none",
    cursor: "[[<url> [<x> <y>]? ,]* [auto|default|none|context-menu|help|pointer|progress|wait|cell|crosshair|text|vertical-text|alias|copy|move|no-drop|not-allowed|e-resize|n-resize|ne-resize|nw-resize|s-resize|se-resize|sw-resize|w-resize|ew-resize|ns-resize|nesw-resize|nwse-resize|col-resize|row-resize|all-scroll|zoom-in|zoom-out|grab|grabbing|hand|-webkit-grab|-webkit-grabbing|-webkit-zoom-in|-webkit-zoom-out|-moz-grab|-moz-grabbing|-moz-zoom-in|-moz-zoom-out]]",
    direction: "ltr|rtl",
    display: "[<display-outside>||<display-inside>]|<display-listitem>|<display-internal>|<display-box>|<display-legacy>|<-non-standard-display>",
    "empty-cells": "show|hide",
    filter: "none|<filter-function-list>|<-ms-filter-function-list>",
    flex: "none|[<'flex-grow'> <'flex-shrink'>?||<'flex-basis'>]",
    "flex-basis": "content|<'width'>",
    "flex-direction": "row|row-reverse|column|column-reverse",
    "flex-flow": "<'flex-direction'>||<'flex-wrap'>",
    "flex-grow": "<number>",
    "flex-shrink": "<number>",
    "flex-wrap": "nowrap|wrap|wrap-reverse",
    float: "left|right|none|inline-start|inline-end",
    font: "[[<'font-style'>||<font-variant-css21>||<'font-weight'>||<'font-stretch'>]? <'font-size'> [/ <'line-height'>]? <'font-family'>]|caption|icon|menu|message-box|small-caption|status-bar",
    "font-family": "[<family-name>|<generic-family>]#",
    "font-feature-settings": "normal|<feature-tag-value>#",
    "font-kerning": "auto|normal|none",
    "font-language-override": "normal|<string>",
    "font-optical-sizing": "auto|none",
    "font-variation-settings": "normal|[<string> <number>]#",
    "font-size": "<absolute-size>|<relative-size>|<length-percentage>",
    "font-size-adjust": "none|[ex-height|cap-height|ch-width|ic-width|ic-height]? [from-font|<number>]",
    "font-smooth": "auto|never|always|<absolute-size>|<length>",
    "font-stretch": "<font-stretch-absolute>",
    "font-style": "normal|italic|oblique <angle>?",
    "font-synthesis": "none|[weight||style||small-caps]",
    "font-variant": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>||stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )||[small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps]||<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero||<east-asian-variant-values>||<east-asian-width-values>||ruby]",
    "font-variant-alternates": "normal|[stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )]",
    "font-variant-caps": "normal|small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps",
    "font-variant-east-asian": "normal|[<east-asian-variant-values>||<east-asian-width-values>||ruby]",
    "font-variant-ligatures": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>]",
    "font-variant-numeric": "normal|[<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero]",
    "font-variant-position": "normal|sub|super",
    "font-weight": "<font-weight-absolute>|bolder|lighter",
    "forced-color-adjust": "auto|none",
    gap: "<'row-gap'> <'column-gap'>?",
    grid: "<'grid-template'>|<'grid-template-rows'> / [auto-flow&&dense?] <'grid-auto-columns'>?|[auto-flow&&dense?] <'grid-auto-rows'>? / <'grid-template-columns'>",
    "grid-area": "<grid-line> [/ <grid-line>]{0,3}",
    "grid-auto-columns": "<track-size>+",
    "grid-auto-flow": "[row|column]||dense",
    "grid-auto-rows": "<track-size>+",
    "grid-column": "<grid-line> [/ <grid-line>]?",
    "grid-column-end": "<grid-line>",
    "grid-column-gap": "<length-percentage>",
    "grid-column-start": "<grid-line>",
    "grid-gap": "<'grid-row-gap'> <'grid-column-gap'>?",
    "grid-row": "<grid-line> [/ <grid-line>]?",
    "grid-row-end": "<grid-line>",
    "grid-row-gap": "<length-percentage>",
    "grid-row-start": "<grid-line>",
    "grid-template": "none|[<'grid-template-rows'> / <'grid-template-columns'>]|[<line-names>? <string> <track-size>? <line-names>?]+ [/ <explicit-track-list>]?",
    "grid-template-areas": "none|<string>+",
    "grid-template-columns": "none|<track-list>|<auto-track-list>|subgrid <line-name-list>?",
    "grid-template-rows": "none|<track-list>|<auto-track-list>|subgrid <line-name-list>?",
    "hanging-punctuation": "none|[first||[force-end|allow-end]||last]",
    height: "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )",
    "hyphenate-character": "auto|<string>",
    hyphens: "none|manual|auto",
    "image-orientation": "from-image|<angle>|[<angle>? flip]",
    "image-rendering": "auto|crisp-edges|pixelated|optimizeSpeed|optimizeQuality|<-non-standard-image-rendering>",
    "image-resolution": "[from-image||<resolution>]&&snap?",
    "ime-mode": "auto|normal|active|inactive|disabled",
    "initial-letter": "normal|[<number> <integer>?]",
    "initial-letter-align": "[auto|alphabetic|hanging|ideographic]",
    "inline-size": "<'width'>",
    "input-security": "auto|none",
    inset: "<'top'>{1,4}",
    "inset-block": "<'top'>{1,2}",
    "inset-block-end": "<'top'>",
    "inset-block-start": "<'top'>",
    "inset-inline": "<'top'>{1,2}",
    "inset-inline-end": "<'top'>",
    "inset-inline-start": "<'top'>",
    isolation: "auto|isolate",
    "justify-content": "normal|<content-distribution>|<overflow-position>? [<content-position>|left|right]",
    "justify-items": "normal|stretch|<baseline-position>|<overflow-position>? [<self-position>|left|right]|legacy|legacy&&[left|right|center]",
    "justify-self": "auto|normal|stretch|<baseline-position>|<overflow-position>? [<self-position>|left|right]",
    "justify-tracks": "[normal|<content-distribution>|<overflow-position>? [<content-position>|left|right]]#",
    left: "<length>|<percentage>|auto",
    "letter-spacing": "normal|<length-percentage>",
    "line-break": "auto|loose|normal|strict|anywhere",
    "line-clamp": "none|<integer>",
    "line-height": "normal|<number>|<length>|<percentage>",
    "line-height-step": "<length>",
    "list-style": "<'list-style-type'>||<'list-style-position'>||<'list-style-image'>",
    "list-style-image": "<image>|none",
    "list-style-position": "inside|outside",
    "list-style-type": "<counter-style>|<string>|none",
    margin: "[<length>|<percentage>|auto]{1,4}",
    "margin-block": "<'margin-left'>{1,2}",
    "margin-block-end": "<'margin-left'>",
    "margin-block-start": "<'margin-left'>",
    "margin-bottom": "<length>|<percentage>|auto",
    "margin-inline": "<'margin-left'>{1,2}",
    "margin-inline-end": "<'margin-left'>",
    "margin-inline-start": "<'margin-left'>",
    "margin-left": "<length>|<percentage>|auto",
    "margin-right": "<length>|<percentage>|auto",
    "margin-top": "<length>|<percentage>|auto",
    "margin-trim": "none|in-flow|all",
    mask: "<mask-layer>#",
    "mask-border": "<'mask-border-source'>||<'mask-border-slice'> [/ <'mask-border-width'>? [/ <'mask-border-outset'>]?]?||<'mask-border-repeat'>||<'mask-border-mode'>",
    "mask-border-mode": "luminance|alpha",
    "mask-border-outset": "[<length>|<number>]{1,4}",
    "mask-border-repeat": "[stretch|repeat|round|space]{1,2}",
    "mask-border-slice": "<number-percentage>{1,4} fill?",
    "mask-border-source": "none|<image>",
    "mask-border-width": "[<length-percentage>|<number>|auto]{1,4}",
    "mask-clip": "[<geometry-box>|no-clip]#",
    "mask-composite": "<compositing-operator>#",
    "mask-image": "<mask-reference>#",
    "mask-mode": "<masking-mode>#",
    "mask-origin": "<geometry-box>#",
    "mask-position": "<position>#",
    "mask-repeat": "<repeat-style>#",
    "mask-size": "<bg-size>#",
    "mask-type": "luminance|alpha",
    "masonry-auto-flow": "[pack|next]||[definite-first|ordered]",
    "math-style": "normal|compact",
    "max-block-size": "<'max-width'>",
    "max-height": "none|<length-percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )",
    "max-inline-size": "<'max-width'>",
    "max-lines": "none|<integer>",
    "max-width": "none|<length-percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|<-non-standard-width>",
    "min-block-size": "<'min-width'>",
    "min-height": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )",
    "min-inline-size": "<'min-width'>",
    "min-width": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|<-non-standard-width>",
    "mix-blend-mode": "<blend-mode>|plus-lighter",
    "object-fit": "fill|contain|cover|none|scale-down",
    "object-position": "<position>",
    offset: "[<'offset-position'>? [<'offset-path'> [<'offset-distance'>||<'offset-rotate'>]?]?]! [/ <'offset-anchor'>]?",
    "offset-anchor": "auto|<position>",
    "offset-distance": "<length-percentage>",
    "offset-path": "none|ray( [<angle>&&<size>&&contain?] )|<path()>|<url>|[<basic-shape>||<geometry-box>]",
    "offset-position": "auto|<position>",
    "offset-rotate": "[auto|reverse]||<angle>",
    opacity: "<alpha-value>",
    order: "<integer>",
    orphans: "<integer>",
    outline: "[<'outline-color'>||<'outline-style'>||<'outline-width'>]",
    "outline-color": "<color>|invert",
    "outline-offset": "<length>",
    "outline-style": "auto|<'border-style'>",
    "outline-width": "<line-width>",
    overflow: "[visible|hidden|clip|scroll|auto]{1,2}|<-non-standard-overflow>",
    "overflow-anchor": "auto|none",
    "overflow-block": "visible|hidden|clip|scroll|auto",
    "overflow-clip-box": "padding-box|content-box",
    "overflow-clip-margin": "<visual-box>||<length [0,\u221E]>",
    "overflow-inline": "visible|hidden|clip|scroll|auto",
    "overflow-wrap": "normal|break-word|anywhere",
    "overflow-x": "visible|hidden|clip|scroll|auto",
    "overflow-y": "visible|hidden|clip|scroll|auto",
    "overscroll-behavior": "[contain|none|auto]{1,2}",
    "overscroll-behavior-block": "contain|none|auto",
    "overscroll-behavior-inline": "contain|none|auto",
    "overscroll-behavior-x": "contain|none|auto",
    "overscroll-behavior-y": "contain|none|auto",
    padding: "[<length>|<percentage>]{1,4}",
    "padding-block": "<'padding-left'>{1,2}",
    "padding-block-end": "<'padding-left'>",
    "padding-block-start": "<'padding-left'>",
    "padding-bottom": "<length>|<percentage>",
    "padding-inline": "<'padding-left'>{1,2}",
    "padding-inline-end": "<'padding-left'>",
    "padding-inline-start": "<'padding-left'>",
    "padding-left": "<length>|<percentage>",
    "padding-right": "<length>|<percentage>",
    "padding-top": "<length>|<percentage>",
    "page-break-after": "auto|always|avoid|left|right|recto|verso",
    "page-break-before": "auto|always|avoid|left|right|recto|verso",
    "page-break-inside": "auto|avoid",
    "paint-order": "normal|[fill||stroke||markers]",
    perspective: "none|<length>",
    "perspective-origin": "<position>",
    "place-content": "<'align-content'> <'justify-content'>?",
    "place-items": "<'align-items'> <'justify-items'>?",
    "place-self": "<'align-self'> <'justify-self'>?",
    "pointer-events": "auto|none|visiblePainted|visibleFill|visibleStroke|visible|painted|fill|stroke|all|inherit",
    position: "static|relative|absolute|sticky|fixed|-webkit-sticky",
    quotes: "none|auto|[<string> <string>]+",
    resize: "none|both|horizontal|vertical|block|inline",
    right: "<length>|<percentage>|auto",
    rotate: "none|<angle>|[x|y|z|<number>{3}]&&<angle>",
    "row-gap": "normal|<length-percentage>",
    "ruby-align": "start|center|space-between|space-around",
    "ruby-merge": "separate|collapse|auto",
    "ruby-position": "[alternate||[over|under]]|inter-character",
    scale: "none|<number>{1,3}",
    "scrollbar-color": "auto|<color>{2}",
    "scrollbar-gutter": "auto|stable&&both-edges?",
    "scrollbar-width": "auto|thin|none",
    "scroll-behavior": "auto|smooth",
    "scroll-margin": "<length>{1,4}",
    "scroll-margin-block": "<length>{1,2}",
    "scroll-margin-block-start": "<length>",
    "scroll-margin-block-end": "<length>",
    "scroll-margin-bottom": "<length>",
    "scroll-margin-inline": "<length>{1,2}",
    "scroll-margin-inline-start": "<length>",
    "scroll-margin-inline-end": "<length>",
    "scroll-margin-left": "<length>",
    "scroll-margin-right": "<length>",
    "scroll-margin-top": "<length>",
    "scroll-padding": "[auto|<length-percentage>]{1,4}",
    "scroll-padding-block": "[auto|<length-percentage>]{1,2}",
    "scroll-padding-block-start": "auto|<length-percentage>",
    "scroll-padding-block-end": "auto|<length-percentage>",
    "scroll-padding-bottom": "auto|<length-percentage>",
    "scroll-padding-inline": "[auto|<length-percentage>]{1,2}",
    "scroll-padding-inline-start": "auto|<length-percentage>",
    "scroll-padding-inline-end": "auto|<length-percentage>",
    "scroll-padding-left": "auto|<length-percentage>",
    "scroll-padding-right": "auto|<length-percentage>",
    "scroll-padding-top": "auto|<length-percentage>",
    "scroll-snap-align": "[none|start|end|center]{1,2}",
    "scroll-snap-coordinate": "none|<position>#",
    "scroll-snap-destination": "<position>",
    "scroll-snap-points-x": "none|repeat( <length-percentage> )",
    "scroll-snap-points-y": "none|repeat( <length-percentage> )",
    "scroll-snap-stop": "normal|always",
    "scroll-snap-type": "none|[x|y|block|inline|both] [mandatory|proximity]?",
    "scroll-snap-type-x": "none|mandatory|proximity",
    "scroll-snap-type-y": "none|mandatory|proximity",
    "shape-image-threshold": "<alpha-value>",
    "shape-margin": "<length-percentage>",
    "shape-outside": "none|[<shape-box>||<basic-shape>]|<image>",
    "tab-size": "<integer>|<length>",
    "table-layout": "auto|fixed",
    "text-align": "start|end|left|right|center|justify|match-parent",
    "text-align-last": "auto|start|end|left|right|center|justify",
    "text-combine-upright": "none|all|[digits <integer>?]",
    "text-decoration": "<'text-decoration-line'>||<'text-decoration-style'>||<'text-decoration-color'>||<'text-decoration-thickness'>",
    "text-decoration-color": "<color>",
    "text-decoration-line": "none|[underline||overline||line-through||blink]|spelling-error|grammar-error",
    "text-decoration-skip": "none|[objects||[spaces|[leading-spaces||trailing-spaces]]||edges||box-decoration]",
    "text-decoration-skip-ink": "auto|all|none",
    "text-decoration-style": "solid|double|dotted|dashed|wavy",
    "text-decoration-thickness": "auto|from-font|<length>|<percentage>",
    "text-emphasis": "<'text-emphasis-style'>||<'text-emphasis-color'>",
    "text-emphasis-color": "<color>",
    "text-emphasis-position": "[over|under]&&[right|left]",
    "text-emphasis-style": "none|[[filled|open]||[dot|circle|double-circle|triangle|sesame]]|<string>",
    "text-indent": "<length-percentage>&&hanging?&&each-line?",
    "text-justify": "auto|inter-character|inter-word|none",
    "text-orientation": "mixed|upright|sideways",
    "text-overflow": "[clip|ellipsis|<string>]{1,2}",
    "text-rendering": "auto|optimizeSpeed|optimizeLegibility|geometricPrecision",
    "text-shadow": "none|<shadow-t>#",
    "text-size-adjust": "none|auto|<percentage>",
    "text-transform": "none|capitalize|uppercase|lowercase|full-width|full-size-kana",
    "text-underline-offset": "auto|<length>|<percentage>",
    "text-underline-position": "auto|from-font|[under||[left|right]]",
    top: "<length>|<percentage>|auto",
    "touch-action": "auto|none|[[pan-x|pan-left|pan-right]||[pan-y|pan-up|pan-down]||pinch-zoom]|manipulation",
    transform: "none|<transform-list>",
    "transform-box": "content-box|border-box|fill-box|stroke-box|view-box",
    "transform-origin": "[<length-percentage>|left|center|right|top|bottom]|[[<length-percentage>|left|center|right]&&[<length-percentage>|top|center|bottom]] <length>?",
    "transform-style": "flat|preserve-3d",
    transition: "<single-transition>#",
    "transition-delay": "<time>#",
    "transition-duration": "<time>#",
    "transition-property": "none|<single-transition-property>#",
    "transition-timing-function": "<easing-function>#",
    translate: "none|<length-percentage> [<length-percentage> <length>?]?",
    "unicode-bidi": "normal|embed|isolate|bidi-override|isolate-override|plaintext|-moz-isolate|-moz-isolate-override|-moz-plaintext|-webkit-isolate|-webkit-isolate-override|-webkit-plaintext",
    "user-select": "auto|text|none|contain|all",
    "vertical-align": "baseline|sub|super|text-top|text-bottom|middle|top|bottom|<percentage>|<length>",
    visibility: "visible|hidden|collapse",
    "white-space": "normal|pre|nowrap|pre-wrap|pre-line|break-spaces",
    widows: "<integer>",
    width: "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|fill|stretch|intrinsic|-moz-max-content|-webkit-max-content|-moz-fit-content|-webkit-fit-content",
    "will-change": "auto|<animateable-feature>#",
    "word-break": "normal|break-all|keep-all|break-word",
    "word-spacing": "normal|<length>",
    "word-wrap": "normal|break-word",
    "writing-mode": "horizontal-tb|vertical-rl|vertical-lr|sideways-rl|sideways-lr|<svg-writing-mode>",
    "z-index": "auto|<integer>",
    zoom: "normal|reset|<number>|<percentage>",
    "-moz-background-clip": "padding|border",
    "-moz-border-radius-bottomleft": "<'border-bottom-left-radius'>",
    "-moz-border-radius-bottomright": "<'border-bottom-right-radius'>",
    "-moz-border-radius-topleft": "<'border-top-left-radius'>",
    "-moz-border-radius-topright": "<'border-bottom-right-radius'>",
    "-moz-control-character-visibility": "visible|hidden",
    "-moz-osx-font-smoothing": "auto|grayscale",
    "-moz-user-select": "none|text|all|-moz-none",
    "-ms-flex-align": "start|end|center|baseline|stretch",
    "-ms-flex-item-align": "auto|start|end|center|baseline|stretch",
    "-ms-flex-line-pack": "start|end|center|justify|distribute|stretch",
    "-ms-flex-negative": "<'flex-shrink'>",
    "-ms-flex-pack": "start|end|center|justify|distribute",
    "-ms-flex-order": "<integer>",
    "-ms-flex-positive": "<'flex-grow'>",
    "-ms-flex-preferred-size": "<'flex-basis'>",
    "-ms-interpolation-mode": "nearest-neighbor|bicubic",
    "-ms-grid-column-align": "start|end|center|stretch",
    "-ms-grid-row-align": "start|end|center|stretch",
    "-ms-hyphenate-limit-last": "none|always|column|page|spread",
    "-webkit-background-clip": "[<box>|border|padding|content|text]#",
    "-webkit-column-break-after": "always|auto|avoid",
    "-webkit-column-break-before": "always|auto|avoid",
    "-webkit-column-break-inside": "always|auto|avoid",
    "-webkit-font-smoothing": "auto|none|antialiased|subpixel-antialiased",
    "-webkit-mask-box-image": "[<url>|<gradient>|none] [<length-percentage>{4} <-webkit-mask-box-repeat>{2}]?",
    "-webkit-print-color-adjust": "economy|exact",
    "-webkit-text-security": "none|circle|disc|square",
    "-webkit-user-drag": "none|element|auto",
    "-webkit-user-select": "auto|none|text|all",
    "alignment-baseline": "auto|baseline|before-edge|text-before-edge|middle|central|after-edge|text-after-edge|ideographic|alphabetic|hanging|mathematical",
    "baseline-shift": "baseline|sub|super|<svg-length>",
    behavior: "<url>+",
    "clip-rule": "nonzero|evenodd",
    cue: "<'cue-before'> <'cue-after'>?",
    "cue-after": "<url> <decibel>?|none",
    "cue-before": "<url> <decibel>?|none",
    "dominant-baseline": "auto|use-script|no-change|reset-size|ideographic|alphabetic|hanging|mathematical|central|middle|text-after-edge|text-before-edge",
    fill: "<paint>",
    "fill-opacity": "<number-zero-one>",
    "fill-rule": "nonzero|evenodd",
    "glyph-orientation-horizontal": "<angle>",
    "glyph-orientation-vertical": "<angle>",
    kerning: "auto|<svg-length>",
    marker: "none|<url>",
    "marker-end": "none|<url>",
    "marker-mid": "none|<url>",
    "marker-start": "none|<url>",
    pause: "<'pause-before'> <'pause-after'>?",
    "pause-after": "<time>|none|x-weak|weak|medium|strong|x-strong",
    "pause-before": "<time>|none|x-weak|weak|medium|strong|x-strong",
    rest: "<'rest-before'> <'rest-after'>?",
    "rest-after": "<time>|none|x-weak|weak|medium|strong|x-strong",
    "rest-before": "<time>|none|x-weak|weak|medium|strong|x-strong",
    "shape-rendering": "auto|optimizeSpeed|crispEdges|geometricPrecision",
    src: "[<url> [format( <string># )]?|local( <family-name> )]#",
    speak: "auto|none|normal",
    "speak-as": "normal|spell-out||digits||[literal-punctuation|no-punctuation]",
    stroke: "<paint>",
    "stroke-dasharray": "none|[<svg-length>+]#",
    "stroke-dashoffset": "<svg-length>",
    "stroke-linecap": "butt|round|square",
    "stroke-linejoin": "miter|round|bevel",
    "stroke-miterlimit": "<number-one-or-greater>",
    "stroke-opacity": "<number-zero-one>",
    "stroke-width": "<svg-length>",
    "text-anchor": "start|middle|end",
    "unicode-range": "<urange>#",
    "voice-balance": "<number>|left|center|right|leftwards|rightwards",
    "voice-duration": "auto|<time>",
    "voice-family": "[[<family-name>|<generic-voice>] ,]* [<family-name>|<generic-voice>]|preserve",
    "voice-pitch": "<frequency>&&absolute|[[x-low|low|medium|high|x-high]||[<frequency>|<semitones>|<percentage>]]",
    "voice-range": "<frequency>&&absolute|[[x-low|low|medium|high|x-high]||[<frequency>|<semitones>|<percentage>]]",
    "voice-rate": "[normal|x-slow|slow|medium|fast|x-fast]||<percentage>",
    "voice-stress": "normal|strong|moderate|none|reduced",
    "voice-volume": "silent|[[x-soft|soft|medium|loud|x-loud]||<decibel>]"
  },
  atrules: {
    charset: {
      prelude: "<string>",
      descriptors: null
    },
    "counter-style": {
      prelude: "<counter-style-name>",
      descriptors: {
        "additive-symbols": "[<integer>&&<symbol>]#",
        fallback: "<counter-style-name>",
        negative: "<symbol> <symbol>?",
        pad: "<integer>&&<symbol>",
        prefix: "<symbol>",
        range: "[[<integer>|infinite]{2}]#|auto",
        "speak-as": "auto|bullets|numbers|words|spell-out|<counter-style-name>",
        suffix: "<symbol>",
        symbols: "<symbol>+",
        system: "cyclic|numeric|alphabetic|symbolic|additive|[fixed <integer>?]|[extends <counter-style-name>]"
      }
    },
    document: {
      prelude: "[<url>|url-prefix( <string> )|domain( <string> )|media-document( <string> )|regexp( <string> )]#",
      descriptors: null
    },
    "font-face": {
      prelude: null,
      descriptors: {
        "ascent-override": "normal|<percentage>",
        "descent-override": "normal|<percentage>",
        "font-display": "[auto|block|swap|fallback|optional]",
        "font-family": "<family-name>",
        "font-feature-settings": "normal|<feature-tag-value>#",
        "font-variation-settings": "normal|[<string> <number>]#",
        "font-stretch": "<font-stretch-absolute>{1,2}",
        "font-style": "normal|italic|oblique <angle>{0,2}",
        "font-weight": "<font-weight-absolute>{1,2}",
        "font-variant": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>||stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )||[small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps]||<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero||<east-asian-variant-values>||<east-asian-width-values>||ruby]",
        "line-gap-override": "normal|<percentage>",
        "size-adjust": "<percentage>",
        src: "[<url> [format( <string># )]?|local( <family-name> )]#",
        "unicode-range": "<urange>#"
      }
    },
    "font-feature-values": {
      prelude: "<family-name>#",
      descriptors: null
    },
    import: {
      prelude: "[<string>|<url>] [layer|layer( <layer-name> )]? [supports( [<supports-condition>|<declaration>] )]? <media-query-list>?",
      descriptors: null
    },
    keyframes: {
      prelude: "<keyframes-name>",
      descriptors: null
    },
    layer: {
      prelude: "[<layer-name>#|<layer-name>?]",
      descriptors: null
    },
    media: {
      prelude: "<media-query-list>",
      descriptors: null
    },
    namespace: {
      prelude: "<namespace-prefix>? [<string>|<url>]",
      descriptors: null
    },
    page: {
      prelude: "<page-selector-list>",
      descriptors: {
        bleed: "auto|<length>",
        marks: "none|[crop||cross]",
        size: "<length>{1,2}|auto|[<page-size>||[portrait|landscape]]"
      }
    },
    property: {
      prelude: "<custom-property-name>",
      descriptors: {
        syntax: "<string>",
        inherits: "true|false",
        "initial-value": "<string>"
      }
    },
    "scroll-timeline": {
      prelude: "<timeline-name>",
      descriptors: null
    },
    supports: {
      prelude: "<supports-condition>",
      descriptors: null
    },
    viewport: {
      prelude: null,
      descriptors: {
        height: "<viewport-length>{1,2}",
        "max-height": "<viewport-length>",
        "max-width": "<viewport-length>",
        "max-zoom": "auto|<number>|<percentage>",
        "min-height": "<viewport-length>",
        "min-width": "<viewport-length>",
        "min-zoom": "auto|<number>|<percentage>",
        orientation: "auto|portrait|landscape",
        "user-zoom": "zoom|fixed",
        "viewport-fit": "auto|contain|cover",
        width: "<viewport-length>{1,2}",
        zoom: "auto|<number>|<percentage>"
      }
    }
  }
}, o0 = {}, G2 = {};
const B0 = I, Rh = m0, V1 = 43, l1 = 45, Qr = 110, Ge = !0, CQ = !1;
function Jr(e, t) {
  let r = this.tokenStart + e;
  const n = this.charCodeAt(r);
  for ((n === V1 || n === l1) && (t && this.error("Number sign is not allowed"), r++); r < this.tokenEnd; r++)
    Rh.isDigit(this.charCodeAt(r)) || this.error("Integer is expected", r);
}
function Xt(e) {
  return Jr.call(this, 0, e);
}
function ye(e, t) {
  if (!this.cmpChar(this.tokenStart + e, t)) {
    let r = "";
    switch (t) {
      case Qr:
        r = "N is expected";
        break;
      case l1:
        r = "HyphenMinus is expected";
        break;
    }
    this.error(r, this.tokenStart + e);
  }
}
function Cn() {
  let e = 0, t = 0, r = this.tokenType;
  for (; r === B0.WhiteSpace || r === B0.Comment; )
    r = this.lookupType(++e);
  if (r !== B0.Number)
    if (this.isDelim(V1, e) || this.isDelim(l1, e)) {
      t = this.isDelim(V1, e) ? V1 : l1;
      do
        r = this.lookupType(++e);
      while (r === B0.WhiteSpace || r === B0.Comment);
      r !== B0.Number && (this.skip(e), Xt.call(this, Ge));
    } else
      return null;
  return e > 0 && this.skip(e), t === 0 && (r = this.charCodeAt(this.tokenStart), r !== V1 && r !== l1 && this.error("Number sign is expected")), Xt.call(this, t !== 0), t === l1 ? "-" + this.consume(B0.Number) : this.consume(B0.Number);
}
const SQ = "AnPlusB", $Q = {
  a: [String, null],
  b: [String, null]
};
function AQ() {
  const e = this.tokenStart;
  let t = null, r = null;
  if (this.tokenType === B0.Number)
    Xt.call(this, CQ), r = this.consume(B0.Number);
  else if (this.tokenType === B0.Ident && this.cmpChar(this.tokenStart, l1))
    switch (t = "-1", ye.call(this, 1, Qr), this.tokenEnd - this.tokenStart) {
      case 2:
        this.next(), r = Cn.call(this);
        break;
      case 3:
        ye.call(this, 2, l1), this.next(), this.skipSC(), Xt.call(this, Ge), r = "-" + this.consume(B0.Number);
        break;
      default:
        ye.call(this, 2, l1), Jr.call(this, 3, Ge), this.next(), r = this.substrToCursor(e + 2);
    }
  else if (this.tokenType === B0.Ident || this.isDelim(V1) && this.lookupType(1) === B0.Ident) {
    let n = 0;
    switch (t = "1", this.isDelim(V1) && (n = 1, this.next()), ye.call(this, 0, Qr), this.tokenEnd - this.tokenStart) {
      case 1:
        this.next(), r = Cn.call(this);
        break;
      case 2:
        ye.call(this, 1, l1), this.next(), this.skipSC(), Xt.call(this, Ge), r = "-" + this.consume(B0.Number);
        break;
      default:
        ye.call(this, 1, l1), Jr.call(this, 2, Ge), this.next(), r = this.substrToCursor(e + n + 1);
    }
  } else if (this.tokenType === B0.Dimension) {
    const n = this.charCodeAt(this.tokenStart), o = n === V1 || n === l1;
    let s = this.tokenStart + o;
    for (; s < this.tokenEnd && Rh.isDigit(this.charCodeAt(s)); s++)
      ;
    s === this.tokenStart + o && this.error("Integer is expected", this.tokenStart + o), ye.call(this, s - this.tokenStart, Qr), t = this.substring(e, s), s + 1 === this.tokenEnd ? (this.next(), r = Cn.call(this)) : (ye.call(this, s - this.tokenStart + 1, l1), s + 2 === this.tokenEnd ? (this.next(), this.skipSC(), Xt.call(this, Ge), r = "-" + this.consume(B0.Number)) : (Jr.call(this, s - this.tokenStart + 2, Ge), this.next(), r = this.substrToCursor(s + 1)));
  } else
    this.error();
  return t !== null && t.charCodeAt(0) === V1 && (t = t.substr(1)), r !== null && r.charCodeAt(0) === V1 && (r = r.substr(1)), {
    type: "AnPlusB",
    loc: this.getLocation(e, this.tokenStart),
    a: t,
    b: r
  };
}
function MQ(e) {
  if (e.a) {
    const t = e.a === "+1" && "n" || e.a === "1" && "n" || e.a === "-1" && "-n" || e.a + "n";
    if (e.b) {
      const r = e.b[0] === "-" || e.b[0] === "+" ? e.b : "+" + e.b;
      this.tokenize(t + r);
    } else
      this.tokenize(t);
  } else
    this.tokenize(e.b);
}
G2.generate = MQ;
G2.name = SQ;
G2.parse = AQ;
G2.structure = $Q;
var kt = {};
const X1 = I;
function m6(e) {
  return this.Raw(e, this.consumeUntilLeftCurlyBracketOrSemicolon, !0);
}
function jQ() {
  for (let e = 1, t; t = this.lookupType(e); e++) {
    if (t === X1.RightCurlyBracket)
      return !0;
    if (t === X1.LeftCurlyBracket || t === X1.AtKeyword)
      return !1;
  }
  return !1;
}
const EQ = "Atrule", TQ = "atrule", PQ = {
  name: String,
  prelude: ["AtrulePrelude", "Raw", null],
  block: ["Block", null]
};
function NQ() {
  const e = this.tokenStart;
  let t, r, n = null, o = null;
  switch (this.eat(X1.AtKeyword), t = this.substrToCursor(e + 1), r = t.toLowerCase(), this.skipSC(), this.eof === !1 && this.tokenType !== X1.LeftCurlyBracket && this.tokenType !== X1.Semicolon && (this.parseAtrulePrelude ? n = this.parseWithFallback(this.AtrulePrelude.bind(this, t), m6) : n = m6.call(this, this.tokenIndex), this.skipSC()), this.tokenType) {
    case X1.Semicolon:
      this.next();
      break;
    case X1.LeftCurlyBracket:
      hasOwnProperty.call(this.atrule, r) && typeof this.atrule[r].block == "function" ? o = this.atrule[r].block.call(this) : o = this.Block(jQ.call(this));
      break;
  }
  return {
    type: "Atrule",
    loc: this.getLocation(e, this.tokenStart),
    name: t,
    prelude: n,
    block: o
  };
}
function DQ(e) {
  this.token(X1.AtKeyword, "@" + e.name), e.prelude !== null && this.node(e.prelude), e.block ? this.node(e.block) : this.token(X1.Semicolon, ";");
}
kt.generate = DQ;
kt.name = EQ;
kt.parse = NQ;
kt.structure = PQ;
kt.walkContext = TQ;
var vt = {};
const f6 = I, OQ = "AtrulePrelude", RQ = "atrulePrelude", IQ = {
  children: [[]]
};
function _Q(e) {
  let t = null;
  return e !== null && (e = e.toLowerCase()), this.skipSC(), hasOwnProperty.call(this.atrule, e) && typeof this.atrule[e].prelude == "function" ? t = this.atrule[e].prelude.call(this) : t = this.readSequence(this.scope.AtrulePrelude), this.skipSC(), this.eof !== !0 && this.tokenType !== f6.LeftCurlyBracket && this.tokenType !== f6.Semicolon && this.error("Semicolon or block is expected"), {
    type: "AtrulePrelude",
    loc: this.getLocationFromList(t),
    children: t
  };
}
function FQ(e) {
  this.children(e);
}
vt.generate = FQ;
vt.name = OQ;
vt.parse = _Q;
vt.structure = IQ;
vt.walkContext = RQ;
var W2 = {};
const C1 = I, BQ = 36, Ih = 42, e8 = 61, ZQ = 94, Ho = 124, qQ = 126;
function UQ() {
  this.eof && this.error("Unexpected end of input");
  const e = this.tokenStart;
  let t = !1;
  return this.isDelim(Ih) ? (t = !0, this.next()) : this.isDelim(Ho) || this.eat(C1.Ident), this.isDelim(Ho) ? this.charCodeAt(this.tokenStart + 1) !== e8 ? (this.next(), this.eat(C1.Ident)) : t && this.error("Identifier is expected", this.tokenEnd) : t && this.error("Vertical line is expected"), {
    type: "Identifier",
    loc: this.getLocation(e, this.tokenStart),
    name: this.substrToCursor(e)
  };
}
function HQ() {
  const e = this.tokenStart, t = this.charCodeAt(e);
  return t !== e8 && t !== qQ && t !== ZQ && t !== BQ && t !== Ih && t !== Ho && this.error("Attribute selector (=, ~=, ^=, $=, *=, |=) is expected"), this.next(), t !== e8 && (this.isDelim(e8) || this.error("Equal sign is expected"), this.next()), this.substrToCursor(e);
}
const GQ = "AttributeSelector", WQ = {
  name: "Identifier",
  matcher: [String, null],
  value: ["String", "Identifier", null],
  flags: [String, null]
};
function VQ() {
  const e = this.tokenStart;
  let t, r = null, n = null, o = null;
  return this.eat(C1.LeftSquareBracket), this.skipSC(), t = UQ.call(this), this.skipSC(), this.tokenType !== C1.RightSquareBracket && (this.tokenType !== C1.Ident && (r = HQ.call(this), this.skipSC(), n = this.tokenType === C1.String ? this.String() : this.Identifier(), this.skipSC()), this.tokenType === C1.Ident && (o = this.consume(C1.Ident), this.skipSC())), this.eat(C1.RightSquareBracket), {
    type: "AttributeSelector",
    loc: this.getLocation(e, this.tokenStart),
    name: t,
    matcher: r,
    value: n,
    flags: o
  };
}
function XQ(e) {
  this.token(C1.Delim, "["), this.node(e.name), e.matcher !== null && (this.tokenize(e.matcher), this.node(e.value)), e.flags !== null && this.token(C1.Ident, e.flags), this.token(C1.Delim, "]");
}
W2.generate = XQ;
W2.name = GQ;
W2.parse = VQ;
W2.structure = WQ;
var yt = {};
const O1 = I;
function _h(e) {
  return this.Raw(e, null, !0);
}
function YQ() {
  return this.parseWithFallback(this.Rule, _h);
}
function d6(e) {
  return this.Raw(e, this.consumeUntilSemicolonIncluded, !0);
}
function KQ() {
  if (this.tokenType === O1.Semicolon)
    return d6.call(this, this.tokenIndex);
  const e = this.parseWithFallback(this.Declaration, d6);
  return this.tokenType === O1.Semicolon && this.next(), e;
}
const QQ = "Block", JQ = "block", eJ = {
  children: [[
    "Atrule",
    "Rule",
    "Declaration"
  ]]
};
function tJ(e) {
  const t = e ? KQ : YQ, r = this.tokenStart;
  let n = this.createList();
  this.eat(O1.LeftCurlyBracket);
  e:
    for (; !this.eof; )
      switch (this.tokenType) {
        case O1.RightCurlyBracket:
          break e;
        case O1.WhiteSpace:
        case O1.Comment:
          this.next();
          break;
        case O1.AtKeyword:
          n.push(this.parseWithFallback(this.Atrule, _h));
          break;
        default:
          n.push(t.call(this));
      }
  return this.eof || this.eat(O1.RightCurlyBracket), {
    type: "Block",
    loc: this.getLocation(r, this.tokenStart),
    children: n
  };
}
function rJ(e) {
  this.token(O1.LeftCurlyBracket, "{"), this.children(e, (t) => {
    t.type === "Declaration" && this.token(O1.Semicolon, ";");
  }), this.token(O1.RightCurlyBracket, "}");
}
yt.generate = rJ;
yt.name = QQ;
yt.parse = tJ;
yt.structure = eJ;
yt.walkContext = JQ;
var V2 = {};
const C8 = I, nJ = "Brackets", oJ = {
  children: [[]]
};
function sJ(e, t) {
  const r = this.tokenStart;
  let n = null;
  return this.eat(C8.LeftSquareBracket), n = e.call(this, t), this.eof || this.eat(C8.RightSquareBracket), {
    type: "Brackets",
    loc: this.getLocation(r, this.tokenStart),
    children: n
  };
}
function iJ(e) {
  this.token(C8.Delim, "["), this.children(e), this.token(C8.Delim, "]");
}
V2.generate = iJ;
V2.name = nJ;
V2.parse = sJ;
V2.structure = oJ;
var X2 = {};
const Fh = I, aJ = "CDC", lJ = [];
function cJ() {
  const e = this.tokenStart;
  return this.eat(Fh.CDC), {
    type: "CDC",
    loc: this.getLocation(e, this.tokenStart)
  };
}
function uJ() {
  this.token(Fh.CDC, "-->");
}
X2.generate = uJ;
X2.name = aJ;
X2.parse = cJ;
X2.structure = lJ;
var Y2 = {};
const Bh = I, hJ = "CDO", mJ = [];
function fJ() {
  const e = this.tokenStart;
  return this.eat(Bh.CDO), {
    type: "CDO",
    loc: this.getLocation(e, this.tokenStart)
  };
}
function dJ() {
  this.token(Bh.CDO, "<!--");
}
Y2.generate = dJ;
Y2.name = hJ;
Y2.parse = fJ;
Y2.structure = mJ;
var K2 = {};
const Go = I, pJ = 46, gJ = "ClassSelector", kJ = {
  name: String
};
function vJ() {
  return this.eatDelim(pJ), {
    type: "ClassSelector",
    loc: this.getLocation(this.tokenStart - 1, this.tokenEnd),
    name: this.consume(Go.Ident)
  };
}
function yJ(e) {
  this.token(Go.Delim, "."), this.token(Go.Ident, e.name);
}
K2.generate = yJ;
K2.name = gJ;
K2.parse = vJ;
K2.structure = kJ;
var Q2 = {};
const p6 = I, bJ = 43, g6 = 47, xJ = 62, wJ = 126, LJ = "Combinator", zJ = {
  name: String
};
function CJ() {
  const e = this.tokenStart;
  let t;
  switch (this.tokenType) {
    case p6.WhiteSpace:
      t = " ";
      break;
    case p6.Delim:
      switch (this.charCodeAt(this.tokenStart)) {
        case xJ:
        case bJ:
        case wJ:
          this.next();
          break;
        case g6:
          this.next(), this.eatIdent("deep"), this.eatDelim(g6);
          break;
        default:
          this.error("Combinator is expected");
      }
      t = this.substrToCursor(e);
      break;
  }
  return {
    type: "Combinator",
    loc: this.getLocation(e, this.tokenStart),
    name: t
  };
}
function SJ(e) {
  this.tokenize(e.name);
}
Q2.generate = SJ;
Q2.name = LJ;
Q2.parse = CJ;
Q2.structure = zJ;
var J2 = {};
const Zh = I, $J = 42, AJ = 47, MJ = "Comment", jJ = {
  value: String
};
function EJ() {
  const e = this.tokenStart;
  let t = this.tokenEnd;
  return this.eat(Zh.Comment), t - e + 2 >= 2 && this.charCodeAt(t - 2) === $J && this.charCodeAt(t - 1) === AJ && (t -= 2), {
    type: "Comment",
    loc: this.getLocation(e, this.tokenStart),
    value: this.substring(e + 2, t)
  };
}
function TJ(e) {
  this.token(Zh.Comment, "/*" + e.value + "*/");
}
J2.generate = TJ;
J2.name = MJ;
J2.parse = EJ;
J2.structure = jJ;
var bt = {};
const PJ = gt, n1 = I, qh = 33, NJ = 35, DJ = 36, OJ = 38, RJ = 42, IJ = 43, k6 = 47;
function _J(e) {
  return this.Raw(e, this.consumeUntilExclamationMarkOrSemicolon, !0);
}
function FJ(e) {
  return this.Raw(e, this.consumeUntilExclamationMarkOrSemicolon, !1);
}
function BJ() {
  const e = this.tokenIndex, t = this.Value();
  return t.type !== "Raw" && this.eof === !1 && this.tokenType !== n1.Semicolon && this.isDelim(qh) === !1 && this.isBalanceEdge(e) === !1 && this.error(), t;
}
const ZJ = "Declaration", qJ = "declaration", UJ = {
  important: [Boolean, String],
  property: String,
  value: ["Value", "Raw"]
};
function HJ() {
  const e = this.tokenStart, t = this.tokenIndex, r = WJ.call(this), n = PJ.isCustomProperty(r), o = n ? this.parseCustomProperty : this.parseValue, s = n ? FJ : _J;
  let i = !1, l;
  this.skipSC(), this.eat(n1.Colon);
  const c = this.tokenIndex;
  if (n || this.skipSC(), o ? l = this.parseWithFallback(BJ, s) : l = s.call(this, this.tokenIndex), n && l.type === "Value" && l.children.isEmpty) {
    for (let a = c - this.tokenIndex; a <= 0; a++)
      if (this.lookupType(a) === n1.WhiteSpace) {
        l.children.appendData({
          type: "WhiteSpace",
          loc: null,
          value: " "
        });
        break;
      }
  }
  return this.isDelim(qh) && (i = VJ.call(this), this.skipSC()), this.eof === !1 && this.tokenType !== n1.Semicolon && this.isBalanceEdge(t) === !1 && this.error(), {
    type: "Declaration",
    loc: this.getLocation(e, this.tokenStart),
    important: i,
    property: r,
    value: l
  };
}
function GJ(e) {
  this.token(n1.Ident, e.property), this.token(n1.Colon, ":"), this.node(e.value), e.important && (this.token(n1.Delim, "!"), this.token(n1.Ident, e.important === !0 ? "important" : e.important));
}
function WJ() {
  const e = this.tokenStart;
  if (this.tokenType === n1.Delim)
    switch (this.charCodeAt(this.tokenStart)) {
      case RJ:
      case DJ:
      case IJ:
      case NJ:
      case OJ:
        this.next();
        break;
      case k6:
        this.next(), this.isDelim(k6) && this.next();
        break;
    }
  return this.tokenType === n1.Hash ? this.eat(n1.Hash) : this.eat(n1.Ident), this.substrToCursor(e);
}
function VJ() {
  this.eat(n1.Delim), this.skipSC();
  const e = this.consume(n1.Ident);
  return e === "important" ? !0 : e;
}
bt.generate = GJ;
bt.name = ZJ;
bt.parse = HJ;
bt.structure = UJ;
bt.walkContext = qJ;
var e3 = {};
const t8 = I;
function XJ(e) {
  return this.Raw(e, this.consumeUntilSemicolonIncluded, !0);
}
const YJ = "DeclarationList", KJ = {
  children: [[
    "Declaration"
  ]]
};
function QJ() {
  const e = this.createList();
  for (; !this.eof; )
    switch (this.tokenType) {
      case t8.WhiteSpace:
      case t8.Comment:
      case t8.Semicolon:
        this.next();
        break;
      default:
        e.push(this.parseWithFallback(this.Declaration, XJ));
    }
  return {
    type: "DeclarationList",
    loc: this.getLocationFromList(e),
    children: e
  };
}
function JJ(e) {
  this.children(e, (t) => {
    t.type === "Declaration" && this.token(t8.Semicolon, ";");
  });
}
e3.generate = JJ;
e3.name = YJ;
e3.parse = QJ;
e3.structure = KJ;
var t3 = {};
const Uh = I, e00 = "Dimension", t00 = {
  value: String,
  unit: String
};
function r00() {
  const e = this.tokenStart, t = this.consumeNumber(Uh.Dimension);
  return {
    type: "Dimension",
    loc: this.getLocation(e, this.tokenStart),
    value: t,
    unit: this.substring(e + t.length, this.tokenStart)
  };
}
function n00(e) {
  this.token(Uh.Dimension, e.value + e.unit);
}
t3.generate = n00;
t3.name = e00;
t3.parse = r00;
t3.structure = t00;
var xt = {};
const Wo = I, o00 = "Function", s00 = "function", i00 = {
  name: String,
  children: [[]]
};
function a00(e, t) {
  const r = this.tokenStart, n = this.consumeFunctionName(), o = n.toLowerCase();
  let s;
  return s = t.hasOwnProperty(o) ? t[o].call(this, t) : e.call(this, t), this.eof || this.eat(Wo.RightParenthesis), {
    type: "Function",
    loc: this.getLocation(r, this.tokenStart),
    name: n,
    children: s
  };
}
function l00(e) {
  this.token(Wo.Function, e.name + "("), this.children(e), this.token(Wo.RightParenthesis, ")");
}
xt.generate = l00;
xt.name = o00;
xt.parse = a00;
xt.structure = i00;
xt.walkContext = s00;
var wt = {};
const Hh = I, c00 = "XXX", u00 = "Hash", h00 = {
  value: String
};
function m00() {
  const e = this.tokenStart;
  return this.eat(Hh.Hash), {
    type: "Hash",
    loc: this.getLocation(e, this.tokenStart),
    value: this.substrToCursor(e + 1)
  };
}
function f00(e) {
  this.token(Hh.Hash, "#" + e.value);
}
wt.generate = f00;
wt.name = u00;
wt.parse = m00;
wt.structure = h00;
wt.xxx = c00;
var r3 = {};
const Gh = I, d00 = "Identifier", p00 = {
  name: String
};
function g00() {
  return {
    type: "Identifier",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    name: this.consume(Gh.Ident)
  };
}
function k00(e) {
  this.token(Gh.Ident, e.name);
}
r3.generate = k00;
r3.name = d00;
r3.parse = g00;
r3.structure = p00;
var n3 = {};
const Wh = I, v00 = "IdSelector", y00 = {
  name: String
};
function b00() {
  const e = this.tokenStart;
  return this.eat(Wh.Hash), {
    type: "IdSelector",
    loc: this.getLocation(e, this.tokenStart),
    name: this.substrToCursor(e + 1)
  };
}
function x00(e) {
  this.token(Wh.Delim, "#" + e.name);
}
n3.generate = x00;
n3.name = v00;
n3.parse = b00;
n3.structure = y00;
var o3 = {};
const i1 = I, w00 = "MediaFeature", L00 = {
  name: String,
  value: ["Identifier", "Number", "Dimension", "Ratio", null]
};
function z00() {
  const e = this.tokenStart;
  let t, r = null;
  if (this.eat(i1.LeftParenthesis), this.skipSC(), t = this.consume(i1.Ident), this.skipSC(), this.tokenType !== i1.RightParenthesis) {
    switch (this.eat(i1.Colon), this.skipSC(), this.tokenType) {
      case i1.Number:
        this.lookupNonWSType(1) === i1.Delim ? r = this.Ratio() : r = this.Number();
        break;
      case i1.Dimension:
        r = this.Dimension();
        break;
      case i1.Ident:
        r = this.Identifier();
        break;
      default:
        this.error("Number, dimension, ratio or identifier is expected");
    }
    this.skipSC();
  }
  return this.eat(i1.RightParenthesis), {
    type: "MediaFeature",
    loc: this.getLocation(e, this.tokenStart),
    name: t,
    value: r
  };
}
function C00(e) {
  this.token(i1.LeftParenthesis, "("), this.token(i1.Ident, e.name), e.value !== null && (this.token(i1.Colon, ":"), this.node(e.value)), this.token(i1.RightParenthesis, ")");
}
o3.generate = C00;
o3.name = w00;
o3.parse = z00;
o3.structure = L00;
var s3 = {};
const Er = I, S00 = "MediaQuery", $00 = {
  children: [[
    "Identifier",
    "MediaFeature",
    "WhiteSpace"
  ]]
};
function A00() {
  const e = this.createList();
  let t = null;
  this.skipSC();
  e:
    for (; !this.eof; ) {
      switch (this.tokenType) {
        case Er.Comment:
        case Er.WhiteSpace:
          this.next();
          continue;
        case Er.Ident:
          t = this.Identifier();
          break;
        case Er.LeftParenthesis:
          t = this.MediaFeature();
          break;
        default:
          break e;
      }
      e.push(t);
    }
  return t === null && this.error("Identifier or parenthesis is expected"), {
    type: "MediaQuery",
    loc: this.getLocationFromList(e),
    children: e
  };
}
function M00(e) {
  this.children(e);
}
s3.generate = M00;
s3.name = S00;
s3.parse = A00;
s3.structure = $00;
var i3 = {};
const Vh = I, j00 = "MediaQueryList", E00 = {
  children: [[
    "MediaQuery"
  ]]
};
function T00() {
  const e = this.createList();
  for (this.skipSC(); !this.eof && (e.push(this.MediaQuery()), this.tokenType === Vh.Comma); )
    this.next();
  return {
    type: "MediaQueryList",
    loc: this.getLocationFromList(e),
    children: e
  };
}
function P00(e) {
  this.children(e, () => this.token(Vh.Comma, ","));
}
i3.generate = P00;
i3.name = j00;
i3.parse = T00;
i3.structure = E00;
var a3 = {};
const N00 = I, D00 = "Nth", O00 = {
  nth: ["AnPlusB", "Identifier"],
  selector: ["SelectorList", null]
};
function R00() {
  this.skipSC();
  const e = this.tokenStart;
  let t = e, r = null, n;
  return this.lookupValue(0, "odd") || this.lookupValue(0, "even") ? n = this.Identifier() : n = this.AnPlusB(), t = this.tokenStart, this.skipSC(), this.lookupValue(0, "of") && (this.next(), r = this.SelectorList(), t = this.tokenStart), {
    type: "Nth",
    loc: this.getLocation(e, t),
    nth: n,
    selector: r
  };
}
function I00(e) {
  this.node(e.nth), e.selector !== null && (this.token(N00.Ident, "of"), this.node(e.selector));
}
a3.generate = I00;
a3.name = D00;
a3.parse = R00;
a3.structure = O00;
var l3 = {};
const Xh = I, _00 = "Number", F00 = {
  value: String
};
function B00() {
  return {
    type: "Number",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    value: this.consume(Xh.Number)
  };
}
function Z00(e) {
  this.token(Xh.Number, e.value);
}
l3.generate = Z00;
l3.name = _00;
l3.parse = B00;
l3.structure = F00;
var c3 = {};
const q00 = "Operator", U00 = {
  value: String
};
function H00() {
  const e = this.tokenStart;
  return this.next(), {
    type: "Operator",
    loc: this.getLocation(e, this.tokenStart),
    value: this.substrToCursor(e)
  };
}
function G00(e) {
  this.tokenize(e.value);
}
c3.generate = G00;
c3.name = q00;
c3.parse = H00;
c3.structure = U00;
var u3 = {};
const S8 = I, W00 = "Parentheses", V00 = {
  children: [[]]
};
function X00(e, t) {
  const r = this.tokenStart;
  let n = null;
  return this.eat(S8.LeftParenthesis), n = e.call(this, t), this.eof || this.eat(S8.RightParenthesis), {
    type: "Parentheses",
    loc: this.getLocation(r, this.tokenStart),
    children: n
  };
}
function Y00(e) {
  this.token(S8.LeftParenthesis, "("), this.children(e), this.token(S8.RightParenthesis, ")");
}
u3.generate = Y00;
u3.name = W00;
u3.parse = X00;
u3.structure = V00;
var h3 = {};
const Yh = I, K00 = "Percentage", Q00 = {
  value: String
};
function J00() {
  return {
    type: "Percentage",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    value: this.consumeNumber(Yh.Percentage)
  };
}
function e10(e) {
  this.token(Yh.Percentage, e.value + "%");
}
h3.generate = e10;
h3.name = K00;
h3.parse = J00;
h3.structure = Q00;
var Lt = {};
const je = I, t10 = "PseudoClassSelector", r10 = "function", n10 = {
  name: String,
  children: [["Raw"], null]
};
function o10() {
  const e = this.tokenStart;
  let t = null, r, n;
  return this.eat(je.Colon), this.tokenType === je.Function ? (r = this.consumeFunctionName(), n = r.toLowerCase(), hasOwnProperty.call(this.pseudo, n) ? (this.skipSC(), t = this.pseudo[n].call(this), this.skipSC()) : (t = this.createList(), t.push(
    this.Raw(this.tokenIndex, null, !1)
  )), this.eat(je.RightParenthesis)) : r = this.consume(je.Ident), {
    type: "PseudoClassSelector",
    loc: this.getLocation(e, this.tokenStart),
    name: r,
    children: t
  };
}
function s10(e) {
  this.token(je.Colon, ":"), e.children === null ? this.token(je.Ident, e.name) : (this.token(je.Function, e.name + "("), this.children(e), this.token(je.RightParenthesis, ")"));
}
Lt.generate = s10;
Lt.name = t10;
Lt.parse = o10;
Lt.structure = n10;
Lt.walkContext = r10;
var zt = {};
const Y1 = I, i10 = "PseudoElementSelector", a10 = "function", l10 = {
  name: String,
  children: [["Raw"], null]
};
function c10() {
  const e = this.tokenStart;
  let t = null, r, n;
  return this.eat(Y1.Colon), this.eat(Y1.Colon), this.tokenType === Y1.Function ? (r = this.consumeFunctionName(), n = r.toLowerCase(), hasOwnProperty.call(this.pseudo, n) ? (this.skipSC(), t = this.pseudo[n].call(this), this.skipSC()) : (t = this.createList(), t.push(
    this.Raw(this.tokenIndex, null, !1)
  )), this.eat(Y1.RightParenthesis)) : r = this.consume(Y1.Ident), {
    type: "PseudoElementSelector",
    loc: this.getLocation(e, this.tokenStart),
    name: r,
    children: t
  };
}
function u10(e) {
  this.token(Y1.Colon, ":"), this.token(Y1.Colon, ":"), e.children === null ? this.token(Y1.Ident, e.name) : (this.token(Y1.Function, e.name + "("), this.children(e), this.token(Y1.RightParenthesis, ")"));
}
zt.generate = u10;
zt.name = i10;
zt.parse = c10;
zt.structure = l10;
zt.walkContext = a10;
var m3 = {};
const r8 = I, h10 = m0, m10 = 47, f10 = 46;
function v6() {
  this.skipSC();
  const e = this.consume(r8.Number);
  for (let t = 0; t < e.length; t++) {
    const r = e.charCodeAt(t);
    !h10.isDigit(r) && r !== f10 && this.error("Unsigned number is expected", this.tokenStart - e.length + t);
  }
  return Number(e) === 0 && this.error("Zero number is not allowed", this.tokenStart - e.length), e;
}
const d10 = "Ratio", p10 = {
  left: String,
  right: String
};
function g10() {
  const e = this.tokenStart, t = v6.call(this);
  let r;
  return this.skipSC(), this.eatDelim(m10), r = v6.call(this), {
    type: "Ratio",
    loc: this.getLocation(e, this.tokenStart),
    left: t,
    right: r
  };
}
function k10(e) {
  this.token(r8.Number, e.left), this.token(r8.Delim, "/"), this.token(r8.Number, e.right);
}
m3.generate = k10;
m3.name = d10;
m3.parse = g10;
m3.structure = p10;
var f3 = {};
const v10 = I;
function y10() {
  return this.tokenIndex > 0 && this.lookupType(-1) === v10.WhiteSpace ? this.tokenIndex > 1 ? this.getTokenStart(this.tokenIndex - 1) : this.firstCharOffset : this.tokenStart;
}
const b10 = "Raw", x10 = {
  value: String
};
function w10(e, t, r) {
  const n = this.getTokenStart(e);
  let o;
  return this.skipUntilBalanced(e, t || this.consumeUntilBalanceEnd), r && this.tokenStart > n ? o = y10.call(this) : o = this.tokenStart, {
    type: "Raw",
    loc: this.getLocation(n, o),
    value: this.substring(n, o)
  };
}
function L10(e) {
  this.tokenize(e.value);
}
f3.generate = L10;
f3.name = b10;
f3.parse = w10;
f3.structure = x10;
var Ct = {};
const z10 = I;
function y6(e) {
  return this.Raw(e, this.consumeUntilLeftCurlyBracket, !0);
}
function C10() {
  const e = this.SelectorList();
  return e.type !== "Raw" && this.eof === !1 && this.tokenType !== z10.LeftCurlyBracket && this.error(), e;
}
const S10 = "Rule", $10 = "rule", A10 = {
  prelude: ["SelectorList", "Raw"],
  block: ["Block"]
};
function M10() {
  const e = this.tokenIndex, t = this.tokenStart;
  let r, n;
  return this.parseRulePrelude ? r = this.parseWithFallback(C10, y6) : r = y6.call(this, e), n = this.Block(!0), {
    type: "Rule",
    loc: this.getLocation(t, this.tokenStart),
    prelude: r,
    block: n
  };
}
function j10(e) {
  this.node(e.prelude), this.node(e.block);
}
Ct.generate = j10;
Ct.name = S10;
Ct.parse = M10;
Ct.structure = A10;
Ct.walkContext = $10;
var d3 = {};
const E10 = "Selector", T10 = {
  children: [[
    "TypeSelector",
    "IdSelector",
    "ClassSelector",
    "AttributeSelector",
    "PseudoClassSelector",
    "PseudoElementSelector",
    "Combinator",
    "WhiteSpace"
  ]]
};
function P10() {
  const e = this.readSequence(this.scope.Selector);
  return this.getFirstListNode(e) === null && this.error("Selector is expected"), {
    type: "Selector",
    loc: this.getLocationFromList(e),
    children: e
  };
}
function N10(e) {
  this.children(e);
}
d3.generate = N10;
d3.name = E10;
d3.parse = P10;
d3.structure = T10;
var St = {};
const Kh = I, D10 = "SelectorList", O10 = "selector", R10 = {
  children: [[
    "Selector",
    "Raw"
  ]]
};
function I10() {
  const e = this.createList();
  for (; !this.eof; ) {
    if (e.push(this.Selector()), this.tokenType === Kh.Comma) {
      this.next();
      continue;
    }
    break;
  }
  return {
    type: "SelectorList",
    loc: this.getLocationFromList(e),
    children: e
  };
}
function _10(e) {
  this.children(e, () => this.token(Kh.Comma, ","));
}
St.generate = _10;
St.name = D10;
St.parse = I10;
St.structure = R10;
St.walkContext = O10;
var p3 = {}, F7 = {};
const Vo = m0, b6 = P0, Xo = 92, Qh = 34, Jh = 39;
function F10(e) {
  const t = e.length, r = e.charCodeAt(0), n = r === Qh || r === Jh ? 1 : 0, o = n === 1 && t > 1 && e.charCodeAt(t - 1) === r ? t - 2 : t - 1;
  let s = "";
  for (let i = n; i <= o; i++) {
    let l = e.charCodeAt(i);
    if (l === Xo) {
      if (i === o) {
        i !== t - 1 && (s = e.substr(i + 1));
        break;
      }
      if (l = e.charCodeAt(++i), Vo.isValidEscape(Xo, l)) {
        const c = i - 1, a = b6.consumeEscaped(e, c);
        i = a - 1, s += b6.decodeEscaped(e.substring(c + 1, a));
      } else
        l === 13 && e.charCodeAt(i + 1) === 10 && i++;
    } else
      s += e[i];
  }
  return s;
}
function B10(e, t) {
  const r = t ? "'" : '"', n = t ? Jh : Qh;
  let o = "", s = !1;
  for (let i = 0; i < e.length; i++) {
    const l = e.charCodeAt(i);
    if (l === 0) {
      o += "\uFFFD";
      continue;
    }
    if (l <= 31 || l === 127) {
      o += "\\" + l.toString(16), s = !0;
      continue;
    }
    l === n || l === Xo ? (o += "\\" + e.charAt(i), s = !1) : (s && (Vo.isHexDigit(l) || Vo.isWhiteSpace(l)) && (o += " "), o += e.charAt(i), s = !1);
  }
  return r + o + r;
}
F7.decode = F10;
F7.encode = B10;
const em = F7, tm = I, Z10 = "String", q10 = {
  value: String
};
function U10() {
  return {
    type: "String",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    value: em.decode(this.consume(tm.String))
  };
}
function H10(e) {
  this.token(tm.String, em.encode(e.value));
}
p3.generate = H10;
p3.name = Z10;
p3.parse = U10;
p3.structure = q10;
var $t = {};
const R3 = I, G10 = 33;
function x6(e) {
  return this.Raw(e, null, !1);
}
const W10 = "StyleSheet", V10 = "stylesheet", X10 = {
  children: [[
    "Comment",
    "CDO",
    "CDC",
    "Atrule",
    "Rule",
    "Raw"
  ]]
};
function Y10() {
  const e = this.tokenStart, t = this.createList();
  let r;
  for (; !this.eof; ) {
    switch (this.tokenType) {
      case R3.WhiteSpace:
        this.next();
        continue;
      case R3.Comment:
        if (this.charCodeAt(this.tokenStart + 2) !== G10) {
          this.next();
          continue;
        }
        r = this.Comment();
        break;
      case R3.CDO:
        r = this.CDO();
        break;
      case R3.CDC:
        r = this.CDC();
        break;
      case R3.AtKeyword:
        r = this.parseWithFallback(this.Atrule, x6);
        break;
      default:
        r = this.parseWithFallback(this.Rule, x6);
    }
    t.push(r);
  }
  return {
    type: "StyleSheet",
    loc: this.getLocation(e, this.tokenStart),
    children: t
  };
}
function K10(e) {
  this.children(e);
}
$t.generate = K10;
$t.name = W10;
$t.parse = Y10;
$t.structure = X10;
$t.walkContext = V10;
var g3 = {};
const Q10 = I, J10 = 42, w6 = 124;
function Sn() {
  this.tokenType !== Q10.Ident && this.isDelim(J10) === !1 && this.error("Identifier or asterisk is expected"), this.next();
}
const ee0 = "TypeSelector", te0 = {
  name: String
};
function re0() {
  const e = this.tokenStart;
  return this.isDelim(w6) ? (this.next(), Sn.call(this)) : (Sn.call(this), this.isDelim(w6) && (this.next(), Sn.call(this))), {
    type: "TypeSelector",
    loc: this.getLocation(e, this.tokenStart),
    name: this.substrToCursor(e)
  };
}
function ne0(e) {
  this.tokenize(e.name);
}
g3.generate = ne0;
g3.name = ee0;
g3.parse = re0;
g3.structure = te0;
var k3 = {};
const I3 = I, oe0 = m0, rm = 43, nm = 45, Yo = 63;
function o7(e, t) {
  let r = 0;
  for (let n = this.tokenStart + e; n < this.tokenEnd; n++) {
    const o = this.charCodeAt(n);
    if (o === nm && t && r !== 0)
      return o7.call(this, e + r + 1, !1), -1;
    oe0.isHexDigit(o) || this.error(
      t && r !== 0 ? "Hyphen minus" + (r < 6 ? " or hex digit" : "") + " is expected" : r < 6 ? "Hex digit is expected" : "Unexpected input",
      n
    ), ++r > 6 && this.error("Too many hex digits", n);
  }
  return this.next(), r;
}
function Tr(e) {
  let t = 0;
  for (; this.isDelim(Yo); )
    ++t > e && this.error("Too many question marks"), this.next();
}
function se0(e) {
  this.charCodeAt(this.tokenStart) !== e && this.error((e === rm ? "Plus sign" : "Hyphen minus") + " is expected");
}
function ie0() {
  let e = 0;
  switch (this.tokenType) {
    case I3.Number:
      if (e = o7.call(this, 1, !0), this.isDelim(Yo)) {
        Tr.call(this, 6 - e);
        break;
      }
      if (this.tokenType === I3.Dimension || this.tokenType === I3.Number) {
        se0.call(this, nm), o7.call(this, 1, !1);
        break;
      }
      break;
    case I3.Dimension:
      e = o7.call(this, 1, !0), e > 0 && Tr.call(this, 6 - e);
      break;
    default:
      if (this.eatDelim(rm), this.tokenType === I3.Ident) {
        e = o7.call(this, 0, !0), e > 0 && Tr.call(this, 6 - e);
        break;
      }
      if (this.isDelim(Yo)) {
        this.next(), Tr.call(this, 5);
        break;
      }
      this.error("Hex digit or question mark is expected");
  }
}
const ae0 = "UnicodeRange", le0 = {
  value: String
};
function ce0() {
  const e = this.tokenStart;
  return this.eatIdent("u"), ie0.call(this), {
    type: "UnicodeRange",
    loc: this.getLocation(e, this.tokenStart),
    value: this.substrToCursor(e)
  };
}
function ue0(e) {
  this.tokenize(e.value);
}
k3.generate = ue0;
k3.name = ae0;
k3.parse = ce0;
k3.structure = le0;
var v3 = {}, g4 = {};
const n8 = m0, L6 = P0, he0 = 32, Ko = 92, me0 = 34, fe0 = 39, de0 = 40, om = 41;
function pe0(e) {
  const t = e.length;
  let r = 4, n = e.charCodeAt(t - 1) === om ? t - 2 : t - 1, o = "";
  for (; r < n && n8.isWhiteSpace(e.charCodeAt(r)); )
    r++;
  for (; r < n && n8.isWhiteSpace(e.charCodeAt(n)); )
    n--;
  for (let s = r; s <= n; s++) {
    let i = e.charCodeAt(s);
    if (i === Ko) {
      if (s === n) {
        s !== t - 1 && (o = e.substr(s + 1));
        break;
      }
      if (i = e.charCodeAt(++s), n8.isValidEscape(Ko, i)) {
        const l = s - 1, c = L6.consumeEscaped(e, l);
        s = c - 1, o += L6.decodeEscaped(e.substring(l + 1, c));
      } else
        i === 13 && e.charCodeAt(s + 1) === 10 && s++;
    } else
      o += e[s];
  }
  return o;
}
function ge0(e) {
  let t = "", r = !1;
  for (let n = 0; n < e.length; n++) {
    const o = e.charCodeAt(n);
    if (o === 0) {
      t += "\uFFFD";
      continue;
    }
    if (o <= 31 || o === 127) {
      t += "\\" + o.toString(16), r = !0;
      continue;
    }
    o === he0 || o === Ko || o === me0 || o === fe0 || o === de0 || o === om ? (t += "\\" + e.charAt(n), r = !1) : (r && n8.isHexDigit(o) && (t += " "), t += e.charAt(n), r = !1);
  }
  return "url(" + t + ")";
}
g4.decode = pe0;
g4.encode = ge0;
const sm = g4, ke0 = F7, We = I, ve0 = "Url", ye0 = {
  value: String
};
function be0() {
  const e = this.tokenStart;
  let t;
  switch (this.tokenType) {
    case We.Url:
      t = sm.decode(this.consume(We.Url));
      break;
    case We.Function:
      this.cmpStr(this.tokenStart, this.tokenEnd, "url(") || this.error("Function name must be `url`"), this.eat(We.Function), this.skipSC(), t = ke0.decode(this.consume(We.String)), this.skipSC(), this.eof || this.eat(We.RightParenthesis);
      break;
    default:
      this.error("Url or Function is expected");
  }
  return {
    type: "Url",
    loc: this.getLocation(e, this.tokenStart),
    value: t
  };
}
function xe0(e) {
  this.token(We.Url, sm.encode(e.value));
}
v3.generate = xe0;
v3.name = ve0;
v3.parse = be0;
v3.structure = ye0;
var y3 = {};
const we0 = "Value", Le0 = {
  children: [[]]
};
function ze0() {
  const e = this.tokenStart, t = this.readSequence(this.scope.Value);
  return {
    type: "Value",
    loc: this.getLocation(e, this.tokenStart),
    children: t
  };
}
function Ce0(e) {
  this.children(e);
}
y3.generate = Ce0;
y3.name = we0;
y3.parse = ze0;
y3.structure = Le0;
var b3 = {};
const im = I, Se0 = Object.freeze({
  type: "WhiteSpace",
  loc: null,
  value: " "
}), $e0 = "WhiteSpace", Ae0 = {
  value: String
};
function Me0() {
  return this.eat(im.WhiteSpace), Se0;
}
function je0(e) {
  this.token(im.WhiteSpace, e.value);
}
b3.generate = je0;
b3.name = $e0;
b3.parse = Me0;
b3.structure = Ae0;
const Ee0 = G2, Te0 = kt, Pe0 = vt, Ne0 = W2, De0 = yt, Oe0 = V2, Re0 = X2, Ie0 = Y2, _e0 = K2, Fe0 = Q2, Be0 = J2, Ze0 = bt, qe0 = e3, Ue0 = t3, He0 = xt, Ge0 = wt, We0 = r3, Ve0 = n3, Xe0 = o3, Ye0 = s3, Ke0 = i3, Qe0 = a3, Je0 = l3, et0 = c3, tt0 = u3, rt0 = h3, nt0 = Lt, ot0 = zt, st0 = m3, it0 = f3, at0 = Ct, lt0 = d3, ct0 = St, ut0 = p3, ht0 = $t, mt0 = g3, ft0 = k3, dt0 = v3, pt0 = y3, gt0 = b3;
o0.AnPlusB = Ee0;
o0.Atrule = Te0;
o0.AtrulePrelude = Pe0;
o0.AttributeSelector = Ne0;
o0.Block = De0;
o0.Brackets = Oe0;
o0.CDC = Re0;
o0.CDO = Ie0;
o0.ClassSelector = _e0;
o0.Combinator = Fe0;
o0.Comment = Be0;
o0.Declaration = Ze0;
o0.DeclarationList = qe0;
o0.Dimension = Ue0;
o0.Function = He0;
o0.Hash = Ge0;
o0.Identifier = We0;
o0.IdSelector = Ve0;
o0.MediaFeature = Xe0;
o0.MediaQuery = Ye0;
o0.MediaQueryList = Ke0;
o0.Nth = Qe0;
o0.Number = Je0;
o0.Operator = et0;
o0.Parentheses = tt0;
o0.Percentage = rt0;
o0.PseudoClassSelector = nt0;
o0.PseudoElementSelector = ot0;
o0.Ratio = st0;
o0.Raw = it0;
o0.Rule = at0;
o0.Selector = lt0;
o0.SelectorList = ct0;
o0.String = ut0;
o0.StyleSheet = ht0;
o0.TypeSelector = mt0;
o0.UnicodeRange = ft0;
o0.Url = dt0;
o0.Value = pt0;
o0.WhiteSpace = gt0;
const kt0 = zQ, vt0 = o0, yt0 = {
  generic: !0,
  ...kt0,
  node: vt0
};
var bt0 = yt0, k4 = {};
const y1 = I, xt0 = 35, wt0 = 42, z6 = 43, Lt0 = 45, zt0 = 47, Ct0 = 117;
function St0(e) {
  switch (this.tokenType) {
    case y1.Hash:
      return this.Hash();
    case y1.Comma:
      return this.Operator();
    case y1.LeftParenthesis:
      return this.Parentheses(this.readSequence, e.recognizer);
    case y1.LeftSquareBracket:
      return this.Brackets(this.readSequence, e.recognizer);
    case y1.String:
      return this.String();
    case y1.Dimension:
      return this.Dimension();
    case y1.Percentage:
      return this.Percentage();
    case y1.Number:
      return this.Number();
    case y1.Function:
      return this.cmpStr(this.tokenStart, this.tokenEnd, "url(") ? this.Url() : this.Function(this.readSequence, e.recognizer);
    case y1.Url:
      return this.Url();
    case y1.Ident:
      return this.cmpChar(this.tokenStart, Ct0) && this.cmpChar(this.tokenStart + 1, z6) ? this.UnicodeRange() : this.Identifier();
    case y1.Delim: {
      const t = this.charCodeAt(this.tokenStart);
      if (t === zt0 || t === wt0 || t === z6 || t === Lt0)
        return this.Operator();
      t === xt0 && this.error("Hex or identifier is expected", this.tokenStart + 1);
      break;
    }
  }
}
var am = St0;
const $t0 = am, At0 = {
  getNode: $t0
};
var Mt0 = At0;
const ie = I, jt0 = 35, Et0 = 42, Tt0 = 43, Pt0 = 47, C6 = 46, Nt0 = 62, Dt0 = 124, Ot0 = 126;
function Rt0(e, t) {
  t.last !== null && t.last.type !== "Combinator" && e !== null && e.type !== "Combinator" && t.push({
    type: "Combinator",
    loc: null,
    name: " "
  });
}
function It0() {
  switch (this.tokenType) {
    case ie.LeftSquareBracket:
      return this.AttributeSelector();
    case ie.Hash:
      return this.IdSelector();
    case ie.Colon:
      return this.lookupType(1) === ie.Colon ? this.PseudoElementSelector() : this.PseudoClassSelector();
    case ie.Ident:
      return this.TypeSelector();
    case ie.Number:
    case ie.Percentage:
      return this.Percentage();
    case ie.Dimension:
      this.charCodeAt(this.tokenStart) === C6 && this.error("Identifier is expected", this.tokenStart + 1);
      break;
    case ie.Delim: {
      switch (this.charCodeAt(this.tokenStart)) {
        case Tt0:
        case Nt0:
        case Ot0:
        case Pt0:
          return this.Combinator();
        case C6:
          return this.ClassSelector();
        case Et0:
        case Dt0:
          return this.TypeSelector();
        case jt0:
          return this.IdSelector();
      }
      break;
    }
  }
}
const _t0 = {
  onWhiteSpace: Rt0,
  getNode: It0
};
var Ft0 = _t0;
function Bt0() {
  return this.createSingleNodeList(
    this.Raw(this.tokenIndex, null, !1)
  );
}
var Zt0 = Bt0;
const S6 = I;
function qt0() {
  const e = this.createList();
  if (this.skipSC(), e.push(this.Identifier()), this.skipSC(), this.tokenType === S6.Comma) {
    e.push(this.Operator());
    const t = this.tokenIndex, r = this.parseCustomProperty ? this.Value(null) : this.Raw(this.tokenIndex, this.consumeUntilExclamationMarkOrSemicolon, !1);
    if (r.type === "Value" && r.children.isEmpty) {
      for (let n = t - this.tokenIndex; n <= 0; n++)
        if (this.lookupType(n) === S6.WhiteSpace) {
          r.children.appendData({
            type: "WhiteSpace",
            loc: null,
            value: " "
          });
          break;
        }
    }
    e.push(r);
  }
  return e;
}
var Ut0 = qt0;
const Ht0 = am, Gt0 = Zt0, Wt0 = Ut0;
function $6(e) {
  return e !== null && e.type === "Operator" && (e.value[e.value.length - 1] === "-" || e.value[e.value.length - 1] === "+");
}
const Vt0 = {
  getNode: Ht0,
  onWhiteSpace(e, t) {
    $6(e) && (e.value = " " + e.value), $6(t.last) && (t.last.value += " ");
  },
  expression: Gt0,
  var: Wt0
};
var Xt0 = Vt0;
const Yt0 = Mt0, Kt0 = Ft0, Qt0 = Xt0;
k4.AtrulePrelude = Yt0;
k4.Selector = Kt0;
k4.Value = Qt0;
const Jt0 = {
  parse: {
    prelude: null,
    block() {
      return this.Block(!0);
    }
  }
};
var e20 = Jt0;
const _3 = I, t20 = {
  parse: {
    prelude() {
      const e = this.createList();
      switch (this.skipSC(), this.tokenType) {
        case _3.String:
          e.push(this.String());
          break;
        case _3.Url:
        case _3.Function:
          e.push(this.Url());
          break;
        default:
          this.error("String or url() is expected");
      }
      return (this.lookupNonWSType(0) === _3.Ident || this.lookupNonWSType(0) === _3.LeftParenthesis) && e.push(this.MediaQueryList()), e;
    },
    block: null
  }
};
var r20 = t20;
const n20 = {
  parse: {
    prelude() {
      return this.createSingleNodeList(
        this.MediaQueryList()
      );
    },
    block() {
      return this.Block(!1);
    }
  }
};
var o20 = n20;
const s20 = {
  parse: {
    prelude() {
      return this.createSingleNodeList(
        this.SelectorList()
      );
    },
    block() {
      return this.Block(!0);
    }
  }
};
var i20 = s20;
const Ye = I;
function a20() {
  return this.createSingleNodeList(
    this.Raw(this.tokenIndex, null, !1)
  );
}
function l20() {
  return this.skipSC(), this.tokenType === Ye.Ident && this.lookupNonWSType(1) === Ye.Colon ? this.createSingleNodeList(
    this.Declaration()
  ) : lm.call(this);
}
function lm() {
  const e = this.createList();
  let t;
  this.skipSC();
  e:
    for (; !this.eof; ) {
      switch (this.tokenType) {
        case Ye.Comment:
        case Ye.WhiteSpace:
          this.next();
          continue;
        case Ye.Function:
          t = this.Function(a20, this.scope.AtrulePrelude);
          break;
        case Ye.Ident:
          t = this.Identifier();
          break;
        case Ye.LeftParenthesis:
          t = this.Parentheses(l20, this.scope.AtrulePrelude);
          break;
        default:
          break e;
      }
      e.push(t);
    }
  return e;
}
const c20 = {
  parse: {
    prelude() {
      const e = lm.call(this);
      return this.getFirstListNode(e) === null && this.error("Condition is expected"), e;
    },
    block() {
      return this.Block(!1);
    }
  }
};
var u20 = c20;
const h20 = e20, m20 = r20, f20 = o20, d20 = i20, p20 = u20, g20 = {
  "font-face": h20,
  import: m20,
  media: f20,
  page: d20,
  supports: p20
};
var k20 = g20;
const _e = {
  parse() {
    return this.createSingleNodeList(
      this.SelectorList()
    );
  }
}, v20 = {
  parse() {
    return this.createSingleNodeList(
      this.Selector()
    );
  }
}, A6 = {
  parse() {
    return this.createSingleNodeList(
      this.Identifier()
    );
  }
}, Pr = {
  parse() {
    return this.createSingleNodeList(
      this.Nth()
    );
  }
}, y20 = {
  dir: A6,
  has: _e,
  lang: A6,
  matches: _e,
  is: _e,
  "-moz-any": _e,
  "-webkit-any": _e,
  where: _e,
  not: _e,
  "nth-child": Pr,
  "nth-last-child": Pr,
  "nth-last-of-type": Pr,
  "nth-of-type": Pr,
  slotted: v20
};
var b20 = y20, s0 = {};
const x20 = G2, w20 = kt, L20 = vt, z20 = W2, C20 = yt, S20 = V2, $20 = X2, A20 = Y2, M20 = K2, j20 = Q2, E20 = J2, T20 = bt, P20 = e3, N20 = t3, D20 = xt, O20 = wt, R20 = r3, I20 = n3, _20 = o3, F20 = s3, B20 = i3, Z20 = a3, q20 = l3, U20 = c3, H20 = u3, G20 = h3, W20 = Lt, V20 = zt, X20 = m3, Y20 = f3, K20 = Ct, Q20 = d3, J20 = St, e30 = p3, t30 = $t, r30 = g3, n30 = k3, o30 = v3, s30 = y3, i30 = b3;
s0.AnPlusB = x20.parse;
s0.Atrule = w20.parse;
s0.AtrulePrelude = L20.parse;
s0.AttributeSelector = z20.parse;
s0.Block = C20.parse;
s0.Brackets = S20.parse;
s0.CDC = $20.parse;
s0.CDO = A20.parse;
s0.ClassSelector = M20.parse;
s0.Combinator = j20.parse;
s0.Comment = E20.parse;
s0.Declaration = T20.parse;
s0.DeclarationList = P20.parse;
s0.Dimension = N20.parse;
s0.Function = D20.parse;
s0.Hash = O20.parse;
s0.Identifier = R20.parse;
s0.IdSelector = I20.parse;
s0.MediaFeature = _20.parse;
s0.MediaQuery = F20.parse;
s0.MediaQueryList = B20.parse;
s0.Nth = Z20.parse;
s0.Number = q20.parse;
s0.Operator = U20.parse;
s0.Parentheses = H20.parse;
s0.Percentage = G20.parse;
s0.PseudoClassSelector = W20.parse;
s0.PseudoElementSelector = V20.parse;
s0.Ratio = X20.parse;
s0.Raw = Y20.parse;
s0.Rule = K20.parse;
s0.Selector = Q20.parse;
s0.SelectorList = J20.parse;
s0.String = e30.parse;
s0.StyleSheet = t30.parse;
s0.TypeSelector = r30.parse;
s0.UnicodeRange = n30.parse;
s0.Url = o30.parse;
s0.Value = s30.parse;
s0.WhiteSpace = i30.parse;
const a30 = k4, l30 = k20, c30 = b20, u30 = s0, h30 = {
  parseContext: {
    default: "StyleSheet",
    stylesheet: "StyleSheet",
    atrule: "Atrule",
    atrulePrelude(e) {
      return this.AtrulePrelude(e.atrule ? String(e.atrule) : null);
    },
    mediaQueryList: "MediaQueryList",
    mediaQuery: "MediaQuery",
    rule: "Rule",
    selectorList: "SelectorList",
    selector: "Selector",
    block() {
      return this.Block(!0);
    },
    declarationList: "DeclarationList",
    declaration: "Declaration",
    value: "Value"
  },
  scope: a30,
  atrule: l30,
  pseudo: c30,
  node: u30
};
var m30 = h30;
const f30 = o0, d30 = {
  node: f30
};
var p30 = d30;
const g30 = Oh, k30 = bt0, v30 = m30, y30 = p30, b30 = g30({
  ...k30,
  ...v30,
  ...y30
});
var x30 = b30, w30 = "2.2.1", B7 = {};
const L30 = w5, z30 = u4, C30 = f4, S30 = P5;
B7.SyntaxError = L30.SyntaxError;
B7.generate = z30.generate;
B7.parse = C30.parse;
B7.walk = S30.walk;
var cm = {};
const $30 = pt;
function Qo(e) {
  const t = {};
  for (const r in e) {
    let n = e[r];
    n && (Array.isArray(n) || n instanceof $30.List ? n = n.map(Qo) : n.constructor === Object && (n = Qo(n))), t[r] = n;
  }
  return t;
}
cm.clone = Qo;
var N5 = {};
const um = m0, M6 = P0, j6 = 92;
function A30(e) {
  const t = e.length - 1;
  let r = "";
  for (let n = 0; n < e.length; n++) {
    let o = e.charCodeAt(n);
    if (o === j6) {
      if (n === t)
        break;
      if (o = e.charCodeAt(++n), um.isValidEscape(j6, o)) {
        const s = n - 1, i = M6.consumeEscaped(e, s);
        n = i - 1, r += M6.decodeEscaped(e.substring(s + 1, i));
      } else
        o === 13 && e.charCodeAt(n + 1) === 10 && n++;
    } else
      r += e[n];
  }
  return r;
}
function M30(e) {
  let t = "";
  if (e.length === 1 && e.charCodeAt(0) === 45)
    return "\\-";
  for (let r = 0; r < e.length; r++) {
    const n = e.charCodeAt(r);
    if (n === 0) {
      t += "\uFFFD";
      continue;
    }
    if (n <= 31 || n === 127 || n >= 48 && n <= 57 && (r === 0 || r === 1 && e.charCodeAt(0) === 45)) {
      t += "\\" + n.toString(16) + " ";
      continue;
    }
    um.isName(n) ? t += e.charAt(r) : t += "\\" + e.charAt(r);
  }
  return t;
}
N5.decode = A30;
N5.encode = M30;
const j30 = x30, E30 = w30, T30 = Oh, P30 = pt, N30 = d5, D30 = B7, O30 = cm, v4 = gt, R30 = N5, I30 = F7, _30 = g4, F30 = I, B30 = a4, Z30 = l4, {
  tokenize: q30,
  parse: U30,
  generate: H30,
  lexer: G30,
  createLexer: W30,
  walk: V30,
  find: X30,
  findLast: Y30,
  findAll: K30,
  toPlainObject: Q30,
  fromPlainObject: J30,
  fork: e70
} = j30;
X.version = E30.version;
X.createSyntax = T30;
X.List = P30.List;
X.Lexer = N30.Lexer;
X.definitionSyntax = D30;
X.clone = O30.clone;
X.isCustomProperty = v4.isCustomProperty;
X.keyword = v4.keyword;
X.property = v4.property;
X.vendorPrefix = v4.vendorPrefix;
X.ident = R30;
X.string = I30;
X.url = _30;
X.tokenTypes = F30;
X.tokenNames = B30;
X.TokenStream = Z30.TokenStream;
X.createLexer = W30;
X.find = X30;
X.findAll = K30;
X.findLast = Y30;
X.fork = e70;
X.fromPlainObject = J30;
X.generate = H30;
X.lexer = G30;
X.parse = U30;
X.toPlainObject = Q30;
X.tokenize = q30;
X.walk = V30;
var hm = {};
const { hasOwnProperty: t70 } = Object.prototype;
function $n(e, t) {
  const r = /* @__PURE__ */ Object.create(null);
  if (!Array.isArray(e))
    return null;
  for (let n of e)
    t && (n = n.toLowerCase()), r[n] = !0;
  return r;
}
function E6(e) {
  if (!e)
    return null;
  const t = $n(e.tags, !0), r = $n(e.ids), n = $n(e.classes);
  return t === null && r === null && n === null ? null : {
    tags: t,
    ids: r,
    classes: n
  };
}
function r70(e) {
  let t = !1;
  if (e.scopes && Array.isArray(e.scopes)) {
    t = /* @__PURE__ */ Object.create(null);
    for (let r = 0; r < e.scopes.length; r++) {
      const n = e.scopes[r];
      if (!n || !Array.isArray(n))
        throw new Error("Wrong usage format");
      for (const o of n) {
        if (t70.call(t, o))
          throw new Error(`Class can't be used for several scopes: ${o}`);
        t[o] = r + 1;
      }
    }
  }
  return {
    whitelist: E6(e),
    blacklist: E6(e.blacklist),
    scopes: t
  };
}
hm.buildIndex = r70;
var Z7 = {};
function n70(e) {
  return !e || !e.children || e.children.isEmpty;
}
function o70(e, t) {
  return e !== null && e.children === t;
}
Z7.hasNoChildren = n70;
Z7.isNodeChildrenList = o70;
const s70 = X, Nr = Z7;
function i70(e, t, r) {
  if (e.block && (this.stylesheet !== null && (this.stylesheet.firstAtrulesAllowed = !1), Nr.hasNoChildren(e.block))) {
    r.remove(t);
    return;
  }
  switch (e.name) {
    case "charset":
      if (Nr.hasNoChildren(e.prelude)) {
        r.remove(t);
        return;
      }
      if (t.prev) {
        r.remove(t);
        return;
      }
      break;
    case "import":
      if (this.stylesheet === null || !this.stylesheet.firstAtrulesAllowed) {
        r.remove(t);
        return;
      }
      r.prevUntil(t.prev, function(n) {
        if (!(n.type === "Atrule" && (n.name === "import" || n.name === "charset")))
          return this.root.firstAtrulesAllowed = !1, r.remove(t), !0;
      }, this);
      break;
    default: {
      const n = s70.keyword(e.name).basename;
      (n === "keyframes" || n === "media" || n === "supports") && (Nr.hasNoChildren(e.prelude) || Nr.hasNoChildren(e.block)) && r.remove(t);
    }
  }
}
var a70 = i70;
function l70(e, t, r) {
  r.remove(t);
}
var c70 = l70;
const u70 = X;
function h70(e, t, r) {
  if (e.value.children && e.value.children.isEmpty) {
    r.remove(t);
    return;
  }
  u70.property(e.property).custom && /\S/.test(e.value.value) && (e.value.value = e.value.value.trim());
}
var m70 = h70;
const T6 = Z7;
function f70(e, t, r) {
  (T6.isNodeChildrenList(this.stylesheet, r) || T6.isNodeChildrenList(this.block, r)) && r.remove(t);
}
var d70 = f70;
const mm = X, An = Z7, { hasOwnProperty: It } = Object.prototype, p70 = /* @__PURE__ */ new Set(["keyframes"]);
function fm(e, t) {
  return e.children.forEach((r, n, o) => {
    let s = !1;
    mm.walk(r, function(i) {
      if (this.selector === null || this.selector === e)
        switch (i.type) {
          case "SelectorList":
            (this.function === null || this.function.name.toLowerCase() !== "not") && fm(i, t) && (s = !0);
            break;
          case "ClassSelector":
            t.whitelist !== null && t.whitelist.classes !== null && !It.call(t.whitelist.classes, i.name) && (s = !0), t.blacklist !== null && t.blacklist.classes !== null && It.call(t.blacklist.classes, i.name) && (s = !0);
            break;
          case "IdSelector":
            t.whitelist !== null && t.whitelist.ids !== null && !It.call(t.whitelist.ids, i.name) && (s = !0), t.blacklist !== null && t.blacklist.ids !== null && It.call(t.blacklist.ids, i.name) && (s = !0);
            break;
          case "TypeSelector":
            i.name.charAt(i.name.length - 1) !== "*" && (t.whitelist !== null && t.whitelist.tags !== null && !It.call(t.whitelist.tags, i.name.toLowerCase()) && (s = !0), t.blacklist !== null && t.blacklist.tags !== null && It.call(t.blacklist.tags, i.name.toLowerCase()) && (s = !0));
            break;
        }
    }), s && o.remove(n);
  }), e.children.isEmpty;
}
function g70(e, t, r, n) {
  if (An.hasNoChildren(e.prelude) || An.hasNoChildren(e.block)) {
    r.remove(t);
    return;
  }
  if (this.atrule && p70.has(mm.keyword(this.atrule.name).basename))
    return;
  const { usage: o } = n;
  if (o && (o.whitelist !== null || o.blacklist !== null) && (fm(e.prelude, o), An.hasNoChildren(e.prelude))) {
    r.remove(t);
    return;
  }
}
var k70 = g70;
function v70(e, t, r) {
  if (t.data.name !== "*")
    return;
  const o = t.next && t.next.data.type;
  (o === "IdSelector" || o === "ClassSelector" || o === "AttributeSelector" || o === "PseudoClassSelector" || o === "PseudoElementSelector") && r.remove(t);
}
var y70 = v70;
function b70(e, t, r) {
  r.remove(t);
}
var x70 = b70;
const w70 = X, L70 = a70, z70 = c70, C70 = m70, S70 = d70, $70 = k70, A70 = y70, M70 = x70, P6 = {
  Atrule: L70,
  Comment: z70,
  Declaration: C70,
  Raw: S70,
  Rule: $70,
  TypeSelector: A70,
  WhiteSpace: M70
};
function j70(e, t) {
  w70.walk(e, {
    leave(r, n, o) {
      P6.hasOwnProperty(r.type) && P6[r.type].call(this, r, n, o, t);
    }
  });
}
var E70 = j70;
function T70(e) {
  e.block.children.forEach((t) => {
    t.prelude.children.forEach((r) => {
      r.children.forEach((n, o) => {
        n.type === "Percentage" && n.value === "100" ? o.data = {
          type: "TypeSelector",
          loc: n.loc,
          name: "to"
        } : n.type === "TypeSelector" && n.name === "from" && (o.data = {
          type: "Percentage",
          loc: n.loc,
          value: "0"
        });
      });
    });
  });
}
var P70 = T70;
const N70 = X, D70 = P70;
function O70(e) {
  N70.keyword(e.name).basename === "keyframes" && D70(e);
}
var R70 = O70;
const I70 = /^(-?\d|--)|[\u0000-\u002c\u002e\u002f\u003A-\u0040\u005B-\u005E\u0060\u007B-\u009f]/;
function _70(e) {
  return e === "" || e === "-" ? !1 : !I70.test(e);
}
function F70(e) {
  const t = e.value;
  !t || t.type !== "String" || _70(t.value) && (e.value = {
    type: "Identifier",
    loc: t.loc,
    name: t.value
  });
}
var B70 = F70;
function Z70(e) {
  const t = e.children;
  t.forEachRight(function(r, n) {
    if (r.type === "Identifier") {
      if (r.name === "bold")
        n.data = {
          type: "Number",
          loc: r.loc,
          value: "700"
        };
      else if (r.name === "normal") {
        const o = n.prev;
        o && o.data.type === "Operator" && o.data.value === "/" && this.remove(o), this.remove(n);
      }
    }
  }), t.isEmpty && t.insert(t.createItem({
    type: "Identifier",
    name: "normal"
  }));
}
var q70 = Z70;
function U70(e) {
  const t = e.children.head.data;
  if (t.type === "Identifier")
    switch (t.name) {
      case "normal":
        e.children.head.data = {
          type: "Number",
          loc: t.loc,
          value: "400"
        };
        break;
      case "bold":
        e.children.head.data = {
          type: "Number",
          loc: t.loc,
          value: "700"
        };
        break;
    }
}
var H70 = U70;
const G70 = X;
function W70(e) {
  function t() {
    n.length || n.unshift(
      {
        type: "Number",
        loc: null,
        value: "0"
      },
      {
        type: "Number",
        loc: null,
        value: "0"
      }
    ), r.push.apply(r, n), n = [];
  }
  let r = [], n = [];
  e.children.forEach((o) => {
    if (o.type === "Operator" && o.value === ",") {
      t(), r.push(o);
      return;
    }
    o.type === "Identifier" && (o.name === "transparent" || o.name === "none" || o.name === "repeat" || o.name === "scroll") || n.push(o);
  }), t(), e.children = new G70.List().fromArray(r);
}
var V70 = W70;
function X70(e) {
  e.children.forEach((t, r, n) => {
    t.type === "Identifier" && t.name.toLowerCase() === "none" && (n.head === n.tail ? r.data = {
      type: "Number",
      loc: t.loc,
      value: "0"
    } : n.remove(r));
  });
}
var Y70 = X70;
const K70 = X, Q70 = q70, J70 = H70, er0 = V70, N6 = Y70, D6 = {
  font: Q70,
  "font-weight": J70,
  background: er0,
  border: N6,
  outline: N6
};
function tr0(e) {
  if (!this.declaration)
    return;
  const t = K70.property(this.declaration.property);
  D6.hasOwnProperty(t.basename) && D6[t.basename](e);
}
var rr0 = tr0, x3 = {};
const nr0 = /^(?:\+|(-))?0*(\d*)(?:\.0*|(\.\d*?)0*)?$/, or0 = /^([\+\-])?0*(\d*)(?:\.0*|(\.\d*?)0*)?$/, sr0 = /* @__PURE__ */ new Set([
  "Dimension",
  "Hash",
  "Identifier",
  "Number",
  "Raw",
  "UnicodeRange"
]);
function dm(e, t) {
  const r = t && t.prev !== null && sr0.has(t.prev.data.type) ? or0 : nr0;
  return e = String(e).replace(r, "$1$2$3"), (e === "" || e === "-") && (e = "0"), e;
}
function ir0(e) {
  e.value = dm(e.value);
}
x3.Number = ir0;
x3.packNumber = dm;
const ar0 = x3, lr0 = /* @__PURE__ */ new Set([
  "calc",
  "min",
  "max",
  "clamp"
]), cr0 = /* @__PURE__ */ new Set([
  "px",
  "mm",
  "cm",
  "in",
  "pt",
  "pc",
  "em",
  "ex",
  "ch",
  "rem",
  "vh",
  "vw",
  "vmin",
  "vmax",
  "vm"
]);
function ur0(e, t) {
  const r = ar0.packNumber(e.value);
  if (e.value = r, r === "0" && this.declaration !== null && this.atrulePrelude === null) {
    const n = e.unit.toLowerCase();
    if (!cr0.has(n) || this.declaration.property === "-ms-flex" || this.declaration.property === "flex" || this.function && lr0.has(this.function.name))
      return;
    t.data = {
      type: "Number",
      loc: e.loc,
      value: r
    };
  }
}
var hr0 = ur0;
const mr0 = X, fr0 = x3, dr0 = /* @__PURE__ */ new Set([
  "width",
  "min-width",
  "max-width",
  "height",
  "min-height",
  "max-height",
  "flex",
  "-ms-flex"
]);
function pr0(e, t) {
  e.value = fr0.packNumber(e.value), e.value === "0" && this.declaration && !dr0.has(this.declaration.property) && (t.data = {
    type: "Number",
    loc: e.loc,
    value: e.value
  }, mr0.lexer.matchDeclaration(this.declaration).isType(t.data, "length") || (t.data = e));
}
var gr0 = pr0;
function kr0(e) {
  e.value = e.value.replace(/\\/g, "/");
}
var vr0 = kr0, y4 = {};
const yr0 = X, br0 = x3, O6 = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgrey: "a9a9a9",
  darkgreen: "006400",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  grey: "808080",
  green: "008000",
  greenyellow: "adff2f",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgrey: "d3d3d3",
  lightgreen: "90ee90",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "639",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, R6 = {
  8e5: "maroon",
  800080: "purple",
  808e3: "olive",
  808080: "gray",
  "00ffff": "cyan",
  f0ffff: "azure",
  f5f5dc: "beige",
  ffe4c4: "bisque",
  "000000": "black",
  "0000ff": "blue",
  a52a2a: "brown",
  ff7f50: "coral",
  ffd700: "gold",
  "008000": "green",
  "4b0082": "indigo",
  fffff0: "ivory",
  f0e68c: "khaki",
  "00ff00": "lime",
  faf0e6: "linen",
  "000080": "navy",
  ffa500: "orange",
  da70d6: "orchid",
  cd853f: "peru",
  ffc0cb: "pink",
  dda0dd: "plum",
  f00: "red",
  ff0000: "red",
  fa8072: "salmon",
  a0522d: "sienna",
  c0c0c0: "silver",
  fffafa: "snow",
  d2b48c: "tan",
  "008080": "teal",
  ff6347: "tomato",
  ee82ee: "violet",
  f5deb3: "wheat",
  ffffff: "white",
  ffff00: "yellow"
};
function Mn(e, t, r) {
  return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? e + (t - e) * 6 * r : r < 1 / 2 ? t : r < 2 / 3 ? e + (t - e) * (2 / 3 - r) * 6 : e;
}
function I6(e, t, r, n) {
  let o, s, i;
  if (t === 0)
    o = s = i = r;
  else {
    const l = r < 0.5 ? r * (1 + t) : r + t - r * t, c = 2 * r - l;
    o = Mn(c, l, e + 1 / 3), s = Mn(c, l, e), i = Mn(c, l, e - 1 / 3);
  }
  return [
    Math.round(o * 255),
    Math.round(s * 255),
    Math.round(i * 255),
    n
  ];
}
function jn(e) {
  return e = e.toString(16), e.length === 1 ? "0" + e : e;
}
function En(e, t, r) {
  let n = e.head, o = [], s = !1;
  for (; n !== null; ) {
    const { type: i, value: l } = n.data;
    switch (i) {
      case "Number":
      case "Percentage":
        if (s)
          return;
        s = !0, o.push({
          type: i,
          value: Number(l)
        });
        break;
      case "Operator":
        if (l === ",") {
          if (!s)
            return;
          s = !1;
        } else if (s || l !== "+")
          return;
        break;
      default:
        return;
    }
    n = n.next;
  }
  if (o.length === t) {
    if (o.length === 4) {
      if (o[3].type !== "Number")
        return;
      o[3].type = "Alpha";
    }
    if (r) {
      if (o[0].type !== o[1].type || o[0].type !== o[2].type)
        return;
    } else {
      if (o[0].type !== "Number" || o[1].type !== "Percentage" || o[2].type !== "Percentage")
        return;
      o[0].type = "Angle";
    }
    return o.map(function(i) {
      let l = Math.max(0, i.value);
      switch (i.type) {
        case "Number":
          l = Math.min(l, 255);
          break;
        case "Percentage":
          if (l = Math.min(l, 100) / 100, !r)
            return l;
          l = 255 * l;
          break;
        case "Angle":
          return (l % 360 + 360) % 360 / 360;
        case "Alpha":
          return Math.min(l, 1);
      }
      return Math.round(l);
    });
  }
}
function xr0(e, t) {
  let r = e.name, n;
  if (r === "rgba" || r === "hsla") {
    if (n = En(e.children, 4, r === "rgba"), !n)
      return;
    if (r === "hsla" && (n = I6(...n), e.name = "rgba"), n[3] === 0) {
      const o = this.function && this.function.name;
      if (n[0] === 0 && n[1] === 0 && n[2] === 0 || !/^(?:to|from|color-stop)$|gradient$/i.test(o)) {
        t.data = {
          type: "Identifier",
          loc: e.loc,
          name: "transparent"
        };
        return;
      }
    }
    if (n[3] !== 1) {
      e.children.forEach((o, s, i) => {
        if (o.type === "Operator") {
          o.value !== "," && i.remove(s);
          return;
        }
        s.data = {
          type: "Number",
          loc: o.loc,
          value: br0.packNumber(n.shift())
        };
      });
      return;
    }
    r = "rgb";
  }
  if (r === "hsl") {
    if (n = n || En(e.children, 3, !1), !n)
      return;
    n = I6(...n), r = "rgb";
  }
  if (r === "rgb") {
    if (n = n || En(e.children, 3, !0), !n)
      return;
    t.data = {
      type: "Hash",
      loc: e.loc,
      value: jn(n[0]) + jn(n[1]) + jn(n[2])
    }, pm(t.data, t);
  }
}
function wr0(e, t) {
  if (this.declaration === null)
    return;
  let r = e.name.toLowerCase();
  if (O6.hasOwnProperty(r) && yr0.lexer.matchDeclaration(this.declaration).isType(e, "color")) {
    const n = O6[r];
    n.length + 1 <= r.length ? t.data = {
      type: "Hash",
      loc: e.loc,
      value: n
    } : (r === "grey" && (r = "gray"), e.name = r);
  }
}
function pm(e, t) {
  let r = e.value.toLowerCase();
  r.length === 6 && r[0] === r[1] && r[2] === r[3] && r[4] === r[5] && (r = r[0] + r[2] + r[4]), R6[r] ? t.data = {
    type: "Identifier",
    loc: e.loc,
    name: R6[r]
  } : e.value = r;
}
y4.compressFunction = xr0;
y4.compressHex = pm;
y4.compressIdent = wr0;
const Lr0 = X, zr0 = R70, Cr0 = B70, Sr0 = rr0, $r0 = hr0, Ar0 = gr0, Mr0 = x3, jr0 = vr0, Tn = y4, _6 = {
  Atrule: zr0,
  AttributeSelector: Cr0,
  Value: Sr0,
  Dimension: $r0,
  Percentage: Ar0,
  Number: Mr0.Number,
  Url: jr0,
  Hash: Tn.compressHex,
  Identifier: Tn.compressIdent,
  Function: Tn.compressFunction
};
function Er0(e) {
  Lr0.walk(e, {
    leave(t, r, n) {
      _6.hasOwnProperty(t.type) && _6[t.type].call(this, t, r, n);
    }
  });
}
var Tr0 = Er0;
const Pr0 = X;
class Nr0 {
  constructor() {
    this.map = /* @__PURE__ */ new Map();
  }
  resolve(t) {
    let r = this.map.get(t);
    return r === void 0 && (r = this.map.size + 1, this.map.set(t, r)), r;
  }
}
function Dr0() {
  const e = new Nr0();
  return function(r) {
    const n = Pr0.generate(r);
    return r.id = e.resolve(n), r.length = n.length, r.fingerprint = null, r;
  };
}
var Or0 = Dr0;
const Rr0 = X;
function Ir0(e) {
  return e.type === "Raw" ? Rr0.parse(e.value, { context: "selectorList" }) : e;
}
function _r0(e, t) {
  for (let r = 0; r < 3; r++)
    if (e[r] !== t[r])
      return e[r] > t[r] ? e : t;
  return e;
}
function F6(e) {
  return Ir0(e).children.reduce(
    (t, r) => _r0(gm(r), t),
    [0, 0, 0]
  );
}
function gm(e) {
  let t = 0, r = 0, n = 0;
  return e.children.forEach((o) => {
    switch (o.type) {
      case "IdSelector":
        t++;
        break;
      case "ClassSelector":
      case "AttributeSelector":
        r++;
        break;
      case "PseudoClassSelector":
        switch (o.name.toLowerCase()) {
          case "not":
          case "has":
          case "is":
          case "matches":
          case "-webkit-any":
          case "-moz-any": {
            const [s, i, l] = F6(o.children.first);
            t += s, r += i, n += l;
            break;
          }
          case "nth-child":
          case "nth-last-child": {
            const s = o.children.first;
            if (s.type === "Nth" && s.selector) {
              const [i, l, c] = F6(s.selector);
              t += i, r += l + 1, n += c;
            } else
              r++;
            break;
          }
          case "where":
            break;
          case "before":
          case "after":
          case "first-line":
          case "first-letter":
            n++;
            break;
          default:
            r++;
        }
        break;
      case "TypeSelector":
        o.name.endsWith("*") || n++;
        break;
      case "PseudoElementSelector":
        n++;
        break;
    }
  }), [t, r, n];
}
var km = gm;
const B6 = X, Fr0 = km, Br0 = /* @__PURE__ */ new Set([
  "first-letter",
  "first-line",
  "after",
  "before"
]), Zr0 = /* @__PURE__ */ new Set([
  "link",
  "visited",
  "hover",
  "active",
  "first-letter",
  "first-line",
  "after",
  "before"
]);
function qr0(e, t) {
  const r = /* @__PURE__ */ new Set();
  e.prelude.children.forEach(function(n) {
    let o = "*", s = 0;
    n.children.forEach(function(i) {
      switch (i.type) {
        case "ClassSelector":
          if (t && t.scopes) {
            const l = t.scopes[i.name] || 0;
            if (s !== 0 && l !== s)
              throw new Error("Selector can't has classes from different scopes: " + B6.generate(n));
            s = l;
          }
          break;
        case "PseudoClassSelector": {
          const l = i.name.toLowerCase();
          Zr0.has(l) || r.add(`:${l}`);
          break;
        }
        case "PseudoElementSelector": {
          const l = i.name.toLowerCase();
          Br0.has(l) || r.add(`::${l}`);
          break;
        }
        case "TypeSelector":
          o = i.name.toLowerCase();
          break;
        case "AttributeSelector":
          i.flags && r.add(`[${i.flags.toLowerCase()}]`);
          break;
        case "Combinator":
          o = "*";
          break;
      }
    }), n.compareMarker = Fr0(n).toString(), n.id = null, n.id = B6.generate(n), s && (n.compareMarker += ":" + s), o !== "*" && (n.compareMarker += "," + o);
  }), e.pseudoSignature = r.size > 0 ? [...r].sort().join(",") : !1;
}
var vm = qr0;
const Dr = X, Ur0 = Or0, Hr0 = vm;
function Gr0(e, t) {
  const r = Ur0();
  return Dr.walk(e, {
    visit: "Rule",
    enter(n) {
      n.block.children.forEach(r), Hr0(n, t.usage);
    }
  }), Dr.walk(e, {
    visit: "Atrule",
    enter(n) {
      n.prelude && (n.prelude.id = null, n.prelude.id = Dr.generate(n.prelude)), Dr.keyword(n.name).basename === "keyframes" && (n.block.avoidRulesMerge = !0, n.block.children.forEach(function(o) {
        o.prelude.children.forEach(function(s) {
          s.compareMarker = s.id;
        });
      }));
    }
  }), {
    declaration: r
  };
}
var Wr0 = Gr0;
const $8 = X, { hasOwnProperty: Z6 } = Object.prototype;
function q6(e, t, r, n) {
  const o = t.data, s = $8.keyword(o.name).basename, i = o.name.toLowerCase() + "/" + (o.prelude ? o.prelude.id : null);
  Z6.call(e, s) || (e[s] = /* @__PURE__ */ Object.create(null)), n && delete e[s][i], Z6.call(e[s], i) || (e[s][i] = new $8.List()), e[s][i].append(r.remove(t));
}
function Vr0(e, t) {
  const r = /* @__PURE__ */ Object.create(null);
  let n = null;
  e.children.forEach(function(o, s, i) {
    if (o.type === "Atrule") {
      const l = $8.keyword(o.name).basename;
      switch (l) {
        case "keyframes":
          q6(r, s, i, !0);
          return;
        case "media":
          if (t.forceMediaMerge) {
            q6(r, s, i, !1);
            return;
          }
          break;
      }
      n === null && l !== "charset" && l !== "import" && (n = s);
    } else
      n === null && (n = s);
  });
  for (const o in r)
    for (const s in r[o])
      e.children.insertList(
        r[o][s],
        o === "media" ? null : n
      );
}
function U6(e) {
  return e.type === "Atrule" && e.name === "media";
}
function Xr0(e, t, r) {
  if (!U6(e))
    return;
  const n = t.prev && t.prev.data;
  !n || !U6(n) || e.prelude && n.prelude && e.prelude.id === n.prelude.id && (n.block.children.appendList(e.block.children), r.remove(t));
}
function Yr0(e, t) {
  Vr0(e, t), $8.walk(e, {
    visit: "Atrule",
    reverse: !0,
    enter: Xr0
  });
}
var Kr0 = Yr0, ee = {};
const { hasOwnProperty: Qr0 } = Object.prototype;
function Jr0(e, t) {
  let r = e.head, n = t.head;
  for (; r !== null && n !== null && r.data.id === n.data.id; )
    r = r.next, n = n.next;
  return r === null && n === null;
}
function e80(e, t) {
  let r = e.head, n = t.head;
  for (; r !== null && n !== null && r.data.id === n.data.id; )
    r = r.next, n = n.next;
  return r === null && n === null;
}
function t80(e, t) {
  const r = {
    eq: [],
    ne1: [],
    ne2: [],
    ne2overrided: []
  }, n = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ Object.create(null);
  for (let s = t.head; s; s = s.next)
    o[s.data.id] = !0;
  for (let s = e.head; s; s = s.next) {
    const i = s.data;
    i.fingerprint && (n[i.fingerprint] = i.important), o[i.id] ? (o[i.id] = !1, r.eq.push(i)) : r.ne1.push(i);
  }
  for (let s = t.head; s; s = s.next) {
    const i = s.data;
    o[i.id] && ((!Qr0.call(n, i.fingerprint) || !n[i.fingerprint] && i.important) && r.ne2.push(i), r.ne2overrided.push(i));
  }
  return r;
}
function r80(e, t) {
  return t.forEach((r) => {
    const n = r.id;
    let o = e.head;
    for (; o; ) {
      const s = o.data.id;
      if (s === n)
        return;
      if (s > n)
        break;
      o = o.next;
    }
    e.insert(e.createItem(r), o);
  }), e;
}
function ym(e, t) {
  let r = e.head;
  for (; r !== null; ) {
    let n = t.head;
    for (; n !== null; ) {
      if (r.data.compareMarker === n.data.compareMarker)
        return !0;
      n = n.next;
    }
    r = r.next;
  }
  return !1;
}
function bm(e) {
  switch (e.type) {
    case "Rule":
      return ym(e.prelude.children, this);
    case "Atrule":
      if (e.block)
        return e.block.children.some(bm, this);
      break;
    case "Declaration":
      return !1;
  }
  return !0;
}
ee.addSelectors = r80;
ee.compareDeclarations = t80;
ee.hasSimilarSelectors = ym;
ee.isEqualDeclarations = e80;
ee.isEqualSelectors = Jr0;
ee.unsafeToSkipNode = bm;
const n80 = X, F3 = ee;
function o80(e, t, r) {
  const n = e.prelude.children, o = e.block.children;
  r.prevUntil(t.prev, function(s) {
    if (s.type !== "Rule")
      return F3.unsafeToSkipNode.call(n, s);
    const i = s.prelude.children, l = s.block.children;
    if (e.pseudoSignature === s.pseudoSignature) {
      if (F3.isEqualSelectors(i, n))
        return l.appendList(o), r.remove(t), !0;
      if (F3.isEqualDeclarations(o, l))
        return F3.addSelectors(i, n), r.remove(t), !0;
    }
    return F3.hasSimilarSelectors(n, i);
  });
}
function s80(e) {
  n80.walk(e, {
    visit: "Rule",
    enter: o80
  });
}
var i80 = s80;
const xm = X;
function a80(e, t, r) {
  const n = e.prelude.children;
  for (; n.head !== n.tail; ) {
    const o = new xm.List();
    o.insert(n.remove(n.head)), r.insert(r.createItem({
      type: "Rule",
      loc: e.loc,
      prelude: {
        type: "SelectorList",
        loc: e.prelude.loc,
        children: o
      },
      block: {
        type: "Block",
        loc: e.block.loc,
        children: e.block.children.copy()
      },
      pseudoSignature: e.pseudoSignature
    }), t);
  }
}
function l80(e) {
  xm.walk(e, {
    visit: "Rule",
    reverse: !0,
    enter: a80
  });
}
var c80 = l80;
const Ut = X, wm = 1, u80 = 2, _t = 0, B3 = 1, Pn = 2, Or = 3, H6 = ["top", "right", "bottom", "left"], h80 = {
  "margin-top": "top",
  "margin-right": "right",
  "margin-bottom": "bottom",
  "margin-left": "left",
  "padding-top": "top",
  "padding-right": "right",
  "padding-bottom": "bottom",
  "padding-left": "left",
  "border-top-color": "top",
  "border-right-color": "right",
  "border-bottom-color": "bottom",
  "border-left-color": "left",
  "border-top-width": "top",
  "border-right-width": "right",
  "border-bottom-width": "bottom",
  "border-left-width": "left",
  "border-top-style": "top",
  "border-right-style": "right",
  "border-bottom-style": "bottom",
  "border-left-style": "left"
}, G6 = {
  margin: "margin",
  "margin-top": "margin",
  "margin-right": "margin",
  "margin-bottom": "margin",
  "margin-left": "margin",
  padding: "padding",
  "padding-top": "padding",
  "padding-right": "padding",
  "padding-bottom": "padding",
  "padding-left": "padding",
  "border-color": "border-color",
  "border-top-color": "border-color",
  "border-right-color": "border-color",
  "border-bottom-color": "border-color",
  "border-left-color": "border-color",
  "border-width": "border-width",
  "border-top-width": "border-width",
  "border-right-width": "border-width",
  "border-bottom-width": "border-width",
  "border-left-width": "border-width",
  "border-style": "border-style",
  "border-top-style": "border-style",
  "border-right-style": "border-style",
  "border-bottom-style": "border-style",
  "border-left-style": "border-style"
};
class m80 {
  constructor(t) {
    this.name = t, this.loc = null, this.iehack = void 0, this.sides = {
      top: null,
      right: null,
      bottom: null,
      left: null
    };
  }
  getValueSequence(t, r) {
    const n = [];
    let o = "";
    return t.value.type !== "Value" || t.value.children.some(function(i) {
      let l = !1;
      switch (i.type) {
        case "Identifier":
          switch (i.name) {
            case "\\0":
            case "\\9":
              o = i.name;
              return;
            case "inherit":
            case "initial":
            case "unset":
            case "revert":
              l = i.name;
              break;
          }
          break;
        case "Dimension":
          switch (i.unit) {
            case "rem":
            case "vw":
            case "vh":
            case "vmin":
            case "vmax":
            case "vm":
              l = i.unit;
              break;
          }
          break;
        case "Hash":
        case "Number":
        case "Percentage":
          break;
        case "Function":
          if (i.name === "var")
            return !0;
          l = i.name;
          break;
        default:
          return !0;
      }
      n.push({
        node: i,
        special: l,
        important: t.important
      });
    }) || n.length > r || typeof this.iehack == "string" && this.iehack !== o ? !1 : (this.iehack = o, n);
  }
  canOverride(t, r) {
    const n = this.sides[t];
    return !n || r.important && !n.important;
  }
  add(t, r) {
    function n() {
      const o = this.sides, s = h80[t];
      if (s) {
        if (!(s in o))
          return !1;
        const i = this.getValueSequence(r, 1);
        if (!i || !i.length)
          return !1;
        for (const l in o)
          if (o[l] !== null && o[l].special !== i[0].special)
            return !1;
        return this.canOverride(s, i[0]) && (o[s] = i[0]), !0;
      } else if (t === this.name) {
        const i = this.getValueSequence(r, 4);
        if (!i || !i.length)
          return !1;
        switch (i.length) {
          case 1:
            i[B3] = i[_t], i[Pn] = i[_t], i[Or] = i[_t];
            break;
          case 2:
            i[Pn] = i[_t], i[Or] = i[B3];
            break;
          case 3:
            i[Or] = i[B3];
            break;
        }
        for (let l = 0; l < 4; l++)
          for (const c in o)
            if (o[c] !== null && o[c].special !== i[l].special)
              return !1;
        for (let l = 0; l < 4; l++)
          this.canOverride(H6[l], i[l]) && (o[H6[l]] = i[l]);
        return !0;
      }
    }
    return n.call(this) ? (this.loc || (this.loc = r.loc), !0) : !1;
  }
  isOkToMinimize() {
    const t = this.sides.top, r = this.sides.right, n = this.sides.bottom, o = this.sides.left;
    if (t && r && n && o) {
      const s = t.important + r.important + n.important + o.important;
      return s === 0 || s === 4;
    }
    return !1;
  }
  getValue() {
    const t = new Ut.List(), r = this.sides, n = [
      r.top,
      r.right,
      r.bottom,
      r.left
    ], o = [
      Ut.generate(r.top.node),
      Ut.generate(r.right.node),
      Ut.generate(r.bottom.node),
      Ut.generate(r.left.node)
    ];
    o[Or] === o[B3] && (n.pop(), o[Pn] === o[_t] && (n.pop(), o[B3] === o[_t] && n.pop()));
    for (let s = 0; s < n.length; s++)
      t.appendData(n[s].node);
    return this.iehack && t.appendData({
      type: "Identifier",
      loc: null,
      name: this.iehack
    }), {
      type: "Value",
      loc: null,
      children: t
    };
  }
  getDeclaration() {
    return {
      type: "Declaration",
      loc: this.loc,
      important: this.sides.top.important,
      property: this.name,
      value: this.getValue()
    };
  }
}
function f80(e, t, r, n) {
  const o = e.block.children, s = e.prelude.children.first.id;
  return e.block.children.forEachRight(function(i, l) {
    const c = i.property;
    if (!G6.hasOwnProperty(c))
      return;
    const a = G6[c];
    let u, h;
    if ((!n || s === n) && a in t && (h = u80, u = t[a]), (!u || !u.add(c, i)) && (h = wm, u = new m80(a), !u.add(c, i))) {
      n = null;
      return;
    }
    t[a] = u, r.push({
      operation: h,
      block: o,
      item: l,
      shorthand: u
    }), n = s;
  }), n;
}
function d80(e, t) {
  e.forEach(function(r) {
    const n = r.shorthand;
    !n.isOkToMinimize() || (r.operation === wm ? r.item.data = t(n.getDeclaration()) : r.block.remove(r.item));
  });
}
function p80(e, t) {
  const r = {}, n = [];
  Ut.walk(e, {
    visit: "Rule",
    reverse: !0,
    enter(o) {
      const s = this.block || this.stylesheet, i = (o.pseudoSignature || "") + "|" + o.prelude.children.first.id;
      let l, c;
      r.hasOwnProperty(s.id) ? l = r[s.id] : (l = {
        lastShortSelector: null
      }, r[s.id] = l), l.hasOwnProperty(i) ? c = l[i] : (c = {}, l[i] = c), l.lastShortSelector = f80.call(this, o, c, n, l.lastShortSelector);
    }
  }), d80(n, t.declaration);
}
var g80 = p80;
const Ke = X;
let k80 = 1;
const v80 = /* @__PURE__ */ new Set([
  "src"
]), W6 = {
  display: /table|ruby|flex|-(flex)?box$|grid|contents|run-in/i,
  "text-align": /^(start|end|match-parent|justify-all)$/i
}, V6 = {
  cursor: [
    "auto",
    "crosshair",
    "default",
    "move",
    "text",
    "wait",
    "help",
    "n-resize",
    "e-resize",
    "s-resize",
    "w-resize",
    "ne-resize",
    "nw-resize",
    "se-resize",
    "sw-resize",
    "pointer",
    "progress",
    "not-allowed",
    "no-drop",
    "vertical-text",
    "all-scroll",
    "col-resize",
    "row-resize"
  ],
  overflow: [
    "hidden",
    "visible",
    "scroll",
    "auto"
  ],
  position: [
    "static",
    "relative",
    "absolute",
    "fixed"
  ]
}, X6 = {
  "border-width": ["border"],
  "border-style": ["border"],
  "border-color": ["border"],
  "border-top": ["border"],
  "border-right": ["border"],
  "border-bottom": ["border"],
  "border-left": ["border"],
  "border-top-width": ["border-top", "border-width", "border"],
  "border-right-width": ["border-right", "border-width", "border"],
  "border-bottom-width": ["border-bottom", "border-width", "border"],
  "border-left-width": ["border-left", "border-width", "border"],
  "border-top-style": ["border-top", "border-style", "border"],
  "border-right-style": ["border-right", "border-style", "border"],
  "border-bottom-style": ["border-bottom", "border-style", "border"],
  "border-left-style": ["border-left", "border-style", "border"],
  "border-top-color": ["border-top", "border-color", "border"],
  "border-right-color": ["border-right", "border-color", "border"],
  "border-bottom-color": ["border-bottom", "border-color", "border"],
  "border-left-color": ["border-left", "border-color", "border"],
  "margin-top": ["margin"],
  "margin-right": ["margin"],
  "margin-bottom": ["margin"],
  "margin-left": ["margin"],
  "padding-top": ["padding"],
  "padding-right": ["padding"],
  "padding-bottom": ["padding"],
  "padding-left": ["padding"],
  "font-style": ["font"],
  "font-variant": ["font"],
  "font-weight": ["font"],
  "font-size": ["font"],
  "font-family": ["font"],
  "list-style-type": ["list-style"],
  "list-style-position": ["list-style"],
  "list-style-image": ["list-style"]
};
function Lm(e, t, r) {
  const n = Ke.property(e).basename;
  if (n === "background")
    return e + ":" + Ke.generate(t.value);
  const o = t.id;
  let s = r[o];
  if (!s) {
    switch (t.value.type) {
      case "Value":
        const i = {};
        let l = "", c = "", a = !1;
        t.value.children.forEach(function u(h) {
          switch (h.type) {
            case "Value":
            case "Brackets":
            case "Parentheses":
              h.children.forEach(u);
              break;
            case "Raw":
              a = !0;
              break;
            case "Identifier": {
              const { name: m } = h;
              l || (l = Ke.keyword(m).vendor), /\\[09]/.test(m) && (c = RegExp.lastMatch), V6.hasOwnProperty(n) ? V6[n].indexOf(m) === -1 && (i[m] = !0) : W6.hasOwnProperty(n) && W6[n].test(m) && (i[m] = !0);
              break;
            }
            case "Function": {
              let { name: m } = h;
              l || (l = Ke.keyword(m).vendor), m === "rect" && (h.children.some(
                (d) => d.type === "Operator" && d.value === ","
              ) || (m = "rect-backward")), i[m + "()"] = !0, h.children.forEach(u);
              break;
            }
            case "Dimension": {
              const { unit: m } = h;
              switch (/\\[09]/.test(m) && (c = RegExp.lastMatch), m) {
                case "rem":
                case "vw":
                case "vh":
                case "vmin":
                case "vmax":
                case "vm":
                  i[m] = !0;
                  break;
              }
              break;
            }
          }
        }), s = a ? "!" + k80++ : "!" + Object.keys(i).sort() + "|" + c + l;
        break;
      case "Raw":
        s = "!" + t.value.value;
        break;
      default:
        s = Ke.generate(t.value);
    }
    r[o] = s;
  }
  return e + s;
}
function y80(e, t, r) {
  const n = Ke.property(t.property);
  if (X6.hasOwnProperty(n.basename)) {
    const o = X6[n.basename];
    for (const s of o) {
      const i = Lm(n.prefix + s, t, r), l = e.hasOwnProperty(i) ? e[i] : null;
      if (l && (!t.important || l.item.data.important))
        return l;
    }
  }
}
function b80(e, t, r, n, o) {
  const s = e.block.children;
  s.forEachRight(function(i, l) {
    const { property: c } = i, a = Lm(c, i, o), u = n[a];
    u && !v80.has(c) ? i.important && !u.item.data.important ? (n[a] = {
      block: s,
      item: l
    }, u.block.remove(u.item)) : s.remove(l) : y80(n, i, o) ? s.remove(l) : (i.fingerprint = a, n[a] = {
      block: s,
      item: l
    });
  }), s.isEmpty && r.remove(t);
}
function x80(e) {
  const t = {}, r = /* @__PURE__ */ Object.create(null);
  Ke.walk(e, {
    visit: "Rule",
    reverse: !0,
    enter(n, o, s) {
      const i = this.block || this.stylesheet, l = (n.pseudoSignature || "") + "|" + n.prelude.children.first.id;
      let c, a;
      t.hasOwnProperty(i.id) ? c = t[i.id] : (c = {}, t[i.id] = c), c.hasOwnProperty(l) ? a = c[l] : (a = {}, c[l] = a), b80.call(this, n, o, s, a, r);
    }
  });
}
var w80 = x80;
const L80 = X, Y6 = ee;
function z80(e, t, r) {
  const n = e.prelude.children, o = e.block.children, s = n.first.compareMarker, i = {};
  r.nextUntil(t.next, function(l, c) {
    if (l.type !== "Rule")
      return Y6.unsafeToSkipNode.call(n, l);
    if (e.pseudoSignature !== l.pseudoSignature)
      return !0;
    const a = l.prelude.children.head, u = l.block.children, h = a.data.compareMarker;
    if (h in i)
      return !0;
    if (n.head === n.tail && n.first.id === a.data.id) {
      o.appendList(u), r.remove(c);
      return;
    }
    if (Y6.isEqualDeclarations(o, u)) {
      const m = a.data.id;
      n.some((f, d) => {
        const k = f.id;
        if (m < k)
          return n.insert(a, d), !0;
        if (!d.next)
          return n.insert(a), !0;
      }), r.remove(c);
      return;
    }
    if (h === s)
      return !0;
    i[h] = !0;
  });
}
function C80(e) {
  L80.walk(e, {
    visit: "Rule",
    enter: z80
  });
}
var S80 = C80;
const Jo = X, Fe = ee;
function Nn(e) {
  return e.reduce((t, r) => t + r.id.length + 1, 0) - 1;
}
function Dn(e) {
  let t = 0;
  for (const r of e)
    t += r.length;
  return t + e.length - 1;
}
function $80(e, t, r) {
  const n = this.block !== null ? this.block.avoidRulesMerge : !1, o = e.prelude.children, s = e.block, i = /* @__PURE__ */ Object.create(null);
  let l = !0, c = !0;
  r.prevUntil(t.prev, function(a, u) {
    const h = a.block, m = a.type;
    if (m !== "Rule") {
      const k = Fe.unsafeToSkipNode.call(o, a);
      return !k && m === "Atrule" && h && Jo.walk(h, {
        visit: "Rule",
        enter(b) {
          b.prelude.children.forEach((w) => {
            i[w.compareMarker] = !0;
          });
        }
      }), k;
    }
    if (e.pseudoSignature !== a.pseudoSignature)
      return !0;
    const f = a.prelude.children;
    if (c = !f.some(
      (k) => k.compareMarker in i
    ), !c && !l)
      return !0;
    if (l && Fe.isEqualSelectors(f, o))
      return h.children.appendList(s.children), r.remove(t), !0;
    const d = Fe.compareDeclarations(s.children, h.children);
    if (d.eq.length) {
      if (!d.ne1.length && !d.ne2.length)
        return c && (Fe.addSelectors(o, f), r.remove(u)), !0;
      if (!n)
        if (d.ne1.length && !d.ne2.length) {
          const k = Nn(o), b = Dn(d.eq);
          l && k < b && (Fe.addSelectors(f, o), s.children.fromArray(d.ne1));
        } else if (!d.ne1.length && d.ne2.length) {
          const k = Nn(f), b = Dn(d.eq);
          c && k < b && (Fe.addSelectors(o, f), h.children.fromArray(d.ne2));
        } else {
          const k = {
            type: "SelectorList",
            loc: null,
            children: Fe.addSelectors(f.copy(), o)
          }, b = Nn(k.children) + 2;
          if (Dn(d.eq) >= b) {
            const L = r.createItem({
              type: "Rule",
              loc: null,
              prelude: k,
              block: {
                type: "Block",
                loc: null,
                children: new Jo.List().fromArray(d.eq)
              },
              pseudoSignature: e.pseudoSignature
            });
            return s.children.fromArray(d.ne1), h.children.fromArray(d.ne2overrided), l ? r.insert(L, u) : r.insert(L, t), !0;
          }
        }
    }
    l && (l = !f.some(
      (k) => o.some(
        (b) => b.compareMarker === k.compareMarker
      )
    )), f.forEach((k) => {
      i[k.compareMarker] = !0;
    });
  });
}
function A80(e) {
  Jo.walk(e, {
    visit: "Rule",
    reverse: !0,
    enter: $80
  });
}
var M80 = A80;
const j80 = Wr0, E80 = Kr0, T80 = i80, P80 = c80, N80 = g80, D80 = w80, O80 = S80, R80 = M80;
function I80(e, t) {
  const r = j80(e, t);
  t.logger("prepare", e), E80(e, t), t.logger("mergeAtrule", e), T80(e), t.logger("initialMergeRuleset", e), P80(e), t.logger("disjoinRuleset", e), N80(e, r), t.logger("restructShorthand", e), D80(e), t.logger("restructBlock", e), O80(e), t.logger("mergeRuleset", e), R80(e), t.logger("restructRuleset", e);
}
var _80 = I80;
const R1 = X, F80 = hm, B80 = E70, Z80 = Tr0, q80 = _80;
function U80(e, t) {
  const r = new R1.List();
  let n = !1, o;
  return e.nextUntil(e.head, (s, i, l) => {
    if (s.type === "Comment") {
      if (!t || s.value.charAt(0) !== "!") {
        l.remove(i);
        return;
      }
      if (n || o)
        return !0;
      l.remove(i), o = s;
      return;
    }
    s.type !== "WhiteSpace" && (n = !0), r.insert(l.remove(i));
  }), {
    comment: o,
    stylesheet: {
      type: "StyleSheet",
      loc: null,
      children: r
    }
  };
}
function H80(e, t, r, n) {
  n.logger(`Compress block #${r}`, null, !0);
  let o = 1;
  return e.type === "StyleSheet" && (e.firstAtrulesAllowed = t, e.id = o++), R1.walk(e, {
    visit: "Atrule",
    enter(s) {
      s.block !== null && (s.block.id = o++);
    }
  }), n.logger("init", e), B80(e, n), n.logger("clean", e), Z80(e), n.logger("replace", e), n.restructuring && q80(e, n), e;
}
function G80(e) {
  let t = "comments" in e ? e.comments : "exclamation";
  return typeof t == "boolean" ? t = t ? "exclamation" : !1 : t !== "exclamation" && t !== "first-exclamation" && (t = !1), t;
}
function W80(e) {
  return "restructure" in e ? e.restructure : "restructuring" in e ? e.restructuring : !0;
}
function V80(e) {
  return new R1.List().appendData({
    type: "Rule",
    loc: null,
    prelude: {
      type: "SelectorList",
      loc: null,
      children: new R1.List().appendData({
        type: "Selector",
        loc: null,
        children: new R1.List().appendData({
          type: "TypeSelector",
          loc: null,
          name: "x"
        })
      })
    },
    block: e
  });
}
function X80(e, t) {
  e = e || { type: "StyleSheet", loc: null, children: new R1.List() }, t = t || {};
  const r = {
    logger: typeof t.logger == "function" ? t.logger : function() {
    },
    restructuring: W80(t),
    forceMediaMerge: Boolean(t.forceMediaMerge),
    usage: t.usage ? F80.buildIndex(t.usage) : !1
  }, n = new R1.List();
  let o = G80(t), s = !0, i, l, c = 1, a;
  t.clone && (e = R1.clone(e)), e.type === "StyleSheet" ? (i = e.children, e.children = n) : i = V80(e);
  do {
    if (l = U80(i, Boolean(o)), H80(l.stylesheet, s, c++, r), a = l.stylesheet.children, l.comment && (n.isEmpty || n.insert(R1.List.createItem({
      type: "Raw",
      value: `
`
    })), n.insert(R1.List.createItem(l.comment)), a.isEmpty || n.insert(R1.List.createItem({
      type: "Raw",
      value: `
`
    }))), s && !a.isEmpty) {
      const u = a.last;
      (u.type !== "Atrule" || u.name !== "import" && u.name !== "charset") && (s = !1);
    }
    o !== "exclamation" && (o = !1), n.appendList(a);
  } while (!i.isEmpty);
  return {
    ast: e
  };
}
var Y80 = X80;
const Yt = X, K80 = Y80, Q80 = km;
function K6(e) {
  const t = Yt.string.encode(e, !0), r = Yt.string.encode(e);
  return t.length < r.length ? t : r;
}
const {
  lexer: J80,
  tokenize: e40,
  parse: t40,
  generate: r40,
  walk: n40,
  find: o40,
  findLast: s40,
  findAll: i40,
  fromPlainObject: a40,
  toPlainObject: l40
} = Yt.fork({
  node: {
    String: {
      generate(e) {
        this.token(Yt.tokenTypes.String, K6(e.value));
      }
    },
    Url: {
      generate(e) {
        const t = Yt.url.encode(e.value), r = K6(e.value);
        this.token(
          Yt.tokenTypes.Url,
          t.length <= r.length + 5 ? t : "url(" + r + ")"
        );
      }
    }
  }
});
f1.compress = K80;
f1.specificity = Q80;
f1.find = o40;
f1.findAll = i40;
f1.findLast = s40;
f1.fromPlainObject = a40;
f1.generate = r40;
f1.lexer = J80;
f1.parse = t40;
f1.toPlainObject = l40;
f1.tokenize = e40;
f1.walk = n40;
var De = {};
const c40 = vm, w3 = ee;
De.processSelector = c40;
De.addSelectors = w3.addSelectors;
De.compareDeclarations = w3.compareDeclarations;
De.hasSimilarSelectors = w3.hasSimilarSelectors;
De.isEqualDeclarations = w3.isEqualDeclarations;
De.isEqualSelectors = w3.isEqualSelectors;
De.unsafeToSkipNode = w3.unsafeToSkipNode;
const u40 = EV, zm = f1, h40 = De, { parse: m40, generate: e9, compress: f40 } = zm;
function Ft(e, t, r, n) {
  return t.debug && console.error(`## ${e} done in %d ms
`, Date.now() - r), n;
}
function d40(e) {
  let t;
  return function(n, o) {
    let s = n;
    if (o && (s = `[${((Date.now() - t) / 1e3).toFixed(3)}s] ${s}`), e > 1 && o) {
      let i = e9(o);
      e === 2 && i.length > 256 && (i = i.substr(0, 256) + "..."), s += `
  ${i}
`;
    }
    console.error(s), t = Date.now();
  };
}
function p40(e) {
  return e = { ...e }, typeof e.logger != "function" && e.debug && (e.logger = d40(e.debug)), e;
}
function Q6(e, t, r) {
  Array.isArray(r) || (r = [r]), r.forEach((n) => n(e, t));
}
function Cm(e, t, r) {
  r = r || {};
  const n = r.filename || "<unknown>";
  let o;
  const s = Ft(
    "parsing",
    r,
    Date.now(),
    m40(t, {
      context: e,
      filename: n,
      positions: Boolean(r.sourceMap)
    })
  );
  r.beforeCompress && Ft(
    "beforeCompress",
    r,
    Date.now(),
    Q6(s, r, r.beforeCompress)
  );
  const i = Ft(
    "compress",
    r,
    Date.now(),
    f40(s, p40(r))
  );
  return r.afterCompress && Ft(
    "afterCompress",
    r,
    Date.now(),
    Q6(i, r, r.afterCompress)
  ), r.sourceMap ? o = Ft("generate(sourceMap: true)", r, Date.now(), (() => {
    const l = e9(i.ast, { sourceMap: !0 });
    return l.map._file = n, l.map.setSourceContent(n, t), l;
  })()) : o = Ft("generate", r, Date.now(), {
    css: e9(i.ast),
    map: null
  }), o;
}
function g40(e, t) {
  return Cm("stylesheet", e, t);
}
function k40(e, t) {
  return Cm("declarationList", e, t);
}
Ne.version = u40.version;
Ne.syntax = zm;
Ne.utils = h40;
Ne.minify = g40;
Ne.minifyBlock = k40;
var d1 = {};
const m1 = d0, On = C7, {
  syntax: { specificity: v40 }
} = Ne, { visit: y40, matches: b40 } = a0, {
  attrsGroups: x40,
  inheritableAttrs: w40,
  presentationNonInheritableGroupAttrs: L40
} = C0, Rr = m1.walk.skip, J6 = (e, t) => {
  const r = [];
  e.block.children.forEach((o) => {
    o.type === "Declaration" && r.push({
      name: o.property,
      value: m1.generate(o.value),
      important: o.important === !0
    });
  });
  const n = [];
  return m1.walk(e.prelude, (o) => {
    if (o.type === "Selector") {
      const s = m1.clone(o);
      let i = !1;
      m1.walk(s, (l, c, a) => {
        l.type === "PseudoClassSelector" && (i = !0, a.remove(c));
      }), n.push({
        specificity: v40(o),
        dynamic: i || t,
        selector: m1.generate(s),
        declarations: r
      });
    }
  }), n;
}, z40 = (e, t) => {
  const r = [], n = m1.parse(e, {
    parseValue: !1,
    parseAtrulePrelude: !1
  });
  return m1.walk(n, (o) => {
    if (o.type === "Rule")
      return r.push(...J6(o, t || !1)), Rr;
    if (o.type === "Atrule")
      return o.name === "keyframes" || o.name === "-webkit-keyframes" || m1.walk(o, (s) => {
        if (s.type === "Rule")
          return r.push(...J6(s, t || !0)), Rr;
      }), Rr;
  }), r;
}, C40 = (e) => {
  const t = [], r = m1.parse(e, {
    context: "declarationList",
    parseValue: !1
  });
  return m1.walk(r, (n) => {
    n.type === "Declaration" && t.push({
      name: n.property,
      value: m1.generate(n.value),
      important: n.important === !0
    });
  }), t;
}, ea = (e, t) => {
  const r = {}, n = /* @__PURE__ */ new Map();
  for (const [s, i] of Object.entries(t.attributes))
    x40.presentation.includes(s) && (r[s] = { type: "static", inherited: !1, value: i }, n.set(s, !1));
  for (const { selector: s, declarations: i, dynamic: l } of e.rules)
    if (b40(t, s))
      for (const { name: c, value: a, important: u } of i) {
        const h = r[c];
        if (!(h && h.type === "dynamic")) {
          if (l) {
            r[c] = { type: "dynamic", inherited: !1 };
            continue;
          }
          (h == null || u === !0 || n.get(c) === !1) && (r[c] = { type: "static", inherited: !1, value: a }, n.set(c, u));
        }
      }
  const o = t.attributes.style == null ? [] : C40(t.attributes.style);
  for (const { name: s, value: i, important: l } of o) {
    const c = r[s];
    c && c.type === "dynamic" || (c == null || l === !0 || n.get(s) === !1) && (r[s] = { type: "static", inherited: !1, value: i }, n.set(s, l));
  }
  return r;
}, Sm = (e, t) => {
  for (let r = 0; r < 4; r += 1) {
    if (e[r] < t[r])
      return -1;
    if (e[r] > t[r])
      return 1;
  }
  return 0;
};
d1.compareSpecificity = Sm;
const S40 = (e) => {
  const t = [], r = /* @__PURE__ */ new Map();
  return y40(e, {
    element: {
      enter: (n, o) => {
        if (r.set(n, o), n.name === "style") {
          const s = n.attributes.media != null && n.attributes.media !== "all";
          if (n.attributes.type == null || n.attributes.type === "" || n.attributes.type === "text/css") {
            const i = n.children;
            for (const l of i)
              (l.type === "text" || l.type === "cdata") && t.push(...z40(l.value, s));
          }
        }
      }
    }
  }), t.sort((n, o) => Sm(n.specificity, o.specificity)), { rules: t, parents: r };
};
d1.collectStylesheet = S40;
const $40 = (e, t) => {
  const { parents: r } = e, n = ea(e, t);
  let o = r.get(t);
  for (; o != null && o.type !== "root"; ) {
    const s = ea(e, o);
    for (const [i, l] of Object.entries(s))
      n[i] == null && w40.includes(i) === !0 && L40.includes(i) === !1 && (n[i] = { ...l, inherited: !0 });
    o = r.get(o);
  }
  return n;
};
d1.computeStyle = $40;
const A40 = (e, t, r = null, n = !1) => {
  const o = typeof e == "string" ? On.parse(e) : On.parse(m1.generate(e.data));
  for (const s of o)
    if (s.some((l, c) => n && (c === s.length - 1 || !On.isTraversal(s[c + 1])) || l.type !== "attribute" || l.name !== t ? !1 : r == null ? !0 : l.value === r))
      return !0;
  return !1;
};
d1.includesAttrSelector = A40;
const b1 = d0, {
  syntax: { specificity: ta }
} = Ne, {
  visitSkip: M40,
  querySelectorAll: j40,
  detachNodeFromParent: E40
} = a0, { compareSpecificity: T40, includesAttrSelector: Rn } = d1, { attrsGroups: P40 } = C0;
N7.name = "inlineStyles";
N7.description = "inline styles (additional options)";
N7.fn = (e, t) => {
  const {
    onlyMatchedOnce: r = !0,
    removeMatchedSelectors: n = !0,
    useMqs: o = ["", "screen"],
    usePseudos: s = [""]
  } = t, i = [];
  let l = [];
  return {
    element: {
      enter: (c, a) => {
        if (c.name === "foreignObject")
          return M40;
        if (c.name !== "style" || c.children.length === 0 || c.attributes.type != null && c.attributes.type !== "" && c.attributes.type !== "text/css")
          return;
        const u = c.children.filter((m) => m.type === "text" || m.type === "cdata").map((m) => m.value).join("");
        let h = null;
        try {
          h = b1.parse(u, {
            parseValue: !1,
            parseCustomProperty: !1
          });
        } catch {
          return;
        }
        h.type === "StyleSheet" && i.push({ node: c, parentNode: a, cssAst: h }), b1.walk(h, {
          visit: "Selector",
          enter(m, f) {
            const d = this.atrule, k = this.rule;
            if (k == null)
              return;
            let b = "";
            if (d != null && (b = d.name, d.prelude != null && (b += ` ${b1.generate(d.prelude)}`)), !o.includes(b))
              return;
            const w = [];
            m.type === "Selector" && m.children.forEach((A, C, g) => {
              (A.type === "PseudoClassSelector" || A.type === "PseudoElementSelector") && w.push({ item: C, list: g });
            });
            const L = b1.generate({
              type: "Selector",
              children: new b1.List().fromArray(
                w.map((A) => A.item.data)
              )
            });
            if (!!s.includes(L)) {
              for (const A of w)
                A.list.remove(A.item);
              l.push({ node: m, item: f, rule: k });
            }
          }
        });
      }
    },
    root: {
      exit: () => {
        var a;
        if (i.length === 0)
          return;
        const c = l.slice().sort((u, h) => {
          const m = ta(u.item.data), f = ta(h.item.data);
          return T40(m, f);
        }).reverse();
        for (const u of c) {
          const h = b1.generate(u.item.data), m = [];
          try {
            for (const f of j40(e, h))
              f.type === "element" && m.push(f);
          } catch {
            continue;
          }
          if (m.length !== 0 && !(r && m.length > 1)) {
            for (const f of m) {
              const d = b1.parse(
                (a = f.attributes.style) != null ? a : "",
                {
                  context: "declarationList",
                  parseValue: !1
                }
              );
              if (d.type !== "DeclarationList")
                continue;
              const k = /* @__PURE__ */ new Map();
              let b;
              b1.walk(d, {
                visit: "Declaration",
                enter(L, A) {
                  b == null && (b = A), k.set(L.property.toLowerCase(), A);
                }
              }), b1.walk(u.rule, {
                visit: "Declaration",
                enter(L) {
                  const A = L.property;
                  P40.presentation.includes(A) && !l.some(
                    (M) => Rn(M.item, A)
                  ) && delete f.attributes[A];
                  const C = k.get(A), g = d.children.createItem(L);
                  C == null ? d.children.insert(
                    g,
                    b
                  ) : C.data.important !== !0 && L.important === !0 && (d.children.replace(
                    C,
                    g
                  ), k.set(A, g));
                }
              });
              const w = b1.generate(d);
              w.length !== 0 && (f.attributes.style = w);
            }
            n && m.length !== 0 && u.rule.prelude.type === "SelectorList" && u.rule.prelude.children.remove(u.item), u.matchedElements = m;
          }
        }
        if (!!n) {
          for (const u of c)
            if (u.matchedElements != null && !(r && u.matchedElements.length > 1))
              for (const h of u.matchedElements) {
                const m = new Set(
                  h.attributes.class == null ? null : h.attributes.class.split(" ")
                );
                for (const d of u.node.children)
                  d.type === "ClassSelector" && !l.some(
                    (k) => Rn(k.item, "class", d.name, !0)
                  ) && m.delete(d.name);
                m.size === 0 ? delete h.attributes.class : h.attributes.class = Array.from(m).join(" ");
                const f = u.node.children.first;
                (f == null ? void 0 : f.type) === "IdSelector" && h.attributes.id === f.name && !l.some(
                  (d) => Rn(
                    d.item,
                    "id",
                    f.name,
                    !0
                  )
                ) && delete h.attributes.id;
              }
          for (const u of i)
            if (b1.walk(u.cssAst, {
              visit: "Rule",
              enter: function(h, m, f) {
                h.type === "Rule" && h.prelude.type === "SelectorList" && h.prelude.children.isEmpty && f.remove(m);
              }
            }), u.cssAst.children.isEmpty)
              E40(u.node, u.parentNode);
            else {
              const h = u.node.children[0];
              (h.type === "text" || h.type === "cdata") && (h.value = b1.generate(u.cssAst));
            }
        }
      }
    }
  };
};
var q7 = {}, Z0 = {};
const { attrsGroups: Z3 } = C0;
Z0.encodeSVGDatauri = (e, t) => {
  var r = "data:image/svg+xml";
  return !t || t === "base64" ? (r += ";base64,", e = r + Buffer.from(e).toString("base64")) : t === "enc" ? e = r + "," + encodeURIComponent(e) : t === "unenc" && (e = r + "," + e), e;
};
Z0.decodeSVGDatauri = (e) => {
  var t = /data:image\/svg\+xml(;charset=[^;,]*)?(;base64)?,(.*)/, r = t.exec(e);
  if (!r)
    return e;
  var n = r[3];
  return r[2] ? e = Buffer.from(n, "base64").toString("utf8") : n.charAt(0) === "%" ? e = decodeURIComponent(n) : n.charAt(0) === "<" && (e = n), e;
};
Z0.cleanupOutData = (e, t, r) => {
  let n = "", o, s;
  return e.forEach((i, l) => {
    if (o = " ", l == 0 && (o = ""), t.noSpaceAfterFlags && (r == "A" || r == "a")) {
      var c = l % 7;
      (c == 4 || c == 5) && (o = "");
    }
    const a = t.leadingZero ? $m(i) : i.toString();
    t.negativeExtraSpace && o != "" && (i < 0 || a.charAt(0) === "." && s % 1 !== 0) && (o = ""), s = i, n += o + a;
  }), n;
};
const $m = (e) => {
  var t = e.toString();
  return 0 < e && e < 1 && t.charAt(0) === "0" ? t = t.slice(1) : -1 < e && e < 0 && t.charAt(1) === "0" && (t = t.charAt(0) + t.slice(2)), t;
};
Z0.removeLeadingZero = $m;
const N40 = (e) => e.name === "script" && e.children.length !== 0 || e.name === "a" && Object.entries(e.attributes).some(
  ([n, o]) => (n === "href" || n.endsWith(":href")) && o != null && o.trimStart().startsWith("javascript:")
) ? !0 : [
  ...Z3.animationEvent,
  ...Z3.documentEvent,
  ...Z3.documentElementEvent,
  ...Z3.globalEvent,
  ...Z3.graphicalEvent
].some((r) => e.attributes[r] != null);
Z0.hasScripts = N40;
const D40 = (e) => /\burl\((["'])?#(.+?)\1\)/g.test(e);
Z0.includesUrlReference = D40;
const ra = Ne, { detachNodeFromParent: O40 } = a0, { hasScripts: R40 } = Z0;
q7.name = "minifyStyles";
q7.description = "minifies styles and removes unused styles";
q7.fn = (e, { usage: t, ...r }) => {
  const n = /* @__PURE__ */ new Map(), o = [], s = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set();
  let c = !0, a = !0, u = !0, h = !1;
  typeof t == "boolean" ? (c = t, a = t, u = t) : t && (c = t.tags == null ? !0 : t.tags, a = t.ids == null ? !0 : t.ids, u = t.classes == null ? !0 : t.classes, h = t.force == null ? !1 : t.force);
  let m = !1;
  return {
    element: {
      enter: (f, d) => {
        if (R40(f) && (m = !0), s.add(f.name), f.attributes.id != null && i.add(f.attributes.id), f.attributes.class != null)
          for (const k of f.attributes.class.split(/\s+/))
            l.add(k);
        f.name === "style" && f.children.length !== 0 ? n.set(f, d) : f.attributes.style != null && o.push(f);
      }
    },
    root: {
      exit: () => {
        const f = {};
        (!m || h) && (c && (f.tags = Array.from(s)), a && (f.ids = Array.from(i)), u && (f.classes = Array.from(l)));
        for (const [d, k] of n.entries())
          if (d.children[0].type === "text" || d.children[0].type === "cdata") {
            const b = d.children[0].value, w = ra.minify(b, {
              ...r,
              usage: f
            }).css;
            if (w.length === 0) {
              O40(d, k);
              continue;
            }
            b.indexOf(">") >= 0 || b.indexOf("<") >= 0 ? (d.children[0].type = "cdata", d.children[0].value = w) : (d.children[0].type = "text", d.children[0].value = w);
          }
        for (const d of o) {
          const k = d.attributes.style;
          d.attributes.style = ra.minifyBlock(k, {
            ...r
          }).css;
        }
      }
    }
  };
};
var U7 = {};
const { visitSkip: I40 } = a0, { hasScripts: _40 } = Z0, { referencesProps: F40 } = C0;
U7.name = "cleanupIds";
U7.description = "removes unused IDs and minifies used";
const B40 = /\burl\((["'])?#(.+?)\1\)/g, Z40 = /^#(.+?)$/, q40 = /(\w+)\.[a-zA-Z]/, Am = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z"
], na = Am.length - 1, U40 = (e, t) => {
  for (const r of t)
    if (e.startsWith(r))
      return !0;
  return !1;
}, H40 = (e) => {
  if (e == null)
    return [0];
  e[e.length - 1] += 1;
  for (let t = e.length - 1; t > 0; t--)
    e[t] > na && (e[t] = 0, e[t - 1] !== void 0 && e[t - 1]++);
  return e[0] > na && (e[0] = 0, e.unshift(0)), e;
}, G40 = (e) => e.map((t) => Am[t]).join("");
U7.fn = (e, t) => {
  const {
    remove: r = !0,
    minify: n = !0,
    preserve: o = [],
    preservePrefixes: s = [],
    force: i = !1
  } = t, l = new Set(
    Array.isArray(o) ? o : o ? [o] : []
  ), c = Array.isArray(s) ? s : s ? [s] : [], a = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map();
  let h = !1;
  return {
    element: {
      enter: (m) => {
        if (!i) {
          if (m.name === "style" && m.children.length !== 0 || _40(m)) {
            h = !0;
            return;
          }
          if (m.name === "svg") {
            let f = !0;
            for (const d of m.children)
              if (d.type !== "element" || d.name !== "defs") {
                f = !1;
                break;
              }
            if (f)
              return I40;
          }
        }
        for (const [f, d] of Object.entries(m.attributes))
          if (f === "id") {
            const k = d;
            a.has(k) ? delete m.attributes.id : a.set(k, m);
          } else {
            let k = [];
            if (F40.includes(f)) {
              const b = d.matchAll(B40);
              for (const w of b)
                k.push(w[2]);
            }
            if (f === "href" || f.endsWith(":href")) {
              const b = d.match(Z40);
              b != null && k.push(b[1]);
            }
            if (f === "begin") {
              const b = d.match(q40);
              b != null && k.push(b[1]);
            }
            for (const b of k) {
              let w = u.get(b);
              w == null && (w = [], u.set(b, w)), w.push({ element: m, name: f });
            }
          }
      }
    },
    root: {
      exit: () => {
        if (h)
          return;
        const m = (d) => l.has(d) || U40(d, c);
        let f = null;
        for (const [d, k] of u) {
          const b = a.get(d);
          if (b != null) {
            if (n && m(d) === !1) {
              let w = null;
              do
                f = H40(f), w = G40(f);
              while (m(w) || u.has(w) && a.get(w) == null);
              b.attributes.id = w;
              for (const { element: L, name: A } of k) {
                const C = L.attributes[A];
                C.includes("#") ? L.attributes[A] = C.replace(
                  `#${d}`,
                  `#${w}`
                ) : L.attributes[A] = C.replace(
                  `${d}.`,
                  `${w}.`
                );
              }
            }
            a.delete(d);
          }
        }
        if (r)
          for (const [d, k] of a)
            m(d) === !1 && delete k.attributes.id;
      }
    }
  };
};
var H7 = {};
const { detachNodeFromParent: oa } = a0, { elemsGroups: W40 } = C0;
H7.name = "removeUselessDefs";
H7.description = "removes elements in <defs> without id";
H7.fn = () => ({
  element: {
    enter: (e, t) => {
      if (e.name === "defs") {
        const r = [];
        Mm(e, r), r.length === 0 && oa(e, t);
        for (const n of r)
          Object.defineProperty(n, "parentNode", {
            writable: !0,
            value: e
          });
        e.children = r;
      } else
        W40.nonRendering.includes(e.name) && e.attributes.id == null && oa(e, t);
    }
  }
});
const Mm = (e, t) => {
  for (const r of e.children)
    r.type === "element" && (r.attributes.id != null || r.name === "style" ? t.push(r) : Mm(r, t));
};
var G7 = {};
const { removeLeadingZero: V40 } = Z0;
G7.name = "cleanupNumericValues";
G7.description = "rounds numeric values to the fixed precision, removes default \u2018px\u2019 units";
const X40 = /^([-+]?\d*\.?\d+([eE][-+]?\d+)?)(px|pt|pc|mm|cm|m|in|ft|em|ex|%)?$/, sa = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  in: 96,
  pt: 4 / 3,
  pc: 16,
  px: 1
};
G7.fn = (e, t) => {
  const {
    floatPrecision: r = 3,
    leadingZero: n = !0,
    defaultPx: o = !0,
    convertToPx: s = !0
  } = t;
  return {
    element: {
      enter: (i) => {
        if (i.attributes.viewBox != null) {
          const l = i.attributes.viewBox.split(/\s,?\s*|,\s*/g);
          i.attributes.viewBox = l.map((c) => {
            const a = Number(c);
            return Number.isNaN(a) ? c : Number(a.toFixed(r));
          }).join(" ");
        }
        for (const [l, c] of Object.entries(i.attributes)) {
          if (l === "version")
            continue;
          const a = c.match(X40);
          if (a) {
            let u = Number(Number(a[1]).toFixed(r)), m = a[3] || "";
            if (s && m !== "" && m in sa) {
              const d = Number(
                (sa[m] * Number(a[1])).toFixed(
                  r
                )
              );
              d.toString().length < a[0].length && (u = d, m = "px");
            }
            let f;
            n ? f = V40(u) : f = u.toString(), o && m === "px" && (m = ""), i.attributes[l] = f + m;
          }
        }
      }
    }
  };
};
var W7 = {};
const q3 = C0;
W7.name = "convertColors";
W7.description = "converts colors: rgb() to #rrggbb and #rrggbb to #rgb";
const In = "([+-]?(?:\\d*\\.\\d+|\\d+\\.?)%?)", ia = "\\s*,\\s*", Y40 = new RegExp(
  "^rgb\\(\\s*" + In + ia + In + ia + In + "\\s*\\)$"
), K40 = /^#(([a-fA-F0-9])\2){3}$/, Q40 = ([e, t, r]) => "#" + ((256 + e << 8 | t) << 8 | r).toString(16).slice(1).toUpperCase();
W7.fn = (e, t) => {
  const {
    currentColor: r = !1,
    names2hex: n = !0,
    rgb2hex: o = !0,
    shorthex: s = !0,
    shortname: i = !0
  } = t;
  return {
    element: {
      enter: (l) => {
        for (const [c, a] of Object.entries(l.attributes))
          if (q3.colorsProps.includes(c)) {
            let u = a;
            if (r) {
              let h;
              typeof r == "string" ? h = u === r : r instanceof RegExp ? h = r.exec(u) != null : h = u !== "none", h && (u = "currentColor");
            }
            if (n) {
              const h = u.toLowerCase();
              q3.colorsNames[h] != null && (u = q3.colorsNames[h]);
            }
            if (o) {
              let h = u.match(Y40);
              if (h != null) {
                let m = h.slice(1, 4).map((f) => {
                  let d;
                  return f.indexOf("%") > -1 ? d = Math.round(parseFloat(f) * 2.55) : d = Number(f), Math.max(0, Math.min(d, 255));
                });
                u = Q40(m);
              }
            }
            if (s) {
              let h = u.match(K40);
              h != null && (u = "#" + h[0][1] + h[0][3] + h[0][5]);
            }
            if (i) {
              const h = u.toLowerCase();
              q3.colorsShortNames[h] != null && (u = q3.colorsShortNames[h]);
            }
            l.attributes[c] = u;
          }
      }
    }
  };
};
var V7 = {};
const { visitSkip: J40, detachNodeFromParent: aa } = a0, { collectStylesheet: en0, computeStyle: tn0 } = d1, {
  elems: rn0,
  attrsGroups: nn0,
  elemsGroups: on0,
  attrsGroupsDefaults: sn0,
  presentationNonInheritableGroupAttrs: in0
} = C0;
V7.name = "removeUnknownsAndDefaults";
V7.description = "removes unknown elements content and attributes, removes attrs with default values";
const t9 = /* @__PURE__ */ new Map(), jm = /* @__PURE__ */ new Map(), Em = /* @__PURE__ */ new Map();
for (const [e, t] of Object.entries(rn0)) {
  const r = /* @__PURE__ */ new Set();
  if (t.content)
    for (const s of t.content)
      r.add(s);
  if (t.contentGroups)
    for (const s of t.contentGroups) {
      const i = on0[s];
      if (i)
        for (const l of i)
          r.add(l);
    }
  const n = /* @__PURE__ */ new Set();
  if (t.attrs)
    for (const s of t.attrs)
      n.add(s);
  const o = /* @__PURE__ */ new Map();
  if (t.defaults)
    for (const [s, i] of Object.entries(t.defaults))
      o.set(s, i);
  for (const s of t.attrsGroups) {
    const i = nn0[s];
    if (i)
      for (const c of i)
        n.add(c);
    const l = sn0[s];
    if (l)
      for (const [c, a] of Object.entries(l))
        o.set(c, a);
  }
  t9.set(e, r), jm.set(e, n), Em.set(e, o);
}
V7.fn = (e, t) => {
  const {
    unknownContent: r = !0,
    unknownAttrs: n = !0,
    defaultAttrs: o = !0,
    uselessOverrides: s = !0,
    keepDataAttrs: i = !0,
    keepAriaAttrs: l = !0,
    keepRoleAttr: c = !1
  } = t, a = en0(e);
  return {
    element: {
      enter: (u, h) => {
        if (u.name.includes(":"))
          return;
        if (u.name === "foreignObject")
          return J40;
        if (r && h.type === "element") {
          const k = t9.get(
            h.name
          );
          if (k == null || k.size === 0) {
            if (t9.get(u.name) == null) {
              aa(u, h);
              return;
            }
          } else if (k.has(u.name) === !1) {
            aa(u, h);
            return;
          }
        }
        const m = jm.get(u.name), f = Em.get(u.name), d = h.type === "element" ? tn0(a, h) : null;
        for (const [k, b] of Object.entries(u.attributes))
          if (!(i && k.startsWith("data-")) && !(l && k.startsWith("aria-")) && !(c && k === "role") && k !== "xmlns") {
            if (k.includes(":")) {
              const [w] = k.split(":");
              if (w !== "xml" && w !== "xlink")
                continue;
            }
            if (n && m && m.has(k) === !1 && delete u.attributes[k], o && u.attributes.id == null && f && f.get(k) === b && (d == null ? void 0 : d[k]) == null && delete u.attributes[k], s && u.attributes.id == null) {
              const w = d == null ? void 0 : d[k];
              in0.includes(k) === !1 && w != null && w.type === "static" && w.value === b && delete u.attributes[k];
            }
          }
      }
    }
  };
};
var X7 = {};
const {
  inheritableAttrs: an0,
  attrsGroups: ln0,
  presentationNonInheritableGroupAttrs: cn0
} = C0;
X7.name = "removeNonInheritableGroupAttrs";
X7.description = "removes non-inheritable group\u2019s presentational attributes";
X7.fn = () => ({
  element: {
    enter: (e) => {
      if (e.name === "g")
        for (const t of Object.keys(e.attributes))
          ln0.presentation.includes(t) === !0 && an0.includes(t) === !1 && cn0.includes(t) === !1 && delete e.attributes[t];
    }
  }
});
var Y7 = {};
const { visit: un0, visitSkip: hn0, detachNodeFromParent: mn0 } = a0, { collectStylesheet: fn0, computeStyle: la } = d1, { hasScripts: dn0 } = Z0, { elemsGroups: pn0 } = C0;
Y7.name = "removeUselessStrokeAndFill";
Y7.description = "removes useless stroke and fill attributes";
Y7.fn = (e, t) => {
  const {
    stroke: r = !0,
    fill: n = !0,
    removeNone: o = !1
  } = t;
  let s = !1;
  if (un0(e, {
    element: {
      enter: (l) => {
        (l.name === "style" || dn0(l)) && (s = !0);
      }
    }
  }), s)
    return null;
  const i = fn0(e);
  return {
    element: {
      enter: (l, c) => {
        if (l.attributes.id != null)
          return hn0;
        if (pn0.shape.includes(l.name) == !1)
          return;
        const a = la(i, l), u = a.stroke, h = a["stroke-opacity"], m = a["stroke-width"], f = a["marker-end"], d = a.fill, k = a["fill-opacity"], b = c.type === "element" ? la(i, c) : null, w = b == null ? null : b.stroke;
        if (r && (u == null || u.type === "static" && u.value == "none" || h != null && h.type === "static" && h.value === "0" || m != null && m.type === "static" && m.value === "0") && (m != null && m.type === "static" && m.value === "0" || f == null)) {
          for (const L of Object.keys(l.attributes))
            L.startsWith("stroke") && delete l.attributes[L];
          w != null && w.type === "static" && w.value !== "none" && (l.attributes.stroke = "none");
        }
        if (n && (d != null && d.type === "static" && d.value === "none" || k != null && k.type === "static" && k.value === "0")) {
          for (const L of Object.keys(l.attributes))
            L.startsWith("fill-") && delete l.attributes[L];
          (d == null || d.type === "static" && d.value !== "none") && (l.attributes.fill = "none");
        }
        o && (u == null || l.attributes.stroke === "none") && (d != null && d.type === "static" && d.value === "none" || l.attributes.fill === "none") && mn0(l, c);
      }
    }
  };
};
var K7 = {};
K7.name = "removeViewBox";
K7.description = "removes viewBox attribute when possible";
const gn0 = ["svg", "pattern", "symbol"];
K7.fn = () => ({
  element: {
    enter: (e, t) => {
      if (gn0.includes(e.name) && e.attributes.viewBox != null && e.attributes.width != null && e.attributes.height != null) {
        if (e.name === "svg" && t.type !== "root")
          return;
        const r = e.attributes.viewBox.split(/[ ,]+/g);
        r[0] === "0" && r[1] === "0" && e.attributes.width.replace(/px$/, "") === r[2] && e.attributes.height.replace(/px$/, "") === r[3] && delete e.attributes.viewBox;
      }
    }
  }
});
var Q7 = {};
const { visit: kn0 } = a0;
Q7.name = "cleanupEnableBackground";
Q7.description = "remove or cleanup enable-background attribute when possible";
Q7.fn = (e) => {
  const t = /^new\s0\s0\s([-+]?\d*\.?\d+([eE][-+]?\d+)?)\s([-+]?\d*\.?\d+([eE][-+]?\d+)?)$/;
  let r = !1;
  return kn0(e, {
    element: {
      enter: (n) => {
        n.name === "filter" && (r = !0);
      }
    }
  }), {
    element: {
      enter: (n) => {
        if (n.attributes["enable-background"] != null)
          if (r) {
            if ((n.name === "svg" || n.name === "mask" || n.name === "pattern") && n.attributes.width != null && n.attributes.height != null) {
              const o = n.attributes["enable-background"].match(t);
              o != null && n.attributes.width === o[1] && n.attributes.height === o[3] && (n.name === "svg" ? delete n.attributes["enable-background"] : n.attributes["enable-background"] = "new");
            }
          } else
            delete n.attributes["enable-background"];
      }
    }
  };
};
var J7 = {}, L3 = {};
const { removeLeadingZero: vn0 } = Z0, Tm = {
  M: 2,
  m: 2,
  Z: 0,
  z: 0,
  L: 2,
  l: 2,
  H: 1,
  h: 1,
  V: 1,
  v: 1,
  C: 6,
  c: 6,
  S: 4,
  s: 4,
  Q: 4,
  q: 4,
  T: 2,
  t: 2,
  A: 7,
  a: 7
}, yn0 = (e) => e in Tm, bn0 = (e) => {
  const t = e.codePointAt(0);
  return t === 32 || t === 9 || t === 13 || t === 10;
}, xn0 = (e) => {
  const t = e.codePointAt(0);
  return t == null ? !1 : 48 <= t && t <= 57;
}, _n = (e, t) => {
  let r = t, n = "", o = "none";
  for (; r < e.length; r += 1) {
    const i = e[r];
    if (i === "+" || i === "-") {
      if (o === "none") {
        o = "sign", n += i;
        continue;
      }
      if (o === "e") {
        o = "exponent_sign", n += i;
        continue;
      }
    }
    if (xn0(i)) {
      if (o === "none" || o === "sign" || o === "whole") {
        o = "whole", n += i;
        continue;
      }
      if (o === "decimal_point" || o === "decimal") {
        o = "decimal", n += i;
        continue;
      }
      if (o === "e" || o === "exponent_sign" || o === "exponent") {
        o = "exponent", n += i;
        continue;
      }
    }
    if (i === "." && (o === "none" || o === "sign" || o === "whole")) {
      o = "decimal_point", n += i;
      continue;
    }
    if ((i === "E" || i == "e") && (o === "whole" || o === "decimal_point" || o === "decimal")) {
      o = "e", n += i;
      continue;
    }
    break;
  }
  const s = Number.parseFloat(n);
  return Number.isNaN(s) ? [t, null] : [r - 1, s];
}, wn0 = (e) => {
  const t = [];
  let r = null, n = [], o = 0, s = !1, i = !1;
  for (let l = 0; l < e.length; l += 1) {
    const c = e.charAt(l);
    if (bn0(c))
      continue;
    if (s && c === ",") {
      if (i)
        break;
      i = !0;
      continue;
    }
    if (yn0(c)) {
      if (i)
        return t;
      if (r == null) {
        if (c !== "M" && c !== "m")
          return t;
      } else if (n.length !== 0)
        return t;
      r = c, n = [], o = Tm[r], s = !1, o === 0 && t.push({ command: r, args: n });
      continue;
    }
    if (r == null)
      return t;
    let a = l, u = null;
    if (r === "A" || r === "a") {
      const h = n.length;
      (h === 0 || h === 1) && c !== "+" && c !== "-" && ([a, u] = _n(e, l)), (h === 2 || h === 5 || h === 6) && ([a, u] = _n(e, l)), (h === 3 || h === 4) && (c === "0" && (u = 0), c === "1" && (u = 1));
    } else
      [a, u] = _n(e, l);
    if (u == null)
      return t;
    n.push(u), s = !0, i = !1, l = a, n.length === o && (t.push({ command: r, args: n }), r === "M" && (r = "L"), r === "m" && (r = "l"), n = []);
  }
  return t;
};
L3.parsePathData = wn0;
const Ln0 = (e, t) => {
  if (t != null) {
    const r = 10 ** t;
    e = Math.round(e * r) / r;
  }
  return vn0(e);
}, zn0 = (e, t, r, n) => {
  let o = "", s = "";
  for (let i = 0; i < t.length; i += 1) {
    const l = t[i], c = Ln0(l, r);
    n && (e === "A" || e === "a") && (i % 7 === 4 || i % 7 === 5) || i === 0 || c.startsWith("-") || s.includes(".") && c.startsWith(".") ? o += c : o += ` ${c}`, s = c;
  }
  return o;
}, Cn0 = ({ pathData: e, precision: t, disableSpaceAfterFlags: r }) => {
  let n = [];
  for (let s = 0; s < e.length; s += 1) {
    const { command: i, args: l } = e[s];
    if (s === 0)
      n.push({ command: i, args: l });
    else {
      const c = n[n.length - 1];
      s === 1 && (i === "L" && (c.command = "M"), i === "l" && (c.command = "m")), c.command === i && c.command !== "M" && c.command !== "m" || c.command === "M" && i === "L" || c.command === "m" && i === "l" ? c.args = [...c.args, ...l] : n.push({ command: i, args: l });
    }
  }
  let o = "";
  for (const { command: s, args: i } of n)
    o += s + zn0(s, i, t, r);
  return o;
};
L3.stringifyPathData = Cn0;
const { elemsGroups: Sn0, referencesProps: $n0 } = C0, {
  visit: An0,
  visitSkip: ca,
  querySelector: ua,
  detachNodeFromParent: Ir
} = a0, { collectStylesheet: Mn0, computeStyle: ha } = d1, { parsePathData: jn0 } = L3, En0 = Sn0.nonRendering;
J7.name = "removeHiddenElems";
J7.description = "removes hidden elements (zero sized, with absent attributes)";
J7.fn = (e, t) => {
  const {
    isHidden: r = !0,
    displayNone: n = !0,
    opacity0: o = !0,
    circleR0: s = !0,
    ellipseRX0: i = !0,
    ellipseRY0: l = !0,
    rectWidth0: c = !0,
    rectHeight0: a = !0,
    patternWidth0: u = !0,
    patternHeight0: h = !0,
    imageWidth0: m = !0,
    imageHeight0: f = !0,
    pathEmptyD: d = !0,
    polylineEmptyPoints: k = !0,
    polygonEmptyPoints: b = !0
  } = t, w = Mn0(e), L = /* @__PURE__ */ new Map(), A = /* @__PURE__ */ new Set();
  function C(g, M) {
    g.type === "element" && g.attributes.id != null && M.type === "element" && M.name === "defs" && A.add(g.attributes.id), Ir(g, M);
  }
  return An0(e, {
    element: {
      enter: (g, M) => {
        if (En0.includes(g.name))
          return g.attributes.id == null ? (Ir(g, M), ca) : (L.set(g, M), ca);
        const P = ha(w, g);
        o && P.opacity && P.opacity.type === "static" && P.opacity.value === "0" && C(g, M);
      }
    }
  }), {
    element: {
      enter: (g, M) => {
        const P = ha(w, g);
        if (r && P.visibility && P.visibility.type === "static" && P.visibility.value === "hidden" && ua(g, "[visibility=visible]") == null) {
          C(g, M);
          return;
        }
        if (n && P.display && P.display.type === "static" && P.display.value === "none" && g.name !== "marker") {
          C(g, M);
          return;
        }
        if (s && g.name === "circle" && g.children.length === 0 && g.attributes.r === "0") {
          C(g, M);
          return;
        }
        if (i && g.name === "ellipse" && g.children.length === 0 && g.attributes.rx === "0") {
          C(g, M);
          return;
        }
        if (l && g.name === "ellipse" && g.children.length === 0 && g.attributes.ry === "0") {
          C(g, M);
          return;
        }
        if (c && g.name === "rect" && g.children.length === 0 && g.attributes.width === "0") {
          C(g, M);
          return;
        }
        if (a && c && g.name === "rect" && g.children.length === 0 && g.attributes.height === "0") {
          C(g, M);
          return;
        }
        if (u && g.name === "pattern" && g.attributes.width === "0") {
          C(g, M);
          return;
        }
        if (h && g.name === "pattern" && g.attributes.height === "0") {
          C(g, M);
          return;
        }
        if (m && g.name === "image" && g.attributes.width === "0") {
          C(g, M);
          return;
        }
        if (f && g.name === "image" && g.attributes.height === "0") {
          C(g, M);
          return;
        }
        if (d && g.name === "path") {
          if (g.attributes.d == null) {
            C(g, M);
            return;
          }
          const x = jn0(g.attributes.d);
          if (x.length === 0) {
            C(g, M);
            return;
          }
          if (x.length === 1 && P["marker-start"] == null && P["marker-end"] == null) {
            C(g, M);
            return;
          }
          return;
        }
        if (k && g.name === "polyline" && g.attributes.points == null) {
          C(g, M);
          return;
        }
        b && g.name === "polygon" && g.attributes.points == null && C(g, M);
      },
      exit: (g, M) => {
        if (g.name === "defs" && g.children.length === 0) {
          C(g, M);
          return;
        }
        if (g.name === "use") {
          Object.entries(g.attributes).some(
            ([x, j]) => (x === "href" || x.endsWith(":href")) && A.has(
              j.slice(j.indexOf("#") + 1).trim()
            )
          ) && Ir(g, M);
          return;
        }
        if (g.name === "svg" && M.type === "root")
          for (const [
            P,
            x
          ] of L.entries()) {
            const j = $n0.map(
              (y) => `[${y}="url(#${P.attributes.id})"]`
            ).join(",");
            ua(e, j) == null && Ir(g, x);
          }
      }
    }
  };
};
var er = {};
const { detachNodeFromParent: Fn } = a0;
er.name = "removeEmptyText";
er.description = "removes empty <text> elements";
er.fn = (e, t) => {
  const { text: r = !0, tspan: n = !0, tref: o = !0 } = t;
  return {
    element: {
      enter: (s, i) => {
        r && s.name === "text" && s.children.length === 0 && Fn(s, i), n && s.name === "tspan" && s.children.length === 0 && Fn(s, i), o && s.name === "tref" && s.attributes["xlink:href"] == null && Fn(s, i);
      }
    }
  };
};
var tr = {};
const { stringifyPathData: U3 } = L3, { detachNodeFromParent: Tn0 } = a0;
tr.name = "convertShapeToPath";
tr.description = "converts basic shapes to more compact path form";
const Pn0 = /[-+]?(?:\d*\.\d+|\d+\.?)(?:[eE][-+]?\d+)?/g;
tr.fn = (e, t) => {
  const { convertArcs: r = !1, floatPrecision: n } = t;
  return {
    element: {
      enter: (o, s) => {
        if (o.name === "rect" && o.attributes.width != null && o.attributes.height != null && o.attributes.rx == null && o.attributes.ry == null) {
          const i = Number(o.attributes.x || "0"), l = Number(o.attributes.y || "0"), c = Number(o.attributes.width), a = Number(o.attributes.height);
          if (Number.isNaN(i - l + c - a))
            return;
          const u = [
            { command: "M", args: [i, l] },
            { command: "H", args: [i + c] },
            { command: "V", args: [l + a] },
            { command: "H", args: [i] },
            { command: "z", args: [] }
          ];
          o.name = "path", o.attributes.d = U3({ pathData: u, precision: n }), delete o.attributes.x, delete o.attributes.y, delete o.attributes.width, delete o.attributes.height;
        }
        if (o.name === "line") {
          const i = Number(o.attributes.x1 || "0"), l = Number(o.attributes.y1 || "0"), c = Number(o.attributes.x2 || "0"), a = Number(o.attributes.y2 || "0");
          if (Number.isNaN(i - l + c - a))
            return;
          const u = [
            { command: "M", args: [i, l] },
            { command: "L", args: [c, a] }
          ];
          o.name = "path", o.attributes.d = U3({ pathData: u, precision: n }), delete o.attributes.x1, delete o.attributes.y1, delete o.attributes.x2, delete o.attributes.y2;
        }
        if ((o.name === "polyline" || o.name === "polygon") && o.attributes.points != null) {
          const i = (o.attributes.points.match(Pn0) || []).map(
            Number
          );
          if (i.length < 4) {
            Tn0(o, s);
            return;
          }
          const l = [];
          for (let c = 0; c < i.length; c += 2)
            l.push({
              command: c === 0 ? "M" : "L",
              args: i.slice(c, c + 2)
            });
          o.name === "polygon" && l.push({ command: "z", args: [] }), o.name = "path", o.attributes.d = U3({ pathData: l, precision: n }), delete o.attributes.points;
        }
        if (o.name === "circle" && r) {
          const i = Number(o.attributes.cx || "0"), l = Number(o.attributes.cy || "0"), c = Number(o.attributes.r || "0");
          if (Number.isNaN(i - l + c))
            return;
          const a = [
            { command: "M", args: [i, l - c] },
            { command: "A", args: [c, c, 0, 1, 0, i, l + c] },
            { command: "A", args: [c, c, 0, 1, 0, i, l - c] },
            { command: "z", args: [] }
          ];
          o.name = "path", o.attributes.d = U3({ pathData: a, precision: n }), delete o.attributes.cx, delete o.attributes.cy, delete o.attributes.r;
        }
        if (o.name === "ellipse" && r) {
          const i = Number(o.attributes.cx || "0"), l = Number(o.attributes.cy || "0"), c = Number(o.attributes.rx || "0"), a = Number(o.attributes.ry || "0");
          if (Number.isNaN(i - l + c - a))
            return;
          const u = [
            { command: "M", args: [i, l - a] },
            { command: "A", args: [c, a, 0, 1, 0, i, l + a] },
            { command: "A", args: [c, a, 0, 1, 0, i, l - a] },
            { command: "z", args: [] }
          ];
          o.name = "path", o.attributes.d = U3({ pathData: u, precision: n }), delete o.attributes.cx, delete o.attributes.cy, delete o.attributes.rx, delete o.attributes.ry;
        }
      }
    }
  };
};
var rr = {};
rr.name = "convertEllipseToCircle";
rr.description = "converts non-eccentric <ellipse>s to <circle>s";
rr.fn = () => ({
  element: {
    enter: (e) => {
      if (e.name === "ellipse") {
        const t = e.attributes.rx || "0", r = e.attributes.ry || "0";
        if (t === r || t === "auto" || r === "auto") {
          e.name = "circle";
          const n = t === "auto" ? r : t;
          delete e.attributes.rx, delete e.attributes.ry, e.attributes.r = n;
        }
      }
    }
  }
});
var nr = {};
const { visit: Nn0 } = a0, { inheritableAttrs: Dn0, pathElems: On0 } = C0;
nr.name = "moveElemsAttrsToGroup";
nr.description = "Move common attributes of group children to the group";
nr.fn = (e) => {
  let t = !1;
  return Nn0(e, {
    element: {
      enter: (r) => {
        r.name === "style" && (t = !0);
      }
    }
  }), {
    element: {
      exit: (r) => {
        if (r.name !== "g" || r.children.length <= 1 || t)
          return;
        const n = /* @__PURE__ */ new Map();
        let o = !0, s = !0;
        for (const i of r.children)
          if (i.type === "element")
            if (On0.includes(i.name) === !1 && (s = !1), o) {
              o = !1;
              for (const [l, c] of Object.entries(i.attributes))
                Dn0.includes(l) && n.set(l, c);
            } else
              for (const [l, c] of n)
                i.attributes[l] !== c && n.delete(l);
        (r.attributes["clip-path"] != null || r.attributes.mask != null) && n.delete("transform"), s && n.delete("transform");
        for (const [i, l] of n)
          i === "transform" ? r.attributes.transform != null ? r.attributes.transform = `${r.attributes.transform} ${l}` : r.attributes.transform = l : r.attributes[i] = l;
        for (const i of r.children)
          if (i.type === "element")
            for (const [l] of n)
              delete i.attributes[l];
      }
    }
  };
};
var or = {};
const { pathElems: Rn0, referencesProps: In0 } = C0, { includesUrlReference: _n0 } = Z0;
or.name = "moveGroupAttrsToElems";
or.description = "moves some group attributes to the content elements";
const Fn0 = [...Rn0, "g", "text"];
or.fn = () => ({
  element: {
    enter: (e) => {
      if (e.name === "g" && e.children.length !== 0 && e.attributes.transform != null && Object.entries(e.attributes).some(
        ([t, r]) => In0.includes(t) && _n0(r)
      ) === !1 && e.children.every(
        (t) => t.type === "element" && Fn0.includes(t.name) && t.attributes.id == null
      )) {
        for (const t of e.children) {
          const r = e.attributes.transform;
          t.type === "element" && (t.attributes.transform != null ? t.attributes.transform = `${r} ${t.attributes.transform}` : t.attributes.transform = r);
        }
        delete e.attributes.transform;
      }
    }
  }
});
var sr = {};
const { inheritableAttrs: Bn0, elemsGroups: Pm } = C0;
sr.name = "collapseGroups";
sr.description = "collapses useless groups";
const Nm = (e, t) => {
  if (e.type === "element") {
    if (Pm.animation.includes(e.name) && e.attributes.attributeName === t)
      return !0;
    for (const r of e.children)
      if (Nm(r, t))
        return !0;
  }
  return !1;
};
sr.fn = () => ({
  element: {
    exit: (e, t) => {
      if (!(t.type === "root" || t.name === "switch") && !(e.name !== "g" || e.children.length === 0)) {
        if (Object.keys(e.attributes).length !== 0 && e.children.length === 1) {
          const r = e.children[0];
          if (r.type === "element" && r.attributes.id == null && e.attributes.filter == null && (e.attributes.class == null || r.attributes.class == null) && (e.attributes["clip-path"] == null && e.attributes.mask == null || r.name === "g" && e.attributes.transform == null && r.attributes.transform == null))
            for (const [n, o] of Object.entries(e.attributes)) {
              if (Nm(r, n))
                return;
              if (r.attributes[n] == null)
                r.attributes[n] = o;
              else if (n === "transform")
                r.attributes[n] = o + " " + r.attributes[n];
              else if (r.attributes[n] === "inherit")
                r.attributes[n] = o;
              else if (Bn0.includes(n) === !1 && r.attributes[n] !== o)
                return;
              delete e.attributes[n];
            }
        }
        if (Object.keys(e.attributes).length === 0) {
          for (const n of e.children)
            if (n.type === "element" && Pm.animation.includes(n.name))
              return;
          const r = t.children.indexOf(e);
          t.children.splice(r, 1, ...e.children);
          for (const n of e.children)
            Object.defineProperty(n, "parentNode", {
              writable: !0,
              value: t
            });
        }
      }
    }
  }
});
var ir = {}, At = {};
const { parsePathData: Zn0, stringifyPathData: qn0 } = L3;
var Z1;
const Un0 = (e) => {
  if (e.pathJS)
    return e.pathJS;
  const t = [], r = Zn0(e.attributes.d);
  for (const { command: n, args: o } of r)
    t.push({ command: n, args: o });
  return t.length && t[0].command == "m" && (t[0].command = "M"), e.pathJS = t, t;
};
At.path2js = Un0;
const ma = (e) => {
  const t = [];
  let r = [0, 0], n = [0, 0];
  for (let { command: o, args: s } of e)
    s = s.slice(), o === "m" && (s[0] += n[0], s[1] += n[1], o = "M"), o === "M" && (n[0] = s[0], n[1] = s[1], r[0] = n[0], r[1] = n[1]), o === "h" && (s[0] += n[0], o = "H"), o === "H" && (n[0] = s[0]), o === "v" && (s[0] += n[1], o = "V"), o === "V" && (n[1] = s[0]), o === "l" && (s[0] += n[0], s[1] += n[1], o = "L"), o === "L" && (n[0] = s[0], n[1] = s[1]), o === "c" && (s[0] += n[0], s[1] += n[1], s[2] += n[0], s[3] += n[1], s[4] += n[0], s[5] += n[1], o = "C"), o === "C" && (n[0] = s[4], n[1] = s[5]), o === "s" && (s[0] += n[0], s[1] += n[1], s[2] += n[0], s[3] += n[1], o = "S"), o === "S" && (n[0] = s[2], n[1] = s[3]), o === "q" && (s[0] += n[0], s[1] += n[1], s[2] += n[0], s[3] += n[1], o = "Q"), o === "Q" && (n[0] = s[2], n[1] = s[3]), o === "t" && (s[0] += n[0], s[1] += n[1], o = "T"), o === "T" && (n[0] = s[0], n[1] = s[1]), o === "a" && (s[5] += n[0], s[6] += n[1], o = "A"), o === "A" && (n[0] = s[5], n[1] = s[6]), (o === "z" || o === "Z") && (n[0] = r[0], n[1] = r[1], o = "z"), t.push({ command: o, args: s });
  return t;
};
At.js2path = function(e, t, r) {
  e.pathJS = t;
  const n = [];
  for (const o of t) {
    if (n.length !== 0 && (o.command === "M" || o.command === "m")) {
      const s = n[n.length - 1];
      (s.command === "M" || s.command === "m") && n.pop();
    }
    n.push({
      command: o.command,
      args: o.args
    });
  }
  e.attributes.d = qn0({
    pathData: n,
    precision: r.floatPrecision,
    disableSpaceAfterFlags: r.noSpaceAfterFlags
  });
};
function Bt(e, t) {
  return e[0] = t[t.length - 2], e[1] = t[t.length - 1], e;
}
At.intersects = function(e, t) {
  const r = fa(ma(e)), n = fa(ma(t));
  if (r.maxX <= n.minX || n.maxX <= r.minX || r.maxY <= n.minY || n.maxY <= r.minY || r.list.every((c) => n.list.every((a) => c.list[c.maxX][0] <= a.list[a.minX][0] || a.list[a.maxX][0] <= c.list[c.minX][0] || c.list[c.maxY][1] <= a.list[a.minY][1] || a.list[a.maxY][1] <= c.list[c.minY][1])))
    return !1;
  const o = r.list.map(da), s = n.list.map(da);
  return o.some(function(c) {
    return c.list.length < 3 ? !1 : s.some(function(a) {
      if (a.list.length < 3)
        return !1;
      for (var u = [i(c, a, [1, 0])], h = u2(u[0]), m = 1e4; ; ) {
        if (m-- == 0)
          return console.error(
            "Error: infinite loop while processing mergePaths plugin."
          ), !0;
        if (u.push(i(c, a, h)), ze(h, u[u.length - 1]) <= 0)
          return !1;
        if (Hn0(u, h))
          return !0;
      }
    });
  });
  function i(c, a, u) {
    return o8(l(c, u), l(a, u2(u)));
  }
  function l(c, a) {
    for (var u = a[1] >= 0 ? a[0] < 0 ? c.maxY : c.maxX : a[0] < 0 ? c.minX : c.minY, h = -1 / 0, m; (m = ze(c.list[u], a)) > h; )
      h = m, u = ++u % c.list.length;
    return c.list[(u || c.list.length) - 1];
  }
};
function Hn0(e, t) {
  if (e.length == 2) {
    let r = e[1], n = e[0], o = u2(e[1]), s = o8(n, r);
    ze(o, s) > 0 ? Bt(t, Bn(s, r)) : (Bt(t, o), e.shift());
  } else {
    let r = e[2], n = e[1], o = e[0], s = o8(n, r), i = o8(o, r), l = u2(r), c = Bn(s, i), a = Bn(i, s);
    if (ze(c, l) > 0)
      ze(s, l) > 0 ? (Bt(t, c), e.shift()) : (Bt(t, l), e.splice(0, 2));
    else if (ze(a, l) > 0)
      ze(i, l) > 0 ? (Bt(t, a), e.splice(1, 1)) : (Bt(t, l), e.splice(0, 2));
    else
      return !0;
  }
  return !1;
}
function u2(e) {
  return [-e[0], -e[1]];
}
function o8(e, t) {
  return [e[0] - t[0], e[1] - t[1]];
}
function ze(e, t) {
  return e[0] * t[0] + e[1] * t[1];
}
function Bn(e, t) {
  var r = [-e[1], e[0]];
  return ze(r, u2(t)) < 0 ? u2(r) : r;
}
function fa(e) {
  const t = { list: [], minX: 0, minY: 0, maxX: 0, maxY: 0 }, r = (s, i) => {
    (!s.list.length || i[1] > s.list[s.maxY][1]) && (s.maxY = s.list.length, t.maxY = t.list.length ? Math.max(i[1], t.maxY) : i[1]), (!s.list.length || i[0] > s.list[s.maxX][0]) && (s.maxX = s.list.length, t.maxX = t.list.length ? Math.max(i[0], t.maxX) : i[0]), (!s.list.length || i[1] < s.list[s.minY][1]) && (s.minY = s.list.length, t.minY = t.list.length ? Math.min(i[1], t.minY) : i[1]), (!s.list.length || i[0] < s.list[s.minX][0]) && (s.minX = s.list.length, t.minX = t.list.length ? Math.min(i[0], t.minX) : i[0]), s.list.push(i);
  };
  for (let s = 0; s < e.length; s += 1) {
    const i = e[s];
    let l = t.list.length === 0 ? { list: [], minX: 0, minY: 0, maxX: 0, maxY: 0 } : t.list[t.list.length - 1], c = s === 0 ? null : e[s - 1], a = l.list.length === 0 ? null : l.list[l.list.length - 1], u = i.args, h = a;
    const m = (f, d) => f + (a == null ? 0 : a[d % 2]);
    switch (i.command) {
      case "M":
        l = { list: [], minX: 0, minY: 0, maxX: 0, maxY: 0 }, t.list.push(l);
        break;
      case "H":
        a != null && r(l, [u[0], a[1]]);
        break;
      case "V":
        a != null && r(l, [a[0], u[0]]);
        break;
      case "Q":
        r(l, u.slice(0, 2)), Z1 = [u[2] - u[0], u[3] - u[1]];
        break;
      case "T":
        a != null && c != null && (c.command == "Q" || c.command == "T") && (h = [
          a[0] + Z1[0],
          a[1] + Z1[1]
        ], r(l, h), Z1 = [u[0] - h[0], u[1] - h[1]]);
        break;
      case "C":
        a != null && r(l, [
          0.5 * (a[0] + u[0]),
          0.5 * (a[1] + u[1])
        ]), r(l, [
          0.5 * (u[0] + u[2]),
          0.5 * (u[1] + u[3])
        ]), r(l, [
          0.5 * (u[2] + u[4]),
          0.5 * (u[3] + u[5])
        ]), Z1 = [u[4] - u[2], u[5] - u[3]];
        break;
      case "S":
        a != null && c != null && (c.command == "C" || c.command == "S") && (r(l, [
          a[0] + 0.5 * Z1[0],
          a[1] + 0.5 * Z1[1]
        ]), h = [
          a[0] + Z1[0],
          a[1] + Z1[1]
        ]), h != null && r(l, [
          0.5 * (h[0] + u[0]),
          0.5 * (h[1] + u[1])
        ]), r(l, [
          0.5 * (u[0] + u[2]),
          0.5 * (u[1] + u[3])
        ]), Z1 = [u[2] - u[0], u[3] - u[1]];
        break;
      case "A":
        if (a != null)
          for (var n = Dm.apply(0, a.concat(u)), o; (o = n.splice(0, 6).map(m)).length; )
            a != null && r(l, [
              0.5 * (a[0] + o[0]),
              0.5 * (a[1] + o[1])
            ]), r(l, [
              0.5 * (o[0] + o[2]),
              0.5 * (o[1] + o[3])
            ]), r(l, [
              0.5 * (o[2] + o[4]),
              0.5 * (o[3] + o[5])
            ]), n.length && r(l, a = o.slice(-2));
        break;
    }
    u.length >= 2 && r(l, u.slice(-2));
  }
  return t;
}
function da(e) {
  e.list.sort(function(a, u) {
    return a[0] == u[0] ? a[1] - u[1] : a[0] - u[0];
  });
  var t = [], r = 0, n = 0;
  for (let a = 0; a < e.list.length; a++) {
    for (; t.length >= 2 && pa(t[t.length - 2], t[t.length - 1], e.list[a]) <= 0; )
      t.pop();
    e.list[a][1] < e.list[r][1] && (r = a, n = t.length), t.push(e.list[a]);
  }
  var o = [], s = e.list.length - 1, i = 0;
  for (let a = e.list.length; a--; ) {
    for (; o.length >= 2 && pa(o[o.length - 2], o[o.length - 1], e.list[a]) <= 0; )
      o.pop();
    e.list[a][1] > e.list[s][1] && (s = a, i = o.length), o.push(e.list[a]);
  }
  o.pop(), t.pop();
  const l = t.concat(o);
  return {
    list: l,
    minX: 0,
    maxX: t.length,
    minY: n,
    maxY: (t.length + i) % l.length
  };
}
function pa(e, t, r) {
  return (t[0] - e[0]) * (r[1] - e[1]) - (t[1] - e[1]) * (r[0] - e[0]);
}
const Dm = (e, t, r, n, o, s, i, l, c, a) => {
  const u = Math.PI * 120 / 180, h = Math.PI / 180 * (+o || 0);
  let m = [];
  const f = (p, N, z) => p * Math.cos(z) - N * Math.sin(z), d = (p, N, z) => p * Math.sin(z) + N * Math.cos(z);
  if (a)
    P = a[0], x = a[1], g = a[2], M = a[3];
  else {
    e = f(e, t, -h), t = d(e, t, -h), l = f(l, c, -h), c = d(l, c, -h);
    var k = (e - l) / 2, b = (t - c) / 2, w = k * k / (r * r) + b * b / (n * n);
    w > 1 && (w = Math.sqrt(w), r = w * r, n = w * n);
    var L = r * r, A = n * n, C = (s == i ? -1 : 1) * Math.sqrt(
      Math.abs(
        (L * A - L * b * b - A * k * k) / (L * b * b + A * k * k)
      )
    ), g = C * r * b / n + (e + l) / 2, M = C * -n * k / r + (t + c) / 2, P = Math.asin(Number(((t - M) / n).toFixed(9))), x = Math.asin(Number(((c - M) / n).toFixed(9)));
    P = e < g ? Math.PI - P : P, x = l < g ? Math.PI - x : x, P < 0 && (P = Math.PI * 2 + P), x < 0 && (x = Math.PI * 2 + x), i && P > x && (P = P - Math.PI * 2), !i && x > P && (x = x - Math.PI * 2);
  }
  var j = x - P;
  if (Math.abs(j) > u) {
    var O = x, y = l, D = c;
    x = P + u * (i && x > P ? 1 : -1), l = g + r * Math.cos(x), c = M + n * Math.sin(x), m = Dm(l, c, r, n, o, 0, i, y, D, [
      x,
      O,
      g,
      M
    ]);
  }
  j = x - P;
  var E = Math.cos(P), W = Math.sin(P), U = Math.cos(x), i0 = Math.sin(x), Q = Math.tan(j / 4), v0 = 4 / 3 * r * Q, N0 = 4 / 3 * n * Q, B = [
    -v0 * W,
    N0 * E,
    l + v0 * i0 - e,
    c - N0 * U - t,
    l - e,
    c - t
  ];
  if (a)
    return B.concat(m);
  m = B.concat(m);
  for (var Y = [], r0 = 0, v = m.length; r0 < v; r0++)
    Y[r0] = r0 % 2 ? d(m[r0 - 1], m[r0], h) : f(m[r0], m[r0 + 1], h);
  return Y;
};
var Om = {}, z3 = {};
const Gn0 = /matrix|translate|scale|rotate|skewX|skewY/, Wn0 = /\s*(matrix|translate|scale|rotate|skewX|skewY)\s*\(\s*(.+?)\s*\)[\s,]*/, Vn0 = /[-+]?(?:\d*\.\d+|\d+\.?)(?:[eE][-+]?\d+)?/g;
z3.transform2js = (e) => {
  const t = [];
  let r = null;
  for (const o of e.split(Wn0)) {
    var n;
    if (o)
      if (Gn0.test(o))
        r = { name: o, data: [] }, t.push(r);
      else
        for (; n = Vn0.exec(o); )
          n = Number(n), r != null && r.data.push(n);
  }
  return r == null || r.data.length == 0 ? [] : t;
};
z3.transformsMultiply = (e) => {
  const t = e.map((n) => n.name === "matrix" ? n.data : Xn0(n));
  return {
    name: "matrix",
    data: t.length > 0 ? t.reduce(Rm) : []
  };
};
const J0 = {
  rad: (e) => e * Math.PI / 180,
  deg: (e) => e * 180 / Math.PI,
  cos: (e) => Math.cos(J0.rad(e)),
  acos: (e, t) => Number(J0.deg(Math.acos(e)).toFixed(t)),
  sin: (e) => Math.sin(J0.rad(e)),
  asin: (e, t) => Number(J0.deg(Math.asin(e)).toFixed(t)),
  tan: (e) => Math.tan(J0.rad(e)),
  atan: (e, t) => Number(J0.deg(Math.atan(e)).toFixed(t))
};
z3.matrixToTransform = (e, t) => {
  let r = t.floatPrecision, n = e.data, o = [], s = Number(
    Math.hypot(n[0], n[1]).toFixed(t.transformPrecision)
  ), i = Number(
    ((n[0] * n[3] - n[1] * n[2]) / s).toFixed(
      t.transformPrecision
    )
  ), l = n[0] * n[2] + n[1] * n[3], c = n[0] * n[1] + n[2] * n[3], a = c != 0 || s == i;
  if ((n[4] || n[5]) && o.push({
    name: "translate",
    data: n.slice(4, n[5] ? 6 : 5)
  }), !n[1] && n[2])
    o.push({
      name: "skewX",
      data: [J0.atan(n[2] / i, r)]
    });
  else if (n[1] && !n[2])
    o.push({
      name: "skewY",
      data: [J0.atan(n[1] / n[0], r)]
    }), s = n[0], i = n[3];
  else if (!l || s == 1 && i == 1 || !a) {
    a || (s = (n[0] < 0 ? -1 : 1) * Math.hypot(n[0], n[2]), i = (n[3] < 0 ? -1 : 1) * Math.hypot(n[1], n[3]), o.push({ name: "scale", data: [s, i] }));
    var u = Math.min(Math.max(-1, n[0] / s), 1), h = [
      J0.acos(u, r) * ((a ? 1 : i) * n[1] < 0 ? -1 : 1)
    ];
    if (h[0] && o.push({ name: "rotate", data: h }), c && l && o.push({
      name: "skewX",
      data: [J0.atan(l / (s * s), r)]
    }), h[0] && (n[4] || n[5])) {
      o.shift();
      var m = n[0] / s, f = n[1] / (a ? s : i), d = n[4] * (a ? 1 : i), k = n[5] * (a ? 1 : s), b = (Math.pow(1 - m, 2) + Math.pow(f, 2)) * (a ? 1 : s * i);
      h.push(((1 - m) * d - f * k) / b), h.push(((1 - m) * k + f * d) / b);
    }
  } else if (n[1] || n[2])
    return [e];
  return (a && (s != 1 || i != 1) || !o.length) && o.push({
    name: "scale",
    data: s == i ? [s] : [s, i]
  }), o;
};
const Xn0 = (e) => {
  if (e.name === "matrix")
    return e.data;
  switch (e.name) {
    case "translate":
      return [1, 0, 0, 1, e.data[0], e.data[1] || 0];
    case "scale":
      return [
        e.data[0],
        0,
        0,
        e.data[1] || e.data[0],
        0,
        0
      ];
    case "rotate":
      var t = J0.cos(e.data[0]), r = J0.sin(e.data[0]), n = e.data[1] || 0, o = e.data[2] || 0;
      return [
        t,
        r,
        -r,
        t,
        (1 - t) * n + r * o,
        (1 - t) * o - r * n
      ];
    case "skewX":
      return [1, 0, J0.tan(e.data[0]), 1, 0, 0];
    case "skewY":
      return [1, J0.tan(e.data[0]), 0, 1, 0, 0];
    default:
      throw Error(`Unknown transform ${e.name}`);
  }
};
z3.transformArc = (e, t, r) => {
  const n = t[5] - e[0], o = t[6] - e[1];
  let s = t[0], i = t[1];
  const l = t[2] * Math.PI / 180, c = Math.cos(l), a = Math.sin(l);
  if (s > 0 && i > 0) {
    let k = Math.pow(n * c + o * a, 2) / (4 * s * s) + Math.pow(o * c - n * a, 2) / (4 * i * i);
    k > 1 && (k = Math.sqrt(k), s *= k, i *= k);
  }
  const u = [s * c, s * a, -i * a, i * c, 0, 0], h = Rm(r, u), m = h[2] * h[2] + h[3] * h[3], f = h[0] * h[0] + h[1] * h[1] + m, d = Math.hypot(h[0] - h[3], h[1] + h[2]) * Math.hypot(h[0] + h[3], h[1] - h[2]);
  if (!d)
    t[0] = t[1] = Math.sqrt(f / 2), t[2] = 0;
  else {
    const k = (f + d) / 2, b = (f - d) / 2, w = Math.abs(k - m) > 1e-6, L = (w ? k : b) - m, A = h[0] * h[2] + h[1] * h[3], C = h[0] * L + h[2] * A, g = h[1] * L + h[3] * A;
    t[0] = Math.sqrt(k), t[1] = Math.sqrt(b), t[2] = ((w ? g < 0 : C > 0) ? -1 : 1) * Math.acos((w ? C : g) / Math.hypot(C, g)) * 180 / Math.PI;
  }
  return r[0] < 0 != r[3] < 0 && (t[4] = 1 - t[4]), t;
};
const Rm = (e, t) => [
  e[0] * t[0] + e[2] * t[1],
  e[1] * t[0] + e[3] * t[1],
  e[0] * t[2] + e[2] * t[3],
  e[1] * t[2] + e[3] * t[3],
  e[0] * t[4] + e[2] * t[5] + e[4],
  e[1] * t[4] + e[3] * t[5] + e[5]
], { collectStylesheet: Yn0, computeStyle: Kn0 } = d1, {
  transformsMultiply: Qn0,
  transform2js: Jn0,
  transformArc: ga
} = z3, { path2js: eo0 } = At, {
  removeLeadingZero: Zn,
  includesUrlReference: to0
} = Z0, { referencesProps: ro0, attrsGroupsDefaults: no0 } = C0, qn = /[-+]?(\d*\.\d+|\d+\.?)(?:[eE][-+]?\d+)?/g, oo0 = (e, t) => {
  const r = Yn0(e);
  return {
    element: {
      enter: (n) => {
        var m, f, d, k;
        if (n.attributes.d == null || n.attributes.id != null || n.attributes.transform == null || n.attributes.transform === "" || n.attributes.style != null || Object.entries(n.attributes).some(
          ([b, w]) => ro0.includes(b) && to0(w)
        ))
          return;
        const o = Kn0(r, n), s = o.transform;
        if (s.type === "static" && s.value !== n.attributes.transform)
          return;
        const i = Qn0(
          Jn0(n.attributes.transform)
        ), l = ((m = o.stroke) == null ? void 0 : m.type) === "static" ? o.stroke.value : null, c = ((f = o["stroke-width"]) == null ? void 0 : f.type) === "static" ? o["stroke-width"].value : null, a = t.transformPrecision;
        if (((d = o.stroke) == null ? void 0 : d.type) === "dynamic" || ((k = o["stroke-width"]) == null ? void 0 : k.type) === "dynamic")
          return;
        const u = Number(
          Math.sqrt(
            i.data[0] * i.data[0] + i.data[1] * i.data[1]
          ).toFixed(a)
        );
        if (l && l != "none") {
          if (!t.applyTransformsStroked || (i.data[0] !== i.data[3] || i.data[1] !== -i.data[2]) && (i.data[0] !== -i.data[3] || i.data[1] !== i.data[2]))
            return;
          u !== 1 && n.attributes["vector-effect"] !== "non-scaling-stroke" && (n.attributes["stroke-width"] = (c || no0.presentation["stroke-width"]).trim().replace(
            qn,
            (b) => Zn(Number(b) * u)
          ), n.attributes["stroke-dashoffset"] != null && (n.attributes["stroke-dashoffset"] = n.attributes["stroke-dashoffset"].trim().replace(
            qn,
            (b) => Zn(Number(b) * u)
          )), n.attributes["stroke-dasharray"] != null && (n.attributes["stroke-dasharray"] = n.attributes["stroke-dasharray"].trim().replace(
            qn,
            (b) => Zn(Number(b) * u)
          )));
        }
        const h = eo0(n);
        so0(h, i.data), delete n.attributes.transform;
      }
    }
  };
};
Om.applyTransforms = oo0;
const M1 = (e, t, r) => {
  const n = e[0] * t + e[2] * r + e[4], o = e[1] * t + e[3] * r + e[5];
  return [n, o];
}, j1 = (e, t, r) => {
  const n = e[0] * t + e[2] * r, o = e[1] * t + e[3] * r;
  return [n, o];
}, so0 = (e, t) => {
  const r = [0, 0], n = [0, 0];
  for (const o of e) {
    let { command: s, args: i } = o;
    if (s === "M") {
      n[0] = i[0], n[1] = i[1], r[0] = n[0], r[1] = n[1];
      const [l, c] = M1(t, i[0], i[1]);
      i[0] = l, i[1] = c;
    }
    if (s === "m") {
      n[0] += i[0], n[1] += i[1], r[0] = n[0], r[1] = n[1];
      const [l, c] = j1(t, i[0], i[1]);
      i[0] = l, i[1] = c;
    }
    if (s === "H" && (s = "L", i = [i[0], n[1]]), s === "h" && (s = "l", i = [i[0], 0]), s === "V" && (s = "L", i = [n[0], i[0]]), s === "v" && (s = "l", i = [0, i[0]]), s === "L") {
      n[0] = i[0], n[1] = i[1];
      const [l, c] = M1(t, i[0], i[1]);
      i[0] = l, i[1] = c;
    }
    if (s === "l") {
      n[0] += i[0], n[1] += i[1];
      const [l, c] = j1(t, i[0], i[1]);
      i[0] = l, i[1] = c;
    }
    if (s === "C") {
      n[0] = i[4], n[1] = i[5];
      const [l, c] = M1(t, i[0], i[1]), [a, u] = M1(t, i[2], i[3]), [h, m] = M1(t, i[4], i[5]);
      i[0] = l, i[1] = c, i[2] = a, i[3] = u, i[4] = h, i[5] = m;
    }
    if (s === "c") {
      n[0] += i[4], n[1] += i[5];
      const [l, c] = j1(t, i[0], i[1]), [a, u] = j1(t, i[2], i[3]), [h, m] = j1(t, i[4], i[5]);
      i[0] = l, i[1] = c, i[2] = a, i[3] = u, i[4] = h, i[5] = m;
    }
    if (s === "S") {
      n[0] = i[2], n[1] = i[3];
      const [l, c] = M1(t, i[0], i[1]), [a, u] = M1(t, i[2], i[3]);
      i[0] = l, i[1] = c, i[2] = a, i[3] = u;
    }
    if (s === "s") {
      n[0] += i[2], n[1] += i[3];
      const [l, c] = j1(t, i[0], i[1]), [a, u] = j1(t, i[2], i[3]);
      i[0] = l, i[1] = c, i[2] = a, i[3] = u;
    }
    if (s === "Q") {
      n[0] = i[2], n[1] = i[3];
      const [l, c] = M1(t, i[0], i[1]), [a, u] = M1(t, i[2], i[3]);
      i[0] = l, i[1] = c, i[2] = a, i[3] = u;
    }
    if (s === "q") {
      n[0] += i[2], n[1] += i[3];
      const [l, c] = j1(t, i[0], i[1]), [a, u] = j1(t, i[2], i[3]);
      i[0] = l, i[1] = c, i[2] = a, i[3] = u;
    }
    if (s === "T") {
      n[0] = i[0], n[1] = i[1];
      const [l, c] = M1(t, i[0], i[1]);
      i[0] = l, i[1] = c;
    }
    if (s === "t") {
      n[0] += i[0], n[1] += i[1];
      const [l, c] = j1(t, i[0], i[1]);
      i[0] = l, i[1] = c;
    }
    if (s === "A") {
      if (ga(n, i, t), n[0] = i[5], n[1] = i[6], Math.abs(i[2]) > 80) {
        const a = i[0], u = i[2];
        i[0] = i[1], i[1] = a, i[2] = u + (u > 0 ? -90 : 90);
      }
      const [l, c] = M1(t, i[5], i[6]);
      i[5] = l, i[6] = c;
    }
    if (s === "a") {
      if (ga([0, 0], i, t), n[0] += i[5], n[1] += i[6], Math.abs(i[2]) > 80) {
        const a = i[0], u = i[2];
        i[0] = i[1], i[1] = a, i[2] = u + (u > 0 ? -90 : 90);
      }
      const [l, c] = j1(t, i[5], i[6]);
      i[5] = l, i[6] = c;
    }
    (s === "z" || s === "Z") && (n[0] = r[0], n[1] = r[1]), o.command = s, o.args = i;
  }
}, { collectStylesheet: io0, computeStyle: ao0 } = d1, { visit: lo0 } = a0, { pathElems: co0 } = C0, { path2js: uo0, js2path: ho0 } = At, { applyTransforms: mo0 } = Om, { cleanupOutData: r9 } = Z0;
ir.name = "convertPathData";
ir.description = "optimizes path data: writes in shorter form, applies transformations";
let Qe, we, ue, D5, O5;
ir.fn = (e, t) => {
  const {
    applyTransforms: r = !0,
    applyTransformsStroked: n = !0,
    makeArcs: o = {
      threshold: 2.5,
      tolerance: 0.5
    },
    straightCurves: s = !0,
    lineShorthands: i = !0,
    convertToZ: l = !0,
    curveSmoothShorthands: c = !0,
    floatPrecision: a = 3,
    transformPrecision: u = 5,
    removeUseless: h = !0,
    collapseRepeated: m = !0,
    utilizeAbsolute: f = !0,
    leadingZero: d = !0,
    negativeExtraSpace: k = !0,
    noSpaceAfterFlags: b = !1,
    forceAbsolutePath: w = !1
  } = t, L = {
    applyTransforms: r,
    applyTransformsStroked: n,
    makeArcs: o,
    straightCurves: s,
    lineShorthands: i,
    convertToZ: l,
    curveSmoothShorthands: c,
    floatPrecision: a,
    transformPrecision: u,
    removeUseless: h,
    collapseRepeated: m,
    utilizeAbsolute: f,
    leadingZero: d,
    negativeExtraSpace: k,
    noSpaceAfterFlags: b,
    forceAbsolutePath: w
  };
  r && lo0(
    e,
    mo0(e, {
      transformPrecision: u,
      applyTransformsStroked: n
    })
  );
  const A = io0(e);
  return {
    element: {
      enter: (C) => {
        var M, P;
        if (co0.includes(C.name) && C.attributes.d != null) {
          const x = ao0(A, C);
          we = a, ue = we !== !1 ? +Math.pow(0.1, we).toFixed(we) : 0.01, Qe = we > 0 && we < 20 ? go0 : ko0, o && (D5 = o.threshold, O5 = o.tolerance);
          const j = x["marker-mid"] != null, O = x.stroke && (x.stroke.type === "dynamic" || x.stroke.value !== "none"), y = x["stroke-linecap"] && (x["stroke-linecap"].type === "dynamic" || x["stroke-linecap"].value !== "butt"), D = O && y, E = O ? ((M = x["stroke-linecap"]) == null ? void 0 : M.type) === "static" && x["stroke-linecap"].value === "round" && ((P = x["stroke-linejoin"]) == null ? void 0 : P.type) === "static" && x["stroke-linejoin"].value === "round" : !0;
          var g = uo0(C);
          g.length && (fo0(g), g = do0(g, L, {
            isSafeToUseZ: E,
            maybeHasStrokeAndLinecap: D,
            hasMarkerMid: j
          }), f && (g = po0(g, L)), ho0(C, g, L));
        }
      }
    }
  };
};
const fo0 = (e) => {
  let t = [0, 0], r = [0, 0], n = [0, 0];
  for (let o = 0; o < e.length; o += 1) {
    const s = e[o];
    let { command: i, args: l } = s;
    i === "m" && (r[0] += l[0], r[1] += l[1], t[0] = r[0], t[1] = r[1]), i === "M" && (o !== 0 && (i = "m"), l[0] -= r[0], l[1] -= r[1], r[0] += l[0], r[1] += l[1], t[0] = r[0], t[1] = r[1]), i === "l" && (r[0] += l[0], r[1] += l[1]), i === "L" && (i = "l", l[0] -= r[0], l[1] -= r[1], r[0] += l[0], r[1] += l[1]), i === "h" && (r[0] += l[0]), i === "H" && (i = "h", l[0] -= r[0], r[0] += l[0]), i === "v" && (r[1] += l[0]), i === "V" && (i = "v", l[0] -= r[1], r[1] += l[0]), i === "c" && (r[0] += l[4], r[1] += l[5]), i === "C" && (i = "c", l[0] -= r[0], l[1] -= r[1], l[2] -= r[0], l[3] -= r[1], l[4] -= r[0], l[5] -= r[1], r[0] += l[4], r[1] += l[5]), i === "s" && (r[0] += l[2], r[1] += l[3]), i === "S" && (i = "s", l[0] -= r[0], l[1] -= r[1], l[2] -= r[0], l[3] -= r[1], r[0] += l[2], r[1] += l[3]), i === "q" && (r[0] += l[2], r[1] += l[3]), i === "Q" && (i = "q", l[0] -= r[0], l[1] -= r[1], l[2] -= r[0], l[3] -= r[1], r[0] += l[2], r[1] += l[3]), i === "t" && (r[0] += l[0], r[1] += l[1]), i === "T" && (i = "t", l[0] -= r[0], l[1] -= r[1], r[0] += l[0], r[1] += l[1]), i === "a" && (r[0] += l[5], r[1] += l[6]), i === "A" && (i = "a", l[5] -= r[0], l[6] -= r[1], r[0] += l[5], r[1] += l[6]), (i === "Z" || i === "z") && (r[0] = t[0], r[1] = t[1]), s.command = i, s.args = l, s.base = n, s.coords = [r[0], r[1]], n = s.coords;
  }
  return e;
};
function do0(e, t, { isSafeToUseZ: r, maybeHasStrokeAndLinecap: n, hasMarkerMid: o }) {
  var s = yo0.bind(null, t), i = [0, 0], l = [0, 0], c = {};
  return e = e.filter(function(a, u, h) {
    let m = a.command, f = a.args, d = h[u + 1];
    if (m !== "Z" && m !== "z") {
      var k = f, b;
      if (m === "s") {
        k = [0, 0].concat(f);
        var w = c.args, L = w.length;
        k[0] = w[L - 2] - w[L - 4], k[1] = w[L - 1] - w[L - 3];
      }
      if (t.makeArcs && (m == "c" || m == "s") && Un(k) && (b = vo0(k))) {
        var A = Qe([b.radius])[0], C = Wn(k, b), g = k[5] * k[0] - k[4] * k[1] > 0 ? 1 : 0, M = {
          command: "a",
          args: [A, A, 0, 0, g, k[4], k[5]],
          coords: a.coords.slice(),
          base: a.base
        }, P = [M], x = [
          b.center[0] - k[4],
          b.center[1] - k[5]
        ], j = { center: x, radius: b.radius }, O = [a], y = 0, D = "", E;
        if (c.command == "c" && Un(c.args) && ka(c.args, b) || c.command == "a" && c.sdata && ka(c.sdata, b)) {
          O.unshift(c), M.base = c.base, M.args[5] = M.coords[0] - M.base[0], M.args[6] = M.coords[1] - M.base[1];
          var W = c.command == "a" ? c.sdata : c.args, U = Wn(W, {
            center: [
              W[4] + b.center[0],
              W[5] + b.center[1]
            ],
            radius: b.radius
          });
          C += U, C > Math.PI && (M.args[3] = 1), y = 1;
        }
        for (var i0 = u; (d = h[++i0]) && ~"cs".indexOf(d.command); ) {
          var Q = d.args;
          if (d.command == "s" && (E = _r(
            { command: "s", args: d.args.slice() },
            h[i0 - 1].args
          ), Q = E.args, E.args = Q.slice(0, 2), D = s([E])), Un(Q) && _m(Q, j)) {
            if (C += Wn(Q, j), C - 2 * Math.PI > 1e-3)
              break;
            if (C > Math.PI && (M.args[3] = 1), O.push(d), 2 * Math.PI - C > 1e-3)
              M.coords = d.coords, M.args[5] = M.coords[0] - M.base[0], M.args[6] = M.coords[1] - M.base[1];
            else {
              M.args[5] = 2 * (j.center[0] - Q[4]), M.args[6] = 2 * (j.center[1] - Q[5]), M.coords = [
                M.base[0] + M.args[5],
                M.base[1] + M.args[6]
              ], M = {
                command: "a",
                args: [
                  A,
                  A,
                  0,
                  0,
                  g,
                  d.coords[0] - M.coords[0],
                  d.coords[1] - M.coords[1]
                ],
                coords: d.coords,
                base: M.coords
              }, P.push(M), i0++;
              break;
            }
            x[0] -= Q[4], x[1] -= Q[5];
          } else
            break;
        }
        if ((s(P) + D).length < s(O).length) {
          if (h[i0] && h[i0].command == "s" && _r(h[i0], h[i0 - 1].args), y) {
            var v0 = P.shift();
            Qe(v0.args), i[0] += v0.args[5] - c.args[c.args.length - 2], i[1] += v0.args[6] - c.args[c.args.length - 1], c.command = "a", c.args = v0.args, a.base = c.coords = v0.coords;
          }
          if (M = P.shift(), O.length == 1 ? a.sdata = k.slice() : O.length - 1 - y > 0 && h.splice.apply(
            h,
            [u + 1, O.length - 1 - y].concat(P)
          ), !M)
            return !1;
          m = "a", f = M.args, a.coords = M.coords;
        }
      }
      if (we !== !1) {
        if (m === "m" || m === "l" || m === "t" || m === "q" || m === "s" || m === "c")
          for (var N0 = f.length; N0--; )
            f[N0] += a.base[N0 % 2] - i[N0 % 2];
        else
          m == "h" ? f[0] += a.base[0] - i[0] : m == "v" ? f[0] += a.base[1] - i[1] : m == "a" && (f[5] += a.base[0] - i[0], f[6] += a.base[1] - i[1]);
        Qe(f), m == "h" ? i[0] += f[0] : m == "v" ? i[1] += f[0] : (i[0] += f[f.length - 2], i[1] += f[f.length - 1]), Qe(i), (m === "M" || m === "m") && (l[0] = i[0], l[1] = i[1]);
      }
      if (t.straightCurves && (m === "c" && Gn(f) || m === "s" && Gn(k) ? (d && d.command == "s" && _r(d, f), m = "l", f = f.slice(-2)) : m === "q" && Gn(f) ? (d && d.command == "t" && _r(d, f), m = "l", f = f.slice(-2)) : (m === "t" && c.command !== "q" && c.command !== "t" || m === "a" && (f[0] === 0 || f[1] === 0)) && (m = "l", f = f.slice(-2))), t.lineShorthands && m === "l" && (f[1] === 0 ? (m = "h", f.pop()) : f[0] === 0 && (m = "v", f.shift())), t.convertToZ && (r || (d == null ? void 0 : d.command) === "Z" || (d == null ? void 0 : d.command) === "z") && (m === "l" || m === "h" || m === "v") && Math.abs(l[0] - a.coords[0]) < ue && Math.abs(l[1] - a.coords[1]) < ue && (m = "z", f = []), t.collapseRepeated && o === !1 && (m === "m" || m === "h" || m === "v") && c.command && m == c.command.toLowerCase() && (m != "h" && m != "v" || c.args[0] >= 0 == f[0] >= 0))
        return c.args[0] += f[0], m != "h" && m != "v" && (c.args[1] += f[1]), c.coords = a.coords, h[u] = c, !1;
      if (t.curveSmoothShorthands && c.command && (m === "c" ? (c.command === "c" && f[0] === -(c.args[2] - c.args[4]) && f[1] === -(c.args[3] - c.args[5]) || c.command === "s" && f[0] === -(c.args[0] - c.args[2]) && f[1] === -(c.args[1] - c.args[3]) || c.command !== "c" && c.command !== "s" && f[0] === 0 && f[1] === 0) && (m = "s", f = f.slice(2)) : m === "q" && (c.command === "q" && f[0] === c.args[2] - c.args[0] && f[1] === c.args[3] - c.args[1] || c.command === "t" && f[2] === c.args[0] && f[3] === c.args[1]) && (m = "t", f = f.slice(2))), t.removeUseless && !n && ((m === "l" || m === "h" || m === "v" || m === "q" || m === "t" || m === "c" || m === "s") && f.every(function(B) {
        return B === 0;
      }) || m === "a" && f[5] === 0 && f[6] === 0))
        return h[u] = c, !1;
      a.command = m, a.args = f;
    } else if (i[0] = l[0], i[1] = l[1], c.command === "Z" || c.command === "z")
      return !1;
    return (m === "Z" || m === "z") && t.removeUseless && r && Math.abs(a.base[0] - a.coords[0]) < ue / 10 && Math.abs(a.base[1] - a.coords[1]) < ue / 10 ? !1 : (c = a, !0);
  }), e;
}
function po0(e, t) {
  var r = e[0];
  return e = e.filter(function(n, o) {
    if (o == 0)
      return !0;
    if (n.command === "Z" || n.command === "z")
      return r = n, !0;
    var s = n.command, i = n.args, l = i.slice();
    if (s === "m" || s === "l" || s === "t" || s === "q" || s === "s" || s === "c")
      for (var c = l.length; c--; )
        l[c] += n.base[c % 2];
    else
      s == "h" ? l[0] += n.base[0] : s == "v" ? l[0] += n.base[1] : s == "a" && (l[5] += n.base[0], l[6] += n.base[1]);
    Qe(l);
    var a = r9(l, t), u = r9(i, t);
    return (t.forceAbsolutePath || a.length < u.length && !(t.negativeExtraSpace && s == r.command && r.command.charCodeAt(0) > 96 && a.length == u.length - 1 && (i[0] < 0 || /^0\./.test(i[0]) && r.args[r.args.length - 1] % 1))) && (n.command = s.toUpperCase(), n.args = l), r = n, !0;
  }), e;
}
function Un(e) {
  var t = Im([
    0,
    0,
    e[2],
    e[3],
    e[0],
    e[1],
    e[4],
    e[5]
  ]);
  return t != null && e[2] < t[0] == t[0] < 0 && e[3] < t[1] == t[1] < 0 && e[4] < t[0] == t[0] < e[0] && e[5] < t[1] == t[1] < e[1];
}
function Im(e) {
  var t = e[1] - e[3], r = e[2] - e[0], n = e[0] * e[3] - e[2] * e[1], o = e[5] - e[7], s = e[6] - e[4], i = e[4] * e[7] - e[5] * e[6], l = t * s - o * r;
  if (!!l) {
    var c = [(r * i - s * n) / l, (t * i - o * n) / -l];
    if (!isNaN(c[0]) && !isNaN(c[1]) && isFinite(c[0]) && isFinite(c[1]))
      return c;
  }
}
function Hn(e, t) {
  const r = 10 ** t;
  return Math.round(e * r) / r;
}
function go0(e) {
  const t = we || 0;
  for (let r = e.length; r-- > 0; ) {
    const n = Hn(e[r], t);
    if (n !== e[r]) {
      const o = Hn(e[r], t - 1);
      e[r] = Hn(Math.abs(o - e[r]), t + 1) >= ue ? n : o;
    }
  }
  return e;
}
function ko0(e) {
  for (var t = e.length; t-- > 0; )
    e[t] = Math.round(e[t]);
  return e;
}
function Gn(e) {
  var t = e.length - 2, r = -e[t + 1], n = e[t], o = 1 / (r * r + n * n);
  if (t <= 1 || !isFinite(o))
    return !1;
  for (; (t -= 2) >= 0; )
    if (Math.sqrt(Math.pow(r * e[t] + n * e[t + 1], 2) * o) > ue)
      return !1;
  return !0;
}
function _r(e, t) {
  switch (e.command) {
    case "s":
      e.command = "c";
      break;
    case "t":
      e.command = "q";
      break;
  }
  return e.args.unshift(
    t[t.length - 2] - t[t.length - 4],
    t[t.length - 1] - t[t.length - 3]
  ), e;
}
function n9(e, t) {
  return Math.hypot(e[0] - t[0], e[1] - t[1]);
}
function o9(e, t) {
  var r = t * t, n = r * t, o = 1 - t, s = o * o;
  return [
    3 * s * t * e[0] + 3 * o * r * e[2] + n * e[4],
    3 * s * t * e[1] + 3 * o * r * e[3] + n * e[5]
  ];
}
function vo0(e) {
  var t = o9(e, 0.5), r = [t[0] / 2, t[1] / 2], n = [(t[0] + e[4]) / 2, (t[1] + e[5]) / 2], o = Im([
    r[0],
    r[1],
    r[0] + r[1],
    r[1] - r[0],
    n[0],
    n[1],
    n[0] + (n[1] - t[1]),
    n[1] - (n[0] - t[0])
  ]), s = o && n9([0, 0], o), i = Math.min(D5 * ue, O5 * s / 100);
  if (o && s < 1e15 && [1 / 4, 3 / 4].every(function(l) {
    return Math.abs(
      n9(o9(e, l), o) - s
    ) <= i;
  }))
    return { center: o, radius: s };
}
function _m(e, t) {
  var r = Math.min(
    D5 * ue,
    O5 * t.radius / 100
  );
  return [0, 1 / 4, 1 / 2, 3 / 4, 1].every(function(n) {
    return Math.abs(
      n9(o9(e, n), t.center) - t.radius
    ) <= r;
  });
}
function ka(e, t) {
  return _m(e, {
    center: [t.center[0] + e[4], t.center[1] + e[5]],
    radius: t.radius
  });
}
function Wn(e, t) {
  var r = -t.center[0], n = -t.center[1], o = e[4] - t.center[0], s = e[5] - t.center[1];
  return Math.acos(
    (r * o + n * s) / Math.sqrt((r * r + n * n) * (o * o + s * s))
  );
}
function yo0(e, t) {
  return t.reduce(function(r, n) {
    var o = "";
    return n.args && (o = r9(Qe(n.args.slice()), e)), r + n.command + o;
  }, "");
}
var ar = {};
const { cleanupOutData: bo0 } = Z0, {
  transform2js: xo0,
  transformsMultiply: wo0,
  matrixToTransform: Lo0
} = z3;
ar.name = "convertTransform";
ar.description = "collapses multiple transformations and optimizes it";
ar.fn = (e, t) => {
  const {
    convertToShorts: r = !0,
    degPrecision: n,
    floatPrecision: o = 3,
    transformPrecision: s = 5,
    matrixToTransform: i = !0,
    shortTranslate: l = !0,
    shortScale: c = !0,
    shortRotate: a = !0,
    removeUseless: u = !0,
    collapseIntoOne: h = !0,
    leadingZero: m = !0,
    negativeExtraSpace: f = !1
  } = t, d = {
    convertToShorts: r,
    degPrecision: n,
    floatPrecision: o,
    transformPrecision: s,
    matrixToTransform: i,
    shortTranslate: l,
    shortScale: c,
    shortRotate: a,
    removeUseless: u,
    collapseIntoOne: h,
    leadingZero: m,
    negativeExtraSpace: f
  };
  return {
    element: {
      enter: (k) => {
        k.attributes.transform != null && Vn(k, "transform", d), k.attributes.gradientTransform != null && Vn(k, "gradientTransform", d), k.attributes.patternTransform != null && Vn(k, "patternTransform", d);
      }
    }
  };
};
const Vn = (e, t, r) => {
  let n = xo0(e.attributes[t]);
  r = zo0(n, r), r.collapseIntoOne && n.length > 1 && (n = [wo0(n)]), r.convertToShorts ? n = So0(n, r) : n.forEach((o) => R5(o, r)), r.removeUseless && (n = $o0(n)), n.length ? e.attributes[t] = s9(n, r) : delete e.attributes[t];
}, zo0 = (e, { ...t }) => {
  const r = [];
  for (const o of e)
    o.name == "matrix" && r.push(...o.data.slice(0, 4));
  let n = t.transformPrecision;
  return r.length && (t.transformPrecision = Math.min(
    t.transformPrecision,
    Math.max.apply(Math, r.map(Co0)) || t.transformPrecision
  ), n = Math.max.apply(
    Math,
    r.map(
      (o) => o.toString().replace(/\D+/g, "").length
    )
  )), t.degPrecision == null && (t.degPrecision = Math.max(
    0,
    Math.min(t.floatPrecision, n - 2)
  )), t;
}, va = (e, t) => t.degPrecision != null && t.degPrecision >= 1 && t.floatPrecision < 20 ? _5(t.degPrecision, e) : I5(e), Xn = (e, t) => t.floatPrecision >= 1 && t.floatPrecision < 20 ? _5(t.floatPrecision, e) : I5(e), ya = (e, t) => t.transformPrecision >= 1 && t.floatPrecision < 20 ? _5(t.transformPrecision, e) : I5(e), Co0 = (e) => {
  const t = e.toString();
  return t.slice(t.indexOf(".")).length - 1;
}, So0 = (e, t) => {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    if (t.matrixToTransform && n.name === "matrix") {
      var o = Lo0(n, t);
      s9(o, t).length <= s9([n], t).length && e.splice(r, 1, ...o), n = e[r];
    }
    R5(n, t), t.shortTranslate && n.name === "translate" && n.data.length === 2 && !n.data[1] && n.data.pop(), t.shortScale && n.name === "scale" && n.data.length === 2 && n.data[0] === n.data[1] && n.data.pop(), t.shortRotate && e[r - 2] && e[r - 2].name === "translate" && e[r - 1].name === "rotate" && e[r].name === "translate" && e[r - 2].data[0] === -e[r].data[0] && e[r - 2].data[1] === -e[r].data[1] && (e.splice(r - 2, 3, {
      name: "rotate",
      data: [
        e[r - 1].data[0],
        e[r - 2].data[0],
        e[r - 2].data[1]
      ]
    }), r -= 2);
  }
  return e;
}, $o0 = (e) => e.filter((t) => !(["translate", "rotate", "skewX", "skewY"].indexOf(t.name) > -1 && (t.data.length == 1 || t.name == "rotate") && !t.data[0] || t.name == "translate" && !t.data[0] && !t.data[1] || t.name == "scale" && t.data[0] == 1 && (t.data.length < 2 || t.data[1] == 1) || t.name == "matrix" && t.data[0] == 1 && t.data[3] == 1 && !(t.data[1] || t.data[2] || t.data[4] || t.data[5]))), s9 = (e, t) => e.map((n) => (R5(n, t), `${n.name}(${bo0(n.data, t)})`)).join(""), R5 = (e, t) => {
  switch (e.name) {
    case "translate":
      e.data = Xn(e.data, t);
      break;
    case "rotate":
      e.data = [
        ...va(e.data.slice(0, 1), t),
        ...Xn(e.data.slice(1), t)
      ];
      break;
    case "skewX":
    case "skewY":
      e.data = va(e.data, t);
      break;
    case "scale":
      e.data = ya(e.data, t);
      break;
    case "matrix":
      e.data = [
        ...ya(e.data.slice(0, 4), t),
        ...Xn(e.data.slice(4), t)
      ];
      break;
  }
  return e;
}, I5 = (e) => e.map(Math.round), _5 = (e, t) => {
  for (var r = t.length, n = +Math.pow(0.1, e).toFixed(e); r--; )
    if (Number(t[r].toFixed(e)) !== t[r]) {
      var o = +t[r].toFixed(e - 1);
      t[r] = +Math.abs(o - t[r]).toFixed(e + 1) >= n ? +t[r].toFixed(e) : o;
    }
  return t;
};
var lr = {};
const { attrsGroups: Ao0 } = C0;
lr.name = "removeEmptyAttrs";
lr.description = "removes empty attributes";
lr.fn = () => ({
  element: {
    enter: (e) => {
      for (const [t, r] of Object.entries(e.attributes))
        r === "" && Ao0.conditionalProcessing.includes(t) === !1 && delete e.attributes[t];
    }
  }
});
var cr = {};
const { detachNodeFromParent: Mo0 } = a0, { elemsGroups: jo0 } = C0;
cr.name = "removeEmptyContainers";
cr.description = "removes empty container elements";
cr.fn = () => ({
  element: {
    exit: (e, t) => {
      e.name === "svg" || jo0.container.includes(e.name) === !1 || e.children.length !== 0 || e.name === "pattern" && Object.keys(e.attributes).length !== 0 || e.name === "g" && e.attributes.filter != null || e.name === "mask" && e.attributes.id != null || t.type === "element" && t.name === "switch" || Mo0(e, t);
    }
  }
});
var ur = {};
const { detachNodeFromParent: Eo0 } = a0, { collectStylesheet: To0, computeStyle: Po0 } = d1, { path2js: ba, js2path: No0, intersects: Do0 } = At;
ur.name = "mergePaths";
ur.description = "merges multiple paths in one if possible";
ur.fn = (e, t) => {
  const {
    force: r = !1,
    floatPrecision: n,
    noSpaceAfterFlags: o = !1
  } = t, s = To0(e);
  return {
    element: {
      enter: (i) => {
        let l = null;
        for (const c of i.children) {
          if (l == null || l.type !== "element" || l.name !== "path" || l.children.length !== 0 || l.attributes.d == null) {
            l = c;
            continue;
          }
          if (c.type !== "element" || c.name !== "path" || c.children.length !== 0 || c.attributes.d == null) {
            l = c;
            continue;
          }
          const a = Po0(s, c);
          if (a["marker-start"] || a["marker-mid"] || a["marker-end"]) {
            l = c;
            continue;
          }
          const u = Object.keys(l.attributes), h = Object.keys(c.attributes);
          let m = u.length === h.length;
          for (const k of h)
            k !== "d" && (l.attributes[k] == null || l.attributes[k] !== c.attributes[k]) && (m = !1);
          const f = ba(l), d = ba(c);
          if (m && (r || !Do0(f, d))) {
            No0(l, f.concat(d), {
              floatPrecision: n,
              noSpaceAfterFlags: o
            }), Eo0(c, i);
            continue;
          }
          l = c;
        }
      }
    }
  };
};
var hr = {};
hr.name = "removeUnusedNS";
hr.description = "removes unused namespaces declaration";
hr.fn = () => {
  const e = /* @__PURE__ */ new Set();
  return {
    element: {
      enter: (t, r) => {
        if (t.name === "svg" && r.type === "root") {
          for (const n of Object.keys(t.attributes))
            if (n.startsWith("xmlns:")) {
              const o = n.slice(6);
              e.add(o);
            }
        }
        if (e.size !== 0) {
          if (t.name.includes(":")) {
            const [n] = t.name.split(":");
            e.has(n) && e.delete(n);
          }
          for (const n of Object.keys(t.attributes))
            if (n.includes(":")) {
              const [o] = n.split(":");
              e.delete(o);
            }
        }
      },
      exit: (t, r) => {
        if (t.name === "svg" && r.type === "root")
          for (const n of e)
            delete t.attributes[`xmlns:${n}`];
      }
    }
  };
};
var mr = {};
mr.name = "sortAttrs";
mr.description = "Sort element attributes for better compression";
mr.fn = (e, t) => {
  const {
    order: r = [
      "id",
      "width",
      "height",
      "x",
      "x1",
      "x2",
      "y",
      "y1",
      "y2",
      "cx",
      "cy",
      "r",
      "fill",
      "stroke",
      "marker",
      "d",
      "points"
    ],
    xmlnsOrder: n = "front"
  } = t, o = (i) => {
    if (n === "front") {
      if (i === "xmlns")
        return 3;
      if (i.startsWith("xmlns:"))
        return 2;
    }
    return i.includes(":") ? 1 : 0;
  }, s = ([i], [l]) => {
    const c = o(i), u = o(l) - c;
    if (u !== 0)
      return u;
    const [h] = i.split("-"), [m] = l.split("-");
    if (h !== m) {
      const f = r.includes(h) ? 1 : 0, d = r.includes(m) ? 1 : 0;
      if (f === 1 && d === 1)
        return r.indexOf(h) - r.indexOf(m);
      const k = d - f;
      if (k !== 0)
        return k;
    }
    return i < l ? -1 : 1;
  };
  return {
    element: {
      enter: (i) => {
        const l = Object.entries(i.attributes);
        l.sort(s);
        const c = {};
        for (const [a, u] of l)
          c[a] = u;
        i.attributes = c;
      }
    }
  };
};
var fr = {};
fr.name = "sortDefsChildren";
fr.description = "Sorts children of <defs> to improve compression";
fr.fn = () => ({
  element: {
    enter: (e) => {
      if (e.name === "defs") {
        const t = /* @__PURE__ */ new Map();
        for (const r of e.children)
          if (r.type === "element") {
            const n = t.get(r.name);
            n == null ? t.set(r.name, 1) : t.set(r.name, n + 1);
          }
        e.children.sort((r, n) => {
          if (r.type !== "element" || n.type !== "element")
            return 0;
          const o = t.get(r.name), s = t.get(n.name);
          if (o != null && s != null) {
            const l = s - o;
            if (l !== 0)
              return l;
          }
          const i = n.name.length - r.name.length;
          return i !== 0 ? i : r.name !== n.name ? r.name > n.name ? -1 : 1 : 0;
        });
      }
    }
  }
});
var dr = {};
const { detachNodeFromParent: Oo0 } = a0;
dr.name = "removeTitle";
dr.description = "removes <title>";
dr.fn = () => ({
  element: {
    enter: (e, t) => {
      e.name === "title" && Oo0(e, t);
    }
  }
});
var pr = {};
const { detachNodeFromParent: Ro0 } = a0;
pr.name = "removeDesc";
pr.description = "removes <desc>";
const Io0 = /^(Created with|Created using)/;
pr.fn = (e, t) => {
  const { removeAny: r = !1 } = t;
  return {
    element: {
      enter: (n, o) => {
        n.name === "desc" && (r || n.children.length === 0 || n.children[0].type === "text" && Io0.test(n.children[0].value)) && Ro0(n, o);
      }
    }
  };
};
const { createPreset: _o0 } = D8, Fo0 = $7, Bo0 = A7, Zo0 = M7, qo0 = j7, Uo0 = E7, Ho0 = T7, Go0 = P7, Wo0 = N7, Vo0 = q7, Xo0 = U7, Yo0 = H7, Ko0 = G7, Qo0 = W7, Jo0 = V7, e90 = X7, t90 = Y7, r90 = K7, n90 = Q7, o90 = J7, s90 = er, i90 = tr, a90 = rr, l90 = nr, c90 = or, u90 = sr, h90 = ir, m90 = ar, f90 = lr, d90 = cr, p90 = ur, g90 = hr, k90 = mr, v90 = fr, y90 = dr, b90 = pr, x90 = _o0({
  name: "preset-default",
  plugins: [
    Fo0,
    Bo0,
    Zo0,
    qo0,
    Uo0,
    Ho0,
    Go0,
    Wo0,
    Vo0,
    Xo0,
    Yo0,
    Ko0,
    Qo0,
    Jo0,
    e90,
    t90,
    r90,
    n90,
    o90,
    s90,
    i90,
    a90,
    l90,
    c90,
    u90,
    h90,
    m90,
    f90,
    d90,
    p90,
    g90,
    k90,
    v90,
    y90,
    b90
  ]
});
var w90 = x90, b4 = {};
b4.name = "addAttributesToSVGElement";
b4.description = "adds attributes to an outer <svg> element";
var L90 = `Error in plugin "addAttributesToSVGElement": absent parameters.
It should have a list of "attributes" or one "attribute".
Config example:

plugins: [
  {
    name: 'addAttributesToSVGElement',
    params: {
      attribute: "mySvg"
    }
  }
]

plugins: [
  {
    name: 'addAttributesToSVGElement',
    params: {
      attributes: ["mySvg", "size-big"]
    }
  }
]

plugins: [
  {
    name: 'addAttributesToSVGElement',
    params: {
      attributes: [
        {
          focusable: false
        },
        {
          'data-image': icon
        }
      ]
    }
  }
]
`;
b4.fn = (e, t) => {
  if (!Array.isArray(t.attributes) && !t.attribute)
    return console.error(L90), null;
  const r = t.attributes || [t.attribute];
  return {
    element: {
      enter: (n, o) => {
        if (n.name === "svg" && o.type === "root") {
          for (const s of r)
            if (typeof s == "string" && n.attributes[s] == null && (n.attributes[s] = void 0), typeof s == "object")
              for (const i of Object.keys(s))
                n.attributes[i] == null && (n.attributes[i] = s[i]);
        }
      }
    }
  };
};
var x4 = {};
x4.name = "addClassesToSVGElement";
x4.description = "adds classnames to an outer <svg> element";
var z90 = `Error in plugin "addClassesToSVGElement": absent parameters.
It should have a list of classes in "classNames" or one "className".
Config example:

plugins: [
  {
    name: "addClassesToSVGElement",
    params: {
      className: "mySvg"
    }
  }
]

plugins: [
  {
    name: "addClassesToSVGElement",
    params: {
      classNames: ["mySvg", "size-big"]
    }
  }
]
`;
x4.fn = (e, t) => {
  if (!(Array.isArray(t.classNames) && t.classNames.some(String)) && !t.className)
    return console.error(z90), null;
  const r = t.classNames || [t.className];
  return {
    element: {
      enter: (n, o) => {
        if (n.name === "svg" && o.type === "root") {
          const s = new Set(
            n.attributes.class == null ? null : n.attributes.class.split(" ")
          );
          for (const i of r)
            i != null && s.add(i);
          n.attributes.class = Array.from(s).join(" ");
        }
      }
    }
  };
};
var w4 = {};
const { removeLeadingZero: C90 } = Z0;
w4.name = "cleanupListOfValues";
w4.description = "rounds list of values to the fixed precision";
const S90 = /^([-+]?\d*\.?\d+([eE][-+]?\d+)?)(px|pt|pc|mm|cm|m|in|ft|em|ex|%)?$/, $90 = /\s+,?\s*|,\s*/, xa = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  in: 96,
  pt: 4 / 3,
  pc: 16,
  px: 1
};
w4.fn = (e, t) => {
  const {
    floatPrecision: r = 3,
    leadingZero: n = !0,
    defaultPx: o = !0,
    convertToPx: s = !0
  } = t, i = (l) => {
    const c = [];
    for (const a of l.split($90)) {
      const u = a.match(S90), h = a.match(/new/);
      if (u) {
        let m = Number(Number(u[1]).toFixed(r)), d = u[3] || "";
        if (s && d && d in xa) {
          const b = Number(
            (xa[d] * Number(u[1])).toFixed(r)
          );
          b.toString().length < u[0].length && (m = b, d = "px");
        }
        let k;
        n ? k = C90(m) : k = m.toString(), o && d === "px" && (d = ""), c.push(k + d);
      } else
        h ? c.push("new") : a && c.push(a);
    }
    return c.join(" ");
  };
  return {
    element: {
      enter: (l) => {
        l.attributes.points != null && (l.attributes.points = i(l.attributes.points)), l.attributes["enable-background"] != null && (l.attributes["enable-background"] = i(
          l.attributes["enable-background"]
        )), l.attributes.viewBox != null && (l.attributes.viewBox = i(l.attributes.viewBox)), l.attributes["stroke-dasharray"] != null && (l.attributes["stroke-dasharray"] = i(
          l.attributes["stroke-dasharray"]
        )), l.attributes.dx != null && (l.attributes.dx = i(l.attributes.dx)), l.attributes.dy != null && (l.attributes.dy = i(l.attributes.dy)), l.attributes.x != null && (l.attributes.x = i(l.attributes.x)), l.attributes.y != null && (l.attributes.y = i(l.attributes.y));
      }
    }
  };
};
var L4 = {};
const { attrsGroupsDefaults: A90, colorsProps: wa } = C0, {
  detachNodeFromParent: La,
  querySelectorAll: za,
  querySelector: M90
} = a0, { computeStyle: j90, collectStylesheet: E90 } = d1;
L4.name = "convertOneStopGradients";
L4.description = "converts one-stop (single color) gradients to a plain color";
L4.fn = (e) => {
  const t = E90(e), r = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  let s = 0;
  return {
    element: {
      enter: (i, l) => {
        if (i.attributes["xlink:href"] != null && s++, i.name === "defs") {
          n.set(i, l);
          return;
        }
        if (i.name !== "linearGradient" && i.name !== "radialGradient")
          return;
        const c = i.children.filter((L) => L.type === "element" && L.name === "stop"), a = i.attributes["xlink:href"] || i.attributes.href;
        let u = c.length === 0 && a != null && a.startsWith("#") ? M90(e, a) : i;
        if (u == null || u.type !== "element") {
          o.set(i, l);
          return;
        }
        const h = u.children.filter((L) => L.type === "element" && L.name === "stop");
        if (h.length !== 1 || h[0].type !== "element")
          return;
        l.type === "element" && l.name === "defs" && r.add(l), o.set(i, l);
        let m;
        const f = j90(t, h[0])["stop-color"];
        f != null && f.type === "static" && (m = f.value);
        const d = `url(#${i.attributes.id})`, k = wa.map((L) => `[${L}="${d}"]`).join(","), b = za(e, k);
        for (const L of b)
          if (L.type === "element")
            for (const A of wa)
              L.attributes[A] === d && (m != null ? L.attributes[A] = m : delete L.attributes[A]);
        const w = za(
          e,
          `[style*=${d}]`
        );
        for (const L of w)
          L.type === "element" && (L.attributes.style = L.attributes.style.replace(
            d,
            m || A90.presentation["stop-color"]
          ));
      },
      exit: (i) => {
        if (i.name === "svg") {
          for (const [l, c] of o.entries())
            l.attributes["xlink:href"] != null && s--, La(l, c);
          s === 0 && delete i.attributes["xmlns:xlink"];
          for (const [l, c] of n.entries())
            r.has(l) && l.children.length === 0 && La(l, c);
        }
      }
    }
  };
};
var z4 = {};
const { attrsGroups: T90 } = C0;
z4.name = "convertStyleToAttrs";
z4.description = "converts style to attributes";
const gr = (...e) => "(?:" + e.join("|") + ")", P90 = T90.presentation, C3 = "\\\\(?:[0-9a-f]{1,6}\\s?|\\r\\n|.)", N90 = "\\s*(" + gr("[^:;\\\\]", C3) + "*?)\\s*", C4 = "'(?:[^'\\n\\r\\\\]|" + C3 + ")*?(?:'|$)", S4 = '"(?:[^"\\n\\r\\\\]|' + C3 + ')*?(?:"|$)', D90 = new RegExp("^" + gr(C4, S4) + "$"), O90 = "\\(" + gr(`[^'"()\\\\]+`, C3, C4, S4) + "*?\\)", R90 = "\\s*(" + gr(
  `[^!'"();\\\\]+?`,
  C3,
  C4,
  S4,
  O90,
  "[^;]*?"
) + "*?)", I90 = "\\s*(?:;\\s*|$)", _90 = "(\\s*!important(?![-(\\w]))?", Ca = new RegExp(
  N90 + ":" + R90 + _90 + I90,
  "ig"
), F90 = new RegExp(
  gr(C3, C4, S4, "/\\*[^]*?\\*/"),
  "ig"
);
z4.fn = (e, t) => {
  const { keepImportant: r = !1 } = t;
  return {
    element: {
      enter: (n) => {
        if (n.attributes.style != null) {
          let s = [];
          const i = {}, l = n.attributes.style.replace(
            F90,
            (c) => c[0] == "/" ? "" : c[0] == "\\" && /[-g-z]/i.test(c[1]) ? c[1] : c
          );
          Ca.lastIndex = 0;
          for (var o; o = Ca.exec(l); )
            (!r || !o[3]) && s.push([o[1], o[2]]);
          s.length && (s = s.filter(function(c) {
            if (c[0]) {
              var a = c[0].toLowerCase(), u = c[1];
              if (D90.test(u) && (u = u.slice(1, -1)), P90.includes(a))
                return i[a] = u, !1;
            }
            return !0;
          }), Object.assign(n.attributes, i), s.length ? n.attributes.style = s.map((c) => c.join(":")).join(";") : delete n.attributes.style);
        }
      }
    }
  };
};
var $4 = {};
const Yn = d0, { referencesProps: B90 } = C0;
$4.name = "prefixIds";
$4.description = "prefix IDs";
const Z90 = (e) => {
  const t = e.match(/[/\\]?([^/\\]+)$/);
  return t ? t[1] : "";
}, q90 = (e) => e.replace(/[. ]/g, "_"), U90 = (e) => e.startsWith('"') && e.endsWith('"') || e.startsWith("'") && e.endsWith("'") ? e.slice(1, -1) : e, s7 = (e, t) => {
  const r = e(t);
  return t.startsWith(r) ? t : r + t;
}, Kn = (e, t) => t.startsWith("#") ? "#" + s7(e, t.slice(1)) : null, H90 = (e, t, r, n, o, s) => {
  if (typeof n == "function") {
    let i = s.get(e);
    return i != null || (i = n(t, r) + o, s.set(e, i)), i;
  }
  return typeof n == "string" ? n + o : n === !1 ? "" : r.path != null && r.path.length > 0 ? q90(Z90(r.path)) + o : "prefix" + o;
};
$4.fn = (e, t, r) => {
  const {
    delim: n = "__",
    prefix: o,
    prefixIds: s = !0,
    prefixClassNames: i = !0
  } = t, l = /* @__PURE__ */ new Map();
  return {
    element: {
      enter: (c) => {
        const a = (u) => H90(u, c, r, o, n, l);
        if (c.name === "style") {
          if (c.children.length === 0)
            return;
          let u = "";
          (c.children[0].type === "text" || c.children[0].type === "cdata") && (u = c.children[0].value);
          let h = null;
          try {
            h = Yn.parse(u, {
              parseValue: !0,
              parseCustomProperty: !1
            });
          } catch {
            return;
          }
          Yn.walk(h, (m) => {
            if (s && m.type === "IdSelector" || i && m.type === "ClassSelector") {
              m.name = s7(a, m.name);
              return;
            }
            if (m.type === "Url" && m.value.length > 0) {
              const f = Kn(
                a,
                U90(m.value)
              );
              f != null && (m.value = f);
            }
          }), (c.children[0].type === "text" || c.children[0].type === "cdata") && (c.children[0].value = Yn.generate(h));
          return;
        }
        s && c.attributes.id != null && c.attributes.id.length !== 0 && (c.attributes.id = s7(a, c.attributes.id)), i && c.attributes.class != null && c.attributes.class.length !== 0 && (c.attributes.class = c.attributes.class.split(/\s+/).map((u) => s7(a, u)).join(" "));
        for (const u of ["href", "xlink:href"])
          if (c.attributes[u] != null && c.attributes[u].length !== 0) {
            const h = Kn(
              a,
              c.attributes[u]
            );
            h != null && (c.attributes[u] = h);
          }
        for (const u of B90)
          c.attributes[u] != null && c.attributes[u].length !== 0 && (c.attributes[u] = c.attributes[u].replace(
            /url\((.*?)\)/gi,
            (h, m) => {
              const f = Kn(a, m);
              return f == null ? h : `url(${f})`;
            }
          ));
        for (const u of ["begin", "end"])
          if (c.attributes[u] != null && c.attributes[u].length !== 0) {
            const h = c.attributes[u].split(/\s*;\s+/).map((m) => {
              if (m.endsWith(".end") || m.endsWith(".start")) {
                const [f, d] = m.split(".");
                return `${s7(a, f)}.${d}`;
              }
              return m;
            });
            c.attributes[u] = h.join("; ");
          }
      }
    }
  };
};
var A4 = {};
const { querySelectorAll: G90 } = a0;
A4.name = "removeAttributesBySelector";
A4.description = "removes attributes of elements that match a css selector";
A4.fn = (e, t) => {
  const r = Array.isArray(t.selectors) ? t.selectors : [t];
  for (const { selector: n, attributes: o } of r) {
    const s = G90(e, n);
    for (const i of s)
      if (i.type === "element")
        if (Array.isArray(o))
          for (const l of o)
            delete i.attributes[l];
        else
          delete i.attributes[o];
  }
  return {};
};
var M4 = {};
M4.name = "removeAttrs";
M4.description = "removes specified attributes";
const W90 = ":", V90 = `Warning: The plugin "removeAttrs" requires the "attrs" parameter.
It should have a pattern to remove, otherwise the plugin is a noop.
Config example:

plugins: [
  {
    name: "removeAttrs",
    params: {
      attrs: "(fill|stroke)"
    }
  }
]
`;
M4.fn = (e, t) => {
  if (typeof t.attrs > "u")
    return console.warn(V90), null;
  const r = typeof t.elemSeparator == "string" ? t.elemSeparator : W90, n = typeof t.preserveCurrentColor == "boolean" ? t.preserveCurrentColor : !1, o = Array.isArray(t.attrs) ? t.attrs : [t.attrs];
  return {
    element: {
      enter: (s) => {
        for (let i of o) {
          i.includes(r) ? i.split(r).length < 3 && (i = [i, ".*"].join(r)) : i = [".*", i, ".*"].join(r);
          const l = i.split(r).map((c) => (c === "*" && (c = ".*"), new RegExp(["^", c, "$"].join(""), "i")));
          if (l[0].test(s.name))
            for (const [c, a] of Object.entries(s.attributes)) {
              const u = n && c == "fill" && a == "currentColor", h = n && c == "stroke" && a == "currentColor";
              !u && !h && l[1].test(c) && l[2].test(a) && delete s.attributes[c];
            }
        }
      }
    }
  };
};
var j4 = {};
j4.name = "removeDimensions";
j4.description = "removes width and height in presence of viewBox (opposite to removeViewBox, disable it first)";
j4.fn = () => ({
  element: {
    enter: (e) => {
      if (e.name === "svg") {
        if (e.attributes.viewBox != null)
          delete e.attributes.width, delete e.attributes.height;
        else if (e.attributes.width != null && e.attributes.height != null && Number.isNaN(Number(e.attributes.width)) === !1 && Number.isNaN(Number(e.attributes.height)) === !1) {
          const t = Number(e.attributes.width), r = Number(e.attributes.height);
          e.attributes.viewBox = `0 0 ${t} ${r}`, delete e.attributes.width, delete e.attributes.height;
        }
      }
    }
  }
});
var E4 = {};
const { detachNodeFromParent: Sa } = a0;
E4.name = "removeElementsByAttr";
E4.description = "removes arbitrary elements by ID or className (disabled by default)";
E4.fn = (e, t) => {
  const r = t.id == null ? [] : Array.isArray(t.id) ? t.id : [t.id], n = t.class == null ? [] : Array.isArray(t.class) ? t.class : [t.class];
  return {
    element: {
      enter: (o, s) => {
        if (o.attributes.id != null && r.length !== 0 && r.includes(o.attributes.id) && Sa(o, s), o.attributes.class && n.length !== 0) {
          const i = o.attributes.class.split(" ");
          for (const l of n)
            if (i.includes(l)) {
              Sa(o, s);
              break;
            }
        }
      }
    }
  };
};
var T4 = {};
const { visitSkip: X90, detachNodeFromParent: Y90 } = a0, { parsePathData: K90 } = L3, { intersects: Q90 } = At;
T4.name = "removeOffCanvasPaths";
T4.description = "removes elements that are drawn outside of the viewbox (disabled by default)";
T4.fn = () => {
  let e = null;
  return {
    element: {
      enter: (t, r) => {
        if (t.name === "svg" && r.type === "root") {
          let n = "";
          t.attributes.viewBox != null ? n = t.attributes.viewBox : t.attributes.height != null && t.attributes.width != null && (n = `0 0 ${t.attributes.width} ${t.attributes.height}`), n = n.replace(/[,+]|px/g, " ").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
          const o = /^(-?\d*\.?\d+) (-?\d*\.?\d+) (\d*\.?\d+) (\d*\.?\d+)$/.exec(
            n
          );
          if (o == null)
            return;
          const s = Number.parseFloat(o[1]), i = Number.parseFloat(o[2]), l = Number.parseFloat(o[3]), c = Number.parseFloat(o[4]);
          e = {
            left: s,
            top: i,
            right: s + l,
            bottom: i + c,
            width: l,
            height: c
          };
        }
        if (t.attributes.transform != null)
          return X90;
        if (t.name === "path" && t.attributes.d != null && e != null) {
          const n = K90(t.attributes.d);
          let o = !1;
          for (const u of n)
            if (u.command === "M") {
              const [h, m] = u.args;
              h >= e.left && h <= e.right && m >= e.top && m <= e.bottom && (o = !0);
            }
          if (o)
            return;
          n.length === 2 && n.push({ command: "z", args: [] });
          const { left: s, top: i, width: l, height: c } = e;
          Q90([
            { command: "M", args: [s, i] },
            { command: "h", args: [l] },
            { command: "v", args: [c] },
            { command: "H", args: [s] },
            { command: "z", args: [] }
          ], n) === !1 && Y90(t, r);
        }
      }
    }
  };
};
var P4 = {};
const { detachNodeFromParent: J90 } = a0;
P4.name = "removeRasterImages";
P4.description = "removes raster images (disabled by default)";
P4.fn = () => ({
  element: {
    enter: (e, t) => {
      e.name === "image" && e.attributes["xlink:href"] != null && /(\.|image\/)(jpe?g|png|gif)/.test(e.attributes["xlink:href"]) && J90(e, t);
    }
  }
});
var N4 = {};
const { detachNodeFromParent: e50 } = a0, { attrsGroups: H3 } = C0;
N4.name = "removeScriptElement";
N4.description = "removes scripts (disabled by default)";
const t50 = [
  ...H3.animationEvent,
  ...H3.documentEvent,
  ...H3.documentElementEvent,
  ...H3.globalEvent,
  ...H3.graphicalEvent
];
N4.fn = () => ({
  element: {
    enter: (e, t) => {
      if (e.name === "script") {
        e50(e, t);
        return;
      }
      for (const r of t50)
        e.attributes[r] != null && delete e.attributes[r];
    },
    exit: (e, t) => {
      if (e.name === "a") {
        for (const r of Object.keys(e.attributes))
          if (r === "href" || r.endsWith(":href")) {
            if (e.attributes[r] == null || !e.attributes[r].trimStart().startsWith("javascript:"))
              continue;
            const n = t.children.indexOf(e);
            t.children.splice(n, 1, ...e.children);
            for (const o of e.children)
              Object.defineProperty(o, "parentNode", {
                writable: !0,
                value: t
              });
          }
      }
    }
  }
});
var D4 = {};
const { detachNodeFromParent: r50 } = a0;
D4.name = "removeStyleElement";
D4.description = "removes <style> element (disabled by default)";
D4.fn = () => ({
  element: {
    enter: (e, t) => {
      e.name === "style" && r50(e, t);
    }
  }
});
var O4 = {};
const { elems: n50 } = C0;
O4.name = "removeXlink";
O4.description = "remove xlink namespace and replaces attributes with the SVG 2 equivalent where applicable";
const $a = "http://www.w3.org/1999/xlink", o50 = {
  new: "_blank",
  replace: "_self"
}, s50 = [
  "cursor",
  "filter",
  "font-face-uri",
  "glyphRef",
  "tref"
], Qn = (e, t, r) => t.map((n) => `${n}:${r}`).filter((n) => e.attributes[n] != null);
O4.fn = (e, t) => {
  const { includeLegacy: r } = t, n = [], o = [], s = [];
  return {
    element: {
      enter: (i) => {
        var h, m;
        for (const [f, d] of Object.entries(i.attributes))
          if (f.startsWith("xmlns:")) {
            const k = f.split(":", 2)[1];
            if (d === $a) {
              n.push(k);
              continue;
            }
            n.includes(k) && o.push(k);
          }
        if (o.some((f) => n.includes(f)))
          return;
        const l = Qn(i, n, "show");
        let c = i.attributes.target != null;
        for (let f = l.length - 1; f >= 0; f--) {
          const d = l[f], k = i.attributes[d], b = o50[k];
          if (c || b == null) {
            delete i.attributes[d];
            continue;
          }
          b !== ((m = (h = n50[i.name]) == null ? void 0 : h.defaults) == null ? void 0 : m.target) && (i.attributes.target = b), delete i.attributes[d], c = !0;
        }
        const a = Qn(i, n, "title");
        for (let f = a.length - 1; f >= 0; f--) {
          const d = a[f], k = i.attributes[d];
          if (i.children.filter(
            (L) => L.type === "element" && L.name === "title"
          ).length > 0) {
            delete i.attributes[d];
            continue;
          }
          const w = {
            type: "element",
            name: "title",
            attributes: {},
            children: [
              {
                type: "text",
                value: k
              }
            ]
          };
          Object.defineProperty(w, "parentNode", {
            writable: !0,
            value: i
          }), i.children.unshift(w), delete i.attributes[d];
        }
        const u = Qn(i, n, "href");
        if (u.length > 0 && s50.includes(i.name) && !r) {
          u.map((f) => f.split(":", 1)[0]).forEach((f) => s.push(f));
          return;
        }
        for (let f = u.length - 1; f >= 0; f--) {
          const d = u[f], k = i.attributes[d];
          if (i.attributes.href != null) {
            delete i.attributes[d];
            continue;
          }
          i.attributes.href = k, delete i.attributes[d];
        }
      },
      exit: (i) => {
        for (const [l, c] of Object.entries(i.attributes)) {
          const [a, u] = l.split(":", 2);
          if (n.includes(a) && !o.includes(a) && !s.includes(a) && !r) {
            delete i.attributes[l];
            continue;
          }
          if (l.startsWith("xmlns:") && !s.includes(u)) {
            if (c === $a) {
              const h = n.indexOf(u);
              n.splice(h, 1), delete i.attributes[l];
              continue;
            }
            if (o.includes(a)) {
              const h = o.indexOf(u);
              o.splice(h, 1);
            }
          }
        }
      }
    }
  };
};
var R4 = {};
R4.name = "removeXMLNS";
R4.description = "removes xmlns attribute (for inline svg, disabled by default)";
R4.fn = () => ({
  element: {
    enter: (e) => {
      e.name === "svg" && delete e.attributes.xmlns;
    }
  }
});
var I4 = {};
const { collectStylesheet: i50 } = d1, { detachNodeFromParent: Aa, querySelectorAll: a50 } = a0;
I4.name = "reusePaths";
I4.description = "Finds <path> elements with the same d, fill, and stroke, and converts them to <use> elements referencing a single <path> def.";
I4.fn = (e) => {
  const t = i50(e), r = /* @__PURE__ */ new Map();
  let n;
  const o = /* @__PURE__ */ new Set();
  return {
    element: {
      enter: (s, i) => {
        if (s.name === "path" && s.attributes.d != null) {
          const l = s.attributes.d, c = s.attributes.fill || "", a = s.attributes.stroke || "", u = l + ";s:" + a + ";f:" + c;
          let h = r.get(u);
          h == null && (h = [], r.set(u, h)), h.push(s);
        }
        if (n == null && s.name === "defs" && i.type === "element" && i.name === "svg" && (n = s), s.name === "use")
          for (const l of ["href", "xlink:href"]) {
            const c = s.attributes[l];
            c != null && c.startsWith("#") && c.length > 1 && o.add(c.slice(1));
          }
      },
      exit: (s, i) => {
        if (s.name === "svg" && i.type === "root") {
          let l = n;
          l == null && (l = {
            type: "element",
            name: "defs",
            attributes: {},
            children: []
          }, Object.defineProperty(l, "parentNode", {
            writable: !0,
            value: s
          }));
          let c = 0;
          for (const a of r.values())
            if (a.length > 1) {
              const u = {
                type: "element",
                name: "path",
                attributes: {},
                children: []
              };
              for (const m of ["fill", "stroke", "d"])
                a[0].attributes[m] != null && (u.attributes[m] = a[0].attributes[m]);
              const h = a[0].attributes.id;
              h == null || o.has(h) || t.rules.some(
                (m) => m.selector === `#${h}`
              ) ? u.attributes.id = "reuse-" + c++ : (u.attributes.id = h, delete a[0].attributes.id), Object.defineProperty(u, "parentNode", {
                writable: !0,
                value: l
              }), l.children.push(u);
              for (const m of a) {
                if (delete m.attributes.d, delete m.attributes.stroke, delete m.attributes.fill, l.children.includes(m) && m.children.length === 0) {
                  if (Object.keys(m.attributes).length === 0) {
                    Aa(m, l);
                    continue;
                  }
                  if (Object.keys(m.attributes).length === 1 && m.attributes.id != null) {
                    Aa(m, l);
                    const f = `[xlink\\:href=#${m.attributes.id}], [href=#${m.attributes.id}]`;
                    for (const d of a50(s, f))
                      if (d.type === "element")
                        for (const k of ["href", "xlink:href"])
                          d.attributes[k] != null && (d.attributes[k] = "#" + u.attributes.id);
                    continue;
                  }
                }
                m.name = "use", m.attributes["xlink:href"] = "#" + u.attributes.id;
              }
            }
          l.children.length !== 0 && (s.attributes["xmlns:xlink"] == null && (s.attributes["xmlns:xlink"] = "http://www.w3.org/1999/xlink"), n == null && s.children.unshift(l));
        }
      }
    }
  };
};
xl.builtin = [
  w90,
  b4,
  x4,
  T7,
  Q7,
  U7,
  w4,
  G7,
  sr,
  W7,
  rr,
  L4,
  ir,
  tr,
  z4,
  ar,
  P7,
  N7,
  ur,
  q7,
  nr,
  or,
  $4,
  A4,
  M4,
  M7,
  pr,
  j4,
  $7,
  E7,
  E4,
  lr,
  cr,
  er,
  J7,
  j7,
  X7,
  T4,
  P4,
  N4,
  D4,
  dr,
  V7,
  hr,
  H7,
  Y7,
  K7,
  O4,
  R4,
  A7,
  I4,
  mr,
  fr
];
const { parseSvg: l50 } = kl, { stringifySvg: c50 } = yl, { builtin: u50 } = xl, { invokePlugins: h50 } = D8, { encodeSVGDatauri: m50 } = Z0, i9 = {};
for (const e of u50)
  i9[e.name] = e;
const f50 = (e) => {
  if (typeof e == "string") {
    const t = i9[e];
    if (t == null)
      throw Error(`Unknown builtin plugin "${e}" specified.`);
    return {
      name: e,
      params: {},
      fn: t.fn
    };
  }
  if (typeof e == "object" && e != null) {
    if (e.name == null)
      throw Error("Plugin name should be specified");
    let t = e.fn;
    if (t == null) {
      const r = i9[e.name];
      if (r == null)
        throw Error(`Unknown builtin plugin "${e.name}" specified.`);
      t = r.fn;
    }
    return {
      name: e.name,
      params: e.params,
      fn: t
    };
  }
  return null;
}, d50 = (e, t) => {
  if (t == null && (t = {}), typeof t != "object")
    throw Error("Config should be an object");
  const r = t.multipass ? 10 : 1;
  let n = Number.POSITIVE_INFINITY, o = "";
  const s = {};
  t.path != null && (s.path = t.path);
  for (let i = 0; i < r; i += 1) {
    s.multipassCount = i;
    const l = l50(e, t.path), c = t.plugins || ["preset-default"];
    if (!Array.isArray(c))
      throw Error(
        "malformed config, `plugins` property must be an array.\nSee more info here: https://github.com/svg/svgo#configuration"
      );
    const a = c.filter((h) => h != null).map(f50);
    a.length < c.length && console.warn(
      "Warning: plugins list includes null or undefined elements, these will be ignored."
    );
    const u = {};
    if (t.floatPrecision != null && (u.floatPrecision = t.floatPrecision), h50(l, s, a, null, u), o = c50(l, t.js2svg), o.length < n)
      e = o, n = o.length;
    else
      break;
  }
  return t.datauri && (o = m50(o, t.datauri)), {
    data: o
  };
};
gl.optimize = d50;
const p50 = mN, { optimize: g50 } = gl, k50 = (e, t) => {
  if (t == null && (t = {}), typeof t != "object")
    throw Error("Config should be an object");
  return g50(e, {
    ...t,
    js2svg: {
      eol: p50.EOL === `\r
` ? "crlf" : "lf",
      ...t.js2svg
    }
  });
};
var Fm = k50;
const Ma = (e) => {
  e.removeChild(e.childNodes[4]), e.removeChild(e.childNodes[0]), e.removeChild(e.childNodes[0]), e.removeChild(e.childNodes[0]);
}, v50 = (e) => {
  e = e.replace("<desc>Created with Fabric.js 2.6.0</desc>", "").replace('width="400" height="400"', 'width="100" height="100"');
  const r = new DOMParser().parseFromString(e, "image/svg+xml");
  r.childNodes[0].childNodes.forEach((s) => {
    s.tagName || r.childNodes[0].removeChild(s);
  }), r.childNodes[0].childNodes.forEach((s) => {
    s.childNodes.length === 5 && (Ma(s), Ma(s.childNodes[0]));
  }), r.querySelectorAll("pattern").forEach((s) => {
    const i = s.firstElementChild, c = i.getAttribute("height") === "200" ? "texture" : "image", a = 2;
    if (c === "image") {
      const u = `${100 * a}`;
      i.setAttribute("width", u), i.setAttribute("height", u);
    }
    if (c === "texture") {
      const u = `${200 / a}`;
      i.setAttribute("width", u), i.setAttribute("height", u);
      const h = `${100 / a}%`;
      i.parentNode.setAttribute("width", h), i.parentNode.setAttribute("height", h);
    }
  }), r.childNodes[0].removeChild(r.childNodes[0].childNodes[0]);
  const o = r.rootElement.outerHTML;
  return Fm(o, {}).data.replace("><rect", "><g><rect").replace("</svg>", "</g></svg>");
}, y50 = (e) => {
  const t = Object.keys(e);
  return t.map((r, n) => {
    const o = n === 0 ? t.length - 1 : n - 1, s = t[o];
    e[r] = s;
  }), e;
}, b50 = (e) => {
  const t = [], r = {};
  e.objects.forEach((l) => {
    l.pk_type !== "background" && (t.push({
      positionX: l.pk_left,
      positionY: l.pk_top,
      scale: l.scaleX * l.objects[1].scaleX,
      rotation: l.pk_rotation,
      shape: l.pk_shape,
      fill: l.pk_fill,
      svg: Fm(l.pk_shape.svg, {}).data
    }), r[l.pk_fill] = "");
  });
  const n = y50(r), { width: o, height: s, fill: i } = e.objects[0];
  return { background: i, width: o, height: s, objects: t, alternateColours: n };
}, x50 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  optimise: v50,
  animationDataJSON: b50
}, Symbol.toStringTag, { value: "Module" })), $50 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  svg: x50,
  image: KP,
  random: wp
}, Symbol.toStringTag, { value: "Module" })), A50 = async (e) => new cN(e).build();
export {
  z50 as blocks,
  A50 as create,
  S50 as shapes,
  L50 as templates,
  C50 as textures,
  $50 as utils
};
